import axios from "axios";

const ENDPOINT = "/api/v1/onboarding";

const onboardingData = {
  stockCodes: [
    {
      slug: "asx-pru",
      code: "ASX:PRU",
      companyName: "Perseus Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-asao",
      code: "ASX:ASAO",
      companyName: "ABRDN Sust Asian Opp Active ETF (Managed Fund)",
      popularity: 7000,
    },
    {
      slug: "asx-stxn",
      code: "ASX:STXN",
      companyName: "Strike Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lrln",
      code: "ASX:LRLN",
      companyName: "Labyrinth Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-afg",
      code: "ASX:AFG",
      companyName: "Australian Finance Group Ltd",
      popularity: 246000,
    },
    {
      slug: "nasdaq-dice",
      code: "NASDAQ:DICE",
      companyName: "DICE Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-krm",
      code: "ASX:KRM",
      companyName: "Kingsrose Mining Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-cgc",
      code: "NYSE:CGC",
      companyName: "Canopy Growth Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-mez",
      code: "ASX:MEZ",
      companyName: "Meridian Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cov",
      code: "ASX:COV",
      companyName: "Cleo Diagnostics Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-argx",
      code: "NASDAQ:ARGX",
      companyName: "argenx SE American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "asx-abpda",
      code: "ASX:ABPDA",
      companyName: "Abacus Property Group",
      popularity: 0,
    },
    {
      slug: "asx-tsln",
      code: "ASX:TSLN",
      companyName: "Titanium Sands Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lu7",
      code: "ASX:LU7",
      companyName: "Lithium Universe Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-duol",
      code: "NASDAQ:DUOL",
      companyName: "Duolingo Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-asea",
      code: "NYSE:ASEA",
      companyName: "Global X FTSE Southeast Asia ETF",
      popularity: 0,
    },
    {
      slug: "asx-ksn",
      code: "ASX:KSN",
      companyName: "Kingston Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-voov",
      code: "NYSE:VOOV",
      companyName: "Vanguard S&P 500 Value ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-pton",
      code: "NASDAQ:PTON",
      companyName: "Peloton Interactive Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-nrxn",
      code: "ASX:NRXN",
      companyName: "Noronex Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kcn",
      code: "ASX:KCN",
      companyName: "Kingsgate Consolidated Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pfe",
      code: "NYSE:PFE",
      companyName: "Pfizer Inc.",
      popularity: 0,
    },
    {
      slug: "asx-qor",
      code: "ASX:QOR",
      companyName: "QORIA Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-se",
      code: "NYSE:SE",
      companyName:
        "Sea Limited American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-rays",
      code: "NYSE:RAYS",
      companyName: "Global X Solar ETF",
      popularity: 0,
    },
    {
      slug: "asx-imlc",
      code: "ASX:IMLC",
      companyName: "IML Conc Aus Shares Fund (Quoted Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-lrt",
      code: "ASX:LRT",
      companyName: "Lowell Resources Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ftnt",
      code: "NYSE:FTNT",
      companyName: "Fortinet Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgen",
      code: "NASDAQ:SGEN",
      companyName: "Seagen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bmy",
      code: "NYSE:BMY",
      companyName: "Bristol-Myers Squibb Co.",
      popularity: 0,
    },
    {
      slug: "asx-kwr",
      code: "ASX:KWR",
      companyName: "KINGWEST RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-fitb",
      code: "NASDAQ:FITB",
      companyName: "Fifth Third Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-azin",
      code: "ASX:AZIN",
      companyName: "Altamin Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ceh",
      code: "ASX:CEH",
      companyName: "Coast Entertainment Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-senna",
      code: "ASX:SENNA",
      companyName: "Senetas Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-klo",
      code: "ASX:KLO",
      companyName: "Kingsland Global Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctic",
      code: "NASDAQ:CTIC",
      companyName: "CTI BioPharma Corp. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scco",
      code: "NYSE:SCCO",
      companyName: "Southern Copper Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-rxdx",
      code: "NASDAQ:RXDX",
      companyName: "Prometheus Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-rf1",
      code: "ASX:RF1",
      companyName: "Regal Investment Fund",
      popularity: 0,
    },
    {
      slug: "asx-d2on",
      code: "ASX:D2ON",
      companyName: "Duxton Water Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-dar",
      code: "NYSE:DAR",
      companyName: "DARLING INGREDIENTS INC.",
      popularity: 0,
    },
    {
      slug: "asx-kpg",
      code: "ASX:KPG",
      companyName: "Kelly Partners Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lv1",
      code: "ASX:LV1",
      companyName: "Live Verdure Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lom",
      code: "ASX:LOM",
      companyName: "Lucapa Diamond Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lsr",
      code: "ASX:LSR",
      companyName: "Lodestar Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lpe",
      code: "ASX:LPE",
      companyName: "Locality Planning Energy Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lce",
      code: "ASX:LCE",
      companyName: "London City Equities Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-tmo",
      code: "NYSE:TMO",
      companyName: "Thermo Fisher Scientific Inc.",
      popularity: 0,
    },
    {
      slug: "asx-lve",
      code: "ASX:LVE",
      companyName: "Love Group Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lky",
      code: "ASX:LKY",
      companyName: "Locksley Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-moat",
      code: "NYSE:MOAT",
      companyName: "VanEck Morningstar Wide Moat ETF",
      popularity: 0,
    },
    {
      slug: "asx-dvp",
      code: "ASX:DVP",
      companyName: "Develop Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rdx",
      code: "ASX:RDX",
      companyName: "REDOX Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-fwonk",
      code: "NASDAQ:FWONK",
      companyName:
        "Liberty Media Corporation Series C Liberty Formula One Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cck",
      code: "NYSE:CCK",
      companyName: "Crown Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "asx-lm8",
      code: "ASX:LM8",
      companyName: "Lunnon Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mff",
      code: "ASX:MFF",
      companyName: "MFF Capital Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mot",
      code: "ASX:MOT",
      companyName: "Metrics Income Opportunities Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-jd",
      code: "NASDAQ:JD",
      companyName: "JD.com Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "asx-mi6",
      code: "ASX:MI6",
      companyName: "Minerals 260 Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nis",
      code: "ASX:NIS",
      companyName: "Nickelsearch Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mls",
      code: "ASX:MLS",
      companyName: "Metals Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lyk",
      code: "ASX:LYK",
      companyName: "Lykos Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mlx",
      code: "ASX:MLX",
      companyName: "Metals X Ltd",
      popularity: 0,
    },
    {
      slug: "asx-whc",
      code: "ASX:WHC",
      companyName: "Whitehaven Coal Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mkl",
      code: "ASX:MKL",
      companyName: "Mighty Kingdom Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ldx",
      code: "ASX:LDX",
      companyName: "Lumos Diagnostics Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mpg",
      code: "ASX:MPG",
      companyName: "Many Peaks Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-1mc",
      code: "ASX:1MC",
      companyName: "Morella Corporation Ltd",
      popularity: 30000,
    },
    {
      slug: "asx-tlc",
      code: "ASX:TLC",
      companyName: "The Lottery Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mmr",
      code: "ASX:MMR",
      companyName: "Mec Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mtc",
      code: "ASX:MTC",
      companyName: "Metalstech Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mek",
      code: "ASX:MEK",
      companyName: "Meeka Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fmg",
      code: "ASX:FMG",
      companyName: "Fortescue Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bld",
      code: "ASX:BLD",
      companyName: "Boral Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gpt",
      code: "ASX:GPT",
      companyName: "GPT Group",
      popularity: 0,
    },
    {
      slug: "nyse-norw",
      code: "NYSE:NORW",
      companyName: "Global X MSCI Norway ETF",
      popularity: 0,
    },
    {
      slug: "asx-llc",
      code: "ASX:LLC",
      companyName: "Lendlease Group",
      popularity: 0,
    },
    {
      slug: "asx-mov",
      code: "ASX:MOV",
      companyName: "Move Logistics Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-adm",
      code: "NYSE:ADM",
      companyName: "Archer Daniels Midland Company",
      popularity: 0,
    },
    {
      slug: "asx-nc1",
      code: "ASX:NC1",
      companyName: "Nico Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mcl",
      code: "ASX:MCL",
      companyName: "Mighty Craft Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mdr",
      code: "ASX:MDR",
      companyName: "Medadvisor Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lyn",
      code: "ASX:LYN",
      companyName: "Lycaon Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gne",
      code: "ASX:GNE",
      companyName: "Genesis Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-vti",
      code: "NYSE:VTI",
      companyName: "Vanguard Total Stock Market ETF",
      popularity: 0,
    },
    {
      slug: "asx-dre",
      code: "ASX:DRE",
      companyName: "Dreadnought Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nfl",
      code: "ASX:NFL",
      companyName: "Norfolk Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mbx",
      code: "ASX:MBX",
      companyName: "My Foodie BOX Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ntd",
      code: "ASX:NTD",
      companyName: "National Tyre & Wheel Ltd",
      popularity: 0,
    },
    {
      slug: "asx-npr",
      code: "ASX:NPR",
      companyName: "Newmark Property REIT",
      popularity: 0,
    },
    {
      slug: "asx-nrx",
      code: "ASX:NRX",
      companyName: "Noronex Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mah",
      code: "ASX:MAH",
      companyName: "Macmahon Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mri",
      code: "ASX:MRI",
      companyName: "My Rewards International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nib",
      code: "ASX:NIB",
      companyName: "NORDIC INVESTMENT BANK",
      popularity: 0,
    },
    {
      slug: "nasdaq-ross",
      code: "NASDAQ:ROSS",
      companyName: "Ross Acquisition Corp II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-msg",
      code: "ASX:MSG",
      companyName: "MCS Services Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nml",
      code: "ASX:NML",
      companyName: "Navarre Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-mp",
      code: "NYSE:MP",
      companyName: "MP Materials Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-tbil",
      code: "NYSE:TBIL",
      companyName: "US Treasury 3 Month Bill ETF",
      popularity: 0,
    },
    {
      slug: "asx-nwm",
      code: "ASX:NWM",
      companyName: "Norwest Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-acm",
      code: "ASX:ACM",
      companyName: "Australian Critical Minerals Ltd",
      popularity: 9000,
    },
    {
      slug: "asx-bel",
      code: "ASX:BEL",
      companyName: "Bentley Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-a1n",
      code: "ASX:A1N",
      companyName: "Arn Media Ltd",
      popularity: 4000,
    },
    {
      slug: "asx-1cgn",
      code: "ASX:1CGN",
      companyName: "One Click Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dace",
      code: "ASX:DACE",
      companyName: "Dimensional Australian Core Equity (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-dfgh",
      code: "ASX:DFGH",
      companyName: "Dimensional Global Core EQ Aud HGD (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "nyse-mtal",
      code: "NYSE:MTAL",
      companyName: "Metals Acquisition Corp",
      popularity: 0,
    },
    {
      slug: "nasdaq-ibm",
      code: "NASDAQ:IBM",
      companyName: "International Business Machines Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-aqc",
      code: "ASX:AQC",
      companyName: "Australian Pacific Coal Ltd",
      popularity: 48000,
    },
    {
      slug: "asx-dgce",
      code: "ASX:DGCE",
      companyName: "Dimensional Global Core EQ UNHGD (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-nou",
      code: "ASX:NOU",
      companyName: "Noumi Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ecl",
      code: "NYSE:ECL",
      companyName: "Ecolab Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-yeti",
      code: "NYSE:YETI",
      companyName: "YETI Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtal",
      code: "NASDAQ:MTAL",
      companyName: "Metals Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-bph",
      code: "ASX:BPH",
      companyName: "BPH Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ntu",
      code: "ASX:NTU",
      companyName: "Northern Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-axp",
      code: "ASX:AXP",
      companyName: "AXP Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-peg",
      code: "NASDAQ:PEG",
      companyName: "Public Service Enterprise Group Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-nrzn",
      code: "ASX:NRZN",
      companyName: "Neurizer Ltd",
      popularity: 0,
    },
    {
      slug: "asx-auz",
      code: "ASX:AUZ",
      companyName: "Australian Mines Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ibp",
      code: "NYSE:IBP",
      companyName: "INSTALLED BUILDING PRODUCTS INC.",
      popularity: 0,
    },
    {
      slug: "nasdaq-lpro",
      code: "NASDAQ:LPRO",
      companyName: "Open Lending Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmp",
      code: "NASDAQ:TMP",
      companyName: "Tompkins Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-bot",
      code: "ASX:BOT",
      companyName: "Botanix Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bro",
      code: "NYSE:BRO",
      companyName: "Brown & Brown Inc.",
      popularity: 0,
    },
    {
      slug: "asx-bfc",
      code: "ASX:BFC",
      companyName: "Beston Global Food Company Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-jbi",
      code: "NASDAQ:JBI",
      companyName: "Janus International Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-boc",
      code: "ASX:BOC",
      companyName: "Bougainville Copper Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aef",
      code: "ASX:AEF",
      companyName: "Australian Ethical Investment Ltd",
      popularity: 910000,
    },
    {
      slug: "asx-vmtn",
      code: "ASX:VMTN",
      companyName: "Vmoto Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-goog",
      code: "NASDAQ:GOOG",
      companyName: "Alphabet Inc. Class C Capital Stock",
      popularity: 0,
    },
    {
      slug: "asx-bky",
      code: "ASX:BKY",
      companyName: "Berkeley Energia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ngs",
      code: "ASX:NGS",
      companyName: "Nutritional Growth Solutions Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nor",
      code: "ASX:NOR",
      companyName: "Norwood Systems Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tmh",
      code: "ASX:TMH",
      companyName: "The Market Herald Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-clne",
      code: "NASDAQ:CLNE",
      companyName: "Clean Energy Fuels Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-apc",
      code: "ASX:APC",
      companyName: "Australian Potash Ltd",
      popularity: 152000,
    },
    {
      slug: "nasdaq-isrg",
      code: "NASDAQ:ISRG",
      companyName: "Intuitive Surgical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fixd",
      code: "NYSE:FIXD",
      companyName: "First Trust TCW Opportunistic Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-alb",
      code: "NASDAQ:ALB",
      companyName: "Albemarle Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-bmt",
      code: "ASX:BMT",
      companyName: "Beamtree Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bhd",
      code: "ASX:BHD",
      companyName: "Benjamin Hornigold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-go2da",
      code: "ASX:GO2DA",
      companyName: "The GO2 People Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xrgnc",
      code: "ASX:XRGNC",
      companyName: "Xreality Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mdin",
      code: "ASX:MDIN",
      companyName: "Middle Island Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-alq",
      code: "ASX:ALQ",
      companyName: "Als Ltd",
      popularity: 178000,
    },
    {
      slug: "nasdaq-nem",
      code: "NASDAQ:NEM",
      companyName: "Newmont Corporation",
      popularity: 0,
    },
    {
      slug: "asx-hpr",
      code: "ASX:HPR",
      companyName: "High Peak Royalties Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kbc",
      code: "ASX:KBC",
      companyName: "Keybridge Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ent",
      code: "ASX:ENT",
      companyName: "Enterprise Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ode",
      code: "ASX:ODE",
      companyName: "Odessa Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-evs",
      code: "ASX:EVS",
      companyName: "Envirosuite Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hlx",
      code: "ASX:HLX",
      companyName: "HELIX Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ody",
      code: "ASX:ODY",
      companyName: "Odyssey Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kza",
      code: "ASX:KZA",
      companyName: "KAZIA Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-egn",
      code: "ASX:EGN",
      companyName: "Engenco Ltd",
      popularity: 0,
    },
    {
      slug: "asx-key",
      code: "ASX:KEY",
      companyName: "KEY Petroleum Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ect",
      code: "ASX:ECT",
      companyName: "Environmental Clean Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hng",
      code: "ASX:HNG",
      companyName: "Hancock & Gore Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gci",
      code: "ASX:GCI",
      companyName: "Gryphon Capital Income Trust",
      popularity: 0,
    },
    {
      slug: "asx-ena",
      code: "ASX:ENA",
      companyName: "Ensurance Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iag",
      code: "ASX:IAG",
      companyName: "Insurance Australia Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hmd",
      code: "ASX:HMD",
      companyName: "Heramed Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-cmg",
      code: "NYSE:CMG",
      companyName: "Chipotle Mexican Grill Inc.",
      popularity: 0,
    },
    {
      slug: "asx-hgo",
      code: "ASX:HGO",
      companyName: "Hillgrove Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-okr",
      code: "ASX:OKR",
      companyName: "Okapi Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hxg",
      code: "ASX:HXG",
      companyName: "Hexagon Energy Materials Ltd",
      popularity: 0,
    },
    {
      slug: "asx-goz",
      code: "ASX:GOZ",
      companyName: "Growthpoint Properties Australia",
      popularity: 0,
    },
    {
      slug: "asx-fsi",
      code: "ASX:FSI",
      companyName: "Flagship Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fwd",
      code: "ASX:FWD",
      companyName: "Fleetwood Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxst",
      code: "NASDAQ:NXST",
      companyName: "Nexstar Media Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-egl",
      code: "ASX:EGL",
      companyName: "Environmental Group Ltd (the)",
      popularity: 0,
    },
    {
      slug: "asx-fzr",
      code: "ASX:FZR",
      companyName: "Fitzroy River Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gtn",
      code: "ASX:GTN",
      companyName: "GTN Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvcr",
      code: "NASDAQ:NVCR",
      companyName: "NovoCure Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-omcl",
      code: "NASDAQ:OMCL",
      companyName: "Omnicell Inc. Common Stock ($0.001 par value)",
      popularity: 0,
    },
    {
      slug: "nyse-ally",
      code: "NYSE:ALLY",
      companyName: "Ally Financial Inc.",
      popularity: 0,
    },
    {
      slug: "asx-cxo",
      code: "ASX:CXO",
      companyName: "Core Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-he8",
      code: "ASX:HE8",
      companyName: "Helios Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gtr",
      code: "ASX:GTR",
      companyName: "Gti Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-sblk",
      code: "NASDAQ:SBLK",
      companyName: "Star Bulk Carriers Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-hfr",
      code: "ASX:HFR",
      companyName: "Highfield Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hil",
      code: "ASX:HIL",
      companyName: "Hills Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-hpp",
      code: "NYSE:HPP",
      companyName: "Hudson Pacific Properties Inc.",
      popularity: 0,
    },
    {
      slug: "asx-exr",
      code: "ASX:EXR",
      companyName: "Elixir Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cvv",
      code: "ASX:CVV",
      companyName: "Caravel Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cf1",
      code: "ASX:CF1",
      companyName: "Complii Fintech Solutions Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cfo",
      code: "ASX:CFO",
      companyName: "Cfoam Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cpm",
      code: "ASX:CPM",
      companyName: "Cooper Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aee",
      code: "ASX:AEE",
      companyName: "Aura Energy Ltd",
      popularity: 46000,
    },
    {
      slug: "asx-ar3",
      code: "ASX:AR3",
      companyName: "Australian Rare EARTHS Ltd",
      popularity: 293000,
    },
    {
      slug: "asx-caq",
      code: "ASX:CAQ",
      companyName: "CAQ Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-asml",
      code: "NASDAQ:ASML",
      companyName: "ASML Holding N.V. New York Registry Shares",
      popularity: 0,
    },
    {
      slug: "asx-bgd",
      code: "ASX:BGD",
      companyName: "Barton Gold Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-c29",
      code: "ASX:C29",
      companyName: "C29 Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ce1",
      code: "ASX:CE1",
      companyName: "Calima Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cpv",
      code: "ASX:CPV",
      companyName: "Clearvue Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-chl",
      code: "ASX:CHL",
      companyName: "Camplify Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cxu",
      code: "ASX:CXU",
      companyName: "Cauldron Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-caz",
      code: "ASX:CAZ",
      companyName: "Cazaly Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bod",
      code: "ASX:BOD",
      companyName: "BOD Science Ltd",
      popularity: 0,
    },
    {
      slug: "asx-akn",
      code: "ASX:AKN",
      companyName: "Auking Mining Ltd",
      popularity: 37000,
    },
    {
      slug: "asx-bvr",
      code: "ASX:BVR",
      companyName: "Bellavista Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bbt",
      code: "ASX:BBT",
      companyName: "Bluebet Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-clt",
      code: "ASX:CLT",
      companyName: "Cellnet Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cat",
      code: "ASX:CAT",
      companyName: "Catapult Group International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-alg",
      code: "ASX:ALG",
      companyName: "Ardent Leisure Group Ltd",
      popularity: 272000,
    },
    {
      slug: "nasdaq-expe",
      code: "NASDAQ:EXPE",
      companyName: "Expedia Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-c1x",
      code: "ASX:C1X",
      companyName: "Cosmos Exploration Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cam",
      code: "ASX:CAM",
      companyName: "Clime Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cbl",
      code: "ASX:CBL",
      companyName: "Control Bionics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cdo",
      code: "ASX:CDO",
      companyName: "Cadence Opportunities Fund Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-wbd",
      code: "NASDAQ:WBD",
      companyName: "Warner Bros. Discovery Inc. Series A Common Stock ",
      popularity: 0,
    },
    {
      slug: "asx-csf",
      code: "ASX:CSF",
      companyName: "Catalano Seafood Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cmo",
      code: "ASX:CMO",
      companyName: "Cosmo Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cnq",
      code: "ASX:CNQ",
      companyName: "Clean TEQ Water Ltd",
      popularity: 0,
    },
    {
      slug: "asx-crb",
      code: "ASX:CRB",
      companyName: "Carbine Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ct1",
      code: "ASX:CT1",
      companyName: "Constellation Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-crs",
      code: "ASX:CRS",
      companyName: "Caprice Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ciw",
      code: "ASX:CIW",
      companyName: "Clime Investment Management Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cwp",
      code: "ASX:CWP",
      companyName: "Cedar Woods Properties Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cwx",
      code: "ASX:CWX",
      companyName: "Carawine Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-caa",
      code: "ASX:CAA",
      companyName: "Capral Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aur",
      code: "ASX:AUR",
      companyName: "Auris Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-as2",
      code: "ASX:AS2",
      companyName: "Askari Metals Ltd",
      popularity: 37000,
    },
    {
      slug: "asx-cyl",
      code: "ASX:CYL",
      companyName: "Catalyst Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cai",
      code: "ASX:CAI",
      companyName: "Calidus Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-avd",
      code: "ASX:AVD",
      companyName: "Avada Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-low",
      code: "NYSE:LOW",
      companyName: "Lowe's Companies Inc.",
      popularity: 0,
    },
    {
      slug: "asx-ata",
      code: "ASX:ATA",
      companyName: "Atturra Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ami",
      code: "ASX:AMI",
      companyName: "Aurelia Metals Ltd",
      popularity: 221000,
    },
    {
      slug: "asx-fbr",
      code: "ASX:FBR",
      companyName: "FBR Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gqg",
      code: "ASX:GQG",
      companyName: "GQG Partners Inc",
      popularity: 0,
    },
    {
      slug: "asx-doc",
      code: "ASX:DOC",
      companyName: "Doctor Care Anywhere Group Plc",
      popularity: 0,
    },
    {
      slug: "asx-ffx",
      code: "ASX:FFX",
      companyName: "Firefinch Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cuf",
      code: "ASX:CUF",
      companyName: "Cufe Ltd",
      popularity: 0,
    },
    {
      slug: "asx-daf",
      code: "ASX:DAF",
      companyName: "Discovery Alaska Ltd",
      popularity: 0,
    },
    {
      slug: "asx-grx",
      code: "ASX:GRX",
      companyName: "Greenx Metals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-rost",
      code: "NASDAQ:ROST",
      companyName: "Ross Stores Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-djw",
      code: "ASX:DJW",
      companyName: "Djerriwarrh Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dun",
      code: "ASX:DUN",
      companyName: "Dundas Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fpp",
      code: "ASX:FPP",
      companyName: "Fat Prophets Global Property Fund",
      popularity: 0,
    },
    {
      slug: "asx-dmc",
      code: "ASX:DMC",
      companyName: "Design Milk Co Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gfn",
      code: "ASX:GFN",
      companyName: "Gefen International A.I. Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hcw",
      code: "ASX:HCW",
      companyName: "Healthco Healthcare and Wellness REIT",
      popularity: 0,
    },
    {
      slug: "nasdaq-ko",
      code: "NASDAQ:KO",
      companyName: "Coca-Cola Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-eqx",
      code: "ASX:EQX",
      companyName: "Equatorial Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fre",
      code: "ASX:FRE",
      companyName: "Firebrick Pharma Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dmm",
      code: "ASX:DMM",
      companyName: "DMC Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hgv",
      code: "ASX:HGV",
      companyName: "Hygrovest Ltd",
      popularity: 0,
    },
    {
      slug: "asx-g6m",
      code: "ASX:G6M",
      companyName: "Group 6 Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ecf",
      code: "ASX:ECF",
      companyName: "Elanor Commercial Property Fund",
      popularity: 0,
    },
    {
      slug: "asx-edu",
      code: "ASX:EDU",
      companyName: "EDU Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dam",
      code: "ASX:DAM",
      companyName: "DRIVER AUSTRALIA MASTER TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ep1",
      code: "ASX:EP1",
      companyName: "E&P Financial Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-epx",
      code: "ASX:EPX",
      companyName: "Ep&T Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eqe",
      code: "ASX:EQE",
      companyName: "EQUUS Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eqr",
      code: "ASX:EQR",
      companyName: "EQ Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gte",
      code: "ASX:GTE",
      companyName: "Great Western Exploration Ltd",
      popularity: 0,
    },
    {
      slug: "asx-exl",
      code: "ASX:EXL",
      companyName: "Elixinol Wellness Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpng",
      code: "NASDAQ:CPNG",
      companyName: "Coupang Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ffg",
      code: "ASX:FFG",
      companyName: "Fatfish Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hfy",
      code: "ASX:HFY",
      companyName: "Hubify Ltd",
      popularity: 0,
    },
    {
      slug: "asx-flx",
      code: "ASX:FLX",
      companyName: "FELIX Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ubs",
      code: "NYSE:UBS",
      companyName: "UBS Group AG",
      popularity: 0,
    },
    {
      slug: "asx-dm1",
      code: "ASX:DM1",
      companyName: "Desert Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mvw",
      code: "ASX:MVW",
      companyName: "Vaneck Australian EQUAL Weight ETF",
      popularity: 0,
    },
    {
      slug: "asx-gsr",
      code: "ASX:GSR",
      companyName: "Greenstone Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-evr",
      code: "ASX:EVR",
      companyName: "EV Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hhr",
      code: "ASX:HHR",
      companyName: "Hartshead Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-ion",
      code: "ASX:ION",
      companyName: "Iondrive Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hmg",
      code: "ASX:HMG",
      companyName: "Hamelin Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hmy",
      code: "ASX:HMY",
      companyName: "Harmoney Corp Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dui",
      code: "ASX:DUI",
      companyName: "Diversified United Investment Ltd",
      popularity: 0,
    },
    {
      slug: "asx-djre",
      code: "ASX:DJRE",
      companyName: "SPDR Dow Jones Global Real Estate Esg Fund",
      popularity: 0,
    },
    {
      slug: "asx-eqn",
      code: "ASX:EQN",
      companyName: "Equinox Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fpc",
      code: "ASX:FPC",
      companyName: "Fat Prophets Global Contrarian Fund Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dxb",
      code: "ASX:DXB",
      companyName: "Dimerix Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-team",
      code: "NASDAQ:TEAM",
      companyName: "Atlassian Corporation Plc Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-dcl",
      code: "ASX:DCL",
      companyName: "Domacom Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vul",
      code: "ASX:VUL",
      companyName: "Vulcan Energy Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgta",
      code: "NASDAQ:MGTA",
      companyName: "Magenta Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-cni",
      code: "ASX:CNI",
      companyName: "Centuria Capital Group",
      popularity: 0,
    },
    {
      slug: "asx-ime",
      code: "ASX:IME",
      companyName: "Imexhs Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-mktx",
      code: "NASDAQ:MKTX",
      companyName: "MarketAxess Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-iri",
      code: "ASX:IRI",
      companyName: "Integrated Research Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pni",
      code: "ASX:PNI",
      companyName: "Pinnacle Investment Management Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aug",
      code: "ASX:AUG",
      companyName: "Augustus Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-maet",
      code: "ASX:MAET",
      companyName: "Munro Global Growth Fund (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-rdt",
      code: "ASX:RDT",
      companyName: "RED DIRT METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-lly",
      code: "NYSE:LLY",
      companyName: "Eli Lilly & Co.",
      popularity: 0,
    },
    {
      slug: "nyse-gtls",
      code: "NYSE:GTLS",
      companyName: "Chart Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amt",
      code: "NYSE:AMT",
      companyName: "American Tower Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-idxx",
      code: "NASDAQ:IDXX",
      companyName: "IDEXX Laboratories Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-chw",
      code: "ASX:CHW",
      companyName: "Chilwa Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cr9",
      code: "ASX:CR9",
      companyName: "Corella Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gmg",
      code: "ASX:GMG",
      companyName: "Goodman Group",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcxa",
      code: "NASDAQ:VCXA",
      companyName:
        "10X Capital Venture Acquisition Corp. II Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "asx-dli",
      code: "ASX:DLI",
      companyName: "Delta Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-irx",
      code: "ASX:IRX",
      companyName: "Inhalerx Ltd",
      popularity: 0,
    },
    {
      slug: "asx-itm",
      code: "ASX:ITM",
      companyName: "Itech Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ipt",
      code: "ASX:IPT",
      companyName: "Impact Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-meli",
      code: "NASDAQ:MELI",
      companyName: "MercadoLibre Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rpt",
      code: "NYSE:RPT",
      companyName: "RPT Realty Common Shares of Beneficial Interest (MD)",
      popularity: 0,
    },
    {
      slug: "asx-ibx",
      code: "ASX:IBX",
      companyName: "Imagion Biosystems Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ieq",
      code: "ASX:IEQ",
      companyName: "International Equities Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iiq",
      code: "ASX:IIQ",
      companyName: "Inoviq Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ima",
      code: "ASX:IMA",
      companyName: "Image Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-imc",
      code: "ASX:IMC",
      companyName: "Immuron Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bet",
      code: "ASX:BET",
      companyName: "Betmakers Technology Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hiq",
      code: "ASX:HIQ",
      companyName: "HITIQ Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lyl",
      code: "ASX:LYL",
      companyName: "Lycopodium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mpl",
      code: "ASX:MPL",
      companyName: "Medibank Private Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ifx",
      code: "ASX:IFX",
      companyName: "INTERNATIONAL FINANCE CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-jhx",
      code: "NYSE:JHX",
      companyName: "JAMES HARDIE INDUSTRIES plc.",
      popularity: 0,
    },
    {
      slug: "asx-avz",
      code: "ASX:AVZ",
      companyName: "AVZ Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtla-",
      code: "NASDAQ:DTLA-",
      companyName:
        "Brookfield DTLA Inc. 7.625% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "asx-ppe",
      code: "ASX:PPE",
      companyName: "Peoplein Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-el",
      code: "NASDAQ:EL",
      companyName: "Estee Lauder Companies Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-img",
      code: "ASX:IMG",
      companyName: "INTERSTAR MILLENNIUM SERIES 2002-1G TRUST",
      popularity: 0,
    },
    {
      slug: "asx-imx",
      code: "ASX:IMX",
      companyName: "INTERSTAR MILLENNIUM SERIES 2003-3G TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-bac",
      code: "NYSE:BAC",
      companyName: "Bank of America Corporation",
      popularity: 0,
    },
    {
      slug: "asx-imq",
      code: "ASX:IMQ",
      companyName: "INTERSTAR MILLENNIUM SERIES 2004-1E TRUST",
      popularity: 0,
    },
    {
      slug: "asx-imk",
      code: "ASX:IMK",
      companyName: "INTERSTAR MILLENNIUM SERIES 2004-2G TRUST",
      popularity: 0,
    },
    {
      slug: "asx-imn",
      code: "ASX:IMN",
      companyName: "INTERSTAR MILLENNIUM SERIES 2004-5 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-imo",
      code: "ASX:IMO",
      companyName: "INTERSTAR MILLENNIUM SERIES 2005-2L TRUST",
      popularity: 0,
    },
    {
      slug: "asx-inl",
      code: "ASX:INL",
      companyName: "Innlanz Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lbl",
      code: "ASX:LBL",
      companyName: "Laserbond Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jhg",
      code: "ASX:JHG",
      companyName: "Janus Henderson Group Plc",
      popularity: 0,
    },
    {
      slug: "nasdaq-opch",
      code: "NASDAQ:OPCH",
      companyName: "Option Care Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-jcs",
      code: "ASX:JCS",
      companyName: "Jcurve Solutions Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kme",
      code: "ASX:KME",
      companyName: "Kip Mcgrath Education Centres Ltd",
      popularity: 0,
    },
    {
      slug: "asx-clg",
      code: "ASX:CLG",
      companyName: "Close the Loop Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lbt",
      code: "ASX:LBT",
      companyName: "LBT Innovations Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lam",
      code: "ASX:LAM",
      companyName: "Laramide Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jay",
      code: "ASX:JAY",
      companyName: "Jayride Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-krr",
      code: "ASX:KRR",
      companyName: "King River Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-gpk",
      code: "NYSE:GPK",
      companyName: "Graphic Packaging Holding Company",
      popularity: 0,
    },
    {
      slug: "nyse-irm",
      code: "NYSE:IRM",
      companyName: "Iron Mountain Inc.",
      popularity: 0,
    },
    {
      slug: "asx-aw1",
      code: "ASX:AW1",
      companyName: "American West Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jrl",
      code: "ASX:JRL",
      companyName: "Jindalee Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bme",
      code: "ASX:BME",
      companyName: "Black Mountain Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lcn",
      code: "ASX:LCN",
      companyName: "LATITUDE AUSTRALIA CREDIT CARD LOAN NOTE TRUST",
      popularity: 0,
    },
    {
      slug: "asx-lc1",
      code: "ASX:LC1",
      companyName: "LATITUDE AUSTRALIA PERSONAL LOANS SERIES 2017-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-lc2",
      code: "ASX:LC2",
      companyName: "LATITUDE AUSTRALIA PERSONAL LOANS SERIES 2020-1 TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-rexr",
      code: "NYSE:REXR",
      companyName: "REXFORD INDUSTRIAL REALTY INC.",
      popularity: 0,
    },
    {
      slug: "asx-osl",
      code: "ASX:OSL",
      companyName: "Oncosil Medical Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jrv",
      code: "ASX:JRV",
      companyName: "Jervois Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lex",
      code: "ASX:LEX",
      companyName: "Lefroy Exploration Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mqgpe",
      code: "ASX:MQGPE",
      companyName: "Macquarie Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-imi",
      code: "ASX:IMI",
      companyName: "Infinity Mining Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsco",
      code: "NASDAQ:TSCO",
      companyName: "Tractor Supply Company Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-jyc",
      code: "ASX:JYC",
      companyName: "Joyce Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kal",
      code: "ASX:KAL",
      companyName: "Kalgoorlie Gold Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kfm",
      code: "ASX:KFM",
      companyName: "Kingfisher Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jxt",
      code: "ASX:JXT",
      companyName: "Jaxsta Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-snap",
      code: "NASDAQ:SNAP",
      companyName: "Snap Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-lcy",
      code: "ASX:LCY",
      companyName: "Legacy Iron Ore Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ler",
      code: "ASX:LER",
      companyName: "Leaf Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-law",
      code: "ASX:LAW",
      companyName: "Lawfinance Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kin",
      code: "ASX:KIN",
      companyName: "KIN Mining NL",
      popularity: 0,
    },
    {
      slug: "asx-jgh",
      code: "ASX:JGH",
      companyName: "Jade Gas Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-leg",
      code: "ASX:LEG",
      companyName: "Legend Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oml",
      code: "ASX:OML",
      companyName: "Ooh!Media Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lpd",
      code: "ASX:LPD",
      companyName: "Lepidico Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lrl",
      code: "ASX:LRL",
      companyName: "Labyrinth Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-olh",
      code: "ASX:OLH",
      companyName: "Oldfields Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oli",
      code: "ASX:OLI",
      companyName: "Oliver's Real Food Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qub",
      code: "ASX:QUB",
      companyName: "QUBE Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pps",
      code: "ASX:PPS",
      companyName: "Praemium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-omh",
      code: "ASX:OMH",
      companyName: "Om Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ook",
      code: "ASX:OOK",
      companyName: "Ookami Ltd",
      popularity: 0,
    },
    {
      slug: "asx-om1",
      code: "ASX:OM1",
      companyName: "Omnia Metals Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hlf",
      code: "ASX:HLF",
      companyName: "Halo Food Co. Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oly",
      code: "ASX:OLY",
      companyName: "Olympio Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kko",
      code: "ASX:KKO",
      companyName: "Kinetiko Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lmg",
      code: "ASX:LMG",
      companyName: "Latrobe Magnesium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-slc",
      code: "ASX:SLC",
      companyName: "Superloop Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-lyft",
      code: "NASDAQ:LYFT",
      companyName: "Lyft Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-jrhg",
      code: "ASX:JRHG",
      companyName: "Jpmorgan GL Re En in EQH Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-map",
      code: "ASX:MAP",
      companyName: "Microba Life Sciences Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mm8n",
      code: "ASX:MM8N",
      companyName: "Medallion Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gedda",
      code: "ASX:GEDDA",
      companyName: "Golden Deeps Ltd",
      popularity: 0,
    },
    {
      slug: "asx-atcn",
      code: "ASX:ATCN",
      companyName: "Altech Batteries Ltd",
      popularity: 0,
    },
    {
      slug: "asx-igo",
      code: "ASX:IGO",
      companyName: "IGO Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-migi",
      code: "NASDAQ:MIGI",
      companyName: "Mawson Infrastructure Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wds",
      code: "NYSE:WDS",
      companyName:
        "Woodside Energy Group Limited American Depositary Shares each representing one Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-roku",
      code: "NASDAQ:ROKU",
      companyName: "Roku Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptc",
      code: "NASDAQ:PTC",
      companyName: "PTC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ssr",
      code: "ASX:SSR",
      companyName: "SSR Mining Inc",
      popularity: 0,
    },
    {
      slug: "asx-oph",
      code: "ASX:OPH",
      companyName: "Ophir High Conviction Fund",
      popularity: 0,
    },
    {
      slug: "asx-lrd",
      code: "ASX:LRD",
      companyName: "Lord Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cceda",
      code: "ASX:CCEDA",
      companyName: "Carnegie Clean Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-keys",
      code: "NYSE:KEYS",
      companyName: "Keysight Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "asx-fhe",
      code: "ASX:FHE",
      companyName: "Frontier Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-opn",
      code: "ASX:OPN",
      companyName: "Openn Negotiation Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-clw",
      code: "NYSE:CLW",
      companyName: "Clearwater Paper Corporation",
      popularity: 0,
    },
    {
      slug: "asx-ngl",
      code: "ASX:NGL",
      companyName: "Nightingale Intelligent Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sbux",
      code: "NYSE:SBUX",
      companyName: "Starbucks Corp",
      popularity: 0,
    },
    {
      slug: "asx-nnl",
      code: "ASX:NNL",
      companyName: "Nordic Nickel Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dhg",
      code: "ASX:DHG",
      companyName: "Domain Holdings Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cflo",
      code: "ASX:CFLO",
      companyName: "Betashares Global Cash Flow Kings ETF",
      popularity: 0,
    },
    {
      slug: "asx-1cg",
      code: "ASX:1CG",
      companyName: "One Click Group Ltd",
      popularity: 5000,
    },
    {
      slug: "asx-cbh",
      code: "ASX:CBH",
      companyName: "Coolabah Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-obm",
      code: "ASX:OBM",
      companyName: "Ora Banda Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eel",
      code: "ASX:EEL",
      companyName: "Enrg Elements Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pld",
      code: "NYSE:PLD",
      companyName: "PROLOGIS INC.",
      popularity: 0,
    },
    {
      slug: "asx-eqs",
      code: "ASX:EQS",
      companyName: "Equity Story Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bge",
      code: "ASX:BGE",
      companyName: "Bridge Saas Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ig6",
      code: "ASX:IG6",
      companyName: "International Graphite Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ccj",
      code: "NYSE:CCJ",
      companyName: "Cameco Corporation",
      popularity: 0,
    },
    {
      slug: "asx-opt",
      code: "ASX:OPT",
      companyName: "Opthea Ltd",
      popularity: 0,
    },
    {
      slug: "asx-opy",
      code: "ASX:OPY",
      companyName: "Openpay Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ibxda",
      code: "ASX:IBXDA",
      companyName: "Imagion Biosystems Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hre",
      code: "ASX:HRE",
      companyName: "Heavy Rare EARTHS Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rlf",
      code: "ASX:RLF",
      companyName: "RLF Agtech Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-hesm",
      code: "NYSE:HESM",
      companyName:
        "Hess Midstream LP Class A Share representing a limited partner Interest",
      popularity: 0,
    },
    {
      slug: "asx-gcx",
      code: "ASX:GCX",
      companyName: "GCX Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rhk",
      code: "ASX:RHK",
      companyName: "Red Hawk Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hcf",
      code: "ASX:HCF",
      companyName: "H&G High Conviction Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xtcn",
      code: "ASX:XTCN",
      companyName: "Xantippe Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-coin",
      code: "NASDAQ:COIN",
      companyName: "Coinbase Global Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-dtmnd",
      code: "ASX:DTMND",
      companyName: "Dart Mining NL",
      popularity: 0,
    },
    {
      slug: "asx-sgh",
      code: "ASX:SGH",
      companyName: "SLATER & GORDON LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-iren",
      code: "NYSE:IREN",
      companyName: "Iris Energy Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-ipx",
      code: "ASX:IPX",
      companyName: "Iperionx Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nhe",
      code: "ASX:NHE",
      companyName: "Noble Helium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lnr",
      code: "ASX:LNR",
      companyName: "Lanthanein Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-mist",
      code: "NASDAQ:MIST",
      companyName: "Milestone Pharmaceuticals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-hyt",
      code: "ASX:HYT",
      companyName: "Hyterra Ltd",
      popularity: 0,
    },
    {
      slug: "asx-psq",
      code: "ASX:PSQ",
      companyName: "Pacific Smiles Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pnt",
      code: "ASX:PNT",
      companyName: "Panther Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pim",
      code: "ASX:PIM",
      companyName: "Pinnacle Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ppc",
      code: "ASX:PPC",
      companyName: "Peet Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-csl",
      code: "NYSE:CSL",
      companyName: "Carlisle Companies Inc.",
      popularity: 0,
    },
    {
      slug: "asx-osm",
      code: "ASX:OSM",
      companyName: "Osmond Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pgh",
      code: "ASX:PGH",
      companyName: "Pact Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pia",
      code: "ASX:PIA",
      companyName: "Pengana International Equities Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pyr",
      code: "ASX:PYR",
      companyName: "Navalo Financial Services Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-repl",
      code: "NASDAQ:REPL",
      companyName: "Replimune Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-phat",
      code: "NYSE:PHAT",
      companyName: "Phathom Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-pnm",
      code: "ASX:PNM",
      companyName: "Pacific Nickel Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pck",
      code: "ASX:PCK",
      companyName: "Painchek Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pcg",
      code: "ASX:PCG",
      companyName: "Pengana Capital Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsr",
      code: "NASDAQ:NSR",
      companyName: "Nomad Royalty Company Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-qml",
      code: "ASX:QML",
      companyName: "Qmines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pfe",
      code: "ASX:PFE",
      companyName: "Pantera Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-prl",
      code: "ASX:PRL",
      companyName: "Province Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-poc",
      code: "ASX:POC",
      companyName: "PROGRESS 2022-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-pnr",
      code: "ASX:PNR",
      companyName: "Pantoro Ltd",
      popularity: 0,
    },
    {
      slug: "asx-puq",
      code: "ASX:PUQ",
      companyName: "PUMA SERIES 2014-4P",
      popularity: 0,
    },
    {
      slug: "asx-qnb",
      code: "ASX:QNB",
      companyName: "QNB FINANCE LTD",
      popularity: 0,
    },
    {
      slug: "asx-peb",
      code: "ASX:PEB",
      companyName: "Pacific Edge Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oxt",
      code: "ASX:OXT",
      companyName: "Orexplore Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pol",
      code: "ASX:POL",
      companyName: "Polymetals Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ozm",
      code: "ASX:OZM",
      companyName: "Ozaurum Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pcl",
      code: "ASX:PCL",
      companyName: "Pancontinental Energy NL",
      popularity: 0,
    },
    {
      slug: "asx-pgo",
      code: "ASX:PGO",
      companyName: "Pacgold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pbl",
      code: "ASX:PBL",
      companyName: "Parabellum Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pfg",
      code: "ASX:PFG",
      companyName: "Prime Financial Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-plt",
      code: "ASX:PLT",
      companyName: "Plenti Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pho",
      code: "ASX:PHO",
      companyName: "Phosco Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ptl",
      code: "ASX:PTL",
      companyName: "Prestal Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pil",
      code: "ASX:PIL",
      companyName: "Peppermint Innovation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qip",
      code: "ASX:QIP",
      companyName: "QANTM Intellectual Property Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ptx",
      code: "ASX:PTX",
      companyName: "Prescient Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-po3",
      code: "ASX:PO3",
      companyName: "Purifloh Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pnn",
      code: "ASX:PNN",
      companyName: "Power Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ppl",
      code: "ASX:PPL",
      companyName: "Pureprofile Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ppy",
      code: "ASX:PPY",
      companyName: "Papyrus Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pr1",
      code: "ASX:PR1",
      companyName: "Pure Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ihvv",
      code: "ASX:IHVV",
      companyName: "Ishares S&P 500 Aud Hedged ETF",
      popularity: 0,
    },
    {
      slug: "asx-pur",
      code: "ASX:PUR",
      companyName: "Pursuit Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-reit",
      code: "ASX:REIT",
      companyName: "Vaneck Ftse International Property (Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-qem",
      code: "ASX:QEM",
      companyName: "QEM Ltd",
      popularity: 0,
    },
    {
      slug: "asx-omx",
      code: "ASX:OMX",
      companyName: "Orange Minerals NL",
      popularity: 0,
    },
    {
      slug: "asx-spz",
      code: "ASX:SPZ",
      companyName: "Smart Parking Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rxm",
      code: "ASX:RXM",
      companyName: "REX Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xql",
      code: "ASX:XQL",
      companyName: "QUEENSLAND TREASURY CORPORATION",
      popularity: 0,
    },
    {
      slug: "asx-ron",
      code: "ASX:RON",
      companyName: "Ronin Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-som",
      code: "ASX:SOM",
      companyName: "Somnomed Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qpm",
      code: "ASX:QPM",
      companyName: "Queensland Pacific Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-skn",
      code: "ASX:SKN",
      companyName: "Skin Elements Ltd",
      popularity: 0,
    },
    {
      slug: "asx-stn",
      code: "ASX:STN",
      companyName: "Saturn Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-snd",
      code: "ASX:SND",
      companyName: "Saunders International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rxh",
      code: "ASX:RXH",
      companyName: "Rewardle Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sgl",
      code: "ASX:SGL",
      companyName: "RICEGROWERS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rml",
      code: "ASX:RML",
      companyName: "Resolution Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-acl",
      code: "ASX:ACL",
      companyName: "Australian Clinical Labs Ltd",
      popularity: 138000,
    },
    {
      slug: "asx-scw",
      code: "ASX:SCW",
      companyName: "SCENTRE GROUP TRUST 1",
      popularity: 0,
    },
    {
      slug: "asx-sca",
      code: "ASX:SCA",
      companyName: "SCENTRE GROUP TRUST 1 AND SCENTRE GROUP TRUST 2",
      popularity: 0,
    },
    {
      slug: "nasdaq-morf",
      code: "NASDAQ:MORF",
      companyName: "Morphic Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gold",
      code: "NASDAQ:GOLD",
      companyName: "Barrick Gold Corporation Common Stock (BC)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bld",
      code: "NASDAQ:BLD",
      companyName: "TopBuild Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-rr1",
      code: "ASX:RR1",
      companyName: "Reach Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-que",
      code: "ASX:QUE",
      companyName: "Queste Communications Ltd",
      popularity: 0,
    },
    {
      slug: "asx-skf",
      code: "ASX:SKF",
      companyName: "SKYFII Ltd",
      popularity: 0,
    },
    {
      slug: "asx-r8r",
      code: "ASX:R8R",
      companyName: "REGENER8 Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-rrr",
      code: "ASX:RRR",
      companyName: "Revolver Resources Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rep",
      code: "ASX:REP",
      companyName: "Ram Essential Services Property Fund",
      popularity: 0,
    },
    {
      slug: "asx-rc1",
      code: "ASX:RC1",
      companyName: "Redcastle Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-vymi",
      code: "NYSE:VYMI",
      companyName: "Vanguard International High Dividend Yield ETF",
      popularity: 0,
    },
    {
      slug: "asx-rey",
      code: "ASX:REY",
      companyName: "REY Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ree",
      code: "ASX:REE",
      companyName: "RAREX Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sks",
      code: "ASX:SKS",
      companyName: "SKS Technologies Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rte",
      code: "ASX:RTE",
      companyName: "Retech Technology Co. Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rth",
      code: "ASX:RTH",
      companyName: "Ras Technology Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gmtl",
      code: "ASX:GMTL",
      companyName: "Global X Green Metal Miners ETF",
      popularity: 0,
    },
    {
      slug: "asx-rvt",
      code: "ASX:RVT",
      companyName: "Richmond Vanadium Technology Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rvs",
      code: "ASX:RVS",
      companyName: "Revasum Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tls",
      code: "NYSE:TLS",
      companyName: "Telos Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-sfc",
      code: "ASX:SFC",
      companyName: "Schaffer Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-skt",
      code: "ASX:SKT",
      companyName: "Sky Network Television Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sky",
      code: "ASX:SKY",
      companyName: "SKY Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sov",
      code: "ASX:SOV",
      companyName: "Sovereign Cloud Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-spa",
      code: "ASX:SPA",
      companyName: "Spacetalk Ltd",
      popularity: 0,
    },
    {
      slug: "asx-spd",
      code: "ASX:SPD",
      companyName: "Southern Palladium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-srx",
      code: "ASX:SRX",
      companyName: "Sierra Rutile Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rwd",
      code: "ASX:RWD",
      companyName: "Reward Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-slh",
      code: "ASX:SLH",
      companyName: "Silk Logistics Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-svg",
      code: "ASX:SVG",
      companyName: "Savannah Goldfields Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-avgo",
      code: "NASDAQ:AVGO",
      companyName: "Broadcom Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ssm",
      code: "ASX:SSM",
      companyName: "Service Stream Ltd",
      popularity: 0,
    },
    {
      slug: "asx-svy",
      code: "ASX:SVY",
      companyName: "Stavely Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sgq",
      code: "ASX:SGQ",
      companyName: "ST George Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-auq",
      code: "ASX:AUQ",
      companyName: "Alara Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-1gov",
      code: "ASX:1GOV",
      companyName: "Vaneck 1-5 Year Australian Government Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tcom",
      code: "NYSE:TCOM",
      companyName: "Trip.com Group Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "asx-sgi",
      code: "ASX:SGI",
      companyName: "Stealth Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-scu",
      code: "ASX:SCU",
      companyName: "STEMCELL UNITED LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ajl",
      code: "ASX:AJL",
      companyName: "AJ Lucas Group Ltd",
      popularity: 35000,
    },
    {
      slug: "asx-grv",
      code: "ASX:GRV",
      companyName: "Greenvale Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-stp",
      code: "ASX:STP",
      companyName: "Step One Clothing Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tmb",
      code: "ASX:TMB",
      companyName: "Tambourah Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-srt",
      code: "ASX:SRT",
      companyName: "Strata Investment Holdings Plc",
      popularity: 0,
    },
    {
      slug: "asx-snl",
      code: "ASX:SNL",
      companyName: "Supply Network Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sm1",
      code: "ASX:SM1",
      companyName: "Synlait Milk Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-fslr",
      code: "NASDAQ:FSLR",
      companyName: "First Solar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-agi",
      code: "ASX:AGI",
      companyName: "Ainsworth Game Technology Ltd",
      popularity: 161000,
    },
    {
      slug: "asx-tal",
      code: "ASX:TAL",
      companyName: "Talius Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-s66",
      code: "ASX:S66",
      companyName: "Star Combo Pharma Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-nok",
      code: "NYSE:NOK",
      companyName: "Nokia Corporation",
      popularity: 0,
    },
    {
      slug: "asx-ksl",
      code: "ASX:KSL",
      companyName: "Kina Securities Ltd",
      popularity: 0,
    },
    {
      slug: "asx-spk",
      code: "ASX:SPK",
      companyName: "Spark New Zealand Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-laaa",
      code: "NASDAQ:LAAA",
      companyName: "Lakeshore Acquisition I Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-spl",
      code: "ASX:SPL",
      companyName: "Starpharma Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-imb",
      code: "ASX:IMB",
      companyName: "Intelligent Monitoring Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tbn",
      code: "ASX:TBN",
      companyName: "Tamboran Resources Corporation",
      popularity: 0,
    },
    {
      slug: "asx-srz",
      code: "ASX:SRZ",
      companyName: "Stellar Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-age",
      code: "ASX:AGE",
      companyName: "Alligator Energy Ltd",
      popularity: 99000,
    },
    {
      slug: "nasdaq-real",
      code: "NASDAQ:REAL",
      companyName: "The RealReal Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-slb",
      code: "ASX:SLB",
      companyName: "Stelar Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sop",
      code: "ASX:SOP",
      companyName: "Synertec Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shn",
      code: "ASX:SHN",
      companyName: "Sunshine Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-srn",
      code: "ASX:SRN",
      companyName: "Surefire Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-sun",
      code: "ASX:SUN",
      companyName: "Suncorp Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tsk",
      code: "ASX:TSK",
      companyName: "Task Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aiz",
      code: "ASX:AIZ",
      companyName: "Air New Zealand Ltd",
      popularity: 602000,
    },
    {
      slug: "asx-apw",
      code: "ASX:APW",
      companyName: "Aims Property Securities Fund",
      popularity: 24000,
    },
    {
      slug: "asx-gth",
      code: "ASX:GTH",
      companyName: "Gathid Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oxtn",
      code: "ASX:OXTN",
      companyName: "Orexplore Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sms",
      code: "ASX:SMS",
      companyName: "Star Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-sq",
      code: "NYSE:SQ",
      companyName: "Block Inc.",
      popularity: 0,
    },
    {
      slug: "asx-spn",
      code: "ASX:SPN",
      companyName: "Sparc Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ssh",
      code: "ASX:SSH",
      companyName: "SSH Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sst",
      code: "ASX:SST",
      companyName: "Steamships Trading Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rcen",
      code: "ASX:RCEN",
      companyName: "Recce Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sw1",
      code: "ASX:SW1",
      companyName: "Swift Networks Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-swp",
      code: "ASX:SWP",
      companyName: "Swoop Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-t88",
      code: "ASX:T88",
      companyName: "Taiton Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-seg",
      code: "ASX:SEG",
      companyName: "Sports Entertainment Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pln",
      code: "ASX:PLN",
      companyName: "Pioneer Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gas",
      code: "ASX:GAS",
      companyName: "State GAS Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebay",
      code: "NASDAQ:EBAY",
      companyName: "eBay Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-tcg",
      code: "ASX:TCG",
      companyName: "Turaco Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mxo",
      code: "ASX:MXO",
      companyName: "Motio Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nng",
      code: "ASX:NNG",
      companyName: "Nexion Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gmd",
      code: "ASX:GMD",
      companyName: "Genesis Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-toy",
      code: "ASX:TOY",
      companyName: "Toys'R'US ANZ Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tpc",
      code: "ASX:TPC",
      companyName: "TPC Consolidated Ltd",
      popularity: 0,
    },
    {
      slug: "asx-uva",
      code: "ASX:UVA",
      companyName: "Uvre Ltd",
      popularity: 0,
    },
    {
      slug: "asx-urf",
      code: "ASX:URF",
      companyName: "US Masters Residential Property Fund",
      popularity: 0,
    },
    {
      slug: "asx-m2m",
      code: "ASX:M2M",
      companyName: "MT Malcolm Mines NL",
      popularity: 0,
    },
    {
      slug: "asx-urw",
      code: "ASX:URW",
      companyName: "Unibail-Rodamco-Westfield",
      popularity: 0,
    },
    {
      slug: "asx-ubi",
      code: "ASX:UBI",
      companyName: "Universal Biosensors Inc",
      popularity: 0,
    },
    {
      slug: "asx-hct",
      code: "ASX:HCT",
      companyName: "Holista Colltech Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vpg",
      code: "ASX:VPG",
      companyName: "VODAFONE GROUP PLC.",
      popularity: 0,
    },
    {
      slug: "asx-iaf",
      code: "ASX:IAF",
      companyName: "Ishares Core Composite Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-t92",
      code: "ASX:T92",
      companyName: "Terra Uranium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vuk",
      code: "ASX:VUK",
      companyName: "Virgin Money Uk Plc",
      popularity: 0,
    },
    {
      slug: "asx-val",
      code: "ASX:VAL",
      companyName: "Valor Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vr1",
      code: "ASX:VR1",
      companyName: "Vection Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mih",
      code: "ASX:MIH",
      companyName: "MNC Media Investment Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ubn",
      code: "ASX:UBN",
      companyName: "Urbanise.com Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tl1",
      code: "ASX:TL1",
      companyName: "TELSTRA CORPORATION LIMITED..",
      popularity: 0,
    },
    {
      slug: "asx-ucm",
      code: "ASX:UCM",
      companyName: "Uscom Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vtx",
      code: "ASX:VTX",
      companyName: "Vertex Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tba",
      code: "ASX:TBA",
      companyName: "Tombola Gold Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-aain",
      code: "NASDAQ:AAIN",
      companyName:
        "Arlington Asset Investment Corp 6.000% Senior Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "asx-1tt",
      code: "ASX:1TT",
      companyName: "Thrive Tribe Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vbc",
      code: "ASX:VBC",
      companyName: "Verbrec Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tgh",
      code: "ASX:TGH",
      companyName: "Terragen Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tvl",
      code: "ASX:TVL",
      companyName: "Touch Ventures Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sbm",
      code: "ASX:SBM",
      companyName: "ST Barbara Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hpc",
      code: "ASX:HPC",
      companyName: "The Hydration Pharmaceuticals Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cco",
      code: "ASX:CCO",
      companyName: "The Calmer Co International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-moh",
      code: "ASX:MOH",
      companyName: "Moho Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hack",
      code: "ASX:HACK",
      companyName: "Betashares Global Cybersecurity ETF",
      popularity: 0,
    },
    {
      slug: "asx-tre",
      code: "ASX:TRE",
      companyName: "Toubani Resources Inc",
      popularity: 0,
    },
    {
      slug: "asx-trp",
      code: "ASX:TRP",
      companyName: "Tissue Repair Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tti",
      code: "ASX:TTI",
      companyName: "Traffic Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vit",
      code: "ASX:VIT",
      companyName: "Vitura Health Ltd",
      popularity: 0,
    },
    {
      slug: "asx-twr",
      code: "ASX:TWR",
      companyName: "Tower Ltd",
      popularity: 0,
    },
    {
      slug: "asx-uos",
      code: "ASX:UOS",
      companyName: "United Overseas Australia Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pep",
      code: "NYSE:PEP",
      companyName: "PepsiCo Inc.",
      popularity: 0,
    },
    {
      slug: "asx-usq",
      code: "ASX:USQ",
      companyName: "US Student Housing REIT",
      popularity: 0,
    },
    {
      slug: "asx-mob",
      code: "ASX:MOB",
      companyName: "Mobilicom Ltd",
      popularity: 0,
    },
    {
      slug: "asx-var",
      code: "ASX:VAR",
      companyName: "Variscan Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vmg",
      code: "ASX:VMG",
      companyName: "VDM Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-veu",
      code: "ASX:VEU",
      companyName: "Vanguard All-World Ex-US Shares INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-tms",
      code: "ASX:TMS",
      companyName: "Tennant Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-x64",
      code: "ASX:X64",
      companyName: "Ten Sixty Four Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wa1",
      code: "ASX:WA1",
      companyName: "WA1 Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-usl",
      code: "ASX:USL",
      companyName: "Unico Silver Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vn8",
      code: "ASX:VN8",
      companyName: "VONEX Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pen",
      code: "ASX:PEN",
      companyName: "Peninsula Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-nee",
      code: "NYSE:NEE",
      companyName: "Nextra Energy Inc.",
      popularity: 0,
    },
    {
      slug: "asx-fbm",
      code: "ASX:FBM",
      companyName: "Future Battery Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vpr",
      code: "ASX:VPR",
      companyName: "Volt Power Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-pins",
      code: "NASDAQ:PINS",
      companyName: "Pinterest Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abr",
      code: "NASDAQ:ABR",
      companyName: "Arbor Realty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-vrx",
      code: "ASX:VRX",
      companyName: "VRX Silica Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mg1",
      code: "ASX:MG1",
      companyName: "MINING GREEN METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dur",
      code: "ASX:DUR",
      companyName: "Duratec Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-cwbc",
      code: "NASDAQ:CWBC",
      companyName: "Community West Bancshares Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-iog",
      code: "ASX:IOG",
      companyName: "INNOGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wnx",
      code: "ASX:WNX",
      companyName: "Wellnex Life Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wsi",
      code: "ASX:WSI",
      companyName: "Weststar Industrial Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wtn",
      code: "ASX:WTN",
      companyName: "Winton Land Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gnp",
      code: "ASX:GNP",
      companyName: "Genusplus Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vys",
      code: "ASX:VYS",
      companyName: "Vysarn Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-shop",
      code: "NYSE:SHOP",
      companyName: "Shopify Inc. Class A subordinate voting shares",
      popularity: 0,
    },
    {
      slug: "asx-w2v",
      code: "ASX:W2V",
      companyName: "Way 2 Vat Ltd",
      popularity: 0,
    },
    {
      slug: "asx-phx",
      code: "ASX:PHX",
      companyName: "Pharmx Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bsv",
      code: "NYSE:BSV",
      companyName: "Vanguard Short-Term Bond ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-nee",
      code: "NASDAQ:NEE",
      companyName: "NextEra Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ipg",
      code: "ASX:IPG",
      companyName: "Ipd Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wyx",
      code: "ASX:WYX",
      companyName: "Western Yilgarn NL",
      popularity: 0,
    },
    {
      slug: "asx-vht",
      code: "ASX:VHT",
      companyName: "Volpara Health Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wgn",
      code: "ASX:WGN",
      companyName: "Wagners Holding Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wcg",
      code: "ASX:WCG",
      companyName: "Webcentral Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wkt",
      code: "ASX:WKT",
      companyName: "Walkabout Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wbedc",
      code: "ASX:WBEDC",
      companyName: "Whitebark Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xgov",
      code: "ASX:XGOV",
      companyName: "Vaneck 10+ Year Australian Government Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-vsr",
      code: "ASX:VSR",
      companyName: "Voltaic Strategic Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-agi",
      code: "NASDAQ:AGI",
      companyName: "Alamos Gold Inc. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-wgr",
      code: "ASX:WGR",
      companyName: "Western Gold Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pll",
      code: "NYSE:PLL",
      companyName: "Piedmont Lithium Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ojc",
      code: "ASX:OJC",
      companyName: "The Original Juice Co. Ltd",
      popularity: 0,
    },
    {
      slug: "asx-5gov",
      code: "ASX:5GOV",
      companyName: "Vaneck 5-10 Year Australian Government Bond ETF",
      popularity: 5000,
    },
    {
      slug: "asx-mxt",
      code: "ASX:MXT",
      companyName: "Metrics Master Income Trust",
      popularity: 0,
    },
    {
      slug: "asx-gnc",
      code: "ASX:GNC",
      companyName: "Graincorp Ltd",
      popularity: 0,
    },
    {
      slug: "asx-m7t",
      code: "ASX:M7T",
      companyName: "MACH7 Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-siq",
      code: "ASX:SIQ",
      companyName: "Smartgroup Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-se",
      code: "NASDAQ:SE",
      companyName:
        "Sea Limited American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ben",
      code: "NASDAQ:BEN",
      companyName: "Franklin Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-adxda",
      code: "ASX:ADXDA",
      companyName: "ADX Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pkon",
      code: "ASX:PKON",
      companyName: "Peako Ltd",
      popularity: 0,
    },
    {
      slug: "asx-waa",
      code: "ASX:WAA",
      companyName: "Wam Active Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vrc",
      code: "ASX:VRC",
      companyName: "Volt Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-emdn",
      code: "ASX:EMDN",
      companyName: "Emyria Ltd",
      popularity: 0,
    },
    {
      slug: "asx-azyn",
      code: "ASX:AZYN",
      companyName: "Antipa Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-sq",
      code: "NASDAQ:SQ",
      companyName: "Block Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-zim",
      code: "ASX:ZIM",
      companyName: "Zimplats Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-emkt",
      code: "ASX:EMKT",
      companyName: "Vaneck MSCI Multifactor Em Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "asx-ihwl",
      code: "ASX:IHWL",
      companyName: "Ishares Core MSCI World Ex Aus Esg (Aud Hed) ETF",
      popularity: 0,
    },
    {
      slug: "asx-yow",
      code: "ASX:YOW",
      companyName: "Yowie Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-dhi",
      code: "NYSE:DHI",
      companyName: "D.R. Horton Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcd",
      code: "NASDAQ:MCD",
      companyName: "McDonald's Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shv",
      code: "NYSE:SHV",
      companyName: "iShares Short Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-rinc",
      code: "ASX:RINC",
      companyName: "Betashares MRTN Currie RL Inc Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-idj",
      code: "ASX:IDJ",
      companyName: "IDOL 2011-2 TRUST",
      popularity: 0,
    },
    {
      slug: "nasdaq-acgln",
      code: "NASDAQ:ACGLN",
      companyName:
        "Arch Capital Group Ltd. Depositary Shares each Representing a 1/1000th Interest in a 4.550% Non-Cumulative Preferred Share Series G",
      popularity: 0,
    },
    {
      slug: "asx-bear",
      code: "ASX:BEAR",
      companyName: "Betashares Australian Equities Bear (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-x2m",
      code: "ASX:X2M",
      companyName: "X2M Connect Ltd",
      popularity: 0,
    },
    {
      slug: "asx-yar",
      code: "ASX:YAR",
      companyName: "Yari Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xrg",
      code: "ASX:XRG",
      companyName: "Xreality Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pgr",
      code: "NYSE:PGR",
      companyName: "Progressive Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-sivb",
      code: "NASDAQ:SIVB",
      companyName: "SVB Financial Group Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ypb",
      code: "ASX:YPB",
      companyName: "YPB Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-zeo",
      code: "ASX:ZEO",
      companyName: "Zeotech Ltd",
      popularity: 0,
    },
    {
      slug: "asx-zer",
      code: "ASX:ZER",
      companyName: "ZETA Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-zeu",
      code: "ASX:ZEU",
      companyName: "ZEUS Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-twen",
      code: "ASX:TWEN",
      companyName: "Treasury Wine Estates Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xl8",
      code: "ASX:XL8",
      companyName: "XLR8 METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-jdopa",
      code: "ASX:JDOPA",
      companyName: "Judo Capital Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-zmi",
      code: "ASX:ZMI",
      companyName: "ZINC of Ireland NL",
      popularity: 0,
    },
    {
      slug: "asx-zmm",
      code: "ASX:ZMM",
      companyName: "ZIMI Ltd",
      popularity: 0,
    },
    {
      slug: "asx-yrl",
      code: "ASX:YRL",
      companyName: "Yandal Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-atvi",
      code: "NASDAQ:ATVI",
      companyName: "Activision Blizzard Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrsn",
      code: "NASDAQ:VRSN",
      companyName: "VeriSign Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sgen",
      code: "NYSE:SGEN",
      companyName: "Seagen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-chk",
      code: "NYSE:CHK",
      companyName: "Chesapeake Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-mkt",
      code: "ASX:MKT",
      companyName: "The Market Ltd",
      popularity: 0,
    },
    {
      slug: "asx-idt",
      code: "ASX:IDT",
      companyName: "IDT Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-emmg",
      code: "ASX:EMMG",
      companyName: "Betashares Martin Currie Em Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-zld",
      code: "ASX:ZLD",
      companyName: "Zelira Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-znc",
      code: "ASX:ZNC",
      companyName: "Zenith Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-yoj",
      code: "ASX:YOJ",
      companyName: "Yojee Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ybr",
      code: "ASX:YBR",
      companyName: "Yellow Brick Road Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qoz",
      code: "ASX:QOZ",
      companyName: "Betashares Ftse Rafi Australia 200 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nem",
      code: "NYSE:NEM",
      companyName: "Newmont Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-cprt",
      code: "NASDAQ:CPRT",
      companyName: "Copart Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-alm",
      code: "ASX:ALM",
      companyName: "Alma Metals Ltd",
      popularity: 7000,
    },
    {
      slug: "nyse-apo",
      code: "NYSE:APO",
      companyName: "Apollo Global Management Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-chpt",
      code: "NYSE:CHPT",
      companyName: "ChargePoint Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mmp",
      code: "NYSE:MMP",
      companyName: "Magellan Midstream Partners L.P.",
      popularity: 0,
    },
    {
      slug: "asx-ike",
      code: "ASX:IKE",
      companyName: "Ikegps Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-gdx",
      code: "NYSE:GDX",
      companyName: "VanEck Gold Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aal",
      code: "NYSE:AAL",
      companyName: "American Airlines Group Inc.",
      popularity: 0,
    },
    {
      slug: "asx-rfg",
      code: "ASX:RFG",
      companyName: "Retail Food Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ael-a",
      code: "NASDAQ:AEL-A",
      companyName:
        "American Equity Investment Life Holding Company Depositary Shares each representing a 1/1000th interest in a share of 5.95% Fixed-Rate Reset Non-Cumulative Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-myps",
      code: "NASDAQ:MYPS",
      companyName: "PLAYSTUDIOS Inc.  Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-exln",
      code: "ASX:EXLN",
      companyName: "Elixinol Wellness Ltd",
      popularity: 0,
    },
    {
      slug: "asx-uni",
      code: "ASX:UNI",
      companyName: "Universal Store Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsqr",
      code: "NASDAQ:BSQR",
      companyName: "BSQUARE Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mdt",
      code: "NYSE:MDT",
      companyName: "Medtronic plc",
      popularity: 0,
    },
    {
      slug: "nyse-xpev",
      code: "NYSE:XPEV",
      companyName:
        "XPeng Inc. American depositary shares each representing two Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-k",
      code: "NYSE:K",
      companyName: "Kellogg Company",
      popularity: 0,
    },
    {
      slug: "asx-xgl",
      code: "ASX:XGL",
      companyName: "Xamble Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tnc",
      code: "ASX:TNC",
      companyName: "True North Copper Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nxl",
      code: "ASX:NXL",
      companyName: "NUIX Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kgl",
      code: "ASX:KGL",
      companyName: "KGL Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-nclh",
      code: "NYSE:NCLH",
      companyName: "Norwegian Cruise Line Holdings Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pbh",
      code: "NYSE:PBH",
      companyName: "Prestige Consumer Healthcare Inc.",
      popularity: 0,
    },
    {
      slug: "asx-smp",
      code: "ASX:SMP",
      companyName: "Smartpay Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-lpx",
      code: "NYSE:LPX",
      companyName: "Louisiana-Pacific Corp.",
      popularity: 0,
    },
    {
      slug: "asx-one",
      code: "ASX:ONE",
      companyName: "Oneview Healthcare Plc",
      popularity: 0,
    },
    {
      slug: "asx-hlo",
      code: "ASX:HLO",
      companyName: "Helloworld Travel Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-enia",
      code: "NASDAQ:ENIA",
      companyName: "Enel Americas S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kc",
      code: "NASDAQ:KC",
      companyName: "Kingsoft Cloud Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-csgp",
      code: "NASDAQ:CSGP",
      companyName: "CoStar Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xom",
      code: "NASDAQ:XOM",
      companyName: "Exxon Mobil Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snx",
      code: "NYSE:SNX",
      companyName: "TD SYNNEX Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-mara",
      code: "NASDAQ:MARA",
      companyName: "Marathon Digital Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wfg",
      code: "NYSE:WFG",
      companyName: "West Fraser Timber Co. Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-wy",
      code: "NYSE:WY",
      companyName: "Weyerhaeuser Company",
      popularity: 0,
    },
    {
      slug: "asx-ask",
      code: "ASX:ASK",
      companyName: "Abacus Storage King",
      popularity: 7000,
    },
    {
      slug: "asx-ajqda",
      code: "ASX:AJQDA",
      companyName: "Armour Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nsb",
      code: "ASX:NSB",
      companyName: "Neuroscientific Biopharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-wsm",
      code: "NASDAQ:WSM",
      companyName: "Williams-Sonoma Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "asx-vhy",
      code: "ASX:VHY",
      companyName: "Vanguard Australian Shares High Yield ETF",
      popularity: 0,
    },
    {
      slug: "asx-sgr",
      code: "ASX:SGR",
      companyName: "The Star Entertainment Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tua",
      code: "ASX:TUA",
      companyName: "Tuas Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ilu",
      code: "ASX:ILU",
      companyName: "Iluka Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bsqr",
      code: "NYSE:BSQR",
      companyName: "BSQUARE Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhi",
      code: "NASDAQ:DHI",
      companyName: "D.R. Horton Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pm",
      code: "NASDAQ:PM",
      companyName: "Philip Morris International Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-schw",
      code: "NYSE:SCHW",
      companyName: "The Charles Schwab Corporation",
      popularity: 0,
    },
    {
      slug: "asx-dub",
      code: "ASX:DUB",
      companyName: "Dubber Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ivv",
      code: "NYSE:IVV",
      companyName: "iShares Core S&P 500 ETF",
      popularity: 0,
    },
    {
      slug: "asx-rpl",
      code: "ASX:RPL",
      companyName: "Regal Partners Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-apa",
      code: "NYSE:APA",
      companyName: "APA Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aogo",
      code: "NASDAQ:AOGO",
      companyName: "Arogo Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-exai",
      code: "NASDAQ:EXAI",
      companyName: "Exscientia Plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "asx-ign",
      code: "ASX:IGN",
      companyName: "Ignite Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nhf",
      code: "ASX:NHF",
      companyName: "Nib Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-lng",
      code: "NYSE:LNG",
      companyName: "Cheniere Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ttd",
      code: "NYSE:TTD",
      companyName: "The Trade Desk Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-li",
      code: "NASDAQ:LI",
      companyName: "Li Auto Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "asx-lin",
      code: "ASX:LIN",
      companyName: "Lindian Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-xom",
      code: "NYSE:XOM",
      companyName: "Exxon Mobil Corporation",
      popularity: 0,
    },
    {
      slug: "asx-stw",
      code: "ASX:STW",
      companyName: "SPDR S&P/ASX 200 Fund",
      popularity: 0,
    },
    {
      slug: "asx-imm",
      code: "ASX:IMM",
      companyName: "Immutep Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tlx",
      code: "ASX:TLX",
      companyName: "TELIX Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-snas",
      code: "ASX:SNAS",
      companyName: "Global X Ultra Short Nasdaq 100 Hedge Fund",
      popularity: 0,
    },
    {
      slug: "asx-eof",
      code: "ASX:EOF",
      companyName: "Ecofibre Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-wmt",
      code: "NYSE:WMT",
      companyName: "Walmart Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lsi",
      code: "NYSE:LSI",
      companyName: "Life Storage Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ulta",
      code: "NASDAQ:ULTA",
      companyName: "Ulta Beauty Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-mel",
      code: "ASX:MEL",
      companyName: "Metgasco Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ioo",
      code: "ASX:IOO",
      companyName: "Ishares Global 100 ETF",
      popularity: 0,
    },
    {
      slug: "asx-mqdb",
      code: "ASX:MQDB",
      companyName: "Macquarie Dynamic Bond Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "nasdaq-biib",
      code: "NASDAQ:BIIB",
      companyName: "Biogen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-mqio",
      code: "ASX:MQIO",
      companyName: "Macquarie Income Opp Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-mqws",
      code: "ASX:MQWS",
      companyName: "MQ Walter Scott GLBL EQ Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "nyse-eix",
      code: "NYSE:EIX",
      companyName: "Edison International",
      popularity: 0,
    },
    {
      slug: "nasdaq-nio",
      code: "NASDAQ:NIO",
      companyName:
        "NIO Inc. American depositary shares each  representing one Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nyse-pcg",
      code: "NYSE:PCG",
      companyName: "PG&E Corporation",
      popularity: 0,
    },
    {
      slug: "asx-apln",
      code: "ASX:APLN",
      companyName: "Associate Global Partners Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-hsdt",
      code: "NASDAQ:HSDT",
      companyName: "Helius Medical Technologies Inc. Class A Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "asx-kpon",
      code: "ASX:KPON",
      companyName: "Kalina Power Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-zts",
      code: "NASDAQ:ZTS",
      companyName: "Zoetis Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amd",
      code: "NASDAQ:AMD",
      companyName: "Advanced Micro Devices Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ikw",
      code: "ASX:IKW",
      companyName: "IKWEZI MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-areb",
      code: "NASDAQ:AREB",
      companyName: "American Rebel Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-exp",
      code: "NYSE:EXP",
      companyName: "Eagle Materials Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-arebw",
      code: "NASDAQ:AREBW",
      companyName: "American Rebel Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "asx-lyc",
      code: "ASX:LYC",
      companyName: "Lynas Rare EARTHS Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wire",
      code: "ASX:WIRE",
      companyName: "Global X Copper Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kss",
      code: "NYSE:KSS",
      companyName: "Kohl's Corporation",
      popularity: 0,
    },
    {
      slug: "asx-beo",
      code: "ASX:BEO",
      companyName: "Beonic Ltd",
      popularity: 0,
    },
    {
      slug: "asx-chmn",
      code: "ASX:CHMN",
      companyName: "Chimeric Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qsml",
      code: "ASX:QSML",
      companyName: "Vaneck MSCI Intl Small Companies Quality ETF",
      popularity: 0,
    },
    {
      slug: "asx-hiqn",
      code: "ASX:HIQN",
      companyName: "HITIQ Ltd",
      popularity: 0,
    },
    {
      slug: "asx-g11",
      code: "ASX:G11",
      companyName: "G11 Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tbil",
      code: "ASX:TBIL",
      companyName: "Vaneck 1-3 Month US Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-advdb",
      code: "ASX:ADVDB",
      companyName: "Ardiden Ltd",
      popularity: 0,
    },
    {
      slug: "asx-usig",
      code: "ASX:USIG",
      companyName: "Global X Usd Corporate Bond ETF (Currency Hedged)",
      popularity: 0,
    },
    {
      slug: "asx-thl",
      code: "ASX:THL",
      companyName: "Tourism Holdings Rentals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-dpz",
      code: "NASDAQ:DPZ",
      companyName: "Domino's Pizza Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-mmkt",
      code: "ASX:MMKT",
      companyName: "Betashares Aust. Cash Plus Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-bgen",
      code: "ASX:BGEN",
      companyName: "Bridge Saas Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gue",
      code: "ASX:GUE",
      companyName: "Global Uranium and Enrichment Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bud",
      code: "NYSE:BUD",
      companyName: "Anheuser-Busch INBEV SA/NV",
      popularity: 0,
    },
    {
      slug: "asx-mpk",
      code: "ASX:MPK",
      companyName: "Many Peaks Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-de",
      code: "NYSE:DE",
      companyName: "Deere & Company",
      popularity: 0,
    },
    {
      slug: "asx-ina",
      code: "ASX:INA",
      companyName: "Ingenia Communities Group",
      popularity: 0,
    },
    {
      slug: "nyse-dxcm",
      code: "NYSE:DXCM",
      companyName: "DexCom Inc.",
      popularity: 0,
    },
    {
      slug: "asx-coyn",
      code: "ASX:COYN",
      companyName: "Coppermoly Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cblna",
      code: "ASX:CBLNA",
      companyName: "Control Bionics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hcl",
      code: "ASX:HCL",
      companyName: "Highcom Ltd",
      popularity: 0,
    },
    {
      slug: "asx-psln",
      code: "ASX:PSLN",
      companyName: "Paterson Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-autda",
      code: "ASX:AUTDA",
      companyName: "Auteco Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rhkn",
      code: "ASX:RHKN",
      companyName: "Red Hawk Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-npmda",
      code: "ASX:NPMDA",
      companyName: "Newpeak Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jll",
      code: "ASX:JLL",
      companyName: "Jindalee Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bexda",
      code: "ASX:BEXDA",
      companyName: "Bikeexchange Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tx3",
      code: "ASX:TX3",
      companyName: "Trinex Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ccm",
      code: "ASX:CCM",
      companyName: "Cadoux Ltd",
      popularity: 0,
    },
    {
      slug: "asx-javdf",
      code: "ASX:JAVDF",
      companyName: "Javelin Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lkoda",
      code: "ASX:LKODA",
      companyName: "Lakes Blue Energy NL",
      popularity: 0,
    },
    {
      slug: "asx-anrn",
      code: "ASX:ANRN",
      companyName: "Anatara Lifesciences Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aqxnb",
      code: "ASX:AQXNB",
      companyName: "Alice QUEEN Ltd",
      popularity: 0,
    },
    {
      slug: "asx-podra",
      code: "ASX:PODRA",
      companyName: "Podium Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wecr",
      code: "ASX:WECR",
      companyName: "White Energy Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hlsnb",
      code: "ASX:HLSNB",
      companyName: "Healius Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ixr",
      code: "ASX:IXR",
      companyName: "Ionic Rare EARTHS Ltd",
      popularity: 0,
    },
    {
      slug: "asx-radn",
      code: "ASX:RADN",
      companyName: "Radiopharm Theranostics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gold",
      code: "ASX:GOLD",
      companyName: "Global X Metal Securities Australia Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctsh",
      code: "NASDAQ:CTSH",
      companyName:
        "Cognizant Technology Solutions Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-nwfn",
      code: "ASX:NWFN",
      companyName: "Newfield Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sfr",
      code: "ASX:SFR",
      companyName: "Sandfire Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-us10",
      code: "ASX:US10",
      companyName: "Betashares US Treasury Bond 7-10YR CH ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-gehc",
      code: "NASDAQ:GEHC",
      companyName: "GE HealthCare Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hca",
      code: "NYSE:HCA",
      companyName: "HCA Healthcare Inc.",
      popularity: 0,
    },
    {
      slug: "asx-cvb",
      code: "ASX:CVB",
      companyName: "Curvebeam Ai Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-acn",
      code: "NASDAQ:ACN",
      companyName: "Accenture plc Class A Ordinary Shares (Ireland)",
      popularity: 0,
    },
    {
      slug: "asx-ase",
      code: "ASX:ASE",
      companyName: "Astute Metals NL",
      popularity: 0,
    },
    {
      slug: "nyse-unh",
      code: "NYSE:UNH",
      companyName: "UNITEDHEALTH GROUP INCORPORATED (Delaware)",
      popularity: 0,
    },
    {
      slug: "asx-ila",
      code: "ASX:ILA",
      companyName: "Island Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-arec",
      code: "NASDAQ:AREC",
      companyName: "American Resources Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-l1if",
      code: "ASX:L1IF",
      companyName: "L1 Capital International Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "nyse-coke",
      code: "NYSE:COKE",
      companyName: "Coca-Cola Consolidated Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nio",
      code: "NYSE:NIO",
      companyName:
        "NIO Inc. American depositary shares each representing one Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "asx-azj",
      code: "ASX:AZJ",
      companyName: "Aurizon Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ifra",
      code: "ASX:IFRA",
      companyName: "Vaneck Ftse Global Infrastructure (Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ba",
      code: "NYSE:BA",
      companyName: "Boeing Company",
      popularity: 0,
    },
    {
      slug: "nasdaq-bx",
      code: "NASDAQ:BX",
      companyName: "Blackstone Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ril",
      code: "ASX:RIL",
      companyName: "Redivium Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-swav",
      code: "NASDAQ:SWAV",
      companyName: "ShockWave Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-t3ddb",
      code: "ASX:T3DDB",
      companyName: "333D Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-amzn",
      code: "NASDAQ:AMZN",
      companyName: "Amazon.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-adrda",
      code: "ASX:ADRDA",
      companyName: "Adherium Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-relx",
      code: "NYSE:RELX",
      companyName: "RELX PLC",
      popularity: 0,
    },
    {
      slug: "nyse-iot",
      code: "NYSE:IOT",
      companyName: "Samsara Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cvs",
      code: "NYSE:CVS",
      companyName: "CVS HEALTH CORPORATION",
      popularity: 0,
    },
    {
      slug: "nasdaq-aren",
      code: "NASDAQ:AREN",
      companyName: "The Arena Group Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ngi",
      code: "ASX:NGI",
      companyName: "Navigator Global Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-toeda",
      code: "ASX:TOEDA",
      companyName: "Toro Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vnl",
      code: "ASX:VNL",
      companyName: "Vinyl Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-crwd",
      code: "NASDAQ:CRWD",
      companyName: "CrowdStrike Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-qual",
      code: "ASX:QUAL",
      companyName: "Vaneck MSCI International Quality ETF",
      popularity: 0,
    },
    {
      slug: "asx-bill",
      code: "ASX:BILL",
      companyName: "Ishares Core Cash ETF",
      popularity: 0,
    },
    {
      slug: "asx-xtcda",
      code: "ASX:XTCDA",
      companyName: "Xantippe Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-aapl",
      code: "NASDAQ:AAPL",
      companyName: "Apple Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jnj",
      code: "NYSE:JNJ",
      companyName: "Johnson & Johnson",
      popularity: 0,
    },
    {
      slug: "nyse-phg",
      code: "NYSE:PHG",
      companyName: "KONINKLIJKE PHILIPS  N.V.",
      popularity: 0,
    },
    {
      slug: "asx-vts",
      code: "ASX:VTS",
      companyName: "Vanguard US Total Market Shares INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-aru",
      code: "ASX:ARU",
      companyName: "Arafura Rare EARTHS Ltd",
      popularity: 529000,
    },
    {
      slug: "nyse-axp",
      code: "NYSE:AXP",
      companyName: "American Express Company",
      popularity: 0,
    },
    {
      slug: "nyse-orcl",
      code: "NYSE:ORCL",
      companyName: "Oracle Corp",
      popularity: 0,
    },
    {
      slug: "asx-rntn",
      code: "ASX:RNTN",
      companyName: "Rent.com.Au Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jbh",
      code: "ASX:JBH",
      companyName: "JB Hi-Fi Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-hack",
      code: "NYSE:HACK",
      companyName: "ETFMG Prime Cyber Security ETF",
      popularity: 0,
    },
    {
      slug: "asx-rmd",
      code: "ASX:RMD",
      companyName: "Resmed Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccep",
      code: "NASDAQ:CCEP",
      companyName: "Coca-Cola Europacific Partners plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-intu",
      code: "NASDAQ:INTU",
      companyName: "Intuit Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-hrnr",
      code: "ASX:HRNR",
      companyName: "Horizon Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cqr",
      code: "ASX:CQR",
      companyName: "Charter Hall Retail REIT",
      popularity: 0,
    },
    {
      slug: "nasdaq-intc",
      code: "NASDAQ:INTC",
      companyName: "Intel Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-lkong",
      code: "ASX:LKONG",
      companyName: "Lakes Blue Energy NL",
      popularity: 0,
    },
    {
      slug: "asx-nvq",
      code: "ASX:NVQ",
      companyName: "Noviqtech Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-cost",
      code: "NASDAQ:COST",
      companyName: "Costco Wholesale Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jnj",
      code: "NASDAQ:JNJ",
      companyName: "Johnson & Johnson Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unh",
      code: "NASDAQ:UNH",
      companyName: "UnitedHealth Group Incorporated Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "asx-scg",
      code: "ASX:SCG",
      companyName: "Scentre Group",
      popularity: 0,
    },
    {
      slug: "nyse-tpr",
      code: "NYSE:TPR",
      companyName: "Tapestry Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-pe1",
      code: "ASX:PE1",
      companyName: "Pengana Private Equity Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-nflx",
      code: "NASDAQ:NFLX",
      companyName: "Netflix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slb",
      code: "NASDAQ:SLB",
      companyName: "Schlumberger N.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-mbkn",
      code: "ASX:MBKN",
      companyName: "Metal Bank Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-splk",
      code: "NASDAQ:SPLK",
      companyName: "Splunk Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-veev",
      code: "NASDAQ:VEEV",
      companyName: "Veeva Systems Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asb-e",
      code: "NASDAQ:ASB-E",
      companyName:
        "Associated Banc-Corp Depositary Shares each representing a 1/40th interest in a share of 5.875% Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nyse-iemg",
      code: "NYSE:IEMG",
      companyName: "iShares Core MSCI Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-googl",
      code: "NASDAQ:GOOGL",
      companyName: "Alphabet Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-byd",
      code: "NASDAQ:BYD",
      companyName: "Boyd Gaming Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qqq",
      code: "NYSE:QQQ",
      companyName: "Invesco QQQ Trust Series 1",
      popularity: 0,
    },
    {
      slug: "nyse-vwo",
      code: "NYSE:VWO",
      companyName: "Vanguard FTSE Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "asx-jlg",
      code: "ASX:JLG",
      companyName: "Johns LYNG Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-arb",
      code: "ASX:ARB",
      companyName: "ARB Corporation Ltd",
      popularity: 455000,
    },
    {
      slug: "asx-pme",
      code: "ASX:PME",
      companyName: "Pro Medicus Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mnd",
      code: "ASX:MND",
      companyName: "Monadelphous Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pg",
      code: "NYSE:PG",
      companyName: "Procter & Gamble Company",
      popularity: 0,
    },
    {
      slug: "asx-clw",
      code: "ASX:CLW",
      companyName: "Charter Hall Long Wale REIT",
      popularity: 0,
    },
    {
      slug: "asx-chn",
      code: "ASX:CHN",
      companyName: "Chalice Mining Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-baba",
      code: "NASDAQ:BABA",
      companyName:
        "Alibaba Group Holding Limited American Depositary Shares each representing eight Ordinary share",
      popularity: 0,
    },
    {
      slug: "nyse-hrb",
      code: "NYSE:HRB",
      companyName: "H&R Block Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rio",
      code: "NYSE:RIO",
      companyName: "Rio Tinto plc",
      popularity: 0,
    },
    {
      slug: "asx-eml",
      code: "ASX:EML",
      companyName: "EML Payments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fpr",
      code: "ASX:FPR",
      companyName: "Fleetpartners Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmcsa",
      code: "NASDAQ:CMCSA",
      companyName: "Comcast Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tyl",
      code: "NASDAQ:TYL",
      companyName: "Tyler Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-coin",
      code: "NYSE:COIN",
      companyName: "Coinbase Global Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-panw",
      code: "NASDAQ:PANW",
      companyName: "Palo Alto Networks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cryp",
      code: "NYSE:CRYP",
      companyName: "AdvisorShares Managed Bitcoin Strategy ETF",
      popularity: 0,
    },
    {
      slug: "asx-ngx",
      code: "ASX:NGX",
      companyName: "NGX Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-cstm",
      code: "NASDAQ:CSTM",
      companyName: "Constellium SE Ordinary Shares (France)",
      popularity: 0,
    },
    {
      slug: "asx-iph",
      code: "ASX:IPH",
      companyName: "IPH Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-crm",
      code: "NYSE:CRM",
      companyName: "Salesforce Inc.",
      popularity: 0,
    },
    {
      slug: "asx-cmm",
      code: "ASX:CMM",
      companyName: "Capricorn Metals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ice",
      code: "NASDAQ:ICE",
      companyName: "Intercontinental Exchange Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-dmp",
      code: "ASX:DMP",
      companyName: "Domino's PIZZA Enterprises Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-igt",
      code: "NYSE:IGT",
      companyName: "International Game Technology PLC",
      popularity: 0,
    },
    {
      slug: "asx-ofx",
      code: "ASX:OFX",
      companyName: "OFX Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-a2b",
      code: "ASX:A2B",
      companyName: "A2B Australia Ltd",
      popularity: 56000,
    },
    {
      slug: "nasdaq-csco",
      code: "NASDAQ:CSCO",
      companyName: "Cisco Systems Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "asx-fph",
      code: "ASX:FPH",
      companyName: "Fisher & Paykel Healthcare Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rhc",
      code: "ASX:RHC",
      companyName: "Ramsay Health Care Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sgf",
      code: "ASX:SGF",
      companyName: "SG Fleet Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-infy",
      code: "NASDAQ:INFY",
      companyName: "Infosys Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "asx-cvw",
      code: "ASX:CVW",
      companyName: "Clearview Wealth Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bxb",
      code: "ASX:BXB",
      companyName: "Brambles Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wtc",
      code: "ASX:WTC",
      companyName: "Wisetech Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pnv",
      code: "ASX:PNV",
      companyName: "Polynovo Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hub",
      code: "ASX:HUB",
      companyName: "HUB24 Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-nke",
      code: "NYSE:NKE",
      companyName: "Nike Inc.",
      popularity: 0,
    },
    {
      slug: "asx-cwy",
      code: "ASX:CWY",
      companyName: "Cleanaway Waste Management Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-v",
      code: "NASDAQ:V",
      companyName: "Visa Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-thcx",
      code: "NYSE:THCX",
      companyName: "The Cannabis ETF",
      popularity: 0,
    },
    {
      slug: "asx-cia",
      code: "ASX:CIA",
      companyName: "Champion Iron Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xro",
      code: "ASX:XRO",
      companyName: "Xero Ltd",
      popularity: 0,
    },
    {
      slug: "asx-a11",
      code: "ASX:A11",
      companyName: "Atlantic Lithium Ltd",
      popularity: 46000,
    },
    {
      slug: "asx-pmv",
      code: "ASX:PMV",
      companyName: "Premier Investments Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-rost",
      code: "NYSE:ROST",
      companyName: "Ross Stores Inc",
      popularity: 0,
    },
    {
      slug: "asx-ad8",
      code: "ASX:AD8",
      companyName: "Audinate Group Ltd",
      popularity: 835000,
    },
    {
      slug: "nyse-cme",
      code: "NYSE:CME",
      companyName: "CME Group Inc.",
      popularity: 0,
    },
    {
      slug: "asx-min",
      code: "ASX:MIN",
      companyName: "Mineral Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nst",
      code: "ASX:NST",
      companyName: "Northern Star Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mei",
      code: "ASX:MEI",
      companyName: "Meteoric Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-snt",
      code: "ASX:SNT",
      companyName: "Syntara Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-gild",
      code: "NASDAQ:GILD",
      companyName: "Gilead Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-bbab",
      code: "ASX:BBAB",
      companyName: "Betashares Geared Short Aus GOV Bond (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-bbfd",
      code: "ASX:BBFD",
      companyName: "Betashares Geared Short US TR Bond CH (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pypl",
      code: "NASDAQ:PYPL",
      companyName: "PayPal Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ggab",
      code: "ASX:GGAB",
      companyName: "Betashares Geared Long Aus GOV Bond (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ggfd",
      code: "ASX:GGFD",
      companyName: "Betashares Geared Long US TR Bond CH (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "nyse-goog",
      code: "NYSE:GOOG",
      companyName: "Alphabet Inc. Class C Capital Stock",
      popularity: 0,
    },
    {
      slug: "asx-gem",
      code: "ASX:GEM",
      companyName: "G8 Education Ltd",
      popularity: 0,
    },
    {
      slug: "asx-prg",
      code: "ASX:PRG",
      companyName: "PRL Global Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfc",
      code: "NASDAQ:WFC",
      companyName: "Wells Fargo & Company Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ccx",
      code: "ASX:CCX",
      companyName: "City Chic Collective Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tbnda",
      code: "ASX:TBNDA",
      companyName: "Tamboran Resources Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-cme",
      code: "NASDAQ:CME",
      companyName: "CME Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-vbcn",
      code: "ASX:VBCN",
      companyName: "Verbrec Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ape",
      code: "ASX:APE",
      companyName: "Eagers Automotive Ltd",
      popularity: 368000,
    },
    {
      slug: "asx-bpt",
      code: "ASX:BPT",
      companyName: "Beach Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-gdxj",
      code: "NYSE:GDXJ",
      companyName: "VanEck Junior Gold Miners ETF",
      popularity: 0,
    },
    {
      slug: "asx-nck",
      code: "ASX:NCK",
      companyName: "Nick Scali Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nxg",
      code: "ASX:NXG",
      companyName: "Nexgen Energy (Canada) Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lov",
      code: "ASX:LOV",
      companyName: "Lovisa Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-rmd",
      code: "NYSE:RMD",
      companyName: "ResMed Inc.",
      popularity: 0,
    },
    {
      slug: "asx-boq",
      code: "ASX:BOQ",
      companyName: "Bank of Queensland Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hmc",
      code: "ASX:HMC",
      companyName: "HMC Capital Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-rba",
      code: "NASDAQ:RBA",
      companyName: "Ritchie Bros. Auctioneers Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ehe",
      code: "ASX:EHE",
      companyName: "Estia Health Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gdg",
      code: "ASX:GDG",
      companyName: "Generation Development Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lsadd",
      code: "ASX:LSADD",
      companyName: "Lachlan Star Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-v",
      code: "NYSE:V",
      companyName: "VISA Inc.",
      popularity: 0,
    },
    {
      slug: "asx-cxur",
      code: "ASX:CXUR",
      companyName: "Cauldron Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-chc",
      code: "ASX:CHC",
      companyName: "Charter Hall Group",
      popularity: 0,
    },
    {
      slug: "nyse-snps",
      code: "NYSE:SNPS",
      companyName: "Synopsys Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fltr",
      code: "NYSE:FLTR",
      companyName: "VanEck Investment Grade Floating Rate ETF",
      popularity: 0,
    },
    {
      slug: "asx-agl",
      code: "ASX:AGL",
      companyName: "AGL Energy Ltd",
      popularity: 2499000,
    },
    {
      slug: "asx-tls",
      code: "ASX:TLS",
      companyName: "Telstra Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdb",
      code: "NASDAQ:MDB",
      companyName: "MongoDB Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zs",
      code: "NASDAQ:ZS",
      companyName: "Zscaler Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-isrg",
      code: "NYSE:ISRG",
      companyName: "Intuitive Surgical Inc.",
      popularity: 0,
    },
    {
      slug: "asx-qri",
      code: "ASX:QRI",
      companyName: "Qualitas Real Estate Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-trex",
      code: "NYSE:TREX",
      companyName: "Trex Company Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-aon",
      code: "NASDAQ:AON",
      companyName: "Aon plc Class A Ordinary Shares (Ireland)",
      popularity: 0,
    },
    {
      slug: "asx-wam",
      code: "ASX:WAM",
      companyName: "WAM Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kls",
      code: "ASX:KLS",
      companyName: "Kelsian Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-umax",
      code: "ASX:UMAX",
      companyName: "Betashares S&P 500 Yield Maximiser Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ymax",
      code: "ASX:YMAX",
      companyName: "Betashares Aus Top 20 Equity Yield MAX Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "nyse-cdw",
      code: "NYSE:CDW",
      companyName: "CDW Corporation",
      popularity: 0,
    },
    {
      slug: "asx-hbrd",
      code: "ASX:HBRD",
      companyName: "Betashares Active Australian Hybrids Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-abb",
      code: "ASX:ABB",
      companyName: "Aussie Broadband Ltd",
      popularity: 565000,
    },
    {
      slug: "asx-hvst",
      code: "ASX:HVST",
      companyName:
        "Betashares Australian Dividend Harvester Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-utip",
      code: "ASX:UTIP",
      companyName: "Betashares Inflation Protected US TRSY Bond CH ETF",
      popularity: 0,
    },
    {
      slug: "asx-lrs",
      code: "ASX:LRS",
      companyName: "Latin Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-invh",
      code: "NYSE:INVH",
      companyName: "Invitation Homes Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-psa",
      code: "NYSE:PSA",
      companyName: "Public Storage",
      popularity: 0,
    },
    {
      slug: "asx-rcap",
      code: "ASX:RCAP",
      companyName: "Resolution Cap Global Prop Sec (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-reg",
      code: "ASX:REG",
      companyName: "Regis Healthcare Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-meli",
      code: "NYSE:MELI",
      companyName: "Mercado Libre Inc",
      popularity: 0,
    },
    {
      slug: "asx-agvt",
      code: "ASX:AGVT",
      companyName: "Betashares Australian Government Bond ETF",
      popularity: 123000,
    },
    {
      slug: "nasdaq-adp",
      code: "NASDAQ:ADP",
      companyName: "Automatic Data Processing Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-lgi",
      code: "ASX:LGI",
      companyName: "LGI Ltd",
      popularity: 0,
    },
    {
      slug: "asx-remn",
      code: "ASX:REMN",
      companyName: "Remsense Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-api",
      code: "ASX:API",
      companyName: "AUSTRALIAN PHARMACEUTICAL INDUSTRIES LIMITED",
      popularity: 552000,
    },
    {
      slug: "asx-arx",
      code: "ASX:ARX",
      companyName: "Aroa Biosurgery Ltd",
      popularity: 155000,
    },
    {
      slug: "asx-arl",
      code: "ASX:ARL",
      companyName: "Ardea Resources Ltd",
      popularity: 75000,
    },
    {
      slug: "asx-agh",
      code: "ASX:AGH",
      companyName: "Althea Group Holdings Ltd",
      popularity: 148000,
    },
    {
      slug: "asx-aqs",
      code: "ASX:AQS",
      companyName: "AQUIS Entertainment Ltd",
      popularity: 25000,
    },
    {
      slug: "asx-atu",
      code: "ASX:ATU",
      companyName: "Atrum Coal Ltd",
      popularity: 0,
    },
    {
      slug: "asx-arf",
      code: "ASX:ARF",
      companyName: "Arena REIT",
      popularity: 119000,
    },
    {
      slug: "asx-ams",
      code: "ASX:AMS",
      companyName: "Atomos Ltd",
      popularity: 214000,
    },
    {
      slug: "asx-azi",
      code: "ASX:AZI",
      companyName: "Altamin Ltd",
      popularity: 0,
    },
    {
      slug: "asx-alf",
      code: "ASX:ALF",
      companyName: "AUSTRALIAN LEADERS FUND LIMITED",
      popularity: 101000,
    },
    {
      slug: "asx-atl",
      code: "ASX:ATL",
      companyName: "APOLLO TOURISM & LEISURE LTD",
      popularity: 0,
    },
    {
      slug: "asx-rnen",
      code: "ASX:RNEN",
      companyName: "Renu Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aiq",
      code: "ASX:AIQ",
      companyName: "Alternative Investment Trust",
      popularity: 47000,
    },
    {
      slug: "asx-nec",
      code: "ASX:NEC",
      companyName: "Nine Entertainment Co. Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-srnnc",
      code: "ASX:SRNNC",
      companyName: "Surefire Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-atc",
      code: "ASX:ATC",
      companyName: "Altech Batteries Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aor",
      code: "ASX:AOR",
      companyName: "APOLLO SERIES 2013-1 TRUST",
      popularity: 18000,
    },
    {
      slug: "asx-aol",
      code: "ASX:AOL",
      companyName: "APOLLO SERIES 2015-1 TRUST",
      popularity: 18000,
    },
    {
      slug: "asx-kkc",
      code: "ASX:KKC",
      companyName: "KKR Credit Income Fund",
      popularity: 0,
    },
    {
      slug: "asx-ahn",
      code: "ASX:AHN",
      companyName: "Athena Resources Ltd",
      popularity: 25000,
    },
    {
      slug: "asx-alx",
      code: "ASX:ALX",
      companyName: "Atlas Arteria",
      popularity: 324000,
    },
    {
      slug: "asx-atp",
      code: "ASX:ATP",
      companyName: "Atlas Pearls Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ad1",
      code: "ASX:AD1",
      companyName: "AD1 Holdings Ltd",
      popularity: 27000,
    },
    {
      slug: "asx-a4n",
      code: "ASX:A4N",
      companyName: "Alpha Hpa Ltd",
      popularity: 71000,
    },
    {
      slug: "asx-ao3",
      code: "ASX:AO3",
      companyName: "APOLLO SERIES 2018-1 TRUST",
      popularity: 21000,
    },
    {
      slug: "asx-ar9",
      code: "ASX:AR9",
      companyName: "Archtis Ltd",
      popularity: 78000,
    },
    {
      slug: "asx-ltp",
      code: "ASX:LTP",
      companyName: "LTR Pharma Ltd",
      popularity: 0,
    },
    {
      slug: "asx-au8",
      code: "ASX:AU8",
      companyName: "AUMAKE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ayk",
      code: "ASX:AYK",
      companyName: "AUSTRALIAN MASTERS YIELD FUND NO 4 LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ayz",
      code: "ASX:AYZ",
      companyName: "AUSTRALIAN MASTERS YIELD FUND NO 5 LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-azv",
      code: "ASX:AZV",
      companyName: "AZURE HEALTHCARE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-atr",
      code: "ASX:ATR",
      companyName: "Astron Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-axe",
      code: "ASX:AXE",
      companyName: "Archer Materials Ltd",
      popularity: 0,
    },
    {
      slug: "asx-podna",
      code: "ASX:PODNA",
      companyName: "Podium Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-adv",
      code: "ASX:ADV",
      companyName: "Ardiden Ltd",
      popularity: 59000,
    },
    {
      slug: "asx-wecn",
      code: "ASX:WECN",
      companyName: "White Energy Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cusn",
      code: "ASX:CUSN",
      companyName: "Copper Search Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nmtn",
      code: "ASX:NMTN",
      companyName: "Neometals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-asx",
      code: "ASX:ASX",
      companyName: "ASX Ltd",
      popularity: 2441000,
    },
    {
      slug: "asx-ozxx",
      code: "ASX:OZXX",
      companyName: "Global X Australia Ex Financials & Resources ETF",
      popularity: 0,
    },
    {
      slug: "asx-1ag",
      code: "ASX:1AG",
      companyName: "Alterra Ltd",
      popularity: 30000,
    },
    {
      slug: "asx-agrn",
      code: "ASX:AGRN",
      companyName: "Aguia Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-crsn",
      code: "ASX:CRSN",
      companyName: "Caprice Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nagn",
      code: "ASX:NAGN",
      companyName: "Nagambie Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-an1",
      code: "ASX:AN1",
      companyName: "Anagenics Ltd",
      popularity: 28000,
    },
    {
      slug: "asx-ao2",
      code: "ASX:AO2",
      companyName: "APOLLO SERIES 2017-2 TRUST",
      popularity: 17000,
    },
    {
      slug: "asx-bwx",
      code: "ASX:BWX",
      companyName: "BWX Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bbl",
      code: "ASX:BBL",
      companyName: "Brisbane Broncos Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bit",
      code: "ASX:BIT",
      companyName: "Biotron Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bd1",
      code: "ASX:BD1",
      companyName: "BARD1 LIFE SCIENCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-brb",
      code: "ASX:BRB",
      companyName: "BREAKER RESOURCES NL",
      popularity: 0,
    },
    {
      slug: "asx-bir",
      code: "ASX:BIR",
      companyName: "BIR Financial Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-rsg",
      code: "NASDAQ:RSG",
      companyName: "Republic Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sap",
      code: "NASDAQ:SAP",
      companyName: "SAP  SE ADS",
      popularity: 0,
    },
    {
      slug: "asx-bux",
      code: "ASX:BUX",
      companyName: "Buxton Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-syk",
      code: "NASDAQ:SYK",
      companyName: "Stryker Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-bmn",
      code: "ASX:BMN",
      companyName: "Bannerman Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bvs",
      code: "ASX:BVS",
      companyName: "Bravura Solutions Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bdc",
      code: "ASX:BDC",
      companyName: "BARDOC GOLD LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bti",
      code: "ASX:BTI",
      companyName: "Bailador Technology Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bgs",
      code: "ASX:BGS",
      companyName: "BIRIMIAN LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bis",
      code: "ASX:BIS",
      companyName: "Bisalloy Steel Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bno",
      code: "ASX:BNO",
      companyName: "Bionomics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bpp",
      code: "ASX:BPP",
      companyName: "Babylon Pump & Power Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bki",
      code: "ASX:BKI",
      companyName: "BKI Investment Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bsn",
      code: "ASX:BSN",
      companyName: "Basin Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bin",
      code: "ASX:BIN",
      companyName: "BINGO INDUSTRIES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bbn",
      code: "ASX:BBN",
      companyName: "Baby Bunting Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bxn",
      code: "ASX:BXN",
      companyName: "Bioxyne Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bye",
      code: "ASX:BYE",
      companyName: "Byron Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bwp",
      code: "ASX:BWP",
      companyName: "BWP Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmo",
      code: "NASDAQ:TMO",
      companyName: "Thermo Fisher Scientific Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-bgt",
      code: "ASX:BGT",
      companyName: "Bio-Gene Technology Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvda",
      code: "NASDAQ:NVDA",
      companyName: "NVIDIA Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-cnx",
      code: "ASX:CNX",
      companyName: "CARBON ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bpb",
      code: "ASX:BPB",
      companyName: "BP CAPITAL MARKETS PLC",
      popularity: 0,
    },
    {
      slug: "asx-cdg",
      code: "ASX:CDG",
      companyName: "CLEVELAND MINING COMPANY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cgc",
      code: "ASX:CGC",
      companyName: "Costa Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dn8",
      code: "ASX:DN8",
      companyName: "DREAMSCAPE NETWORKS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-da1",
      code: "ASX:DA1",
      companyName: "DRIVER AUSTRALIA FIVE TRUST",
      popularity: 0,
    },
    {
      slug: "asx-daz",
      code: "ASX:DAZ",
      companyName: "DRIVER AUSTRALIA FOUR TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ltr",
      code: "ASX:LTR",
      companyName: "Liontown Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dae",
      code: "ASX:DAE",
      companyName: "DRIVER AUSTRALIA THREE TRUST",
      popularity: 0,
    },
    {
      slug: "asx-cob",
      code: "ASX:COB",
      companyName: "Cobalt Blue Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-css",
      code: "ASX:CSS",
      companyName: "Clean Seas Seafood Ltd",
      popularity: 0,
    },
    {
      slug: "asx-clv",
      code: "ASX:CLV",
      companyName: "Clover Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-daq",
      code: "ASX:DAQ",
      companyName: "DRIVER AUSTRALIA TWO TRUST",
      popularity: 0,
    },
    {
      slug: "asx-cuv",
      code: "ASX:CUV",
      companyName: "Clinuvel Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dtm",
      code: "ASX:DTM",
      companyName: "Dart Mining NL",
      popularity: 0,
    },
    {
      slug: "asx-cyc",
      code: "ASX:CYC",
      companyName: "Cyclopharm Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cue",
      code: "ASX:CUE",
      companyName: "CUE Energy Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cul",
      code: "ASX:CUL",
      companyName: "Cullen Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cvc",
      code: "ASX:CVC",
      companyName: "CVC Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ca8",
      code: "ASX:CA8",
      companyName: "COASSETS LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-egi",
      code: "ASX:EGI",
      companyName: "ELLERSTON GLOBAL INVESTMENTS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ifl",
      code: "ASX:IFL",
      companyName: "Insignia Financial Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cy5",
      code: "ASX:CY5",
      companyName: "CYGNUS Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cyq",
      code: "ASX:CYQ",
      companyName: "CYCLIQ Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dcn",
      code: "ASX:DCN",
      companyName: "Dacian Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cd3",
      code: "ASX:CD3",
      companyName: "CD Private Equity Fund Iii",
      popularity: 0,
    },
    {
      slug: "asx-dcc",
      code: "ASX:DCC",
      companyName: "Digitalx Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dnk",
      code: "ASX:DNK",
      companyName: "Danakali Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cyp",
      code: "ASX:CYP",
      companyName: "Cynata Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-tru",
      code: "NYSE:TRU",
      companyName: "TransUnion",
      popularity: 0,
    },
    {
      slug: "asx-cdu",
      code: "ASX:CDU",
      companyName: "CUDECO LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cv1",
      code: "ASX:CV1",
      companyName: "CV CHECK LTD",
      popularity: 0,
    },
    {
      slug: "asx-cyb",
      code: "ASX:CYB",
      companyName: "CYBG PLC",
      popularity: 0,
    },
    {
      slug: "asx-elx",
      code: "ASX:ELX",
      companyName: "ELLEX MEDICAL LASERS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-igl",
      code: "ASX:IGL",
      companyName: "Ive Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-epa",
      code: "ASX:EPA",
      companyName: "EPHRAIM RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-e2e",
      code: "ASX:E2E",
      companyName: "EON NRG LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cgr",
      code: "ASX:CGR",
      companyName: "CGN Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-elo",
      code: "ASX:ELO",
      companyName: "ELMO SOFTWARE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dau",
      code: "ASX:DAU",
      companyName: "DAMPIER GOLD LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dhr",
      code: "ASX:DHR",
      companyName: "DARK HORSE RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ese",
      code: "ASX:ESE",
      companyName: "ESENSE-LAB LTD",
      popularity: 0,
    },
    {
      slug: "asx-epw",
      code: "ASX:EPW",
      companyName: "ERM POWER LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-evm",
      code: "ASX:EVM",
      companyName: "ENVIROMISSION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fei",
      code: "ASX:FEI",
      companyName: "FE INVESTMENTS GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fel",
      code: "ASX:FEL",
      companyName: "FE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fsa",
      code: "ASX:FSA",
      companyName: "FSA Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gtk",
      code: "ASX:GTK",
      companyName: "Gentrack Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-race",
      code: "NASDAQ:RACE",
      companyName: "Ferrari N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-fnt",
      code: "ASX:FNT",
      companyName: "FRONTIER RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-trex",
      code: "NASDAQ:TREX",
      companyName: "Trex Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ftz",
      code: "ASX:FTZ",
      companyName: "Fertoz Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gbr",
      code: "ASX:GBR",
      companyName: "Great Boulder Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gge",
      code: "ASX:GGE",
      companyName: "Grand Gulf Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gla",
      code: "ASX:GLA",
      companyName: "Gladiator Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gnx",
      code: "ASX:GNX",
      companyName: "GENEX Power Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gma",
      code: "ASX:GMA",
      companyName: "GENWORTH MORTGAGE INSURANCE AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gsn",
      code: "ASX:GSN",
      companyName: "Great Southern Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gss",
      code: "ASX:GSS",
      companyName: "Genetic Signatures Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gtg",
      code: "ASX:GTG",
      companyName: "Genetic Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-iot",
      code: "NASDAQ:IOT",
      companyName: "Samsara Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ggg",
      code: "ASX:GGG",
      companyName: "GREENLAND MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrvl",
      code: "NASDAQ:MRVL",
      companyName: "Marvell Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wolf",
      code: "NASDAQ:WOLF",
      companyName: "Wolfspeed Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-imf",
      code: "ASX:IMF",
      companyName: "IMF BENTHAM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gpr",
      code: "ASX:GPR",
      companyName: "Geopacific Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-psil",
      code: "NYSE:PSIL",
      companyName: "AdvisorShares Psychedelics ETF",
      popularity: 0,
    },
    {
      slug: "asx-fun",
      code: "ASX:FUN",
      companyName: "FUNTASTIC LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-ixj",
      code: "NYSE:IXJ",
      companyName: "iShares Global Healthcare ETF",
      popularity: 0,
    },
    {
      slug: "asx-grr",
      code: "ASX:GRR",
      companyName: "Grange Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-riot",
      code: "NASDAQ:RIOT",
      companyName: "Riot Blockchain Inc.  Common Stock ",
      popularity: 0,
    },
    {
      slug: "asx-ges",
      code: "ASX:GES",
      companyName: "Genesis Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-otis",
      code: "NYSE:OTIS",
      companyName: "Otis Worldwide Corporation",
      popularity: 0,
    },
    {
      slug: "asx-gsw",
      code: "ASX:GSW",
      companyName: "GETSWIFT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gid",
      code: "ASX:GID",
      companyName: "GI DYNAMICS, INC",
      popularity: 0,
    },
    {
      slug: "nasdaq-clsk",
      code: "NASDAQ:CLSK",
      companyName: "CleanSpark Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gbg",
      code: "ASX:GBG",
      companyName: "GINDALBIE METALS LTD",
      popularity: 0,
    },
    {
      slug: "nyse-ma",
      code: "NYSE:MA",
      companyName: "Mastercard Incorporated",
      popularity: 0,
    },
    {
      slug: "asx-gib",
      code: "ASX:GIB",
      companyName: "Gibb River Diamonds Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gba",
      code: "ASX:GBA",
      companyName: "GRANDBRIDGE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gpx",
      code: "ASX:GPX",
      companyName: "GRAPHEX MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-azek",
      code: "NYSE:AZEK",
      companyName: "The AZEK Company Inc.",
      popularity: 0,
    },
    {
      slug: "asx-gsl",
      code: "ASX:GSL",
      companyName: "GREATCELL SOLAR LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gpp",
      code: "ASX:GPP",
      companyName: "GREENPOWER ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-irc",
      code: "ASX:IRC",
      companyName: "INTERMIN RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-we",
      code: "NASDAQ:WE",
      companyName: "WeWork Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tme",
      code: "NYSE:TME",
      companyName:
        "Tencent Music Entertainment Group American Depositary Shares each representing two Class A Ordinary",
      popularity: 0,
    },
    {
      slug: "asx-iec",
      code: "ASX:IEC",
      companyName: "Intra Energy Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-inv",
      code: "ASX:INV",
      companyName: "Investsmart Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-twe",
      code: "ASX:TWE",
      companyName: "Treasury Wine Estates Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jci",
      code: "ASX:JCI",
      companyName: "JIANCHENG INTERNATIONAL GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ivt",
      code: "ASX:IVT",
      companyName: "Inventis Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-iren",
      code: "NASDAQ:IREN",
      companyName: "Iris Energy Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gfl",
      code: "NYSE:GFL",
      companyName: "GFL Environmental Inc. Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ma",
      code: "NASDAQ:MA",
      companyName: "Mastercard Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-qan",
      code: "ASX:QAN",
      companyName: "Qantas Airways Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ivr",
      code: "ASX:IVR",
      companyName: "Investigator Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mfg",
      code: "ASX:MFG",
      companyName: "Magellan Financial Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-tsm",
      code: "NYSE:TSM",
      companyName: "Taiwan Semiconductor Manufacturing Company Ltd.",
      popularity: 0,
    },
    {
      slug: "asx-fbu",
      code: "ASX:FBU",
      companyName: "Fletcher Building Ltd",
      popularity: 0,
    },
    {
      slug: "asx-inb",
      code: "ASX:INB",
      companyName: "INTERSTAR MILLENNIUM SERIES 2006-2G TRUST",
      popularity: 0,
    },
    {
      slug: "asx-iam",
      code: "ASX:IAM",
      companyName: "Income Asset Management Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mgf",
      code: "ASX:MGF",
      companyName: "Magellan Global Fund",
      popularity: 0,
    },
    {
      slug: "asx-iau",
      code: "ASX:IAU",
      companyName: "INTREPID MINES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-inn",
      code: "ASX:INN",
      companyName: "INTERSTAR MILLENNIUM SERIES 2006-3L TRUST",
      popularity: 0,
    },
    {
      slug: "asx-jhl",
      code: "ASX:JHL",
      companyName: "JAYEX HEALTHCARE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-jjf",
      code: "ASX:JJF",
      companyName: "JIAJIAFU MODERN AGRICULTURE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-job",
      code: "ASX:JOB",
      companyName: "JOBSTORE GROUP LTD.",
      popularity: 0,
    },
    {
      slug: "asx-laa",
      code: "ASX:LAA",
      companyName: "LATAM AUTOS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-inh",
      code: "ASX:INH",
      companyName: "INTERSTAR MILLENNIUM SERIES 2006-4H TRUST",
      popularity: 0,
    },
    {
      slug: "asx-lcd",
      code: "ASX:LCD",
      companyName: "LATITUDE CONSOLIDATED LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lgd",
      code: "ASX:LGD",
      companyName: "LEGEND CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lck",
      code: "ASX:LCK",
      companyName: "LEIGH CREEK ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mse",
      code: "ASX:MSE",
      companyName: "METALSEARCH LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ncc",
      code: "ASX:NCC",
      companyName: "Naos Emerging Opportunities Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nao",
      code: "ASX:NAO",
      companyName: "NATIONAL RMBS TRUST 2011-2 SERIES 2011-2",
      popularity: 0,
    },
    {
      slug: "asx-naf",
      code: "ASX:NAF",
      companyName: "NATIONAL RMBS TRUST 2011-1 SERIES 2011-1",
      popularity: 0,
    },
    {
      slug: "asx-nmm",
      code: "ASX:NMM",
      companyName: "NOBLE METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nbl",
      code: "ASX:NBL",
      companyName: "NONI B LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nah",
      code: "ASX:NAH",
      companyName: "NATIONAL RMBS TRUST 2012-2 SERIES 2012-2",
      popularity: 0,
    },
    {
      slug: "asx-mmi",
      code: "ASX:MMI",
      companyName: "Metro Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mpp",
      code: "ASX:MPP",
      companyName: "Metro Performance Glass Ltd",
      popularity: 0,
    },
    {
      slug: "asx-msv",
      code: "ASX:MSV",
      companyName: "Mitchell Services Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nvl",
      code: "ASX:NVL",
      companyName: "NATIONAL VETERINARY CARE LTD",
      popularity: 0,
    },
    {
      slug: "asx-mir",
      code: "ASX:MIR",
      companyName: "Mirrabooka Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mxc",
      code: "ASX:MXC",
      companyName: "MGC Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nac",
      code: "ASX:NAC",
      companyName: "Naos Ex-50 Opportunities Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mrr",
      code: "ASX:MRR",
      companyName: "Minrex Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nsc",
      code: "ASX:NSC",
      companyName: "Naos Small Cap Opportunities Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nvu",
      code: "ASX:NVU",
      companyName: "Nanoveu Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mth",
      code: "ASX:MTH",
      companyName: "Mithril Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-msft",
      code: "NASDAQ:MSFT",
      companyName: "Microsoft Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-mgc",
      code: "ASX:MGC",
      companyName: "MG UNIT TRUST",
      popularity: 0,
    },
    {
      slug: "asx-nav",
      code: "ASX:NAV",
      companyName: "NAVIGATOR RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nvt",
      code: "ASX:NVT",
      companyName: "NAVITAS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-niu",
      code: "ASX:NIU",
      companyName: "NIUMINCO GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-n27",
      code: "ASX:N27",
      companyName: "NORTHERN COBALT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nmi",
      code: "ASX:NMI",
      companyName: "NORTHERN MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nwe",
      code: "ASX:NWE",
      companyName: "NORWEST ENERGY NL",
      popularity: 0,
    },
    {
      slug: "asx-pzc",
      code: "ASX:PZC",
      companyName: "PAN ASIA CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pgi",
      code: "ASX:PGI",
      companyName: "PANTERRA GOLD LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-meq",
      code: "ASX:MEQ",
      companyName: "METLIFECARE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mnc",
      code: "ASX:MNC",
      companyName: "METMINCO LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mwr",
      code: "ASX:MWR",
      companyName: "MGM WIRELESS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-evn",
      code: "ASX:EVN",
      companyName: "Evolution Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-naj",
      code: "ASX:NAJ",
      companyName: "NATIONAL RMBS TRUST 2015-1 SERIES 2015-1",
      popularity: 0,
    },
    {
      slug: "asx-nrm",
      code: "ASX:NRM",
      companyName: "NATIONAL RMBS TRUST 2016-1",
      popularity: 0,
    },
    {
      slug: "asx-nro",
      code: "ASX:NRO",
      companyName: "NATIONAL RMBS TRUST 2018-1 IN RESPECT OF SERIES 2018-1",
      popularity: 0,
    },
    {
      slug: "asx-rhp",
      code: "ASX:RHP",
      companyName: "RHIPE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sto",
      code: "ASX:STO",
      companyName: "Santos Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pet",
      code: "ASX:PET",
      companyName: "Phoslock Environmental Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-f",
      code: "NYSE:F",
      companyName: "Ford Motor Company",
      popularity: 0,
    },
    {
      slug: "asx-paa",
      code: "ASX:PAA",
      companyName: "Pharmaust Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pxs",
      code: "ASX:PXS",
      companyName: "Pharmaxis Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pdi",
      code: "ASX:PDI",
      companyName: "Predictive Discovery Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qbc",
      code: "ASX:QBC",
      companyName: "QUEBEC",
      popularity: 0,
    },
    {
      slug: "asx-pph",
      code: "ASX:PPH",
      companyName: "PUSHPAY HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pua",
      code: "ASX:PUA",
      companyName: "Peak Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-prt",
      code: "ASX:PRT",
      companyName: "PRT Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ptr",
      code: "ASX:PTR",
      companyName: "Petratherm Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-shop",
      code: "NASDAQ:SHOP",
      companyName: "Shopify Inc. Class A Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "asx-ppt",
      code: "ASX:PPT",
      companyName: "Perpetual Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pec",
      code: "ASX:PEC",
      companyName: "Perpetual Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-sny",
      code: "NASDAQ:SNY",
      companyName: "Sanofi ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-roiv",
      code: "NASDAQ:ROIV",
      companyName: "Roivant Sciences Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rxrx",
      code: "NASDAQ:RXRX",
      companyName: "Recursion Pharmaceuticals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-pic",
      code: "ASX:PIC",
      companyName: "Perpetual Equity Investment Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pgx",
      code: "ASX:PGX",
      companyName: "PRIMERO GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-puu",
      code: "ASX:PUU",
      companyName: "PUMA SERIES 2015-1",
      popularity: 0,
    },
    {
      slug: "asx-puv",
      code: "ASX:PUV",
      companyName: "PUMA SERIES 2015-3",
      popularity: 0,
    },
    {
      slug: "asx-puz",
      code: "ASX:PUZ",
      companyName: "PUMA SERIES 2017-1",
      popularity: 0,
    },
    {
      slug: "asx-pvd",
      code: "ASX:PVD",
      companyName: "PURA VIDA ENERGY NL",
      popularity: 0,
    },
    {
      slug: "asx-pm1",
      code: "ASX:PM1",
      companyName: "PURE MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-plx",
      code: "ASX:PLX",
      companyName: "PYROLYX AG",
      popularity: 0,
    },
    {
      slug: "asx-qtg",
      code: "ASX:QTG",
      companyName: "Q TECHNOLOGY GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-qms",
      code: "ASX:QMS",
      companyName: "QMS MEDIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-qfy",
      code: "ASX:QFY",
      companyName: "QUANTIFY TECHNOLOGY HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-qtm",
      code: "ASX:QTM",
      companyName: "QUANTUM HEALTH GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-qpr",
      code: "ASX:QPR",
      companyName: "QUATTRO PLUS REAL ESTATE",
      popularity: 0,
    },
    {
      slug: "asx-qst",
      code: "ASX:QST",
      companyName: "QUEST INVESTMENTS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-qss",
      code: "ASX:QSS",
      companyName: "QUESTUS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rva",
      code: "ASX:RVA",
      companyName: "REVA MEDICAL, INC",
      popularity: 0,
    },
    {
      slug: "asx-sar",
      code: "ASX:SAR",
      companyName: "SARACEN MINERAL HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ref",
      code: "ASX:REF",
      companyName: "REVERSE CORP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-svd",
      code: "ASX:SVD",
      companyName: "SCANDIVANADIUM LTD",
      popularity: 0,
    },
    {
      slug: "asx-srv",
      code: "ASX:SRV",
      companyName: "Servcorp Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sys",
      code: "ASX:SYS",
      companyName: "SYNGAS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sl1",
      code: "ASX:SL1",
      companyName: "SYMBOL MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sfx",
      code: "ASX:SFX",
      companyName: "Sheffield Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sse",
      code: "ASX:SSE",
      companyName: "SMART ABS SERIES 2014-4 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-si6",
      code: "ASX:SI6",
      companyName: "SI6 Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sit",
      code: "ASX:SIT",
      companyName: "Site Group International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-syd",
      code: "ASX:SYD",
      companyName: "SYDNEY AIRPORT",
      popularity: 0,
    },
    {
      slug: "asx-sko",
      code: "ASX:SKO",
      companyName: "Serko Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ssg",
      code: "ASX:SSG",
      companyName: "Shaver Shop Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qbe",
      code: "ASX:QBE",
      companyName: "QBE Insurance Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bby",
      code: "NYSE:BBY",
      companyName: "Best Buy Company Inc.",
      popularity: 0,
    },
    {
      slug: "asx-ndo",
      code: "ASX:NDO",
      companyName: "Nido Education Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tri",
      code: "ASX:TRI",
      companyName: "Trivarx Ltd",
      popularity: 0,
    },
    {
      slug: "asx-afi",
      code: "ASX:AFI",
      companyName: "Australian Foundation Investment Company Ltd",
      popularity: 1283000,
    },
    {
      slug: "asx-rfc",
      code: "ASX:RFC",
      companyName: "SERIES 2017-1 REDS TRUST",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvo",
      code: "NASDAQ:NVO",
      companyName: "Novo Nordisk A/S Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meta",
      code: "NASDAQ:META",
      companyName: "Meta Platforms Inc",
      popularity: 0,
    },
    {
      slug: "asx-srf",
      code: "ASX:SRF",
      companyName: "SURFSTITCH GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-say",
      code: "ASX:SAY",
      companyName: "SOUTH AMERICAN IRON & STEEL CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-ceg",
      code: "NYSE:CEG",
      companyName: "Constellation Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-syt",
      code: "ASX:SYT",
      companyName: "SYNTONIC LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rt2",
      code: "ASX:RT2",
      companyName: "SERIES 2018-1 REDS EHP TRUST",
      popularity: 0,
    },
    {
      slug: "asx-s3r",
      code: "ASX:S3R",
      companyName: "SERPENTINE TECHNOLOGIES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-svt",
      code: "ASX:SVT",
      companyName: "SERVTECH GLOBAL HOLDINGS LTD",
      popularity: 0,
    },
    {
      slug: "asx-sro",
      code: "ASX:SRO",
      companyName: "SHAREROOT LTD",
      popularity: 0,
    },
    {
      slug: "asx-swm",
      code: "ASX:SWM",
      companyName: "Seven West Media Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shi",
      code: "ASX:SHI",
      companyName: "SHINE METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sam",
      code: "ASX:SAM",
      companyName: "SIV ASSET MANAGEMENT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-shu",
      code: "ASX:SHU",
      companyName: "SHENHUA INTERNATIONAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-skp",
      code: "ASX:SKP",
      companyName: "SKYLAND PETROLEUM  GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sas",
      code: "ASX:SAS",
      companyName: "SKY AND SPACE COMPANY LTD",
      popularity: 0,
    },
    {
      slug: "asx-smt",
      code: "ASX:SMT",
      companyName: "SMART ABS SERIES 2015-2 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-rfe",
      code: "ASX:RFE",
      companyName: "SERIES 2018-1 REDS TRUST",
      popularity: 0,
    },
    {
      slug: "asx-sxb",
      code: "ASX:SXB",
      companyName: "SMART ABS SERIES 2015-4E TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ss6",
      code: "ASX:SS6",
      companyName: "SMART ABS SERIES 2016-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-saz",
      code: "ASX:SAZ",
      companyName: "SMART ABS SERIES 2016-3 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ssf",
      code: "ASX:SSF",
      companyName: "SMART ABS SERIES 2017-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ss7",
      code: "ASX:SS7",
      companyName: "SMART ABS SERIES 2017-2 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-sm8",
      code: "ASX:SM8",
      companyName: "SMART MARINE SYSTEMS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sil",
      code: "ASX:SIL",
      companyName: "SMILES INCLUSIVE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-smg",
      code: "ASX:SMG",
      companyName: "SOON MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-scl",
      code: "ASX:SCL",
      companyName: "Schrole Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-swk",
      code: "ASX:SWK",
      companyName: "SWICK MINING SERVICES LTD",
      popularity: 0,
    },
    {
      slug: "asx-smd",
      code: "ASX:SMD",
      companyName: "SYNDICATED METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vmx",
      code: "ASX:VMX",
      companyName: "VALMEC LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-alu",
      code: "ASX:ALU",
      companyName: "Altium Ltd",
      popularity: 2345000,
    },
    {
      slug: "asx-ttm",
      code: "ASX:TTM",
      companyName: "Titan Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nhc",
      code: "ASX:NHC",
      companyName: "New Hope Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-uuv",
      code: "ASX:UUV",
      companyName: "UUV AQUABOTIX LTD",
      popularity: 0,
    },
    {
      slug: "asx-voc",
      code: "ASX:VOC",
      companyName: "VOCUS GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fod",
      code: "ASX:FOD",
      companyName: "THE FOOD REVOLUTION GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-go2",
      code: "ASX:GO2",
      companyName: "The GO2 People Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lrvn",
      code: "ASX:LRVN",
      companyName: "Larvotto Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tmt",
      code: "ASX:TMT",
      companyName: "Technology Metals Australia Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgr",
      code: "NASDAQ:PGR",
      companyName: "Progressive Corporation (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-tou",
      code: "ASX:TOU",
      companyName: "Tlou Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tsl",
      code: "ASX:TSL",
      companyName: "Titanium Sands Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dxn",
      code: "ASX:DXN",
      companyName: "DXN Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ttt",
      code: "ASX:TTT",
      companyName: "Titomic Ltd",
      popularity: 0,
    },
    {
      slug: "asx-toe",
      code: "ASX:TOE",
      companyName: "Toro Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bcb",
      code: "ASX:BCB",
      companyName: "Bowen Coking Coal Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tsn",
      code: "ASX:TSN",
      companyName: "The Sustainable Nutrition Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-trt",
      code: "ASX:TRT",
      companyName: "Todd River Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pgr",
      code: "ASX:PGR",
      companyName: "THE PAS GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vxr",
      code: "ASX:VXR",
      companyName: "VENTUREX RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vvr",
      code: "ASX:VVR",
      companyName: "VIVA ENERGY REIT",
      popularity: 0,
    },
    {
      slug: "asx-eqt",
      code: "ASX:EQT",
      companyName: "EQT Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tny",
      code: "ASX:TNY",
      companyName: "Tinybeans Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-van",
      code: "ASX:VAN",
      companyName: "VANGO MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vec",
      code: "ASX:VEC",
      companyName: "VECTOR RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-unv",
      code: "ASX:UNV",
      companyName: "UNIVERSAL COAL PLC",
      popularity: 0,
    },
    {
      slug: "asx-urb",
      code: "ASX:URB",
      companyName: "URB INVESTMENTS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-usr",
      code: "ASX:USR",
      companyName: "US RESIDENTIAL FUND",
      popularity: 0,
    },
    {
      slug: "asx-vlt",
      code: "ASX:VLT",
      companyName: "VAULT INTELLIGENCE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vp7",
      code: "ASX:VP7",
      companyName: "VELOCITY PROPERTY GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-viv",
      code: "ASX:VIV",
      companyName: "VIVID TECHNOLOGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tbh",
      code: "ASX:TBH",
      companyName: "THE BETMAKERS HOLDINGS LTD",
      popularity: 0,
    },
    {
      slug: "asx-cgl",
      code: "ASX:CGL",
      companyName: "THE CITADEL GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vpc",
      code: "ASX:VPC",
      companyName: "VPCL LTD",
      popularity: 0,
    },
    {
      slug: "asx-wfb",
      code: "ASX:WFB",
      companyName: "WFD TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ixc",
      code: "ASX:IXC",
      companyName: "INVEX Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-msr",
      code: "ASX:MSR",
      companyName: "MANAS RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-cvx",
      code: "NYSE:CVX",
      companyName: "Chevron Corporation",
      popularity: 0,
    },
    {
      slug: "asx-wel",
      code: "ASX:WEL",
      companyName: "Winchester Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wnd",
      code: "ASX:WND",
      companyName: "WINDLAB LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tcl",
      code: "ASX:TCL",
      companyName: "Transurban Group",
      popularity: 0,
    },
    {
      slug: "asx-pwh",
      code: "ASX:PWH",
      companyName: "PWR Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-a1m",
      code: "ASX:A1M",
      companyName: "Aic Mines Ltd",
      popularity: 55000,
    },
    {
      slug: "asx-wfe",
      code: "ASX:WFE",
      companyName: "WINMAR RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rul",
      code: "ASX:RUL",
      companyName: "Rpmglobal Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qfe",
      code: "ASX:QFE",
      companyName: "Quickfee Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wec",
      code: "ASX:WEC",
      companyName: "White Energy Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-whk",
      code: "ASX:WHK",
      companyName: "Whitehawk Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-sdiv",
      code: "NYSE:SDIV",
      companyName: "Global X SuperDividend ETF",
      popularity: 0,
    },
    {
      slug: "asx-wnr",
      code: "ASX:WNR",
      companyName: "Wingara AG Ltd",
      popularity: 0,
    },
    {
      slug: "asx-whf",
      code: "ASX:WHF",
      companyName: "Whitefield Industrials Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wrm",
      code: "ASX:WRM",
      companyName: "White Rock Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bhp",
      code: "NYSE:BHP",
      companyName:
        "BHP Group Limited American Depositary Shares (Each representing two Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "asx-wbe",
      code: "ASX:WBE",
      companyName: "Whitebark Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-hon",
      code: "NASDAQ:HON",
      companyName: "Honeywell International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nrgu",
      code: "NYSE:NRGU",
      companyName: "MicroSectors US Big Oil 3x Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-c",
      code: "NYSE:C",
      companyName: "Citigroup Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dpst",
      code: "NYSE:DPST",
      companyName: "Direxion Daily Regional Banks Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nail",
      code: "NYSE:NAIL",
      companyName: "Direxion Daily Homebuilders & Supplies Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-safe",
      code: "NYSE:SAFE",
      companyName: "Safehold Inc.",
      popularity: 0,
    },
    {
      slug: "asx-wcn",
      code: "ASX:WCN",
      companyName: "White Cliff Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-afl",
      code: "ASX:AFL",
      companyName: "Af Legal Group Ltd",
      popularity: 31000,
    },
    {
      slug: "asx-wsp",
      code: "ASX:WSP",
      companyName: "Whispir Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-xylg",
      code: "NYSE:XYLG",
      companyName: "Global X S&P 500 Covered Call & Growth ETF",
      popularity: 0,
    },
    {
      slug: "asx-nan",
      code: "ASX:NAN",
      companyName: "Nanosonics Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-carr",
      code: "NYSE:CARR",
      companyName: "Carrier Global Corporation",
      popularity: 0,
    },
    {
      slug: "asx-woa",
      code: "ASX:WOA",
      companyName: "Wide Open Agriculture Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ceqp-",
      code: "NASDAQ:CEQP-",
      companyName:
        "Crestwood Equity Partners LP Preferred Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nyse-nycb",
      code: "NYSE:NYCB",
      companyName: "New York Community Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-are",
      code: "NYSE:ARE",
      companyName: "Alexandria Real Estate Equities Inc.",
      popularity: 0,
    },
    {
      slug: "asx-lot",
      code: "ASX:LOT",
      companyName: "Lotus Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-itg",
      code: "ASX:ITG",
      companyName: "INTEGA GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vor",
      code: "ASX:VOR",
      companyName: "VORTIV LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-fsk",
      code: "NYSE:FSK",
      companyName: "FS KKR Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-lme",
      code: "ASX:LME",
      companyName: "Limeade Inc",
      popularity: 0,
    },
    {
      slug: "asx-pus",
      code: "ASX:PUS",
      companyName: "PEPPER SPARKZ TRUST NO.1",
      popularity: 0,
    },
    {
      slug: "asx-pgu",
      code: "ASX:PGU",
      companyName: "PROPERTYGURU LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tdi",
      code: "ASX:TDI",
      companyName: "360 CAPITAL DIGITAL INFRASTRUCTURE FUND",
      popularity: 0,
    },
    {
      slug: "asx-llp",
      code: "ASX:LLP",
      companyName: "LLOYDS BANK PLC",
      popularity: 0,
    },
    {
      slug: "nyse-xclr",
      code: "NYSE:XCLR",
      companyName: "Global X S&P 500 Collar 95-110 ETF",
      popularity: 0,
    },
    {
      slug: "asx-tt1",
      code: "ASX:TT1",
      companyName: "TRITON TRUST NO. 8 IN RESPECT OF THE BOND SERIES 2019-2",
      popularity: 0,
    },
    {
      slug: "asx-pwg",
      code: "ASX:PWG",
      companyName: "PRIMEWEST",
      popularity: 0,
    },
    {
      slug: "asx-dtc",
      code: "ASX:DTC",
      companyName: "Damstra Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mio",
      code: "ASX:MIO",
      companyName: "Macarthur Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-flt",
      code: "ASX:FLT",
      companyName: "Flight Centre Travel Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vir",
      code: "ASX:VIR",
      companyName: "VIRGO RESOURCES LTD",
      popularity: 0,
    },
    {
      slug: "asx-arg",
      code: "ASX:ARG",
      companyName: "Argo Investments Ltd",
      popularity: 1087000,
    },
    {
      slug: "asx-hvn",
      code: "ASX:HVN",
      companyName: "Harvey Norman Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mhk",
      code: "ASX:MHK",
      companyName: "Metal Hawk Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cau",
      code: "ASX:CAU",
      companyName: "CRONOS AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-scd",
      code: "ASX:SCD",
      companyName: "STANDARD CHARTERED PLC",
      popularity: 0,
    },
    {
      slug: "asx-ana",
      code: "ASX:ANA",
      companyName: "ANSILA ENERGY NL",
      popularity: 18000,
    },
    {
      slug: "asx-aph",
      code: "ASX:APH",
      companyName: "AUSTRALIAN PRIMARY HEMP LIMITED",
      popularity: 50000,
    },
    {
      slug: "asx-wzr",
      code: "ASX:WZR",
      companyName: "Wisr Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fm2",
      code: "ASX:FM2",
      companyName: "FIRSTMAC MORTGAGE FUNDING TRUST NO.4 SERIES 2-2019",
      popularity: 0,
    },
    {
      slug: "asx-prn",
      code: "ASX:PRN",
      companyName: "Perenti Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ev1",
      code: "ASX:EV1",
      companyName: "Evolution Energy Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-coh",
      code: "ASX:COH",
      companyName: "Cochlear Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ihhy",
      code: "ASX:IHHY",
      companyName: "Ishares Global High Yield Bond (Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-ytmorg",
      code: "ASX:YTMORG",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dow",
      code: "ASX:DOW",
      companyName: "Downer Edi Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cst",
      code: "ASX:CST",
      companyName: "Castile Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-addn",
      code: "ASX:ADDN",
      companyName: "Adavale Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmqf4",
      code: "ASX:YTMQF4",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-igb",
      code: "ASX:IGB",
      companyName: "Ishares Treasury ETF",
      popularity: 0,
    },
    {
      slug: "asx-ckf",
      code: "ASX:CKF",
      companyName: "Collins Foods Ltd",
      popularity: 0,
    },
    {
      slug: "asx-egr",
      code: "ASX:EGR",
      companyName: "Ecograf Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hvm",
      code: "ASX:HVM",
      companyName: "Happy Valley Nutrition Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rlg",
      code: "ASX:RLG",
      companyName: "Roolife Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmscp",
      code: "ASX:YTMSCP",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gben",
      code: "ASX:GBEN",
      companyName: "Globe Metals & Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-id8n",
      code: "ASX:ID8N",
      companyName: "Identitii Ltd",
      popularity: 0,
    },
    {
      slug: "asx-thrdd",
      code: "ASX:THRDD",
      companyName: "Thor Energy Plc",
      popularity: 0,
    },
    {
      slug: "asx-ijh",
      code: "ASX:IJH",
      companyName: "Ishares S&P Mid-Cap ETF",
      popularity: 0,
    },
    {
      slug: "asx-mvr",
      code: "ASX:MVR",
      companyName: "Vaneck Australian Resources ETF",
      popularity: 0,
    },
    {
      slug: "asx-psl",
      code: "ASX:PSL",
      companyName: "Paterson Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rcln",
      code: "ASX:RCLN",
      companyName: "Readcloud Ltd",
      popularity: 0,
    },
    {
      slug: "asx-spr",
      code: "ASX:SPR",
      companyName: "Spartan Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-etf",
      code: "ASX:ETF",
      companyName: "Ubs IQ Morningstar Australia Quality ETF",
      popularity: 0,
    },
    {
      slug: "asx-ijp",
      code: "ASX:IJP",
      companyName: "Ishares MSCI Japan ETF",
      popularity: 0,
    },
    {
      slug: "asx-opl",
      code: "ASX:OPL",
      companyName: "Opyl Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iind",
      code: "ASX:IIND",
      companyName: "Betashares India Quality ETF",
      popularity: 0,
    },
    {
      slug: "asx-ihoo",
      code: "ASX:IHOO",
      companyName: "Ishares Global 100 Aud Hedged ETF",
      popularity: 0,
    },
    {
      slug: "asx-ihcb",
      code: "ASX:IHCB",
      companyName: "Ishares Core Global Corporate Bond(Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-ytmdx1",
      code: "ASX:YTMDX1",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmdx2",
      code: "ASX:YTMDX2",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmdx3",
      code: "ASX:YTMDX3",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmsg3",
      code: "ASX:YTMSG3",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ihd",
      code: "ASX:IHD",
      companyName: "Ishares S&P/ASX DIV Opportunities Esg Screened ETF",
      popularity: 0,
    },
    {
      slug: "asx-jin",
      code: "ASX:JIN",
      companyName: "Jumbo Interactive Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmmg2",
      code: "ASX:YTMMG2",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mvb",
      code: "ASX:MVB",
      companyName: "Vaneck Australian Banks ETF",
      popularity: 0,
    },
    {
      slug: "asx-iheb",
      code: "ASX:IHEB",
      companyName: "Ishares J.P. Morgan Usd Emerging Markets (Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-ytmmq1",
      code: "ASX:YTMMQ1",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lgp",
      code: "ASX:LGP",
      companyName: "Little Green Pharma Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmtl2",
      code: "ASX:YTMTL2",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmvc1",
      code: "ASX:YTMVC1",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmvcx",
      code: "ASX:YTMVCX",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ethi",
      code: "ASX:ETHI",
      companyName: "Betashares Global Sustainability Leaders ETF",
      popularity: 0,
    },
    {
      slug: "asx-mve",
      code: "ASX:MVE",
      companyName: "Vaneck S&P/ASX Midcap ETF",
      popularity: 0,
    },
    {
      slug: "asx-mvol",
      code: "ASX:MVOL",
      companyName: "Ishares Edge MSCI Australia Minimum Volatility ETF",
      popularity: 0,
    },
    {
      slug: "asx-amtn",
      code: "ASX:AMTN",
      companyName: "Allegra Orthopaedics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mvs",
      code: "ASX:MVS",
      companyName: "Vaneck Small Companies Masters ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bnku",
      code: "NYSE:BNKU",
      companyName: "MicroSectorsTM U.S. Big Banks Index 3X Leveraged ETNs",
      popularity: 0,
    },
    {
      slug: "nyse-epr",
      code: "NYSE:EPR",
      companyName: "EPR Properties",
      popularity: 0,
    },
    {
      slug: "asx-nyr",
      code: "ASX:NYR",
      companyName: "Nyrada Inc",
      popularity: 0,
    },
    {
      slug: "nyse-socl",
      code: "NYSE:SOCL",
      companyName: "Global X Funds Global X Social Media ETF",
      popularity: 0,
    },
    {
      slug: "asx-ixun",
      code: "ASX:IXUN",
      companyName: "Ixup Ltd",
      popularity: 0,
    },
    {
      slug: "asx-prm",
      code: "ASX:PRM",
      companyName: "Prominence Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-uba",
      code: "ASX:UBA",
      companyName: "Ubs IQ MSCI Australia Ethical ETF",
      popularity: 0,
    },
    {
      slug: "asx-abg",
      code: "ASX:ABG",
      companyName: "Abacus Group",
      popularity: 8000,
    },
    {
      slug: "asx-exp",
      code: "ASX:EXP",
      companyName: "Experience Co Ltd",
      popularity: 0,
    },
    {
      slug: "asx-smll",
      code: "ASX:SMLL",
      companyName: "Betashares Aust Small Companies Select Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-rari",
      code: "ASX:RARI",
      companyName: "Russell Investments Australian Responsible Investment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mrk",
      code: "NYSE:MRK",
      companyName: "Merck & Co. Inc.",
      popularity: 0,
    },
    {
      slug: "asx-ooo",
      code: "ASX:OOO",
      companyName: "Betashares Crude Oil INDEX ETF-Currency Hedged (Synthetic)",
      popularity: 0,
    },
    {
      slug: "asx-ozf",
      code: "ASX:OZF",
      companyName: "SPDR S&P/ASX 200 Financials Ex A-REIT Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-on",
      code: "NASDAQ:ON",
      companyName: "ON Semiconductor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-syi",
      code: "ASX:SYI",
      companyName: "SPDR MSCI Australia Select High Dividend Yield Fund",
      popularity: 0,
    },
    {
      slug: "asx-wmi",
      code: "ASX:WMI",
      companyName: "Wam Microcap Ltd",
      popularity: 0,
    },
    {
      slug: "asx-maq",
      code: "ASX:MAQ",
      companyName: "Macquarie Technology Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qre",
      code: "ASX:QRE",
      companyName: "Betashares Australian Resources Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sil",
      code: "NYSE:SIL",
      companyName: "Global X Silver Miners ETF (NEW)",
      popularity: 0,
    },
    {
      slug: "asx-swtz",
      code: "ASX:SWTZ",
      companyName: "Switzer Dividend Growth Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bidu",
      code: "NASDAQ:BIDU",
      companyName: "Baidu Inc. ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-agnc",
      code: "NASDAQ:AGNC",
      companyName: "AGNC Investment Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ozr",
      code: "ASX:OZR",
      companyName: "SPDR S&P/ASX 200 Resources Fund",
      popularity: 0,
    },
    {
      slug: "asx-imd",
      code: "ASX:IMD",
      companyName: "IMDEX Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fgh",
      code: "ASX:FGH",
      companyName: "Foresta Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tech",
      code: "ASX:TECH",
      companyName: "Global X Morningstar Global Technology ETF",
      popularity: 0,
    },
    {
      slug: "asx-pixx",
      code: "ASX:PIXX",
      companyName: "Platinum International Fund (Quoted Managed Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-tlg",
      code: "ASX:TLG",
      companyName: "Talga Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ibm",
      code: "NYSE:IBM",
      companyName: "International Business Machines Corporation",
      popularity: 0,
    },
    {
      slug: "asx-evt",
      code: "ASX:EVT",
      companyName: "EVT Ltd",
      popularity: 0,
    },
    {
      slug: "asx-paxx",
      code: "ASX:PAXX",
      companyName: "Platinum Asia Fund (Quoted Managed Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-cymna",
      code: "ASX:CYMNA",
      companyName: "Cyprium Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-1ai",
      code: "ASX:1AI",
      companyName: "Algorae Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-qdiv",
      code: "NYSE:QDIV",
      companyName: "Global X S&P 500 Quality Dividend ETF",
      popularity: 0,
    },
    {
      slug: "asx-ube",
      code: "ASX:UBE",
      companyName: "Ubs IQ MSCI Europe Ethical ETF",
      popularity: 0,
    },
    {
      slug: "asx-ubj",
      code: "ASX:UBJ",
      companyName: "Ubs IQ MSCI Japan Ethical ETF",
      popularity: 0,
    },
    {
      slug: "asx-ubp",
      code: "ASX:UBP",
      companyName: "Ubs IQ MSCI Asia APEX 50 Ethical ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lulu",
      code: "NYSE:LULU",
      companyName: "lululemon athletica inc.",
      popularity: 0,
    },
    {
      slug: "asx-fhsn",
      code: "ASX:FHSN",
      companyName: "Freehill Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qgl",
      code: "ASX:QGL",
      companyName: "Quantum Graphite Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dgl",
      code: "ASX:DGL",
      companyName: "DGL Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-n100",
      code: "ASX:N100",
      companyName: "Global X US 100 ETF",
      popularity: 0,
    },
    {
      slug: "asx-nxmr",
      code: "ASX:NXMR",
      companyName: "Nexus Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-hon",
      code: "NYSE:HON",
      companyName: "Honeywell International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lumn",
      code: "NYSE:LUMN",
      companyName: "Lumen Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tte",
      code: "NYSE:TTE",
      companyName: "TotalEnergies SE",
      popularity: 0,
    },
    {
      slug: "asx-usd",
      code: "ASX:USD",
      companyName: "Betashares U.S. Dollar ETF",
      popularity: 0,
    },
    {
      slug: "asx-jby",
      code: "ASX:JBY",
      companyName: "James Bay Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-syr",
      code: "ASX:SYR",
      companyName: "Syrah Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ext",
      code: "ASX:EXT",
      companyName: "Excite Technology Services Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ubu",
      code: "ASX:UBU",
      companyName: "Ubs IQ MSCI Usa Ethical ETF",
      popularity: 0,
    },
    {
      slug: "asx-ubw",
      code: "ASX:UBW",
      companyName: "Ubs IQ MSCI World Ex Australia Ethical ETF",
      popularity: 0,
    },
    {
      slug: "asx-pxxn",
      code: "ASX:PXXN",
      companyName: "Polarx Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pltr",
      code: "NYSE:PLTR",
      companyName: "Palantir Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvna",
      code: "NASDAQ:CVNA",
      companyName: "Carvana Co. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-rmin",
      code: "ASX:RMIN",
      companyName: "Resource Mining Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsla",
      code: "NASDAQ:TSLA",
      companyName: "Tesla Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pep",
      code: "NASDAQ:PEP",
      companyName: "PepsiCo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmcau",
      code: "NASDAQ:CMCAU",
      companyName: "Capitalworks Emerging Markets Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "asx-acwn",
      code: "ASX:ACWN",
      companyName: "Actinogen Medical Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-gme",
      code: "NASDAQ:GME",
      companyName: "GameStop Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-lll",
      code: "ASX:LLL",
      companyName: "Leo Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pii",
      code: "NYSE:PII",
      companyName: "Polaris Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lthm",
      code: "NYSE:LTHM",
      companyName: "Livent Corporation",
      popularity: 0,
    },
    {
      slug: "asx-apx",
      code: "ASX:APX",
      companyName: "Appen Ltd",
      popularity: 2390000,
    },
    {
      slug: "nasdaq-wday",
      code: "NASDAQ:WDAY",
      companyName: "Workday Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-race",
      code: "NYSE:RACE",
      companyName: "Ferrari N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-qbts",
      code: "NYSE:QBTS",
      companyName: "D-Wave Quantum Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rgti",
      code: "NYSE:RGTI",
      companyName: "Rigetti Computing Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-docu",
      code: "NASDAQ:DOCU",
      companyName: "DocuSign Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mndy",
      code: "NASDAQ:MNDY",
      companyName: "monday.com Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftnt",
      code: "NASDAQ:FTNT",
      companyName: "Fortinet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqix",
      code: "NASDAQ:EQIX",
      companyName: "Equinix Inc. Common Stock REIT",
      popularity: 0,
    },
    {
      slug: "asx-xaro",
      code: "ASX:XARO",
      companyName: "Activex Ardea Real Outcome Bond Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ax1",
      code: "ASX:AX1",
      companyName: "Accent Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cod",
      code: "ASX:COD",
      companyName: "Coda Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ax8",
      code: "ASX:AX8",
      companyName: "Accelerate Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-afp",
      code: "ASX:AFP",
      companyName: "Aft Pharmaceuticals Ltd",
      popularity: 199000,
    },
    {
      slug: "asx-wxhg",
      code: "ASX:WXHG",
      companyName: "SPDR S&P World Ex Aus Carbon Control (Hedged) Fund",
      popularity: 0,
    },
    {
      slug: "asx-rfxn",
      code: "ASX:RFXN",
      companyName: "Redflow Ltd",
      popularity: 0,
    },
    {
      slug: "asx-whkn",
      code: "ASX:WHKN",
      companyName: "Whitehawk Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-spce",
      code: "NYSE:SPCE",
      companyName: "Virgin Galactic Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "asx-adx",
      code: "ASX:ADX",
      companyName: "ADX Energy Ltd",
      popularity: 47000,
    },
    {
      slug: "asx-yank",
      code: "ASX:YANK",
      companyName: "Betashares Strong U.S. Dollar Fund (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-trs",
      code: "ASX:TRS",
      companyName: "The Reject Shop Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vso",
      code: "ASX:VSO",
      companyName: "Vanguard MSCI Australian Small Companies INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-vesg",
      code: "ASX:VESG",
      companyName:
        "Vanguard Ethically Conscious International Shares INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-acs",
      code: "ASX:ACS",
      companyName: "Accent Resources NL",
      popularity: 25000,
    },
    {
      slug: "nyse-txn",
      code: "NYSE:TXN",
      companyName: "Texas Instruments Incorporated",
      popularity: 0,
    },
    {
      slug: "nasdaq-uber",
      code: "NASDAQ:UBER",
      companyName: "Uber Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-aer",
      code: "ASX:AER",
      companyName: "Aeeris Ltd",
      popularity: 22000,
    },
    {
      slug: "asx-abv",
      code: "ASX:ABV",
      companyName: "Advanced Braking Technology Ltd",
      popularity: 32000,
    },
    {
      slug: "asx-asw",
      code: "ASX:ASW",
      companyName: "Advanced Share Registry Ltd",
      popularity: 26000,
    },
    {
      slug: "asx-vism",
      code: "ASX:VISM",
      companyName: "Vanguard MSCI International Small Companies INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-a1g",
      code: "ASX:A1G",
      companyName: "African Gold Ltd",
      popularity: 136000,
    },
    {
      slug: "asx-xtc",
      code: "ASX:XTC",
      companyName: "XTC Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wdiv",
      code: "ASX:WDIV",
      companyName: "SPDR S&P Global Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qubt",
      code: "NYSE:QUBT",
      companyName: "Quantum Computing Inc. Common",
      popularity: 0,
    },
    {
      slug: "nasdaq-rick",
      code: "NASDAQ:RICK",
      companyName: "RCI Hospitality Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-sga",
      code: "ASX:SGA",
      companyName: "Sarytogan Graphite Ltd",
      popularity: 0,
    },
    {
      slug: "asx-agr",
      code: "ASX:AGR",
      companyName: "Aguia Resources Ltd",
      popularity: 31000,
    },
    {
      slug: "asx-acq",
      code: "ASX:ACQ",
      companyName: "Acorn Capital Investment Fund Ltd",
      popularity: 112000,
    },
    {
      slug: "asx-ais",
      code: "ASX:AIS",
      companyName: "Aeris Resources Ltd",
      popularity: 339000,
    },
    {
      slug: "asx-ano",
      code: "ASX:ANO",
      companyName: "Advance Zinctek Ltd",
      popularity: 87000,
    },
    {
      slug: "asx-vacf",
      code: "ASX:VACF",
      companyName: "Vanguard Australian Corp Fixed Interest INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-aml",
      code: "ASX:AML",
      companyName: "Aeon Metals Ltd",
      popularity: 77000,
    },
    {
      slug: "asx-av1",
      code: "ASX:AV1",
      companyName: "Adveritas Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-fslr",
      code: "NYSE:FSLR",
      companyName: "First Solar Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ceg",
      code: "NASDAQ:CEG",
      companyName: "Constellation Energy Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nyse-pak",
      code: "NYSE:PAK",
      companyName: "Global X MSCI Pakistan ETF",
      popularity: 0,
    },
    {
      slug: "asx-aei",
      code: "ASX:AEI",
      companyName: "Aeris Environmental Ltd",
      popularity: 66000,
    },
    {
      slug: "asx-cof",
      code: "ASX:COF",
      companyName: "Centuria Office REIT",
      popularity: 0,
    },
    {
      slug: "asx-akl",
      code: "ASX:AKL",
      companyName: "AUCKLAND REAL ESTATE TRUST",
      popularity: 32000,
    },
    {
      slug: "asx-aso",
      code: "ASX:ASO",
      companyName: "Aston Minerals Ltd",
      popularity: 57000,
    },
    {
      slug: "nyse-uber",
      code: "NYSE:UBER",
      companyName: "Uber Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "asx-afw",
      code: "ASX:AFW",
      companyName: "Applyflow Ltd",
      popularity: 16000,
    },
    {
      slug: "asx-bugg",
      code: "ASX:BUGG",
      companyName: "Global X Cybersecurity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rblx",
      code: "NYSE:RBLX",
      companyName: "Roblox Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-eog",
      code: "NYSE:EOG",
      companyName: "EOG Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-spot",
      code: "NASDAQ:SPOT",
      companyName: "Spotify Technology S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-podd",
      code: "NASDAQ:PODD",
      companyName: "Insulet Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lly",
      code: "NASDAQ:LLY",
      companyName: "Eli Lilly and Company Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-sdf",
      code: "ASX:SDF",
      companyName: "Steadfast Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ahl",
      code: "ASX:AHL",
      companyName: "Adrad Holdings Ltd",
      popularity: 15000,
    },
    {
      slug: "nyse-lac",
      code: "NYSE:LAC",
      companyName: "Lithium Americas Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-and",
      code: "ASX:AND",
      companyName: "Ansarada Group Ltd",
      popularity: 35000,
    },
    {
      slug: "nyse-spot",
      code: "NYSE:SPOT",
      companyName: "Spotify Technology S.A.",
      popularity: 0,
    },
    {
      slug: "asx-hhi",
      code: "ASX:HHI",
      companyName: "HEALTH HOUSE INTERNATIONAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hpcn",
      code: "ASX:HPCN",
      companyName: "The Hydration Pharmaceuticals Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-alb",
      code: "ASX:ALB",
      companyName: "Albion Resources Ltd",
      popularity: 18000,
    },
    {
      slug: "asx-auk",
      code: "ASX:AUK",
      companyName: "Aumake Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bkg",
      code: "ASX:BKG",
      companyName: "Booktopia Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pls",
      code: "ASX:PLS",
      companyName: "Pilbara Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fos",
      code: "ASX:FOS",
      companyName: "FOS Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-frw",
      code: "ASX:FRW",
      companyName: "Freightways Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vge",
      code: "ASX:VGE",
      companyName: "Vanguard Ftse Emerging Markets Shares ETF",
      popularity: 0,
    },
    {
      slug: "asx-agc",
      code: "ASX:AGC",
      companyName: "Australian Gold and Copper Ltd",
      popularity: 112000,
    },
    {
      slug: "nyse-ww",
      code: "NYSE:WW",
      companyName: "WW International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ddog",
      code: "NYSE:DDOG",
      companyName: "Datadog Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-wmx",
      code: "ASX:WMX",
      companyName: "WILUNA MINING CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-btr",
      code: "ASX:BTR",
      companyName: "Brightstar Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-gmre",
      code: "NYSE:GMRE",
      companyName: "Global Medical REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nge",
      code: "NYSE:NGE",
      companyName: "Global X MSCI Nigeria ETF",
      popularity: 0,
    },
    {
      slug: "asx-alv",
      code: "ASX:ALV",
      companyName: "Alvo Minerals Ltd",
      popularity: 9000,
    },
    {
      slug: "asx-ctt",
      code: "ASX:CTT",
      companyName: "Cettire Ltd",
      popularity: 0,
    },
    {
      slug: "asx-azl",
      code: "ASX:AZL",
      companyName: "Arizona Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-rok",
      code: "NYSE:ROK",
      companyName: "Rockwell Automation Inc.",
      popularity: 0,
    },
    {
      slug: "asx-cxl",
      code: "ASX:CXL",
      companyName: "CALIX Ltd",
      popularity: 0,
    },
    {
      slug: "asx-5ea",
      code: "ASX:5EA",
      companyName: "5E Advanced Materials Inc",
      popularity: 20000,
    },
    {
      slug: "asx-ang",
      code: "ASX:ANG",
      companyName: "Austin Engineering Ltd",
      popularity: 76000,
    },
    {
      slug: "asx-ae1",
      code: "ASX:AE1",
      companyName: "Aerison Group Ltd",
      popularity: 8000,
    },
    {
      slug: "nasdaq-okta",
      code: "NASDAQ:OKTA",
      companyName: "Okta Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gl1",
      code: "ASX:GL1",
      companyName: "Global Lithium Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cetf",
      code: "ASX:CETF",
      companyName: "Vaneck Ftse China A50 ETF",
      popularity: 0,
    },
    {
      slug: "asx-esgi",
      code: "ASX:ESGI",
      companyName: "Vaneck MSCI International Sustainable Equity ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-rivn",
      code: "NASDAQ:RIVN",
      companyName: "Rivian Automotive Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gm",
      code: "NYSE:GM",
      companyName: "General Motors Company",
      popularity: 0,
    },
    {
      slug: "nasdaq-rblx",
      code: "NASDAQ:RBLX",
      companyName: "Roblox Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lcid",
      code: "NYSE:LCID",
      companyName: "Lucid Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-erth",
      code: "ASX:ERTH",
      companyName: "Betashares Climate Change Innovation ETF",
      popularity: 0,
    },
    {
      slug: "asx-brx",
      code: "ASX:BRX",
      companyName: "Belararox Ltd",
      popularity: 0,
    },
    {
      slug: "asx-29m",
      code: "ASX:29M",
      companyName: "29METALS Ltd",
      popularity: 135000,
    },
    {
      slug: "nyse-arkk",
      code: "NYSE:ARKK",
      companyName: "ARK Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-miln",
      code: "NYSE:MILN",
      companyName: "Global X Funds Global X Millennial Consumer ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivz",
      code: "NYSE:IVZ",
      companyName: "Invesco LTD",
      popularity: 0,
    },
    {
      slug: "asx-ess",
      code: "ASX:ESS",
      companyName: "Essential Metals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ww",
      code: "NASDAQ:WW",
      companyName: "WW International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-mts",
      code: "ASX:MTS",
      companyName: "Metcash Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-blk",
      code: "NYSE:BLK",
      companyName: "Blackrock Inc.",
      popularity: 0,
    },
    {
      slug: "asx-gt1",
      code: "ASX:GT1",
      companyName: "Green Technology Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-amm",
      code: "ASX:AMM",
      companyName: "Armada Metals Ltd",
      popularity: 8000,
    },
    {
      slug: "nyse-aptv",
      code: "NYSE:APTV",
      companyName: "Aptiv PLC",
      popularity: 0,
    },
    {
      slug: "nyse-zbra",
      code: "NYSE:ZBRA",
      companyName: "Zebra Technologies Corporation",
      popularity: 0,
    },
    {
      slug: "asx-aps",
      code: "ASX:APS",
      companyName: "Allup Silica Ltd",
      popularity: 10000,
    },
    {
      slug: "asx-nabpj",
      code: "ASX:NABPJ",
      companyName: "National Australia Bank Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pmt",
      code: "ASX:PMT",
      companyName: "Patriot Battery Metals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-snow",
      code: "NYSE:SNOW",
      companyName: "Snowflake Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-abnb",
      code: "NASDAQ:ABNB",
      companyName: "Airbnb Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aal",
      code: "NASDAQ:AAL",
      companyName: "American Airlines Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sli",
      code: "NASDAQ:SLI",
      companyName: "Standard Lithium Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-ipl",
      code: "ASX:IPL",
      companyName: "Incitec Pivot Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-sqm",
      code: "NYSE:SQM",
      companyName: "Sociedad Quimica y Minera de Chile SA",
      popularity: 0,
    },
    {
      slug: "nasdaq-aaqc",
      code: "NASDAQ:AAQC",
      companyName: "Accelerate Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-okta",
      code: "NYSE:OKTA",
      companyName: "Okta Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-a",
      code: "NASDAQ:A",
      companyName: "Agilent Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aa",
      code: "NASDAQ:AA",
      companyName: "Alcoa Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-aac",
      code: "NASDAQ:AAC",
      companyName: "Ares Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aaciw",
      code: "NASDAQ:AACIW",
      companyName: "Armada Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-aaciu",
      code: "NASDAQ:AACIU",
      companyName: "Armada Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-aaic",
      code: "NASDAQ:AAIC",
      companyName: "Arlington Asset Investment Corp Class A (new)",
      popularity: 0,
    },
    {
      slug: "nasdaq-aadi",
      code: "NASDAQ:AADI",
      companyName: "Aadi Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aacg",
      code: "NASDAQ:AACG",
      companyName: "ATA Creativity Global American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aaic-b",
      code: "NASDAQ:AAIC-B",
      companyName: "Arlington Asset Investment Corp 7.00%",
      popularity: 0,
    },
    {
      slug: "nasdaq-aam-b",
      code: "NASDAQ:AAM-B",
      companyName:
        "Apollo Asset Management Inc. 6.375% Series B Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aaon",
      code: "NASDAQ:AAON",
      companyName: "AAON Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aaoi",
      code: "NASDAQ:AAOI",
      companyName: "Applied Optoelectronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aan",
      code: "NASDAQ:AAN",
      companyName: "Aarons Holdings Company Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-aame",
      code: "NASDAQ:AAME",
      companyName: "Atlantic American Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aamc",
      code: "NASDAQ:AAMC",
      companyName: "Altisource Asset Management Corp Com",
      popularity: 0,
    },
    {
      slug: "nasdaq-aam-a",
      code: "NASDAQ:AAM-A",
      companyName:
        "Apollo Asset Management Inc. 6.375% Series A Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aap",
      code: "NASDAQ:AAP",
      companyName: "Advance Auto Parts Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-aatc",
      code: "NASDAQ:AATC",
      companyName: "Autoscope Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aau",
      code: "NASDAQ:AAU",
      companyName: "Almaden Minerals Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-abcb",
      code: "NASDAQ:ABCB",
      companyName: "Ameris Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aaic-c",
      code: "NASDAQ:AAIC-C",
      companyName:
        "Arlington Asset Investment Corp 8.250% Seies C Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abcm",
      code: "NASDAQ:ABCM",
      companyName: "Abcam plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-abr-f",
      code: "NASDAQ:ABR-F",
      companyName:
        "Arbor Realty Trust 6.25% Series F Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock Liquidation Preference $25.00 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-abr-e",
      code: "NASDAQ:ABR-E",
      companyName:
        "Arbor Realty Trust 6.25% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-krma",
      code: "NYSE:KRMA",
      companyName: "Global X Conscious Companies ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-acrx",
      code: "NASDAQ:ACRX",
      companyName: "AcelRx Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abst",
      code: "NASDAQ:ABST",
      companyName: "Absolute Software Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abr-d",
      code: "NASDAQ:ABR-D",
      companyName:
        "Arbor Realty Trust 6.375% Series D Cumulative Redeemable Preferred Stock Liquidation Preference $25.00 per Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-acax",
      code: "NASDAQ:ACAX",
      companyName: "Alset Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acaxu",
      code: "NASDAQ:ACAXU",
      companyName: "Alset Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-acb",
      code: "NASDAQ:ACB",
      companyName: "Aurora Cannabis Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-acc",
      code: "NASDAQ:ACC",
      companyName: "American Campus Communities Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acbaw",
      code: "NASDAQ:ACBAW",
      companyName: "Ace Global Business Acquisition Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-accd",
      code: "NASDAQ:ACCD",
      companyName: "Accolade Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acco",
      code: "NASDAQ:ACCO",
      companyName: "Acco Brands Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acel",
      code: "NASDAQ:ACEL",
      companyName: "Accel Entertainment Inc. ",
      popularity: 0,
    },
    {
      slug: "nasdaq-acer",
      code: "NASDAQ:ACER",
      companyName: "Acer Therapeutics Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-acet",
      code: "NASDAQ:ACET",
      companyName: "Adicet Bio Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-acev",
      code: "NASDAQ:ACEV",
      companyName: "ACE Convergence Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-acdi",
      code: "NASDAQ:ACDI",
      companyName:
        "Ascendant Digital Acquisition Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-acevw",
      code: "NASDAQ:ACEVW",
      companyName: "ACE Convergence Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-acevu",
      code: "NASDAQ:ACEVU",
      companyName: "ACE Convergence Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-acglo",
      code: "NASDAQ:ACGLO",
      companyName:
        "Arch Capital Group Ltd. Depositary Shares Each Representing 1/1000th Interest in a Share of 5.45% Non-Cumulative Preferred Shares Series F",
      popularity: 0,
    },
    {
      slug: "nasdaq-acgl",
      code: "NASDAQ:ACGL",
      companyName: "Arch Capital Group Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ach",
      code: "NASDAQ:ACH",
      companyName:
        "Aluminum Corporation of China Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-achc",
      code: "NASDAQ:ACHC",
      companyName: "Acadia Healthcare Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acii",
      code: "NASDAQ:ACII",
      companyName: "Atlas Crest Investment Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aciw",
      code: "NASDAQ:ACIW",
      companyName: "ACI Worldwide Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aclx",
      code: "NASDAQ:ACLX",
      companyName: "Arcellx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acmr",
      code: "NASDAQ:ACMR",
      companyName: "ACM Research Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acon",
      code: "NASDAQ:ACON",
      companyName: "Aclarion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aconw",
      code: "NASDAQ:ACONW",
      companyName: "Aclarion Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-acor",
      code: "NASDAQ:ACOR",
      companyName: "Acorda Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acp",
      code: "NASDAQ:ACP",
      companyName: "Aberdeen Income Credit Strategies Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-acnb",
      code: "NASDAQ:ACNB",
      companyName: "ACNB Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acm",
      code: "NASDAQ:ACM",
      companyName: "AECOM Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acls",
      code: "NASDAQ:ACLS",
      companyName: "Axcelis Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ackiw",
      code: "NASDAQ:ACKIW",
      companyName: "Ackrell SPAC Partners I Co. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-ackit",
      code: "NASDAQ:ACKIT",
      companyName: "Ackrell SPAC Partners I Co. Subunits",
      popularity: 0,
    },
    {
      slug: "nasdaq-ackiu",
      code: "NASDAQ:ACKIU",
      companyName: "Ackrell SPAC Partners I Co. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-acp-a",
      code: "NASDAQ:ACP-A",
      companyName:
        "Aberdeen Income Credit Strategies Fund 5.250% Series A Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aci",
      code: "NASDAQ:ACI",
      companyName: "Albertsons Companies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acqr",
      code: "NASDAQ:ACQR",
      companyName: "Independence Holdings Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-acqrw",
      code: "NASDAQ:ACQRW",
      companyName: "Independence Holdings Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-acr",
      code: "NASDAQ:ACR",
      companyName: "ACRES Commercial Realty Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acr-d",
      code: "NASDAQ:ACR-D",
      companyName:
        "ACRES Commercial Realty Corp. 7.875% Series D Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acst",
      code: "NASDAQ:ACST",
      companyName: "Acasti Pharma Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acre",
      code: "NASDAQ:ACRE",
      companyName: "Ares Commercial Real Estate Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-actd",
      code: "NASDAQ:ACTD",
      companyName: "ArcLight Clean Transition Corp. II Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-actdw",
      code: "NASDAQ:ACTDW",
      companyName: "ArcLight Clean Transition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-actdu",
      code: "NASDAQ:ACTDU",
      companyName: "ArcLight Clean Transition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-acr-c",
      code: "NASDAQ:ACR-C",
      companyName:
        "ACRES Commercial Realty Corp. 8.625% Fixed-to-Floating Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acqru",
      code: "NASDAQ:ACQRU",
      companyName: "Independence Holdings Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-act",
      code: "NASDAQ:ACT",
      companyName: "Enact Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acba",
      code: "NASDAQ:ACBA",
      companyName: "Ace Global Business Acquisition Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ader",
      code: "NASDAQ:ADER",
      companyName: "26 Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-biv",
      code: "NYSE:BIV",
      companyName: "Vanguard Intermediate-Term Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-cip",
      code: "ASX:CIP",
      companyName: "Centuria Industrial REIT",
      popularity: 0,
    },
    {
      slug: "nasdaq-ades",
      code: "NASDAQ:ADES",
      companyName: "Advanced Emissions Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adi",
      code: "NASDAQ:ADI",
      companyName: "Analog Devices Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adct",
      code: "NASDAQ:ADCT",
      companyName: "ADC Therapeutics SA Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aderu",
      code: "NASDAQ:ADERU",
      companyName: "26 Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-aderw",
      code: "NASDAQ:ADERW",
      companyName: "26 Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-adex",
      code: "NASDAQ:ADEX",
      companyName: "Adit EdTech Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abcl",
      code: "NASDAQ:ABCL",
      companyName: "AbCellera Biologics Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aat",
      code: "NASDAQ:AAT",
      companyName: "American Assets Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-actg",
      code: "NASDAQ:ACTG",
      companyName: "Acacia Research Corporation (Acacia Tech) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acu",
      code: "NASDAQ:ACU",
      companyName: "Acme United Corporation. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acv",
      code: "NASDAQ:ACV",
      companyName:
        "Virtus AllianzGI Diversified Income & Convertible Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-acva",
      code: "NASDAQ:ACVA",
      companyName: "ACV Auctions Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adgi",
      code: "NASDAQ:ADGI",
      companyName: "Adagio Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-cla",
      code: "ASX:CLA",
      companyName: "Celsius Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-acxp",
      code: "NASDAQ:ACXP",
      companyName: "Acurx Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adag",
      code: "NASDAQ:ADAG",
      companyName: "Adagene Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-adil",
      code: "NASDAQ:ADIL",
      companyName: "Adial Pharmaceuticals Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adap",
      code: "NASDAQ:ADAP",
      companyName: "Adaptimmune Therapeutics plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "asx-vif",
      code: "ASX:VIF",
      companyName: "Vanguard International Fixed Interest INDEX (Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-admp",
      code: "NASDAQ:ADMP",
      companyName: "Adamis Pharmaceuticals Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adn",
      code: "NASDAQ:ADN",
      companyName: "Advent Technologies Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adma",
      code: "NASDAQ:ADMA",
      companyName: "ADMA Biologics Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adnt",
      code: "NASDAQ:ADNT",
      companyName: "Adient plc Ordinary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-adnww",
      code: "NASDAQ:ADNWW",
      companyName: "Advent Technologies Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-adocr",
      code: "NASDAQ:ADOCR",
      companyName: "Edoc Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-adocw",
      code: "NASDAQ:ADOCW",
      companyName: "Edoc Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "asx-umg",
      code: "ASX:UMG",
      companyName: "United Malt Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-caf",
      code: "ASX:CAF",
      companyName: "Centrepoint Alliance Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vae",
      code: "ASX:VAE",
      companyName: "Vanguard Ftse Asia Ex Japan Shares INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-ctp",
      code: "ASX:CTP",
      companyName: "Central Petroleum Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-stla",
      code: "NASDAQ:STLA",
      companyName: "Stellantis N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-abg",
      code: "NASDAQ:ABG",
      companyName: "Asbury Automotive Group Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adc",
      code: "NASDAQ:ADC",
      companyName: "Agree Realty Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adc-a",
      code: "NASDAQ:ADC-A",
      companyName:
        "Agree Realty Corporation Depositary Shares each representing 1/1000th of a 4.250% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adrt",
      code: "NASDAQ:ADRT",
      companyName: "Ault Disruptive Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adsew",
      code: "NASDAQ:ADSEW",
      companyName: "ADS-TEC ENERGY PLC Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-adsk",
      code: "NASDAQ:ADSK",
      companyName: "Autodesk Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adt",
      code: "NASDAQ:ADT",
      companyName: "ADT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adse",
      code: "NASDAQ:ADSE",
      companyName: "ADS-TEC ENERGY PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-adra",
      code: "NASDAQ:ADRA",
      companyName: "Adara Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adal",
      code: "NASDAQ:ADAL",
      companyName:
        "Anthemis Digital Acquisitions I Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-adoc",
      code: "NASDAQ:ADOC",
      companyName: "Edoc Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "asx-cxm",
      code: "ASX:CXM",
      companyName: "Centrex Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-keji",
      code: "NYSE:KEJI",
      companyName: "Global X Funds Global X China Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-adthw",
      code: "NASDAQ:ADTHW",
      companyName: "AdTheorent Holding Company Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-adtn",
      code: "NASDAQ:ADTN",
      companyName: "ADTRAN Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeacu",
      code: "NASDAQ:AEACU",
      companyName: "Authentic Equity Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-aee",
      code: "NASDAQ:AEE",
      companyName: "Ameren Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeg",
      code: "NASDAQ:AEG",
      companyName: "AEGON N.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aei",
      code: "NASDAQ:AEI",
      companyName: "Alset EHome International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qyld",
      code: "NYSE:QYLD",
      companyName: "Global X Funds Global X NASDAQ-100 Covered Call ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeye",
      code: "NASDAQ:AEYE",
      companyName: "AudioEye Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aezs",
      code: "NASDAQ:AEZS",
      companyName: "Aeterna Zentaris Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-afaqw",
      code: "NASDAQ:AFAQW",
      companyName: "AF Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-afaru",
      code: "NASDAQ:AFARU",
      companyName: "Aura FAT Projects Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-afb",
      code: "NASDAQ:AFB",
      companyName: "AllianceBernstein National Municipal Income Fund Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-afbi",
      code: "NASDAQ:AFBI",
      companyName: "Affinity Bancshares Inc. Common Stock (MD)",
      popularity: 0,
    },
    {
      slug: "nasdaq-afcg",
      code: "NASDAQ:AFCG",
      companyName: "AFC Gamma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-afg",
      code: "NASDAQ:AFG",
      companyName: "American Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-afgc",
      code: "NASDAQ:AFGC",
      companyName:
        "American Financial Group Inc. 5.125% Subordinated Debentures due 2059",
      popularity: 0,
    },
    {
      slug: "nasdaq-afgd",
      code: "NASDAQ:AFGD",
      companyName:
        "American Financial Group Inc. 5.625% Subordinated Debentures due 2060",
      popularity: 0,
    },
    {
      slug: "nasdaq-afge",
      code: "NASDAQ:AFGE",
      companyName:
        "American Financial Group Inc. 4.500% Subordinated Debentures due 2060",
      popularity: 0,
    },
    {
      slug: "nasdaq-afi",
      code: "NASDAQ:AFI",
      companyName: "Armstrong Flooring Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adth",
      code: "NASDAQ:ADTH",
      companyName: "AdTheorent Holding Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adtx",
      code: "NASDAQ:ADTX",
      companyName: "Aditxt Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adus",
      code: "NASDAQ:ADUS",
      companyName: "Addus HomeCare Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adv",
      code: "NASDAQ:ADV",
      companyName: "Advantage Solutions Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-advm",
      code: "NASDAQ:ADVM",
      companyName: "Adverum Biotechnologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-advww",
      code: "NASDAQ:ADVWW",
      companyName: "Advantage Solutions Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-adxn",
      code: "NASDAQ:ADXN",
      companyName: "Addex Therapeutics Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-adx",
      code: "NASDAQ:ADX",
      companyName: "Adams Diversified Equity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ae",
      code: "NASDAQ:AE",
      companyName: "Adams Resources & Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeac",
      code: "NASDAQ:AEAC",
      companyName: "Authentic Equity Acquisition Corp. Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeacw",
      code: "NASDAQ:AEACW",
      companyName: "Authentic Equity Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeae",
      code: "NASDAQ:AEAE",
      companyName: "AltEnergy Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeaew",
      code: "NASDAQ:AEAEW",
      companyName: "AltEnergy Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-aef",
      code: "NASDAQ:AEF",
      companyName:
        "Aberdeen Emerging Markets Equity Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aefc",
      code: "NASDAQ:AEFC",
      companyName:
        "Aegon Funding Company LLC 5.10% Subordinated Notes due 2049",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeha",
      code: "NASDAQ:AEHA",
      companyName: "Aesther Healthcare Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aehaw",
      code: "NASDAQ:AEHAW",
      companyName: "Aesther Healthcare Acquisition Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-aehl",
      code: "NASDAQ:AEHL",
      companyName:
        "Antelope Enterprise Holdings Limited Common Stock (0.024 par)",
      popularity: 0,
    },
    {
      slug: "nasdaq-aehr",
      code: "NASDAQ:AEHR",
      companyName: "Aehr Test Systems Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeis",
      code: "NASDAQ:AEIS",
      companyName: "Advanced Energy Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ael-b",
      code: "NASDAQ:AEL-B",
      companyName:
        "American Equity Investment Life Holding Company Depositary Shares each representing a 1/1000th interest in a share of 6.625% Fixed-Rate Reset Non-Cumulative Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-aem",
      code: "NASDAQ:AEM",
      companyName: "Agnico Eagle Mines Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeppz",
      code: "NASDAQ:AEPPZ",
      companyName: "American Electric Power Company Inc. Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-aer",
      code: "NASDAQ:AER",
      companyName: "AerCap Holdings N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aerc",
      code: "NASDAQ:AERC",
      companyName: "AeroClean Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeri",
      code: "NASDAQ:AERI",
      companyName: "Aerie Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aesc",
      code: "NASDAQ:AESC",
      companyName: "The AES Corporation Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-aey",
      code: "NASDAQ:AEY",
      companyName: "ADDvantage Technologies Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aes",
      code: "NASDAQ:AES",
      companyName: "The AES Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aep",
      code: "NASDAQ:AEP",
      companyName: "American Electric Power Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aenz",
      code: "NASDAQ:AENZ",
      companyName: "Aenza S.A.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeo",
      code: "NASDAQ:AEO",
      companyName: "American Eagle Outfitters Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aemd",
      code: "NASDAQ:AEMD",
      companyName: "Aethlon Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ael",
      code: "NASDAQ:AEL",
      companyName:
        "American Equity Investment Life Holding Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-afaq",
      code: "NASDAQ:AFAQ",
      companyName: "AF Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-afac",
      code: "NASDAQ:AFAC",
      companyName: "Arena Fortify Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-lbtr",
      code: "ASX:LBTR",
      companyName: "LBT Innovations Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-afib",
      code: "NASDAQ:AFIB",
      companyName: "Acutus Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-afl",
      code: "NASDAQ:AFL",
      companyName: "AFLAC Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-afmd",
      code: "NASDAQ:AFMD",
      companyName: "Affimed N.V.",
      popularity: 0,
    },
    {
      slug: "nasdaq-afrm",
      code: "NASDAQ:AFRM",
      companyName: "Affirm Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aft",
      code: "NASDAQ:AFT",
      companyName: "Apollo Senior Floating Rate Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aftr",
      code: "NASDAQ:AFTR",
      companyName:
        "AfterNext HealthTech Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-afya",
      code: "NASDAQ:AFYA",
      companyName: "Afya Limited Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ag",
      code: "NASDAQ:AG",
      companyName: "First Majestic Silver Corp. Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-agac",
      code: "NASDAQ:AGAC",
      companyName:
        "African Gold Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-agba",
      code: "NASDAQ:AGBA",
      companyName: "AGBA Acquisition Limited Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-agbar",
      code: "NASDAQ:AGBAR",
      companyName: "AGBA Acquisition Limited Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-agbaw",
      code: "NASDAQ:AGBAW",
      companyName: "AGBA Acquisition Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-agcb",
      code: "NASDAQ:AGCB",
      companyName: "Altimeter Growth Corp. 2 Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-agco",
      code: "NASDAQ:AGCO",
      companyName: "AGCO Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agd",
      code: "NASDAQ:AGD",
      companyName: "Aberdeen Global Dynamic Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-age",
      code: "NASDAQ:AGE",
      companyName: "AgeX Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agen",
      code: "NASDAQ:AGEN",
      companyName: "Agenus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agfs",
      code: "NASDAQ:AGFS",
      companyName: "AgroFresh Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agfy",
      code: "NASDAQ:AGFY",
      companyName: "Agrify Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aggr",
      code: "NASDAQ:AGGR",
      companyName: "Agile Growth Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-aggru",
      code: "NASDAQ:AGGRU",
      companyName: "Agile Growth Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-aggrw",
      code: "NASDAQ:AGGRW",
      companyName: "Agile Growth Corp. Warrant.",
      popularity: 0,
    },
    {
      slug: "nasdaq-agil",
      code: "NASDAQ:AGIL",
      companyName: "AgileThought Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agilw",
      code: "NASDAQ:AGILW",
      companyName: "AgileThought Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-agio",
      code: "NASDAQ:AGIO",
      companyName: "Agios Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agl",
      code: "NASDAQ:AGL",
      companyName: "agilon health inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agle",
      code: "NASDAQ:AGLE",
      companyName: "Aeglea BioTherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agm",
      code: "NASDAQ:AGM",
      companyName: "Federal Agricultural Mortgage Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agm-c",
      code: "NASDAQ:AGM-C",
      companyName:
        "Federal Agricultural Mortgage Corporation Preferred Series C Fixed to Fltg",
      popularity: 0,
    },
    {
      slug: "nasdaq-agm-d",
      code: "NASDAQ:AGM-D",
      companyName:
        "Federal Agricultural Mortgage Corporation 5.700% Non-Cumulative Preferred Stock Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-agm-e",
      code: "NASDAQ:AGM-E",
      companyName:
        "Federal Agricultural Mortgage Corporation 5.750% Non-Cumulative Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-agm-f",
      code: "NASDAQ:AGM-F",
      companyName:
        "Federal Agricultural Mortgage Corporation 5.250% Non-Cumulative Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nasdaq-agm-g",
      code: "NASDAQ:AGM-G",
      companyName:
        "Federal Agricultural Mortgage Corporation 4.875% Non-Cumulative Preferred Stock Series G",
      popularity: 0,
    },
    {
      slug: "nasdaq-agmh",
      code: "NASDAQ:AGMH",
      companyName: "AGM Group Holdings Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-agncm",
      code: "NASDAQ:AGNCM",
      companyName:
        "AGNC Investment Corp. Depositary Shares rep 6.875% Series D Fixed-to-Floating Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agncn",
      code: "NASDAQ:AGNCN",
      companyName:
        "AGNC Investment Corp. Depositary Shares Each Representing a 1/1000th Interest in a Share of 7.00% Series C Fixed-To-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agnco",
      code: "NASDAQ:AGNCO",
      companyName:
        "AGNC Investment Corp. Depositary Shares each representing a 1/1000th interest in a share of 6.50% Series E Fixed-to-Floating Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ago",
      code: "NASDAQ:AGO",
      companyName: "Assured Guaranty Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agr",
      code: "NASDAQ:AGR",
      companyName: "Avangrid Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agri",
      code: "NASDAQ:AGRI",
      companyName: "AgriFORCE  Growing Systems Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-agriw",
      code: "NASDAQ:AGRIW",
      companyName: "AgriFORCE  Growing Systems Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-agro",
      code: "NASDAQ:AGRO",
      companyName: "Adecoagro S.A. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-agrx",
      code: "NASDAQ:AGRX",
      companyName: "Agile Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ags",
      code: "NASDAQ:AGS",
      companyName: "PlayAGS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agtc",
      code: "NASDAQ:AGTC",
      companyName: "Applied Genetic Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agti",
      code: "NASDAQ:AGTI",
      companyName: "Agiliti Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agx",
      code: "NASDAQ:AGX",
      companyName: "Argan Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agys",
      code: "NASDAQ:AGYS",
      companyName: "Agilysys Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahco",
      code: "NASDAQ:AHCO",
      companyName: "AdaptHealth Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahg",
      code: "NASDAQ:AHG",
      companyName: "Akso Health Group ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahh",
      code: "NASDAQ:AHH",
      companyName: "Armada Hoffler Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahh-a",
      code: "NASDAQ:AHH-A",
      companyName:
        "Armada Hoffler Properties Inc. 6.75% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahi",
      code: "NASDAQ:AHI",
      companyName: "Advanced Human Imaging Limited. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahl-c",
      code: "NASDAQ:AHL-C",
      companyName:
        "Aspen Insurance Holdings Limited 5.95% Fixed-to-Floating Rate Perpetual Non-Cumulative Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahl-d",
      code: "NASDAQ:AHL-D",
      companyName:
        "Aspen Insurance Holdings Limited 5.625% Perpetual Non-Cumulative Preference Shares",
      popularity: 0,
    },
    {
      slug: "asx-nc1n",
      code: "ASX:NC1N",
      companyName: "Nico Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-alty",
      code: "NYSE:ALTY",
      companyName: "Global X Funds Global X Alternative Income ETF",
      popularity: 0,
    },
    {
      slug: "asx-rog",
      code: "ASX:ROG",
      companyName: "Red Sky Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rcw",
      code: "ASX:RCW",
      companyName: "Rightcrowd Ltd",
      popularity: 0,
    },
    {
      slug: "asx-spx",
      code: "ASX:SPX",
      companyName: "Spenda Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-sli",
      code: "NYSE:SLI",
      companyName: "Standard Lithium Ltd.",
      popularity: 0,
    },
    {
      slug: "asx-sbw",
      code: "ASX:SBW",
      companyName: "Shekel Brainweigh Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sfy",
      code: "ASX:SFY",
      companyName: "SPDR S&P/ASX 50 Fund",
      popularity: 0,
    },
    {
      slug: "asx-slf",
      code: "ASX:SLF",
      companyName: "SPDR S&P/ASX 200 Listed Property Fund",
      popularity: 0,
    },
    {
      slug: "asx-reh",
      code: "ASX:REH",
      companyName: "Reece Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qfn",
      code: "ASX:QFN",
      companyName: "Betashares Australian Financials Sector ETF",
      popularity: 0,
    },
    {
      slug: "asx-sp3",
      code: "ASX:SP3",
      companyName: "Spectur Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rdm",
      code: "ASX:RDM",
      companyName: "Red Metal Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dro",
      code: "ASX:DRO",
      companyName: "Droneshield Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dxc",
      code: "ASX:DXC",
      companyName: "Dexus Convenience Retail REIT",
      popularity: 0,
    },
    {
      slug: "asx-jhc",
      code: "ASX:JHC",
      companyName: "JAPARA HEALTHCARE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ric",
      code: "ASX:RIC",
      companyName: "Ridley Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tmgnc",
      code: "ASX:TMGNC",
      companyName: "Trigg Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rhy",
      code: "ASX:RHY",
      companyName: "RHYTHM Biosciences Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pyc",
      code: "ASX:PYC",
      companyName: "PYC Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rbl",
      code: "ASX:RBL",
      companyName: "Redbubble Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rds",
      code: "ASX:RDS",
      companyName: "Redstone Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shj",
      code: "ASX:SHJ",
      companyName: "Shine Justice Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ald",
      code: "ASX:ALD",
      companyName: "Ampol Ltd",
      popularity: 381000,
    },
    {
      slug: "asx-rno",
      code: "ASX:RNO",
      companyName: "Rhinomed Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rhi",
      code: "ASX:RHI",
      companyName: "Red Hill Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-abc",
      code: "NASDAQ:ABC",
      companyName: "AmerisourceBergen Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abos",
      code: "NASDAQ:ABOS",
      companyName: "Acumen Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahl-e",
      code: "NASDAQ:AHL-E",
      companyName:
        "Aspen Insurance Holdings Limited Depositary Shares each representing a 1/1000th interest in a share of 5.625% Perpetual Non-Cumulative Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahpa",
      code: "NASDAQ:AHPA",
      companyName: "Avista Public Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-vaf",
      code: "ASX:VAF",
      companyName: "Vanguard Australian Fixed Interest INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-rie",
      code: "ASX:RIE",
      companyName: "Riedel Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rfx",
      code: "ASX:RFX",
      companyName: "Redflow Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rlc",
      code: "ASX:RLC",
      companyName: "Reedy Lagoon Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rmx",
      code: "ASX:RMX",
      companyName: "Red Mountain Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rvr",
      code: "ASX:RVR",
      companyName: "Red River Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-agng",
      code: "NYSE:AGNG",
      companyName: "Global X Funds Global X Aging Population ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdns",
      code: "NASDAQ:CDNS",
      companyName: "Cadence Design Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-rim",
      code: "ASX:RIM",
      companyName: "Rimfire Pacific Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sec",
      code: "ASX:SEC",
      companyName: "Spheria Emerging Companies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-benpg",
      code: "ASX:BENPG",
      companyName: "Bendigo and Adelaide Bank Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-gild",
      code: "NYSE:GILD",
      companyName: "Gilead Sciences Inc",
      popularity: 0,
    },
    {
      slug: "asx-cbapg",
      code: "ASX:CBAPG",
      companyName: "Commonwealth Bank of Australia",
      popularity: 0,
    },
    {
      slug: "asx-ktg",
      code: "ASX:KTG",
      companyName: "K-Tig Ltd",
      popularity: 0,
    },
    {
      slug: "asx-an3pk",
      code: "ASX:AN3PK",
      companyName: "Australia and New Zealand Banking Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ayupa",
      code: "ASX:AYUPA",
      companyName: "Australian Unity Ltd",
      popularity: 0,
    },
    {
      slug: "asx-baor",
      code: "ASX:BAOR",
      companyName: "Aoris Int Fund (Class B) (Unhedged) (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "nyse-gww",
      code: "NYSE:GWW",
      companyName: "W.W. Grainger Inc.",
      popularity: 0,
    },
    {
      slug: "asx-tco",
      code: "ASX:TCO",
      companyName: "Transmetro Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-jpm",
      code: "NYSE:JPM",
      companyName: "JPMorgan Chase & Co.",
      popularity: 0,
    },
    {
      slug: "asx-camg",
      code: "ASX:CAMG",
      companyName: "Clime Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bgbl",
      code: "ASX:BGBL",
      companyName: "Betashares Global Shares ETF",
      popularity: 0,
    },
    {
      slug: "asx-ttb",
      code: "ASX:TTB",
      companyName: "Total Brain Ltd",
      popularity: 0,
    },
    {
      slug: "asx-amppb",
      code: "ASX:AMPPB",
      companyName: "AMP Ltd",
      popularity: 9000,
    },
    {
      slug: "asx-szl",
      code: "ASX:SZL",
      companyName: "Sezzle Inc",
      popularity: 0,
    },
    {
      slug: "nyse-edv",
      code: "NYSE:EDV",
      companyName: "Vanguard World Funds Extended Duration ETF",
      popularity: 0,
    },
    {
      slug: "asx-benph",
      code: "ASX:BENPH",
      companyName: "Bendigo and Adelaide Bank Ltd",
      popularity: 0,
    },
    {
      slug: "asx-boqpe",
      code: "ASX:BOQPE",
      companyName: "Bank of Queensland Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tkl",
      code: "ASX:TKL",
      companyName: "Traka Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cym",
      code: "ASX:CYM",
      companyName: "Cyprium Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-boqpf",
      code: "ASX:BOQPF",
      companyName: "Bank of Queensland Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sho",
      code: "ASX:SHO",
      companyName: "Sportshero Ltd",
      popularity: 0,
    },
    {
      slug: "asx-boqpg",
      code: "ASX:BOQPG",
      companyName: "Bank of Queensland Ltd",
      popularity: 0,
    },
    {
      slug: "asx-st1",
      code: "ASX:ST1",
      companyName: "Spirit Technology Solutions Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vms",
      code: "ASX:VMS",
      companyName: "Venture Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lnw",
      code: "ASX:LNW",
      companyName: "Light & Wonder Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-c",
      code: "NASDAQ:C",
      companyName: "Citigroup Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvs",
      code: "NASDAQ:NVS",
      companyName: "Novartis AG Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-cbapi",
      code: "ASX:CBAPI",
      companyName: "Commonwealth Bank of Australia",
      popularity: 0,
    },
    {
      slug: "nyse-mck",
      code: "NYSE:MCK",
      companyName: "McKesson Corporation",
      popularity: 0,
    },
    {
      slug: "asx-six",
      code: "ASX:SIX",
      companyName: "Sprintex Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vee",
      code: "ASX:VEE",
      companyName: "Veem Ltd",
      popularity: 0,
    },
    {
      slug: "asx-spt",
      code: "ASX:SPT",
      companyName: "Splitit Payments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-an3pg",
      code: "ASX:AN3PG",
      companyName: "Australia and New Zealand Banking Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-aiq",
      code: "NYSE:AIQ",
      companyName:
        "Global X Funds Global X Artificial Intelligence & Technology ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-abbv",
      code: "NASDAQ:ABBV",
      companyName: "AbbVie Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahpau",
      code: "NASDAQ:AHPAU",
      companyName: "Avista Public Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahpaw",
      code: "NASDAQ:AHPAW",
      companyName: "Avista Public Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "asx-an3ph",
      code: "ASX:AN3PH",
      companyName: "Australia and New Zealand Banking Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahpi",
      code: "NASDAQ:AHPI",
      companyName: "Allied Healthcare Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-an3pi",
      code: "ASX:AN3PI",
      companyName: "Australia and New Zealand Banking Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-an3pj",
      code: "ASX:AN3PJ",
      companyName: "Australia and New Zealand Banking Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cbaph",
      code: "ASX:CBAPH",
      companyName: "Commonwealth Bank of Australia",
      popularity: 0,
    },
    {
      slug: "asx-cbapj",
      code: "ASX:CBAPJ",
      companyName: "Commonwealth Bank of Australia",
      popularity: 0,
    },
    {
      slug: "asx-cbapk",
      code: "ASX:CBAPK",
      companyName: "Commonwealth Bank of Australia",
      popularity: 0,
    },
    {
      slug: "asx-vbs",
      code: "ASX:VBS",
      companyName: "Vectus Biosystems Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-usb",
      code: "NYSE:USB",
      companyName: "U.S. Bancorp",
      popularity: 0,
    },
    {
      slug: "asx-zgl",
      code: "ASX:ZGL",
      companyName: "ZICOM Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fsiga",
      code: "ASX:FSIGA",
      companyName: "Flagship Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cgfpc",
      code: "ASX:CGFPC",
      companyName: "Challenger Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cgfpd",
      code: "ASX:CGFPD",
      companyName: "Challenger Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wsr",
      code: "ASX:WSR",
      companyName: "Westar Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hgbl",
      code: "ASX:HGBL",
      companyName: "Betashares Global Shares ETF - Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-cure",
      code: "ASX:CURE",
      companyName: "Global X S&P Biotech ETF",
      popularity: 0,
    },
    {
      slug: "asx-veq",
      code: "ASX:VEQ",
      companyName: "Vanguard Ftse Europe Shares ETF",
      popularity: 0,
    },
    {
      slug: "asx-cinpa",
      code: "ASX:CINPA",
      companyName: "Carlton Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fft",
      code: "ASX:FFT",
      companyName: "Future First Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kau",
      code: "ASX:KAU",
      companyName: "Kaiser Reef Ltd",
      popularity: 0,
    },
    {
      slug: "asx-emd",
      code: "ASX:EMD",
      companyName: "Emyria Ltd",
      popularity: 0,
    },
    {
      slug: "asx-einc",
      code: "ASX:EINC",
      companyName: "Betashares MRTN Currie EQY Inc Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "nasdaq-aht-f",
      code: "NASDAQ:AHT-F",
      companyName:
        "Ashford Hospitality Trust Inc 7.375% Series F Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "asx-iagpe",
      code: "ASX:IAGPE",
      companyName: "Insurance Australia Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-nvo",
      code: "NYSE:NVO",
      companyName: "Novo-Nordisk A/S",
      popularity: 0,
    },
    {
      slug: "nasdaq-aht-g",
      code: "NASDAQ:AHT-G",
      companyName:
        "Ashford Hospitality Trust Inc 7.375% Series G Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "asx-emuca",
      code: "ASX:EMUCA",
      companyName: "EMU NL",
      popularity: 0,
    },
    {
      slug: "asx-cbapl",
      code: "ASX:CBAPL",
      companyName: "Commonwealth Bank of Australia",
      popularity: 0,
    },
    {
      slug: "asx-cos",
      code: "ASX:COS",
      companyName: "Cosol Ltd",
      popularity: 0,
    },
    {
      slug: "asx-estx",
      code: "ASX:ESTX",
      companyName: "Global X Euro STOXX 50 ETF",
      popularity: 0,
    },
    {
      slug: "asx-td1",
      code: "ASX:TD1",
      companyName: "Tali Digital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-daor",
      code: "ASX:DAOR",
      companyName: "Aoris Int Fund (Class D) (Hedged) (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ndia",
      code: "ASX:NDIA",
      companyName: "Global X India Nifty 50 ETF",
      popularity: 0,
    },
    {
      slug: "asx-gc1pa",
      code: "ASX:GC1PA",
      companyName: "Glennon Small Companies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cbapm",
      code: "ASX:CBAPM",
      companyName: "Commonwealth Bank of Australia",
      popularity: 0,
    },
    {
      slug: "asx-cpt",
      code: "ASX:CPT",
      companyName: "Cipherpoint Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eafz",
      code: "ASX:EAFZ",
      companyName: "Ellerston Asia Growth Fund (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ai",
      code: "NASDAQ:AI",
      companyName: "C3.ai Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-etpmpd",
      code: "ASX:ETPMPD",
      companyName: "Global X Metal Securities Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ar1",
      code: "ASX:AR1",
      companyName: "Austral Resources Australia Ltd",
      popularity: 23000,
    },
    {
      slug: "nyse-ajg",
      code: "NYSE:AJG",
      companyName: "Arthur J. Gallagher & Co.",
      popularity: 0,
    },
    {
      slug: "asx-good",
      code: "ASX:GOOD",
      companyName: "Janus Henderson Sust CR Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-etpmag",
      code: "ASX:ETPMAG",
      companyName: "Global X Metal Securities Australia Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-aht-h",
      code: "NASDAQ:AHT-H",
      companyName:
        "Ashford Hospitality Trust Inc 7.50% Series H Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aht-i",
      code: "NASDAQ:AHT-I",
      companyName:
        "Ashford Hospitality Trust Inc 7.50% Series I Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abeo",
      code: "NASDAQ:ABEO",
      companyName: "Abeona Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ahrn",
      code: "NASDAQ:AHRN",
      companyName: "Ahren Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aht",
      code: "NASDAQ:AHT",
      companyName: "Ashford Hospitality Trust Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aht-d",
      code: "NASDAQ:AHT-D",
      companyName:
        "Ashford Hospitality Trust Inc 8.45% Series D Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aib",
      code: "NASDAQ:AIB",
      companyName: "AIB Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aibbr",
      code: "NASDAQ:AIBBR",
      companyName: "AIB Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-aic",
      code: "NASDAQ:AIC",
      companyName: "Arlington Asset Investment Corp 6.750% Notes due 2025",
      popularity: 0,
    },
    {
      slug: "asx-gflga",
      code: "ASX:GFLGA",
      companyName: "Global Masters Fund Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cbe",
      code: "ASX:CBE",
      companyName: "Cobre Ltd",
      popularity: 0,
    },
    {
      slug: "asx-glpr",
      code: "ASX:GLPR",
      companyName: "Ishares Ftse GBL Property Ex Aus (Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ausf",
      code: "NYSE:AUSF",
      companyName: "Global X Adaptive U.S. Factor ETF",
      popularity: 0,
    },
    {
      slug: "asx-hcd",
      code: "ASX:HCD",
      companyName: "Hydrocarbon Dynamics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iisv",
      code: "ASX:IISV",
      companyName: "Intell Invest Select Value SHR Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-cbr",
      code: "ASX:CBR",
      companyName: "Carbon Revolution Ltd",
      popularity: 0,
    },
    {
      slug: "asx-m24",
      code: "ASX:M24",
      companyName: "Mamba Exploration Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-aiki",
      code: "NASDAQ:AIKI",
      companyName: "AIkido Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aim",
      code: "NASDAQ:AIM",
      companyName: "AIM ImmunoTech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aimau",
      code: "NASDAQ:AIMAU",
      companyName: "Aimfinity Investment Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-aimc",
      code: "NASDAQ:AIMC",
      companyName: "Altra Industrial Motion Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ain",
      code: "NASDAQ:AIN",
      companyName: "Albany International Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-m2rn",
      code: "ASX:M2RN",
      companyName: "Miramar Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-icl",
      code: "ASX:ICL",
      companyName: "Iceni Gold Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-uso",
      code: "NYSE:USO",
      companyName: "United States Oil Fund LP",
      popularity: 0,
    },
    {
      slug: "nasdaq-ainc",
      code: "NASDAQ:AINC",
      companyName: "Ashford Inc. (Holding Company) Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-vdgr",
      code: "ASX:VDGR",
      companyName: "Vanguard Diversified Growth INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-del",
      code: "ASX:DEL",
      companyName: "Delorean Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mauca",
      code: "ASX:MAUCA",
      companyName: "Magnetic Resources NL",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvx",
      code: "NASDAQ:NVX",
      companyName: "NOVONIX Limited American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ainv",
      code: "NASDAQ:AINV",
      companyName: "Apollo Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aio",
      code: "NASDAQ:AIO",
      companyName:
        "Virtus AllianzGI Artificial Intelligence & Technology Opportunities Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-mozg",
      code: "ASX:MOZG",
      companyName: "Mosaic Brands Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hpp",
      code: "ASX:HPP",
      companyName: "Health and Plant Protein Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-5gg",
      code: "ASX:5GG",
      companyName: "Pentanet Ltd",
      popularity: 81000,
    },
    {
      slug: "asx-ph2",
      code: "ASX:PH2",
      companyName: "Pure Hydrogen Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-dd",
      code: "NYSE:DD",
      companyName: "DuPont de Nemours Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-mtr",
      code: "ASX:MTR",
      companyName: "METAL TIGER PLC",
      popularity: 0,
    },
    {
      slug: "asx-kcc",
      code: "ASX:KCC",
      companyName: "Kincora Copper Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jhpi",
      code: "ASX:JHPI",
      companyName: "JPM EQTY Prem Inc H Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "nyse-gld",
      code: "NYSE:GLD",
      companyName: "SPDR Gold Trust SPDR Gold Shares",
      popularity: 0,
    },
    {
      slug: "asx-jpeq",
      code: "ASX:JPEQ",
      companyName: "JPM US100Q EQ Prem Inc Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-a8g",
      code: "ASX:A8G",
      companyName: "Australasian Metals Ltd",
      popularity: 37000,
    },
    {
      slug: "asx-phl",
      code: "ASX:PHL",
      companyName: "Propell Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jphq",
      code: "ASX:JPHQ",
      companyName: "JPM US100Q EQ Prem Inc H Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ahi",
      code: "ASX:AHI",
      companyName: "Advanced Health Intelligence Ltd",
      popularity: 61000,
    },
    {
      slug: "nasdaq-ms",
      code: "NASDAQ:MS",
      companyName: "Morgan Stanley Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-kain",
      code: "ASX:KAIN",
      companyName: "Kairos Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mblpd",
      code: "ASX:MBLPD",
      companyName: "Macquarie Bank Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mblpc",
      code: "ASX:MBLPC",
      companyName: "Macquarie Bank Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-abm",
      code: "NASDAQ:ABM",
      companyName: "ABM Industries Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aif",
      code: "NASDAQ:AIF",
      companyName: "Apollo Tactical Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-bca",
      code: "ASX:BCA",
      companyName: "Black Canyon Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-aig",
      code: "NASDAQ:AIG",
      companyName: "American International Group Inc. New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aig-a",
      code: "NASDAQ:AIG-A",
      companyName:
        "American International Group Inc. Depositary Shares Each Representing a 1/1000th Interest in a Share of Series A 5.85% Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cefa",
      code: "NYSE:CEFA",
      companyName: "Global X S&P Catholic Values Developed ex-U.S. ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-aih",
      code: "NASDAQ:AIH",
      companyName:
        "Aesthetic Medical International Holdings Group Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aihs",
      code: "NASDAQ:AIHS",
      companyName: "Senmiao Technology Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-92e",
      code: "ASX:92E",
      companyName: "92 Energy Ltd",
      popularity: 52000,
    },
    {
      slug: "asx-lfspa",
      code: "ASX:LFSPA",
      companyName: "Latitude Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-aip",
      code: "NASDAQ:AIP",
      companyName: "Arteris Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-air",
      code: "NASDAQ:AIR",
      companyName: "AAR Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-airc",
      code: "NASDAQ:AIRC",
      companyName: "Apartment Income REIT Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-airg",
      code: "NASDAQ:AIRG",
      companyName: "Airgain Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-airi",
      code: "NASDAQ:AIRI",
      companyName: "Air Industries Group Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-lgl",
      code: "ASX:LGL",
      companyName: "Lynch Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shg",
      code: "ASX:SHG",
      companyName: "Singular Health Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mggda",
      code: "ASX:MGGDA",
      companyName: "Mogul Games Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnxc",
      code: "NASDAQ:CNXC",
      companyName: "Concentrix Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fb",
      code: "NASDAQ:FB",
      companyName: "Meta Platforms Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-fme",
      code: "ASX:FME",
      companyName: "Future Metals NL",
      popularity: 0,
    },
    {
      slug: "asx-aqn",
      code: "ASX:AQN",
      companyName: "Aquirian Ltd",
      popularity: 18000,
    },
    {
      slug: "asx-mqgpd",
      code: "ASX:MQGPD",
      companyName: "Macquarie Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sunpi",
      code: "ASX:SUNPI",
      companyName: "Suncorp Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eye",
      code: "ASX:EYE",
      companyName: "Nova EYE Medical Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lgm",
      code: "ASX:LGM",
      companyName: "Legacy Minerals Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mqgpf",
      code: "ASX:MQGPF",
      companyName: "Macquarie Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nabpe",
      code: "ASX:NABPE",
      companyName: "National Australia Bank Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nabph",
      code: "ASX:NABPH",
      companyName: "National Australia Bank Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nabpi",
      code: "ASX:NABPI",
      companyName: "National Australia Bank Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-bili",
      code: "NASDAQ:BILI",
      companyName: "Bilibili Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pypl",
      code: "NYSE:PYPL",
      companyName: "PayPal Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-aii",
      code: "ASX:AII",
      companyName: "Almonty Industries Inc",
      popularity: 16000,
    },
    {
      slug: "asx-rdv",
      code: "ASX:RDV",
      companyName: "Russell Investments High Dividend Australian Shares ETF",
      popularity: 0,
    },
    {
      slug: "asx-bmm",
      code: "ASX:BMM",
      companyName: "Balkan Mining and Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cpo",
      code: "ASX:CPO",
      companyName: "Culpeo Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bdx",
      code: "ASX:BDX",
      companyName: "Bcal Diagnostics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ir1",
      code: "ASX:IR1",
      companyName: "Iris Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mqgpc",
      code: "ASX:MQGPC",
      companyName: "Macquarie Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rhcpa",
      code: "ASX:RHCPA",
      companyName: "Ramsay Health Care Ltd",
      popularity: 0,
    },
    {
      slug: "asx-knb",
      code: "ASX:KNB",
      companyName: "Koonenberry Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nkl",
      code: "ASX:NKL",
      companyName: "Nickelx Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kni",
      code: "ASX:KNI",
      companyName: "Kuniko Ltd",
      popularity: 0,
    },
    {
      slug: "asx-m3m",
      code: "ASX:M3M",
      companyName: "M3 Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nol",
      code: "ASX:NOL",
      companyName: "Nobleoak Life Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-absi",
      code: "NASDAQ:ABSI",
      companyName: "Absci Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-airs",
      code: "NASDAQ:AIRS",
      companyName: "AirSculpt Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aiu",
      code: "NASDAQ:AIU",
      companyName: "Meta Data Limited ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-aiv",
      code: "NASDAQ:AIV",
      companyName: "Apartment Investment and Management Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aiz",
      code: "NASDAQ:AIZ",
      companyName: "Assurant Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aizn",
      code: "NASDAQ:AIZN",
      companyName: "Assurant Inc. 5.25% Subordinated Notes due 2061",
      popularity: 0,
    },
    {
      slug: "nasdaq-ajg",
      code: "NASDAQ:AJG",
      companyName: "Arthur J. Gallagher & Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ajrd",
      code: "NASDAQ:AJRD",
      companyName: "Aerojet Rocketdyne Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ajx",
      code: "NASDAQ:AJX",
      companyName: "Great Ajax Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ajxa",
      code: "NASDAQ:AJXA",
      companyName: "Great Ajax Corp. 7.25% Convertible Senior Notes due 2024",
      popularity: 0,
    },
    {
      slug: "asx-nwslv",
      code: "ASX:NWSLV",
      companyName: "News Corporation",
      popularity: 0,
    },
    {
      slug: "asx-mm1",
      code: "ASX:MM1",
      companyName: "Midas Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nabpf",
      code: "ASX:NABPF",
      companyName: "National Australia Bank Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-beco",
      code: "NYSE:BECO",
      companyName: "BlackRock Future Climate and Sustainable Economy ETF",
      popularity: 0,
    },
    {
      slug: "asx-ragn",
      code: "ASX:RAGN",
      companyName: "Ragnar Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-si6ne",
      code: "ASX:SI6NE",
      companyName: "SI6 Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sslpa",
      code: "ASX:SSLPA",
      companyName: "Sietel Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sunpg",
      code: "ASX:SUNPG",
      companyName: "Suncorp Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sunph",
      code: "ASX:SUNPH",
      companyName: "Suncorp Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-xsd",
      code: "NYSE:XSD",
      companyName: "SPDR S&P Semiconductor ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-aka",
      code: "NASDAQ:AKA",
      companyName: "a.k.a. Brands Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-akam",
      code: "NASDAQ:AKAM",
      companyName: "Akamai Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-akan",
      code: "NASDAQ:AKAN",
      companyName: "Akanda Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-akba",
      code: "NASDAQ:AKBA",
      companyName: "Akebia Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-akic",
      code: "NASDAQ:AKIC",
      companyName: "Sports Ventures Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-akicw",
      code: "NASDAQ:AKICW",
      companyName: "Sports Ventures Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ako/a",
      code: "NASDAQ:AKO/A",
      companyName: "Embotelladora Andina S.A.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ako/b",
      code: "NASDAQ:AKO/B",
      companyName: "Embotelladora Andina S.A.",
      popularity: 0,
    },
    {
      slug: "nasdaq-akr",
      code: "NASDAQ:AKR",
      companyName: "Acadia Realty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-amn",
      code: "ASX:AMN",
      companyName: "Agrimin Ltd",
      popularity: 49000,
    },
    {
      slug: "nasdaq-alkt",
      code: "NASDAQ:ALKT",
      companyName: "Alkami Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-allk",
      code: "NASDAQ:ALLK",
      companyName: "Allakos Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-allg",
      code: "NASDAQ:ALLG",
      companyName: "Allego N.V. Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-alle",
      code: "NASDAQ:ALLE",
      companyName: "Allegion plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-vgb",
      code: "ASX:VGB",
      companyName: "Vanguard Australian Government Bond INDEX ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-all",
      code: "NASDAQ:ALL",
      companyName: "Allstate Corporation (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-all-g",
      code: "NASDAQ:ALL-G",
      companyName:
        "Allstate Corporation (The) Depositary Shares each representing a 1/1000th interest in a share of Fixed Rate Noncumulative Perpetual Preferred Stock Series G",
      popularity: 0,
    },
    {
      slug: "nasdaq-all-b",
      code: "NASDAQ:ALL-B",
      companyName:
        "Allstate Corporation (The) 5.100% Fixed-to-Floating Rate Subordinated Debentures due 2053",
      popularity: 0,
    },
    {
      slug: "nasdaq-alks",
      code: "NASDAQ:ALKS",
      companyName: "Alkermes plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-vdba",
      code: "ASX:VDBA",
      companyName: "Vanguard Diversified Balanced INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-lis",
      code: "ASX:LIS",
      companyName: "Li-S Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ms",
      code: "NYSE:MS",
      companyName: "Morgan Stanley",
      popularity: 0,
    },
    {
      slug: "asx-wbcph",
      code: "ASX:WBCPH",
      companyName: "Westpac Banking Corporation",
      popularity: 0,
    },
    {
      slug: "asx-dc2",
      code: "ASX:DC2",
      companyName: "DC Two Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cbo",
      code: "ASX:CBO",
      companyName: "Cobram Estate Olives Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tttn",
      code: "ASX:TTTN",
      companyName: "Titomic Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-acrs",
      code: "NASDAQ:ACRS",
      companyName: "Aclaris Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-akro",
      code: "NASDAQ:AKRO",
      companyName: "Akero Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-akts",
      code: "NASDAQ:AKTS",
      companyName: "Akoustis Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aktx",
      code: "NASDAQ:AKTX",
      companyName: "Akari Therapeutics plc ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-aku",
      code: "NASDAQ:AKU",
      companyName: "Akumin Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-akus",
      code: "NASDAQ:AKUS",
      companyName: "Akouos Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-akya",
      code: "NASDAQ:AKYA",
      companyName: "Akoya BioSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-al",
      code: "NASDAQ:AL",
      companyName: "Air Lease Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-al-a",
      code: "NASDAQ:AL-A",
      companyName:
        "Air Lease Corporation 6.150% Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "asx-cus",
      code: "ASX:CUS",
      companyName: "Copper Search Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-albo",
      code: "NASDAQ:ALBO",
      companyName: "Albireo Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alc",
      code: "NASDAQ:ALC",
      companyName: "Alcon Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-alcc",
      code: "NASDAQ:ALCC",
      companyName: "AltC Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alco",
      code: "NASDAQ:ALCO",
      companyName: "Alico Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aldx",
      code: "NASDAQ:ALDX",
      companyName: "Aldeyra Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ale",
      code: "NASDAQ:ALE",
      companyName: "Allete Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-alec",
      code: "NASDAQ:ALEC",
      companyName: "Alector Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alex",
      code: "NASDAQ:ALEX",
      companyName: "Alexander & Baldwin Inc. Common Stock REIT Holding Company",
      popularity: 0,
    },
    {
      slug: "nasdaq-alf",
      code: "NASDAQ:ALF",
      companyName: "ALFI Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alfiw",
      code: "NASDAQ:ALFIW",
      companyName: "ALFI Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-alg",
      code: "NASDAQ:ALG",
      companyName: "Alamo Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-algm",
      code: "NASDAQ:ALGM",
      companyName: "Allegro MicroSystems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-algn",
      code: "NASDAQ:ALGN",
      companyName: "Align Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-algs",
      code: "NASDAQ:ALGS",
      companyName: "Aligos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-algt",
      code: "NASDAQ:ALGT",
      companyName: "Allegiant Travel Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alhc",
      code: "NASDAQ:ALHC",
      companyName: "Alignment Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alim",
      code: "NASDAQ:ALIM",
      companyName: "Alimera Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alin-b",
      code: "NASDAQ:ALIN-B",
      companyName: "Altera Infrastructure L.P. 8.50% Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-aljj",
      code: "NASDAQ:ALJJ",
      companyName: "ALJ Regional Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alin-a",
      code: "NASDAQ:ALIN-A",
      companyName: "Altera Infrastructure L.P. 7.25% Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-alin-e",
      code: "NASDAQ:ALIN-E",
      companyName: "Altera Infrastructure L.P. 8.875% Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-alit",
      code: "NASDAQ:ALIT",
      companyName: "Alight Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-hvy",
      code: "ASX:HVY",
      companyName: "Heavy Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-t3k",
      code: "ASX:T3K",
      companyName: "Tek-Ocean Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-chb",
      code: "NYSE:CHB",
      companyName: "Global X China Biotech Innovation ETF",
      popularity: 0,
    },
    {
      slug: "asx-vgad",
      code: "ASX:VGAD",
      companyName: "Vanguard MSCI INDEX International Shares (Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-wbcpi",
      code: "ASX:WBCPI",
      companyName: "Westpac Banking Corporation",
      popularity: 0,
    },
    {
      slug: "asx-qal",
      code: "ASX:QAL",
      companyName: "Qualitas Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-alrn",
      code: "NASDAQ:ALRN",
      companyName: "Aileron Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-tee",
      code: "ASX:TEE",
      companyName: "Top End Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wbcpj",
      code: "ASX:WBCPJ",
      companyName: "Westpac Banking Corporation",
      popularity: 0,
    },
    {
      slug: "asx-ytmald",
      code: "ASX:YTMALD",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eiq",
      code: "ASX:EIQ",
      companyName: "Echoiq Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmap1",
      code: "ASX:YTMAP1",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gre",
      code: "ASX:GRE",
      companyName: "Greentech Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmdo2",
      code: "ASX:YTMDO2",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-acro",
      code: "NASDAQ:ACRO",
      companyName:
        "Acropolis Infrastructure Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-allr",
      code: "NASDAQ:ALLR",
      companyName: "Allarity Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-allo",
      code: "NASDAQ:ALLO",
      companyName: "Allogene Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-allt",
      code: "NASDAQ:ALLT",
      companyName: "Allot Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-alna",
      code: "NASDAQ:ALNA",
      companyName: "Allena Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-s3n",
      code: "ASX:S3N",
      companyName: "Sensore Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-alny",
      code: "NASDAQ:ALNY",
      companyName: "Alnylam Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ally",
      code: "NASDAQ:ALLY",
      companyName: "Ally Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aloru",
      code: "NASDAQ:ALORU",
      companyName: "ALSP Orchid Acquisition Corporation I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-alor",
      code: "NASDAQ:ALOR",
      companyName:
        "ALSP Orchid Acquisition Corporation I Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-alorw",
      code: "NASDAQ:ALORW",
      companyName: "ALSP Orchid Acquisition Corporation I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-alot",
      code: "NASDAQ:ALOT",
      companyName: "AstroNova Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alp-q",
      code: "NASDAQ:ALP-Q",
      companyName:
        "Alabama Power Company 5.00% Class A Preferred Stock Cumulative Par Value $1 Per Share (Stated Capital $25 Per Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-alpa",
      code: "NASDAQ:ALPA",
      companyName:
        "Alpha Healthcare Acquisition Corp. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alpaw",
      code: "NASDAQ:ALPAW",
      companyName: "Alpha Healthcare Acquisition Corp. III Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-alpn",
      code: "NASDAQ:ALPN",
      companyName: "Alpine Immune Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alpp",
      code: "NASDAQ:ALPP",
      companyName: "Alpine 4 Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-jav",
      code: "ASX:JAV",
      companyName: "Javelin Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wbcpk",
      code: "ASX:WBCPK",
      companyName: "Westpac Banking Corporation",
      popularity: 0,
    },
    {
      slug: "asx-ccr",
      code: "ASX:CCR",
      companyName: "Credit Clear Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ctq",
      code: "ASX:CTQ",
      companyName: "Careteq Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rb6",
      code: "ASX:RB6",
      companyName: "RUBIX Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rfa",
      code: "ASX:RFA",
      companyName: "Rare Foods Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sha",
      code: "ASX:SHA",
      companyName: "Shape Australia Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-alr",
      code: "NASDAQ:ALR",
      companyName: "AlerisLife Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alrs",
      code: "NASDAQ:ALRS",
      companyName: "Alerus Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alrm",
      code: "NASDAQ:ALRM",
      companyName: "Alarm.com Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alsar",
      code: "NASDAQ:ALSAR",
      companyName: "Alpha Star Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-alsau",
      code: "NASDAQ:ALSAU",
      companyName: "Alpha Star Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-alsn",
      code: "NASDAQ:ALSN",
      companyName: "Allison Transmission Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alt",
      code: "NASDAQ:ALT",
      companyName: "Altimmune Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alsaw",
      code: "NASDAQ:ALSAW",
      companyName: "Alpha Star Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "asx-wbcpl",
      code: "ASX:WBCPL",
      companyName: "Westpac Banking Corporation",
      popularity: 0,
    },
    {
      slug: "asx-whfpa",
      code: "ASX:WHFPA",
      companyName: "Whitefield Industrials Ltd",
      popularity: 0,
    },
    {
      slug: "asx-whfpb",
      code: "ASX:WHFPB",
      companyName: "Whitefield Industrials Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wia",
      code: "ASX:WIA",
      companyName: "WIA Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wnxn",
      code: "ASX:WNXN",
      companyName: "Wellnex Life Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wrk",
      code: "ASX:WRK",
      companyName: "WRKR Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xasg",
      code: "ASX:XASG",
      companyName: "Alphinity Global Sustainable Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-xpn",
      code: "ASX:XPN",
      companyName: "Xpon Technologies Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmas2",
      code: "ASX:YTMAS2",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-avr",
      code: "ASX:AVR",
      companyName: "Anteris Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ytmgp1",
      code: "ASX:YTMGP1",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-amgn",
      code: "NASDAQ:AMGN",
      companyName: "Amgen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amh-g",
      code: "NASDAQ:AMH-G",
      companyName:
        "American Homes 4 Rent Series G cumulative redeemable perpetual preferred shares of beneficial interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-amk",
      code: "NASDAQ:AMK",
      companyName: "AssetMark Financial Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amkr",
      code: "NASDAQ:AMKR",
      companyName: "Amkor Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amn",
      code: "NASDAQ:AMN",
      companyName: "AMN Healthcare Services Inc AMN Healthcare Services Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-amat",
      code: "NASDAQ:AMAT",
      companyName: "Applied Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-altg",
      code: "NASDAQ:ALTG",
      companyName: "Alta Equipment Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-altg-a",
      code: "NASDAQ:ALTG-A",
      companyName:
        "Alta Equipment Group Inc. Depositary Shares (each representing 1/1000th in a share of 10% Series A Cumulative Perpetual Preferred Stock)",
      popularity: 0,
    },
    {
      slug: "nasdaq-altu",
      code: "NASDAQ:ALTU",
      companyName: "Altitude Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-altuw",
      code: "NASDAQ:ALTUW",
      companyName: "Altitude Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-altr",
      code: "NASDAQ:ALTR",
      companyName: "Altair Engineering Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alv",
      code: "NASDAQ:ALV",
      companyName: "Autoliv Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alvr",
      code: "NASDAQ:ALVR",
      companyName: "AlloVir Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alx",
      code: "NASDAQ:ALX",
      companyName: "Alexander's Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alxo",
      code: "NASDAQ:ALXO",
      companyName: "ALX Oncology Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amlx",
      code: "NASDAQ:AMLX",
      companyName: "Amylyx Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-alzn",
      code: "NASDAQ:ALZN",
      companyName: "Alzamend Neuro Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-am",
      code: "NASDAQ:AM",
      companyName: "Antero Midstream Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amam",
      code: "NASDAQ:AMAM",
      companyName:
        "Ambrx Biopharma Inc. American Depositary Shares (each representing seven Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-amao",
      code: "NASDAQ:AMAO",
      companyName: "American Acquisition Opportunity Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amaou",
      code: "NASDAQ:AMAOU",
      companyName: "American Acquisition Opportunity Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-amaow",
      code: "NASDAQ:AMAOW",
      companyName: "American Acquisition Opportunity Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ambc",
      code: "NASDAQ:AMBC",
      companyName: "Ambac Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amba",
      code: "NASDAQ:AMBA",
      companyName: "Ambarella Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-amnb",
      code: "NASDAQ:AMNB",
      companyName: "American National Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amot",
      code: "NASDAQ:AMOT",
      companyName: "Allied Motion Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ambo",
      code: "NASDAQ:AMBO",
      companyName:
        "Ambow Education Holding Ltd. American Depository Shares each representing two Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-alya",
      code: "NASDAQ:ALYA",
      companyName: "Alithya Group inc. Class A Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-alto",
      code: "NASDAQ:ALTO",
      companyName: "Alto Ingredients Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amh-h",
      code: "NASDAQ:AMH-H",
      companyName:
        "American Homes 4 Rent Series H cumulative redeemable perpetual Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-amh",
      code: "NASDAQ:AMH",
      companyName: "American Homes 4 Rent Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-amov",
      code: "NASDAQ:AMOV",
      companyName:
        "America Movil S.A.B. de C.V. Class A American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-amg",
      code: "NASDAQ:AMG",
      companyName: "Affiliated Managers Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ameh",
      code: "NASDAQ:AMEH",
      companyName: "Apollo Medical Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ambp",
      code: "NASDAQ:AMBP",
      companyName: "Ardagh Metal Packaging S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-amal",
      code: "NASDAQ:AMAL",
      companyName: "Amalgamated Financial Corp. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ame",
      code: "NASDAQ:AME",
      companyName: "AMETEK Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ampe",
      code: "NASDAQ:AMPE",
      companyName: "Ampio Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-amed",
      code: "NASDAQ:AMED",
      companyName: "Amedisys Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ampg",
      code: "NASDAQ:AMPG",
      companyName: "Amplitech Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amcx",
      code: "NASDAQ:AMCX",
      companyName: "AMC Networks Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amp",
      code: "NASDAQ:AMP",
      companyName: "Ameriprise Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ytmip1",
      code: "ASX:YTMIP1",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ihr",
      code: "ASX:IHR",
      companyName: "INTELLIHR LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ytmf14",
      code: "ASX:YTMF14",
      companyName: "Equity Trustees Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-amc",
      code: "NASDAQ:AMC",
      companyName: "AMC Entertainment Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-fgl",
      code: "ASX:FGL",
      companyName: "Frugl Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-amx",
      code: "NASDAQ:AMX",
      companyName:
        "America Movil S.A.B. de C.V. American Depository Receipt Series L",
      popularity: 0,
    },
    {
      slug: "nasdaq-amrs",
      code: "NASDAQ:AMRS",
      companyName: "Amyris Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-hit",
      code: "ASX:HIT",
      companyName: "Hitech Group Australia Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-amsc",
      code: "NASDAQ:AMSC",
      companyName: "American Superconductor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ams",
      code: "NASDAQ:AMS",
      companyName: "American Shared Hospital Services Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amsf",
      code: "NASDAQ:AMSF",
      companyName: "AMERISAFE Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gw1",
      code: "ASX:GW1",
      companyName: "Greenwing Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-crm",
      code: "NASDAQ:CRM",
      companyName: "Salesforce Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ampgw",
      code: "NASDAQ:AMPGW",
      companyName: "Amplitech Group Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-ampl",
      code: "NASDAQ:AMPL",
      companyName: "Amplitude Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ampy",
      code: "NASDAQ:AMPY",
      companyName: "Amplify Energy Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amr",
      code: "NASDAQ:AMR",
      companyName: "Alpha Metallurgical Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amps",
      code: "NASDAQ:AMPS",
      companyName: "Altus Power Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-eai",
      code: "ASX:EAI",
      companyName: "ELLERSTON ASIAN INVESTMENTS LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-amrk",
      code: "NASDAQ:AMRK",
      companyName: "A-Mark Precious Metals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amrc",
      code: "NASDAQ:AMRC",
      companyName: "Ameresco Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amrn",
      code: "NASDAQ:AMRN",
      companyName: "Amarin Corporation plc",
      popularity: 0,
    },
    {
      slug: "nasdaq-amrx",
      code: "NASDAQ:AMRX",
      companyName: "Amneal Pharmaceuticals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amswa",
      code: "NASDAQ:AMSWA",
      companyName: "American Software Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amst",
      code: "NASDAQ:AMST",
      companyName: "Amesite Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amtb",
      code: "NASDAQ:AMTB",
      companyName: "Amerant Bancorp Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amt",
      code: "NASDAQ:AMT",
      companyName: "American Tower Corporation (REIT) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amti",
      code: "NASDAQ:AMTI",
      companyName: "Applied Molecular Transport Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amtd",
      code: "NASDAQ:AMTD",
      companyName:
        "AMTD IDEA Group American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ampi",
      code: "NASDAQ:AMPI",
      companyName: "Advanced Merger Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-dy6",
      code: "ASX:DY6",
      companyName: "DY6 Metals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-anat",
      code: "NASDAQ:ANAT",
      companyName: "American National Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amtx",
      code: "NASDAQ:AMTX",
      companyName: "Aemetis Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amph",
      code: "NASDAQ:AMPH",
      companyName: "Amphastar Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amwl",
      code: "NASDAQ:AMWL",
      companyName: "American Well Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-myd",
      code: "ASX:MYD",
      companyName: "MYDEAL.COM.AU LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-pdi",
      code: "NYSE:PDI",
      companyName: "PIMCO Dynamic Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tflo",
      code: "NYSE:TFLO",
      companyName: "iShares Treasury Floating Rate Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-obl",
      code: "ASX:OBL",
      companyName: "Omni Bridgeway Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-amwd",
      code: "NASDAQ:AMWD",
      companyName: "American Woodmark Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amyt",
      code: "NASDAQ:AMYT",
      companyName: "Amryt Pharma plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ing",
      code: "NYSE:ING",
      companyName: "ING Groep N.V. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ryld",
      code: "NYSE:RYLD",
      companyName: "Global X Russell 2000 Covered Call ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-an",
      code: "NASDAQ:AN",
      companyName: "AutoNation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-anab",
      code: "NASDAQ:ANAB",
      companyName: "AnaptysBio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-anac",
      code: "NASDAQ:ANAC",
      companyName: "Arctos NorthStar Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-ako",
      code: "ASX:AKO",
      companyName: "Akora Resources Ltd",
      popularity: 20000,
    },
    {
      slug: "asx-dlt",
      code: "ASX:DLT",
      companyName: "DELTA DRONE INTERNATIONAL LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-mlpx",
      code: "NYSE:MLPX",
      companyName: "Global X MLP & Energy Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "asx-cdm",
      code: "ASX:CDM",
      companyName: "Cadence Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fm3",
      code: "ASX:FM3",
      companyName: "FIRSTMAC MORTGAGE FUNDING TRUST NO. 4 SERIES 1-2020",
      popularity: 0,
    },
    {
      slug: "nasdaq-apn",
      code: "NASDAQ:APN",
      companyName: "Apeiron Capital Investment Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-any",
      code: "NASDAQ:ANY",
      companyName: "Sphere 3D Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-apmiw",
      code: "NASDAQ:APMIW",
      companyName: "AxonPrime Infrastructure Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-apd",
      code: "NASDAQ:APD",
      companyName: "Air Products and Chemicals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ande",
      code: "NASDAQ:ANDE",
      companyName: "Andersons Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aneb",
      code: "NASDAQ:ANEB",
      companyName: "Anebulo Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-anf",
      code: "NASDAQ:ANF",
      companyName: "Abercrombie & Fitch Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-anip",
      code: "NASDAQ:ANIP",
      companyName: "ANI Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-anix",
      code: "NASDAQ:ANIX",
      companyName: "Anixa Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-annx",
      code: "NASDAQ:ANNX",
      companyName: "Annexon Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-anss",
      code: "NASDAQ:ANSS",
      companyName: "ANSYS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ante",
      code: "NASDAQ:ANTE",
      companyName: "AirNet Technology Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-anpc",
      code: "NASDAQ:ANPC",
      companyName:
        "AnPac Bio-Medical Science Co. Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-anik",
      code: "NASDAQ:ANIK",
      companyName: "Anika Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ango",
      code: "NASDAQ:ANGO",
      companyName: "AngioDynamics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-antm",
      code: "NASDAQ:ANTM",
      companyName: "Anthem Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-angn",
      code: "NASDAQ:ANGN",
      companyName: "Angion Biomedica Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-antx",
      code: "NASDAQ:ANTX",
      companyName: "AN2 Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-anvs",
      code: "NASDAQ:ANVS",
      companyName: "Annovis Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-anzuw",
      code: "NASDAQ:ANZUW",
      companyName: "Anzu Special Acquisition Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-anzuu",
      code: "NASDAQ:ANZUU",
      companyName: "Anzu Special Acquisition Corp I Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-aogow",
      code: "NASDAQ:AOGOW",
      companyName: "Arogo Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-aomr",
      code: "NASDAQ:AOMR",
      companyName: "Angel Oak Mortgage Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aort",
      code: "NASDAQ:AORT",
      companyName: "Artivion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aos",
      code: "NASDAQ:AOS",
      companyName: "A.O. Smith Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aosl",
      code: "NASDAQ:AOSL",
      companyName: "Alpha and Omega Semiconductor Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ap",
      code: "NASDAQ:AP",
      companyName: "Ampco-Pittsburgh Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apa",
      code: "NASDAQ:APA",
      companyName: "APA Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apac",
      code: "NASDAQ:APAC",
      companyName:
        "StoneBridge Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-apacw",
      code: "NASDAQ:APACW",
      companyName: "StoneBridge Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-apam",
      code: "NASDAQ:APAM",
      companyName:
        "Artisan Partners Asset Management Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apca",
      code: "NASDAQ:APCA",
      companyName: "AP Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-apcxw",
      code: "NASDAQ:APCXW",
      companyName: "AppTech Payments Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-aod",
      code: "NASDAQ:AOD",
      companyName: "Aberdeen Total Dynamic Dividend Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apcx",
      code: "NASDAQ:APCX",
      companyName: "AppTech Payments Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apdn",
      code: "NASDAQ:APDN",
      companyName: "Applied DNA Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apen",
      code: "NASDAQ:APEN",
      companyName: "Apollo Endosurgery Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apld",
      code: "NASDAQ:APLD",
      companyName: "Applied Blockchain Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aple",
      code: "NASDAQ:APLE",
      companyName: "Apple Hospitality REIT Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-apls",
      code: "NASDAQ:APLS",
      companyName: "Apellis Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-api",
      code: "NASDAQ:API",
      companyName: "Agora Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-apg",
      code: "NASDAQ:APG",
      companyName: "APi Group Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aout",
      code: "NASDAQ:AOUT",
      companyName: "American Outdoor Brands Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-apei",
      code: "NASDAQ:APEI",
      companyName: "American Public Education Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aplt",
      code: "NASDAQ:APLT",
      companyName: "Applied Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apmiu",
      code: "NASDAQ:APMIU",
      companyName: "AxonPrime Infrastructure Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-apog",
      code: "NASDAQ:APOG",
      companyName: "Apogee Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-app",
      code: "NASDAQ:APP",
      companyName: "Applovin Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apph",
      code: "NASDAQ:APPH",
      companyName: "AppHarvest Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-anzu",
      code: "NASDAQ:ANZU",
      companyName: "Anzu Special Acquisition Corp I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apgb",
      code: "NASDAQ:APGB",
      companyName: "Apollo Strategic Growth Capital II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-apmi",
      code: "NASDAQ:APMI",
      companyName:
        "AxonPrime Infrastructure Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-appf",
      code: "NASDAQ:APPF",
      companyName: "AppFolio Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apm",
      code: "NASDAQ:APM",
      companyName: "Aptorum Group Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-xyld",
      code: "NYSE:XYLD",
      companyName: "Global X S&P 500 Covered Call ETF",
      popularity: 0,
    },
    {
      slug: "asx-m2r",
      code: "ASX:M2R",
      companyName: "Miramar Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-appn",
      code: "NASDAQ:APPN",
      companyName: "Appian Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apre",
      code: "NASDAQ:APRE",
      companyName: "Aprea Therapeutics Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apphw",
      code: "NASDAQ:APPHW",
      companyName: "AppHarvest Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-apps",
      code: "NASDAQ:APPS",
      companyName: "Digital Turbine Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aprn",
      code: "NASDAQ:APRN",
      companyName: "Blue Apron Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apt",
      code: "NASDAQ:APT",
      companyName: "Alpha Pro Tech Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aptmw",
      code: "NASDAQ:APTMW",
      companyName: "Alpha Partners Technology Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-apto",
      code: "NASDAQ:APTO",
      companyName: "Aptose Biosciences Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-fnx",
      code: "ASX:FNX",
      companyName: "Finexia Financial Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lrk",
      code: "ASX:LRK",
      companyName: "Lark Distilling Co. Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ards",
      code: "NASDAQ:ARDS",
      companyName: "Aridis Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apsg",
      code: "NASDAQ:APSG",
      companyName: "Apollo Strategic Growth Capital Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aptm",
      code: "NASDAQ:APTM",
      companyName:
        "Alpha Partners Technology Merger Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aqb",
      code: "NASDAQ:AQB",
      companyName: "AquaBounty Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aqms",
      code: "NASDAQ:AQMS",
      companyName: "Aqua Metals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-apyx",
      code: "NASDAQ:APYX",
      companyName: "Apyx Medical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aqna",
      code: "NASDAQ:AQNA",
      companyName:
        "Algonquin Power & Utilities Corp. 6.875% Fixed-to-Floating Rate Subordinated Notes Series 2018-A due October 17 2078",
      popularity: 0,
    },
    {
      slug: "nasdaq-aqn",
      code: "NASDAQ:AQN",
      companyName: "Algonquin Power & Utilities Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aqnu",
      code: "NASDAQ:AQNU",
      companyName: "Algonquin Power & Utilities Corp. Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-aqst",
      code: "NASDAQ:AQST",
      companyName: "Aquestive Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aqua",
      code: "NASDAQ:AQUA",
      companyName: "Evoqua Water Technologies Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ar",
      code: "NASDAQ:AR",
      companyName: "Antero Resources Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aqnb",
      code: "NASDAQ:AQNB",
      companyName:
        "Algonquin Power & Utilities Corp. 6.20% Fixed-to-Floating Subordinated Notes Series 2019-A due July 1 2079",
      popularity: 0,
    },
    {
      slug: "nasdaq-aray",
      code: "NASDAQ:ARAY",
      companyName: "Accuray Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arav",
      code: "NASDAQ:ARAV",
      companyName: "Aravive Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arbe",
      code: "NASDAQ:ARBE",
      companyName: "Arbe Robotics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-arbew",
      code: "NASDAQ:ARBEW",
      companyName: "Arbe Robotics Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-apxiw",
      code: "NASDAQ:APXIW",
      companyName: "APx Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-apxiu",
      code: "NASDAQ:APXIU",
      companyName: "APx Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-apwc",
      code: "NASDAQ:APWC",
      companyName:
        "Asia Pacific Wire & Cable Corporation Ltd. Ordinary Shares (Bermuda)",
      popularity: 0,
    },
    {
      slug: "nasdaq-apvo",
      code: "NASDAQ:APVO",
      companyName: "Aptevo Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aptx",
      code: "NASDAQ:APTX",
      companyName: "Aptinyx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aptv-a",
      code: "NASDAQ:APTV-A",
      companyName:
        "Aptiv PLC 5.50% Series A Mandatory Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-apts",
      code: "NASDAQ:APTS",
      companyName: "Preferred Apartment Communities Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arbg",
      code: "NASDAQ:ARBG",
      companyName: "Aequi Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arbgu",
      code: "NASDAQ:ARBGU",
      companyName: "Aequi Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-arbgw",
      code: "NASDAQ:ARBGW",
      companyName: "Aequi Acquisition Corp. warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-arc",
      code: "NASDAQ:ARC",
      companyName: "ARC Document Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arcc",
      code: "NASDAQ:ARCC",
      companyName: "Ares Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arch",
      code: "NASDAQ:ARCH",
      companyName: "Arch Resources Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arcku",
      code: "NASDAQ:ARCKU",
      companyName: "Arbor Rapha Capital Bioholdings Corp. I Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-arco",
      code: "NASDAQ:ARCO",
      companyName: "Arcos Dorados Holdings Inc. Class A Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-arct",
      code: "NASDAQ:ARCT",
      companyName: "Arcturus Therapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ardc",
      code: "NASDAQ:ARDC",
      companyName: "Ares Dynamic Credit Allocation Fund Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ardx",
      code: "NASDAQ:ARDX",
      companyName: "Ardelyx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-are",
      code: "NASDAQ:ARE",
      companyName: "Alexandria Real Estate Equities Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arckw",
      code: "NASDAQ:ARCKW",
      companyName: "Arbor Rapha Capital Bioholdings Corp. I Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-arck",
      code: "NASDAQ:ARCK",
      companyName:
        "Arbor Rapha Capital Bioholdings Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arce",
      code: "NASDAQ:ARCE",
      companyName: "Arco Platform Limited Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-arcb",
      code: "NASDAQ:ARCB",
      companyName: "ArcBest Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arbkl",
      code: "NASDAQ:ARBKL",
      companyName: "Argo Blockchain plc 8.75% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-arbk",
      code: "NASDAQ:ARBK",
      companyName: "Argo Blockchain plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-argd",
      code: "NASDAQ:ARGD",
      companyName:
        "Argo Group International Holdings Ltd. 6.5% Senior Notes Due 2042",
      popularity: 0,
    },
    {
      slug: "nasdaq-argo",
      code: "NASDAQ:ARGO",
      companyName: "Argo Group International Holdings Ltd.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ares",
      code: "NASDAQ:ARES",
      companyName: "Ares Management Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-nmr",
      code: "ASX:NMR",
      companyName: "Native Mineral Resources Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-argo-a",
      code: "NASDAQ:ARGO-A",
      companyName:
        "Argo Group International Holdings Ltd. Depositary Shares Each Representing a 1/1000th Interest in a 7.00% Resettable Fixed Rate Preference Share Series A",
      popularity: 0,
    },
    {
      slug: "asx-wfl",
      code: "ASX:WFL",
      companyName: "Wellfully Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-argu",
      code: "NASDAQ:ARGU",
      companyName: "Argus Capital Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ariz",
      code: "NASDAQ:ARIZ",
      companyName: "Arisz Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arguw",
      code: "NASDAQ:ARGUW",
      companyName: "Argus Capital Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-arizu",
      code: "NASDAQ:ARIZU",
      companyName: "Arisz Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-arko",
      code: "NASDAQ:ARKO",
      companyName: "ARKO Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arkow",
      code: "NASDAQ:ARKOW",
      companyName: "ARKO Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-arizr",
      code: "NASDAQ:ARIZR",
      companyName: "Arisz Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-arlo",
      code: "NASDAQ:ARLO",
      companyName: "Arlo Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arlp",
      code: "NASDAQ:ARLP",
      companyName:
        "Alliance Resource Partners L.P. Common Units representing Limited Partners Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-armp",
      code: "NASDAQ:ARMP",
      companyName: "Armata Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arnc",
      code: "NASDAQ:ARNC",
      companyName: "Arconic Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-arow",
      code: "NASDAQ:AROW",
      companyName: "Arrow Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arqq",
      code: "NASDAQ:ARQQ",
      companyName: "Arqit Quantum Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-arqqw",
      code: "NASDAQ:ARQQW",
      companyName: "Arqit Quantum Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-arr",
      code: "NASDAQ:ARR",
      companyName: "ARMOUR Residential REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-arrw",
      code: "NASDAQ:ARRW",
      companyName: "Arrowroot Acquisition Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arrww",
      code: "NASDAQ:ARRWW",
      companyName: "Arrowroot Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-arry",
      code: "NASDAQ:ARRY",
      companyName: "Array Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arrwu",
      code: "NASDAQ:ARRWU",
      companyName: "Arrowroot Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-arr-c",
      code: "NASDAQ:ARR-C",
      companyName:
        "ARMOUR Residential REIT Inc. 7% Series C Cumulative Redeemable Preferred Stock (liquidation preference $25.00 per share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-arqt",
      code: "NASDAQ:ARQT",
      companyName: "Arcutis Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arta",
      code: "NASDAQ:ARTA",
      companyName: "Artisan Acquisition Corp. Class A Ordinary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-aroc",
      code: "NASDAQ:AROC",
      companyName: "Archrock Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-armk",
      code: "NASDAQ:ARMK",
      companyName: "Aramark Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arl",
      code: "NASDAQ:ARL",
      companyName: "American Realty Investors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arkr",
      code: "NASDAQ:ARKR",
      companyName: "Ark Restaurants Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-artau",
      code: "NASDAQ:ARTAU",
      companyName: "Artisan Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-artaw",
      code: "NASDAQ:ARTAW",
      companyName: "Artisan Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-artl",
      code: "NASDAQ:ARTL",
      companyName: "Artelo Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-artna",
      code: "NASDAQ:ARTNA",
      companyName: "Artesian Resources Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-artw",
      code: "NASDAQ:ARTW",
      companyName: "Art's-Way Manufacturing Co. Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arvl",
      code: "NASDAQ:ARVL",
      companyName: "Arrival Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-arwr",
      code: "NASDAQ:ARWR",
      companyName: "Arrowhead Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aryd",
      code: "NASDAQ:ARYD",
      companyName: "ARYA Sciences Acquisition Corp IV Class A Odinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-arye",
      code: "NASDAQ:ARYE",
      companyName: "ARYA Sciences Acquisition Corp V Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-asai",
      code: "NASDAQ:ASAI",
      companyName: "Sendas Distribuidora S A ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-asaq",
      code: "NASDAQ:ASAQ",
      companyName: "Atlantic Street Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asax",
      code: "NASDAQ:ASAX",
      companyName: "Astrea Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asan",
      code: "NASDAQ:ASAN",
      companyName: "Asana Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asa",
      code: "NASDAQ:ASA",
      companyName: "ASA  Gold and Precious Metals Limited",
      popularity: 0,
    },
    {
      slug: "nasdaq-asb",
      code: "NASDAQ:ASB",
      companyName: "Associated Banc-Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asb-f",
      code: "NASDAQ:ASB-F",
      companyName:
        "Associated Banc-Corp Depositary Shares each representing a 1/40th interest in a share of Associated Banc-Corp 5.625% Non-Cumulative Perpetual Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nasdaq-asaxw",
      code: "NASDAQ:ASAXW",
      companyName: "Astrea Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-asaxu",
      code: "NASDAQ:ASAXU",
      companyName: "Astrea Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-arw",
      code: "NASDAQ:ARW",
      companyName: "Arrow Electronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arvn",
      code: "NASDAQ:ARVN",
      companyName: "Arvinas Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-arte",
      code: "NASDAQ:ARTE",
      companyName:
        "Artemis Strategic Investment Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-artew",
      code: "NASDAQ:ARTEW",
      companyName: "Artemis Strategic Investment Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-artlw",
      code: "NASDAQ:ARTLW",
      companyName: "Artelo Biosciences Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-atco-d",
      code: "NASDAQ:ATCO-D",
      companyName: "Atlas Corp. 7.95% Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-aten",
      code: "NASDAQ:ATEN",
      companyName: "A10 Networks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asps",
      code: "NASDAQ:ASPS",
      companyName: "Altisource Portfolio Solutions S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aspu",
      code: "NASDAQ:ASPU",
      companyName: "Aspen Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asr",
      code: "NASDAQ:ASR",
      companyName: "Grupo Aeroportuario del Sureste S.A. de C.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asrt",
      code: "NASDAQ:ASRT",
      companyName: "Assertio Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-astc",
      code: "NASDAQ:ASTC",
      companyName: "Astrotech Corporation (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-astl",
      code: "NASDAQ:ASTL",
      companyName: "Algoma Steel Group Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-astlw",
      code: "NASDAQ:ASTLW",
      companyName: "Algoma Steel Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-asts",
      code: "NASDAQ:ASTS",
      companyName: "AST SpaceMobile Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-astsw",
      code: "NASDAQ:ASTSW",
      companyName: "AST SpaceMobile Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-asur",
      code: "NASDAQ:ASUR",
      companyName: "Asure Software Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asx",
      code: "NASDAQ:ASX",
      companyName:
        "ASE Technology Holding Co. Ltd. American Depositary Shares (each representing Two Common Shares) ",
      popularity: 0,
    },
    {
      slug: "nasdaq-asxc",
      code: "NASDAQ:ASXC",
      companyName: "Asensus Surgical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asys",
      code: "NASDAQ:ASYS",
      companyName: "Amtech Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asz",
      code: "NASDAQ:ASZ",
      companyName:
        "Austerlitz Acquisition Corporation II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ata",
      code: "NASDAQ:ATA",
      companyName: "Americas Technology Acquisition Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-atai",
      code: "NASDAQ:ATAI",
      companyName: "ATAI Life Sciences N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-atak",
      code: "NASDAQ:ATAK",
      companyName:
        "Aurora Technology Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-atakr",
      code: "NASDAQ:ATAKR",
      companyName: "Aurora Technology Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-ataku",
      code: "NASDAQ:ATAKU",
      companyName: "Aurora Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-atakw",
      code: "NASDAQ:ATAKW",
      companyName: "Aurora Technology Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-ataq",
      code: "NASDAQ:ATAQ",
      companyName: "Altimar Acquisition Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-atax",
      code: "NASDAQ:ATAX",
      companyName:
        "America First Multifamily Investors L.P. Beneficial Unit Certificates (BUCs) representing Limited Partnership Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-atc",
      code: "NASDAQ:ATC",
      companyName: "Atotech Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-atco",
      code: "NASDAQ:ATCO",
      companyName: "Atlas Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ater",
      code: "NASDAQ:ATER",
      companyName: "Aterian Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atex",
      code: "NASDAQ:ATEX",
      companyName: "Anterix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atge",
      code: "NASDAQ:ATGE",
      companyName: "Adtalem Global Education Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atco-h",
      code: "NASDAQ:ATCO-H",
      companyName: "Atlas Corp. 7.875% Series H",
      popularity: 0,
    },
    {
      slug: "nasdaq-atco-i",
      code: "NASDAQ:ATCO-I",
      companyName: "Atlas Corp. Series I Fixed-to-Floating ",
      popularity: 0,
    },
    {
      slug: "nasdaq-atcol",
      code: "NASDAQ:ATCOL",
      companyName: "Atlas Corp. 7.125% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nasdaq-atcx",
      code: "NASDAQ:ATCX",
      companyName: "Atlas Technical Consultants Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atec",
      code: "NASDAQ:ATEC",
      companyName: "Alphatec Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atek",
      code: "NASDAQ:ATEK",
      companyName:
        "Athena Technology Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asc",
      code: "NASDAQ:ASC",
      companyName: "Ardmore Shipping Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asca",
      code: "NASDAQ:ASCA",
      companyName: "A SPAC I Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ascar",
      code: "NASDAQ:ASCAR",
      companyName: "A SPAC I Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-ascau",
      code: "NASDAQ:ASCAU",
      companyName: "A SPAC I Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-asg",
      code: "NASDAQ:ASG",
      companyName: "Liberty All-Star Growth Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-asix",
      code: "NASDAQ:ASIX",
      companyName: "AdvanSix Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-asle",
      code: "NASDAQ:ASLE",
      companyName: "AerSale Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asln",
      code: "NASDAQ:ASLN",
      companyName: "ASLAN Pharmaceuticals Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-asm",
      code: "NASDAQ:ASM",
      companyName: "Avino Silver & Gold Mines Ltd. Common Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-asmb",
      code: "NASDAQ:ASMB",
      companyName: "Assembly Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asnd",
      code: "NASDAQ:ASND",
      companyName: "Ascendis Pharma A/S American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aso",
      code: "NASDAQ:ASO",
      companyName: "Academy Sports and Outdoors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aspa",
      code: "NASDAQ:ASPA",
      companyName: "ABRI SPAC I INC. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aspaw",
      code: "NASDAQ:ASPAW",
      companyName: "ABRI SPAC I INC. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-aspc",
      code: "NASDAQ:ASPC",
      companyName:
        "Alpha Capital Acquisition Company One Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ascbu",
      code: "NASDAQ:ASCBU",
      companyName: "A SPAC II Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-aspcw",
      code: "NASDAQ:ASPCW",
      companyName: "Alpha Capital Acquisition Company Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-aspcu",
      code: "NASDAQ:ASPCU",
      companyName: "Alpha Capital Acquisition Company Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-aspn",
      code: "NASDAQ:ASPN",
      companyName: "Aspen Aerogels Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aste",
      code: "NASDAQ:ASTE",
      companyName: "Astec Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asrv",
      code: "NASDAQ:ASRV",
      companyName: "AmeriServ Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-astr",
      code: "NASDAQ:ASTR",
      companyName: "Astra Space Inc. Class A Common Stock ",
      popularity: 0,
    },
    {
      slug: "asx-meg",
      code: "ASX:MEG",
      companyName: "Megado Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ath-a",
      code: "NASDAQ:ATH-A",
      companyName:
        "Athene Holding Ltd. Depositary Shares Each Representing a 1/1000th Interest in a 6.35% Fixed-to-Floating Rate Perpetual Non-Cumulative Preference Share Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-ath-c",
      code: "NASDAQ:ATH-C",
      companyName:
        "Athene Holding Ltd. Depositary Shares each representing a 1/1000th Interest in a Share of 6.375% Fixed-Rate Reset Perpetual Non-Cumulative Preference Shares Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-ath-d",
      code: "NASDAQ:ATH-D",
      companyName:
        "Athene Holding Ltd. Depositary Shares Each Representing a 1/1000th Interest in a 4.875% Fixed-Rate Perpetual Non-Cumulative Preference Share Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-atha",
      code: "NASDAQ:ATHA",
      companyName: "Athira Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-athe",
      code: "NASDAQ:ATHE",
      companyName: "Alterity Therapeutics Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-athm",
      code: "NASDAQ:ATHM",
      companyName:
        "Autohome Inc. American Depositary Shares each representing four class A ordinary shares.",
      popularity: 0,
    },
    {
      slug: "nasdaq-athx",
      code: "NASDAQ:ATHX",
      companyName: "Athersys Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ati",
      code: "NASDAQ:ATI",
      companyName: "Allegheny Technologies Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atif",
      code: "NASDAQ:ATIF",
      companyName: "ATIF Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-atip",
      code: "NASDAQ:ATIP",
      companyName: "ATI Physical Therapy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atkr",
      code: "NASDAQ:ATKR",
      companyName: "Atkore Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atlc",
      code: "NASDAQ:ATLC",
      companyName: "Atlanticus Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atlcl",
      code: "NASDAQ:ATLCL",
      companyName:
        "Atlanticus Holdings Corporation 6.125% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-atlcp",
      code: "NASDAQ:ATLCP",
      companyName:
        "Atlanticus Holdings Corporation 7.625% Series B Cumulative Perpetual Preferred Stock no par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-atlo",
      code: "NASDAQ:ATLO",
      companyName: "Ames National Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atnf",
      code: "NASDAQ:ATNF",
      companyName: "180 Life Sciences Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atnfw",
      code: "NASDAQ:ATNFW",
      companyName: "180 Life Sciences Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-atni",
      code: "NASDAQ:ATNI",
      companyName: "ATN International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atnm",
      code: "NASDAQ:ATNM",
      companyName: "Actinium Pharmaceuticals Inc. (Delaware) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atnx",
      code: "NASDAQ:ATNX",
      companyName: "Athenex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ato",
      code: "NASDAQ:ATO",
      companyName: "Atmos Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atom",
      code: "NASDAQ:ATOM",
      companyName: "Atomera Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atos",
      code: "NASDAQ:ATOS",
      companyName: "Atossa Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atr",
      code: "NASDAQ:ATR",
      companyName: "AptarGroup Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atra",
      code: "NASDAQ:ATRA",
      companyName: "Atara Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atrc",
      code: "NASDAQ:ATRC",
      companyName: "AtriCure Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atri",
      code: "NASDAQ:ATRI",
      companyName: "Atrion Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atro",
      code: "NASDAQ:ATRO",
      companyName: "Astronics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atrs",
      code: "NASDAQ:ATRS",
      companyName: "Antares Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atsg",
      code: "NASDAQ:ATSG",
      companyName: "Air Transport Services Group Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-atto",
      code: "NASDAQ:ATTO",
      companyName: "Atento S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-atus",
      code: "NASDAQ:ATUS",
      companyName: "Altice USA Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atvc",
      code: "NASDAQ:ATVC",
      companyName: "Tribe Capital Growth Corp I Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atvcu",
      code: "NASDAQ:ATVCU",
      companyName: "Tribe Capital Growth Corp I Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-atvcw",
      code: "NASDAQ:ATVCW",
      companyName: "Tribe Capital Growth Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-atxi",
      code: "NASDAQ:ATXI",
      companyName: "Avenue Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-atxs",
      code: "NASDAQ:ATXS",
      companyName: "Astria Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aty",
      code: "NASDAQ:ATY",
      companyName: "AcuityAds Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-au",
      code: "NASDAQ:AU",
      companyName: "AngloGold Ashanti Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aub",
      code: "NASDAQ:AUB",
      companyName: "Atlantic Union Bankshares Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aubap",
      code: "NASDAQ:AUBAP",
      companyName:
        "Atlantic Union Bankshares Corporation Depositary Shares each representing a 1/400th ownership interest in a share of 6.875% Perpetual Non-Cumulative Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-aubn",
      code: "NASDAQ:AUBN",
      companyName: "Auburn National Bancorporation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aud",
      code: "NASDAQ:AUD",
      companyName: "Audacy Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-audc",
      code: "NASDAQ:AUDC",
      companyName: "AudioCodes Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-augx",
      code: "NASDAQ:AUGX",
      companyName: "Augmedix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-auid",
      code: "NASDAQ:AUID",
      companyName: "Ipsidy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aumn",
      code: "NASDAQ:AUMN",
      companyName: "Golden Minerals Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-auph",
      code: "NASDAQ:AUPH",
      companyName: "Aurinia Pharmaceuticals Inc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aur",
      code: "NASDAQ:AUR",
      companyName: "Aurora Innovation Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aura",
      code: "NASDAQ:AURA",
      companyName: "Aura Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aurc",
      code: "NASDAQ:AURC",
      companyName: "Aurora Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aurcu",
      code: "NASDAQ:AURCU",
      companyName: "Aurora Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-aurcw",
      code: "NASDAQ:AURCW",
      companyName: "Aurora Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-aurow",
      code: "NASDAQ:AUROW",
      companyName: "Aurora Innovation Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-aus",
      code: "NASDAQ:AUS",
      companyName:
        "Austerlitz Acquisition Corporation I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-qxr",
      code: "ASX:QXR",
      companyName: "QX Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-auud",
      code: "NASDAQ:AUUD",
      companyName: "Auddia Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-auudw",
      code: "NASDAQ:AUUDW",
      companyName: "Auddia Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-auvi",
      code: "NASDAQ:AUVI",
      companyName: "Applied UV Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-auvip",
      code: "NASDAQ:AUVIP",
      companyName:
        "Applied UV Inc. 10.5% Series A Cumulative Perpetual Preferred Stock $0.0001 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-auy",
      code: "NASDAQ:AUY",
      companyName: "Yamana Gold Inc. Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ava",
      code: "NASDAQ:AVA",
      companyName: "Avista Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avac",
      code: "NASDAQ:AVAC",
      companyName: "Avalon Acquisition Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avacu",
      code: "NASDAQ:AVACU",
      companyName: "Avalon Acquisition Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-avacw",
      code: "NASDAQ:AVACW",
      companyName: "Avalon Acquisition Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-avah",
      code: "NASDAQ:AVAH",
      companyName: "Aveanna Healthcare Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aval",
      code: "NASDAQ:AVAL",
      companyName:
        "Grupo Aval Acciones y Valores S.A. ADR (Each representing 20 preferred shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-avan",
      code: "NASDAQ:AVAN",
      companyName: "Avanti Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-avav",
      code: "NASDAQ:AVAV",
      companyName: "AeroVironment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avb",
      code: "NASDAQ:AVB",
      companyName: "AvalonBay Communities Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avco",
      code: "NASDAQ:AVCO",
      companyName: "Avalon GloboCare Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avct",
      code: "NASDAQ:AVCT",
      companyName: "American Virtual Cloud Technologies Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-avctw",
      code: "NASDAQ:AVCTW",
      companyName:
        "American Virtual Cloud Technologies Inc. Warrant expiring 4/7/2025",
      popularity: 0,
    },
    {
      slug: "nasdaq-avd",
      code: "NASDAQ:AVD",
      companyName:
        "American Vanguard Corporation Common Stock ($0.10 Par Value)",
      popularity: 0,
    },
    {
      slug: "nasdaq-avdl",
      code: "NASDAQ:AVDL",
      companyName: "Avadel Pharmaceuticals plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-avdx",
      code: "NASDAQ:AVDX",
      companyName: "AvidXchange Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aveo",
      code: "NASDAQ:AVEO",
      companyName: "AVEO Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avgop",
      code: "NASDAQ:AVGOP",
      companyName:
        "Broadcom Inc. 8.00% Mandatory Convertible Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-avgr",
      code: "NASDAQ:AVGR",
      companyName: "Avinger Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avhiu",
      code: "NASDAQ:AVHIU",
      companyName: "Achari Ventures Holdings Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-avhiw",
      code: "NASDAQ:AVHIW",
      companyName: "Achari Ventures Holdings Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-avid",
      code: "NASDAQ:AVID",
      companyName: "Avid Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avir",
      code: "NASDAQ:AVIR",
      companyName: "Atea Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avk",
      code: "NASDAQ:AVK",
      companyName: "Advent Convertible and Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-avlr",
      code: "NASDAQ:AVLR",
      companyName: "Avalara Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avns",
      code: "NASDAQ:AVNS",
      companyName: "Avanos Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avnt",
      code: "NASDAQ:AVNT",
      companyName: "Avient Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avnw",
      code: "NASDAQ:AVNW",
      companyName: "Aviat Networks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avo",
      code: "NASDAQ:AVO",
      companyName: "Mission Produce Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avpt",
      code: "NASDAQ:AVPT",
      companyName: "AvePoint Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avptw",
      code: "NASDAQ:AVPTW",
      companyName: "AvePoint Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-avro",
      code: "NASDAQ:AVRO",
      companyName: "AVROBIO Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avt",
      code: "NASDAQ:AVT",
      companyName: "Avnet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avte",
      code: "NASDAQ:AVTE",
      companyName: "Aerovate Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avtr",
      code: "NASDAQ:AVTR",
      companyName: "Avantor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avtr-a",
      code: "NASDAQ:AVTR-A",
      companyName:
        "Avantor Inc. Series A Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avtx",
      code: "NASDAQ:AVTX",
      companyName: "Avalo Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avxl",
      code: "NASDAQ:AVXL",
      companyName: "Anavex Life Sciences Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avy",
      code: "NASDAQ:AVY",
      companyName: "Avery Dennison Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-avya",
      code: "NASDAQ:AVYA",
      companyName: "Avaya Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-awf",
      code: "NASDAQ:AWF",
      companyName: "Alliancebernstein Global High Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-awh",
      code: "NASDAQ:AWH",
      companyName: "Aspira Women's Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-awi",
      code: "NASDAQ:AWI",
      companyName: "Armstrong World Industries Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-awk",
      code: "NASDAQ:AWK",
      companyName: "American Water Works Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-awp",
      code: "NASDAQ:AWP",
      companyName:
        "Aberdeen Global Premier Properties Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-awr",
      code: "NASDAQ:AWR",
      companyName: "American States Water Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-awre",
      code: "NASDAQ:AWRE",
      companyName: "Aware Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-awx",
      code: "NASDAQ:AWX",
      companyName: "Avalon Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ax",
      code: "NASDAQ:AX",
      companyName: "Axos Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axac",
      code: "NASDAQ:AXAC",
      companyName:
        "AXIOS Sustainable Growth Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-axl",
      code: "NASDAQ:AXL",
      companyName: "American Axle & Manufacturing Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ti1",
      code: "ASX:TI1",
      companyName: "Tombador Iron Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-axla",
      code: "NASDAQ:AXLA",
      companyName: "Axcella Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axnx",
      code: "NASDAQ:AXNX",
      companyName: "Axonics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axon",
      code: "NASDAQ:AXON",
      companyName: "Axon Enterprise Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axp",
      code: "NASDAQ:AXP",
      companyName: "American Express Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axr",
      code: "NASDAQ:AXR",
      companyName: "AMREP Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axs",
      code: "NASDAQ:AXS",
      companyName: "Axis Capital Holdings Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axs-e",
      code: "NASDAQ:AXS-E",
      companyName:
        "Axis Capital Holdings Limited Depositary Shares each representing 1/100th interest in a share of a 5.50% Series E Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-axsm",
      code: "NASDAQ:AXSM",
      companyName: "Axsome Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axta",
      code: "NASDAQ:AXTA",
      companyName: "Axalta Coating Systems Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-axti",
      code: "NASDAQ:AXTI",
      companyName: "AXT Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axu",
      code: "NASDAQ:AXU",
      companyName: "Alexco Resource Corp Common Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ay",
      code: "NASDAQ:AY",
      companyName: "Atlantica Sustainable Infrastructure plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ayi",
      code: "NASDAQ:AYI",
      companyName: "Acuity Brands Inc. ",
      popularity: 0,
    },
    {
      slug: "nasdaq-ayla",
      code: "NASDAQ:AYLA",
      companyName: "Ayala Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ayro",
      code: "NASDAQ:AYRO",
      companyName: "AYRO Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aytu",
      code: "NASDAQ:AYTU",
      companyName: "Aytu BioPharma Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ayx",
      code: "NASDAQ:AYX",
      companyName: "Alteryx Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-az",
      code: "NASDAQ:AZ",
      companyName: "A2Z Smart Technologies Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-azek",
      code: "NASDAQ:AZEK",
      companyName: "The AZEK Company Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-azn",
      code: "NASDAQ:AZN",
      companyName: "AstraZeneca PLC American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-azo",
      code: "NASDAQ:AZO",
      companyName: "AutoZone Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-azpn",
      code: "NASDAQ:AZPN",
      companyName: "Aspen Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-azre",
      code: "NASDAQ:AZRE",
      companyName: "Azure Power Global Limited Equity Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-azta",
      code: "NASDAQ:AZTA",
      companyName: "Azenta Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-azul",
      code: "NASDAQ:AZUL",
      companyName:
        "Azul S.A. American Depositary Shares (each representing three preferred shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-azyo",
      code: "NASDAQ:AZYO",
      companyName: "Aziyo Biologics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-azz",
      code: "NASDAQ:AZZ",
      companyName: "AZZ Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-b",
      code: "NASDAQ:B",
      companyName: "Barnes Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ba",
      code: "NASDAQ:BA",
      companyName: "Boeing Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac",
      code: "NASDAQ:BAC",
      companyName: "Bank of America Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-b",
      code: "NASDAQ:BAC-B",
      companyName:
        "Bank of America Corporation Depositary Shares each representing a 1/1000th interest in a share of 6.000% Non-Cumulative Preferred Stock Series GG",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-e",
      code: "NASDAQ:BAC-E",
      companyName:
        "Bank of America Corporation Depositary Sh repstg 1/1000th Perp Pfd Ser E",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-k",
      code: "NASDAQ:BAC-K",
      companyName:
        "Bank of America Corporation Depositary Shares each representing a 1/1000th interest in a share of 5.875% Non- Cumulative Preferred Stock Series HH",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-l",
      code: "NASDAQ:BAC-L",
      companyName:
        "Bank of America Corporation Non Cumulative Perpetual Conv Pfd Ser L",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-m",
      code: "NASDAQ:BAC-M",
      companyName:
        "Bank of America Corporation Depositary Shares each representing a 1/1000th interest in a share of 5.375% Non-Cumulative Preferred Stock Series KK",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-n",
      code: "NASDAQ:BAC-N",
      companyName:
        "Bank of America Corporation Depositary shares each representing 1/1000th interest in a share of 5.000% Non-Cumulative Preferred Stock Series LL",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-o",
      code: "NASDAQ:BAC-O",
      companyName:
        "Bank of America Corporation Depositary shares each representing 1/1000th interest in a share of 4.375% Non-Cumulative Preferred Stock Series NN",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-p",
      code: "NASDAQ:BAC-P",
      companyName:
        "Bank of America Corporation Depositary Shares each representing a 1/1000th interest in a share of 4.125% Non-Cumulative Preferred Stock Series PP",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-q",
      code: "NASDAQ:BAC-Q",
      companyName:
        "Bank of America Corporation Depositary shares each representing 1/1000th interest in a share of 4.250% Non-Cumulative Preferred Stock Series QQ",
      popularity: 0,
    },
    {
      slug: "nasdaq-bac-s",
      code: "NASDAQ:BAC-S",
      companyName:
        "Bank of America Corporation Depositary shares each representing 1/1000th interest in a share of 4.750% Non-Cumulative Preferred Stock Series SS",
      popularity: 0,
    },
    {
      slug: "nasdaq-baca",
      code: "NASDAQ:BACA",
      companyName: "Berenson Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bafn",
      code: "NASDAQ:BAFN",
      companyName: "BayFirst Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bah",
      code: "NASDAQ:BAH",
      companyName: "Booz Allen Hamilton Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bak",
      code: "NASDAQ:BAK",
      companyName: "Braskem SA ADR",
      popularity: 0,
    },
    {
      slug: "nasdaq-baly",
      code: "NASDAQ:BALY",
      companyName: "Bally's Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bami",
      code: "NASDAQ:BAMI",
      companyName: "Brookfield Finance Inc. 4.50% Perpetual Subordinated Notes",
      popularity: 0,
    },
    {
      slug: "nasdaq-bamr",
      code: "NASDAQ:BAMR",
      companyName:
        "Brookfield Asset Management Reinsurance Partners Ltd. Class A Exchangeable Limited Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-banc",
      code: "NASDAQ:BANC",
      companyName: "Banc of California Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-banf",
      code: "NASDAQ:BANF",
      companyName: "BancFirst Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-band",
      code: "NASDAQ:BAND",
      companyName: "Bandwidth Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bam",
      code: "NASDAQ:BAM",
      companyName: "Brookfield Asset Management Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-banfp",
      code: "NASDAQ:BANFP",
      companyName:
        "BancFirst Corporation - BFC Capital Trust II Cumulative Trust Preferred Securities",
      popularity: 0,
    },
    {
      slug: "nasdaq-bch",
      code: "NASDAQ:BCH",
      companyName: "Banco De Chile Banco De Chile ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-banr",
      code: "NASDAQ:BANR",
      companyName: "Banner Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-banx",
      code: "NASDAQ:BANX",
      companyName: "ArrowMark Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-baos",
      code: "NASDAQ:BAOS",
      companyName: "Baosheng Media Group Holdings Limited Ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bap",
      code: "NASDAQ:BAP",
      companyName: "Credicorp Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bark",
      code: "NASDAQ:BARK",
      companyName: "BARK Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-base",
      code: "NASDAQ:BASE",
      companyName: "Couchbase Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-batl",
      code: "NASDAQ:BATL",
      companyName: "Battalion Oil Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-batra",
      code: "NASDAQ:BATRA",
      companyName:
        "Liberty Media Corporation Series A Liberty Braves Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-batrk",
      code: "NASDAQ:BATRK",
      companyName:
        "Liberty Media Corporation Series C Liberty Braves Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bax",
      code: "NASDAQ:BAX",
      companyName: "Baxter International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bb",
      code: "NASDAQ:BB",
      companyName: "BlackBerry Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbai",
      code: "NASDAQ:BBAI",
      companyName: "BigBear.ai Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbar",
      code: "NASDAQ:BBAR",
      companyName: "Banco BBVA Argentina S.A. ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbby",
      code: "NASDAQ:BBBY",
      companyName: "Bed Bath & Beyond Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbcp",
      code: "NASDAQ:BBCP",
      companyName: "Concrete Pumping Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbd",
      code: "NASDAQ:BBD",
      companyName: "Banco Bradesco Sa American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbdc",
      code: "NASDAQ:BBDC",
      companyName: "Barings BDC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbdo",
      code: "NASDAQ:BBDO",
      companyName:
        "Banco Bradesco Sa American Depositary Shares (each representing one Common Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbgi",
      code: "NASDAQ:BBGI",
      companyName: "Beasley Broadcast Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbi",
      code: "NASDAQ:BBI",
      companyName: "Brickell Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbig",
      code: "NASDAQ:BBIG",
      companyName: "Vinco Ventures Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbio",
      code: "NASDAQ:BBIO",
      companyName: "BridgeBio Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bblg",
      code: "NASDAQ:BBLG",
      companyName: "Bone Biologics Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bblgw",
      code: "NASDAQ:BBLGW",
      companyName: "Bone Biologics Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbln",
      code: "NASDAQ:BBLN",
      companyName: "Babylon Holdings Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbn",
      code: "NASDAQ:BBN",
      companyName:
        "BlackRock Taxable Municipal Bond Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbq",
      code: "NASDAQ:BBQ",
      companyName: "BBQ Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbsi",
      code: "NASDAQ:BBSI",
      companyName: "Barrett Business Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbu",
      code: "NASDAQ:BBU",
      companyName:
        "Brookfield Business Partners L.P. Limited Partnership Units ",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbuc",
      code: "NASDAQ:BBUC",
      companyName:
        "Brookfield Business Corporation Class A Exchangeable Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbva",
      code: "NASDAQ:BBVA",
      companyName: "Banco Bilbao Vizcaya Argentaria S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbw",
      code: "NASDAQ:BBW",
      companyName: "Build-A-Bear Workshop Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bbwi",
      code: "NASDAQ:BBWI",
      companyName: "Bath & Body Works Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-bby",
      code: "NASDAQ:BBY",
      companyName: "Best Buy Co. Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bc",
      code: "NASDAQ:BC",
      companyName: "Brunswick Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bc-b",
      code: "NASDAQ:BC-B",
      companyName: "Brunswick Corporation 6.625% Senior Notes due 2049",
      popularity: 0,
    },
    {
      slug: "nasdaq-bc-c",
      code: "NASDAQ:BC-C",
      companyName: "Brunswick Corporation 6.375% Notes due 2049",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcab",
      code: "NASDAQ:BCAB",
      companyName: "BioAtla Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcac",
      code: "NASDAQ:BCAC",
      companyName: "Brookline Capital Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcacu",
      code: "NASDAQ:BCACU",
      companyName: "Brookline Capital Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcacw",
      code: "NASDAQ:BCACW",
      companyName: "Brookline Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcat",
      code: "NASDAQ:BCAT",
      companyName:
        "BlackRock Capital Allocation Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcbp",
      code: "NASDAQ:BCBP",
      companyName: "BCB Bancorp Inc. (NJ) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcc",
      code: "NASDAQ:BCC",
      companyName: "Boise Cascade L.L.C. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcda",
      code: "NASDAQ:BCDA",
      companyName: "BioCardia Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bce",
      code: "NASDAQ:BCE",
      companyName: "BCE Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcel",
      code: "NASDAQ:BCEL",
      companyName: "Atreca Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcli",
      code: "NASDAQ:BCLI",
      companyName: "Brainstorm Cell Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcml",
      code: "NASDAQ:BCML",
      companyName: "BayCom Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bco",
      code: "NASDAQ:BCO",
      companyName: "Brinks Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcov",
      code: "NASDAQ:BCOV",
      companyName: "Brightcove Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcow",
      code: "NASDAQ:BCOW",
      companyName: "1895 Bancorp of Wisconsin Inc. (MD) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcpc",
      code: "NASDAQ:BCPC",
      companyName: "Balchem Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcrx",
      code: "NASDAQ:BCRX",
      companyName: "BioCryst Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcs",
      code: "NASDAQ:BCS",
      companyName: "Barclays PLC Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcsa",
      code: "NASDAQ:BCSA",
      companyName:
        "Blockchain Coinvestors Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "asx-dex",
      code: "ASX:DEX",
      companyName: "DUKE EXPLORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-be",
      code: "NASDAQ:BE",
      companyName: "Bloom Energy Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-beneu",
      code: "NASDAQ:BENEU",
      companyName: "Benessere Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcsau",
      code: "NASDAQ:BCSAU",
      companyName: "Blockchain Coinvestors Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcsaw",
      code: "NASDAQ:BCSAW",
      companyName: "Blockchain Coinvestors Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcsf",
      code: "NASDAQ:BCSF",
      companyName: "Bain Capital Specialty Finance Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bctx",
      code: "NASDAQ:BCTX",
      companyName: "BriaCell Therapeutics Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bctxw",
      code: "NASDAQ:BCTXW",
      companyName: "BriaCell Therapeutics Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcv",
      code: "NASDAQ:BCV",
      companyName: "Bancroft Fund Ltd.",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcv-a",
      code: "NASDAQ:BCV-A",
      companyName:
        "Bancroft Fund Limited 5.375% Series A Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcx",
      code: "NASDAQ:BCX",
      companyName: "BlackRock Resources Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcyc",
      code: "NASDAQ:BCYC",
      companyName: "Bicycle Therapeutics plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bdc",
      code: "NASDAQ:BDC",
      companyName: "Belden Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bdj",
      code: "NASDAQ:BDJ",
      companyName: "Blackrock Enhanced Equity Dividend Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bdl",
      code: "NASDAQ:BDL",
      companyName: "Flanigan's Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bdn",
      code: "NASDAQ:BDN",
      companyName: "Brandywine Realty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bdr",
      code: "NASDAQ:BDR",
      companyName: "Blonder Tongue Laboratories Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bdsx",
      code: "NASDAQ:BDSX",
      companyName: "Biodesix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bdx",
      code: "NASDAQ:BDX",
      companyName: "Becton Dickinson and Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bdxb",
      code: "NASDAQ:BDXB",
      companyName:
        "Becton Dickinson and Company Depositary Shares each Representing a 1/20th Interest in a Share of 6.00% Mandatory Convertible Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-beat",
      code: "NASDAQ:BEAT",
      companyName: "Heartbeam Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-beatw",
      code: "NASDAQ:BEATW",
      companyName: "Heartbeam Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-becn",
      code: "NASDAQ:BECN",
      companyName: "Beacon Roofing Supply Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bedu",
      code: "NASDAQ:BEDU",
      companyName:
        "Bright Scholar Education Holdings Limited American Depositary Shares each  representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-beem",
      code: "NASDAQ:BEEM",
      companyName: "Beam Global Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-beemw",
      code: "NASDAQ:BEEMW",
      companyName: "Beam Global Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-beke",
      code: "NASDAQ:BEKE",
      companyName:
        "KE Holdings Inc American Depositary Shares (each representing three Class A Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-belfa",
      code: "NASDAQ:BELFA",
      companyName: "Bel Fuse Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-belfb",
      code: "NASDAQ:BELFB",
      companyName: "Bel Fuse Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bene",
      code: "NASDAQ:BENE",
      companyName: "Benessere Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bener",
      code: "NASDAQ:BENER",
      companyName: "Benessere Capital Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-benew",
      code: "NASDAQ:BENEW",
      companyName: "Benessere Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bep",
      code: "NASDAQ:BEP",
      companyName: "Brookfield Renewable Partners L.P. ",
      popularity: 0,
    },
    {
      slug: "nasdaq-bep-a",
      code: "NASDAQ:BEP-A",
      companyName:
        "Brookfield Renewable Partners L.P. 5.25% Class A Preferred Limited Partnership Units Series 17",
      popularity: 0,
    },
    {
      slug: "nasdaq-bepc",
      code: "NASDAQ:BEPC",
      companyName:
        "Brookfield Renewable Corporation Class A Subordinate Voting Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-beph",
      code: "NASDAQ:BEPH",
      companyName:
        "Brookfield BRP Holdings (Canada) Inc. 4.625% Perpetual Subordinated Notes",
      popularity: 0,
    },
    {
      slug: "nasdaq-bepi",
      code: "NASDAQ:BEPI",
      companyName:
        "Brookfield BRP Holdings (Canada) Inc. 4.875% Perpetual Subordinated Notes",
      popularity: 0,
    },
    {
      slug: "nasdaq-bery",
      code: "NASDAQ:BERY",
      companyName: "Berry Global Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-best",
      code: "NASDAQ:BEST",
      companyName:
        "BEST Inc. American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-bf/a",
      code: "NASDAQ:BF/A",
      companyName: "Brown Forman Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-bf/b",
      code: "NASDAQ:BF/B",
      companyName: "Brown Forman Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfac",
      code: "NASDAQ:BFAC",
      companyName: "Battery Future Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfam",
      code: "NASDAQ:BFAM",
      companyName: "Bright Horizons Family Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfc",
      code: "NASDAQ:BFC",
      companyName: "Bank First Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfh",
      code: "NASDAQ:BFH",
      companyName: "Bread Financial Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfi",
      code: "NASDAQ:BFI",
      companyName: "BurgerFi International Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfiiw",
      code: "NASDAQ:BFIIW",
      companyName: "BurgerFi International Inc. Warrant ",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfin",
      code: "NASDAQ:BFIN",
      companyName: "BankFinancial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfk",
      code: "NASDAQ:BFK",
      companyName: "BlackRock Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfly",
      code: "NASDAQ:BFLY",
      companyName: "Butterfly Network Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfri",
      code: "NASDAQ:BFRI",
      companyName: "Biofrontera Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfs-d",
      code: "NASDAQ:BFS-D",
      companyName:
        "Saul Centers Inc. Depositary Shares each representing 1/100th of a share of 6.125% Series D Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bdtx",
      code: "NASDAQ:BDTX",
      companyName: "Black Diamond Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-dou",
      code: "ASX:DOU",
      companyName: "Douugh Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iou",
      code: "ASX:IOU",
      companyName: "Ioupay Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhp",
      code: "NASDAQ:BHP",
      companyName:
        "BHP Group Limited American Depositary Shares (Each representing two Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfs-e",
      code: "NASDAQ:BFS-E",
      companyName:
        "Saul Centers Inc. Depositary shares each representing a 1/100th fractional interest in a share of 6.000% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfz",
      code: "NASDAQ:BFZ",
      companyName: "BlackRock California Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bg",
      code: "NASDAQ:BG",
      companyName: "Bunge Limited Bunge Limited",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhc",
      code: "NASDAQ:BHC",
      companyName: "Bausch Health Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gs",
      code: "NYSE:GS",
      companyName: "Goldman Sachs Group Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgb",
      code: "NASDAQ:BGB",
      companyName: "Blackstone Strategic Credit Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgcp",
      code: "NASDAQ:BGCP",
      companyName: "BGC Partners Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgfv",
      code: "NASDAQ:BGFV",
      companyName: "Big 5 Sporting Goods Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgh",
      code: "NASDAQ:BGH",
      companyName:
        "Barings Global Short Duration High Yield Fund Common Shares of Beneficial Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgi",
      code: "NASDAQ:BGI",
      companyName: "Birks Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgne",
      code: "NASDAQ:BGNE",
      companyName: "BeiGene Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgr",
      code: "NASDAQ:BGR",
      companyName: "BlackRock Energy and Resources Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgry",
      code: "NASDAQ:BGRY",
      companyName: "Berkshire Grey Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgryw",
      code: "NASDAQ:BGRYW",
      companyName: "Berkshire Grey Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgs",
      code: "NASDAQ:BGS",
      companyName: "B&G Foods Inc. B&G Foods Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgsf",
      code: "NASDAQ:BGSF",
      companyName: "BGSF Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgsx",
      code: "NASDAQ:BGSX",
      companyName: "Build Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgt",
      code: "NASDAQ:BGT",
      companyName: "BlackRock Floating Rate Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgx",
      code: "NASDAQ:BGX",
      companyName: "Blackstone Long Short Credit Income Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bgy",
      code: "NASDAQ:BGY",
      companyName: "Blackrock Enhanced International Dividend Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bh",
      code: "NASDAQ:BH",
      companyName: "Biglari Holdings Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhac",
      code: "NASDAQ:BHAC",
      companyName: "Crixus BH3 Acquisition Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhacu",
      code: "NASDAQ:BHACU",
      companyName: "Crixus BH3 Acquisition Company Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhat",
      code: "NASDAQ:BHAT",
      companyName:
        "Blue Hat Interactive Entertainment Technology Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhb",
      code: "NASDAQ:BHB",
      companyName: "Bar Harbor Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhe",
      code: "NASDAQ:BHE",
      companyName: "Benchmark Electronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhf",
      code: "NASDAQ:BHF",
      companyName: "Brighthouse Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhfal",
      code: "NASDAQ:BHFAL",
      companyName:
        "Brighthouse Financial Inc. 6.25% Junior Subordinated Debentures due 2058",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhfam",
      code: "NASDAQ:BHFAM",
      companyName:
        "Brighthouse Financial Inc. Depositary shares each representing a 1/1000th Interest in a Share of 4.625% Non-Cumulative Preferred Stock Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhfan",
      code: "NASDAQ:BHFAN",
      companyName:
        "Brighthouse Financial Inc. Depositary shares each representing a 1/1000th interest in a share of 5.375% Non-Cumulative Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhfao",
      code: "NASDAQ:BHFAO",
      companyName:
        "Brighthouse Financial Inc. Depositary Shares 6.75% Non-Cumulative Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhfap",
      code: "NASDAQ:BHFAP",
      companyName:
        "Brighthouse Financial Inc. Depositary Shares 6.6% Non-Cumulative Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhg",
      code: "NASDAQ:BHG",
      companyName: "Bright Health Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhil",
      code: "NASDAQ:BHIL",
      companyName: "Benson Hill Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhlb",
      code: "NASDAQ:BHLB",
      companyName: "Berkshire Hills Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhr",
      code: "NASDAQ:BHR",
      companyName: "Braemar Hotels & Resorts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhr-b",
      code: "NASDAQ:BHR-B",
      companyName:
        "Braemar Hotels & Resorts Inc. 5.50% Series B Cumulative Convertible Preferred Stock par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhr-d",
      code: "NASDAQ:BHR-D",
      companyName:
        "Braemar Hotels & Resorts Inc. 8.25% Series D Cumulative Preferred Stock  par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhse",
      code: "NASDAQ:BHSE",
      companyName: "Bull Horn Holdings Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhseu",
      code: "NASDAQ:BHSEU",
      companyName: "Bull Horn Holdings Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhsew",
      code: "NASDAQ:BHSEW",
      companyName: "Bull Horn Holdings Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhv",
      code: "NASDAQ:BHV",
      companyName: "BlackRock Virginia Municipal Bond Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhvn",
      code: "NASDAQ:BHVN",
      companyName: "Biohaven Pharmaceutical Holding Company Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-big",
      code: "NASDAQ:BIG",
      companyName: "Big Lots Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bigc",
      code: "NASDAQ:BIGC",
      companyName: "BigCommerce Holdings Inc. Series 1 Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bigz",
      code: "NASDAQ:BIGZ",
      companyName:
        "BlackRock Innovation and Growth Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bill",
      code: "NASDAQ:BILL",
      companyName: "Bill.com Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bhk",
      code: "NASDAQ:BHK",
      companyName: "Blackrock Core Bond Trust Blackrock Core Bond Trust",
      popularity: 0,
    },
    {
      slug: "asx-tcf",
      code: "ASX:TCF",
      companyName: "360 Capital Mortgage REIT",
      popularity: 0,
    },
    {
      slug: "asx-mr1",
      code: "ASX:MR1",
      companyName: "MONTEM RESOURCES LIMITED.",
      popularity: 0,
    },
    {
      slug: "nasdaq-bimi",
      code: "NASDAQ:BIMI",
      companyName: "BIMI International Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bio",
      code: "NASDAQ:BIO",
      companyName: "Bio-Rad Laboratories Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bki",
      code: "NASDAQ:BKI",
      companyName: "Black Knight Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-bioc",
      code: "NASDAQ:BIOC",
      companyName: "Biocept Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-biol",
      code: "NASDAQ:BIOL",
      companyName: "Biolase Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bios",
      code: "NASDAQ:BIOS",
      companyName: "BioPlus Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-biosw",
      code: "NASDAQ:BIOSW",
      companyName: "BioPlus Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-biot",
      code: "NASDAQ:BIOT",
      companyName: "Biotech Acquisition Company Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-biotu",
      code: "NASDAQ:BIOTU",
      companyName: "Biotech Acquisition Company Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-biotw",
      code: "NASDAQ:BIOTW",
      companyName: "Biotech Acquisition Company Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-biox",
      code: "NASDAQ:BIOX",
      companyName: "Bioceres Crop Solutions Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bip",
      code: "NASDAQ:BIP",
      companyName:
        "Brookfield Infrastructure Partners LP Limited Partnership Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-bip-a",
      code: "NASDAQ:BIP-A",
      companyName:
        "Brookfield Infrastructure Partners LP 5.125% Class A Preferred Limited Partnership Units Series 13",
      popularity: 0,
    },
    {
      slug: "nasdaq-bip-b",
      code: "NASDAQ:BIP-B",
      companyName:
        "Brookfield Infrastructure Partners LP 5.000% Class A Preferred Limited Partnership Units Series 14",
      popularity: 0,
    },
    {
      slug: "nasdaq-bipc",
      code: "NASDAQ:BIPC",
      companyName:
        "Brookfield Infrastructure Partners LP Class A Subordinate Voting Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-biph",
      code: "NASDAQ:BIPH",
      companyName:
        "Brookfield Infrastructure Corporation 5.000% Subordinated Notes due 2081",
      popularity: 0,
    },
    {
      slug: "nasdaq-bipi",
      code: "NASDAQ:BIPI",
      companyName:
        "BIP Bermuda Holdings I Limited 5.125% Perpetual Subordinated Notes",
      popularity: 0,
    },
    {
      slug: "nasdaq-bird",
      code: "NASDAQ:BIRD",
      companyName: "Allbirds Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bit",
      code: "NASDAQ:BIT",
      companyName:
        "BlackRock Multi-Sector Income Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bite",
      code: "NASDAQ:BITE",
      companyName: "Bite Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bitf",
      code: "NASDAQ:BITF",
      companyName: "Bitfarms Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bivi",
      code: "NASDAQ:BIVI",
      companyName: "BioVie Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bj",
      code: "NASDAQ:BJ",
      companyName: "BJ's Wholesale Club Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bjdx",
      code: "NASDAQ:BJDX",
      companyName: "Bluejay Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bjri",
      code: "NASDAQ:BJRI",
      companyName: "BJ's Restaurants Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bk",
      code: "NASDAQ:BK",
      companyName: "The Bank of New York Mellon Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkcc",
      code: "NASDAQ:BKCC",
      companyName: "BlackRock Capital Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkd",
      code: "NASDAQ:BKD",
      companyName: "Brookdale Senior Living Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bke",
      code: "NASDAQ:BKE",
      companyName: "Buckle Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkep",
      code: "NASDAQ:BKEP",
      companyName: "Blueknight Energy Partners L.P. Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkepp",
      code: "NASDAQ:BKEPP",
      companyName: "Blueknight Energy Partners L.P. Series A Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkh",
      code: "NASDAQ:BKH",
      companyName: "Black Hills Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkkt",
      code: "NASDAQ:BKKT",
      companyName: "Bakkt Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkn",
      code: "NASDAQ:BKN",
      companyName: "BlackRock Investment Quality Municipal Trust Inc. (The)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bksc",
      code: "NASDAQ:BKSC",
      companyName: "Bank of South Carolina Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bksy",
      code: "NASDAQ:BKSY",
      companyName: "BlackSky Technology Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkt",
      code: "NASDAQ:BKT",
      companyName: "BlackRock Income Trust Inc. (The)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkti",
      code: "NASDAQ:BKTI",
      companyName: "BK Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bku",
      code: "NASDAQ:BKU",
      companyName: "BankUnited Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkyi",
      code: "NASDAQ:BKYI",
      companyName: "BIO-key International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bl",
      code: "NASDAQ:BL",
      companyName: "BlackLine Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blbd",
      code: "NASDAQ:BLBD",
      companyName: "Blue Bird Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blbx",
      code: "NASDAQ:BLBX",
      companyName: "Blackboxstocks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blcm",
      code: "NASDAQ:BLCM",
      companyName: "Bellicum Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blco",
      code: "NASDAQ:BLCO",
      companyName: "Bausch + Lomb Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-blct",
      code: "NASDAQ:BLCT",
      companyName: "BlueCity Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkr",
      code: "NASDAQ:BKR",
      companyName: "Baker Hughes Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blde",
      code: "NASDAQ:BLDE",
      companyName: "Blade Air Mobility Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bldew",
      code: "NASDAQ:BLDEW",
      companyName: "Blade Air Mobility Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-bldp",
      code: "NASDAQ:BLDP",
      companyName: "Ballard Power Systems Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bldr",
      code: "NASDAQ:BLDR",
      companyName: "Builders FirstSource Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ble",
      code: "NASDAQ:BLE",
      companyName: "BlackRock Municipal Income Trust II",
      popularity: 0,
    },
    {
      slug: "nasdaq-bleu",
      code: "NASDAQ:BLEU",
      companyName: "bleuacacia ltd Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bleur",
      code: "NASDAQ:BLEUR",
      companyName: "bleuacacia ltd Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-bleuu",
      code: "NASDAQ:BLEUU",
      companyName: "bleuacacia ltd Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bleuw",
      code: "NASDAQ:BLEUW",
      companyName: "bleuacacia ltd Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-blfs",
      code: "NASDAQ:BLFS",
      companyName: "BioLife Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blk",
      code: "NASDAQ:BLK",
      companyName: "BlackRock Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blkb",
      code: "NASDAQ:BLKB",
      companyName: "Blackbaud Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-tem",
      code: "ASX:TEM",
      companyName: "Tempest Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-bll",
      code: "NASDAQ:BLL",
      companyName: "Ball Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blmn",
      code: "NASDAQ:BLMN",
      companyName: "Bloomin' Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blnd",
      code: "NASDAQ:BLND",
      companyName: "Blend Labs Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blng",
      code: "NASDAQ:BLNG",
      companyName: "Belong Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blngu",
      code: "NASDAQ:BLNGU",
      companyName: "Belong Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-blngw",
      code: "NASDAQ:BLNGW",
      companyName: "Belong Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-blnk",
      code: "NASDAQ:BLNK",
      companyName: "Blink Charging Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blnkw",
      code: "NASDAQ:BLNKW",
      companyName: "Blink Charging Co. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-blph",
      code: "NASDAQ:BLPH",
      companyName: "Bellerophon Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blrx",
      code: "NASDAQ:BLRX",
      companyName: "BioLineRx Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-blsa",
      code: "NASDAQ:BLSA",
      companyName: "BCLS Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-blte",
      code: "NASDAQ:BLTE",
      companyName: "Belite Bio Inc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-blts",
      code: "NASDAQ:BLTS",
      companyName: "Bright Lights Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bltsu",
      code: "NASDAQ:BLTSU",
      companyName: "Bright Lights Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bltsw",
      code: "NASDAQ:BLTSW",
      companyName: "Bright Lights Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-blu",
      code: "NASDAQ:BLU",
      companyName: "BELLUS Health Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-blua",
      code: "NASDAQ:BLUA",
      companyName: "BlueRiver Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-blue",
      code: "NASDAQ:BLUE",
      companyName: "bluebird bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blw",
      code: "NASDAQ:BLW",
      companyName: "Blackrock Limited Duration Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-blx",
      code: "NASDAQ:BLX",
      companyName: "Banco Latinoamericano de Comercio Exterior S.A.",
      popularity: 0,
    },
    {
      slug: "nasdaq-blze",
      code: "NASDAQ:BLZE",
      companyName: "Backblaze Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bma",
      code: "NASDAQ:BMA",
      companyName:
        "Banco Macro S.A.  ADR (representing Ten Class B Common Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmac",
      code: "NASDAQ:BMAC",
      companyName: "Black Mountain Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmaq",
      code: "NASDAQ:BMAQ",
      companyName: "Blockchain Moon Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmaqr",
      code: "NASDAQ:BMAQR",
      companyName: "Blockchain Moon Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmaqu",
      code: "NASDAQ:BMAQU",
      companyName: "Blockchain Moon Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmaqw",
      code: "NASDAQ:BMAQW",
      companyName: "Blockchain Moon Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmbl",
      code: "NASDAQ:BMBL",
      companyName: "Bumble Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bme",
      code: "NASDAQ:BME",
      companyName: "Blackrock Health Sciences Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmea",
      code: "NASDAQ:BMEA",
      companyName: "Biomea Fusion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmez",
      code: "NASDAQ:BMEZ",
      companyName:
        "BlackRock Health Sciences Trust II Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmi",
      code: "NASDAQ:BMI",
      companyName: "Badger Meter Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bml-g",
      code: "NASDAQ:BML-G",
      companyName:
        "Bank of America Corporation Bank of America Corporation Depositary Shares (Each representing a 1/1200th interest in a share of Floating Rate Non-Cumulative Preferred Stock  Series 1)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bml-h",
      code: "NASDAQ:BML-H",
      companyName:
        "Bank of America Corporation Bank of America Corporation Depositary Shares (Each representing a 1/1200th interest in a Share of Floating Rate Non-Cumulative Preferred Stock Series 2)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bml-j",
      code: "NASDAQ:BML-J",
      companyName:
        "Bank of America Corporation Bank of America Corporation Depositary Shares (Each representing a 1/1200th interest in a Share of Floating Rate Non-Cumulative Preferred Stock Series 4)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bml-l",
      code: "NASDAQ:BML-L",
      companyName:
        "Bank of America Corporation Bank of America Corporation Depositary Shares (Each representing a 1/1200th Interest in a Share of Floating Rate Non-Cumulative Preferred Stock Series 5)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmo",
      code: "NASDAQ:BMO",
      companyName: "Bank Of Montreal Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmra",
      code: "NASDAQ:BMRA",
      companyName: "Biomerica Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmrc",
      code: "NASDAQ:BMRC",
      companyName: "Bank of Marin Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmrn",
      code: "NASDAQ:BMRN",
      companyName: "BioMarin Pharmaceutical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmtx",
      code: "NASDAQ:BMTX",
      companyName: "BM Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bmy",
      code: "NASDAQ:BMY",
      companyName: "Bristol-Myers Squibb Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bned",
      code: "NASDAQ:BNED",
      companyName: "Barnes & Noble Education Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnft",
      code: "NASDAQ:BNFT",
      companyName: "Benefitfocus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bngo",
      code: "NASDAQ:BNGO",
      companyName: "Bionano Genomics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bngow",
      code: "NASDAQ:BNGOW",
      companyName: "Bionano Genomics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnix",
      code: "NASDAQ:BNIX",
      companyName: "Bannix Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnixw",
      code: "NASDAQ:BNIXW",
      companyName: "Bannix Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnl",
      code: "NASDAQ:BNL",
      companyName: "Broadstone Net Lease Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnnrw",
      code: "NASDAQ:BNNRW",
      companyName: "Banner Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnox",
      code: "NASDAQ:BNOX",
      companyName: "Bionomics Limited American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnr",
      code: "NASDAQ:BNR",
      companyName: "Burning Rock Biotech Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bns",
      code: "NASDAQ:BNS",
      companyName: "Bank Nova Scotia Halifax Pfd 3 Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnso",
      code: "NASDAQ:BNSO",
      companyName: "Bonso Electronics International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bntc",
      code: "NASDAQ:BNTC",
      companyName: "Benitec Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bny",
      code: "NASDAQ:BNY",
      companyName: "BlackRock New York Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-boac",
      code: "NASDAQ:BOAC",
      companyName:
        "Bluescape Opportunities Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-boas",
      code: "NASDAQ:BOAS",
      companyName: "BOA Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-boc",
      code: "NASDAQ:BOC",
      companyName: "Boston Omaha Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bocn",
      code: "NASDAQ:BOCN",
      companyName: "Blue Ocean Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bocnw",
      code: "NASDAQ:BOCNW",
      companyName: "Blue Ocean Acquisition Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-body",
      code: "NASDAQ:BODY",
      companyName: "The Beachbody Company Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-boe",
      code: "NASDAQ:BOE",
      companyName:
        "Blackrock Enhanced Global Dividend Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-boh",
      code: "NASDAQ:BOH",
      companyName: "Bank of Hawaii Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-boh-a",
      code: "NASDAQ:BOH-A",
      companyName:
        "Bank of Hawaii Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of 4.375% Fixed Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-bokf",
      code: "NASDAQ:BOKF",
      companyName: "BOK Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bolt",
      code: "NASDAQ:BOLT",
      companyName: "Bolt Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bon",
      code: "NASDAQ:BON",
      companyName: "Bon Natural Life Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-boom",
      code: "NASDAQ:BOOM",
      companyName: "DMC Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-boot",
      code: "NASDAQ:BOOT",
      companyName: "Boot Barn Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-borr",
      code: "NASDAQ:BORR",
      companyName: "Borr Drilling Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bosc",
      code: "NASDAQ:BOSC",
      companyName: "B.O.S. Better Online Solutions Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-botj",
      code: "NASDAQ:BOTJ",
      companyName: "Bank of the James Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bowl",
      code: "NASDAQ:BOWL",
      companyName: "Bowlero Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-box",
      code: "NASDAQ:BOX",
      companyName: "Box Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-boxd",
      code: "NASDAQ:BOXD",
      companyName: "Boxed Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-boxl",
      code: "NASDAQ:BOXL",
      companyName: "Boxlight Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpac",
      code: "NASDAQ:BPAC",
      companyName: "Bullpen Parlay Acquisition Company Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpacu",
      code: "NASDAQ:BPACU",
      companyName: "Bullpen Parlay Acquisition Company Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpacw",
      code: "NASDAQ:BPACW",
      companyName: "Bullpen Parlay Acquisition Company Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpmc",
      code: "NASDAQ:BPMC",
      companyName: "Blueprint Medicines Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpop",
      code: "NASDAQ:BPOP",
      companyName: "Popular Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpopm",
      code: "NASDAQ:BPOPM",
      companyName:
        "Popular Inc. Popular Capital Trust II - 6.125% Cumulative Monthly Income Trust Preferred Securities",
      popularity: 0,
    },
    {
      slug: "nasdaq-bprn",
      code: "NASDAQ:BPRN",
      companyName: "The Bank of Princeton Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpt",
      code: "NASDAQ:BPT",
      companyName: "BP Prudhoe Bay Royalty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpth",
      code: "NASDAQ:BPTH",
      companyName: "Bio-Path Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpts",
      code: "NASDAQ:BPTS",
      companyName: "Biophytis SA American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpypm",
      code: "NASDAQ:BPYPM",
      companyName:
        "Brookfield Property Partners L.P. 6.25% Class A Cumulative Redeemable Preferred Units Series 1",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpypn",
      code: "NASDAQ:BPYPN",
      companyName:
        "Brookfield Property Partners L.P. 5.750% Class A Cumulative Redeemable Perpetual Preferred Units Series 3",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpypo",
      code: "NASDAQ:BPYPO",
      companyName:
        "Brookfield Property Partners L.P. 6.375% Class A Cumulative Redeemable Perpetual Preferred Units Series 2",
      popularity: 0,
    },
    {
      slug: "nasdaq-bpypp",
      code: "NASDAQ:BPYPP",
      companyName:
        "Brookfield Property Partners L.P. 6.50% Class A Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-bq",
      code: "NASDAQ:BQ",
      companyName:
        "Boqii Holding Limited American Depositary Shares representing Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-br",
      code: "NASDAQ:BR",
      companyName: "Broadridge Financial Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bracr",
      code: "NASDAQ:BRACR",
      companyName: "Broad Capital Acquisition Corp Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-brag",
      code: "NASDAQ:BRAG",
      companyName: "Bragg Gaming Group Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-brbr",
      code: "NASDAQ:BRBR",
      companyName: "BellRing Brands Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-brbs",
      code: "NASDAQ:BRBS",
      companyName: "Blue Ridge Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brc",
      code: "NASDAQ:BRC",
      companyName: "Brady Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brcc",
      code: "NASDAQ:BRCC",
      companyName: "BRC Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brcn",
      code: "NASDAQ:BRCN",
      companyName: "Burcon NutraScience Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brd",
      code: "NASDAQ:BRD",
      companyName:
        "Beard Energy Transition Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brdg",
      code: "NASDAQ:BRDG",
      companyName: "Bridge Investment Group Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brds",
      code: "NASDAQ:BRDS",
      companyName: "Bird Global Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brez",
      code: "NASDAQ:BREZ",
      companyName: "Breeze Holdings Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brezr",
      code: "NASDAQ:BREZR",
      companyName: "Breeze Holdings Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-brezw",
      code: "NASDAQ:BREZW",
      companyName: "Breeze Holdings Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-brfh",
      code: "NASDAQ:BRFH",
      companyName: "Barfresh Food Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brfs",
      code: "NASDAQ:BRFS",
      companyName: "BRF S.A.",
      popularity: 0,
    },
    {
      slug: "nasdaq-brg",
      code: "NASDAQ:BRG",
      companyName: "Bluerock Residential Growth REIT Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brg-c",
      code: "NASDAQ:BRG-C",
      companyName:
        "Bluerock Residential Growth REIT Inc. 7.625% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brg-d",
      code: "NASDAQ:BRG-D",
      companyName:
        "Bluerock Residential Growth REIT Inc. 7.125% Series D Cumulative Preferred Stock ($0.01 par value per share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-brid",
      code: "NASDAQ:BRID",
      companyName: "Bridgford Foods Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-briv",
      code: "NASDAQ:BRIV",
      companyName: "B. Riley Principal 250 Merger Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brivu",
      code: "NASDAQ:BRIVU",
      companyName: "B. Riley Principal 250 Merger Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-brivw",
      code: "NASDAQ:BRIVW",
      companyName: "B. Riley Principal 250 Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-brk/a",
      code: "NASDAQ:BRK/A",
      companyName: "Berkshire Hathaway Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-brk/b",
      code: "NASDAQ:BRK/B",
      companyName: "Berkshire Hathaway Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-brkh",
      code: "NASDAQ:BRKH",
      companyName: "BurTech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brkhu",
      code: "NASDAQ:BRKHU",
      companyName: "BurTech Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-brkhw",
      code: "NASDAQ:BRKHW",
      companyName: "BurTech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-brkl",
      code: "NASDAQ:BRKL",
      companyName: "Brookline Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brkr",
      code: "NASDAQ:BRKR",
      companyName: "Bruker Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brli",
      code: "NASDAQ:BRLI",
      companyName: "Brilliant Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-brlir",
      code: "NASDAQ:BRLIR",
      companyName: "Brilliant Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-brliw",
      code: "NASDAQ:BRLIW",
      companyName: "Brilliant Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-brlt",
      code: "NASDAQ:BRLT",
      companyName: "Brilliant Earth Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brmk",
      code: "NASDAQ:BRMK",
      companyName: "Broadmark Realty Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brn",
      code: "NASDAQ:BRN",
      companyName: "Barnwell Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bro",
      code: "NASDAQ:BRO",
      companyName: "Brown & Brown Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brog",
      code: "NASDAQ:BROG",
      companyName: "Brooge Energy Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-brogw",
      code: "NASDAQ:BROGW",
      companyName: "Brooge Holdings Limited Warrant expiring 12/20/2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-bros",
      code: "NASDAQ:BROS",
      companyName: "Dutch Bros Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brp",
      code: "NASDAQ:BRP",
      companyName: "BRP Group Inc. (Insurance Company) Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brpm",
      code: "NASDAQ:BRPM",
      companyName: "B. Riley Principal 150 Merger Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brpmu",
      code: "NASDAQ:BRPMU",
      companyName: "B. Riley Principal 150 Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-brpmw",
      code: "NASDAQ:BRPMW",
      companyName: "B. Riley Principal 150 Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-brqs",
      code: "NASDAQ:BRQS",
      companyName: "Borqs Technologies Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-brsp",
      code: "NASDAQ:BRSP",
      companyName: "BrightSpire Capital Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brt",
      code: "NASDAQ:BRT",
      companyName: "BRT Apartments Corp. (MD) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brtx",
      code: "NASDAQ:BRTX",
      companyName: "BioRestorative Therapies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brw",
      code: "NASDAQ:BRW",
      companyName: "Saba Capital Income & Opportunities Fund SBI",
      popularity: 0,
    },
    {
      slug: "nasdaq-brx",
      code: "NASDAQ:BRX",
      companyName: "Brixmor Property Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bry",
      code: "NASDAQ:BRY",
      companyName: "Berry Corporation (bry) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-brze",
      code: "NASDAQ:BRZE",
      companyName: "Braze Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsac",
      code: "NASDAQ:BSAC",
      companyName: "Banco Santander - Chile ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsbk",
      code: "NASDAQ:BSBK",
      companyName: "Bogota Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsbr",
      code: "NASDAQ:BSBR",
      companyName:
        "Banco Santander Brasil SA American Depositary Shares each representing one unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bset",
      code: "NASDAQ:BSET",
      companyName: "Bassett Furniture Industries Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsfc",
      code: "NASDAQ:BSFC",
      companyName: "Blue Star Foods Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsga",
      code: "NASDAQ:BSGA",
      companyName: "Blue Safari Group Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsgar",
      code: "NASDAQ:BSGAR",
      companyName: "Blue Safari Group Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsgau",
      code: "NASDAQ:BSGAU",
      companyName: "Blue Safari Group Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsgm",
      code: "NASDAQ:BSGM",
      companyName: "BioSig Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsig",
      code: "NASDAQ:BSIG",
      companyName: "BrightSphere Investment Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsky",
      code: "NASDAQ:BSKY",
      companyName: "Big Sky Growth Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bskyu",
      code: "NASDAQ:BSKYU",
      companyName: "Big Sky Growth Partners Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bskyw",
      code: "NASDAQ:BSKYW",
      companyName: "Big Sky Growth Partners Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsl",
      code: "NASDAQ:BSL",
      companyName:
        "Blackstone Senior Floating Rate Term Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsm",
      code: "NASDAQ:BSM",
      companyName:
        "Black Stone Minerals L.P. Common units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsmx",
      code: "NASDAQ:BSMX",
      companyName:
        "Banco Santander Mexico S.A. Institucion de Banca Multiple Grupo Financiero Santander Mexico",
      popularity: 0,
    },
    {
      slug: "nasdaq-bst",
      code: "NASDAQ:BST",
      companyName:
        "BlackRock Science and Technology Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bstz",
      code: "NASDAQ:BSTZ",
      companyName:
        "BlackRock Science and Technology Trust II Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsvn",
      code: "NASDAQ:BSVN",
      companyName: "Bank7 Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsx",
      code: "NASDAQ:BSX",
      companyName: "Boston Scientific Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsx-a",
      code: "NASDAQ:BSX-A",
      companyName:
        "Boston Scientific Corporation 5.50% Mandatory Convertible Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsy",
      code: "NASDAQ:BSY",
      companyName: "Bentley Systems Incorporated Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bta",
      code: "NASDAQ:BTA",
      companyName:
        "BlackRock Long-Term Municipal Advantage Trust BlackRock Long-Term Municipal Advantage Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-btai",
      code: "NASDAQ:BTAI",
      companyName: "BioXcel Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-btb",
      code: "NASDAQ:BTB",
      companyName: "Bit Brother Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-btbd",
      code: "NASDAQ:BTBD",
      companyName: "BT Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-btbt",
      code: "NASDAQ:BTBT",
      companyName: "Bit Digital Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-btcm",
      code: "NASDAQ:BTCM",
      companyName: "BIT Mining Limited ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-btcs",
      code: "NASDAQ:BTCS",
      companyName: "BTCS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-btcy",
      code: "NASDAQ:BTCY",
      companyName: "Biotricity Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-btg",
      code: "NASDAQ:BTG",
      companyName: "B2Gold Corp Common shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bti",
      code: "NASDAQ:BTI",
      companyName:
        "British American Tobacco  Industries p.l.c. Common Stock ADR",
      popularity: 0,
    },
    {
      slug: "nasdaq-btn",
      code: "NASDAQ:BTN",
      companyName: "Ballantyne Strong Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bto",
      code: "NASDAQ:BTO",
      companyName: "John Hancock Financial Opportunities Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-btog",
      code: "NASDAQ:BTOG",
      companyName: "China Xiangtai Food Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-btrs",
      code: "NASDAQ:BTRS",
      companyName: "BTRS Holdings Inc. Class 1 Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-btt",
      code: "NASDAQ:BTT",
      companyName: "BlackRock Municipal 2030 Target Term Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bttr",
      code: "NASDAQ:BTTR",
      companyName: "Better Choice Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bttx",
      code: "NASDAQ:BTTX",
      companyName: "Better Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-btwn",
      code: "NASDAQ:BTWN",
      companyName: "Bridgetown Holdings Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-btwnu",
      code: "NASDAQ:BTWNU",
      companyName: "Bridgetown Holdings Limited Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-btwnw",
      code: "NASDAQ:BTWNW",
      companyName: "Bridgetown Holdings Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-btx",
      code: "NASDAQ:BTX",
      companyName: "Brooklyn ImmunoTherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-btz",
      code: "NASDAQ:BTZ",
      companyName: "BlackRock Credit Allocation Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bud",
      code: "NASDAQ:BUD",
      companyName: "Anheuser-Busch Inbev SA Sponsored ADR (Belgium)",
      popularity: 0,
    },
    {
      slug: "nasdaq-bui",
      code: "NASDAQ:BUI",
      companyName:
        "BlackRock Utility Infrastructure & Power Opportunities Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-bur",
      code: "NASDAQ:BUR",
      companyName: "Burford Capital Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-burl",
      code: "NASDAQ:BURL",
      companyName: "Burlington Stores Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-buse",
      code: "NASDAQ:BUSE",
      companyName: "First Busey Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bv",
      code: "NASDAQ:BV",
      companyName: "BrightView Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bvh",
      code: "NASDAQ:BVH",
      companyName:
        "Bluegreen Vacations Holding Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bvn",
      code: "NASDAQ:BVN",
      companyName: "Buenaventura Mining Company Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-bvs",
      code: "NASDAQ:BVS",
      companyName: "Bioventus Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bvxv",
      code: "NASDAQ:BVXV",
      companyName: "BiondVax Pharmaceuticals Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bw",
      code: "NASDAQ:BW",
      companyName: "Babcock & Wilcox Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bw-a",
      code: "NASDAQ:BW-A",
      companyName:
        "Babcock & Wilcox Enterprises Inc. 7.75% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwa",
      code: "NASDAQ:BWA",
      companyName: "BorgWarner Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwac",
      code: "NASDAQ:BWAC",
      companyName: "Better World Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwacu",
      code: "NASDAQ:BWACU",
      companyName: "Better World Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwacw",
      code: "NASDAQ:BWACW",
      companyName: "Better World Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwaq",
      code: "NASDAQ:BWAQ",
      companyName: "Blue World Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwaqr",
      code: "NASDAQ:BWAQR",
      companyName: "Blue World Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwaqu",
      code: "NASDAQ:BWAQU",
      companyName: "Blue World Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwaqw",
      code: "NASDAQ:BWAQW",
      companyName: "Blue World Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bway",
      code: "NASDAQ:BWAY",
      companyName: "BrainsWay Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwb",
      code: "NASDAQ:BWB",
      companyName: "Bridgewater Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwbbp",
      code: "NASDAQ:BWBBP",
      companyName:
        "Bridgewater Bancshares Inc. Depositary Shares Each Representing a 1/100th Interest in a Share of 5.875% Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwc",
      code: "NASDAQ:BWC",
      companyName: "Blue Whale Acquisition Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwcau",
      code: "NASDAQ:BWCAU",
      companyName: "Blue Whale Acquisition Corp I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwen",
      code: "NASDAQ:BWEN",
      companyName: "Broadwind Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwfg",
      code: "NASDAQ:BWFG",
      companyName: "Bankwell Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwg",
      code: "NASDAQ:BWG",
      companyName: "BrandywineGLOBAL Global Income Opportunities Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwsn",
      code: "NASDAQ:BWSN",
      companyName:
        "Babcock & Wilcox Enterprises Inc. 8.125% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwv",
      code: "NASDAQ:BWV",
      companyName: "Blue Water Vaccines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwxt",
      code: "NASDAQ:BWXT",
      companyName: "BWX Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bxc",
      code: "NASDAQ:BXC",
      companyName: "Bluelinx Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bxmt",
      code: "NASDAQ:BXMT",
      companyName: "Blackstone Mortgage Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bxmx",
      code: "NASDAQ:BXMX",
      companyName:
        "Nuveen S&P 500 Buy-Write Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-bxp",
      code: "NASDAQ:BXP",
      companyName: "Boston Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bxrx",
      code: "NASDAQ:BXRX",
      companyName: "Baudax Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bxsl",
      code: "NASDAQ:BXSL",
      companyName:
        "Blackstone Secured Lending Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-by",
      code: "NASDAQ:BY",
      companyName: "Byline Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-byfc",
      code: "NASDAQ:BYFC",
      companyName: "Broadway Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bym",
      code: "NASDAQ:BYM",
      companyName:
        "Blackrock Municipal Income Quality Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-byn",
      code: "NASDAQ:BYN",
      companyName: "Banyan Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-byno",
      code: "NASDAQ:BYNO",
      companyName: "byNordic Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bynou",
      code: "NASDAQ:BYNOU",
      companyName: "byNordic Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-bynow",
      code: "NASDAQ:BYNOW",
      companyName: "byNordic Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-byrn",
      code: "NASDAQ:BYRN",
      companyName: "Byrna Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bysi",
      code: "NASDAQ:BYSI",
      companyName: "BeyondSpring Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-byts",
      code: "NASDAQ:BYTS",
      companyName: "BYTE Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bytsw",
      code: "NASDAQ:BYTSW",
      companyName: "BYTE Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-bz",
      code: "NASDAQ:BZ",
      companyName: "KANZHUN LIMITED American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bzfd",
      code: "NASDAQ:BZFD",
      companyName: "BuzzFeed Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bzfdw",
      code: "NASDAQ:BZFDW",
      companyName: "BuzzFeed Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-bzh",
      code: "NASDAQ:BZH",
      companyName: "Beazer Homes USA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bzun",
      code: "NASDAQ:BZUN",
      companyName: "Baozun Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-c-j",
      code: "NASDAQ:C-J",
      companyName: "Citigroup Inc. Dep Shs Repstg 1/1000 Pfd Ser J Fixed/Fltg",
      popularity: 0,
    },
    {
      slug: "nasdaq-c-k",
      code: "NASDAQ:C-K",
      companyName: "Citigroup Inc. Dep Shs Repstg 1/1000th Pfd Ser K",
      popularity: 0,
    },
    {
      slug: "nasdaq-c-n",
      code: "NASDAQ:C-N",
      companyName:
        "Citigroup Capital XIII 7.875% Fixed rate Floating Rate trust Preferred Securities (TruPS)",
      popularity: 0,
    },
    {
      slug: "nasdaq-caap",
      code: "NASDAQ:CAAP",
      companyName: "Corporacion America Airports SA Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-caas",
      code: "NASDAQ:CAAS",
      companyName: "China Automotive Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-caba",
      code: "NASDAQ:CABA",
      companyName: "Cabaletta Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cabo",
      code: "NASDAQ:CABO",
      companyName: "Cable One Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cac",
      code: "NASDAQ:CAC",
      companyName: "Camden National Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cacc",
      code: "NASDAQ:CACC",
      companyName: "Credit Acceptance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-caci",
      code: "NASDAQ:CACI",
      companyName: "CACI International Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cade",
      code: "NASDAQ:CADE",
      companyName: "Cadence Bank Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cade-a",
      code: "NASDAQ:CADE-A",
      companyName: "Cadence Bank 5.50% Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-cadl",
      code: "NASDAQ:CADL",
      companyName: "Candel Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cae",
      code: "NASDAQ:CAE",
      companyName: "CAE Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-caf",
      code: "NASDAQ:CAF",
      companyName: "Morgan Stanley China A Share Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cag",
      code: "NASDAQ:CAG",
      companyName: "ConAgra Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cah",
      code: "NASDAQ:CAH",
      companyName: "Cardinal Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-caj",
      code: "NASDAQ:CAJ",
      companyName: "Canon Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cake",
      code: "NASDAQ:CAKE",
      companyName: "Cheesecake Factory Incorporated (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cal",
      code: "NASDAQ:CAL",
      companyName: "Caleres Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cala",
      code: "NASDAQ:CALA",
      companyName: "Calithera Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-calb",
      code: "NASDAQ:CALB",
      companyName: "California BanCorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-calm",
      code: "NASDAQ:CALM",
      companyName: "Cal-Maine Foods Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-calt",
      code: "NASDAQ:CALT",
      companyName: "Calliditas Therapeutics AB American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-calx",
      code: "NASDAQ:CALX",
      companyName: "Calix Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-camp",
      code: "NASDAQ:CAMP",
      companyName: "CalAmp Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-camt",
      code: "NASDAQ:CAMT",
      companyName: "Camtek Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cang",
      code: "NASDAQ:CANG",
      companyName:
        "Cango Inc. American Depositary Shares  each representing two (2) Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cano",
      code: "NASDAQ:CANO",
      companyName: "Cano Health Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-capl",
      code: "NASDAQ:CAPL",
      companyName:
        "CrossAmerica Partners LP Common Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-capr",
      code: "NASDAQ:CAPR",
      companyName: "Capricor Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-car",
      code: "NASDAQ:CAR",
      companyName: "Avis Budget Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cara",
      code: "NASDAQ:CARA",
      companyName: "Cara Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-care",
      code: "NASDAQ:CARE",
      companyName: "Carter Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-carg",
      code: "NASDAQ:CARG",
      companyName: "CarGurus Inc. Class A Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-carr",
      code: "NASDAQ:CARR",
      companyName: "Carrier Global Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-cat",
      code: "NASDAQ:CAT",
      companyName: "Caterpillar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cars",
      code: "NASDAQ:CARS",
      companyName: "Cars.com Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-carv",
      code: "NASDAQ:CARV",
      companyName: "Carver Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cas",
      code: "NASDAQ:CAS",
      companyName: "Cascade Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-casa",
      code: "NASDAQ:CASA",
      companyName: "Casa Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cco",
      code: "NASDAQ:CCO",
      companyName: "Clear Channel Outdoor Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cash",
      code: "NASDAQ:CASH",
      companyName: "Meta Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-casi",
      code: "NASDAQ:CASI",
      companyName: "CASI Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cass",
      code: "NASDAQ:CASS",
      companyName: "Cass Information Systems Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-casy",
      code: "NASDAQ:CASY",
      companyName: "Casey's General Stores Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-catc",
      code: "NASDAQ:CATC",
      companyName: "Cambridge Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cato",
      code: "NASDAQ:CATO",
      companyName: "Cato Corporation (The) Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-caty",
      code: "NASDAQ:CATY",
      companyName: "Cathay General Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cb",
      code: "NASDAQ:CB",
      companyName: "Chubb Limited  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cban",
      code: "NASDAQ:CBAN",
      companyName: "Colony Bankcorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbat",
      code: "NASDAQ:CBAT",
      companyName: "CBAK Energy Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbay",
      code: "NASDAQ:CBAY",
      companyName: "CymaBay Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbd",
      code: "NASDAQ:CBD",
      companyName:
        "Companhia Brasileira de Distribuicao American Depsitary Shares; each representing one Common Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbfv",
      code: "NASDAQ:CBFV",
      companyName: "CB Financial Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbh",
      code: "NASDAQ:CBH",
      companyName:
        "Virtus AllianzGI Convertible & Income 2024 Target Term Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbio",
      code: "NASDAQ:CBIO",
      companyName: "Catalyst Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbl",
      code: "NASDAQ:CBL",
      companyName: "CBL & Associates Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbnk",
      code: "NASDAQ:CBNK",
      companyName: "Capital Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cboe",
      code: "NASDAQ:CBOE",
      companyName: "Cboe Global Markets Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbre",
      code: "NASDAQ:CBRE",
      companyName: "CBRE Group Inc Common Stock Class A",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbrg",
      code: "NASDAQ:CBRG",
      companyName: "Chain Bridge I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbrgu",
      code: "NASDAQ:CBRGU",
      companyName: "Chain Bridge I Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbrgw",
      code: "NASDAQ:CBRGW",
      companyName: "Chain Bridge I Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbrl",
      code: "NASDAQ:CBRL",
      companyName: "Cracker Barrel Old Country Store Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbsh",
      code: "NASDAQ:CBSH",
      companyName: "Commerce Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbt",
      code: "NASDAQ:CBT",
      companyName: "Cabot Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbtx",
      code: "NASDAQ:CBTX",
      companyName: "CBTX Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbu",
      code: "NASDAQ:CBU",
      companyName: "Community Bank System Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cbz",
      code: "NASDAQ:CBZ",
      companyName: "CBIZ Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cc",
      code: "NASDAQ:CC",
      companyName: "Chemours Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccai",
      code: "NASDAQ:CCAI",
      companyName: "Cascadia Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccaiu",
      code: "NASDAQ:CCAIU",
      companyName: "Cascadia Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccaiw",
      code: "NASDAQ:CCAIW",
      companyName: "Cascadia Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccap",
      code: "NASDAQ:CCAP",
      companyName: "Crescent Capital BDC Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccb",
      code: "NASDAQ:CCB",
      companyName: "Coastal Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccbg",
      code: "NASDAQ:CCBG",
      companyName: "Capital City Bank Group Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cccc",
      code: "NASDAQ:CCCC",
      companyName: "C4 Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cccs",
      code: "NASDAQ:CCCS",
      companyName: "CCC Intelligent Solutions Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccd",
      code: "NASDAQ:CCD",
      companyName: "Calamos Dynamic Convertible & Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccel",
      code: "NASDAQ:CCEL",
      companyName: "Cryo-Cell International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccf",
      code: "NASDAQ:CCF",
      companyName: "Chase Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cci",
      code: "NASDAQ:CCI",
      companyName: "Crown Castle International Corp. (REIT) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccj",
      code: "NASDAQ:CCJ",
      companyName: "Cameco Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cck",
      code: "NASDAQ:CCK",
      companyName: "Crown Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccmp",
      code: "NASDAQ:CCMP",
      companyName: "CMC Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccnc",
      code: "NASDAQ:CCNC",
      companyName: "Code Chain New Continent Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccne",
      code: "NASDAQ:CCNE",
      companyName: "CNB Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccnep",
      code: "NASDAQ:CCNEP",
      companyName:
        "CNB Financial Corporation Depositary Shares each representing a 1/40th ownership interest in a share of 7.125% Series A Fixed-Rate Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccoi",
      code: "NASDAQ:CCOI",
      companyName: "Cogent Communications Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccrd",
      code: "NASDAQ:CCRD",
      companyName: "CoreCard Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccrn",
      code: "NASDAQ:CCRN",
      companyName:
        "Cross Country Healthcare Inc. Common Stock $0.0001 Par Value",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccs",
      code: "NASDAQ:CCS",
      companyName: "Century Communities Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccsi",
      code: "NASDAQ:CCSI",
      companyName: "Consensus Cloud Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccts",
      code: "NASDAQ:CCTS",
      companyName: "Cactus Acquisition Corp. 1 Limited Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-cctsu",
      code: "NASDAQ:CCTSU",
      companyName: "Cactus Acquisition Corp. 1 Limited Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccu",
      code: "NASDAQ:CCU",
      companyName: "Compania Cervecerias Unidas S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccv",
      code: "NASDAQ:CCV",
      companyName: "Churchill Capital Corp V Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccvi",
      code: "NASDAQ:CCVI",
      companyName: "Churchill Capital Corp VI Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccxi",
      code: "NASDAQ:CCXI",
      companyName: "ChemoCentryx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cd",
      code: "NASDAQ:CD",
      companyName: "Chindata Group Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdak",
      code: "NASDAQ:CDAK",
      companyName: "Codiak BioSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdaq",
      code: "NASDAQ:CDAQ",
      companyName: "Compass Digital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdaqu",
      code: "NASDAQ:CDAQU",
      companyName: "Compass Digital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdaqw",
      code: "NASDAQ:CDAQW",
      companyName: "Compass Digital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cday",
      code: "NASDAQ:CDAY",
      companyName: "Ceridian HCM Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cde",
      code: "NASDAQ:CDE",
      companyName: "Coeur Mining Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdev",
      code: "NASDAQ:CDEV",
      companyName: "Centennial Resource Development Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdlx",
      code: "NASDAQ:CDLX",
      companyName: "Cardlytics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdmo",
      code: "NASDAQ:CDMO",
      companyName: "Avid Bioservices Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdna",
      code: "NASDAQ:CDNA",
      companyName: "CareDx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdr",
      code: "NASDAQ:CDR",
      companyName: "Cedar Realty Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdr-b",
      code: "NASDAQ:CDR-B",
      companyName:
        "Cedar Realty Trust Inc. 7.25% Series B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdr-c",
      code: "NASDAQ:CDR-C",
      companyName:
        "Cedar Realty Trust Inc. 6.50% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdre",
      code: "NASDAQ:CDRE",
      companyName: "Cadre Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdro",
      code: "NASDAQ:CDRO",
      companyName: "Codere Online Luxembourg S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdrow",
      code: "NASDAQ:CDROW",
      companyName: "Codere Online Luxembourg S.A. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdtx",
      code: "NASDAQ:CDTX",
      companyName: "Cidara Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdw",
      code: "NASDAQ:CDW",
      companyName: "CDW Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdxc",
      code: "NASDAQ:CDXC",
      companyName: "ChromaDex Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdxs",
      code: "NASDAQ:CDXS",
      companyName: "Codexis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdzi",
      code: "NASDAQ:CDZI",
      companyName: "CADIZ Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdzip",
      code: "NASDAQ:CDZIP",
      companyName: "Cadiz Inc. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ce",
      code: "NASDAQ:CE",
      companyName: "Celanese Corporation Celanese Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cea",
      code: "NASDAQ:CEA",
      companyName: "China Eastern Airlines Corporation Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cead",
      code: "NASDAQ:CEAD",
      companyName: "CEA Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ceadw",
      code: "NASDAQ:CEADW",
      companyName: "CEA Industries Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cece",
      code: "NASDAQ:CECE",
      companyName: "CECO Environmental Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cee",
      code: "NASDAQ:CEE",
      companyName:
        "The Central and Eastern Europe Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cei",
      code: "NASDAQ:CEI",
      companyName: "Camber Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ceix",
      code: "NASDAQ:CEIX",
      companyName: "CONSOL Energy Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-celc",
      code: "NASDAQ:CELC",
      companyName: "Celcuity Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-celp",
      code: "NASDAQ:CELP",
      companyName:
        "Cypress Environmental Partners L.P. Common Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-celu",
      code: "NASDAQ:CELU",
      companyName: "Celularity Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cem",
      code: "NASDAQ:CEM",
      companyName: "ClearBridge MLP and Midstream Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cemi",
      code: "NASDAQ:CEMI",
      companyName: "Chembio Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cen",
      code: "NASDAQ:CEN",
      companyName: "Center Coast Brookfield MLP & Energy Infrastructure Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-cenn",
      code: "NASDAQ:CENN",
      companyName: "Cenntro Electric Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cenq",
      code: "NASDAQ:CENQ",
      companyName: "CENAQ Energy Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cenqw",
      code: "NASDAQ:CENQW",
      companyName: "CENAQ Energy Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cent",
      code: "NASDAQ:CENT",
      companyName: "Central Garden & Pet Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-centa",
      code: "NASDAQ:CENTA",
      companyName:
        "Central Garden & Pet Company Class A Common Stock Nonvoting",
      popularity: 0,
    },
    {
      slug: "nasdaq-cenx",
      code: "NASDAQ:CENX",
      companyName: "Century Aluminum Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cepu",
      code: "NASDAQ:CEPU",
      companyName:
        "Central Puerto S.A. American Depositary Shares (each represents ten Common Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ceqp",
      code: "NASDAQ:CEQP",
      companyName: "Crestwood Equity Partners LP",
      popularity: 0,
    },
    {
      slug: "nasdaq-cere",
      code: "NASDAQ:CERE",
      companyName: "Cerevel Therapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cern",
      code: "NASDAQ:CERN",
      companyName: "Cerner Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cers",
      code: "NASDAQ:CERS",
      companyName: "Cerus Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cert",
      code: "NASDAQ:CERT",
      companyName: "Certara Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cet",
      code: "NASDAQ:CET",
      companyName: "Central Securities Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cetx",
      code: "NASDAQ:CETX",
      companyName: "Cemtrex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cetxp",
      code: "NASDAQ:CETXP",
      companyName: "Cemtrex Inc. Series 1 Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cev",
      code: "NASDAQ:CEV",
      companyName:
        "Eaton Vance California Municipal Income Trust Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-cf",
      code: "NASDAQ:CF",
      companyName: "CF Industries Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfb",
      code: "NASDAQ:CFB",
      companyName: "CrossFirst Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfbk",
      code: "NASDAQ:CFBK",
      companyName: "CF Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cffe",
      code: "NASDAQ:CFFE",
      companyName: "CF Acquisition Corp. VIII Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cffeu",
      code: "NASDAQ:CFFEU",
      companyName: "CF Acquisition Corp. VIII Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cffew",
      code: "NASDAQ:CFFEW",
      companyName: "CF Acquisition Corp. VIII Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cffi",
      code: "NASDAQ:CFFI",
      companyName: "C&F Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cffn",
      code: "NASDAQ:CFFN",
      companyName: "Capitol Federal Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cffs",
      code: "NASDAQ:CFFS",
      companyName: "CF Acquisition Corp. VII Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cffsu",
      code: "NASDAQ:CFFSU",
      companyName: "CF Acquisition Corp. VII Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cffsw",
      code: "NASDAQ:CFFSW",
      companyName: "CF Acquisition Corp. VII Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfg",
      code: "NASDAQ:CFG",
      companyName: "Citizens Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfg-d",
      code: "NASDAQ:CFG-D",
      companyName:
        "Citizens Financial Group Inc. Depositary Shares each representing a 1/40th Interest in a Share of 6.350% Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfg-e",
      code: "NASDAQ:CFG-E",
      companyName:
        "Citizens Financial Group Inc. Depositary Shares Each Representing 1/40th Interest in a Share of 5.000% Fixed-Rate Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfiv",
      code: "NASDAQ:CFIV",
      companyName: "CF Acquisition Corp. IV Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfivu",
      code: "NASDAQ:CFIVU",
      companyName: "CF Acquisition Corp. IV Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfivw",
      code: "NASDAQ:CFIVW",
      companyName: "CF Acquisition Corp. IV Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cflt",
      code: "NASDAQ:CFLT",
      companyName: "Confluent Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfms",
      code: "NASDAQ:CFMS",
      companyName: "Conformis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfr",
      code: "NASDAQ:CFR",
      companyName: "Cullen/Frost Bankers Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfr-b",
      code: "NASDAQ:CFR-B",
      companyName:
        "Cullen/Frost Bankers Inc. Depositary Shares each representing a 1/40th ownership interest in a share of 4.450% non-cumulative perpetual preferred stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfrx",
      code: "NASDAQ:CFRX",
      companyName: "ContraFect Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfsb",
      code: "NASDAQ:CFSB",
      companyName: "CFSB Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfvi",
      code: "NASDAQ:CFVI",
      companyName: "CF Acquisition Corp. VI Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfviu",
      code: "NASDAQ:CFVIU",
      companyName: "CF Acquisition Corp. VI Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cfviw",
      code: "NASDAQ:CFVIW",
      companyName: "CF Acquisition Corp. VI Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cg",
      code: "NASDAQ:CG",
      companyName: "The Carlyle Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cga",
      code: "NASDAQ:CGA",
      companyName: "China Green Agriculture Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgabl",
      code: "NASDAQ:CGABL",
      companyName: "The Carlyle Group Inc. 4.625% Subordinated Notes due 2061",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgau",
      code: "NASDAQ:CGAU",
      companyName: "Centerra Gold Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgbd",
      code: "NASDAQ:CGBD",
      companyName: "Carlyle Secured Lending Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgc",
      code: "NASDAQ:CGC",
      companyName: "Canopy Growth Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgem",
      code: "NASDAQ:CGEM",
      companyName: "Cullinan Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgnx",
      code: "NASDAQ:CGNX",
      companyName: "Cognex Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgo",
      code: "NASDAQ:CGO",
      companyName: "Calamos Global Total Return Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgrn",
      code: "NASDAQ:CGRN",
      companyName: "Capstone Green Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgtx",
      code: "NASDAQ:CGTX",
      companyName: "Cognition Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chaa",
      code: "NASDAQ:CHAA",
      companyName: "Catcha Investment Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-chci",
      code: "NASDAQ:CHCI",
      companyName: "Comstock Holding Companies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chco",
      code: "NASDAQ:CHCO",
      companyName: "City Holding Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chct",
      code: "NASDAQ:CHCT",
      companyName: "Community Healthcare Trust Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chd",
      code: "NASDAQ:CHD",
      companyName: "Church & Dwight Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chdn",
      code: "NASDAQ:CHDN",
      companyName: "Churchill Downs Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-che",
      code: "NASDAQ:CHE",
      companyName: "Chemed Corp",
      popularity: 0,
    },
    {
      slug: "nasdaq-cheau",
      code: "NASDAQ:CHEAU",
      companyName: "Chenghe Acquisition Co. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-chef",
      code: "NASDAQ:CHEF",
      companyName: "The Chefs' Warehouse Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chek",
      code: "NASDAQ:CHEK",
      companyName: "Check-Cap Ltd. Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-chekz",
      code: "NASDAQ:CHEKZ",
      companyName: "Check-Cap Ltd. Series C Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-chgg",
      code: "NASDAQ:CHGG",
      companyName: "Chegg Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chh",
      code: "NASDAQ:CHH",
      companyName: "Choice Hotels International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chi",
      code: "NASDAQ:CHI",
      companyName:
        "Calamos Convertible Opportunities and Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chk",
      code: "NASDAQ:CHK",
      companyName: "Chesapeake Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chkel",
      code: "NASDAQ:CHKEL",
      companyName: "Chesapeake Energy Corporation Class C Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-chkew",
      code: "NASDAQ:CHKEW",
      companyName: "Chesapeake Energy Corporation Class A Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-chkez",
      code: "NASDAQ:CHKEZ",
      companyName: "Chesapeake Energy Corporation Class B Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-chkp",
      code: "NASDAQ:CHKP",
      companyName: "Check Point Software Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-chmg",
      code: "NASDAQ:CHMG",
      companyName: "Chemung Financial Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chmi",
      code: "NASDAQ:CHMI",
      companyName: "Cherry Hill Mortgage Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chmi-a",
      code: "NASDAQ:CHMI-A",
      companyName:
        "Cherry Hill Mortgage Investment Corporation 8.20% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chmi-b",
      code: "NASDAQ:CHMI-B",
      companyName:
        "Cherry Hill Mortgage Investment Corporation 8.250% Series B Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chn",
      code: "NASDAQ:CHN",
      companyName: "China Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chng",
      code: "NASDAQ:CHNG",
      companyName: "Change Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chngu",
      code: "NASDAQ:CHNGU",
      companyName: "Change Healthcare Inc. Tangible Equity Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-chnr",
      code: "NASDAQ:CHNR",
      companyName: "China Natural Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chpt",
      code: "NASDAQ:CHPT",
      companyName: "ChargePoint Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chra",
      code: "NASDAQ:CHRA",
      companyName: "Charah Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chrb",
      code: "NASDAQ:CHRB",
      companyName: "Charah Solutions Inc. 8.50% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-chrs",
      code: "NASDAQ:CHRS",
      companyName: "Coherus BioSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chrw",
      code: "NASDAQ:CHRW",
      companyName: "C.H. Robinson Worldwide Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chs",
      code: "NASDAQ:CHS",
      companyName: "Chico's FAS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chscl",
      code: "NASDAQ:CHSCL",
      companyName:
        "CHS Inc Class B Cumulative Redeemable Preferred Stock Series 4",
      popularity: 0,
    },
    {
      slug: "nasdaq-chscm",
      code: "NASDAQ:CHSCM",
      companyName:
        "CHS Inc Class B Reset Rate Cumulative Redeemable Preferred Stock Series 3",
      popularity: 0,
    },
    {
      slug: "nasdaq-chscn",
      code: "NASDAQ:CHSCN",
      companyName: "CHS Inc Preferred Class B Series 2 Reset Rate",
      popularity: 0,
    },
    {
      slug: "nasdaq-chsco",
      code: "NASDAQ:CHSCO",
      companyName: "CHS Inc. Class B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chscp",
      code: "NASDAQ:CHSCP",
      companyName: "CHS Inc. 8%  Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cht",
      code: "NASDAQ:CHT",
      companyName: "Chunghwa Telecom Co. Ltd.",
      popularity: 0,
    },
    {
      slug: "nasdaq-chuy",
      code: "NASDAQ:CHUY",
      companyName: "Chuy's Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chw",
      code: "NASDAQ:CHW",
      companyName: "Calamos Global Dynamic Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chwa",
      code: "NASDAQ:CHWA",
      companyName: "CHW Acquisition Corporation Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-chwau",
      code: "NASDAQ:CHWAU",
      companyName: "CHW Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-chwaw",
      code: "NASDAQ:CHWAW",
      companyName: "CHW Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-chwy",
      code: "NASDAQ:CHWY",
      companyName: "Chewy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-chy",
      code: "NASDAQ:CHY",
      companyName: "Calamos Convertible and High Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ci",
      code: "NASDAQ:CI",
      companyName: "Cigna Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cia",
      code: "NASDAQ:CIA",
      companyName: "Citizens Inc. Class A Common Stock ($1.00 Par)",
      popularity: 0,
    },
    {
      slug: "nasdaq-cib",
      code: "NASDAQ:CIB",
      companyName: "BanColombia S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cidm",
      code: "NASDAQ:CIDM",
      companyName: "Cinedigm Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cien",
      code: "NASDAQ:CIEN",
      companyName: "Ciena Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cif",
      code: "NASDAQ:CIF",
      companyName: "MFS Intermediate High Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cifrw",
      code: "NASDAQ:CIFRW",
      companyName: "Cipher Mining Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cig",
      code: "NASDAQ:CIG",
      companyName: "Comp En De Mn Cemig ADS American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cigi",
      code: "NASDAQ:CIGI",
      companyName:
        "Colliers International Group Inc. Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cih",
      code: "NASDAQ:CIH",
      companyName: "China Index Holdings Limited American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cii",
      code: "NASDAQ:CII",
      companyName: "Blackrock Capital and Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ciig",
      code: "NASDAQ:CIIG",
      companyName: "CIIG Capital Partners II Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ciigu",
      code: "NASDAQ:CIIGU",
      companyName: "CIIG Capital Partners II Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ciigw",
      code: "NASDAQ:CIIGW",
      companyName: "CIIG Capital Partners II Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cik",
      code: "NASDAQ:CIK",
      companyName:
        "Credit Suisse Asset Management Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cim",
      code: "NASDAQ:CIM",
      companyName: "Chimera Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cim-a",
      code: "NASDAQ:CIM-A",
      companyName:
        "Chimera Investment Corporation 8.00% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cim-b",
      code: "NASDAQ:CIM-B",
      companyName:
        "Chimera Investment Corporation 8.00% Series B Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cim-c",
      code: "NASDAQ:CIM-C",
      companyName:
        "Chimera Investment Corporation 7.75% Series C Fixed-to-Floating Rate  Cumulative Redeemable  Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cim-d",
      code: "NASDAQ:CIM-D",
      companyName:
        "Chimera Investment Corporation 8.00% Series D Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cinc",
      code: "NASDAQ:CINC",
      companyName: "CinCor Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cinf",
      code: "NASDAQ:CINF",
      companyName: "Cincinnati Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cing",
      code: "NASDAQ:CING",
      companyName: "Cingulate Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cingw",
      code: "NASDAQ:CINGW",
      companyName: "Cingulate Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-cint",
      code: "NASDAQ:CINT",
      companyName: "CI&T Inc Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cio",
      code: "NASDAQ:CIO",
      companyName: "City Office REIT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cifr",
      code: "NASDAQ:CIFR",
      companyName: "Cipher Mining Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cio-a",
      code: "NASDAQ:CIO-A",
      companyName:
        "City Office REIT Inc. 6.625% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cion",
      code: "NASDAQ:CION",
      companyName: "CION Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cir",
      code: "NASDAQ:CIR",
      companyName: "CIRCOR International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ciso",
      code: "NASDAQ:CISO",
      companyName: "Cerberus Cyber Sentinel Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cite",
      code: "NASDAQ:CITE",
      companyName: "Cartica Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-citeu",
      code: "NASDAQ:CITEU",
      companyName: "Cartica Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-citew",
      code: "NASDAQ:CITEW",
      companyName: "Cartica Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-civb",
      code: "NASDAQ:CIVB",
      companyName: "Civista Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-civi",
      code: "NASDAQ:CIVI",
      companyName: "Civitas Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cix",
      code: "NASDAQ:CIX",
      companyName: "CompX International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cixx",
      code: "NASDAQ:CIXX",
      companyName: "CI Financial Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cizn",
      code: "NASDAQ:CIZN",
      companyName: "Citizens Holding Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cjjd",
      code: "NASDAQ:CJJD",
      companyName:
        "China Jo-Jo Drugstores Inc. (Cayman Islands) Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ckpt",
      code: "NASDAQ:CKPT",
      companyName: "Checkpoint Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ckx",
      code: "NASDAQ:CKX",
      companyName: "CKX Lands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cl",
      code: "NASDAQ:CL",
      companyName: "Colgate-Palmolive Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-claa",
      code: "NASDAQ:CLAA",
      companyName: "Colonnade Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-claq",
      code: "NASDAQ:CLAQ",
      companyName: "CleanTech Acquisition Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-claqr",
      code: "NASDAQ:CLAQR",
      companyName: "CleanTech Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-claqu",
      code: "NASDAQ:CLAQU",
      companyName: "CleanTech Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-claqw",
      code: "NASDAQ:CLAQW",
      companyName: "CleanTech Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-clar",
      code: "NASDAQ:CLAR",
      companyName: "Clarus Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clas",
      code: "NASDAQ:CLAS",
      companyName: "Class Acceleration Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clay",
      code: "NASDAQ:CLAY",
      companyName: "Chavant Capital Acquisition Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-clayw",
      code: "NASDAQ:CLAYW",
      companyName: "Chavant Capital Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-clb",
      code: "NASDAQ:CLB",
      companyName: "Core Laboratories N.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clbk",
      code: "NASDAQ:CLBK",
      companyName: "Columbia Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clbr",
      code: "NASDAQ:CLBR",
      companyName: "Colombier Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clbs",
      code: "NASDAQ:CLBS",
      companyName: "Caladrius Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clbtw",
      code: "NASDAQ:CLBTW",
      companyName: "Cellebrite DI Ltd. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-cldt",
      code: "NASDAQ:CLDT",
      companyName:
        "Chatham Lodging Trust (REIT) Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-cldt-a",
      code: "NASDAQ:CLDT-A",
      companyName:
        "Chatham Lodging Trust (REIT) 6.625% Series A Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-cldx",
      code: "NASDAQ:CLDX",
      companyName: "Celldex Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-cleu",
      code: "NASDAQ:CLEU",
      companyName: "China Liberal Education Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-clf",
      code: "NASDAQ:CLF",
      companyName: "Cleveland-Cliffs Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clfd",
      code: "NASDAQ:CLFD",
      companyName: "Clearfield Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clin",
      code: "NASDAQ:CLIN",
      companyName: "Clean Earth Acquisitions Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clinr",
      code: "NASDAQ:CLINR",
      companyName: "Clean Earth Acquisitions Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-clir",
      code: "NASDAQ:CLIR",
      companyName: "ClearSign Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clls",
      code: "NASDAQ:CLLS",
      companyName: "Cellectis S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-clm",
      code: "NASDAQ:CLM",
      companyName: "Cornerstone Strategic Value Fund Inc. New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clmt",
      code: "NASDAQ:CLMT",
      companyName: "Calumet Specialty Products Partners L.P. Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-clbt",
      code: "NASDAQ:CLBT",
      companyName: "Cellebrite DI Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-clnn",
      code: "NASDAQ:CLNN",
      companyName: "Clene Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cloe",
      code: "NASDAQ:CLOE",
      companyName: "Clover Leaf Capital Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clov",
      code: "NASDAQ:CLOV",
      companyName: "Clover Health Investments Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clpr",
      code: "NASDAQ:CLPR",
      companyName: "Clipper Realty Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clps",
      code: "NASDAQ:CLPS",
      companyName: "CLPS Incorporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clpt",
      code: "NASDAQ:CLPT",
      companyName: "ClearPoint Neuro Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clr",
      code: "NASDAQ:CLR",
      companyName: "Continental Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clrb",
      code: "NASDAQ:CLRB",
      companyName: "Cellectar Biosciences Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clrcu",
      code: "NASDAQ:CLRCU",
      companyName: "ClimateRock Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-clrm",
      code: "NASDAQ:CLRM",
      companyName: "Clarim Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clrmu",
      code: "NASDAQ:CLRMU",
      companyName: "Clarim Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-clrmw",
      code: "NASDAQ:CLRMW",
      companyName: "Clarim Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-clro",
      code: "NASDAQ:CLRO",
      companyName: "ClearOne Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cls",
      code: "NASDAQ:CLS",
      companyName: "Celestica Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clsd",
      code: "NASDAQ:CLSD",
      companyName: "Clearside Biomedical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clsn",
      code: "NASDAQ:CLSN",
      companyName: "Celsion Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clst",
      code: "NASDAQ:CLST",
      companyName: "Catalyst Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clvr",
      code: "NASDAQ:CLVR",
      companyName: "Clever Leaves Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-clvrw",
      code: "NASDAQ:CLVRW",
      companyName: "Clever Leaves Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-clvs",
      code: "NASDAQ:CLVS",
      companyName: "Clovis Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clvt",
      code: "NASDAQ:CLVT",
      companyName: "Clarivate Plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-clvt-a",
      code: "NASDAQ:CLVT-A",
      companyName:
        "Clarivate Plc 5.25% Series A Mandatory Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-clw",
      code: "NASDAQ:CLW",
      companyName: "Clearwater Paper Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clwt",
      code: "NASDAQ:CLWT",
      companyName: "Euro Tech Holdings Company Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clx",
      code: "NASDAQ:CLX",
      companyName: "Clorox Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clxt",
      code: "NASDAQ:CLXT",
      companyName: "Calyxt Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cm",
      code: "NASDAQ:CM",
      companyName: "Canadian Imperial Bank of Commerce Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cma",
      code: "NASDAQ:CMA",
      companyName: "Comerica Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmax",
      code: "NASDAQ:CMAX",
      companyName: "CareMax Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmaxw",
      code: "NASDAQ:CMAXW",
      companyName: "CareMax Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmbm",
      code: "NASDAQ:CMBM",
      companyName: "Cambium Networks Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmc",
      code: "NASDAQ:CMC",
      companyName: "Commercial Metals Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmca",
      code: "NASDAQ:CMCA",
      companyName:
        "Capitalworks Emerging Markets Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmcaw",
      code: "NASDAQ:CMCAW",
      companyName: "Capitalworks Emerging Markets Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmcl",
      code: "NASDAQ:CMCL",
      companyName: "Caledonia Mining Corporation Plc Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmcm",
      code: "NASDAQ:CMCM",
      companyName:
        "Cheetah Mobile Inc. American Depositary Shares each representing 10 Class Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmco",
      code: "NASDAQ:CMCO",
      companyName: "Columbus McKinnon Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmct",
      code: "NASDAQ:CMCT",
      companyName: "Creative Media & Community Trust Corporation Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmctp",
      code: "NASDAQ:CMCTP",
      companyName:
        "Creative Media & Community Trust Corporation Series L Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmi",
      code: "NASDAQ:CMI",
      companyName: "Cummins Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmls",
      code: "NASDAQ:CMLS",
      companyName: "Cumulus Media Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmmb",
      code: "NASDAQ:CMMB",
      companyName: "Chemomab Therapeutics Ltd. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmp",
      code: "NASDAQ:CMP",
      companyName: "Compass Minerals Intl Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmpi",
      code: "NASDAQ:CMPI",
      companyName: "Checkmate Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmpo",
      code: "NASDAQ:CMPO",
      companyName: "CompoSecure Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmpow",
      code: "NASDAQ:CMPOW",
      companyName: "CompoSecure Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmpr",
      code: "NASDAQ:CMPR",
      companyName: "Cimpress plc Ordinary Shares (Ireland)",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmps",
      code: "NASDAQ:CMPS",
      companyName: "COMPASS Pathways Plc American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmpx",
      code: "NASDAQ:CMPX",
      companyName: "Compass Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmre",
      code: "NASDAQ:CMRE",
      companyName: "Costamare Inc. Common Stock $0.0001 par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmre-b",
      code: "NASDAQ:CMRE-B",
      companyName:
        "Costamare Inc. Perpetual Preferred Stock Series B (Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmre-c",
      code: "NASDAQ:CMRE-C",
      companyName:
        "Costamare Inc. Perpetual Preferred Series C (Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmre-d",
      code: "NASDAQ:CMRE-D",
      companyName:
        "Costamare Inc. 8.75% Series D Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmre-e",
      code: "NASDAQ:CMRE-E",
      companyName:
        "Costamare Inc. 8.875% Series E Cumulative Redeemable Perpetual Preferred Stock par value $0.0001",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmrx",
      code: "NASDAQ:CMRX",
      companyName: "Chimerix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cms",
      code: "NASDAQ:CMS",
      companyName: "CMS Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cms-b",
      code: "NASDAQ:CMS-B",
      companyName: "CMS Energy Corporation Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cms-c",
      code: "NASDAQ:CMS-C",
      companyName:
        "CMS Energy Corporation Depositary Shares each representing a 1/1000th interest in a share of 4.200% Cumulative Redeemable Perpetual Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmsa",
      code: "NASDAQ:CMSA",
      companyName:
        "CMS Energy Corporation 5.625% Junior Subordinated Notes due 2078",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmsc",
      code: "NASDAQ:CMSC",
      companyName:
        "CMS Energy Corporation 5.875% Junior Subordinated Notes due 2078",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmsd",
      code: "NASDAQ:CMSD",
      companyName:
        "CMS Energy Corporation 5.875% Junior Subordinated Notes due 2079",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmt",
      code: "NASDAQ:CMT",
      companyName: "Core Molding Technologies Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmtg",
      code: "NASDAQ:CMTG",
      companyName: "Claros Mortgage Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmtl",
      code: "NASDAQ:CMTL",
      companyName: "Comtech Telecommunications Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmu",
      code: "NASDAQ:CMU",
      companyName: "MFS Municipal Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cna",
      code: "NASDAQ:CNA",
      companyName: "CNA Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnc",
      code: "NASDAQ:CNC",
      companyName: "Centene Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnce",
      code: "NASDAQ:CNCE",
      companyName: "Concert Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnd",
      code: "NASDAQ:CND",
      companyName: "Concord Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnda",
      code: "NASDAQ:CNDA",
      companyName: "Concord Acquisition Corp II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cndb",
      code: "NASDAQ:CNDB",
      companyName: "Concord Acquisition Corp III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cndt",
      code: "NASDAQ:CNDT",
      companyName: "Conduent Incorporated Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnet",
      code: "NASDAQ:CNET",
      companyName: "ZW Data Action Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cney",
      code: "NASDAQ:CNEY",
      companyName: "CN Energy Group Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnf",
      code: "NASDAQ:CNF",
      companyName:
        "CNFinance Holdings Limited American Depositary Shares each representing  twenty (20) Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnfr",
      code: "NASDAQ:CNFR",
      companyName: "Conifer Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnfrl",
      code: "NASDAQ:CNFRL",
      companyName:
        "Conifer Holdings Inc. 6.75% Senior Unsecured Notes due 2023",
      popularity: 0,
    },
    {
      slug: "nasdaq-cngl",
      code: "NASDAQ:CNGL",
      companyName: "Canna-Global Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnglw",
      code: "NASDAQ:CNGLW",
      companyName: "Canna-Global Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnhi",
      code: "NASDAQ:CNHI",
      companyName: "CNH Industrial N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cni",
      code: "NASDAQ:CNI",
      companyName: "Canadian National Railway Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnk",
      code: "NASDAQ:CNK",
      companyName: "Cinemark Holdings Inc Cinemark Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnm",
      code: "NASDAQ:CNM",
      companyName: "Core & Main Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnmd",
      code: "NASDAQ:CNMD",
      companyName: "CONMED Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnnb",
      code: "NASDAQ:CNNB",
      companyName: "Cincinnati Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnne",
      code: "NASDAQ:CNNE",
      companyName: "Cannae Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cno",
      code: "NASDAQ:CNO",
      companyName: "CNO Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cno-a",
      code: "NASDAQ:CNO-A",
      companyName:
        "CNO Financial Group Inc. 5.125% Subordinated Debentures due 2060",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnob",
      code: "NASDAQ:CNOB",
      companyName: "ConnectOne Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnobp",
      code: "NASDAQ:CNOBP",
      companyName:
        "ConnectOne Bancorp Inc. Depositary Shares each representing a 1/40th interest in a share of 5.25% Fixed-Rate Reset Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnp",
      code: "NASDAQ:CNP",
      companyName: "CenterPoint Energy Inc (Holding Co) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnq",
      code: "NASDAQ:CNQ",
      companyName: "Canadian Natural Resources Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnr",
      code: "NASDAQ:CNR",
      companyName: "Cornerstone Building Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cns",
      code: "NASDAQ:CNS",
      companyName: "Cohen & Steers Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnsl",
      code: "NASDAQ:CNSL",
      companyName: "Consolidated Communications Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnsp",
      code: "NASDAQ:CNSP",
      companyName: "CNS Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnta",
      code: "NASDAQ:CNTA",
      companyName: "Centessa Pharmaceuticals plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cntb",
      code: "NASDAQ:CNTB",
      companyName:
        "Connect Biopharma Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cntg",
      code: "NASDAQ:CNTG",
      companyName: "Centogene N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cntq",
      code: "NASDAQ:CNTQ",
      companyName: "Chardan NexTech Acquisition 2 Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cntqu",
      code: "NASDAQ:CNTQU",
      companyName: "Chardan NexTech Acquisition 2 Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnty",
      code: "NASDAQ:CNTY",
      companyName: "Century Casinos Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnvy",
      code: "NASDAQ:CNVY",
      companyName: "Convey Health Solutions Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnx",
      code: "NASDAQ:CNX",
      companyName: "CNX Resources Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cnxn",
      code: "NASDAQ:CNXN",
      companyName: "PC Connection Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-co",
      code: "NASDAQ:CO",
      companyName: "Global Cord Blood Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-coco",
      code: "NASDAQ:COCO",
      companyName: "The Vita Coco Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cocp",
      code: "NASDAQ:COCP",
      companyName: "Cocrystal Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-coda",
      code: "NASDAQ:CODA",
      companyName: "Coda Octopus Group Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-codi",
      code: "NASDAQ:CODI",
      companyName:
        "D/B/A Compass Diversified Holdings Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-codi-a",
      code: "NASDAQ:CODI-A",
      companyName:
        "Compass Diversified Holdings 7.250% Series A Preferred Shares representing beneficial interest in Compass Diversified Holdings",
      popularity: 0,
    },
    {
      slug: "nasdaq-codi-b",
      code: "NASDAQ:CODI-B",
      companyName:
        "Compass Diversified Holdings 7.875% Series B Fixed-to-Floating Rate Cumulative Preferred Shares representing beneficial interests in Compass Diversified Holdings",
      popularity: 0,
    },
    {
      slug: "nasdaq-codi-c",
      code: "NASDAQ:CODI-C",
      companyName:
        "Compass Diversified Holdings 7.875% Series C Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-codx",
      code: "NASDAQ:CODX",
      companyName: "Co-Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-coe",
      code: "NASDAQ:COE",
      companyName:
        "China Online Education Group American depositary shares each representing 15 Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cof",
      code: "NASDAQ:COF",
      companyName: "Capital One Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cof-i",
      code: "NASDAQ:COF-I",
      companyName:
        "Capital One Financial Corporation Depositary shares each representing a 1/40th interest in a share of Fixed Rate Non-Cumulative Perpetual Preferred Stock Series I of the Issuer",
      popularity: 0,
    },
    {
      slug: "nasdaq-cof-j",
      code: "NASDAQ:COF-J",
      companyName:
        "Capital One Financial Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of Fixed Rate Non- Cumulative Perpetual Preferred Stock Series J",
      popularity: 0,
    },
    {
      slug: "nasdaq-cof-k",
      code: "NASDAQ:COF-K",
      companyName:
        "Capital One Financial Corporation Depositary Shares Each Representing a 1/40th Ownership Interest in a Share of Fixed Rate Non-Cumulative Perpetual Preferred Stock Series K",
      popularity: 0,
    },
    {
      slug: "nasdaq-cof-l",
      code: "NASDAQ:COF-L",
      companyName:
        "Capital One Financial Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of Fixed Rate Non-Cumulative Perpetual Preferred Stock Series L",
      popularity: 0,
    },
    {
      slug: "nasdaq-dht",
      code: "NASDAQ:DHT",
      companyName: "DHT Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-cof-n",
      code: "NASDAQ:COF-N",
      companyName:
        "Capital One Financial Corporation Depositary Shares Each Representing a 1/40th Ownership Interest in a Share of Fixed Rate Non-Cumulative Perpetual Preferred Stock Series N",
      popularity: 0,
    },
    {
      slug: "nasdaq-cofs",
      code: "NASDAQ:COFS",
      companyName: "ChoiceOne Financial Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cogt",
      code: "NASDAQ:COGT",
      companyName: "Cogent Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cohn",
      code: "NASDAQ:COHN",
      companyName: "Cohen & Company Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-cohu",
      code: "NASDAQ:COHU",
      companyName: "Cohu Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-coke",
      code: "NASDAQ:COKE",
      companyName: "Coca-Cola Consolidated Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-colb",
      code: "NASDAQ:COLB",
      companyName: "Columbia Banking System Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cold",
      code: "NASDAQ:COLD",
      companyName: "Americold Realty Trust Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-coli",
      code: "NASDAQ:COLI",
      companyName: "Colicity Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-coliu",
      code: "NASDAQ:COLIU",
      companyName: "Colicity Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-coliw",
      code: "NASDAQ:COLIW",
      companyName: "Colicity Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-coll",
      code: "NASDAQ:COLL",
      companyName: "Collegium Pharmaceutical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-colm",
      code: "NASDAQ:COLM",
      companyName: "Columbia Sportswear Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-comm",
      code: "NASDAQ:COMM",
      companyName: "CommScope Holding Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-comp",
      code: "NASDAQ:COMP",
      companyName: "Compass Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-coms",
      code: "NASDAQ:COMS",
      companyName: "ComSovereign Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-comsp",
      code: "NASDAQ:COMSP",
      companyName:
        "ComSovereign Holding Corp. 9.25% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-comsw",
      code: "NASDAQ:COMSW",
      companyName: "ComSovereign Holding Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-conn",
      code: "NASDAQ:CONN",
      companyName: "Conn's Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-conx",
      code: "NASDAQ:CONX",
      companyName: "CONX Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-conxu",
      code: "NASDAQ:CONXU",
      companyName: "CONX Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-conxw",
      code: "NASDAQ:CONXW",
      companyName: "CONX Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-coo",
      code: "NASDAQ:COO",
      companyName: "The Cooper Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cook",
      code: "NASDAQ:COOK",
      companyName: "Traeger Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cool",
      code: "NASDAQ:COOL",
      companyName: "Corner Growth Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-coolu",
      code: "NASDAQ:COOLU",
      companyName: "Corner Growth Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-coolw",
      code: "NASDAQ:COOLW",
      companyName: "Corner Growth Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-coop",
      code: "NASDAQ:COOP",
      companyName: "Mr. Cooper Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cop",
      code: "NASDAQ:COP",
      companyName: "ConocoPhillips Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cort",
      code: "NASDAQ:CORT",
      companyName: "Corcept Therapeutics Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-corz",
      code: "NASDAQ:CORZ",
      companyName: "Core Scientific Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-corzw",
      code: "NASDAQ:CORZW",
      companyName: "Core Scientific Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cosm",
      code: "NASDAQ:COSM",
      companyName: "Cosmos Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-coty",
      code: "NASDAQ:COTY",
      companyName: "Coty Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-coup",
      code: "NASDAQ:COUP",
      companyName: "Coupa Software Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cour",
      code: "NASDAQ:COUR",
      companyName: "Coursera Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cova",
      code: "NASDAQ:COVA",
      companyName: "COVA Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-covau",
      code: "NASDAQ:COVAU",
      companyName: "COVA Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-covaw",
      code: "NASDAQ:COVAW",
      companyName:
        "COVA Acquisition Corp. Warrants to purchase Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cown",
      code: "NASDAQ:COWN",
      companyName: "Cowen Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cownl",
      code: "NASDAQ:COWNL",
      companyName: "Cowen Inc. 7.75% Senior Notes due 2033",
      popularity: 0,
    },
    {
      slug: "nasdaq-cp",
      code: "NASDAQ:CP",
      companyName: "Canadian Pacific Railway Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpa",
      code: "NASDAQ:CPA",
      companyName: "Copa Holdings S.A. Copa Holdings S.A. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpaa",
      code: "NASDAQ:CPAA",
      companyName: "Conyers Park III Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpaau",
      code: "NASDAQ:CPAAU",
      companyName: "Conyers Park III Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpac",
      code: "NASDAQ:CPAC",
      companyName:
        "Cementos Pacasmayo S.A.A. American Depositary Shares (Each representing five Common Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpaqu",
      code: "NASDAQ:CPAQU",
      companyName: "Counter Press Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpaqw",
      code: "NASDAQ:CPAQW",
      companyName: "Counter Press Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpar",
      code: "NASDAQ:CPAR",
      companyName: "Catalyst Partners Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-cparu",
      code: "NASDAQ:CPARU",
      companyName: "Catalyst Partners Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cparw",
      code: "NASDAQ:CPARW",
      companyName: "Catalyst Partners Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpb",
      code: "NASDAQ:CPB",
      companyName: "Campbell Soup Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpe",
      code: "NASDAQ:CPE",
      companyName: "Callon Petroleum Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpf",
      code: "NASDAQ:CPF",
      companyName: "Central Pacific Financial Corp New",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpg",
      code: "NASDAQ:CPG",
      companyName: "Crescent Point Energy Corporation Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-cphc",
      code: "NASDAQ:CPHC",
      companyName: "Canterbury Park Holding Corporation 'New' Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cphi",
      code: "NASDAQ:CPHI",
      companyName: "China Pharma Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpix",
      code: "NASDAQ:CPIX",
      companyName: "Cumberland Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpk",
      code: "NASDAQ:CPK",
      companyName: "Chesapeake Utilities Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpri",
      code: "NASDAQ:CPRI",
      companyName: "Capri Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cplp",
      code: "NASDAQ:CPLP",
      companyName: "Capital Product Partners L.P. Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpop",
      code: "NASDAQ:CPOP",
      companyName: "Pop Culture Group Co. Ltd Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cprx",
      code: "NASDAQ:CPRX",
      companyName: "Catalyst Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cps",
      code: "NASDAQ:CPS",
      companyName: "Cooper-Standard Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpsh",
      code: "NASDAQ:CPSH",
      companyName: "CPS Technologies Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpsi",
      code: "NASDAQ:CPSI",
      companyName: "Computer Programs and Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpss",
      code: "NASDAQ:CPSS",
      companyName: "Consumer Portfolio Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpt",
      code: "NASDAQ:CPT",
      companyName: "Camden Property Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cptag",
      code: "NASDAQ:CPTAG",
      companyName: "Capitala Finance Corp. 5.75% Convertible Notes Due 2022",
      popularity: 0,
    },
    {
      slug: "nasdaq-cptal",
      code: "NASDAQ:CPTAL",
      companyName: "Capitala Finance Corp. 6% Notes Due 2022",
      popularity: 0,
    },
    {
      slug: "nasdaq-cptk",
      code: "NASDAQ:CPTK",
      companyName: "Crown PropTech Acquisitions Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cptn",
      code: "NASDAQ:CPTN",
      companyName: "Cepton Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cptnw",
      code: "NASDAQ:CPTNW",
      companyName: "Cepton Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpuh",
      code: "NASDAQ:CPUH",
      companyName: "Compute Health Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cpz",
      code: "NASDAQ:CPZ",
      companyName:
        "Calamos Long/Short Equity & Dynamic Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cqp",
      code: "NASDAQ:CQP",
      companyName:
        "Cheniere Energy Partners LP Cheniere Energy Partners LP Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-cr",
      code: "NASDAQ:CR",
      companyName: "Crane Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crai",
      code: "NASDAQ:CRAI",
      companyName: "CRA International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crbp",
      code: "NASDAQ:CRBP",
      companyName: "Corbus Pharmaceuticals Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crbu",
      code: "NASDAQ:CRBU",
      companyName: "Caribou Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crecu",
      code: "NASDAQ:CRECU",
      companyName: "Crescera Capital Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-creg",
      code: "NASDAQ:CREG",
      companyName: "Smart Powerr Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cresw",
      code: "NASDAQ:CRESW",
      companyName: "Cresud S.A.C.I.F. y A. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cresy",
      code: "NASDAQ:CRESY",
      companyName: "Cresud S.A.C.I.F. y A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-crex",
      code: "NASDAQ:CREX",
      companyName: "Creative Realities Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crf",
      code: "NASDAQ:CRF",
      companyName: "Cornerstone Total Return Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crge",
      code: "NASDAQ:CRGE",
      companyName: "Charge Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crgy",
      code: "NASDAQ:CRGY",
      companyName: "Crescent Energy Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crh",
      code: "NASDAQ:CRH",
      companyName: "CRH PLC American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-crhc",
      code: "NASDAQ:CRHC",
      companyName: "Cohn Robbins Holdings Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cris",
      code: "NASDAQ:CRIS",
      companyName: "Curis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crk",
      code: "NASDAQ:CRK",
      companyName: "Comstock Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crkn",
      code: "NASDAQ:CRKN",
      companyName: "Crown Electrokinetics Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crl",
      code: "NASDAQ:CRL",
      companyName: "Charles River Laboratories International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crmd",
      code: "NASDAQ:CRMD",
      companyName: "CorMedix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crmt",
      code: "NASDAQ:CRMT",
      companyName: "America's Car-Mart Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crnc",
      code: "NASDAQ:CRNC",
      companyName: "Cerence Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crnt",
      code: "NASDAQ:CRNT",
      companyName: "Ceragon Networks Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-crnx",
      code: "NASDAQ:CRNX",
      companyName: "Crinetics Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cron",
      code: "NASDAQ:CRON",
      companyName: "Cronos Group Inc. Common Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-crox",
      code: "NASDAQ:CROX",
      companyName: "Crocs Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crs",
      code: "NASDAQ:CRS",
      companyName: "Carpenter Technology Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crsp",
      code: "NASDAQ:CRSP",
      companyName: "CRISPR Therapeutics AG Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-crsr",
      code: "NASDAQ:CRSR",
      companyName: "Corsair Gaming Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crt",
      code: "NASDAQ:CRT",
      companyName: "Cross Timbers Royalty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crtd",
      code: "NASDAQ:CRTD",
      companyName: "Creatd Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crtdw",
      code: "NASDAQ:CRTDW",
      companyName: "Creatd Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-crto",
      code: "NASDAQ:CRTO",
      companyName: "Criteo S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-crtx",
      code: "NASDAQ:CRTX",
      companyName: "Cortexyme Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cru",
      code: "NASDAQ:CRU",
      companyName: "Crucible Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crus",
      code: "NASDAQ:CRUS",
      companyName: "Cirrus Logic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crvl",
      code: "NASDAQ:CRVL",
      companyName: "CorVel Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crvs",
      code: "NASDAQ:CRVS",
      companyName: "Corvus Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crws",
      code: "NASDAQ:CRWS",
      companyName: "Crown Crafts Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crxt",
      code: "NASDAQ:CRXT",
      companyName: "Clarus Therapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dow",
      code: "NASDAQ:DOW",
      companyName: "Dow Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-crxtw",
      code: "NASDAQ:CRXTW",
      companyName: "Clarus Therapeutics Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-crzn",
      code: "NASDAQ:CRZN",
      companyName:
        "Corazon Capital V838 Monoceros Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-crznu",
      code: "NASDAQ:CRZNU",
      companyName: "Corazon Capital V838 Monoceros Corp Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-crznw",
      code: "NASDAQ:CRZNW",
      companyName: "Corazon Capital V838 Monoceros Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cs",
      code: "NASDAQ:CS",
      companyName: "Credit Suisse Group American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-csan",
      code: "NASDAQ:CSAN",
      companyName: "Cosan S.A. ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-csbr",
      code: "NASDAQ:CSBR",
      companyName: "Champions Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cscw",
      code: "NASDAQ:CSCW",
      companyName: "Color Star Technology Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-csgs",
      code: "NASDAQ:CSGS",
      companyName: "CSG Systems International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cslm",
      code: "NASDAQ:CSLM",
      companyName: "Consilium Acquisition Corp I Ltd. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-cslmu",
      code: "NASDAQ:CSLMU",
      companyName: "Consilium Acquisition Corp I Ltd. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-cslmw",
      code: "NASDAQ:CSLMW",
      companyName: "Consilium Acquisition Corp I Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cspi",
      code: "NASDAQ:CSPI",
      companyName: "CSP Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-csq",
      code: "NASDAQ:CSQ",
      companyName: "Calamos Strategic Total Return Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-csr",
      code: "NASDAQ:CSR",
      companyName: "D/B/A Centerspace Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-csr-c",
      code: "NASDAQ:CSR-C",
      companyName: "D/B/A Centerspace 6.625% Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-csse",
      code: "NASDAQ:CSSE",
      companyName:
        "Chicken Soup for the Soul Entertainment Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cssen",
      code: "NASDAQ:CSSEN",
      companyName:
        "Chicken Soup for the Soul Entertainment Inc. 9.50% Notes due 2025",
      popularity: 0,
    },
    {
      slug: "nasdaq-cssep",
      code: "NASDAQ:CSSEP",
      companyName:
        "Chicken Soup for the Soul Entertainment Inc. 9.75% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-csta",
      code: "NASDAQ:CSTA",
      companyName: "Constellation Acquisition Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cste",
      code: "NASDAQ:CSTE",
      companyName: "Caesarstone Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cstl",
      code: "NASDAQ:CSTL",
      companyName: "Castle Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctas",
      code: "NASDAQ:CTAS",
      companyName: "Cintas Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cstr",
      code: "NASDAQ:CSTR",
      companyName: "CapStar Financial Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-csv",
      code: "NASDAQ:CSV",
      companyName: "Carriage Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cswc",
      code: "NASDAQ:CSWC",
      companyName: "Capital Southwest Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cswi",
      code: "NASDAQ:CSWI",
      companyName: "CSW Industrials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-csx",
      code: "NASDAQ:CSX",
      companyName: "CSX Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cta-a",
      code: "NASDAQ:CTA-A",
      companyName: "E.I. du Pont de Nemours and Company Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cta-b",
      code: "NASDAQ:CTA-B",
      companyName: "E.I. du Pont de Nemours and Company Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctaq",
      code: "NASDAQ:CTAQ",
      companyName:
        "Carney Technology Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctaqu",
      code: "NASDAQ:CTAQU",
      companyName: "Carney Technology Acquisition Corp. II Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctaqw",
      code: "NASDAQ:CTAQW",
      companyName: "Carney Technology Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctbb",
      code: "NASDAQ:CTBB",
      companyName: "Qwest Corporation 6.5% Notes due 2056",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctbi",
      code: "NASDAQ:CTBI",
      companyName: "Community Trust Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctdd",
      code: "NASDAQ:CTDD",
      companyName: "Qwest Corporation 6.75% Notes due 2057",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctek",
      code: "NASDAQ:CTEK",
      companyName: "CynergisTek Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctg",
      code: "NASDAQ:CTG",
      companyName: "Computer Task Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctgo",
      code: "NASDAQ:CTGO",
      companyName: "Contango ORE Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cthr",
      code: "NASDAQ:CTHR",
      companyName: "Charles & Colvard Ltd Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctib",
      code: "NASDAQ:CTIB",
      companyName: "Yunhong CTI Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-csl",
      code: "NASDAQ:CSL",
      companyName: "Carlisle Companies Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctk",
      code: "NASDAQ:CTK",
      companyName:
        "CooTek (Cayman) Inc. American Depositary Shares each representing 50 Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctkb",
      code: "NASDAQ:CTKB",
      companyName: "Cytek Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctlp",
      code: "NASDAQ:CTLP",
      companyName: "Cantaloupe Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctlt",
      code: "NASDAQ:CTLT",
      companyName: "Catalent Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctmx",
      code: "NASDAQ:CTMX",
      companyName: "CytomX Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cto",
      code: "NASDAQ:CTO",
      companyName: "CTO Realty Growth Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cto-a",
      code: "NASDAQ:CTO-A",
      companyName:
        "CTO Realty Growth Inc. 6.375% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctos",
      code: "NASDAQ:CTOS",
      companyName: "Custom Truck One Source Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctr",
      code: "NASDAQ:CTR",
      companyName:
        "ClearBridge MLP and Midstream Total Return Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctra",
      code: "NASDAQ:CTRA",
      companyName: "Coterra Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctre",
      code: "NASDAQ:CTRE",
      companyName: "CareTrust REIT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctrm",
      code: "NASDAQ:CTRM",
      companyName: "Castor Maritime Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctrn",
      code: "NASDAQ:CTRN",
      companyName: "Citi Trends Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cts",
      code: "NASDAQ:CTS",
      companyName: "CTS Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctso",
      code: "NASDAQ:CTSO",
      companyName: "Cytosorbents Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctt",
      code: "NASDAQ:CTT",
      companyName: "CatchMark Timber Trust Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctv",
      code: "NASDAQ:CTV",
      companyName: "Innovid Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctva",
      code: "NASDAQ:CTVA",
      companyName: "Corteva Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctxr",
      code: "NASDAQ:CTXR",
      companyName: "Citius Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctxrw",
      code: "NASDAQ:CTXRW",
      companyName: "Citius Pharmaceuticals Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cubb",
      code: "NASDAQ:CUBB",
      companyName: "Customers Bancorp Inc 5.375% Subordinated Notes Due 2034",
      popularity: 0,
    },
    {
      slug: "nasdaq-cube",
      code: "NASDAQ:CUBE",
      companyName: "CubeSmart Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cubi",
      code: "NASDAQ:CUBI",
      companyName: "Customers Bancorp Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cubi-e",
      code: "NASDAQ:CUBI-E",
      companyName:
        "Customers Bancorp Inc Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-cubi-f",
      code: "NASDAQ:CUBI-F",
      companyName:
        "Customers Bancorp Inc Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nasdaq-cue",
      code: "NASDAQ:CUE",
      companyName: "Cue Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cuen",
      code: "NASDAQ:CUEN",
      companyName: "Cuentas Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cuenw",
      code: "NASDAQ:CUENW",
      companyName: "Cuentas Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cuk",
      code: "NASDAQ:CUK",
      companyName: "Carnival Plc ADS ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-cull",
      code: "NASDAQ:CULL",
      companyName: "Cullman Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-culp",
      code: "NASDAQ:CULP",
      companyName: "Culp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-curiw",
      code: "NASDAQ:CURIW",
      companyName: "CuriosityStream Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-curo",
      code: "NASDAQ:CURO",
      companyName: "CURO Group Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-curv",
      code: "NASDAQ:CURV",
      companyName: "Torrid Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cutr",
      code: "NASDAQ:CUTR",
      companyName: "Cutera Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cuz",
      code: "NASDAQ:CUZ",
      companyName: "Cousins Properties Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvac",
      code: "NASDAQ:CVAC",
      companyName: "CureVac N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvbf",
      code: "NASDAQ:CVBF",
      companyName: "CVB Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvco",
      code: "NASDAQ:CVCO",
      companyName: "Cavco Industries Inc. Common Stock When Issued",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvcy",
      code: "NASDAQ:CVCY",
      companyName: "Central Valley Community Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cve",
      code: "NASDAQ:CVE",
      companyName: "Cenovus Energy Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cveo",
      code: "NASDAQ:CVEO",
      companyName: "Civeo Corporation (Canada) Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvet",
      code: "NASDAQ:CVET",
      companyName: "Covetrus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvgi",
      code: "NASDAQ:CVGI",
      companyName: "Commercial Vehicle Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvgw",
      code: "NASDAQ:CVGW",
      companyName: "Calavo Growers Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvi",
      code: "NASDAQ:CVI",
      companyName: "CVR Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvii",
      code: "NASDAQ:CVII",
      companyName: "Churchill Capital Corp VII Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvlg",
      code: "NASDAQ:CVLG",
      companyName: "Covenant Logistics Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvlt",
      code: "NASDAQ:CVLT",
      companyName: "Commvault Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvly",
      code: "NASDAQ:CVLY",
      companyName: "Codorus Valley Bancorp Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvm",
      code: "NASDAQ:CVM",
      companyName: "Cel-Sci Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvr",
      code: "NASDAQ:CVR",
      companyName: "Chicago Rivet & Machine Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvrx",
      code: "NASDAQ:CVRX",
      companyName: "CVRx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvs",
      code: "NASDAQ:CVS",
      companyName: "CVS Health Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvt",
      code: "NASDAQ:CVT",
      companyName: "Cvent Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvu",
      code: "NASDAQ:CVU",
      companyName: "CPI Aerostructures Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvv",
      code: "NASDAQ:CVV",
      companyName: "CVD Equipment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cw",
      code: "NASDAQ:CW",
      companyName: "Curtiss-Wright Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cwan",
      code: "NASDAQ:CWAN",
      companyName: "Clearwater Analytics Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cvx",
      code: "NASDAQ:CVX",
      companyName: "Chevron Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cwbr",
      code: "NASDAQ:CWBR",
      companyName: "CohBar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cwco",
      code: "NASDAQ:CWCO",
      companyName: "Consolidated Water Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cwen",
      code: "NASDAQ:CWEN",
      companyName: "Clearway Energy Inc. Class C Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cwh",
      code: "NASDAQ:CWH",
      companyName: "Camping World Holdings Inc. Class A Commom Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cwk",
      code: "NASDAQ:CWK",
      companyName: "Cushman & Wakefield plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cwst",
      code: "NASDAQ:CWST",
      companyName: "Casella Waste Systems Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cwt",
      code: "NASDAQ:CWT",
      companyName: "California Water Service Group Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cx",
      code: "NASDAQ:CX",
      companyName: "Cemex S.A.B. de C.V. Sponsored ADR",
      popularity: 0,
    },
    {
      slug: "nasdaq-cxac",
      code: "NASDAQ:CXAC",
      companyName: "C5 Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cxdo",
      code: "NASDAQ:CXDO",
      companyName: "Crexendo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cxe",
      code: "NASDAQ:CXE",
      companyName: "MFS High Income Municipal Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cxh",
      code: "NASDAQ:CXH",
      companyName: "MFS Investment Grade Municipal Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cxm",
      code: "NASDAQ:CXM",
      companyName: "Sprinklr Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-curi",
      code: "NASDAQ:CURI",
      companyName: "CuriosityStream Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cxw",
      code: "NASDAQ:CXW",
      companyName: "CoreCivic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyad",
      code: "NASDAQ:CYAD",
      companyName: "Celyad Oncology SA American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cybr",
      code: "NASDAQ:CYBR",
      companyName: "CyberArk Software Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cycc",
      code: "NASDAQ:CYCC",
      companyName: "Cyclacel Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyccp",
      code: "NASDAQ:CYCCP",
      companyName:
        "Cyclacel Pharmaceuticals Inc. 6% Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cycn",
      code: "NASDAQ:CYCN",
      companyName: "Cyclerion Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyd",
      code: "NASDAQ:CYD",
      companyName: "China Yuchai International Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyh",
      code: "NASDAQ:CYH",
      companyName: "Community Health Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyrn",
      code: "NASDAQ:CYRN",
      companyName: "CYREN Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyrx",
      code: "NASDAQ:CYRX",
      companyName: "CryoPort Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyt",
      code: "NASDAQ:CYT",
      companyName: "Cyteir Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyth",
      code: "NASDAQ:CYTH",
      companyName: "Cyclo Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cytk",
      code: "NASDAQ:CYTK",
      companyName: "Cytokinetics Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyto",
      code: "NASDAQ:CYTO",
      companyName: "Altamira Therapeutics Ltd. Common Shares 0.01 SF (Bermuda)",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyxt",
      code: "NASDAQ:CYXT",
      companyName: "Cyxtera Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cznc",
      code: "NASDAQ:CZNC",
      companyName: "Citizens & Northern Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-czoo",
      code: "NASDAQ:CZOO",
      companyName: "Cazoo Group Ltd Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-czr",
      code: "NASDAQ:CZR",
      companyName: "Caesars Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-czwi",
      code: "NASDAQ:CZWI",
      companyName: "Citizens Community Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-d",
      code: "NASDAQ:D",
      companyName: "Dominion Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dac",
      code: "NASDAQ:DAC",
      companyName: "Danaos Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dada",
      code: "NASDAQ:DADA",
      companyName: "Dada Nexus Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-daio",
      code: "NASDAQ:DAIO",
      companyName: "Data I/O Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dakt",
      code: "NASDAQ:DAKT",
      companyName: "Daktronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dal",
      code: "NASDAQ:DAL",
      companyName: "Delta Air Lines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-daln",
      code: "NASDAQ:DALN",
      companyName: "DallasNews Corporation Series A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dals",
      code: "NASDAQ:DALS",
      companyName:
        "DA32 Life Science Tech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dan",
      code: "NASDAQ:DAN",
      companyName: "Dana Incorporated Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-dao",
      code: "NASDAQ:DAO",
      companyName:
        "Youdao Inc. American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-daoo",
      code: "NASDAQ:DAOO",
      companyName: "Crypto 1 Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-daoou",
      code: "NASDAQ:DAOOU",
      companyName: "Crypto 1 Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-daoow",
      code: "NASDAQ:DAOOW",
      companyName: "Crypto 1 Acquisition Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-dar",
      code: "NASDAQ:DAR",
      companyName: "Darling Ingredients Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dare",
      code: "NASDAQ:DARE",
      companyName: "Dare Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dats",
      code: "NASDAQ:DATS",
      companyName: "DatChat Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-datsw",
      code: "NASDAQ:DATSW",
      companyName: "DatChat Inc. Series A Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dava",
      code: "NASDAQ:DAVA",
      companyName:
        "Endava plc American Depositary Shares (each representing one Class A Ordinary Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-dave",
      code: "NASDAQ:DAVE",
      companyName: "Dave Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-davew",
      code: "NASDAQ:DAVEW",
      companyName: "Dave Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-dawn",
      code: "NASDAQ:DAWN",
      companyName: "Day One Biopharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbd",
      code: "NASDAQ:DBD",
      companyName: "Diebold Nixdorf Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbgi",
      code: "NASDAQ:DBGI",
      companyName: "Digital Brands Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbgiw",
      code: "NASDAQ:DBGIW",
      companyName: "Digital Brands Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbi",
      code: "NASDAQ:DBI",
      companyName: "Designer Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbl",
      code: "NASDAQ:DBL",
      companyName:
        "DoubleLine Opportunistic Credit Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbrg",
      code: "NASDAQ:DBRG",
      companyName: "DigitalBridge Group Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbrg-h",
      code: "NASDAQ:DBRG-H",
      companyName: "DigitalBridge Group Inc. 7.125% Series H",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbrg-i",
      code: "NASDAQ:DBRG-I",
      companyName: "DigitalBridge Group Inc. 7.15% Series I",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbrg-j",
      code: "NASDAQ:DBRG-J",
      companyName: "DigitalBridge Group Inc. 7.125% Series J",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbtx",
      code: "NASDAQ:DBTX",
      companyName: "Decibel Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbvt",
      code: "NASDAQ:DBVT",
      companyName: "DBV Technologies S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dbx",
      code: "NASDAQ:DBX",
      companyName: "Dropbox Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dc",
      code: "NASDAQ:DC",
      companyName: "Dakota Gold Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcbo",
      code: "NASDAQ:DCBO",
      companyName: "Docebo Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcfcw",
      code: "NASDAQ:DCFCW",
      companyName: "Tritium DCFC Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-db",
      code: "NASDAQ:DB",
      companyName: "Deutsche Bank AG Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcgo",
      code: "NASDAQ:DCGO",
      companyName: "DocGo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcgow",
      code: "NASDAQ:DCGOW",
      companyName: "DocGo Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-dci",
      code: "NASDAQ:DCI",
      companyName: "Donaldson Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dco",
      code: "NASDAQ:DCO",
      companyName: "Ducommun Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcom",
      code: "NASDAQ:DCOM",
      companyName: "Dime Community Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ddog",
      code: "NASDAQ:DDOG",
      companyName: "Datadog Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcomp",
      code: "NASDAQ:DCOMP",
      companyName:
        "Dime Community Bancshares Inc. Fixed-Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcp",
      code: "NASDAQ:DCP",
      companyName: "DCP Midstream  LP Common Units ",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcp-b",
      code: "NASDAQ:DCP-B",
      companyName:
        "DCP Midstream LP 7.875% Series B Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcp-c",
      code: "NASDAQ:DCP-C",
      companyName:
        "DCP Midstream LP 7.95% Series C Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcph",
      code: "NASDAQ:DCPH",
      companyName: "Deciphera Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcrd",
      code: "NASDAQ:DCRD",
      companyName:
        "Decarbonization Plus Acquisition Corporation IV Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcrdw",
      code: "NASDAQ:DCRDW",
      companyName: "Decarbonization Plus Acquisition Corporation IV Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dct",
      code: "NASDAQ:DCT",
      companyName: "Duck Creek Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcth",
      code: "NASDAQ:DCTH",
      companyName: "Delcath Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcue",
      code: "NASDAQ:DCUE",
      companyName: "Dominion Energy Inc. 2019 Series A Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-dd",
      code: "NASDAQ:DD",
      companyName: "DuPont de Nemours Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ddd",
      code: "NASDAQ:DDD",
      companyName: "3D Systems Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ddf",
      code: "NASDAQ:DDF",
      companyName:
        "Delaware Investments Dividend & Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ddi",
      code: "NASDAQ:DDI",
      companyName: "DoubleDown Interactive Co. Ltd. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ddl",
      code: "NASDAQ:DDL",
      companyName:
        "Dingdong (Cayman) Limited American Depositary Shares (each two representing three Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-dds",
      code: "NASDAQ:DDS",
      companyName: "Dillard's Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ddt",
      code: "NASDAQ:DDT",
      companyName: "Dillard's Capital Trust I",
      popularity: 0,
    },
    {
      slug: "nasdaq-dea",
      code: "NASDAQ:DEA",
      companyName: "Easterly Government Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-decau",
      code: "NASDAQ:DECAU",
      companyName: "Denali Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-deck",
      code: "NASDAQ:DECK",
      companyName: "Deckers Outdoor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dei",
      code: "NASDAQ:DEI",
      companyName: "Douglas Emmett Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dell",
      code: "NASDAQ:DELL",
      companyName: "Dell Technologies Inc. Class C Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-den",
      code: "NASDAQ:DEN",
      companyName: "Denbury Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-denn",
      code: "NASDAQ:DENN",
      companyName: "Denny's Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-deo",
      code: "NASDAQ:DEO",
      companyName: "Diageo plc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-derm",
      code: "NASDAQ:DERM",
      companyName: "Journey Medical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-desp",
      code: "NASDAQ:DESP",
      companyName: "Despegar.com Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dex",
      code: "NASDAQ:DEX",
      companyName:
        "Delaware Enhanced Global Dividend Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-dffn",
      code: "NASDAQ:DFFN",
      companyName: "Diffusion Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dfh",
      code: "NASDAQ:DFH",
      companyName: "Dream Finders Homes Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dfin",
      code: "NASDAQ:DFIN",
      companyName: "Donnelley Financial Solutions Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-dfp",
      code: "NASDAQ:DFP",
      companyName:
        "Flaherty & Crumrine Dynamic Preferred and Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dfs",
      code: "NASDAQ:DFS",
      companyName: "Discover Financial Services Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-de",
      code: "NASDAQ:DE",
      companyName: "Deere & Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dghi",
      code: "NASDAQ:DGHI",
      companyName: "Digihost Technology Inc. Common Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dgica",
      code: "NASDAQ:DGICA",
      companyName: "Donegal Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dgicb",
      code: "NASDAQ:DGICB",
      companyName: "Donegal Group Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dgii",
      code: "NASDAQ:DGII",
      companyName: "Digi International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dgly",
      code: "NASDAQ:DGLY",
      companyName: "Digital Ally Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dgnu",
      code: "NASDAQ:DGNU",
      companyName:
        "Dragoneer Growth Opportunities Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dgx",
      code: "NASDAQ:DGX",
      companyName: "Quest Diagnostics Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dh",
      code: "NASDAQ:DH",
      companyName: "Definitive Healthcare Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhac",
      code: "NASDAQ:DHAC",
      companyName: "Digital Health Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhacu",
      code: "NASDAQ:DHACU",
      companyName: "Digital Health Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhacw",
      code: "NASDAQ:DHACW",
      companyName: "Digital Health Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhbc",
      code: "NASDAQ:DHBC",
      companyName: "DHB Capital Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhbcu",
      code: "NASDAQ:DHBCU",
      companyName: "DHB Capital Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhhcu",
      code: "NASDAQ:DHHCU",
      companyName: "DiamondHead Holdings Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhr-b",
      code: "NASDAQ:DHR-B",
      companyName:
        "Danaher Corporation 5.00% Mandatory Convertible Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhx",
      code: "NASDAQ:DHX",
      companyName: "DHI Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhy",
      code: "NASDAQ:DHY",
      companyName: "Credit Suisse High Yield Bond Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhhcw",
      code: "NASDAQ:DHHCW",
      companyName: "DiamondHead Holdings Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhil",
      code: "NASDAQ:DHIL",
      companyName: "Diamond Hill Investment Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhr",
      code: "NASDAQ:DHR",
      companyName: "Danaher Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-diax",
      code: "NASDAQ:DIAX",
      companyName:
        "Nuveen Dow 30SM Dynamic Overwrite Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-dibs",
      code: "NASDAQ:DIBS",
      companyName: "1stdibs.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlr",
      code: "NASDAQ:DLR",
      companyName: "Digital Realty Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-didi",
      code: "NASDAQ:DIDI",
      companyName:
        "DiDi Global Inc. American Depositary Shares (each four representing one Class A Ordinary Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-dilaw",
      code: "NASDAQ:DILAW",
      companyName: "DILA Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-din",
      code: "NASDAQ:DIN",
      companyName: "Dine Brands Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dino",
      code: "NASDAQ:DINO",
      companyName: "HF Sinclair Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-diod",
      code: "NASDAQ:DIOD",
      companyName: "Diodes Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dis",
      code: "NASDAQ:DIS",
      companyName: "Walt Disney Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-disa",
      code: "NASDAQ:DISA",
      companyName:
        "Disruptive Acquisition Corporation I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-disau",
      code: "NASDAQ:DISAU",
      companyName: "Disruptive Acquisition Corporation I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-disaw",
      code: "NASDAQ:DISAW",
      companyName: "Disruptive Acquisition Corporation I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dish",
      code: "NASDAQ:DISH",
      companyName: "DISH Network Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dit",
      code: "NASDAQ:DIT",
      companyName: "AMCON Distributing Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-djco",
      code: "NASDAQ:DJCO",
      companyName: "Daily Journal Corp. (S.C.) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dk",
      code: "NASDAQ:DK",
      companyName: "Delek US Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dkdca",
      code: "NASDAQ:DKDCA",
      companyName: "Data Knights Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dkdcw",
      code: "NASDAQ:DKDCW",
      companyName: "Data Knights Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dkl",
      code: "NASDAQ:DKL",
      companyName:
        "Delek Logistics Partners L.P. Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-dkng",
      code: "NASDAQ:DKNG",
      companyName: "DraftKings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dks",
      code: "NASDAQ:DKS",
      companyName: "Dick's Sporting Goods Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dla",
      code: "NASDAQ:DLA",
      companyName: "Delta Apparel Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlb",
      code: "NASDAQ:DLB",
      companyName: "Dolby Laboratories Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlca",
      code: "NASDAQ:DLCA",
      companyName:
        "Deep Lake Capital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlcau",
      code: "NASDAQ:DLCAU",
      companyName: "Deep Lake Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlcaw",
      code: "NASDAQ:DLCAW",
      companyName: "Deep Lake Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlhc",
      code: "NASDAQ:DLHC",
      companyName: "DLH Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlng",
      code: "NASDAQ:DLNG",
      companyName: "Dynagas LNG Partners LP Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlng-a",
      code: "NASDAQ:DLNG-A",
      companyName:
        "Dynagas LNG Partners LP 9.00% Series A Cumulative Redeemable Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlng-b",
      code: "NASDAQ:DLNG-B",
      companyName:
        "Dynagas LNG Partners LP 8.75% Series B Fixed to Floating Rate Cumulative Redeemable Perpetual Preferred Units liquidation preference $25.00 per Uni",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlo",
      code: "NASDAQ:DLO",
      companyName: "DLocal Limited Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlpn",
      code: "NASDAQ:DLPN",
      companyName: "Dolphin Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlr-j",
      code: "NASDAQ:DLR-J",
      companyName:
        "Digital Realty Trust Inc. 5.250% Series J Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlr-k",
      code: "NASDAQ:DLR-K",
      companyName:
        "Digital Realty Trust Inc. 5.850% Series K Cumulative Redeemable Preferred Stock par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-dltr",
      code: "NASDAQ:DLTR",
      companyName: "Dollar Tree Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlx",
      code: "NASDAQ:DLX",
      companyName: "Deluxe Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dly",
      code: "NASDAQ:DLY",
      companyName:
        "DoubleLine Yield Opportunities Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-dm",
      code: "NASDAQ:DM",
      companyName: "Desktop Metal Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dma",
      code: "NASDAQ:DMA",
      companyName: "Destra Multi-Alternative Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmac",
      code: "NASDAQ:DMAC",
      companyName: "DiaMedica Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmaq",
      code: "NASDAQ:DMAQ",
      companyName: "Deep Medicine Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmaqr",
      code: "NASDAQ:DMAQR",
      companyName: "Deep Medicine Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmb",
      code: "NASDAQ:DMB",
      companyName:
        "BNY Mellon Municipal Bond Infrastructure Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmf",
      code: "NASDAQ:DMF",
      companyName: "BNY Mellon Municipal Income Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmlp",
      code: "NASDAQ:DMLP",
      companyName:
        "Dorchester Minerals L.P. Common Units Representing Limited Partnership Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmo",
      code: "NASDAQ:DMO",
      companyName: "Western Asset Mortgage Opportunity Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmrc",
      code: "NASDAQ:DMRC",
      companyName: "Digimarc Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dms",
      code: "NASDAQ:DMS",
      companyName: "Digital Media Solutions Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmtk",
      code: "NASDAQ:DMTK",
      companyName: "DermTech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dmys",
      code: "NASDAQ:DMYS",
      companyName: "dMY Technology Group Inc. VI Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dna",
      code: "NASDAQ:DNA",
      companyName: "Ginkgo Bioworks Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnaa",
      code: "NASDAQ:DNAA",
      companyName:
        "Social Capital Suvretta Holdings Corp. I Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnab",
      code: "NASDAQ:DNAB",
      companyName:
        "Social Capital Suvretta Holdings Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnac",
      code: "NASDAQ:DNAC",
      companyName:
        "Social Capital Suvretta Holdings Corp. III Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnad",
      code: "NASDAQ:DNAD",
      companyName:
        "Social Capital Suvretta Holdings Corp. IV Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnay",
      code: "NASDAQ:DNAY",
      companyName: "Codex DNA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnb",
      code: "NASDAQ:DNB",
      companyName: "Dun & Bradstreet Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnli",
      code: "NASDAQ:DNLI",
      companyName: "Denali Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnmr",
      code: "NASDAQ:DNMR",
      companyName: "Danimer Scientific Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnn",
      code: "NASDAQ:DNN",
      companyName: "Denison Mines Corp Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnow",
      code: "NASDAQ:DNOW",
      companyName: "NOW Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnp",
      code: "NASDAQ:DNP",
      companyName: "DNP Select Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnut",
      code: "NASDAQ:DNUT",
      companyName: "Krispy Kreme Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dnz",
      code: "NASDAQ:DNZ",
      companyName: "D and Z Media Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-doc",
      code: "NASDAQ:DOC",
      companyName:
        "Physicians Realty Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-docn",
      code: "NASDAQ:DOCN",
      companyName: "DigitalOcean Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-docs",
      code: "NASDAQ:DOCS",
      companyName: "Doximity Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dogz",
      code: "NASDAQ:DOGZ",
      companyName: "Dogness (International) Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dole",
      code: "NASDAQ:DOLE",
      companyName: "Dole plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-doma",
      code: "NASDAQ:DOMA",
      companyName: "Doma Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-domo",
      code: "NASDAQ:DOMO",
      companyName: "Domo Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dooo",
      code: "NASDAQ:DOOO",
      companyName:
        "BRP Inc. (Recreational Products) Common Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-door",
      code: "NASDAQ:DOOR",
      companyName:
        "Masonite International Corporation Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-dorm",
      code: "NASDAQ:DORM",
      companyName: "Dorman Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-doug",
      code: "NASDAQ:DOUG",
      companyName: "Douglas Elliman Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dov",
      code: "NASDAQ:DOV",
      companyName: "Dover Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dox",
      code: "NASDAQ:DOX",
      companyName: "Amdocs Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-doyu",
      code: "NASDAQ:DOYU",
      companyName: "DouYu International Holdings Limited ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-dpcs",
      code: "NASDAQ:DPCS",
      companyName: "DP Cap Acquisition Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dpcsw",
      code: "NASDAQ:DPCSW",
      companyName: "DP Cap Acquisition Corp I Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-dpg",
      code: "NASDAQ:DPG",
      companyName: "Duff & Phelps Utility and Infrastructure Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-dpro",
      code: "NASDAQ:DPRO",
      companyName: "Draganfly Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dpsi",
      code: "NASDAQ:DPSI",
      companyName: "DecisionPoint Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dq",
      code: "NASDAQ:DQ",
      companyName:
        "DAQO New Energy Corp. American Depositary Shares each representing five ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dray",
      code: "NASDAQ:DRAY",
      companyName:
        "Macondray Capital Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-drayw",
      code: "NASDAQ:DRAYW",
      companyName: "Macondray Capital Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-drctw",
      code: "NASDAQ:DRCTW",
      companyName: "Direct Digital Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-drd",
      code: "NASDAQ:DRD",
      companyName: "DRDGOLD Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dre",
      code: "NASDAQ:DRE",
      companyName: "Duke Realty Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-drh-a",
      code: "NASDAQ:DRH-A",
      companyName:
        "Diamondrock Hospitality Company 8.250% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dri",
      code: "NASDAQ:DRI",
      companyName: "Darden Restaurants Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-drio",
      code: "NASDAQ:DRIO",
      companyName: "DarioHealth Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-drma",
      code: "NASDAQ:DRMA",
      companyName: "Dermata Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-drmaw",
      code: "NASDAQ:DRMAW",
      companyName: "Dermata Therapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-drq",
      code: "NASDAQ:DRQ",
      companyName: "Dril-Quip Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-drrx",
      code: "NASDAQ:DRRX",
      companyName: "DURECT Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-drts",
      code: "NASDAQ:DRTS",
      companyName: "Alpha Tau Medical Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-drtsw",
      code: "NASDAQ:DRTSW",
      companyName: "Alpha Tau Medical Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-drtt",
      code: "NASDAQ:DRTT",
      companyName: "DIRTT Environmental Solutions Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-drug",
      code: "NASDAQ:DRUG",
      companyName: "Bright Minds Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-drvn",
      code: "NASDAQ:DRVN",
      companyName: "Driven Brands Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ds",
      code: "NASDAQ:DS",
      companyName: "Drive Shack Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ds-b",
      code: "NASDAQ:DS-B",
      companyName: "Drive Shack Inc. Preferred Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-ds-c",
      code: "NASDAQ:DS-C",
      companyName: "Drive Shack Inc. Preferred Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-ds-d",
      code: "NASDAQ:DS-D",
      companyName: "Drive Shack Inc. Pfd Ser D",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsac",
      code: "NASDAQ:DSAC",
      companyName: "Duddell Street Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsacw",
      code: "NASDAQ:DSACW",
      companyName: "Duddell Street Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsaq",
      code: "NASDAQ:DSAQ",
      companyName: "Direct Selling Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsey",
      code: "NASDAQ:DSEY",
      companyName: "Diversey Holdings Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsgn",
      code: "NASDAQ:DSGN",
      companyName: "Design Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsgx",
      code: "NASDAQ:DSGX",
      companyName: "Descartes Systems Group Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dske",
      code: "NASDAQ:DSKE",
      companyName: "Daseke Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-do",
      code: "NASDAQ:DO",
      companyName: "Diamond Offshore Drilling Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-drh",
      code: "NASDAQ:DRH",
      companyName: "Diamondrock Hospitality Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsl",
      code: "NASDAQ:DSL",
      companyName:
        "DoubleLine Income Solutions Fund Common Shares of Beneficial Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsm",
      code: "NASDAQ:DSM",
      companyName: "BNY Mellon Strategic Municipal Bond Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsp",
      code: "NASDAQ:DSP",
      companyName: "Viant Technology Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dss",
      code: "NASDAQ:DSS",
      companyName: "DSS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsu",
      code: "NASDAQ:DSU",
      companyName: "Blackrock Debt Strategies Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dswl",
      code: "NASDAQ:DSWL",
      companyName: "Deswell Industries Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsx",
      code: "NASDAQ:DSX",
      companyName: "Diana Shipping inc. common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dsx-b",
      code: "NASDAQ:DSX-B",
      companyName:
        "Diana Shipping Inc. Perpetual Preferred Shares Series B (Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-dt",
      code: "NASDAQ:DT",
      companyName: "Dynatrace Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtb",
      code: "NASDAQ:DTB",
      companyName:
        "DTE Energy Company 2020 Series G 4.375% Junior Subordinated Debentures due 2080",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtc",
      code: "NASDAQ:DTC",
      companyName: "Solo Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dte",
      code: "NASDAQ:DTE",
      companyName: "DTE Energy Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtea",
      code: "NASDAQ:DTEA",
      companyName: "DAVIDsTEA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtf",
      code: "NASDAQ:DTF",
      companyName: "DTF Tax-Free Income 2028 Term Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtg",
      code: "NASDAQ:DTG",
      companyName:
        "DTE Energy Company 2021 Series E 4.375% Junior Subordinated Debentures",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtil",
      code: "NASDAQ:DTIL",
      companyName: "Precision BioSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtm",
      code: "NASDAQ:DTM",
      companyName: "DT Midstream Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtoc",
      code: "NASDAQ:DTOC",
      companyName:
        "Digital Transformation Opportunities Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtocu",
      code: "NASDAQ:DTOCU",
      companyName: "Digital Transformation Opportunities Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtocw",
      code: "NASDAQ:DTOCW",
      companyName: "Digital Transformation Opportunities Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtp",
      code: "NASDAQ:DTP",
      companyName: "DTE Energy Company 6.25% Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtrt",
      code: "NASDAQ:DTRT",
      companyName: "DTRT Health Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtrtw",
      code: "NASDAQ:DTRTW",
      companyName: "DTRT Health Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtss",
      code: "NASDAQ:DTSS",
      companyName: "Datasea Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtst",
      code: "NASDAQ:DTST",
      companyName: "Data Storage Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtstw",
      code: "NASDAQ:DTSTW",
      companyName: "Data Storage Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dtw",
      code: "NASDAQ:DTW",
      companyName:
        "DTE Energy Company 2017 Series E 5.25% Junior Subordinated Debentures due 2077",
      popularity: 0,
    },
    {
      slug: "nasdaq-duet",
      code: "NASDAQ:DUET",
      companyName: "DUET Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-duk",
      code: "NASDAQ:DUK",
      companyName: "Duke Energy Corporation (Holding Company) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-duk-a",
      code: "NASDAQ:DUK-A",
      companyName:
        "Duke Energy Corporation Depositary Shares each representing a 1/1000th interest in a share of 5.75% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dune",
      code: "NASDAQ:DUNE",
      companyName: "Dune Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-duneu",
      code: "NASDAQ:DUNEU",
      companyName: "Dune Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-dunew",
      code: "NASDAQ:DUNEW",
      companyName: "Dune Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-duo",
      code: "NASDAQ:DUO",
      companyName: "Fangdd Network Group Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-duot",
      code: "NASDAQ:DUOT",
      companyName: "Duos Technologies Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dv",
      code: "NASDAQ:DV",
      companyName: "DoubleVerify Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dva",
      code: "NASDAQ:DVA",
      companyName: "DaVita Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dvax",
      code: "NASDAQ:DVAX",
      companyName: "Dynavax Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dvn",
      code: "NASDAQ:DVN",
      companyName: "Devon Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dwac",
      code: "NASDAQ:DWAC",
      companyName: "Digital World Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dwacu",
      code: "NASDAQ:DWACU",
      companyName: "Digital World Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-dwacw",
      code: "NASDAQ:DWACW",
      companyName: "Digital World Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-dwin",
      code: "NASDAQ:DWIN",
      companyName: "Delwinds Insurance Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dwsn",
      code: "NASDAQ:DWSN",
      companyName: "Dawson Geophysical Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dx",
      code: "NASDAQ:DX",
      companyName: "Dynex Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dx-c",
      code: "NASDAQ:DX-C",
      companyName:
        "Dynex Capital Inc. 6.900% Series C Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dxc",
      code: "NASDAQ:DXC",
      companyName: "DXC Technology Company Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-dxf",
      code: "NASDAQ:DXF",
      companyName:
        "Dunxin Financial Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dxlg",
      code: "NASDAQ:DXLG",
      companyName: "Destination XL Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dxpe",
      code: "NASDAQ:DXPE",
      companyName: "DXP Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dxr",
      code: "NASDAQ:DXR",
      companyName: "Daxor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dxyn",
      code: "NASDAQ:DXYN",
      companyName: "Dixie Group Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dy",
      code: "NASDAQ:DY",
      companyName: "Dycom Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dyai",
      code: "NASDAQ:DYAI",
      companyName: "Dyadic International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dyfn",
      code: "NASDAQ:DYFN",
      companyName:
        "Angel Oak Dynamic Financial Strategies Income Term Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-dyn",
      code: "NASDAQ:DYN",
      companyName: "Dyne Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dyns",
      code: "NASDAQ:DYNS",
      companyName: "Dynamics Special Purpose Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dynt",
      code: "NASDAQ:DYNT",
      companyName: "Dynatronics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dzsi",
      code: "NASDAQ:DZSI",
      companyName: "DZS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-e",
      code: "NASDAQ:E",
      companyName: "ENI S.p.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ea",
      code: "NASDAQ:EA",
      companyName: "Electronic Arts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eac",
      code: "NASDAQ:EAC",
      companyName: "Edify Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eacpu",
      code: "NASDAQ:EACPU",
      companyName: "Edify Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-eacpw",
      code: "NASDAQ:EACPW",
      companyName: "Edify Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ead",
      code: "NASDAQ:EAD",
      companyName: "Allspring Income Opportunities Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eaf",
      code: "NASDAQ:EAF",
      companyName: "GrafTech International Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eai",
      code: "NASDAQ:EAI",
      companyName:
        "Entergy Arkansas LLC First Mortgage Bonds 4.875% Series Due September 1 2066",
      popularity: 0,
    },
    {
      slug: "nasdaq-ear",
      code: "NASDAQ:EAR",
      companyName: "Eargo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-earn",
      code: "NASDAQ:EARN",
      companyName:
        "Ellington Residential Mortgage REIT Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-east",
      code: "NASDAQ:EAST",
      companyName: "Eastside Distilling Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eat",
      code: "NASDAQ:EAT",
      companyName: "Brinker International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eb",
      code: "NASDAQ:EB",
      companyName: "Eventbrite Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebac",
      code: "NASDAQ:EBAC",
      companyName: "European Biotech Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebacu",
      code: "NASDAQ:EBACU",
      companyName: "European Biotech Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebacw",
      code: "NASDAQ:EBACW",
      companyName: "European Biotech Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecl",
      code: "NASDAQ:ECL",
      companyName: "Ecolab Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebc",
      code: "NASDAQ:EBC",
      companyName: "Eastern Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebet",
      code: "NASDAQ:EBET",
      companyName: "EBET INC. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebf",
      code: "NASDAQ:EBF",
      companyName: "Ennis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebix",
      code: "NASDAQ:EBIX",
      companyName: "Ebix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebmt",
      code: "NASDAQ:EBMT",
      companyName: "Eagle Bancorp Montana Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebon",
      code: "NASDAQ:EBON",
      companyName: "Ebang International Holdings Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebr",
      code: "NASDAQ:EBR",
      companyName:
        "Centrais Electricas Brasileiras S A American Depositary Shares (Each representing one Common Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebs",
      code: "NASDAQ:EBS",
      companyName: "Emergent Biosolutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ebtc",
      code: "NASDAQ:EBTC",
      companyName: "Enterprise Bancorp Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ec",
      code: "NASDAQ:EC",
      companyName: "Ecopetrol S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecat",
      code: "NASDAQ:ECAT",
      companyName:
        "BlackRock ESG Capital Allocation Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecc",
      code: "NASDAQ:ECC           ",
      companyName: "Eagle Point Credit Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecc-d",
      code: "NASDAQ:ECC-D",
      companyName:
        "Eagle Point Credit Company Inc. 6.75% Series D Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eccc",
      code: "NASDAQ:ECCC",
      companyName:
        "Eagle Point Credit Company Inc. 6.50% Series C Term Preferred Stock due 2031",
      popularity: 0,
    },
    {
      slug: "nasdaq-eccv",
      code: "NASDAQ:ECCV",
      companyName: "Eagle Point Credit Company Inc. 5.375% Notes due 2029",
      popularity: 0,
    },
    {
      slug: "nasdaq-eccw",
      code: "NASDAQ:ECCW",
      companyName: "Eagle Point Credit Company Inc. 6.75% Notes due 2031",
      popularity: 0,
    },
    {
      slug: "nasdaq-eccx",
      code: "NASDAQ:ECCX",
      companyName: "Eagle Point Credit Company Inc. 6.6875% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecom",
      code: "NASDAQ:ECOM          ",
      companyName: "ChannelAdvisor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecor",
      code: "NASDAQ:ECOR",
      companyName: "electroCore Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecpg",
      code: "NASDAQ:ECPG",
      companyName: "Encore Capital Group Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecvt",
      code: "NASDAQ:ECVT",
      companyName: "Ecovyst Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ed",
      code: "NASDAQ:ED",
      companyName: "Consolidated Edison Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-edap",
      code: "NASDAQ:EDAP",
      companyName: "EDAP TMS S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-edbl",
      code: "NASDAQ:EDBL",
      companyName: "Edible Garden AG Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-edblw",
      code: "NASDAQ:EDBLW",
      companyName: "Edible Garden AG Incorporated Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-edd",
      code: "NASDAQ:EDD",
      companyName:
        "Morgan Stanley Emerging Markets Domestic Debt Fund Inc. Morgan Stanley Emerging Markets Domestic Debt Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-edf",
      code: "NASDAQ:EDF",
      companyName:
        "Virtus Stone Harbor Emerging Markets Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-edi",
      code: "NASDAQ:EDI",
      companyName:
        "Virtus Stone Harbor Emerging Markets Total Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-edit",
      code: "NASDAQ:EDIT",
      companyName: "Editas Medicine Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-edn",
      code: "NASDAQ:EDN",
      companyName:
        "Empresa Distribuidora Y Comercializadora Norte S.A. (Edenor) Empresa Distribuidora Y Comercializadora Norte S.A. (Edenor) American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ednc",
      code: "NASDAQ:EDNC",
      companyName: "Endurance Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-edncu",
      code: "NASDAQ:EDNCU",
      companyName: "Endurance Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-edr",
      code: "NASDAQ:EDR",
      companyName: "Endeavor Group Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-edry",
      code: "NASDAQ:EDRY",
      companyName: "EuroDry Ltd. Common Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-edsa",
      code: "NASDAQ:EDSA",
      companyName: "Edesa Biotech Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-edtk",
      code: "NASDAQ:EDTK",
      companyName:
        "Skillful Craftsman Education Technology Limited Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-edtx",
      code: "NASDAQ:EDTX",
      companyName: "EdtechX Holdings Acquisition Corp. II Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-edtxw",
      code: "NASDAQ:EDTXW",
      companyName: "EdtechX Holdings Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-edu",
      code: "NASDAQ:EDU",
      companyName:
        "New Oriental Education & Technology Group Inc. Sponsored ADR representing 10 Ordinary Share (Cayman Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-educ",
      code: "NASDAQ:EDUC",
      companyName: "Educational Development Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ee",
      code: "NASDAQ:EE",
      companyName: "Excelerate Energy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eea",
      code: "NASDAQ:EEA",
      companyName: "The European Equity Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eeft",
      code: "NASDAQ:EEFT",
      companyName: "Euronet Worldwide Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eeiq",
      code: "NASDAQ:EEIQ",
      companyName: "Elite Education Group International Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eex",
      code: "NASDAQ:EEX",
      companyName: "Emerald Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-efc",
      code: "NASDAQ:EFC",
      companyName: "Ellington Financial Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-efc-a",
      code: "NASDAQ:EFC-A",
      companyName:
        "Ellington Financial Inc. 6.750% Series A Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-efc-b",
      code: "NASDAQ:EFC-B",
      companyName:
        "Ellington Financial Inc. 6.250% Series B Fixed-Rate Reset Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-efl",
      code: "NASDAQ:EFL",
      companyName:
        "Eaton Vance Floating-Rate 2022 Target Term Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-efoi",
      code: "NASDAQ:EFOI",
      companyName: "Energy Focus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-efr",
      code: "NASDAQ:EFR",
      companyName:
        "Eaton Vance Senior Floating-Rate Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-efsc",
      code: "NASDAQ:EFSC",
      companyName: "Enterprise Financial Services Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-efscp",
      code: "NASDAQ:EFSCP",
      companyName:
        "Enterprise Financial Services Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of 5% Fixed Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-eft",
      code: "NASDAQ:EFT",
      companyName:
        "Eaton Vance Floating Rate Income Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-eftr",
      code: "NASDAQ:EFTR",
      companyName: "eFFECTOR Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eftrw",
      code: "NASDAQ:EFTRW",
      companyName: "eFFECTOR Therapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-efx",
      code: "NASDAQ:EFX",
      companyName: "Equifax Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-egan",
      code: "NASDAQ:EGAN",
      companyName: "eGain Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-egbn",
      code: "NASDAQ:EGBN",
      companyName: "Eagle Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-egf",
      code: "NASDAQ:EGF",
      companyName: "Blackrock Enhanced Government Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eggf",
      code: "NASDAQ:EGGF",
      companyName: "EG Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eght",
      code: "NASDAQ:EGHT",
      companyName: "8x8 Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-egle",
      code: "NASDAQ:EGLE",
      companyName: "Eagle Bulk Shipping Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eglx",
      code: "NASDAQ:EGLX",
      companyName: "Enthusiast Gaming Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ego",
      code: "NASDAQ:EGO",
      companyName: "Eldorado Gold Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-egp",
      code: "NASDAQ:EGP",
      companyName: "EastGroup Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-egrx",
      code: "NASDAQ:EGRX",
      companyName: "Eagle Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eh",
      code: "NASDAQ:EH",
      companyName: "EHang Holdings Limited ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-ehc",
      code: "NASDAQ:EHC",
      companyName: "Encompass Health Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ehi",
      code: "NASDAQ:EHI",
      companyName: "Western Asset Global High Income Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ehth",
      code: "NASDAQ:EHTH",
      companyName: "eHealth Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eic",
      code: "NASDAQ:EIC",
      companyName: "Eagle Point Income Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eica",
      code: "NASDAQ:EICA",
      companyName:
        "Eagle Point Income Company Inc. 5.00% Series A Term Preferred Stock due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-eig",
      code: "NASDAQ:EIG",
      companyName: "Employers Holdings Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eigr",
      code: "NASDAQ:EIGR",
      companyName: "Eiger BioPharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eim",
      code: "NASDAQ:EIM",
      companyName:
        "Eaton Vance Municipal Bond Fund Common Shares of Beneficial Interest $.01 par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-eix",
      code: "NASDAQ:EIX",
      companyName: "Edison International Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ejfa",
      code: "NASDAQ:EJFA",
      companyName: "EJF Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ejfaw",
      code: "NASDAQ:EJFAW",
      companyName: "EJF Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ejh",
      code: "NASDAQ:EJH",
      companyName: "E-Home Household Service Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ekso",
      code: "NASDAQ:EKSO",
      companyName: "Ekso Bionics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ela",
      code: "NASDAQ:ELA",
      companyName: "Envela Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elan",
      code: "NASDAQ:ELAN",
      companyName: "Elanco Animal Health Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elat",
      code: "NASDAQ:ELAT",
      companyName:
        "Elanco Animal Health Incorporated 5.00% Tangible Equity Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-elbm",
      code: "NASDAQ:ELBM",
      companyName: "Electra Battery Materials Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elc",
      code: "NASDAQ:ELC",
      companyName:
        "Entergy Louisiana Inc. Collateral Trust Mortgage Bonds 4.875 % Series due September 1 2066",
      popularity: 0,
    },
    {
      slug: "nasdaq-eldn",
      code: "NASDAQ:ELDN",
      companyName: "Eledon Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elev",
      code: "NASDAQ:ELEV",
      companyName: "Elevation Oncology Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elf",
      code: "NASDAQ:ELF",
      companyName: "e.l.f. Beauty Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ello",
      code: "NASDAQ:ELLO",
      companyName: "Ellomay Capital Ltd Ordinary Shares (Israel)",
      popularity: 0,
    },
    {
      slug: "nasdaq-elmd",
      code: "NASDAQ:ELMD",
      companyName: "Electromed Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elms",
      code: "NASDAQ:ELMS",
      companyName: "Electric Last Mile Solutions Inc. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elmsw",
      code: "NASDAQ:ELMSW",
      companyName: "Electric Last Mile Solutions Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-elox",
      code: "NASDAQ:ELOX",
      companyName: "Eloxx Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elp",
      code: "NASDAQ:ELP",
      companyName:
        "Companhia Paranaense de Energia (COPEL) American Depositary Shares (each representing one Unit consisting one Common Share and four non-voting Class B Preferred Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-els",
      code: "NASDAQ:ELS",
      companyName: "Equity Lifestyle Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-else",
      code: "NASDAQ:ELSE",
      companyName: "Electro-Sensors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eltk",
      code: "NASDAQ:ELTK",
      companyName: "Eltek Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-elvt",
      code: "NASDAQ:ELVT",
      companyName: "Elevate Credit Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ely",
      code: "NASDAQ:ELY",
      companyName: "Callaway Golf Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elym",
      code: "NASDAQ:ELYM",
      companyName: "Eliem Therapeutics Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-elys",
      code: "NASDAQ:ELYS",
      companyName: "Elys Game Technology Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-em",
      code: "NASDAQ:EM",
      companyName: "Smart Share Global Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eman",
      code: "NASDAQ:EMAN",
      companyName: "eMagin Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-embc",
      code: "NASDAQ:EMBC",
      companyName: "Embecta Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-embk",
      code: "NASDAQ:EMBK",
      companyName: "Embark Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-embkw",
      code: "NASDAQ:EMBKW",
      companyName: "Embark Technology Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-emcf",
      code: "NASDAQ:EMCF",
      companyName: "Emclaire Financial Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-emd",
      code: "NASDAQ:EMD",
      companyName: "Western Asset Emerging Markets Debt Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eme",
      code: "NASDAQ:EME",
      companyName: "EMCOR Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-emf",
      code: "NASDAQ:EMF",
      companyName: "Templeton Emerging Markets Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-emkr",
      code: "NASDAQ:EMKR",
      companyName: "EMCORE Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eml",
      code: "NASDAQ:EML",
      companyName: "Eastern Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-emld",
      code: "NASDAQ:EMLD",
      companyName: "FTAC Emerald Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-emldw",
      code: "NASDAQ:EMLDW",
      companyName: "FTAC Emerald Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-emn",
      code: "NASDAQ:EMN",
      companyName: "Eastman Chemical Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-emo",
      code: "NASDAQ:EMO",
      companyName:
        "ClearBridge Energy Midstream Opportunity Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-emp",
      code: "NASDAQ:EMP",
      companyName:
        "Entergy Mississippi LLC First Mortgage Bonds 4.90% Series Due October 1 2066",
      popularity: 0,
    },
    {
      slug: "nasdaq-emr",
      code: "NASDAQ:EMR",
      companyName: "Emerson Electric Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-emx",
      code: "NASDAQ:EMX",
      companyName: "EMX Royalty Corporation Common Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-encp",
      code: "NASDAQ:ENCP",
      companyName: "Energem Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-endp",
      code: "NASDAQ:ENDP",
      companyName: "Endo International plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ener",
      code: "NASDAQ:ENER",
      companyName: "Accretion Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eneru",
      code: "NASDAQ:ENERU",
      companyName: "Accretion Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-enerw",
      code: "NASDAQ:ENERW",
      companyName: "Accretion Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-enfn",
      code: "NASDAQ:ENFN",
      companyName: "Enfusion Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eng",
      code: "NASDAQ:ENG",
      companyName: "ENGlobal Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enic",
      code: "NASDAQ:ENIC",
      companyName:
        "Enel Chile S.A. American Depositary Shares (Each representing 50 shares of Common Stock)",
      popularity: 0,
    },
    {
      slug: "nasdaq-enj",
      code: "NASDAQ:ENJ",
      companyName:
        "Entergy New Orleans LLC First Mortgage Bonds 5.0% Series due December 1 2052",
      popularity: 0,
    },
    {
      slug: "nasdaq-enjy",
      code: "NASDAQ:ENJY",
      companyName: "Enjoy Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enjyw",
      code: "NASDAQ:ENJYW",
      companyName: "Enjoy Technology Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-enlc",
      code: "NASDAQ:ENLC",
      companyName:
        "EnLink Midstream LLC Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-enlv",
      code: "NASDAQ:ENLV",
      companyName: "Enlivex Therapeutics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eno",
      code: "NASDAQ:ENO",
      companyName:
        "Entergy New Orleans LLC First Mortgage Bonds 5.50% Series due April 1 2066",
      popularity: 0,
    },
    {
      slug: "nasdaq-enob",
      code: "NASDAQ:ENOB",
      companyName: "Enochian Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enov",
      code: "NASDAQ:ENOV",
      companyName: "Enovis Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enpc",
      code: "NASDAQ:ENPC",
      companyName:
        "Executive Network Partnering Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enr",
      code: "NASDAQ:ENR",
      companyName: "Energizer Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ensc",
      code: "NASDAQ:ENSC",
      companyName: "Ensysce Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ensg",
      code: "NASDAQ:ENSG",
      companyName: "The Ensign Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ensv",
      code: "NASDAQ:ENSV",
      companyName: "Enservco Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enta",
      code: "NASDAQ:ENTA",
      companyName: "Enanta Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-entf",
      code: "NASDAQ:ENTF",
      companyName:
        "Enterprise 4.0 Technology Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-entfu",
      code: "NASDAQ:ENTFU",
      companyName: "Enterprise 4.0 Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-entfw",
      code: "NASDAQ:ENTFW",
      companyName: "Enterprise 4.0 Technology Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-entg",
      code: "NASDAQ:ENTG",
      companyName: "Entegris Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-entx",
      code: "NASDAQ:ENTX",
      companyName: "Entera Bio Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-entxw",
      code: "NASDAQ:ENTXW",
      companyName: "Entera Bio Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ens",
      code: "NASDAQ:ENS",
      companyName: "EnerSys Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-env",
      code: "NASDAQ:ENV",
      companyName: "Envestnet Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enva",
      code: "NASDAQ:ENVA",
      companyName: "Enova International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-envb",
      code: "NASDAQ:ENVB",
      companyName: "Enveric Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-envx",
      code: "NASDAQ:ENVX",
      companyName: "Enovix Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enx",
      code: "NASDAQ:ENX",
      companyName:
        "Eaton Vance New York Municipal Bond Fund Common Shares of Beneficial Interest $.01 par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-enz",
      code: "NASDAQ:ENZ",
      companyName: "Enzo Biochem Inc. Common Stock ($0.01 Par Value)",
      popularity: 0,
    },
    {
      slug: "nasdaq-eocw",
      code: "NASDAQ:EOCW",
      companyName: "Elliott Opportunity II Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eod",
      code: "NASDAQ:EOD",
      companyName:
        "Allspring Global Dividend Opportunity Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-eog",
      code: "NASDAQ:EOG",
      companyName: "EOG Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eoi",
      code: "NASDAQ:EOI",
      companyName:
        "Eaton Vance Enhance Equity Income Fund Eaton Vance Enhanced Equity Income Fund Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-eols",
      code: "NASDAQ:EOLS",
      companyName: "Evolus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eos",
      code: "NASDAQ:EOS",
      companyName: "Eaton Vance Enhance Equity Income Fund II Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eose",
      code: "NASDAQ:EOSE",
      companyName: "Eos Energy Enterprises Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eosew",
      code: "NASDAQ:EOSEW",
      companyName: "Eos Energy Enterprises Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-eot",
      code: "NASDAQ:EOT",
      companyName:
        "Eaton Vance Municipal Income Trust EATON VANCE NATIONAL MUNICIPAL OPPORTUNITIES TRUST",
      popularity: 0,
    },
    {
      slug: "nasdaq-ep",
      code: "NASDAQ:EP",
      companyName: "Empire Petroleum Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ep-c",
      code: "NASDAQ:EP-C",
      companyName: "El Paso Corporation Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epac",
      code: "NASDAQ:EPAC",
      companyName: "Enerpac Tool Group Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epam",
      code: "NASDAQ:EPAM",
      companyName: "EPAM Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epay",
      code: "NASDAQ:EPAY",
      companyName: "Bottomline Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epc",
      code: "NASDAQ:EPC",
      companyName: "Edgewell Personal Care Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epd",
      code: "NASDAQ:EPD",
      companyName: "Enterprise Products Partners L.P. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ephy",
      code: "NASDAQ:EPHY",
      companyName: "Epiphany Technology Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ephyu",
      code: "NASDAQ:EPHYU",
      companyName: "Epiphany Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ephyw",
      code: "NASDAQ:EPHYW",
      companyName: "Epiphany Technology Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-epix",
      code: "NASDAQ:EPIX",
      companyName: "ESSA Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epm",
      code: "NASDAQ:EPM",
      companyName: "Evolution Petroleum Corporation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epr",
      code: "NASDAQ:EPR",
      companyName: "EPR Properties Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epr-c",
      code: "NASDAQ:EPR-C",
      companyName:
        "EPR Properties 5.75% Series C Cumulative Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-epr-e",
      code: "NASDAQ:EPR-E",
      companyName: "EPR Properties Series E Cumulative Conv Pfd Shs Ser E",
      popularity: 0,
    },
    {
      slug: "nasdaq-epr-g",
      code: "NASDAQ:EPR-G",
      companyName:
        "EPR Properties 5.750% Series G Cumulative Redeemable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eprt",
      code: "NASDAQ:EPRT",
      companyName: "Essential Properties Realty Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epsn",
      code: "NASDAQ:EPSN",
      companyName: "Epsilon Energy Ltd. Common Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-epwr",
      code: "NASDAQ:EPWR",
      companyName:
        "Empowerment & Inclusion Capital I Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-epzm",
      code: "NASDAQ:EPZM",
      companyName: "Epizyme Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eq",
      code: "NASDAQ:EQ",
      companyName: "Equillium Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqbk",
      code: "NASDAQ:EQBK",
      companyName: "Equity Bancshares Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqc",
      code: "NASDAQ:EQC",
      companyName: "Equity Commonwealth Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqc-d",
      code: "NASDAQ:EQC-D",
      companyName: "Equity Commonwealth 6.50% Pfd Conv Shs Ser D",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqd",
      code: "NASDAQ:EQD",
      companyName: "Equity Distribution Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqh",
      code: "NASDAQ:EQH",
      companyName: "Equitable Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqh-a",
      code: "NASDAQ:EQH-A",
      companyName: "Equitable Holdings Inc. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqh-c",
      code: "NASDAQ:EQH-C",
      companyName:
        "Equitable Holdings Inc. Depositary Shares each representing a 1/1000th interest in a share of Fixed Rate Noncumulative Perpetual Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqha",
      code: "NASDAQ:EQHA",
      companyName: "EQ Health Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqnr",
      code: "NASDAQ:EQNR",
      companyName: "Equinor ASA",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqos",
      code: "NASDAQ:EQOS",
      companyName: "EQONEX LIMITED Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqr",
      code: "NASDAQ:EQR",
      companyName: "Equity Residential Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqrx",
      code: "NASDAQ:EQRX",
      companyName: "EQRx Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqrxw",
      code: "NASDAQ:EQRXW",
      companyName: "EQRx Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqs",
      code: "NASDAQ:EQS",
      companyName: "Equus Total Return Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqt",
      code: "NASDAQ:EQT",
      companyName: "EQT Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eqx",
      code: "NASDAQ:EQX",
      companyName: "Equinox Gold Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eras",
      code: "NASDAQ:ERAS",
      companyName: "Erasca Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-erc",
      code: "NASDAQ:ERC",
      companyName: "Allspring Multi-Sector Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eres",
      code: "NASDAQ:ERES",
      companyName: "East Resources Acquisition Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eresu",
      code: "NASDAQ:ERESU",
      companyName: "East Resources Acquisition Company Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-eresw",
      code: "NASDAQ:ERESW",
      companyName: "East Resources Acquisition Company Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-erf",
      code: "NASDAQ:ERF",
      companyName: "Enerplus Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-erh",
      code: "NASDAQ:ERH",
      companyName: "Allspring Utilities and High Income Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eric",
      code: "NASDAQ:ERIC",
      companyName: "Ericsson American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-erie",
      code: "NASDAQ:ERIE",
      companyName: "Erie Indemnity Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-erii",
      code: "NASDAQ:ERII",
      companyName: "Energy Recovery Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-erj",
      code: "NASDAQ:ERJ",
      companyName: "Embraer S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ero",
      code: "NASDAQ:ERO",
      companyName: "Ero Copper Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eryp",
      code: "NASDAQ:ERYP",
      companyName: "Erytech Pharma S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-es",
      code: "NASDAQ:ES",
      companyName: "Eversource Energy (D/B/A) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-esab",
      code: "NASDAQ:ESAB",
      companyName: "ESAB Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-esac",
      code: "NASDAQ:ESAC",
      companyName: "ESGEN Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-esacu",
      code: "NASDAQ:ESACU",
      companyName: "ESGEN Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-esacw",
      code: "NASDAQ:ESACW",
      companyName: "ESGEN Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-esbk",
      code: "NASDAQ:ESBK",
      companyName: "Elmira Savings Bank Elmira NY Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-esca",
      code: "NASDAQ:ESCA",
      companyName: "Escalade Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ese",
      code: "NASDAQ:ESE",
      companyName: "ESCO Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-esea",
      code: "NASDAQ:ESEA",
      companyName: "Euroseas Ltd. Common Stock (Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-esgc",
      code: "NASDAQ:ESGC",
      companyName: "Eros STX Global Corporation A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-esgr",
      code: "NASDAQ:ESGR",
      companyName: "Enstar Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-esgro",
      code: "NASDAQ:ESGRO",
      companyName:
        "Enstar Group Limited Depository Shares 7.00% Perpetual Non-Cumulative Preference Shares Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-esgrp",
      code: "NASDAQ:ESGRP",
      companyName:
        "Enstar Group Limited Depositary Shares Each Representing 1/1000th of an interest in Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-esi",
      code: "NASDAQ:ESI",
      companyName: "Element Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eslt",
      code: "NASDAQ:ESLT",
      companyName: "Elbit Systems Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-esm",
      code: "NASDAQ:ESM",
      companyName: "ESM Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-esmt",
      code: "NASDAQ:ESMT",
      companyName: "EngageSmart Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-esoa",
      code: "NASDAQ:ESOA",
      companyName: "Energy Services of America Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-esp",
      code: "NASDAQ:ESP",
      companyName: "Espey Mfg. & Electronics Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-espr",
      code: "NASDAQ:ESPR",
      companyName: "Esperion Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-esq",
      code: "NASDAQ:ESQ",
      companyName: "Esquire Financial Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-esrt",
      code: "NASDAQ:ESRT",
      companyName: "Empire State Realty Trust Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ess",
      code: "NASDAQ:ESS",
      companyName: "Essex Property Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-essa",
      code: "NASDAQ:ESSA",
      companyName: "ESSA Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-essc",
      code: "NASDAQ:ESSC",
      companyName: "East Stone Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-esscr",
      code: "NASDAQ:ESSCR",
      companyName: "East Stone Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-esscu",
      code: "NASDAQ:ESSCU",
      companyName: "East Stone Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-esscw",
      code: "NASDAQ:ESSCW",
      companyName: "East Stone Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-esta",
      code: "NASDAQ:ESTA",
      companyName: "Establishment Labs Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-estc",
      code: "NASDAQ:ESTC",
      companyName: "Elastic N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-este",
      code: "NASDAQ:ESTE",
      companyName: "Earthstone Energy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-et",
      code: "NASDAQ:ET",
      companyName: "Energy Transfer LP Common Units ",
      popularity: 0,
    },
    {
      slug: "nasdaq-et-c",
      code: "NASDAQ:ET-C",
      companyName:
        "Energy Transfer L.P. 7.375% Series C Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-et-d",
      code: "NASDAQ:ET-D",
      companyName:
        "Energy Transfer L.P. 7.625% Series D Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-et-e",
      code: "NASDAQ:ET-E",
      companyName:
        "Energy Transfer L.P. 7.600% Series E Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-etac",
      code: "NASDAQ:ETAC",
      companyName: "E.Merge Technology Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-etacu",
      code: "NASDAQ:ETACU",
      companyName: "E.Merge Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-etacw",
      code: "NASDAQ:ETACW",
      companyName: "E.Merge Technology Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-etb",
      code: "NASDAQ:ETB",
      companyName:
        "Eaton Vance Tax-Managed Buy-Write Income Fund Eaton Vance Tax-Managed Buy-Write Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-etd",
      code: "NASDAQ:ETD",
      companyName: "Ethan Allen Interiors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-etg",
      code: "NASDAQ:ETG",
      companyName:
        "Eaton Vance Tax-Advantaged Global Dividend Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-eti-",
      code: "NASDAQ:ETI-",
      companyName:
        "Entergy Texas Inc 5.375% Series A Preferred Stock Cumulative No Par Value",
      popularity: 0,
    },
    {
      slug: "nasdaq-etj",
      code: "NASDAQ:ETJ",
      companyName:
        "Eaton Vance Risk-Managed Diversified Equity Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-etn",
      code: "NASDAQ:ETN",
      companyName: "Eaton Corporation PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-etnb",
      code: "NASDAQ:ETNB",
      companyName: "89bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eto",
      code: "NASDAQ:ETO",
      companyName: "Eaton Vance Tax-Advantage Global Dividend Opp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eton",
      code: "NASDAQ:ETON",
      companyName: "Eton Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-etr",
      code: "NASDAQ:ETR",
      companyName: "Entergy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-etrn",
      code: "NASDAQ:ETRN",
      companyName: "Equitrans Midstream Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-etsy",
      code: "NASDAQ:ETSY",
      companyName: "Etsy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ettx",
      code: "NASDAQ:ETTX",
      companyName: "Entasis Therapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-etv",
      code: "NASDAQ:ETV",
      companyName:
        "Eaton Vance Corporation Eaton Vance Tax-Managed Buy-Write Opportunities Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-etw",
      code: "NASDAQ:ETW",
      companyName:
        "Eaton Vance Corporation Eaton Vance Tax-Managed Global Buy-Write Opportunites Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-etwo",
      code: "NASDAQ:ETWO",
      companyName: "E2open Parent Holdings Inc.Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-etx",
      code: "NASDAQ:ETX           ",
      companyName:
        "Eaton Vance Municipal Income 2028 Term Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ety",
      code: "NASDAQ:ETY",
      companyName:
        "Eaton Vance Tax-Managed Diversified Equity Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-eucr",
      code: "NASDAQ:EUCR",
      companyName: "Eucrates Biomedical Acquisition Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eucru",
      code: "NASDAQ:EUCRU",
      companyName: "Eucrates Biomedical Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-eucrw",
      code: "NASDAQ:EUCRW",
      companyName: "Eucrates Biomedical Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-eurn",
      code: "NASDAQ:EURN",
      companyName: "Euronav NV Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-eva",
      code: "NASDAQ:EVA",
      companyName: "Enviva Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evax",
      code: "NASDAQ:EVAX",
      companyName: "Evaxion Biotech A/S American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-evbg",
      code: "NASDAQ:EVBG",
      companyName: "Everbridge Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evbn",
      code: "NASDAQ:EVBN",
      companyName: "Evans Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evc",
      code: "NASDAQ:EVC",
      companyName: "Entravision Communications Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evcm",
      code: "NASDAQ:EVCM",
      companyName: "EverCommerce Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eve",
      code: "NASDAQ:EVE",
      companyName: "EVe Mobility Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ever",
      code: "NASDAQ:EVER",
      companyName: "EverQuote Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evf",
      code: "NASDAQ:EVF",
      companyName: "Eaton Vance Senior Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evfm",
      code: "NASDAQ:EVFM",
      companyName: "Evofem Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evg",
      code: "NASDAQ:EVG",
      companyName:
        "Eaton Vance Short Diversified Income Fund Eaton Vance Short Duration Diversified Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-evgrw",
      code: "NASDAQ:EVGRW",
      companyName: "Evergreen Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-evh",
      code: "NASDAQ:EVH",
      companyName: "Evolent Health Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evi",
      code: "NASDAQ:EVI",
      companyName: "EVI Industries Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evk",
      code: "NASDAQ:EVK",
      companyName: "Ever-Glory International Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evlo",
      code: "NASDAQ:EVLO",
      companyName: "Evelo Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evlv",
      code: "NASDAQ:EVLV",
      companyName: "Evolv Technologies Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evlvw",
      code: "NASDAQ:EVLVW",
      companyName: "Evolv Technologies Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-evm",
      code: "NASDAQ:EVM",
      companyName:
        "Eaton Vance California Municipal Bond Fund Common Shares of Beneficial Interest $.01 par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-evn",
      code: "NASDAQ:EVN",
      companyName: "Eaton Vance Municipal Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evo",
      code: "NASDAQ:EVO",
      companyName: "Evotec SE American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-evoj",
      code: "NASDAQ:EVOJ",
      companyName: "Evo Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evojw",
      code: "NASDAQ:EVOJW",
      companyName: "Evo Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-evok",
      code: "NASDAQ:EVOK",
      companyName: "Evoke Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evop",
      code: "NASDAQ:EVOP",
      companyName: "EVO Payments Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evr",
      code: "NASDAQ:EVR",
      companyName: "Evercore Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evrg",
      code: "NASDAQ:EVRG",
      companyName: "Evergy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evri",
      code: "NASDAQ:EVRI",
      companyName: "Everi Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evt",
      code: "NASDAQ:EVT",
      companyName:
        "Eaton Vance Tax Advantaged Dividend Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-evtc",
      code: "NASDAQ:EVTC",
      companyName: "Evertec Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evtl",
      code: "NASDAQ:EVTL",
      companyName: "Vertical Aerospace Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-evv",
      code: "NASDAQ:EVV",
      companyName:
        "Eaton Vance Limited Duration Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ew",
      code: "NASDAQ:EW",
      companyName: "Edwards Lifesciences Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ewcz",
      code: "NASDAQ:EWCZ",
      companyName: "European Wax Center Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ewtx",
      code: "NASDAQ:EWTX",
      companyName: "Edgewise Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-exas",
      code: "NASDAQ:EXAS",
      companyName: "Exact Sciences Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-exc",
      code: "NASDAQ:EXC",
      companyName: "Exelon Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-exd",
      code: "NASDAQ:EXD",
      companyName:
        "Eaton Vance Tax-Managed Buy-Write Strategy Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-exel",
      code: "NASDAQ:EXEL",
      companyName: "Exelixis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-exfy",
      code: "NASDAQ:EXFY",
      companyName: "Expensify Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-exg",
      code: "NASDAQ:EXG",
      companyName:
        "Eaton Vance Tax-Managed Global Diversified Equity Income Fund Eaton Vance Tax-Managed Global Diversified Equity Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-exk",
      code: "NASDAQ:EXK",
      companyName: "Endeavour Silver Corporation Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-exls",
      code: "NASDAQ:EXLS",
      companyName: "ExlService Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-exn",
      code: "NASDAQ:EXN",
      companyName: "Excellon Resources Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-exp",
      code: "NASDAQ:EXP",
      companyName: "Eagle Materials Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-expd",
      code: "NASDAQ:EXPD",
      companyName: "Expeditors International of Washington Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-expi",
      code: "NASDAQ:EXPI",
      companyName: "eXp World Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-expo",
      code: "NASDAQ:EXPO",
      companyName: "Exponent Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-expr",
      code: "NASDAQ:EXPR",
      companyName: "Express Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-exr",
      code: "NASDAQ:EXR",
      companyName: "Extra Space Storage Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-extn",
      code: "NASDAQ:EXTN",
      companyName: "Exterran Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-extr",
      code: "NASDAQ:EXTR",
      companyName: "Extreme Networks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eye",
      code: "NASDAQ:EYE",
      companyName: "National Vision Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eyen",
      code: "NASDAQ:EYEN",
      companyName: "Eyenovia Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eyes",
      code: "NASDAQ:EYES",
      companyName: "Second Sight Medical Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-eyesw",
      code: "NASDAQ:EYESW",
      companyName:
        "Second Sight Medical Products Inc. Warrants expiring 03/14/2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-eypt",
      code: "NASDAQ:EYPT",
      companyName: "EyePoint Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ezfl",
      code: "NASDAQ:EZFL",
      companyName: "EzFill Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ezgo",
      code: "NASDAQ:EZGO",
      companyName: "EZGO Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-f-c",
      code: "NASDAQ:F-C",
      companyName: "Ford Motor Company 6% Notes due December 1 2059",
      popularity: 0,
    },
    {
      slug: "nasdaq-fa",
      code: "NASDAQ:FA",
      companyName: "First Advantage Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-faca",
      code: "NASDAQ:FACA",
      companyName: "Figure Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fact",
      code: "NASDAQ:FACT",
      companyName: "Freedom Acquisition I Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-faf",
      code: "NASDAQ:FAF",
      companyName: "First American Corporation (New) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fam",
      code: "NASDAQ:FAM",
      companyName:
        "First Trust/Aberdeen Global Opportunity Income Fund First Trust/Aberdeen Global Opportunity Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-fami",
      code: "NASDAQ:FAMI",
      companyName: "Farmmi Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fanh",
      code: "NASDAQ:FANH",
      companyName: "Fanhua Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-farm",
      code: "NASDAQ:FARM",
      companyName: "Farmer Brothers Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-faro",
      code: "NASDAQ:FARO",
      companyName: "FARO Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fast",
      code: "NASDAQ:FAST",
      companyName: "Fastenal Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fat",
      code: "NASDAQ:FAT",
      companyName: "FAT Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fatbb",
      code: "NASDAQ:FATBB",
      companyName: "FAT Brands Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fatbp",
      code: "NASDAQ:FATBP",
      companyName: "FAT Brands Inc. 8.25% Series B Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fatbw",
      code: "NASDAQ:FATBW",
      companyName: "FAT Brands Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fate",
      code: "NASDAQ:FATE",
      companyName: "Fate Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fath",
      code: "NASDAQ:FATH",
      companyName:
        "Fathom Digital Manufacturing Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fatp",
      code: "NASDAQ:FATP",
      companyName: "Fat Projects Acquisition Corp Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-fatpw",
      code: "NASDAQ:FATPW",
      companyName: "Fat Projects Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fax",
      code: "NASDAQ:FAX",
      companyName: "Aberdeen Asia-Pacific Income Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbc",
      code: "NASDAQ:FBC",
      companyName: "Flagstar Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbio",
      code: "NASDAQ:FBIO",
      companyName: "Fortress Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbiop",
      code: "NASDAQ:FBIOP",
      companyName:
        "Fortress Biotech Inc. 9.375% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbiz",
      code: "NASDAQ:FBIZ",
      companyName: "First Business Financial Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbk",
      code: "NASDAQ:FBK",
      companyName: "FB Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbms",
      code: "NASDAQ:FBMS",
      companyName: "First Bancshares Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbnc",
      code: "NASDAQ:FBNC",
      companyName: "First Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbp",
      code: "NASDAQ:FBP",
      companyName: "First BanCorp. New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbrt",
      code: "NASDAQ:FBRT",
      companyName: "Franklin BSP Realty Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbrt-e",
      code: "NASDAQ:FBRT-E",
      companyName:
        "Franklin BSP Realty Trust Inc. 7.50% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbrx",
      code: "NASDAQ:FBRX",
      companyName: "Forte Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fc",
      code: "NASDAQ:FC",
      companyName: "Franklin Covey Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcap",
      code: "NASDAQ:FCAP",
      companyName: "First Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcax",
      code: "NASDAQ:FCAX",
      companyName: "Fortress Capital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcbc",
      code: "NASDAQ:FCBC",
      companyName: "First Community Bankshares Inc. (VA) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcco",
      code: "NASDAQ:FCCO",
      companyName: "First Community Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcel",
      code: "NASDAQ:FCEL",
      companyName: "FuelCell Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcf",
      code: "NASDAQ:FCF",
      companyName: "First Commonwealth Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcfs",
      code: "NASDAQ:FCFS",
      companyName: "FirstCash Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcn",
      code: "NASDAQ:FCN",
      companyName: "FTI Consulting Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcnca",
      code: "NASDAQ:FCNCA",
      companyName: "First Citizens BancShares Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcnco",
      code: "NASDAQ:FCNCO",
      companyName:
        "First Citizens BancShares Inc. 5.625% Non-Cumulative Perpetual Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-fang",
      code: "NASDAQ:FANG",
      companyName: "Diamondback Energy Inc. Commmon Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcncp",
      code: "NASDAQ:FCNCP",
      companyName: "First Citizens BancShares Inc. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fco",
      code: "NASDAQ:FCO",
      companyName: "Aberdeen Global Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcpt",
      code: "NASDAQ:FCPT",
      companyName: "Four Corners Property Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcrd",
      code: "NASDAQ:FCRD",
      companyName: "First Eagle Alternative Capital BDC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcrx",
      code: "NASDAQ:FCRX",
      companyName:
        "First Eagle Alternative Capital BDC Inc. 5.000% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-fct",
      code: "NASDAQ:FCT",
      companyName:
        "First Trust Senior Floating Rate Income Fund II Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcuv",
      code: "NASDAQ:FCUV",
      companyName: "Focus Universal Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fdbc",
      code: "NASDAQ:FDBC",
      companyName: "Fidelity D & D Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fdmt",
      code: "NASDAQ:FDMT",
      companyName: "4D Molecular Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fdp",
      code: "NASDAQ:FDP",
      companyName: "Fresh Del Monte Produce Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fds",
      code: "NASDAQ:FDS",
      companyName: "FactSet Research Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fdus",
      code: "NASDAQ:FDUS",
      companyName: "Fidus Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fdx",
      code: "NASDAQ:FDX",
      companyName: "FedEx Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fe",
      code: "NASDAQ:FE",
      companyName: "FirstEnergy Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-feam",
      code: "NASDAQ:FEAM",
      companyName: "5E Advanced Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fedu",
      code: "NASDAQ:FEDU",
      companyName:
        "Four Seasons Education (Cayman) Inc. American Depositary Shares each two ADSs representing one ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-fei",
      code: "NASDAQ:FEI           ",
      companyName:
        "First Trust MLP and Energy Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-feim",
      code: "NASDAQ:FEIM",
      companyName: "Frequency Electronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fele",
      code: "NASDAQ:FELE",
      companyName: "Franklin Electric Co. Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-femy",
      code: "NASDAQ:FEMY",
      companyName: "Femasys Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fen",
      code: "NASDAQ:FEN",
      companyName: "First Trust Energy Income and Growth Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-fenc",
      code: "NASDAQ:FENC",
      companyName: "Fennec Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-feng",
      code: "NASDAQ:FENG",
      companyName:
        "Phoenix New Media Limited American Depositary Shares each representing 8 Class A ordinary shares.",
      popularity: 0,
    },
    {
      slug: "nasdaq-feo",
      code: "NASDAQ:FEO",
      companyName:
        "First Trust/Aberdeen Emerging Opportunity Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ferg",
      code: "NASDAQ:FERG",
      companyName: "Ferguson plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fet",
      code: "NASDAQ:FET",
      companyName: "Forum Energy Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fexd",
      code: "NASDAQ:FEXD",
      companyName: "Fintech Ecosystem Development Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fexdr",
      code: "NASDAQ:FEXDR",
      companyName: "Fintech Ecosystem Development Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-ff",
      code: "NASDAQ:FF",
      companyName: "FutureFuel Corp.  Common shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffa",
      code: "NASDAQ:FFA",
      companyName: "First Trust Enhanced Equity Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffbc",
      code: "NASDAQ:FFBC",
      companyName: "First Financial Bancorp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffbw",
      code: "NASDAQ:FFBW",
      companyName: "FFBW Inc. Common Stock (MD)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffc",
      code: "NASDAQ:FFC",
      companyName:
        "Flaherty & Crumrine Preferred and Income Securities Fund Incorporated",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffhl",
      code: "NASDAQ:FFHL",
      companyName: "Fuwei Films (Holdings) Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffic",
      code: "NASDAQ:FFIC",
      companyName: "Flushing Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffie",
      code: "NASDAQ:FFIE",
      companyName: "Faraday Future Intelligent Electric Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffiew",
      code: "NASDAQ:FFIEW",
      companyName: "Faraday Future Intelligent Electric Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffin",
      code: "NASDAQ:FFIN",
      companyName: "First Financial Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffiv",
      code: "NASDAQ:FFIV",
      companyName: "F5 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffnw",
      code: "NASDAQ:FFNW",
      companyName: "First Financial Northwest Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ffwm",
      code: "NASDAQ:FFWM",
      companyName: "First Foundation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgb",
      code: "NASDAQ:FGB",
      companyName:
        "First Trust Specialty Finance and Financial Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgbi",
      code: "NASDAQ:FGBI",
      companyName: "First Guaranty Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgbip",
      code: "NASDAQ:FGBIP",
      companyName:
        "First Guaranty Bancshares Inc. 6.75% Series A Fixed-Rate Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgen",
      code: "NASDAQ:FGEN",
      companyName: "FibroGen Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgf",
      code: "NASDAQ:FGF",
      companyName: "FG Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgfpp",
      code: "NASDAQ:FGFPP",
      companyName: "FG Financial Group Inc. 8.00% Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgi",
      code: "NASDAQ:FGI",
      companyName: "FGI Industries Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgiww",
      code: "NASDAQ:FGIWW",
      companyName: "FGI Industries Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgmc",
      code: "NASDAQ:FGMC",
      companyName: "FG Merger Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fgmcu",
      code: "NASDAQ:FGMCU",
      companyName: "FG Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhb",
      code: "NASDAQ:FHB",
      companyName: "First Hawaiian Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhi",
      code: "NASDAQ:FHI",
      companyName: "Federated Hermes Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhlt",
      code: "NASDAQ:FHLT",
      companyName: "Future Health ESG Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhltu",
      code: "NASDAQ:FHLTU",
      companyName: "Future Health ESG Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhltw",
      code: "NASDAQ:FHLTW",
      companyName: "Future Health ESG Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhn",
      code: "NASDAQ:FHN",
      companyName: "First Horizon Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhn-b",
      code: "NASDAQ:FHN-B",
      companyName:
        "First Horizon Corporation Depositary Shares each representing a 1/400th interest in a share of Non-Cumulative Perpetual Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhn-c",
      code: "NASDAQ:FHN-C",
      companyName:
        "First Horizon Corporation Depositary Shares each representing a 1/400th interest in a share of Non-Cumulative Perpetual Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhn-d",
      code: "NASDAQ:FHN-D",
      companyName:
        "First Horizon Corporation Depositary Shares each representing a 1/400th interest in a share of Non-Cumulative Perpetual Preferred Stock Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhn-e",
      code: "NASDAQ:FHN-E",
      companyName:
        "First Horizon Corporation Depositary Shares each representing a 1/4000th interest in a share of Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhn-f",
      code: "NASDAQ:FHN-F",
      companyName:
        "First Horizon Corporation Depositary Shares each representing 1/4000th Interest in a Share of Non-Cumulative Perpetual Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhtx",
      code: "NASDAQ:FHTX",
      companyName: "Foghorn Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fiac",
      code: "NASDAQ:FIAC",
      companyName: "Focus Impact Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fiacu",
      code: "NASDAQ:FIACU",
      companyName: "Focus Impact Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-fiacw",
      code: "NASDAQ:FIACW",
      companyName: "Focus Impact Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fibk",
      code: "NASDAQ:FIBK",
      companyName: "First Interstate BancSystem Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fico",
      code: "NASDAQ:FICO",
      companyName: "Fair Isaac Corproation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ficv",
      code: "NASDAQ:FICV",
      companyName: "Frontier Investment Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ficvw",
      code: "NASDAQ:FICVW",
      companyName: "Frontier Investment Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-fif",
      code: "NASDAQ:FIF",
      companyName:
        "First Trust Energy Infrastructure Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-figs",
      code: "NASDAQ:FIGS",
      companyName: "FIGS Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-finm",
      code: "NASDAQ:FINM",
      companyName: "Marlin Technology Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-finmw",
      code: "NASDAQ:FINMW",
      companyName: "Marlin Technology Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fins",
      code: "NASDAQ:FINS",
      companyName:
        "Angel Oak Financial Strategies Income Term Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-finv",
      code: "NASDAQ:FINV",
      companyName: "FinVolution Group American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-finw",
      code: "NASDAQ:FINW",
      companyName: "FinWise Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fis",
      code: "NASDAQ:FIS",
      companyName: "Fidelity National Information Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fisi",
      code: "NASDAQ:FISI",
      companyName: "Financial Institutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fisv",
      code: "NASDAQ:FISV",
      companyName: "Fiserv Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flmn",
      code: "NASDAQ:FLMN",
      companyName: "Falcon Minerals Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fitbi",
      code: "NASDAQ:FITBI",
      companyName: "Fifth Third Bancorp Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fitbo",
      code: "NASDAQ:FITBO",
      companyName:
        "Fifth Third Bancorp Depositary Shares each representing a 1/1000th ownership interest in a share of Non-Cumulative Perpetual Preferred Stock Series K",
      popularity: 0,
    },
    {
      slug: "nasdaq-fitbp",
      code: "NASDAQ:FITBP",
      companyName:
        "Fifth Third Bancorp Depositary Shares each representing 1/40th share of Fifth Third 6.00% Non-Cumulative Perpetual Class B Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-five",
      code: "NASDAQ:FIVE",
      companyName: "Five Below Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fivn",
      code: "NASDAQ:FIVN",
      companyName: "Five9 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fix",
      code: "NASDAQ:FIX",
      companyName: "Comfort Systems USA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fixx",
      code: "NASDAQ:FIXX",
      companyName: "Homology Medicines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fizz",
      code: "NASDAQ:FIZZ",
      companyName: "National Beverage Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fkwl",
      code: "NASDAQ:FKWL",
      companyName: "Franklin Wireless Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fl",
      code: "NASDAQ:FL",
      companyName: "Foot Locker Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-flac",
      code: "NASDAQ:FLAC",
      companyName:
        "Frazier Lifesciences Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-flacu",
      code: "NASDAQ:FLACU",
      companyName: "Frazier Lifesciences Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-flacw",
      code: "NASDAQ:FLACW",
      companyName: "Frazier Lifesciences Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-flag",
      code: "NASDAQ:FLAG",
      companyName: "First Light Acquisition Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flc",
      code: "NASDAQ:FLC",
      companyName: "Flaherty & Crumrine Total Return Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flex",
      code: "NASDAQ:FLEX",
      companyName: "Flex Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-flgc",
      code: "NASDAQ:FLGC",
      companyName: "Flora Growth Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flgt",
      code: "NASDAQ:FLGT",
      companyName: "Fulgent Genetics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flic",
      code: "NASDAQ:FLIC",
      companyName: "First of Long Island Corporation (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fll",
      code: "NASDAQ:FLL",
      companyName: "Full House Resorts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flme",
      code: "NASDAQ:FLME",
      companyName: "Flame Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flnc",
      code: "NASDAQ:FLNC",
      companyName: "Fluence Energy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flng",
      code: "NASDAQ:FLNG",
      companyName: "FLEX LNG Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-flnt",
      code: "NASDAQ:FLNT",
      companyName: "Fluent Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flo",
      code: "NASDAQ:FLO",
      companyName: "Flowers Foods Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flr",
      code: "NASDAQ:FLR",
      companyName: "Fluor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fls",
      code: "NASDAQ:FLS",
      companyName: "Flowserve Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flt",
      code: "NASDAQ:FLT",
      companyName: "FleetCor Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flux",
      code: "NASDAQ:FLUX",
      companyName: "Flux Power Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flmnw",
      code: "NASDAQ:FLMNW",
      companyName: "Falcon Minerals Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-flws",
      code: "NASDAQ:FLWS",
      companyName: "1-800-FLOWERS.COM Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flxs",
      code: "NASDAQ:FLXS",
      companyName: "Flexsteel Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-flya",
      code: "NASDAQ:FLYA",
      companyName: "SOAR Technology Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-flyw",
      code: "NASDAQ:FLYW",
      companyName: "Flywire Corporation Voting Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmao",
      code: "NASDAQ:FMAO",
      companyName: "Farmers & Merchants Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmbh",
      code: "NASDAQ:FMBH",
      companyName: "First Mid Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmc",
      code: "NASDAQ:FMC",
      companyName: "FMC Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmiv",
      code: "NASDAQ:FMIV",
      companyName: "Forum Merger IV Corporation Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmivw",
      code: "NASDAQ:FMIVW",
      companyName: "Forum Merger IV Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmn",
      code: "NASDAQ:FMN",
      companyName: "Federated Hermes Premier Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmnb",
      code: "NASDAQ:FMNB",
      companyName: "Farmers National Banc Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fms",
      code: "NASDAQ:FMS",
      companyName: "Fresenius Medical Care AG Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmtx",
      code: "NASDAQ:FMTX",
      companyName: "Forma Therapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmx",
      code: "NASDAQ:FMX",
      companyName: "Fomento Economico Mexicano S.A.B. de C.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmy",
      code: "NASDAQ:FMY",
      companyName:
        "First Trust Motgage Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-fn",
      code: "NASDAQ:FN",
      companyName: "Fabrinet Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fna",
      code: "NASDAQ:FNA",
      companyName: "Paragon 28 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnb",
      code: "NASDAQ:FNB",
      companyName: "F.N.B. Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnb-e",
      code: "NASDAQ:FNB-E",
      companyName:
        "F.N.B. Corporation Depositary Shares each representing a 1/40th interest in a share of Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred  Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-fncb",
      code: "NASDAQ:FNCB",
      companyName: "FNCB Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnch",
      code: "NASDAQ:FNCH",
      companyName: "Finch Therapeutics Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnd",
      code: "NASDAQ:FND",
      companyName: "Floor & Decor Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnf",
      code: "NASDAQ:FNF",
      companyName: "FNF Group of Fidelity National Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fngr",
      code: "NASDAQ:FNGR",
      companyName: "FingerMotion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnhc",
      code: "NASDAQ:FNHC",
      companyName: "FedNat Holding Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnko",
      code: "NASDAQ:FNKO",
      companyName: "Funko Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnlc",
      code: "NASDAQ:FNLC",
      companyName: "First Bancorp Inc  (ME) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnv",
      code: "NASDAQ:FNV",
      companyName: "Franco-Nevada Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnvt",
      code: "NASDAQ:FNVT",
      companyName: "Finnovate Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnvtu",
      code: "NASDAQ:FNVTU",
      companyName: "Finnovate Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnvtw",
      code: "NASDAQ:FNVTW",
      companyName: "Finnovate Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnwb",
      code: "NASDAQ:FNWB",
      companyName: "First Northwest Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fnwd",
      code: "NASDAQ:FNWD",
      companyName: "Finward Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-foa",
      code: "NASDAQ:FOA",
      companyName: "Finance of America Companies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-focs",
      code: "NASDAQ:FOCS",
      companyName: "Focus Financial Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fof",
      code: "NASDAQ:FOF",
      companyName:
        "Cohen & Steers Closed-End Opportunity Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fold",
      code: "NASDAQ:FOLD",
      companyName: "Amicus Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fonr",
      code: "NASDAQ:FONR",
      companyName: "Fonar Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-for",
      code: "NASDAQ:FOR",
      companyName: "Forestar Group Inc Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-fora",
      code: "NASDAQ:FORA",
      companyName: "Forian Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ford",
      code: "NASDAQ:FORD",
      companyName: "Forward Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-forg",
      code: "NASDAQ:FORG",
      companyName: "ForgeRock Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-form",
      code: "NASDAQ:FORM",
      companyName: "FormFactor Inc. FormFactor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-forr",
      code: "NASDAQ:FORR",
      companyName: "Forrester Research Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-forty",
      code: "NASDAQ:FORTY",
      companyName: "Formula Systems (1985) Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fosl",
      code: "NASDAQ:FOSL",
      companyName: "Fossil Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fosll",
      code: "NASDAQ:FOSLL",
      companyName: "Fossil Group Inc. 7% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-foun",
      code: "NASDAQ:FOUN",
      companyName: "Founder SPAC Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-founu",
      code: "NASDAQ:FOUNU",
      companyName: "Founder SPAC Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-founw",
      code: "NASDAQ:FOUNW",
      companyName: "Founder SPAC Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-four",
      code: "NASDAQ:FOUR",
      companyName: "Shift4 Payments Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fox",
      code: "NASDAQ:FOX",
      companyName: "Fox Corporation Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-foxa",
      code: "NASDAQ:FOXA",
      companyName: "Fox Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-foxf",
      code: "NASDAQ:FOXF",
      companyName: "Fox Factory Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-foxw",
      code: "NASDAQ:FOXW",
      companyName:
        "FoxWayne Enterprises Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-foxww",
      code: "NASDAQ:FOXWW",
      companyName: "FoxWayne Enterprises Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fpac",
      code: "NASDAQ:FPAC",
      companyName: "Far Peak Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fpay",
      code: "NASDAQ:FPAY",
      companyName: "FlexShopper Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fpf",
      code: "NASDAQ:FPF",
      companyName:
        "First Trust Intermediate Duration Preferred & Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-fph",
      code: "NASDAQ:FPH",
      companyName: "Five Point Holdings LLC Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fpi",
      code: "NASDAQ:FPI",
      companyName: "Farmland Partners Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fpl",
      code: "NASDAQ:FPL",
      companyName:
        "First Trust New Opportunities MLP & Energy Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-fr",
      code: "NASDAQ:FR",
      companyName: "First Industrial Realty Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fra",
      code: "NASDAQ:FRA",
      companyName:
        "Blackrock Floating Rate Income Strategies Fund Inc  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fraf",
      code: "NASDAQ:FRAF",
      companyName: "Franklin Financial Services Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frbk",
      code: "NASDAQ:FRBK",
      companyName: "Republic First Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frbn",
      code: "NASDAQ:FRBN",
      companyName: "Forbion European Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-frc",
      code: "NASDAQ:FRC",
      companyName: "FIRST REPUBLIC BANK Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frc-h",
      code: "NASDAQ:FRC-H",
      companyName:
        "FIRST REPUBLIC BANK Depositary Shares each representing a 1/40th interest in a share of 5.125% Noncumulative Perpetual Series H Preferred Stock par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-frc-i",
      code: "NASDAQ:FRC-I",
      companyName:
        "FIRST REPUBLIC BANK Depositary Shares each representing a 1/40th interest in a share of 5.50% Noncumulative Perpetual Series I Preferred Stock par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-frc-j",
      code: "NASDAQ:FRC-J",
      companyName:
        "FIRST REPUBLIC BANK Depositary Shares Each Representing a 1/40th Interest in a Share of 4.70% Noncumulative Perpetual Series J Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frc-k",
      code: "NASDAQ:FRC-K",
      companyName:
        "FIRST REPUBLIC BANK Depositary Shares Each Representing a 1/40th Interest in a Share of 4.125% Noncumulative Perpetual Series K Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frc-l",
      code: "NASDAQ:FRC-L",
      companyName:
        "FIRST REPUBLIC BANK Depositary Shares Each Representing a 1/40th Interest in a Share of 4.250% Noncumulative Perpetual Series L Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frc-m",
      code: "NASDAQ:FRC-M",
      companyName:
        "FIRST REPUBLIC BANK Depositary Shares each representing a 1/40th interest in a share of 4.000% Noncumulative Perpetual Series M Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frc-n",
      code: "NASDAQ:FRC-N",
      companyName:
        "First Republic Bank Depositary Shares Each Representing a 1/40th Interest in a Share of 4.500% Noncumulative Perpetual Series N Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frd",
      code: "NASDAQ:FRD",
      companyName: "Friedman Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-free",
      code: "NASDAQ:FREE",
      companyName: "Whole Earth Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-freew",
      code: "NASDAQ:FREEW",
      companyName: "Whole Earth Brands Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-freq",
      code: "NASDAQ:FREQ",
      companyName: "Frequency Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frey",
      code: "NASDAQ:FREY",
      companyName: "FREYR Battery Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-frg",
      code: "NASDAQ:FRG",
      companyName: "Franchise Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frgap",
      code: "NASDAQ:FRGAP",
      companyName:
        "Franchise Group Inc. 7.50% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frge",
      code: "NASDAQ:FRGE",
      companyName: "Forge Global Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frgi",
      code: "NASDAQ:FRGI",
      companyName: "Fiesta Restaurant Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frhc",
      code: "NASDAQ:FRHC",
      companyName: "Freedom Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frla",
      code: "NASDAQ:FRLA",
      companyName: "Fortune Rise Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frlau",
      code: "NASDAQ:FRLAU",
      companyName: "Fortune Rise Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-frlaw",
      code: "NASDAQ:FRLAW",
      companyName: "Fortune Rise Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-frln",
      code: "NASDAQ:FRLN",
      companyName:
        "Freeline Therapeutics Holdings plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-frme",
      code: "NASDAQ:FRME",
      companyName: "First Merchants Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frmep",
      code: "NASDAQ:FRMEP",
      companyName: "First Merchants Corporation Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fro",
      code: "NASDAQ:FRO",
      companyName: "Frontline Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-frog",
      code: "NASDAQ:FROG",
      companyName: "JFrog Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fron",
      code: "NASDAQ:FRON",
      companyName: "Frontier Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fronu",
      code: "NASDAQ:FRONU",
      companyName: "Frontier Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-fronw",
      code: "NASDAQ:FRONW",
      companyName: "Frontier Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-frph",
      code: "NASDAQ:FRPH",
      companyName: "FRP Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frpt",
      code: "NASDAQ:FRPT",
      companyName: "Freshpet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frsg",
      code: "NASDAQ:FRSG",
      companyName:
        "First Reserve Sustainable Growth Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frsgw",
      code: "NASDAQ:FRSGW",
      companyName: "First Reserve Sustainable Growth Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-frsh",
      code: "NASDAQ:FRSH",
      companyName: "Freshworks Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frst",
      code: "NASDAQ:FRST",
      companyName: "Primis Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frsx",
      code: "NASDAQ:FRSX",
      companyName:
        "Foresight Autonomous Holdings Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-frt",
      code: "NASDAQ:FRT",
      companyName: "Federal Realty Investment Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frt-c",
      code: "NASDAQ:FRT-C",
      companyName:
        "Federal Realty Investment Trust Depositary Shares each representing a 1/1000th interest in a 5.000% Series C Cumulative Redeemable Preferred Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-frw",
      code: "NASDAQ:FRW",
      companyName: "PWP Forward Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-frwaw",
      code: "NASDAQ:FRWAW",
      companyName: "PWP Forward Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-frxb",
      code: "NASDAQ:FRXB",
      companyName: "Forest Road Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsbc",
      code: "NASDAQ:FSBC",
      companyName: "Five Star Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsbw",
      code: "NASDAQ:FSBW",
      companyName: "FS Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsd",
      code: "NASDAQ:FSD",
      companyName:
        "First Trust High Income Long Short Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsea",
      code: "NASDAQ:FSEA",
      companyName: "First Seacoast Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsi",
      code: "NASDAQ:FSI",
      companyName: "Flexible Solutions International Inc. Common Stock (CDA)",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsk",
      code: "NASDAQ:FSK",
      companyName: "FS KKR Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsly",
      code: "NASDAQ:FSLY",
      companyName: "Fastly Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsp",
      code: "NASDAQ:FSP",
      companyName: "Franklin Street Properties Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsr",
      code: "NASDAQ:FSR",
      companyName: "Fisker Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsrd",
      code: "NASDAQ:FSRD",
      companyName: "Fast Radius Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsrdw",
      code: "NASDAQ:FSRDW",
      companyName: "Fast Radius Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsrx",
      code: "NASDAQ:FSRX",
      companyName: "FinServ Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsrxu",
      code: "NASDAQ:FSRXU",
      companyName: "FinServ Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsrxw",
      code: "NASDAQ:FSRXW",
      companyName: "FinServ Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fss",
      code: "NASDAQ:FSS",
      companyName: "Federal Signal Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fssi",
      code: "NASDAQ:FSSI",
      companyName: "Fortistar Sustainable Solutions Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fssiw",
      code: "NASDAQ:FSSIW",
      companyName: "Fortistar Sustainable Solutions Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-fst",
      code: "NASDAQ:FST",
      companyName: "FAST Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fstr",
      code: "NASDAQ:FSTR",
      companyName: "L.B. Foster Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fstx",
      code: "NASDAQ:FSTX",
      companyName: "F-star Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsv",
      code: "NASDAQ:FSV",
      companyName: "FirstService Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ft",
      code: "NASDAQ:FT",
      companyName: "Franklin Universal Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftaa",
      code: "NASDAQ:FTAA",
      companyName: "FTAC Athena Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftaau",
      code: "NASDAQ:FTAAU",
      companyName: "FTAC Athena Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftaaw",
      code: "NASDAQ:FTAAW",
      companyName: "FTAC Athena Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftai",
      code: "NASDAQ:FTAI",
      companyName:
        "Fortress Transportation and Infrastructure Investors LLC Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftain",
      code: "NASDAQ:FTAIN",
      companyName:
        "Fortress Transportation and Infrastructure Investors LLC 8.25% Fixed - Rate Reset Series C Cumulative Perpetual Redeemable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftaio",
      code: "NASDAQ:FTAIO",
      companyName:
        "Fortress Transportation and Infrastructure Investors LLC 8.00% Fixed-to-Floating Rate Series B Cumulative Perpetual Redeemable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftaip",
      code: "NASDAQ:FTAIP",
      companyName:
        "Fortress Transportation and Infrastructure Investors LLC 8.25% Fixed to Floating Rate Series A Cumulative Perpetual Redeemable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftch",
      code: "NASDAQ:FTCH",
      companyName: "Farfetch Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftci",
      code: "NASDAQ:FTCI",
      companyName: "FTC Solar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftcv",
      code: "NASDAQ:FTCV",
      companyName: "FinTech Acquisition Corp. V Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftcvu",
      code: "NASDAQ:FTCVU",
      companyName: "FinTech Acquisition Corp. V Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftcvw",
      code: "NASDAQ:FTCVW",
      companyName: "FinTech Acquisition Corp. V Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftdr",
      code: "NASDAQ:FTDR",
      companyName: "Frontdoor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftek",
      code: "NASDAQ:FTEK",
      companyName: "Fuel Tech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftev",
      code: "NASDAQ:FTEV",
      companyName:
        "FinTech Evolution Acquisition Group Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftf",
      code: "NASDAQ:FTF",
      companyName:
        "Franklin Limited Duration Income Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftft",
      code: "NASDAQ:FTFT",
      companyName: "Future FinTech Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fthm",
      code: "NASDAQ:FTHM",
      companyName: "Fathom Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fthy",
      code: "NASDAQ:FTHY",
      companyName:
        "First Trust High Yield Opportunities 2027 Term Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fti",
      code: "NASDAQ:FTI",
      companyName: "TechnipFMC plc Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftii",
      code: "NASDAQ:FTII",
      companyName: "FutureTech II Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftiiu",
      code: "NASDAQ:FTIIU",
      companyName: "FutureTech II Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftiiw",
      code: "NASDAQ:FTIIW",
      companyName: "FutureTech II Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftk",
      code: "NASDAQ:FTK",
      companyName: "Flotek Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftpa",
      code: "NASDAQ:FTPA",
      companyName: "FTAC Parnassus Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftpau",
      code: "NASDAQ:FTPAU",
      companyName: "FTAC Parnassus Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftpaw",
      code: "NASDAQ:FTPAW",
      companyName: "FTAC Parnassus Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftrp",
      code: "NASDAQ:FTRP",
      companyName: "Field Trip Health Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fts",
      code: "NASDAQ:FTS",
      companyName: "Fortis Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftv",
      code: "NASDAQ:FTV",
      companyName: "Fortive Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftvi",
      code: "NASDAQ:FTVI",
      companyName: "FinTech Acquisition Corp. VI Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ftviw",
      code: "NASDAQ:FTVIW",
      companyName: "FinTech Acquisition Corp. VI Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-fubo",
      code: "NASDAQ:FUBO",
      companyName: "fuboTV Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ful",
      code: "NASDAQ:FUL",
      companyName: "H. B. Fuller Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fulc",
      code: "NASDAQ:FULC",
      companyName: "Fulcrum Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fult",
      code: "NASDAQ:FULT",
      companyName: "Fulton Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fultp",
      code: "NASDAQ:FULTP",
      companyName:
        "Fulton Financial Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of Fixed Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-fun",
      code: "NASDAQ:FUN",
      companyName: "Cedar Fair L.P. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-func",
      code: "NASDAQ:FUNC",
      companyName: "First United Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fund",
      code: "NASDAQ:FUND",
      companyName: "Sprott Focus Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fury",
      code: "NASDAQ:FURY",
      companyName: "Fury Gold Mines Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fusb",
      code: "NASDAQ:FUSB",
      companyName: "First US Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-futu",
      code: "NASDAQ:FUTU",
      companyName: "Futu Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fvam",
      code: "NASDAQ:FVAM",
      companyName: "5:01 Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fvcb",
      code: "NASDAQ:FVCB",
      companyName: "FVCBankcorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fviv",
      code: "NASDAQ:FVIV",
      companyName: "Fortress Value Acquisition Corp. IV Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fvrr",
      code: "NASDAQ:FVRR",
      companyName: "Fiverr International Ltd. Ordinary Shares no par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-fvt",
      code: "NASDAQ:FVT",
      companyName: "Fortress Value Acquisition Corp. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fwac",
      code: "NASDAQ:FWAC",
      companyName: "Fifth Wall Acquisition Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fwbi",
      code: "NASDAQ:FWBI",
      companyName: "First Wave BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fwona",
      code: "NASDAQ:FWONA",
      companyName:
        "Liberty Media Corporation Series A Liberty Formula One Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fwp",
      code: "NASDAQ:FWP",
      companyName: "Forward Pharma A/S American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fwrd",
      code: "NASDAQ:FWRD",
      companyName: "Forward Air Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fwrg",
      code: "NASDAQ:FWRG",
      companyName: "First Watch Restaurant Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fxcor",
      code: "NASDAQ:FXCOR",
      companyName: "Financial Strategies Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-fxlv",
      code: "NASDAQ:FXLV",
      companyName: "F45 Training Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fxnc",
      code: "NASDAQ:FXNC",
      companyName: "First National Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fybr",
      code: "NASDAQ:FYBR",
      companyName: "Frontier Communications Parent Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fzt",
      code: "NASDAQ:FZT",
      companyName: "FAST Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-g",
      code: "NASDAQ:G",
      companyName: "Genpact Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gab",
      code: "NASDAQ:GAB",
      companyName: "Gabelli Equity Trust Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gab-g",
      code: "NASDAQ:GAB-G",
      companyName:
        "Gabelli Equity Trust Inc. (The) Series G Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gab-h",
      code: "NASDAQ:GAB-H",
      companyName: "Gabelli Equity Trust Inc. (The) Pfd Ser H",
      popularity: 0,
    },
    {
      slug: "nasdaq-gab-k",
      code: "NASDAQ:GAB-K",
      companyName:
        "Gabelli Equity Trust Inc. (The) 5.00% Series K Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gabc",
      code: "NASDAQ:GABC",
      companyName: "German American Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gacq",
      code: "NASDAQ:GACQ",
      companyName: "Global Consumer Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gacqu",
      code: "NASDAQ:GACQU",
      companyName: "Global Consumer Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gacqw",
      code: "NASDAQ:GACQW",
      companyName: "Global Consumer Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gaia",
      code: "NASDAQ:GAIA",
      companyName: "Gaia Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gain",
      code: "NASDAQ:GAIN",
      companyName:
        "Gladstone Investment Corporation Business Development Company",
      popularity: 0,
    },
    {
      slug: "nasdaq-gainn",
      code: "NASDAQ:GAINN",
      companyName: "Gladstone Investment Corporation 5.00% Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-gainz",
      code: "NASDAQ:GAINZ",
      companyName: "Gladstone Investment Corporation 4.875% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-galt",
      code: "NASDAQ:GALT",
      companyName: "Galectin Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gam",
      code: "NASDAQ:GAM",
      companyName: "General American Investors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gam-b",
      code: "NASDAQ:GAM-B",
      companyName:
        "General American Investors Company Inc. Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gamb",
      code: "NASDAQ:GAMB",
      companyName: "Gambling.com Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gamc",
      code: "NASDAQ:GAMC",
      companyName: "Golden Arrow Merger Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gamcu",
      code: "NASDAQ:GAMCU",
      companyName: "Golden Arrow Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gamcw",
      code: "NASDAQ:GAMCW",
      companyName: "Golden Arrow Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-game",
      code: "NASDAQ:GAME",
      companyName: "Engine Gaming and Media Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gan",
      code: "NASDAQ:GAN",
      companyName: "GAN Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ganx",
      code: "NASDAQ:GANX",
      companyName: "Gain Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gapa",
      code: "NASDAQ:GAPA",
      companyName: "G&P Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gaq",
      code: "NASDAQ:GAQ",
      companyName:
        "Generation Asia I Acquisition Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gass",
      code: "NASDAQ:GASS",
      companyName: "StealthGas Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gate",
      code: "NASDAQ:GATE",
      companyName: "Marblegate Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gateu",
      code: "NASDAQ:GATEU",
      companyName: "Marblegate Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gatew",
      code: "NASDAQ:GATEW",
      companyName: "Marblegate Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gato",
      code: "NASDAQ:GATO",
      companyName: "Gatos Silver Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gatx",
      code: "NASDAQ:GATX",
      companyName: "GATX Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gau",
      code: "NASDAQ:GAU",
      companyName: "Galiano Gold Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-gb",
      code: "NASDAQ:GB",
      companyName: "Global Blue Group Holding AG Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbab",
      code: "NASDAQ:GBAB",
      companyName:
        "Guggenheim Taxable Municipal Bond & Investment Grade Debt Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbci",
      code: "NASDAQ:GBCI",
      companyName: "Glacier Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbdc",
      code: "NASDAQ:GBDC",
      companyName: "Golub Capital BDC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbli",
      code: "NASDAQ:GBLI",
      companyName: "Global Indemnity Group LLC Class A Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbnh",
      code: "NASDAQ:GBNH",
      companyName: "Greenbrook TMS Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbny",
      code: "NASDAQ:GBNY",
      companyName: "Generations Bancorp NY Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbox",
      code: "NASDAQ:GBOX",
      companyName: "Greenbox POS Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbr",
      code: "NASDAQ:GBR",
      companyName: "New Concept Energy Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbrg",
      code: "NASDAQ:GBRG",
      companyName: "Goldenbridge Acquisition Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbrgr",
      code: "NASDAQ:GBRGR",
      companyName: "Goldenbridge Acquisition Limited Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbrgw",
      code: "NASDAQ:GBRGW",
      companyName: "Goldenbridge Acquisition Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbs",
      code: "NASDAQ:GBS",
      companyName: "GBS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbt",
      code: "NASDAQ:GBT",
      companyName: "Global Blood Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbx",
      code: "NASDAQ:GBX",
      companyName: "Greenbrier Companies Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gcbc",
      code: "NASDAQ:GCBC",
      companyName: "Greene County Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gci",
      code: "NASDAQ:GCI",
      companyName: "Gannett Co. Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gcmg",
      code: "NASDAQ:GCMG",
      companyName: "GCM Grosvenor Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gcmgw",
      code: "NASDAQ:GCMGW",
      companyName: "GCM Grosvenor Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gco",
      code: "NASDAQ:GCO",
      companyName: "Genesco Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gcp",
      code: "NASDAQ:GCP",
      companyName: "GCP Applied Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gctk",
      code: "NASDAQ:GCTK",
      companyName: "GlucoTrack Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gcv",
      code: "NASDAQ:GCV",
      companyName:
        "Gabelli Convertible and Income Securities Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gd",
      code: "NASDAQ:GD",
      companyName: "General Dynamics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gddy",
      code: "NASDAQ:GDDY",
      companyName: "GoDaddy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gden",
      code: "NASDAQ:GDEN",
      companyName: "Golden Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdl",
      code: "NASDAQ:GDL",
      companyName: "GDL Fund The Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdl-c",
      code: "NASDAQ:GDL-C",
      companyName:
        "The GDL Fund Series C Cumulative Puttable and Callable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdnr",
      code: "NASDAQ:GDNR",
      companyName: "Gardiner Healthcare Acquisitions Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdnru",
      code: "NASDAQ:GDNRU",
      companyName: "Gardiner Healthcare Acquisitions Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdnrw",
      code: "NASDAQ:GDNRW",
      companyName: "Gardiner Healthcare Acquisitions Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdo",
      code: "NASDAQ:GDO",
      companyName:
        "Western Asset Global Corporate Defined Opportunity Fund Inc. Western Asset Global Corporate Defined Opportunity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdot",
      code: "NASDAQ:GDOT",
      companyName:
        "Green Dot Corporation Class A Common Stock $0.001 par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdrx",
      code: "NASDAQ:GDRX",
      companyName: "GoodRx Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gds",
      code: "NASDAQ:GDS",
      companyName: "GDS Holdings Limited ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdst",
      code: "NASDAQ:GDST",
      companyName: "Goldenstone Acquisition Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdstr",
      code: "NASDAQ:GDSTR",
      companyName: "Goldenstone Acquisition Limited Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdstu",
      code: "NASDAQ:GDSTU",
      companyName: "Goldenstone Acquisition Limited Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdstw",
      code: "NASDAQ:GDSTW",
      companyName: "Goldenstone Acquisition Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdv",
      code: "NASDAQ:GDV",
      companyName:
        "Gabelli Dividend & Income Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdv-h",
      code: "NASDAQ:GDV-H",
      companyName:
        "The Gabelli Dividend & Income Trust 5.375% Series H Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdv-k",
      code: "NASDAQ:GDV-K",
      companyName:
        "The Gabelli Dividend & Income Trust 4.250% Series K Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gdyn",
      code: "NASDAQ:GDYN",
      companyName: "Grid Dynamics Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ge",
      code: "NASDAQ:GE",
      companyName: "General Electric Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gecc",
      code: "NASDAQ:GECC",
      companyName: "Great Elm Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-geccm",
      code: "NASDAQ:GECCM",
      companyName: "Great Elm Capital Corp. 6.75% Notes Due 2025",
      popularity: 0,
    },
    {
      slug: "nasdaq-geccn",
      code: "NASDAQ:GECCN",
      companyName: "Great Elm Capital Corp. 6.5% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-gecco",
      code: "NASDAQ:GECCO",
      companyName: "Great Elm Capital Corp. 5.875% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-geex",
      code: "NASDAQ:GEEX",
      companyName:
        "Games & Esports Experience Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-geexu",
      code: "NASDAQ:GEEXU",
      companyName: "Games & Esports Experience Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gef",
      code: "NASDAQ:GEF",
      companyName: "Greif Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-geg",
      code: "NASDAQ:GEG",
      companyName: "Great Elm Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gel",
      code: "NASDAQ:GEL",
      companyName: "Genesis Energy L.P. Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-genc",
      code: "NASDAQ:GENC",
      companyName: "Gencor Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gene",
      code: "NASDAQ:GENE",
      companyName: "Genetic Technologies Ltd ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-geni",
      code: "NASDAQ:GENI",
      companyName: "Genius Sports Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-genq",
      code: "NASDAQ:GENQ",
      companyName: "Genesis Unicorn Capital Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-genqw",
      code: "NASDAQ:GENQW",
      companyName: "Genesis Unicorn Capital Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-geo",
      code: "NASDAQ:GEO",
      companyName: "Geo Group Inc (The) REIT",
      popularity: 0,
    },
    {
      slug: "nasdaq-geos",
      code: "NASDAQ:GEOS",
      companyName: "Geospace Technologies Corporation Common Stock (Texas)",
      popularity: 0,
    },
    {
      slug: "nasdaq-gern",
      code: "NASDAQ:GERN",
      companyName: "Geron Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ges",
      code: "NASDAQ:GES",
      companyName: "Guess? Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gvp",
      code: "NASDAQ:GVP",
      companyName: "GSE Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-get",
      code: "NASDAQ:GET",
      companyName:
        "Getnet Adquirencia e Servicos para Meios de Pagamento S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gevo",
      code: "NASDAQ:GEVO",
      companyName: "Gevo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gf",
      code: "NASDAQ:GF",
      companyName: "New Germany Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfai",
      code: "NASDAQ:GFAI",
      companyName: "Guardforce AI Co. Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfaiw",
      code: "NASDAQ:GFAIW",
      companyName: "Guardforce AI Co. Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gff",
      code: "NASDAQ:GFF",
      companyName: "Griffon Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfgd",
      code: "NASDAQ:GFGD",
      companyName:
        "The Growth for Good Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfgdu",
      code: "NASDAQ:GFGDU",
      companyName: "The Growth for Good Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfgdw",
      code: "NASDAQ:GFGDW",
      companyName: "The Growth for Good Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfi",
      code: "NASDAQ:GFI",
      companyName: "Gold Fields Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfl",
      code: "NASDAQ:GFL",
      companyName:
        "GFL Environmental Inc. Subordinate voting shares no par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-gflu",
      code: "NASDAQ:GFLU",
      companyName: "GFL Environmental Inc. Tangible Equity Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfor",
      code: "NASDAQ:GFOR",
      companyName: "Graf Acquisition Corp. IV Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfs",
      code: "NASDAQ:GFS",
      companyName: "GlobalFoundries Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gfx",
      code: "NASDAQ:GFX",
      companyName: "Golden Falcon Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggaa",
      code: "NASDAQ:GGAA",
      companyName:
        "Genesis Growth Tech Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggaaw",
      code: "NASDAQ:GGAAW",
      companyName: "Genesis Growth Tech Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggal",
      code: "NASDAQ:GGAL",
      companyName: "Grupo Financiero Galicia S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggb",
      code: "NASDAQ:GGB",
      companyName: "Gerdau S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gge",
      code: "NASDAQ:GGE",
      companyName: "Green Giant Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gggv",
      code: "NASDAQ:GGGV",
      companyName: "G3 VRM Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gggvr",
      code: "NASDAQ:GGGVR",
      companyName: "G3 VRM Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggmc",
      code: "NASDAQ:GGMC",
      companyName: "Glenfarne Merger Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggmcw",
      code: "NASDAQ:GGMCW",
      companyName: "Glenfarne Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggn",
      code: "NASDAQ:GGN",
      companyName: "GAMCO Global Gold Natural Resources & Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggpi",
      code: "NASDAQ:GGPI",
      companyName: "Gores Guggenheim Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggpiu",
      code: "NASDAQ:GGPIU",
      companyName: "Gores Guggenheim Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggpiw",
      code: "NASDAQ:GGPIW",
      companyName: "Gores Guggenheim Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggr",
      code: "NASDAQ:GGR",
      companyName: "Gogoro Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggrow",
      code: "NASDAQ:GGROW",
      companyName: "Gogoro Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggt",
      code: "NASDAQ:GGT",
      companyName: "Gabelli Multi-Media Trust Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggt-e",
      code: "NASDAQ:GGT-E",
      companyName:
        "Gabelli Multi-Media Trust Inc. (The) 5.125% Series E Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggt-g",
      code: "NASDAQ:GGT-G",
      companyName:
        "Gabelli Multi-Media Trust Inc. (The) 5.125% Series G Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggz",
      code: "NASDAQ:GGZ",
      companyName:
        "Gabelli Global Small and Mid Cap Value Trust (The) Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-gh",
      code: "NASDAQ:GH",
      companyName: "Guardant Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghac",
      code: "NASDAQ:GHAC",
      companyName:
        "Gaming & Hospitality Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghacu",
      code: "NASDAQ:GHACU",
      companyName: "Gaming & Hospitality Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghacw",
      code: "NASDAQ:GHACW",
      companyName: "Gaming & Hospitality Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghc",
      code: "NASDAQ:GHC",
      companyName: "Graham Holdings Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghg",
      code: "NASDAQ:GHG",
      companyName:
        "GreenTree Hospitality Group Ltd. American depositary shares each representing one Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghix",
      code: "NASDAQ:GHIX",
      companyName: "Gores Holdings IX Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghixu",
      code: "NASDAQ:GHIXU",
      companyName: "Gores Holdings IX Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghixw",
      code: "NASDAQ:GHIXW",
      companyName: "Gores Holdings IX Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghl",
      code: "NASDAQ:GHL",
      companyName: "Greenhill & Co. Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghld",
      code: "NASDAQ:GHLD",
      companyName: "Guild Holdings Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghm",
      code: "NASDAQ:GHM",
      companyName: "Graham Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghrs",
      code: "NASDAQ:GHRS",
      companyName: "GH Research PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghsi",
      code: "NASDAQ:GHSI",
      companyName: "Guardion Health Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ghy",
      code: "NASDAQ:GHY",
      companyName: "PGIM Global High Yield Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-gia",
      code: "NASDAQ:GIA",
      companyName: "GigCapital 5 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-giac",
      code: "NASDAQ:GIAC",
      companyName: "Gesher I Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-giacw",
      code: "NASDAQ:GIACW",
      companyName: "Gesher I Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-gib",
      code: "NASDAQ:GIB",
      companyName: "CGI Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gic",
      code: "NASDAQ:GIC",
      companyName: "Global Industrial Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gigm",
      code: "NASDAQ:GIGM",
      companyName: "GigaMedia Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-giii",
      code: "NASDAQ:GIII",
      companyName: "G-III Apparel Group LTD. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-giix",
      code: "NASDAQ:GIIX",
      companyName: "Gores Holdings VIII Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggn-b",
      code: "NASDAQ:GGN-B",
      companyName:
        "GAMCO Global Gold Natural Reources & Income Trust 5.00% Series B Cumulative 25.00 Liquidation Preference",
      popularity: 0,
    },
    {
      slug: "nasdaq-giixu",
      code: "NASDAQ:GIIXU",
      companyName: "Gores Holdings VIII Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-giixw",
      code: "NASDAQ:GIIXW",
      companyName: "Gores Holdings VIII Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gil",
      code: "NASDAQ:GIL",
      companyName: "Gildan Activewear Inc. Class A Sub. Vot. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gilt",
      code: "NASDAQ:GILT",
      companyName: "Gilat Satellite Networks Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gim",
      code: "NASDAQ:GIM",
      companyName: "Templeton Global Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gipr",
      code: "NASDAQ:GIPR",
      companyName: "Generation Income Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-giprw",
      code: "NASDAQ:GIPRW",
      companyName: "Generation Income Properties Inc Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gis",
      code: "NASDAQ:GIS",
      companyName: "General Mills Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-giw",
      code: "NASDAQ:GIW",
      companyName: "GigInternational1 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-giwwu",
      code: "NASDAQ:GIWWU",
      companyName: "GigInternational1 Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-giwww",
      code: "NASDAQ:GIWWW",
      companyName: "GigInternational1 Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gjo",
      code: "NASDAQ:GJO",
      companyName:
        "Synthetic Fixed-Income Securities Inc. Synthetic Fixed-Income Securities Inc. on behalf of STRATS(SM) Trust for Wal-Mart Stores Inc. Securities Series 2004-5",
      popularity: 0,
    },
    {
      slug: "nasdaq-gjr",
      code: "NASDAQ:GJR",
      companyName:
        "Synthetic Fixed-Income Securities Inc. STRATS Trust for Procter&Gamble Securities Series 2006-1",
      popularity: 0,
    },
    {
      slug: "nasdaq-gjs",
      code: "NASDAQ:GJS",
      companyName:
        "Goldman Sachs Group Securities STRATS Trust for Goldman Sachs Group Securities Series 2006-2",
      popularity: 0,
    },
    {
      slug: "nasdaq-gjt",
      code: "NASDAQ:GJT",
      companyName:
        "Synthetic Fixed-Income Securities Inc. Synthetic Fixed-Income Securities Inc. Floating Rate Structured Repackaged Asset-Backed Trust Securities Certificates Series 2006-3",
      popularity: 0,
    },
    {
      slug: "nasdaq-gkos",
      code: "NASDAQ:GKOS",
      companyName: "Glaukos Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gl",
      code: "NASDAQ:GL",
      companyName: "Globe Life Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gl-d",
      code: "NASDAQ:GL-D",
      companyName:
        "Globe Life Inc. 4.25% Junior Subordinated Debentures due 2061",
      popularity: 0,
    },
    {
      slug: "nasdaq-glad",
      code: "NASDAQ:GLAD",
      companyName: "Gladstone Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glaq",
      code: "NASDAQ:GLAQ",
      companyName: "Globis Acquisition Corp. common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glaqw",
      code: "NASDAQ:GLAQW",
      companyName: "Globis Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-glbe",
      code: "NASDAQ:GLBE",
      companyName: "Global-E Online Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-glbl",
      code: "NASDAQ:GLBL",
      companyName: "Cartesian Growth Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-glblu",
      code: "NASDAQ:GLBLU",
      companyName: "Cartesian Growth Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-glblw",
      code: "NASDAQ:GLBLW",
      companyName: "Cartesian Growth Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-glbs",
      code: "NASDAQ:GLBS",
      companyName: "Globus Maritime Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glbz",
      code: "NASDAQ:GLBZ",
      companyName: "Glen Burnie Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gldd",
      code: "NASDAQ:GLDD",
      companyName: "Great Lakes Dredge & Dock Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gldg",
      code: "NASDAQ:GLDG",
      companyName: "GoldMining Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-glee",
      code: "NASDAQ:GLEE",
      companyName: "Gladstone Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gleeu",
      code: "NASDAQ:GLEEU",
      companyName: "Gladstone Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gleew",
      code: "NASDAQ:GLEEW",
      companyName: "Gladstone Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-glg",
      code: "NASDAQ:GLG",
      companyName: "TD Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glha",
      code: "NASDAQ:GLHA",
      companyName: "Glass Houses Acquisition Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glhaw",
      code: "NASDAQ:GLHAW",
      companyName: "Glass Houses Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gllir",
      code: "NASDAQ:GLLIR",
      companyName: "Globalink Investment Inc. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-glliw",
      code: "NASDAQ:GLLIW",
      companyName: "Globalink Investment Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-glmd",
      code: "NASDAQ:GLMD",
      companyName: "Galmed Pharmaceuticals Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-glng",
      code: "NASDAQ:GLNG",
      companyName: "Golar Lng Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-glo",
      code: "NASDAQ:GLO",
      companyName: "Clough Global Opportunities Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glob",
      code: "NASDAQ:GLOB",
      companyName: "Globant S.A. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-glog-a",
      code: "NASDAQ:GLOG-A",
      companyName:
        "GasLog LP. 8.75% Series A Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-glop",
      code: "NASDAQ:GLOP",
      companyName:
        "GasLog Partners LP Common Units representing limited partnership interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-glop-a",
      code: "NASDAQ:GLOP-A",
      companyName:
        "GasLog Partners LP 8.625% Series A Cumulative Redeemable Perpetual Fixed to Floating Rate Preference Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-glop-b",
      code: "NASDAQ:GLOP-B",
      companyName:
        "GasLog Partners LP 8.200% Series B Cumulative Redeemable Perpetual Fixed to Floating Rate Preference Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-glop-c",
      code: "NASDAQ:GLOP-C",
      companyName:
        "GasLog Partners LP 8.500% Series C Cumulative Redeemable Perpetual Fixed to Floating Rate Preference Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-glp",
      code: "NASDAQ:GLP",
      companyName:
        "Global Partners LP Global Partners LP Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-glp-a",
      code: "NASDAQ:GLP-A",
      companyName:
        "Global Partners LP 9.75% Series A Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-glp-b",
      code: "NASDAQ:GLP-B",
      companyName:
        "Global Partners LP 9.50% Series B Fixed Rate Cumulative Redeemable Perpetual Preferred Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-glq",
      code: "NASDAQ:GLQ",
      companyName:
        "Clough Global Equity Fund Clough Global Equity Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-glre",
      code: "NASDAQ:GLRE",
      companyName: "Greenlight Capital Re Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gls",
      code: "NASDAQ:GLS",
      companyName: "Gelesis Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glsi",
      code: "NASDAQ:GLSI",
      companyName: "Greenwich LifeSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glspt",
      code: "NASDAQ:GLSPT",
      companyName: "Global SPAC Partners Co. Subunit ",
      popularity: 0,
    },
    {
      slug: "nasdaq-glspu",
      code: "NASDAQ:GLSPU",
      companyName: "Global SPAC Partners Co. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-glspw",
      code: "NASDAQ:GLSPW",
      companyName: "Global SPAC Partners Co. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-glt",
      code: "NASDAQ:GLT",
      companyName: "Glatfelter Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glta",
      code: "NASDAQ:GLTA",
      companyName: "Galata Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-glto",
      code: "NASDAQ:GLTO",
      companyName: "Galecto Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glu",
      code: "NASDAQ:GLU",
      companyName:
        "Gabelli Global Utility Common Shares of Beneficial Ownership",
      popularity: 0,
    },
    {
      slug: "nasdaq-glu-b",
      code: "NASDAQ:GLU-B",
      companyName:
        "The Gabelli Global Utility and Income Trust Series B Cumulative Puttable and Callable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-glue",
      code: "NASDAQ:GLUE",
      companyName: "Monte Rosa Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glv",
      code: "NASDAQ:GLV",
      companyName:
        "Clough Global Dividend and Income Fund Common Shares of beneficial interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-glw",
      code: "NASDAQ:GLW",
      companyName: "Corning Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glyc",
      code: "NASDAQ:GLYC",
      companyName: "GlycoMimetics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gm",
      code: "NASDAQ:GM",
      companyName: "General Motors Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmab",
      code: "NASDAQ:GMAB",
      companyName: "Genmab A/S ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmbl",
      code: "NASDAQ:GMBL",
      companyName: "Esports Entertainment Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmblp",
      code: "NASDAQ:GMBLP",
      companyName:
        "Esports Entertainment Group Inc. 10.0% Series A Cumulative Redeemable Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmblw",
      code: "NASDAQ:GMBLW",
      companyName: "Esports Entertainment Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmblz",
      code: "NASDAQ:GMBLZ",
      companyName: "Esports Entertainment Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmda",
      code: "NASDAQ:GMDA",
      companyName: "Gamida Cell Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnrc",
      code: "NASDAQ:GNRC",
      companyName: "Generac Holdlings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmed",
      code: "NASDAQ:GMED",
      companyName: "Globus Medical Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmfi",
      code: "NASDAQ:GMFI",
      companyName: "Aetherium Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmfiu",
      code: "NASDAQ:GMFIU",
      companyName: "Aetherium Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmgi",
      code: "NASDAQ:GMGI",
      companyName: "Golden Matrix Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmre",
      code: "NASDAQ:GMRE",
      companyName: "Global Medical REIT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmre-a",
      code: "NASDAQ:GMRE-A",
      companyName:
        "Global Medical REIT Inc. Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gms",
      code: "NASDAQ:GMS",
      companyName: "GMS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmtx",
      code: "NASDAQ:GMTX",
      companyName: "Gemini Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmvd",
      code: "NASDAQ:GMVD",
      companyName: "G Medical Innovations Holdings Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gmvdw",
      code: "NASDAQ:GMVDW",
      companyName: "G Medical Innovations Holdings Ltd. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnac",
      code: "NASDAQ:GNAC",
      companyName: "Group Nine Acquisition Corp. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnacw",
      code: "NASDAQ:GNACW",
      companyName: "Group Nine Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnca",
      code: "NASDAQ:GNCA",
      companyName: "Genocea Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gne",
      code: "NASDAQ:GNE",
      companyName: "Genie Energy Ltd. Class B Common Stock Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gne-a",
      code: "NASDAQ:GNE-A",
      companyName:
        "Genie Energy Ltd. Series 2012 - A Preferred Stock $0.01 par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnft",
      code: "NASDAQ:GNFT",
      companyName: "GENFIT S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnk",
      code: "NASDAQ:GNK",
      companyName:
        "Genco Shipping & Trading Limited Ordinary Shares New (Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnl",
      code: "NASDAQ:GNL",
      companyName: "Global Net Lease Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnl-a",
      code: "NASDAQ:GNL-A",
      companyName:
        "Global Net Lease Inc. 7.25% Series A Cumulative Redeemable Preferred Stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnl-b",
      code: "NASDAQ:GNL-B",
      companyName:
        "Global Net Lease Inc. 6.875% Series B Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnln",
      code: "NASDAQ:GNLN",
      companyName: "Greenlane Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnpx",
      code: "NASDAQ:GNPX",
      companyName: "Genprex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gns",
      code: "NASDAQ:GNS",
      companyName: "Genius Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnss",
      code: "NASDAQ:GNSS",
      companyName: "Genasys Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnt",
      code: "NASDAQ:GNT",
      companyName: "GAMCO Natural Resources Gold & Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnta",
      code: "NASDAQ:GNTA",
      companyName: "Genenta Science S.p.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gntx",
      code: "NASDAQ:GNTX",
      companyName: "Gentex Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnty",
      code: "NASDAQ:GNTY",
      companyName: "Guaranty Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-goco",
      code: "NASDAQ:GOCO",
      companyName: "GoHealth Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-goed",
      code: "NASDAQ:GOED",
      companyName: "1847 Goedeker Inc. Commom Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-goev",
      code: "NASDAQ:GOEV",
      companyName: "Canoo Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-goevw",
      code: "NASDAQ:GOEVW",
      companyName: "Canoo Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gof",
      code: "NASDAQ:GOF",
      companyName:
        "Guggenheim Strategic Opportunities Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-gogl",
      code: "NASDAQ:GOGL",
      companyName: "Golden Ocean Group Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gogn",
      code: "NASDAQ:GOGN",
      companyName: "GoGreen Investments Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gogo",
      code: "NASDAQ:GOGO",
      companyName: "Gogo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gol",
      code: "NASDAQ:GOL",
      companyName:
        "Gol Linhas Aereas Inteligentes S.A. Sponsored ADR representing 2 Pfd Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnt-a",
      code: "NASDAQ:GNT-A",
      companyName:
        "GAMCO Natural Resources Gold & Income Tust  5.20% Series A Cumulative Preferred Shares (Liquidation Preference $25.00 per share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-golf",
      code: "NASDAQ:GOLF",
      companyName: "Acushnet Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-good",
      code: "NASDAQ:GOOD",
      companyName:
        "Gladstone Commercial Corporation Real Estate Investment Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-goodn",
      code: "NASDAQ:GOODN",
      companyName:
        "Gladstone Commercial Corporation 6.625% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-goodo",
      code: "NASDAQ:GOODO",
      companyName:
        "Gladstone Commercial Corporation 6.00% Series G Cumulative Redeemable Preferred Stock par value $0.001 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-goos",
      code: "NASDAQ:GOOS",
      companyName: "Canada Goose Holdings Inc. Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-goro",
      code: "NASDAQ:GORO",
      companyName: "Gold Resource Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-goss",
      code: "NASDAQ:GOSS",
      companyName: "Gossamer Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gotu",
      code: "NASDAQ:GOTU",
      companyName: "Gaotu Techedu Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-govx",
      code: "NASDAQ:GOVX",
      companyName: "GeoVax Labs Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-govxw",
      code: "NASDAQ:GOVXW",
      companyName: "GeoVax Labs Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-gp",
      code: "NASDAQ:GP",
      companyName: "GreenPower Motor Company Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpac",
      code: "NASDAQ:GPAC",
      companyName: "Global Partner Acquisition Corp II Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpacu",
      code: "NASDAQ:GPACU",
      companyName: "Global Partner Acquisition Corp II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpacw",
      code: "NASDAQ:GPACW",
      companyName: "Global Partner Acquisition Corp II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpc",
      code: "NASDAQ:GPC",
      companyName: "Genuine Parts Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpco",
      code: "NASDAQ:GPCO",
      companyName: "Golden Path Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpcor",
      code: "NASDAQ:GPCOR",
      companyName: "Golden Path Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpcou",
      code: "NASDAQ:GPCOU",
      companyName: "Golden Path Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpcow",
      code: "NASDAQ:GPCOW",
      companyName: "Golden Path Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpi",
      code: "NASDAQ:GPI",
      companyName: "Group 1 Automotive Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpja",
      code: "NASDAQ:GPJA",
      companyName:
        "Georgia Power Company Series 2017A 5.00% Junior Subordinated Notes due October 1 2077",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpk",
      code: "NASDAQ:GPK",
      companyName: "Graphic Packaging Holding Company",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpl",
      code: "NASDAQ:GPL",
      companyName: "Great Panther Mining Limited Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpmt",
      code: "NASDAQ:GPMT",
      companyName: "Granite Point Mortgage Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpmt-a",
      code: "NASDAQ:GPMT-A",
      companyName:
        "Granite Point Mortgage Trust Inc. 7.00% Series A Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpn",
      code: "NASDAQ:GPN",
      companyName: "Global Payments Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpor",
      code: "NASDAQ:GPOR",
      companyName: "Gulfport Energy Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpp",
      code: "NASDAQ:GPP",
      companyName: "Green Plains Partners LP Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpre",
      code: "NASDAQ:GPRE",
      companyName: "Green Plains Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gprk",
      code: "NASDAQ:GPRK",
      companyName: "Geopark Ltd Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gpro",
      code: "NASDAQ:GPRO",
      companyName: "GoPro Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gps",
      code: "NASDAQ:GPS",
      companyName: "Gap Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grab",
      code: "NASDAQ:GRAB",
      companyName: "Grab Holdings Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-grabw",
      code: "NASDAQ:GRABW",
      companyName: "Grab Holdings Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gray",
      code: "NASDAQ:GRAY",
      companyName: "Graybug Vision Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grbk",
      code: "NASDAQ:GRBK",
      companyName: "Green Brick Partners Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grbk-a",
      code: "NASDAQ:GRBK-A",
      companyName:
        "Green Brick Partners Inc. Depositary Shares (each representing a 1/1000th fractional interest in a share of 5.75% Series A Cumulative Perpetual Preferred Stock)",
      popularity: 0,
    },
    {
      slug: "nasdaq-grc",
      code: "NASDAQ:GRC",
      companyName: "Gorman-Rupp Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grcy",
      code: "NASDAQ:GRCY",
      companyName: "Greencity Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-grcyw",
      code: "NASDAQ:GRCYW",
      companyName: "Greencity Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-gree",
      code: "NASDAQ:GREE",
      companyName: "Greenidge Generation Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-greel",
      code: "NASDAQ:GREEL",
      companyName:
        "Greenidge Generation Holdings Inc. 8.50% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-grf",
      code: "NASDAQ:GRF",
      companyName: "Eagle Capital Growth Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grfs",
      code: "NASDAQ:GRFS",
      companyName: "Grifols S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gril",
      code: "NASDAQ:GRIL",
      companyName: "Muscle Maker Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grin",
      code: "NASDAQ:GRIN",
      companyName: "Grindrod Shipping Holdings Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-grmn",
      code: "NASDAQ:GRMN",
      companyName: "Garmin Ltd. Common Stock (Switzerland)",
      popularity: 0,
    },
    {
      slug: "nasdaq-grna",
      code: "NASDAQ:GRNA",
      companyName: "GreenLight Biosciences Holdings PBC Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grnaw",
      code: "NASDAQ:GRNAW",
      companyName: "GreenLight Biosciences Holdings PBC Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-grnq",
      code: "NASDAQ:GRNQ",
      companyName: "Greenpro Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grom",
      code: "NASDAQ:GROM",
      companyName: "Grom Social Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gromw",
      code: "NASDAQ:GROMW",
      companyName: "Grom Social Enterprises Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-grow",
      code: "NASDAQ:GROW",
      companyName: "U.S. Global Investors Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-groy",
      code: "NASDAQ:GROY",
      companyName: "Gold Royalty Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-grph",
      code: "NASDAQ:GRPH",
      companyName: "Graphite Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grpn",
      code: "NASDAQ:GRPN",
      companyName: "Groupon Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grts",
      code: "NASDAQ:GRTS",
      companyName: "Gritstone bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grtx",
      code: "NASDAQ:GRTX",
      companyName: "Galera Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grvi",
      code: "NASDAQ:GRVI",
      companyName: "Grove Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grvy",
      code: "NASDAQ:GRVY",
      companyName: "GRAVITY Co. Ltd. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-grwg",
      code: "NASDAQ:GRWG",
      companyName: "GrowGeneration Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-grx",
      code: "NASDAQ:GRX",
      companyName:
        "The Gabelli Healthcare & Wellness Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-gs-a",
      code: "NASDAQ:GS-A",
      companyName:
        "Goldman Sachs Group Inc. (The) Depositary Shares each representing 1/1000th Interest in a Share of Floating Rate Non-Cumulative Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-gs-c",
      code: "NASDAQ:GS-C",
      companyName:
        "Goldman Sachs Group Inc. (The) Depositary Share repstg 1/1000th Preferred Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-gs-d",
      code: "NASDAQ:GS-D",
      companyName:
        "Goldman Sachs Group Inc. (The) Dep Shs repstg 1/1000 Pfd Ser D Fltg",
      popularity: 0,
    },
    {
      slug: "nasdaq-gs-j",
      code: "NASDAQ:GS-J",
      companyName:
        "Goldman Sachs Group Inc Depositary Shs Repstg 1/1000th Pfd Ser J Fixed to Fltg Rate",
      popularity: 0,
    },
    {
      slug: "nasdaq-gs-k",
      code: "NASDAQ:GS-K",
      companyName:
        "Goldman Sachs Group Inc. (The) Dep Shs Repstg 1/1000 Int Sh Fxd/Fltg Non Cum Pfd Stk Ser K",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsaq",
      code: "NASDAQ:GSAQ",
      companyName: "Global Synergy Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsaqu",
      code: "NASDAQ:GSAQU",
      companyName: "Global Synergy Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsaqw",
      code: "NASDAQ:GSAQW",
      companyName: "Global Synergy Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsat",
      code: "NASDAQ:GSAT",
      companyName: "Globalstar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsbc",
      code: "NASDAQ:GSBC",
      companyName: "Great Southern Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsbd",
      code: "NASDAQ:GSBD",
      companyName: "Goldman Sachs BDC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsev",
      code: "NASDAQ:GSEV",
      companyName: "Gores Holdings VII Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsevu",
      code: "NASDAQ:GSEVU",
      companyName: "Gores Holdings VII Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsevw",
      code: "NASDAQ:GSEVW",
      companyName: "Gores Holdings VII Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gshd",
      code: "NASDAQ:GSHD",
      companyName: "Goosehead Insurance Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsit",
      code: "NASDAQ:GSIT",
      companyName: "GSI Technology Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsk",
      code: "NASDAQ:GSK",
      companyName: "GlaxoSmithKline PLC Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsl",
      code: "NASDAQ:GSL",
      companyName: "Global Ship Lease Inc New Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsl-b",
      code: "NASDAQ:GSL-B",
      companyName:
        "Global Ship Lease Inc. Depository Shares Representing 1/100th Perpetual Preferred Series B% (Marshall Island)",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsld",
      code: "NASDAQ:GSLD",
      companyName: "Global Ship Lease Inc. 8.00% Senior Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsm",
      code: "NASDAQ:GSM",
      companyName: "Ferroglobe PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsmg",
      code: "NASDAQ:GSMG",
      companyName: "Glory Star New Media Group Holdings Limited Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsmgw",
      code: "NASDAQ:GSMGW",
      companyName:
        "Glory Star New Media Group Holdings Limited Warrant expiring 2/13/2025",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsqb",
      code: "NASDAQ:GSQB",
      companyName: "G Squared Ascend II Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsqd",
      code: "NASDAQ:GSQD",
      companyName: "G Squared Ascend I Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsrm",
      code: "NASDAQ:GSRM",
      companyName: "GSR II Meteora Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsrmr",
      code: "NASDAQ:GSRMR",
      companyName: "GSR II Meteora Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsrmu",
      code: "NASDAQ:GSRMU",
      companyName: "GSR II Meteora Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsrmw",
      code: "NASDAQ:GSRMW",
      companyName: "GSR II Meteora Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gsv",
      code: "NASDAQ:GSV",
      companyName: "Gold Standard Ventures Corporation Common Stock (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-gt",
      code: "NASDAQ:GT",
      companyName: "The Goodyear Tire & Rubber Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gte",
      code: "NASDAQ:GTE",
      companyName: "Gran Tierra Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtec",
      code: "NASDAQ:GTEC",
      companyName: "Greenland Technologies Holding Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtes",
      code: "NASDAQ:GTES",
      companyName: "Gates Industrial Corporation plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gth",
      code: "NASDAQ:GTH",
      companyName: "Genetron Holdings Limited ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-gthx",
      code: "NASDAQ:GTHX",
      companyName: "G1 Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtim",
      code: "NASDAQ:GTIM",
      companyName: "Good Times Restaurants Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtlb",
      code: "NASDAQ:GTLB",
      companyName: "GitLab Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtls",
      code: "NASDAQ:GTLS",
      companyName: "Chart Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtn",
      code: "NASDAQ:GTN",
      companyName: "Gray Television Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtpa",
      code: "NASDAQ:GTPA",
      companyName: "Gores Technology Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtpau",
      code: "NASDAQ:GTPAU",
      companyName: "Gores Technology Partners Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtpaw",
      code: "NASDAQ:GTPAW",
      companyName: "Gores Technology Partners Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtpb",
      code: "NASDAQ:GTPB",
      companyName: "Gores Technology Partners II Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtpbu",
      code: "NASDAQ:GTPBU",
      companyName: "Gores Technology Partners II Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtpbw",
      code: "NASDAQ:GTPBW",
      companyName: "Gores Technology Partners II Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtx",
      code: "NASDAQ:GTX",
      companyName: "Garrett Motion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtxap",
      code: "NASDAQ:GTXAP",
      companyName:
        "Garrett Motion Inc. Series A Cumulative Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gty",
      code: "NASDAQ:GTY",
      companyName: "Getty Realty Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtyh",
      code: "NASDAQ:GTYH",
      companyName: "GTY Technology Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gug",
      code: "NASDAQ:GUG",
      companyName:
        "Guggenheim Active Allocation Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-gure",
      code: "NASDAQ:GURE",
      companyName: "Gulf Resources Inc. (NV) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gut",
      code: "NASDAQ:GUT",
      companyName: "Gabelli Utility Trust (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gut-c",
      code: "NASDAQ:GUT-C",
      companyName:
        "Gabelli Utility Trust (The) 5.375% Series C Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gva",
      code: "NASDAQ:GVA",
      companyName: "Granite Construction Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gvci",
      code: "NASDAQ:GVCI",
      companyName:
        "Green Visor Financial Technology Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gvciw",
      code: "NASDAQ:GVCIW",
      companyName:
        "Green Visor Financial Technology Acquisition Corp. I Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-gwh",
      code: "NASDAQ:GWH",
      companyName: "ESS Tech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gwii",
      code: "NASDAQ:GWII",
      companyName: "Good Works II Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gwiiw",
      code: "NASDAQ:GWIIW",
      companyName: "Good Works II Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gwre",
      code: "NASDAQ:GWRE",
      companyName: "Guidewire Software Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gwrs",
      code: "NASDAQ:GWRS",
      companyName: "Global Water Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gww",
      code: "NASDAQ:GWW",
      companyName: "W.W. Grainger Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gxii",
      code: "NASDAQ:GXII",
      companyName: "GX Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gxiiu",
      code: "NASDAQ:GXIIU",
      companyName: "GX Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-gxiiw",
      code: "NASDAQ:GXIIW",
      companyName: "GX Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-gxo",
      code: "NASDAQ:GXO",
      companyName: "GXO Logistics Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-h",
      code: "NASDAQ:H",
      companyName: "Hyatt Hotels Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ha",
      code: "NASDAQ:HA",
      companyName: "Hawaiian Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-haac",
      code: "NASDAQ:HAAC",
      companyName: "Health Assurance Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-haacu",
      code: "NASDAQ:HAACU",
      companyName: "Health Assurance Acquisition Corp. SAIL Securities",
      popularity: 0,
    },
    {
      slug: "nasdaq-haacw",
      code: "NASDAQ:HAACW",
      companyName: "Health Assurance Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-hae",
      code: "NASDAQ:HAE",
      companyName: "Haemonetics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hafc",
      code: "NASDAQ:HAFC",
      companyName: "Hanmi Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-haia",
      code: "NASDAQ:HAIA",
      companyName: "Healthcare AI Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hain",
      code: "NASDAQ:HAIN",
      companyName: "Hain Celestial Group Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hal",
      code: "NASDAQ:HAL",
      companyName: "Halliburton Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hall",
      code: "NASDAQ:HALL",
      companyName: "Hallmark Financial Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-halo",
      code: "NASDAQ:HALO",
      companyName: "Halozyme Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-happ",
      code: "NASDAQ:HAPP",
      companyName:
        "Happiness Development Group Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-harp",
      code: "NASDAQ:HARP",
      companyName: "Harpoon Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-has",
      code: "NASDAQ:HAS",
      companyName: "Hasbro Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hasi",
      code: "NASDAQ:HASI",
      companyName:
        "Hannon Armstrong Sustainable Infrastructure Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hayn",
      code: "NASDAQ:HAYN",
      companyName: "Haynes International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hayw",
      code: "NASDAQ:HAYW",
      companyName: "Hayward Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hbanm",
      code: "NASDAQ:HBANM",
      companyName:
        "Huntington Bancshares Incorporated Depositary Shares each representing a 1/1000th interest in a share of Huntington Series I Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hbb",
      code: "NASDAQ:HBB",
      companyName:
        "Hamilton Beach Brands Holding Company Class A Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-hbcp",
      code: "NASDAQ:HBCP",
      companyName: "Home Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hbi",
      code: "NASDAQ:HBI",
      companyName: "Hanesbrands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hbio",
      code: "NASDAQ:HBIO",
      companyName: "Harvard Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hbm",
      code: "NASDAQ:HBM",
      companyName: "Hudbay Minerals Inc. Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-hbnc",
      code: "NASDAQ:HBNC",
      companyName: "Horizon Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hbt",
      code: "NASDAQ:HBT",
      companyName: "HBT Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hca",
      code: "NASDAQ:HCA",
      companyName: "HCA Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcar",
      code: "NASDAQ:HCAR",
      companyName:
        "Healthcare Services Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcaru",
      code: "NASDAQ:HCARU",
      companyName: "Healthcare Services Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcarw",
      code: "NASDAQ:HCARW",
      companyName: "Healthcare Services Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcat",
      code: "NASDAQ:HCAT",
      companyName: "Health Catalyst Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcc",
      code: "NASDAQ:HCC",
      companyName: "Warrior Met Coal Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcci",
      code: "NASDAQ:HCCI",
      companyName: "Heritage-Crystal Clean Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcdi",
      code: "NASDAQ:HCDI",
      companyName: "Harbor Custom Development Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcdip",
      code: "NASDAQ:HCDIP",
      companyName:
        "Harbor Custom Development Inc. 8.0% Series A Cumulative Convertible Preferred Stock no par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcdiw",
      code: "NASDAQ:HCDIW",
      companyName: "Harbor Custom Development Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcdiz",
      code: "NASDAQ:HCDIZ",
      companyName: "Harbor Custom Development Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hci",
      code: "NASDAQ:HCI",
      companyName: "HCI Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcic",
      code: "NASDAQ:HCIC",
      companyName: "Hennessy Capital Investment Corp. V Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcicu",
      code: "NASDAQ:HCICU",
      companyName: "Hennessy Capital Investment Corp. V Units ",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcicw",
      code: "NASDAQ:HCICW",
      companyName: "Hennessy Capital Investment Corp. V Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcii",
      code: "NASDAQ:HCII",
      companyName: "Hudson Executive Investment Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hciiu",
      code: "NASDAQ:HCIIU",
      companyName: "Hudson Executive Investment Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-hciiw",
      code: "NASDAQ:HCIIW",
      companyName: "Hudson Executive Investment Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hckt",
      code: "NASDAQ:HCKT",
      companyName: "Hackett Group Inc (The). Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcm",
      code: "NASDAQ:HCM",
      companyName: "HUTCHMED (China) Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcma",
      code: "NASDAQ:HCMA",
      companyName: "HCM Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcne",
      code: "NASDAQ:HCNE",
      companyName: "Jaws Hurricane Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcneu",
      code: "NASDAQ:HCNEU",
      companyName: "Jaws Hurricane Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcnew",
      code: "NASDAQ:HCNEW",
      companyName: "Jaws Hurricane Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcp",
      code: "NASDAQ:HCP",
      companyName: "HashiCorp Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcsg",
      code: "NASDAQ:HCSG",
      companyName: "Healthcare Services Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcti",
      code: "NASDAQ:HCTI",
      companyName: "Healthcare Triangle Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcvi",
      code: "NASDAQ:HCVI",
      companyName: "Hennessy Capital Investment Corp. VI Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcviu",
      code: "NASDAQ:HCVIU",
      companyName: "Hennessy Capital Investment Corp. VI Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcviw",
      code: "NASDAQ:HCVIW",
      companyName: "Hennessy Capital Investment Corp. VI Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcwb",
      code: "NASDAQ:HCWB",
      companyName: "HCW Biologics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hcxy",
      code: "NASDAQ:HCXY",
      companyName: "Hercules Capital Inc. 6.25% Notes due 2033",
      popularity: 0,
    },
    {
      slug: "nasdaq-hd",
      code: "NASDAQ:HD",
      companyName: "Home Depot Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hdb",
      code: "NASDAQ:HDB",
      companyName: "HDFC Bank Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hdsn",
      code: "NASDAQ:HDSN",
      companyName: "Hudson Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-he",
      code: "NASDAQ:HE",
      companyName: "Hawaiian Electric Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hear",
      code: "NASDAQ:HEAR",
      companyName: "Turtle Beach Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hees",
      code: "NASDAQ:HEES",
      companyName: "H&E Equipment Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hei",
      code: "NASDAQ:HEI",
      companyName: "Heico Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hei/a",
      code: "NASDAQ:HEI/A",
      companyName: "Heico Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-hele",
      code: "NASDAQ:HELE",
      companyName: "Helen of Troy Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hep",
      code: "NASDAQ:HEP",
      companyName: "Holly Energy Partners L.P. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hepa",
      code: "NASDAQ:HEPA",
      companyName: "Hepion Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-heps",
      code: "NASDAQ:HEPS",
      companyName:
        "D-Market Electronic Services & Trading American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-heq",
      code: "NASDAQ:HEQ",
      companyName:
        "John Hancock Hedged Equity & Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-hera",
      code: "NASDAQ:HERA",
      companyName: "FTAC Hera Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-herau",
      code: "NASDAQ:HERAU",
      companyName: "FTAC Hera Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-heraw",
      code: "NASDAQ:HERAW",
      companyName: "FTAC Hera Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hes",
      code: "NASDAQ:HES",
      companyName: "Hess Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hesm",
      code: "NASDAQ:HESM",
      companyName: "Hess Midstream LP Class A Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-hfbl",
      code: "NASDAQ:HFBL",
      companyName: "Home Federal Bancorp Inc. of Louisiana Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hffg",
      code: "NASDAQ:HFFG",
      companyName: "HF Foods Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hfro",
      code: "NASDAQ:HFRO",
      companyName: "Highland Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-hfro-a",
      code: "NASDAQ:HFRO-A",
      companyName:
        "Highland Income Fund 5.375% Series A Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hfwa",
      code: "NASDAQ:HFWA",
      companyName: "Heritage Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hgbl",
      code: "NASDAQ:HGBL",
      companyName: "Heritage Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hgen",
      code: "NASDAQ:HGEN",
      companyName: "Humanigen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hglb",
      code: "NASDAQ:HGLB",
      companyName: "Highland Global Allocation Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hgty",
      code: "NASDAQ:HGTY",
      companyName: "Hagerty Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hgv",
      code: "NASDAQ:HGV",
      companyName: "Hilton Grand Vacations Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-hhc",
      code: "NASDAQ:HHC",
      companyName: "Howard Hughes Corporation (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hhgc",
      code: "NASDAQ:HHGC",
      companyName: "HHG Capital Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hhgcr",
      code: "NASDAQ:HHGCR",
      companyName: "HHG Capital Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-hhla",
      code: "NASDAQ:HHLA",
      companyName: "HH&L Acquisition Co. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hhs",
      code: "NASDAQ:HHS",
      companyName: "Harte-Hanks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hi",
      code: "NASDAQ:HI",
      companyName: "Hillenbrand Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hibb",
      code: "NASDAQ:HIBB",
      companyName: "Hibbett Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hie",
      code: "NASDAQ:HIE",
      companyName:
        "Miller/Howard High Income Equity Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-hifs",
      code: "NASDAQ:HIFS",
      companyName: "Hingham Institution for Savings Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hig",
      code: "NASDAQ:HIG",
      companyName: "Hartford Financial Services Group Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hig-g",
      code: "NASDAQ:HIG-G",
      companyName:
        "Hartford Financial Services Group Inc. (The) Depositary Shares each representing a 1/1000th interest in a share of 6.000% Non-Cumulative Preferred Stock Series G $0.01 par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-higa",
      code: "NASDAQ:HIGA",
      companyName: "H.I.G. Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hiho",
      code: "NASDAQ:HIHO",
      companyName: "Highway Holdings Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hii",
      code: "NASDAQ:HII",
      companyName: "Huntington Ingalls Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hiii",
      code: "NASDAQ:HIII",
      companyName: "Hudson Executive Investment Corp. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hiiiu",
      code: "NASDAQ:HIIIU",
      companyName: "Hudson Executive Investment Corp. III Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-hiiiw",
      code: "NASDAQ:HIIIW",
      companyName: "Hudson Executive Investment Corp. III Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hil",
      code: "NASDAQ:HIL",
      companyName: "Hill International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hils",
      code: "NASDAQ:HILS",
      companyName: "Hillstream BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hims",
      code: "NASDAQ:HIMS",
      companyName: "Hims & Hers Health Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-himx",
      code: "NASDAQ:HIMX",
      companyName: "Himax Technologies Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hio",
      code: "NASDAQ:HIO",
      companyName:
        "Western Asset High Income Opportunity Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hipo",
      code: "NASDAQ:HIPO",
      companyName: "Hippo Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hiti",
      code: "NASDAQ:HITI",
      companyName: "High Tide Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hive",
      code: "NASDAQ:HIVE",
      companyName: "Hive Blockchain Technologies Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hiw",
      code: "NASDAQ:HIW",
      companyName: "Highwoods Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hix",
      code: "NASDAQ:HIX",
      companyName: "Western Asset High Income Fund II Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hl",
      code: "NASDAQ:HL",
      companyName: "Hecla Mining Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hl-b",
      code: "NASDAQ:HL-B",
      companyName: "Hecla Mining Company Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlah",
      code: "NASDAQ:HLAH",
      companyName:
        "Hamilton Lane Alliance Holdings I Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlahu",
      code: "NASDAQ:HLAHU",
      companyName: "Hamilton Lane Alliance Holdings I Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlahw",
      code: "NASDAQ:HLAHW",
      companyName: "Hamilton Lane Alliance Holdings I Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlbz",
      code: "NASDAQ:HLBZ",
      companyName: "Helbiz Inc. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlbzw",
      code: "NASDAQ:HLBZW",
      companyName: "Helbiz Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlf",
      code: "NASDAQ:HLF",
      companyName: "Herbalife Nutrition Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlg",
      code: "NASDAQ:HLG",
      companyName: "Hailiang Education Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlgn",
      code: "NASDAQ:HLGN",
      companyName: "Heliogen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hli",
      code: "NASDAQ:HLI",
      companyName: "Houlihan Lokey Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlio",
      code: "NASDAQ:HLIO",
      companyName: "Helios Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlit",
      code: "NASDAQ:HLIT",
      companyName: "Harmonic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlly",
      code: "NASDAQ:HLLY",
      companyName: "Holley Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlmn",
      code: "NASDAQ:HLMN",
      companyName: "Hillman Solutions Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlne",
      code: "NASDAQ:HLNE",
      companyName: "Hamilton Lane Incorporated Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlt",
      code: "NASDAQ:HLT",
      companyName: "Hilton Worldwide Holdings Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlth",
      code: "NASDAQ:HLTH",
      companyName: "Cue Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlvx",
      code: "NASDAQ:HLVX",
      companyName: "HilleVax Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hlx",
      code: "NASDAQ:HLX",
      companyName: "Helix Energy Solutions Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hma",
      code: "NASDAQ:HMA",
      companyName: "Heartland Media Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmcou",
      code: "NASDAQ:HMCOU",
      companyName: "HumanCo Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmcow",
      code: "NASDAQ:HMCOW",
      companyName: "HumanCo Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmlp",
      code: "NASDAQ:HMLP",
      companyName:
        "Hoegh LNG Partners LP Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmlp-a",
      code: "NASDAQ:HMLP-A",
      companyName:
        "Hoegh LNG Partners LP 8.75% Series A Cumulative Redeemable Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmn",
      code: "NASDAQ:HMN",
      companyName: "Horace Mann Educators Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmnf",
      code: "NASDAQ:HMNF",
      companyName: "HMN Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmpt",
      code: "NASDAQ:HMPT",
      companyName: "Home Point Capital Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmst",
      code: "NASDAQ:HMST",
      companyName: "HomeStreet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmtv",
      code: "NASDAQ:HMTV",
      companyName: "Hemisphere Media Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmy",
      code: "NASDAQ:HMY",
      companyName: "Harmony Gold Mining Company Limited",
      popularity: 0,
    },
    {
      slug: "nasdaq-hngr",
      code: "NASDAQ:HNGR",
      companyName: "Hanger Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hni",
      code: "NASDAQ:HNI",
      companyName: "HNI Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hnna",
      code: "NASDAQ:HNNA",
      companyName: "Hennessy Advisors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hnnaz",
      code: "NASDAQ:HNNAZ",
      companyName: "Hennessy Advisors Inc. 4.875% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-hnp",
      code: "NASDAQ:HNP",
      companyName: "Huaneng Power Intl Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hnra",
      code: "NASDAQ:HNRA",
      companyName: "HNR Acquisition Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hnrg",
      code: "NASDAQ:HNRG",
      companyName: "Hallador Energy Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hnst",
      code: "NASDAQ:HNST",
      companyName: "The Honest Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hnw",
      code: "NASDAQ:HNW",
      companyName: "Pioneer Diversified High Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-hoft",
      code: "NASDAQ:HOFT",
      companyName: "Hooker Furnishings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hofv",
      code: "NASDAQ:HOFV",
      companyName: "Hall of Fame Resort & Entertainment Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hofvw",
      code: "NASDAQ:HOFVW",
      companyName: "Hall of Fame Resort &amp; Entertainment Company Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hog",
      code: "NASDAQ:HOG",
      companyName: "Harley-Davidson Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-holi",
      code: "NASDAQ:HOLI",
      companyName:
        "Hollysys Automation Technologies Ltd. Common Shares (British Virgin Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-holx",
      code: "NASDAQ:HOLX",
      companyName: "Hologic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-homb",
      code: "NASDAQ:HOMB",
      companyName: "Home BancShares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hone",
      code: "NASDAQ:HONE",
      companyName: "HarborOne Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hood",
      code: "NASDAQ:HOOD",
      companyName: "Robinhood Markets Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hook",
      code: "NASDAQ:HOOK",
      companyName: "HOOKIPA Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hope",
      code: "NASDAQ:HOPE",
      companyName: "Hope Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hori",
      code: "NASDAQ:HORI",
      companyName: "Emerging Markets Horizon Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hoth",
      code: "NASDAQ:HOTH",
      companyName: "Hoth Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hour",
      code: "NASDAQ:HOUR",
      companyName: "Hour Loop Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hov",
      code: "NASDAQ:HOV",
      companyName: "Hovnanian Enterprises Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hovnp",
      code: "NASDAQ:HOVNP",
      companyName: "Hovnanian Enterprises Inc Dep Shr Srs A Pfd",
      popularity: 0,
    },
    {
      slug: "nasdaq-howl",
      code: "NASDAQ:HOWL",
      companyName: "Werewolf Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hp",
      code: "NASDAQ:HP",
      companyName: "Helmerich & Payne Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpf",
      code: "NASDAQ:HPF",
      companyName: "John Hancock Pfd Income Fund II Pfd Income Fund II",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpi",
      code: "NASDAQ:HPI",
      companyName:
        "John Hancock Preferred Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpk",
      code: "NASDAQ:HPK",
      companyName: "HighPeak Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpkew",
      code: "NASDAQ:HPKEW",
      companyName: "HighPeak Energy Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hplt",
      code: "NASDAQ:HPLT",
      companyName: "Home Plate Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpltw",
      code: "NASDAQ:HPLTW",
      companyName: "Home Plate Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpp",
      code: "NASDAQ:HPP",
      companyName: "Hudson Pacific Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpp-c",
      code: "NASDAQ:HPP-C",
      companyName:
        "Hudson Pacific Properties Inc. 4.750% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpq",
      code: "NASDAQ:HPQ",
      companyName: "HP Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hps",
      code: "NASDAQ:HPS",
      companyName:
        "John Hancock Preferred Income Fund III Preferred Income Fund III",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpx",
      code: "NASDAQ:HPX",
      companyName: "HPX Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hqh",
      code: "NASDAQ:HQH",
      companyName: "Tekla Healthcare Investors Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hqi",
      code: "NASDAQ:HQI",
      companyName: "HireQuest Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-hql",
      code: "NASDAQ:HQL",
      companyName: "TeklaLife Sciences Investors Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hqy",
      code: "NASDAQ:HQY",
      companyName: "HealthEquity Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hr",
      code: "NASDAQ:HR",
      companyName: "Healthcare Realty Trust Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hrb",
      code: "NASDAQ:HRB",
      companyName: "H&R Block Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hri",
      code: "NASDAQ:HRI",
      companyName: "Herc Holdings Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-hrmy",
      code: "NASDAQ:HRMY",
      companyName: "Harmony Biosciences Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hrowl",
      code: "NASDAQ:HROWL",
      companyName: "Harrow Health Inc. 8.625% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-hrt",
      code: "NASDAQ:HRT",
      companyName: "HireRight Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hrtg",
      code: "NASDAQ:HRTG",
      companyName: "Heritage Insurance Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hrtx",
      code: "NASDAQ:HRTX",
      companyName: "Heron Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hrzn",
      code: "NASDAQ:HRZN",
      companyName: "Horizon Technology Finance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hsaq",
      code: "NASDAQ:HSAQ",
      companyName: "Health Sciences Acquisitions Corporation 2 Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hsbc",
      code: "NASDAQ:HSBC",
      companyName: "HSBC Holdings plc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hsc",
      code: "NASDAQ:HSC",
      companyName: "Harsco Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hsic",
      code: "NASDAQ:HSIC",
      companyName: "Henry Schein Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hsii",
      code: "NASDAQ:HSII",
      companyName: "Heidrick & Struggles International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hska",
      code: "NASDAQ:HSKA",
      companyName: "Heska Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hson",
      code: "NASDAQ:HSON",
      companyName: "Hudson Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hst",
      code: "NASDAQ:HST",
      companyName: "Host Hotels & Resorts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hstm",
      code: "NASDAQ:HSTM",
      companyName: "HealthStream Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hsto",
      code: "NASDAQ:HSTO",
      companyName: "Histogen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hsy",
      code: "NASDAQ:HSY",
      companyName: "The Hershey Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ht",
      code: "NASDAQ:HT",
      companyName:
        "Hersha Hospitality Trust Class A Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ht-c",
      code: "NASDAQ:HT-C",
      companyName:
        "Hersha Hospitality Trust 6.875% Series C Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ht-d",
      code: "NASDAQ:HT-D",
      companyName:
        "Hersha Hospitality Trust 6.50% Series D Cumulative Redeemable Preferred Shares of Beneficial Interest $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ht-e",
      code: "NASDAQ:HT-E",
      companyName:
        "Hersha Hospitality Trust 6.50% Series E Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-hta",
      code: "NASDAQ:HTA",
      companyName: "Healthcare Trust of America Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htaq",
      code: "NASDAQ:HTAQ",
      companyName: "Hunt Companies Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-htbi",
      code: "NASDAQ:HTBI",
      companyName: "HomeTrust Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htbk",
      code: "NASDAQ:HTBK",
      companyName: "Heritage Commerce Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htcr",
      code: "NASDAQ:HTCR",
      companyName: "Heartcore Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htd",
      code: "NASDAQ:HTD",
      companyName:
        "John Hancock Tax Advantaged Dividend Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-htfb",
      code: "NASDAQ:HTFB",
      companyName:
        "Horizon Technology Finance Corporation 4.875% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-htgc",
      code: "NASDAQ:HTGC",
      companyName: "Hercules Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htgm",
      code: "NASDAQ:HTGM",
      companyName: "HTG Molecular Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hth",
      code: "NASDAQ:HTH",
      companyName: "Hilltop Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-htht",
      code: "NASDAQ:HTHT",
      companyName: "Huazhu Group Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-htia",
      code: "NASDAQ:HTIA",
      companyName:
        "Healthcare Trust Inc. 7.375% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htibp",
      code: "NASDAQ:HTIBP",
      companyName:
        "Healthcare Trust Inc. 7.125% Series B Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htld",
      code: "NASDAQ:HTLD",
      companyName: "Heartland Express Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htlf",
      code: "NASDAQ:HTLF",
      companyName: "Heartland Financial USA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htlfp",
      code: "NASDAQ:HTLFP",
      companyName:
        "Heartland Financial USA Inc. Depositary Shares each representing a 1/400th ownership interest in a share of 7.00% Fixed-Rate Reset Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-htoo",
      code: "NASDAQ:HTOO",
      companyName: "Fusion Fuel Green PLC Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-htoow",
      code: "NASDAQ:HTOOW",
      companyName: "Fusion Fuel Green PLC Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-htpa",
      code: "NASDAQ:HTPA",
      companyName:
        "Highland Transcend Partners I Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hty",
      code: "NASDAQ:HTY",
      companyName:
        "John Hancock Tax-Advantaged Global Shareholder Yield Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-htz",
      code: "NASDAQ:HTZ",
      companyName: "Hertz Global Holdings Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-htzww",
      code: "NASDAQ:HTZWW",
      companyName: "Hertz Global Holdings Inc Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hubb",
      code: "NASDAQ:HUBB",
      companyName: "Hubbell Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hubg",
      code: "NASDAQ:HUBG",
      companyName: "Hub Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hubs",
      code: "NASDAQ:HUBS",
      companyName: "HubSpot Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hudi",
      code: "NASDAQ:HUDI",
      companyName: "Huadi International Group Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-huge",
      code: "NASDAQ:HUGE",
      companyName: "FSD Pharma Inc. Class B Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hugs",
      code: "NASDAQ:HUGS",
      companyName: "USHG Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-huiz",
      code: "NASDAQ:HUIZ",
      companyName: "Huize Holding Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hum",
      code: "NASDAQ:HUM",
      companyName: "Humana Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-huma",
      code: "NASDAQ:HUMA",
      companyName: "Humacyte Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-humaw",
      code: "NASDAQ:HUMAW",
      companyName: "Humacyte Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hun",
      code: "NASDAQ:HUN",
      companyName: "Huntsman Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hurc",
      code: "NASDAQ:HURC",
      companyName: "Hurco Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-husa",
      code: "NASDAQ:HUSA",
      companyName: "Houston American Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-husn",
      code: "NASDAQ:HUSN",
      companyName: "Hudson Capital Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hut",
      code: "NASDAQ:HUT",
      companyName: "Hut 8 Mining Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-huya",
      code: "NASDAQ:HUYA",
      companyName:
        "HUYA Inc. American depositary shares each  representing one Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-hvbc",
      code: "NASDAQ:HVBC",
      companyName: "HV Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hvt",
      code: "NASDAQ:HVT",
      companyName: "Haverty Furniture Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hvt/a",
      code: "NASDAQ:HVT/A",
      companyName: "Haverty Furniture Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-hwbk",
      code: "NASDAQ:HWBK",
      companyName: "Hawthorn Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hwc",
      code: "NASDAQ:HWC",
      companyName: "Hancock Whitney Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hwcpz",
      code: "NASDAQ:HWCPZ",
      companyName:
        "Hancock Whitney Corporation 6.25% Subordinated Notes due 2060",
      popularity: 0,
    },
    {
      slug: "nasdaq-hwel",
      code: "NASDAQ:HWEL",
      companyName: "Healthwell Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hwkn",
      code: "NASDAQ:HWKN",
      companyName: "Hawkins Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hwkz",
      code: "NASDAQ:HWKZ",
      companyName: "Hawks Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hwm",
      code: "NASDAQ:HWM",
      companyName: "Howmet Aerospace Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hwm-",
      code: "NASDAQ:HWM-",
      companyName: "Howmet Aerospace Inc. $3.75 Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hxl",
      code: "NASDAQ:HXL",
      companyName: "Hexcel Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hy",
      code: "NASDAQ:HY",
      companyName: "Hyster-Yale Materials Handling Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyac",
      code: "NASDAQ:HYAC",
      companyName: "Haymaker Acquisition Corp. III Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyacu",
      code: "NASDAQ:HYACU",
      companyName: "Haymaker Acquisition Corp. III Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyacw",
      code: "NASDAQ:HYACW",
      companyName: "Haymaker Acquisition Corp. III Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyb",
      code: "NASDAQ:HYB",
      companyName: "New America High Income Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyfm",
      code: "NASDAQ:HYFM",
      companyName: "Hydrofarm Holdings Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyi",
      code: "NASDAQ:HYI",
      companyName:
        "Western Asset High Yield Defined Opportunity Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyln",
      code: "NASDAQ:HYLN",
      companyName: "Hyliion Holdings Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hymc",
      code: "NASDAQ:HYMC",
      companyName: "Hycroft Mining Holding Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hymcl",
      code: "NASDAQ:HYMCL",
      companyName: "Hycroft Mining Holding Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-hymcw",
      code: "NASDAQ:HYMCW",
      companyName: "Hycroft Mining Holding Corporation  Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hymcz",
      code: "NASDAQ:HYMCZ",
      companyName: "Hycroft Mining Holding Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-hypr",
      code: "NASDAQ:HYPR",
      companyName: "Hyperfine Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyre",
      code: "NASDAQ:HYRE",
      companyName: "HyreCar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyt",
      code: "NASDAQ:HYT",
      companyName: "Blackrock Corporate High Yield Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyw",
      code: "NASDAQ:HYW",
      companyName: "Hywin Holdings Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyzn",
      code: "NASDAQ:HYZN",
      companyName: "Hyzon Motors Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hyznw",
      code: "NASDAQ:HYZNW",
      companyName: "Hyzon Motors Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-hzn",
      code: "NASDAQ:HZN",
      companyName: "Horizon Global Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hznp",
      code: "NASDAQ:HZNP",
      companyName:
        "Horizon Therapeutics Public Limited Company Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hzo",
      code: "NASDAQ:HZO",
      companyName: "MarineMax Inc.  (FL) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hzon",
      code: "NASDAQ:HZON",
      companyName: "Horizon Acquisition Corporation II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iaa",
      code: "NASDAQ:IAA",
      companyName: "IAA Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-iac",
      code: "NASDAQ:IAC",
      companyName: "IAC/InterActiveCorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iacc",
      code: "NASDAQ:IACC",
      companyName: "ION Acquisition Corp 3 Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iae",
      code: "NASDAQ:IAE",
      companyName:
        "Voya Asia Pacific High Dividend Equity Income Fund ING Asia Pacific High Dividend Equity Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-iaf",
      code: "NASDAQ:IAF",
      companyName: "Aberdeen Australia Equity Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iag",
      code: "NASDAQ:IAG",
      companyName: "Iamgold Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iart",
      code: "NASDAQ:IART",
      companyName: "Integra LifeSciences Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ias",
      code: "NASDAQ:IAS",
      companyName: "Integral Ad Science Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iba",
      code: "NASDAQ:IBA",
      companyName: "Industrias Bachoco S.A.B. de C.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ibcp",
      code: "NASDAQ:IBCP",
      companyName: "Independent Bank Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iber",
      code: "NASDAQ:IBER",
      companyName: "Ibere Pharmaceuticals Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ibex",
      code: "NASDAQ:IBEX",
      companyName: "IBEX Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ibio",
      code: "NASDAQ:IBIO",
      companyName: "iBio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ibkr",
      code: "NASDAQ:IBKR",
      companyName: "Interactive Brokers Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ibn",
      code: "NASDAQ:IBN",
      companyName: "ICICI Bank Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iboc",
      code: "NASDAQ:IBOC",
      companyName: "International Bancshares Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ibrx",
      code: "NASDAQ:IBRX",
      companyName: "ImmunityBio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ibtx",
      code: "NASDAQ:IBTX",
      companyName: "Independent Bank Group Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-icd",
      code: "NASDAQ:ICD",
      companyName: "Independence Contract Drilling Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-icfi",
      code: "NASDAQ:ICFI",
      companyName: "ICF International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ichr",
      code: "NASDAQ:ICHR",
      companyName: "Ichor Holdings Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-icl",
      code: "NASDAQ:ICL",
      companyName: "ICL Group Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iclk",
      code: "NASDAQ:ICLK",
      companyName:
        "iClick Interactive Asia Group Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iclr",
      code: "NASDAQ:ICLR",
      companyName: "ICON plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-icmb",
      code: "NASDAQ:ICMB",
      companyName: "Investcorp Credit Management BDC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-icnc",
      code: "NASDAQ:ICNC",
      companyName: "Iconic Sports Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-icpt",
      code: "NASDAQ:ICPT",
      companyName: "Intercept Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-icr-a",
      code: "NASDAQ:ICR-A",
      companyName:
        "InPoint Commercial Real Estate Income Inc. 6.75% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-icui",
      code: "NASDAQ:ICUI",
      companyName: "ICU Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-id",
      code: "NASDAQ:ID",
      companyName: "PARTS iD Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ida",
      code: "NASDAQ:IDA",
      companyName: "IDACORP Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-idai",
      code: "NASDAQ:IDAI",
      companyName: "T Stamp Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-idba",
      code: "NASDAQ:IDBA",
      companyName: "IDEX Biometrics ASA American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-idcc",
      code: "NASDAQ:IDCC",
      companyName: "InterDigital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ide",
      code: "NASDAQ:IDE",
      companyName:
        "Voya Infrastructure Industrials and Materials Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-idex",
      code: "NASDAQ:IDEX",
      companyName: "Ideanomics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-idn",
      code: "NASDAQ:IDN",
      companyName: "Intellicheck Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-idr",
      code: "NASDAQ:IDR",
      companyName: "Idaho Strategic Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-idra",
      code: "NASDAQ:IDRA",
      companyName: "Idera Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-idt",
      code: "NASDAQ:IDT",
      companyName: "IDT Corporation Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-idw",
      code: "NASDAQ:IDW",
      companyName: "IDW Media Holdings Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-idya",
      code: "NASDAQ:IDYA",
      companyName: "IDEAYA Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iea",
      code: "NASDAQ:IEA",
      companyName: "Infrastructure and Energy Alternatives Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ieaww",
      code: "NASDAQ:IEAWW",
      companyName: "Infrastructure and Energy Alternatives Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-iep",
      code: "NASDAQ:IEP",
      companyName: "Icahn Enterprises L.P. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iesc",
      code: "NASDAQ:IESC",
      companyName: "IES Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iex",
      code: "NASDAQ:IEX",
      companyName: "IDEX Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ifbd",
      code: "NASDAQ:IFBD",
      companyName: "Infobird Co. Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iff",
      code: "NASDAQ:IFF",
      companyName: "International Flavors & Fragrances Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ifin",
      code: "NASDAQ:IFIN",
      companyName: "InFinT Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ifn",
      code: "NASDAQ:IFN",
      companyName: "India Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ibp",
      code: "NASDAQ:IBP",
      companyName: "Installed Building Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ifrx",
      code: "NASDAQ:IFRX",
      companyName: "InflaRx N.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ifs",
      code: "NASDAQ:IFS",
      companyName: "Intercorp Financial Services Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iga",
      code: "NASDAQ:IGA",
      companyName:
        "Voya Global Advantage and Premium Opportunity Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-igac",
      code: "NASDAQ:IGAC",
      companyName: "IG Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-igacu",
      code: "NASDAQ:IGACU",
      companyName: "IG Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-igacw",
      code: "NASDAQ:IGACW",
      companyName: "IG Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-igc",
      code: "NASDAQ:IGC",
      companyName: "India Globalization Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-igd",
      code: "NASDAQ:IGD",
      companyName: "Voya Global Equity Dividend and Premium Opportunity Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-igi",
      code: "NASDAQ:IGI",
      companyName:
        "Western Asset Investment Grade Defined Opportunity Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-igic",
      code: "NASDAQ:IGIC",
      companyName:
        "International General Insurance Holdings Ltd. Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-igms",
      code: "NASDAQ:IGMS",
      companyName: "IGM Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-igny",
      code: "NASDAQ:IGNY",
      companyName: "Ignyte Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ignyu",
      code: "NASDAQ:IGNYU",
      companyName: "Ignyte Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ignyw",
      code: "NASDAQ:IGNYW",
      companyName: "Ignyte Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-igr",
      code: "NASDAQ:IGR",
      companyName:
        "CBRE Global Real Estate Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-igt",
      code: "NASDAQ:IGT",
      companyName: "International Game Technology Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ih",
      code: "NASDAQ:IH",
      companyName:
        "iHuman Inc. American depositary shares each representing five Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ihd",
      code: "NASDAQ:IHD",
      companyName:
        "Voya Emerging Markets High Income Dividend Equity Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ihg",
      code: "NASDAQ:IHG",
      companyName:
        "Intercontinental Hotels Group American Depositary Shares (Each representing one Ordinary Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ihit",
      code: "NASDAQ:IHIT",
      companyName:
        "Invesco High Income 2023 Target Term Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ihrt",
      code: "NASDAQ:IHRT",
      companyName: "iHeartMedia Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ihs",
      code: "NASDAQ:IHS",
      companyName: "IHS Holding Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iht",
      code: "NASDAQ:IHT",
      companyName: "InnSuites Hospitality Trust Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ihta",
      code: "NASDAQ:IHTA",
      companyName:
        "Invesco High Income 2024 Target Term Fund Common Shares of Beneficial Interest No par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-iif",
      code: "NASDAQ:IIF",
      companyName: "Morgan Stanley India Investment Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iii",
      code: "NASDAQ:III",
      companyName:
        "Information Services Group Inc. Information Services Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iiii",
      code: "NASDAQ:IIII",
      companyName: "INSU Acquisition Corp. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iiiiw",
      code: "NASDAQ:IIIIW",
      companyName: "INSU Acquisition Corp. III Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-iiin",
      code: "NASDAQ:IIIN",
      companyName: "Insteel Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iiiv",
      code: "NASDAQ:IIIV",
      companyName: "i3 Verticals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iim",
      code: "NASDAQ:IIM",
      companyName: "Invesco Value Municipal Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iin",
      code: "NASDAQ:IIN",
      companyName: "Intricon Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iinn",
      code: "NASDAQ:IINN",
      companyName: "Inspira Technologies Oxy B.H.N. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iinnw",
      code: "NASDAQ:IINNW",
      companyName: "Inspira Technologies Oxy B.H.N. Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-iipr",
      code: "NASDAQ:IIPR",
      companyName: "Innovative Industrial Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iipr-a",
      code: "NASDAQ:IIPR-A",
      companyName:
        "Innovative Industrial Properties Inc. 9.00% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iivi",
      code: "NASDAQ:IIVI",
      companyName: "II-VI Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iivip",
      code: "NASDAQ:IIVIP",
      companyName:
        "II-VI Incorporated 6.00% Series A Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ikna",
      code: "NASDAQ:IKNA",
      companyName: "Ikena Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ikt",
      code: "NASDAQ:IKT",
      companyName: "Inhibikase Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ilmn",
      code: "NASDAQ:ILMN",
      companyName: "Illumina Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ilpt",
      code: "NASDAQ:ILPT",
      companyName:
        "Industrial Logistics Properties Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-imab",
      code: "NASDAQ:IMAB",
      companyName: "I-MAB American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-imac",
      code: "NASDAQ:IMAC",
      companyName: "IMAC Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imacw",
      code: "NASDAQ:IMACW",
      companyName: "IMAC Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-imaq",
      code: "NASDAQ:IMAQ",
      companyName: "International Media Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imaqr",
      code: "NASDAQ:IMAQR",
      companyName: "International Media Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-imaqu",
      code: "NASDAQ:IMAQU",
      companyName: "International Media Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-imaqw",
      code: "NASDAQ:IMAQW",
      companyName: "International Media Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-imax",
      code: "NASDAQ:IMAX",
      companyName: "Imax Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imbi",
      code: "NASDAQ:IMBI",
      companyName: "iMedia Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imbil",
      code: "NASDAQ:IMBIL",
      companyName: "iMedia Brands Inc. 8.5% Senior Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-imcc",
      code: "NASDAQ:IMCC",
      companyName: "IM Cannabis Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-imcr",
      code: "NASDAQ:IMCR",
      companyName: "Immunocore Holdings plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-imgn",
      code: "NASDAQ:IMGN",
      companyName: "ImmunoGen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imgo",
      code: "NASDAQ:IMGO",
      companyName: "Imago BioSciences Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imh",
      code: "NASDAQ:IMH",
      companyName: "Impac Mortgage Holdings Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-imkta",
      code: "NASDAQ:IMKTA",
      companyName: "Ingles Markets Incorporated Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-immp",
      code: "NASDAQ:IMMP",
      companyName: "Immutep Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-immr",
      code: "NASDAQ:IMMR",
      companyName: "Immersion Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-immx",
      code: "NASDAQ:IMMX",
      companyName: "Immix Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imnm",
      code: "NASDAQ:IMNM",
      companyName: "Immunome Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imo",
      code: "NASDAQ:IMO",
      companyName: "Imperial Oil Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imos",
      code: "NASDAQ:IMOS",
      companyName: "ChipMOS TECHNOLOGIES INC. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-impl",
      code: "NASDAQ:IMPL",
      companyName: "Impel Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-impp",
      code: "NASDAQ:IMPP",
      companyName: "Imperial Petroleum Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-imppp",
      code: "NASDAQ:IMPPP",
      companyName:
        "Imperial Petroleum Inc. 8.75% Series A Cumulative Redeemable Perpetual Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-impx",
      code: "NASDAQ:IMPX",
      companyName: "AEA-Bridges Impact Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-imra",
      code: "NASDAQ:IMRA",
      companyName: "IMARA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imrn",
      code: "NASDAQ:IMRN",
      companyName: "Immuron Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-imrnw",
      code: "NASDAQ:IMRNW",
      companyName: "Immuron Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-imrx",
      code: "NASDAQ:IMRX",
      companyName: "Immuneering Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imte",
      code: "NASDAQ:IMTE",
      companyName: "Integrated Media Technology Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-imtx",
      code: "NASDAQ:IMTX",
      companyName: "Immatics N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-inbk",
      code: "NASDAQ:INBK",
      companyName: "First Internet Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inbkz",
      code: "NASDAQ:INBKZ",
      companyName:
        "First Internet Bancorp 6.0% Fixed-to-Floating Rate Subordinated Notes Due 2029",
      popularity: 0,
    },
    {
      slug: "nasdaq-inbx",
      code: "NASDAQ:INBX",
      companyName: "Inhibrx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-incr",
      code: "NASDAQ:INCR",
      companyName: "Intercure Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-incy",
      code: "NASDAQ:INCY",
      companyName: "Incyte Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-indb",
      code: "NASDAQ:INDB",
      companyName: "Independent Bank Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-indi",
      code: "NASDAQ:INDI",
      companyName: "indie Semiconductor Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-indiw",
      code: "NASDAQ:INDIW",
      companyName: "indie Semiconductor Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-indo",
      code: "NASDAQ:INDO",
      companyName: "Indonesia Energy Corporation Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-indp",
      code: "NASDAQ:INDP",
      companyName: "Indaptus Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-indt",
      code: "NASDAQ:INDT",
      companyName: "INDUS Realty Trust Inc. (MD) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-infa",
      code: "NASDAQ:INFA",
      companyName: "Informatica Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-infi",
      code: "NASDAQ:INFI",
      companyName: "Infinity Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-infn",
      code: "NASDAQ:INFN",
      companyName: "Infinera Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-infu",
      code: "NASDAQ:INFU",
      companyName: "InfuSystems Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ing",
      code: "NASDAQ:ING",
      companyName: "ING Group N.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ingn",
      code: "NASDAQ:INGN",
      companyName: "Inogen Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ingr",
      code: "NASDAQ:INGR",
      companyName: "Ingredion Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inka",
      code: "NASDAQ:INKA",
      companyName: "KludeIn I Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inkaw",
      code: "NASDAQ:INKAW",
      companyName: "KludeIn I Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-inkt",
      code: "NASDAQ:INKT",
      companyName: "MiNK Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inm",
      code: "NASDAQ:INM",
      companyName: "InMed Pharmaceuticals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-inmb",
      code: "NASDAQ:INMB",
      companyName: "INmune Bio Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inmd",
      code: "NASDAQ:INMD",
      companyName: "InMode Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-inn",
      code: "NASDAQ:INN",
      companyName: "Summit Hotel Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inn-e",
      code: "NASDAQ:INN-E",
      companyName:
        "Summit Hotel Properties Inc. 6.250% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inn-f",
      code: "NASDAQ:INN-F",
      companyName:
        "Summit Hotel Properties Inc. 5.875% Series F Cumulative Redeemable Preferred Stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-innv",
      code: "NASDAQ:INNV",
      companyName: "InnovAge Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ino",
      code: "NASDAQ:INO",
      companyName: "Inovio Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inod",
      code: "NASDAQ:INOD",
      companyName: "Innodata Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inpx",
      code: "NASDAQ:INPX",
      companyName: "Inpixon Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inse",
      code: "NASDAQ:INSE",
      companyName: "Inspired Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-insg",
      code: "NASDAQ:INSG",
      companyName: "Inseego Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-insi",
      code: "NASDAQ:INSI",
      companyName: "Insight Select Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-insm",
      code: "NASDAQ:INSM",
      companyName: "Insmed Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-insp",
      code: "NASDAQ:INSP",
      companyName: "Inspire Medical Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inst",
      code: "NASDAQ:INST",
      companyName: "Instructure Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-insw",
      code: "NASDAQ:INSW",
      companyName: "International Seaways Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-insw-a",
      code: "NASDAQ:INSW-A",
      companyName:
        "International Seaways Inc. 8.50% Senior Notes due June 30 2023",
      popularity: 0,
    },
    {
      slug: "nasdaq-int",
      code: "NASDAQ:INT",
      companyName: "World Fuel Services Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inta",
      code: "NASDAQ:INTA",
      companyName: "Intapp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inte",
      code: "NASDAQ:INTE",
      companyName: "Integral Acquisition Corporation 1 Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-intew",
      code: "NASDAQ:INTEW",
      companyName: "Integral Acquisition Corporation 1 Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-intg",
      code: "NASDAQ:INTG",
      companyName: "Intergroup Corporation (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-intt",
      code: "NASDAQ:INTT",
      companyName: "inTest Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-intz",
      code: "NASDAQ:INTZ",
      companyName: "Intrusion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inuv",
      code: "NASDAQ:INUV",
      companyName: "Inuvo Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-inva",
      code: "NASDAQ:INVA",
      companyName: "Innoviva Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inve",
      code: "NASDAQ:INVE",
      companyName: "Identiv Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-invh",
      code: "NASDAQ:INVH",
      companyName: "Invitation Homes Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-invo",
      code: "NASDAQ:INVO",
      companyName: "INVO BioScience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inzy",
      code: "NASDAQ:INZY",
      companyName: "Inozyme Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-io",
      code: "NASDAQ:IO",
      companyName: "Ion Geophysical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ioac",
      code: "NASDAQ:IOAC",
      companyName:
        "Innovative International Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ioacw",
      code: "NASDAQ:IOACW",
      companyName: "Innovative International Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-iobt",
      code: "NASDAQ:IOBT",
      companyName: "IO Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ionm",
      code: "NASDAQ:IONM",
      companyName: "Assure Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ions",
      code: "NASDAQ:IONS",
      companyName: "Ionis Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ior",
      code: "NASDAQ:IOR",
      companyName: "Income Opportunity Realty Investors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iosp",
      code: "NASDAQ:IOSP",
      companyName: "Innospec Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iova",
      code: "NASDAQ:IOVA",
      companyName: "Iovance Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ip",
      code: "NASDAQ:IP",
      companyName: "International Paper Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipa",
      code: "NASDAQ:IPA",
      companyName: "ImmunoPrecise Antibodies Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipar",
      code: "NASDAQ:IPAR",
      companyName: "Inter Parfums Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipax",
      code: "NASDAQ:IPAX",
      companyName: "Inflection Point Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipaxu",
      code: "NASDAQ:IPAXU",
      companyName: "Inflection Point Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipaxw",
      code: "NASDAQ:IPAXW",
      companyName: "Inflection Point Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipdn",
      code: "NASDAQ:IPDN",
      companyName: "Professional Diversity Network Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipg",
      code: "NASDAQ:IPG",
      companyName: "Interpublic Group of Companies Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipgp",
      code: "NASDAQ:IPGP",
      companyName: "IPG Photonics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipha",
      code: "NASDAQ:IPHA",
      companyName: "Innate Pharma S.A. ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipi",
      code: "NASDAQ:IPI",
      companyName: "Intrepid Potash Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipod",
      code: "NASDAQ:IPOD",
      companyName:
        "Social Capital Hedosophia Holdings Corp. IV Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipof",
      code: "NASDAQ:IPOF",
      companyName:
        "Social Capital Hedosophia Holdings Corp. VI Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipsc",
      code: "NASDAQ:IPSC",
      companyName: "Century Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipva",
      code: "NASDAQ:IPVA",
      companyName: "InterPrivate II Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipvf",
      code: "NASDAQ:IPVF",
      companyName:
        "InterPrivate III Financial Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipvi",
      code: "NASDAQ:IPVI",
      companyName:
        "InterPrivate IV InfraTech Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipviu",
      code: "NASDAQ:IPVIU",
      companyName: "InterPrivate IV InfraTech Partners Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipviw",
      code: "NASDAQ:IPVIW",
      companyName: "InterPrivate IV InfraTech Partners Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipw",
      code: "NASDAQ:IPW",
      companyName: "iPower Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ipwr",
      code: "NASDAQ:IPWR",
      companyName: "Ideal Power Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iq",
      code: "NASDAQ:IQ",
      companyName: "iQIYI Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-iqi",
      code: "NASDAQ:IQI",
      companyName: "Invesco Quality Municipal Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iqmd",
      code: "NASDAQ:IQMD",
      companyName:
        "Intelligent Medicine Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iqmdu",
      code: "NASDAQ:IQMDU",
      companyName: "Intelligent Medicine Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-iqmdw",
      code: "NASDAQ:IQMDW",
      companyName: "Intelligent Medicine Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-iqv",
      code: "NASDAQ:IQV",
      companyName: "IQVIA Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ir",
      code: "NASDAQ:IR",
      companyName: "Ingersoll Rand Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irbt",
      code: "NASDAQ:IRBT",
      companyName: "iRobot Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ircp",
      code: "NASDAQ:IRCP",
      companyName:
        "IRSA Propiedades Comerciales S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-irdm",
      code: "NASDAQ:IRDM",
      companyName: "Iridium Communications Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ionq",
      code: "NASDAQ:IONQ",
      companyName: "IonQ Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irix",
      code: "NASDAQ:IRIX",
      companyName: "IRIDEX Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irl",
      code: "NASDAQ:IRL",
      companyName: "New Ireland Fund Inc (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irm",
      code: "NASDAQ:IRM",
      companyName: "Iron Mountain Incorporated (Delaware)Common Stock REIT",
      popularity: 0,
    },
    {
      slug: "nasdaq-irmd",
      code: "NASDAQ:IRMD",
      companyName: "iRadimed Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irnt",
      code: "NASDAQ:IRNT",
      companyName: "IronNet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irrx",
      code: "NASDAQ:IRRX",
      companyName:
        "Integrated Rail and Resources Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irs",
      code: "NASDAQ:IRS",
      companyName: "IRSA Inversiones Y Representaciones S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irt",
      code: "NASDAQ:IRT",
      companyName: "Independence Realty Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irtc",
      code: "NASDAQ:IRTC",
      companyName: "iRhythm Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-irwd",
      code: "NASDAQ:IRWD",
      companyName: "Ironwood Pharmaceuticals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-is",
      code: "NASDAQ:IS",
      companyName: "ironSource Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-isaa",
      code: "NASDAQ:ISAA",
      companyName: "Iron Spark I Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-isee",
      code: "NASDAQ:ISEE",
      companyName: "IVERIC bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-isig",
      code: "NASDAQ:ISIG",
      companyName: "Insignia Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-isle",
      code: "NASDAQ:ISLE",
      companyName: "Isleworth Healthcare Acquisition Corporation Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-islew",
      code: "NASDAQ:ISLEW",
      companyName: "Isleworth Healthcare Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-iso",
      code: "NASDAQ:ISO",
      companyName: "IsoPlexis Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ispc",
      code: "NASDAQ:ISPC",
      companyName: "iSpecimen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ispo",
      code: "NASDAQ:ISPO",
      companyName: "Inspirato Incorporated Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ispow",
      code: "NASDAQ:ISPOW",
      companyName: "Inspirato Incorporated Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-isr",
      code: "NASDAQ:ISR",
      companyName: "IsoRay Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-issc",
      code: "NASDAQ:ISSC",
      companyName: "Innovative Solutions and Support Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-istr",
      code: "NASDAQ:ISTR",
      companyName: "Investar Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-isun",
      code: "NASDAQ:ISUN",
      companyName: "iSun Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-it",
      code: "NASDAQ:IT",
      companyName: "Gartner Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-itaq",
      code: "NASDAQ:ITAQ",
      companyName: "Industrial Tech Acquisitions II Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-itaqu",
      code: "NASDAQ:ITAQU",
      companyName: "Industrial Tech Acquisitions II Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-itcb",
      code: "NASDAQ:ITCB",
      companyName:
        "Itau CorpBanca American Depositary Shares (each representing 1500 shares of Common Stock no par value)",
      popularity: 0,
    },
    {
      slug: "nasdaq-itci",
      code: "NASDAQ:ITCI",
      companyName: "Intra-Cellular Therapies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-itgr",
      code: "NASDAQ:ITGR",
      companyName: "Integer Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ithx",
      code: "NASDAQ:ITHX",
      companyName: "ITHAX Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ithxw",
      code: "NASDAQ:ITHXW",
      companyName: "ITHAX Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-iti",
      code: "NASDAQ:ITI",
      companyName: "Iteris Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-itic",
      code: "NASDAQ:ITIC",
      companyName: "Investors Title Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-itos",
      code: "NASDAQ:ITOS",
      companyName: "iTeos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-itp",
      code: "NASDAQ:ITP",
      companyName: "IT Tech Packaging Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-itq",
      code: "NASDAQ:ITQ",
      companyName: "Itiquira Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-itqrw",
      code: "NASDAQ:ITQRW",
      companyName: "Itiquira Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-itrg",
      code: "NASDAQ:ITRG",
      companyName: "Integra Resources Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-itrm",
      code: "NASDAQ:ITRM",
      companyName: "Iterum Therapeutics plc Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-itrn",
      code: "NASDAQ:ITRN",
      companyName: "Ituran Location and Control Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-itt",
      code: "NASDAQ:ITT",
      companyName: "ITT Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-itub",
      code: "NASDAQ:ITUB",
      companyName:
        "Itau Unibanco Banco Holding SA American Depositary Shares (Each repstg 500 Preferred shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-itw",
      code: "NASDAQ:ITW",
      companyName: "Illinois Tool Works Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iva",
      code: "NASDAQ:IVA",
      companyName: "Inventiva S.A. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivac",
      code: "NASDAQ:IVAC",
      companyName: "Intevac Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivc",
      code: "NASDAQ:IVC",
      companyName: "Invacare Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivcb",
      code: "NASDAQ:IVCB",
      companyName:
        "Investcorp Europe Acquisition Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivcbu",
      code: "NASDAQ:IVCBU",
      companyName: "Investcorp Europe Acquisition Corp I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivcbw",
      code: "NASDAQ:IVCBW",
      companyName: "Investcorp Europe Acquisition Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivcp",
      code: "NASDAQ:IVCP",
      companyName: "Swiftmerge Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivda",
      code: "NASDAQ:IVDA",
      companyName: "Iveda Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivdaw",
      code: "NASDAQ:IVDAW",
      companyName: "Iveda Solutions Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivh",
      code: "NASDAQ:IVH",
      companyName: "Delaware Ivy High Income Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivr",
      code: "NASDAQ:IVR",
      companyName: "INVESCO MORTGAGE CAPITAL INC Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivr-b",
      code: "NASDAQ:IVR-B",
      companyName:
        "Invesco Mortgage Capital Inc. Preferred Series B Cum Fxd to Fltg",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivr-c",
      code: "NASDAQ:IVR-C",
      companyName:
        "INVESCO MORTGAGE CAPITAL INC 7.5% Fixed-to-Floating Series C Cumulative Redeemable Preferred Stock Liquation Preference $25.00 per Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivt",
      code: "NASDAQ:IVT",
      companyName: "InvenTrust Properties Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ivz",
      code: "NASDAQ:IVZ",
      companyName: "Invesco Ltd Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ix",
      code: "NASDAQ:IX",
      companyName: "Orix Corp Ads Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ixaq",
      code: "NASDAQ:IXAQ",
      companyName: "IX Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ixaqw",
      code: "NASDAQ:IXAQW",
      companyName: "IX Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ixhl",
      code: "NASDAQ:IXHL",
      companyName: "Incannex Healthcare Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-isd",
      code: "NASDAQ:ISD",
      companyName: "PGIM High Yield Bond Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-itri",
      code: "NASDAQ:ITRI",
      companyName: "Itron Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-izea",
      code: "NASDAQ:IZEA",
      companyName: "IZEA Worldwide Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-j",
      code: "NASDAQ:J",
      companyName: "Jacobs Engineering Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jack",
      code: "NASDAQ:JACK",
      companyName: "Jack In The Box Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jagx",
      code: "NASDAQ:JAGX",
      companyName: "Jaguar Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jakk",
      code: "NASDAQ:JAKK",
      companyName: "JAKKS Pacific Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jamf",
      code: "NASDAQ:JAMF",
      companyName: "Jamf Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jaqcw",
      code: "NASDAQ:JAQCW",
      companyName: "Jupiter Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-jatt",
      code: "NASDAQ:JATT",
      companyName: "JATT Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jazz",
      code: "NASDAQ:JAZZ",
      companyName: "Jazz Pharmaceuticals plc Common Stock (Ireland)",
      popularity: 0,
    },
    {
      slug: "nasdaq-jbgs",
      code: "NASDAQ:JBGS",
      companyName: "JBG SMITH Properties Common Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-jbht",
      code: "NASDAQ:JBHT",
      companyName: "J.B. Hunt Transport Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jbk",
      code: "NASDAQ:JBK",
      companyName:
        "Lehman ABS 3.50 3.50% Adjustable Corp Backed Tr Certs GS Cap I",
      popularity: 0,
    },
    {
      slug: "nasdaq-jbl",
      code: "NASDAQ:JBL",
      companyName: "Jabil Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jblu",
      code: "NASDAQ:JBLU",
      companyName: "JetBlue Airways Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jbss",
      code: "NASDAQ:JBSS",
      companyName: "John B. Sanfilippo & Son Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jbt",
      code: "NASDAQ:JBT",
      companyName: "John Bean Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jce",
      code: "NASDAQ:JCE",
      companyName:
        "Nuveen Core Equity Alpha Fund Nuveen Core Equity Alpha Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jci",
      code: "NASDAQ:JCI",
      companyName: "Johnson Controls International plc Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-jcic",
      code: "NASDAQ:JCIC",
      companyName: "Jack Creek Investment Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jcicu",
      code: "NASDAQ:JCICU",
      companyName: "Jack Creek Investment Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-jcicw",
      code: "NASDAQ:JCICW",
      companyName: "Jack Creek Investment Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-jco",
      code: "NASDAQ:JCO",
      companyName:
        "Nuveen Credit Opportunities 2022 Target Term Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jcse",
      code: "NASDAQ:JCSE",
      companyName: "JE Cleantech Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jctcf",
      code: "NASDAQ:JCTCF",
      companyName: "Jewett-Cameron Trading Company Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jef",
      code: "NASDAQ:JEF",
      companyName: "Jefferies Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jeld",
      code: "NASDAQ:JELD",
      companyName: "JELD-WEN Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jemd",
      code: "NASDAQ:JEMD",
      companyName:
        "Nuveen Emerging Markets Debt 2022 Target Term Fund Common Shares of Beneficial Interest $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-jeq",
      code: "NASDAQ:JEQ",
      companyName: "Aberdeen Japan Equity Fund Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jfin",
      code: "NASDAQ:JFIN",
      companyName: "Jiayin Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jfr",
      code: "NASDAQ:JFR",
      companyName: "Nuveen Floating Rate Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jfu",
      code: "NASDAQ:JFU",
      companyName: "9F Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jg",
      code: "NASDAQ:JG",
      companyName: "Aurora Mobile Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jggc",
      code: "NASDAQ:JGGC",
      companyName: "Jaguar Global Growth Corporation I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jggcr",
      code: "NASDAQ:JGGCR",
      companyName: "Jaguar Global Growth Corporation I Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-jggcu",
      code: "NASDAQ:JGGCU",
      companyName: "Jaguar Global Growth Corporation I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-jgh",
      code: "NASDAQ:JGH",
      companyName:
        "Nuveen Global High Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jhaa",
      code: "NASDAQ:JHAA",
      companyName: "Nuveen Corporate Income 2023 Target Term Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-jhg",
      code: "NASDAQ:JHG",
      companyName: "Janus Henderson Group plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jhi",
      code: "NASDAQ:JHI",
      companyName: "John Hancock Investors Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jhs",
      code: "NASDAQ:JHS",
      companyName: "John Hancock Income Securities Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jhx",
      code: "NASDAQ:JHX",
      companyName:
        "James Hardie Industries plc American Depositary Shares (Ireland)",
      popularity: 0,
    },
    {
      slug: "nasdaq-jill",
      code: "NASDAQ:JILL",
      companyName: "J. Jill Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jjsf",
      code: "NASDAQ:JJSF",
      companyName: "J & J Snack Foods Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jkhy",
      code: "NASDAQ:JKHY",
      companyName: "Jack Henry & Associates Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jks",
      code: "NASDAQ:JKS",
      companyName:
        "JinkoSolar Holding Company Limited American Depositary Shares (each representing 4 Common Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-jll",
      code: "NASDAQ:JLL",
      companyName: "Jones Lang LaSalle Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jls",
      code: "NASDAQ:JLS",
      companyName: "Nuveen Mortgage and Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-jmac",
      code: "NASDAQ:JMAC",
      companyName: "Maxpro Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jmacu",
      code: "NASDAQ:JMACU",
      companyName: "Maxpro Capital Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-jmacw",
      code: "NASDAQ:JMACW",
      companyName: "Maxpro Capital Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-jmia",
      code: "NASDAQ:JMIA",
      companyName:
        "Jumia Technologies AG American Depositary Shares each representing two Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jmm",
      code: "NASDAQ:JMM",
      companyName: "Nuveen Multi-Market Income Fund (MA)",
      popularity: 0,
    },
    {
      slug: "nasdaq-jmsb",
      code: "NASDAQ:JMSB",
      companyName: "John Marshall Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jnce",
      code: "NASDAQ:JNCE",
      companyName: "Jounce Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jnpr",
      code: "NASDAQ:JNPR",
      companyName: "Juniper Networks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-joan",
      code: "NASDAQ:JOAN",
      companyName: "JOANN Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-joe",
      code: "NASDAQ:JOE",
      companyName: "St. Joe Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jof",
      code: "NASDAQ:JOF",
      companyName: "Japan Smaller Capitalization Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-joff",
      code: "NASDAQ:JOFF",
      companyName: "JOFF Fintech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-joffu",
      code: "NASDAQ:JOFFU",
      companyName: "JOFF Fintech Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-joffw",
      code: "NASDAQ:JOFFW",
      companyName: "JOFF Fintech Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-jout",
      code: "NASDAQ:JOUT",
      companyName: "Johnson Outdoors Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jp",
      code: "NASDAQ:JP",
      companyName:
        "Jupai Holdings Limited American Depositary Shares each representing six ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jpc",
      code: "NASDAQ:JPC",
      companyName: "Nuveen Preferred & Income Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-jpi",
      code: "NASDAQ:JPI",
      companyName:
        "Nuveen Preferred and Income Term Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jpm-c",
      code: "NASDAQ:JPM-C",
      companyName:
        "J P Morgan Chase & Co Depositary Shares each representing a 1/400th interest in a share of 6.00% Non-Cumulative  Preferred Stock Series EE",
      popularity: 0,
    },
    {
      slug: "nasdaq-jpm-d",
      code: "NASDAQ:JPM-D",
      companyName:
        "J P Morgan Chase & Co Depositary Shares each representing a 1/400th  interest in a share of 5.75% Non-Cumulative  Preferred Stock Series DD",
      popularity: 0,
    },
    {
      slug: "nasdaq-jpm-j",
      code: "NASDAQ:JPM-J",
      companyName:
        "J P Morgan Chase & Co Depositary Shares each representing a 1/400th interest in a share of JPMorgan Chase & Co. 4.75% Non-Cumulative Preferred Stock Series GG",
      popularity: 0,
    },
    {
      slug: "nasdaq-jpm-k",
      code: "NASDAQ:JPM-K",
      companyName:
        "J P Morgan Chase & Co Depositary Shares each representing a 1/400th interest in a share of 4.55% Non-Cumulative Preferred Stock Series JJ",
      popularity: 0,
    },
    {
      slug: "nasdaq-jpm-l",
      code: "NASDAQ:JPM-L",
      companyName:
        "J P Morgan Chase & Co Depositary Shares each representing a 1/400th interest in a share of 4.625% Non-Cumulative Preferred Stock Series LL",
      popularity: 0,
    },
    {
      slug: "nasdaq-jpm-m",
      code: "NASDAQ:JPM-M",
      companyName:
        "J P Morgan Chase & Co Depositary Shares each representing a 1/400th interest in a share of 4.20% Non-Cumulative Preferred Stock Series MM",
      popularity: 0,
    },
    {
      slug: "nasdaq-jps",
      code: "NASDAQ:JPS",
      companyName: "Nuveen Preferred & Income Securities Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-jpt",
      code: "NASDAQ:JPT",
      companyName:
        "Nuveen Preferred and Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jqc",
      code: "NASDAQ:JQC",
      companyName:
        "Nuveen Credit Strategies Income Fund Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jri",
      code: "NASDAQ:JRI",
      companyName:
        "Nuveen Real Asset Income and Growth Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jro",
      code: "NASDAQ:JRO",
      companyName:
        "Nuveen Floating Rate Income Opportuntiy Fund Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jrs",
      code: "NASDAQ:JRS",
      companyName:
        "Nuveen Real Estate Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jrsh",
      code: "NASDAQ:JRSH",
      companyName: "Jerash Holdings (US) Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jrvr",
      code: "NASDAQ:JRVR",
      companyName: "James River Group Holdings Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jsd",
      code: "NASDAQ:JSD",
      companyName:
        "Nuveen Short Duration Credit Opportunities Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-jsm",
      code: "NASDAQ:JSM",
      companyName: "Navient Corporation 6% Senior Notes due December 15 2043",
      popularity: 0,
    },
    {
      slug: "nasdaq-jspr",
      code: "NASDAQ:JSPR",
      companyName: "Jasper Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jsprw",
      code: "NASDAQ:JSPRW",
      companyName: "Japer Therapeutics Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-jt",
      code: "NASDAQ:JT",
      companyName: "Jianpu Technology Inc. American depositary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jugg",
      code: "NASDAQ:JUGG",
      companyName:
        "Jaws Juggernaut Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-juggu",
      code: "NASDAQ:JUGGU",
      companyName: "Jaws Juggernaut Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-juggw",
      code: "NASDAQ:JUGGW",
      companyName: "Jaws Juggernaut Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-jun",
      code: "NASDAQ:JUN",
      companyName: "Juniper II Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jupw",
      code: "NASDAQ:JUPW",
      companyName: "Jupiter Wellness Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jupww",
      code: "NASDAQ:JUPWW",
      companyName: "Jupiter Wellness Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-jva",
      code: "NASDAQ:JVA",
      companyName: "Coffee Holding Co. Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jwac",
      code: "NASDAQ:JWAC",
      companyName: "Jupiter Wellness Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jwacr",
      code: "NASDAQ:JWACR",
      companyName: "Jupiter Wellness Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-jwel",
      code: "NASDAQ:JWEL",
      companyName: "Jowell Global Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jwn",
      code: "NASDAQ:JWN",
      companyName: "Nordstrom Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jwsm",
      code: "NASDAQ:JWSM",
      companyName: "Jaws Mustang Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-jxn",
      code: "NASDAQ:JXN",
      companyName: "Jackson Financial Inc. Class A Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-jyac",
      code: "NASDAQ:JYAC",
      companyName: "Jiya Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jynt",
      code: "NASDAQ:JYNT",
      companyName: "The Joint Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jzxn",
      code: "NASDAQ:JZXN",
      companyName: "Jiuzi Holdings Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-k",
      code: "NASDAQ:K",
      companyName: "Kellogg Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kacl",
      code: "NASDAQ:KACL",
      companyName: "Kairous Acquisition Corp. Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kaclr",
      code: "NASDAQ:KACLR",
      companyName: "Kairous Acquisition Corp. Limited Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-kaclw",
      code: "NASDAQ:KACLW",
      companyName: "Kairous Acquisition Corp. Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-kahc",
      code: "NASDAQ:KAHC",
      companyName: "KKR Acquisition Holdings I Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kai",
      code: "NASDAQ:KAI",
      companyName: "Kadant Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kair",
      code: "NASDAQ:KAIR",
      companyName: "Kairos Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kairw",
      code: "NASDAQ:KAIRW",
      companyName: "Kairos Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-kala",
      code: "NASDAQ:KALA",
      companyName: "Kala Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kalu",
      code: "NASDAQ:KALU",
      companyName: "Kaiser Aluminum Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kalv",
      code: "NASDAQ:KALV",
      companyName: "KalVista Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kamn",
      code: "NASDAQ:KAMN",
      companyName: "Kaman Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kar",
      code: "NASDAQ:KAR",
      companyName: "KAR Auction Services Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-karo",
      code: "NASDAQ:KARO",
      companyName: "Karooooo Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kavl",
      code: "NASDAQ:KAVL",
      companyName: "Kaival Brands Innovations Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kb",
      code: "NASDAQ:KB",
      companyName: "KB Financial Group Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-kbal",
      code: "NASDAQ:KBAL",
      companyName: "Kimball International Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kbh",
      code: "NASDAQ:KBH",
      companyName: "KB Home Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kbnt",
      code: "NASDAQ:KBNT",
      companyName: "Kubient Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kbntw",
      code: "NASDAQ:KBNTW",
      companyName: "Kubient Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-kbr",
      code: "NASDAQ:KBR",
      companyName: "KBR Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kio",
      code: "NASDAQ:KIO",
      companyName: "KKR Income Opportunities Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kcgi",
      code: "NASDAQ:KCGI",
      companyName:
        "Kensington Capital Acquisition Corp. V Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kd",
      code: "NASDAQ:KD",
      companyName: "Kyndryl Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kdny",
      code: "NASDAQ:KDNY",
      companyName: "Chinook Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kdp",
      code: "NASDAQ:KDP",
      companyName: "Keurig Dr Pepper Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ke",
      code: "NASDAQ:KE",
      companyName: "Kimball Electronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kelya",
      code: "NASDAQ:KELYA",
      companyName: "Kelly Services Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kelyb",
      code: "NASDAQ:KELYB",
      companyName: "Kelly Services Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ken",
      code: "NASDAQ:KEN",
      companyName: "Kenon Holdings Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kep",
      code: "NASDAQ:KEP",
      companyName: "Korea Electric Power Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kequ",
      code: "NASDAQ:KEQU",
      companyName: "Kewaunee Scientific Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kern",
      code: "NASDAQ:KERN",
      companyName: "Akerna Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kernw",
      code: "NASDAQ:KERNW",
      companyName: "Akerna Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-kex",
      code: "NASDAQ:KEX",
      companyName: "Kirby Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-key",
      code: "NASDAQ:KEY",
      companyName: "KeyCorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-key-i",
      code: "NASDAQ:KEY-I",
      companyName:
        "KeyCorp Depositary Shares Each Representing a 1/40th Ownership Interest in a Share of Fixed-to-Floating Rate Perpetual Non-Cumulative Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-key-j",
      code: "NASDAQ:KEY-J",
      companyName:
        "KeyCorp Depositary Shares each representing a 1/40th ownership interest in a share of Fixed Rate Perpetual Non-Cumulative Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nasdaq-key-k",
      code: "NASDAQ:KEY-K",
      companyName:
        "KeyCorp Depositary Shares each representing a 1/40th ownership interest in a share of Fixed Rate Perpetual Non-Cumulative Preferred Stock Series G",
      popularity: 0,
    },
    {
      slug: "nasdaq-keys",
      code: "NASDAQ:KEYS",
      companyName: "Keysight Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kf",
      code: "NASDAQ:KF",
      companyName: "Korea Fund Inc. (The) New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kffb",
      code: "NASDAQ:KFFB",
      companyName: "Kentucky First Federal Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kfrc",
      code: "NASDAQ:KFRC",
      companyName: "Kforce Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kfs",
      code: "NASDAQ:KFS",
      companyName: "Kingsway Financial Services Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-kfy",
      code: "NASDAQ:KFY",
      companyName: "Korn Ferry Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kgc",
      code: "NASDAQ:KGC",
      companyName: "Kinross Gold Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kids",
      code: "NASDAQ:KIDS",
      companyName: "OrthoPediatrics Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kiii",
      code: "NASDAQ:KIII",
      companyName: "Kismet Acquisition Three Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kiiiu",
      code: "NASDAQ:KIIIU",
      companyName: "Kismet Acquisition Three Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-kiiiw",
      code: "NASDAQ:KIIIW",
      companyName: "Kismet Acquisition Three Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-kim",
      code: "NASDAQ:KIM",
      companyName: "Kimco Realty Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kim-l",
      code: "NASDAQ:KIM-L",
      companyName:
        "Kimco Realty Corporation Class L Depositary Shares each of which represents a one-one thousandth fractional interest in a share of 5.125% Class L Cumulative Redeemable Preferred Stock liquidation preference $25000.00 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-kim-m",
      code: "NASDAQ:KIM-M",
      companyName:
        "Kimco Realty Corporation Class M Depositary Shares each of which represents a one-one thousandth fractional interest in a share of 5.25% Class M Cumulative Redeemable Preferred Stock liquidation preference $25000.00 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-kind",
      code: "NASDAQ:KIND",
      companyName: "Nextdoor Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kins",
      code: "NASDAQ:KINS",
      companyName: "Kingstone Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kinz",
      code: "NASDAQ:KINZ",
      companyName: "KINS Technology Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kinzw",
      code: "NASDAQ:KINZW",
      companyName: "KINS Technology Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-kiq",
      code: "NASDAQ:KIQ",
      companyName: "Kelso Technologies Inc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kirk",
      code: "NASDAQ:KIRK",
      companyName: "Kirkland's Inc. COMMONSTOCK",
      popularity: 0,
    },
    {
      slug: "nasdaq-kkr",
      code: "NASDAQ:KKR",
      companyName: "KKR & Co. Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kkr-c",
      code: "NASDAQ:KKR-C",
      companyName:
        "KKR & Co. Inc. 6.00% Series C Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kkrs",
      code: "NASDAQ:KKRS",
      companyName:
        "KKR Group Finance Co. IX LLC 4.625% Subordinated Notes due 2061",
      popularity: 0,
    },
    {
      slug: "nasdaq-klac",
      code: "NASDAQ:KLAC",
      companyName: "KLA Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-klaq",
      code: "NASDAQ:KLAQ",
      companyName: "KL Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-klaqw",
      code: "NASDAQ:KLAQW",
      companyName: "KL Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-klic",
      code: "NASDAQ:KLIC",
      companyName: "Kulicke and Soffa Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-klr",
      code: "NASDAQ:KLR",
      companyName: "Kaleyra Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kltr",
      code: "NASDAQ:KLTR",
      companyName: "Kaltura Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-klxe",
      code: "NASDAQ:KLXE",
      companyName: "KLX Energy Services Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kmb",
      code: "NASDAQ:KMB",
      companyName: "Kimberly-Clark Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kmda",
      code: "NASDAQ:KMDA",
      companyName: "Kamada Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kmf",
      code: "NASDAQ:KMF",
      companyName: "Kayne Anderson NextGen Energy & Infrastructure Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-kmi",
      code: "NASDAQ:KMI",
      companyName: "Kinder Morgan Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kmpb",
      code: "NASDAQ:KMPB",
      companyName:
        "Kemper Corporation 5.875% Fixed-Rate Reset Junior Subordinated Debentures due 2062",
      popularity: 0,
    },
    {
      slug: "nasdaq-kmph",
      code: "NASDAQ:KMPH",
      companyName: "KemPharm Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kmpr",
      code: "NASDAQ:KMPR",
      companyName: "Kemper Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-kmt",
      code: "NASDAQ:KMT",
      companyName: "Kennametal Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kmx",
      code: "NASDAQ:KMX",
      companyName: "CarMax Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-kn",
      code: "NASDAQ:KN",
      companyName: "Knowles Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-knbe",
      code: "NASDAQ:KNBE",
      companyName: "KnowBe4 Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kndi",
      code: "NASDAQ:KNDI",
      companyName: "Kandi Technologies Group Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-knop",
      code: "NASDAQ:KNOP",
      companyName:
        "KNOT Offshore Partners LP Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-knsa",
      code: "NASDAQ:KNSA",
      companyName: "Kiniksa Pharmaceuticals Ltd. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-knsl",
      code: "NASDAQ:KNSL",
      companyName: "Kinsale Capital Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-knsw",
      code: "NASDAQ:KNSW",
      companyName: "KnightSwan Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-knte",
      code: "NASDAQ:KNTE",
      companyName: "Kinnate Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kntk",
      code: "NASDAQ:KNTK",
      companyName: "Kinetik Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-knx",
      code: "NASDAQ:KNX",
      companyName: "Knight-Swift Transportation Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-kod",
      code: "NASDAQ:KOD",
      companyName: "Kodiak Sciences Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kodk",
      code: "NASDAQ:KODK",
      companyName: "Eastman Kodak Company Common New",
      popularity: 0,
    },
    {
      slug: "nasdaq-kof",
      code: "NASDAQ:KOF",
      companyName:
        "Coca Cola Femsa S.A.B. de C.V.  American Depositary Shares each representing 10 Units (each Unit consists of 3 Series B Shares and 5 Series L Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-kop",
      code: "NASDAQ:KOP",
      companyName: "Koppers Holdings Inc. Koppers Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kopn",
      code: "NASDAQ:KOPN",
      companyName: "Kopin Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kore",
      code: "NASDAQ:KORE",
      companyName: "KORE Group Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kos",
      code: "NASDAQ:KOS",
      companyName: "Kosmos Energy Ltd. Common Shares (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-koss",
      code: "NASDAQ:KOSS",
      companyName: "Koss Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kplt",
      code: "NASDAQ:KPLT",
      companyName: "Katapult Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kpltw",
      code: "NASDAQ:KPLTW",
      companyName: "Katapult Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-kprx",
      code: "NASDAQ:KPRX",
      companyName: "Kiora Pharmaceuticals Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kpti",
      code: "NASDAQ:KPTI",
      companyName: "Karyopharm Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kr",
      code: "NASDAQ:KR",
      companyName: "Kroger Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-krbp",
      code: "NASDAQ:KRBP",
      companyName: "Kiromic BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-krc",
      code: "NASDAQ:KRC",
      companyName: "Kilroy Realty Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kref",
      code: "NASDAQ:KREF",
      companyName: "KKR Real Estate Finance Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kref-a",
      code: "NASDAQ:KREF-A",
      companyName:
        "KKR Real Estate Finance Trust Inc. 6.50% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-krg",
      code: "NASDAQ:KRG",
      companyName: "Kite Realty Group Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-krkr",
      code: "NASDAQ:KRKR",
      companyName: "36Kr Holdings Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-krmd",
      code: "NASDAQ:KRMD",
      companyName: "Repro Med Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-krnl",
      code: "NASDAQ:KRNL",
      companyName: "Kernel Group Holdings Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-krnlu",
      code: "NASDAQ:KRNLU",
      companyName: "Kernel Group Holdings Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-krnlw",
      code: "NASDAQ:KRNLW",
      companyName: "Kernel Group Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-krnt",
      code: "NASDAQ:KRNT",
      companyName: "Kornit Digital Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-krny",
      code: "NASDAQ:KRNY",
      companyName: "Kearny Financial Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kron",
      code: "NASDAQ:KRON",
      companyName: "Kronos Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kros",
      code: "NASDAQ:KROS",
      companyName: "Keros Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-krp",
      code: "NASDAQ:KRP",
      companyName:
        "Kimbell Royalty Partners Common Units Representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-krt",
      code: "NASDAQ:KRT",
      companyName: "Karat Packaging Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-krtx",
      code: "NASDAQ:KRTX",
      companyName: "Karuna Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-krus",
      code: "NASDAQ:KRUS",
      companyName: "Kura Sushi USA Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-krys",
      code: "NASDAQ:KRYS",
      companyName: "Krystal Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kscp",
      code: "NASDAQ:KSCP",
      companyName: "Knightscope Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ksi",
      code: "NASDAQ:KSI",
      companyName: "Kadem Sustainable Impact Corporation Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ksicw",
      code: "NASDAQ:KSICW",
      companyName: "Kadem Sustainable Impact Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ksm",
      code: "NASDAQ:KSM",
      companyName: "DWS Strategic Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-kspn",
      code: "NASDAQ:KSPN",
      companyName: "Kaspien Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kss",
      code: "NASDAQ:KSS",
      companyName: "Kohl's Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ktb",
      code: "NASDAQ:KTB",
      companyName: "Kontoor Brands Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-ktcc",
      code: "NASDAQ:KTCC",
      companyName: "Key Tronic Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ktf",
      code: "NASDAQ:KTF",
      companyName: "DWS Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nasdaq-kth",
      code: "NASDAQ:KTH",
      companyName:
        "Structures Products Cp 8% CorTS Issued by Peco Energy Cap Tr II Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ktn",
      code: "NASDAQ:KTN",
      companyName:
        "Structured Products Corp 8.205% CorTS 8.205% Corporate Backed Trust Securities (CorTS)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ktos",
      code: "NASDAQ:KTOS",
      companyName: "Kratos Defense & Security Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ktra",
      code: "NASDAQ:KTRA",
      companyName: "Kintara Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ktta",
      code: "NASDAQ:KTTA",
      companyName: "Pasithea Therapeutics Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kttaw",
      code: "NASDAQ:KTTAW",
      companyName: "Pasithea Therapeutics Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-kuke",
      code: "NASDAQ:KUKE",
      companyName:
        "Kuke Music Holding Limited American Depositary Shares each representing one Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-kulr",
      code: "NASDAQ:KULR",
      companyName: "KULR Technology Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kura",
      code: "NASDAQ:KURA",
      companyName: "Kura Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kvhi",
      code: "NASDAQ:KVHI",
      companyName: "KVH Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kvsa",
      code: "NASDAQ:KVSA",
      companyName: "Khosla Ventures Acquisition Co. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kvsc",
      code: "NASDAQ:KVSC",
      companyName: "Khosla Ventures Acquisition Co. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kw",
      code: "NASDAQ:KW",
      companyName: "Kennedy-Wilson Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kwac",
      code: "NASDAQ:KWAC",
      companyName: "Kingswood Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kwr",
      code: "NASDAQ:KWR",
      companyName: "Quaker Houghton Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kxin",
      code: "NASDAQ:KXIN",
      companyName: "Kaixin Auto Holdings Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kych",
      code: "NASDAQ:KYCH",
      companyName: "Keyarch Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kymr",
      code: "NASDAQ:KYMR",
      companyName: "Kymera Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kyn",
      code: "NASDAQ:KYN",
      companyName: "Kayne Anderson Energy Infrastructure Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-kzia",
      code: "NASDAQ:KZIA",
      companyName: "Kazia Therapeutics Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kzr",
      code: "NASDAQ:KZR",
      companyName: "Kezar Life Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-l",
      code: "NASDAQ:L",
      companyName: "Loews Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-laaaw",
      code: "NASDAQ:LAAAW",
      companyName: "Lakeshore Acquisition I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lab",
      code: "NASDAQ:LAB",
      companyName: "Standard BioTools Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-labp",
      code: "NASDAQ:LABP",
      companyName: "Landos Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lac",
      code: "NASDAQ:LAC",
      companyName: "Lithium Americas Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lad",
      code: "NASDAQ:LAD",
      companyName: "Lithia Motors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ladr",
      code: "NASDAQ:LADR",
      companyName: "Ladder Capital Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lake",
      code: "NASDAQ:LAKE",
      companyName: "Lakeland Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lamr",
      code: "NASDAQ:LAMR",
      companyName: "Lamar Advertising Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lanc",
      code: "NASDAQ:LANC",
      companyName: "Lancaster Colony Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-land",
      code: "NASDAQ:LAND",
      companyName: "Gladstone Land Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-landm",
      code: "NASDAQ:LANDM",
      companyName:
        "Gladstone Land Corporation 5.00% Series D Cumulative Term Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lando",
      code: "NASDAQ:LANDO",
      companyName:
        "Gladstone Land Corporation 6.00% Series B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lark",
      code: "NASDAQ:LARK",
      companyName: "Landmark Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lasr",
      code: "NASDAQ:LASR",
      companyName: "nLIGHT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-latg",
      code: "NASDAQ:LATG",
      companyName: "LatAmGrowth SPAC Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-latgw",
      code: "NASDAQ:LATGW",
      companyName: "LatAmGrowth SPAC Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-laur",
      code: "NASDAQ:LAUR",
      companyName: "Laureate Education Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-law",
      code: "NASDAQ:LAW",
      companyName: "CS Disco Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lax",
      code: "NASDAQ:LAX",
      companyName: "8i Acquisition 2 Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-laxxr",
      code: "NASDAQ:LAXXR",
      companyName: "8i Acquisition 2 Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-laxxw",
      code: "NASDAQ:LAXXW",
      companyName: "8i Acquisition 2 Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-laz",
      code: "NASDAQ:LAZ",
      companyName: "Lazard LTD. Lazard LTD. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lazr",
      code: "NASDAQ:LAZR",
      companyName: "Luminar Technologies Inc.  Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lazy",
      code: "NASDAQ:LAZY",
      companyName: "Lazydays Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbai",
      code: "NASDAQ:LBAI",
      companyName: "Lakeland Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbbb",
      code: "NASDAQ:LBBB",
      companyName: "Lakeshore Acquisition II Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbbbr",
      code: "NASDAQ:LBBBR",
      companyName: "Lakeshore Acquisition II Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbbbu",
      code: "NASDAQ:LBBBU",
      companyName: "Lakeshore Acquisition II Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbbbw",
      code: "NASDAQ:LBBBW",
      companyName: "Lakeshore Acquisition II Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbc",
      code: "NASDAQ:LBC",
      companyName: "Luther Burbank Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbph",
      code: "NASDAQ:LBPH",
      companyName: "Longboard Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbps",
      code: "NASDAQ:LBPS",
      companyName: "4D pharma plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbpsw",
      code: "NASDAQ:LBPSW",
      companyName: "4D pharma plc Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbrda",
      code: "NASDAQ:LBRDA",
      companyName: "Liberty Broadband Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbrdk",
      code: "NASDAQ:LBRDK",
      companyName: "Liberty Broadband Corporation Class C Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbrdp",
      code: "NASDAQ:LBRDP",
      companyName:
        "Liberty Broadband Corporation Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbrt",
      code: "NASDAQ:LBRT",
      companyName: "Liberty Energy Inc. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbtya",
      code: "NASDAQ:LBTYA",
      companyName: "Liberty Global plc Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbtyb",
      code: "NASDAQ:LBTYB",
      companyName: "Liberty Global plc Class B Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lbtyk",
      code: "NASDAQ:LBTYK",
      companyName: "Liberty Global plc Class C Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lc",
      code: "NASDAQ:LC",
      companyName: "LendingClub Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lca",
      code: "NASDAQ:LCA",
      companyName: "Landcadia Holdings IV Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcaa",
      code: "NASDAQ:LCAA",
      companyName: "L Catterton Asia Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcaaw",
      code: "NASDAQ:LCAAW",
      companyName: "L Catterton Asia Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcahw",
      code: "NASDAQ:LCAHW",
      companyName: "Landcadia Holdings IV Inc. Warrant ",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcap",
      code: "NASDAQ:LCAP",
      companyName: "Lionheart Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcapw",
      code: "NASDAQ:LCAPW",
      companyName: "Lionheart Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcfy",
      code: "NASDAQ:LCFY",
      companyName: "Locafy Limited Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcfyw",
      code: "NASDAQ:LCFYW",
      companyName: "Locafy Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lci",
      code: "NASDAQ:LCI",
      companyName: "Lannett Co Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcid",
      code: "NASDAQ:LCID",
      companyName: "Lucid Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcii",
      code: "NASDAQ:LCII",
      companyName: "LCI Industries",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcnb",
      code: "NASDAQ:LCNB",
      companyName: "LCNB Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lctx",
      code: "NASDAQ:LCTX",
      companyName: "Lineage Cell Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcut",
      code: "NASDAQ:LCUT",
      companyName: "Lifetime Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lcw",
      code: "NASDAQ:LCW",
      companyName: "Learn CW Investment Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ldha",
      code: "NASDAQ:LDHA",
      companyName: "LDH Growth Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ldhau",
      code: "NASDAQ:LDHAU",
      companyName: "LDH Growth Corp I Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ldhaw",
      code: "NASDAQ:LDHAW",
      companyName: "LDH Growth Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ldi",
      code: "NASDAQ:LDI",
      companyName: "loanDepot Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ldos",
      code: "NASDAQ:LDOS",
      companyName: "Leidos Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ldp",
      code: "NASDAQ:LDP",
      companyName:
        "Cohen & Steers Limited Duration Preferred and Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-le",
      code: "NASDAQ:LE",
      companyName: "Lands' End Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lea",
      code: "NASDAQ:LEA",
      companyName: "Lear Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-leap",
      code: "NASDAQ:LEAP",
      companyName: "Ribbit LEAP Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-leco",
      code: "NASDAQ:LECO",
      companyName: "Lincoln Electric Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-leds",
      code: "NASDAQ:LEDS",
      companyName: "SemiLEDS Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lee",
      code: "NASDAQ:LEE",
      companyName: "Lee Enterprises Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-leg",
      code: "NASDAQ:LEG",
      companyName: "Leggett & Platt Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lega",
      code: "NASDAQ:LEGA",
      companyName: "Lead Edge Growth Opportunities Ltd Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-legau",
      code: "NASDAQ:LEGAU",
      companyName: "Lead Edge Growth Opportunities Ltd Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-legaw",
      code: "NASDAQ:LEGAW",
      companyName: "Lead Edge Growth Opportunities Ltd Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-legh",
      code: "NASDAQ:LEGH",
      companyName: "Legacy Housing Corporation Common Stock (TX)",
      popularity: 0,
    },
    {
      slug: "nasdaq-legn",
      code: "NASDAQ:LEGN",
      companyName: "Legend Biotech Corporation American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-leju",
      code: "NASDAQ:LEJU",
      companyName:
        "Leju Holdings Limited American Depositary Shares each representing one Ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-len",
      code: "NASDAQ:LEN",
      companyName: "Lennar Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-leo",
      code: "NASDAQ:LEO",
      companyName: "BNY Mellon Strategic Municipals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-leu",
      code: "NASDAQ:LEU",
      companyName: "Centrus Energy Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lev",
      code: "NASDAQ:LEV",
      companyName: "The Lion Electric Company Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-levi",
      code: "NASDAQ:LEVI",
      companyName: "Levi Strauss & Co Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lexx",
      code: "NASDAQ:LEXX",
      companyName: "Lexaria Bioscience Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lexxw",
      code: "NASDAQ:LEXXW",
      companyName: "Lexaria Bioscience Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfac",
      code: "NASDAQ:LFAC",
      companyName: "LF Capital Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfacu",
      code: "NASDAQ:LFACU",
      companyName: "LF Capital Acquisition Corp. II Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfacw",
      code: "NASDAQ:LFACW",
      companyName: "LF Capital Acquisition Corp. II Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfc",
      code: "NASDAQ:LFC",
      companyName:
        "China Life Insurance Company Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfg",
      code: "NASDAQ:LFG",
      companyName: "Archaea Energy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfly",
      code: "NASDAQ:LFLY",
      companyName: "Leafly Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lflyw",
      code: "NASDAQ:LFLYW",
      companyName: "Leafly Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfmd",
      code: "NASDAQ:LFMD",
      companyName: "LifeMD Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfmdp",
      code: "NASDAQ:LFMDP",
      companyName:
        "LifeMD Inc. 8.875% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfst",
      code: "NASDAQ:LFST",
      companyName: "LifeStance Health Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lft",
      code: "NASDAQ:LFT",
      companyName: "Lument Finance Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lft-a",
      code: "NASDAQ:LFT-A",
      companyName:
        "Lument Finance Trust Inc. 7.875% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lftr",
      code: "NASDAQ:LFTR",
      companyName: "Lefteris Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lftru",
      code: "NASDAQ:LFTRU",
      companyName: "Lefteris Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-lftrw",
      code: "NASDAQ:LFTRW",
      companyName: "Lefteris Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfus",
      code: "NASDAQ:LFUS",
      companyName: "Littelfuse Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lfvn",
      code: "NASDAQ:LFVN",
      companyName: "Lifevantage Corporation Common Stock (Delaware)",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgac",
      code: "NASDAQ:LGAC",
      companyName: "Lazard Growth Acquisition Corp. I Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgacu",
      code: "NASDAQ:LGACU",
      companyName: "Lazard Growth Acquisition Corp. I Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgacw",
      code: "NASDAQ:LGACW",
      companyName: "Lazard Growth Acquisition Corp. I Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lghl",
      code: "NASDAQ:LGHL",
      companyName: "Lion Group Holding Ltd. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-lghlw",
      code: "NASDAQ:LGHLW",
      companyName: "Lion Group Holding Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgi",
      code: "NASDAQ:LGI",
      companyName: "Lazard Global Total Return and Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgih",
      code: "NASDAQ:LGIH",
      companyName: "LGI Homes Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgl",
      code: "NASDAQ:LGL",
      companyName: "LGL Group Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgmk",
      code: "NASDAQ:LGMK",
      companyName: "LogicMark Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgnd",
      code: "NASDAQ:LGND",
      companyName: "Ligand Pharmaceuticals Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgo",
      code: "NASDAQ:LGO",
      companyName: "Largo Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgst",
      code: "NASDAQ:LGST",
      companyName:
        "Semper Paratus Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgstu",
      code: "NASDAQ:LGSTU",
      companyName: "Semper Paratus Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgto",
      code: "NASDAQ:LGTO",
      companyName: "Legato Merger Corp. II Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgtow",
      code: "NASDAQ:LGTOW",
      companyName: "Legato Merger Corp. II Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgv",
      code: "NASDAQ:LGV",
      companyName: "Longview Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgvc",
      code: "NASDAQ:LGVC",
      companyName: "LAMF Global Ventures Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgvcu",
      code: "NASDAQ:LGVCU",
      companyName: "LAMF Global Ventures Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgvcw",
      code: "NASDAQ:LGVCW",
      companyName: "LAMF Global Ventures Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lgvn",
      code: "NASDAQ:LGVN",
      companyName: "Longeveron Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lh",
      code: "NASDAQ:LH",
      companyName: "Laboratory Corporation of America Holdings Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lhaa",
      code: "NASDAQ:LHAA",
      companyName: "Lerer Hippeau Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lhc",
      code: "NASDAQ:LHC",
      companyName: "Leo Holdings Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lhcg",
      code: "NASDAQ:LHCG",
      companyName: "LHC Group Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lhdx",
      code: "NASDAQ:LHDX",
      companyName: "Lucira Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lhx",
      code: "NASDAQ:LHX",
      companyName: "L3Harris Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lian",
      code: "NASDAQ:LIAN",
      companyName: "LianBio American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-liby",
      code: "NASDAQ:LIBY",
      companyName: "Liberty Resources Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-libyu",
      code: "NASDAQ:LIBYU",
      companyName: "Liberty Resources Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-libyw",
      code: "NASDAQ:LIBYW",
      companyName: "Liberty Resources Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-licy",
      code: "NASDAQ:LICY",
      companyName: "Li-Cycle Holdings Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lidr",
      code: "NASDAQ:LIDR",
      companyName: "AEye Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lidrw",
      code: "NASDAQ:LIDRW",
      companyName: "AEye Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-life",
      code: "NASDAQ:LIFE",
      companyName: "aTyr Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lii",
      code: "NASDAQ:LII",
      companyName: "Lennox International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lila",
      code: "NASDAQ:LILA",
      companyName: "Liberty Latin America Ltd. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-linc",
      code: "NASDAQ:LINC",
      companyName: "Lincoln Educational Services Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lind",
      code: "NASDAQ:LIND",
      companyName: "Lindblad Expeditions Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-link",
      code: "NASDAQ:LINK",
      companyName: "Interlink Electronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lionw",
      code: "NASDAQ:LIONW",
      companyName: "Lionheart III Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-liqt",
      code: "NASDAQ:LIQT",
      companyName: "LiqTech International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-litb",
      code: "NASDAQ:LITB",
      companyName:
        "LightInTheBox Holding Co. Ltd. American Depositary Shares each representing 2 ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lite",
      code: "NASDAQ:LITE",
      companyName: "Lumentum Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-litm",
      code: "NASDAQ:LITM",
      companyName: "Snow Lake Resources Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-litt",
      code: "NASDAQ:LITT",
      companyName:
        "Logistics Innovation Technologies Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-littu",
      code: "NASDAQ:LITTU",
      companyName: "Logistics Innovation Technologies Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-littw",
      code: "NASDAQ:LITTW",
      companyName: "Logistics Innovation Technologies Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-livbu",
      code: "NASDAQ:LIVBU",
      companyName: "LIV Capital Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-livbw",
      code: "NASDAQ:LIVBW",
      companyName: "LIV Capital Acquisition Corp. II Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-live",
      code: "NASDAQ:LIVE",
      companyName: "Live Ventures Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-livn",
      code: "NASDAQ:LIVN",
      companyName: "LivaNova PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lixt",
      code: "NASDAQ:LIXT",
      companyName: "Lixte Biotechnology Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lin",
      code: "NASDAQ:LIN",
      companyName: "Linde plc Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-lixtw",
      code: "NASDAQ:LIXTW",
      companyName: "Lixte Biotechnology Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lizi",
      code: "NASDAQ:LIZI",
      companyName: "LIZHI INC. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ljaq",
      code: "NASDAQ:LJAQ",
      companyName: "LightJump Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ljaqu",
      code: "NASDAQ:LJAQU",
      companyName: "LightJump Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ljaqw",
      code: "NASDAQ:LJAQW",
      companyName: "LightJump Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ljpc",
      code: "NASDAQ:LJPC",
      companyName: "La Jolla Pharmaceutical Company Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-lkco",
      code: "NASDAQ:LKCO",
      companyName: "Luokung Technology Corp Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lkfn",
      code: "NASDAQ:LKFN",
      companyName: "Lakeland Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lkq",
      code: "NASDAQ:LKQ",
      companyName: "LKQ Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ll",
      code: "NASDAQ:LL",
      companyName: "LL Flooring Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-llap",
      code: "NASDAQ:LLAP",
      companyName: "Terran Orbital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lll",
      code: "NASDAQ:LLL",
      companyName: "JX Luxventure Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-llnw",
      code: "NASDAQ:LLNW",
      companyName: "Limelight Networks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmaca",
      code: "NASDAQ:LMACA",
      companyName:
        "Liberty Media Acquisition Corporation Series A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmacu",
      code: "NASDAQ:LMACU",
      companyName: "Liberty Media Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmacw",
      code: "NASDAQ:LMACW",
      companyName: "Liberty Media Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmao",
      code: "NASDAQ:LMAO",
      companyName: "LMF Acquisition Opportunities Inc. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmaow",
      code: "NASDAQ:LMAOW",
      companyName: "LMF Acquisition Opportunities Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmat",
      code: "NASDAQ:LMAT",
      companyName: "LeMaitre Vascular Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmb",
      code: "NASDAQ:LMB",
      companyName: "Limbach Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmdx",
      code: "NASDAQ:LMDX",
      companyName: "LumiraDx Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmdxw",
      code: "NASDAQ:LMDXW",
      companyName: "LumiraDx Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmfa",
      code: "NASDAQ:LMFA",
      companyName: "LM Funding America Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmnl",
      code: "NASDAQ:LMNL",
      companyName: "Liminal BioSciences Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmnr",
      code: "NASDAQ:LMNR",
      companyName: "Limoneira Co Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmpx",
      code: "NASDAQ:LMPX",
      companyName: "LMP Automotive Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmst",
      code: "NASDAQ:LMST",
      companyName: "Limestone Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmt",
      code: "NASDAQ:LMT",
      companyName: "Lockheed Martin Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lnc",
      code: "NASDAQ:LNC",
      companyName: "Lincoln National Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lnd",
      code: "NASDAQ:LND",
      companyName:
        "Brasilagro Brazilian Agric Real Estate Co Sponsored ADR (Brazil)",
      popularity: 0,
    },
    {
      slug: "nasdaq-lndc",
      code: "NASDAQ:LNDC",
      companyName: "Landec Corporation Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-lnfa",
      code: "NASDAQ:LNFA",
      companyName: "L&amp;F Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lng",
      code: "NASDAQ:LNG",
      companyName: "Cheniere Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lnn",
      code: "NASDAQ:LNN",
      companyName: "Lindsay Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lnsr",
      code: "NASDAQ:LNSR",
      companyName: "LENSAR Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lnt",
      code: "NASDAQ:LNT",
      companyName: "Alliant Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lob",
      code: "NASDAQ:LOB",
      companyName: "Live Oak Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-locc",
      code: "NASDAQ:LOCC",
      companyName:
        "Live Oak Crestview Climate Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-locl",
      code: "NASDAQ:LOCL",
      companyName: "Local Bounti Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-loco",
      code: "NASDAQ:LOCO",
      companyName: "El Pollo Loco Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lode",
      code: "NASDAQ:LODE",
      companyName: "Comstock Mining Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-logc",
      code: "NASDAQ:LOGC",
      companyName: "LogicBio Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-logi",
      code: "NASDAQ:LOGI",
      companyName: "Logitech International S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lokm",
      code: "NASDAQ:LOKM",
      companyName: "Live Oak Mobility Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-loma",
      code: "NASDAQ:LOMA",
      companyName:
        "Loma Negra Compania Industrial Argentina Sociedad Anonima ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-loop",
      code: "NASDAQ:LOOP",
      companyName: "Loop Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lope",
      code: "NASDAQ:LOPE",
      companyName: "Grand Canyon Education Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lotz",
      code: "NASDAQ:LOTZ",
      companyName: "CarLotz Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lotzw",
      code: "NASDAQ:LOTZW",
      companyName: "CarLotz Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lov",
      code: "NASDAQ:LOV",
      companyName: "Spark Networks SE American Depositary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-love",
      code: "NASDAQ:LOVE",
      companyName: "The Lovesac Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-low",
      code: "NASDAQ:LOW",
      companyName: "Lowe's Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lpcn",
      code: "NASDAQ:LPCN",
      companyName: "Lipocine Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lpg",
      code: "NASDAQ:LPG",
      companyName: "Dorian LPG Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lpi",
      code: "NASDAQ:LPI",
      companyName: "Laredo Petroleum Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lpl",
      code: "NASDAQ:LPL",
      companyName: "LG Display Co Ltd AMERICAN DEPOSITORY SHARES",
      popularity: 0,
    },
    {
      slug: "nasdaq-lpla",
      code: "NASDAQ:LPLA",
      companyName: "LPL Financial Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lmnd",
      code: "NASDAQ:LMND",
      companyName: "Lemonade Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lpsn",
      code: "NASDAQ:LPSN",
      companyName: "LivePerson Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lpth",
      code: "NASDAQ:LPTH",
      companyName: "LightPath Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lptx",
      code: "NASDAQ:LPTX",
      companyName: "Leap Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lqda",
      code: "NASDAQ:LQDA",
      companyName: "Liquidia Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lqdt",
      code: "NASDAQ:LQDT",
      companyName: "Liquidity Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lrfc",
      code: "NASDAQ:LRFC",
      companyName: "Logan Ridge Finance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lrmr",
      code: "NASDAQ:LRMR",
      companyName: "Larimar Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lrn",
      code: "NASDAQ:LRN",
      companyName: "Stride Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lsbk",
      code: "NASDAQ:LSBK",
      companyName: "Lake Shore Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lscc",
      code: "NASDAQ:LSCC",
      companyName: "Lattice Semiconductor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lsea",
      code: "NASDAQ:LSEA",
      companyName: "Landsea Homes Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lseaw",
      code: "NASDAQ:LSEAW",
      companyName: "Landsea Homes Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lsf",
      code: "NASDAQ:LSF",
      companyName: "Laird Superfood Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lsi",
      code: "NASDAQ:LSI",
      companyName: "Life Storage Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lspd",
      code: "NASDAQ:LSPD",
      companyName: "Lightspeed Commerce Inc. Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lspr",
      code: "NASDAQ:LSPR",
      companyName: "Larkspur Health Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lstr",
      code: "NASDAQ:LSTR",
      companyName: "Landstar System Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lsxma",
      code: "NASDAQ:LSXMA",
      companyName:
        "Liberty Media Corporation Series A Liberty SiriusXM Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lsxmb",
      code: "NASDAQ:LSXMB",
      companyName:
        "Liberty Media Corporation Series B Liberty SiriusXM Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lsxmk",
      code: "NASDAQ:LSXMK",
      companyName:
        "Liberty Media Corporation Series C Liberty SiriusXM Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltbr",
      code: "NASDAQ:LTBR",
      companyName: "Lightbridge Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltc",
      code: "NASDAQ:LTC",
      companyName: "LTC Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltch",
      code: "NASDAQ:LTCH",
      companyName: "Latch Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltchw",
      code: "NASDAQ:LTCHW",
      companyName: "Latch Inc. Warrant expiring 6/4/2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-lth",
      code: "NASDAQ:LTH",
      companyName: "Life Time Group Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lpx",
      code: "NASDAQ:LPX",
      companyName: "Louisiana-Pacific Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltrn",
      code: "NASDAQ:LTRN",
      companyName: "Lantern Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltrpa",
      code: "NASDAQ:LTRPA",
      companyName: "Liberty TripAdvisor Holdings Inc. Series A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltrpb",
      code: "NASDAQ:LTRPB",
      companyName: "Liberty TripAdvisor Holdings Inc. Series B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltrx",
      code: "NASDAQ:LTRX",
      companyName: "Lantronix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltry",
      code: "NASDAQ:LTRY",
      companyName: "Lottery.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ltryw",
      code: "NASDAQ:LTRYW",
      companyName: "Lottery.com Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lucd",
      code: "NASDAQ:LUCD",
      companyName: "Lucid Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lumn",
      code: "NASDAQ:LUMN",
      companyName: "Lumen Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lumo",
      code: "NASDAQ:LUMO",
      companyName: "Lumos Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-luna",
      code: "NASDAQ:LUNA",
      companyName: "Luna Innovations Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lung",
      code: "NASDAQ:LUNG",
      companyName: "Pulmonx Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-luv",
      code: "NASDAQ:LUV",
      companyName: "Southwest Airlines Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-luxa",
      code: "NASDAQ:LUXA",
      companyName: "Lux Health Tech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-luxau",
      code: "NASDAQ:LUXAU",
      companyName: "Lux Health Tech Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-luxaw",
      code: "NASDAQ:LUXAW",
      companyName: "Lux Health Tech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvac",
      code: "NASDAQ:LVAC",
      companyName: "LAVA Medtech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvacu",
      code: "NASDAQ:LVACU",
      companyName: "LAVA Medtech Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvacw",
      code: "NASDAQ:LVACW",
      companyName: "LAVA Medtech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvlu",
      code: "NASDAQ:LVLU",
      companyName: "Lulu's Fashion Lounge Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvo",
      code: "NASDAQ:LVO",
      companyName: "LiveOne Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvox",
      code: "NASDAQ:LVOX",
      companyName: "LiveVox Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvoxu",
      code: "NASDAQ:LVOXU",
      companyName: "LiveVox Holdings Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvoxw",
      code: "NASDAQ:LVOXW",
      companyName: "LiveVox Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvra",
      code: "NASDAQ:LVRA",
      companyName: "Levere Holdings Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvraw",
      code: "NASDAQ:LVRAW",
      companyName: "Levere Holdings Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvs",
      code: "NASDAQ:LVS",
      companyName: "Las Vegas Sands Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lvtx",
      code: "NASDAQ:LVTX",
      companyName: "LAVA Therapeutics N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lw",
      code: "NASDAQ:LW",
      companyName: "Lamb Weston Holdings Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-lway",
      code: "NASDAQ:LWAY",
      companyName: "Lifeway Foods Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lwlg",
      code: "NASDAQ:LWLG",
      companyName: "Lightwave Logic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lx",
      code: "NASDAQ:LX",
      companyName: "LexinFintech Holdings Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lxeh",
      code: "NASDAQ:LXEH",
      companyName:
        "Lixiang Education Holding Co. Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lxfr",
      code: "NASDAQ:LXFR",
      companyName: "Luxfer Holdings PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lxp",
      code: "NASDAQ:LXP",
      companyName: "LXP Industrial Trust Common Stock (Maryland REIT)",
      popularity: 0,
    },
    {
      slug: "nasdaq-lxp-c",
      code: "NASDAQ:LXP-C",
      companyName:
        "LXP Industrial Trust 6.5% Series C Cumulative Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lxrx",
      code: "NASDAQ:LXRX",
      companyName: "Lexicon Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lxu",
      code: "NASDAQ:LXU",
      companyName: "LSB Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lyb",
      code: "NASDAQ:LYB",
      companyName:
        "LyondellBasell Industries NV Ordinary Shares Class A (Netherlands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-lyel",
      code: "NASDAQ:LYEL",
      companyName: "Lyell Immunopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lyg",
      code: "NASDAQ:LYG",
      companyName: "Lloyds Banking Group Plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lyl",
      code: "NASDAQ:LYL",
      companyName: "Dragon Victory International Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lylt",
      code: "NASDAQ:LYLT",
      companyName: "Loyalty Ventures Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lyra",
      code: "NASDAQ:LYRA",
      companyName: "Lyra Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lyts",
      code: "NASDAQ:LYTS",
      companyName: "LSI Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lyv",
      code: "NASDAQ:LYV",
      companyName: "Live Nation Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lz",
      code: "NASDAQ:LZ",
      companyName: "LegalZoom.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lzb",
      code: "NASDAQ:LZB",
      companyName: "La-Z-Boy Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-m",
      code: "NASDAQ:M",
      companyName: "Macy's Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-maa",
      code: "NASDAQ:MAA",
      companyName: "Mid-America Apartment Communities Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-maa-i",
      code: "NASDAQ:MAA-I",
      companyName:
        "Mid-America Apartment Communities Inc. 8.50% Series I Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-maaq",
      code: "NASDAQ:MAAQ",
      companyName: "Mana Capital Acquisition Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-maaqr",
      code: "NASDAQ:MAAQR",
      companyName: "Mana Capital Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-maaqu",
      code: "NASDAQ:MAAQU",
      companyName: "Mana Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-maaqw",
      code: "NASDAQ:MAAQW",
      companyName: "Mana Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mac",
      code: "NASDAQ:MAC",
      companyName: "Macerich Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-maca",
      code: "NASDAQ:MACA",
      companyName: "Moringa Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-macau",
      code: "NASDAQ:MACAU",
      companyName: "Moringa Acquisition Corp Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-macaw",
      code: "NASDAQ:MACAW",
      companyName: "Moringa Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-macc",
      code: "NASDAQ:MACC",
      companyName: "Mission Advancement Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mack",
      code: "NASDAQ:MACK",
      companyName: "Merrimack Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mag",
      code: "NASDAQ:MAG",
      companyName: "MAG Silver Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-manh",
      code: "NASDAQ:MANH",
      companyName: "Manhattan Associates Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mant",
      code: "NASDAQ:MANT",
      companyName:
        "ManTech International Corporation Common Stock $0.01 Par Value",
      popularity: 0,
    },
    {
      slug: "nasdaq-manu",
      code: "NASDAQ:MANU",
      companyName: "Manchester United Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-maps",
      code: "NASDAQ:MAPS",
      companyName: "WM Technology Inc. Class A Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-mapsw",
      code: "NASDAQ:MAPSW",
      companyName: "WM Technology Inc. Warrants ",
      popularity: 0,
    },
    {
      slug: "nasdaq-maqc",
      code: "NASDAQ:MAQC",
      companyName:
        "Maquia Capital Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-maqcu",
      code: "NASDAQ:MAQCU",
      companyName: "Maquia Capital Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-maqcw",
      code: "NASDAQ:MAQCW",
      companyName: "Maquia Capital Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mar",
      code: "NASDAQ:MAR",
      companyName: "Marriott International Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mat",
      code: "NASDAQ:MAT",
      companyName: "Mattel Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mark",
      code: "NASDAQ:MARK",
      companyName: "Remark Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-marps",
      code: "NASDAQ:MARPS",
      companyName: "Marine Petroleum Trust Units of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-mas",
      code: "NASDAQ:MAS",
      companyName: "Masco Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mass",
      code: "NASDAQ:MASS",
      companyName: "908 Devices Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-matw",
      code: "NASDAQ:MATW",
      companyName: "Matthews International Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-matx",
      code: "NASDAQ:MATX",
      companyName: "Matson Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mav",
      code: "NASDAQ:MAV",
      companyName: "Pioneer Municipal High Income Advantage Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-max",
      code: "NASDAQ:MAX",
      companyName: "MediaAlpha Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-maxn",
      code: "NASDAQ:MAXN",
      companyName: "Maxeon Solar Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-maxr",
      code: "NASDAQ:MAXR",
      companyName: "Maxar Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-mays",
      code: "NASDAQ:MAYS",
      companyName: "J. W. Mays Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbac",
      code: "NASDAQ:MBAC",
      companyName: "M3-Brigade Acquisition II Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbcn",
      code: "NASDAQ:MBCN",
      companyName: "Middlefield Banc Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbi",
      code: "NASDAQ:MBI",
      companyName: "MBIA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbii",
      code: "NASDAQ:MBII",
      companyName: "Marrone Bio Innovations Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbin",
      code: "NASDAQ:MBIN",
      companyName: "Merchants Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbinn",
      code: "NASDAQ:MBINN",
      companyName: "Merchants Bancorp Depositary Shares Preferred Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-mq",
      code: "NASDAQ:MQ",
      companyName: "Marqeta Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbino",
      code: "NASDAQ:MBINO",
      companyName:
        "Merchants Bancorp Depositary Shares Each Representing a 1/40th Interest in a Share of Series B  Fixed-to-Floating Rate",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbinp",
      code: "NASDAQ:MBINP",
      companyName:
        "Merchants Bancorp 7.00% Fixed-to-Floating Rate Series A Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbio",
      code: "NASDAQ:MBIO",
      companyName: "Mustang Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbnkp",
      code: "NASDAQ:MBNKP",
      companyName:
        "Medallion Bank Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbot",
      code: "NASDAQ:MBOT",
      companyName: "Microbot Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbrx",
      code: "NASDAQ:MBRX",
      companyName: "Moleculin Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbsc",
      code: "NASDAQ:MBSC",
      companyName: "M3-Brigade Acquisition III Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbtc",
      code: "NASDAQ:MBTC",
      companyName: "Nocturne Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbtcr",
      code: "NASDAQ:MBTCR",
      companyName: "Nocturne Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbtcu",
      code: "NASDAQ:MBTCU",
      companyName: "Nocturne Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbuu",
      code: "NASDAQ:MBUU",
      companyName: "Malibu Boats Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mbwm",
      code: "NASDAQ:MBWM",
      companyName: "Mercantile Bank Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mc",
      code: "NASDAQ:MC",
      companyName: "Moelis & Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcaa",
      code: "NASDAQ:MCAA",
      companyName: "Mountain & Co. I Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcaaw",
      code: "NASDAQ:MCAAW",
      companyName: "Mountain & Co. I Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcaer",
      code: "NASDAQ:MCAER",
      companyName: "Mountain Crest Acquisition Corp. III Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcaf",
      code: "NASDAQ:MCAF",
      companyName: "Mountain Crest Acquisition Corp. IV Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcafr",
      code: "NASDAQ:MCAFR",
      companyName: "Mountain Crest Acquisition Corp. IV Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcafu",
      code: "NASDAQ:MCAFU",
      companyName: "Mountain Crest Acquisition Corp. IV Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcag",
      code: "NASDAQ:MCAG",
      companyName: "Mountain Crest Acquisition Corp. V Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcagu",
      code: "NASDAQ:MCAGU",
      companyName: "Mountain Crest Acquisition Corp. V Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcb",
      code: "NASDAQ:MCB",
      companyName: "Metropolitan Bank Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcbc",
      code: "NASDAQ:MCBC",
      companyName: "Macatawa Bank Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcbs",
      code: "NASDAQ:MCBS",
      companyName: "MetroCity Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcft",
      code: "NASDAQ:MCFT",
      companyName: "MasterCraft Boat Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcg",
      code: "NASDAQ:MCG",
      companyName: "Membership Collective Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdt",
      code: "NASDAQ:MDT",
      companyName: "Medtronic plc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcldw",
      code: "NASDAQ:MCLDW",
      companyName: "mCloud Technologies Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcn",
      code: "NASDAQ:MCN",
      companyName: "Madison Covered Call & Equity Strategy Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mco",
      code: "NASDAQ:MCO",
      companyName: "Moody's Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcr",
      code: "NASDAQ:MCR",
      companyName: "MFS Charter Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcrb",
      code: "NASDAQ:MCRB",
      companyName: "Seres Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcri",
      code: "NASDAQ:MCRI",
      companyName: "Monarch Casino & Resort Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcs",
      code: "NASDAQ:MCS",
      companyName: "Marcus Corporation (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcw",
      code: "NASDAQ:MCW",
      companyName: "Mister Car Wash Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcy",
      code: "NASDAQ:MCY",
      companyName: "Mercury General Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-md",
      code: "NASDAQ:MD",
      companyName: "Mednax Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdc",
      code: "NASDAQ:MDC",
      companyName: "M.D.C. Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdgl",
      code: "NASDAQ:MDGL",
      companyName: "Madrigal Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdgs",
      code: "NASDAQ:MDGS",
      companyName: "Medigus Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdh",
      code: "NASDAQ:MDH",
      companyName: "MDH Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdia",
      code: "NASDAQ:MDIA",
      companyName: "Mediaco Holding Inc. Class A Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdjh",
      code: "NASDAQ:MDJH",
      companyName: "MDJM LTD Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdlz",
      code: "NASDAQ:MDLZ",
      companyName: "Mondelez International Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdna",
      code: "NASDAQ:MDNA",
      companyName: "Medicenna Therapeutics Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdrr",
      code: "NASDAQ:MDRR",
      companyName: "Medalist Diversified REIT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdrrp",
      code: "NASDAQ:MDRRP",
      companyName:
        "Medalist Diversified REIT Inc. Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdrx",
      code: "NASDAQ:MDRX",
      companyName: "Allscripts Healthcare Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdu",
      code: "NASDAQ:MDU",
      companyName: "MDU Resources Group Inc. Common Stock (Holding Company)",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdv",
      code: "NASDAQ:MDV",
      companyName: "Modiv Inc. Class C Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdv-a",
      code: "NASDAQ:MDV-A",
      companyName:
        "Modiv Inc. 7.375% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdvl",
      code: "NASDAQ:MDVL",
      companyName: "MedAvail Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdwd",
      code: "NASDAQ:MDWD",
      companyName: "MediWound Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdwt",
      code: "NASDAQ:MDWT",
      companyName: "Midwest Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdxg",
      code: "NASDAQ:MDXG",
      companyName: "MiMedx Group Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mdxh",
      code: "NASDAQ:MDXH",
      companyName: "MDxHealth SA American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-me",
      code: "NASDAQ:ME",
      companyName: "23andMe Holding Co. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meac",
      code: "NASDAQ:MEAC",
      companyName: "Mercury Ecommerce Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meacw",
      code: "NASDAQ:MEACW",
      companyName: "Mercury Ecommerce Acquisition Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-mec",
      code: "NASDAQ:MEC",
      companyName: "Mayville Engineering Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-med",
      code: "NASDAQ:MED",
      companyName: "MEDIFAST INC Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-medp",
      code: "NASDAQ:MEDP",
      companyName: "Medpace Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meds",
      code: "NASDAQ:MEDS",
      companyName: "TRxADE HEALTH Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meg",
      code: "NASDAQ:MEG",
      companyName: "Montrose Environmental Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-megi",
      code: "NASDAQ:MEGI",
      companyName:
        "MainStay CBRE Global Infrastructure Megatrends Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mei",
      code: "NASDAQ:MEI",
      companyName: "Methode Electronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meip",
      code: "NASDAQ:MEIP",
      companyName: "MEI Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meka",
      code: "NASDAQ:MEKA",
      companyName: "MELI Kaszek Pioneer Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgu",
      code: "NASDAQ:MGU",
      companyName:
        "Macquarie Global Infrastructure Total Return Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meoa",
      code: "NASDAQ:MEOA",
      companyName:
        "Minority Equality Opportunities Acquisition Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meoau",
      code: "NASDAQ:MEOAU",
      companyName: "Minority Equality Opportunities Acquisition Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-meoaw",
      code: "NASDAQ:MEOAW",
      companyName: "Minority Equality Opportunities Acquisition Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-meoh",
      code: "NASDAQ:MEOH",
      companyName: "Methanex Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mer-k",
      code: "NASDAQ:MER-K",
      companyName:
        "Bank of America Corporation Income Capital Obligation Notes initially due December 15 2066",
      popularity: 0,
    },
    {
      slug: "nasdaq-merc",
      code: "NASDAQ:MERC",
      companyName: "Mercer International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mesa",
      code: "NASDAQ:MESA",
      companyName: "Mesa Air Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-meso",
      code: "NASDAQ:MESO",
      companyName: "Mesoblast Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-met-e",
      code: "NASDAQ:MET-E",
      companyName:
        "MetLife Inc. Depositary shares each representing a 1/1000th interest in a share of the Issuera??s 5.625% Non-Cumulative Preferred Stock Series E.",
      popularity: 0,
    },
    {
      slug: "nasdaq-met-f",
      code: "NASDAQ:MET-F",
      companyName:
        "MetLife Inc. Depositary Shares each representing a 1/1000th interest in a share of 4.75% Non-Cumulative Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nasdaq-metc",
      code: "NASDAQ:METC",
      companyName: "Ramaco Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-metcl",
      code: "NASDAQ:METCL",
      companyName: "Ramaco Resources Inc. 9.00% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-metx",
      code: "NASDAQ:METX",
      companyName: "Meten Holding Group Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-metxw",
      code: "NASDAQ:METXW",
      companyName: "Meten Holding Group Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mf",
      code: "NASDAQ:MF",
      companyName: "Missfresh Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfa-b",
      code: "NASDAQ:MFA-B",
      companyName: "MFA Financial Inc. Preferred Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfa-c",
      code: "NASDAQ:MFA-C",
      companyName:
        "MFA Financial Inc. 6.50% Series C Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfc",
      code: "NASDAQ:MFC",
      companyName: "Manulife Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfg",
      code: "NASDAQ:MFG",
      companyName: "Mizuho Financial Group Inc. Sponosred ADR (Japan)",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfgp",
      code: "NASDAQ:MFGP",
      companyName: "Micro Focus Intl PLC ADS each representing One Ord Sh",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfh",
      code: "NASDAQ:MFH",
      companyName: "Mercurity Fintech Holding Inc. ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfin",
      code: "NASDAQ:MFIN",
      companyName: "Medallion Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfm",
      code: "NASDAQ:MFM",
      companyName: "MFS Municipal Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfv",
      code: "NASDAQ:MFV",
      companyName: "MFS Special Value Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mg",
      code: "NASDAQ:MG",
      companyName: "Mistras Group Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mga",
      code: "NASDAQ:MGA",
      companyName: "Magna International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgee",
      code: "NASDAQ:MGEE",
      companyName: "MGE Energy Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgf",
      code: "NASDAQ:MGF",
      companyName: "MFS Government Markets Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgi",
      code: "NASDAQ:MGI",
      companyName: "Moneygram International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgic",
      code: "NASDAQ:MGIC",
      companyName: "Magic Software Enterprises Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgld",
      code: "NASDAQ:MGLD",
      companyName: "The Marygold Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgm",
      code: "NASDAQ:MGM",
      companyName: "MGM Resorts International Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgni",
      code: "NASDAQ:MGNI",
      companyName: "Magnite Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgnx",
      code: "NASDAQ:MGNX",
      companyName: "MacroGenics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgpi",
      code: "NASDAQ:MGPI",
      companyName: "MGP Ingredients Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgr",
      code: "NASDAQ:MGR",
      companyName:
        "Affiliated Managers Group Inc. 5.875% Junior Subordinated Notes due 2059",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgrb",
      code: "NASDAQ:MGRB",
      companyName:
        "Affiliated Managers Group Inc. 4.750% Junior Subordinated Notes due 2060",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgrc",
      code: "NASDAQ:MGRC",
      companyName: "McGrath RentCorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgrd",
      code: "NASDAQ:MGRD",
      companyName:
        "Affiliated Managers Group Inc. 4.200% Junior Subordinated Notes due 2061",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgtx",
      code: "NASDAQ:MGTX",
      companyName: "MeiraGTx Holdings plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgy",
      code: "NASDAQ:MGY",
      companyName: "Magnolia Oil & Gas Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mgyr",
      code: "NASDAQ:MGYR",
      companyName: "Magyar Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfd",
      code: "NASDAQ:MFD",
      companyName: "Macquarie First Trust Global Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mh-a",
      code: "NASDAQ:MH-A",
      companyName: "Maiden Holdings Ltd. Pref Shs Ser A (Bermuda)",
      popularity: 0,
    },
    {
      slug: "nasdaq-mh-c",
      code: "NASDAQ:MH-C",
      companyName:
        "Maiden Holdings North America Ltd. 7.125% Non-Cumulative Preference Shares Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-mh-d",
      code: "NASDAQ:MH-D",
      companyName:
        "Maiden Holdings Ltd. 6.700% Non-Cumulative Preference Shares Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhd",
      code: "NASDAQ:MHD",
      companyName: "Blackrock MuniHoldings Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhf",
      code: "NASDAQ:MHF",
      companyName: "Western Asset Municipal High Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhh",
      code: "NASDAQ:MHH",
      companyName: "Mastech Digital Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhi",
      code: "NASDAQ:MHI",
      companyName: "Pioneer Municipal High Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhk",
      code: "NASDAQ:MHK",
      companyName: "Mohawk Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhla",
      code: "NASDAQ:MHLA",
      companyName: "Maiden Holdings Ltd. 6.625% Notes due 2046",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhld",
      code: "NASDAQ:MHLD",
      companyName: "Maiden Holdings Ltd.",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhn",
      code: "NASDAQ:MHN",
      companyName:
        "Blackrock MuniHoldings New York Quality Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhnc",
      code: "NASDAQ:MHNC",
      companyName: "Maiden Holdings North America Ltd. 7.75% Notes due 2043",
      popularity: 0,
    },
    {
      slug: "nasdaq-mho",
      code: "NASDAQ:MHO",
      companyName: "M/I Homes Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mhua",
      code: "NASDAQ:MHUA",
      companyName:
        "Meihua International Medical Technologies Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mict",
      code: "NASDAQ:MICT",
      companyName: "MICT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-milew",
      code: "NASDAQ:MILEW",
      companyName: "Metromile Inc. Warrant ",
      popularity: 0,
    },
    {
      slug: "nasdaq-mime",
      code: "NASDAQ:MIME",
      companyName: "Mimecast Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mimo",
      code: "NASDAQ:MIMO",
      companyName: "Airspan Networks Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-min",
      code: "NASDAQ:MIN",
      companyName: "MFS Intermediate Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mind",
      code: "NASDAQ:MIND",
      companyName: "MIND Technology Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-mindp",
      code: "NASDAQ:MINDP",
      companyName:
        "MIND Technology Inc. Series A 9.00% Series A Cumulative Preferred Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-minm",
      code: "NASDAQ:MINM",
      companyName: "Minim Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mio",
      code: "NASDAQ:MIO",
      companyName:
        "Pioneer Municipal High Income Opportunities Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mir",
      code: "NASDAQ:MIR",
      companyName: "Mirion Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mirm",
      code: "NASDAQ:MIRM",
      companyName: "Mirum Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-miro",
      code: "NASDAQ:MIRO",
      companyName: "Miromatrix Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mit",
      code: "NASDAQ:MIT",
      companyName: "Mason Industrial Technology Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mita",
      code: "NASDAQ:MITA",
      companyName: "Coliseum Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-mitau",
      code: "NASDAQ:MITAU",
      companyName: "Coliseum Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mitaw",
      code: "NASDAQ:MITAW",
      companyName: "Coliseum Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mitc",
      code: "NASDAQ:MITC",
      companyName: "MeaTech 3D Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mitk",
      code: "NASDAQ:MITK",
      companyName: "Mitek Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mito",
      code: "NASDAQ:MITO",
      companyName: "Stealth BioTherapeutics Corp. ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-mitq",
      code: "NASDAQ:MITQ",
      companyName: "Moving iMage Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mitt",
      code: "NASDAQ:MITT",
      companyName: "AG Mortgage Investment Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mitt-a",
      code: "NASDAQ:MITT-A",
      companyName: "AG Mortgage Investment Trust Inc. 8.25% Preferred Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-mitt-b",
      code: "NASDAQ:MITT-B",
      companyName: "AG Mortgage Investment Trust Inc. Preferred Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-mitt-c",
      code: "NASDAQ:MITT-C",
      companyName:
        "AG Mortgage Investment Trust Inc. 8.00% Series C Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-mixt",
      code: "NASDAQ:MIXT",
      companyName:
        "MiX Telematics Limited American Depositary Shares each representing 25 Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-miy",
      code: "NASDAQ:MIY",
      companyName:
        "Blackrock MuniYield Michigan Quality Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mkc",
      code: "NASDAQ:MKC",
      companyName: "McCormick & Company Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mkd",
      code: "NASDAQ:MKD",
      companyName: "Molecular Data Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mkfg",
      code: "NASDAQ:MKFG",
      companyName: "Markforged Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mkl",
      code: "NASDAQ:MKL",
      companyName: "Markel Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mksi",
      code: "NASDAQ:MKSI",
      companyName: "MKS Instruments Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mktw",
      code: "NASDAQ:MKTW",
      companyName: "MarketWise Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mktww",
      code: "NASDAQ:MKTWW",
      companyName: "MarketWise Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ml",
      code: "NASDAQ:ML",
      companyName: "MoneyLion Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlab",
      code: "NASDAQ:MLAB",
      companyName: "Mesa Laboratories Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlac",
      code: "NASDAQ:MLAC",
      companyName:
        "Malacca Straits Acquisition Company Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlacw",
      code: "NASDAQ:MLACW",
      companyName: "Malacca Straits Acquisition Company Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlai",
      code: "NASDAQ:MLAI",
      companyName: "McLaren Technology Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlaiu",
      code: "NASDAQ:MLAIU",
      companyName: "McLaren Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlco",
      code: "NASDAQ:MLCO",
      companyName:
        "Melco Resorts & Entertainment Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mic",
      code: "NASDAQ:MIC",
      companyName: "Macquarie Infrastructure Holdings LLC Common Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mli",
      code: "NASDAQ:MLI",
      companyName: "Mueller Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlkn",
      code: "NASDAQ:MLKN",
      companyName: "MillerKnoll Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlm",
      code: "NASDAQ:MLM",
      companyName: "Martin Marietta Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlnk",
      code: "NASDAQ:MLNK",
      companyName: "MeridianLink Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlp",
      code: "NASDAQ:MLP",
      companyName: "Maui Land & Pineapple Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlr",
      code: "NASDAQ:MLR",
      companyName: "Miller Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlss",
      code: "NASDAQ:MLSS",
      companyName: "Milestone Scientific Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mltx",
      code: "NASDAQ:MLTX",
      companyName: "MoonLake Immunotherapeutics Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mlvf",
      code: "NASDAQ:MLVF",
      companyName: "Malvern Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmat",
      code: "NASDAQ:MMAT",
      companyName: "Meta Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmd",
      code: "NASDAQ:MMD",
      companyName: "MainStay MacKay DefinedTerm Municipal Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmi",
      code: "NASDAQ:MMI",
      companyName: "Marcus & Millichap Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmlp",
      code: "NASDAQ:MMLP",
      companyName: "Martin Midstream Partners L.P. Limited Partnership",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmp",
      code: "NASDAQ:MMP",
      companyName: "Magellan Midstream Partners L.P. Limited Partnership",
      popularity: 0,
    },
    {
      slug: "nasdaq-mms",
      code: "NASDAQ:MMS",
      companyName: "Maximus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmsi",
      code: "NASDAQ:MMSI",
      companyName: "Merit Medical Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmt",
      code: "NASDAQ:MMT",
      companyName: "MFS Multimarket Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmu",
      code: "NASDAQ:MMU",
      companyName: "Western Asset Managed Municipals Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmx",
      code: "NASDAQ:MMX",
      companyName: "Maverix Metals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmyt",
      code: "NASDAQ:MMYT",
      companyName: "MakeMyTrip Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mn",
      code: "NASDAQ:MN",
      companyName: "Manning & Napier Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mndo",
      code: "NASDAQ:MNDO",
      companyName: "MIND C.T.I. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mndt",
      code: "NASDAQ:MNDT",
      companyName: "Mandiant Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnkd",
      code: "NASDAQ:MNKD",
      companyName: "MannKind Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnmd",
      code: "NASDAQ:MNMD",
      companyName: "Mind Medicine (MindMed) Inc. Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnov",
      code: "NASDAQ:MNOV",
      companyName: "Medicinova Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnp",
      code: "NASDAQ:MNP",
      companyName: "Western Asset Municipal Partners Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnpr",
      code: "NASDAQ:MNPR",
      companyName: "Monopar Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnrl",
      code: "NASDAQ:MNRL",
      companyName: "Brigham Minerals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnro",
      code: "NASDAQ:MNRO",
      companyName: "Monro Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnsb",
      code: "NASDAQ:MNSB",
      companyName: "MainStreet Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnsbp",
      code: "NASDAQ:MNSBP",
      companyName: "MainStreet Bancshares Inc. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnso",
      code: "NASDAQ:MNSO",
      companyName:
        "MINISO Group Holding Limited American Depositary Shares each representing four Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnst",
      code: "NASDAQ:MNST",
      companyName: "Monster Beverage Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-mntk",
      code: "NASDAQ:MNTK",
      companyName: "Montauk Renewables Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mntn",
      code: "NASDAQ:MNTN",
      companyName:
        "Everest Consolidator Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mnts",
      code: "NASDAQ:MNTS",
      companyName: "Momentus Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mntsw",
      code: "NASDAQ:MNTSW",
      companyName: "Momentus Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mntv",
      code: "NASDAQ:MNTV",
      companyName: "Momentive Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mntx",
      code: "NASDAQ:MNTX",
      companyName: "Manitex International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mo",
      code: "NASDAQ:MO",
      companyName: "Altria Group Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-mobq",
      code: "NASDAQ:MOBQ",
      companyName: "Mobiquity Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mobqw",
      code: "NASDAQ:MOBQW",
      companyName: "Mobiquity Technologies Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mod",
      code: "NASDAQ:MOD",
      companyName: "Modine Manufacturing Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-modd",
      code: "NASDAQ:MODD",
      companyName: "Modular Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-modn",
      code: "NASDAQ:MODN",
      companyName: "Model N Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-modv",
      code: "NASDAQ:MODV",
      companyName: "ModivCare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mofg",
      code: "NASDAQ:MOFG",
      companyName: "MidWestOne Financial Gp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mogo",
      code: "NASDAQ:MOGO",
      companyName: "Mogo Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mogu",
      code: "NASDAQ:MOGU",
      companyName:
        "MOGU Inc. American Depositary Shares (each  representing 25 Class A Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-moh",
      code: "NASDAQ:MOH",
      companyName: "Molina Healthcare Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-moho",
      code: "NASDAQ:MOHO",
      companyName: "ECMOHO Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-moln",
      code: "NASDAQ:MOLN",
      companyName: "Molecular Partners AG American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-momo",
      code: "NASDAQ:MOMO",
      companyName: "Hello Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mon",
      code: "NASDAQ:MON",
      companyName: "Monument Circle Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-moncu",
      code: "NASDAQ:MONCU",
      companyName: "Monument Circle Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-moncw",
      code: "NASDAQ:MONCW",
      companyName: "Monument Circle Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mor",
      code: "NASDAQ:MOR",
      companyName: "MorphoSys AG American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-morn",
      code: "NASDAQ:MORN",
      companyName: "Morningstar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mos",
      code: "NASDAQ:MOS",
      companyName: "Mosaic Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mots",
      code: "NASDAQ:MOTS",
      companyName: "Motus GI Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mov",
      code: "NASDAQ:MOV",
      companyName: "Movado Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-move",
      code: "NASDAQ:MOVE",
      companyName: "Movano Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-moxc",
      code: "NASDAQ:MOXC",
      companyName: "Moxian (BVI) Inc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpa",
      code: "NASDAQ:MPA",
      companyName: "Blackrock MuniYield Pennsylvania Quality Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpaa",
      code: "NASDAQ:MPAA",
      companyName: "Motorcar Parts  of America Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpac",
      code: "NASDAQ:MPAC",
      companyName: "Model Performance Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpacr",
      code: "NASDAQ:MPACR",
      companyName: "Model Performance Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpacu",
      code: "NASDAQ:MPACU",
      companyName: "Model Performance Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpb",
      code: "NASDAQ:MPB",
      companyName: "Mid Penn Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpc",
      code: "NASDAQ:MPC",
      companyName: "Marathon Petroleum Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpw",
      code: "NASDAQ:MPW",
      companyName: "Medical Properties Trust Inc. common stock",
      popularity: 0,
    },
    {
      slug: "asx-ozl",
      code: "ASX:OZL",
      companyName: "OZ MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpx",
      code: "NASDAQ:MPX",
      companyName: "Marine Products Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mqt",
      code: "NASDAQ:MQT",
      companyName: "Blackrock MuniYield Quality Fund II Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mqy",
      code: "NASDAQ:MQY",
      companyName: "Blackrock MuniYield Quality Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrai",
      code: "NASDAQ:MRAI",
      companyName: "Marpai Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mram",
      code: "NASDAQ:MRAM",
      companyName: "Everspin Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrbk",
      code: "NASDAQ:MRBK",
      companyName: "Meridian Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrc",
      code: "NASDAQ:MRC",
      companyName: "MRC Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrcc",
      code: "NASDAQ:MRCC",
      companyName: "Monroe Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrcy",
      code: "NASDAQ:MRCY",
      companyName: "Mercury Systems Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mreo",
      code: "NASDAQ:MREO",
      companyName: "Mereo BioPharma Group plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrin",
      code: "NASDAQ:MRIN",
      companyName: "Marin Software Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrkr",
      code: "NASDAQ:MRKR",
      companyName: "Marker Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrm",
      code: "NASDAQ:MRM",
      companyName:
        "MEDIROM Healthcare Technologies Inc. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrns",
      code: "NASDAQ:MRNS",
      companyName: "Marinus Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mro",
      code: "NASDAQ:MRO",
      companyName: "Marathon Oil Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrsn",
      code: "NASDAQ:MRSN",
      companyName: "Mersana Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrtn",
      code: "NASDAQ:MRTN",
      companyName: "Marten Transport Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrtx",
      code: "NASDAQ:MRTX",
      companyName: "Mirati Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrus",
      code: "NASDAQ:MRUS",
      companyName: "Merus N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrvi",
      code: "NASDAQ:MRVI",
      companyName: "Maravai LifeSciences Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ms-a",
      code: "NASDAQ:MS-A",
      companyName: "Morgan Stanley Dep Shs repstg 1/1000 Pfd Ser A",
      popularity: 0,
    },
    {
      slug: "nasdaq-ms-e",
      code: "NASDAQ:MS-E",
      companyName:
        "Morgan Stanley DEPOSITARY SHARES REP 1/1000TH SHARES FIXED/FLTG PREFERRED STOCK SERIES E",
      popularity: 0,
    },
    {
      slug: "nasdaq-ms-f",
      code: "NASDAQ:MS-F",
      companyName:
        "Morgan Stanley Dep Shs Rpstg 1/1000th Int Prd Ser F Fxd to Flag",
      popularity: 0,
    },
    {
      slug: "nasdaq-ms-i",
      code: "NASDAQ:MS-I",
      companyName:
        "Morgan Stanley Depository Shares Representing 1/1000th Preferred Series 1 Fixed to Floating Non (Cum)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ms-k",
      code: "NASDAQ:MS-K",
      companyName:
        "Morgan Stanley Depositary Shares each representing 1/1000th of a share of Fixed-to-Floating Rate Non-Cumulative Preferred Stock  Series K",
      popularity: 0,
    },
    {
      slug: "nasdaq-ms-l",
      code: "NASDAQ:MS-L",
      companyName:
        "Morgan Stanley Depositary Shares each representing 1/1000th of a share of 4.875% Non-Cumulative Preferred Stock Series L",
      popularity: 0,
    },
    {
      slug: "nasdaq-ms-o",
      code: "NASDAQ:MS-O",
      companyName:
        "Morgan Stanley Depositary Shares each representing 1/1000th of a share of 4.250% Non-Cumulative Preferred Stock Series O",
      popularity: 0,
    },
    {
      slug: "nasdaq-msa",
      code: "NASDAQ:MSA",
      companyName: "MSA Safety Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msac",
      code: "NASDAQ:MSAC",
      companyName: "Medicus Sciences Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-msb",
      code: "NASDAQ:MSB",
      companyName: "Mesabi Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msbi",
      code: "NASDAQ:MSBI",
      companyName: "Midland States Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msc",
      code: "NASDAQ:MSC",
      companyName:
        "Studio City International Holdings Limited American depositary shares each representing four  Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-msci",
      code: "NASDAQ:MSCI",
      companyName: "MSCI Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msd",
      code: "NASDAQ:MSD",
      companyName:
        "Morgan Stanley Emerging Markets Debt Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msda",
      code: "NASDAQ:MSDA",
      companyName: "MSD Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-msdau",
      code: "NASDAQ:MSDAU",
      companyName: "MSD Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-msdaw",
      code: "NASDAQ:MSDAW",
      companyName: "MSD Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-msex",
      code: "NASDAQ:MSEX",
      companyName: "Middlesex Water Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msge",
      code: "NASDAQ:MSGE",
      companyName:
        "Madison Square Garden Entertainment Corp. Class A Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-msgm",
      code: "NASDAQ:MSGM",
      companyName: "Motorsport Games Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msgs",
      code: "NASDAQ:MSGS",
      companyName:
        "Madison Square Garden Sports Corp. Class A Common Stock (New)",
      popularity: 0,
    },
    {
      slug: "nasdaq-msn",
      code: "NASDAQ:MSN",
      companyName: "Emerson Radio Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msp",
      code: "NASDAQ:MSP",
      companyName: "Datto Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mssau",
      code: "NASDAQ:MSSAU",
      companyName: "Metal Sky Star Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mufg",
      code: "NASDAQ:MUFG",
      companyName: "Mitsubishi UFJ Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msvb",
      code: "NASDAQ:MSVB",
      companyName: "Mid-Southern Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mt",
      code: "NASDAQ:MT",
      companyName: "Arcelor Mittal NY Registry Shares NEW",
      popularity: 0,
    },
    {
      slug: "nasdaq-mta",
      code: "NASDAQ:MTA",
      companyName: "Metalla Royalty & Streaming Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtac",
      code: "NASDAQ:MTAC",
      companyName: "MedTech Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtacu",
      code: "NASDAQ:MTACU",
      companyName: "MedTech Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtacw",
      code: "NASDAQ:MTACW",
      companyName: "MedTech Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtb",
      code: "NASDAQ:MTB",
      companyName: "M&T Bank Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtb-h",
      code: "NASDAQ:MTB-H",
      companyName:
        "M&T Bank Corporation Perpetual Fixed-to-Floating Rate Non-Cumulative Preferred Stock Series H",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtbc",
      code: "NASDAQ:MTBC",
      companyName: "CareCloud Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtbco",
      code: "NASDAQ:MTBCO",
      companyName:
        "CareCloud Inc. 8.75% Series B Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtbcp",
      code: "NASDAQ:MTBCP",
      companyName:
        "CareCloud Inc. 11% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtc",
      code: "NASDAQ:MTC",
      companyName: "MMTec Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtch",
      code: "NASDAQ:MTCH",
      companyName: "Match Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtcn",
      code: "NASDAQ:MTCN",
      companyName:
        "ArcelorMittal 5.50% Mandatorily Convertible Subordinated Notes due 2023",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtcr",
      code: "NASDAQ:MTCR",
      companyName: "Metacrine Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtd",
      code: "NASDAQ:MTD",
      companyName: "Mettler-Toledo International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtdr",
      code: "NASDAQ:MTDR",
      companyName: "Matador Resources Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtek",
      code: "NASDAQ:MTEK",
      companyName: "Maris-Tech Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtekw",
      code: "NASDAQ:MTEKW",
      companyName: "Maris-Tech Ltd. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtem",
      code: "NASDAQ:MTEM",
      companyName: "Molecular Templates Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtex",
      code: "NASDAQ:MTEX",
      companyName: "Mannatech Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtg",
      code: "NASDAQ:MTG",
      companyName: "MGIC Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mth",
      code: "NASDAQ:MTH",
      companyName: "Meritage Homes Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtls",
      code: "NASDAQ:MTLS",
      companyName: "Materialise NV American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtmt",
      code: "NASDAQ:MTMT",
      companyName: "Mega Matrix Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtn",
      code: "NASDAQ:MTN",
      companyName: "Vail Resorts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtnb",
      code: "NASDAQ:MTNB",
      companyName: "Matinas Biopharma Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtor",
      code: "NASDAQ:MTOR",
      companyName: "Meritor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtp",
      code: "NASDAQ:MTP",
      companyName: "Midatech Pharma PLC American Depositary Shs",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtr",
      code: "NASDAQ:MTR",
      companyName: "Mesa Royalty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtrn",
      code: "NASDAQ:MTRN",
      companyName: "Materion Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtrx",
      code: "NASDAQ:MTRX",
      companyName: "Matrix Service Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtry",
      code: "NASDAQ:MTRY",
      companyName: "Monterey Bio Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtryw",
      code: "NASDAQ:MTRYW",
      companyName: "Monterey Bio Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtsi",
      code: "NASDAQ:MTSI",
      companyName: "MACOM Technology Solutions Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mttr",
      code: "NASDAQ:MTTR",
      companyName: "Matterport Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtvc",
      code: "NASDAQ:MTVC",
      companyName: "Motive Capital Corp II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtw",
      code: "NASDAQ:MTW",
      companyName: "Manitowoc Company Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtx",
      code: "NASDAQ:MTX",
      companyName: "Minerals Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mtz",
      code: "NASDAQ:MTZ",
      companyName: "MasTec Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mua",
      code: "NASDAQ:MUA",
      companyName: "Blackrock MuniAssets Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-muc",
      code: "NASDAQ:MUC",
      companyName:
        "Blackrock MuniHoldings California Quality Fund Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-muds",
      code: "NASDAQ:MUDS",
      companyName:
        "Mudrick Capital Acquisition Corporation II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mudsu",
      code: "NASDAQ:MUDSU",
      companyName: "Mudrick Capital Acquisition Corporation II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mudsw",
      code: "NASDAQ:MUDSW",
      companyName: "Mudrick Capital Acquisition Corporation II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mue",
      code: "NASDAQ:MUE",
      companyName: "Blackrock MuniHoldings Quality Fund II Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mui",
      code: "NASDAQ:MUI",
      companyName: "BlackRock Municipal Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-muj",
      code: "NASDAQ:MUJ",
      companyName:
        "Blackrock MuniHoldings New Jersey Quality Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-muln",
      code: "NASDAQ:MULN",
      companyName: "Mullen Automotive Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mur",
      code: "NASDAQ:MUR",
      companyName: "Murphy Oil Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-murf",
      code: "NASDAQ:MURF",
      companyName: "Murphy Canyon Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-musa",
      code: "NASDAQ:MUSA",
      companyName: "Murphy USA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mux",
      code: "NASDAQ:MUX",
      companyName: "McEwen Mining Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mvbf",
      code: "NASDAQ:MVBF",
      companyName: "MVB Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mvf",
      code: "NASDAQ:MVF",
      companyName: "Blackrock MuniVest Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mvis",
      code: "NASDAQ:MVIS",
      companyName: "MicroVision Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mvo",
      code: "NASDAQ:MVO",
      companyName: "MV Oil Trust Units of Beneficial Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-mvst",
      code: "NASDAQ:MVST",
      companyName: "Microvast Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mvstw",
      code: "NASDAQ:MVSTW",
      companyName: "Microvast Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-mvt",
      code: "NASDAQ:MVT",
      companyName: "Blackrock MuniVest Fund II Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mwa",
      code: "NASDAQ:MWA",
      companyName: "MUELLER WATER PRODUCTS Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mx",
      code: "NASDAQ:MX",
      companyName: "Magnachip Semiconductor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mxc",
      code: "NASDAQ:MXC",
      companyName: "Mexco Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mxct",
      code: "NASDAQ:MXCT",
      companyName: "MaxCyte Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mxe",
      code: "NASDAQ:MXE",
      companyName: "Mexico Equity and Income Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mxf",
      code: "NASDAQ:MXF",
      companyName: "Mexico Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mxl",
      code: "NASDAQ:MXL",
      companyName: "MaxLinear Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-myd",
      code: "NASDAQ:MYD",
      companyName: "Blackrock MuniYield Fund Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mye",
      code: "NASDAQ:MYE",
      companyName: "Myers Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-myfw",
      code: "NASDAQ:MYFW",
      companyName: "First Western Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mygn",
      code: "NASDAQ:MYGN",
      companyName: "Myriad Genetics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-myi",
      code: "NASDAQ:MYI",
      companyName: "Blackrock MuniYield Quality Fund III Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mymd",
      code: "NASDAQ:MYMD",
      companyName: "MyMD Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-myn",
      code: "NASDAQ:MYN",
      companyName: "Blackrock MuniYield New York Quality Fund Inc.Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-myna",
      code: "NASDAQ:MYNA",
      companyName: "Mynaric AG American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mynz",
      code: "NASDAQ:MYNZ",
      companyName: "Mainz Biomed B.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-myo",
      code: "NASDAQ:MYO",
      companyName: "Myomo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-myov",
      code: "NASDAQ:MYOV",
      companyName: "Myovant Sciences Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-myrg",
      code: "NASDAQ:MYRG",
      companyName: "MYR Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mypsw",
      code: "NASDAQ:MYPSW",
      companyName: "PLAYSTUDIOS Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mysz",
      code: "NASDAQ:MYSZ",
      companyName: "My Size Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-myte",
      code: "NASDAQ:MYTE",
      companyName:
        "MYT Netherlands Parent B.V. American Depositary Shares each representing one Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-naac",
      code: "NASDAQ:NAAC",
      companyName:
        "North Atlantic Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-naacu",
      code: "NASDAQ:NAACU",
      companyName: "North Atlantic Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-naacw",
      code: "NASDAQ:NAACW",
      companyName: "North Atlantic Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nabl",
      code: "NASDAQ:NABL",
      companyName: "N-able Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nac",
      code: "NASDAQ:NAC",
      companyName: "Nuveen California Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-nad",
      code: "NASDAQ:NAD",
      companyName: "Nuveen Quality Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-naii",
      code: "NASDAQ:NAII",
      companyName: "Natural Alternatives International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nak",
      code: "NASDAQ:NAK",
      companyName: "Northern Dynasty Minerals Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nan",
      code: "NASDAQ:NAN",
      companyName: "Nuveen New York Quality Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-naov",
      code: "NASDAQ:NAOV",
      companyName: "NanoVibronix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-napa",
      code: "NASDAQ:NAPA",
      companyName: "The Duckhorn Portfolio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nat",
      code: "NASDAQ:NAT",
      companyName: "Nordic American Tankers Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nath",
      code: "NASDAQ:NATH",
      companyName: "Nathan's Famous Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nati",
      code: "NASDAQ:NATI",
      companyName: "National Instruments Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-natr",
      code: "NASDAQ:NATR",
      companyName: "Nature's Sunshine Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-naut",
      code: "NASDAQ:NAUT",
      companyName: "Nautilus Biotechnolgy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-navb",
      code: "NASDAQ:NAVB",
      companyName: "Navidea Biopharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-navi",
      code: "NASDAQ:NAVI",
      companyName: "Navient Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-naz",
      code: "NASDAQ:NAZ",
      companyName: "Nuveen Arizona Quality Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbb",
      code: "NASDAQ:NBB",
      companyName:
        "Nuveen Taxable Municipal Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbev",
      code: "NASDAQ:NBEV",
      companyName: "NewAge Inc. Common Stock (Delaware)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbh",
      code: "NASDAQ:NBH",
      companyName: "Neuberger Berman Municipal Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbhc",
      code: "NASDAQ:NBHC",
      companyName: "National Bank Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbn",
      code: "NASDAQ:NBN",
      companyName: "Northeast Bank Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbo",
      code: "NASDAQ:NBO",
      companyName: "Neuberger Berman New York Municipal Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbse",
      code: "NASDAQ:NBSE",
      companyName: "NeuBase Therapeutics Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbst",
      code: "NASDAQ:NBST",
      companyName: "Newbury Street Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbstu",
      code: "NASDAQ:NBSTU",
      companyName: "Newbury Street Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-nari",
      code: "NASDAQ:NARI",
      companyName: "Inari Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbix",
      code: "NASDAQ:NBIX",
      companyName: "Neurocrine Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbstw",
      code: "NASDAQ:NBSTW",
      companyName: "Newbury Street Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbtb",
      code: "NASDAQ:NBTB",
      companyName: "NBT Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbtx",
      code: "NASDAQ:NBTX",
      companyName: "Nanobiotix S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbw",
      code: "NASDAQ:NBW",
      companyName:
        "Neuberger Berman California Municipal Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbxg",
      code: "NASDAQ:NBXG",
      companyName:
        "Neuberger Berman Next Generation Connectivity Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nby",
      code: "NASDAQ:NBY",
      companyName: "NovaBay Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nc",
      code: "NASDAQ:NC",
      companyName: "NACCO Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nca",
      code: "NASDAQ:NCA",
      companyName: "Nuveen California Municipal Value Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncac",
      code: "NASDAQ:NCAC",
      companyName: "Newcourt Acquisition Corp Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncacu",
      code: "NASDAQ:NCACU",
      companyName: "Newcourt Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncacw",
      code: "NASDAQ:NCACW",
      companyName: "Newcourt Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncbs",
      code: "NASDAQ:NCBS",
      companyName: "Nicolet Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nclh",
      code: "NASDAQ:NCLH",
      companyName: "Norwegian Cruise Line Holdings Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncmi",
      code: "NASDAQ:NCMI",
      companyName: "National CineMedia Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncna",
      code: "NASDAQ:NCNA",
      companyName: "NuCana plc American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncno",
      code: "NASDAQ:NCNO",
      companyName: "nCino Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncr",
      code: "NASDAQ:NCR",
      companyName: "NCR Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncsm",
      code: "NASDAQ:NCSM",
      companyName: "NCS Multistage Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncty",
      code: "NASDAQ:NCTY",
      companyName: "The9 Limited American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncv",
      code: "NASDAQ:NCV",
      companyName:
        "Virtus AllianzGI Convertible & Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncv-a",
      code: "NASDAQ:NCV-A",
      companyName:
        "Virtus AllianzGI Convertible & Income Fund 5.625% Series A Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncz",
      code: "NASDAQ:NCZ",
      companyName:
        "Virtus AllianzGI Convertible & Income Fund II Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ncz-a",
      code: "NASDAQ:NCZ-A",
      companyName:
        "Virtus AllianzGI Convertible & Income Fund II 5.50% Series A Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndac",
      code: "NASDAQ:NDAC",
      companyName: "NightDragon Acquisition Corp. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndacu",
      code: "NASDAQ:NDACU",
      companyName: "NightDragon Acquisition Corp. SCALE Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndacw",
      code: "NASDAQ:NDACW",
      companyName:
        "NightDragon Acquisition Corp. Warrants to purchase Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndaq",
      code: "NASDAQ:NDAQ",
      companyName: "Nasdaq Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndls",
      code: "NASDAQ:NDLS",
      companyName: "Noodles & Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndmo",
      code: "NASDAQ:NDMO",
      companyName:
        "Nuveen Dynamic Municipal Opportunities Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndp",
      code: "NASDAQ:NDP",
      companyName: "Tortoise Energy Independence Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndra",
      code: "NASDAQ:NDRA",
      companyName: "ENDRA Life Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndraw",
      code: "NASDAQ:NDRAW",
      companyName: "ENDRA Life Sciences Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-ndsn",
      code: "NASDAQ:NDSN",
      companyName: "Nordson Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ne",
      code: "NASDAQ:NE",
      companyName: "Noble Corporation plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nea",
      code: "NASDAQ:NEA",
      companyName:
        "Nuveen AMT-Free Quality Municipal Income Fund Common Shares of Beneficial Interest Par Value $.01",
      popularity: 0,
    },
    {
      slug: "nasdaq-necb",
      code: "NASDAQ:NECB",
      companyName: "NorthEast Community Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nee-n",
      code: "NASDAQ:NEE-N",
      companyName:
        "NextEra Energy Inc. Series N Junior Subordinated Debentures due March 1 2079",
      popularity: 0,
    },
    {
      slug: "nasdaq-nee-o",
      code: "NASDAQ:NEE-O",
      companyName: "NextEra Energy Inc. 4.872% Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-nee-p",
      code: "NASDAQ:NEE-P",
      companyName: "NextEra Energy Inc. 5.279% Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-nee-q",
      code: "NASDAQ:NEE-Q",
      companyName: "NextEra Energy Inc. 6.219% Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-negg",
      code: "NASDAQ:NEGG",
      companyName: "Newegg Commerce Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nen",
      code: "NASDAQ:NEN",
      companyName:
        "New England Realty Associates Limited Partnership Class A Depositary Receipts Evidencing Units of Limited Partnership",
      popularity: 0,
    },
    {
      slug: "nasdaq-neo",
      code: "NASDAQ:NEO",
      companyName: "NeoGenomics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-neog",
      code: "NASDAQ:NEOG",
      companyName: "Neogen Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-neon",
      code: "NASDAQ:NEON",
      companyName: "Neonode Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nep",
      code: "NASDAQ:NEP",
      companyName:
        "NextEra Energy Partners LP Common Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-neph",
      code: "NASDAQ:NEPH",
      companyName: "Nephros Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nept",
      code: "NASDAQ:NEPT",
      companyName: "Neptune Wellness Solutions Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nerv",
      code: "NASDAQ:NERV",
      companyName: "Minerva Neurosciences Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nesr",
      code: "NASDAQ:NESR",
      companyName: "National Energy Services Reunited Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-net",
      code: "NASDAQ:NET",
      companyName: "Cloudflare Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nev",
      code: "NASDAQ:NEV",
      companyName:
        "Nuveen Enhanced Municipal Value Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-newr",
      code: "NASDAQ:NEWR",
      companyName: "New Relic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-newt",
      code: "NASDAQ:NEWT",
      companyName: "Newtek Business Services Corp. Common Stock (Maryland)",
      popularity: 0,
    },
    {
      slug: "nasdaq-newtl",
      code: "NASDAQ:NEWTL",
      companyName: "Newtek Business Services Corp. 5.75% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-newtz",
      code: "NASDAQ:NEWTZ",
      companyName: "Newtek Business Services Corp. 5.50% Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-nex",
      code: "NASDAQ:NEX",
      companyName: "NexTier Oilfield Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nexa",
      code: "NASDAQ:NEXA",
      companyName: "Nexa Resources S.A. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nexi",
      code: "NASDAQ:NEXI",
      companyName: "NexImmune Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-next",
      code: "NASDAQ:NEXT",
      companyName: "NextDecade Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nfbk",
      code: "NASDAQ:NFBK",
      companyName: "Northfield Bancorp Inc. Common Stock (Delaware)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nfe",
      code: "NASDAQ:NFE",
      companyName: "New Fortress Energy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nfg",
      code: "NASDAQ:NFG",
      companyName: "National Fuel Gas Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nfgc",
      code: "NASDAQ:NFGC",
      companyName: "New Found Gold Corp Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nfj",
      code: "NASDAQ:NFJ",
      companyName:
        "Virtus Dividend Interest & Premium Strategy Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-nfnt",
      code: "NASDAQ:NFNT",
      companyName: "Infinite Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nfys",
      code: "NASDAQ:NFYS",
      companyName: "Enphys Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ng",
      code: "NASDAQ:NG",
      companyName: "Novagold Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngc",
      code: "NASDAQ:NGC",
      companyName: "Northern Genesis Acquisition Corp. III Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngd",
      code: "NASDAQ:NGD",
      companyName: "New Gold Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngg",
      code: "NASDAQ:NGG",
      companyName:
        "National Grid Transco PLC National Grid PLC (NEW) American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngl",
      code: "NASDAQ:NGL",
      companyName:
        "NGL ENERGY PARTNERS LP Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngl-b",
      code: "NASDAQ:NGL-B",
      companyName:
        "NGL ENERGY PARTNERS LP 9.00% Class B Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Units representing limited partnership interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngl-c",
      code: "NASDAQ:NGL-C",
      companyName:
        "NGL ENERGY PARTNERS LP 9.625% Class C Fixed-to-Floating Rate Cumulative  Redeemable Perpetual Preferred Units representing  limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngm",
      code: "NASDAQ:NGM",
      companyName: "NGM Biopharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngms",
      code: "NASDAQ:NGMS",
      companyName: "NeoGames S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngs",
      code: "NASDAQ:NGS",
      companyName: "Natural Gas Services Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngvc",
      code: "NASDAQ:NGVC",
      companyName: "Natural Grocers by Vitamin Cottage Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ngvt",
      code: "NASDAQ:NGVT",
      companyName: "Ingevity Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-nh",
      code: "NASDAQ:NH",
      companyName: "NantHealth Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nhc",
      code: "NASDAQ:NHC",
      companyName: "National HealthCare Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nhi",
      code: "NASDAQ:NHI",
      companyName: "National Health Investors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nhic",
      code: "NASDAQ:NHIC",
      companyName: "NewHold Investment Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nhicu",
      code: "NASDAQ:NHICU",
      companyName: "NewHold Investment Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-nhs",
      code: "NASDAQ:NHS",
      companyName: "Neuberger Berman High Yield Strategies Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-nhtc",
      code: "NASDAQ:NHTC",
      companyName: "Natural Health Trends Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nhwk",
      code: "NASDAQ:NHWK",
      companyName: "NightHawk Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ni",
      code: "NASDAQ:NI",
      companyName: "NiSource Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ni-b",
      code: "NASDAQ:NI-B",
      companyName:
        "NiSource Inc Depositary Shares representing 1/1000th ownership interest in a share of 6.50% Series B Preferred Stock and 1/1000th ownership interest in a share of Series B-1 Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nice",
      code: "NASDAQ:NICE",
      companyName: "NICE Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nick",
      code: "NASDAQ:NICK",
      companyName: "Nicholas Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nid",
      code: "NASDAQ:NID",
      companyName:
        "Nuveen Intermediate Duration Municipal Term Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-nie",
      code: "NASDAQ:NIE",
      companyName:
        "Virtus AllianzGI Equity & Convertible Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-nile",
      code: "NASDAQ:NILE",
      companyName: "BitNile Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nim",
      code: "NASDAQ:NIM",
      companyName: "Nuveen Select Maturities Municipal Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nimc",
      code: "NASDAQ:NIMC",
      companyName: "NiSource Inc Series A Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-nine",
      code: "NASDAQ:NINE",
      companyName: "Nine Energy Service Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-niq",
      code: "NASDAQ:NIQ",
      companyName:
        "Nuveenn Intermediate Duration Quality Municipal Term Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-njr",
      code: "NASDAQ:NJR",
      companyName: "NewJersey Resources Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nkg",
      code: "NASDAQ:NKG",
      companyName: "Nuveen Georgia Quality Municipal Income Fund ",
      popularity: 0,
    },
    {
      slug: "nasdaq-nkla",
      code: "NASDAQ:NKLA",
      companyName: "Nikola Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nksh",
      code: "NASDAQ:NKSH",
      companyName: "National Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nktr",
      code: "NASDAQ:NKTR",
      companyName: "Nektar Therapeutics  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nktx",
      code: "NASDAQ:NKTX",
      companyName: "Nkarta Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nkx",
      code: "NASDAQ:NKX",
      companyName: "Nuveen California AMT-Free Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-nl",
      code: "NASDAQ:NL",
      companyName: "NL Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nlit",
      code: "NASDAQ:NLIT",
      companyName: "Northern Lights Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nlitw",
      code: "NASDAQ:NLITW",
      companyName: "Northern Lights Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-nlok",
      code: "NASDAQ:NLOK",
      companyName: "NortonLifeLock Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nls",
      code: "NASDAQ:NLS",
      companyName: "Nautilus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nlsn",
      code: "NASDAQ:NLSN",
      companyName: "Nielsen N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nke",
      code: "NASDAQ:NKE",
      companyName: "Nike Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nlsp",
      code: "NASDAQ:NLSP",
      companyName: "NLS Pharmaceutics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nlspw",
      code: "NASDAQ:NLSPW",
      companyName: "NLS Pharmaceutics Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nltx",
      code: "NASDAQ:NLTX",
      companyName: "Neoleukin Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nly",
      code: "NASDAQ:NLY",
      companyName: "Annaly Capital Management Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nly-f",
      code: "NASDAQ:NLY-F",
      companyName: "Annaly Capital Management Inc 6.95% Series F",
      popularity: 0,
    },
    {
      slug: "nasdaq-nly-g",
      code: "NASDAQ:NLY-G",
      companyName:
        "Annaly Capital Management Inc 6.50% Series G Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nly-i",
      code: "NASDAQ:NLY-I",
      companyName:
        "Annaly Capital Management Inc 6.750% Series I Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nm",
      code: "NASDAQ:NM",
      companyName: "Navios Maritime Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nm-g",
      code: "NASDAQ:NM-G",
      companyName:
        "Navios Maritime Holdings Inc. Sponsored ADR Representing 1/100th Perpetual Preferred Series G (Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nm-h",
      code: "NASDAQ:NM-H",
      companyName:
        "Navios Maritime Holdings Inc. Sponsored ADR Representing 1/100th Perp. Preferred Series H%",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmai",
      code: "NASDAQ:NMAI",
      companyName:
        "Nuveen Multi-Asset Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmco",
      code: "NASDAQ:NMCO",
      companyName: "Nuveen Municipal Credit Opportunities Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmfc",
      code: "NASDAQ:NMFC",
      companyName: "New Mountain Finance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmg",
      code: "NASDAQ:NMG",
      companyName: "Nouveau Monde Graphite Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmi",
      code: "NASDAQ:NMI",
      companyName: "Nuveen Municipal Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmih",
      code: "NASDAQ:NMIH",
      companyName: "NMI Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmk-b",
      code: "NASDAQ:NMK-B",
      companyName: "Niagara Mohawk Holdings Inc. Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nml",
      code: "NASDAQ:NML",
      companyName:
        "Neuberger Berman MLP and Energy Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmm",
      code: "NASDAQ:NMM",
      companyName:
        "Navios Maritime Partners LP Common Units Representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmmc",
      code: "NASDAQ:NMMC",
      companyName: "North Mountain Merger Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmmcu",
      code: "NASDAQ:NMMCU",
      companyName: "North Mountain Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmmcw",
      code: "NASDAQ:NMMCW",
      companyName: "North Mountain Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmr",
      code: "NASDAQ:NMR",
      companyName: "Nomura Holdings Inc ADR American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmrd",
      code: "NASDAQ:NMRD",
      companyName: "Nemaura Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmrk",
      code: "NASDAQ:NMRK",
      companyName: "Newmark Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nms",
      code: "NASDAQ:NMS",
      companyName: "Nuveen Minnesota Quality Municipal Income Fund ",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmt",
      code: "NASDAQ:NMT",
      companyName:
        "Nuveen Massachusetts Quality Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmtc",
      code: "NASDAQ:NMTC",
      companyName: "NeuroOne Medical Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmtr",
      code: "NASDAQ:NMTR",
      companyName: "9 Meters Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nmz",
      code: "NASDAQ:NMZ",
      companyName:
        "Nuveen Municipal High Income Opportunity Fund Common Stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-nn",
      code: "NASDAQ:NN",
      companyName: "NextNav Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nnavw",
      code: "NASDAQ:NNAVW",
      companyName: "NextNav Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nnbr",
      code: "NASDAQ:NNBR",
      companyName: "NN Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nndm",
      code: "NASDAQ:NNDM",
      companyName: "Nano Dimension Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nni",
      code: "NASDAQ:NNI",
      companyName: "Nelnet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nnn",
      code: "NASDAQ:NNN",
      companyName: "National Retail Properties Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nnox",
      code: "NASDAQ:NNOX",
      companyName: "NANO-X IMAGING LTD Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nnvc",
      code: "NASDAQ:NNVC",
      companyName: "NanoViricides Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nny",
      code: "NASDAQ:NNY",
      companyName: "Nuveen New York Municipal Value Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-noa",
      code: "NASDAQ:NOA",
      companyName:
        "North American Construction Group Ltd. Common Shares (no par)",
      popularity: 0,
    },
    {
      slug: "nasdaq-noacu",
      code: "NASDAQ:NOACU",
      companyName: "Natural Order Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-noacw",
      code: "NASDAQ:NOACW",
      companyName: "Natural Order Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-noah",
      code: "NASDAQ:NOAH",
      companyName: "Noah Holdings Limited",
      popularity: 0,
    },
    {
      slug: "nasdaq-noc",
      code: "NASDAQ:NOC",
      companyName: "Northrop Grumman Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nodk",
      code: "NASDAQ:NODK",
      companyName: "NI Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nog",
      code: "NASDAQ:NOG",
      companyName: "Northern Oil and Gas Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nok",
      code: "NASDAQ:NOK",
      companyName: "Nokia Corporation Sponsored American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nom",
      code: "NASDAQ:NOM",
      companyName: "Nuveen Missouri Quality Municipal Income Fund ",
      popularity: 0,
    },
    {
      slug: "nasdaq-nomd",
      code: "NASDAQ:NOMD",
      companyName: "Nomad Foods Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-notv",
      code: "NASDAQ:NOTV",
      companyName: "Inotiv Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nov",
      code: "NASDAQ:NOV",
      companyName: "NOV Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nova",
      code: "NASDAQ:NOVA",
      companyName: "Sunnova Energy International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-novn",
      code: "NASDAQ:NOVN",
      companyName: "Novan Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-novt",
      code: "NASDAQ:NOVT",
      companyName: "Novanta Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-novvu",
      code: "NASDAQ:NOVVU",
      companyName: "Nova Vision Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-novvw",
      code: "NASDAQ:NOVVW",
      companyName: "Nova Vision Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-np",
      code: "NASDAQ:NP",
      companyName: "Neenah Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-npab",
      code: "NASDAQ:NPAB",
      companyName: "New Providence Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-npabu",
      code: "NASDAQ:NPABU",
      companyName: "New Providence Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-npabw",
      code: "NASDAQ:NPABW",
      companyName: "New Providence Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-npce",
      code: "NASDAQ:NPCE",
      companyName: "Neuropace Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-npct",
      code: "NASDAQ:NPCT",
      companyName:
        "Nuveen Core Plus Impact Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-npfd",
      code: "NASDAQ:NPFD",
      companyName: "Nuveen Variable Rate Preferred & Income Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-npk",
      code: "NASDAQ:NPK",
      companyName: "National Presto Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-npo",
      code: "NASDAQ:NPO",
      companyName: "EnPro Industries Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-nptn",
      code: "NASDAQ:NPTN",
      companyName: "NeoPhotonics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-npv",
      code: "NASDAQ:NPV",
      companyName: "Nuveen Virginia Quality Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nqp",
      code: "NASDAQ:NQP",
      companyName:
        "Nuveen Pennsylvania Quality Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nr",
      code: "NASDAQ:NR",
      companyName: "Newpark Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrac",
      code: "NASDAQ:NRAC",
      companyName: "Noble Rock Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-nracu",
      code: "NASDAQ:NRACU",
      companyName: "Noble Rock Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-nracw",
      code: "NASDAQ:NRACW",
      companyName: "Noble Rock Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrbo",
      code: "NASDAQ:NRBO",
      companyName: "NeuroBo Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrc",
      code: "NASDAQ:NRC",
      companyName: "National Research Corporation Common Stock (Delaware)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrds",
      code: "NASDAQ:NRDS",
      companyName: "NerdWallet Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrdy",
      code: "NASDAQ:NRDY",
      companyName: "Nerdy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nref",
      code: "NASDAQ:NREF",
      companyName: "NexPoint Real Estate Finance Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nref-a",
      code: "NASDAQ:NREF-A",
      companyName:
        "NexPoint Real Estate Finance Inc. 8.50% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrg",
      code: "NASDAQ:NRG",
      companyName: "NRG Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrgv",
      code: "NASDAQ:NRGV",
      companyName: "Energy Vault Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrgx",
      code: "NASDAQ:NRGX",
      companyName:
        "PIMCO Energy and Tactical Credit Opportunities Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrim",
      code: "NASDAQ:NRIM",
      companyName: "Northrim BanCorp Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrix",
      code: "NASDAQ:NRIX",
      companyName: "Nurix Therapeutics Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrk",
      code: "NASDAQ:NRK",
      companyName: "Nuveen New York AMT-Free Quality Municipal Income Fund ",
      popularity: 0,
    },
    {
      slug: "nasdaq-nro",
      code: "NASDAQ:NRO",
      companyName:
        "Neuberger Berman Real Estate Securities Income Fund Inc. Neuberger Berman Real Estate Securities Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrp",
      code: "NASDAQ:NRP",
      companyName: "Natural Resource Partners LP Limited Partnership",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrsn",
      code: "NASDAQ:NRSN",
      companyName: "NeuroSense Therapeutics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrsnw",
      code: "NASDAQ:NRSNW",
      companyName: "NeuroSense Therapeutics Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrt",
      code: "NASDAQ:NRT",
      companyName: "North European Oil Royality Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nruc",
      code: "NASDAQ:NRUC",
      companyName:
        "National Rural Utilities Cooperative Finance Corporation 5.500% Subordinated Notes due 2064 (Subordinated Deferrable Interest Notes)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrxp",
      code: "NASDAQ:NRXP",
      companyName: "NRX Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrxpw",
      code: "NASDAQ:NRXPW",
      companyName: "NRX Pharmaceuticals Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrz",
      code: "NASDAQ:NRZ",
      companyName: "New Residential Investment Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrz-a",
      code: "NASDAQ:NRZ-A",
      companyName:
        "New Residential Investment Corp. 7.50% Series A Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrz-b",
      code: "NASDAQ:NRZ-B",
      companyName:
        "New Residential Investment Corp. 7.125% Series B Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrz-c",
      code: "NASDAQ:NRZ-C",
      companyName:
        "New Residential Investment Corp. 6.375% Series C Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nrz-d",
      code: "NASDAQ:NRZ-D",
      companyName:
        "New Residential Investment Corp. 7.00% Fixed-Rate Reset Series D Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ns-a",
      code: "NASDAQ:NS-A",
      companyName:
        "Nustar Energy L.P. 8.50% Series A Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ns-b",
      code: "NASDAQ:NS-B",
      companyName:
        "Nustar Energy L.P. 7.625% Series B Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-ns-c",
      code: "NASDAQ:NS-C",
      companyName:
        "Nustar Energy L.P. 9.00% Series C Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsa",
      code: "NASDAQ:NSA",
      companyName:
        "National Storage Affiliates Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsa-a",
      code: "NASDAQ:NSA-A",
      companyName:
        "National Storage Affiliates Trust 6.000% Series A Cumulative Redeemable Preferred Shares of Beneficial Interest (Liquidation Preference $25.00 per share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsc",
      code: "NASDAQ:NSC",
      companyName: "Norfolk Southern Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsec",
      code: "NASDAQ:NSEC",
      companyName: "National Security Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsit",
      code: "NASDAQ:NSIT",
      companyName: "Insight Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsl",
      code: "NASDAQ:NSL",
      companyName: "Nuveen Senior Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsp",
      code: "NASDAQ:NSP",
      companyName: "Insperity Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nspr",
      code: "NASDAQ:NSPR",
      companyName: "InspireMD Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nss",
      code: "NASDAQ:NSS",
      companyName:
        "NuStar Logistics L.P. 7.625% Fixed-to-Floating Rate Subordinated Notes due 2043",
      popularity: 0,
    },
    {
      slug: "nasdaq-nssc",
      code: "NASDAQ:NSSC",
      companyName: "NAPCO Security Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nstb",
      code: "NASDAQ:NSTB",
      companyName: "Northern Star Investment Corp. II Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nstc",
      code: "NASDAQ:NSTC",
      companyName: "Northern Star Investment Corp. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nstd",
      code: "NASDAQ:NSTD",
      companyName: "Northern Star Investment Corp. IV Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nstg",
      code: "NASDAQ:NSTG",
      companyName: "NanoString Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsts",
      code: "NASDAQ:NSTS",
      companyName: "NSTS Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nsys",
      code: "NASDAQ:NSYS",
      companyName: "Nortech Systems Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntap",
      code: "NASDAQ:NTAP",
      companyName: "NetApp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntb",
      code: "NASDAQ:NTB",
      companyName:
        "Bank of N.T. Butterfield & Son Limited (The) Voting Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntco",
      code: "NASDAQ:NTCO",
      companyName: "Natura &Co Holding S.A. American Depositary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntct",
      code: "NASDAQ:NTCT",
      companyName: "NetScout Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntes",
      code: "NASDAQ:NTES",
      companyName: "NetEase Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntg",
      code: "NASDAQ:NTG",
      companyName: "Tortoise Midstream Energy Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntgr",
      code: "NASDAQ:NTGR",
      companyName: "NETGEAR Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntic",
      code: "NASDAQ:NTIC",
      companyName:
        "Northern Technologies International Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntip",
      code: "NASDAQ:NTIP",
      companyName: "Network-1 Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntnx",
      code: "NASDAQ:NTNX",
      companyName: "Nutanix Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntp",
      code: "NASDAQ:NTP",
      companyName: "Nam Tai Property Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntra",
      code: "NASDAQ:NTRA",
      companyName: "Natera Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntrb",
      code: "NASDAQ:NTRB",
      companyName: "Nutriband Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntrbw",
      code: "NASDAQ:NTRBW",
      companyName: "Nutriband Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntrs",
      code: "NASDAQ:NTRS",
      companyName: "Northern Trust Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntrso",
      code: "NASDAQ:NTRSO",
      companyName:
        "Northern Trust Corporation Depositary Shares Each Representing a 1/1000th Interest in a Share of Series E Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntst",
      code: "NASDAQ:NTST",
      companyName: "NetSTREIT Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntus",
      code: "NASDAQ:NTUS",
      companyName: "Natus Medical Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntwk",
      code: "NASDAQ:NTWK",
      companyName: "NetSol Technologies Inc. Common  Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntz",
      code: "NASDAQ:NTZ",
      companyName: "Natuzzi S.p.A.",
      popularity: 0,
    },
    {
      slug: "nasdaq-nu",
      code: "NASDAQ:NU",
      companyName: "Nu Holdings Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nubi",
      code: "NASDAQ:NUBI",
      companyName: "Nubia Brand International Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nubiu",
      code: "NASDAQ:NUBIU",
      companyName: "Nubia Brand International Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-nubiw",
      code: "NASDAQ:NUBIW",
      companyName: "Nubia Brand International Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nue",
      code: "NASDAQ:NUE",
      companyName: "Nucor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nuo",
      code: "NASDAQ:NUO",
      companyName: "Nuveen Ohio Quality Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nuro",
      code: "NASDAQ:NURO",
      companyName: "NeuroMetrix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nus",
      code: "NASDAQ:NUS",
      companyName: "Nu Skin Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nutx",
      code: "NASDAQ:NUTX",
      companyName: "Nutex Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nuv",
      code: "NASDAQ:NUV",
      companyName: "Nuveen Municipal Value Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nuva",
      code: "NASDAQ:NUVA",
      companyName: "NuVasive Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nuvb",
      code: "NASDAQ:NUVB",
      companyName: "Nuvation Bio Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvac",
      code: "NASDAQ:NVAC",
      companyName: "NorthView Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvacw",
      code: "NASDAQ:NVACW",
      companyName: "NorthView Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvcn",
      code: "NASDAQ:NVCN",
      companyName: "Neovasc Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvct",
      code: "NASDAQ:NVCT",
      companyName: "Nuvectis Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-lmgn",
      code: "ASX:LMGN",
      companyName: "Latrobe Magnesium Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvec",
      code: "NASDAQ:NVEC",
      companyName: "NVE Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvee",
      code: "NASDAQ:NVEE",
      companyName: "NV5 Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvei",
      code: "NASDAQ:NVEI",
      companyName: "Nuvei Corporation Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvfy",
      code: "NASDAQ:NVFY",
      companyName: "Nova Lifestyle Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvg",
      code: "NASDAQ:NVG",
      companyName: "Nuveen AMT-Free Municipal Credit Income Fund ",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvgs",
      code: "NASDAQ:NVGS",
      companyName: "Navigator Holdings Ltd. Ordinary Shares (Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nviv",
      code: "NASDAQ:NVIV",
      companyName: "InVivo Therapeutics Holdings Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvmi",
      code: "NASDAQ:NVMI",
      companyName: "Nova Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvno",
      code: "NASDAQ:NVNO",
      companyName: "enVVeno Medical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvnow",
      code: "NASDAQ:NVNOW",
      companyName: "enVVeno Medical Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvos",
      code: "NASDAQ:NVOS",
      companyName: "Novo Integrated Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvr",
      code: "NASDAQ:NVR",
      companyName: "NVR Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvro",
      code: "NASDAQ:NVRO",
      companyName: "Nevro Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntr",
      code: "NASDAQ:NTR",
      companyName: "Nutrien Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvsa",
      code: "NASDAQ:NVSA",
      companyName: "New Vista Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvsau",
      code: "NASDAQ:NVSAU",
      companyName: "New Vista Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvsaw",
      code: "NASDAQ:NVSAW",
      companyName: "New Vista Acquisition Corp. Warrant ",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvst",
      code: "NASDAQ:NVST",
      companyName: "Envista Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvta",
      code: "NASDAQ:NVTA",
      companyName: "Invitae Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvts",
      code: "NASDAQ:NVTS",
      companyName: "Navitas Semiconductor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvve",
      code: "NASDAQ:NVVE",
      companyName: "Nuvve Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvvew",
      code: "NASDAQ:NVVEW",
      companyName: "Nuvve Holding Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nwbi",
      code: "NASDAQ:NWBI",
      companyName: "Northwest Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nwe",
      code: "NASDAQ:NWE",
      companyName: "NorthWestern Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nwfl",
      code: "NASDAQ:NWFL",
      companyName: "Norwood Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nwg",
      code: "NASDAQ:NWG",
      companyName: "NatWest Group plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nwl",
      code: "NASDAQ:NWL",
      companyName: "Newell Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nwli",
      code: "NASDAQ:NWLI",
      companyName: "National Western Life Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nwn",
      code: "NASDAQ:NWN",
      companyName: "Northwest Natural Holding Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nwpx",
      code: "NASDAQ:NWPX",
      companyName: "Northwest Pipe Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nws",
      code: "NASDAQ:NWS",
      companyName: "News Corporation Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nwsa",
      code: "NASDAQ:NWSA",
      companyName: "News Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nx",
      code: "NASDAQ:NX",
      companyName: "Quanex Building Products Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxc",
      code: "NASDAQ:NXC",
      companyName:
        "Nuveen California Select Tax-Free Income Portfolio Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxdt",
      code: "NASDAQ:NXDT",
      companyName: "NexPoint Diversified Real Estate Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxdt-a",
      code: "NASDAQ:NXDT-A",
      companyName:
        "NexPoint Diversified Real Estate Trust 5.50% Series A Cumulative Preferred Shares ($25.00 liquidation preference per share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxe",
      code: "NASDAQ:NXE",
      companyName: "Nexgen Energy Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxgl",
      code: "NASDAQ:NXGL",
      companyName: "NexGel Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxglw",
      code: "NASDAQ:NXGLW",
      companyName: "NexGel Inc Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxgn",
      code: "NASDAQ:NXGN",
      companyName: "NextGen Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxj",
      code: "NASDAQ:NXJ",
      companyName: "Nuveen New Jersey Qualified Municipal Fund ",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxn",
      code: "NASDAQ:NXN",
      companyName:
        "Nuveen New York Select Tax-Free Income Portfolio Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxp",
      code: "NASDAQ:NXP",
      companyName: "Nuveen Select Tax Free Income Portfolio Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxpi",
      code: "NASDAQ:NXPI",
      companyName: "NXP Semiconductors N.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxpl",
      code: "NASDAQ:NXPL",
      companyName: "NextPlat Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxrt",
      code: "NASDAQ:NXRT",
      companyName: "NexPoint Residential Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxtc",
      code: "NASDAQ:NXTC",
      companyName: "NextCure Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxtp",
      code: "NASDAQ:NXTP",
      companyName: "NextPlay Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nyc",
      code: "NASDAQ:NYC",
      companyName: "New York City REIT Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nycb",
      code: "NASDAQ:NYCB",
      companyName: "New York Community Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nycb-a",
      code: "NASDAQ:NYCB-A",
      companyName:
        "New York Community Bancorp Inc. Depositary shares each representing a 1/40th interest in a share of Fixed-to-Floating Rate Series A Noncumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nycb-u",
      code: "NASDAQ:NYCB-U",
      companyName:
        "New York Community Bancorp Inc. New York Community Capital Tr V (BONUSES)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nymt",
      code: "NASDAQ:NYMT",
      companyName: "New York Mortgage Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nymtl",
      code: "NASDAQ:NYMTL",
      companyName:
        "New York Mortgage Trust Inc. 6.875% Series F Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-nymtm",
      code: "NASDAQ:NYMTM",
      companyName:
        "New York Mortgage Trust Inc. 7.875% Series E Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nymtn",
      code: "NASDAQ:NYMTN",
      companyName:
        "New York Mortgage Trust Inc. 8.00% Series D Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nymtz",
      code: "NASDAQ:NYMTZ",
      companyName:
        "New York Mortgage Trust Inc. 7.000% Series G Cumulative Redeemable Preferred Stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-nymx",
      code: "NASDAQ:NYMX",
      companyName: "Nymox Pharmaceutical Corporation Common Stock (Bahamas)",
      popularity: 0,
    },
    {
      slug: "nasdaq-nyt",
      code: "NASDAQ:NYT",
      companyName: "New York Times Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nyxh",
      code: "NASDAQ:NYXH",
      companyName: "Nyxoah SA Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nzf",
      code: "NASDAQ:NZF",
      companyName: "Nuveen Municipal Credit Income Fund ",
      popularity: 0,
    },
    {
      slug: "nasdaq-o",
      code: "NASDAQ:O",
      companyName: "Realty Income Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oacb",
      code: "NASDAQ:OACB",
      companyName: "Oaktree Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-oak-a",
      code: "NASDAQ:OAK-A",
      companyName: "Oaktree Capital Group LLC 6.625% Series A Preferred units",
      popularity: 0,
    },
    {
      slug: "nasdaq-oak-b",
      code: "NASDAQ:OAK-B",
      companyName: "Oaktree Capital Group LLC 6.550% Series B Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-oas",
      code: "NASDAQ:OAS",
      companyName: "Oasis Petroleum Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ob",
      code: "NASDAQ:OB",
      companyName: "Outbrain Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-obci",
      code: "NASDAQ:OBCI",
      companyName: "Ocean Bio-Chem Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-obe",
      code: "NASDAQ:OBE",
      companyName: "Obsidian Energy Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-oblg",
      code: "NASDAQ:OBLG",
      companyName: "Oblong Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-obnk",
      code: "NASDAQ:OBNK",
      companyName: "Origin Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-obsv",
      code: "NASDAQ:OBSV",
      companyName: "ObsEva SA Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-obt",
      code: "NASDAQ:OBT",
      companyName: "Orange County Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oc",
      code: "NASDAQ:OC",
      companyName: "Owens Corning Inc Common Stock New",
      popularity: 0,
    },
    {
      slug: "nasdaq-oca",
      code: "NASDAQ:OCA",
      companyName: "Omnichannel Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocax",
      code: "NASDAQ:OCAX",
      companyName: "OCA Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocaxw",
      code: "NASDAQ:OCAXW",
      companyName: "OCA Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-occ",
      code: "NASDAQ:OCC",
      companyName: "Optical Cable Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-occi",
      code: "NASDAQ:OCCI",
      companyName: "OFS Credit Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-occin",
      code: "NASDAQ:OCCIN",
      companyName:
        "OFS Credit Company Inc. 5.25% Series E Term Preferred Stock Due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-occio",
      code: "NASDAQ:OCCIO",
      companyName:
        "OFS Credit Company Inc. 6.125% Series C Term Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocdx",
      code: "NASDAQ:OCDX",
      companyName: "Ortho Clinical Diagnostics Holdings plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocfc",
      code: "NASDAQ:OCFC",
      companyName: "OceanFirst Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocfcp",
      code: "NASDAQ:OCFCP",
      companyName: "OceanFirst Financial Corp. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocft",
      code: "NASDAQ:OCFT",
      companyName:
        "OneConnect Financial Technology Co. Ltd. American Depositary Shares each representing three ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocg",
      code: "NASDAQ:OCG",
      companyName: "Oriental Culture Holding LTD Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocgn",
      code: "NASDAQ:OCGN",
      companyName: "Ocugen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocn",
      code: "NASDAQ:OCN",
      companyName: "Ocwen Financial Corporation NEW Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocsl",
      code: "NASDAQ:OCSL",
      companyName: "Oaktree Specialty Lending Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocul",
      code: "NASDAQ:OCUL",
      companyName: "Ocular Therapeutix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocup",
      code: "NASDAQ:OCUP",
      companyName: "Ocuphire Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ocx",
      code: "NASDAQ:OCX",
      companyName: "Oncocyte Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-odc",
      code: "NASDAQ:ODC",
      companyName: "Oil-Dri Corporation Of America Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-odfl",
      code: "NASDAQ:ODFL",
      companyName: "Old Dominion Freight Line Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-odp",
      code: "NASDAQ:ODP",
      companyName: "The ODP Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oec",
      code: "NASDAQ:OEC",
      companyName: "Orion Engineered Carbons S.A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-oeg",
      code: "NASDAQ:OEG",
      companyName: "Orbital Energy Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oepw",
      code: "NASDAQ:OEPW",
      companyName:
        "One Equity Partners Open Water I Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oepwu",
      code: "NASDAQ:OEPWU",
      companyName: "One Equity Partners Open Water I Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-oepww",
      code: "NASDAQ:OEPWW",
      companyName: "One Equity Partners Open Water I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ofed",
      code: "NASDAQ:OFED",
      companyName: "Oconee Federal Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ofg",
      code: "NASDAQ:OFG",
      companyName: "OFG Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ofix",
      code: "NASDAQ:OFIX",
      companyName: "Orthofix Medical Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-oflx",
      code: "NASDAQ:OFLX",
      companyName: "Omega Flex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ofs",
      code: "NASDAQ:OFS",
      companyName: "OFS Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ofssh",
      code: "NASDAQ:OFSSH",
      companyName: "OFS Capital Corporation 4.95% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-og",
      code: "NASDAQ:OG",
      companyName:
        "Onion Global Limited American Depositary Shares (each ten (10) ADSs representing one (1) Class A Ordinary Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-oge",
      code: "NASDAQ:OGE",
      companyName: "OGE Energy Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ogen",
      code: "NASDAQ:OGEN",
      companyName: "Oragenics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ogi",
      code: "NASDAQ:OGI",
      companyName: "Organigram Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ogn",
      code: "NASDAQ:OGN",
      companyName: "Organon & Co. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-ogs",
      code: "NASDAQ:OGS",
      companyName: "ONE Gas Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ohaa",
      code: "NASDAQ:OHAA",
      companyName: "OPY Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ohi",
      code: "NASDAQ:OHI",
      companyName: "Omega Healthcare Investors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ohpa",
      code: "NASDAQ:OHPA",
      companyName: "Orion Acquisition Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ohpau",
      code: "NASDAQ:OHPAU",
      companyName: "Orion Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ohpaw",
      code: "NASDAQ:OHPAW",
      companyName: "Orion Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-oi",
      code: "NASDAQ:OI",
      companyName: "O-I Glass Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oia",
      code: "NASDAQ:OIA",
      companyName: "Invesco Municipal Income Opportunities Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oii",
      code: "NASDAQ:OII",
      companyName: "Oceaneering International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oiim",
      code: "NASDAQ:OIIM",
      companyName: "O2Micro International Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ois",
      code: "NASDAQ:OIS",
      companyName: "Oil States International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oke",
      code: "NASDAQ:OKE",
      companyName: "ONEOK Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-olb",
      code: "NASDAQ:OLB",
      companyName: "The OLB Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oled",
      code: "NASDAQ:OLED",
      companyName: "Universal Display Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-olit",
      code: "NASDAQ:OLIT",
      companyName: "OmniLit Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-olitu",
      code: "NASDAQ:OLITU",
      companyName: "OmniLit Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-olitw",
      code: "NASDAQ:OLITW",
      companyName: "OmniLit Acquisition Corp. Warrants.",
      popularity: 0,
    },
    {
      slug: "nasdaq-olk",
      code: "NASDAQ:OLK",
      companyName: "Olink Holding AB (publ) American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-olli",
      code: "NASDAQ:OLLI",
      companyName: "Ollie's Bargain Outlet Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-olma",
      code: "NASDAQ:OLMA",
      companyName: "Olema Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oln",
      code: "NASDAQ:OLN",
      companyName: "Olin Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-olo",
      code: "NASDAQ:OLO",
      companyName: "Olo Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-olp",
      code: "NASDAQ:OLP",
      companyName: "One Liberty Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-olpx",
      code: "NASDAQ:OLPX",
      companyName: "Olaplex Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-om",
      code: "NASDAQ:OM",
      companyName: "Outset Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-omab",
      code: "NASDAQ:OMAB",
      companyName: "Grupo Aeroportuario del Centro Norte S.A.B. de C.V. ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-omc",
      code: "NASDAQ:OMC",
      companyName: "Omnicom Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-omeg",
      code: "NASDAQ:OMEG",
      companyName: "Omega Alpha SPAC Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-omer",
      code: "NASDAQ:OMER",
      companyName: "Omeros Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-omex",
      code: "NASDAQ:OMEX",
      companyName: "Odyssey Marine Exploration Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-omf",
      code: "NASDAQ:OMF",
      companyName: "OneMain Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-omga",
      code: "NASDAQ:OMGA",
      companyName: "Omega Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-omi",
      code: "NASDAQ:OMI",
      companyName: "Owens & Minor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-omic",
      code: "NASDAQ:OMIC",
      companyName: "Singular Genomics Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-omqs",
      code: "NASDAQ:OMQS",
      companyName: "OMNIQ Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onb",
      code: "NASDAQ:ONB",
      companyName: "Old National Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onbpo",
      code: "NASDAQ:ONBPO",
      companyName:
        "Old National Bancorp Depositary Shares Each Representing a 1/40th Interest in a Share of Series C Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onbpp",
      code: "NASDAQ:ONBPP",
      companyName:
        "Old National Bancorp Depositary Shares Each Representing a 1/40th Interest in a Share of Series A Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oncr",
      code: "NASDAQ:ONCR",
      companyName: "Oncorus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oncs",
      code: "NASDAQ:ONCS",
      companyName: "OncoSec Medical Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onct",
      code: "NASDAQ:ONCT",
      companyName: "Oncternal Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oncy",
      code: "NASDAQ:ONCY",
      companyName: "Oncolytics Biotech Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-onds",
      code: "NASDAQ:ONDS",
      companyName: "Ondas Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onl",
      code: "NASDAQ:ONL",
      companyName: "Orion Office REIT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onon",
      code: "NASDAQ:ONON",
      companyName: "On Holding AG Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ontf",
      code: "NASDAQ:ONTF",
      companyName: "ON24 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onto",
      code: "NASDAQ:ONTO",
      companyName: "Onto Innovation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ontx",
      code: "NASDAQ:ONTX",
      companyName: "Onconova Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onvo",
      code: "NASDAQ:ONVO",
      companyName: "Organovo Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onyx",
      code: "NASDAQ:ONYX",
      companyName: "Onyx Acquisition Co. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-onyxw",
      code: "NASDAQ:ONYXW",
      companyName: "Onyx Acquisition Co. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ooma",
      code: "NASDAQ:OOMA",
      companyName: "Ooma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-op",
      code: "NASDAQ:OP",
      companyName: "OceanPal Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opa",
      code: "NASDAQ:OPA",
      companyName: "Magnum Opus Acquisition Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-opad",
      code: "NASDAQ:OPAD",
      companyName: "Offerpad Solutions Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opbk",
      code: "NASDAQ:OPBK",
      companyName: "OP Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opfi",
      code: "NASDAQ:OPFI",
      companyName: "OppFi Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opgn",
      code: "NASDAQ:OPGN",
      companyName: "OpGen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ophc",
      code: "NASDAQ:OPHC",
      companyName: "OptimumBank Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opi",
      code: "NASDAQ:OPI",
      companyName:
        "Office Properties Income Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-opinl",
      code: "NASDAQ:OPINL",
      companyName:
        "Office Properties Income Trust 6.375% Senior Notes due 2050",
      popularity: 0,
    },
    {
      slug: "nasdaq-opk",
      code: "NASDAQ:OPK",
      companyName: "OPKO Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opnt",
      code: "NASDAQ:OPNT",
      companyName: "Opiant Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opof",
      code: "NASDAQ:OPOF",
      companyName: "Old Point Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opp",
      code: "NASDAQ:OPP",
      companyName:
        "RiverNorth/DoubleLine Strategic Opportunity Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opp-a",
      code: "NASDAQ:OPP-A",
      companyName:
        "RiverNorth/DoubleLine Strategic Opportunity Fund Inc. 4.375% Series A Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opp-b",
      code: "NASDAQ:OPP-B",
      companyName:
        "RiverNorth/DoubleLine Strategic Opportunity Fund Inc. 4.75% Series B Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opra",
      code: "NASDAQ:OPRA",
      companyName: "Opera Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-oprt",
      code: "NASDAQ:OPRT",
      companyName: "Oportun Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oprx",
      code: "NASDAQ:OPRX",
      companyName: "OptimizeRx Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opt",
      code: "NASDAQ:OPT",
      companyName: "Opthea Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-optn",
      code: "NASDAQ:OPTN",
      companyName: "OptiNose Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-optt",
      code: "NASDAQ:OPTT",
      companyName: "Ocean Power Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-opy",
      code: "NASDAQ:OPY",
      companyName: "Oppenheimer Holdings Inc. Class A Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-or",
      code: "NASDAQ:OR",
      companyName: "Osisko Gold Royalties Ltd Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ora",
      code: "NASDAQ:ORA",
      companyName: "Ormat Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oran",
      code: "NASDAQ:ORAN",
      companyName: "Orange",
      popularity: 0,
    },
    {
      slug: "nasdaq-orc",
      code: "NASDAQ:ORC",
      companyName: "Orchid Island Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-orcc",
      code: "NASDAQ:ORCC",
      companyName: "Owl Rock Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-orgn",
      code: "NASDAQ:ORGN",
      companyName: "Origin Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-orgnw",
      code: "NASDAQ:ORGNW",
      companyName: "Origin Materials Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-orgo",
      code: "NASDAQ:ORGO",
      companyName: "Organogenesis Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-orgs",
      code: "NASDAQ:ORGS",
      companyName: "Orgenesis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ori",
      code: "NASDAQ:ORI",
      companyName: "Old Republic International Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oria",
      code: "NASDAQ:ORIA",
      companyName: "Orion Biotech Opportunities Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-oriau",
      code: "NASDAQ:ORIAU",
      companyName: "Orion Biotech Opportunities Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-oriaw",
      code: "NASDAQ:ORIAW",
      companyName: "Orion Biotech Opportunities Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-oric",
      code: "NASDAQ:ORIC",
      companyName: "Oric Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-orla",
      code: "NASDAQ:ORLA",
      companyName: "Orla Mining Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ormp",
      code: "NASDAQ:ORMP",
      companyName: "Oramed Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-orn",
      code: "NASDAQ:ORN",
      companyName: "Orion Group Holdings Inc. Common",
      popularity: 0,
    },
    {
      slug: "nasdaq-orrf",
      code: "NASDAQ:ORRF",
      companyName: "Orrstown Financial Services Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ortx",
      code: "NASDAQ:ORTX",
      companyName: "Orchard Therapeutics plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-osbc",
      code: "NASDAQ:OSBC",
      companyName: "Old Second Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oscr",
      code: "NASDAQ:OSCR",
      companyName: "Oscar Health Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-osg",
      code: "NASDAQ:OSG",
      companyName: "Overseas Shipholding Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-osi",
      code: "NASDAQ:OSI",
      companyName: "Osiris Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-osis",
      code: "NASDAQ:OSIS",
      companyName: "OSI Systems Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-osk",
      code: "NASDAQ:OSK",
      companyName: "Oshkosh Corporation (Holding Company)Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ospn",
      code: "NASDAQ:OSPN",
      companyName: "OneSpan Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oss",
      code: "NASDAQ:OSS",
      companyName: "One Stop Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ost",
      code: "NASDAQ:OST",
      companyName: "Ostin Technology Group Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ostk",
      code: "NASDAQ:OSTK",
      companyName: "Overstock.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ostr",
      code: "NASDAQ:OSTR",
      companyName: "Oyster Enterprises Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ostru",
      code: "NASDAQ:OSTRU",
      companyName: "Oyster Enterprises Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ostrw",
      code: "NASDAQ:OSTRW",
      companyName: "Oyster Enterprises Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-osur",
      code: "NASDAQ:OSUR",
      companyName: "OraSure Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-osw",
      code: "NASDAQ:OSW",
      companyName: "OneSpaWorld Holdings Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-otec",
      code: "NASDAQ:OTEC",
      companyName: "OceanTech Acquisitions I Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-otecw",
      code: "NASDAQ:OTECW",
      companyName: "OceanTech Acquisitions I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-otex",
      code: "NASDAQ:OTEX",
      companyName: "Open Text Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-otic",
      code: "NASDAQ:OTIC",
      companyName: "Otonomy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-otis",
      code: "NASDAQ:OTIS",
      companyName: "Otis Worldwide Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-otlk",
      code: "NASDAQ:OTLK",
      companyName: "Outlook Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-otly",
      code: "NASDAQ:OTLY",
      companyName: "Oatly Group AB American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-otmo",
      code: "NASDAQ:OTMO",
      companyName: "Otonomo Technologies Ltd. Ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-otmow",
      code: "NASDAQ:OTMOW",
      companyName: "Otonomo Technologies Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-otra",
      code: "NASDAQ:OTRA",
      companyName: "OTR Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-otrau",
      code: "NASDAQ:OTRAU",
      companyName: "OTR Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-otraw",
      code: "NASDAQ:OTRAW",
      companyName: "OTR Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-otrk",
      code: "NASDAQ:OTRK",
      companyName: "Ontrak Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-otrkp",
      code: "NASDAQ:OTRKP",
      companyName:
        "Ontrak Inc. 9.50% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ottr",
      code: "NASDAQ:OTTR",
      companyName: "Otter Tail Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oust",
      code: "NASDAQ:OUST",
      companyName: "Ouster Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-out",
      code: "NASDAQ:OUT",
      companyName: "OUTFRONT Media Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ovbc",
      code: "NASDAQ:OVBC",
      companyName: "Ohio Valley Banc Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ovid",
      code: "NASDAQ:OVID",
      companyName: "Ovid Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ovly",
      code: "NASDAQ:OVLY",
      companyName: "Oak Valley Bancorp (CA) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ovv",
      code: "NASDAQ:OVV",
      companyName: "Ovintiv Inc. (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-owl",
      code: "NASDAQ:OWL",
      companyName: "Blue Owl Capital Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-owlt",
      code: "NASDAQ:OWLT",
      companyName: "Owlet Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxac",
      code: "NASDAQ:OXAC",
      companyName: "Oxbridge Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dis",
      code: "NYSE:DIS",
      companyName: "The Walt Disney Company",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxacw",
      code: "NASDAQ:OXACW",
      companyName: "Oxbridge Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxbr",
      code: "NASDAQ:OXBR",
      companyName: "Oxbridge Re Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxbrw",
      code: "NASDAQ:OXBRW",
      companyName: "Oxbridge Re Holdings Limited Warrant expiring 3/26/2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxlc",
      code: "NASDAQ:OXLC",
      companyName: "Oxford Lane Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxlcl",
      code: "NASDAQ:OXLCL",
      companyName: "Oxford Lane Capital Corp. 6.75% Notes due 2031",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxlcm",
      code: "NASDAQ:OXLCM",
      companyName:
        "Oxford Lane Capital Corp. 6.75% Series 2024 Term Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxlco",
      code: "NASDAQ:OXLCO",
      companyName:
        "Oxford Lane Capital Corp. Preferred Stock Shares 6.00% Series 2029",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxlcp",
      code: "NASDAQ:OXLCP",
      companyName:
        "Oxford Lane Capital Corp. 6.25% Series 2027 Term Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxlcz",
      code: "NASDAQ:OXLCZ",
      companyName: "Oxford Lane Capital Corp. 5.00% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxm",
      code: "NASDAQ:OXM",
      companyName: "Oxford Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxsq",
      code: "NASDAQ:OXSQ",
      companyName: "Oxford Square Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxsqg",
      code: "NASDAQ:OXSQG",
      companyName: "Oxford Square Capital Corp. 5.50% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxsql",
      code: "NASDAQ:OXSQL",
      companyName: "Oxford Square Capital Corp. 6.50% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxsqz",
      code: "NASDAQ:OXSQZ",
      companyName: "Oxford Square Capital Corp. 6.25% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxus",
      code: "NASDAQ:OXUS",
      companyName: "Oxus Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxusw",
      code: "NASDAQ:OXUSW",
      companyName: "Oxus Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-oxy",
      code: "NASDAQ:OXY",
      companyName: "Occidental Petroleum Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oyst",
      code: "NASDAQ:OYST",
      companyName: "Oyster Point Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-oz",
      code: "NASDAQ:OZ",
      companyName: "Belpointe PREP LLC Class A Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ozk",
      code: "NASDAQ:OZK",
      companyName: "Bank OZK Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ozkap",
      code: "NASDAQ:OZKAP",
      companyName:
        "Bank OZK 4.625% Series A Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-paa",
      code: "NASDAQ:PAA",
      companyName:
        "Plains All American Pipeline L.P. Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-paas",
      code: "NASDAQ:PAAS",
      companyName: "Pan American Silver Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-paci",
      code: "NASDAQ:PACI",
      companyName: "PROOF Acquisition Corp I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pack",
      code: "NASDAQ:PACK",
      companyName: "Ranpak Holdings Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pacw",
      code: "NASDAQ:PACW",
      companyName: "PacWest Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pacx",
      code: "NASDAQ:PACX",
      companyName: "Pioneer Merger Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-pacxu",
      code: "NASDAQ:PACXU",
      companyName: "Pioneer Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-pacxw",
      code: "NASDAQ:PACXW",
      companyName: "Pioneer Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pafor",
      code: "NASDAQ:PAFOR",
      companyName: "Pacifico Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-pag",
      code: "NASDAQ:PAG",
      companyName: "Penske Automotive Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pagp",
      code: "NASDAQ:PAGP",
      companyName:
        "Plains GP Holdings L.P. Class A Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-pags",
      code: "NASDAQ:PAGS",
      companyName: "PagSeguro Digital Ltd. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pahc",
      code: "NASDAQ:PAHC",
      companyName: "Phibro Animal Health Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pai",
      code: "NASDAQ:PAI",
      companyName: "Western Asset Investment Grade Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-pali",
      code: "NASDAQ:PALI",
      companyName: "Palisade Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-palt",
      code: "NASDAQ:PALT",
      companyName: "Paltalk Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pam",
      code: "NASDAQ:PAM",
      companyName: "Pampa Energia S.A. Pampa Energia S.A.",
      popularity: 0,
    },
    {
      slug: "nasdaq-pana",
      code: "NASDAQ:PANA",
      companyName: "Panacea Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-panl",
      code: "NASDAQ:PANL",
      companyName: "Pangaea Logistics Solutions Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-paqc",
      code: "NASDAQ:PAQC",
      companyName: "Provident Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-paqcu",
      code: "NASDAQ:PAQCU",
      companyName: "Provident Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-paqcw",
      code: "NASDAQ:PAQCW",
      companyName: "Provident Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-par",
      code: "NASDAQ:PAR",
      companyName: "PAR Technology Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-para",
      code: "NASDAQ:PARA",
      companyName: "Paramount Global Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-paraa",
      code: "NASDAQ:PARAA",
      companyName: "Paramount Global Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-parap",
      code: "NASDAQ:PARAP",
      companyName:
        "Paramount Global 5.75% Series A Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-parr",
      code: "NASDAQ:PARR",
      companyName: "Par Pacific Holdings Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pasg",
      code: "NASDAQ:PASG",
      companyName: "Passage Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-path",
      code: "NASDAQ:PATH",
      companyName: "UiPath Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pati",
      code: "NASDAQ:PATI",
      companyName: "Patriot Transportation Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-patk",
      code: "NASDAQ:PATK",
      companyName: "Patrick Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pavm",
      code: "NASDAQ:PAVM",
      companyName: "PAVmed Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pavmz",
      code: "NASDAQ:PAVMZ",
      companyName: "PAVmed Inc. Series Z Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pax",
      code: "NASDAQ:PAX",
      companyName: "Patria Investments Limited Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-paxs",
      code: "NASDAQ:PAXS",
      companyName:
        "PIMCO Access Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pay",
      code: "NASDAQ:PAY",
      companyName: "Paymentus Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-paya",
      code: "NASDAQ:PAYA",
      companyName: "Paya Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-payc",
      code: "NASDAQ:PAYC",
      companyName: "Paycom Software Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-payo",
      code: "NASDAQ:PAYO",
      companyName: "Payoneer Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-payow",
      code: "NASDAQ:PAYOW",
      companyName: "Payoneer Global Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pays",
      code: "NASDAQ:PAYS",
      companyName: "Paysign Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-payx",
      code: "NASDAQ:PAYX",
      companyName: "Paychex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pb",
      code: "NASDAQ:PB",
      companyName: "Prosperity Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pba",
      code: "NASDAQ:PBA",
      companyName: "Pembina Pipeline Corp. Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbax",
      code: "NASDAQ:PBAX",
      companyName: "Phoenix Biotech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbaxu",
      code: "NASDAQ:PBAXU",
      companyName: "Phoenix Biotech Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbaxw",
      code: "NASDAQ:PBAXW",
      companyName: "Phoenix Biotech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbbk",
      code: "NASDAQ:PBBK",
      companyName: "PB Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbf",
      code: "NASDAQ:PBF",
      companyName: "PBF Energy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbfs",
      code: "NASDAQ:PBFS",
      companyName: "Pioneer Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbfx",
      code: "NASDAQ:PBFX",
      companyName:
        "PBF Logistics LP Common Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbh",
      code: "NASDAQ:PBH",
      companyName: "Prestige Consumer Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbhc",
      code: "NASDAQ:PBHC",
      companyName: "Pathfinder Bancorp Inc. Common Stock (MD)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbi",
      code: "NASDAQ:PBI",
      companyName: "Pitney Bowes Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbi-b",
      code: "NASDAQ:PBI-B",
      companyName: "Pitney Bowes Inc 6.70% Notes Due 2043",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbip",
      code: "NASDAQ:PBIP",
      companyName: "Prudential Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbla",
      code: "NASDAQ:PBLA",
      companyName: "Panbela Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbpb",
      code: "NASDAQ:PBPB",
      companyName: "Potbelly Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbt",
      code: "NASDAQ:PBT",
      companyName: "Permian Basin Royalty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbts",
      code: "NASDAQ:PBTS",
      companyName: "Powerbridge Technologies Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbyi",
      code: "NASDAQ:PBYI",
      companyName: "Puma Biotechnology Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcar",
      code: "NASDAQ:PCAR",
      companyName: "PACCAR Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcb",
      code: "NASDAQ:PCB",
      companyName: "PCB Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcct",
      code: "NASDAQ:PCCT",
      companyName: "Perception Capital Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcctw",
      code: "NASDAQ:PCCTW",
      companyName: "Perception Capital Corp. II Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcf",
      code: "NASDAQ:PCF",
      companyName: "High Income Securities Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcg",
      code: "NASDAQ:PCG",
      companyName: "Pacific Gas & Electric Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcg-a",
      code: "NASDAQ:PCG-A",
      companyName: "Pacific Gas & Electric Co. 6% Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcg-b",
      code: "NASDAQ:PCG-B",
      companyName: "Pacific Gas & Electric Co. 5 1/2% Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcg-c",
      code: "NASDAQ:PCG-C",
      companyName: "Pacific Gas & Electric Co. 5% 1st Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcg-d",
      code: "NASDAQ:PCG-D",
      companyName: "Pacific Gas & Electric Co. 5% 1st  Red. Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcg-e",
      code: "NASDAQ:PCG-E",
      companyName: "Pacific Gas & Electric Co. 5% 1st A Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcg-g",
      code: "NASDAQ:PCG-G",
      companyName: "Pacific Gas & Electric Co. 4.80% 1st Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcg-h",
      code: "NASDAQ:PCG-H",
      companyName: "Pacific Gas & Electric Co. 4.50% 1st Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcg-i",
      code: "NASDAQ:PCG-I",
      companyName: "Pacific Gas & Electric Co. 4.36% 1st Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcgu",
      code: "NASDAQ:PCGU",
      companyName: "Pacific Gas & Electric Co. Equity Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-pch",
      code: "NASDAQ:PCH",
      companyName: "PotlatchDeltic Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pck",
      code: "NASDAQ:PCK",
      companyName:
        "Pimco California Municipal Income Fund II Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcm",
      code: "NASDAQ:PCM",
      companyName: "PCM Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcn",
      code: "NASDAQ:PCN",
      companyName: "Pimco Corporate & Income Strategy Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcom",
      code: "NASDAQ:PCOM",
      companyName: "Points.com Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcor",
      code: "NASDAQ:PCOR",
      companyName: "Procore Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcpc",
      code: "NASDAQ:PCPC",
      companyName:
        "Periphas Capital Partnering Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcq",
      code: "NASDAQ:PCQ",
      companyName: "PIMCO California Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcrx",
      code: "NASDAQ:PCRX",
      companyName: "Pacira BioSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcsa",
      code: "NASDAQ:PCSA",
      companyName: "Processa Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcsb",
      code: "NASDAQ:PCSB",
      companyName: "PCSB Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pct",
      code: "NASDAQ:PCT",
      companyName: "PureCycle Technologies Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcti",
      code: "NASDAQ:PCTI",
      companyName: "PCTEL Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcttw",
      code: "NASDAQ:PCTTW",
      companyName: "PureCycle Technologies Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcty",
      code: "NASDAQ:PCTY",
      companyName: "Paylocity Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcvx",
      code: "NASDAQ:PCVX",
      companyName: "Vaxcyte Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcx",
      code: "NASDAQ:PCX",
      companyName: "Parsec Capital Acquisitions Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcxcu",
      code: "NASDAQ:PCXCU",
      companyName: "Parsec Capital Acquisitions Corp Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcyg",
      code: "NASDAQ:PCYG",
      companyName: "Park City Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pcyo",
      code: "NASDAQ:PCYO",
      companyName: "Pure Cycle Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pd",
      code: "NASDAQ:PD",
      companyName: "PagerDuty Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdce",
      code: "NASDAQ:PDCE",
      companyName: "PDC Energy Inc. Common Stock (Delaware)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdco",
      code: "NASDAQ:PDCO",
      companyName: "Patterson Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdd",
      code: "NASDAQ:PDD",
      companyName: "Pinduoduo Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdex",
      code: "NASDAQ:PDEX",
      companyName: "Pro-Dex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdfs",
      code: "NASDAQ:PDFS",
      companyName: "PDF Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdi",
      code: "NASDAQ:PDI",
      companyName: "PIMCO Dynamic Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdlb",
      code: "NASDAQ:PDLB",
      companyName: "Ponce Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdm",
      code: "NASDAQ:PDM",
      companyName: "Piedmont Office Realty Trust Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdo",
      code: "NASDAQ:PDO",
      companyName:
        "PIMCO Dynamic Income Opportunities Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdot",
      code: "NASDAQ:PDOT",
      companyName: "Peridot Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pds",
      code: "NASDAQ:PDS",
      companyName: "Precision Drilling Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdsb",
      code: "NASDAQ:PDSB",
      companyName: "PDS Biotechnology Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pdt",
      code: "NASDAQ:PDT",
      companyName: "John Hancock Premium Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-peak",
      code: "NASDAQ:PEAK",
      companyName: "Healthpeak Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pear",
      code: "NASDAQ:PEAR",
      companyName: "Pear Therapeutics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pearw",
      code: "NASDAQ:PEARW",
      companyName: "Pear Therapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-peb",
      code: "NASDAQ:PEB",
      companyName:
        "Pebblebrook Hotel Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-peb-e",
      code: "NASDAQ:PEB-E",
      companyName:
        "Pebblebrook Hotel Trust 6.375% Series E Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-peb-g",
      code: "NASDAQ:PEB-G",
      companyName:
        "Pebblebrook Hotel Trust 6.375% Series G Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-peb-h",
      code: "NASDAQ:PEB-H",
      companyName:
        "Pebblebrook Hotel Trust 5.700% Series H Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pebk",
      code: "NASDAQ:PEBK",
      companyName: "Peoples Bancorp of North Carolina Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pebo",
      code: "NASDAQ:PEBO",
      companyName: "Peoples Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-peco",
      code: "NASDAQ:PECO",
      companyName: "Phillips Edison & Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ped",
      code: "NASDAQ:PED",
      companyName: "Pedevco Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pega",
      code: "NASDAQ:PEGA",
      companyName: "Pegasystems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pegr",
      code: "NASDAQ:PEGR",
      companyName:
        "Project Energy Reimagined Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-pegy",
      code: "NASDAQ:PEGY",
      companyName: "Pineapple Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pei",
      code: "NASDAQ:PEI",
      companyName: "Pennsylvania Real Estate Investment Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pei-b",
      code: "NASDAQ:PEI-B",
      companyName:
        "Pennsylvania Real Estate Investment Trust Cumulative Redeemable Perpetual Preferred Shares Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-pei-c",
      code: "NASDAQ:PEI-C",
      companyName:
        "Pennsylvania Real Estate Investment Trust 7.20% Series C Cumulative Redeemable Perpetual Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pei-d",
      code: "NASDAQ:PEI-D",
      companyName:
        "Pennsylvania Real Estate Investment Trust 6.875% Series D Cumulative Redeemable Perpetual Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pen",
      code: "NASDAQ:PEN",
      companyName: "Penumbra Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-penn",
      code: "NASDAQ:PENN",
      companyName: "Penn National Gaming Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-peo",
      code: "NASDAQ:PEO",
      companyName: "Adams Natural Resources Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pepg",
      code: "NASDAQ:PEPG",
      companyName: "PepGen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pepl",
      code: "NASDAQ:PEPL",
      companyName:
        "PepperLime Health Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-peplu",
      code: "NASDAQ:PEPLU",
      companyName: "PepperLime Health Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-peplw",
      code: "NASDAQ:PEPLW",
      companyName: "PepperLime Health Acquisition Corporation Warrrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-peri",
      code: "NASDAQ:PERI",
      companyName: "Perion Network Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pesi",
      code: "NASDAQ:PESI",
      companyName: "Perma-Fix Environmental Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-petq",
      code: "NASDAQ:PETQ",
      companyName: "PetIQ Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pets",
      code: "NASDAQ:PETS",
      companyName: "PetMed Express Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-petv",
      code: "NASDAQ:PETV",
      companyName: "PetVivo Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-petvw",
      code: "NASDAQ:PETVW",
      companyName: "PetVivo Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-petz",
      code: "NASDAQ:PETZ",
      companyName: "TDH Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfbc",
      code: "NASDAQ:PFBC",
      companyName: "Preferred Bank Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfc",
      code: "NASDAQ:PFC",
      companyName: "Premier Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfd",
      code: "NASDAQ:PFD",
      companyName: "Flaherty & Crumrine Preferred and Income Fund Incorporated",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfdr",
      code: "NASDAQ:PFDR",
      companyName: "Pathfinder Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfdru",
      code: "NASDAQ:PFDRU",
      companyName: "Pathfinder Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfdrw",
      code: "NASDAQ:PFDRW",
      companyName: "Pathfinder Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfg",
      code: "NASDAQ:PFG",
      companyName: "Principal Financial Group Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfgc",
      code: "NASDAQ:PFGC",
      companyName: "Performance Food Group Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfh",
      code: "NASDAQ:PFH",
      companyName:
        "Prudential Financial Inc. 4.125% Junior Subordinated Notes due 2060",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfhd",
      code: "NASDAQ:PFHD",
      companyName: "Professional Holding Corp. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfie",
      code: "NASDAQ:PFIE",
      companyName: "Profire Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfin",
      code: "NASDAQ:PFIN",
      companyName: "P & F Industries Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfis",
      code: "NASDAQ:PFIS",
      companyName: "Peoples Financial Services Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfl",
      code: "NASDAQ:PFL",
      companyName: "PIMCO Income Strategy Fund Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pflt",
      code: "NASDAQ:PFLT",
      companyName: "PennantPark Floating Rate Capital Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfmt",
      code: "NASDAQ:PFMT",
      companyName: "Performant Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfn",
      code: "NASDAQ:PFN",
      companyName: "PIMCO Income Strategy Fund II",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfo",
      code: "NASDAQ:PFO",
      companyName:
        "Flaherty & Crumrine Preferred and Income Opportunity Fund Incorporated",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfs",
      code: "NASDAQ:PFS",
      companyName: "Provident Financial Services Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfsi",
      code: "NASDAQ:PFSI",
      companyName: "PennyMac Financial Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfsw",
      code: "NASDAQ:PFSW",
      companyName: "PFSweb Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfta",
      code: "NASDAQ:PFTA",
      companyName:
        "Portage Fintech Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-pftau",
      code: "NASDAQ:PFTAU",
      companyName: "Portage Fintech Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-pftaw",
      code: "NASDAQ:PFTAW",
      companyName: "Portage Fintech Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfx",
      code: "NASDAQ:PFX",
      companyName: "PhenixFIN Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pg",
      code: "NASDAQ:PG",
      companyName: "Procter & Gamble Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgc",
      code: "NASDAQ:PGC",
      companyName: "Peapack-Gladstone Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgen",
      code: "NASDAQ:PGEN",
      companyName: "Precigen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgny",
      code: "NASDAQ:PGNY",
      companyName: "Progyny Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgp",
      code: "NASDAQ:PGP",
      companyName:
        "Pimco Global Stocksplus & Income Fund Pimco Global StocksPlus & Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgre",
      code: "NASDAQ:PGRE",
      companyName: "Paramount Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgru",
      code: "NASDAQ:PGRU",
      companyName: "PropertyGuru Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgrw",
      code: "NASDAQ:PGRW",
      companyName: "Progress Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgrwu",
      code: "NASDAQ:PGRWU",
      companyName: "Progress Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgrww",
      code: "NASDAQ:PGRWW",
      companyName: "Progress Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgss",
      code: "NASDAQ:PGSS",
      companyName:
        "Pegasus Digital Mobility Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgti",
      code: "NASDAQ:PGTI",
      companyName: "PGT Innovations Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-pgz",
      code: "NASDAQ:PGZ",
      companyName:
        "Principal Real Estate Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ph",
      code: "NASDAQ:PH",
      companyName: "Parker-Hannifin Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-phar",
      code: "NASDAQ:PHAR",
      companyName:
        "Pharming Group N.V. ADS each representing 10 ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-phas",
      code: "NASDAQ:PHAS",
      companyName: "PhaseBio Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-phat",
      code: "NASDAQ:PHAT",
      companyName: "Phathom Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-phcf",
      code: "NASDAQ:PHCF",
      companyName:
        "Puhui Wealth Investment Management Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-phd",
      code: "NASDAQ:PHD",
      companyName: "Pioneer Floating Rate Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-phg",
      code: "NASDAQ:PHG",
      companyName: "Koninklijke Philips N.V. NY Registry Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-phge",
      code: "NASDAQ:PHGE",
      companyName: "BiomX Inc. COmmon Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-phi",
      code: "NASDAQ:PHI",
      companyName: "PLDT Inc. Sponsored ADR",
      popularity: 0,
    },
    {
      slug: "nasdaq-phic",
      code: "NASDAQ:PHIC",
      companyName:
        "Population Health Investment Co. Inc. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-phicu",
      code: "NASDAQ:PHICU",
      companyName: "Population Health Investment Co. Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-phicw",
      code: "NASDAQ:PHICW",
      companyName: "Population Health Investment Co. Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-phio",
      code: "NASDAQ:PHIO",
      companyName: "Phio Pharmaceuticals Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-phk",
      code: "NASDAQ:PHK",
      companyName: "Pimco High Income Fund Pimco High Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-phm",
      code: "NASDAQ:PHM",
      companyName: "PulteGroup Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-phr",
      code: "NASDAQ:PHR",
      companyName: "Phreesia Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pht",
      code: "NASDAQ:PHT",
      companyName: "Pioneer High Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-phun",
      code: "NASDAQ:PHUN",
      companyName: "Phunware Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-phunw",
      code: "NASDAQ:PHUNW",
      companyName: "Phunware Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-phvs",
      code: "NASDAQ:PHVS",
      companyName: "Pharvaris N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-phx",
      code: "NASDAQ:PHX",
      companyName: "PHX Minerals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-phyt",
      code: "NASDAQ:PHYT",
      companyName: "Pyrophyte Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pi",
      code: "NASDAQ:PI",
      companyName: "Impinj Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-piai",
      code: "NASDAQ:PIAI",
      companyName: "Prime Impact Acquisition I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-picc",
      code: "NASDAQ:PICC",
      companyName: "Pivotal Investment Corporation III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pii",
      code: "NASDAQ:PII",
      companyName: "Polaris Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-piii",
      code: "NASDAQ:PIII",
      companyName: "P3 Health Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-piiiw",
      code: "NASDAQ:PIIIW",
      companyName: "P3 Health Partners Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pik",
      code: "NASDAQ:PIK",
      companyName: "Kidpik Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pim",
      code: "NASDAQ:PIM",
      companyName: "Putnam Master Intermediate Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pinc",
      code: "NASDAQ:PINC",
      companyName: "Premier Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pine",
      code: "NASDAQ:PINE",
      companyName: "Alpine Income Property Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ping",
      code: "NASDAQ:PING",
      companyName: "Ping Identity Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pipp",
      code: "NASDAQ:PIPP",
      companyName: "Pine Island Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pipr",
      code: "NASDAQ:PIPR",
      companyName: "Piper Sandler Companies Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pirs",
      code: "NASDAQ:PIRS",
      companyName: "Pieris Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pixy",
      code: "NASDAQ:PIXY",
      companyName: "ShiftPixy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pjt",
      code: "NASDAQ:PJT",
      companyName: "PJT Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pk",
      code: "NASDAQ:PK",
      companyName: "Park Hotels & Resorts Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-pkbk",
      code: "NASDAQ:PKBK",
      companyName: "Parke Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pke",
      code: "NASDAQ:PKE",
      companyName: "Park Aerospace Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pkg",
      code: "NASDAQ:PKG",
      companyName: "Packaging Corporation of America Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pki",
      code: "NASDAQ:PKI",
      companyName: "PerkinElmer Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pkoh",
      code: "NASDAQ:PKOH",
      companyName: "Park-Ohio Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pl",
      code: "NASDAQ:PL",
      companyName: "Planet Labs PBC Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plab",
      code: "NASDAQ:PLAB",
      companyName: "Photronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plag",
      code: "NASDAQ:PLAG",
      companyName: "Planet Green Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plan",
      code: "NASDAQ:PLAN",
      companyName: "Anaplan Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plao",
      code: "NASDAQ:PLAO",
      companyName:
        "Patria Latin American Opportunity Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-plaou",
      code: "NASDAQ:PLAOU",
      companyName: "Patria Latin American Opportunity Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-plaow",
      code: "NASDAQ:PLAOW",
      companyName:
        "Patria Latin American Opportunity Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-play",
      code: "NASDAQ:PLAY",
      companyName: "Dave & Buster's Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plbc",
      code: "NASDAQ:PLBC",
      companyName: "Plumas Bancorp",
      popularity: 0,
    },
    {
      slug: "nasdaq-plby",
      code: "NASDAQ:PLBY",
      companyName: "PLBY Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plce",
      code: "NASDAQ:PLCE",
      companyName: "Children's Place Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pld",
      code: "NASDAQ:PLD",
      companyName: "Prologis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plg",
      code: "NASDAQ:PLG",
      companyName: "Platinum Group Metals Ltd. Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pll",
      code: "NASDAQ:PLL",
      companyName: "Piedmont Lithium Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plm",
      code: "NASDAQ:PLM",
      companyName: "Polymet Mining Corporation Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-plmi",
      code: "NASDAQ:PLMI",
      companyName: "Plum Acquisition Corp. I Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-plmiu",
      code: "NASDAQ:PLMIU",
      companyName: "Plum Acquisition Corp. I Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-plmiw",
      code: "NASDAQ:PLMIW",
      companyName: "Plum Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-plnt",
      code: "NASDAQ:PLNT",
      companyName: "Planet Fitness Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plow",
      code: "NASDAQ:PLOW",
      companyName: "Douglas Dynamics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plpc",
      code: "NASDAQ:PLPC",
      companyName: "Preformed Line Products Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plrx",
      code: "NASDAQ:PLRX",
      companyName: "Pliant Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plse",
      code: "NASDAQ:PLSE",
      companyName: "Pulse Biosciences Inc Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pltk",
      code: "NASDAQ:PLTK",
      companyName: "Playtika Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmd",
      code: "NASDAQ:PMD",
      companyName: "Psychemedics Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-plug",
      code: "NASDAQ:PLUG",
      companyName: "Plug Power Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plus",
      code: "NASDAQ:PLUS",
      companyName: "ePlus inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plx",
      code: "NASDAQ:PLX",
      companyName: "Protalix BioTherapeutics Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plxp",
      code: "NASDAQ:PLXP",
      companyName: "PLx Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plxs",
      code: "NASDAQ:PLXS",
      companyName: "Plexus Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plya",
      code: "NASDAQ:PLYA",
      companyName: "Playa Hotels & Resorts N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-plym",
      code: "NASDAQ:PLYM",
      companyName: "Plymouth Industrial REIT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plym-a",
      code: "NASDAQ:PLYM-A",
      companyName:
        "Plymouth Industrial REIT Inc. 7.50% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-plmr",
      code: "NASDAQ:PLMR",
      companyName: "Palomar Holdings Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmcb",
      code: "NASDAQ:PMCB",
      companyName: "PharmaCyte  Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pme",
      code: "NASDAQ:PME",
      companyName: "Pingtan Marine Enterprise Ltd.",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmf",
      code: "NASDAQ:PMF",
      companyName: "PIMCO Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmgm",
      code: "NASDAQ:PMGM",
      companyName: "Priveterra Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmgmu",
      code: "NASDAQ:PMGMU",
      companyName: "Priveterra Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmgmw",
      code: "NASDAQ:PMGMW",
      companyName: "Priveterra Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pml",
      code: "NASDAQ:PML",
      companyName:
        "Pimco Municipal Income Fund II Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmm",
      code: "NASDAQ:PMM",
      companyName: "Putnam Managed Municipal Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmo",
      code: "NASDAQ:PMO",
      companyName: "Putnam Municipal Opportunities Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmt",
      code: "NASDAQ:PMT",
      companyName:
        "PennyMac Mortgage Investment Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmt-a",
      code: "NASDAQ:PMT-A",
      companyName:
        "PennyMac Mortgage Investment Trust 8.125% Series A Fixed-to-Floating Rate Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmt-b",
      code: "NASDAQ:PMT-B",
      companyName:
        "PennyMac Mortgage Investment Trust 8.00% Series B Fixed-to-Floating Rate Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmt-c",
      code: "NASDAQ:PMT-C",
      companyName:
        "PennyMac Mortgage Investment Trust 6.75% Series C Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmts",
      code: "NASDAQ:PMTS",
      companyName: "CPI Card Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmvc",
      code: "NASDAQ:PMVC",
      companyName: "PMV Consumer Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmvp",
      code: "NASDAQ:PMVP",
      companyName: "PMV Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pmx",
      code: "NASDAQ:PMX",
      companyName:
        "PIMCO Municipal Income Fund III Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnbk",
      code: "NASDAQ:PNBK",
      companyName: "Patriot National Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnc",
      code: "NASDAQ:PNC",
      companyName: "PNC Financial Services Group Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnc-p",
      code: "NASDAQ:PNC-P",
      companyName:
        "PNC Financial Services Group Inc. (The) Depositary Shares Representing 1/4000th Perpetual Preferred Series P",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnfp",
      code: "NASDAQ:PNFP",
      companyName: "Pinnacle Financial Partners Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnfpp",
      code: "NASDAQ:PNFPP",
      companyName:
        "Pinnacle Financial Partners Inc. Depositary shares of Pinnacle Financial Partners Inc. each representing a 1/40th Interest in a share of its 6.75% Fixed-Rate Non-Cumulative Perpetual Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-pni",
      code: "NASDAQ:PNI",
      companyName:
        "Pimco New York Municipal Income Fund II Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnm",
      code: "NASDAQ:PNM",
      companyName: "PNM Resources Inc. (Holding Co.) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnnt",
      code: "NASDAQ:PNNT",
      companyName: "PennantPark Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnr",
      code: "NASDAQ:PNR",
      companyName: "Pentair plc. Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnrg",
      code: "NASDAQ:PNRG",
      companyName: "PrimeEnergy Resources Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pntg",
      code: "NASDAQ:PNTG",
      companyName: "The Pennant Group Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-pntm",
      code: "NASDAQ:PNTM",
      companyName: "Pontem Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnw",
      code: "NASDAQ:PNW",
      companyName: "Pinnacle West Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-poai",
      code: "NASDAQ:POAI",
      companyName: "Predictive Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-poet",
      code: "NASDAQ:POET",
      companyName: "POET Technologies Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pola",
      code: "NASDAQ:POLA",
      companyName: "Polar Power Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-poly",
      code: "NASDAQ:POLY",
      companyName: "Plantronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pond",
      code: "NASDAQ:POND",
      companyName: "Angel Pond Holdings Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pono",
      code: "NASDAQ:PONO",
      companyName: "Pono Capital Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ponow",
      code: "NASDAQ:PONOW",
      companyName: "Pono Capital Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pool",
      code: "NASDAQ:POOL",
      companyName: "Pool Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-por",
      code: "NASDAQ:POR",
      companyName: "Portland General Electric Co Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-port",
      code: "NASDAQ:PORT",
      companyName: "Southport Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-posh",
      code: "NASDAQ:POSH",
      companyName: "Poshmark Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-post",
      code: "NASDAQ:POST",
      companyName: "Post Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pow",
      code: "NASDAQ:POW",
      companyName: "Powered Brands Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-powi",
      code: "NASDAQ:POWI",
      companyName: "Power Integrations Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-powl",
      code: "NASDAQ:POWL",
      companyName: "Powell Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-powru",
      code: "NASDAQ:POWRU",
      companyName: "Powered Brands Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-powrw",
      code: "NASDAQ:POWRW",
      companyName: "Powered Brands Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-poww",
      code: "NASDAQ:POWW",
      companyName: "AMMO Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-powwp",
      code: "NASDAQ:POWWP",
      companyName:
        "AMMO Inc. 8.75% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppbi",
      code: "NASDAQ:PPBI",
      companyName: "Pacific Premier Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppbt",
      code: "NASDAQ:PPBT",
      companyName: "Purple Biotech Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppc",
      code: "NASDAQ:PPC",
      companyName: "Pilgrim's Pride Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppg",
      code: "NASDAQ:PPG",
      companyName: "PPG Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pphp",
      code: "NASDAQ:PPHP",
      companyName: "PHP Ventures Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pphpr",
      code: "NASDAQ:PPHPR",
      companyName: "PHP Ventures Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-pphpu",
      code: "NASDAQ:PPHPU",
      companyName: "PHP Ventures Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-pphpw",
      code: "NASDAQ:PPHPW",
      companyName: "PHP Ventures Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppih",
      code: "NASDAQ:PPIH",
      companyName: "Perma-Pipe International Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppl",
      code: "NASDAQ:PPL",
      companyName: "PPL Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppsi",
      code: "NASDAQ:PPSI",
      companyName: "Pioneer Power Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppt",
      code: "NASDAQ:PPT",
      companyName: "Putnam Premier Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppta",
      code: "NASDAQ:PPTA",
      companyName: "Perpetua Resources Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppyau",
      code: "NASDAQ:PPYAU",
      companyName: "Papaya Growth Opportunity Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ppyaw",
      code: "NASDAQ:PPYAW",
      companyName: "Papaya Growth Opportunity Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pra",
      code: "NASDAQ:PRA",
      companyName: "ProAssurance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-praa",
      code: "NASDAQ:PRAA",
      companyName: "PRA Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prax",
      code: "NASDAQ:PRAX",
      companyName: "Praxis Precision Medicines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prbm",
      code: "NASDAQ:PRBM",
      companyName: "Parabellum Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prch",
      code: "NASDAQ:PRCH",
      companyName: "Porch Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prct",
      code: "NASDAQ:PRCT",
      companyName: "PROCEPT BioRobotics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prdo",
      code: "NASDAQ:PRDO",
      companyName: "Perdoceo Education Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prds",
      code: "NASDAQ:PRDS",
      companyName: "Pardes Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pre-j",
      code: "NASDAQ:PRE-J",
      companyName:
        "PartnerRe Ltd. 4.875% Fixed Rate Non-Cumulative Redeemable Preferred Shares Series J",
      popularity: 0,
    },
    {
      slug: "nasdaq-prft",
      code: "NASDAQ:PRFT",
      companyName: "Perficient Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prfx",
      code: "NASDAQ:PRFX",
      companyName: "PainReform Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-prg",
      code: "NASDAQ:PRG",
      companyName: "PROG Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prgs",
      code: "NASDAQ:PRGS",
      companyName: "Progress Software Corporation Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pri",
      code: "NASDAQ:PRI",
      companyName: "Primerica Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prif-d",
      code: "NASDAQ:PRIF-D",
      companyName:
        "Priority Income Fund Inc. 7.00% Series D Term Preferred Stock due 2029",
      popularity: 0,
    },
    {
      slug: "nasdaq-prif-f",
      code: "NASDAQ:PRIF-F",
      companyName:
        "Priority Income Fund Inc. 6.625% Series F Term Preferred Stock due 2027",
      popularity: 0,
    },
    {
      slug: "nasdaq-prif-g",
      code: "NASDAQ:PRIF-G",
      companyName:
        "Priority Income Fund Inc. 6.25% Series G Preferred Stock Due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-prif-h",
      code: "NASDAQ:PRIF-H",
      companyName:
        "Priority Income Fund Inc. 6.00% Series H Term Preferred Stock due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-prif-i",
      code: "NASDAQ:PRIF-I",
      companyName:
        "Priority Income Fund Inc. 6.125% Series I Term Preferred Stock due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-prif-j",
      code: "NASDAQ:PRIF-J",
      companyName:
        "Priority Income Fund Inc. 6.000% Series J Term Preferred Stock due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-prif-k",
      code: "NASDAQ:PRIF-K",
      companyName:
        "Priority Income Fund Inc. 7.000% Series K Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prif-l",
      code: "NASDAQ:PRIF-L",
      companyName:
        "Priority Income Fund Inc. 6.375% Series L Term Preferred Stock Due 2029",
      popularity: 0,
    },
    {
      slug: "nasdaq-prim",
      code: "NASDAQ:PRIM",
      companyName: "Primoris Services Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prk",
      code: "NASDAQ:PRK",
      companyName: "Park National Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prlb",
      code: "NASDAQ:PRLB",
      companyName: "Proto Labs Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prld",
      code: "NASDAQ:PRLD",
      companyName: "Prelude Therapeutics Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prlh",
      code: "NASDAQ:PRLH",
      companyName: "Pearl Holdings Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-prlhu",
      code: "NASDAQ:PRLHU",
      companyName: "Pearl Holdings Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-prm",
      code: "NASDAQ:PRM",
      companyName: "Perimeter Solutions SA Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-prmw",
      code: "NASDAQ:PRMW",
      companyName: "Primo Water Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pro",
      code: "NASDAQ:PRO",
      companyName: "PROS Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-proc",
      code: "NASDAQ:PROC",
      companyName: "Procaps Group S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-procw",
      code: "NASDAQ:PROCW",
      companyName: "Procaps Group S.A. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-prof",
      code: "NASDAQ:PROF",
      companyName: "Profound Medical Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prog",
      code: "NASDAQ:PROG",
      companyName: "Biora Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prov",
      code: "NASDAQ:PROV",
      companyName: "Provident Financial Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prpb",
      code: "NASDAQ:PRPB",
      companyName: "CC Neuberger Principal Holdings II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-prpc",
      code: "NASDAQ:PRPC",
      companyName:
        "CC Neuberger Principal Holdings III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-prph",
      code: "NASDAQ:PRPH",
      companyName: "ProPhase Labs Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-prpl",
      code: "NASDAQ:PRPL",
      companyName: "Purple Innovation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prpo",
      code: "NASDAQ:PRPO",
      companyName: "Precipio Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prqr",
      code: "NASDAQ:PRQR",
      companyName: "ProQR Therapeutics N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-prs",
      code: "NASDAQ:PRS",
      companyName:
        "Prudential Financial Inc. 5.625% Junior Subordinated Notes due 2058",
      popularity: 0,
    },
    {
      slug: "nasdaq-prso",
      code: "NASDAQ:PRSO",
      companyName: "Peraso Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prsr",
      code: "NASDAQ:PRSR",
      companyName: "Prospector Capital Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-prsru",
      code: "NASDAQ:PRSRU",
      companyName: "Prospector Capital Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-prsrw",
      code: "NASDAQ:PRSRW",
      companyName: "Prospector Capital Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-prt",
      code: "NASDAQ:PRT",
      companyName: "PermRock Royalty Trust Trust Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-prta",
      code: "NASDAQ:PRTA",
      companyName: "Prothena Corporation plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-prtc",
      code: "NASDAQ:PRTC",
      companyName: "PureTech Health plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-prtg",
      code: "NASDAQ:PRTG",
      companyName: "Portage Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prth",
      code: "NASDAQ:PRTH",
      companyName: "Priority Technology Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prtk",
      code: "NASDAQ:PRTK",
      companyName: "Paratek Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prts",
      code: "NASDAQ:PRTS",
      companyName: "CarParts.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prty",
      code: "NASDAQ:PRTY",
      companyName: "Party City Holdco Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pru",
      code: "NASDAQ:PRU",
      companyName: "Prudential Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prva",
      code: "NASDAQ:PRVA",
      companyName: "Privia Health Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prvb",
      code: "NASDAQ:PRVB",
      companyName: "Provention Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa",
      code: "NASDAQ:PSA",
      companyName: "Public Storage Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-f",
      code: "NASDAQ:PSA-F",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 5.15% Cumulative Preferred Share of Beneficial Interest Series F par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-g",
      code: "NASDAQ:PSA-G",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 5.05% Cumulative Preferred Share of Beneficial Interest Series G",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-h",
      code: "NASDAQ:PSA-H",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a  5.60% Cumulative Preferred  Share of Beneficial Interest Series H",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-i",
      code: "NASDAQ:PSA-I",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.875% Cumulative Preferred Share of Beneficial Interest Series I par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-j",
      code: "NASDAQ:PSA-J",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.700% Cumulative Preferred Share of Beneficial Interest Series J par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-k",
      code: "NASDAQ:PSA-K",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.75% Cumulative Preferred Share of Beneficial Interest Series K",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-l",
      code: "NASDAQ:PSA-L",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.625% Cumulative Preferred Share of Beneficial Interest Series L par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-m",
      code: "NASDAQ:PSA-M",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.125% Cumulative Preferred Share of Beneficial Interest Series M",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-n",
      code: "NASDAQ:PSA-N",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 3.875% Cumulative Preferred Share of Beneficial Interest Series N",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-o",
      code: "NASDAQ:PSA-O",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 3.900% Cumulative Preferred Share of Beneficial Interest Series O",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-p",
      code: "NASDAQ:PSA-P",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.000% Cumulative Preferred Share of Bene cial Interest Series P",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-q",
      code: "NASDAQ:PSA-Q",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 3.950% Cumulative Preferred Share of Beneficial Interest Series Q par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-r",
      code: "NASDAQ:PSA-R",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.00% Cumulative Preferred Share of Bene cial Interest Series R",
      popularity: 0,
    },
    {
      slug: "nasdaq-psa-s",
      code: "NASDAQ:PSA-S",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.100% Cumulative Preferred Share of Beneficial Interest Series S",
      popularity: 0,
    },
    {
      slug: "nasdaq-psagu",
      code: "NASDAQ:PSAGU",
      companyName: "Property Solutions Acquisition Corporation II Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-psagw",
      code: "NASDAQ:PSAGW",
      companyName: "Property Solutions Acquisition Corporation II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-psb",
      code: "NASDAQ:PSB",
      companyName: "PS Business Parks Inc. (MD) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psb-x",
      code: "NASDAQ:PSB-X",
      companyName:
        "PS Business Parks Inc. Depositary Shares Each Representing 1/1000 of a Share of 5.25% Cumulative Preferred Stock Series X",
      popularity: 0,
    },
    {
      slug: "nasdaq-psb-y",
      code: "NASDAQ:PSB-Y",
      companyName:
        "PS Business Parks Inc. 5.20% Cumulative Preferred Stock Series Y",
      popularity: 0,
    },
    {
      slug: "nasdaq-psb-z",
      code: "NASDAQ:PSB-Z",
      companyName:
        "PS Business Parks Inc. Depositary Shares Each Representing 1/1000 of a Share of 4.875% Cumulative Preferred Stock Series Z  par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-psec",
      code: "NASDAQ:PSEC",
      companyName: "Prospect Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psec-a",
      code: "NASDAQ:PSEC-A",
      companyName:
        "Prospect Capital Corporation 5.35% Series A Fixed Rate Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psf",
      code: "NASDAQ:PSF",
      companyName:
        "Cohen & Steers Select Preferred and Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psfe",
      code: "NASDAQ:PSFE",
      companyName: "Paysafe Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pshg",
      code: "NASDAQ:PSHG",
      companyName: "Performance Shipping Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-psmt",
      code: "NASDAQ:PSMT",
      companyName: "PriceSmart Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psn",
      code: "NASDAQ:PSN",
      companyName: "Parsons Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psnl",
      code: "NASDAQ:PSNL",
      companyName: "Personalis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pso",
      code: "NASDAQ:PSO",
      companyName: "Pearson Plc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pspc",
      code: "NASDAQ:PSPC",
      companyName: "Post Holdings Partnering Corporation Series A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pstg",
      code: "NASDAQ:PSTG",
      companyName: "Pure Storage Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psth",
      code: "NASDAQ:PSTH",
      companyName: "Pershing Square Tontine Holdings Ltd. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psti",
      code: "NASDAQ:PSTI",
      companyName: "Pluristem Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pstl",
      code: "NASDAQ:PSTL",
      companyName: "Postal Realty Trust Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pstv",
      code: "NASDAQ:PSTV",
      companyName: "PLUS THERAPEUTICS Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-pstx",
      code: "NASDAQ:PSTX",
      companyName: "Poseida Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-psx",
      code: "NASDAQ:PSX",
      companyName: "Phillips 66 Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pt",
      code: "NASDAQ:PT",
      companyName:
        "Pintec Technology Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pta",
      code: "NASDAQ:PTA",
      companyName:
        "Cohen & Steers Tax-Advantaged Preferred Securities and Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptct",
      code: "NASDAQ:PTCT",
      companyName: "PTC Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pte",
      code: "NASDAQ:PTE",
      companyName: "PolarityTE Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pten",
      code: "NASDAQ:PTEN",
      companyName: "Patterson-UTI Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptgx",
      code: "NASDAQ:PTGX",
      companyName: "Protagonist Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptic",
      code: "NASDAQ:PTIC",
      companyName: "PropTech Investment Corporation II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pticu",
      code: "NASDAQ:PTICU",
      companyName: "PropTech Investment Corporation II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-pticw",
      code: "NASDAQ:PTICW",
      companyName: "PropTech Investment Corporation II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptix",
      code: "NASDAQ:PTIX",
      companyName: "Protagenic Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptixw",
      code: "NASDAQ:PTIXW",
      companyName: "Protagenic Therapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptlo",
      code: "NASDAQ:PTLO",
      companyName: "Portillo's Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptmn",
      code: "NASDAQ:PTMN",
      companyName: "Portman Ridge Finance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptn",
      code: "NASDAQ:PTN",
      companyName: "Palatin Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptnr",
      code: "NASDAQ:PTNR",
      companyName:
        "Partner Communications Company Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptoc",
      code: "NASDAQ:PTOC",
      companyName: "Pine Technology Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptocu",
      code: "NASDAQ:PTOCU",
      companyName: "Pine Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptocw",
      code: "NASDAQ:PTOCW",
      companyName: "Pine Technology Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptra",
      code: "NASDAQ:PTRA",
      companyName: "Proterra Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptrs",
      code: "NASDAQ:PTRS",
      companyName: "Partners Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptsi",
      code: "NASDAQ:PTSI",
      companyName: "P.A.M. Transportation Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptve",
      code: "NASDAQ:PTVE",
      companyName: "Pactiv Evergreen Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pty",
      code: "NASDAQ:PTY",
      companyName: "Pimco Corporate & Income Opportunity Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-pubm",
      code: "NASDAQ:PUBM",
      companyName: "PubMatic Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-puck",
      code: "NASDAQ:PUCK",
      companyName: "Goal Acquisitions Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pucku",
      code: "NASDAQ:PUCKU",
      companyName: "Goal Acquisitions Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-puckw",
      code: "NASDAQ:PUCKW",
      companyName: "Goal Acquisitions Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-puk",
      code: "NASDAQ:PUK",
      companyName: "Prudential Public Limited Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pulm",
      code: "NASDAQ:PULM",
      companyName: "Pulmatrix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pump",
      code: "NASDAQ:PUMP",
      companyName: "ProPetro Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-puyi",
      code: "NASDAQ:PUYI",
      companyName: "Puyi Inc. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pv",
      code: "NASDAQ:PV",
      companyName:
        "Primavera Capital Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pvbc",
      code: "NASDAQ:PVBC",
      companyName: "Provident Bancorp Inc. (MD) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pvh",
      code: "NASDAQ:PVH",
      companyName: "PVH Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pvl",
      code: "NASDAQ:PVL",
      companyName: "Permianville Royalty Trust Trust Units ",
      popularity: 0,
    },
    {
      slug: "nasdaq-pw",
      code: "NASDAQ:PW",
      companyName: "Power REIT (MD) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pw-a",
      code: "NASDAQ:PW-A",
      companyName:
        "Power REIT 7.75% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pwfl",
      code: "NASDAQ:PWFL",
      companyName: "PowerFleet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pwod",
      code: "NASDAQ:PWOD",
      companyName: "Penns Woods Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pwp",
      code: "NASDAQ:PWP",
      companyName: "Perella Weinberg Partners Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pwppw",
      code: "NASDAQ:PWPPW",
      companyName: "Perella Weinberg Partners Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-pwr",
      code: "NASDAQ:PWR",
      companyName: "Quanta Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pwsc",
      code: "NASDAQ:PWSC",
      companyName: "PowerSchool Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pwup",
      code: "NASDAQ:PWUP",
      companyName: "PowerUp Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pwupu",
      code: "NASDAQ:PWUPU",
      companyName: "PowerUp Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-pwupw",
      code: "NASDAQ:PWUPW",
      companyName: "PowerUp Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-px",
      code: "NASDAQ:PX",
      companyName: "P10 Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pxd",
      code: "NASDAQ:PXD",
      companyName: "Pioneer Natural Resources Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pxlw",
      code: "NASDAQ:PXLW",
      companyName: "Pixelworks Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pxs",
      code: "NASDAQ:PXS",
      companyName: "Pyxis Tankers Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pxsap",
      code: "NASDAQ:PXSAP",
      companyName:
        "Pyxis Tankers Inc. 7.75% Series A Cumulative Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pycr",
      code: "NASDAQ:PYCR",
      companyName: "Paycor HCM Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pyn",
      code: "NASDAQ:PYN",
      companyName:
        "PIMCO New York Municipal Income Fund III Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pypd",
      code: "NASDAQ:PYPD",
      companyName: "PolyPid Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pyr",
      code: "NASDAQ:PYR",
      companyName: "PyroGenesis Canada Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-pys",
      code: "NASDAQ:PYS",
      companyName: "Merrill Lynch Depositor Inc PPlus Tr Ser RRD-1 Tr Ctf Cl A",
      popularity: 0,
    },
    {
      slug: "nasdaq-pyt",
      code: "NASDAQ:PYT",
      companyName: "PPlus Tr GSC-2 Tr Ctf Fltg Rate",
      popularity: 0,
    },
    {
      slug: "nasdaq-pyxs",
      code: "NASDAQ:PYXS",
      companyName: "Pyxis Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pzc",
      code: "NASDAQ:PZC",
      companyName:
        "PIMCO California Municipal Income Fund III Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pzg",
      code: "NASDAQ:PZG",
      companyName: "Paramount Gold Nevada Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pzn",
      code: "NASDAQ:PZN",
      companyName: "Pzena Investment Management Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pzza",
      code: "NASDAQ:PZZA",
      companyName: "Papa John's International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qcrh",
      code: "NASDAQ:QCRH",
      companyName: "QCR Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qd",
      code: "NASDAQ:QD",
      companyName:
        "Qudian Inc. American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-qdel",
      code: "NASDAQ:QDEL",
      companyName: "Quidel Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qfin",
      code: "NASDAQ:QFIN",
      companyName: "360 DigiTech Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qfta",
      code: "NASDAQ:QFTA",
      companyName: "Quantum FinTech Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qgen",
      code: "NASDAQ:QGEN",
      companyName: "Qiagen N.V. Common Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-qh",
      code: "NASDAQ:QH",
      companyName: "Quhuo Limited American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qipt",
      code: "NASDAQ:QIPT",
      companyName: "Quipt Home Medical Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qk",
      code: "NASDAQ:QK",
      companyName: "Q&K International Group Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qlgn",
      code: "NASDAQ:QLGN",
      companyName: "Qualigen Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qli",
      code: "NASDAQ:QLI",
      companyName: "Qilian International Holding Group Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qlys",
      code: "NASDAQ:QLYS",
      companyName: "Qualys Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qmco",
      code: "NASDAQ:QMCO",
      companyName: "Quantum Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qngy",
      code: "NASDAQ:QNGY",
      companyName: "Quanergy Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qnrx",
      code: "NASDAQ:QNRX",
      companyName: "Quoin Pharmaceuticals Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qnst",
      code: "NASDAQ:QNST",
      companyName: "QuinStreet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qqqx",
      code: "NASDAQ:QQQX",
      companyName:
        "Nuveen NASDAQ 100 Dynamic Overwrite Fund Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-qrhc",
      code: "NASDAQ:QRHC",
      companyName: "Quest Resource Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qrtea",
      code: "NASDAQ:QRTEA",
      companyName: "Qurate Retail Inc. Series A Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-qrteb",
      code: "NASDAQ:QRTEB",
      companyName: "Qurate Retail Inc. Series B Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-qrtep",
      code: "NASDAQ:QRTEP",
      companyName:
        "Qurate Retail Inc. 8.0% Fixed Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qrvo",
      code: "NASDAQ:QRVO",
      companyName: "Qorvo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qsam",
      code: "NASDAQ:QSAM",
      companyName: "QSAM Biosciences Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-qsi",
      code: "NASDAQ:QSI",
      companyName: "Quantum-Si Incorporated Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qsiaw",
      code: "NASDAQ:QSIAW",
      companyName: "Quantum-Si Incorporated Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-qsr",
      code: "NASDAQ:QSR",
      companyName: "Restaurant Brands International Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qtek",
      code: "NASDAQ:QTEK",
      companyName: "QualTek Services Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qtekw",
      code: "NASDAQ:QTEKW",
      companyName: "QualTek Services Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-qtnt",
      code: "NASDAQ:QTNT",
      companyName: "Quotient Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qtrx",
      code: "NASDAQ:QTRX",
      companyName: "Quanterix Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qtt",
      code: "NASDAQ:QTT",
      companyName: "Qutoutiao Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qtwo",
      code: "NASDAQ:QTWO",
      companyName: "Q2 Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-quad",
      code: "NASDAQ:QUAD",
      companyName: "Quad Graphics Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qubt",
      code: "NASDAQ:QUBT",
      companyName: "Quantum Computing Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-quik",
      code: "NASDAQ:QUIK",
      companyName: "QuickLogic Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qumu",
      code: "NASDAQ:QUMU",
      companyName: "Qumu Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-quot",
      code: "NASDAQ:QUOT",
      companyName: "Quotient Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-qure",
      code: "NASDAQ:QURE",
      companyName: "uniQure N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-qvcc",
      code: "NASDAQ:QVCC",
      companyName: "QVC Inc. 6.250% Senior Secured Notes due 2068",
      popularity: 0,
    },
    {
      slug: "nasdaq-qvcd",
      code: "NASDAQ:QVCD",
      companyName: "QVC Inc. 6.375% Senior Secured Notes due 2067",
      popularity: 0,
    },
    {
      slug: "nasdaq-r",
      code: "NASDAQ:R",
      companyName: "Ryder System Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ra",
      code: "NASDAQ:RA",
      companyName: "Brookfield Real Assets Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-raas",
      code: "NASDAQ:RAAS",
      companyName:
        "Cloopen Group Holding Limited American Depositary Shares each representing two Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-racb",
      code: "NASDAQ:RACB",
      companyName: "Research Alliance Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-racy",
      code: "NASDAQ:RACY",
      companyName: "Relativity Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-racyu",
      code: "NASDAQ:RACYU",
      companyName: "Relativity Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-racyw",
      code: "NASDAQ:RACYW",
      companyName: "Relativity Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rad",
      code: "NASDAQ:RAD",
      companyName: "Rite Aid Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rada",
      code: "NASDAQ:RADA",
      companyName: "RADA Electronic Industries Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-radi",
      code: "NASDAQ:RADI",
      companyName: "Radius Global Infrastructure Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rail",
      code: "NASDAQ:RAIL",
      companyName: "FreightCar America Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rain",
      code: "NASDAQ:RAIN",
      companyName: "Rain Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ram",
      code: "NASDAQ:RAM",
      companyName: "Aries I Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-rammu",
      code: "NASDAQ:RAMMU",
      companyName: "Aries I Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rammw",
      code: "NASDAQ:RAMMW",
      companyName: "Aries I Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ramp",
      code: "NASDAQ:RAMP",
      companyName: "LiveRamp Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rand",
      code: "NASDAQ:RAND",
      companyName: "Rand Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rani",
      code: "NASDAQ:RANI",
      companyName: "Rani Therapeutics Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rapt",
      code: "NASDAQ:RAPT",
      companyName: "RAPT Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rare",
      code: "NASDAQ:RARE",
      companyName: "Ultragenyx Pharmaceutical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rave",
      code: "NASDAQ:RAVE",
      companyName: "Rave Restaurant Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rbac",
      code: "NASDAQ:RBAC",
      companyName: "RedBall Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rbb",
      code: "NASDAQ:RBB",
      companyName: "RBB Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rbbn",
      code: "NASDAQ:RBBN",
      companyName: "Ribbon Communications Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rbcaa",
      code: "NASDAQ:RBCAA",
      companyName: "Republic Bancorp Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rbcn",
      code: "NASDAQ:RBCN",
      companyName: "Rubicon Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rbkb",
      code: "NASDAQ:RBKB",
      companyName: "Rhinebeck Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rbot",
      code: "NASDAQ:RBOT",
      companyName: "Vicarious Surgical Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rc",
      code: "NASDAQ:RC",
      companyName: "Ready Capital Corproation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rca",
      code: "NASDAQ:RCA",
      companyName:
        "Ready Capital Corporation 7.00% Convertible Senior Notes due 2023",
      popularity: 0,
    },
    {
      slug: "nasdaq-qs",
      code: "NASDAQ:QS",
      companyName: "QuantumScape Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcacu",
      code: "NASDAQ:RCACU",
      companyName: "Revelstone Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcacw",
      code: "NASDAQ:RCACW",
      companyName: "Revelstone Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcat",
      code: "NASDAQ:RCAT",
      companyName: "Red Cat Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcb",
      code: "NASDAQ:RCB",
      companyName: "Ready Capital Corporation 6.20% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcc",
      code: "NASDAQ:RCC",
      companyName: "Ready Capital Corporation 5.75% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcel",
      code: "NASDAQ:RCEL",
      companyName: "Avita Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcfa",
      code: "NASDAQ:RCFA",
      companyName: "RCF Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcg",
      code: "NASDAQ:RCG",
      companyName: "RENN Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rchg",
      code: "NASDAQ:RCHG",
      companyName: "Recharge Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rchgw",
      code: "NASDAQ:RCHGW",
      companyName: "Recharge Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rci",
      code: "NASDAQ:RCI",
      companyName: "Rogers Communication Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcii",
      code: "NASDAQ:RCII",
      companyName: "Rent-A-Center Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rckt",
      code: "NASDAQ:RCKT",
      companyName: "Rocket Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcky",
      code: "NASDAQ:RCKY",
      companyName: "Rocky Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcl",
      code: "NASDAQ:RCL",
      companyName: "D/B/A Royal Caribbean Cruises Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rclf",
      code: "NASDAQ:RCLF",
      companyName: "Rosecliff Acquisition Corp I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rclfu",
      code: "NASDAQ:RCLFU",
      companyName: "Rosecliff Acquisition Corp I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rclfw",
      code: "NASDAQ:RCLFW",
      companyName: "Rosecliff Acquisition Corp I Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcm",
      code: "NASDAQ:RCM",
      companyName: "R1 RCM Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcmt",
      code: "NASDAQ:RCMT",
      companyName: "RCM Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcon",
      code: "NASDAQ:RCON",
      companyName: "Recon Technology Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcor",
      code: "NASDAQ:RCOR",
      companyName: "Renovacor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcrt",
      code: "NASDAQ:RCRT",
      companyName: "Recruiter.com Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcrtw",
      code: "NASDAQ:RCRTW",
      companyName: "Recruiter.com Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcs",
      code: "NASDAQ:RCS",
      companyName: "PIMCO Strategic Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-rcus",
      code: "NASDAQ:RCUS",
      companyName: "Arcus Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdbx",
      code: "NASDAQ:RDBX",
      companyName: "Redbox Entertainment Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdbxw",
      code: "NASDAQ:RDBXW",
      companyName: "Redbox Entertainment Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdcm",
      code: "NASDAQ:RDCM",
      companyName: "Radcom Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdfn",
      code: "NASDAQ:RDFN",
      companyName: "Redfin Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdhl",
      code: "NASDAQ:RDHL",
      companyName: "Redhill Biopharma Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdi",
      code: "NASDAQ:RDI",
      companyName: "Reading International Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdib",
      code: "NASDAQ:RDIB",
      companyName: "Reading International Inc Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdnt",
      code: "NASDAQ:RDNT",
      companyName: "RadNet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdus",
      code: "NASDAQ:RDUS",
      companyName: "Radius Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdvt",
      code: "NASDAQ:RDVT",
      companyName: "Red Violet Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdw",
      code: "NASDAQ:RDW",
      companyName: "Redwire Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdwr",
      code: "NASDAQ:RDWR",
      companyName: "Radware Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdy",
      code: "NASDAQ:RDY",
      companyName: "Dr. Reddy's Laboratories Ltd Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-re",
      code: "NASDAQ:RE",
      companyName: "Everest Re Group Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-reax",
      code: "NASDAQ:REAX",
      companyName: "The Real Brokerage Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-redu",
      code: "NASDAQ:REDU",
      companyName: "RISE Education Cayman Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ree",
      code: "NASDAQ:REE",
      companyName: "REE Automotive Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-reeaw",
      code: "NASDAQ:REEAW",
      companyName: "REE Automotive Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-reed",
      code: "NASDAQ:REED",
      companyName: "Reeds Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-refi",
      code: "NASDAQ:REFI",
      companyName: "Chicago Atlantic Real Estate Finance Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-refr",
      code: "NASDAQ:REFR",
      companyName: "Research Frontiers Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-reg",
      code: "NASDAQ:REG",
      companyName: "Regency Centers Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-regi",
      code: "NASDAQ:REGI",
      companyName: "Renewable Energy Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-regn",
      code: "NASDAQ:REGN",
      companyName: "Regeneron Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rei",
      code: "NASDAQ:REI",
      companyName: "Ring Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rekr",
      code: "NASDAQ:REKR",
      companyName: "Rekor Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-reli",
      code: "NASDAQ:RELI",
      companyName: "Reliance Global Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-reliw",
      code: "NASDAQ:RELIW",
      companyName: "Reliance Global Group Inc. Series A Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-rell",
      code: "NASDAQ:RELL",
      companyName: "Richardson Electronics Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rely",
      code: "NASDAQ:RELY",
      companyName: "Remitly Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-reneu",
      code: "NASDAQ:RENEU",
      companyName: "Cartesian Growth Corporation II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-renn",
      code: "NASDAQ:RENN",
      companyName:
        "Renren Inc. American Depositary Shares each representing fifteen Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-reno",
      code: "NASDAQ:RENO",
      companyName: "Renovare Environmental Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rent",
      code: "NASDAQ:RENT",
      companyName: "Rent the Runway Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rdn",
      code: "NASDAQ:RDN",
      companyName: "Radian Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-repx",
      code: "NASDAQ:REPX",
      companyName: "Riley Exploration Permian Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rere",
      code: "NASDAQ:RERE",
      companyName:
        "ATRenew Inc. American Depositary Shares (every three of which representing two Class A ordinary shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-res",
      code: "NASDAQ:RES",
      companyName: "RPC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-reta",
      code: "NASDAQ:RETA",
      companyName: "Reata Pharmaceuticals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-reto",
      code: "NASDAQ:RETO",
      companyName: "ReTo Eco-Solutions Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rev",
      code: "NASDAQ:REV",
      companyName: "Revlon Inc. New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-revb",
      code: "NASDAQ:REVB",
      companyName: "Revelation Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-revbw",
      code: "NASDAQ:REVBW",
      companyName: "Revelation Biosciences Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-reve",
      code: "NASDAQ:REVE",
      companyName: "Alpine Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-reveu",
      code: "NASDAQ:REVEU",
      companyName: "Alpine Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-revew",
      code: "NASDAQ:REVEW",
      companyName: "Alpine Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-revg",
      code: "NASDAQ:REVG",
      companyName: "REV Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-revh",
      code: "NASDAQ:REVH",
      companyName:
        "Revolution Healthcare Acquisition Corp. SAIL Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-revhu",
      code: "NASDAQ:REVHU",
      companyName: "Revolution Healthcare Acquisition Corp. SAIL Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-revhw",
      code: "NASDAQ:REVHW",
      companyName: "Revolution Healthcare Acquisition Corp. SAIL Warrant.",
      popularity: 0,
    },
    {
      slug: "nasdaq-rex",
      code: "NASDAQ:REX",
      companyName: "REX American Resources Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-rexr",
      code: "NASDAQ:REXR",
      companyName: "Rexford Industrial Realty Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rexr-b",
      code: "NASDAQ:REXR-B",
      companyName:
        "Rexford Industrial Realty Inc. 5.875% Series B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rexr-c",
      code: "NASDAQ:REXR-C",
      companyName:
        "Rexford Industrial Realty Inc. 5.625% Series C Cumulative Redeemable Preferred Stock par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-reyn",
      code: "NASDAQ:REYN",
      companyName: "Reynolds Consumer Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rezi",
      code: "NASDAQ:REZI",
      companyName: "Resideo Technologies Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-rf",
      code: "NASDAQ:RF",
      companyName: "Regions Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rf-b",
      code: "NASDAQ:RF-B",
      companyName:
        "Regions Financial Corporation Depositary Shares Representing 1/40th Perpetual Preferred Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-rf-c",
      code: "NASDAQ:RF-C",
      companyName:
        "Regions Financial Corporation Depositary Shares each Representing a 1/40th Interest in a  Share of 5.700% Fixed-to-Floating Rate Non-Cumulative  Perpetual Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-rf-e",
      code: "NASDAQ:RF-E",
      companyName:
        "Regions Financial Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of 4.45% Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfac",
      code: "NASDAQ:RFAC",
      companyName: "RF Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfacr",
      code: "NASDAQ:RFACR",
      companyName: "RF Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfacu",
      code: "NASDAQ:RFACU",
      companyName: "RF Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfacw",
      code: "NASDAQ:RFACW",
      companyName: "RF Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfi",
      code: "NASDAQ:RFI",
      companyName: "Cohen & Steers Total Return Realty Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfil",
      code: "NASDAQ:RFIL",
      companyName: "RF Industries Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfl",
      code: "NASDAQ:RFL",
      companyName: "Rafael Holdings Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfm",
      code: "NASDAQ:RFM",
      companyName:
        "RiverNorth Flexible Municipal Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfmz",
      code: "NASDAQ:RFMZ",
      companyName:
        "RiverNorth Flexible Municipal Income Fund II Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rfp",
      code: "NASDAQ:RFP",
      companyName: "Resolute Forest Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rga",
      code: "NASDAQ:RGA",
      companyName: "Reinsurance Group of America Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgc",
      code: "NASDAQ:RGC",
      companyName: "Regencell Bioscience Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgco",
      code: "NASDAQ:RGCO",
      companyName: "RGC Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgen",
      code: "NASDAQ:RGEN",
      companyName: "Repligen Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgf",
      code: "NASDAQ:RGF",
      companyName: "The Real Good Food Company Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgld",
      code: "NASDAQ:RGLD",
      companyName: "Royal Gold Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgls",
      code: "NASDAQ:RGLS",
      companyName: "Regulus Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgnx",
      code: "NASDAQ:RGNX",
      companyName: "REGENXBIO Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgp",
      code: "NASDAQ:RGP",
      companyName: "Resources Connection Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgr",
      code: "NASDAQ:RGR",
      companyName: "Sturm Ruger & Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgs",
      code: "NASDAQ:RGS",
      companyName: "Regis Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgt",
      code: "NASDAQ:RGT",
      companyName: "Royce Global Value Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgti",
      code: "NASDAQ:RGTI",
      companyName: "Rigetti Computing Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rgtiw",
      code: "NASDAQ:RGTIW",
      companyName: "Rigetti Computing Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-rh",
      code: "NASDAQ:RH",
      companyName: "RH Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rhe-a",
      code: "NASDAQ:RHE-A",
      companyName:
        "Regional Health Properties Inc. 10.875% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rhi",
      code: "NASDAQ:RHI",
      companyName: "Robert Half International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rhp",
      code: "NASDAQ:RHP",
      companyName: "Ryman Hospitality Properties Inc. (REIT)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ribt",
      code: "NASDAQ:RIBT",
      companyName: "RiceBran Technologies Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rico",
      code: "NASDAQ:RICO",
      companyName: "Agrico Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ricow",
      code: "NASDAQ:RICOW",
      companyName: "Agrico Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ride",
      code: "NASDAQ:RIDE",
      companyName: "Lordstown Motors Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rig",
      code: "NASDAQ:RIG",
      companyName: "Transocean Ltd (Switzerland) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rigl",
      code: "NASDAQ:RIGL",
      companyName: "Rigel Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rily",
      code: "NASDAQ:RILY",
      companyName: "B. Riley Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rilyg",
      code: "NASDAQ:RILYG",
      companyName: "B. Riley Financial Inc. 5.00% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-rilyk",
      code: "NASDAQ:RILYK",
      companyName: "B. Riley Financial Inc. 5.50% Senior Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-rilyl",
      code: "NASDAQ:RILYL",
      companyName:
        "B. Riley Financial Inc. Depositary Shares each representing 1/1000th in a share of 7.375% Series B Cumulative Perpetual Preferred Stock par value $0.0001",
      popularity: 0,
    },
    {
      slug: "nasdaq-rilym",
      code: "NASDAQ:RILYM",
      companyName: "B. Riley Financial Inc. 6.375% Senior Notes due 2025",
      popularity: 0,
    },
    {
      slug: "nasdaq-rilyn",
      code: "NASDAQ:RILYN",
      companyName: "B. Riley Financial Inc. 6.50% Senior Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-rilyo",
      code: "NASDAQ:RILYO",
      companyName: "B. Riley Financial Inc. 6.75% Senior Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-rilyp",
      code: "NASDAQ:RILYP",
      companyName:
        "B. Riley Financial Inc. Depositary Shares each representing a 1/1000th fractional interest in a share of Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rilyt",
      code: "NASDAQ:RILYT",
      companyName: "B. Riley Financial Inc. 6.00% Senior Notes Due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-rilyz",
      code: "NASDAQ:RILYZ",
      companyName: "B. Riley Financial Inc. 5.25% Senior Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-rio",
      code: "NASDAQ:RIO",
      companyName: "Rio Tinto Plc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmd",
      code: "NASDAQ:RMD",
      companyName: "ResMed Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-riv",
      code: "NASDAQ:RIV",
      companyName: "RiverNorth Opportunities Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-riv-a",
      code: "NASDAQ:RIV-A",
      companyName:
        "RiverNorth Opportunities Fund Inc. 6.00% Series A Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rjac",
      code: "NASDAQ:RJAC",
      companyName: "Jackson Acquisition Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rjf",
      code: "NASDAQ:RJF",
      companyName: "Raymond James Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rkda",
      code: "NASDAQ:RKDA",
      companyName: "Arcadia Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rklb",
      code: "NASDAQ:RKLB",
      companyName: "Rocket Lab USA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rkly",
      code: "NASDAQ:RKLY",
      companyName: "Rockley Photonics Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rkt",
      code: "NASDAQ:RKT",
      companyName: "Rocket Companies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rkta",
      code: "NASDAQ:RKTA",
      companyName:
        "Rocket Internet Growth Opportunities Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rlay",
      code: "NASDAQ:RLAY",
      companyName: "Relay Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rlgt",
      code: "NASDAQ:RLGT",
      companyName: "Radiant Logistics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rlgy",
      code: "NASDAQ:RLGY",
      companyName: "Realogy Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rli",
      code: "NASDAQ:RLI",
      companyName: "RLI Corp. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-rlj",
      code: "NASDAQ:RLJ",
      companyName:
        "RLJ Lodging Trust Common Shares of Beneficial Interest $0.01 par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-rlj-a",
      code: "NASDAQ:RLJ-A",
      companyName:
        "RLJ Lodging Trust $1.95 Series A Cumulative Convertible  Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rlmd",
      code: "NASDAQ:RLMD",
      companyName: "Relmada Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rlty",
      code: "NASDAQ:RLTY",
      companyName:
        "Cohen & Steers Real Estate Opportunities and Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-rlx",
      code: "NASDAQ:RLX",
      companyName:
        "RLX Technology Inc. American Depositary Shares each representing the right to receive one (1) Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-rlyb",
      code: "NASDAQ:RLYB",
      companyName: "Rallybio Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rm",
      code: "NASDAQ:RM",
      companyName: "Regional Management Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmax",
      code: "NASDAQ:RMAX",
      companyName: "RE/MAX Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmbi",
      code: "NASDAQ:RMBI",
      companyName: "Richmond Mutual Bancorporation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmbl",
      code: "NASDAQ:RMBL",
      companyName: "RumbleOn Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmbs",
      code: "NASDAQ:RMBS",
      companyName: "Rambus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmcf",
      code: "NASDAQ:RMCF",
      companyName: "Rocky Mountain Chocolate Factory Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmed",
      code: "NASDAQ:RMED",
      companyName: "Ra Medical Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmgc",
      code: "NASDAQ:RMGC",
      companyName: "RMG Acquisition Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmgcu",
      code: "NASDAQ:RMGCU",
      companyName: "RMG Acquisition Corp. III Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmgcw",
      code: "NASDAQ:RMGCW",
      companyName: "RMG Acquisition Corp. III Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmi",
      code: "NASDAQ:RMI",
      companyName:
        "RiverNorth Opportunistic Municipal Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmmz",
      code: "NASDAQ:RMMZ",
      companyName:
        "RiverNorth Managed Duration Municipal Income Fund II Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmo",
      code: "NASDAQ:RMO",
      companyName: "Romeo Power Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmpl-",
      code: "NASDAQ:RMPL-",
      companyName: "RiverNorth Specialty Finance Corporation 5.875%",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmr",
      code: "NASDAQ:RMR",
      companyName: "The RMR Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmt",
      code: "NASDAQ:RMT",
      companyName: "Royce Micro-Cap Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmti",
      code: "NASDAQ:RMTI",
      companyName: "Rockwell Medical Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rna",
      code: "NASDAQ:RNA",
      companyName: "Avidity Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnaz",
      code: "NASDAQ:RNAZ",
      companyName: "TransCode Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rndb",
      code: "NASDAQ:RNDB",
      companyName: "Randolph Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rner",
      code: "NASDAQ:RNER",
      companyName: "Mount Rainier Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rl",
      code: "NASDAQ:RL",
      companyName: "Ralph Lauren Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rneru",
      code: "NASDAQ:RNERU",
      companyName: "Mount Rainier Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnerw",
      code: "NASDAQ:RNERW",
      companyName: "Mount Rainier Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rng",
      code: "NASDAQ:RNG",
      companyName: "RingCentral Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rngr",
      code: "NASDAQ:RNGR",
      companyName: "Ranger Energy Services Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnlx",
      code: "NASDAQ:RNLX",
      companyName: "Renalytix plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnp",
      code: "NASDAQ:RNP",
      companyName:
        "Cohen & Steers REIT and Preferred and Income Fund Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnr",
      code: "NASDAQ:RNR",
      companyName: "RenaissanceRe Holdings Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnr-f",
      code: "NASDAQ:RNR-F",
      companyName:
        "RenaissanceRe Holdings Ltd. Depositary Shares each Representing a 1/1000th Interest in a 5.750% Series F Preference Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnr-g",
      code: "NASDAQ:RNR-G",
      companyName:
        "RenaissanceRe Holdings Ltd. Depositary Shares each representing a 1/1000th interest in a share of 4.20% Series G Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnst",
      code: "NASDAQ:RNST",
      companyName: "Renasant Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnw",
      code: "NASDAQ:RNW",
      companyName: "ReNew Energy Global plc Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnwk",
      code: "NASDAQ:RNWK",
      companyName: "RealNetworks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnwww",
      code: "NASDAQ:RNWWW",
      companyName: "ReNew Energy Global plc Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rnxt",
      code: "NASDAQ:RNXT",
      companyName: "RenovoRx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-road",
      code: "NASDAQ:ROAD",
      companyName: "Construction Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-roc",
      code: "NASDAQ:ROC",
      companyName: "ROC Energy Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rocar",
      code: "NASDAQ:ROCAR",
      companyName: "ROC Energy Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-rocau",
      code: "NASDAQ:ROCAU",
      companyName: "ROC Energy Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rocc",
      code: "NASDAQ:ROCC",
      companyName: "Ranger Oil Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rocg",
      code: "NASDAQ:ROCG",
      companyName: "Roth CH Acquisition IV Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rocgu",
      code: "NASDAQ:ROCGU",
      companyName: "Roth CH Acquisition IV Co. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rocgw",
      code: "NASDAQ:ROCGW",
      companyName: "Roth CH Acquisition IV Co. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rock",
      code: "NASDAQ:ROCK",
      companyName: "Gibraltar Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rocl",
      code: "NASDAQ:ROCL",
      companyName: "Roth CH Acquisition V Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-roclu",
      code: "NASDAQ:ROCLU",
      companyName: "Roth CH Acquisition V Co. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-roclw",
      code: "NASDAQ:ROCLW",
      companyName: "Roth CH Acquisition V Co. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rog",
      code: "NASDAQ:ROG",
      companyName: "Rogers Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-roic",
      code: "NASDAQ:ROIC",
      companyName: "Retail Opportunity Investments Corp. Common Stock (MD)",
      popularity: 0,
    },
    {
      slug: "nasdaq-roivw",
      code: "NASDAQ:ROIVW",
      companyName: "Roivant Sciences Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rok",
      code: "NASDAQ:ROK",
      companyName: "Rockwell Automation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rol",
      code: "NASDAQ:ROL",
      companyName: "Rollins Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-roll",
      code: "NASDAQ:ROLL",
      companyName: "RBC Bearings Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rollp",
      code: "NASDAQ:ROLLP",
      companyName:
        "RBC Bearings Incorporated 5.00% Series A Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-roni",
      code: "NASDAQ:RONI",
      companyName: "Rice Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-root",
      code: "NASDAQ:ROOT",
      companyName: "Root Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rop",
      code: "NASDAQ:ROP",
      companyName: "Roper Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rose",
      code: "NASDAQ:ROSE",
      companyName: "Rose Hill Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-roseu",
      code: "NASDAQ:ROSEU",
      companyName: "Rose Hill Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rosew",
      code: "NASDAQ:ROSEW",
      companyName: "Rose Hill Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rovr",
      code: "NASDAQ:ROVR",
      companyName: "Rover Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rpay",
      code: "NASDAQ:RPAY",
      companyName: "Repay Holdings Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rpd",
      code: "NASDAQ:RPD",
      companyName: "Rapid7 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rphm",
      code: "NASDAQ:RPHM",
      companyName: "Reneo Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rpm",
      code: "NASDAQ:RPM",
      companyName: "RPM International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rprx",
      code: "NASDAQ:RPRX",
      companyName: "Royalty Pharma plc Class A Ordinary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-rpt",
      code: "NASDAQ:RPT",
      companyName: "RPT Realty Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rpt-d",
      code: "NASDAQ:RPT-D",
      companyName: "RPT Realty 7.25%",
      popularity: 0,
    },
    {
      slug: "nasdaq-rptx",
      code: "NASDAQ:RPTX",
      companyName: "Repare Therapeutics Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rqi",
      code: "NASDAQ:RQI",
      companyName:
        "Cohen & Steers Quality Income Realty Fund Inc Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rrac",
      code: "NASDAQ:RRAC",
      companyName: "Rigel Resource Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rrbi",
      code: "NASDAQ:RRBI",
      companyName: "Red River Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rrc",
      code: "NASDAQ:RRC",
      companyName: "Range Resources Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rrgb",
      code: "NASDAQ:RRGB",
      companyName: "Red Robin Gourmet Burgers Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rrr",
      code: "NASDAQ:RRR",
      companyName: "Red Rock Resorts Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rrx",
      code: "NASDAQ:RRX",
      companyName: "Regal Rexnord Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rs",
      code: "NASDAQ:RS",
      companyName: "Reliance Steel & Aluminum Co. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ryan",
      code: "NASDAQ:RYAN",
      companyName: "Ryan Specialty Group Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rsf",
      code: "NASDAQ:RSF",
      companyName: "RiverNorth Specialty Finance Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-rsi",
      code: "NASDAQ:RSI",
      companyName: "Rush Street Interactive Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rskd",
      code: "NASDAQ:RSKD",
      companyName: "Riskified Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rsls",
      code: "NASDAQ:RSLS",
      companyName: "ReShape Lifesciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rsss",
      code: "NASDAQ:RSSS",
      companyName: "Research Solutions Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rsvr",
      code: "NASDAQ:RSVR",
      companyName: "Reservoir Media Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rsvrw",
      code: "NASDAQ:RSVRW",
      companyName: "Reservoir Media Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rtl",
      code: "NASDAQ:RTL",
      companyName: "The Necessity Retail REIT Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rtlpo",
      code: "NASDAQ:RTLPO",
      companyName:
        "The Necessity Retail REIT Inc. 7.375% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rtlpp",
      code: "NASDAQ:RTLPP",
      companyName:
        "The Necessity Retail REIT Inc. 7.50% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rtlr",
      code: "NASDAQ:RTLR",
      companyName: "Rattler Midstream LP Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-rtx",
      code: "NASDAQ:RTX",
      companyName: "Raytheon Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ruby",
      code: "NASDAQ:RUBY",
      companyName: "Rubius Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-run",
      code: "NASDAQ:RUN",
      companyName: "Sunrun Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rusha",
      code: "NASDAQ:RUSHA",
      companyName: "Rush Enterprises Inc. Common Stock Cl A",
      popularity: 0,
    },
    {
      slug: "nasdaq-rushb",
      code: "NASDAQ:RUSHB",
      companyName: "Rush Enterprises Inc. Class B",
      popularity: 0,
    },
    {
      slug: "nasdaq-ruth",
      code: "NASDAQ:RUTH",
      companyName: "Ruth's Hospitality Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvac",
      code: "NASDAQ:RVAC",
      companyName: "Riverview Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvacu",
      code: "NASDAQ:RVACU",
      companyName: "Riverview Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvacw",
      code: "NASDAQ:RVACW",
      companyName: "Riverview Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvlp",
      code: "NASDAQ:RVLP",
      companyName: "RVL Pharmaceuticals plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvlv",
      code: "NASDAQ:RVLV",
      companyName: "Revolve Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvmd",
      code: "NASDAQ:RVMD",
      companyName: "Revolution Medicines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvnc",
      code: "NASDAQ:RVNC",
      companyName: "Revance Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvp",
      code: "NASDAQ:RVP",
      companyName: "Retractable Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvph",
      code: "NASDAQ:RVPH",
      companyName: "Reviva Pharmaceuticals Holdings Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvphw",
      code: "NASDAQ:RVPHW",
      companyName: "Reviva Pharmaceuticals Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvsb",
      code: "NASDAQ:RVSB",
      companyName: "Riverview Bancorp Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvsn",
      code: "NASDAQ:RVSN",
      companyName: "Rail Vision Ltd. Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvsnw",
      code: "NASDAQ:RVSNW",
      companyName: "Rail Vision Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-rvt",
      code: "NASDAQ:RVT",
      companyName: "Royce Value Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rway",
      code: "NASDAQ:RWAY",
      companyName: "Runway Growth Finance Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rwlk",
      code: "NASDAQ:RWLK",
      companyName: "ReWalk Robotics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-rwod",
      code: "NASDAQ:RWOD",
      companyName: "Redwoods Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rwodr",
      code: "NASDAQ:RWODR",
      companyName: "Redwoods Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-rwodu",
      code: "NASDAQ:RWODU",
      companyName: "Redwoods Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-rwodw",
      code: "NASDAQ:RWODW",
      companyName: "Redwoods Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-rwt",
      code: "NASDAQ:RWT",
      companyName: "Redwood Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rxra",
      code: "NASDAQ:RXRA",
      companyName: "RXR Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rxrau",
      code: "NASDAQ:RXRAU",
      companyName: "RXR Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-rxraw",
      code: "NASDAQ:RXRAW",
      companyName:
        "RXR Acquisition Corp. Warrants to purchase Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rxst",
      code: "NASDAQ:RXST",
      companyName: "RxSight Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rxt",
      code: "NASDAQ:RXT",
      companyName: "Rackspace Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ryaay",
      code: "NASDAQ:RYAAY",
      companyName: "Ryanair Holdings plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ryam",
      code: "NASDAQ:RYAM",
      companyName: "Rayonier Advanced Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ryb",
      code: "NASDAQ:RYB",
      companyName:
        "RYB Education Inc. American depositary shares each representing one Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ryi",
      code: "NASDAQ:RYI",
      companyName: "Ryerson Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ryn",
      code: "NASDAQ:RYN",
      companyName: "Rayonier Inc. REIT Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rytm",
      code: "NASDAQ:RYTM",
      companyName: "Rhythm Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rza",
      code: "NASDAQ:RZA",
      companyName:
        "Reinsurance Group of America Incorporated 6.20% Fixed-to-Floating Rate Subordinated Debentures due 2042",
      popularity: 0,
    },
    {
      slug: "nasdaq-rzb",
      code: "NASDAQ:RZB",
      companyName:
        "Reinsurance Group of America Incorporated 5.75% Fixed-To-Floating Rate Subordinated Debentures due 2056",
      popularity: 0,
    },
    {
      slug: "nasdaq-rzlt",
      code: "NASDAQ:RZLT",
      companyName: "Rezolute Inc. Common Stock (NV)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sa",
      code: "NASDAQ:SA",
      companyName: "Seabridge Gold Inc. Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sabr",
      code: "NASDAQ:SABR",
      companyName: "Sabre Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sabrp",
      code: "NASDAQ:SABRP",
      companyName:
        "Sabre Corporation 6.50% Series A Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sabs",
      code: "NASDAQ:SABS",
      companyName: "SAB Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sabsw",
      code: "NASDAQ:SABSW",
      companyName: "SAB Biotherapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sacc",
      code: "NASDAQ:SACC",
      companyName: "Sachem Capital Corp. 6.875% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-sach",
      code: "NASDAQ:SACH",
      companyName: "Sachem Capital Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sach-a",
      code: "NASDAQ:SACH-A",
      companyName:
        "Sachem Capital Corp. 7.75% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-safe",
      code: "NASDAQ:SAFE",
      companyName: "Safehold Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-safm",
      code: "NASDAQ:SAFM",
      companyName: "Sanderson Farms Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-saft",
      code: "NASDAQ:SAFT",
      companyName: "Safety Insurance Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-saga",
      code: "NASDAQ:SAGA",
      companyName: "Sagaliam Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sagar",
      code: "NASDAQ:SAGAR",
      companyName: "Sagaliam Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-sagau",
      code: "NASDAQ:SAGAU",
      companyName: "Sagaliam Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-sage",
      code: "NASDAQ:SAGE",
      companyName: "Sage Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sah",
      code: "NASDAQ:SAH",
      companyName: "Sonic Automotive Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sai",
      code: "NASDAQ:SAI",
      companyName: "SAI.TECH Global Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-saia",
      code: "NASDAQ:SAIA",
      companyName: "Saia Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-saic",
      code: "NASDAQ:SAIC",
      companyName:
        "SCIENCE APPLICATIONS INTERNATIONAL CORPORATION Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sail",
      code: "NASDAQ:SAIL",
      companyName: "SailPoint Technologies Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-saitw",
      code: "NASDAQ:SAITW",
      companyName: "SAI.TECH Global Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sak",
      code: "NASDAQ:SAK",
      companyName: "Saratoga Investment Corp 7.25% Notes due 2025",
      popularity: 0,
    },
    {
      slug: "nasdaq-sal",
      code: "NASDAQ:SAL",
      companyName: "Salisbury Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-salm",
      code: "NASDAQ:SALM",
      companyName: "Salem Media Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sam",
      code: "NASDAQ:SAM",
      companyName: "Boston Beer Company Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sama",
      code: "NASDAQ:SAMA",
      companyName:
        "Schultze Special Purpose Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-samaw",
      code: "NASDAQ:SAMAW",
      companyName: "Schultze Special Purpose Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-samg",
      code: "NASDAQ:SAMG",
      companyName:
        "Silvercrest Asset Management Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-san",
      code: "NASDAQ:SAN",
      companyName: "Banco Santander S.A. Sponsored ADR (Spain)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sana",
      code: "NASDAQ:SANA",
      companyName: "Sana Biotechnology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sanb",
      code: "NASDAQ:SANB",
      companyName: "Sanaby Health Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sand",
      code: "NASDAQ:SAND          ",
      companyName: "Sandstorm Gold Ltd. Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sang",
      code: "NASDAQ:SANG",
      companyName: "Sangoma Technologies Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sanm",
      code: "NASDAQ:SANM",
      companyName: "Sanmina Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sanw",
      code: "NASDAQ:SANW",
      companyName: "S&W Seed Company Common Stock (NV)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sar",
      code: "NASDAQ:SAR",
      companyName: "Saratoga Investment Corp New",
      popularity: 0,
    },
    {
      slug: "nasdaq-sasr",
      code: "NASDAQ:SASR",
      companyName: "Sandy Spring Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sat",
      code: "NASDAQ:SAT",
      companyName: "Saratoga Investment Corp 6.00% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nasdaq-satl",
      code: "NASDAQ:SATL",
      companyName: "Satellogic Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-satlw",
      code: "NASDAQ:SATLW",
      companyName: "Satellogic Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sats",
      code: "NASDAQ:SATS",
      companyName: "EchoStar  Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sava",
      code: "NASDAQ:SAVA",
      companyName: "Cassava Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-save",
      code: "NASDAQ:SAVE",
      companyName: "Spirit Airlines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbac",
      code: "NASDAQ:SBAC",
      companyName: "SBA Communications Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbba",
      code: "NASDAQ:SBBA",
      companyName: "Scorpio Tankers Inc. 7.00% Senior Notes due 2025",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbcf",
      code: "NASDAQ:SBCF",
      companyName: "Seacoast Banking Corporation of Florida Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbet",
      code: "NASDAQ:SBET",
      companyName: "SharpLink Gaming Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbev",
      code: "NASDAQ:SBEV",
      companyName: "Splash Beverage Group Inc. (NV) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbfg",
      code: "NASDAQ:SBFG",
      companyName: "SB Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbfm",
      code: "NASDAQ:SBFM",
      companyName: "Sunshine Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbfmw",
      code: "NASDAQ:SBFMW",
      companyName: "Sunshine Biopharma Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbgi",
      code: "NASDAQ:SBGI",
      companyName: "Sinclair Broadcast Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbh",
      code: "NASDAQ:SBH",
      companyName:
        "Sally Beauty Holdings Inc. (Name to be changed from Sally Holdings Inc.) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbi",
      code: "NASDAQ:SBI",
      companyName: "Western Asset Intermediate Muni Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbii",
      code: "NASDAQ:SBII",
      companyName: "Sandbridge X2 Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbnyp",
      code: "NASDAQ:SBNYP",
      companyName:
        "Signature Bank Depositary shares each representing a 1/40th ownership interest in a share of 5.000% Noncumulative Perpetual Series A Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbow",
      code: "NASDAQ:SBOW",
      companyName: "SilverBow Resorces Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbr",
      code: "NASDAQ:SBR",
      companyName: "Sabine Royalty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbra",
      code: "NASDAQ:SBRA",
      companyName: "Sabra Health Care REIT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbs",
      code: "NASDAQ:SBS",
      companyName:
        "Companhia de saneamento Basico Do Estado De Sao Paulo - Sabesp American Depositary Shares (Each repstg 250 Common Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbsi",
      code: "NASDAQ:SBSI",
      companyName: "Southside Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbsw",
      code: "NASDAQ:SBSW",
      companyName: "D/B/A Sibanye-Stillwater Limited ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbt",
      code: "NASDAQ:SBT",
      companyName: "Sterling Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbtx",
      code: "NASDAQ:SBTX",
      companyName: "Silverback Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scaqu",
      code: "NASDAQ:SCAQU",
      companyName: "Stratim Cloud Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-scaqw",
      code: "NASDAQ:SCAQW",
      companyName: "Stratim Cloud Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sccb",
      code: "NASDAQ:SCCB",
      companyName: "Sachem Capital Corp. 7.125% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-sccc",
      code: "NASDAQ:SCCC",
      companyName: "Sachem Capital Corp. 7.75% Notes due 2025",
      popularity: 0,
    },
    {
      slug: "nasdaq-sccd",
      code: "NASDAQ:SCCD",
      companyName: "Sachem Capital Corp. 6.00% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-scce",
      code: "NASDAQ:SCCE",
      companyName: "Sachem Capital Corp. 6.00% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nasdaq-scco",
      code: "NASDAQ:SCCO",
      companyName: "Southern Copper Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scd",
      code: "NASDAQ:SCD",
      companyName: "LMP Capital and Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sce-g",
      code: "NASDAQ:SCE-G",
      companyName: "SCE Trust II Trust Preferred Securities",
      popularity: 0,
    },
    {
      slug: "nasdaq-sce-h",
      code: "NASDAQ:SCE-H",
      companyName:
        "SCE Trust III Fixed/Floating Rate Trust Preference Securities",
      popularity: 0,
    },
    {
      slug: "nasdaq-sce-j",
      code: "NASDAQ:SCE-J",
      companyName:
        "Southern California Edison Company 5.375% Fixed-to-Floating Rate Trust Preference Securities",
      popularity: 0,
    },
    {
      slug: "nasdaq-sce-k",
      code: "NASDAQ:SCE-K",
      companyName:
        "Southern California Edison Company 5.45% Fixed-to-Floating Rate Trust Preference Securities",
      popularity: 0,
    },
    {
      slug: "nasdaq-sce-l",
      code: "NASDAQ:SCE-L",
      companyName: "SCE TRUST VI",
      popularity: 0,
    },
    {
      slug: "nasdaq-schl",
      code: "NASDAQ:SCHL",
      companyName: "Scholastic Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-schn",
      code: "NASDAQ:SCHN",
      companyName: "Schnitzer Steel Industries Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-schw-d",
      code: "NASDAQ:SCHW-D",
      companyName:
        "The Charles Schwab Corporation Depositary Shares each representing 1/40th interest in a share of 5.95% Non-Cumulative Perpetual Preferred Stock Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-schw-j",
      code: "NASDAQ:SCHW-J",
      companyName:
        "The Charles Schwab Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of 4.450% Non-Cumulative Perpetual Preferred Stock Series J",
      popularity: 0,
    },
    {
      slug: "nasdaq-sci",
      code: "NASDAQ:SCI",
      companyName: "Service Corporation International Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sckt",
      code: "NASDAQ:SCKT",
      companyName: "Socket Mobile Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scl",
      code: "NASDAQ:SCL",
      companyName: "Stepan Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scle",
      code: "NASDAQ:SCLE",
      companyName: "Broadscale Acquisition Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scleu",
      code: "NASDAQ:SCLEU",
      companyName: "Broadscale Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-sclew",
      code: "NASDAQ:SCLEW",
      companyName: "Broadscale Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-scm",
      code: "NASDAQ:SCM",
      companyName: "Stellus Capital Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scma",
      code: "NASDAQ:SCMA",
      companyName:
        "Seaport Calibre Materials Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scmaw",
      code: "NASDAQ:SCMAW",
      companyName: "Seaport Calibre Materials Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-scoa",
      code: "NASDAQ:SCOA",
      companyName: "ScION Tech Growth I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-scoau",
      code: "NASDAQ:SCOAU",
      companyName: "ScION Tech Growth I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-scoaw",
      code: "NASDAQ:SCOAW",
      companyName: "ScION Tech Growth I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-scob",
      code: "NASDAQ:SCOB",
      companyName: "ScION Tech Growth II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-scobu",
      code: "NASDAQ:SCOBU",
      companyName: "ScION Tech Growth II Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-scobw",
      code: "NASDAQ:SCOBW",
      companyName: "ScION Tech Growth II Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-scor",
      code: "NASDAQ:SCOR",
      companyName: "comScore Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scph",
      code: "NASDAQ:SCPH",
      companyName: "scPharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scpl",
      code: "NASDAQ:SCPL",
      companyName: "SciPlay Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scps",
      code: "NASDAQ:SCPS",
      companyName: "Scopus BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scrm",
      code: "NASDAQ:SCRM",
      companyName: "Screaming Eagle Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-scrmu",
      code: "NASDAQ:SCRMU",
      companyName: "Screaming Eagle Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-scrmw",
      code: "NASDAQ:SCRMW",
      companyName: "Screaming Eagle Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-scs",
      code: "NASDAQ:SCS",
      companyName: "Steelcase Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scsc",
      code: "NASDAQ:SCSC",
      companyName: "ScanSource Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sctl",
      code: "NASDAQ:SCTL",
      companyName: "Societal CDMO Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scu",
      code: "NASDAQ:SCU",
      companyName: "Sculptor Capital Management Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scua",
      code: "NASDAQ:SCUA",
      companyName: "Sculptor Acquisition Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-scvl",
      code: "NASDAQ:SCVL",
      companyName: "Shoe Carnival Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scwx",
      code: "NASDAQ:SCWX",
      companyName: "SecureWorks Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scx",
      code: "NASDAQ:SCX",
      companyName: "L.S. Starrett Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-scyx",
      code: "NASDAQ:SCYX",
      companyName: "SCYNEXIS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sd",
      code: "NASDAQ:SD",
      companyName: "SandRidge Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sdac",
      code: "NASDAQ:SDAC",
      companyName:
        "Sustainable Development Acquisition I Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sdacu",
      code: "NASDAQ:SDACU",
      companyName: "Sustainable Development Acquisition I Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-sdacw",
      code: "NASDAQ:SDACW",
      companyName: "Sustainable Development Acquisition I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sdc",
      code: "NASDAQ:SDC",
      companyName: "SmileDirectClub Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sdgr",
      code: "NASDAQ:SDGR",
      companyName: "Schrodinger Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sdh",
      code: "NASDAQ:SDH",
      companyName: "Global Internet of People Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sdhy",
      code: "NASDAQ:SDHY",
      companyName:
        "PGIM Short Duration High Yield Opportunities Fund Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sdig",
      code: "NASDAQ:SDIG",
      companyName: "Stronghold Digital Mining Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sdpi",
      code: "NASDAQ:SDPI",
      companyName: "Superior Drilling Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sens",
      code: "NASDAQ:SENS",
      companyName: "Senseonics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seac",
      code: "NASDAQ:SEAC",
      companyName: "SeaChange International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seal-a",
      code: "NASDAQ:SEAL-A",
      companyName:
        "Seapeak LLC 9.00% Series A Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-seal-b",
      code: "NASDAQ:SEAL-B",
      companyName:
        "Seapeak LLC 8.50% Series B Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-seas",
      code: "NASDAQ:SEAS",
      companyName: "SeaWorld Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seat",
      code: "NASDAQ:SEAT",
      companyName: "Vivid Seats Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seatw",
      code: "NASDAQ:SEATW",
      companyName: "Vivid Seats Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-seb",
      code: "NASDAQ:SEB",
      companyName: "Seaboard Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seco",
      code: "NASDAQ:SECO",
      companyName: "Secoo Holding Limited ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-seda",
      code: "NASDAQ:SEDA",
      companyName: "SDCL EDGE Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sedg",
      code: "NASDAQ:SEDG",
      companyName: "SolarEdge Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-see",
      code: "NASDAQ:SEE",
      companyName: "Sealed Air Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seed",
      code: "NASDAQ:SEED",
      companyName: "Origin Agritech Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seel",
      code: "NASDAQ:SEEL",
      companyName: "Seelos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seer",
      code: "NASDAQ:SEER",
      companyName: "Seer Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seic",
      code: "NASDAQ:SEIC",
      companyName: "SEI Investments Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-selb",
      code: "NASDAQ:SELB",
      companyName: "Selecta Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-self",
      code: "NASDAQ:SELF",
      companyName: "Global Self Storage Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sem",
      code: "NASDAQ:SEM",
      companyName: "Select Medical Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-semr",
      code: "NASDAQ:SEMR",
      companyName: "SEMrush Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-senea",
      code: "NASDAQ:SENEA",
      companyName: "Seneca Foods Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-seneb",
      code: "NASDAQ:SENEB",
      companyName: "Seneca Foods Corp. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sera",
      code: "NASDAQ:SERA",
      companyName: "Sera Prognostics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ses",
      code: "NASDAQ:SES",
      companyName: "SES AI Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sesn",
      code: "NASDAQ:SESN",
      companyName: "Sesen Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sev",
      code: "NASDAQ:SEV",
      companyName: "Sono Group N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sevn",
      code: "NASDAQ:SEVN",
      companyName: "Seven Hills Realty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sf",
      code: "NASDAQ:SF",
      companyName: "Stifel Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sf-b",
      code: "NASDAQ:SF-B",
      companyName:
        "Stifel Financial Corporation Depositary Shares Each Representing 1/1000th  Interest in a Share of 6.25% Non-Cumulative  Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-sf-c",
      code: "NASDAQ:SF-C",
      companyName:
        "Stifel Financial Corporation Depositary Shares Each Representing 1/1000th Interest in a Share of 6.125% Non Cumulative Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-sf-d",
      code: "NASDAQ:SF-D",
      companyName:
        "Stifel Financial Corporation Depositary Shares Each Representing 1/1000th Interest in a Share of 4.50% Non-Cumulative Preferred Stock Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfb",
      code: "NASDAQ:SFB",
      companyName: "Stifel Financial Corporation 5.20% Senior Notes due 2047",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfbc",
      code: "NASDAQ:SFBC",
      companyName: "Sound Financial Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfbs",
      code: "NASDAQ:SFBS",
      companyName: "ServisFirst Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfe",
      code: "NASDAQ:SFE",
      companyName: "Safeguard Scientifics Inc. New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfet",
      code: "NASDAQ:SFET",
      companyName: "Safe-T Group Ltd. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfix",
      code: "NASDAQ:SFIX",
      companyName: "Stitch Fix Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfm",
      code: "NASDAQ:SFM",
      companyName: "Sprouts Farmers Market Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfnc",
      code: "NASDAQ:SFNC",
      companyName: "Simmons First National Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfst",
      code: "NASDAQ:SFST",
      companyName: "Southern First Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sft",
      code: "NASDAQ:SFT",
      companyName: "Shift Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfun",
      code: "NASDAQ:SFUN",
      companyName:
        "Fang Holdings Limited American Depositary Shares (Each representing Four Class A Ordinary Shares HK$1.00 par value)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sg",
      code: "NASDAQ:SG",
      companyName: "Sweetgreen Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sga",
      code: "NASDAQ:SGA",
      companyName: "Saga Communications Inc. Class A Common Stock (FL)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgbx",
      code: "NASDAQ:SGBX",
      companyName: "SG Blocks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgc",
      code: "NASDAQ:SGC",
      companyName: "Superior Group of Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgfy",
      code: "NASDAQ:SGFY",
      companyName: "Signify Health Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgh",
      code: "NASDAQ:SGH",
      companyName: "SMART Global Holdings Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sghc",
      code: "NASDAQ:SGHC",
      companyName: "Super Group (SGHC) Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sghl",
      code: "NASDAQ:SGHL",
      companyName: "Signal Hill Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sghlu",
      code: "NASDAQ:SGHLU",
      companyName: "Signal Hill Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-sghlw",
      code: "NASDAQ:SGHLW",
      companyName: "Signal Hill Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sght",
      code: "NASDAQ:SGHT",
      companyName: "Sight Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgii",
      code: "NASDAQ:SGII",
      companyName: "Seaport Global Acquisition II Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgiiu",
      code: "NASDAQ:SGIIU",
      companyName: "Seaport Global Acquisition II Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgiiw",
      code: "NASDAQ:SGIIW",
      companyName: "Seaport Global Acquisition II Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-sglb",
      code: "NASDAQ:SGLB",
      companyName: "Sigma Labs Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgly",
      code: "NASDAQ:SGLY",
      companyName: "Singularity Future Technology Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgma",
      code: "NASDAQ:SGMA",
      companyName: "SigmaTron International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shel",
      code: "NASDAQ:SHEL",
      companyName:
        "Royal Dutch Shell PLC American Depositary Shares (each representing two (2) Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgmo",
      code: "NASDAQ:SGMO",
      companyName: "Sangamo Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgrp",
      code: "NASDAQ:SGRP",
      companyName: "SPAR Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgry",
      code: "NASDAQ:SGRY",
      companyName: "Surgery Partners Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgtx",
      code: "NASDAQ:SGTX",
      companyName: "Sigilon Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sgu",
      code: "NASDAQ:SGU",
      companyName: "Star Group L.P. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shac",
      code: "NASDAQ:SHAC",
      companyName:
        "SCP & CO Healthcare Acquisition Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shacw",
      code: "NASDAQ:SHACW",
      companyName: "SCP & CO Healthcare Acquisition Company Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-shak",
      code: "NASDAQ:SHAK",
      companyName: "Shake Shack Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shap",
      code: "NASDAQ:SHAP",
      companyName: "Spree Acquisition Corp. 1 Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-shbi",
      code: "NASDAQ:SHBI",
      companyName: "Shore Bancshares Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shc",
      code: "NASDAQ:SHC",
      companyName: "Sotera Health Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shca",
      code: "NASDAQ:SHCA",
      companyName: "Spindletop Health Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shcau",
      code: "NASDAQ:SHCAU",
      companyName: "Spindletop Health Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-shcaw",
      code: "NASDAQ:SHCAW",
      companyName: "Spindletop Health Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-shcr",
      code: "NASDAQ:SHCR",
      companyName: "Sharecare Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shcrw",
      code: "NASDAQ:SHCRW",
      companyName: "Sharecare Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-shen",
      code: "NASDAQ:SHEN",
      companyName: "Shenandoah Telecommunications Co Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shg",
      code: "NASDAQ:SHG",
      companyName: "Shinhan Financial Group Co Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-shi",
      code: "NASDAQ:SHI",
      companyName: "SINOPEC Shangai Petrochemical Company Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ship",
      code: "NASDAQ:SHIP",
      companyName: "Seanergy Maritime Holdings Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shipz",
      code: "NASDAQ:SHIPZ",
      companyName: "Seanergy Maritime Holdings Corp Class B Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-shls",
      code: "NASDAQ:SHLS",
      companyName: "Shoals Technologies Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sho",
      code: "NASDAQ:SHO",
      companyName:
        "Sunstone Hotel Investors Inc. Sunstone Hotel Investors Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sho-h",
      code: "NASDAQ:SHO-H",
      companyName:
        "Sunstone Hotel Investors Inc. 6.125% Series H Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sho-i",
      code: "NASDAQ:SHO-I",
      companyName:
        "Sunstone Hotel Investors Inc. 5.70% Series I Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shoo",
      code: "NASDAQ:SHOO",
      companyName: "Steven Madden Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shpw",
      code: "NASDAQ:SHPW",
      companyName: "Shapeways Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shqa",
      code: "NASDAQ:SHQA",
      companyName: "Shelter Acquisition Corporation I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shqau",
      code: "NASDAQ:SHQAU",
      companyName: "Shelter Acquisition Corporation I Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-shqaw",
      code: "NASDAQ:SHQAW",
      companyName: "Shelter Acquisition Corporation I Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-shua",
      code: "NASDAQ:SHUA",
      companyName: "SHUAA Partners Acquisition Corp I Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-shuau",
      code: "NASDAQ:SHUAU",
      companyName: "SHUAA Partners Acquisition Corp I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-shuaw",
      code: "NASDAQ:SHUAW",
      companyName: "SHUAA Partners Acquisition Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-shw",
      code: "NASDAQ:SHW",
      companyName: "Sherwin-Williams Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-shyf",
      code: "NASDAQ:SHYF",
      companyName: "The Shyft Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-si",
      code: "NASDAQ:SI",
      companyName: "Silvergate Capital Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-si-a",
      code: "NASDAQ:SI-A",
      companyName:
        "Silvergate Capital Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of 5.375% Fixed Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-sid",
      code: "NASDAQ:SID",
      companyName: "Companhia Siderurgica Nacional S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sidu",
      code: "NASDAQ:SIDU",
      companyName: "Sidus Space Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sieb",
      code: "NASDAQ:SIEB",
      companyName: "Siebert Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sien",
      code: "NASDAQ:SIEN",
      companyName: "Sientra Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sier",
      code: "NASDAQ:SIER",
      companyName: "Sierra Lake Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sieru",
      code: "NASDAQ:SIERU",
      companyName: "Sierra Lake Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-sierw",
      code: "NASDAQ:SIERW",
      companyName: "Sierra Lake Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sif",
      code: "NASDAQ:SIF",
      companyName: "SIFCO Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sify",
      code: "NASDAQ:SIFY",
      companyName: "Sify Technologies Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sig",
      code: "NASDAQ:SIG",
      companyName: "Signet Jewelers Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-siga",
      code: "NASDAQ:SIGA",
      companyName: "SIGA Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sigi",
      code: "NASDAQ:SIGI",
      companyName: "Selective Insurance Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sigip",
      code: "NASDAQ:SIGIP",
      companyName:
        "Selective Insurance Group Inc. Depositary Shares each representing a 1/1000th interest in a share of 4.60% Non-Cumulative Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-sii",
      code: "NASDAQ:SII",
      companyName: "Sprott Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-silc",
      code: "NASDAQ:SILC",
      companyName: "Silicom Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-silv",
      code: "NASDAQ:SILV",
      companyName: "SilverCrest Metals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sim",
      code: "NASDAQ:SIM",
      companyName: "Grupo Simec S.A.B. de C.V. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-simo",
      code: "NASDAQ:SIMO",
      companyName:
        "Silicon Motion Technology Corporation American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sint",
      code: "NASDAQ:SINT",
      companyName: "SiNtx Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-siox",
      code: "NASDAQ:SIOX",
      companyName: "Sio Gene Therapies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sire",
      code: "NASDAQ:SIRE",
      companyName:
        "Sisecam Resources LP Common Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-siri",
      code: "NASDAQ:SIRI",
      companyName: "Sirius XM Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sisi",
      code: "NASDAQ:SISI",
      companyName: "Shineco Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sitc",
      code: "NASDAQ:SITC",
      companyName: "SITE Centers Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sitc-a",
      code: "NASDAQ:SITC-A",
      companyName: "SITE Centers Corp. 6.375% Class A Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-site",
      code: "NASDAQ:SITE",
      companyName: "SiteOne Landscape Supply Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sitm",
      code: "NASDAQ:SITM",
      companyName: "SiTime Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sivbp",
      code: "NASDAQ:SIVBP",
      companyName:
        "SVB Financial Group Depositary Shs each representing a 1/40th interest in a share of 5.25% Fixed-Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-six",
      code: "NASDAQ:SIX",
      companyName: "Six Flags Entertainment Corporation New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sj",
      code: "NASDAQ:SJ",
      companyName: "Scienjoy Holding Corporation Class A Ordinary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-sji",
      code: "NASDAQ:SJI",
      companyName: "South Jersey Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sjij",
      code: "NASDAQ:SJIJ",
      companyName:
        "South Jersey Industries Inc. 5.625% Junior Subordinated Notes due 2079",
      popularity: 0,
    },
    {
      slug: "nasdaq-sjiv",
      code: "NASDAQ:SJIV",
      companyName: "South Jersey Industries Inc. Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-sjm",
      code: "NASDAQ:SJM",
      companyName: "J.M. Smucker Company (The) New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sjr",
      code: "NASDAQ:SJR",
      companyName: "Shaw Communications Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sjt",
      code: "NASDAQ:SJT",
      companyName: "San Juan Basin Royalty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sjw",
      code: "NASDAQ:SJW",
      companyName: "SJW Group Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ske",
      code: "NASDAQ:SKE",
      companyName: "Skeena Resources Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-skil",
      code: "NASDAQ:SKIL",
      companyName: "Skillsoft Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-skin",
      code: "NASDAQ:SKIN",
      companyName: "The Beauty Health Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sklz",
      code: "NASDAQ:SKLZ",
      companyName: "Skillz Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-skm",
      code: "NASDAQ:SKM",
      companyName: "SK Telecom Co. Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-skt",
      code: "NASDAQ:SKT",
      companyName: "Tanger Factory Outlet Centers Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-skx",
      code: "NASDAQ:SKX",
      companyName: "Skechers U.S.A. Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sky",
      code: "NASDAQ:SKY",
      companyName: "Skyline Champion Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-skya",
      code: "NASDAQ:SKYA",
      companyName: "Skydeck Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-skyaw",
      code: "NASDAQ:SKYAW",
      companyName: "Skydeck Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-skyh",
      code: "NASDAQ:SKYH",
      companyName: "Sky Harbour Group Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-skyt",
      code: "NASDAQ:SKYT",
      companyName: "SkyWater Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-skyw",
      code: "NASDAQ:SKYW",
      companyName: "SkyWest Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-skyx",
      code: "NASDAQ:SKYX",
      companyName: "SQL Technologies Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slab",
      code: "NASDAQ:SLAB",
      companyName: "Silicon Laboratories Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slac",
      code: "NASDAQ:SLAC",
      companyName: "Social Leverage Acquisition Corp I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slam",
      code: "NASDAQ:SLAM",
      companyName: "Slam Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-slamu",
      code: "NASDAQ:SLAMU",
      companyName: "Slam Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-slamw",
      code: "NASDAQ:SLAMW",
      companyName: "Slam Corp. warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-silk",
      code: "NASDAQ:SILK",
      companyName: "Silk Road Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slca",
      code: "NASDAQ:SLCA",
      companyName: "U.S. Silica Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slcr",
      code: "NASDAQ:SLCR",
      companyName:
        "Silver Crest Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-slcru",
      code: "NASDAQ:SLCRU",
      companyName: "Silver Crest Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-slcrw",
      code: "NASDAQ:SLCRW",
      companyName: "Silver Crest Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sldb",
      code: "NASDAQ:SLDB",
      companyName: "Solid Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sldp",
      code: "NASDAQ:SLDP",
      companyName: "Solid Power Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sldpw",
      code: "NASDAQ:SLDPW",
      companyName: "Solid Power Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-slf",
      code: "NASDAQ:SLF",
      companyName: "Sun Life Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slg",
      code: "NASDAQ:SLG",
      companyName: "SL Green Realty Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slg-i",
      code: "NASDAQ:SLG-I",
      companyName: "SL Green Realty Corporation Preferred Series I",
      popularity: 0,
    },
    {
      slug: "nasdaq-slgc",
      code: "NASDAQ:SLGC",
      companyName: "SomaLogic Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slgcw",
      code: "NASDAQ:SLGCW",
      companyName: "SomaLogic Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-slgg",
      code: "NASDAQ:SLGG",
      companyName: "Super League Gaming Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slgl",
      code: "NASDAQ:SLGL",
      companyName: "Sol-Gel Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-slgn",
      code: "NASDAQ:SLGN",
      companyName: "Silgan Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slhg",
      code: "NASDAQ:SLHG",
      companyName: "Skylight Health Group Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-slhgp",
      code: "NASDAQ:SLHGP",
      companyName:
        "Skylight Health Group Inc. 9.25% Series A Cumulative Redeemable Perpetual Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-slm",
      code: "NASDAQ:SLM",
      companyName: "SLM Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slmbp",
      code: "NASDAQ:SLMBP",
      companyName:
        "SLM Corporation Floating Rate Non-Cumulative Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-sln",
      code: "NASDAQ:SLN",
      companyName: "Silence Therapeutics Plc American Depository Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-slng",
      code: "NASDAQ:SLNG",
      companyName: "Stabilis Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slnh",
      code: "NASDAQ:SLNH",
      companyName: "Soluna Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slnhp",
      code: "NASDAQ:SLNHP",
      companyName:
        "Soluna Holdings Inc 9.0% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slno",
      code: "NASDAQ:SLNO",
      companyName: "Soleno Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slp",
      code: "NASDAQ:SLP",
      companyName: "Simulations Plus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slqt",
      code: "NASDAQ:SLQT",
      companyName: "SelectQuote Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slrc",
      code: "NASDAQ:SLRC",
      companyName: "SLR Investment Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slrx",
      code: "NASDAQ:SLRX",
      companyName: "Salarius Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sls",
      code: "NASDAQ:SLS",
      companyName: "SELLAS Life Sciences Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slvm",
      code: "NASDAQ:SLVM",
      companyName: "Sylvamo Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-slvr",
      code: "NASDAQ:SLVR",
      companyName: "SilverSPAC Inc. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-slvru",
      code: "NASDAQ:SLVRU",
      companyName: "SilverSPAC Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-slvrw",
      code: "NASDAQ:SLVRW",
      companyName: "SilverSPAC Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sm",
      code: "NASDAQ:SM",
      companyName: "SM Energy Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smap",
      code: "NASDAQ:SMAP",
      companyName: "SportsMap Tech Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smapw",
      code: "NASDAQ:SMAPW",
      companyName: "SportsMap Tech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-smar",
      code: "NASDAQ:SMAR",
      companyName: "Smartsheet Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smbc",
      code: "NASDAQ:SMBC",
      companyName: "Southern Missouri Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smbk",
      code: "NASDAQ:SMBK",
      companyName: "SmartFinancial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smci",
      code: "NASDAQ:SMCI",
      companyName: "Super Micro Computer Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smfr",
      code: "NASDAQ:SMFR",
      companyName: "Sema4 Holdings Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smfrw",
      code: "NASDAQ:SMFRW",
      companyName: "Sema4 Holdings Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-smg",
      code: "NASDAQ:SMG",
      companyName: "Scotts Miracle-Gro Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smhi",
      code: "NASDAQ:SMHI",
      companyName: "SEACOR Marine Holdings Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-smid",
      code: "NASDAQ:SMID",
      companyName: "Smith-Midland Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smih",
      code: "NASDAQ:SMIH",
      companyName: "Summit Healthcare Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-smihu",
      code: "NASDAQ:SMIHU",
      companyName: "Summit Healthcare Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-smihw",
      code: "NASDAQ:SMIHW",
      companyName: "Summit Healthcare Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-smit",
      code: "NASDAQ:SMIT",
      companyName: "Schmitt Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smlp",
      code: "NASDAQ:SMLP",
      companyName:
        "Summit Midstream Partners LP Common Units Representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-smlr",
      code: "NASDAQ:SMLR",
      companyName: "Semler Scientific Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smm",
      code: "NASDAQ:SMM",
      companyName: "Salient Midstream Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-smmf",
      code: "NASDAQ:SMMF",
      companyName: "Summit Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smmt",
      code: "NASDAQ:SMMT",
      companyName: "Summit Therapeutics Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-smp",
      code: "NASDAQ:SMP",
      companyName: "Standard Motor Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smpl",
      code: "NASDAQ:SMPL",
      companyName: "The Simply Good Foods Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smr",
      code: "NASDAQ:SMR",
      companyName: "NuScale Power Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smrt",
      code: "NASDAQ:SMRT",
      companyName: "SmartRent Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smsi",
      code: "NASDAQ:SMSI",
      companyName: "Smith Micro Software Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smtc",
      code: "NASDAQ:SMTC",
      companyName: "Semtech Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smti",
      code: "NASDAQ:SMTI",
      companyName: "Sanara MedTech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smts",
      code: "NASDAQ:SMTS",
      companyName: "Sierra Metals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smwb",
      code: "NASDAQ:SMWB",
      companyName: "Similarweb Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sna",
      code: "NASDAQ:SNA",
      companyName: "Snap-On Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snax",
      code: "NASDAQ:SNAX",
      companyName: "Stryve Foods Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snaxw",
      code: "NASDAQ:SNAXW",
      companyName: "Stryve Foods Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-snbr",
      code: "NASDAQ:SNBR",
      companyName: "Sleep Number Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snce",
      code: "NASDAQ:SNCE",
      companyName: "Science 37 Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sncr",
      code: "NASDAQ:SNCR",
      companyName: "Synchronoss Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sncrl",
      code: "NASDAQ:SNCRL",
      companyName: "Synchronoss Technologies Inc. 8.375% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-sncy",
      code: "NASDAQ:SNCY",
      companyName: "Sun Country Airlines Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snd",
      code: "NASDAQ:SND",
      companyName: "Smart Sand Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snda",
      code: "NASDAQ:SNDA",
      companyName: "Sonida Senior Living Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sndl",
      code: "NASDAQ:SNDL",
      companyName: "Sundial Growers Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sndr",
      code: "NASDAQ:SNDR",
      companyName: "Schneider National Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sndx",
      code: "NASDAQ:SNDX",
      companyName: "Syndax Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snes",
      code: "NASDAQ:SNES",
      companyName: "SenesTech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snex",
      code: "NASDAQ:SNEX",
      companyName: "StoneX Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snfca",
      code: "NASDAQ:SNFCA",
      companyName:
        "Security National Financial Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sngx",
      code: "NASDAQ:SNGX",
      companyName: "Soligenix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snmp",
      code: "NASDAQ:SNMP",
      companyName: "Evolve Transition Infrastructure LP Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snn",
      code: "NASDAQ:SNN",
      companyName: "Smith & Nephew SNATS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snoa",
      code: "NASDAQ:SNOA",
      companyName: "Sonoma Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snp",
      code: "NASDAQ:SNP",
      companyName: "China Petroleum & Chemical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snpo",
      code: "NASDAQ:SNPO",
      companyName: "Snap One Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snow",
      code: "NASDAQ:SNOW",
      companyName: "Snowflake Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snpx",
      code: "NASDAQ:SNPX",
      companyName: "Synaptogenix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snrh",
      code: "NASDAQ:SNRH",
      companyName: "Senior Connect Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snrhu",
      code: "NASDAQ:SNRHU",
      companyName: "Senior Connect Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-snrhw",
      code: "NASDAQ:SNRHW",
      companyName: "Senior Connect Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-snse",
      code: "NASDAQ:SNSE",
      companyName: "Sensei Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snt",
      code: "NASDAQ:SNT",
      companyName: "Senstar Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sntg",
      code: "NASDAQ:SNTG",
      companyName: "Sentage Holdings Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-snv-d",
      code: "NASDAQ:SNV-D",
      companyName:
        "Synovus Financial Corp. Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series D Liquation Preference $25.00 per Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-snv-e",
      code: "NASDAQ:SNV-E",
      companyName:
        "Synovus Financial Corp. 5.875% Fixed-Rate Reset Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-so",
      code: "NASDAQ:SO",
      companyName: "Southern Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sofi",
      code: "NASDAQ:SOFI",
      companyName: "SoFi Technologies Inc. Common Stock  ",
      popularity: 0,
    },
    {
      slug: "nasdaq-sofo",
      code: "NASDAQ:SOFO",
      companyName: "Sonic Foundry Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-soho",
      code: "NASDAQ:SOHO",
      companyName: "Sotherly Hotels Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sohob",
      code: "NASDAQ:SOHOB",
      companyName:
        "Sotherly Hotels Inc. 8.0% Series B Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sohon",
      code: "NASDAQ:SOHON",
      companyName:
        "Sotherly Hotels Inc. 8.25% Series D Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sohoo",
      code: "NASDAQ:SOHOO",
      companyName:
        "Sotherly Hotels Inc. 7.875% Series C Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sohu",
      code: "NASDAQ:SOHU",
      companyName: "Sohu.com Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-soi",
      code: "NASDAQ:SOI",
      companyName: "Solaris Oilfield Infrastructure Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sojc",
      code: "NASDAQ:SOJC",
      companyName:
        "Southern Company (The) Series 2017B 5.25% Junior Subordinated Notes due December 1 2077",
      popularity: 0,
    },
    {
      slug: "nasdaq-sojd",
      code: "NASDAQ:SOJD",
      companyName:
        "Southern Company (The) Series 2020A 4.95% Junior Subordinated Notes due January 30 2080",
      popularity: 0,
    },
    {
      slug: "nasdaq-soje",
      code: "NASDAQ:SOJE",
      companyName:
        "Southern Company (The) Series 2020C 4.20% Junior Subordinated Notes due October 15 2060",
      popularity: 0,
    },
    {
      slug: "nasdaq-sol",
      code: "NASDAQ:SOL",
      companyName:
        "Renesola Ltd. American Depsitary Shares (Each representing 10 shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-soln",
      code: "NASDAQ:SOLN",
      companyName: "Southern Company (The) 2019 Series A Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-solo",
      code: "NASDAQ:SOLO",
      companyName: "Electrameccanica Vehicles Corp. Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-solow",
      code: "NASDAQ:SOLOW",
      companyName: "Electrameccanica Vehicles Corp. Ltd. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-son",
      code: "NASDAQ:SON",
      companyName: "Sonoco Products Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sond",
      code: "NASDAQ:SOND",
      companyName: "Sonder Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sondw",
      code: "NASDAQ:SONDW",
      companyName: "Sonder Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-sonm",
      code: "NASDAQ:SONM",
      companyName: "Sonim Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sonn",
      code: "NASDAQ:SONN",
      companyName: "Sonnet BioTherapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sono",
      code: "NASDAQ:SONO",
      companyName: "Sonos Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sonx",
      code: "NASDAQ:SONX",
      companyName: "Sonendo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sony",
      code: "NASDAQ:SONY",
      companyName: "Sony Group Corporation American Depositary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-sopa",
      code: "NASDAQ:SOPA",
      companyName: "Society Pass Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-soph",
      code: "NASDAQ:SOPH",
      companyName: "SOPHiA GENETICS SA Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sor",
      code: "NASDAQ:SOR",
      companyName: "Source Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sos",
      code: "NASDAQ:SOS",
      companyName: "SOS Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sotk",
      code: "NASDAQ:SOTK",
      companyName: "Sono-Tek Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-soun",
      code: "NASDAQ:SOUN",
      companyName: "SoundHound AI Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sounw",
      code: "NASDAQ:SOUNW",
      companyName: "SoundHound AI Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sovo",
      code: "NASDAQ:SOVO",
      companyName: "Sovos Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sp",
      code: "NASDAQ:SP",
      companyName: "SP Plus Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spb",
      code: "NASDAQ:SPB",
      companyName: "Spectrum Brands Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spcb",
      code: "NASDAQ:SPCB",
      companyName: "SuperCom Ltd. Ordinary Shares (Israel)",
      popularity: 0,
    },
    {
      slug: "nasdaq-spce",
      code: "NASDAQ:SPCE",
      companyName: "Virgin Galactic Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spcm",
      code: "NASDAQ:SPCM",
      companyName: "Sound Point Acquisition Corp I Ltd Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-spcmu",
      code: "NASDAQ:SPCMU",
      companyName: "Sound Point Acquisition Corp I Ltd Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-spcmw",
      code: "NASDAQ:SPCMW",
      companyName: "Sound Point Acquisition Corp I Ltd Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-spe",
      code: "NASDAQ:SPE",
      companyName: "Special Opportunities Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spe-c",
      code: "NASDAQ:SPE-C",
      companyName:
        "Special Opportunities Fund Inc. 2.75% Convertible Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-spfi",
      code: "NASDAQ:SPFI",
      companyName: "South Plains Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spg",
      code: "NASDAQ:SPG",
      companyName: "Simon Property Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spg-j",
      code: "NASDAQ:SPG-J",
      companyName:
        "Simon Property Group Inc. Simon Property Group 8 3/8% Series J Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spgi",
      code: "NASDAQ:SPGI",
      companyName: "S&P Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spgs",
      code: "NASDAQ:SPGS",
      companyName:
        "Simon Property Group Acquisition Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sph",
      code: "NASDAQ:SPH",
      companyName: "Suburban Propane Partners L.P. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spi",
      code: "NASDAQ:SPI",
      companyName: "SPI Energy Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-spir",
      code: "NASDAQ:SPIR",
      companyName: "Spire Global Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spkb",
      code: "NASDAQ:SPKB",
      companyName: "Silver Spike Acquisition Corp II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-spkbu",
      code: "NASDAQ:SPKBU",
      companyName: "Silver Spike Acquisition Corp II Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-spkbw",
      code: "NASDAQ:SPKBW",
      companyName: "Silver Spike Acquisition Corp II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-spns",
      code: "NASDAQ:SPNS",
      companyName:
        "Sapiens International Corporation N.V. Common Shares (Cayman Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-spnt",
      code: "NASDAQ:SPNT",
      companyName: "SiriusPoint Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-spnt-b",
      code: "NASDAQ:SPNT-B",
      companyName:
        "SiriusPoint Ltd. 8.00% Resettable Fixed Rate Preference Shares Series B $25.00 liquidation preference per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-spok",
      code: "NASDAQ:SPOK",
      companyName: "Spok Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sppi",
      code: "NASDAQ:SPPI",
      companyName: "Spectrum Pharmaceuticals Inc.Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spr",
      code: "NASDAQ:SPR",
      companyName: "Spirit Aerosystems Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sprb",
      code: "NASDAQ:SPRB",
      companyName: "Spruce Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sprc",
      code: "NASDAQ:SPRC",
      companyName: "SciSparc Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-spro",
      code: "NASDAQ:SPRO",
      companyName: "Spero Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spsc",
      code: "NASDAQ:SPSC",
      companyName: "SPS Commerce Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spt",
      code: "NASDAQ:SPT",
      companyName: "Sprout Social Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sptk",
      code: "NASDAQ:SPTK",
      companyName: "SportsTek Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sptkw",
      code: "NASDAQ:SPTKW",
      companyName: "SportsTek Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-sptn",
      code: "NASDAQ:SPTN",
      companyName: "SpartanNash Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spwh",
      code: "NASDAQ:SPWH",
      companyName: "Sportsman's Warehouse Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spwr",
      code: "NASDAQ:SPWR",
      companyName: "SunPower Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spxc",
      code: "NASDAQ:SPXC",
      companyName: "SPX Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-spxx",
      code: "NASDAQ:SPXX",
      companyName: "Nuveen S&P 500 Dynamic Overwrite Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-sqft",
      code: "NASDAQ:SQFT",
      companyName: "Presidio Property Trust Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sqftp",
      code: "NASDAQ:SQFTP",
      companyName:
        "Presidio Property Trust Inc. 9.375% Series D Cumulative Redeemable Perpetual Preferred Stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-sqftw",
      code: "NASDAQ:SQFTW",
      companyName:
        "Presidio Property Trust Inc. Series A Common Stock Purchase Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-sql",
      code: "NASDAQ:SQL",
      companyName: "SeqLL Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sqns",
      code: "NASDAQ:SQNS",
      companyName: "Sequans Communications S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sqsp",
      code: "NASDAQ:SQSP",
      companyName: "Squarespace Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sqz",
      code: "NASDAQ:SQZ",
      companyName: "SQZ Biotechnologies Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sr",
      code: "NASDAQ:SR",
      companyName: "Spire Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sr-a",
      code: "NASDAQ:SR-A",
      companyName:
        "Spire Inc. Depositary Shares each representing a 1/1000th interest in a share of 5.90% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srad",
      code: "NASDAQ:SRAD",
      companyName: "Sportradar Group AG Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dell",
      code: "NYSE:DELL",
      companyName: "Dell Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-srax",
      code: "NASDAQ:SRAX",
      companyName: "SRAX Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-src",
      code: "NASDAQ:SRC",
      companyName: "Spirit Realty Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-src-a",
      code: "NASDAQ:SRC-A",
      companyName:
        "Spirit Realty Capital Inc. 6.000% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srce",
      code: "NASDAQ:SRCE",
      companyName: "1st Source Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srcl",
      code: "NASDAQ:SRCL",
      companyName: "Stericycle Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srdx",
      code: "NASDAQ:SRDX",
      companyName: "Surmodics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sre",
      code: "NASDAQ:SRE",
      companyName: "DBA Sempra Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srea",
      code: "NASDAQ:SREA",
      companyName: "DBA Sempra 5.750% Junior Subordinated Notes due 2079",
      popularity: 0,
    },
    {
      slug: "nasdaq-srev",
      code: "NASDAQ:SREV",
      companyName: "ServiceSource International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srg",
      code: "NASDAQ:SRG",
      companyName: "Seritage Growth Properties Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srg-a",
      code: "NASDAQ:SRG-A",
      companyName:
        "Seritage Growth Properties 7.00% Series A Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-srga",
      code: "NASDAQ:SRGA",
      companyName: "Surgalign Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sri",
      code: "NASDAQ:SRI",
      companyName: "Stoneridge Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srl",
      code: "NASDAQ:SRL",
      companyName: "Scully Royalty Ltd.",
      popularity: 0,
    },
    {
      slug: "nasdaq-srlp",
      code: "NASDAQ:SRLP",
      companyName:
        "Sprague Resources LP Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-srne",
      code: "NASDAQ:SRNE",
      companyName: "Sorrento Therapeutics Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srpt",
      code: "NASDAQ:SRPT",
      companyName: "Sarepta Therapeutics Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-srra",
      code: "NASDAQ:SRRA",
      companyName: "Sierra Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srrk",
      code: "NASDAQ:SRRK",
      companyName: "Scholar Rock Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srsa",
      code: "NASDAQ:SRSA",
      companyName: "Sarissa Capital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-srsau",
      code: "NASDAQ:SRSAU",
      companyName: "Sarissa Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-srsaw",
      code: "NASDAQ:SRSAW",
      companyName: "Sarissa Capital Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-srt",
      code: "NASDAQ:SRT",
      companyName: "StarTek Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srts",
      code: "NASDAQ:SRTS",
      companyName: "Sensus Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srv",
      code: "NASDAQ:SRV",
      companyName: "Cushing MLP & Infrastructure Total Return Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-srzn",
      code: "NASDAQ:SRZN",
      companyName: "Surrozen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-srznw",
      code: "NASDAQ:SRZNW",
      companyName: "Surrozen Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssaa",
      code: "NASDAQ:SSAA",
      companyName:
        "Science Strategic Acquisition Corp. Alpha Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssaau",
      code: "NASDAQ:SSAAU",
      companyName: "Science Strategic Acquisition Corp. Alpha Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssaaw",
      code: "NASDAQ:SSAAW",
      companyName: "Science Strategic Acquisition Corp. Alpha Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssb",
      code: "NASDAQ:SSB",
      companyName: "SouthState Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssbi",
      code: "NASDAQ:SSBI",
      companyName: "Summit State Bank Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssbk",
      code: "NASDAQ:SSBK",
      companyName: "Southern States Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssd",
      code: "NASDAQ:SSD",
      companyName: "Simpson Manufacturing Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssic",
      code: "NASDAQ:SSIC",
      companyName: "Silver Spike Investment Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sskn",
      code: "NASDAQ:SSKN",
      companyName: "Strata Skin Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssl",
      code: "NASDAQ:SSL",
      companyName: "Sasol Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssnc",
      code: "NASDAQ:SSNC",
      companyName: "SS&C Technologies Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssnt",
      code: "NASDAQ:SSNT",
      companyName: "SilverSun Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssp",
      code: "NASDAQ:SSP",
      companyName: "E.W. Scripps Company (The) Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssrm",
      code: "NASDAQ:SSRM",
      companyName: "SSR Mining Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssss",
      code: "NASDAQ:SSSS",
      companyName: "SuRo Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssssl",
      code: "NASDAQ:SSSSL",
      companyName: "SuRo Capital Corp. 6.00% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-sst",
      code: "NASDAQ:SST",
      companyName: "System1 Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssti",
      code: "NASDAQ:SSTI",
      companyName: "ShotSpotter Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sstk",
      code: "NASDAQ:SSTK",
      companyName: "Shutterstock Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssu",
      code: "NASDAQ:SSU",
      companyName: "SIGNA Sports United N.V. Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssy",
      code: "NASDAQ:SSY",
      companyName: "SunLink Health Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ssys",
      code: "NASDAQ:SSYS",
      companyName: "Stratasys Ltd. Ordinary Shares (Israel)",
      popularity: 0,
    },
    {
      slug: "nasdaq-st",
      code: "NASDAQ:ST",
      companyName: "Sensata Technologies Holding plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-staa",
      code: "NASDAQ:STAA",
      companyName: "STAAR Surgical Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stab",
      code: "NASDAQ:STAB",
      companyName: "Statera Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-staf",
      code: "NASDAQ:STAF",
      companyName: "Staffing 360 Solutions Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-stag",
      code: "NASDAQ:STAG",
      companyName: "Stag Industrial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-star",
      code: "NASDAQ:STAR          ",
      companyName: "iStar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-star-d",
      code: "NASDAQ:STAR-D",
      companyName: "iStar Inc. Series D Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-star-g",
      code: "NASDAQ:STAR-G",
      companyName: "iStar Inc. Series G Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-star-i",
      code: "NASDAQ:STAR-I",
      companyName: "iStar Inc. Series I Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stba",
      code: "NASDAQ:STBA",
      companyName: "S&T Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stc",
      code: "NASDAQ:STC",
      companyName: "Stewart Information Services Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stcn",
      code: "NASDAQ:STCN",
      companyName: "Steel Connect Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stz",
      code: "NASDAQ:STZ",
      companyName: "Constellation Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ste",
      code: "NASDAQ:STE",
      companyName: "STERIS plc (Ireland) Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-stem",
      code: "NASDAQ:STEM",
      companyName: "Stem Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-step",
      code: "NASDAQ:STEP",
      companyName: "StepStone Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ster",
      code: "NASDAQ:STER",
      companyName: "Sterling Check Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stet",
      code: "NASDAQ:STET",
      companyName: "ST Energy Transition I Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-stew",
      code: "NASDAQ:STEW",
      companyName: "SRH Total Return Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stg",
      code: "NASDAQ:STG",
      companyName:
        "Sunlands Technology Group American Depositary Shares representing Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-stgw",
      code: "NASDAQ:STGW",
      companyName: "Stagwell Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stim",
      code: "NASDAQ:STIM",
      companyName: "Neuronetics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stk",
      code: "NASDAQ:STK",
      companyName: "Columbia Seligman Premium Technology Growth Fund Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-stkl",
      code: "NASDAQ:STKL",
      companyName: "SunOpta Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stks",
      code: "NASDAQ:STKS",
      companyName: "The ONE Group Hospitality Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stld",
      code: "NASDAQ:STLD",
      companyName: "Steel Dynamics Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-stm",
      code: "NASDAQ:STM",
      companyName: "STMicroelectronics N.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stn",
      code: "NASDAQ:STN",
      companyName: "Stantec Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stne",
      code: "NASDAQ:STNE",
      companyName: "StoneCo Ltd. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-stng",
      code: "NASDAQ:STNG",
      companyName: "Scorpio Tankers Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-stok",
      code: "NASDAQ:STOK",
      companyName: "Stoke Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ston",
      code: "NASDAQ:STON",
      companyName: "StoneMor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stor",
      code: "NASDAQ:STOR",
      companyName: "STORE Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stra",
      code: "NASDAQ:STRA",
      companyName: "Strategic Education Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-strcw",
      code: "NASDAQ:STRCW",
      companyName: "Sarcos Technology and Robotics Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-stre",
      code: "NASDAQ:STRE",
      companyName:
        "Supernova Partners Acquisition Company III Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-strl",
      code: "NASDAQ:STRL",
      companyName: "Sterling Construction Company Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-strm",
      code: "NASDAQ:STRM",
      companyName: "Streamline Health Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-strn",
      code: "NASDAQ:STRN",
      companyName: "Stran & Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-strnw",
      code: "NASDAQ:STRNW",
      companyName: "Stran & Company Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-stro",
      code: "NASDAQ:STRO",
      companyName: "Sutro Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-strr",
      code: "NASDAQ:STRR",
      companyName: "Star Equity Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-strrp",
      code: "NASDAQ:STRRP",
      companyName:
        "Star Equity Holdings Inc. Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-strs",
      code: "NASDAQ:STRS",
      companyName: "Stratus Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-strt",
      code: "NASDAQ:STRT",
      companyName: "STRATTEC SECURITY CORPORATION Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stry",
      code: "NASDAQ:STRY",
      companyName: "Starry Group Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stsa",
      code: "NASDAQ:STSA",
      companyName: "Satsuma Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stss",
      code: "NASDAQ:STSS",
      companyName: "Sharps Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stssw",
      code: "NASDAQ:STSSW",
      companyName: "Sharps Technology Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-stt",
      code: "NASDAQ:STT",
      companyName: "State Street Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stt-d",
      code: "NASDAQ:STT-D",
      companyName:
        "State Street Corporation Depositary Shares representing 1/4000th Perpetual Preferred Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-stt-g",
      code: "NASDAQ:STT-G",
      companyName:
        "State Street Corporation Depositary shares each representing a 1/4000th ownership interest in a share of Fixed-to-Floating Rate Non-Cumulative",
      popularity: 0,
    },
    {
      slug: "nasdaq-sttk",
      code: "NASDAQ:STTK",
      companyName: "Shattuck Labs Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stvn",
      code: "NASDAQ:STVN",
      companyName: "Stevanato Group S.p.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-stwd",
      code: "NASDAQ:STWD",
      companyName: "STARWOOD PROPERTY TRUST INC. Starwood Property Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-stx",
      code: "NASDAQ:STX",
      companyName: "Seagate Technology Holdings PLC Ordinary Shares (Ireland)",
      popularity: 0,
    },
    {
      slug: "nasdaq-stxs",
      code: "NASDAQ:STXS",
      companyName: "Stereotaxis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-stz/b",
      code: "NASDAQ:STZ/B",
      companyName: "Constellation Brands Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-su",
      code: "NASDAQ:SU",
      companyName: "Suncor Energy  Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-suac",
      code: "NASDAQ:SUAC",
      companyName:
        "ShoulderUp Technology Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sui",
      code: "NASDAQ:SUI",
      companyName: "Sun Communities Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sum",
      code: "NASDAQ:SUM",
      companyName: "Summit Materials Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sumo",
      code: "NASDAQ:SUMO",
      companyName: "Sumo Logic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sumr",
      code: "NASDAQ:SUMR",
      companyName: "Summer Infant Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sun",
      code: "NASDAQ:SUN",
      companyName:
        "Sunoco LP Common Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-sunl",
      code: "NASDAQ:SUNL",
      companyName: "Sunlight Financial Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sunw",
      code: "NASDAQ:SUNW",
      companyName: "Sunworks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sup",
      code: "NASDAQ:SUP",
      companyName: "Superior Industries International Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-supn",
      code: "NASDAQ:SUPN",
      companyName: "Supernus Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-supv",
      code: "NASDAQ:SUPV",
      companyName:
        "Grupo Supervielle S.A. American Depositary Shares each Representing five Class B shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-surf",
      code: "NASDAQ:SURF",
      companyName: "Surface Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-surg",
      code: "NASDAQ:SURG",
      companyName: "SurgePays Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-surgw",
      code: "NASDAQ:SURGW",
      companyName: "SurgePays Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-suz",
      code: "NASDAQ:SUZ",
      companyName:
        "Suzano S.A. American Depositary Shares (each representing One Ordinary Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-svc",
      code: "NASDAQ:SVC",
      companyName: "Service Properties Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-svfa",
      code: "NASDAQ:SVFA",
      companyName: "SVF Investment Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-svfau",
      code: "NASDAQ:SVFAU",
      companyName: "SVF Investment Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-svfaw",
      code: "NASDAQ:SVFAW",
      companyName: "SVF Investment Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-svfb",
      code: "NASDAQ:SVFB",
      companyName: "SVF Investment Corp. 2 Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-svfc",
      code: "NASDAQ:SVFC",
      companyName: "SVF Investment Corp. 3 Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-svfd",
      code: "NASDAQ:SVFD",
      companyName: "Save Foods Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-svm",
      code: "NASDAQ:SVM",
      companyName: "Silvercorp Metals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-svna",
      code: "NASDAQ:SVNA",
      companyName: "7 Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-svnaw",
      code: "NASDAQ:SVNAW",
      companyName: "7 Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-svra",
      code: "NASDAQ:SVRA",
      companyName: "Savara Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-svt",
      code: "NASDAQ:SVT",
      companyName: "Servotronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-svvc",
      code: "NASDAQ:SVVC",
      companyName: "Firsthand Technology Value Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swag",
      code: "NASDAQ:SWAG",
      companyName: "Software Acquisition Group Inc. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swagu",
      code: "NASDAQ:SWAGU",
      companyName: "Software Acquisition Group Inc. III Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-swbi",
      code: "NASDAQ:SWBI",
      companyName: "Smith & Wesson Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swetw",
      code: "NASDAQ:SWETW",
      companyName: "Athlon Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-swi",
      code: "NASDAQ:SWI",
      companyName: "SolarWinds Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swim",
      code: "NASDAQ:SWIM",
      companyName: "Latham Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swir",
      code: "NASDAQ:SWIR",
      companyName: "Sierra Wireless Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swk",
      code: "NASDAQ:SWK",
      companyName: "Stanley Black & Decker Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swkh",
      code: "NASDAQ:SWKH",
      companyName: "SWK Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swks",
      code: "NASDAQ:SWKS",
      companyName: "Skyworks Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swm",
      code: "NASDAQ:SWM",
      companyName: "Schweitzer-Mauduit International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swn",
      code: "NASDAQ:SWN",
      companyName: "Southwestern Energy Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swss",
      code: "NASDAQ:SWSS",
      companyName: "Springwater Special Situations Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swssu",
      code: "NASDAQ:SWSSU",
      companyName: "Springwater Special Situations Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-swssw",
      code: "NASDAQ:SWSSW",
      companyName: "Springwater Special Situations Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-swt",
      code: "NASDAQ:SWT",
      companyName: "Stanley Black & Decker Inc. Corporate Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-swtx",
      code: "NASDAQ:SWTX",
      companyName: "SpringWorks Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swvl",
      code: "NASDAQ:SWVL",
      companyName: "Swvl Holdings Corp Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-swvlw",
      code: "NASDAQ:SWVLW",
      companyName: "Swvl Holdings Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-swx",
      code: "NASDAQ:SWX",
      companyName: "Southwest Gas Holdings Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-swz",
      code: "NASDAQ:SWZ",
      companyName: "Swiss Helvetia Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sxc",
      code: "NASDAQ:SXC",
      companyName: "SunCoke Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sxi",
      code: "NASDAQ:SXI",
      companyName: "Standex International Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sxt",
      code: "NASDAQ:SXT",
      companyName: "Sensient Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sxtc",
      code: "NASDAQ:SXTC",
      companyName: "China SXT Pharmaceuticals Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sy",
      code: "NASDAQ:SY",
      companyName: "So-Young International Inc. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sybt",
      code: "NASDAQ:SYBT",
      companyName: "Stock Yards Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sybx",
      code: "NASDAQ:SYBX",
      companyName: "Synlogic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-syf",
      code: "NASDAQ:SYF",
      companyName: "Synchrony Financial Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-syf-a",
      code: "NASDAQ:SYF-A",
      companyName:
        "Synchrony Financial Depositary Shares each Representing a 1/40th Interest in a Share of 5.625% Fixed Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-syn",
      code: "NASDAQ:SYN",
      companyName: "Synthetic Biologics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-syna",
      code: "NASDAQ:SYNA",
      companyName: "Synaptics Incorporated Common Stock $0.001 Par Value",
      popularity: 0,
    },
    {
      slug: "nasdaq-synh",
      code: "NASDAQ:SYNH",
      companyName: "Syneos Health Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-synl",
      code: "NASDAQ:SYNL",
      companyName: "Synalloy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sypr",
      code: "NASDAQ:SYPR",
      companyName: "Sypris Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-syrs",
      code: "NASDAQ:SYRS",
      companyName: "Syros Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-syta",
      code: "NASDAQ:SYTA",
      companyName: "Siyata Mobile Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-sytaw",
      code: "NASDAQ:SYTAW",
      companyName: "Siyata Mobile Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-syy",
      code: "NASDAQ:SYY",
      companyName: "Sysco Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-szc",
      code: "NASDAQ:SZC",
      companyName:
        "Cushing NextGen Infrastructure Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-szzl",
      code: "NASDAQ:SZZL",
      companyName: "Sizzle Acquisition Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-szzlu",
      code: "NASDAQ:SZZLU",
      companyName: "Sizzle Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-t",
      code: "NASDAQ:T",
      companyName: "AT&T Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-t-a",
      code: "NASDAQ:T-A",
      companyName:
        "AT&T Inc. Depositary Shares each representing a 1/1000th interest in a share of 5.000% Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-t-c",
      code: "NASDAQ:T-C",
      companyName:
        "AT&T Inc. Depositary Shares each representing a 1/1000th interest in a share of 4.750% Perpetual Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nasdaq-ta",
      code: "NASDAQ:TA",
      companyName: "TravelCenters of America Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tac",
      code: "NASDAQ:TAC",
      companyName: "TransAlta Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-taca",
      code: "NASDAQ:TACA",
      companyName: "Trepont Acquisition Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tact",
      code: "NASDAQ:TACT",
      companyName: "TransAct Technologies Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tait",
      code: "NASDAQ:TAIT",
      companyName: "Taitron Components Incorporated Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tal",
      code: "NASDAQ:TAL",
      companyName: "TAL Education Group American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-talk",
      code: "NASDAQ:TALK",
      companyName: "Talkspace Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-talkw",
      code: "NASDAQ:TALKW",
      companyName: "Talkspace Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-talo",
      code: "NASDAQ:TALO",
      companyName: "Talos Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tals",
      code: "NASDAQ:TALS",
      companyName: "Talaris Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tanh",
      code: "NASDAQ:TANH",
      companyName: "Tantech Holdings Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tannl",
      code: "NASDAQ:TANNL",
      companyName: "TravelCenters of America Inc. 8.00% Senior Notes due 2029",
      popularity: 0,
    },
    {
      slug: "nasdaq-tannz",
      code: "NASDAQ:TANNZ",
      companyName: "TravelCenters of America Inc. 8.00% Senior Notes due 2030",
      popularity: 0,
    },
    {
      slug: "nasdaq-taop",
      code: "NASDAQ:TAOP",
      companyName: "Taoping Inc. Ordinary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-tap",
      code: "NASDAQ:TAP",
      companyName: "Molson Coors Beverage Company Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tara",
      code: "NASDAQ:TARA",
      companyName: "Protara Therapeutics Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-taro",
      code: "NASDAQ:TARO",
      companyName: "Taro Pharmaceutical Industries Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tars",
      code: "NASDAQ:TARS",
      companyName: "Tarsus Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-task",
      code: "NASDAQ:TASK",
      companyName: "TaskUs Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tast",
      code: "NASDAQ:TAST",
      companyName: "Carrols Restaurant Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tatt",
      code: "NASDAQ:TATT",
      companyName: "TAT Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tayd",
      code: "NASDAQ:TAYD",
      companyName: "Taylor Devices Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbb",
      code: "NASDAQ:TBB",
      companyName: "AT&T Inc. 5.350% Global Notes due 2066",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbbk",
      code: "NASDAQ:TBBK",
      companyName: "The Bancorp Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbc",
      code: "NASDAQ:TBC",
      companyName: "AT&T Inc. 5.625% Global Notes due 2067",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbcp",
      code: "NASDAQ:TBCP",
      companyName:
        "Thunder Bridge Capital Partners III Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbcpu",
      code: "NASDAQ:TBCPU",
      companyName: "Thunder Bridge Capital Partners III Inc. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbcpw",
      code: "NASDAQ:TBCPW",
      companyName: "Thunder Bridge Capital Partners III Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbi",
      code: "NASDAQ:TBI",
      companyName: "TrueBlue Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbk",
      code: "NASDAQ:TBK",
      companyName: "Triumph Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbkcp",
      code: "NASDAQ:TBKCP",
      companyName:
        "Triumph Bancorp Inc. Depositary Shares Each Representing a 1/40th Interest in a Share of 7.125% Series C Fixed-Rate Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbla",
      code: "NASDAQ:TBLA",
      companyName: "Taboola.com Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tblaw",
      code: "NASDAQ:TBLAW",
      companyName: "Taboola.com Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbld",
      code: "NASDAQ:TBLD",
      companyName: "Thornburg Income Builder Opportunities Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tblt",
      code: "NASDAQ:TBLT",
      companyName: "ToughBuilt Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbltw",
      code: "NASDAQ:TBLTW",
      companyName: "ToughBuilt Industries Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbnk",
      code: "NASDAQ:TBNK",
      companyName: "Territorial Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbph",
      code: "NASDAQ:TBPH",
      companyName: "Theravance Biopharma Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbsa",
      code: "NASDAQ:TBSA",
      companyName: "TB SA Acquisition Corp Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-tbsaw",
      code: "NASDAQ:TBSAW",
      companyName: "TB SA Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tc",
      code: "NASDAQ:TC",
      companyName: "TuanChe Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcac",
      code: "NASDAQ:TCAC",
      companyName:
        "Tuatara Capital Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcacu",
      code: "NASDAQ:TCACU",
      companyName: "Tuatara Capital Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcacw",
      code: "NASDAQ:TCACW",
      companyName: "Tuatara Capital Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcbc",
      code: "NASDAQ:TCBC",
      companyName: "TC Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcbi",
      code: "NASDAQ:TCBI",
      companyName: "Texas Capital Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcbio",
      code: "NASDAQ:TCBIO",
      companyName:
        "Texas Capital Bancshares Inc. Depositary Shares 5.75% Fixed Rate Non-Cumulative Perpetual Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcbk",
      code: "NASDAQ:TCBK",
      companyName: "TriCo Bancshares Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcbp",
      code: "NASDAQ:TCBP",
      companyName: "TC BioPharm (Holdings) plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcbpw",
      code: "NASDAQ:TCBPW",
      companyName: "TC BioPharm (Holdings) plc Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcbs",
      code: "NASDAQ:TCBS",
      companyName: "Texas Community Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcbx",
      code: "NASDAQ:TCBX",
      companyName: "Third Coast Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcda",
      code: "NASDAQ:TCDA",
      companyName: "Tricida Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcfc",
      code: "NASDAQ:TCFC",
      companyName: "The Community Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tci",
      code: "NASDAQ:TCI",
      companyName: "Transcontinental Realty Investors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcmd",
      code: "NASDAQ:TCMD",
      companyName: "Tactile Systems Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcn",
      code: "NASDAQ:TCN",
      companyName: "Tricon Residential Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcom",
      code: "NASDAQ:TCOM",
      companyName: "Trip.com Group Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcon",
      code: "NASDAQ:TCON",
      companyName: "TRACON Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcpc",
      code: "NASDAQ:TCPC",
      companyName: "BlackRock TCP Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcrr",
      code: "NASDAQ:TCRR",
      companyName: "TCR2 Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcrt",
      code: "NASDAQ:TCRT",
      companyName: "Alaunos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcrx",
      code: "NASDAQ:TCRX",
      companyName: "TScan Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcs",
      code: "NASDAQ:TCS",
      companyName: "Container Store (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcva",
      code: "NASDAQ:TCVA",
      companyName: "TCV Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tcx",
      code: "NASDAQ:TCX",
      companyName: "Tucows Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-td",
      code: "NASDAQ:TD",
      companyName: "Toronto Dominion Bank (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tdc",
      code: "NASDAQ:TDC",
      companyName: "Teradata Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tdcx",
      code: "NASDAQ:TDCX",
      companyName:
        "TDCX Inc. American Depositary Shares each representing one Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-tds",
      code: "NASDAQ:TDS",
      companyName: "Telephone and Data Systems Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tds-u",
      code: "NASDAQ:TDS-U",
      companyName:
        "Telephone and Data Systems Inc. Depositary Shares Each Representing a 1/1000th Interest in a 6.625% Series UU Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tds-v",
      code: "NASDAQ:TDS-V",
      companyName:
        "Telephone and Data Systems Inc. Depositary Shares Each Representing a 1/1000th Interest in a 6.000% Series VV Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tdup",
      code: "NASDAQ:TDUP",
      companyName: "ThredUp Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tdw",
      code: "NASDAQ:TDW",
      companyName: "Tidewater Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tdy",
      code: "NASDAQ:TDY",
      companyName: "Teledyne Technologies Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-teaf",
      code: "NASDAQ:TEAF",
      companyName: "Ecofin Sustainable and Social Impact Term Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-tech",
      code: "NASDAQ:TECH",
      companyName: "Bio-Techne Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-teck",
      code: "NASDAQ:TECK",
      companyName: "Teck Resources Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tectp",
      code: "NASDAQ:TECTP",
      companyName:
        "Tectonic Financial Inc. 9.00% Fixed-to-Floating Rate Series B Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tedu",
      code: "NASDAQ:TEDU",
      companyName: "Tarena International Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tef",
      code: "NASDAQ:TEF",
      companyName: "Telefonica SA Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tei",
      code: "NASDAQ:TEI",
      companyName: "Templeton Emerging Markets Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tekk",
      code: "NASDAQ:TEKK",
      companyName: "Tekkorp Digital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tekku",
      code: "NASDAQ:TEKKU",
      companyName: "Tekkorp Digital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-tekkw",
      code: "NASDAQ:TEKKW",
      companyName: "Tekkorp Digital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tel",
      code: "NASDAQ:TEL",
      companyName: "TE Connectivity Ltd. New Switzerland Registered Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tell",
      code: "NASDAQ:TELL",
      companyName: "Tellurian Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-telz",
      code: "NASDAQ:TELZ",
      companyName: "Tellurian Inc. 8.25% Senior Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-ten",
      code: "NASDAQ:TEN",
      companyName: "Tenneco Inc. Class A Voting Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tenb",
      code: "NASDAQ:TENB",
      companyName: "Tenable Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tenx",
      code: "NASDAQ:TENX",
      companyName: "Tenax Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-teo",
      code: "NASDAQ:TEO",
      companyName: "Telecom Argentina SA",
      popularity: 0,
    },
    {
      slug: "nasdaq-tern",
      code: "NASDAQ:TERN",
      companyName: "Terns Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tess",
      code: "NASDAQ:TESS",
      companyName: "TESSCO Technologies Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tetc",
      code: "NASDAQ:TETC",
      companyName:
        "Tech and Energy Transition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tetcu",
      code: "NASDAQ:TETCU",
      companyName: "Tech and Energy Transition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-tetcw",
      code: "NASDAQ:TETCW",
      companyName: "Tech and Energy Transition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tete",
      code: "NASDAQ:TETE",
      companyName:
        "Technology & Telecommunication Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-teteu",
      code: "NASDAQ:TETEU",
      companyName:
        "Technology & Telecommunication Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-teva",
      code: "NASDAQ:TEVA",
      companyName:
        "Teva Pharmaceutical Industries Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tex",
      code: "NASDAQ:TEX",
      companyName: "Terex Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tfc",
      code: "NASDAQ:TFC",
      companyName: "Truist Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tfc-i",
      code: "NASDAQ:TFC-I",
      companyName: "Truist Financial Corporation Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tfc-o",
      code: "NASDAQ:TFC-O",
      companyName:
        "Truist Financial Corporation Depositary Shares Each Representing a 1/1000th Interest in a Share of Series O Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tfc-r",
      code: "NASDAQ:TFC-R",
      companyName:
        "Truist Financial Corporation Depositary Shares each representing 1/1000th interest in a share of Series R Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tffp",
      code: "NASDAQ:TFFP",
      companyName: "TFF Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tfii",
      code: "NASDAQ:TFII",
      companyName: "TFI International Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tfsa",
      code: "NASDAQ:TFSA",
      companyName: "Terra Income Fund VI 7.00% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-tfsl",
      code: "NASDAQ:TFSL",
      companyName: "TFS Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tfx",
      code: "NASDAQ:TFX",
      companyName: "Teleflex Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tg",
      code: "NASDAQ:TG",
      companyName: "Tredegar Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tga",
      code: "NASDAQ:TGA",
      companyName: "TransGlobe Energy Corporation Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgaa",
      code: "NASDAQ:TGAA",
      companyName: "Target Global Acquisition I Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgaau",
      code: "NASDAQ:TGAAU",
      companyName: "Target Global Acquisition I Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgaaw",
      code: "NASDAQ:TGAAW",
      companyName: "Target Global Acquisition I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgan",
      code: "NASDAQ:TGAN",
      companyName: "Transphorm Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgb",
      code: "NASDAQ:TGB",
      companyName: "Taseko Mines Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgh",
      code: "NASDAQ:TGH",
      companyName: "Textainer Group Holdings Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgh-a",
      code: "NASDAQ:TGH-A",
      companyName:
        "Textainer Group Holdings Limited Depositary Shares each representing a 1/1000th interest in a share of 7.000% Series A Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgh-b",
      code: "NASDAQ:TGH-B",
      companyName:
        "Textainer Group Holdings Limited Depositary Shares each representing a 1/1000th interest in a share of 6.250% Series B Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgls",
      code: "NASDAQ:TGLS",
      companyName: "Tecnoglass Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgna",
      code: "NASDAQ:TGNA",
      companyName: "TEGNA Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgr",
      code: "NASDAQ:TGR",
      companyName: "Kimbell Tiger Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgs",
      code: "NASDAQ:TGS",
      companyName: "Transportadora de Gas del Sur SA TGS Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgt",
      code: "NASDAQ:TGT",
      companyName: "Target Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgtx",
      code: "NASDAQ:TGTX",
      companyName: "TG Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgvc",
      code: "NASDAQ:TGVC",
      companyName: "TG Venture Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgvcu",
      code: "NASDAQ:TGVCU",
      companyName: "TG Venture Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-th",
      code: "NASDAQ:TH",
      companyName: "Target Hospitality Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thac",
      code: "NASDAQ:THAC",
      companyName: "Thrive Acquisition Corporation Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-thacu",
      code: "NASDAQ:THACU",
      companyName: "Thrive Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-thacw",
      code: "NASDAQ:THACW",
      companyName: "Thrive Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-thc",
      code: "NASDAQ:THC",
      companyName: "Tenet Healthcare Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thca",
      code: "NASDAQ:THCA",
      companyName: "Tuscan Holdings Corp. II Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thcaw",
      code: "NASDAQ:THCAW",
      companyName: "Tuscan Holdings Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-thcp",
      code: "NASDAQ:THCP",
      companyName:
        "Thunder Bridge Capital Partners IV Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thcpu",
      code: "NASDAQ:THCPU",
      companyName: "Thunder Bridge Capital Partners IV Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-thcpw",
      code: "NASDAQ:THCPW",
      companyName: "Thunder Bridge Capital Partners IV Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-thff",
      code: "NASDAQ:THFF",
      companyName: "First Financial Corporation Indiana Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thg",
      code: "NASDAQ:THG",
      companyName: "Hanover Insurance Group Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-thm",
      code: "NASDAQ:THM",
      companyName:
        "International Tower Hill Mines Ltd. Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-thmo",
      code: "NASDAQ:THMO",
      companyName: "ThermoGenesis Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tho",
      code: "NASDAQ:THO",
      companyName: "Thor Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thq",
      code: "NASDAQ:THQ",
      companyName:
        "Tekla Healthcare Opportunies Fund Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-thr",
      code: "NASDAQ:THR",
      companyName: "Thermon Group Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thrm",
      code: "NASDAQ:THRM",
      companyName: "Gentherm Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thrn",
      code: "NASDAQ:THRN",
      companyName: "Thorne Healthtech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thrx",
      code: "NASDAQ:THRX",
      companyName: "Theseus Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thry",
      code: "NASDAQ:THRY",
      companyName: "Thryv Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ths",
      code: "NASDAQ:THS",
      companyName: "Treehouse Foods Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-thtx",
      code: "NASDAQ:THTX",
      companyName: "Theratechnologies Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-thw",
      code: "NASDAQ:THW",
      companyName: "Tekla World Healthcare Fund Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-thwww",
      code: "NASDAQ:THWWW",
      companyName: "Target Hospitality Corp. Warrant expiring 3/15/2024",
      popularity: 0,
    },
    {
      slug: "nasdaq-tig",
      code: "NASDAQ:TIG",
      companyName: "Trean Insurance Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tigo",
      code: "NASDAQ:TIGO",
      companyName: "Millicom International Cellular S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tigr",
      code: "NASDAQ:TIGR",
      companyName:
        "UP Fintech Holding Ltd American Depositary Share representing fifteen Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-til",
      code: "NASDAQ:TIL",
      companyName: "Instil Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tile",
      code: "NASDAQ:TILE",
      companyName: "Interface Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-timb",
      code: "NASDAQ:TIMB",
      companyName:
        "TIM S.A. American Depositary Shares (Each representing 5 Common Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-tinv",
      code: "NASDAQ:TINV",
      companyName: "Tiga Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tioa",
      code: "NASDAQ:TIOA",
      companyName: "Tio Tech A Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-tioau",
      code: "NASDAQ:TIOAU",
      companyName: "Tio Tech A Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-tioaw",
      code: "NASDAQ:TIOAW",
      companyName: "Tio Tech A Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-tipt",
      code: "NASDAQ:TIPT",
      companyName: "Tiptree Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tirx",
      code: "NASDAQ:TIRX",
      companyName: "TIAN RUIXIANG Holdings Ltd Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tisi",
      code: "NASDAQ:TISI",
      companyName: "Team Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-titn",
      code: "NASDAQ:TITN",
      companyName: "Titan Machinery Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tivc",
      code: "NASDAQ:TIVC",
      companyName: "Tivic Health Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tixt",
      code: "NASDAQ:TIXT",
      companyName: "TELUS International (Cda) Inc. Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tjx",
      code: "NASDAQ:TJX",
      companyName: "TJX Companies Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tk",
      code: "NASDAQ:TK",
      companyName: "Teekay Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tkat",
      code: "NASDAQ:TKAT",
      companyName: "Takung Art Co. Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tkc",
      code: "NASDAQ:TKC",
      companyName: "Turkcell Iletisim Hizmetleri AS Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tklf",
      code: "NASDAQ:TKLF",
      companyName: "Yoshitsu Co. Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tkno",
      code: "NASDAQ:TKNO",
      companyName: "Alpha Teknova Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tkr",
      code: "NASDAQ:TKR",
      companyName: "Timken Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tlis",
      code: "NASDAQ:TLIS",
      companyName: "Talis Biomedical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tlk",
      code: "NASDAQ:TLK",
      companyName: "PT Telekomunikasi Indonesia Tbk",
      popularity: 0,
    },
    {
      slug: "nasdaq-tlry",
      code: "NASDAQ:TLRY",
      companyName: "Tilray Brands Inc. Class 2 Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tls",
      code: "NASDAQ:TLS",
      companyName: "Telos Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tlsa",
      code: "NASDAQ:TLSA",
      companyName: "Tiziana Life Sciences Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tlys",
      code: "NASDAQ:TLYS",
      companyName: "Tilly's Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmac",
      code: "NASDAQ:TMAC",
      companyName: "The Music Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmbr",
      code: "NASDAQ:TMBR",
      companyName: "Timber Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmc",
      code: "NASDAQ:TMC",
      companyName: "TMC the metals company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmci",
      code: "NASDAQ:TMCI",
      companyName: "Treace Medical Concepts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmcww",
      code: "NASDAQ:TMCWW",
      companyName: "TMC the metals company Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmdi",
      code: "NASDAQ:TMDI",
      companyName: "Titan Medical Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmdx",
      code: "NASDAQ:TMDX",
      companyName: "TransMedics Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmhc",
      code: "NASDAQ:TMHC",
      companyName: "Taylor Morrison Home Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmkr",
      code: "NASDAQ:TMKR",
      companyName: "Tastemaker Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmkrw",
      code: "NASDAQ:TMKRW",
      companyName:
        "Tastemaker Acquisition Corp. Warrant to purchase Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tndm",
      code: "NASDAQ:TNDM",
      companyName: "Tandem Diabetes Care Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tme",
      code: "NASDAQ:TME",
      companyName:
        "Tencent Music Entertainment Group American Depositary Shares each representing two Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmpm",
      code: "NASDAQ:TMPM",
      companyName: "Turmeric Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmpmu",
      code: "NASDAQ:TMPMU",
      companyName: "Turmeric Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmpmw",
      code: "NASDAQ:TMPMW",
      companyName: "Turmeric Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmq",
      code: "NASDAQ:TMQ",
      companyName: "Trilogy Metals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmst",
      code: "NASDAQ:TMST",
      companyName: "TimkenSteel Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmus",
      code: "NASDAQ:TMUS",
      companyName: "T-Mobile US Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tmx",
      code: "NASDAQ:TMX",
      companyName: "Terminix Global Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnc",
      code: "NASDAQ:TNC",
      companyName: "Tennant Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnet",
      code: "NASDAQ:TNET",
      companyName: "TriNet Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tngx",
      code: "NASDAQ:TNGX",
      companyName: "Tango Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnk",
      code: "NASDAQ:TNK",
      companyName: "Teekay Tankers Ltd.",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnl",
      code: "NASDAQ:TNL",
      companyName: "Travel   Leisure Co. Common  Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnon",
      code: "NASDAQ:TNON",
      companyName: "Tenon Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnp",
      code: "NASDAQ:TNP",
      companyName: "Tsakos Energy Navigation Ltd Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnp-d",
      code: "NASDAQ:TNP-D",
      companyName:
        "Tsakos Energy Navigation Ltd 8.75% Series D Cumulative Redeemable Perpetual Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnp-e",
      code: "NASDAQ:TNP-E",
      companyName:
        "Tsakos Energy Navigation Ltd Series E Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Shares par value $1.00",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnp-f",
      code: "NASDAQ:TNP-F",
      companyName:
        "Tsakos Energy Navigation Ltd Series F Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Shares par value $1.00",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnxp",
      code: "NASDAQ:TNXP",
      companyName: "Tonix Pharmaceuticals Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tnya",
      code: "NASDAQ:TNYA",
      companyName: "Tenaya Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-toac",
      code: "NASDAQ:TOAC",
      companyName: "Talon 1 Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-toacw",
      code: "NASDAQ:TOACW",
      companyName: "Talon 1 Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-toi",
      code: "NASDAQ:TOI",
      companyName: "The Oncology Institute Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-toiiw",
      code: "NASDAQ:TOIIW",
      companyName: "The Oncology Institute Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tol",
      code: "NASDAQ:TOL",
      companyName: "Toll Brothers Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tomz",
      code: "NASDAQ:TOMZ",
      companyName: "TOMI Environmental Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tops",
      code: "NASDAQ:TOPS",
      companyName: "TOP Ships Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tost",
      code: "NASDAQ:TOST",
      companyName: "Toast Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tm",
      code: "NASDAQ:TM",
      companyName: "Toyota Motor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tour",
      code: "NASDAQ:TOUR",
      companyName: "Tuniu Corporation American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-town",
      code: "NASDAQ:TOWN",
      companyName: "TowneBank Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpb",
      code: "NASDAQ:TPB",
      companyName: "Turning Point Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpbau",
      code: "NASDAQ:TPBAU",
      companyName: "TPB Acquisition Corporation I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpbaw",
      code: "NASDAQ:TPBAW",
      companyName: "TPB Acquisition Corporation I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpc",
      code: "NASDAQ:TPC",
      companyName: "Tutor Perini Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpg",
      code: "NASDAQ:TPG",
      companyName: "TPG Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tph",
      code: "NASDAQ:TPH",
      companyName: "Tri Pointe Homes Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tphs",
      code: "NASDAQ:TPHS",
      companyName: "Trinity Place Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpl",
      code: "NASDAQ:TPL",
      companyName: "Texas Pacific Land Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpr",
      code: "NASDAQ:TPR",
      companyName: "Tapestry Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpst",
      code: "NASDAQ:TPST",
      companyName: "Tempest Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpta",
      code: "NASDAQ:TPTA",
      companyName: "Terra Property Trust Inc. 6.00% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-tptx",
      code: "NASDAQ:TPTX",
      companyName: "Turning Point Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpvg",
      code: "NASDAQ:TPVG",
      companyName: "TriplePoint Venture Growth BDC Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpx",
      code: "NASDAQ:TPX",
      companyName: "Tempur Sealy International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpz",
      code: "NASDAQ:TPZ",
      companyName:
        "Tortoise Power and Energy Infrastructure Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tr",
      code: "NASDAQ:TR",
      companyName: "Tootsie Roll Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-traq",
      code: "NASDAQ:TRAQ",
      companyName: "Trine II Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trc",
      code: "NASDAQ:TRC",
      companyName: "Tejon Ranch Co Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trca",
      code: "NASDAQ:TRCA",
      companyName:
        "Twin Ridge Capital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trda",
      code: "NASDAQ:TRDA",
      companyName: "Entrada Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trec",
      code: "NASDAQ:TREC",
      companyName: "Trecora Resources Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tree",
      code: "NASDAQ:TREE",
      companyName: "LendingTree Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpic",
      code: "NASDAQ:TPIC",
      companyName: "TPI Composites Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trgp",
      code: "NASDAQ:TRGP",
      companyName: "Targa Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trhc",
      code: "NASDAQ:TRHC",
      companyName: "Tabula Rasa HealthCare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tri",
      code: "NASDAQ:TRI",
      companyName: "Thomson Reuters Corp Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trib",
      code: "NASDAQ:TRIB",
      companyName: "Trinity Biotech plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trin",
      code: "NASDAQ:TRIN",
      companyName: "Trinity Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trip",
      code: "NASDAQ:TRIP",
      companyName: "TripAdvisor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tris",
      code: "NASDAQ:TRIS",
      companyName: "Tristar Acquisition I Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trka",
      code: "NASDAQ:TRKA",
      companyName: "Troika Media Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trkaw",
      code: "NASDAQ:TRKAW",
      companyName: "Troika Media Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-trmb",
      code: "NASDAQ:TRMB",
      companyName: "Trimble Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trmd",
      code: "NASDAQ:TRMD",
      companyName: "TORM plc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trmk",
      code: "NASDAQ:TRMK",
      companyName: "Trustmark Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trmr",
      code: "NASDAQ:TRMR",
      companyName: "Tremor International Ltd. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trn",
      code: "NASDAQ:TRN",
      companyName: "Trinity Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trno",
      code: "NASDAQ:TRNO",
      companyName: "Terreno Realty Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trns",
      code: "NASDAQ:TRNS",
      companyName: "Transcat Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tron",
      code: "NASDAQ:TRON",
      companyName: "Corner Growth Acquisition Corp. 2 Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-tronw",
      code: "NASDAQ:TRONW",
      companyName: "Corner Growth Acquisition Corp. 2 Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-troo",
      code: "NASDAQ:TROO",
      companyName: "TROOPS Inc. Ordinary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-trow",
      code: "NASDAQ:TROW",
      companyName: "T. Rowe Price Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trox",
      code: "NASDAQ:TROX",
      companyName: "Tronox Holdings plc Ordinary Shares (UK)",
      popularity: 0,
    },
    {
      slug: "nasdaq-trp",
      code: "NASDAQ:TRP",
      companyName: "TC Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trq",
      code: "NASDAQ:TRQ",
      companyName: "Turquoise Hill Resources Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trs",
      code: "NASDAQ:TRS",
      companyName: "TriMas Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trst",
      code: "NASDAQ:TRST",
      companyName: "TrustCo Bank Corp NY Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trt",
      code: "NASDAQ:TRT",
      companyName: "Trio-Tech International Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trtl",
      code: "NASDAQ:TRTL",
      companyName:
        "TortoiseEcofin Acquisition Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trtn",
      code: "NASDAQ:TRTN",
      companyName: "Triton International Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trtn-a",
      code: "NASDAQ:TRTN-A",
      companyName:
        "Triton International Limited 8.50% Series A Cumulative Redeemable Perpetual  Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trtn-b",
      code: "NASDAQ:TRTN-B",
      companyName:
        "Triton International Limited 8.00% Series B Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trtn-c",
      code: "NASDAQ:TRTN-C",
      companyName:
        "Triton International Limited 7.375% Series C Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trtn-d",
      code: "NASDAQ:TRTN-D",
      companyName:
        "Triton International Limited 6.875% Series D Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trtn-e",
      code: "NASDAQ:TRTN-E",
      companyName:
        "Triton International Limited 5.75% Series E Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trtx",
      code: "NASDAQ:TRTX",
      companyName: "TPG RE Finance Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trtx-c",
      code: "NASDAQ:TRTX-C",
      companyName:
        "TPG RE Finance Trust Inc. 6.25% Series C Cumulative Redeemable Preferred Stock $0.001 par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-tru",
      code: "NASDAQ:TRU",
      companyName: "TransUnion Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-true",
      code: "NASDAQ:TRUE",
      companyName: "TrueCar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trup",
      code: "NASDAQ:TRUP",
      companyName: "Trupanion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trv",
      code: "NASDAQ:TRV",
      companyName: "The Travelers Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsbk",
      code: "NASDAQ:TSBK",
      companyName: "Timberland Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsc",
      code: "NASDAQ:TSC",
      companyName: "TriState Capital Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tscap",
      code: "NASDAQ:TSCAP",
      companyName:
        "TriState Capital Holdings Inc. Dep Shs Rep 1/40th Int 6.75% Srs A Non-Cum Pfd Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tscbp",
      code: "NASDAQ:TSCBP",
      companyName:
        "TriState Capital Holdings Inc. Depositary Share representing a 1/40th Interest in a Share of 6.375% Fixed-to-Floating Rate Series B Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tse",
      code: "NASDAQ:TSE",
      companyName: "Trinseo PLC Ordinary Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsem",
      code: "NASDAQ:TSEM",
      companyName: "Tower Semiconductor Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsha",
      code: "NASDAQ:TSHA",
      companyName: "Taysha Gene Therapies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsi",
      code: "NASDAQ:TSI",
      companyName: "TCW Strategic Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsib",
      code: "NASDAQ:TSIB",
      companyName: "Tishman Speyer Innovation Corp. II Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsibu",
      code: "NASDAQ:TSIBU",
      companyName: "Tishman Speyer Innovation Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsibw",
      code: "NASDAQ:TSIBW",
      companyName: "Tishman Speyer Innovation Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tslx",
      code: "NASDAQ:TSLX",
      companyName: "Sixth Street Specialty Lending Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttd",
      code: "NASDAQ:TTD",
      companyName: "The Trade Desk Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsn",
      code: "NASDAQ:TSN",
      companyName: "Tyson Foods Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsp",
      code: "NASDAQ:TSP",
      companyName: "TuSimple Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tspq",
      code: "NASDAQ:TSPQ",
      companyName: "TCW Special Purpose Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsq",
      code: "NASDAQ:TSQ",
      companyName: "Townsquare Media Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsri",
      code: "NASDAQ:TSRI",
      companyName: "TSR Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsvt",
      code: "NASDAQ:TSVT",
      companyName: "2seventy bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tt",
      code: "NASDAQ:TT",
      companyName: "Trane Technologies plc",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttc",
      code: "NASDAQ:TTC",
      companyName: "Toro Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttcf",
      code: "NASDAQ:TTCF",
      companyName: "Tattooed Chef Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tte",
      code: "NASDAQ:TTE",
      companyName: "TotalEnergies SE",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttec",
      code: "NASDAQ:TTEC",
      companyName: "TTEC Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttek",
      code: "NASDAQ:TTEK",
      companyName: "Tetra Tech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttgt",
      code: "NASDAQ:TTGT",
      companyName: "TechTarget Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tti",
      code: "NASDAQ:TTI",
      companyName: "Tetra Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttm",
      code: "NASDAQ:TTM",
      companyName: "Tata Motors Ltd Tata Motors Limited",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttmi",
      code: "NASDAQ:TTMI",
      companyName: "TTM Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttnp",
      code: "NASDAQ:TTNP",
      companyName: "Titan Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttoo",
      code: "NASDAQ:TTOO",
      companyName: "T2 Biosystems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttp",
      code: "NASDAQ:TTP",
      companyName: "Tortoise Pipeline & Energy Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttsh",
      code: "NASDAQ:TTSH",
      companyName: "Tile Shop Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ttwo",
      code: "NASDAQ:TTWO",
      companyName: "Take-Two Interactive Software Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tu",
      code: "NASDAQ:TU",
      companyName: "Telus Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tuem",
      code: "NASDAQ:TUEM",
      companyName: "Tuesday Morning Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tufn",
      code: "NASDAQ:TUFN",
      companyName: "Tufin Software Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tup",
      code: "NASDAQ:TUP",
      companyName: "Tupperware Brands Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-turn",
      code: "NASDAQ:TURN",
      companyName: "180 Degree Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tusk",
      code: "NASDAQ:TUSK",
      companyName: "Mammoth Energy Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tuya",
      code: "NASDAQ:TUYA",
      companyName:
        "Tuya Inc. American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-tv",
      code: "NASDAQ:TV",
      companyName: "Grupo Televisa S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tvc",
      code: "NASDAQ:TVC",
      companyName: "Tennessee Valley Authority Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tve",
      code: "NASDAQ:TVE",
      companyName: "Tennessee Valley Authority",
      popularity: 0,
    },
    {
      slug: "nasdaq-tvtx",
      code: "NASDAQ:TVTX",
      companyName: "Travere Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tvty",
      code: "NASDAQ:TVTY",
      companyName: "Tivity Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tw",
      code: "NASDAQ:TW",
      companyName: "Tradeweb Markets Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twi",
      code: "NASDAQ:TWI",
      companyName: "Titan International Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twin",
      code: "NASDAQ:TWIN",
      companyName: "Twin Disc Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twks",
      code: "NASDAQ:TWKS",
      companyName: "Thoughtworks Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twlo",
      code: "NASDAQ:TWLO",
      companyName: "Twilio Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twlv",
      code: "NASDAQ:TWLV",
      companyName: "Twelve Seas Investment Company II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twlvu",
      code: "NASDAQ:TWLVU",
      companyName: "Twelve Seas Investment Company II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-twlvw",
      code: "NASDAQ:TWLVW",
      companyName: "Twelve Seas Investment Company II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-twn",
      code: "NASDAQ:TWN",
      companyName: "Taiwan Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twnd",
      code: "NASDAQ:TWND",
      companyName: "Tailwind Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twni",
      code: "NASDAQ:TWNI",
      companyName:
        "Tailwind International Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-twnk",
      code: "NASDAQ:TWNK",
      companyName: "Hostess Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-two",
      code: "NASDAQ:TWO",
      companyName: "Two Harbors Investment Corp",
      popularity: 0,
    },
    {
      slug: "nasdaq-two-a",
      code: "NASDAQ:TWO-A",
      companyName:
        "Two Harbors Investments Corp 8.125% Series A Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock ($25.00 liquidation preference per share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-two-b",
      code: "NASDAQ:TWO-B",
      companyName:
        "Two Harbors Investments Corp 7.625% Series B Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-two-c",
      code: "NASDAQ:TWO-C",
      companyName:
        "Two Harbors Investments Corp 7.25% Series C Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twoa",
      code: "NASDAQ:TWOA",
      companyName: "two Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-twou",
      code: "NASDAQ:TWOU",
      companyName: "2U Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twst",
      code: "NASDAQ:TWST",
      companyName: "Twist Bioscience Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tx",
      code: "NASDAQ:TX",
      companyName:
        "Ternium S.A. Ternium S.A. American Depositary Shares (each representing ten shares USD1.00 par value)",
      popularity: 0,
    },
    {
      slug: "nasdaq-txg",
      code: "NASDAQ:TXG",
      companyName: "10x Genomics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-txmd",
      code: "NASDAQ:TXMD",
      companyName: "TherapeuticsMD Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-txn",
      code: "NASDAQ:TXN",
      companyName: "Texas Instruments Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-txrh",
      code: "NASDAQ:TXRH",
      companyName: "Texas Roadhouse Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-txt",
      code: "NASDAQ:TXT",
      companyName: "Textron Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ty",
      code: "NASDAQ:TY",
      companyName: "Tri Continental Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ty-",
      code: "NASDAQ:TY-",
      companyName: "Tri Continental Corporation Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tyg",
      code: "NASDAQ:TYG",
      companyName: "Tortoise Energy Infrastructure Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tyme",
      code: "NASDAQ:TYME",
      companyName: "Tyme Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tyra",
      code: "NASDAQ:TYRA",
      companyName: "Tyra Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tzoo",
      code: "NASDAQ:TZOO",
      companyName: "Travelzoo Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tzps",
      code: "NASDAQ:TZPS",
      companyName: "TZP Strategies Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-tzpsw",
      code: "NASDAQ:TZPSW",
      companyName: "TZP Strategies Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ua",
      code: "NASDAQ:UA",
      companyName: "Under Armour Inc. Class C Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uaa",
      code: "NASDAQ:UAA",
      companyName: "Under Armour Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ual",
      code: "NASDAQ:UAL",
      companyName: "United Airlines Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uamy",
      code: "NASDAQ:UAMY",
      companyName: "United States Antimony Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uan",
      code: "NASDAQ:UAN",
      companyName:
        "CVR Partners LP Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-uavs",
      code: "NASDAQ:UAVS",
      companyName: "AgEagle Aerial Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uba",
      code: "NASDAQ:UBA",
      companyName: "Urstadt Biddle Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ubcp",
      code: "NASDAQ:UBCP",
      companyName: "United Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ubfo",
      code: "NASDAQ:UBFO",
      companyName: "United Security Bancshares Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uboh",
      code: "NASDAQ:UBOH",
      companyName: "United Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ubp",
      code: "NASDAQ:UBP",
      companyName: "Urstadt Biddle Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ubp-h",
      code: "NASDAQ:UBP-H",
      companyName:
        "Urstadt Biddle Properties Inc. 6.250% Series H Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ubp-k",
      code: "NASDAQ:UBP-K",
      companyName:
        "Urstadt Biddle Properties Inc. 5.875% Series K Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ubs",
      code: "NASDAQ:UBS",
      companyName: "UBS Group AG Registered Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ubsi",
      code: "NASDAQ:UBSI",
      companyName: "United Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ubx",
      code: "NASDAQ:UBX",
      companyName: "Unity Biotechnology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ucbi",
      code: "NASDAQ:UCBI",
      companyName: "United Community Banks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-udr",
      code: "NASDAQ:UDR",
      companyName: "UDR Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ue",
      code: "NASDAQ:UE",
      companyName: "Urban Edge Properties Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-ueic",
      code: "NASDAQ:UEIC",
      companyName: "Universal Electronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ueps",
      code: "NASDAQ:UEPS",
      companyName: "Net 1 UEPS Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ufab",
      code: "NASDAQ:UFAB",
      companyName: "Unique Fabricating Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ufcs",
      code: "NASDAQ:UFCS",
      companyName: "United Fire Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ufi",
      code: "NASDAQ:UFI",
      companyName: "Unifi Inc. New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ufpi",
      code: "NASDAQ:UFPI",
      companyName: "UFP Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ufpt",
      code: "NASDAQ:UFPT",
      companyName: "UFP Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ug",
      code: "NASDAQ:UG",
      companyName: "United-Guardian Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-u",
      code: "NASDAQ:U",
      companyName: "Unity Software Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ugi",
      code: "NASDAQ:UGI",
      companyName: "UGI Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twtr",
      code: "NASDAQ:TWTR",
      companyName: "Twitter Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ugic",
      code: "NASDAQ:UGIC",
      companyName: "UGI Corporation Corporate Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ugp",
      code: "NASDAQ:UGP",
      companyName:
        "Ultrapar Participacoes S.A. (New) American Depositary Shares (Each representing one Common Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ugro",
      code: "NASDAQ:UGRO",
      companyName: "urban-gro Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uhal",
      code: "NASDAQ:UHAL",
      companyName: "Amerco Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uhs",
      code: "NASDAQ:UHS",
      companyName: "Universal Health Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uht",
      code: "NASDAQ:UHT",
      companyName: "Universal Health Realty Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ui",
      code: "NASDAQ:UI",
      companyName: "Ubiquiti Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uihc",
      code: "NASDAQ:UIHC",
      companyName: "United Insurance Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uis",
      code: "NASDAQ:UIS",
      companyName: "Unisys Corporation New Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uk",
      code: "NASDAQ:UK",
      companyName: "Ucommune International Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ukomw",
      code: "NASDAQ:UKOMW",
      companyName: "Ucommune International Ltd Warrant expiring 11/17/2025",
      popularity: 0,
    },
    {
      slug: "nasdaq-ul",
      code: "NASDAQ:UL",
      companyName: "Unilever PLC Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ulbi",
      code: "NASDAQ:ULBI",
      companyName: "Ultralife Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ulcc",
      code: "NASDAQ:ULCC",
      companyName: "Frontier Group Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ulh",
      code: "NASDAQ:ULH",
      companyName: "Universal Logistics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-umbf",
      code: "NASDAQ:UMBF",
      companyName: "UMB Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-umc",
      code: "NASDAQ:UMC",
      companyName: "United Microelectronics Corporation (NEW) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-umh",
      code: "NASDAQ:UMH",
      companyName: "UMH Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-umh-c",
      code: "NASDAQ:UMH-C",
      companyName:
        "UMH Properties Inc. 6.75% Series C Cumulative Redeemable Preferred Stock  Liquidation Preference $25 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-umh-d",
      code: "NASDAQ:UMH-D",
      companyName:
        "UMH Properties Inc. 6.375% Series D Cumulative Redeemable Preferred Stock Liquidation Preference $25 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-umpq",
      code: "NASDAQ:UMPQ",
      companyName: "Umpqua Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unam",
      code: "NASDAQ:UNAM",
      companyName: "Unico American Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unb",
      code: "NASDAQ:UNB",
      companyName: "Union Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uncy",
      code: "NASDAQ:UNCY",
      companyName: "Unicycive Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unf",
      code: "NASDAQ:UNF",
      companyName: "Unifirst Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unfi",
      code: "NASDAQ:UNFI",
      companyName: "United Natural Foods Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unit",
      code: "NASDAQ:UNIT",
      companyName: "Uniti Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unm",
      code: "NASDAQ:UNM",
      companyName: "Unum Group Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unma",
      code: "NASDAQ:UNMA",
      companyName: "Unum Group 6.250% Junior Subordinated Notes due 2058",
      popularity: 0,
    },
    {
      slug: "nasdaq-unp",
      code: "NASDAQ:UNP",
      companyName: "Union Pacific Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unty",
      code: "NASDAQ:UNTY",
      companyName: "Unity Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-unvr",
      code: "NASDAQ:UNVR",
      companyName: "Univar Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uone",
      code: "NASDAQ:UONE",
      companyName: "Urban One Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uonek",
      code: "NASDAQ:UONEK",
      companyName: "Urban One Inc. Class D Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-up",
      code: "NASDAQ:UP",
      companyName: "Wheels Up Experience Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-upc",
      code: "NASDAQ:UPC",
      companyName: "Universe Pharmaceuticals Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-uph",
      code: "NASDAQ:UPH",
      companyName: "UpHealth Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-upld",
      code: "NASDAQ:UPLD",
      companyName: "Upland Software Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ups",
      code: "NASDAQ:UPS",
      companyName: "United Parcel Service Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uptdu",
      code: "NASDAQ:UPTDU",
      companyName: "TradeUP Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-uptdw",
      code: "NASDAQ:UPTDW",
      companyName: "TradeUP Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-upwk",
      code: "NASDAQ:UPWK",
      companyName: "Upwork Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usas",
      code: "NASDAQ:USAS",
      companyName:
        "Americas Gold and Silver Corporation Common Shares no par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-urg",
      code: "NASDAQ:URG",
      companyName: "Ur Energy Inc Common Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-urgn",
      code: "NASDAQ:URGN",
      companyName: "UroGen Pharma Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-uri",
      code: "NASDAQ:URI",
      companyName: "United Rentals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uroy",
      code: "NASDAQ:UROY",
      companyName: "Uranium Royalty Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usa",
      code: "NASDAQ:USA",
      companyName: "Liberty All-Star Equity Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usac",
      code: "NASDAQ:USAC",
      companyName:
        "USA Compression Partners LP Common Units Representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-usak",
      code: "NASDAQ:USAK",
      companyName: "USA Truck Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usap",
      code: "NASDAQ:USAP",
      companyName: "Universal Stainless & Alloy Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usau",
      code: "NASDAQ:USAU",
      companyName: "U.S. Gold Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usb",
      code: "NASDAQ:USB",
      companyName: "U.S. Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usb-a",
      code: "NASDAQ:USB-A",
      companyName:
        "U.S. Bancorp Depositary Shares Each representing a 1/100th interest in a share of Series A Non-CumulativePerpetual Pfd Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usb-h",
      code: "NASDAQ:USB-H",
      companyName: "U.S. Bancorp Depositary Shares repstg 1/1000th Pfd Ser B",
      popularity: 0,
    },
    {
      slug: "nasdaq-usb-p",
      code: "NASDAQ:USB-P",
      companyName:
        "U.S. Bancorp Depositary Shares each representing a 1/1000th interest in a share of Series K Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usb-q",
      code: "NASDAQ:USB-Q",
      companyName:
        "U.S. Bancorp Depositary Shares Each Representing a 1/1000th Interest in a Share of Series L Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usb-r",
      code: "NASDAQ:USB-R",
      companyName:
        "U.S. Bancorp Depositary Shares Each Representing a 1/1000th Interest in a Share of Series M Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usb-s",
      code: "NASDAQ:USB-S",
      companyName:
        "U.S. Bancorp Depositary Shares each representing a 1/1000th interest in a share of Series O Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uscb",
      code: "NASDAQ:USCB",
      companyName: "USCB Financial Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usct",
      code: "NASDAQ:USCT",
      companyName: "TKB Critical Technologies 1 Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-usctu",
      code: "NASDAQ:USCTU",
      companyName: "TKB Critical Technologies 1 Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-usctw",
      code: "NASDAQ:USCTW",
      companyName: "TKB Critical Technologies 1 Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-usdp",
      code: "NASDAQ:USDP",
      companyName:
        "USD Partners LP Common Units representing limited partner interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-useg",
      code: "NASDAQ:USEG",
      companyName: "U.S. Energy Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-user",
      code: "NASDAQ:USER",
      companyName: "UserTesting Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usfd",
      code: "NASDAQ:USFD",
      companyName: "US Foods Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usio",
      code: "NASDAQ:USIO",
      companyName: "Usio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uslm",
      code: "NASDAQ:USLM",
      companyName: "United States Lime & Minerals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usm",
      code: "NASDAQ:USM",
      companyName: "United States Cellular Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usna",
      code: "NASDAQ:USNA",
      companyName: "USANA Health Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usph",
      code: "NASDAQ:USPH",
      companyName: "U.S. Physical Therapy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-usws",
      code: "NASDAQ:USWS",
      companyName: "U.S. Well Services Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uswsw",
      code: "NASDAQ:USWSW",
      companyName: "U.S. Well Services Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-usx",
      code: "NASDAQ:USX",
      companyName: "U.S. Xpress Enterprises Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-utaa",
      code: "NASDAQ:UTAA",
      companyName: "UTA Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-utaau",
      code: "NASDAQ:UTAAU",
      companyName: "UTA Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-utaaw",
      code: "NASDAQ:UTAAW",
      companyName: "UTA Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-utf",
      code: "NASDAQ:UTF",
      companyName: "Cohen & Steers Infrastructure Fund Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-utg",
      code: "NASDAQ:UTG",
      companyName:
        "Reaves Utility Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-uthr",
      code: "NASDAQ:UTHR",
      companyName: "United Therapeutics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uti",
      code: "NASDAQ:UTI",
      companyName: "Universal Technical Institute Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-utl",
      code: "NASDAQ:UTL",
      companyName: "UNITIL Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-utmd",
      code: "NASDAQ:UTMD",
      companyName: "Utah Medical Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-utme",
      code: "NASDAQ:UTME",
      companyName: "UTime Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-utrs",
      code: "NASDAQ:UTRS",
      companyName: "Minerva Surgical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-utsi",
      code: "NASDAQ:UTSI",
      companyName: "UTStarcom Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nasdaq-utz",
      code: "NASDAQ:UTZ",
      companyName: "Utz Brands Inc Class A Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-uuu",
      code: "NASDAQ:UUU",
      companyName: "Universal Security Instruments Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uuuu",
      code: "NASDAQ:UUUU",
      companyName: "Energy Fuels Inc Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-uve",
      code: "NASDAQ:UVE",
      companyName: "UNIVERSAL INSURANCE HOLDINGS INC Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uvsp",
      code: "NASDAQ:UVSP",
      companyName: "Univest Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uvv",
      code: "NASDAQ:UVV",
      companyName: "Universal Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uwmc",
      code: "NASDAQ:UWMC",
      companyName: "UWM Holdings Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uze",
      code: "NASDAQ:UZE",
      companyName:
        "United States Cellular Corporation 5.500% Senior Notes due 2070",
      popularity: 0,
    },
    {
      slug: "nasdaq-uzf",
      code: "NASDAQ:UZF",
      companyName:
        "United States Cellular Corporation 5.500% Senior Notes due 2070",
      popularity: 0,
    },
    {
      slug: "nasdaq-vabk",
      code: "NASDAQ:VABK",
      companyName: "Virginia National Bankshares Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vac",
      code: "NASDAQ:VAC",
      companyName: "Marriott Vacations Worldwide Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vacc",
      code: "NASDAQ:VACC",
      companyName: "Vaccitech plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-val",
      code: "NASDAQ:VAL",
      companyName: "Valaris Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vale",
      code: "NASDAQ:VALE",
      companyName:
        "VALE S.A.  American Depositary Shares Each Representing one common share",
      popularity: 0,
    },
    {
      slug: "nasdaq-valn",
      code: "NASDAQ:VALN",
      companyName: "Valneva SE American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-valu",
      code: "NASDAQ:VALU",
      companyName: "Value Line Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vapo",
      code: "NASDAQ:VAPO",
      companyName: "Vapotherm Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vaqc",
      code: "NASDAQ:VAQC",
      companyName: "Vector Acquisition Corporation II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vate",
      code: "NASDAQ:VATE",
      companyName: "INNOVATE Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vaxx",
      code: "NASDAQ:VAXX",
      companyName: "Vaxxinity Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vbfc",
      code: "NASDAQ:VBFC",
      companyName: "Village Bank and Trust Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vbiv",
      code: "NASDAQ:VBIV",
      companyName: "VBI Vaccines Inc. New Common Stock (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-vblt",
      code: "NASDAQ:VBLT",
      companyName: "Vascular Biogenics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vbnk",
      code: "NASDAQ:VBNK",
      companyName: "VersaBank Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vbocw",
      code: "NASDAQ:VBOCW",
      companyName: "Viscogliosi Brothers Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vbtx",
      code: "NASDAQ:VBTX",
      companyName: "Veritex Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vc",
      code: "NASDAQ:VC",
      companyName: "Visteon Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcel",
      code: "NASDAQ:VCEL",
      companyName: "Vericel Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcif",
      code: "NASDAQ:VCIF",
      companyName:
        "Vertical Capital Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcka",
      code: "NASDAQ:VCKA",
      companyName: "Vickers Vantage Corp. I Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vckau",
      code: "NASDAQ:VCKAU",
      companyName: "Vickers Vantage Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-vckaw",
      code: "NASDAQ:VCKAW",
      companyName: "Vickers Vantage Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcnx",
      code: "NASDAQ:VCNX",
      companyName: "Vaccinex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcsa",
      code: "NASDAQ:VCSA",
      companyName: "Vacasa Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vctr",
      code: "NASDAQ:VCTR",
      companyName: "Victory Capital Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcv",
      code: "NASDAQ:VCV",
      companyName:
        "Invesco California Value Municipal Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcxau",
      code: "NASDAQ:VCXAU",
      companyName: "10X Capital Venture Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcxaw",
      code: "NASDAQ:VCXAW",
      companyName: "10X Capital Venture Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcxb",
      code: "NASDAQ:VCXB",
      companyName:
        "10X Capital Venture Acquisition Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vcyt",
      code: "NASDAQ:VCYT",
      companyName: "Veracyte Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vec",
      code: "NASDAQ:VEC",
      companyName: "Vectrus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-veco",
      code: "NASDAQ:VECO",
      companyName: "Veeco Instruments Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vect",
      code: "NASDAQ:VECT",
      companyName: "VectivBio Holding AG Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-veee",
      code: "NASDAQ:VEEE",
      companyName: "Twin Vee PowerCats Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vel",
      code: "NASDAQ:VEL",
      companyName: "Velocity Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-velo",
      code: "NASDAQ:VELO",
      companyName: "Velocity Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-velou",
      code: "NASDAQ:VELOU",
      companyName: "Velocity Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-velow",
      code: "NASDAQ:VELOW",
      companyName: "Velocity Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vena",
      code: "NASDAQ:VENA",
      companyName: "Venus Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-venar",
      code: "NASDAQ:VENAR",
      companyName: "Venus Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nasdaq-venau",
      code: "NASDAQ:VENAU",
      companyName: "Venus Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-venaw",
      code: "NASDAQ:VENAW",
      companyName: "Venus Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-veon",
      code: "NASDAQ:VEON",
      companyName: "VEON Ltd. ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-vera",
      code: "NASDAQ:VERA",
      companyName: "Vera Therapeutics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-verb",
      code: "NASDAQ:VERB",
      companyName: "Verb Technology Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-verbw",
      code: "NASDAQ:VERBW",
      companyName: "Verb Technology Company Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-veri",
      code: "NASDAQ:VERI",
      companyName: "Veritone Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vero",
      code: "NASDAQ:VERO",
      companyName: "Venus Concept Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-veru",
      code: "NASDAQ:VERU",
      companyName: "Veru Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-verv",
      code: "NASDAQ:VERV",
      companyName: "Verve Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-verx",
      code: "NASDAQ:VERX",
      companyName: "Vertex Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-very",
      code: "NASDAQ:VERY",
      companyName: "Vericity Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vev",
      code: "NASDAQ:VEV",
      companyName: "Vicinity Motor Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vfc",
      code: "NASDAQ:VFC",
      companyName: "V.F. Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vff",
      code: "NASDAQ:VFF",
      companyName: "Village Farms International Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vfl",
      code: "NASDAQ:VFL",
      companyName:
        "Delaware Investments National Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vg",
      code: "NASDAQ:VG",
      companyName: "Vonage Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vgfc",
      code: "NASDAQ:VGFC",
      companyName: "The Very Good Food Company Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vgi",
      code: "NASDAQ:VGI",
      companyName:
        "Virtus Global Multi-Sector Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-vgii",
      code: "NASDAQ:VGII",
      companyName: "Virgin Group Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vgm",
      code: "NASDAQ:VGM",
      companyName:
        "Invesco Trust for Investment Grade Municipals Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-vgr",
      code: "NASDAQ:VGR",
      companyName: "Vector Group Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vgz",
      code: "NASDAQ:VGZ",
      companyName: "Vista Gold Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vhaq",
      code: "NASDAQ:VHAQ",
      companyName: "Viveon Health Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vhc",
      code: "NASDAQ:VHC",
      companyName: "VirnetX Holding Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vhi",
      code: "NASDAQ:VHI",
      companyName: "Valhi Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vhna",
      code: "NASDAQ:VHNA",
      companyName:
        "Vahanna Tech Edge Acquisition I Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vhnaw",
      code: "NASDAQ:VHNAW",
      companyName: "Vahanna Tech Edge Acquisition I Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-via",
      code: "NASDAQ:VIA",
      companyName: "Via Renewables Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-viao",
      code: "NASDAQ:VIAO",
      companyName:
        "VIA optronics AG American Depositary Shares each representing one-fifth of an Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-viasp",
      code: "NASDAQ:VIASP",
      companyName:
        "Via Renewables Inc. 8.75% Series A Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-viav",
      code: "NASDAQ:VIAV",
      companyName: "Viavi Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vici",
      code: "NASDAQ:VICI",
      companyName: "VICI Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vicr",
      code: "NASDAQ:VICR",
      companyName: "Vicor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-view",
      code: "NASDAQ:VIEW",
      companyName: "View Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vieww",
      code: "NASDAQ:VIEWW",
      companyName: "View Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vigl",
      code: "NASDAQ:VIGL",
      companyName: "Vigil Neuroscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vii",
      code: "NASDAQ:VII",
      companyName: "7GC & Co. Holdings Inc. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-viiaw",
      code: "NASDAQ:VIIAW",
      companyName: "7GC & Co. Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vinc",
      code: "NASDAQ:VINC",
      companyName: "Vincerx Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vine",
      code: "NASDAQ:VINE",
      companyName: "Fresh Vine Wine Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vino",
      code: "NASDAQ:VINO",
      companyName: "Gaucho Group Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vinp",
      code: "NASDAQ:VINP",
      companyName: "Vinci Partners Investments Ltd. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-viot",
      code: "NASDAQ:VIOT",
      companyName: "Viomi Technology Co. Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vips",
      code: "NASDAQ:VIPS",
      companyName:
        "Vipshop Holdings Limited American Depositary Shares each representing two ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vir",
      code: "NASDAQ:VIR",
      companyName: "Vir Biotechnology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-virc",
      code: "NASDAQ:VIRC",
      companyName: "Virco Manufacturing Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-viri",
      code: "NASDAQ:VIRI",
      companyName: "Virios Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-virt",
      code: "NASDAQ:VIRT",
      companyName: "Virtu Financial Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-virx",
      code: "NASDAQ:VIRX",
      companyName: "Viracta Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-visl",
      code: "NASDAQ:VISL",
      companyName: "Vislink Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vist",
      code: "NASDAQ:VIST",
      companyName:
        "Vista Energy S.A.B. de C.V. American Depositary Shares each representing one series A share with no par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-vitl",
      code: "NASDAQ:VITL",
      companyName: "Vital Farms Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-viv",
      code: "NASDAQ:VIV",
      companyName:
        "Telefonica Brasil S.A. American Depositary Shares (Each representing One Common Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-vive",
      code: "NASDAQ:VIVE",
      companyName: "Viveve Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vivk",
      code: "NASDAQ:VIVK",
      companyName: "Vivakor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vivo",
      code: "NASDAQ:VIVO",
      companyName: "Meridian Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vjet",
      code: "NASDAQ:VJET",
      companyName: "voxeljet AG American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vki",
      code: "NASDAQ:VKI",
      companyName:
        "Invesco Advantage Municipal Income Trust II Common Shares of Beneficial Interest (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-vkq",
      code: "NASDAQ:VKQ",
      companyName: "Invesco Municipal Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vktx",
      code: "NASDAQ:VKTX",
      companyName: "Viking Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlat",
      code: "NASDAQ:VLAT",
      companyName: "Valor Latitude Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlatu",
      code: "NASDAQ:VLATU",
      companyName: "Valor Latitude Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlatw",
      code: "NASDAQ:VLATW",
      companyName: "Valor Latitude Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlcn",
      code: "NASDAQ:VLCN",
      companyName: "Volcon Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vld",
      code: "NASDAQ:VLD",
      companyName: "Velo3D Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vldr",
      code: "NASDAQ:VLDR",
      companyName: "Velodyne Lidar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vldrw",
      code: "NASDAQ:VLDRW",
      companyName: "Velodyne Lidar Inc. Warrants ",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlgea",
      code: "NASDAQ:VLGEA",
      companyName: "Village Super Market Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vln",
      code: "NASDAQ:VLN",
      companyName: "Valens Semiconductor Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlns",
      code: "NASDAQ:VLNS",
      companyName: "The Valens Company Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlrs",
      code: "NASDAQ:VLRS",
      companyName:
        "Controladora Vuela Compania de Aviacion S.A.B. de C.V. American Depositary Shares each representing ten (10) Ordinary Participation Certificates",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlt",
      code: "NASDAQ:VLT",
      companyName: "Invesco High Income Trust II",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlta",
      code: "NASDAQ:VLTA",
      companyName: "Volta Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vly",
      code: "NASDAQ:VLY",
      companyName: "Valley National Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlypo",
      code: "NASDAQ:VLYPO",
      companyName:
        "Valley National Bancorp 5.50% Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlypp",
      code: "NASDAQ:VLYPP",
      companyName:
        "Valley National Bancorp 6.25% Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmar",
      code: "NASDAQ:VMAR",
      companyName: "Vision Marine Technologies Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmc",
      code: "NASDAQ:VMC",
      companyName: "Vulcan Materials Company (Holding Company) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmcau",
      code: "NASDAQ:VMCAU",
      companyName: "Valuence Merger Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmd",
      code: "NASDAQ:VMD",
      companyName: "Viemed Healthcare Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmeo",
      code: "NASDAQ:VMEO",
      companyName: "Vimeo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmga",
      code: "NASDAQ:VMGA",
      companyName: "VMG Consumer Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmgau",
      code: "NASDAQ:VMGAU",
      companyName: "VMG Consumer Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmi",
      code: "NASDAQ:VMI",
      companyName: "Valmont Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmo",
      code: "NASDAQ:VMO",
      companyName: "Invesco Municipal Opportunity Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vmw",
      code: "NASDAQ:VMW",
      companyName: "Vmware Inc. Common stock Class A",
      popularity: 0,
    },
    {
      slug: "nasdaq-vnce",
      code: "NASDAQ:VNCE",
      companyName: "Vince Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vnda",
      code: "NASDAQ:VNDA",
      companyName: "Vanda Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vnet",
      code: "NASDAQ:VNET",
      companyName: "VNET Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vno",
      code: "NASDAQ:VNO",
      companyName: "Vornado Realty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vno-l",
      code: "NASDAQ:VNO-L",
      companyName: "Vornado Realty Trust Pfd Ser L %",
      popularity: 0,
    },
    {
      slug: "nasdaq-vno-m",
      code: "NASDAQ:VNO-M",
      companyName:
        "Vornado Realty Trust 5.25% Series M Cumulative Redeemable Preferred Shares of Beneficial Interest liquidation preference $25.00 per share no par value per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-vno-n",
      code: "NASDAQ:VNO-N",
      companyName:
        "Vornado Realty Trust 5.25% Series N Cumulative Redeemable Preferred Shares of Beneficial Interest liquidation preference $25.00 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-vno-o",
      code: "NASDAQ:VNO-O",
      companyName:
        "Vornado Realty Trust 4.45% Series O Cumulative Redeemable Preferred Shares Liquidation Preference $25.00 Per Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-vnom",
      code: "NASDAQ:VNOM",
      companyName: "Viper Energy Partners LP Common Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-vnrx",
      code: "NASDAQ:VNRX",
      companyName: "VolitionRX Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vnt",
      code: "NASDAQ:VNT",
      companyName: "Vontier Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-vntr",
      code: "NASDAQ:VNTR",
      companyName: "Venator Materials PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-voc",
      code: "NASDAQ:VOC",
      companyName: "VOC Energy Trust Units of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-vod",
      code: "NASDAQ:VOD",
      companyName: "Vodafone Group Plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vor",
      code: "NASDAQ:VOR",
      companyName: "Vor Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vorb",
      code: "NASDAQ:VORB",
      companyName: "Virgin Orbit Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vorbw",
      code: "NASDAQ:VORBW",
      companyName: "Virgin Orbit Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-voxx",
      code: "NASDAQ:VOXX",
      companyName: "VOXX International Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-voya",
      code: "NASDAQ:VOYA",
      companyName: "Voya Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-voya-b",
      code: "NASDAQ:VOYA-B",
      companyName:
        "Voya Financial Inc. Depositary Shares each representing a 1/40th interest in a share of 5.35% Fixed-Rate Reset Non-Cumulative Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nasdaq-vpcb",
      code: "NASDAQ:VPCB",
      companyName: "VPC Impact Acquisition Holdings II Class A ordinary shre",
      popularity: 0,
    },
    {
      slug: "nasdaq-vpcbu",
      code: "NASDAQ:VPCBU",
      companyName: "VPC Impact Acquisition Holdings II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-vpcbw",
      code: "NASDAQ:VPCBW",
      companyName: "VPC Impact Acquisition Holdings II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vpg",
      code: "NASDAQ:VPG",
      companyName: "Vishay Precision Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vpv",
      code: "NASDAQ:VPV",
      companyName:
        "Invesco Pennsylvania Value Municipal Income Trust Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-vqs",
      code: "NASDAQ:VQS",
      companyName: "VIQ Solutions Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vra",
      code: "NASDAQ:VRA",
      companyName: "Vera Bradley Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrar",
      code: "NASDAQ:VRAR",
      companyName: "The Glimpse Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vray",
      code: "NASDAQ:VRAY",
      companyName: "ViewRay Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrca",
      code: "NASDAQ:VRCA",
      companyName: "Verrica Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrdn",
      code: "NASDAQ:VRDN",
      companyName: "Viridian Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vre",
      code: "NASDAQ:VRE",
      companyName: "Veris Residential Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrex",
      code: "NASDAQ:VREX",
      companyName: "Varex Imaging Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrm",
      code: "NASDAQ:VRM",
      companyName: "Vroom Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrme",
      code: "NASDAQ:VRME",
      companyName: "VerifyMe Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrmew",
      code: "NASDAQ:VRMEW",
      companyName: "VerifyMe Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrna",
      code: "NASDAQ:VRNA",
      companyName: "Verona Pharma plc American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrrm",
      code: "NASDAQ:VRRM",
      companyName: "Verra Mobility Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrsk",
      code: "NASDAQ:VRSK",
      companyName: "Verisk Analytics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrt",
      code: "NASDAQ:VRT",
      companyName: "Vertiv Holdings LLC Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrts",
      code: "NASDAQ:VRTS",
      companyName: "Virtus Investment Partners Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrtv",
      code: "NASDAQ:VRTV",
      companyName: "Veritiv Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vs",
      code: "NASDAQ:VS",
      companyName: "Versus Systems Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vsac",
      code: "NASDAQ:VSAC",
      companyName: "Vision Sensing Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vsacw",
      code: "NASDAQ:VSACW",
      companyName: "Vision Sensing Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-vsat",
      code: "NASDAQ:VSAT",
      companyName: "ViaSat Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vsco",
      code: "NASDAQ:VSCO",
      companyName: "Victorias Secret & Co. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-vsec",
      code: "NASDAQ:VSEC",
      companyName: "VSE Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vsh",
      code: "NASDAQ:VSH",
      companyName: "Vishay Intertechnology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vssyw",
      code: "NASDAQ:VSSYW",
      companyName: "Versus Systems Inc. Class A Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-vst",
      code: "NASDAQ:VST",
      companyName: "Vistra Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vsta",
      code: "NASDAQ:VSTA",
      companyName: "Vasta Platform Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vstm",
      code: "NASDAQ:VSTM",
      companyName: "Verastem Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vsto",
      code: "NASDAQ:VSTO",
      companyName: "Vista Outdoor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtaq",
      code: "NASDAQ:VTAQ",
      companyName: "Ventoux CCM Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtaqr",
      code: "NASDAQ:VTAQR",
      companyName: "Ventoux CCM Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtaqu",
      code: "NASDAQ:VTAQU",
      companyName: "Ventoux CCM Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtaqw",
      code: "NASDAQ:VTAQW",
      companyName: "Ventoux CCM Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtex",
      code: "NASDAQ:VTEX",
      companyName: "VTEX Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtgn",
      code: "NASDAQ:VTGN",
      companyName: "VistaGen Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtiq",
      code: "NASDAQ:VTIQ",
      companyName: "VectoIQ Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtiqu",
      code: "NASDAQ:VTIQU",
      companyName: "VectoIQ Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtiqw",
      code: "NASDAQ:VTIQW",
      companyName: "VectoIQ Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtn",
      code: "NASDAQ:VTN",
      companyName:
        "Invesco Trust for Investment Grade New York Municipals Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtnr",
      code: "NASDAQ:VTNR",
      companyName: "Vertex Energy Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtol",
      code: "NASDAQ:VTOL",
      companyName: "Bristow Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtrs",
      code: "NASDAQ:VTRS",
      companyName: "Viatris Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtru",
      code: "NASDAQ:VTRU",
      companyName: "Vitru Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtsi",
      code: "NASDAQ:VTSI",
      companyName: "VirTra Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtvt",
      code: "NASDAQ:VTVT",
      companyName: "vTv Therapeutics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtyx",
      code: "NASDAQ:VTYX",
      companyName: "Ventyx Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vuzi",
      code: "NASDAQ:VUZI",
      companyName: "Vuzix Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vvi",
      code: "NASDAQ:VVI",
      companyName: "Viad Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vvnt",
      code: "NASDAQ:VVNT",
      companyName: "Vivint Smart Home Inc. ",
      popularity: 0,
    },
    {
      slug: "nasdaq-vvos",
      code: "NASDAQ:VVOS",
      companyName: "Vivos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vvpr",
      code: "NASDAQ:VVPR",
      companyName: "VivoPower International PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vvr",
      code: "NASDAQ:VVR",
      companyName: "Invesco Senior Income Trust Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-vvv",
      code: "NASDAQ:VVV",
      companyName: "Valvoline Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vwe",
      code: "NASDAQ:VWE",
      companyName: "Vintage Wine Estates Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vweww",
      code: "NASDAQ:VWEWW",
      companyName: "Vintage Wine Estates Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-vwtr",
      code: "NASDAQ:VWTR",
      companyName: "Vidler Water Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vxrt",
      code: "NASDAQ:VXRT",
      companyName: "Vaxart Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vygg",
      code: "NASDAQ:VYGG",
      companyName: "Vy Global Growth Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-vygr",
      code: "NASDAQ:VYGR",
      companyName: "Voyager Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vyne",
      code: "NASDAQ:VYNE",
      companyName: "VYNE Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vynt",
      code: "NASDAQ:VYNT",
      companyName: "Vyant Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vz",
      code: "NASDAQ:VZ",
      companyName: "Verizon Communications Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vzio",
      code: "NASDAQ:VZIO",
      companyName: "VIZIO Holding Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vzla",
      code: "NASDAQ:VZLA",
      companyName: "Vizsla Silver Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-w",
      code: "NASDAQ:W",
      companyName: "Wayfair Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wab",
      code: "NASDAQ:WAB",
      companyName:
        "Westinghouse Air Brake Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wabc",
      code: "NASDAQ:WABC",
      companyName: "Westamerica Bancorporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wafu",
      code: "NASDAQ:WAFU",
      companyName: "Wah Fu Education Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wal",
      code: "NASDAQ:WAL",
      companyName: "Western Alliance Bancorporation Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nasdaq-wal-a",
      code: "NASDAQ:WAL-A",
      companyName:
        "Western Alliance Bancorporation Depositary Shares Each Representing a 1/400th Interest in a Share of 4.250% Fixed-Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-wald",
      code: "NASDAQ:WALD",
      companyName: "Waldencast Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-waldu",
      code: "NASDAQ:WALDU",
      companyName: "Waldencast Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-waldw",
      code: "NASDAQ:WALDW",
      companyName: "Waldencast Acquisition Corp. Warrant ",
      popularity: 0,
    },
    {
      slug: "nasdaq-warr",
      code: "NASDAQ:WARR",
      companyName:
        "Warrior Technologies Acquisition Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wash",
      code: "NASDAQ:WASH",
      companyName: "Washington Trust Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wat",
      code: "NASDAQ:WAT",
      companyName: "Waters Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-watt",
      code: "NASDAQ:WATT",
      companyName: "Energous Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wavc",
      code: "NASDAQ:WAVC",
      companyName:
        "Waverley Capital Acquisition Corp. 1 Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wavd",
      code: "NASDAQ:WAVD",
      companyName: "WaveDancer Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wave",
      code: "NASDAQ:WAVE",
      companyName: "Eco Wave Power Global AB (publ) American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wavsw",
      code: "NASDAQ:WAVSW",
      companyName: "Western Acquisition Ventures Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-wb",
      code: "NASDAQ:WB",
      companyName: "Weibo Corporation American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-wba",
      code: "NASDAQ:WBA",
      companyName: "Walgreens Boots Alliance Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wbev",
      code: "NASDAQ:WBEV",
      companyName: "Winc Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wbs",
      code: "NASDAQ:WBS",
      companyName: "Webster Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wbs-f",
      code: "NASDAQ:WBS-F",
      companyName:
        "Webster Financial Corporation Depositary Shares Each Representing 1/1000th Interest in a Share of 5.25% Series F Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wbs-g",
      code: "NASDAQ:WBS-G",
      companyName:
        "Webster Financial Corporation Depositary Shares each representing a 1/40th interest in a share of 6.50% Series G non-cumulative perpetual preferred stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wbt",
      code: "NASDAQ:WBT",
      companyName: "Welbilt Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wbx",
      code: "NASDAQ:WBX",
      companyName: "Wallbox N.V. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wcc",
      code: "NASDAQ:WCC",
      companyName: "WESCO International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wcc-a",
      code: "NASDAQ:WCC-A",
      companyName:
        "WESCO International Inc. Depositary Shares each representing 1/1000th interest in a share of Series A Fixed-Rate Reset Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wcn",
      code: "NASDAQ:WCN",
      companyName: "Waste Connections Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wd",
      code: "NASDAQ:WD",
      companyName: "Walker & Dunlop Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wdc",
      code: "NASDAQ:WDC",
      companyName: "Western Digital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wdfc",
      code: "NASDAQ:WDFC",
      companyName: "WD-40 Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wdh",
      code: "NASDAQ:WDH",
      companyName:
        "Waterdrop Inc. American Depositary Shares (each representing the right to receive 10 Class A Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-wdi",
      code: "NASDAQ:WDI",
      companyName:
        "Western Asset Diversified Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-weav",
      code: "NASDAQ:WEAV",
      companyName: "Weave Communications Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-webr",
      code: "NASDAQ:WEBR",
      companyName: "Weber Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wec",
      code: "NASDAQ:WEC",
      companyName: "WEC Energy Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wei",
      code: "NASDAQ:WEI",
      companyName:
        "Weidai Ltd. American depositary shares each  representing one (1) Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-wejo",
      code: "NASDAQ:WEJO",
      companyName: "Wejo Group Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wejow",
      code: "NASDAQ:WEJOW",
      companyName: "Wejo Group Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-wel",
      code: "NASDAQ:WEL",
      companyName:
        "Integrated Wellness Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-well",
      code: "NASDAQ:WELL",
      companyName: "Welltower Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wen",
      code: "NASDAQ:WEN",
      companyName: "Wendy's Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wern",
      code: "NASDAQ:WERN",
      companyName: "Werner Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wes",
      code: "NASDAQ:WES",
      companyName:
        "Western Midstream Partners LP Common Units Representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-wetf",
      code: "NASDAQ:WETF",
      companyName: "WisdomTree Investments Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wex",
      code: "NASDAQ:WEX",
      companyName: "WEX Inc. common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-weys",
      code: "NASDAQ:WEYS",
      companyName: "Weyco Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wf",
      code: "NASDAQ:WF",
      companyName:
        "Woori Financial Group Inc. American Depositary Shares (each representing three (3) shares of Common Stock)",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfc-a",
      code: "NASDAQ:WFC-A",
      companyName:
        "Wells Fargo & Company Depositary Shares each representing a 1/1000th interest in a share of Non-Cumulative Perpetual Class A Preferred Stock Series AA",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfc-c",
      code: "NASDAQ:WFC-C",
      companyName:
        "Wells Fargo & Company Depositary Shares each representing a 1/1000th interest in a share of Non-Cumulative Perpetual Class A Preferred Stock Series CC",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfc-d",
      code: "NASDAQ:WFC-D",
      companyName:
        "Wells Fargo & Company Depositary Shares each representing a 1/1000th interest in  a share of Non-Cumulative Perpetual Class A Preferred Stock Series DD",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfc-l",
      code: "NASDAQ:WFC-L",
      companyName:
        "Wells Fargo & Company Wells Fargo & Company 7.50% Non-Cumulative Perpetual Convertible Class A Preferred Stock Series L",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfc-q",
      code: "NASDAQ:WFC-Q",
      companyName:
        "Wells Fargo & Company Depositary Shares Representing 1/1000th Interest Perpetual Preferred Class A Series Q Fixed to Floating",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfc-r",
      code: "NASDAQ:WFC-R",
      companyName:
        "Wells Fargo & Company Dep Shs Repstg 1/1000th Int Perp Pfd Cl A (Ser R Fixed To Flltg)",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfc-y",
      code: "NASDAQ:WFC-Y",
      companyName:
        "Wells Fargo & Company Depositary Shares each representing a 1/1000th interest in a share of Non-Cumulative Perpetual Class A Preferred Stock Series Y",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfc-z",
      code: "NASDAQ:WFC-Z",
      companyName:
        "Wells Fargo & Company Depositary Shares each representing a 1/1000th interest in a share of Non-Cumulative Perpetual Class A Preferred Stock Series Z",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfcf",
      code: "NASDAQ:WFCF",
      companyName: "Where Food Comes From Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfg",
      code: "NASDAQ:WFG",
      companyName: "West Fraser Timber Co. Ltd Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wfrd",
      code: "NASDAQ:WFRD",
      companyName: "Weatherford International plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wgo",
      code: "NASDAQ:WGO",
      companyName: "Winnebago Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wh",
      code: "NASDAQ:WH",
      companyName: "Wyndham Hotels & Resorts Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-whd",
      code: "NASDAQ:WHD",
      companyName: "Cactus Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-whf",
      code: "NASDAQ:WHF",
      companyName: "WhiteHorse Finance Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-whg",
      code: "NASDAQ:WHG",
      companyName: "Westwood Holdings Group Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-whlm",
      code: "NASDAQ:WHLM",
      companyName: "Wilhelmina International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-whlr",
      code: "NASDAQ:WHLR",
      companyName: "Wheeler Real Estate Investment Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-whlrd",
      code: "NASDAQ:WHLRD",
      companyName:
        "Wheeler Real Estate Investment Trust Inc. Series D Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-whlrl",
      code: "NASDAQ:WHLRL",
      companyName:
        "Wheeler Real Estate Investment Trust Inc. 7.00% Senior Subordinated Convertible Notes Due 2031",
      popularity: 0,
    },
    {
      slug: "nasdaq-whlrp",
      code: "NASDAQ:WHLRP",
      companyName:
        "Wheeler Real Estate Investment Trust Inc. Class B Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-whr",
      code: "NASDAQ:WHR",
      companyName: "Whirlpool Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wia",
      code: "NASDAQ:WIA",
      companyName: "Western Asset Inflation-Linked Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-wilc",
      code: "NASDAQ:WILC",
      companyName: "G. Willi-Food International  Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wimi",
      code: "NASDAQ:WIMI",
      companyName: "WiMi Hologram Cloud Inc. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-wina",
      code: "NASDAQ:WINA",
      companyName: "Winmark Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wing",
      code: "NASDAQ:WING",
      companyName: "Wingstop Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wint",
      code: "NASDAQ:WINT",
      companyName: "Windtree Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-winv",
      code: "NASDAQ:WINV",
      companyName: "WinVest Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-winvr",
      code: "NASDAQ:WINVR",
      companyName: "WinVest Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-winvw",
      code: "NASDAQ:WINVW",
      companyName: "WinVest Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-wire",
      code: "NASDAQ:WIRE",
      companyName: "Encore Wire Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wea",
      code: "NASDAQ:WEA",
      companyName: "Western Asset Bond Fund Share of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-wisa",
      code: "NASDAQ:WISA",
      companyName: "WiSA Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wish",
      code: "NASDAQ:WISH",
      companyName: "ContextLogic Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wit",
      code: "NASDAQ:WIT",
      companyName: "Wipro Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wprt",
      code: "NASDAQ:WPRT",
      companyName: "Westport Fuel Systems Inc Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wiw",
      code: "NASDAQ:WIW",
      companyName: "Western Asset Inflation-Linked Opportunities & Income Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-wix",
      code: "NASDAQ:WIX",
      companyName: "Wix.com Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wk",
      code: "NASDAQ:WK",
      companyName: "Workiva Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wkey",
      code: "NASDAQ:WKEY",
      companyName:
        "WISeKey International Holding AG American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wkhs",
      code: "NASDAQ:WKHS",
      companyName: "Workhorse Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wkme",
      code: "NASDAQ:WKME",
      companyName: "WalkMe Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wksp",
      code: "NASDAQ:WKSP",
      companyName: "Worksport Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wkspw",
      code: "NASDAQ:WKSPW",
      companyName: "Worksport Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-wldn",
      code: "NASDAQ:WLDN",
      companyName: "Willdan Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wlfc",
      code: "NASDAQ:WLFC",
      companyName: "Willis Lease Finance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wlk",
      code: "NASDAQ:WLK",
      companyName: "Westlake Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wlkp",
      code: "NASDAQ:WLKP",
      companyName:
        "Westlake Chemical Partners LP Common Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-wll",
      code: "NASDAQ:WLL",
      companyName: "Whiting Petroleum Corporation Common Stock (New)",
      popularity: 0,
    },
    {
      slug: "nasdaq-wlms",
      code: "NASDAQ:WLMS",
      companyName: "Williams Industrial Services Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wly",
      code: "NASDAQ:WLY",
      companyName: "John Wiley & Sons Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wlyb",
      code: "NASDAQ:WLYB",
      companyName: "John Wiley & Sons Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wm",
      code: "NASDAQ:WM",
      companyName: "Waste Management Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wmb",
      code: "NASDAQ:WMB",
      companyName: "Williams Companies Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wmc",
      code: "NASDAQ:WMC",
      companyName: "Western Asset Mortgage Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wmg",
      code: "NASDAQ:WMG",
      companyName: "Warner Music Group Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wmk",
      code: "NASDAQ:WMK",
      companyName: "Weis Markets Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wmpn",
      code: "NASDAQ:WMPN",
      companyName: "William Penn Bancorporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wneb",
      code: "NASDAQ:WNEB",
      companyName: "Western New England Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wnnr",
      code: "NASDAQ:WNNR",
      companyName: "Andretti Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wns",
      code: "NASDAQ:WNS",
      companyName: "WNS (Holdings) Limited Sponsored ADR (Jersey)",
      popularity: 0,
    },
    {
      slug: "nasdaq-wnw",
      code: "NASDAQ:WNW",
      companyName: "Meiwu Technology Company Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-woof",
      code: "NASDAQ:WOOF",
      companyName:
        "Petco Health and Wellness Company Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wor",
      code: "NASDAQ:WOR",
      companyName: "Worthington Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-worx",
      code: "NASDAQ:WORX",
      companyName: "SCWorx Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wpc",
      code: "NASDAQ:WPC",
      companyName: "W. P. Carey Inc. REIT",
      popularity: 0,
    },
    {
      slug: "nasdaq-wpca",
      code: "NASDAQ:WPCA",
      companyName:
        "Warburg Pincus Capital Corporation IA Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wpcb",
      code: "NASDAQ:WPCB",
      companyName:
        "Warburg Pincus Capital Corporation IB Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wpp",
      code: "NASDAQ:WPP",
      companyName: "WPP plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wqga",
      code: "NASDAQ:WQGA",
      companyName:
        "World Quantum Growth Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrac",
      code: "NASDAQ:WRAC",
      companyName: "Williams Rowland Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrap",
      code: "NASDAQ:WRAP",
      companyName: "Wrap Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrb",
      code: "NASDAQ:WRB",
      companyName: "W.R. Berkley Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrb-e",
      code: "NASDAQ:WRB-E",
      companyName:
        "W.R. Berkley Corporation 5.70% Subordinated Debentures due 2058",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrb-f",
      code: "NASDAQ:WRB-F",
      companyName:
        "W.R. Berkley Corporation 5.10% Subordinated Debentures due 2059",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrb-g",
      code: "NASDAQ:WRB-G",
      companyName:
        "W.R. Berkley Corporation 4.25% Subordinated Debentures due 2060",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrb-h",
      code: "NASDAQ:WRB-H",
      companyName:
        "W.R. Berkley Corporation 4.125% Subordinated Debentures due 2061",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrby",
      code: "NASDAQ:WRBY",
      companyName: "Warby Parker Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wre",
      code: "NASDAQ:WRE",
      companyName: "Washington Real Estate Investment Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrk",
      code: "NASDAQ:WRK",
      companyName: "Westrock Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrld",
      code: "NASDAQ:WRLD",
      companyName: "World Acceptance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wrn",
      code: "NASDAQ:WRN",
      companyName: "Western Copper and Gold Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wsbc",
      code: "NASDAQ:WSBC",
      companyName: "WesBanco Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wsbcp",
      code: "NASDAQ:WSBCP",
      companyName:
        "WesBanco Inc. Depositary Shares Each Representing a 1/40th Interest in a Share of 6.75% Fixed-Rate Reset Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nasdaq-wsbf",
      code: "NASDAQ:WSBF",
      companyName: "Waterstone Financial Inc. Common Stock (MD)",
      popularity: 0,
    },
    {
      slug: "nasdaq-wsc",
      code: "NASDAQ:WSC",
      companyName: "WillScot Mobile Mini Holdings Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wsfs",
      code: "NASDAQ:WSFS",
      companyName: "WSFS Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wow",
      code: "NASDAQ:WOW",
      companyName: "WideOpenWest Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wso",
      code: "NASDAQ:WSO",
      companyName: "Watsco Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wso/b",
      code: "NASDAQ:WSO/B",
      companyName: "Watsco Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-wsr",
      code: "NASDAQ:WSR",
      companyName: "Whitestone REIT Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wst",
      code: "NASDAQ:WST",
      companyName: "West Pharmaceutical Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wstg",
      code: "NASDAQ:WSTG",
      companyName: "Wayside Technology Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtba",
      code: "NASDAQ:WTBA",
      companyName: "West Bancorporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wter",
      code: "NASDAQ:WTER",
      companyName: "The Alkaline Water Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtfc",
      code: "NASDAQ:WTFC",
      companyName: "Wintrust Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtfcm",
      code: "NASDAQ:WTFCM",
      companyName:
        "Wintrust Financial Corporation Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series D",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtfcp",
      code: "NASDAQ:WTFCP",
      companyName:
        "Wintrust Financial Corporation Depositary Shares Each Representing a 1/1000th Interest in a Share of 6.875% Fixed-Rate Reset Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nasdaq-wti",
      code: "NASDAQ:WTI",
      companyName: "W&T Offshore Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtm",
      code: "NASDAQ:WTM",
      companyName: "White Mountains Insurance Group Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtma",
      code: "NASDAQ:WTMA",
      companyName: "Welsbach Technology Metals Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtmar",
      code: "NASDAQ:WTMAR",
      companyName:
        "Welsbach Technology Metals Acquisition Corp. one right to receive 1/10th of a share of common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtmau",
      code: "NASDAQ:WTMAU",
      companyName: "Welsbach Technology Metals Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtrg",
      code: "NASDAQ:WTRG",
      companyName: "Essential Utilities Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtrh",
      code: "NASDAQ:WTRH",
      companyName: "Waitr Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wts",
      code: "NASDAQ:WTS",
      companyName: "Watts Water Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtt",
      code: "NASDAQ:WTT",
      companyName: "Wireless Telecom Group  Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wttr",
      code: "NASDAQ:WTTR",
      companyName: "Select Energy Services Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wtw",
      code: "NASDAQ:WTW",
      companyName:
        "Willis Towers Watson Public Limited Company Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wulf",
      code: "NASDAQ:WULF",
      companyName: "TeraWulf Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wve",
      code: "NASDAQ:WVE",
      companyName: "Wave Life Sciences Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wvfc",
      code: "NASDAQ:WVFC",
      companyName: "WVS Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wvvi",
      code: "NASDAQ:WVVI",
      companyName: "Willamette Valley Vineyards Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wvvip",
      code: "NASDAQ:WVVIP",
      companyName:
        "Willamette Valley Vineyards Inc. Series A Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wynn",
      code: "NASDAQ:WYNN",
      companyName: "Wynn Resorts Limited Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wwac",
      code: "NASDAQ:WWAC",
      companyName: "Worldwide Webb Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-wwacu",
      code: "NASDAQ:WWACU",
      companyName: "Worldwide Webb Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-wwacw",
      code: "NASDAQ:WWACW",
      companyName: "Worldwide Webb Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-wwd",
      code: "NASDAQ:WWD",
      companyName: "Woodward Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wwe",
      code: "NASDAQ:WWE",
      companyName: "World Wrestling Entertainment Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wwr",
      code: "NASDAQ:WWR",
      companyName: "Westwater Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-www",
      code: "NASDAQ:WWW",
      companyName: "Wolverine World Wide Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wy",
      code: "NASDAQ:WY",
      companyName: "Weyerhaeuser Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wyy",
      code: "NASDAQ:WYY",
      companyName: "WidePoint Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-x",
      code: "NASDAQ:X",
      companyName: "United States Steel Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xair",
      code: "NASDAQ:XAIR",
      companyName: "Beyond Air Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xbio",
      code: "NASDAQ:XBIO",
      companyName: "Xenetic Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xbit",
      code: "NASDAQ:XBIT",
      companyName: "XBiotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xcur",
      code: "NASDAQ:XCUR",
      companyName: "Exicure Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xel",
      code: "NASDAQ:XEL",
      companyName: "Xcel Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xela",
      code: "NASDAQ:XELA",
      companyName: "Exela Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xelap",
      code: "NASDAQ:XELAP",
      companyName:
        "Exela Technologies Inc. 6.00% Series B Cumulative Convertible Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xelb",
      code: "NASDAQ:XELB",
      companyName: "Xcel Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xene",
      code: "NASDAQ:XENE",
      companyName: "Xenon Pharmaceuticals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-xent",
      code: "NASDAQ:XENT",
      companyName: "Intersect ENT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xers",
      code: "NASDAQ:XERS",
      companyName: "Xeris Biopharma Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xfin",
      code: "NASDAQ:XFIN",
      companyName: "ExcelFin Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xfinw",
      code: "NASDAQ:XFINW",
      companyName: "ExcelFin Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-xflt",
      code: "NASDAQ:XFLT",
      companyName:
        "XAI Octagon Floating Rate & Alternative Income Term Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-xflt-a",
      code: "NASDAQ:XFLT-A",
      companyName:
        "XAI Octagon Floating Rate & Alternative Income Term Trust 6.50% Series 2026 Term Preferred Shares (Liquidation Preference $25.00)",
      popularity: 0,
    },
    {
      slug: "nasdaq-xfor",
      code: "NASDAQ:XFOR",
      companyName: "X4 Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xgn",
      code: "NASDAQ:XGN",
      companyName: "Exagen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xhr",
      code: "NASDAQ:XHR",
      companyName: "Xenia Hotels & Resorts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xin",
      code: "NASDAQ:XIN",
      companyName: "Xinyuan Real Estate Co Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-xl",
      code: "NASDAQ:XL",
      companyName: "XL Fleet Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xlo",
      code: "NASDAQ:XLO",
      companyName: "Xilio Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xm",
      code: "NASDAQ:XM",
      companyName: "Qualtrics International Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xmtr",
      code: "NASDAQ:XMTR",
      companyName: "Xometry Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xncr",
      code: "NASDAQ:XNCR",
      companyName: "Xencor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xnet",
      code: "NASDAQ:XNET",
      companyName: "Xunlei Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpev",
      code: "NASDAQ:XPEV",
      companyName:
        "XPeng Inc. American depositary shares each representing two Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-xoma",
      code: "NASDAQ:XOMA",
      companyName: "XOMA Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xomao",
      code: "NASDAQ:XOMAO",
      companyName:
        "XOMA Corporation Depositary Shares Rep Series B 8.375% Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xomap",
      code: "NASDAQ:XOMAP",
      companyName:
        "XOMA Corporation 8.625% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xos",
      code: "NASDAQ:XOS",
      companyName: "Xos Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xosww",
      code: "NASDAQ:XOSWW",
      companyName: "Xos Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-xp",
      code: "NASDAQ:XP",
      companyName: "XP Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpax",
      code: "NASDAQ:XPAX",
      companyName: "XPAC Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpaxu",
      code: "NASDAQ:XPAXU",
      companyName: "XPAC Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpaxw",
      code: "NASDAQ:XPAXW",
      companyName: "XPAC Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpdbu",
      code: "NASDAQ:XPDBU",
      companyName: "Power & Digital Infrastructure Acquisition II Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpdbw",
      code: "NASDAQ:XPDBW",
      companyName:
        "Power & Digital Infrastructure Acquisition II Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpel",
      code: "NASDAQ:XPEL",
      companyName: "XPEL Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xper",
      code: "NASDAQ:XPER",
      companyName: "Xperi Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpl",
      code: "NASDAQ:XPL",
      companyName: "Solitario Zinc Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpo",
      code: "NASDAQ:XPO",
      companyName: "XPO Logistics Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-xray",
      code: "NASDAQ:XRAY",
      companyName: "DENTSPLY SIRONA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xrtx",
      code: "NASDAQ:XRTX",
      companyName: "XORTX Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xspa",
      code: "NASDAQ:XSPA",
      companyName: "XpresSpa Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xtlb",
      code: "NASDAQ:XTLB",
      companyName: "XTL Biopharmaceuticals Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-xtnt",
      code: "NASDAQ:XTNT",
      companyName: "Xtant Medical Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xxii",
      code: "NASDAQ:XXII",
      companyName: "22nd Century Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xyf",
      code: "NASDAQ:XYF",
      companyName:
        "X Financial American Depositary Shares each representing six Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-xyl",
      code: "NASDAQ:XYL",
      companyName: "Xylem Inc. Common Stock New",
      popularity: 0,
    },
    {
      slug: "nasdaq-y",
      code: "NASDAQ:Y",
      companyName: "Alleghany Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-yala",
      code: "NASDAQ:YALA",
      companyName:
        "Yalla Group Limited American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ycbd",
      code: "NASDAQ:YCBD",
      companyName: "cbdMD Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ycbd-a",
      code: "NASDAQ:YCBD-A",
      companyName:
        "cbdMD Inc. 8.0% Series A Cumulative Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-yell",
      code: "NASDAQ:YELL",
      companyName: "Yellow Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-yelp",
      code: "NASDAQ:YELP",
      companyName: "Yelp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-yeti",
      code: "NASDAQ:YETI",
      companyName: "YETI Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-yext",
      code: "NASDAQ:YEXT",
      companyName: "Yext Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ygmz",
      code: "NASDAQ:YGMZ",
      companyName: "MingZhu Logistics Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-yi",
      code: "NASDAQ:YI",
      companyName: "111 Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-yj",
      code: "NASDAQ:YJ",
      companyName: "Yunji Inc. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ymab",
      code: "NASDAQ:YMAB",
      companyName: "Y-mAbs Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ymm",
      code: "NASDAQ:YMM",
      companyName:
        "Full Truck Alliance Co. Ltd. American Depositary Shares (each representing 20 Class A Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ymtx",
      code: "NASDAQ:YMTX",
      companyName: "Yumanity Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-yorw",
      code: "NASDAQ:YORW",
      companyName: "York Water Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-yotau",
      code: "NASDAQ:YOTAU",
      companyName: "Yotta Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-you",
      code: "NASDAQ:YOU",
      companyName: "Clear Secure Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ypf",
      code: "NASDAQ:YPF",
      companyName: "YPF Sociedad Anonima Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-yq",
      code: "NASDAQ:YQ",
      companyName:
        "17 Education & Technology Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-yrd",
      code: "NASDAQ:YRD",
      companyName:
        "Yiren Digital Ltd. American Depositary Shares each representing two ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ysg",
      code: "NASDAQ:YSG",
      companyName:
        "Yatsen Holding Limited American Depositary Shares each representing four Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-yten",
      code: "NASDAQ:YTEN",
      companyName: "Yield10 Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ytpg",
      code: "NASDAQ:YTPG",
      companyName: "TPG Pace Beneficial II Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-ytra",
      code: "NASDAQ:YTRA",
      companyName: "Yatra Online Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-yum",
      code: "NASDAQ:YUM",
      companyName: "Yum! Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-yumc",
      code: "NASDAQ:YUMC",
      companyName: "Yum China Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-yvr",
      code: "NASDAQ:YVR",
      companyName: "Liquid Media Group Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-yy",
      code: "NASDAQ:YY",
      companyName: "JOYY Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-xrx",
      code: "NASDAQ:XRX",
      companyName: "Xerox Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-z",
      code: "NASDAQ:Z",
      companyName: "Zillow Group Inc. Class C Capital Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zbh",
      code: "NASDAQ:ZBH",
      companyName: "Zimmer Biomet Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-iel",
      code: "ASX:IEL",
      companyName: "Idp Education Ltd",
      popularity: 0,
    },
    {
      slug: "asx-asr",
      code: "ASX:ASR",
      companyName: "Asra Minerals Ltd",
      popularity: 13000,
    },
    {
      slug: "nasdaq-zcmd",
      code: "NASDAQ:ZCMD",
      companyName: "Zhongchao Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-zd",
      code: "NASDAQ:ZD",
      companyName: "Ziff Davis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zdge",
      code: "NASDAQ:ZDGE",
      companyName: "Zedge Inc. Class B Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-zeal",
      code: "NASDAQ:ZEAL",
      companyName: "Zealand Pharma A/S American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-zen",
      code: "NASDAQ:ZEN",
      companyName: "Zendesk Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zenv",
      code: "NASDAQ:ZENV",
      companyName: "Zenvia Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zepp",
      code: "NASDAQ:ZEPP",
      companyName: "Zepp Health Corporation American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-zest",
      code: "NASDAQ:ZEST",
      companyName: "Ecoark Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zeta",
      code: "NASDAQ:ZETA",
      companyName: "Zeta Global Holdings Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zeus",
      code: "NASDAQ:ZEUS",
      companyName: "Olympic Steel Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zev",
      code: "NASDAQ:ZEV",
      companyName: "Lightning eMotors Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zgn",
      code: "NASDAQ:ZGN",
      companyName: "Ermenegildo Zegna N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-zingw",
      code: "NASDAQ:ZINGW",
      companyName: "FTAC Zeus Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-zion",
      code: "NASDAQ:ZION",
      companyName: "Zions Bancorporation N.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zionl",
      code: "NASDAQ:ZIONL",
      companyName:
        "Zions Bancorporation 6.95% Fixed-to-Floating Rate Subordinated Notes",
      popularity: 0,
    },
    {
      slug: "nasdaq-ziono",
      code: "NASDAQ:ZIONO",
      companyName:
        "Zions Bancorporation N.A. Dep Shs Repstg 1/40th Perp Pfd Ser G",
      popularity: 0,
    },
    {
      slug: "nasdaq-zionp",
      code: "NASDAQ:ZIONP",
      companyName:
        "Zions Bancorporation N.A. Depositary Shares (Each representing 1/40th Interest in a Share of Series A Floating-Rate Non-Cumulative Perpetual Preferred Stock)",
      popularity: 0,
    },
    {
      slug: "nasdaq-zip",
      code: "NASDAQ:ZIP",
      companyName: "ZipRecruiter Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zivo",
      code: "NASDAQ:ZIVO",
      companyName: "Zivo Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zivow",
      code: "NASDAQ:ZIVOW",
      companyName: "Zivo Bioscience Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-zkin",
      code: "NASDAQ:ZKIN",
      companyName: "ZK International Group Co. Ltd Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-zlab",
      code: "NASDAQ:ZLAB",
      companyName: "Zai Lab Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-zme",
      code: "NASDAQ:ZME",
      companyName: "Zhangmen Education Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-znga",
      code: "NASDAQ:ZNGA",
      companyName: "Zynga Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-znh",
      code: "NASDAQ:ZNH",
      companyName: "China Southern Airlines Company Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-znte",
      code: "NASDAQ:ZNTE",
      companyName: "Zanite Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-znteu",
      code: "NASDAQ:ZNTEU",
      companyName: "Zanite Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-zntew",
      code: "NASDAQ:ZNTEW",
      companyName: "Zanite Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-zntl",
      code: "NASDAQ:ZNTL",
      companyName: "Zentalis Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zom",
      code: "NASDAQ:ZOM",
      companyName: "Zomedica Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-od6",
      code: "ASX:OD6",
      companyName: "OD6 Metals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-zsan",
      code: "NASDAQ:ZSAN",
      companyName: "Zosano Pharma Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zt",
      code: "NASDAQ:ZT",
      companyName:
        "Zimmer Energy Transition Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ztaqu",
      code: "NASDAQ:ZTAQU",
      companyName: "Zimmer Energy Transition Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ztaqw",
      code: "NASDAQ:ZTAQW",
      companyName: "Zimmer Energy Transition Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-ztek",
      code: "NASDAQ:ZTEK",
      companyName: "Zentek Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zto",
      code: "NASDAQ:ZTO",
      companyName:
        "ZTO Express (Cayman) Inc. American Depositary Shares each representing one Class A ordinary share.",
      popularity: 0,
    },
    {
      slug: "nasdaq-ztr",
      code: "NASDAQ:ZTR",
      companyName: "Virtus Total Return Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-zumz",
      code: "NASDAQ:ZUMZ",
      companyName: "Zumiez Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zuo",
      code: "NASDAQ:ZUO",
      companyName: "Zuora Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zvia",
      code: "NASDAQ:ZVIA",
      companyName: "Zevia PBC Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zvo",
      code: "NASDAQ:ZVO",
      companyName: "Zovio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zwrk",
      code: "NASDAQ:ZWRK",
      companyName: "Z-Work Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zwrku",
      code: "NASDAQ:ZWRKU",
      companyName: "Z-Work Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-zwrkw",
      code: "NASDAQ:ZWRKW",
      companyName: "Z-Work Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-zws",
      code: "NASDAQ:ZWS",
      companyName: "Zurn Water Solutions Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zy",
      code: "NASDAQ:ZY",
      companyName: "Zymergen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zyme",
      code: "NASDAQ:ZYME",
      companyName: "Zymeworks Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-zyne",
      code: "NASDAQ:ZYNE",
      companyName: "Zynerba Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zyxi",
      code: "NASDAQ:ZYXI",
      companyName: "Zynex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zg",
      code: "NASDAQ:ZG",
      companyName: "Zillow Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zm",
      code: "NASDAQ:ZM",
      companyName: "Zoom Video Communications Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-aen",
      code: "ASX:AEN",
      companyName: "AERAMENTUM RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ckm",
      code: "ASX:CKM",
      companyName: "CHALKOS METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sp1",
      code: "ASX:SP1",
      companyName: "SOUTHERN CROSS PAYMENTS LTD",
      popularity: 0,
    },
    {
      slug: "asx-ctv",
      code: "ASX:CTV",
      companyName: "Colortv Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-aac",
      code: "NYSE:AAC",
      companyName: "Ares Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-aacg",
      code: "NYSE:AACG",
      companyName: "ATA Creativity Global American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-aaci",
      code: "NYSE:AACI",
      companyName: "Armada Acquisition Corp. I Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aaciu",
      code: "NYSE:AACIU",
      companyName: "Armada Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aaciw",
      code: "NYSE:AACIW",
      companyName: "Armada Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aadi",
      code: "NYSE:AADI",
      companyName: "Aadi Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aadr",
      code: "NYSE:AADR",
      companyName: "AdvisorShares Dorsey Wright ADR ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aaic",
      code: "NYSE:AAIC",
      companyName: "Arlington Asset Investment Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-aaic-b",
      code: "NYSE:AAIC-B",
      companyName:
        "Arlington Asset Investment Corp. 7.00% Series B Cumulative Perpetual Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aaic-c",
      code: "NYSE:AAIC-C",
      companyName:
        "Arlington Asset Investment Corp. 8.250% Series C Fixed-to-Floating Rate Cumulative Redeemable Prefer",
      popularity: 0,
    },
    {
      slug: "nyse-aain",
      code: "NYSE:AAIN",
      companyName:
        "Arlington Asset Investment Corp. 6.000% Senior Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "asx-mga",
      code: "ASX:MGA",
      companyName: "Metalsgrove Mining Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-aam-a",
      code: "NYSE:AAM-A",
      companyName:
        "Apollo Asset Management Inc. 6.375% Series A Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aam-b",
      code: "NYSE:AAM-B",
      companyName:
        "Apollo Asset Management Inc. 6.375% Series B Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aamc",
      code: "NYSE:AAMC",
      companyName: "Altisource Asset Mgmt Corp",
      popularity: 0,
    },
    {
      slug: "nyse-aame",
      code: "NYSE:AAME",
      companyName: "Atlantic American Corp",
      popularity: 0,
    },
    {
      slug: "nyse-aan",
      code: "NYSE:AAN",
      companyName: "The Aaron's Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aaoi",
      code: "NYSE:AAOI",
      companyName: "Applied Optoelectronics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aaon",
      code: "NYSE:AAON",
      companyName: "Aaon Inc",
      popularity: 0,
    },
    {
      slug: "nyse-aap",
      code: "NYSE:AAP",
      companyName: "ADVANCE AUTO PARTS INC",
      popularity: 0,
    },
    {
      slug: "nyse-aapb",
      code: "NYSE:AAPB",
      companyName: "GraniteShares 1.75x Long AAPL Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aapd",
      code: "NYSE:AAPD",
      companyName: "Direxion Daily AAPL Bear 1X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-aapu",
      code: "NYSE:AAPU",
      companyName: "Direxion Daily AAPL Bull 1.5X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-aaqc",
      code: "NYSE:AAQC",
      companyName: "Accelerate Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-aat",
      code: "NYSE:AAT",
      companyName: "AMERICAN ASSETS TRUST INC.",
      popularity: 0,
    },
    {
      slug: "nyse-aatc",
      code: "NYSE:AATC",
      companyName: "Autoscope Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aau",
      code: "NYSE:AAU",
      companyName: "Almaden Minerals Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-aaww",
      code: "NYSE:AAWW",
      companyName: "Atlas Air Worldwide Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aaxj",
      code: "NYSE:AAXJ",
      companyName: "iShares MSCI All Country Asia ex Japan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ab",
      code: "NYSE:AB",
      companyName: "AllianceBernstein Holding L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-abc",
      code: "NYSE:ABC",
      companyName: "AmerisourceBergen Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-abcb",
      code: "NYSE:ABCB",
      companyName: "Ameris Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-abcl",
      code: "NYSE:ABCL",
      companyName: "AbCellera Biologics Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-abcm",
      code: "NYSE:ABCM",
      companyName: "Abcam plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-abeo",
      code: "NYSE:ABEO",
      companyName: "Abeona Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-abeq",
      code: "NYSE:ABEQ",
      companyName: "Absolute Select Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-abev",
      code: "NYSE:ABEV",
      companyName: "AMBEV S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-abg",
      code: "NYSE:ABG",
      companyName: "Asbury Automotive Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-abgi",
      code: "NYSE:ABGI",
      companyName: "ABG Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-abio",
      code: "NYSE:ABIO",
      companyName: "ARCA biopharma Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-abm",
      code: "NYSE:ABM",
      companyName: "ABM Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-abmd",
      code: "NYSE:ABMD",
      companyName: "Abiomed Inc",
      popularity: 0,
    },
    {
      slug: "nyse-abr",
      code: "NYSE:ABR",
      companyName: "Arbor Realty Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-abr-d",
      code: "NYSE:ABR-D",
      companyName:
        "Arbor Realty Trust Inc. 6.375% Series D Cumulative Redeemable Preferred Stock Liquidation Preferen",
      popularity: 0,
    },
    {
      slug: "nyse-abr-e",
      code: "NYSE:ABR-E",
      companyName:
        "Arbor Realty Trust Inc. 6.25% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-abr-f",
      code: "NYSE:ABR-F",
      companyName:
        "Arbor Realty Trust Inc. 6.25% Series F Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-absi",
      code: "NYSE:ABSI",
      companyName: "Absci Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-abst",
      code: "NYSE:ABST",
      companyName: "Absolute Software Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-abnb",
      code: "NYSE:ABNB",
      companyName: "Airbnb Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-abtx",
      code: "NYSE:ABTX",
      companyName: "Allegiance Bancshares Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-abus",
      code: "NYSE:ABUS",
      companyName: "Arbutus Biopharma Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-abvc",
      code: "NYSE:ABVC",
      companyName: "ABVC BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ac",
      code: "NYSE:AC",
      companyName: "Associated Capital Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aca",
      code: "NYSE:ACA",
      companyName: "Arcosa Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-abbv",
      code: "NYSE:ABBV",
      companyName: "ABBVIE INC.",
      popularity: 0,
    },
    {
      slug: "nyse-abb",
      code: "NYSE:ABB",
      companyName: "ABB Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-cnxt",
      code: "NYSE:CNXT",
      companyName: "VanEck ChiNext ETF",
      popularity: 0,
    },
    {
      slug: "asx-bte",
      code: "ASX:BTE",
      companyName: "Botala Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-acab",
      code: "NYSE:ACAB",
      companyName: "Atlantic Coastal Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acabu",
      code: "NYSE:ACABU",
      companyName: "Atlantic Coastal Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-acabw",
      code: "NYSE:ACABW",
      companyName: "Atlantic Coastal Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-acac",
      code: "NYSE:ACAC",
      companyName: "Acri Capital Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acacu",
      code: "NYSE:ACACU",
      companyName: "Acri Capital Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-acacw",
      code: "NYSE:ACACW",
      companyName: "Acri Capital Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-acad",
      code: "NYSE:ACAD",
      companyName: "Acadia Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-acah",
      code: "NYSE:ACAH",
      companyName: "Atlantic Coastal Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acahu",
      code: "NYSE:ACAHU",
      companyName: "Atlantic Coastal Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-acahw",
      code: "NYSE:ACAHW",
      companyName: "Atlantic Coastal Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-acaq",
      code: "NYSE:ACAQ",
      companyName: "Athena Consumer Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-acax",
      code: "NYSE:ACAX",
      companyName: "Alset Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acaxr",
      code: "NYSE:ACAXR",
      companyName: "Alset Capital Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-acaxu",
      code: "NYSE:ACAXU",
      companyName: "Alset Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-acaxw",
      code: "NYSE:ACAXW",
      companyName: "Alset Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-acb",
      code: "NYSE:ACB",
      companyName: "Aurora Cannabis Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-acba",
      code: "NYSE:ACBA",
      companyName: "Ace Global Business Acquisition Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-acbau",
      code: "NYSE:ACBAU",
      companyName: "Ace Global Business Acquisition Limited Unit",
      popularity: 0,
    },
    {
      slug: "nyse-acbaw",
      code: "NYSE:ACBAW",
      companyName: "Ace Global Business Acquisition Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-accd",
      code: "NYSE:ACCD",
      companyName: "Accolade Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acco",
      code: "NYSE:ACCO",
      companyName: "Acco Brands Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-acdi",
      code: "NYSE:ACDI",
      companyName: "Ascendant Digital Acquisition Corp. III",
      popularity: 0,
    },
    {
      slug: "nyse-acel",
      code: "NYSE:ACEL",
      companyName: "Accel Entertainment Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-acer",
      code: "NYSE:ACER",
      companyName: "Acer Therapeutics Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-aces",
      code: "NYSE:ACES",
      companyName: "ALPS Clean Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-acet",
      code: "NYSE:ACET",
      companyName: "Adicet Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acev",
      code: "NYSE:ACEV",
      companyName: "ACE Convergence Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-acevu",
      code: "NYSE:ACEVU",
      companyName: "ACE Convergence Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-acevw",
      code: "NYSE:ACEVW",
      companyName: "ACE Convergence Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-acgl",
      code: "NYSE:ACGL",
      companyName: "Arch Capital Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-acgln",
      code: "NYSE:ACGLN",
      companyName:
        "Arch Capital Group Ltd. Depositary Shares each Representing a 1/1000th Interest in a 4.550% Non-Cu",
      popularity: 0,
    },
    {
      slug: "nyse-acglo",
      code: "NYSE:ACGLO",
      companyName:
        "Arch Capital Group Ltd. Depositary Shares Each Representing 1/1000th Interest in a Share of 5.45% N",
      popularity: 0,
    },
    {
      slug: "nyse-ach",
      code: "NYSE:ACH",
      companyName: "Alum Corp of China Limited",
      popularity: 0,
    },
    {
      slug: "nyse-achc",
      code: "NYSE:ACHC",
      companyName: "Acadia Healthcare Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-achl",
      code: "NYSE:ACHL",
      companyName: "Achilles Therapeutics plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-achr",
      code: "NYSE:ACHR",
      companyName: "Archer Aviation Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-achv",
      code: "NYSE:ACHV",
      companyName: "Achieve Life Sciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aci",
      code: "NYSE:ACI",
      companyName: "Albertsons Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-acii",
      code: "NYSE:ACII",
      companyName: "Atlas Crest Investment Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-acio",
      code: "NYSE:ACIO",
      companyName: "Aptus Collared Income Opportunity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aciu",
      code: "NYSE:ACIU",
      companyName: "AC Immune SA",
      popularity: 0,
    },
    {
      slug: "nyse-aciw",
      code: "NYSE:ACIW",
      companyName: "ACI Worldwide Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ackit",
      code: "NYSE:ACKIT",
      companyName: "Ackrell SPAC Partners I Co. Subunits",
      popularity: 0,
    },
    {
      slug: "nyse-ackiu",
      code: "NYSE:ACKIU",
      companyName: "Ackrell SPAC Partners I Co. Units",
      popularity: 0,
    },
    {
      slug: "nyse-ackiw",
      code: "NYSE:ACKIW",
      companyName: "Ackrell SPAC Partners I Co. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-acls",
      code: "NYSE:ACLS",
      companyName: "Axcelis Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-aclx",
      code: "NYSE:ACLX",
      companyName: "Arcellx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acm",
      code: "NYSE:ACM",
      companyName: "Aecom",
      popularity: 0,
    },
    {
      slug: "nyse-acmr",
      code: "NYSE:ACMR",
      companyName: "ACM Research Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acon",
      code: "NYSE:ACON",
      companyName: "Aclarion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aconw",
      code: "NYSE:ACONW",
      companyName: "Aclarion Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-acor",
      code: "NYSE:ACOR",
      companyName: "Acorda Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-acp",
      code: "NYSE:ACP",
      companyName: "abrdn Income Credit Strategies Fund",
      popularity: 0,
    },
    {
      slug: "nyse-acp-a",
      code: "NYSE:ACP-A",
      companyName:
        "abrdn Income Credit Strategies Fund  5.250% Series A Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acqr",
      code: "NYSE:ACQR",
      companyName: "Independence Holdings Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-acqru",
      code: "NYSE:ACQRU",
      companyName: "Independence Holdings Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-acqrw",
      code: "NYSE:ACQRW",
      companyName: "Independence Holdings Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-acr",
      code: "NYSE:ACR",
      companyName: "ACRES Commercial Realty Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-acr-c",
      code: "NYSE:ACR-C",
      companyName:
        "ACRES Commercial Realty Corp. 8.625% Fixed-to-Floating Series C Cumulative Redeemable Preferred Stoc",
      popularity: 0,
    },
    {
      slug: "nyse-acr-d",
      code: "NYSE:ACR-D",
      companyName:
        "ACRES Commercial Realty Corp. 7.875% Series D Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acre",
      code: "NYSE:ACRE",
      companyName: "Ares Commercial Real Estate Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-acro",
      code: "NYSE:ACRO",
      companyName: "Acropolis Infrastructure Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-acrs",
      code: "NYSE:ACRS",
      companyName: "Aclaris Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-acrx",
      code: "NYSE:ACRX",
      companyName: "AcelRx Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-acsi",
      code: "NYSE:ACSI",
      companyName: "American Customer Satisfaction ETF",
      popularity: 0,
    },
    {
      slug: "nyse-acst",
      code: "NYSE:ACST",
      companyName: "Acasti Pharma Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-act",
      code: "NYSE:ACT",
      companyName: "Enact Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-actg",
      code: "NYSE:ACTG",
      companyName: "Acacia Research Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-actv",
      code: "NYSE:ACTV",
      companyName: "LeaderShares Activist Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-acu",
      code: "NYSE:ACU",
      companyName: "Acme United Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-acv",
      code: "NYSE:ACV",
      companyName: "Virtus Diversified Income & Convertible Fund",
      popularity: 0,
    },
    {
      slug: "nyse-acva",
      code: "NYSE:ACVA",
      companyName: "ACV Auctions Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acvf",
      code: "NYSE:ACVF",
      companyName: "American Conservative Values ETF",
      popularity: 0,
    },
    {
      slug: "nyse-acwf",
      code: "NYSE:ACWF",
      companyName: "iShares MSCI Global Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-acwi",
      code: "NYSE:ACWI",
      companyName: "iShares MSCI ACWI ETF",
      popularity: 0,
    },
    {
      slug: "nyse-acwv",
      code: "NYSE:ACWV",
      companyName: "iShares MSCI Global Min Vol Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-acwx",
      code: "NYSE:ACWX",
      companyName: "iShares MSCI ACWI ex US ETF",
      popularity: 0,
    },
    {
      slug: "nyse-acxp",
      code: "NYSE:ACXP",
      companyName: "Acurx Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-adag",
      code: "NYSE:ADAG",
      companyName: "Adagene Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-adal",
      code: "NYSE:ADAL",
      companyName:
        "Anthemis Digital Acquisitions I Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-adalu",
      code: "NYSE:ADALU",
      companyName: "Anthemis Digital Acquisitions I Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-adalw",
      code: "NYSE:ADALW",
      companyName: "Anthemis Digital Acquisitions I Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-adap",
      code: "NYSE:ADAP",
      companyName: "Adaptimmune Therapeutics plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-adc",
      code: "NYSE:ADC",
      companyName: "Agree Realty Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-adc-a",
      code: "NYSE:ADC-A",
      companyName:
        "Agree Realty Corporation Depositary Shares each representing 1/1000th of a 4.250% Series A Cumulat",
      popularity: 0,
    },
    {
      slug: "nyse-adct",
      code: "NYSE:ADCT",
      companyName: "ADC Therapeutics SA",
      popularity: 0,
    },
    {
      slug: "nyse-ader",
      code: "NYSE:ADER",
      companyName: "26 Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aderu",
      code: "NYSE:ADERU",
      companyName: "26 Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aderw",
      code: "NYSE:ADERW",
      companyName: "26 Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ades",
      code: "NYSE:ADES",
      companyName: "Advanced Emissions Solutions Inc",
      popularity: 0,
    },
    {
      slug: "nyse-adex",
      code: "NYSE:ADEX",
      companyName: "Adit EdTech Acquisition Corp",
      popularity: 0,
    },
    {
      slug: "nyse-adfi",
      code: "NYSE:ADFI",
      companyName: "Anfield Dynamic Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-adgi",
      code: "NYSE:ADGI",
      companyName: "Adagio Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-adi",
      code: "NYSE:ADI",
      companyName: "Analog Devices Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-adil",
      code: "NYSE:ADIL",
      companyName: "Adial Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-adilw",
      code: "NYSE:ADILW",
      companyName: "Adial Pharmaceuticals Inc Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-adiv",
      code: "NYSE:ADIV",
      companyName: "SmartETFs Asia Pacific Dividend Builder ETF",
      popularity: 0,
    },
    {
      slug: "nyse-adma",
      code: "NYSE:ADMA",
      companyName: "ADMA Biologics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-adme",
      code: "NYSE:ADME",
      companyName: "Aptus Behavioral Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-admp",
      code: "NYSE:ADMP",
      companyName: "Adamis Pharmaceuticals Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-adn",
      code: "NYSE:ADN",
      companyName: "Advent Technologies Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-adnt",
      code: "NYSE:ADNT",
      companyName: "Adient plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-adnww",
      code: "NYSE:ADNWW",
      companyName: "Advent Technologies Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-adoc",
      code: "NYSE:ADOC",
      companyName: "Edoc Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-adocr",
      code: "NYSE:ADOCR",
      companyName: "Edoc Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-adocw",
      code: "NYSE:ADOCW",
      companyName: "Edoc Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-adp",
      code: "NYSE:ADP",
      companyName: "Automatic Data Processing",
      popularity: 0,
    },
    {
      slug: "nyse-adpt",
      code: "NYSE:ADPT",
      companyName: "Adaptive Biotechnologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-adre",
      code: "NYSE:ADRE",
      companyName: "Invesco BLDRS Emerging Markets 50 ADR Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-adrt",
      code: "NYSE:ADRT",
      companyName: "Ault Disruptive Technologies Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-adse",
      code: "NYSE:ADSE",
      companyName: "ADS-TEC ENERGY PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-adsew",
      code: "NYSE:ADSEW",
      companyName: "ADS-TEC ENERGY PLC Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-adsk",
      code: "NYSE:ADSK",
      companyName: "Autodesk Inc",
      popularity: 0,
    },
    {
      slug: "nyse-adt",
      code: "NYSE:ADT",
      companyName: "ADT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-adth",
      code: "NYSE:ADTH",
      companyName: "AdTheorent Holding Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-adthw",
      code: "NYSE:ADTHW",
      companyName: "AdTheorent Holding Company Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-adtn",
      code: "NYSE:ADTN",
      companyName: "ADTRAN Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-adtx",
      code: "NYSE:ADTX",
      companyName: "Aditxt Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-adus",
      code: "NYSE:ADUS",
      companyName: "Addus HomeCare Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-adv",
      code: "NYSE:ADV",
      companyName: "Advantage Solutions Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-advm",
      code: "NYSE:ADVM",
      companyName: "Adverum Biotechnologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-advww",
      code: "NYSE:ADVWW",
      companyName: "Advantage Solutions Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-adx",
      code: "NYSE:ADX",
      companyName: "Adams Diversified Equity Fund Inc",
      popularity: 0,
    },
    {
      slug: "nyse-adxn",
      code: "NYSE:ADXN",
      companyName: "Addex Therapeutics Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ae",
      code: "NYSE:AE",
      companyName: "Adams Resources & Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aeac",
      code: "NYSE:AEAC",
      companyName: "Authentic Equity Acquisition Corp. Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nyse-aeacu",
      code: "NYSE:AEACU",
      companyName: "Authentic Equity Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aeacw",
      code: "NYSE:AEACW",
      companyName: "Authentic Equity Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aeae",
      code: "NYSE:AEAE",
      companyName: "AltEnergy Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aeaeu",
      code: "NYSE:AEAEU",
      companyName: "AltEnergy Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aeaew",
      code: "NYSE:AEAEW",
      companyName: "AltEnergy Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aee",
      code: "NYSE:AEE",
      companyName: "Ameren Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-aef",
      code: "NYSE:AEF",
      companyName: "abrdn Emerging Markets Equity Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aefc",
      code: "NYSE:AEFC",
      companyName:
        "Aegon Funding Company LLC 5.10% Subordinated Notes due 2049",
      popularity: 0,
    },
    {
      slug: "nyse-aeg",
      code: "NYSE:AEG",
      companyName: "AEGON N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-aeha",
      code: "NYSE:AEHA",
      companyName: "Aesther Healthcare Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aehau",
      code: "NYSE:AEHAU",
      companyName: "Aesther Healthcare Acquisition Corp Units",
      popularity: 0,
    },
    {
      slug: "nyse-aehaw",
      code: "NYSE:AEHAW",
      companyName: "Aesther Healthcare Acquisition Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-aehl",
      code: "NYSE:AEHL",
      companyName:
        "Antelope Enterprise Holdings Limited Common Stock (0.024 par)",
      popularity: 0,
    },
    {
      slug: "nyse-aehr",
      code: "NYSE:AEHR",
      companyName: "Aehr Test Systems",
      popularity: 0,
    },
    {
      slug: "nyse-aei",
      code: "NYSE:AEI",
      companyName: "Alset EHome International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aeis",
      code: "NYSE:AEIS",
      companyName: "Advanced Energy Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ael",
      code: "NYSE:AEL",
      companyName: "American Equity Investment Life Holding Company",
      popularity: 0,
    },
    {
      slug: "nyse-ael-a",
      code: "NYSE:AEL-A",
      companyName:
        "American Equity Investment Life Holding Company Depositary Shares each representing a 1/1000th int",
      popularity: 0,
    },
    {
      slug: "nyse-ael-b",
      code: "NYSE:AEL-B",
      companyName:
        "American Equity Investment Life Holding Company Depositary Shares each representing a 1/1 000th in",
      popularity: 0,
    },
    {
      slug: "nyse-aem",
      code: "NYSE:AEM",
      companyName: "Agnico Eagle Mines Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-aemd",
      code: "NYSE:AEMD",
      companyName: "AETHLON MEDICAL INC",
      popularity: 0,
    },
    {
      slug: "nyse-aenz",
      code: "NYSE:AENZ",
      companyName: "Aenza S.A.A.",
      popularity: 0,
    },
    {
      slug: "nyse-aeo",
      code: "NYSE:AEO",
      companyName: "American Eagle Outfitters",
      popularity: 0,
    },
    {
      slug: "nyse-aep",
      code: "NYSE:AEP",
      companyName: "American Electric Power Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aeppz",
      code: "NYSE:AEPPZ",
      companyName: "American Electric Power Company Inc. Corporate Units",
      popularity: 0,
    },
    {
      slug: "nyse-aer",
      code: "NYSE:AER",
      companyName: "Aercap Holdings N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-aerc",
      code: "NYSE:AERC",
      companyName: "AeroClean Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aeri",
      code: "NYSE:AERI",
      companyName: "Aerie Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aes",
      code: "NYSE:AES",
      companyName: "AES Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-aesc",
      code: "NYSE:AESC",
      companyName: "The AES Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-aese",
      code: "NYSE:AESE",
      companyName: "Allied Esports Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aesr",
      code: "NYSE:AESR",
      companyName: "Anfield U.S. Equity Sector Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aeva",
      code: "NYSE:AEVA",
      companyName: "Aeva Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aey",
      code: "NYSE:AEY",
      companyName: "ADDvantage Technologies Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aeye",
      code: "NYSE:AEYE",
      companyName: "AudioEye Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aezs",
      code: "NYSE:AEZS",
      companyName: "Aeterna Zentaris Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-afac",
      code: "NYSE:AFAC",
      companyName: "Arena Fortify Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-afacu",
      code: "NYSE:AFACU",
      companyName: "Arena Fortify Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-afacw",
      code: "NYSE:AFACW",
      companyName: "Arena Fortify Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-afaq",
      code: "NYSE:AFAQ",
      companyName: "AF Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-afaqu",
      code: "NYSE:AFAQU",
      companyName: "AF Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-afaqw",
      code: "NYSE:AFAQW",
      companyName: "AF Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-afar",
      code: "NYSE:AFAR",
      companyName: "Aura FAT Projects Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-afaru",
      code: "NYSE:AFARU",
      companyName: "Aura FAT Projects Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-afarw",
      code: "NYSE:AFARW",
      companyName: "Aura FAT Projects Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-afb",
      code: "NYSE:AFB",
      companyName: "Alliance National Municipal Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-afbi",
      code: "NYSE:AFBI",
      companyName: "Affinity Bancshares Inc. Common Stock (MD)",
      popularity: 0,
    },
    {
      slug: "nyse-afcg",
      code: "NYSE:AFCG",
      companyName: "AFC Gamma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-afg",
      code: "NYSE:AFG",
      companyName: "American Financial Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-afgb",
      code: "NYSE:AFGB",
      companyName:
        "American Financial Group Inc. 5.875% Subordinated Debentures due 2059",
      popularity: 0,
    },
    {
      slug: "nyse-afgc",
      code: "NYSE:AFGC",
      companyName:
        "American Financial Group Inc. 5.125% Subordinated Debentures due 2059",
      popularity: 0,
    },
    {
      slug: "nyse-afgd",
      code: "NYSE:AFGD",
      companyName:
        "American Financial Group Inc. 5.625% Subordinated Debentures due 2060",
      popularity: 0,
    },
    {
      slug: "nyse-afge",
      code: "NYSE:AFGE",
      companyName:
        "American Financial Group Inc. 4.500% Subordinated Debentures due 2060",
      popularity: 0,
    },
    {
      slug: "nyse-afib",
      code: "NYSE:AFIB",
      companyName: "Acutus Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-afif",
      code: "NYSE:AFIF",
      companyName: "Anfield Universal Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-afk",
      code: "NYSE:AFK",
      companyName: "VanEck Africa Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-afl",
      code: "NYSE:AFL",
      companyName: "Aflac Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aflg",
      code: "NYSE:AFLG",
      companyName: "First Trust Active Factor Large Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-afmc",
      code: "NYSE:AFMC",
      companyName: "First Trust Active Factor Mid Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-afmd",
      code: "NYSE:AFMD",
      companyName: "Affimed N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-afri",
      code: "NYSE:AFRI",
      companyName: "Forafric Global PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-afriw",
      code: "NYSE:AFRIW",
      companyName: "Forafric Global PLC Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-afrm",
      code: "NYSE:AFRM",
      companyName: "Affirm Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-afsm",
      code: "NYSE:AFSM",
      companyName: "First Trust Active Factor Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aft",
      code: "NYSE:AFT",
      companyName: "Apollo Senior Floating Rate Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aftr",
      code: "NYSE:AFTR",
      companyName: "AfterNext HealthTech Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-afty",
      code: "NYSE:AFTY",
      companyName: "Pacer CSOP FTSE China A50 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-afya",
      code: "NYSE:AFYA",
      companyName: "Afya Limited Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ag",
      code: "NYSE:AG",
      companyName: "FIRST MAJESTIC SILVER CORP",
      popularity: 0,
    },
    {
      slug: "nyse-agac",
      code: "NYSE:AGAC",
      companyName: "African Gold Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-agba",
      code: "NYSE:AGBA",
      companyName: "AGBA Acquisition Limited Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-agbar",
      code: "NYSE:AGBAR",
      companyName: "AGBA Acquisition Limited Right",
      popularity: 0,
    },
    {
      slug: "nyse-agbau",
      code: "NYSE:AGBAU",
      companyName: "AGBA Acquisition Limited Unit",
      popularity: 0,
    },
    {
      slug: "nyse-agbaw",
      code: "NYSE:AGBAW",
      companyName: "AGBA Acquisition Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-agcb",
      code: "NYSE:AGCB",
      companyName: "Altimeter Growth Corp. 2",
      popularity: 0,
    },
    {
      slug: "nyse-agco",
      code: "NYSE:AGCO",
      companyName: "AGCO Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-agd",
      code: "NYSE:AGD",
      companyName: "abrdn Global Dynamic Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-age",
      code: "NYSE:AGE",
      companyName: "AgeX Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-agen",
      code: "NYSE:AGEN",
      companyName: "Agenus Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-agfs",
      code: "NYSE:AGFS",
      companyName: "AgroFresh Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-agfy",
      code: "NYSE:AGFY",
      companyName: "Agrify Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aggh",
      code: "NYSE:AGGH",
      companyName: "Simplify Aggregate Bond PLUS Credit Hedge ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aggr",
      code: "NYSE:AGGR",
      companyName: "Agile Growth Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-aggru",
      code: "NYSE:AGGRU",
      companyName: "Agile Growth Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-aggrw",
      code: "NYSE:AGGRW",
      companyName: "Agile Growth Corp. Warrant.",
      popularity: 0,
    },
    {
      slug: "nyse-aggy",
      code: "NYSE:AGGY",
      companyName: "WisdomTree Yield Enhanced U.S. Aggregate Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-agi",
      code: "NYSE:AGI",
      companyName: "Alamos Gold Inc. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-agil",
      code: "NYSE:AGIL",
      companyName: "AgileThought Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-agilw",
      code: "NYSE:AGILW",
      companyName: "AgileThought Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-agio",
      code: "NYSE:AGIO",
      companyName: "Agios Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-agl",
      code: "NYSE:AGL",
      companyName: "agilon health inc.",
      popularity: 0,
    },
    {
      slug: "nyse-agle",
      code: "NYSE:AGLE",
      companyName: "Aeglea BioTherapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-agm",
      code: "NYSE:AGM",
      companyName: "Federal Agricultural Mortgage Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-agm-c",
      code: "NYSE:AGM-C",
      companyName:
        "Federal Agricultural Mortgage Corporation 6.000% Fixed-to-Floating Rate Non-Cumulative Preferred Sto",
      popularity: 0,
    },
    {
      slug: "nyse-agm-d",
      code: "NYSE:AGM-D",
      companyName:
        "Federal Agricultural Mortgage Corporation 5.700% Non-Cumulative Preferred Stock Series D",
      popularity: 0,
    },
    {
      slug: "nyse-agm-e",
      code: "NYSE:AGM-E",
      companyName:
        "Federal Agricultural Mortgage Corporation 5.750% Non-Cumulative Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nyse-agm-f",
      code: "NYSE:AGM-F",
      companyName:
        "Federal Agricultural Mortgage Corporation 5.250% Non-Cumulative Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nyse-agm-g",
      code: "NYSE:AGM-G",
      companyName:
        "Federal Agricultural Mortgage Corporation 4.875% Non-Cumulative Preferred Stock Series G",
      popularity: 0,
    },
    {
      slug: "nyse-agmh",
      code: "NYSE:AGMH",
      companyName: "AGM Group Holdings Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-agnc",
      code: "NYSE:AGNC",
      companyName: "AGNC Investment Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-agncm",
      code: "NYSE:AGNCM",
      companyName:
        "AGNC Investment Corp. Depositary Shares rep 6.875% Series D Fixed-to-Floating Cumulative Redeemable",
      popularity: 0,
    },
    {
      slug: "nyse-agncn",
      code: "NYSE:AGNCN",
      companyName:
        "AGNC Investment Corp. Depositary Shares Each Representing a 1/1000th Interest in a Share of 7 perce",
      popularity: 0,
    },
    {
      slug: "nyse-agnco",
      code: "NYSE:AGNCO",
      companyName:
        "AGNC Investment Corp. Depositary Shares each representing a 1/1000th interest in a share of 6.50%",
      popularity: 0,
    },
    {
      slug: "nyse-agncp",
      code: "NYSE:AGNCP",
      companyName:
        "AGNC Investment Corp. Depositary Shares Each Representing a 1/1000th Interest in a Share of 6.125%",
      popularity: 0,
    },
    {
      slug: "nyse-agov",
      code: "NYSE:AGOV",
      companyName: "ETC Gavekal Asia Pacific Government Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-agox",
      code: "NYSE:AGOX",
      companyName: "Adaptive Alpha Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-agq",
      code: "NYSE:AGQ",
      companyName: "ProShares Ultra Silver",
      popularity: 0,
    },
    {
      slug: "nyse-agr",
      code: "NYSE:AGR",
      companyName: "Avangrid Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-agri",
      code: "NYSE:AGRI",
      companyName: "AgriFORCE Growing Systems Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-agriw",
      code: "NYSE:AGRIW",
      companyName: "AgriFORCE Growing Systems Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-agro",
      code: "NYSE:AGRO",
      companyName: "ADECOAGRO S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-agrx",
      code: "NYSE:AGRX",
      companyName: "Agile Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ags",
      code: "NYSE:AGS",
      companyName: "PlayAGS Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-agt",
      code: "NYSE:AGT",
      companyName: "iShares MSCI Argentina and Global Exposure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-agtc",
      code: "NYSE:AGTC",
      companyName: "Applied Genetic Technologies Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-agti",
      code: "NYSE:AGTI",
      companyName: "Agiliti Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-agx",
      code: "NYSE:AGX",
      companyName: "Argan Inc",
      popularity: 0,
    },
    {
      slug: "nyse-agys",
      code: "NYSE:AGYS",
      companyName: "Agilysys Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-agz",
      code: "NYSE:AGZ",
      companyName: "iShares Agency Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-agzd",
      code: "NYSE:AGZD",
      companyName:
        "WisdomTree Trust WisdomTree Interest Rate Hedged U.S. Aggregate Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-agg",
      code: "NYSE:AGG",
      companyName: "iShares Core U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-agih",
      code: "NYSE:AGIH",
      companyName: "iShares Inflation Hedged U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-agrh",
      code: "NYSE:AGRH",
      companyName: "iShares Interest Rate Hedged U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ahco",
      code: "NYSE:AHCO",
      companyName: "AdaptHealth Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ahg",
      code: "NYSE:AHG",
      companyName: "Akso Health Group ADS",
      popularity: 0,
    },
    {
      slug: "nyse-ahh",
      code: "NYSE:AHH",
      companyName: "Armada Hoffler Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ahh-a",
      code: "NYSE:AHH-A",
      companyName:
        "Armada Hoffler Properties Inc. 6.75% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ahhx",
      code: "NYSE:AHHX",
      companyName: "Adaptive High Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ahi",
      code: "NYSE:AHI",
      companyName: "Advanced Human Imaging Limited. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ahl-c",
      code: "NYSE:AHL-C",
      companyName:
        "Aspen Insurance Holdings Limited 5.95% Fixed-to-Floating Rate Perpetual Non-Cumulative Preference Sh",
      popularity: 0,
    },
    {
      slug: "nyse-ahl-d",
      code: "NYSE:AHL-D",
      companyName:
        "Aspen Insurance Holdings Limited 5.625% Perpetual Non-Cumulative Preference Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ahl-e",
      code: "NYSE:AHL-E",
      companyName:
        "Aspen Insurance Holdings Limited Depositary Shares each representing a 1/1000th interest in a share",
      popularity: 0,
    },
    {
      slug: "nyse-ahoy",
      code: "NYSE:AHOY",
      companyName: "Newday Ocean Health ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ahpa",
      code: "NYSE:AHPA",
      companyName: "Avista Public Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ahpau",
      code: "NYSE:AHPAU",
      companyName: "Avista Public Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ahpaw",
      code: "NYSE:AHPAW",
      companyName: "Avista Public Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ahpi",
      code: "NYSE:AHPI",
      companyName: "Allied Healthcare Products",
      popularity: 0,
    },
    {
      slug: "nyse-ahrn",
      code: "NYSE:AHRN",
      companyName: "Ahren Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ahrnu",
      code: "NYSE:AHRNU",
      companyName: "Ahren Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ahrnw",
      code: "NYSE:AHRNW",
      companyName: "Ahren Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-aht",
      code: "NYSE:AHT",
      companyName: "Ashford Hospitality Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aht-d",
      code: "NYSE:AHT-D",
      companyName: "Ashford Hospitality Trust Inc. 8.45% Series D",
      popularity: 0,
    },
    {
      slug: "nyse-aht-f",
      code: "NYSE:AHT-F",
      companyName: "Ashford Hospitality Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aht-g",
      code: "NYSE:AHT-G",
      companyName:
        "Ashford Hospitality Trust Inc   7.375% Series G Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aht-h",
      code: "NYSE:AHT-H",
      companyName:
        "Ashford Hospitality Trust Inc. 7.50 Percent Series H Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aht-i",
      code: "NYSE:AHT-I",
      companyName:
        "Ashford Hospitality Trust Inc. 7.50% Series I Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ahyb",
      code: "NYSE:AHYB",
      companyName: "American Century Select High Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ai",
      code: "NYSE:AI",
      companyName: "C3.ai Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aia",
      code: "NYSE:AIA",
      companyName: "iShares Asia 50 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aib",
      code: "NYSE:AIB",
      companyName: "AIB Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-aibbr",
      code: "NYSE:AIBBR",
      companyName: "AIB Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nyse-aibbu",
      code: "NYSE:AIBBU",
      companyName: "AIB Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aic",
      code: "NYSE:AIC",
      companyName: "Arlington Asset Investment Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-aieq",
      code: "NYSE:AIEQ",
      companyName: "AI Powered Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aif",
      code: "NYSE:AIF",
      companyName: "Apollo Tactical Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aig",
      code: "NYSE:AIG",
      companyName: "American International Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aig-a",
      code: "NYSE:AIG-A",
      companyName:
        "American International Group Inc. Depositary Shares Each Representing a 1/1000th Interest in a Sha",
      popularity: 0,
    },
    {
      slug: "nyse-aih",
      code: "NYSE:AIH",
      companyName:
        "Aesthetic Medical International Holdings Group Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-aihs",
      code: "NYSE:AIHS",
      companyName: "Senmiao Technology Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aiki",
      code: "NYSE:AIKI",
      companyName: "AIkido Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ailg",
      code: "NYSE:AILG",
      companyName: "Alpha Intelligent - Large Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ailv",
      code: "NYSE:AILV",
      companyName: "Alpha Intelligent - Large Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aim",
      code: "NYSE:AIM",
      companyName: "AIM ImmunoTech Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aimau",
      code: "NYSE:AIMAU",
      companyName: "Aimfinity Investment Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aimaw",
      code: "NYSE:AIMAW",
      companyName: "Aimfinity Investment Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aimbu",
      code: "NYSE:AIMBU",
      companyName: "Aimfinity Investment Corp. I Subunit",
      popularity: 0,
    },
    {
      slug: "nyse-ain",
      code: "NYSE:AIN",
      companyName: "Albany International Corp Class A",
      popularity: 0,
    },
    {
      slug: "nyse-ainc",
      code: "NYSE:AINC",
      companyName: "Ashford Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aio",
      code: "NYSE:AIO",
      companyName:
        "Virtus Artificial Intelligence & Technology Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-aip",
      code: "NYSE:AIP",
      companyName: "Arteris Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-air",
      code: "NYSE:AIR",
      companyName: "AAR Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-airc",
      code: "NYSE:AIRC",
      companyName: "Apartment Income REIT Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-airg",
      code: "NYSE:AIRG",
      companyName: "Airgain Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-airi",
      code: "NYSE:AIRI",
      companyName: "Air Industries Group",
      popularity: 0,
    },
    {
      slug: "nyse-airr",
      code: "NYSE:AIRR",
      companyName: "First Trust RBA American Industrial Renaissance ETF",
      popularity: 0,
    },
    {
      slug: "nyse-airs",
      code: "NYSE:AIRS",
      companyName: "AirSculpt Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-airt",
      code: "NYSE:AIRT",
      companyName: "Air T Inc",
      popularity: 0,
    },
    {
      slug: "nyse-airtp",
      code: "NYSE:AIRTP",
      companyName:
        "Air T Inc. Air T Funding Alpha Income Trust Preferred Securities",
      popularity: 0,
    },
    {
      slug: "nyse-ait",
      code: "NYSE:AIT",
      companyName: "Applied Industrial Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aiu",
      code: "NYSE:AIU",
      companyName: "Meta Data Limited",
      popularity: 0,
    },
    {
      slug: "nyse-aiv",
      code: "NYSE:AIV",
      companyName: "Apartment Investment and Management Company",
      popularity: 0,
    },
    {
      slug: "nyse-aivi",
      code: "NYSE:AIVI",
      companyName: "WisdomTree International AI Enhanced Value Fund",
      popularity: 0,
    },
    {
      slug: "nyse-aivl",
      code: "NYSE:AIVL",
      companyName: "WisdomTree U.S. AI Enhanced Value Fund",
      popularity: 0,
    },
    {
      slug: "nyse-aiz",
      code: "NYSE:AIZ",
      companyName: "Assurant Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aizn",
      code: "NYSE:AIZN",
      companyName: "Assurant Inc. 5.25% Subordinated Notes due 2061",
      popularity: 0,
    },
    {
      slug: "nyse-ajrd",
      code: "NYSE:AJRD",
      companyName: "Aerojet Rocketdyne Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ajx",
      code: "NYSE:AJX",
      companyName: "Great Ajax Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ajxa",
      code: "NYSE:AJXA",
      companyName: "Great Ajax Corp.7.25% Convertible Senior Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nyse-aka",
      code: "NYSE:AKA",
      companyName: "a.k.a. Brands Holding Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-akam",
      code: "NYSE:AKAM",
      companyName: "Akamai Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-akan",
      code: "NYSE:AKAN",
      companyName: "Akanda Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-akba",
      code: "NYSE:AKBA",
      companyName: "Akebia Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-akic",
      code: "NYSE:AKIC",
      companyName: "Sports Ventures Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-akicu",
      code: "NYSE:AKICU",
      companyName: "Sports Ventures Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-akicw",
      code: "NYSE:AKICW",
      companyName: "Sports Ventures Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-akli",
      code: "NYSE:AKLI",
      companyName: "Akili Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-akr",
      code: "NYSE:AKR",
      companyName: "Acadia Realty Trust",
      popularity: 0,
    },
    {
      slug: "nyse-akro",
      code: "NYSE:AKRO",
      companyName: "Akero Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-akts",
      code: "NYSE:AKTS",
      companyName: "AKOUSTIS TECHNOLOGIES INC.",
      popularity: 0,
    },
    {
      slug: "nyse-aktx",
      code: "NYSE:AKTX",
      companyName: "Akari Therapeutics plc ADR (0.01 USD)",
      popularity: 0,
    },
    {
      slug: "nyse-aku",
      code: "NYSE:AKU",
      companyName: "Akumin Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-akus",
      code: "NYSE:AKUS",
      companyName: "Akouos Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-akya",
      code: "NYSE:AKYA",
      companyName: "Akoya BioSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-al",
      code: "NYSE:AL",
      companyName: "Air Lease Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-al-a",
      code: "NYSE:AL-A",
      companyName:
        "Air Lease Corporation 6.150% Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series",
      popularity: 0,
    },
    {
      slug: "nyse-albo",
      code: "NYSE:ALBO",
      companyName: "Albireo Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alc",
      code: "NYSE:ALC",
      companyName: "Alcon Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-alcc",
      code: "NYSE:ALCC",
      companyName: "AltC Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-alco",
      code: "NYSE:ALCO",
      companyName: "Alico Inc",
      popularity: 0,
    },
    {
      slug: "nyse-aldx",
      code: "NYSE:ALDX",
      companyName: "Aldeyra Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ale",
      code: "NYSE:ALE",
      companyName: "ALLETE Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-alec",
      code: "NYSE:ALEC",
      companyName: "Alector Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alex",
      code: "NYSE:ALEX",
      companyName: "Alexander & Baldwin Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-alf",
      code: "NYSE:ALF",
      companyName: "ALFI Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alfa",
      code: "NYSE:ALFA",
      companyName: "AlphaClone Alternative Alpha ETF",
      popularity: 0,
    },
    {
      slug: "nyse-alfiw",
      code: "NYSE:ALFIW",
      companyName: "ALFI Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-alg",
      code: "NYSE:ALG",
      companyName: "Alamo Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-algm",
      code: "NYSE:ALGM",
      companyName: "Allegro MicroSystems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-algn",
      code: "NYSE:ALGN",
      companyName: "Align Technology Inc",
      popularity: 0,
    },
    {
      slug: "nyse-algs",
      code: "NYSE:ALGS",
      companyName: "Aligos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-algt",
      code: "NYSE:ALGT",
      companyName: "Allegiant Travel Company",
      popularity: 0,
    },
    {
      slug: "nyse-alhc",
      code: "NYSE:ALHC",
      companyName: "Alignment Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alim",
      code: "NYSE:ALIM",
      companyName: "Alimera Sciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-alit",
      code: "NYSE:ALIT",
      companyName: "Alight Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aljj",
      code: "NYSE:ALJJ",
      companyName: "ALJ Regional Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alks",
      code: "NYSE:ALKS",
      companyName: "Alkermes Inc. plc",
      popularity: 0,
    },
    {
      slug: "nyse-all",
      code: "NYSE:ALL",
      companyName: "The Allstate Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-all-b",
      code: "NYSE:ALL-B",
      companyName:
        "The Allstate Corporation 5.100%  Fixed-To-Floating Rate Subordinated Debentures due 2053",
      popularity: 0,
    },
    {
      slug: "nyse-all-g",
      code: "NYSE:ALL-G",
      companyName:
        "The Allstate Corporation Depositary Shares each representing a 1/1000th interest in a share of Fixe",
      popularity: 0,
    },
    {
      slug: "nyse-all-h",
      code: "NYSE:ALL-H",
      companyName: "The Allstate Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-all-i",
      code: "NYSE:ALL-I",
      companyName: "The Allstate Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-alle",
      code: "NYSE:ALLE",
      companyName: "Allegion Public Limited Company",
      popularity: 0,
    },
    {
      slug: "nyse-allg",
      code: "NYSE:ALLG",
      companyName: "Allego N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-allk",
      code: "NYSE:ALLK",
      companyName: "Allakos Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-allo",
      code: "NYSE:ALLO",
      companyName: "Allogene Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-allr",
      code: "NYSE:ALLR",
      companyName: "Allarity Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-allt",
      code: "NYSE:ALLT",
      companyName: "Allot Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-alna",
      code: "NYSE:ALNA",
      companyName: "Allena Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alor",
      code: "NYSE:ALOR",
      companyName:
        "ALSP Orchid Acquisition Corporation I Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-aloru",
      code: "NYSE:ALORU",
      companyName: "ALSP Orchid Acquisition Corporation I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-alorw",
      code: "NYSE:ALORW",
      companyName: "ALSP Orchid Acquisition Corporation I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-alot",
      code: "NYSE:ALOT",
      companyName: "AstroNova Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alp-q",
      code: "NYSE:ALP-Q",
      companyName:
        "Alabama Power Company 5.00% Class A Preferred Stock Cumulative Par Value $1 Per Share (Stated Capi",
      popularity: 0,
    },
    {
      slug: "nyse-alpa",
      code: "NYSE:ALPA",
      companyName:
        "Alpha Healthcare Acquisition Corp. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alpau",
      code: "NYSE:ALPAU",
      companyName: "Alpha Healthcare Acquisition Corp. III Units",
      popularity: 0,
    },
    {
      slug: "nyse-alny",
      code: "NYSE:ALNY",
      companyName: "Alnylam Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-alpaw",
      code: "NYSE:ALPAW",
      companyName: "Alpha Healthcare Acquisition Corp. III Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-alpn",
      code: "NYSE:ALPN",
      companyName: "Alpine Immune Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alpp",
      code: "NYSE:ALPP",
      companyName: "Alpine 4 Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alr",
      code: "NYSE:ALR",
      companyName: "AlerisLife Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alrm",
      code: "NYSE:ALRM",
      companyName: "Alarm.com Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-alrn",
      code: "NYSE:ALRN",
      companyName: "Aileron Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alrs",
      code: "NYSE:ALRS",
      companyName: "Alerus Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alsa",
      code: "NYSE:ALSA",
      companyName: "Alpha Star Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-alsar",
      code: "NYSE:ALSAR",
      companyName: "Alpha Star Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nyse-alsau",
      code: "NYSE:ALSAU",
      companyName: "Alpha Star Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nyse-alsaw",
      code: "NYSE:ALSAW",
      companyName: "Alpha Star Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-alsn",
      code: "NYSE:ALSN",
      companyName: "ALLISON TRANSMISSION HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-alt",
      code: "NYSE:ALT",
      companyName: "Altimmune Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-altg",
      code: "NYSE:ALTG",
      companyName: "Alta Equipment Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-altg-a",
      code: "NYSE:ALTG-A",
      companyName:
        "Alta Equipment Group Inc. Depositary Shares (each representing 1/1000th in a share of 10% Series A C",
      popularity: 0,
    },
    {
      slug: "nyse-altl",
      code: "NYSE:ALTL",
      companyName: "Pacer Lunt Large Cap Alternator ETF",
      popularity: 0,
    },
    {
      slug: "nyse-alto",
      code: "NYSE:ALTO",
      companyName: "Alto Ingredients Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-altr",
      code: "NYSE:ALTR",
      companyName: "Altair Engineering Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-altu",
      code: "NYSE:ALTU",
      companyName: "Altitude Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-altuu",
      code: "NYSE:ALTUU",
      companyName: "Altitude Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-altuw",
      code: "NYSE:ALTUW",
      companyName: "Altitude Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-amcr",
      code: "NYSE:AMCR",
      companyName: "Amcor plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-alv",
      code: "NYSE:ALV",
      companyName: "Autoliv Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-alvo",
      code: "NYSE:ALVO",
      companyName: "Alvotech Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-alvow",
      code: "NYSE:ALVOW",
      companyName: "Alvotech Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-alvr",
      code: "NYSE:ALVR",
      companyName: "AlloVir Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alx",
      code: "NYSE:ALX",
      companyName: "Alexander's Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-alxo",
      code: "NYSE:ALXO",
      companyName: "ALX Oncology Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-alya",
      code: "NYSE:ALYA",
      companyName: "Alithya Group inc. Class A Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-alzn",
      code: "NYSE:ALZN",
      companyName: "Alzamend Neuro Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-am",
      code: "NYSE:AM",
      companyName: "Antero Midstream Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-amam",
      code: "NYSE:AMAM",
      companyName:
        "Ambrx Biopharma Inc. American Depositary Shares (each representing seven Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-amao",
      code: "NYSE:AMAO",
      companyName: "American Acquisition Opportunity Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-amaou",
      code: "NYSE:AMAOU",
      companyName: "American Acquisition Opportunity Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-amaow",
      code: "NYSE:AMAOW",
      companyName: "American Acquisition Opportunity Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-amat",
      code: "NYSE:AMAT",
      companyName: "Applied Materials Inc",
      popularity: 0,
    },
    {
      slug: "nyse-amax",
      code: "NYSE:AMAX",
      companyName: "RH Hedged Multi-Asset Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-amba",
      code: "NYSE:AMBA",
      companyName: "Ambarella Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ambc",
      code: "NYSE:AMBC",
      companyName: "Ambac Financial Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ambp",
      code: "NYSE:AMBP",
      companyName: "Ardagh Metal Packaging S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-amc",
      code: "NYSE:AMC",
      companyName: "AMC ENTERTAINMENT HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-amci",
      code: "NYSE:AMCI",
      companyName: "AMCI Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-amciu",
      code: "NYSE:AMCIU",
      companyName: "AMCI Acquisition Corp. II Units",
      popularity: 0,
    },
    {
      slug: "nyse-amciw",
      code: "NYSE:AMCIW",
      companyName: "AMCI Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-amcx",
      code: "NYSE:AMCX",
      companyName: "AMC Networks Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-ame",
      code: "NYSE:AME",
      companyName: "Ametek Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amed",
      code: "NYSE:AMED",
      companyName: "Amedisys Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ameh",
      code: "NYSE:AMEH",
      companyName: "Apollo Medical Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-amer",
      code: "NYSE:AMER",
      companyName: "Emles Made in America ETF",
      popularity: 0,
    },
    {
      slug: "nyse-amg",
      code: "NYSE:AMG",
      companyName: "Affiliated Managers Group",
      popularity: 0,
    },
    {
      slug: "nyse-amgn",
      code: "NYSE:AMGN",
      companyName: "Amgen Inc",
      popularity: 0,
    },
    {
      slug: "nyse-amh-g",
      code: "NYSE:AMH-G",
      companyName:
        "American Homes 4 Rent Series G cumulative redeemable perpetual preferred shares of beneficial intere",
      popularity: 0,
    },
    {
      slug: "nyse-amh-h",
      code: "NYSE:AMH-H",
      companyName:
        "American Homes 4 Rent Series H cumulative redeemable perpetual Preferred Shares of Beneficial Intere",
      popularity: 0,
    },
    {
      slug: "nyse-amid",
      code: "NYSE:AMID",
      companyName: "Argent Mid Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-amj",
      code: "NYSE:AMJ",
      companyName: "JP Morgan Alerian MLP Index ETN 5/24/24",
      popularity: 0,
    },
    {
      slug: "nyse-amk",
      code: "NYSE:AMK",
      companyName: "AssetMark Financial Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amkr",
      code: "NYSE:AMKR",
      companyName: "Amkor Technology Inc",
      popularity: 0,
    },
    {
      slug: "nyse-amlp",
      code: "NYSE:AMLP",
      companyName: "Alerian MLP ETF",
      popularity: 0,
    },
    {
      slug: "nyse-amlx",
      code: "NYSE:AMLX",
      companyName: "Amylyx Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-amn",
      code: "NYSE:AMN",
      companyName: "AMN Healthcare Services",
      popularity: 0,
    },
    {
      slug: "nyse-amna",
      code: "NYSE:AMNA",
      companyName: "ETRACS Alerian Midstream Energy Index ETN",
      popularity: 0,
    },
    {
      slug: "nyse-amal",
      code: "NYSE:AMAL",
      companyName: "Amalgamated Financial Corp. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-amnb",
      code: "NYSE:AMNB",
      companyName: "American National Bankshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-amnd",
      code: "NYSE:AMND",
      companyName: "ETRACS Alerian Midstream Energy High Dividend Index ETN",
      popularity: 0,
    },
    {
      slug: "nyse-amom",
      code: "NYSE:AMOM",
      companyName: "Qraft AI-Enhanced US Large Cap Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-amot",
      code: "NYSE:AMOT",
      companyName: "Allied Motion Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-amov",
      code: "NYSE:AMOV",
      companyName: "America Movil SAB de CV",
      popularity: 0,
    },
    {
      slug: "nyse-amp",
      code: "NYSE:AMP",
      companyName: "Ameriprise Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ampe",
      code: "NYSE:AMPE",
      companyName: "Ampio Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ampg",
      code: "NYSE:AMPG",
      companyName: "AMPLITECH GROUP INC. COM",
      popularity: 0,
    },
    {
      slug: "nyse-ampgw",
      code: "NYSE:AMPGW",
      companyName: "Amplitech Group Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-amph",
      code: "NYSE:AMPH",
      companyName: "Amphastar Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ampi",
      code: "NYSE:AMPI",
      companyName: "Advanced Merger Partners Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ampl",
      code: "NYSE:AMPL",
      companyName: "Amplitude Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-amps",
      code: "NYSE:AMPS",
      companyName: "Altus Power Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ampy",
      code: "NYSE:AMPY",
      companyName: "Amplify Energy Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-amr",
      code: "NYSE:AMR",
      companyName: "Alpha Metallurgical Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amrc",
      code: "NYSE:AMRC",
      companyName: "Ameresco Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amrk",
      code: "NYSE:AMRK",
      companyName: "A-Mark Precious Metals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amrn",
      code: "NYSE:AMRN",
      companyName: "Amarin Corp Plc",
      popularity: 0,
    },
    {
      slug: "nyse-amrs",
      code: "NYSE:AMRS",
      companyName: "Amyris Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amrx",
      code: "NYSE:AMRX",
      companyName: "Amneal Pharmaceuticals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ams",
      code: "NYSE:AMS",
      companyName: "American Shared Hospital Services",
      popularity: 0,
    },
    {
      slug: "nyse-amsc",
      code: "NYSE:AMSC",
      companyName: "American Superconductor Corp",
      popularity: 0,
    },
    {
      slug: "nyse-amsf",
      code: "NYSE:AMSF",
      companyName: "AMERISAFE Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amst",
      code: "NYSE:AMST",
      companyName: "Amesite Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amswa",
      code: "NYSE:AMSWA",
      companyName: "American Software Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amtb",
      code: "NYSE:AMTB",
      companyName: "Amerant Bancorp Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-amtd",
      code: "NYSE:AMTD",
      companyName: "AMTD IDEA Group",
      popularity: 0,
    },
    {
      slug: "nyse-amti",
      code: "NYSE:AMTI",
      companyName: "Applied Molecular Transport Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-amtr",
      code: "NYSE:AMTR",
      companyName: "ETRACS Alerian Midstream Energy Total Return Index ETN",
      popularity: 0,
    },
    {
      slug: "nyse-amtx",
      code: "NYSE:AMTX",
      companyName: "Aemetis Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-amub",
      code: "NYSE:AMUB",
      companyName: "ETRACS Alerian MLP Index ETN Series B due July 18 2042",
      popularity: 0,
    },
    {
      slug: "nyse-amwd",
      code: "NYSE:AMWD",
      companyName: "American Woodmark Corp",
      popularity: 0,
    },
    {
      slug: "nyse-amwl",
      code: "NYSE:AMWL",
      companyName: "American Well Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-amx",
      code: "NYSE:AMX",
      companyName: "America Movil S.A.B de C.V",
      popularity: 0,
    },
    {
      slug: "nyse-amyt",
      code: "NYSE:AMYT",
      companyName: "Amryt Pharma plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-amza",
      code: "NYSE:AMZA",
      companyName: "InfraCap MLP ETF",
      popularity: 0,
    },
    {
      slug: "nyse-an",
      code: "NYSE:AN",
      companyName: "AutoNation Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-anab",
      code: "NYSE:ANAB",
      companyName: "AnaptysBio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-anac",
      code: "NYSE:ANAC",
      companyName: "Arctos NorthStar Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ande",
      code: "NYSE:ANDE",
      companyName: "Andersons Inc/The",
      popularity: 0,
    },
    {
      slug: "nyse-angh",
      code: "NYSE:ANGH",
      companyName: "Anghami Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-anghw",
      code: "NYSE:ANGHW",
      companyName: "Anghami Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-angi",
      code: "NYSE:ANGI",
      companyName: "Angi Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-angl",
      code: "NYSE:ANGL",
      companyName: "VanEck Fallen Angel High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-angn",
      code: "NYSE:ANGN",
      companyName: "Angion Biomedica Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ango",
      code: "NYSE:ANGO",
      companyName: "AngioDynamics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-anik",
      code: "NYSE:ANIK",
      companyName: "Anika Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-anip",
      code: "NYSE:ANIP",
      companyName: "ANI Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-anix",
      code: "NYSE:ANIX",
      companyName: "Anixa Biosciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-annx",
      code: "NYSE:ANNX",
      companyName: "Annexon Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-anpc",
      code: "NYSE:ANPC",
      companyName:
        "AnPac Bio-Medical Science Co. Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ante",
      code: "NYSE:ANTE",
      companyName: "AirNet Technology Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-antx",
      code: "NYSE:ANTX",
      companyName: "AN2 Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-anvs",
      code: "NYSE:ANVS",
      companyName: "Annovis Bio Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-any",
      code: "NYSE:ANY",
      companyName: "Sphere 3D Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-anzu",
      code: "NYSE:ANZU",
      companyName: "Anzu Special Acquisition Corp I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-anzuu",
      code: "NYSE:ANZUU",
      companyName: "Anzu Special Acquisition Corp I Units",
      popularity: 0,
    },
    {
      slug: "nyse-anzuw",
      code: "NYSE:ANZUW",
      companyName: "Anzu Special Acquisition Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aoa",
      code: "NYSE:AOA",
      companyName: "iShares Core Aggressive Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aod",
      code: "NYSE:AOD",
      companyName: "abrdn Total Dynamic Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-aogo",
      code: "NYSE:AOGO",
      companyName: "Arogo Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aogou",
      code: "NYSE:AOGOU",
      companyName: "Arogo Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aogow",
      code: "NYSE:AOGOW",
      companyName: "Arogo Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aok",
      code: "NYSE:AOK",
      companyName: "iShares Core Moderate Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aom",
      code: "NYSE:AOM",
      companyName: "iShares Core Moderate Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aomr",
      code: "NYSE:AOMR",
      companyName: "Angel Oak Mortgage Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aor",
      code: "NYSE:AOR",
      companyName: "iShares Core Growth Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aort",
      code: "NYSE:AORT",
      companyName: "Artivion Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aos",
      code: "NYSE:AOS",
      companyName: "A.O. Smith Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-aosl",
      code: "NYSE:AOSL",
      companyName: "Alpha and Omega Semiconductor Limited",
      popularity: 0,
    },
    {
      slug: "nyse-aotg",
      code: "NYSE:AOTG",
      companyName: "AOT Growth and Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aout",
      code: "NYSE:AOUT",
      companyName: "American Outdoor Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ap",
      code: "NYSE:AP",
      companyName: "Ampco-Pittsburgh Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-apm",
      code: "NYSE:APM",
      companyName: "Aptorum Group Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-apac",
      code: "NYSE:APAC",
      companyName:
        "StoneBridge Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-apacu",
      code: "NYSE:APACU",
      companyName: "StoneBridge Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-apacw",
      code: "NYSE:APACW",
      companyName: "StoneBridge Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-apam",
      code: "NYSE:APAM",
      companyName: "ARTISAN PARTNERS ASSET MANAGEMENT INC.",
      popularity: 0,
    },
    {
      slug: "nyse-apca",
      code: "NYSE:APCA",
      companyName: "AP Acquisition Corp",
      popularity: 0,
    },
    {
      slug: "nyse-apcx",
      code: "NYSE:APCX",
      companyName: "AppTech Payments Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-apcxw",
      code: "NYSE:APCXW",
      companyName: "AppTech Payments Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-apdn",
      code: "NYSE:APDN",
      companyName: "Applied DNA Sciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ape",
      code: "NYSE:APE",
      companyName:
        "AMC Entertainment Holdings Inc. AMC Preferred Equity Units each constituting a depositary share re",
      popularity: 0,
    },
    {
      slug: "nyse-apei",
      code: "NYSE:APEI",
      companyName: "American Public Education Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-apen",
      code: "NYSE:APEN",
      companyName: "Apollo Endosurgery Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-apg",
      code: "NYSE:APG",
      companyName: "APi Group Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-apgb",
      code: "NYSE:APGB",
      companyName: "Apollo Strategic Growth Capital II",
      popularity: 0,
    },
    {
      slug: "nyse-apgn",
      code: "NYSE:APGN",
      companyName: "Apexigen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-apgnw",
      code: "NYSE:APGNW",
      companyName: "Apexigen Inc. WarrantApexigen Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-api",
      code: "NYSE:API",
      companyName: "Agora Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-apld",
      code: "NYSE:APLD",
      companyName: "Applied Blockchain Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-apls",
      code: "NYSE:APLS",
      companyName: "Apellis Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aplt",
      code: "NYSE:APLT",
      companyName: "Applied Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-apmiu",
      code: "NYSE:APMIU",
      companyName: "AxonPrime Infrastructure Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-apmiw",
      code: "NYSE:APMIW",
      companyName: "AxonPrime Infrastructure Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-apn",
      code: "NYSE:APN",
      companyName: "Apeiron Capital Investment Corp",
      popularity: 0,
    },
    {
      slug: "nyse-aple",
      code: "NYSE:APLE",
      companyName: "Apple Hospitality REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-apog",
      code: "NYSE:APOG",
      companyName: "Apogee Enterprises Inc",
      popularity: 0,
    },
    {
      slug: "nyse-app",
      code: "NYSE:APP",
      companyName: "Applovin Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-appf",
      code: "NYSE:APPF",
      companyName: "AppFolio Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-apph",
      code: "NYSE:APPH",
      companyName: "AppHarvest Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-apphw",
      code: "NYSE:APPHW",
      companyName: "AppHarvest Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-appn",
      code: "NYSE:APPN",
      companyName: "Appian Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-apps",
      code: "NYSE:APPS",
      companyName: "Digital Turbine Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-apre",
      code: "NYSE:APRE",
      companyName: "Aprea Therapeutics Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-aprn",
      code: "NYSE:APRN",
      companyName: "Blue Apron Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aprz",
      code: "NYSE:APRZ",
      companyName: "TrueShares Structured Outcome (April) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-apt",
      code: "NYSE:APT",
      companyName: "Alpha Pro Tech Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-aptm",
      code: "NYSE:APTM",
      companyName:
        "Alpha Partners Technology Merger Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-aptmu",
      code: "NYSE:APTMU",
      companyName: "Alpha Partners Technology Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aptmw",
      code: "NYSE:APTMW",
      companyName: "Alpha Partners Technology Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-apto",
      code: "NYSE:APTO",
      companyName: "Aptose Biosciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aptv-a",
      code: "NYSE:APTV-A",
      companyName:
        "Aptiv PLC 5.50% Series A Mandatory Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-aptx",
      code: "NYSE:APTX",
      companyName: "Aptinyx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-apvo",
      code: "NYSE:APVO",
      companyName: "Aptevo Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-apwc",
      code: "NYSE:APWC",
      companyName: "Asia Pacific Wire & Cable Corp",
      popularity: 0,
    },
    {
      slug: "nyse-apxh",
      code: "NYSE:APXH",
      companyName: "APEX HealthCare ETF",
      popularity: 0,
    },
    {
      slug: "nyse-apxi",
      code: "NYSE:APXI",
      companyName: "APx Acquisition Corp. I Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-apxiu",
      code: "NYSE:APXIU",
      companyName: "APx Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-apxiw",
      code: "NYSE:APXIW",
      companyName: "APx Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-apyx",
      code: "NYSE:APYX",
      companyName: "Apyx Medical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aqb",
      code: "NYSE:AQB",
      companyName: "AquaBounty Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aqgx",
      code: "NYSE:AQGX",
      companyName: "AI Quality Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aqms",
      code: "NYSE:AQMS",
      companyName: "Aqua Metals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aqn",
      code: "NYSE:AQN",
      companyName: "Algonquin Power & Utilities Corp",
      popularity: 0,
    },
    {
      slug: "nyse-apmi",
      code: "NYSE:APMI",
      companyName:
        "AxonPrime Infrastructure Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-apd",
      code: "NYSE:APD",
      companyName: "Air Products & Chemicals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aqna",
      code: "NYSE:AQNA",
      companyName:
        "Algonquin Power & Utilities Corp. 6.875% Fixed-to-Floating Rate Subordinated Notes Series 2018-A due",
      popularity: 0,
    },
    {
      slug: "nyse-aqnb",
      code: "NYSE:AQNB",
      companyName:
        "Algonquin Power & Utilities Corp. 6.20% Fixed-to-Floating Subordinated Notes Series 2019-A due July",
      popularity: 0,
    },
    {
      slug: "nyse-aqnu",
      code: "NYSE:AQNU",
      companyName: "Algonquin Power & Utilities Corp. Corporate Units",
      popularity: 0,
    },
    {
      slug: "nyse-aqst",
      code: "NYSE:AQST",
      companyName: "Aquestive Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aqua",
      code: "NYSE:AQUA",
      companyName: "Evoqua Water Technologies Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ar",
      code: "NYSE:AR",
      companyName: "ANTERO RESOURCES CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-arav",
      code: "NYSE:ARAV",
      companyName: "Aravive Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aray",
      code: "NYSE:ARAY",
      companyName: "Accuray Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-arb",
      code: "NYSE:ARB",
      companyName: "AltShares Merger Arbitrage ETF",
      popularity: 0,
    },
    {
      slug: "nyse-arbe",
      code: "NYSE:ARBE",
      companyName: "Arbe Robotics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-arbew",
      code: "NYSE:ARBEW",
      companyName: "Arbe Robotics Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-arbg",
      code: "NYSE:ARBG",
      companyName: "Aequi Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arbgu",
      code: "NYSE:ARBGU",
      companyName: "Aequi Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-arbgw",
      code: "NYSE:ARBGW",
      companyName: "Aequi Acquisition Corp. warrants",
      popularity: 0,
    },
    {
      slug: "nyse-arbk",
      code: "NYSE:ARBK",
      companyName: "Argo Blockchain plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-arbkl",
      code: "NYSE:ARBKL",
      companyName: "Argo Blockchain plc 8.75% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-arc",
      code: "NYSE:ARC",
      companyName: "ARC Document Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-arcb",
      code: "NYSE:ARCB",
      companyName: "ArcBest Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-arcc",
      code: "NYSE:ARCC",
      companyName: "Ares Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-arce",
      code: "NYSE:ARCE",
      companyName: "Arco Platform Limited Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-arch",
      code: "NYSE:ARCH",
      companyName: "Arch Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-arck",
      code: "NYSE:ARCK",
      companyName:
        "Arbor Rapha Capital Bioholdings Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arcku",
      code: "NYSE:ARCKU",
      companyName: "Arbor Rapha Capital Bioholdings Corp. I Units",
      popularity: 0,
    },
    {
      slug: "nyse-arckw",
      code: "NYSE:ARCKW",
      companyName: "Arbor Rapha Capital Bioholdings Corp. I Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-arcm",
      code: "NYSE:ARCM",
      companyName: "Arrow Reserve Capital Management ETF",
      popularity: 0,
    },
    {
      slug: "nyse-arco",
      code: "NYSE:ARCO",
      companyName: "ARCOS DORADOS HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-arct",
      code: "NYSE:ARCT",
      companyName: "Arcturus Therapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ardc",
      code: "NYSE:ARDC",
      companyName: "ARES DYNAMIC CREDIT ALLOCATION FUND INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ards",
      code: "NYSE:ARDS",
      companyName: "Aridis Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ardx",
      code: "NYSE:ARDX",
      companyName: "Ardelyx Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ares",
      code: "NYSE:ARES",
      companyName: "Ares Management Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-areb",
      code: "NYSE:AREB",
      companyName: "American Rebel Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arebw",
      code: "NYSE:AREBW",
      companyName: "American Rebel Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-arec",
      code: "NYSE:AREC",
      companyName: "AMERICAN RESOURCES CORP",
      popularity: 0,
    },
    {
      slug: "nyse-aren",
      code: "NYSE:AREN",
      companyName: "The Arena Group Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-argd",
      code: "NYSE:ARGD",
      companyName: "Argo Group US Inc. 6.500% Senior Notes due 2042",
      popularity: 0,
    },
    {
      slug: "nyse-argo",
      code: "NYSE:ARGO",
      companyName: "Argo Group International Holdings Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-argo-a",
      code: "NYSE:ARGO-A",
      companyName:
        "Argo Group International Holdings Ltd. Depositary Shares Each Representing a 1/1000th Interest in",
      popularity: 0,
    },
    {
      slug: "nyse-argu",
      code: "NYSE:ARGU",
      companyName: "Argus Capital Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arguu",
      code: "NYSE:ARGUU",
      companyName: "Argus Capital Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-arguw",
      code: "NYSE:ARGUW",
      companyName: "Argus Capital Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-argx",
      code: "NYSE:ARGX",
      companyName: "argenx SE American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-arhs",
      code: "NYSE:ARHS",
      companyName: "Arhaus Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ari",
      code: "NYSE:ARI",
      companyName: "APOLLO COMMERCIAL REAL ESTATE FINANCE INC.",
      popularity: 0,
    },
    {
      slug: "nyse-aris",
      code: "NYSE:ARIS",
      companyName: "Aris Water Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ariz",
      code: "NYSE:ARIZ",
      companyName: "Arisz Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arizr",
      code: "NYSE:ARIZR",
      companyName: "Arisz Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-arizu",
      code: "NYSE:ARIZU",
      companyName: "Arisz Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-arizw",
      code: "NYSE:ARIZW",
      companyName: "Arisz Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-arkf",
      code: "NYSE:ARKF",
      companyName: "ARK Fintech Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-arkg",
      code: "NYSE:ARKG",
      companyName: "ARK Genomic Revolution ETF",
      popularity: 0,
    },
    {
      slug: "nyse-arko",
      code: "NYSE:ARKO",
      companyName: "ARKO Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arkow",
      code: "NYSE:ARKOW",
      companyName: "ARKO Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-arkr",
      code: "NYSE:ARKR",
      companyName: "Ark Restaurants Corp",
      popularity: 0,
    },
    {
      slug: "nyse-arkw",
      code: "NYSE:ARKW",
      companyName: "ARK Next Generation Internet ETF",
      popularity: 0,
    },
    {
      slug: "nyse-arkx",
      code: "NYSE:ARKX",
      companyName: "ARK Space Exploration & Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-arl",
      code: "NYSE:ARL",
      companyName: "American Realty Investors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-arlo",
      code: "NYSE:ARLO",
      companyName: "Arlo Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-arlp",
      code: "NYSE:ARLP",
      companyName: "Alliance Resource Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-aqwa",
      code: "NYSE:AQWA",
      companyName: "Global X Clean Water ETF",
      popularity: 0,
    },
    {
      slug: "nyse-argt",
      code: "NYSE:ARGT",
      companyName: "Global X MSCI Argentina ETF",
      popularity: 0,
    },
    {
      slug: "nyse-armk",
      code: "NYSE:ARMK",
      companyName: "ARAMARK",
      popularity: 0,
    },
    {
      slug: "nyse-arkq",
      code: "NYSE:ARKQ",
      companyName: "ARK Autonomous Technology & Robotics ETF",
      popularity: 0,
    },
    {
      slug: "nyse-armp",
      code: "NYSE:ARMP",
      companyName: "Armata Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-armr",
      code: "NYSE:ARMR",
      companyName: "Armor US Equity Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-arnc",
      code: "NYSE:ARNC",
      companyName: "Arconic Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-aroc",
      code: "NYSE:AROC",
      companyName: "Archrock Inc",
      popularity: 0,
    },
    {
      slug: "nyse-arow",
      code: "NYSE:AROW",
      companyName: "Arrow Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-arqq",
      code: "NYSE:ARQQ",
      companyName: "Arqit Quantum Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-arqqw",
      code: "NYSE:ARQQW",
      companyName: "Arqit Quantum Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-arqt",
      code: "NYSE:ARQT",
      companyName: "Arcutis Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arr",
      code: "NYSE:ARR",
      companyName: "ARMOUR Residential REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-arr-c",
      code: "NYSE:ARR-C",
      companyName:
        "ARMOUR Residential REIT Inc. 7.00% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arrw",
      code: "NYSE:ARRW",
      companyName: "Arrowroot Acquisition Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-arrwu",
      code: "NYSE:ARRWU",
      companyName: "Arrowroot Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-arrww",
      code: "NYSE:ARRWW",
      companyName: "Arrowroot Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-arry",
      code: "NYSE:ARRY",
      companyName: "Array Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arte",
      code: "NYSE:ARTE",
      companyName:
        "Artemis Strategic Investment Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-arteu",
      code: "NYSE:ARTEU",
      companyName: "Artemis Strategic Investment Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-artew",
      code: "NYSE:ARTEW",
      companyName: "Artemis Strategic Investment Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-artl",
      code: "NYSE:ARTL",
      companyName: "Artelo Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-artlw",
      code: "NYSE:ARTLW",
      companyName: "Artelo Biosciences Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-artna",
      code: "NYSE:ARTNA",
      companyName: "Artesian Resources Corp",
      popularity: 0,
    },
    {
      slug: "nyse-artw",
      code: "NYSE:ARTW",
      companyName: "Arts-Way Manufacturing Co Inc",
      popularity: 0,
    },
    {
      slug: "nyse-arvl",
      code: "NYSE:ARVL",
      companyName: "Arrival Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-arvn",
      code: "NYSE:ARVN",
      companyName: "Arvinas Inc",
      popularity: 0,
    },
    {
      slug: "nyse-arvr",
      code: "NYSE:ARVR",
      companyName: "First Trust Indxx Metaverse ETF",
      popularity: 0,
    },
    {
      slug: "nyse-arw",
      code: "NYSE:ARW",
      companyName: "Arrow Electronics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-arwr",
      code: "NYSE:ARWR",
      companyName: "Arrowhead Research Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-aryd",
      code: "NYSE:ARYD",
      companyName: "ARYA Sciences Acquisition Corp IV Class A Odinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-arye",
      code: "NYSE:ARYE",
      companyName: "ARYA Sciences Acquisition Corp V Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-asa",
      code: "NYSE:ASA",
      companyName: "ASA GOLD AND PRECIOUS METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-asai",
      code: "NYSE:ASAI",
      companyName:
        "Sendas Distribuidora S.A. American Depositary Share (each representing five common shares)",
      popularity: 0,
    },
    {
      slug: "nyse-asan",
      code: "NYSE:ASAN",
      companyName: "Asana Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-asaq",
      code: "NYSE:ASAQ",
      companyName: "Atlantic Avenue Acquisition Corp",
      popularity: 0,
    },
    {
      slug: "nyse-asax",
      code: "NYSE:ASAX",
      companyName: "Astrea Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-asaxu",
      code: "NYSE:ASAXU",
      companyName: "Astrea Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-asb-e",
      code: "NYSE:ASB-E",
      companyName:
        "Associated Banc-Corp Depositary Shares each representing a 1/40th interest in a share of 5.875% Non",
      popularity: 0,
    },
    {
      slug: "nyse-asb-f",
      code: "NYSE:ASB-F",
      companyName:
        "Associated Banc-Corp Depositary Shares each representing a 1/40th interest in a share of Associated",
      popularity: 0,
    },
    {
      slug: "nyse-asc",
      code: "NYSE:ASC",
      companyName: "ARDMORE SHIPPING CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-asca",
      code: "NYSE:ASCA",
      companyName: "A SPAC I Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ascar",
      code: "NYSE:ASCAR",
      companyName: "A SPAC I Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-ascau",
      code: "NYSE:ASCAU",
      companyName: "A SPAC I Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ascaw",
      code: "NYSE:ASCAW",
      companyName: "A SPAC I Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ascb",
      code: "NYSE:ASCB",
      companyName: "A SPAC II Acquisition Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ascbr",
      code: "NYSE:ASCBR",
      companyName: "A SPAC II Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-ascbu",
      code: "NYSE:ASCBU",
      companyName: "A SPAC II Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ascbw",
      code: "NYSE:ASCBW",
      companyName: "A SPAC II Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aset",
      code: "NYSE:ASET",
      companyName: "FlexShares Real Assets Allocation Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-asg",
      code: "NYSE:ASG",
      companyName: "LIBERTY ALL-STAR GROWTH FD",
      popularity: 0,
    },
    {
      slug: "nyse-asgi",
      code: "NYSE:ASGI",
      companyName: "abrdn Global Infrastructure Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-asgn",
      code: "NYSE:ASGN",
      companyName: "ASGN Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-ash",
      code: "NYSE:ASH",
      companyName: "Ashland Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ashr",
      code: "NYSE:ASHR",
      companyName: "Xtrackers Harvest CSI 300 China A-Shares ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ashs",
      code: "NYSE:ASHS",
      companyName: "Xtrackers Harvest CSI 500 China A-Shares Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ashx",
      code: "NYSE:ASHX",
      companyName: "Xtrackers MSCI China A Inclusion Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-asix",
      code: "NYSE:ASIX",
      companyName: "AdvanSix Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-asle",
      code: "NYSE:ASLE",
      companyName: "AerSale Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-asln",
      code: "NYSE:ASLN",
      companyName: "ASLAN Pharmaceuticals Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-asm",
      code: "NYSE:ASM",
      companyName: "Avino Silver & Gold Mines Ltd. (Canada)",
      popularity: 0,
    },
    {
      slug: "nyse-asmb",
      code: "NYSE:ASMB",
      companyName: "Assembly Biosciences Inc",
      popularity: 0,
    },
    {
      slug: "nyse-asnd",
      code: "NYSE:ASND",
      companyName: "Ascendis Pharma A/S American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-asns",
      code: "NYSE:ASNS",
      companyName: "Actelis Networks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aso",
      code: "NYSE:ASO",
      companyName: "Academy Sports and Outdoors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aspa",
      code: "NYSE:ASPA",
      companyName: "ABRI SPAC I INC. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aspau",
      code: "NYSE:ASPAU",
      companyName: "Abri SPAC I Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aspaw",
      code: "NYSE:ASPAW",
      companyName: "ABRI SPAC I INC. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aspn",
      code: "NYSE:ASPN",
      companyName: "Aspen Aerogels Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-asps",
      code: "NYSE:ASPS",
      companyName: "Altisource Portfolio Solutions S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-aspu",
      code: "NYSE:ASPU",
      companyName: "ASPEN GROUP INC.",
      popularity: 0,
    },
    {
      slug: "nyse-aspy",
      code: "NYSE:ASPY",
      companyName: "ASYMshares ASYMmetric S&P 500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-asr",
      code: "NYSE:ASR",
      companyName:
        "Grupo Aeroportuario del Sureste S.A. de C.V. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-asrt",
      code: "NYSE:ASRT",
      companyName: "Assertio Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-asrv",
      code: "NYSE:ASRV",
      companyName: "AmeriServ Financial Inc",
      popularity: 0,
    },
    {
      slug: "nyse-astc",
      code: "NYSE:ASTC",
      companyName: "Astrotech Corporation (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aste",
      code: "NYSE:ASTE",
      companyName: "Astec Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-astl",
      code: "NYSE:ASTL",
      companyName: "Algoma Steel Group Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-astlw",
      code: "NYSE:ASTLW",
      companyName: "Algoma Steel Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-astr",
      code: "NYSE:ASTR",
      companyName: "Astra Space Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-asts",
      code: "NYSE:ASTS",
      companyName: "AST SpaceMobile Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-astsw",
      code: "NYSE:ASTSW",
      companyName: "AST SpaceMobile Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-asur",
      code: "NYSE:ASUR",
      companyName: "Asure Software Inc",
      popularity: 0,
    },
    {
      slug: "nyse-asx",
      code: "NYSE:ASX",
      companyName: "ASE Technology Holding Co. Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-asxc",
      code: "NYSE:ASXC",
      companyName: "Asensus Surgical Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-asys",
      code: "NYSE:ASYS",
      companyName: "Amtech Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-asz",
      code: "NYSE:ASZ",
      companyName: "Austerlitz Acquisition Corporation II",
      popularity: 0,
    },
    {
      slug: "nyse-ata",
      code: "NYSE:ATA",
      companyName: "Americas Technology Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-atai",
      code: "NYSE:ATAI",
      companyName: "ATAI Life Sciences N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-atak",
      code: "NYSE:ATAK",
      companyName:
        "Aurora Technology Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-atakr",
      code: "NYSE:ATAKR",
      companyName: "Aurora Technology Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-ataku",
      code: "NYSE:ATAKU",
      companyName: "Aurora Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-atakw",
      code: "NYSE:ATAKW",
      companyName: "Aurora Technology Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-ataq",
      code: "NYSE:ATAQ",
      companyName: "Altimar Acquisition Corp. III",
      popularity: 0,
    },
    {
      slug: "nyse-atax",
      code: "NYSE:ATAX",
      companyName:
        "America First Multifamily Investors L.P. Beneficial Unit Certificates (BUCs) representing Limited P",
      popularity: 0,
    },
    {
      slug: "nyse-atco",
      code: "NYSE:ATCO",
      companyName: "Atlas Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-atco-d",
      code: "NYSE:ATCO-D",
      companyName:
        "Atlas Corp. 7.95% Series D Cumulative Redeemable Perpetual Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-atco-h",
      code: "NYSE:ATCO-H",
      companyName:
        "Atlas Corp. 7.875% Cumulative Redeemable Perpetual Preferred Shares - Series H",
      popularity: 0,
    },
    {
      slug: "nyse-atco-i",
      code: "NYSE:ATCO-I",
      companyName:
        "Atlas Corp. Series I Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-atcol",
      code: "NYSE:ATCOL",
      companyName: "Atlas Corp. 7.125% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nyse-atcx",
      code: "NYSE:ATCX",
      companyName: "Atlas Technical Consultants Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-atek",
      code: "NYSE:ATEK",
      companyName: "Athena Technology Acquisition Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-aten",
      code: "NYSE:ATEN",
      companyName: "A10 NETWORKS INC",
      popularity: 0,
    },
    {
      slug: "nyse-ater",
      code: "NYSE:ATER",
      companyName: "Aterian Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-atex",
      code: "NYSE:ATEX",
      companyName: "Anterix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-atfv",
      code: "NYSE:ATFV",
      companyName: "Alger 35 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-atge",
      code: "NYSE:ATGE",
      companyName: "Adtalem Global Education Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ath-a",
      code: "NYSE:ATH-A",
      companyName:
        "Athene Holding Ltd. Depositary Shares Each Representing a 1/1000th Interest in a 6.35% Fixed-to-Fl",
      popularity: 0,
    },
    {
      slug: "nyse-ath-b",
      code: "NYSE:ATH-B",
      companyName:
        "Athene Holding Ltd. Depositary Shares Each Representing a 1/1000th Interest in a 5.625% Fixed Rate",
      popularity: 0,
    },
    {
      slug: "nyse-ath-c",
      code: "NYSE:ATH-C",
      companyName:
        "Athene Holding Ltd. Depositary Shares each representing a 1/1 000th Interest in a Share of 6.375%",
      popularity: 0,
    },
    {
      slug: "nyse-ath-d",
      code: "NYSE:ATH-D",
      companyName:
        "Athene Holding Ltd. Depositary Shares Each Representing a 1/1000th Interest in a 4.875% Fixed-Rate",
      popularity: 0,
    },
    {
      slug: "nyse-atha",
      code: "NYSE:ATHA",
      companyName: "Athira Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-athe",
      code: "NYSE:ATHE",
      companyName: "Alterity Therapeutics Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-athm",
      code: "NYSE:ATHM",
      companyName:
        "Autohome Inc. American Depositary Shares each representing four Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-athx",
      code: "NYSE:ATHX",
      companyName: "Athersys Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ati",
      code: "NYSE:ATI",
      companyName: "ATI Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-atif",
      code: "NYSE:ATIF",
      companyName: "ATIF Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-atip",
      code: "NYSE:ATIP",
      companyName: "ATI Physical Therapy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-atkr",
      code: "NYSE:ATKR",
      companyName: "Atkore Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-atlc",
      code: "NYSE:ATLC",
      companyName: "Atlanticus Holdings Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-atlcl",
      code: "NYSE:ATLCL",
      companyName:
        "Atlanticus Holdings Corporation 6.125% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-atlcp",
      code: "NYSE:ATLCP",
      companyName:
        "Atlanticus Holdings Corporation 7.625% Series B Cumulative Perpetual Preferred Stock no par value p",
      popularity: 0,
    },
    {
      slug: "nyse-atlo",
      code: "NYSE:ATLO",
      companyName: "AMES National Corp",
      popularity: 0,
    },
    {
      slug: "nyse-atmp",
      code: "NYSE:ATMP",
      companyName: "iPath Select MLP ETN",
      popularity: 0,
    },
    {
      slug: "nyse-atnf",
      code: "NYSE:ATNF",
      companyName: "180 Life Sciences Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-atnfw",
      code: "NYSE:ATNFW",
      companyName: "180 Life Sciences Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-atni",
      code: "NYSE:ATNI",
      companyName: "ATN International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-atnm",
      code: "NYSE:ATNM",
      companyName: "Actinium Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-atnx",
      code: "NYSE:ATNX",
      companyName: "Athenex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ato",
      code: "NYSE:ATO",
      companyName: "Atmos Energy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-atom",
      code: "NYSE:ATOM",
      companyName: "Atomera Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-atos",
      code: "NYSE:ATOS",
      companyName: "Atossa Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-atr",
      code: "NYSE:ATR",
      companyName: "AptarGroup Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-atra",
      code: "NYSE:ATRA",
      companyName: "Atara Biotherapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-atrc",
      code: "NYSE:ATRC",
      companyName: "AtriCure Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-atri",
      code: "NYSE:ATRI",
      companyName: "Atrion Corp",
      popularity: 0,
    },
    {
      slug: "nyse-atro",
      code: "NYSE:ATRO",
      companyName: "Astronics Corp",
      popularity: 0,
    },
    {
      slug: "nyse-atsg",
      code: "NYSE:ATSG",
      companyName: "Air Transport Services Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-atto",
      code: "NYSE:ATTO",
      companyName: "Atento S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-atus",
      code: "NYSE:ATUS",
      companyName: "Altice USA Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-atvi",
      code: "NYSE:ATVI",
      companyName: "Activision Blizzard Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-atxi",
      code: "NYSE:ATXI",
      companyName: "Avenue Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-atxs",
      code: "NYSE:ATXS",
      companyName: "Astria Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aty",
      code: "NYSE:ATY",
      companyName: "AcuityAds Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-au",
      code: "NYSE:AU",
      companyName: "AngloGold Ashanti Limited",
      popularity: 0,
    },
    {
      slug: "nyse-aub",
      code: "NYSE:AUB",
      companyName: "Atlantic Union Bankshares Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aubap",
      code: "NYSE:AUBAP",
      companyName:
        "Atlantic Union Bankshares Corporation Depositary Shares each representing a 1/400th ownership intere",
      popularity: 0,
    },
    {
      slug: "nyse-aubn",
      code: "NYSE:AUBN",
      companyName: "Auburn National Bancorporation",
      popularity: 0,
    },
    {
      slug: "nyse-aud",
      code: "NYSE:AUD",
      companyName: "Audacy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-audc",
      code: "NYSE:AUDC",
      companyName: "AudioCodes Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-augx",
      code: "NYSE:AUGX",
      companyName: "Augmedix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-augz",
      code: "NYSE:AUGZ",
      companyName: "TrueShares Structured Outcome (August) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-auid",
      code: "NYSE:AUID",
      companyName: "authID Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aumn",
      code: "NYSE:AUMN",
      companyName: "Golden Minerals Company",
      popularity: 0,
    },
    {
      slug: "nyse-auph",
      code: "NYSE:AUPH",
      companyName: "Aurinia Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-aur",
      code: "NYSE:AUR",
      companyName: "Aurora Innovation Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aura",
      code: "NYSE:AURA",
      companyName: "Aura Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aurc",
      code: "NYSE:AURC",
      companyName: "Aurora Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-aurcu",
      code: "NYSE:AURCU",
      companyName: "Aurora Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-aurcw",
      code: "NYSE:AURCW",
      companyName: "Aurora Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aurow",
      code: "NYSE:AUROW",
      companyName: "Aurora Innovation Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-aust",
      code: "NYSE:AUST",
      companyName: "Austin Gold Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-autl",
      code: "NYSE:AUTL",
      companyName: "Autolus Therapeutics plc American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-auto",
      code: "NYSE:AUTO",
      companyName: "AutoWeb Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-auud",
      code: "NYSE:AUUD",
      companyName: "Auddia Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-auudw",
      code: "NYSE:AUUDW",
      companyName: "Auddia Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-auvi",
      code: "NYSE:AUVI",
      companyName: "Applied UV Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-auvip",
      code: "NYSE:AUVIP",
      companyName:
        "Applied UV Inc. 10.5% Series A Cumulative Perpetual Preferred Stock $0.0001 par value per share",
      popularity: 0,
    },
    {
      slug: "nyse-auy",
      code: "NYSE:AUY",
      companyName: "Yamana Gold Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ava",
      code: "NYSE:AVA",
      companyName: "Avista Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-avac",
      code: "NYSE:AVAC",
      companyName: "Avalon Acquisition Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avacu",
      code: "NYSE:AVACU",
      companyName: "Avalon Acquisition Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-avacw",
      code: "NYSE:AVACW",
      companyName: "Avalon Acquisition Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-avah",
      code: "NYSE:AVAH",
      companyName: "Aveanna Healthcare Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aval",
      code: "NYSE:AVAL",
      companyName: "GRUPO AVAL ACCIONES Y VALORES S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-avan",
      code: "NYSE:AVAN",
      companyName: "Avanti Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-avav",
      code: "NYSE:AVAV",
      companyName: "AeroVironment Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-avb",
      code: "NYSE:AVB",
      companyName: "AvalonBay Communities Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-avco",
      code: "NYSE:AVCO",
      companyName: "Avalon GloboCare Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avct",
      code: "NYSE:AVCT",
      companyName: "American Virtual Cloud Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avctw",
      code: "NYSE:AVCTW",
      companyName:
        "American Virtual Cloud Technologies Inc. Warrant expiring 4/7/2025",
      popularity: 0,
    },
    {
      slug: "nyse-avd",
      code: "NYSE:AVD",
      companyName: "American Vanguard Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-avde",
      code: "NYSE:AVDE",
      companyName: "Avantis International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avdl",
      code: "NYSE:AVDL",
      companyName: "Avadel Pharmaceuticals plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-avdv",
      code: "NYSE:AVDV",
      companyName: "Avantis International Small Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avdx",
      code: "NYSE:AVDX",
      companyName: "AvidXchange Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avem",
      code: "NYSE:AVEM",
      companyName: "Avantis Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aveo",
      code: "NYSE:AVEO",
      companyName: "AVEO Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aves",
      code: "NYSE:AVES",
      companyName: "Avantis Emerging Markets Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avgop",
      code: "NYSE:AVGOP",
      companyName:
        "Broadcom Inc. 8.00% Mandatory Convertible Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nyse-avgr",
      code: "NYSE:AVGR",
      companyName: "Avinger Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avhi",
      code: "NYSE:AVHI",
      companyName: "Achari Ventures Holdings Corp. I Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avhiu",
      code: "NYSE:AVHIU",
      companyName: "Achari Ventures Holdings Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-avgo",
      code: "NYSE:AVGO",
      companyName: "Broadcom Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avhiw",
      code: "NYSE:AVHIW",
      companyName: "Achari Ventures Holdings Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-avid",
      code: "NYSE:AVID",
      companyName: "Avid Technology Inc",
      popularity: 0,
    },
    {
      slug: "nyse-avig",
      code: "NYSE:AVIG",
      companyName: "Avantis Core Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avir",
      code: "NYSE:AVIR",
      companyName: "Atea Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aviv",
      code: "NYSE:AVIV",
      companyName: "Avantis International Large Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avk",
      code: "NYSE:AVK",
      companyName: "Advent Convertible and Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-avlr",
      code: "NYSE:AVLR",
      companyName: "Avalara Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-avlv",
      code: "NYSE:AVLV",
      companyName: "Avantis U.S. Large Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avmu",
      code: "NYSE:AVMU",
      companyName: "Avantis Core Municipal Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avns",
      code: "NYSE:AVNS",
      companyName: "Avanos Medical Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-avnt",
      code: "NYSE:AVNT",
      companyName: "Avient Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-avnw",
      code: "NYSE:AVNW",
      companyName: "Aviat Networks Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-avo",
      code: "NYSE:AVO",
      companyName: "Mission Produce Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avpt",
      code: "NYSE:AVPT",
      companyName: "AvePoint Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avptw",
      code: "NYSE:AVPTW",
      companyName: "AvePoint Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-avre",
      code: "NYSE:AVRE",
      companyName: "Avantis Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avro",
      code: "NYSE:AVRO",
      companyName: "AVROBIO Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avsc",
      code: "NYSE:AVSC",
      companyName: "Avantis U.S. Small Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avsd",
      code: "NYSE:AVSD",
      companyName: "Avantis Responsible International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avse",
      code: "NYSE:AVSE",
      companyName: "Avantis Responsible Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avsf",
      code: "NYSE:AVSF",
      companyName: "Avantis Short-Term Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avsu",
      code: "NYSE:AVSU",
      companyName: "Avantis Responsible U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avt",
      code: "NYSE:AVT",
      companyName: "Avnet Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-avte",
      code: "NYSE:AVTE",
      companyName: "Aerovate Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avtr",
      code: "NYSE:AVTR",
      companyName: "Avantor Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-avtx",
      code: "NYSE:AVTX",
      companyName: "Avalo Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-avus",
      code: "NYSE:AVUS",
      companyName: "Avantis U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avuv",
      code: "NYSE:AVUV",
      companyName: "Avantis U.S. Small Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-avxl",
      code: "NYSE:AVXL",
      companyName: "Anavex Life Sciences",
      popularity: 0,
    },
    {
      slug: "nyse-avy",
      code: "NYSE:AVY",
      companyName: "Avery Dennison Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-avya",
      code: "NYSE:AVYA",
      companyName: "Avaya Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-awp",
      code: "NYSE:AWP",
      companyName: "abrdn Global Premier Properties Fund",
      popularity: 0,
    },
    {
      slug: "nyse-awr",
      code: "NYSE:AWR",
      companyName: "American States Water Company",
      popularity: 0,
    },
    {
      slug: "nyse-awre",
      code: "NYSE:AWRE",
      companyName: "Aware Inc",
      popularity: 0,
    },
    {
      slug: "nyse-awx",
      code: "NYSE:AWX",
      companyName: "Avalon Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-awyx",
      code: "NYSE:AWYX",
      companyName: "ETFMG 2x Daily Travel Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ax",
      code: "NYSE:AX",
      companyName: "Axos Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-axac",
      code: "NYSE:AXAC",
      companyName: "AXIOS Sustainable Growth Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-axac^",
      code: "NYSE:AXAC^",
      companyName:
        "AXIOS Sustainable Growth Acquisition Corporation Rights to receive one-tenth (1/10) of one Class A o",
      popularity: 0,
    },
    {
      slug: "nyse-axdx",
      code: "NYSE:AXDX",
      companyName: "Accelerate Diagnostics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-axgn",
      code: "NYSE:AXGN",
      companyName: "Axogen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-axh",
      code: "NYSE:AXH",
      companyName: "Industrial Human Capital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-axl",
      code: "NYSE:AXL",
      companyName: "American Axle & Manufacturing Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-axla",
      code: "NYSE:AXLA",
      companyName: "Axcella Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-axnx",
      code: "NYSE:AXNX",
      companyName: "Axonics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-axon",
      code: "NYSE:AXON",
      companyName: "Axon Enterprise Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-axr",
      code: "NYSE:AXR",
      companyName: "AMREP Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-axs",
      code: "NYSE:AXS",
      companyName: "Axis Capital Holders Limited",
      popularity: 0,
    },
    {
      slug: "nyse-axs-e",
      code: "NYSE:AXS-E",
      companyName:
        "AXIS Capital Holdings Limited Depositary Shares each representing 1/100th interest in a share of th",
      popularity: 0,
    },
    {
      slug: "nyse-axsm",
      code: "NYSE:AXSM",
      companyName: "Axsome Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-axta",
      code: "NYSE:AXTA",
      companyName: "Axalta Coating Systems Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-axu",
      code: "NYSE:AXU",
      companyName: "Alexco Resource Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ay",
      code: "NYSE:AY",
      companyName: "Atlantica Sustainable Infrastructure plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ayi",
      code: "NYSE:AYI",
      companyName: "Acuity Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ayla",
      code: "NYSE:AYLA",
      companyName: "Ayala Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ayro",
      code: "NYSE:AYRO",
      companyName: "AYRO Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aytu",
      code: "NYSE:AYTU",
      companyName: "AYTU BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ayx",
      code: "NYSE:AYX",
      companyName: "Alteryx Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-az",
      code: "NYSE:AZ",
      companyName: "A2Z Smart Technologies Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-azaa",
      code: "NYSE:AZAA",
      companyName: "AllianzIM U.S. Large Cap Buffer10 Apr ETF",
      popularity: 0,
    },
    {
      slug: "nyse-azaj",
      code: "NYSE:AZAJ",
      companyName: "AllianzIM U.S. Large Cap Buffer10 Jan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-azal",
      code: "NYSE:AZAL",
      companyName: "AllianzIM U.S. Large Cap Buffer10 Jul ETF",
      popularity: 0,
    },
    {
      slug: "nyse-azao",
      code: "NYSE:AZAO",
      companyName: "AllianzIM U.S. Large Cap Buffer10 Oct ETF",
      popularity: 0,
    },
    {
      slug: "nyse-azba",
      code: "NYSE:AZBA",
      companyName: "AllianzIM U.S. Large Cap Buffer20 Apr ETF",
      popularity: 0,
    },
    {
      slug: "nyse-azbj",
      code: "NYSE:AZBJ",
      companyName: "AllianzIM U.S. Large Cap Buffer20 Jan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-belfa",
      code: "NYSE:BELFA",
      companyName: "Bel Fuse Inc",
      popularity: 0,
    },
    {
      slug: "nyse-azbl",
      code: "NYSE:AZBL",
      companyName: "AllianzIM U.S. Large Cap Buffer20 Jul ETF",
      popularity: 0,
    },
    {
      slug: "nyse-azbo",
      code: "NYSE:AZBO",
      companyName: "AllianzIM U.S. Large Cap Buffer20 Oct ETF",
      popularity: 0,
    },
    {
      slug: "nyse-baba",
      code: "NYSE:BABA",
      companyName:
        "Alibaba Group Holding Limited American Depositary Shares each represents eight Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-azn",
      code: "NYSE:AZN",
      companyName: "AstraZeneca PLC",
      popularity: 0,
    },
    {
      slug: "nyse-azo",
      code: "NYSE:AZO",
      companyName: "AutoZone Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-azpn",
      code: "NYSE:AZPN",
      companyName: "Aspen Technology Inc",
      popularity: 0,
    },
    {
      slug: "nyse-azre",
      code: "NYSE:AZRE",
      companyName: "Azure Power Global Limited",
      popularity: 0,
    },
    {
      slug: "nyse-azta",
      code: "NYSE:AZTA",
      companyName: "Azenta Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aztd",
      code: "NYSE:AZTD",
      companyName: "Aztlan Global Stock Selection DM SMID ETF",
      popularity: 0,
    },
    {
      slug: "nyse-azul",
      code: "NYSE:AZUL",
      companyName:
        "Azul S.A. American Depositary Shares (each representing three preferred shares)",
      popularity: 0,
    },
    {
      slug: "nyse-azyo",
      code: "NYSE:AZYO",
      companyName: "Aziyo Biologics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-azz",
      code: "NYSE:AZZ",
      companyName: "AZZ Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-b",
      code: "NYSE:B",
      companyName: "Barnes Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bab",
      code: "NYSE:BAB",
      companyName: "Invesco Taxable Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bac-b",
      code: "NYSE:BAC-B",
      companyName:
        "Bank of America Corporation Depositary Shares each representing a 1/1000th interest in a share of",
      popularity: 0,
    },
    {
      slug: "nyse-bac-e",
      code: "NYSE:BAC-E",
      companyName:
        "Bank of America Corporation Depositary Shares (representing 1/1000th of a share of Floating Rate No",
      popularity: 0,
    },
    {
      slug: "nyse-bac-k",
      code: "NYSE:BAC-K",
      companyName:
        "Bank of America Corporation Depositary Shares each representing a 1/1000th interest in a share of",
      popularity: 0,
    },
    {
      slug: "nyse-bac-l",
      code: "NYSE:BAC-L",
      companyName:
        "Bank Of America Corporation 7.25% Non-Cumulative Perpetual Convertible Preferred Stock Series L",
      popularity: 0,
    },
    {
      slug: "nyse-bac-m",
      code: "NYSE:BAC-M",
      companyName:
        "Bank of America Corporation Depositary Shares each representing a 1/1000th interest in a share of",
      popularity: 0,
    },
    {
      slug: "nyse-bac-n",
      code: "NYSE:BAC-N",
      companyName:
        "Bank of America Corporation Depositary shares each representing 1/1000th interest in a share of 5.",
      popularity: 0,
    },
    {
      slug: "nyse-bac-o",
      code: "NYSE:BAC-O",
      companyName:
        "Bank of America Corporation Depositary shares each representing 1/1000th interest in a share of 4.",
      popularity: 0,
    },
    {
      slug: "nyse-bac-p",
      code: "NYSE:BAC-P",
      companyName:
        "Bank of America Corporation Depositary Shares each representing a 1/1000th interest in a share of",
      popularity: 0,
    },
    {
      slug: "nyse-bac-q",
      code: "NYSE:BAC-Q",
      companyName:
        "Bank of America Corporation Depositary shares each representing 1/1000th interest in a share of 4.",
      popularity: 0,
    },
    {
      slug: "nyse-bac-s",
      code: "NYSE:BAC-S",
      companyName:
        "Bank of America Corporation Depositary shares each representing 1/1000th interest in a share of 4.",
      popularity: 0,
    },
    {
      slug: "nyse-baca",
      code: "NYSE:BACA",
      companyName: "Berenson Acquisition Corp. I",
      popularity: 0,
    },
    {
      slug: "nyse-back",
      code: "NYSE:BACK",
      companyName: "IMAC Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bad",
      code: "NYSE:BAD",
      companyName: "B.A.D. ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bafn",
      code: "NYSE:BAFN",
      companyName: "BayFirst Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bah",
      code: "NYSE:BAH",
      companyName: "Booz Allen Hamilton Holding Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bak",
      code: "NYSE:BAK",
      companyName:
        "Braskem S.A. American Depositary Shares (Each representing Two Class A  Preferred Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-bal",
      code: "NYSE:BAL",
      companyName:
        "iPath Series B Bloomberg Cotton Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-ball",
      code: "NYSE:BALL",
      companyName: "Ball Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-balt",
      code: "NYSE:BALT",
      companyName: "Innovator Defined Wealth Shield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-baly",
      code: "NYSE:BALY",
      companyName: "Bally's Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bam",
      code: "NYSE:BAM",
      companyName: "Brookfield Asset Management Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bamh",
      code: "NYSE:BAMH",
      companyName:
        "Brookfield Finance Inc. 4.625% Subordinated Notes due October 16 2080",
      popularity: 0,
    },
    {
      slug: "nyse-bami",
      code: "NYSE:BAMI",
      companyName:
        "Brookfield Finance I (UK) plc 4.50% Perpetual Subordinated Notes",
      popularity: 0,
    },
    {
      slug: "nyse-bamr",
      code: "NYSE:BAMR",
      companyName:
        "Brookfield Asset Management Reinsurance Partners Ltd.  Class A Exchangeable Limited Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-banc",
      code: "NYSE:BANC",
      companyName: "Banc of California Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-band",
      code: "NYSE:BAND",
      companyName: "Bandwidth Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-banfp",
      code: "NYSE:BANFP",
      companyName:
        "BancFirst Corporation - BFC Capital Trust II Cumulative Trust Pfd Secs",
      popularity: 0,
    },
    {
      slug: "nyse-banr",
      code: "NYSE:BANR",
      companyName: "Banner Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-banx",
      code: "NYSE:BANX",
      companyName: "ArrowMark Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-baos",
      code: "NYSE:BAOS",
      companyName: "Baosheng Media Group Holdings Limited Ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-bap",
      code: "NYSE:BAP",
      companyName: "Credicorp LTD",
      popularity: 0,
    },
    {
      slug: "nyse-bapr",
      code: "NYSE:BAPR",
      companyName: "Innovator U.S. Equity Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-bar",
      code: "NYSE:BAR",
      companyName: "GraniteShares Gold Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bark",
      code: "NYSE:BARK",
      companyName: "BARK Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-base",
      code: "NYSE:BASE",
      companyName: "Couchbase Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-batl",
      code: "NYSE:BATL",
      companyName: "Battalion Oil Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-batra",
      code: "NYSE:BATRA",
      companyName:
        "Liberty Media Corporation Series A Liberty Braves Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-batrk",
      code: "NYSE:BATRK",
      companyName:
        "Liberty Media Corporation Series C Liberty Braves Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-batt",
      code: "NYSE:BATT",
      companyName: "Amplify Lithium & Battery Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-baug",
      code: "NYSE:BAUG",
      companyName: "Innovator U.S. Equity Buffer ETF - August",
      popularity: 0,
    },
    {
      slug: "nyse-bax",
      code: "NYSE:BAX",
      companyName: "Baxter International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bb",
      code: "NYSE:BB",
      companyName: "BlackBerry Limited",
      popularity: 0,
    },
    {
      slug: "nyse-bbai",
      code: "NYSE:BBAI",
      companyName: "BigBear.ai Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bbar",
      code: "NYSE:BBAR",
      companyName: "Banco BBVA Argentina S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-bbax",
      code: "NYSE:BBAX",
      companyName: "JPMorgan BetaBuilders Developed Asia Pacific-ex Japan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbby",
      code: "NYSE:BBBY",
      companyName: "Bed Bath & Beyond Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bbc",
      code: "NYSE:BBC",
      companyName: "Virtus LifeSci Biotech Clinical Trials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbca",
      code: "NYSE:BBCA",
      companyName: "JPMorgan BetaBuilders Canada ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbcp",
      code: "NYSE:BBCP",
      companyName: "Concrete Pumping Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bbd",
      code: "NYSE:BBD",
      companyName:
        "Banco Bradesco S.A. American Depositary Shares (Each representing one Preferred Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-bbdc",
      code: "NYSE:BBDC",
      companyName: "Barings BDC Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bbdo",
      code: "NYSE:BBDO",
      companyName:
        "Banco Bradesco S.A. American Depositary Shares (Each representing one  Common Share no par value)",
      popularity: 0,
    },
    {
      slug: "nyse-bbeu",
      code: "NYSE:BBEU",
      companyName: "JPMorgan BetaBuilders Europe ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbgi",
      code: "NYSE:BBGI",
      companyName: "Beasley Broadcasting Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bbh",
      code: "NYSE:BBH",
      companyName: "VanEck Biotech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbi",
      code: "NYSE:BBI",
      companyName: "Brickell Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bbig",
      code: "NYSE:BBIG",
      companyName: "Vinco Ventures Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bbin",
      code: "NYSE:BBIN",
      companyName: "JPMorgan BetaBuilders International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbio",
      code: "NYSE:BBIO",
      companyName: "BridgeBio Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bbjp",
      code: "NYSE:BBJP",
      companyName: "JPMorgan BetaBuilders Japan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bblg",
      code: "NYSE:BBLG",
      companyName: "Bone Biologics Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bblgw",
      code: "NYSE:BBLGW",
      companyName: "Bone Biologics Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-bbln",
      code: "NYSE:BBLN",
      companyName: "Babylon Holdings Limited",
      popularity: 0,
    },
    {
      slug: "nyse-bbmc",
      code: "NYSE:BBMC",
      companyName: "JPMorgan BetaBuilders U.S. Mid Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbp",
      code: "NYSE:BBP",
      companyName: "Virtus LifeSci Biotech Products ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbq",
      code: "NYSE:BBQ",
      companyName: "BBQ Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bbre",
      code: "NYSE:BBRE",
      companyName: "JPMorgan BetaBuilders MSCI U.S. REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbsa",
      code: "NYSE:BBSA",
      companyName: "JPMorgan BetaBuilders 1-5 Year U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbsc",
      code: "NYSE:BBSC",
      companyName: "JPMorgan BetaBuilders U.S. Small Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbsi",
      code: "NYSE:BBSI",
      companyName: "Barrett Business Services",
      popularity: 0,
    },
    {
      slug: "nyse-bbu",
      code: "NYSE:BBU",
      companyName: "Brookfield Business Partners L.P.Limited Partnership Units",
      popularity: 0,
    },
    {
      slug: "nyse-bbuc",
      code: "NYSE:BBUC",
      companyName:
        "Brookfield Business Corporation Class A Exchangeable Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bbus",
      code: "NYSE:BBUS",
      companyName: "JPMorgan BetaBuilders U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bbva",
      code: "NYSE:BBVA",
      companyName: "Banco Bilbao Vizcaya Argentaria S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-bbw",
      code: "NYSE:BBW",
      companyName: "Build-A-Bear Workshop Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bc",
      code: "NYSE:BC",
      companyName: "Brunswick Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bc-a",
      code: "NYSE:BC-A",
      companyName: "Brunswick Corporation 6.500% Senior Notes due 2048",
      popularity: 0,
    },
    {
      slug: "nyse-bc-b",
      code: "NYSE:BC-B",
      companyName: "Brunswick Corporation 6.625% Senior Notes due 2049",
      popularity: 0,
    },
    {
      slug: "nyse-bc-c",
      code: "NYSE:BC-C",
      companyName: "Brunswick Corporation 6.375% Notes due 2049",
      popularity: 0,
    },
    {
      slug: "nyse-bcab",
      code: "NYSE:BCAB",
      companyName: "BioAtla Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bcan",
      code: "NYSE:BCAN",
      companyName: "BYND Cannasoft Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bcat",
      code: "NYSE:BCAT",
      companyName: "BlackRock Capital Allocation Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bcbp",
      code: "NYSE:BCBP",
      companyName: "BCB Bancorp Inc (NJ)",
      popularity: 0,
    },
    {
      slug: "nyse-bcc",
      code: "NYSE:BCC",
      companyName: "Boise Cascade Company",
      popularity: 0,
    },
    {
      slug: "nyse-bcd",
      code: "NYSE:BCD",
      companyName:
        "abrdn Bloomberg All Commodity Longer Dated Strategy K-1 Free ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bcda",
      code: "NYSE:BCDA",
      companyName: "BioCardia Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bcdaw",
      code: "NYSE:BCDAW",
      companyName: "BioCardia Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bcdf",
      code: "NYSE:BCDF",
      companyName: "Horizon Kinetics Blockchain Development ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bce",
      code: "NYSE:BCE",
      companyName: "BCE Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bcel",
      code: "NYSE:BCEL",
      companyName: "Atreca Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bch",
      code: "NYSE:BCH",
      companyName:
        "Banco de ChileAmerican Depositary Shares (Each representing 200 shares of Common Stock)",
      popularity: 0,
    },
    {
      slug: "nyse-bci",
      code: "NYSE:BCI",
      companyName: "abrdn Bloomberg All Commodity Strategy K-1 Free ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bcim",
      code: "NYSE:BCIM",
      companyName: "abrdn Bloomberg Industrial Metals Strategy K-1 Free ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bcli",
      code: "NYSE:BCLI",
      companyName: "Brainstorm Cell Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bcm",
      code: "NYSE:BCM",
      companyName: "iPath Pure Beta Broad Commodity ETN",
      popularity: 0,
    },
    {
      slug: "nyse-bcml",
      code: "NYSE:BCML",
      companyName: "BayCom Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bco",
      code: "NYSE:BCO",
      companyName: "The Brink's Company",
      popularity: 0,
    },
    {
      slug: "nyse-bcor",
      code: "NYSE:BCOR",
      companyName: "Blucora Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bcov",
      code: "NYSE:BCOV",
      companyName: "Brightcove Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bcow",
      code: "NYSE:BCOW",
      companyName: "1895 Bancorp of Wisconsin Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bcpc",
      code: "NYSE:BCPC",
      companyName: "Balchem Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bcrx",
      code: "NYSE:BCRX",
      companyName: "BioCryst Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bcs",
      code: "NYSE:BCS",
      companyName: "Barclays PLC",
      popularity: 0,
    },
    {
      slug: "nyse-bcsa",
      code: "NYSE:BCSA",
      companyName:
        "Blockchain Coinvestors Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bcsau",
      code: "NYSE:BCSAU",
      companyName: "Blockchain Coinvestors Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bcsaw",
      code: "NYSE:BCSAW",
      companyName: "Blockchain Coinvestors Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bcsf",
      code: "NYSE:BCSF",
      companyName: "Bain Capital Specialty Finance Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bctx",
      code: "NYSE:BCTX",
      companyName: "Briacell Therapeutics Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bctxw",
      code: "NYSE:BCTXW",
      companyName: "BriaCell Therapeutics Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bcv",
      code: "NYSE:BCV",
      companyName: "Bancroft Fund Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-bcv-a",
      code: "NYSE:BCV-A",
      companyName:
        "Bancroft Fund Ltd 5.375% Series A Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bcx",
      code: "NYSE:BCX",
      companyName: "BLACKROCK RESOURCES & COMMODITIES STRATEGY TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-bcyc",
      code: "NYSE:BCYC",
      companyName: "Bicycle Therapeutics plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bdc",
      code: "NYSE:BDC",
      companyName: "Belden Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bdcx",
      code: "NYSE:BDCX",
      companyName:
        "ETRACS Quarterly Pay 1.5X Leveraged MVIS BDC Index ETN due June 10 2050",
      popularity: 0,
    },
    {
      slug: "nyse-bdcz",
      code: "NYSE:BDCZ",
      companyName:
        "ETRACS MVIS Business Development Companies Index ETN due April 26 2041",
      popularity: 0,
    },
    {
      slug: "nyse-bdec",
      code: "NYSE:BDEC",
      companyName: "Innovator U.S. Equity Buffer ETF - December",
      popularity: 0,
    },
    {
      slug: "nyse-bdj",
      code: "NYSE:BDJ",
      companyName: "BlackRock Enhanced Equity Dividend Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bdl",
      code: "NYSE:BDL",
      companyName: "Flanigan's Enterprises Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bdn",
      code: "NYSE:BDN",
      companyName: "Brandywine Realty Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bdry",
      code: "NYSE:BDRY",
      companyName: "Breakwave Dry Bulk Shipping ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bdsx",
      code: "NYSE:BDSX",
      companyName: "Biodesix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bdtx",
      code: "NYSE:BDTX",
      companyName: "Black Diamond Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bdxb",
      code: "NYSE:BDXB",
      companyName:
        "Becton Dickinson and Company Depositary Shares each Representing a 1/20th Interest in a Share of 6",
      popularity: 0,
    },
    {
      slug: "nyse-bdx",
      code: "NYSE:BDX",
      companyName: "Becton Dickinson and Co.",
      popularity: 0,
    },
    {
      slug: "nyse-beat",
      code: "NYSE:BEAT",
      companyName: "Heartbeam Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-beatw",
      code: "NYSE:BEATW",
      companyName: "Heartbeam Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-becn",
      code: "NYSE:BECN",
      companyName: "Beacon Roofing Supply Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bfit",
      code: "NYSE:BFIT",
      companyName: "Global X Funds Global X Health & Wellness ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bedu",
      code: "NYSE:BEDU",
      companyName:
        "Bright Scholar Education Holdings Limited American Depositary Shares each representing four (4) Cla",
      popularity: 0,
    },
    {
      slug: "nyse-bedz",
      code: "NYSE:BEDZ",
      companyName: "AdvisorShares Hotel ETF",
      popularity: 0,
    },
    {
      slug: "nyse-beem",
      code: "NYSE:BEEM",
      companyName: "Beam Global Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-beemw",
      code: "NYSE:BEEMW",
      companyName: "Beam Global Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-beke",
      code: "NYSE:BEKE",
      companyName:
        "KE Holdings Inc. American Depositary Shares (each representing three Class A Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-belfb",
      code: "NYSE:BELFB",
      companyName: "Bel Fuse Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ben",
      code: "NYSE:BEN",
      companyName: "Franklin Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bene",
      code: "NYSE:BENE",
      companyName: "Benessere Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bener",
      code: "NYSE:BENER",
      companyName: "Benessere Capital Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-beneu",
      code: "NYSE:BENEU",
      companyName: "Benessere Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-benew",
      code: "NYSE:BENEW",
      companyName: "Benessere Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bep",
      code: "NYSE:BEP",
      companyName: "Brookfield Renewable Partners L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-bep-a",
      code: "NYSE:BEP-A",
      companyName:
        "Brookfield Renewable Partners L.P. 5.25% Class A Preferred Limited Partnership Units Series 17",
      popularity: 0,
    },
    {
      slug: "nyse-bepc",
      code: "NYSE:BEPC",
      companyName:
        "Brookfield Renewable Corporation Class A Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-beph",
      code: "NYSE:BEPH",
      companyName:
        "Brookfield BRP Holdings (Canada) Inc. 4.625% Perpetual Subordinated Notes",
      popularity: 0,
    },
    {
      slug: "nyse-bepi",
      code: "NYSE:BEPI",
      companyName:
        "Brookfield BRP Holdings (Canada) Inc. 4.875% Perpetual Subordinated Notes",
      popularity: 0,
    },
    {
      slug: "nyse-bery",
      code: "NYSE:BERY",
      companyName: "Berry Global Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-berz",
      code: "NYSE:BERZ",
      companyName: "MicroSectors FANG & Innovation -3x Inverse Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-best",
      code: "NYSE:BEST",
      companyName:
        "BEST Inc. American Depositary Shares each representing five (5) Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-betz",
      code: "NYSE:BETZ",
      companyName: "Roundhill Sports Betting & iGaming ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bfac",
      code: "NYSE:BFAC",
      companyName: "Battery Future Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-bfam",
      code: "NYSE:BFAM",
      companyName: "BRIGHT HORIZONS FAMILY SOLUTIONS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-bfc",
      code: "NYSE:BFC",
      companyName: "Bank First Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bfeb",
      code: "NYSE:BFEB",
      companyName: "Innovator U.S. Equity Buffer ETF - February",
      popularity: 0,
    },
    {
      slug: "nyse-bfh",
      code: "NYSE:BFH",
      companyName: "Bread Financial Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bfi",
      code: "NYSE:BFI",
      companyName: "BurgerFi International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bfiiw",
      code: "NYSE:BFIIW",
      companyName: "BurgerFi International Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bfin",
      code: "NYSE:BFIN",
      companyName: "BankFinancial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bfix",
      code: "NYSE:BFIX",
      companyName: "Build Bond Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bfk",
      code: "NYSE:BFK",
      companyName: "BlackRock Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bfly",
      code: "NYSE:BFLY",
      companyName: "Butterfly Network Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bfor",
      code: "NYSE:BFOR",
      companyName: "Barron's 400 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bfri",
      code: "NYSE:BFRI",
      companyName: "Biofrontera Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bigz",
      code: "NYSE:BIGZ",
      companyName: "BlackRock Innovation and Growth Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bfriw",
      code: "NYSE:BFRIW",
      companyName: "Biofrontera Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-bfs",
      code: "NYSE:BFS",
      companyName: "Saul Centers Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bfs-d",
      code: "NYSE:BFS-D",
      companyName:
        "Saul Centers Inc. Depositary Shares each representing 1/100th of a share of 6.125% Series D Cumula",
      popularity: 0,
    },
    {
      slug: "nyse-bfs-e",
      code: "NYSE:BFS-E",
      companyName:
        "Saul Centers Inc. Depositary Shares each representing 1/100th of a share of 6.000% Series E Cumula",
      popularity: 0,
    },
    {
      slug: "nyse-bfst",
      code: "NYSE:BFST",
      companyName: "Business First Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bftr",
      code: "NYSE:BFTR",
      companyName: "BlackRock Future Innovators ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bfz",
      code: "NYSE:BFZ",
      companyName: "BLACKROCK CA MUNICIPAL INC TR",
      popularity: 0,
    },
    {
      slug: "nyse-bg",
      code: "NYSE:BG",
      companyName: "Bunge Limited",
      popularity: 0,
    },
    {
      slug: "nyse-bgb",
      code: "NYSE:BGB",
      companyName: "Blackstone Strategic Credit Fund",
      popularity: 0,
    },
    {
      slug: "nyse-bgcp",
      code: "NYSE:BGCP",
      companyName: "BGC Partners Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bgfv",
      code: "NYSE:BGFV",
      companyName: "Big 5 Sporting Goods Corp",
      popularity: 0,
    },
    {
      slug: "nyse-bgh",
      code: "NYSE:BGH",
      companyName: "Barings Global Short Duration High Yield Fund",
      popularity: 0,
    },
    {
      slug: "nyse-bgi",
      code: "NYSE:BGI",
      companyName: "Birks Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bgld",
      code: "NYSE:BGLD",
      companyName: "FT Cboe Vest Gold Strategy Quarterly Buffer ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bgne",
      code: "NYSE:BGNE",
      companyName: "BeiGene Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bgr",
      code: "NYSE:BGR",
      companyName: "Blackrock Energy and Resources Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bgrn",
      code: "NYSE:BGRN",
      companyName: "iShares Trust iShares USD Green Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bgry",
      code: "NYSE:BGRY",
      companyName: "Berkshire Grey Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bgryw",
      code: "NYSE:BGRYW",
      companyName: "Berkshire Grey Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bgs",
      code: "NYSE:BGS",
      companyName: "B&G Foods Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bgsf",
      code: "NYSE:BGSF",
      companyName: "BGSF Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bgsx",
      code: "NYSE:BGSX",
      companyName: "Build Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-bgt",
      code: "NYSE:BGT",
      companyName: "BlackRock Floating Rate Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bgx",
      code: "NYSE:BGX",
      companyName: "Blackstone Long-Short Credit Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-bgxx",
      code: "NYSE:BGXX",
      companyName: "Bright Green Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bgy",
      code: "NYSE:BGY",
      companyName: "BlackRock Enhanced International Dividend Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bh",
      code: "NYSE:BH",
      companyName: "Biglari Holdings Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bhac",
      code: "NYSE:BHAC",
      companyName: "Crixus BH3 Acquisition Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bhacu",
      code: "NYSE:BHACU",
      companyName: "Crixus BH3 Acquisition Company Units",
      popularity: 0,
    },
    {
      slug: "nyse-bhacw",
      code: "NYSE:BHACW",
      companyName: "Crixus BH3 Acquisition Company Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-bhat",
      code: "NYSE:BHAT",
      companyName:
        "Blue Hat Interactive Entertainment Technology Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bhb",
      code: "NYSE:BHB",
      companyName: "Bar Harbor Bankshares",
      popularity: 0,
    },
    {
      slug: "nyse-bhc",
      code: "NYSE:BHC",
      companyName: "BauschÿHealthÿCompaniesÿInc.",
      popularity: 0,
    },
    {
      slug: "nyse-bhe",
      code: "NYSE:BHE",
      companyName: "Benchmark Electronics",
      popularity: 0,
    },
    {
      slug: "nyse-bhf",
      code: "NYSE:BHF",
      companyName: "Brighthouse Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bhfal",
      code: "NYSE:BHFAL",
      companyName:
        "Brighthouse Financial Inc. 6.25% Junior Subordinated Debentures due 2058",
      popularity: 0,
    },
    {
      slug: "nyse-bhfam",
      code: "NYSE:BHFAM",
      companyName:
        "Brighthouse Financial Inc. Depositary shares each representing a 1/1000th Interest in a Share of 4",
      popularity: 0,
    },
    {
      slug: "nyse-bhfan",
      code: "NYSE:BHFAN",
      companyName:
        "Brighthouse Financial Inc. Depositary shares each representing a 1/1000th interest in a share of",
      popularity: 0,
    },
    {
      slug: "nyse-bhfao",
      code: "NYSE:BHFAO",
      companyName:
        "Brighthouse Financial Inc. Depositary Shares 6.75% Non-Cum Pfd Series B",
      popularity: 0,
    },
    {
      slug: "nyse-bhfap",
      code: "NYSE:BHFAP",
      companyName:
        "Brighthouse Financial Inc. Depositary Shares 6.6% Non-Cumulative Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nyse-bhg",
      code: "NYSE:BHG",
      companyName: "Bright Health Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bhil",
      code: "NYSE:BHIL",
      companyName: "Benson Hill Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bhk",
      code: "NYSE:BHK",
      companyName: "BLACKROCK CORE BD TR",
      popularity: 0,
    },
    {
      slug: "nyse-bhlb",
      code: "NYSE:BHLB",
      companyName: "Berkshire Hills Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bidu",
      code: "NYSE:BIDU",
      companyName: "Baidu Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bhr",
      code: "NYSE:BHR",
      companyName: "Braemar Hotels & Resorts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bhr-b",
      code: "NYSE:BHR-B",
      companyName:
        "Braemar Hotels & Resorts Inc. 5.50% Series B Cumulative Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bhr-d",
      code: "NYSE:BHR-D",
      companyName:
        "Braemar Hotels & Resorts Inc. 8.25% Series D Cumulative Preferred Stock par value $0.01 per share",
      popularity: 0,
    },
    {
      slug: "nyse-bhse",
      code: "NYSE:BHSE",
      companyName: "Bull Horn Holdings Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bhseu",
      code: "NYSE:BHSEU",
      companyName: "Bull Horn Holdings Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bhsew",
      code: "NYSE:BHSEW",
      companyName: "Bull Horn Holdings Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-bhv",
      code: "NYSE:BHV",
      companyName: "BlackRock Virginia Muni Bond Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bhvn",
      code: "NYSE:BHVN",
      companyName: "Biohaven Pharmaceutical Holding Company Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-bib",
      code: "NYSE:BIB",
      companyName: "ProShares Ultra NASDAQ Biotechnology",
      popularity: 0,
    },
    {
      slug: "nyse-bibl",
      code: "NYSE:BIBL",
      companyName: "Inspire 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bick",
      code: "NYSE:BICK",
      companyName: "First Trust BICK Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-bids",
      code: "NYSE:BIDS",
      companyName: "Amplify Digital & Online Trading ETF",
      popularity: 0,
    },
    {
      slug: "nyse-big",
      code: "NYSE:BIG",
      companyName: "Big Lots Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bigc",
      code: "NYSE:BIGC",
      companyName: "BigCommerce Holdings Inc. Series 1 Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-biib",
      code: "NYSE:BIIB",
      companyName: "Biogen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-box",
      code: "NYSE:BOX",
      companyName: "BOX INC.",
      popularity: 0,
    },
    {
      slug: "nyse-bil",
      code: "NYSE:BIL",
      companyName: "SPDR Bloomberg 1-3 Month T-Bill ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bili",
      code: "NYSE:BILI",
      companyName: "Bilibili Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bill",
      code: "NYSE:BILL",
      companyName: "Bill.com Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bils",
      code: "NYSE:BILS",
      companyName: "SPDR Bloomberg 3-12 Month T-Bill ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bimi",
      code: "NYSE:BIMI",
      companyName: "BIMI International Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bio",
      code: "NYSE:BIO",
      companyName: "Bio-Rad Laboratories Inc.Class A",
      popularity: 0,
    },
    {
      slug: "nyse-bioc",
      code: "NYSE:BIOC",
      companyName: "Biocept Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-biol",
      code: "NYSE:BIOL",
      companyName: "Biolase Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bior",
      code: "NYSE:BIOR",
      companyName: "Biora Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bios",
      code: "NYSE:BIOS",
      companyName: "BioPlus Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-biosu",
      code: "NYSE:BIOSU",
      companyName: "BioPlus Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-biosw",
      code: "NYSE:BIOSW",
      companyName: "BioPlus Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-biot",
      code: "NYSE:BIOT",
      companyName: "Biotech Acquisition Company Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-biotu",
      code: "NYSE:BIOTU",
      companyName: "Biotech Acquisition Company Unit",
      popularity: 0,
    },
    {
      slug: "nyse-biotw",
      code: "NYSE:BIOTW",
      companyName: "Biotech Acquisition Company Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-biox",
      code: "NYSE:BIOX",
      companyName: "Bioceres Crop Solutions Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bip",
      code: "NYSE:BIP",
      companyName:
        "Brookfield Infrastructure Partners L.P. Limited Partnership Units",
      popularity: 0,
    },
    {
      slug: "nyse-bip-a",
      code: "NYSE:BIP-A",
      companyName:
        "Brookfield Infrastructure Partners L.P. 5.125% Class A Preferred Limited Partnership Units Series 1",
      popularity: 0,
    },
    {
      slug: "nyse-bip-b",
      code: "NYSE:BIP-B",
      companyName:
        "Brookfield Infrastructure Partners L.P. 5.000% Class A Preferred Limited Partnership Units Series 1",
      popularity: 0,
    },
    {
      slug: "nyse-bipc",
      code: "NYSE:BIPC",
      companyName:
        "Brookfield Infrastructure Corporation Class A Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-biph",
      code: "NYSE:BIPH",
      companyName:
        "Brookfield Infrastructure Finance ULC 5.000% Subordinated Notes due 2081",
      popularity: 0,
    },
    {
      slug: "nyse-bipi",
      code: "NYSE:BIPI",
      companyName:
        "BIP Bermuda Holdings I Limited 5.125% Perpetual Subordinated Notes",
      popularity: 0,
    },
    {
      slug: "nyse-bird",
      code: "NYSE:BIRD",
      companyName: "Allbirds Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bis",
      code: "NYSE:BIS",
      companyName: "ProShares UltraShort NASDAQ Biotechnology",
      popularity: 0,
    },
    {
      slug: "nyse-bitf",
      code: "NYSE:BITF",
      companyName: "Bitfarms Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-biti",
      code: "NYSE:BITI",
      companyName: "ProShares Short Bitcoin Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bito",
      code: "NYSE:BITO",
      companyName: "ProShares Bitcoin Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bitq",
      code: "NYSE:BITQ",
      companyName: "Bitwise Crypto Industry Innovators ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bivi",
      code: "NYSE:BIVI",
      companyName: "BioVie Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bizd",
      code: "NYSE:BIZD",
      companyName: "VanEck BDC Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bj",
      code: "NYSE:BJ",
      companyName: "BJs Wholesale Club Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bjan",
      code: "NYSE:BJAN",
      companyName: "Innovator U.S. Equity Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-bjdx",
      code: "NYSE:BJDX",
      companyName: "Bluejay Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bjk",
      code: "NYSE:BJK",
      companyName: "VanEck Gaming ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bjri",
      code: "NYSE:BJRI",
      companyName: "BJ's Restaurants Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bjul",
      code: "NYSE:BJUL",
      companyName: "Innovator U.S. Equity Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-bjun",
      code: "NYSE:BJUN",
      companyName: "Innovator U.S. Equity Buffer ETF - June",
      popularity: 0,
    },
    {
      slug: "nyse-bk",
      code: "NYSE:BK",
      companyName: "Bank of New York Mellon Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bkag",
      code: "NYSE:BKAG",
      companyName: "BNY Mellon Core Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkcc",
      code: "NYSE:BKCC",
      companyName: "BlackRock Capital Investment Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bkci",
      code: "NYSE:BKCI",
      companyName: "BNY Mellon Concentrated International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkd",
      code: "NYSE:BKD",
      companyName: "Brookdale Senior Living Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bke",
      code: "NYSE:BKE",
      companyName: "The Buckle Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bkem",
      code: "NYSE:BKEM",
      companyName: "BNY Mellon Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkes",
      code: "NYSE:BKES",
      companyName: "BNY Mellon Sustainable Global Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkf",
      code: "NYSE:BKF",
      companyName: "iShares MSCI BIC ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkh",
      code: "NYSE:BKH",
      companyName: "Black Hills Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bkhy",
      code: "NYSE:BKHY",
      companyName: "BNY Mellon High Yield Beta ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bki",
      code: "NYSE:BKI",
      companyName: "Black Knight Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bkie",
      code: "NYSE:BKIE",
      companyName: "BNY Mellon International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkis",
      code: "NYSE:BKIS",
      companyName: "BNY Mellon Sustainable International Equity ETF ÿ",
      popularity: 0,
    },
    {
      slug: "nyse-bkkt",
      code: "NYSE:BKKT",
      companyName: "Bakkt Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bklc",
      code: "NYSE:BKLC",
      companyName: "BNY Mellon US Large Cap Core Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkln",
      code: "NYSE:BKLN",
      companyName: "Invesco Senior Loan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkmc",
      code: "NYSE:BKMC",
      companyName: "BNY Mellon US Mid Cap Core Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkn",
      code: "NYSE:BKN",
      companyName: "BlackRock Investment Quality Municipal Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bits",
      code: "NYSE:BITS",
      companyName: "Global X Blockchain & Bitcoin Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bksb",
      code: "NYSE:BKSB",
      companyName: "BNY Mellon Short Duration Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bksc",
      code: "NYSE:BKSC",
      companyName: "Bank of South Carolina",
      popularity: 0,
    },
    {
      slug: "nyse-bkse",
      code: "NYSE:BKSE",
      companyName: "BNY Mellon US Small Cap Core Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bksy",
      code: "NYSE:BKSY",
      companyName: "BlackSky Technology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bkch",
      code: "NYSE:BKCH",
      companyName: "Global X Blockchain ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkt",
      code: "NYSE:BKT",
      companyName: "BlackRock Income Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bkti",
      code: "NYSE:BKTI",
      companyName: "BK Technologies Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bku",
      code: "NYSE:BKU",
      companyName: "Bankunited Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bkui",
      code: "NYSE:BKUI",
      companyName: "BNY Mellon Ultra Short Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkus",
      code: "NYSE:BKUS",
      companyName: "BNY Mellon Sustainable US Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bkyi",
      code: "NYSE:BKYI",
      companyName: "BIO-key International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bl",
      code: "NYSE:BL",
      companyName: "BlackLine Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-blbd",
      code: "NYSE:BLBD",
      companyName: "Blue Bird Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-blbx",
      code: "NYSE:BLBX",
      companyName: "Blackboxstocks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-blcm",
      code: "NYSE:BLCM",
      companyName: "Bellicum Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-blcn",
      code: "NYSE:BLCN",
      companyName: "Siren ETF Trust Siren Nasdaq NexGen Economy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-blco",
      code: "NYSE:BLCO",
      companyName: "Bausch + Lomb Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bld",
      code: "NYSE:BLD",
      companyName: "TopBuild Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-blde",
      code: "NYSE:BLDE",
      companyName: "Blade Air Mobility Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bldew",
      code: "NYSE:BLDEW",
      companyName: "Blade Air Mobility Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-bldg",
      code: "NYSE:BLDG",
      companyName: "Cambria Global Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bldp",
      code: "NYSE:BLDP",
      companyName: "Ballard Power Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ble",
      code: "NYSE:BLE",
      companyName: "BlackRock Municipal Income Trust II",
      popularity: 0,
    },
    {
      slug: "nyse-bles",
      code: "NYSE:BLES",
      companyName: "Inspire Global Hope ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bleu",
      code: "NYSE:BLEU",
      companyName: "bleuacacia ltd Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bleur",
      code: "NYSE:BLEUR",
      companyName: "bleuacacia ltd Rights",
      popularity: 0,
    },
    {
      slug: "nyse-bleuu",
      code: "NYSE:BLEUU",
      companyName: "bleuacacia ltd Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bleuw",
      code: "NYSE:BLEUW",
      companyName: "bleuacacia ltd Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-blfs",
      code: "NYSE:BLFS",
      companyName: "BioLife Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-blhy",
      code: "NYSE:BLHY",
      companyName: "Virtus Newfleet High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bli",
      code: "NYSE:BLI",
      companyName: "Berkeley Lights Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-blin",
      code: "NYSE:BLIN",
      companyName: "Bridgeline Digital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-blkb",
      code: "NYSE:BLKB",
      companyName: "Blackbaud Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-blkc",
      code: "NYSE:BLKC",
      companyName:
        "Invesco Alerian Galaxy Blockchain Users and Decentralized Commerce ETF",
      popularity: 0,
    },
    {
      slug: "nyse-blmn",
      code: "NYSE:BLMN",
      companyName: "Bloomin' Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-blnd",
      code: "NYSE:BLND",
      companyName: "Blend Labs Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-blng",
      code: "NYSE:BLNG",
      companyName: "Belong Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-blngu",
      code: "NYSE:BLNGU",
      companyName: "Belong Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-blngw",
      code: "NYSE:BLNGW",
      companyName: "Belong Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-blnk",
      code: "NYSE:BLNK",
      companyName: "Blink Charging Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-blnkw",
      code: "NYSE:BLNKW",
      companyName: "Blink Charging Co. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-blok",
      code: "NYSE:BLOK",
      companyName: "Amplify Transformational Data Sharing ETF",
      popularity: 0,
    },
    {
      slug: "nyse-blph",
      code: "NYSE:BLPH",
      companyName: "Bellerophon Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-blrx",
      code: "NYSE:BLRX",
      companyName: "BioLineRX Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-blsa",
      code: "NYSE:BLSA",
      companyName: "BCLS Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-blte",
      code: "NYSE:BLTE",
      companyName: "Belite Bio Inc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-blts",
      code: "NYSE:BLTS",
      companyName: "Bright Lights Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bltsu",
      code: "NYSE:BLTSU",
      companyName: "Bright Lights Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bltsw",
      code: "NYSE:BLTSW",
      companyName: "Bright Lights Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-blu",
      code: "NYSE:BLU",
      companyName: "BELLUS Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-blua",
      code: "NYSE:BLUA",
      companyName: "BlueRiver Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-blue",
      code: "NYSE:BLUE",
      companyName: "bluebird bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-blw",
      code: "NYSE:BLW",
      companyName: "Blackrock Limited Duration Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-blx",
      code: "NYSE:BLX",
      companyName: "Banco Latinoamericano de Comercio Exterior S.A",
      popularity: 0,
    },
    {
      slug: "nyse-blze",
      code: "NYSE:BLZE",
      companyName: "Backblaze Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bma",
      code: "NYSE:BMA",
      companyName: "Banco Macro S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-bmac",
      code: "NYSE:BMAC",
      companyName: "Black Mountain Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-bmaq",
      code: "NYSE:BMAQ",
      companyName: "Blockchain Moon Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bmaqr",
      code: "NYSE:BMAQR",
      companyName: "Blockchain Moon Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-bmaqu",
      code: "NYSE:BMAQU",
      companyName: "Blockchain Moon Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-bmaqw",
      code: "NYSE:BMAQW",
      companyName: "Blockchain Moon Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-bmar",
      code: "NYSE:BMAR",
      companyName: "Innovator U.S. Equity Buffer ETF - March",
      popularity: 0,
    },
    {
      slug: "nyse-bmay",
      code: "NYSE:BMAY",
      companyName: "Innovator U.S. Equity Buffer ETF - May",
      popularity: 0,
    },
    {
      slug: "nyse-bmbl",
      code: "NYSE:BMBL",
      companyName: "Bumble Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bme",
      code: "NYSE:BME",
      companyName: "Blackrock Health Sciences Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bmea",
      code: "NYSE:BMEA",
      companyName: "Biomea Fusion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bmed",
      code: "NYSE:BMED",
      companyName: "BlackRock Future Health ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bmez",
      code: "NYSE:BMEZ",
      companyName: "BlackRock Health Sciences Trust II",
      popularity: 0,
    },
    {
      slug: "nyse-bmi",
      code: "NYSE:BMI",
      companyName: "Badger Meter Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-blv",
      code: "NYSE:BLV",
      companyName: "Vanguard Long-Term Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bml-g",
      code: "NYSE:BML-G",
      companyName:
        "Bank Of America Corporation Depositary Shares(Each representing a 1/1200th interest in a share of Ba",
      popularity: 0,
    },
    {
      slug: "nyse-bml-h",
      code: "NYSE:BML-H",
      companyName:
        "Bank Of America Corporation Depositary Shares(Each representing a 1/1200th interest in a share of Ba",
      popularity: 0,
    },
    {
      slug: "nyse-boss",
      code: "NYSE:BOSS",
      companyName: "Global X Founder-Run Companies ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bml-j",
      code: "NYSE:BML-J",
      companyName:
        "Bank of America Depositary Shares(Each representing 1/1200th interest in a share of Bank of America",
      popularity: 0,
    },
    {
      slug: "nyse-bml-l",
      code: "NYSE:BML-L",
      companyName:
        "Bank of America Depositary Shares(Each representing 1/1200th interest in a share of Bank of America",
      popularity: 0,
    },
    {
      slug: "nyse-bmo",
      code: "NYSE:BMO",
      companyName: "Bank of Montreal",
      popularity: 0,
    },
    {
      slug: "nyse-bmra",
      code: "NYSE:BMRA",
      companyName: "BIOMERICA INC",
      popularity: 0,
    },
    {
      slug: "nyse-bmrc",
      code: "NYSE:BMRC",
      companyName: "Bank of Marin Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-bmrn",
      code: "NYSE:BMRN",
      companyName: "BioMarin Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bmtx",
      code: "NYSE:BMTX",
      companyName: "BM Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bndc",
      code: "NYSE:BNDC",
      companyName: "FlexShares Core Select Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-bndd",
      code: "NYSE:BNDD",
      companyName: "Quadratic Deflation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bne",
      code: "NYSE:BNE",
      companyName: "Blue Horizon BNE ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bned",
      code: "NYSE:BNED",
      companyName: "Barnes & Noble Education Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bnft",
      code: "NYSE:BNFT",
      companyName: "Benefitfocus Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bnge",
      code: "NYSE:BNGE",
      companyName: "First Trust S-Network Streaming and Gaming ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bngo",
      code: "NYSE:BNGO",
      companyName: "Bionano Genomics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bngow",
      code: "NYSE:BNGOW",
      companyName: "Bionano Genomics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bnix",
      code: "NYSE:BNIX",
      companyName: "Bannix Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bnixr",
      code: "NYSE:BNIXR",
      companyName: "Bannix Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-bnkd",
      code: "NYSE:BNKD",
      companyName:
        "MicroSectorsTM U.S. Big Banks Index -3X Inverse Leveraged ETNs",
      popularity: 0,
    },
    {
      slug: "nyse-bnl",
      code: "NYSE:BNL",
      companyName: "Broadstone Net Lease Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bnnr",
      code: "NYSE:BNNR",
      companyName: "Banner Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bnnru",
      code: "NYSE:BNNRU",
      companyName: "Banner Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-bnnrw",
      code: "NYSE:BNNRW",
      companyName: "Banner Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-bno",
      code: "NYSE:BNO",
      companyName: "United States Brent Oil Fund LP",
      popularity: 0,
    },
    {
      slug: "nyse-bnov",
      code: "NYSE:BNOV",
      companyName: "Innovator U.S. Equity Buffer ETF - November",
      popularity: 0,
    },
    {
      slug: "nyse-bnox",
      code: "NYSE:BNOX",
      companyName: "Bionomics Limited American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bnr",
      code: "NYSE:BNR",
      companyName: "Burning Rock Biotech Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bnrg",
      code: "NYSE:BNRG",
      companyName: "Brenmiller Energy Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bns",
      code: "NYSE:BNS",
      companyName: "Bank of Nova Scotia",
      popularity: 0,
    },
    {
      slug: "nyse-bnso",
      code: "NYSE:BNSO",
      companyName: "Bonso Electronic International",
      popularity: 0,
    },
    {
      slug: "nyse-bntc",
      code: "NYSE:BNTC",
      companyName: "Benitec Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bny",
      code: "NYSE:BNY",
      companyName: "BlackRock New York Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-boac",
      code: "NYSE:BOAC",
      companyName: "Bluescape Opportunities Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-boas",
      code: "NYSE:BOAS",
      companyName: "BOA Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-boat",
      code: "NYSE:BOAT",
      companyName: "SonicShares Global Shipping ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bob",
      code: "NYSE:BOB",
      companyName: "Merlyn.AI Best-of-Breed Core Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-boc",
      code: "NYSE:BOC",
      companyName: "Boston Omaha Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bocn",
      code: "NYSE:BOCN",
      companyName: "Blue Ocean Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bocnu",
      code: "NYSE:BOCNU",
      companyName: "Blue Ocean Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bocnw",
      code: "NYSE:BOCNW",
      companyName: "Blue Ocean Acquisition Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-boct",
      code: "NYSE:BOCT",
      companyName: "Innovator U.S. Equity Buffer ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-body",
      code: "NYSE:BODY",
      companyName: "The Beachbody Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-boe",
      code: "NYSE:BOE",
      companyName: "BlackRock Enhanced Global Dividend Trust",
      popularity: 0,
    },
    {
      slug: "nyse-boh",
      code: "NYSE:BOH",
      companyName: "Bank of Hawaii Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-boh-a",
      code: "NYSE:BOH-A",
      companyName:
        "Bank of Hawaii Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of 4.375",
      popularity: 0,
    },
    {
      slug: "nyse-boil",
      code: "NYSE:BOIL",
      companyName: "ProShares Ultra Bloomberg Natural Gas",
      popularity: 0,
    },
    {
      slug: "nyse-bokf",
      code: "NYSE:BOKF",
      companyName: "BOK Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-bolt",
      code: "NYSE:BOLT",
      companyName: "Bolt Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bon",
      code: "NYSE:BON",
      companyName: "Bon Natural Life Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-boom",
      code: "NYSE:BOOM",
      companyName: "DMC Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-boot",
      code: "NYSE:BOOT",
      companyName: "Boot Barn Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bosc",
      code: "NYSE:BOSC",
      companyName: "B.O.S. Better On-Line Solutions Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-botj",
      code: "NYSE:BOTJ",
      companyName: "Bank of the James Financial Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-botz",
      code: "NYSE:BOTZ",
      companyName:
        "Global X Funds Global X Robotics & Artificial Intelligence ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bnd",
      code: "NYSE:BND",
      companyName: "Vanguard Total Bond Market",
      popularity: 0,
    },
    {
      slug: "nyse-bntx",
      code: "NYSE:BNTX",
      companyName: "BioNTech SE American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-bndw",
      code: "NYSE:BNDW",
      companyName: "Vanguard Total World Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bndx",
      code: "NYSE:BNDX",
      companyName: "Vanguard Total International Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bond",
      code: "NYSE:BOND",
      companyName: "PIMCO Active Bond Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-bout",
      code: "NYSE:BOUT",
      companyName: "Innovator IBD Breakout Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bowl",
      code: "NYSE:BOWL",
      companyName: "Bowlero Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-boxd",
      code: "NYSE:BOXD",
      companyName: "Boxed Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-boxl",
      code: "NYSE:BOXL",
      companyName: "Boxlight Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bp",
      code: "NYSE:BP",
      companyName: "BP p.l.c.",
      popularity: 0,
    },
    {
      slug: "nyse-bpac",
      code: "NYSE:BPAC",
      companyName: "Bullpen Parlay Acquisition Company Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-bpacu",
      code: "NYSE:BPACU",
      companyName: "Bullpen Parlay Acquisition Company Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bpacw",
      code: "NYSE:BPACW",
      companyName: "Bullpen Parlay Acquisition Company Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bpay",
      code: "NYSE:BPAY",
      companyName: "BlackRock Future Financial and Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bpmc",
      code: "NYSE:BPMC",
      companyName: "Blueprint Medicines Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bpop",
      code: "NYSE:BPOP",
      companyName: "Popular Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bpopm",
      code: "NYSE:BPOPM",
      companyName: "Popular Inc. Popular Capital Tr II 6.125%",
      popularity: 0,
    },
    {
      slug: "nyse-bprn",
      code: "NYSE:BPRN",
      companyName: "The Bank of Princeton",
      popularity: 0,
    },
    {
      slug: "nyse-bpt",
      code: "NYSE:BPT",
      companyName: "BP Prudhoe Bay Royalty Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bpth",
      code: "NYSE:BPTH",
      companyName: "Bio-Path Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bpts",
      code: "NYSE:BPTS",
      companyName: "Biophytis SA ADS",
      popularity: 0,
    },
    {
      slug: "nyse-bpypm",
      code: "NYSE:BPYPM",
      companyName:
        "Brookfield Property Partners L.P. 6.25% Class A Cumulative Redeemable Preferred Units Series 1",
      popularity: 0,
    },
    {
      slug: "nyse-bpypn",
      code: "NYSE:BPYPN",
      companyName:
        "Brookfield Property Partners L.P. 5.750% Class A Cumulative Redeemable Perpetual Preferred Units Se",
      popularity: 0,
    },
    {
      slug: "nyse-bpypo",
      code: "NYSE:BPYPO",
      companyName:
        "Brookfield Property Partners L.P. 6.375% Class A Cumulative Redeemable Perpetual Preferred Units Se",
      popularity: 0,
    },
    {
      slug: "nyse-bpypp",
      code: "NYSE:BPYPP",
      companyName:
        "Brookfield Property Partners L.P. 6.50% Class A Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nyse-bq",
      code: "NYSE:BQ",
      companyName:
        "Boqii Holding Limited American Depositary Shares (each representing four and a half (4.5) Class A Or",
      popularity: 0,
    },
    {
      slug: "nyse-br",
      code: "NYSE:BR",
      companyName: "Broadridge Financial Solutions Inc",
      popularity: 0,
    },
    {
      slug: "nyse-brac",
      code: "NYSE:BRAC",
      companyName: "Broad Capital Acquisition Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bracr",
      code: "NYSE:BRACR",
      companyName: "Broad Capital Acquisition Corp Rights",
      popularity: 0,
    },
    {
      slug: "nyse-bracu",
      code: "NYSE:BRACU",
      companyName: "Broad Capital Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-brag",
      code: "NYSE:BRAG",
      companyName: "Bragg Gaming Group Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-brbr",
      code: "NYSE:BRBR",
      companyName: "BellRing Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brbs",
      code: "NYSE:BRBS",
      companyName: "Blue Ridge Bankshares Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brc",
      code: "NYSE:BRC",
      companyName: "Brady Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-brcc",
      code: "NYSE:BRCC",
      companyName: "BRC Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brcn",
      code: "NYSE:BRCN",
      companyName: "Burcon NutraScience Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-brd",
      code: "NYSE:BRD",
      companyName: "Beard Energy Transition Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-brdg",
      code: "NYSE:BRDG",
      companyName: "Bridge Investment Group Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brds",
      code: "NYSE:BRDS",
      companyName: "Bird Global Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brez",
      code: "NYSE:BREZ",
      companyName: "Breeze Holdings Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brezr",
      code: "NYSE:BREZR",
      companyName: "Breeze Holdings Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-brezw",
      code: "NYSE:BREZW",
      companyName: "Breeze Holdings Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-brf",
      code: "NYSE:BRF",
      companyName: "VanEck Brazil Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-brfh",
      code: "NYSE:BRFH",
      companyName: "Barfresh Food Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brfs",
      code: "NYSE:BRFS",
      companyName: "BRF - Brasil Foods S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-brg",
      code: "NYSE:BRG",
      companyName: "Bluerock Residential Growth REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brg-c",
      code: "NYSE:BRG-C",
      companyName: "Bluerock Residential Growth REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brg-d",
      code: "NYSE:BRG-D",
      companyName:
        "Bluerock Residential Growth REIT Inc. 7.125% Series D Cumulative Preferred Stock ($0.01 par value p",
      popularity: 0,
    },
    {
      slug: "nyse-brid",
      code: "NYSE:BRID",
      companyName: "Bridgford Foods Corp",
      popularity: 0,
    },
    {
      slug: "nyse-briv",
      code: "NYSE:BRIV",
      companyName: "B. Riley Principal 250 Merger Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-brivu",
      code: "NYSE:BRIVU",
      companyName: "B. Riley Principal 250 Merger Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-brivw",
      code: "NYSE:BRIVW",
      companyName: "B. Riley Principal 250 Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-brkh",
      code: "NYSE:BRKH",
      companyName: "BurTech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brkhu",
      code: "NYSE:BRKHU",
      companyName: "BurTech Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-brkhw",
      code: "NYSE:BRKHW",
      companyName: "BurTech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-brkl",
      code: "NYSE:BRKL",
      companyName: "Brookline Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-brkr",
      code: "NYSE:BRKR",
      companyName: "Bruker Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-brky",
      code: "NYSE:BRKY",
      companyName: "Direxion Breakfast Commodities Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-brli",
      code: "NYSE:BRLI",
      companyName: "Brilliant Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-brlir",
      code: "NYSE:BRLIR",
      companyName: "Brilliant Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nyse-brliu",
      code: "NYSE:BRLIU",
      companyName: "Brilliant Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-brliw",
      code: "NYSE:BRLIW",
      companyName: "Brilliant Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-brlt",
      code: "NYSE:BRLT",
      companyName: "Brilliant Earth Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brmk",
      code: "NYSE:BRMK",
      companyName: "Broadmark Realty Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brn",
      code: "NYSE:BRN",
      companyName: "Barnwell Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brog",
      code: "NYSE:BROG",
      companyName: "Brooge Energy Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-brogw",
      code: "NYSE:BROGW",
      companyName: "Brooge Holdings Limited Warrant expiring 12/20/2024",
      popularity: 0,
    },
    {
      slug: "nyse-bros",
      code: "NYSE:BROS",
      companyName: "Dutch Bros Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brp",
      code: "NYSE:BRP",
      companyName: "BRP Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brqs",
      code: "NYSE:BRQS",
      companyName: "Borqs Technologies Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-brsh",
      code: "NYSE:BRSH",
      companyName: "Bruush Oral Care Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brshw",
      code: "NYSE:BRSHW",
      companyName: "Bruush Oral Care Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-brsp",
      code: "NYSE:BRSP",
      companyName: "BrightSpire Capital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-brt",
      code: "NYSE:BRT",
      companyName: "BRT Apartments Corp",
      popularity: 0,
    },
    {
      slug: "nyse-brtx",
      code: "NYSE:BRTX",
      companyName: "BioRestorative Therapies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brw",
      code: "NYSE:BRW",
      companyName: "Saba Capital Income & Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-brx",
      code: "NYSE:BRX",
      companyName: "BRIXMOR PROPERTY GROUP INC.",
      popularity: 0,
    },
    {
      slug: "nyse-bry",
      code: "NYSE:BRY",
      companyName: "Berry Corporation (bry) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brze",
      code: "NYSE:BRZE",
      companyName: "Braze Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-brzu",
      code: "NYSE:BRZU",
      companyName: "Direxion Daily MSCI Brazil Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bsac",
      code: "NYSE:BSAC",
      companyName: "Banco Santander-Chile",
      popularity: 0,
    },
    {
      slug: "nyse-bsaq",
      code: "NYSE:BSAQ",
      companyName: "Black Spade Acquisition Co",
      popularity: 0,
    },
    {
      slug: "nyse-bsbe",
      code: "NYSE:BSBE",
      companyName: "Invesco BulletShares 2022 USD Emerging Markets Debt ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsbk",
      code: "NYSE:BSBK",
      companyName: "Bogota Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bsbr",
      code: "NYSE:BSBR",
      companyName: "BANCO SANTANDER (BRASIL) SA",
      popularity: 0,
    },
    {
      slug: "nyse-bsce",
      code: "NYSE:BSCE",
      companyName: "Invesco BulletShares 2023 USD Emerging Markets Debt ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bscm",
      code: "NYSE:BSCM",
      companyName: "Invesco BulletShares 2022 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bscn",
      code: "NYSE:BSCN",
      companyName: "Invesco BulletShares 2023 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsco",
      code: "NYSE:BSCO",
      companyName: "Invesco BulletShares 2024 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bscp",
      code: "NYSE:BSCP",
      companyName: "Invesco BulletShares 2025 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bscr",
      code: "NYSE:BSCR",
      companyName: "Invesco BulletShares 2027 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bscs",
      code: "NYSE:BSCS",
      companyName: "Invesco BulletShares 2028 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsct",
      code: "NYSE:BSCT",
      companyName: "Invesco BulletShares 2029 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bscu",
      code: "NYSE:BSCU",
      companyName: "Invesco BulletShares 2030 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bscv",
      code: "NYSE:BSCV",
      companyName: "Invesco BulletShares 2031 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsde",
      code: "NYSE:BSDE",
      companyName: "Invesco BulletShares 2024 USD Emerging Markets Debt ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsea",
      code: "NYSE:BSEA",
      companyName: "ETFMG Breakwave Sea Decarbonization Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsep",
      code: "NYSE:BSEP",
      companyName: "Innovator U.S. Equity Buffer ETF - September",
      popularity: 0,
    },
    {
      slug: "nyse-bset",
      code: "NYSE:BSET",
      companyName: "Bassett Furniture Industries I",
      popularity: 0,
    },
    {
      slug: "nyse-bsfc",
      code: "NYSE:BSFC",
      companyName: "Blue Star Foods Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bsga",
      code: "NYSE:BSGA",
      companyName: "Blue Safari Group Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-bsgar",
      code: "NYSE:BSGAR",
      companyName: "Blue Safari Group Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-bsgau",
      code: "NYSE:BSGAU",
      companyName: "Blue Safari Group Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bsgm",
      code: "NYSE:BSGM",
      companyName: "BioSig Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bsig",
      code: "NYSE:BSIG",
      companyName: "BrightSphere Investment Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bsjm",
      code: "NYSE:BSJM",
      companyName: "Invesco BulletShares 2022 High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsjn",
      code: "NYSE:BSJN",
      companyName: "Invesco BulletShares 2023 High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsjo",
      code: "NYSE:BSJO",
      companyName: "Invesco BulletShares 2024 High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsjp",
      code: "NYSE:BSJP",
      companyName: "Invesco BulletShares 2025 High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsjq",
      code: "NYSE:BSJQ",
      companyName: "Invesco BulletShares 2026 High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsjr",
      code: "NYSE:BSJR",
      companyName: "Invesco BulletShares 2027 High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsjs",
      code: "NYSE:BSJS",
      companyName: "Invesco BulletShares 2028 High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsjt",
      code: "NYSE:BSJT",
      companyName: "Invesco BulletShares 2029 High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsky",
      code: "NYSE:BSKY",
      companyName: "Big Sky Growth Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bskyu",
      code: "NYSE:BSKYU",
      companyName: "Big Sky Growth Partners Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bskyw",
      code: "NYSE:BSKYW",
      companyName: "Big Sky Growth Partners Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bsl",
      code: "NYSE:BSL",
      companyName: "Blackstone Senior Floating Rate Term Fund",
      popularity: 0,
    },
    {
      slug: "nyse-bsm",
      code: "NYSE:BSM",
      companyName: "Black Stone Minerals L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-bsmm",
      code: "NYSE:BSMM",
      companyName: "Invesco BulletShares 2022 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsmn",
      code: "NYSE:BSMN",
      companyName: "Invesco BulletShares 2023 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsmo",
      code: "NYSE:BSMO",
      companyName: "Invesco BulletShares 2024 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsmp",
      code: "NYSE:BSMP",
      companyName: "Invesco BulletShares 2025 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsmq",
      code: "NYSE:BSMQ",
      companyName: "Invesco BulletShares 2026 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsmr",
      code: "NYSE:BSMR",
      companyName: "Invesco BulletShares 2027 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsms",
      code: "NYSE:BSMS",
      companyName: "Invesco BulletShares 2028 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsmt",
      code: "NYSE:BSMT",
      companyName: "Invesco BulletShares 2029 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsmu",
      code: "NYSE:BSMU",
      companyName: "Invesco BulletShares 2030 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsmv",
      code: "NYSE:BSMV",
      companyName: "Invesco BulletShares 2031 Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bsmx",
      code: "NYSE:BSMX",
      companyName:
        "Banco Santander M‚xico S A. Instituci¢n de Banca M£ltiple Grupo Financiero Santander M‚xico",
      popularity: 0,
    },
    {
      slug: "nyse-bsrr",
      code: "NYSE:BSRR",
      companyName: "Sierra Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-bst",
      code: "NYSE:BST",
      companyName: "BlackRock Science and Technology Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bstp",
      code: "NYSE:BSTP",
      companyName: "Innovator Buffer Step-Up Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bstz",
      code: "NYSE:BSTZ",
      companyName: "BlackRock Science and Technology Trust II",
      popularity: 0,
    },
    {
      slug: "nyse-bsvn",
      code: "NYSE:BSVN",
      companyName: "Bank7 Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-bsx-a",
      code: "NYSE:BSX-A",
      companyName:
        "Boston Scientific Corporation 5.50% Mandatory Convertible Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nyse-bsy",
      code: "NYSE:BSY",
      companyName: "Bentley Systems Incorporated Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bta",
      code: "NYSE:BTA",
      companyName: "Blackrock Long-Term Municipal Advantage Trust",
      popularity: 0,
    },
    {
      slug: "nyse-btai",
      code: "NYSE:BTAI",
      companyName: "BioXcel Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-btal",
      code: "NYSE:BTAL",
      companyName: "AGFiQ U.S. Market Neutral Anti-Beta Fund",
      popularity: 0,
    },
    {
      slug: "nyse-btb",
      code: "NYSE:BTB",
      companyName: "Bit Brother Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-btbd",
      code: "NYSE:BTBD",
      companyName: "BT Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-btbdw",
      code: "NYSE:BTBDW",
      companyName: "BT Brands Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-btbt",
      code: "NYSE:BTBT",
      companyName: "Bit Digital Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-btcm",
      code: "NYSE:BTCM",
      companyName: "BIT Mining Limited",
      popularity: 0,
    },
    {
      slug: "nyse-btcr",
      code: "NYSE:BTCR",
      companyName: "Volt Crypto Industry Revolution and Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-btcs",
      code: "NYSE:BTCS",
      companyName: "BTCS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-btcy",
      code: "NYSE:BTCY",
      companyName: "Biotricity Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-btec",
      code: "NYSE:BTEC",
      companyName:
        "Principal Exchange-Traded Funds Principal Healthcare Innovators ETF",
      popularity: 0,
    },
    {
      slug: "nyse-btek",
      code: "NYSE:BTEK",
      companyName: "BlackRock Future Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bthm",
      code: "NYSE:BTHM",
      companyName: "BlackRock Future U.S. Themes ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bti",
      code: "NYSE:BTI",
      companyName:
        "British American Tobacco p.l.c. American Depositary Shares American Depositary Shares each represe",
      popularity: 0,
    },
    {
      slug: "nyse-bto",
      code: "NYSE:BTO",
      companyName: "John Hancock Financial Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-btog",
      code: "NYSE:BTOG",
      companyName: "Bit Origin Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-btrs",
      code: "NYSE:BTRS",
      companyName: "BTRS Holdings Inc. Class 1 Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-btt",
      code: "NYSE:BTT",
      companyName: "BlackRock Municipal 2030 Target Term Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bttr",
      code: "NYSE:BTTR",
      companyName: "Better Choice Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bttx",
      code: "NYSE:BTTX",
      companyName: "Better Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-btu",
      code: "NYSE:BTU",
      companyName: "Peabody Energy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-btwn",
      code: "NYSE:BTWN",
      companyName: "Bridgetown Holdings Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-btwnu",
      code: "NYSE:BTWNU",
      companyName: "Bridgetown Holdings Limited Units",
      popularity: 0,
    },
    {
      slug: "nyse-btwnw",
      code: "NYSE:BTWNW",
      companyName: "Bridgetown Holdings Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-btx",
      code: "NYSE:BTX",
      companyName: "Brooklyn ImmunoTherapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-btz",
      code: "NYSE:BTZ",
      companyName: "BlackRock Credit Allocation Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bug",
      code: "NYSE:BUG",
      companyName: "Global X Cybersecurity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bufb",
      code: "NYSE:BUFB",
      companyName: "Innovator Laddered Allocation Buffer ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bufd",
      code: "NYSE:BUFD",
      companyName: "FT Cboe Vest Fund of Deep Buffer ETFs",
      popularity: 0,
    },
    {
      slug: "nyse-buff",
      code: "NYSE:BUFF",
      companyName: "Innovator Laddered Allocation Power Buffer ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bufg",
      code: "NYSE:BUFG",
      companyName: "FT Cboe Vest Buffered Allocation Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bufq",
      code: "NYSE:BUFQ",
      companyName: "FT Cboe Vest Fund of Nasdaq-100 Buffer ETFs",
      popularity: 0,
    },
    {
      slug: "nyse-bufr",
      code: "NYSE:BUFR",
      companyName: "FT Cboe Vest Fund of Buffer ETFs",
      popularity: 0,
    },
    {
      slug: "nyse-buft",
      code: "NYSE:BUFT",
      companyName: "FT Cboe Vest Buffered Allocation Defensive ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bui",
      code: "NYSE:BUI",
      companyName:
        "BlackRock Utilities Infrastructure & Power Opportunities Trust",
      popularity: 0,
    },
    {
      slug: "nyse-bul",
      code: "NYSE:BUL",
      companyName: "Pacer US Cash Cows Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-buld",
      code: "NYSE:BULD",
      companyName: "Pacer BlueStar Engineering the Future ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bulz",
      code: "NYSE:BULZ",
      companyName: "MicroSectors FANG & Innovation 3x Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-bur",
      code: "NYSE:BUR",
      companyName: "Burford Capital Limited",
      popularity: 0,
    },
    {
      slug: "nyse-burl",
      code: "NYSE:BURL",
      companyName: "BURLINGTON STORES INC.",
      popularity: 0,
    },
    {
      slug: "nyse-buse",
      code: "NYSE:BUSE",
      companyName: "First Busey Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-buyz",
      code: "NYSE:BUYZ",
      companyName: "Franklin Disruptive Commerce ETF",
      popularity: 0,
    },
    {
      slug: "nyse-buzz",
      code: "NYSE:BUZZ",
      companyName: "VanEck Social Sentiment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bv",
      code: "NYSE:BV",
      companyName: "BrightView Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bvh",
      code: "NYSE:BVH",
      companyName: "Bluegreen Vacations Holding Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bvn",
      code: "NYSE:BVN",
      companyName: "Compania de Minas Buenaventura S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-bvs",
      code: "NYSE:BVS",
      companyName: "Bioventus Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bvxv",
      code: "NYSE:BVXV",
      companyName: "BiondVax Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bw",
      code: "NYSE:BW",
      companyName: "Babcock & Wilcox Enterprises Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bw-a",
      code: "NYSE:BW-A",
      companyName:
        "Babcock & Wilcox Enterprises Inc. 7.75% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bwa",
      code: "NYSE:BWA",
      companyName: "BorgWarner Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bwac",
      code: "NYSE:BWAC",
      companyName: "BETTER WORLD ACQUISITION CORP. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bwacu",
      code: "NYSE:BWACU",
      companyName: "Better World Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bsx",
      code: "NYSE:BSX",
      companyName: "Boston Scientific Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-bwacw",
      code: "NYSE:BWACW",
      companyName: "BETTER WORLD ACQUISITION CORP. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-bwaq",
      code: "NYSE:BWAQ",
      companyName: "Blue World Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bwaqr",
      code: "NYSE:BWAQR",
      companyName: "Blue World Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nyse-bwaqu",
      code: "NYSE:BWAQU",
      companyName: "Blue World Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bwaqw",
      code: "NYSE:BWAQW",
      companyName: "Blue World Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bway",
      code: "NYSE:BWAY",
      companyName: "Brainsway Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bwb",
      code: "NYSE:BWB",
      companyName: "Bridgewater Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bwbbp",
      code: "NYSE:BWBBP",
      companyName:
        "Bridgewater Bancshares Inc. Depositary Shares Each Representing a 1/100th Interest in a Share of 5",
      popularity: 0,
    },
    {
      slug: "nyse-bwc",
      code: "NYSE:BWC",
      companyName: "Blue Whale Acquisition Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bwcau",
      code: "NYSE:BWCAU",
      companyName: "Blue Whale Acquisition Corp I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-bwcaw",
      code: "NYSE:BWCAW",
      companyName: "Blue Whale Acquisition Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bwen",
      code: "NYSE:BWEN",
      companyName: "Broadwind Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bwfg",
      code: "NYSE:BWFG",
      companyName: "Bankwell Financial Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bwg",
      code: "NYSE:BWG",
      companyName: "BrandywineGLOBAL Global Income Opportunities Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bwmn",
      code: "NYSE:BWMN",
      companyName: "Bowman Consulting Group Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bwmx",
      code: "NYSE:BWMX",
      companyName: "Betterware de Mexico S.A.P.I. de C.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bwnb",
      code: "NYSE:BWNB",
      companyName:
        "Babcock & Wilcox Enterprises Inc. 6.50% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-bwv",
      code: "NYSE:BWV",
      companyName: "Blue Water Vaccines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bwx",
      code: "NYSE:BWX",
      companyName: "SPDR Bloomberg International Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bwxt",
      code: "NYSE:BWXT",
      companyName: "BWX Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bwz",
      code: "NYSE:BWZ",
      companyName: "SPDR Bloomberg Short Term International Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bx",
      code: "NYSE:BX",
      companyName: "Blackstone Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bxc",
      code: "NYSE:BXC",
      companyName: "BlueLinx Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bxmt",
      code: "NYSE:BXMT",
      companyName: "Blackstone Mortgage Trust Inc. (NEW)",
      popularity: 0,
    },
    {
      slug: "nyse-bxmx",
      code: "NYSE:BXMX",
      companyName: "NUVEEN S&P BUY-WRITE INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-bxp",
      code: "NYSE:BXP",
      companyName: "Boston Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-bxrx",
      code: "NYSE:BXRX",
      companyName: "Baudax Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bxsl",
      code: "NYSE:BXSL",
      companyName: "Blackstone Secured Lending Fund",
      popularity: 0,
    },
    {
      slug: "nyse-by",
      code: "NYSE:BY",
      companyName: "Byline Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-byd",
      code: "NYSE:BYD",
      companyName: "Boyd Gaming Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-byfc",
      code: "NYSE:BYFC",
      companyName: "Broadway Financial Corp/Del",
      popularity: 0,
    },
    {
      slug: "nyse-byld",
      code: "NYSE:BYLD",
      companyName: "iShares Yield Optimized Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-bym",
      code: "NYSE:BYM",
      companyName: "BLACKROCK MUNICIPAL INCOME QUALITY TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-byn",
      code: "NYSE:BYN",
      companyName: "Banyan Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bynd",
      code: "NYSE:BYND",
      companyName: "Beyond Meat Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-byno",
      code: "NYSE:BYNO",
      companyName: "byNordic Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bynou",
      code: "NYSE:BYNOU",
      companyName: "byNordic Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nyse-bynow",
      code: "NYSE:BYNOW",
      companyName: "byNordic Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-byob",
      code: "NYSE:BYOB",
      companyName: "Tidal ETF Trust SoFi Be Your Own Boss ETF",
      popularity: 0,
    },
    {
      slug: "nyse-byre",
      code: "NYSE:BYRE",
      companyName: "Principal Real Estate Active Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-byrn",
      code: "NYSE:BYRN",
      companyName: "Byrna Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bysi",
      code: "NYSE:BYSI",
      companyName: "BeyondSpring Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-byte",
      code: "NYSE:BYTE",
      companyName: "Roundhill IO Digital Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-byts",
      code: "NYSE:BYTS",
      companyName: "BYTE Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bytsu",
      code: "NYSE:BYTSU",
      companyName: "BYTE Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-bytsw",
      code: "NYSE:BYTSW",
      companyName: "BYTE Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-bz",
      code: "NYSE:BZ",
      companyName: "KANZHUN LIMITED American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-bzfd",
      code: "NYSE:BZFD",
      companyName: "BuzzFeed Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bzfdw",
      code: "NYSE:BZFDW",
      companyName: "BuzzFeed Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bzh",
      code: "NYSE:BZH",
      companyName: "Beazer Homes USA Inc. New",
      popularity: 0,
    },
    {
      slug: "nyse-bzq",
      code: "NYSE:BZQ",
      companyName: "ProShares UltraShort MSCI Brazil Capped",
      popularity: 0,
    },
    {
      slug: "nyse-bzun",
      code: "NYSE:BZUN",
      companyName: "Baozun Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-c-j",
      code: "NYSE:C-J",
      companyName:
        "CITIGROUP INC. Depositary Shares Each Representing a 1/1000th Interest in a Share of 7.125% Fixed",
      popularity: 0,
    },
    {
      slug: "nyse-c-k",
      code: "NYSE:C-K",
      companyName:
        "Citigroup Inc. Depositary Shares Each Representing a 1/1000th Interest in a Share of 6.875% Fixed",
      popularity: 0,
    },
    {
      slug: "nyse-c-n",
      code: "NYSE:C-N",
      companyName:
        "Citigroup Capital XIII 7.875% Fixed Rate/Floating Rate Trust Preferred Securities",
      popularity: 0,
    },
    {
      slug: "nyse-caap",
      code: "NYSE:CAAP",
      companyName: "Corporacion America Airports S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-caas",
      code: "NYSE:CAAS",
      companyName: "China Automotive Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-caba",
      code: "NYSE:CABA",
      companyName: "Cabaletta Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cabo",
      code: "NYSE:CABO",
      companyName: "Cable One Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cac",
      code: "NYSE:CAC",
      companyName: "Camden National Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cacc",
      code: "NYSE:CACC",
      companyName: "Credit Acceptance Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cacg",
      code: "NYSE:CACG",
      companyName:
        "Legg Mason ETF Investment Trust ClearBridge All Cap Growth ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-caci",
      code: "NYSE:CACI",
      companyName: "CACI INTERNATIONAL CLA",
      popularity: 0,
    },
    {
      slug: "nyse-cade",
      code: "NYSE:CADE",
      companyName: "Cadence Bank",
      popularity: 0,
    },
    {
      slug: "nyse-cade-a",
      code: "NYSE:CADE-A",
      companyName:
        "Cadence Bank 5.50% Series A Non- Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cadl",
      code: "NYSE:CADL",
      companyName: "Candel Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-caf",
      code: "NYSE:CAF",
      companyName: "MORGAN STANLEY CHINA A SHARE FUND INC",
      popularity: 0,
    },
    {
      slug: "nyse-cag",
      code: "NYSE:CAG",
      companyName: "Conagra Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cah",
      code: "NYSE:CAH",
      companyName: "Cardinal Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-caj",
      code: "NYSE:CAJ",
      companyName: "Canon Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cake",
      code: "NYSE:CAKE",
      companyName: "Cheesecake Factory (The)",
      popularity: 0,
    },
    {
      slug: "nyse-cal",
      code: "NYSE:CAL",
      companyName: "Caleres Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cala",
      code: "NYSE:CALA",
      companyName: "Calithera Biosciences Inc",
      popularity: 0,
    },
    {
      slug: "nyse-calb",
      code: "NYSE:CALB",
      companyName: "California BanCorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-calf",
      code: "NYSE:CALF",
      companyName: "Pacer US Small Cap Cash Cows 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-calm",
      code: "NYSE:CALM",
      companyName: "Cal-Maine Foods Inc",
      popularity: 0,
    },
    {
      slug: "nyse-calt",
      code: "NYSE:CALT",
      companyName: "Calliditas Therapeutics AB American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-calx",
      code: "NYSE:CALX",
      companyName: "CALIX INC.",
      popularity: 0,
    },
    {
      slug: "nyse-camp",
      code: "NYSE:CAMP",
      companyName: "CalAmp Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-camt",
      code: "NYSE:CAMT",
      companyName: "Camtek Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-canf",
      code: "NYSE:CANF",
      companyName: "Can-Fite BioPharma Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-cang",
      code: "NYSE:CANG",
      companyName:
        "Cango Inc. American Depositary Shares  each representing two (2) Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cano",
      code: "NYSE:CANO",
      companyName: "Cano Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-capd",
      code: "NYSE:CAPD",
      companyName: "iPath Shiller CAPE ETN",
      popularity: 0,
    },
    {
      slug: "nyse-cape",
      code: "NYSE:CAPE",
      companyName: "DoubleLine Shiller CAPE U.S. Equities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-capl",
      code: "NYSE:CAPL",
      companyName:
        "CrossAmerica Partners LP Common units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nyse-capr",
      code: "NYSE:CAPR",
      companyName: "Capricor Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-car",
      code: "NYSE:CAR",
      companyName: "Avis Budget Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cara",
      code: "NYSE:CARA",
      companyName: "Cara Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-care",
      code: "NYSE:CARE",
      companyName: "Carter Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-carg",
      code: "NYSE:CARG",
      companyName: "CarGurus Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cars",
      code: "NYSE:CARS",
      companyName: "Cars.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-carv",
      code: "NYSE:CARV",
      companyName: "Carver Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-carz",
      code: "NYSE:CARZ",
      companyName:
        "First Trust Exchange-Traded Fund II First Trust S-Network Future Vehicles & Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-casa",
      code: "NYSE:CASA",
      companyName: "Casa Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cash",
      code: "NYSE:CASH",
      companyName: "Pathward Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-casi",
      code: "NYSE:CASI",
      companyName: "CASI Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cass",
      code: "NYSE:CASS",
      companyName: "Cass Information Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-casy",
      code: "NYSE:CASY",
      companyName: "Casey's General Stores Inc",
      popularity: 0,
    },
    {
      slug: "nyse-catc",
      code: "NYSE:CATC",
      companyName: "CAMBRIDGE BANCORP",
      popularity: 0,
    },
    {
      slug: "nyse-cato",
      code: "NYSE:CATO",
      companyName: "CATO CORP",
      popularity: 0,
    },
    {
      slug: "nyse-caty",
      code: "NYSE:CATY",
      companyName: "Cathay General Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-cb",
      code: "NYSE:CB",
      companyName: "Chubb Limited",
      popularity: 0,
    },
    {
      slug: "nyse-cban",
      code: "NYSE:CBAN",
      companyName: "Colony Bankcorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cbat",
      code: "NYSE:CBAT",
      companyName: "CBAK Energy Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cbay",
      code: "NYSE:CBAY",
      companyName: "Cymabay Therapeutics",
      popularity: 0,
    },
    {
      slug: "nyse-cbd",
      code: "NYSE:CBD",
      companyName: "Companhia Brasileira de Distribuicao",
      popularity: 0,
    },
    {
      slug: "nyse-cbfv",
      code: "NYSE:CBFV",
      companyName: "CB Financial Services Inc. (PA)",
      popularity: 0,
    },
    {
      slug: "nyse-cbh",
      code: "NYSE:CBH",
      companyName: "Virtus Convertible & Income 2024 Target Term Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cbio",
      code: "NYSE:CBIO",
      companyName: "Catalyst Biosciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cbl",
      code: "NYSE:CBL",
      companyName: "CBL & Associates Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cbls",
      code: "NYSE:CBLS",
      companyName: "Changebridge Capital Long/Short Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cbnk",
      code: "NYSE:CBNK",
      companyName: "Capital Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cboe",
      code: "NYSE:CBOE",
      companyName: "Cboe Global Markets Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cbon",
      code: "NYSE:CBON",
      companyName: "VanEck China Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cbre",
      code: "NYSE:CBRE",
      companyName: "CBRE GROUP INC.",
      popularity: 0,
    },
    {
      slug: "nyse-cbrg",
      code: "NYSE:CBRG",
      companyName: "Chain Bridge I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cbrgu",
      code: "NYSE:CBRGU",
      companyName: "Chain Bridge I Units",
      popularity: 0,
    },
    {
      slug: "nyse-cbrgw",
      code: "NYSE:CBRGW",
      companyName: "Chain Bridge I Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-cbrl",
      code: "NYSE:CBRL",
      companyName: "Cracker Barrel Old Country Store Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cbse",
      code: "NYSE:CBSE",
      companyName: "Changebridge Capital Sustainable Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cbsh",
      code: "NYSE:CBSH",
      companyName: "Commerce Bancshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cbt",
      code: "NYSE:CBT",
      companyName: "Cabot Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cbtx",
      code: "NYSE:CBTX",
      companyName: "CBTX Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cbu",
      code: "NYSE:CBU",
      companyName: "Community Bank System",
      popularity: 0,
    },
    {
      slug: "nyse-cbz",
      code: "NYSE:CBZ",
      companyName: "CBIZ Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cc",
      code: "NYSE:CC",
      companyName: "The Chemours Company",
      popularity: 0,
    },
    {
      slug: "nyse-ccai",
      code: "NYSE:CCAI",
      companyName: "Cascadia Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ccaiu",
      code: "NYSE:CCAIU",
      companyName: "Cascadia Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cath",
      code: "NYSE:CATH",
      companyName: "Global X S&P 500 Catholic Values ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ccaiw",
      code: "NYSE:CCAIW",
      companyName: "Cascadia Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ccap",
      code: "NYSE:CCAP",
      companyName: "Crescent Capital BDC Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-ccb",
      code: "NYSE:CCB",
      companyName: "Coastal Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ccbg",
      code: "NYSE:CCBG",
      companyName: "Capital City Bank Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cccc",
      code: "NYSE:CCCC",
      companyName: "C4 Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cccs",
      code: "NYSE:CCCS",
      companyName: "CCC Intelligent Solutions Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ccd",
      code: "NYSE:CCD",
      companyName: "Calamos Dynamic Convertible & Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ccel",
      code: "NYSE:CCEL",
      companyName: "Cryo-Cell International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ccep",
      code: "NYSE:CCEP",
      companyName: "Coca-Cola Europacific Partners plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ccf",
      code: "NYSE:CCF",
      companyName: "Chase Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cci",
      code: "NYSE:CCI",
      companyName: "Crown Castle Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ccm",
      code: "NYSE:CCM",
      companyName: "Concord Medical Services Holding Limited",
      popularity: 0,
    },
    {
      slug: "nyse-ccnc",
      code: "NYSE:CCNC",
      companyName: "Code Chain New Continent Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ccne",
      code: "NYSE:CCNE",
      companyName: "CNB Financial Corp/PA",
      popularity: 0,
    },
    {
      slug: "nyse-ccnep",
      code: "NYSE:CCNEP",
      companyName:
        "CNB Financial Corporation Depositary Shares each representing a 1/40th ownership interest in a shar",
      popularity: 0,
    },
    {
      slug: "nyse-cco",
      code: "NYSE:CCO",
      companyName: "Clear Channel Outdoor Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ccoi",
      code: "NYSE:CCOI",
      companyName: "Cogent Communications Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ccor",
      code: "NYSE:CCOR",
      companyName: "Core Alternative Capital",
      popularity: 0,
    },
    {
      slug: "nyse-ccrd",
      code: "NYSE:CCRD",
      companyName: "CoreCard Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ccrn",
      code: "NYSE:CCRN",
      companyName: "Cross Country Healthcare Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ccrv",
      code: "NYSE:CCRV",
      companyName: "iShares Commodity Curve Carry Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ccs",
      code: "NYSE:CCS",
      companyName: "CENTURY COMMUNITIES INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ccsi",
      code: "NYSE:CCSI",
      companyName: "Consensus Cloud Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ccts",
      code: "NYSE:CCTS",
      companyName: "Cactus Acquisition Corp. 1 Limited Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-cctsu",
      code: "NYSE:CCTSU",
      companyName: "Cactus Acquisition Corp. 1 Limited Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cctsw",
      code: "NYSE:CCTSW",
      companyName: "Cactus Acquisition Corp. 1 Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ccu",
      code: "NYSE:CCU",
      companyName: "Compania Cervecerias Unidas S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-ccv",
      code: "NYSE:CCV",
      companyName: "Churchill Capital Corp V",
      popularity: 0,
    },
    {
      slug: "nyse-ccvi",
      code: "NYSE:CCVI",
      companyName: "Churchill Capital Corp VI",
      popularity: 0,
    },
    {
      slug: "nyse-ccxi",
      code: "NYSE:CCXI",
      companyName: "ChemoCentryx Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ccz",
      code: "NYSE:CCZ",
      companyName:
        "Comcast Holdings Corp. 2.0% Exchangeable Subordinated Debentures due October 15 2029 (ZONES)",
      popularity: 0,
    },
    {
      slug: "nyse-cd",
      code: "NYSE:CD",
      companyName: "Chindata Group Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cdak",
      code: "NYSE:CDAK",
      companyName: "Codiak BioSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cdaq",
      code: "NYSE:CDAQ",
      companyName: "Compass Digital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cdaqu",
      code: "NYSE:CDAQU",
      companyName: "Compass Digital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cdaqw",
      code: "NYSE:CDAQW",
      companyName: "Compass Digital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cday",
      code: "NYSE:CDAY",
      companyName: "Ceridian HCM Holding",
      popularity: 0,
    },
    {
      slug: "nyse-cdc",
      code: "NYSE:CDC",
      companyName: "VictoryShares US EQ Income Enhanced Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cde",
      code: "NYSE:CDE",
      companyName: "Coeur Mining Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cdev",
      code: "NYSE:CDEV",
      companyName:
        "Centennial Resource Development Inc. Class A Common Stock Business Combination",
      popularity: 0,
    },
    {
      slug: "nyse-cdl",
      code: "NYSE:CDL",
      companyName: "VictoryShares US Large Cap High Div Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cdlx",
      code: "NYSE:CDLX",
      companyName: "Cardlytics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cdmo",
      code: "NYSE:CDMO",
      companyName: "Avid Bioservices Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cdna",
      code: "NYSE:CDNA",
      companyName: "CareDx Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cdns",
      code: "NYSE:CDNS",
      companyName: "Cadence Design Systems",
      popularity: 0,
    },
    {
      slug: "nyse-cdr",
      code: "NYSE:CDR",
      companyName: "Cedar Realty Trust Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cdr-b",
      code: "NYSE:CDR-B",
      companyName:
        "CEDAR REALTY TRUST INC. 7.25% Series B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cdr-c",
      code: "NYSE:CDR-C",
      companyName:
        "Cedar Realty Trust Inc. 6.50% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cdre",
      code: "NYSE:CDRE",
      companyName: "Cadre Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cdro",
      code: "NYSE:CDRO",
      companyName: "Codere Online Luxembourg S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cdrow",
      code: "NYSE:CDROW",
      companyName: "Codere Online Luxembourg S.A. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-cdtx",
      code: "NYSE:CDTX",
      companyName: "Cidara Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cdx",
      code: "NYSE:CDX",
      companyName: "Simplify High Yield PLUS Credit Hedge ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cdxc",
      code: "NYSE:CDXC",
      companyName: "ChromaDex Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cdxs",
      code: "NYSE:CDXS",
      companyName: "Codexis Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cdzi",
      code: "NYSE:CDZI",
      companyName: "CADIZ Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cdzip",
      code: "NYSE:CDZIP",
      companyName: "Cadiz Inc. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ce",
      code: "NYSE:CE",
      companyName: "Celanese Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cea",
      code: "NYSE:CEA",
      companyName: "China Eastern Airlines",
      popularity: 0,
    },
    {
      slug: "nyse-cead",
      code: "NYSE:CEAD",
      companyName: "CEA Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ceadw",
      code: "NYSE:CEADW",
      companyName: "CEA Industries Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cece",
      code: "NYSE:CECE",
      companyName: "Ceco Environmental Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ccl",
      code: "NYSE:CCL",
      companyName: "Carnival Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cee",
      code: "NYSE:CEE",
      companyName: "The Central and Eastern Europe Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cef",
      code: "NYSE:CEF",
      companyName: "Sprott Physical Gold and Silver Trust",
      popularity: 0,
    },
    {
      slug: "nyse-cefd",
      code: "NYSE:CEFD",
      companyName:
        "ETRACS Monthly Pay 1.5X Leveraged Closed-End Fund Index ETN",
      popularity: 0,
    },
    {
      slug: "nyse-cefs",
      code: "NYSE:CEFS",
      companyName: "Saba Closed-End Funds ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cei",
      code: "NYSE:CEI",
      companyName: "Camber Energy Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ceix",
      code: "NYSE:CEIX",
      companyName: "CONSOL Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-celc",
      code: "NYSE:CELC",
      companyName: "Celcuity Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-celg^",
      code: "NYSE:CELG^",
      companyName: "Bristol-Myers Squibb Company Contingent Value Rights",
      popularity: 0,
    },
    {
      slug: "nyse-celh",
      code: "NYSE:CELH",
      companyName: "Celsius Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-celu",
      code: "NYSE:CELU",
      companyName: "Celularity Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-celuw",
      code: "NYSE:CELUW",
      companyName: "Celularity Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-celz",
      code: "NYSE:CELZ",
      companyName: "Creative Medical Technology Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cem",
      code: "NYSE:CEM",
      companyName: "ClearBridge MLP and Midstream Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cemb",
      code: "NYSE:CEMB",
      companyName: "iShares J.P. Morgan EM Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cemi",
      code: "NYSE:CEMI",
      companyName: "Chembio diagnostics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cen",
      code: "NYSE:CEN",
      companyName: "Center Coast Brookfield MLP & Energy Infrastructure Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cenn",
      code: "NYSE:CENN",
      companyName: "Cenntro Electric Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cenq",
      code: "NYSE:CENQ",
      companyName: "CENAQ Energy Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cenqu",
      code: "NYSE:CENQU",
      companyName: "CENAQ Energy Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cenqw",
      code: "NYSE:CENQW",
      companyName: "CENAQ Energy Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cent",
      code: "NYSE:CENT",
      companyName: "Central Garden and Pet Co",
      popularity: 0,
    },
    {
      slug: "nyse-centa",
      code: "NYSE:CENTA",
      companyName: "Central Garden & Pet Company",
      popularity: 0,
    },
    {
      slug: "nyse-cenx",
      code: "NYSE:CENX",
      companyName: "Century Aluminum Co",
      popularity: 0,
    },
    {
      slug: "nyse-cepu",
      code: "NYSE:CEPU",
      companyName:
        "Central Puerto S.A. American Depositary Shares (each represents ten Common Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-ceqp",
      code: "NYSE:CEQP",
      companyName: "Crestwood Equity Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-ceqp-",
      code: "NYSE:CEQP-",
      companyName:
        "Crestwood Equity Partners LP Preferred Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nyse-cere",
      code: "NYSE:CERE",
      companyName: "Cerevel Therapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cers",
      code: "NYSE:CERS",
      companyName: "Cerus Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cert",
      code: "NYSE:CERT",
      companyName: "Certara Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cet",
      code: "NYSE:CET",
      companyName: "Central Securities Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-cetx",
      code: "NYSE:CETX",
      companyName: "CEMTREX INC.",
      popularity: 0,
    },
    {
      slug: "nyse-cetxp",
      code: "NYSE:CETXP",
      companyName: "Cemtrex Inc. Series 1 Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cev",
      code: "NYSE:CEV",
      companyName: "Eaton Vance California Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-ceva",
      code: "NYSE:CEVA",
      companyName: "CEVA Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cew",
      code: "NYSE:CEW",
      companyName: "WisdomTree  Emerging Currency Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cey",
      code: "NYSE:CEY",
      companyName: "VictoryShares Emerging Market High Div Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cf",
      code: "NYSE:CF",
      companyName: "CF Industries Holding Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cfa",
      code: "NYSE:CFA",
      companyName: "VictoryShares US 500 Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cfb",
      code: "NYSE:CFB",
      companyName: "CrossFirst Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cfbk",
      code: "NYSE:CFBK",
      companyName: "CF Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cfcv",
      code: "NYSE:CFCV",
      companyName: "ClearBridge Focus Value ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cffe",
      code: "NYSE:CFFE",
      companyName: "CF Acquisition Corp. VIII Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cffeu",
      code: "NYSE:CFFEU",
      companyName: "CF Acquisition Corp. VIII Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cffew",
      code: "NYSE:CFFEW",
      companyName: "CF Acquisition Corp. VIII Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cffi",
      code: "NYSE:CFFI",
      companyName: "C&F Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cffn",
      code: "NYSE:CFFN",
      companyName: "Capitol Federal Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cffs",
      code: "NYSE:CFFS",
      companyName: "CF Acquisition Corp. VII Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cffsu",
      code: "NYSE:CFFSU",
      companyName: "CF Acquisition Corp. VII Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cffsw",
      code: "NYSE:CFFSW",
      companyName: "CF Acquisition Corp. VII Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cfg",
      code: "NYSE:CFG",
      companyName: "Citizens Financial Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cfg-d",
      code: "NYSE:CFG-D",
      companyName:
        "Citizens Financial Group Inc. Depositary Shares each representing a 1/40th Interest in a Share of",
      popularity: 0,
    },
    {
      slug: "nyse-cfg-e",
      code: "NYSE:CFG-E",
      companyName:
        "Citizens Financial Group Inc.Depositary Shares Each Representing 1/40th Interest in a Share of 5.00",
      popularity: 0,
    },
    {
      slug: "nyse-cfiv",
      code: "NYSE:CFIV",
      companyName: "CF Acquisition Corp. IV Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-cfivu",
      code: "NYSE:CFIVU",
      companyName: "CF Acquisition Corp. IV Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cfivw",
      code: "NYSE:CFIVW",
      companyName: "CF Acquisition Corp. IV Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cflt",
      code: "NYSE:CFLT",
      companyName: "Confluent Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cfms",
      code: "NYSE:CFMS",
      companyName: "Conformis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cfo",
      code: "NYSE:CFO",
      companyName: "VictoryShares US 500 Enhanced Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cfr",
      code: "NYSE:CFR",
      companyName: "Cullen/Frost Bankers Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cfr-b",
      code: "NYSE:CFR-B",
      companyName:
        "Cullen/Frost Bankers Inc. Depositary Shares each representing a 1/40th ownership interest in a sha",
      popularity: 0,
    },
    {
      slug: "nyse-cfrx",
      code: "NYSE:CFRX",
      companyName: "ContraFect Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ckx",
      code: "NYSE:CKX",
      companyName: "CKX Lands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cfsb",
      code: "NYSE:CFSB",
      companyName: "CFSB Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cfvi",
      code: "NYSE:CFVI",
      companyName: "CF Acquisition Corp. VI Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cfviu",
      code: "NYSE:CFVIU",
      companyName: "CF Acquisition Corp. VI Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cfviw",
      code: "NYSE:CFVIW",
      companyName: "CF Acquisition Corp. VI Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cg",
      code: "NYSE:CG",
      companyName: "The Carlyle Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cga",
      code: "NYSE:CGA",
      companyName: "CHINA GREEN AGRICULTURE INC",
      popularity: 0,
    },
    {
      slug: "nyse-cgabl",
      code: "NYSE:CGABL",
      companyName: "The Carlyle Group Inc. 4.625% Subordinated Notes due 2061",
      popularity: 0,
    },
    {
      slug: "nyse-cgau",
      code: "NYSE:CGAU",
      companyName: "Centerra Gold Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cgbd",
      code: "NYSE:CGBD",
      companyName: "Carlyle Secured Lending Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cgcp",
      code: "NYSE:CGCP",
      companyName: "Capital Group Core Plus Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cgdv",
      code: "NYSE:CGDV",
      companyName: "Capital Group Dividend Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cgem",
      code: "NYSE:CGEM",
      companyName: "Cullinan Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cgen",
      code: "NYSE:CGEN",
      companyName: "Compugen Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-cggr",
      code: "NYSE:CGGR",
      companyName: "Capital Group Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cgnt",
      code: "NYSE:CGNT",
      companyName: "Cognyte Software Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cgnx",
      code: "NYSE:CGNX",
      companyName: "Cognex Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cgo",
      code: "NYSE:CGO",
      companyName: "Calamos Global Total Return Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cgrn",
      code: "NYSE:CGRN",
      companyName: "Capstone Green Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cgtx",
      code: "NYSE:CGTX",
      companyName: "Cognition Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cgus",
      code: "NYSE:CGUS",
      companyName: "Capital Group Core Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cgv",
      code: "NYSE:CGV",
      companyName: "Conductor Global Equity Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cgw",
      code: "NYSE:CGW",
      companyName: "Invesco S&P Global Water Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cgxu",
      code: "NYSE:CGXU",
      companyName: "Capital Group International Focus Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chaa",
      code: "NYSE:CHAA",
      companyName: "Catcha Investment Corp",
      popularity: 0,
    },
    {
      slug: "nyse-chad",
      code: "NYSE:CHAD",
      companyName: "Direxion Daily CSI 300 China A Share Bear 1X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-chau",
      code: "NYSE:CHAU",
      companyName: "Direxion Daily CSI 300 China A Share Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-chci",
      code: "NYSE:CHCI",
      companyName: "Comstock Holding Companies Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-chco",
      code: "NYSE:CHCO",
      companyName: "City Holding Co",
      popularity: 0,
    },
    {
      slug: "nyse-chct",
      code: "NYSE:CHCT",
      companyName:
        "Community Healthcare Trust Incorporated Common Stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nyse-chd",
      code: "NYSE:CHD",
      companyName: "Church & Dwight Co. Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-chdn",
      code: "NYSE:CHDN",
      companyName: "Churchill Downs Inc",
      popularity: 0,
    },
    {
      slug: "nyse-che",
      code: "NYSE:CHE",
      companyName: "Chemed Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-chea",
      code: "NYSE:CHEA",
      companyName: "Chenghe Acquisition Co. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-cheau",
      code: "NYSE:CHEAU",
      companyName: "Chenghe Acquisition Co. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cheaw",
      code: "NYSE:CHEAW",
      companyName: "Chenghe Acquisition Co. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-chef",
      code: "NYSE:CHEF",
      companyName: "The Chef's Warehouse Inc",
      popularity: 0,
    },
    {
      slug: "nyse-chek",
      code: "NYSE:CHEK",
      companyName: "Check-Cap Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-chekz",
      code: "NYSE:CHEKZ",
      companyName: "Check-Cap Ltd. Series C Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-chg",
      code: "NYSE:CHG",
      companyName: "Corphousing Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-chgg",
      code: "NYSE:CHGG",
      companyName: "CHEGG INC.",
      popularity: 0,
    },
    {
      slug: "nyse-chgx",
      code: "NYSE:CHGX",
      companyName: "AXS Change Finance ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chh",
      code: "NYSE:CHH",
      companyName: "Choice Hotels Intnl.",
      popularity: 0,
    },
    {
      slug: "nyse-chi",
      code: "NYSE:CHI",
      companyName: "Calamos Convertible Opportunities and Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-chie",
      code: "NYSE:CHIE",
      companyName: "Global X MSCI China Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chih",
      code: "NYSE:CHIH",
      companyName: "Global X MSCI China Health Care ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chii",
      code: "NYSE:CHII",
      companyName: "Global X MSCI China Industrials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chik",
      code: "NYSE:CHIK",
      companyName: "Global X MSCI China Information Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chim",
      code: "NYSE:CHIM",
      companyName: "Global X MSCI China Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chiq",
      code: "NYSE:CHIQ",
      companyName: "Global X MSCI China Consumer Discretionary ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chir",
      code: "NYSE:CHIR",
      companyName: "Global X MSCI China Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chis",
      code: "NYSE:CHIS",
      companyName: "Global X MSCI China Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chiu",
      code: "NYSE:CHIU",
      companyName: "Global X MSCI China Utilities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chix",
      code: "NYSE:CHIX",
      companyName: "Global X MSCI China Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chkel",
      code: "NYSE:CHKEL",
      companyName: "Chesapeake Energy Corporation Class C Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-chkew",
      code: "NYSE:CHKEW",
      companyName: "Chesapeake Energy Corporation Class A Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-chkez",
      code: "NYSE:CHKEZ",
      companyName: "Chesapeake Energy Corporation Class B Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-chkp",
      code: "NYSE:CHKP",
      companyName: "Check Point Software Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-chmg",
      code: "NYSE:CHMG",
      companyName: "Chemung Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-chmi",
      code: "NYSE:CHMI",
      companyName: "CHERRY HILL MORTGAGE INVESTMENT CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-chmi-a",
      code: "NYSE:CHMI-A",
      companyName:
        "Cherry Hill Mortgage Investment Corporation 8.20% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-chmi-b",
      code: "NYSE:CHMI-B",
      companyName:
        "Cherry Hill Mortgage Investment Corporation 8.250% Series B Fixed-to-Floating Rate Cumulative Redeem",
      popularity: 0,
    },
    {
      slug: "nyse-chic",
      code: "NYSE:CHIC",
      companyName: "Global X MSCI China Communication Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chn",
      code: "NYSE:CHN",
      companyName: "CHINA FUND",
      popularity: 0,
    },
    {
      slug: "nyse-chna",
      code: "NYSE:CHNA",
      companyName: "Loncar China BioPharma ETF",
      popularity: 0,
    },
    {
      slug: "nyse-chng",
      code: "NYSE:CHNG",
      companyName: "Change Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-chnr",
      code: "NYSE:CHNR",
      companyName: "China Natural Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-chra",
      code: "NYSE:CHRA",
      companyName: "Charah Solutions Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-chrb",
      code: "NYSE:CHRB",
      companyName: "Charah Solutions Inc. 8.50% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-chrd",
      code: "NYSE:CHRD",
      companyName: "Chord Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-chrs",
      code: "NYSE:CHRS",
      companyName: "Coherus BioSciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-chrw",
      code: "NYSE:CHRW",
      companyName: "C.H. Robinson Worldwide Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-chs",
      code: "NYSE:CHS",
      companyName: "Chicos FAS Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-chscl",
      code: "NYSE:CHSCL",
      companyName:
        "CHS Inc Class B Cumulative Redeemable Preferred Stock Series 4",
      popularity: 0,
    },
    {
      slug: "nyse-chscm",
      code: "NYSE:CHSCM",
      companyName:
        "CHS Inc Class B Reset Rate Cumulative Redeemable Preferred Stock Series 3",
      popularity: 0,
    },
    {
      slug: "nyse-chscn",
      code: "NYSE:CHSCN",
      companyName: "CHS Inc Preferred Class B Series 2 Reset Rate",
      popularity: 0,
    },
    {
      slug: "nyse-chsco",
      code: "NYSE:CHSCO",
      companyName: "CHS Inc. Class B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-chscp",
      code: "NYSE:CHSCP",
      companyName: "CHS Inc. 8% Cumulative Redeemable Pfd",
      popularity: 0,
    },
    {
      slug: "nyse-cht",
      code: "NYSE:CHT",
      companyName: "CHUNGHWA TELECOM CO. LTD",
      popularity: 0,
    },
    {
      slug: "nyse-chtr",
      code: "NYSE:CHTR",
      companyName: "Charter Comm Inc Del CL A New",
      popularity: 0,
    },
    {
      slug: "nyse-chuy",
      code: "NYSE:CHUY",
      companyName: "Chuy's Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-chw",
      code: "NYSE:CHW",
      companyName: "Calamos Global Dynamic Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-chwy",
      code: "NYSE:CHWY",
      companyName: "Chewy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-chy",
      code: "NYSE:CHY",
      companyName: "Calamos Convertible and High Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ci",
      code: "NYSE:CI",
      companyName: "CIGNA Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cia",
      code: "NYSE:CIA",
      companyName: "Citizens Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cian",
      code: "NYSE:CIAN",
      companyName:
        "Cian PLC American Depositary Shares each representing one Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-cib",
      code: "NYSE:CIB",
      companyName: "Bancolombia S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-cibr",
      code: "NYSE:CIBR",
      companyName:
        "First Trust Exchange-Traded Fund II First Trust NASDAQ Cybersecurity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cid",
      code: "NYSE:CID",
      companyName: "VictoryShares International High Div Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cidm",
      code: "NYSE:CIDM",
      companyName: "Cinedigm Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-cien",
      code: "NYSE:CIEN",
      companyName: "Ciena Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cif",
      code: "NYSE:CIF",
      companyName: "MFS Intermediate High Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cifr",
      code: "NYSE:CIFR",
      companyName: "Cipher Mining Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cifrw",
      code: "NYSE:CIFRW",
      companyName: "Cipher Mining Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cig",
      code: "NYSE:CIG",
      companyName: "Companhia Energetica De Minas Gerais-CEMIG",
      popularity: 0,
    },
    {
      slug: "nyse-cigi",
      code: "NYSE:CIGI",
      companyName:
        "Colliers International Group Inc. Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cih",
      code: "NYSE:CIH",
      companyName: "China Index Holdings Limited American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cii",
      code: "NYSE:CII",
      companyName: "Blackrock Enhanced Captial and Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ciig",
      code: "NYSE:CIIG",
      companyName: "CIIG Capital Partners II Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ciigu",
      code: "NYSE:CIIGU",
      companyName: "CIIG Capital Partners II Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ciigw",
      code: "NYSE:CIIGW",
      companyName: "CIIG Capital Partners II Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cik",
      code: "NYSE:CIK",
      companyName: "Credit Suisse Asset Management Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cil",
      code: "NYSE:CIL",
      companyName: "VictoryShares International Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cim",
      code: "NYSE:CIM",
      companyName: "Chimera Investment Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-cim-a",
      code: "NYSE:CIM-A",
      companyName:
        "Chimera Investment Corporation 8.00% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cim-b",
      code: "NYSE:CIM-B",
      companyName:
        "Chimera Investment Corporation 8.00% Series B Fixed-to-Floating Rate Cumulative Redeemable Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-cim-c",
      code: "NYSE:CIM-C",
      companyName:
        "Chimera Investment Corporation 7.75% Series C Fixed-to-Floating Rate  Cumulative Redeemable  Preferr",
      popularity: 0,
    },
    {
      slug: "nyse-cim-d",
      code: "NYSE:CIM-D",
      companyName:
        "Chimera Investment Corporation 8.00% Series D Fixed-to-Floating Rate Cumulative Redeemable Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-cinc",
      code: "NYSE:CINC",
      companyName: "CinCor Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cinf",
      code: "NYSE:CINF",
      companyName: "Cincinnati Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cing",
      code: "NYSE:CING",
      companyName: "Cingulate Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cingw",
      code: "NYSE:CINGW",
      companyName: "Cingulate Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-cint",
      code: "NYSE:CINT",
      companyName: "CI&T Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cio",
      code: "NYSE:CIO",
      companyName: "CITY OFFICE REIT INC.",
      popularity: 0,
    },
    {
      slug: "nyse-cio-a",
      code: "NYSE:CIO-A",
      companyName:
        "City Office REIT Inc.  6.625% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cion",
      code: "NYSE:CION",
      companyName: "CION Investment Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cir",
      code: "NYSE:CIR",
      companyName: "CIRCOR International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ciso",
      code: "NYSE:CISO",
      companyName: "Cerberus Cyber Sentinel Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cite",
      code: "NYSE:CITE",
      companyName: "Cartica Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-citeu",
      code: "NYSE:CITEU",
      companyName: "Cartica Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-citew",
      code: "NYSE:CITEW",
      companyName: "Cartica Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-civb",
      code: "NYSE:CIVB",
      companyName: "Civista Bancshares Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-civi",
      code: "NYSE:CIVI",
      companyName: "Civitas Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cix",
      code: "NYSE:CIX",
      companyName: "Comp X International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cixx",
      code: "NYSE:CIXX",
      companyName: "CI Financial Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ciz",
      code: "NYSE:CIZ",
      companyName: "VictoryShares Developed Enhanced Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cizn",
      code: "NYSE:CIZN",
      companyName: "Citizens Holding Co.",
      popularity: 0,
    },
    {
      slug: "nyse-cjjd",
      code: "NYSE:CJJD",
      companyName:
        "China Jo-Jo Drugstores Inc. (Cayman Islands) Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ckpt",
      code: "NYSE:CKPT",
      companyName: "Checkpoint Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cl",
      code: "NYSE:CL",
      companyName: "Colgate-Palmolive Company",
      popularity: 0,
    },
    {
      slug: "nyse-claa",
      code: "NYSE:CLAA",
      companyName: "Colonnade Acquisition Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-claq",
      code: "NYSE:CLAQ",
      companyName: "CleanTech Acquisition Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-claqr",
      code: "NYSE:CLAQR",
      companyName: "CleanTech Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-claqu",
      code: "NYSE:CLAQU",
      companyName: "CleanTech Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-claqw",
      code: "NYSE:CLAQW",
      companyName: "CleanTech Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-clar",
      code: "NYSE:CLAR",
      companyName: "Clarus Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clas",
      code: "NYSE:CLAS",
      companyName: "Class Acceleration Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-clay",
      code: "NYSE:CLAY",
      companyName: "Chavant Capital Acquisition Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-clayu",
      code: "NYSE:CLAYU",
      companyName: "Chavant Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-clayw",
      code: "NYSE:CLAYW",
      companyName: "Chavant Capital Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-clb",
      code: "NYSE:CLB",
      companyName: "Core Laboratories N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-clbk",
      code: "NYSE:CLBK",
      companyName: "Columbia Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clbr",
      code: "NYSE:CLBR",
      companyName: "Colombier Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-clbs",
      code: "NYSE:CLBS",
      companyName: "Caladrius Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clbt",
      code: "NYSE:CLBT",
      companyName: "Cellebrite DI Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-clbtw",
      code: "NYSE:CLBTW",
      companyName: "Cellebrite DI Ltd. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-cldl",
      code: "NYSE:CLDL",
      companyName: "Direxion Daily Cloud Computing Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-clds",
      code: "NYSE:CLDS",
      companyName: "Direxion Daily Cloud Computing Bear 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cldt",
      code: "NYSE:CLDT",
      companyName: "CHATHAM LODGING TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-cldt-a",
      code: "NYSE:CLDT-A",
      companyName:
        "Chatham Lodging Trust 6.625% Series A Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-cldx",
      code: "NYSE:CLDX",
      companyName: "Celldex Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cleu",
      code: "NYSE:CLEU",
      companyName: "China Liberal Education Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-clf",
      code: "NYSE:CLF",
      companyName: "Cleveland-Cliffs Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-clfd",
      code: "NYSE:CLFD",
      companyName: "Clearfield Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-clgn",
      code: "NYSE:CLGN",
      companyName: "CollPlant Biotechnologies Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-clh",
      code: "NYSE:CLH",
      companyName: "Clean Harbors Inc",
      popularity: 0,
    },
    {
      slug: "nyse-clim",
      code: "NYSE:CLIM",
      companyName: "Climate Real Impact Solutions II Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-clin",
      code: "NYSE:CLIN",
      companyName: "Clean Earth Acquisitions Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clinr",
      code: "NYSE:CLINR",
      companyName: "Clean Earth Acquisitions Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-clinu",
      code: "NYSE:CLINU",
      companyName: "Clean Earth Acquisitions Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-clinw",
      code: "NYSE:CLINW",
      companyName: "Clean Earth Acquisitions Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-clir",
      code: "NYSE:CLIR",
      companyName: "ClearSign Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clix",
      code: "NYSE:CLIX",
      companyName: "ProShares Long Online/Short Stores ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clls",
      code: "NYSE:CLLS",
      companyName: "Cellectis S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-clm",
      code: "NYSE:CLM",
      companyName: "Cornerstone Strategic Value Fund",
      popularity: 0,
    },
    {
      slug: "nyse-clmt",
      code: "NYSE:CLMT",
      companyName: "Calumet Specialty Products Partners L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-clne",
      code: "NYSE:CLNE",
      companyName: "Clean Energy Fuels Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-clnn",
      code: "NYSE:CLNN",
      companyName: "Clene Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clnnw",
      code: "NYSE:CLNNW",
      companyName: "Clene Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-clnr",
      code: "NYSE:CLNR",
      companyName: "IQ Cleaner Transport ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cloe",
      code: "NYSE:CLOE",
      companyName: "Clover Leaf Capital Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cloer",
      code: "NYSE:CLOER",
      companyName: "Clover Leaf Capital Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-cloeu",
      code: "NYSE:CLOEU",
      companyName: "Clover Leaf Capital Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cloi",
      code: "NYSE:CLOI",
      companyName: "VanEck CLO ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clou",
      code: "NYSE:CLOU",
      companyName: "Global X Cloud Computing ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clov",
      code: "NYSE:CLOV",
      companyName: "Clover Health Investments Corp",
      popularity: 0,
    },
    {
      slug: "nyse-clpr",
      code: "NYSE:CLPR",
      companyName: "Clipper Realty Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clps",
      code: "NYSE:CLPS",
      companyName: "CLPS Incorporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clpt",
      code: "NYSE:CLPT",
      companyName: "ClearPoint Neuro Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clr",
      code: "NYSE:CLR",
      companyName: "CONTINENTAL RESOURCES INC.",
      popularity: 0,
    },
    {
      slug: "nyse-clrb",
      code: "NYSE:CLRB",
      companyName: "Cellectar Biosciences INC NEW",
      popularity: 0,
    },
    {
      slug: "nyse-clrc",
      code: "NYSE:CLRC",
      companyName: "ClimateRock Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-clrcr",
      code: "NYSE:CLRCR",
      companyName: "ClimateRock Right",
      popularity: 0,
    },
    {
      slug: "nyse-clrcu",
      code: "NYSE:CLRCU",
      companyName: "ClimateRock Unit",
      popularity: 0,
    },
    {
      slug: "nyse-clrcw",
      code: "NYSE:CLRCW",
      companyName: "ClimateRock Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-clrg",
      code: "NYSE:CLRG",
      companyName: "IQ Chaikin U.S. Large Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clrm",
      code: "NYSE:CLRM",
      companyName: "Clarim Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clrmu",
      code: "NYSE:CLRMU",
      companyName: "Clarim Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-clrmw",
      code: "NYSE:CLRMW",
      companyName: "Clarim Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-clro",
      code: "NYSE:CLRO",
      companyName: "ClearOne Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cls",
      code: "NYSE:CLS",
      companyName: "Celestica Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-clsa",
      code: "NYSE:CLSA",
      companyName: "Cabana Target Leading Sector Aggressive ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clsc",
      code: "NYSE:CLSC",
      companyName: "Cabana Target Leading Sector Conservative ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clsd",
      code: "NYSE:CLSD",
      companyName: "Clearside Biomedical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-clse",
      code: "NYSE:CLSE",
      companyName: "Convergence Long/Short Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clsk",
      code: "NYSE:CLSK",
      companyName: "CLEANSPARK INC",
      popularity: 0,
    },
    {
      slug: "nyse-clsm",
      code: "NYSE:CLSM",
      companyName: "Cabana Target Leading Sector Moderate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clsn",
      code: "NYSE:CLSN",
      companyName: "Celsion Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-clst",
      code: "NYSE:CLST",
      companyName: "Catalyst Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cltl",
      code: "NYSE:CLTL",
      companyName: "Invesco Treasury Collateral ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clvr",
      code: "NYSE:CLVR",
      companyName: "Clever Leaves Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-clvrw",
      code: "NYSE:CLVRW",
      companyName: "Clever Leaves Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-clvs",
      code: "NYSE:CLVS",
      companyName: "Clovis Oncology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-clvt",
      code: "NYSE:CLVT",
      companyName: "Clarivate Plc",
      popularity: 0,
    },
    {
      slug: "nyse-clwt",
      code: "NYSE:CLWT",
      companyName: "Euro Tech Holdings Co Ltd. New",
      popularity: 0,
    },
    {
      slug: "nyse-clx",
      code: "NYSE:CLX",
      companyName: "Clorox Company",
      popularity: 0,
    },
    {
      slug: "nyse-clxt",
      code: "NYSE:CLXT",
      companyName: "Calyxt Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cm",
      code: "NYSE:CM",
      companyName: "Canadian Imperial Bank of Commerce",
      popularity: 0,
    },
    {
      slug: "nyse-cma",
      code: "NYSE:CMA",
      companyName: "Comerica Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-cmax",
      code: "NYSE:CMAX",
      companyName: "CareMax Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cmaxw",
      code: "NYSE:CMAXW",
      companyName: "CareMax Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cmbm",
      code: "NYSE:CMBM",
      companyName: "Cambium Networks Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cmbs",
      code: "NYSE:CMBS",
      companyName: "iShares CMBS ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cmc",
      code: "NYSE:CMC",
      companyName: "Commercial Metals Company",
      popularity: 0,
    },
    {
      slug: "nyse-cmca",
      code: "NYSE:CMCA",
      companyName:
        "Capitalworks Emerging Markets Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cmcau",
      code: "NYSE:CMCAU",
      companyName: "Capitalworks Emerging Markets Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cmcaw",
      code: "NYSE:CMCAW",
      companyName: "Capitalworks Emerging Markets Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cmcl",
      code: "NYSE:CMCL",
      companyName: "Caledonia Mining Corporation Plc",
      popularity: 0,
    },
    {
      slug: "nyse-cmcm",
      code: "NYSE:CMCM",
      companyName: "CHEETAH MOBILE INC.",
      popularity: 0,
    },
    {
      slug: "nyse-cmco",
      code: "NYSE:CMCO",
      companyName: "Columbus McKinnon Corp/NY",
      popularity: 0,
    },
    {
      slug: "nyse-cmcsa",
      code: "NYSE:CMCSA",
      companyName: "Comcast Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cmct",
      code: "NYSE:CMCT",
      companyName: "Creative Media & Community Trust Corporation Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-cmctp",
      code: "NYSE:CMCTP",
      companyName:
        "Creative Media & Community Trust Corporation Series L Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cmdy",
      code: "NYSE:CMDY",
      companyName: "iShares Bloomberg Roll Select Commodity Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cmf",
      code: "NYSE:CMF",
      companyName: "iShares California Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cmi",
      code: "NYSE:CMI",
      companyName: "Cummins Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cmls",
      code: "NYSE:CMLS",
      companyName: "Cumulus Media Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cmmb",
      code: "NYSE:CMMB",
      companyName: "Chemomab Therapeutics Ltd. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-cmp",
      code: "NYSE:CMP",
      companyName: "Compass Minerals International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cmpo",
      code: "NYSE:CMPO",
      companyName: "CompoSecure Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cmpow",
      code: "NYSE:CMPOW",
      companyName: "CompoSecure Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cmpr",
      code: "NYSE:CMPR",
      companyName: "Cimpress PLC Ordinary Shares (Ireland)",
      popularity: 0,
    },
    {
      slug: "nyse-cmps",
      code: "NYSE:CMPS",
      companyName: "COMPASS Pathways Plc American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cmpx",
      code: "NYSE:CMPX",
      companyName: "Compass Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cmra",
      code: "NYSE:CMRA",
      companyName: "Comera Life Sciences Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cmraw",
      code: "NYSE:CMRAW",
      companyName:
        "Comera Life Sciences Holdings Inc. Warrant expiring 5/19/2027",
      popularity: 0,
    },
    {
      slug: "nyse-cmre",
      code: "NYSE:CMRE",
      companyName: "Costamare Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cmre-b",
      code: "NYSE:CMRE-B",
      companyName:
        "Costamare Inc. 7.625% Series B Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cmre-c",
      code: "NYSE:CMRE-C",
      companyName:
        "COSTAMARE INC. 8.50% Series C Cumulative Redeemable Perpetual Preferred Stock $0.0001 par value",
      popularity: 0,
    },
    {
      slug: "nyse-cmre-d",
      code: "NYSE:CMRE-D",
      companyName:
        "Costamare Inc.  8.75% Series D Cumulative Redeemable Perpetual Preferred Stock $0.0001 par",
      popularity: 0,
    },
    {
      slug: "nyse-cmre-e",
      code: "NYSE:CMRE-E",
      companyName:
        "Costamare Inc. 8.875% Series E Cumulative Redeemable Perpetual Preferred Stock par value $0.0001",
      popularity: 0,
    },
    {
      slug: "nyse-cmrx",
      code: "NYSE:CMRX",
      companyName: "Chimerix Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cms",
      code: "NYSE:CMS",
      companyName: "CMS Energy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cms-b",
      code: "NYSE:CMS-B",
      companyName: "Consumers Energy Company $4.50 Cumulative Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-cms-c",
      code: "NYSE:CMS-C",
      companyName:
        "CMS Energy Corporation Depositary Shares each representing a 1/1 000th interest in a share of 4.20",
      popularity: 0,
    },
    {
      slug: "nyse-cmsa",
      code: "NYSE:CMSA",
      companyName:
        "CMS Energy Corporation 5.625% Junior Subordinated Notes due 2078",
      popularity: 0,
    },
    {
      slug: "nyse-cmsc",
      code: "NYSE:CMSC",
      companyName:
        "CMS Energy Corporation 5.875% Junior Subordinated Notes due 2078",
      popularity: 0,
    },
    {
      slug: "nyse-cmsd",
      code: "NYSE:CMSD",
      companyName:
        "CMS Energy Corporation 5.875% Junior Subordinated Notes due 2079",
      popularity: 0,
    },
    {
      slug: "nyse-cmt",
      code: "NYSE:CMT",
      companyName: "Core Molding Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cmtg",
      code: "NYSE:CMTG",
      companyName: "Claros Mortgage Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cmtl",
      code: "NYSE:CMTL",
      companyName: "Comtech Telecommunications",
      popularity: 0,
    },
    {
      slug: "nyse-cmu",
      code: "NYSE:CMU",
      companyName: "MFS High Yield Municipal Trust",
      popularity: 0,
    },
    {
      slug: "nyse-cn",
      code: "NYSE:CN",
      companyName: "Xtrackers MSCI All China Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cna",
      code: "NYSE:CNA",
      companyName: "CNA Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cnbs",
      code: "NYSE:CNBS",
      companyName: "Amplify Seymour Cannabis ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cnc",
      code: "NYSE:CNC",
      companyName: "Centene Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cnce",
      code: "NYSE:CNCE",
      companyName: "Concert Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cncr",
      code: "NYSE:CNCR",
      companyName: "Loncar Cancer Immunotherapy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cnd",
      code: "NYSE:CND",
      companyName: "Concord Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-cnda",
      code: "NYSE:CNDA",
      companyName: "Concord Acquisition Corp II",
      popularity: 0,
    },
    {
      slug: "nyse-cndb",
      code: "NYSE:CNDB",
      companyName: "Concord Acquisition Corp III",
      popularity: 0,
    },
    {
      slug: "nyse-cndt",
      code: "NYSE:CNDT",
      companyName: "Conduent Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cnet",
      code: "NYSE:CNET",
      companyName: "ZW Data Action Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cney",
      code: "NYSE:CNEY",
      companyName: "CN Energy Group Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cnf",
      code: "NYSE:CNF",
      companyName:
        'CNFinance Holdings Limited American Depositary Shares ("ADSs") each representing twenty (20) Ordina',
      popularity: 0,
    },
    {
      slug: "nyse-cnfr",
      code: "NYSE:CNFR",
      companyName: "Conifer Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cnfrl",
      code: "NYSE:CNFRL",
      companyName:
        "Conifer Holdings Inc. 6.75% Senior Unsecured Notes due 2023",
      popularity: 0,
    },
    {
      slug: "nyse-cngl",
      code: "NYSE:CNGL",
      companyName: "Canna-Global Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cnglu",
      code: "NYSE:CNGLU",
      companyName: "Canna-Global Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cnglw",
      code: "NYSE:CNGLW",
      companyName: "Canna-Global Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cnhi",
      code: "NYSE:CNHI",
      companyName: "CNH INDUSTRIAL N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-cni",
      code: "NYSE:CNI",
      companyName: "Canadian National Railway",
      popularity: 0,
    },
    {
      slug: "nyse-cnk",
      code: "NYSE:CNK",
      companyName: "Cinemark Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cnm",
      code: "NYSE:CNM",
      companyName: "Core & Main Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cnmd",
      code: "NYSE:CNMD",
      companyName: "CONMED Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cnnb",
      code: "NYSE:CNNB",
      companyName: "CINCINNATI BANCORP",
      popularity: 0,
    },
    {
      slug: "nyse-cnne",
      code: "NYSE:CNNE",
      companyName: "Cannae Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cno",
      code: "NYSE:CNO",
      companyName: "CNO Financial Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cno-a",
      code: "NYSE:CNO-A",
      companyName:
        "CNO Financial Group Inc. 5.125% Subordinated Debentures due 2060",
      popularity: 0,
    },
    {
      slug: "nyse-cnob",
      code: "NYSE:CNOB",
      companyName: "Center Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cnobp",
      code: "NYSE:CNOBP",
      companyName:
        "ConnectOne Bancorp Inc. Depositary Shares each representing a 1/40th interest in a share of 5.25%",
      popularity: 0,
    },
    {
      slug: "nyse-cnp",
      code: "NYSE:CNP",
      companyName: "CenterPoint Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cnq",
      code: "NYSE:CNQ",
      companyName: "Canadian Natural Resources Limited",
      popularity: 0,
    },
    {
      slug: "nyse-cnrg",
      code: "NYSE:CNRG",
      companyName: "SPDR S&P Kensho Clean Power ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cns",
      code: "NYSE:CNS",
      companyName: "Cohen & Steers Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cnsl",
      code: "NYSE:CNSL",
      companyName: "Consolidated Communications Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cnsp",
      code: "NYSE:CNSP",
      companyName: "CNS Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cnta",
      code: "NYSE:CNTA",
      companyName: "Centessa Pharmaceuticals plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cntb",
      code: "NYSE:CNTB",
      companyName:
        "Connect Biopharma Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cntg",
      code: "NYSE:CNTG",
      companyName: "Centogene N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cntq",
      code: "NYSE:CNTQ",
      companyName: "Chardan NexTech Acquisition 2 Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cntqu",
      code: "NYSE:CNTQU",
      companyName: "Chardan NexTech Acquisition 2 Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cntqw",
      code: "NYSE:CNTQW",
      companyName: "Chardan NexTech Acquisition 2 Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cntx",
      code: "NYSE:CNTX",
      companyName: "Context Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cnty",
      code: "NYSE:CNTY",
      companyName: "Century Casinos Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cnvy",
      code: "NYSE:CNVY",
      companyName: "Convey Health Solutions Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cnx",
      code: "NYSE:CNX",
      companyName: "CNX Resources Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cnxa",
      code: "NYSE:CNXA",
      companyName: "Connexa Sports Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cnxc",
      code: "NYSE:CNXC",
      companyName: "Concentrix Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cnxn",
      code: "NYSE:CNXN",
      companyName: "PC Connection Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cnya",
      code: "NYSE:CNYA",
      companyName: "iShares MSCI China A ETF",
      popularity: 0,
    },
    {
      slug: "nyse-co",
      code: "NYSE:CO",
      companyName: "Global Cord Blood Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-coco",
      code: "NYSE:COCO",
      companyName: "The Vita Coco Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cocp",
      code: "NYSE:COCP",
      companyName: "Cocrystal Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-coda",
      code: "NYSE:CODA",
      companyName: "Coda Octopus Group Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-codi",
      code: "NYSE:CODI",
      companyName: "Compass Diversified",
      popularity: 0,
    },
    {
      slug: "nyse-codi-a",
      code: "NYSE:CODI-A",
      companyName:
        "Compass Diversified Holdings 7.250% Series A Preferred Shares representing beneficial interest in Co",
      popularity: 0,
    },
    {
      slug: "nyse-codi-b",
      code: "NYSE:CODI-B",
      companyName:
        "Compass Diversified Holdings 7.875% Series B Fixed-to-Floating Rate Cumulative Preferred Shares repr",
      popularity: 0,
    },
    {
      slug: "nyse-codi-c",
      code: "NYSE:CODI-C",
      companyName:
        "Compass Diversified Holdings 7.875% Series C Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-codx",
      code: "NYSE:CODX",
      companyName: "Co-Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-coe",
      code: "NYSE:COE",
      companyName:
        "China Online Education Group American depositary shares each representing 15 Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nyse-cof",
      code: "NYSE:COF",
      companyName: "Capital One Financial",
      popularity: 0,
    },
    {
      slug: "nyse-cof-i",
      code: "NYSE:COF-I",
      companyName:
        "Capital One Financial Corporation Depositary shares each representing a 1/40th interest in a share o",
      popularity: 0,
    },
    {
      slug: "nyse-cof-j",
      code: "NYSE:COF-J",
      companyName:
        "Capital One Financial Corporation Depositary Shares Each Representing a 1/40th Interest in a Share",
      popularity: 0,
    },
    {
      slug: "nyse-cof-k",
      code: "NYSE:COF-K",
      companyName:
        "Capital One Financial Corporation Depositary Shares Each Representing a 1/40th Ownership Interest i",
      popularity: 0,
    },
    {
      slug: "nyse-cof-l",
      code: "NYSE:COF-L",
      companyName:
        "Capital One Financial Corporation Depositary Shares Each Representing a 1/40th Interest in a Share",
      popularity: 0,
    },
    {
      slug: "nyse-cof-n",
      code: "NYSE:COF-N",
      companyName:
        "Capital One Financial Corporation Depositary Shares Each Representing a 1/40th Ownership Interest i",
      popularity: 0,
    },
    {
      slug: "nyse-cofs",
      code: "NYSE:COFS",
      companyName: "CHOICEONE FINANCIAL",
      popularity: 0,
    },
    {
      slug: "nyse-cogt",
      code: "NYSE:COGT",
      companyName: "Cogent Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cohn",
      code: "NYSE:COHN",
      companyName: "Cohen & Company Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cohu",
      code: "NYSE:COHU",
      companyName: "Cohu Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cost",
      code: "NYSE:COST",
      companyName: "Costco Wholesale Corp",
      popularity: 0,
    },
    {
      slug: "nyse-colb",
      code: "NYSE:COLB",
      companyName: "Columbia Banking Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cold",
      code: "NYSE:COLD",
      companyName: "Americold Realty Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-coli",
      code: "NYSE:COLI",
      companyName: "Colicity Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-coliu",
      code: "NYSE:COLIU",
      companyName: "Colicity Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-coliw",
      code: "NYSE:COLIW",
      companyName: "Colicity Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-coll",
      code: "NYSE:COLL",
      companyName: "Collegium Pharmaceutical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-colm",
      code: "NYSE:COLM",
      companyName: "Columbia Sportswear Co",
      popularity: 0,
    },
    {
      slug: "nyse-com",
      code: "NYSE:COM",
      companyName: "Direxion Auspice Broad Commodity Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-comb",
      code: "NYSE:COMB",
      companyName:
        "GraniteShares Bloomberg Commodity Broad Strategy No K-1 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-comm",
      code: "NYSE:COMM",
      companyName: "CommScope Holding Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-comp",
      code: "NYSE:COMP",
      companyName: "Compass Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-coms",
      code: "NYSE:COMS",
      companyName: "ComSovereign Holding Corp. Common",
      popularity: 0,
    },
    {
      slug: "nyse-comsp",
      code: "NYSE:COMSP",
      companyName:
        "ComSovereign Holding Corp. 9.25% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-comsw",
      code: "NYSE:COMSW",
      companyName: "ComSovereign Holding Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-comt",
      code: "NYSE:COMT",
      companyName:
        "iShares U.S. ETF Trust iShares GSCI Commodity Dynamic Roll Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-conl",
      code: "NYSE:CONL",
      companyName: "GraniteShares 1.5x Long Coinbase Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-conn",
      code: "NYSE:CONN",
      companyName: "Conn's Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-conx",
      code: "NYSE:CONX",
      companyName: "CONX Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-conxu",
      code: "NYSE:CONXU",
      companyName: "CONX Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-conxw",
      code: "NYSE:CONXW",
      companyName: "CONX Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-coo",
      code: "NYSE:COO",
      companyName: "The Cooper Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cook",
      code: "NYSE:COOK",
      companyName: "Traeger Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cool",
      code: "NYSE:COOL",
      companyName: "Corner Growth Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-coolu",
      code: "NYSE:COOLU",
      companyName: "Corner Growth Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-coolw",
      code: "NYSE:COOLW",
      companyName: "Corner Growth Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-coop",
      code: "NYSE:COOP",
      companyName: "Mr. Cooper Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cop",
      code: "NYSE:COP",
      companyName: "ConocoPhillips",
      popularity: 0,
    },
    {
      slug: "nyse-copx",
      code: "NYSE:COPX",
      companyName: "Global X Copper Miners ETF (NEW)",
      popularity: 0,
    },
    {
      slug: "nyse-corn",
      code: "NYSE:CORN",
      companyName: "Teucrium Corn Fund",
      popularity: 0,
    },
    {
      slug: "nyse-corp",
      code: "NYSE:CORP",
      companyName:
        "PIMCO Investment Grade Corporate Bond Index Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-corr",
      code: "NYSE:CORR",
      companyName: "CorEnergy Infrastructure Trust Inc. (NEW",
      popularity: 0,
    },
    {
      slug: "nyse-corr-a",
      code: "NYSE:CORR-A",
      companyName:
        "CorEnergy Infrastructure Trust Inc Depositary Shares representing a 1/100th fractional interest of",
      popularity: 0,
    },
    {
      slug: "nyse-cors",
      code: "NYSE:CORS",
      companyName: "Corsair Partnering Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cort",
      code: "NYSE:CORT",
      companyName: "Corcept Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-corz",
      code: "NYSE:CORZ",
      companyName: "Core Scientific Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-corzw",
      code: "NYSE:CORZW",
      companyName: "Core Scientific Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cosm",
      code: "NYSE:COSM",
      companyName: "Cosmos Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-coty",
      code: "NYSE:COTY",
      companyName: "COTY INC",
      popularity: 0,
    },
    {
      slug: "nyse-coup",
      code: "NYSE:COUP",
      companyName: "Coupa Software Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-cour",
      code: "NYSE:COUR",
      companyName: "Coursera Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cova",
      code: "NYSE:COVA",
      companyName: "COVA Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-covau",
      code: "NYSE:COVAU",
      companyName: "COVA Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-covaw",
      code: "NYSE:COVAW",
      companyName:
        "COVA Acquisition Corp. Warrants to purchase Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-cow",
      code: "NYSE:COW",
      companyName:
        "iPath Series B Bloomberg Livestock Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-cown",
      code: "NYSE:COWN",
      companyName: "Cowen Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cownl",
      code: "NYSE:COWNL",
      companyName: "Cowen Inc. 7.75% Senior Notes due 2033",
      popularity: 0,
    },
    {
      slug: "nyse-cowz",
      code: "NYSE:COWZ",
      companyName: "Pacer US Cash Cows 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cp",
      code: "NYSE:CP",
      companyName: "Canadian Pacific Railway",
      popularity: 0,
    },
    {
      slug: "nyse-cpa",
      code: "NYSE:CPA",
      companyName: "Copa Holdings S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-cpaa",
      code: "NYSE:CPAA",
      companyName: "Conyers Park III Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cpaau",
      code: "NYSE:CPAAU",
      companyName: "Conyers Park III Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cpaaw",
      code: "NYSE:CPAAW",
      companyName: "Conyers Park III Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-cpac",
      code: "NYSE:CPAC",
      companyName: "CEMENTOS PACASMAYO S.A.A.",
      popularity: 0,
    },
    {
      slug: "nyse-cpaq",
      code: "NYSE:CPAQ",
      companyName:
        "Counter Press Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-cpaqu",
      code: "NYSE:CPAQU",
      companyName: "Counter Press Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cpaqw",
      code: "NYSE:CPAQW",
      companyName: "Counter Press Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cpar",
      code: "NYSE:CPAR",
      companyName: "Catalyst Partners Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-cparu",
      code: "NYSE:CPARU",
      companyName: "Catalyst Partners Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cparw",
      code: "NYSE:CPARW",
      companyName: "Catalyst Partners Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cpb",
      code: "NYSE:CPB",
      companyName: "Campbell Soup Company",
      popularity: 0,
    },
    {
      slug: "nyse-cpe",
      code: "NYSE:CPE",
      companyName: "Callon Petroleum Company",
      popularity: 0,
    },
    {
      slug: "nyse-cper",
      code: "NYSE:CPER",
      companyName: "United States Copper Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cpf",
      code: "NYSE:CPF",
      companyName: "Central Pacific Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cpg",
      code: "NYSE:CPG",
      companyName: "CRESCENT POINT ENERGY CORP.",
      popularity: 0,
    },
    {
      slug: "nyse-cphi",
      code: "NYSE:CPHI",
      companyName: "China Pharma Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cpi",
      code: "NYSE:CPI",
      companyName: "CPI Inflation Hedged ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cpii",
      code: "NYSE:CPII",
      companyName: "Ionic Inflation Protection ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cpix",
      code: "NYSE:CPIX",
      companyName: "Cumberland Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cpk",
      code: "NYSE:CPK",
      companyName: "Chesapeake Utilities",
      popularity: 0,
    },
    {
      slug: "nyse-cplp",
      code: "NYSE:CPLP",
      companyName: "Capital Product Partners L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-cpng",
      code: "NYSE:CPNG",
      companyName: "Coupang Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cpop",
      code: "NYSE:CPOP",
      companyName: "Pop Culture Group Co. Ltd Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cpri",
      code: "NYSE:CPRI",
      companyName: "Capri Holdings Limited",
      popularity: 0,
    },
    {
      slug: "nyse-cprx",
      code: "NYSE:CPRX",
      companyName: "Catalyst Pharmaceutical  Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cps",
      code: "NYSE:CPS",
      companyName: "Cooper-Standard Automotive Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cpsh",
      code: "NYSE:CPSH",
      companyName: "CPS Technologies Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cpsi",
      code: "NYSE:CPSI",
      companyName: "Computer Programs & Systems In",
      popularity: 0,
    },
    {
      slug: "nyse-cpss",
      code: "NYSE:CPSS",
      companyName: "Consumer Portfolio Services",
      popularity: 0,
    },
    {
      slug: "nyse-cpt",
      code: "NYSE:CPT",
      companyName: "Camden Property Trust",
      popularity: 0,
    },
    {
      slug: "nyse-cptk",
      code: "NYSE:CPTK",
      companyName: "Crown PropTech Acquisitions",
      popularity: 0,
    },
    {
      slug: "nyse-cptn",
      code: "NYSE:CPTN",
      companyName: "Cepton Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cptnw",
      code: "NYSE:CPTNW",
      companyName: "Cepton Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cpuh",
      code: "NYSE:CPUH",
      companyName: "Compute Health Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-cpz",
      code: "NYSE:CPZ",
      companyName:
        "Calamos Long/Short Equity & Dynamic Income Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cqp",
      code: "NYSE:CQP",
      companyName: "Cheniere Energy Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-cqqq",
      code: "NYSE:CQQQ",
      companyName: "Invesco China Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cr",
      code: "NYSE:CR",
      companyName: "Crane Holdings Co.",
      popularity: 0,
    },
    {
      slug: "nyse-crai",
      code: "NYSE:CRAI",
      companyName: "CRA International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-crak",
      code: "NYSE:CRAK",
      companyName: "VanEck Oil Refiners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-crbn",
      code: "NYSE:CRBN",
      companyName: "iShares MSCI ACWI Low Carbon Target ETF",
      popularity: 0,
    },
    {
      slug: "nyse-crbp",
      code: "NYSE:CRBP",
      companyName: "Corbus Pharmaceuticals Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-crbu",
      code: "NYSE:CRBU",
      companyName: "Caribou Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crc",
      code: "NYSE:CRC",
      companyName: "California Resources Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-crct",
      code: "NYSE:CRCT",
      companyName: "Cricut Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crdf",
      code: "NYSE:CRDF",
      companyName: "Cardiff Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crdl",
      code: "NYSE:CRDL",
      companyName: "Cardiol Therapeutics Inc. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-crdo",
      code: "NYSE:CRDO",
      companyName: "Credo Technology Group Holding Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-crec",
      code: "NYSE:CREC",
      companyName: "Crescera Capital Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-crecu",
      code: "NYSE:CRECU",
      companyName: "Crescera Capital Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-crecw",
      code: "NYSE:CRECW",
      companyName: "Crescera Capital Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-creg",
      code: "NYSE:CREG",
      companyName: "Smart Powerr Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cresw",
      code: "NYSE:CRESW",
      companyName: "Cresud S.A.C.I.F. y A. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cresy",
      code: "NYSE:CRESY",
      companyName: "Cresud SA",
      popularity: 0,
    },
    {
      slug: "nyse-crex",
      code: "NYSE:CREX",
      companyName: "CREATIVE REALITIES INC.",
      popularity: 0,
    },
    {
      slug: "nyse-crexw",
      code: "NYSE:CREXW",
      companyName: "Creative Realities Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-crf",
      code: "NYSE:CRF",
      companyName: "Cornerstone Total Return Fund Inc",
      popularity: 0,
    },
    {
      slug: "nyse-crge",
      code: "NYSE:CRGE",
      companyName: "Charge Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crhc",
      code: "NYSE:CRHC",
      companyName: "Cohn Robbins Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-cri",
      code: "NYSE:CRI",
      companyName: "Carter's Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cris",
      code: "NYSE:CRIS",
      companyName: "Curis Inc",
      popularity: 0,
    },
    {
      slug: "nyse-crit",
      code: "NYSE:CRIT",
      companyName: "Optica Rare Earths & Critical Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-crk",
      code: "NYSE:CRK",
      companyName: "Comstock Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-crkn",
      code: "NYSE:CRKN",
      companyName: "Crown Electrokinetics Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crl",
      code: "NYSE:CRL",
      companyName: "Charles River Laboratories International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-crgy",
      code: "NYSE:CRGY",
      companyName: "Crescent Energy Company",
      popularity: 0,
    },
    {
      slug: "nyse-crmd",
      code: "NYSE:CRMD",
      companyName: "CorMedix Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-crmt",
      code: "NYSE:CRMT",
      companyName: "America's Car Mart Inc",
      popularity: 0,
    },
    {
      slug: "nyse-crnc",
      code: "NYSE:CRNC",
      companyName: "Cerence Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crnt",
      code: "NYSE:CRNT",
      companyName: "Ceragon Networks Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-crnx",
      code: "NYSE:CRNX",
      companyName: "Crinetics Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cron",
      code: "NYSE:CRON",
      companyName: "Cronos Group Inc. Common Share",
      popularity: 0,
    },
    {
      slug: "nyse-crox",
      code: "NYSE:CROX",
      companyName: "Crocs Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-crpt",
      code: "NYSE:CRPT",
      companyName:
        "First Trust SkyBridge Crypto Industry and Digital Economy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-crs",
      code: "NYSE:CRS",
      companyName: "Carpenter Technology Corp",
      popularity: 0,
    },
    {
      slug: "nyse-crsp",
      code: "NYSE:CRSP",
      companyName: "CRISPR Therapeutics AG",
      popularity: 0,
    },
    {
      slug: "nyse-crsr",
      code: "NYSE:CRSR",
      companyName: "Corsair Gaming Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crt",
      code: "NYSE:CRT",
      companyName: "Cross Timbers Royalty Trust",
      popularity: 0,
    },
    {
      slug: "nyse-crtd",
      code: "NYSE:CRTD",
      companyName: "Creatd Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crtdw",
      code: "NYSE:CRTDW",
      companyName: "Creatd Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-crto",
      code: "NYSE:CRTO",
      companyName: "Criteo S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-cru",
      code: "NYSE:CRU",
      companyName: "Crucible Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-crus",
      code: "NYSE:CRUS",
      companyName: "Cirrus Logic Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cruz",
      code: "NYSE:CRUZ",
      companyName: "Defiance Hotel Airline and Cruise ETF",
      popularity: 0,
    },
    {
      slug: "nyse-crvl",
      code: "NYSE:CRVL",
      companyName: "Corvel Corp",
      popularity: 0,
    },
    {
      slug: "nyse-crvs",
      code: "NYSE:CRVS",
      companyName: "Corvus Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-crwd",
      code: "NYSE:CRWD",
      companyName: "CrowdStrike Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crws",
      code: "NYSE:CRWS",
      companyName: "Crown Crafts Inc",
      popularity: 0,
    },
    {
      slug: "nyse-crxt",
      code: "NYSE:CRXT",
      companyName: "Clarus Therapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-crxtw",
      code: "NYSE:CRXTW",
      companyName: "Clarus Therapeutics Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-crzn",
      code: "NYSE:CRZN",
      companyName:
        "Corazon Capital V838 Monoceros Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-crznu",
      code: "NYSE:CRZNU",
      companyName: "Corazon Capital V838 Monoceros Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-crznw",
      code: "NYSE:CRZNW",
      companyName: "Corazon Capital V838 Monoceros Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cs",
      code: "NYSE:CS",
      companyName: "Credit Suisse Group",
      popularity: 0,
    },
    {
      slug: "nyse-csa",
      code: "NYSE:CSA",
      companyName: "VictoryShares US Small Cap Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-csan",
      code: "NYSE:CSAN",
      companyName:
        "Cosan S.A. American Depositary Shares (each representing four Common Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-csb",
      code: "NYSE:CSB",
      companyName: "VictoryShares US Small Cap High Div Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-csbr",
      code: "NYSE:CSBR",
      companyName: "Champions Oncology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cscw",
      code: "NYSE:CSCW",
      companyName: "Color Star Technology Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-csd",
      code: "NYSE:CSD",
      companyName: "Invesco S&P Spin-Off ETF",
      popularity: 0,
    },
    {
      slug: "nyse-csf",
      code: "NYSE:CSF",
      companyName: "VictoryShares US Discovery Enhanced Volatility Wtd ETF",
      popularity: 0,
    },
    {
      slug: "nyse-csgp",
      code: "NYSE:CSGP",
      companyName: "CoStar Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-csgs",
      code: "NYSE:CSGS",
      companyName: "CSG Systems International",
      popularity: 0,
    },
    {
      slug: "nyse-csh",
      code: "NYSE:CSH",
      companyName: "Morgan Creek - Exos Active SPAC Arbitrage ETF",
      popularity: 0,
    },
    {
      slug: "nyse-csii",
      code: "NYSE:CSII",
      companyName: "Cardiovascular Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-csiq",
      code: "NYSE:CSIQ",
      companyName: "Canadian Solar Inc. Common Shares (BC)",
      popularity: 0,
    },
    {
      slug: "nyse-cslm",
      code: "NYSE:CSLM",
      companyName: "Consilium Acquisition Corp I Ltd. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-cslmr",
      code: "NYSE:CSLMR",
      companyName: "Consilium Acquisition Corp I Ltd. Right",
      popularity: 0,
    },
    {
      slug: "nyse-cslmu",
      code: "NYSE:CSLMU",
      companyName: "Consilium Acquisition Corp I Ltd. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-cslmw",
      code: "NYSE:CSLMW",
      companyName: "Consilium Acquisition Corp I Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-csm",
      code: "NYSE:CSM",
      companyName: "ProShares Large Cap Core Plus",
      popularity: 0,
    },
    {
      slug: "nyse-csml",
      code: "NYSE:CSML",
      companyName: "IQ Chaikin U.S. Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cspi",
      code: "NYSE:CSPI",
      companyName: "CSP Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-csq",
      code: "NYSE:CSQ",
      companyName: "Calamos Strategic Total Return Fund",
      popularity: 0,
    },
    {
      slug: "nyse-csr",
      code: "NYSE:CSR",
      companyName: "Centerspace",
      popularity: 0,
    },
    {
      slug: "nyse-csr-c",
      code: "NYSE:CSR-C",
      companyName:
        "Centerspace 6.625% Series C Cumulative Redeemable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-csse",
      code: "NYSE:CSSE",
      companyName:
        "Chicken Soup for the Soul Entertainment Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cssel",
      code: "NYSE:CSSEL",
      companyName: "Chicken Soup for the Soul Entertainment Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cssen",
      code: "NYSE:CSSEN",
      companyName:
        "Chicken Soup for the Soul Entertainment Inc. 9.50% Notes due 2025",
      popularity: 0,
    },
    {
      slug: "nyse-cssep",
      code: "NYSE:CSSEP",
      companyName:
        "Chicken Soup for the Soul Entertainment Inc. Series A Cumulative Redeemable Perpetual Preferred Sto",
      popularity: 0,
    },
    {
      slug: "nyse-csta",
      code: "NYSE:CSTA",
      companyName: "Constellation Acquisition Corp I",
      popularity: 0,
    },
    {
      slug: "nyse-cste",
      code: "NYSE:CSTE",
      companyName: "Caesarstone Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-cstl",
      code: "NYSE:CSTL",
      companyName: "Castle Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cstm",
      code: "NYSE:CSTM",
      companyName: "Constellium SE Class A Ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-cstr",
      code: "NYSE:CSTR",
      companyName: "CapStar Financial Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-csv",
      code: "NYSE:CSV",
      companyName: "Carriage Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cswc",
      code: "NYSE:CSWC",
      companyName: "Capital Southwest Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cswi",
      code: "NYSE:CSWI",
      companyName: "CSW Industrials Inc",
      popularity: 0,
    },
    {
      slug: "nyse-csx",
      code: "NYSE:CSX",
      companyName: "CSX Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cta",
      code: "NYSE:CTA",
      companyName: "Simplify Managed Futures Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cta-a",
      code: "NYSE:CTA-A",
      companyName:
        "E.I. du Pont de Nemours and Company Preferred Stock $3.50 Series",
      popularity: 0,
    },
    {
      slug: "nyse-cta-b",
      code: "NYSE:CTA-B",
      companyName:
        "E.I. du Pont de Nemours and Company Preferred Stock $4.50 Series",
      popularity: 0,
    },
    {
      slug: "nyse-ctaq",
      code: "NYSE:CTAQ",
      companyName:
        "Carney Technology Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-csco",
      code: "NYSE:CSCO",
      companyName: "Cisco Systems Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-ctaqu",
      code: "NYSE:CTAQU",
      companyName: "Carney Technology Acquisition Corp. II Units",
      popularity: 0,
    },
    {
      slug: "nyse-cube",
      code: "NYSE:CUBE",
      companyName: "CubeSmart",
      popularity: 0,
    },
    {
      slug: "nyse-ctaqw",
      code: "NYSE:CTAQW",
      companyName: "Carney Technology Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ctbb",
      code: "NYSE:CTBB",
      companyName: "Qwest Corporation 6.5% Notes due 2056",
      popularity: 0,
    },
    {
      slug: "nyse-ctbi",
      code: "NYSE:CTBI",
      companyName: "Community Trust Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ctdd",
      code: "NYSE:CTDD",
      companyName: "Qwest Corporation 6.75% Notes due 2057",
      popularity: 0,
    },
    {
      slug: "nyse-ctec",
      code: "NYSE:CTEC",
      companyName: "Global X CleanTech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ctek",
      code: "NYSE:CTEK",
      companyName: "CynergisTek Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ctg",
      code: "NYSE:CTG",
      companyName: "Computer Task Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ctgo",
      code: "NYSE:CTGO",
      companyName: "Contango ORE Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cthr",
      code: "NYSE:CTHR",
      companyName: "Charles & Colvard Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ctib",
      code: "NYSE:CTIB",
      companyName: "Yunhong CTI Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ctic",
      code: "NYSE:CTIC",
      companyName: "CTI BioPharma Corp. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ctkb",
      code: "NYSE:CTKB",
      companyName: "Cytek Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ctlp",
      code: "NYSE:CTLP",
      companyName: "Cantaloupe Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ctlt",
      code: "NYSE:CTLT",
      companyName: "CATALENT INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ctmx",
      code: "NYSE:CTMX",
      companyName: "CytomX Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cto",
      code: "NYSE:CTO",
      companyName: "CTO Realty Growth Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cto-a",
      code: "NYSE:CTO-A",
      companyName:
        "CTO Realty Growth Inc. 6.375% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ctos",
      code: "NYSE:CTOS",
      companyName: "Custom Truck One Source Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ctr",
      code: "NYSE:CTR",
      companyName: "ClearBridge MLP and Midstream Total Return Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ctra",
      code: "NYSE:CTRA",
      companyName: "Coterra Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ctre",
      code: "NYSE:CTRE",
      companyName: "CareTrust REIT Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ctrm",
      code: "NYSE:CTRM",
      companyName: "Castor Maritime Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ctrn",
      code: "NYSE:CTRN",
      companyName: "Citi Trends Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cts",
      code: "NYSE:CTS",
      companyName: "CTS Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ctsh",
      code: "NYSE:CTSH",
      companyName: "Cognizant Technology Solutions",
      popularity: 0,
    },
    {
      slug: "nyse-ctso",
      code: "NYSE:CTSO",
      companyName: "Cytosorbents Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ctt",
      code: "NYSE:CTT",
      companyName: "CATCHMARK TIMBER TRUST INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ctv",
      code: "NYSE:CTV",
      companyName: "Innovid Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ctva",
      code: "NYSE:CTVA",
      companyName: "Corteva Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ctxr",
      code: "NYSE:CTXR",
      companyName: "Citius Pharmaceuticals Inc. Common",
      popularity: 0,
    },
    {
      slug: "nyse-ctxs",
      code: "NYSE:CTXS",
      companyName: "Citrix Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cuba",
      code: "NYSE:CUBA",
      companyName: "Herzfeld Caribbean Basin Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cubb",
      code: "NYSE:CUBB",
      companyName: "Customers Bancorp Inc. 5.375% Subordinated Notes Due 2034",
      popularity: 0,
    },
    {
      slug: "nyse-cubi",
      code: "NYSE:CUBI",
      companyName: "CUSTOMERS BANCORP INC",
      popularity: 0,
    },
    {
      slug: "nyse-cubi-e",
      code: "NYSE:CUBI-E",
      companyName:
        "Customers Bancorp Inc. Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nyse-cubi-f",
      code: "NYSE:CUBI-F",
      companyName:
        "Customers Bancorp Inc  Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nyse-cubs",
      code: "NYSE:CUBS",
      companyName: "Asian Growth Cubs ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cue",
      code: "NYSE:CUE",
      companyName: "Cue Biopharma Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cuen",
      code: "NYSE:CUEN",
      companyName: "Cuentas Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cuenw",
      code: "NYSE:CUENW",
      companyName: "Cuentas Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cuk",
      code: "NYSE:CUK",
      companyName: "Carnival PLC",
      popularity: 0,
    },
    {
      slug: "nyse-cull",
      code: "NYSE:CULL",
      companyName: "Cullman Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-culp",
      code: "NYSE:CULP",
      companyName: "Culp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cure",
      code: "NYSE:CURE",
      companyName: "Direxion Daily Healthcare Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-curi",
      code: "NYSE:CURI",
      companyName: "CuriosityStream Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-curiw",
      code: "NYSE:CURIW",
      companyName: "CuriosityStream Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-curo",
      code: "NYSE:CURO",
      companyName: "CURO Group Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-curv",
      code: "NYSE:CURV",
      companyName: "Torrid Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cut",
      code: "NYSE:CUT",
      companyName: "Invesco MSCI Global Timber ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cutr",
      code: "NYSE:CUTR",
      companyName: "Cutera Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cuz",
      code: "NYSE:CUZ",
      companyName: "Cousins Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cvac",
      code: "NYSE:CVAC",
      companyName: "CureVac N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cvar",
      code: "NYSE:CVAR",
      companyName: "Cultivar ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cvbf",
      code: "NYSE:CVBF",
      companyName: "CVB Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cvco",
      code: "NYSE:CVCO",
      companyName: "Cavco Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cvcy",
      code: "NYSE:CVCY",
      companyName: "Central Valley Community Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-cveo",
      code: "NYSE:CVEO",
      companyName: "Civeo Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cvet",
      code: "NYSE:CVET",
      companyName: "Covetrus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cvgi",
      code: "NYSE:CVGI",
      companyName: "Commercial Vehicle Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cvgw",
      code: "NYSE:CVGW",
      companyName: "Calavo Growers Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cvi",
      code: "NYSE:CVI",
      companyName: "CVR ENERGY INC.",
      popularity: 0,
    },
    {
      slug: "nyse-cvii",
      code: "NYSE:CVII",
      companyName: "Churchill Capital Corp VII",
      popularity: 0,
    },
    {
      slug: "nyse-cvlg",
      code: "NYSE:CVLG",
      companyName: "Covenant Logistics Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cvlt",
      code: "NYSE:CVLT",
      companyName: "Commault Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cvly",
      code: "NYSE:CVLY",
      companyName: "Codorus Valley Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cvm",
      code: "NYSE:CVM",
      companyName: "Cel-Sci Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cvna",
      code: "NYSE:CVNA",
      companyName: "Carvana Co.",
      popularity: 0,
    },
    {
      slug: "nyse-cvr",
      code: "NYSE:CVR",
      companyName: "Chicago Rivet & Machine Co.",
      popularity: 0,
    },
    {
      slug: "nyse-cvrx",
      code: "NYSE:CVRX",
      companyName: "CVRx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cvt",
      code: "NYSE:CVT",
      companyName: "Cvent Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cvv",
      code: "NYSE:CVV",
      companyName: "CVD Equipment Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-cvy",
      code: "NYSE:CVY",
      companyName: "Invesco Zacks Multi-Asset Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cw",
      code: "NYSE:CW",
      companyName: "Curtiss-Wright Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-cwan",
      code: "NYSE:CWAN",
      companyName: "Clearwater Analytics Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cwb",
      code: "NYSE:CWB",
      companyName: "SPDR Bloomberg Convertible Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cwbc",
      code: "NYSE:CWBC",
      companyName: "Community West BanCshares",
      popularity: 0,
    },
    {
      slug: "nyse-cwbr",
      code: "NYSE:CWBR",
      companyName: "CohBar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cwco",
      code: "NYSE:CWCO",
      companyName: "Consolidated Water Co Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cweb",
      code: "NYSE:CWEB",
      companyName: "Direxion Daily CSI China Internet Index Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cwen",
      code: "NYSE:CWEN",
      companyName: "Clearway Energy Inc. Class C Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cwh",
      code: "NYSE:CWH",
      companyName: "Camping World Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cwi",
      code: "NYSE:CWI",
      companyName: "SPDR MSCI ACWI ex-US ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cwk",
      code: "NYSE:CWK",
      companyName: "Cushman & Wakefield plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cws",
      code: "NYSE:CWS",
      companyName: "AdvisorShares Focused Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cwst",
      code: "NYSE:CWST",
      companyName: "Casella Waste Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cwt",
      code: "NYSE:CWT",
      companyName: "California Water Service",
      popularity: 0,
    },
    {
      slug: "nyse-cx",
      code: "NYSE:CX",
      companyName: "Cemex S.A.B. de C.V.",
      popularity: 0,
    },
    {
      slug: "nyse-cxac",
      code: "NYSE:CXAC",
      companyName: "C5 Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-cxdo",
      code: "NYSE:CXDO",
      companyName: "CREXENDO INC",
      popularity: 0,
    },
    {
      slug: "nyse-cxe",
      code: "NYSE:CXE",
      companyName: "MFS High Income Municipal Trust",
      popularity: 0,
    },
    {
      slug: "nyse-cxh",
      code: "NYSE:CXH",
      companyName: "MFS Investment Grade Municipal Trust",
      popularity: 0,
    },
    {
      slug: "nyse-cxm",
      code: "NYSE:CXM",
      companyName: "Sprinklr Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cxse",
      code: "NYSE:CXSE",
      companyName:
        "WisdomTree Trust WisdomTree China ex-State-Owned Enterprises Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cxw",
      code: "NYSE:CXW",
      companyName: "CoreCivic Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cya",
      code: "NYSE:CYA",
      companyName: "Simplify Tail Risk Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-cyad",
      code: "NYSE:CYAD",
      companyName: "Celyad Oncology SA American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cyan",
      code: "NYSE:CYAN",
      companyName: "Cyanotech Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cyb",
      code: "NYSE:CYB",
      companyName: "WisdomTree  Chinese Yuan Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cybe",
      code: "NYSE:CYBE",
      companyName: "Cyberoptics Corp",
      popularity: 0,
    },
    {
      slug: "nyse-cybn",
      code: "NYSE:CYBN",
      companyName: "Cybin Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cybr",
      code: "NYSE:CYBR",
      companyName: "CyberArk Software Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-cycc",
      code: "NYSE:CYCC",
      companyName: "Cyclacel Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-cyccp",
      code: "NYSE:CYCCP",
      companyName: "Cyclacel Pharmaceuticals Inc. 6% Cnvrtbl. Prfrd. Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cycn",
      code: "NYSE:CYCN",
      companyName: "Cyclerion Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cyd",
      code: "NYSE:CYD",
      companyName: "China Yuchai International Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-cyh",
      code: "NYSE:CYH",
      companyName: "Community Health Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cyn",
      code: "NYSE:CYN",
      companyName: "Cyngn Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cyrn",
      code: "NYSE:CYRN",
      companyName: "CYREN Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-cyrx",
      code: "NYSE:CYRX",
      companyName: "CryoPort Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cyt",
      code: "NYSE:CYT",
      companyName: "Cyteir Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cyth",
      code: "NYSE:CYTH",
      companyName: "Cyclo Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cythw",
      code: "NYSE:CYTHW",
      companyName: "Cyclo Therapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-cytk",
      code: "NYSE:CYTK",
      companyName: "Cytokinetics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-cyto",
      code: "NYSE:CYTO",
      companyName: "Altamira Therapeutics Ltd. Common Shares 0.01 SF (Bermuda)",
      popularity: 0,
    },
    {
      slug: "nyse-cyxt",
      code: "NYSE:CYXT",
      companyName: "Cyxtera Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cza",
      code: "NYSE:CZA",
      companyName: "Invesco Zacks Mid-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-czfs",
      code: "NYSE:CZFS",
      companyName: "Citizens Financial Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-cznc",
      code: "NYSE:CZNC",
      companyName: "Citizens & Northern Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-czoo",
      code: "NYSE:CZOO",
      companyName: "Cazoo Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-czr",
      code: "NYSE:CZR",
      companyName: "Caesars Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-czwi",
      code: "NYSE:CZWI",
      companyName: "Citizens Community Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-d",
      code: "NYSE:D",
      companyName: "Dominion Energy Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dac",
      code: "NYSE:DAC",
      companyName: "Danaos Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-dada",
      code: "NYSE:DADA",
      companyName: "Dada Nexus Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-daio",
      code: "NYSE:DAIO",
      companyName: "Data I/O Corp",
      popularity: 0,
    },
    {
      slug: "nyse-dakt",
      code: "NYSE:DAKT",
      companyName: "Daktronics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-dal",
      code: "NYSE:DAL",
      companyName: "Delta Air Lines Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dali",
      code: "NYSE:DALI",
      companyName: "First Trust DorseyWright DALI 1 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-daln",
      code: "NYSE:DALN",
      companyName: "DallasNews Corporation Series A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dals",
      code: "NYSE:DALS",
      companyName:
        "DA32 Life Science Tech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dalt",
      code: "NYSE:DALT",
      companyName: "Anfield Diversified Alternatives ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dam",
      code: "NYSE:DAM",
      companyName: "VanEck Digital Assets Mining ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dan",
      code: "NYSE:DAN",
      companyName: "Dana Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-dao",
      code: "NYSE:DAO",
      companyName:
        "Youdao Inc. American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-daoo",
      code: "NYSE:DAOO",
      companyName: "Crypto 1 Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-daoou",
      code: "NYSE:DAOOU",
      companyName: "Crypto 1 Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-daoow",
      code: "NYSE:DAOOW",
      companyName: "Crypto 1 Acquisition Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-dapp",
      code: "NYSE:DAPP",
      companyName: "VanEck Digital Transformation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dapr",
      code: "NYSE:DAPR",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-dat",
      code: "NYSE:DAT",
      companyName: "ProShares Big Data Refiners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dats",
      code: "NYSE:DATS",
      companyName: "DatChat Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-datsw",
      code: "NYSE:DATSW",
      companyName: "DatChat Inc. Series A Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-daug",
      code: "NYSE:DAUG",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - August",
      popularity: 0,
    },
    {
      slug: "nyse-dava",
      code: "NYSE:DAVA",
      companyName:
        "Endava plc American Depositary Shares (each representing one Class A Ordinary Share)",
      popularity: 0,
    },
    {
      slug: "nyse-dave",
      code: "NYSE:DAVE",
      companyName: "Dave Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-davew",
      code: "NYSE:DAVEW",
      companyName: "Dave Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-dawn",
      code: "NYSE:DAWN",
      companyName: "Day One Biopharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dax",
      code: "NYSE:DAX",
      companyName: "Global X Funds Global X DAX Germany ETF",
      popularity: 0,
    },
    {
      slug: "nyse-db",
      code: "NYSE:DB",
      companyName: "Deutsche Bank Aktiengesellschaft",
      popularity: 0,
    },
    {
      slug: "nyse-dba",
      code: "NYSE:DBA",
      companyName: "Invesco DB Agriculture Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dbaw",
      code: "NYSE:DBAW",
      companyName: "Xtrackers MSCI All World ex US Hedged Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbb",
      code: "NYSE:DBB",
      companyName: "Invesco DB Base Metals Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dbc",
      code: "NYSE:DBC",
      companyName: "Invesco DB Commodity Index Tracking Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dbd",
      code: "NYSE:DBD",
      companyName: "Diebold Nixdorf Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-dbe",
      code: "NYSE:DBE",
      companyName: "Invesco DB Energy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dbef",
      code: "NYSE:DBEF",
      companyName: "Xtrackers MSCI EAFE Hedged Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbeh",
      code: "NYSE:DBEH",
      companyName: "iMGP DBi Hedge Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbem",
      code: "NYSE:DBEM",
      companyName: "Xtrackers MSCI Emerging Markets Hedged Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbeu",
      code: "NYSE:DBEU",
      companyName: "Xtrackers MSCI Europe Hedged Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbez",
      code: "NYSE:DBEZ",
      companyName: "Xtrackers MSCI Eurozone Hedged Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbgi",
      code: "NYSE:DBGI",
      companyName: "Digital Brands Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dbgiw",
      code: "NYSE:DBGIW",
      companyName: "Digital Brands Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dbgr",
      code: "NYSE:DBGR",
      companyName: "Xtrackers MSCI Germany Hedged Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbi",
      code: "NYSE:DBI",
      companyName: "Designer Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dbja",
      code: "NYSE:DBJA",
      companyName: "Innovator Double Stacker 9 Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-dbjp",
      code: "NYSE:DBJP",
      companyName: "Xtrackers MSCI Japan Hedged Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbl",
      code: "NYSE:DBL",
      companyName: "DOUBLELINE OPPORTUNISTIC CREDIT FUND",
      popularity: 0,
    },
    {
      slug: "nyse-dblv",
      code: "NYSE:DBLV",
      companyName: "AdvisorShares DoubleLine Value Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbmf",
      code: "NYSE:DBMF",
      companyName: "iMGP DBi Managed Futures Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbnd",
      code: "NYSE:DBND",
      companyName: "DoubleLine Opportunistic Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dbo",
      code: "NYSE:DBO",
      companyName: "Invesco DB Oil Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dboc",
      code: "NYSE:DBOC",
      companyName: "Innovator Double Stacker 9 Buffer ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-dbp",
      code: "NYSE:DBP",
      companyName: "Invesco DB Precious Metals Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dbrg",
      code: "NYSE:DBRG",
      companyName: "DigitalBridge Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dbrg-h",
      code: "NYSE:DBRG-H",
      companyName:
        "DigitalBridge Group Inc. 7.125% Series H Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dbrg-i",
      code: "NYSE:DBRG-I",
      companyName:
        "DigitalBridge Group Inc. 7.15% Series I Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dbrg-j",
      code: "NYSE:DBRG-J",
      companyName:
        "DigitalBridge Group Inc. 7.125% Series J Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dbs",
      code: "NYSE:DBS",
      companyName: "Invesco DB Silver Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dbtx",
      code: "NYSE:DBTX",
      companyName: "Decibel Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dbv",
      code: "NYSE:DBV",
      companyName: "Invesco DB G10 Currency Harvest Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dbvt",
      code: "NYSE:DBVT",
      companyName: "DBV Technologies S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-dbx",
      code: "NYSE:DBX",
      companyName: "Dropbox Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-dc",
      code: "NYSE:DC",
      companyName: "Dakota Gold Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-dcbo",
      code: "NYSE:DCBO",
      companyName: "Docebo Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dcf",
      code: "NYSE:DCF",
      companyName:
        "BNY Mellon Alcentra Global Credit Income 2024 Target Term Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dcfc",
      code: "NYSE:DCFC",
      companyName: "Tritium DCFC Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dcfcw",
      code: "NYSE:DCFCW",
      companyName: "Tritium DCFC Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dcgo",
      code: "NYSE:DCGO",
      companyName: "DocGo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dcgow",
      code: "NYSE:DCGOW",
      companyName: "DocGo Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-dci",
      code: "NYSE:DCI",
      companyName: "Donaldson Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dco",
      code: "NYSE:DCO",
      companyName: "Ducommun Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-dcom",
      code: "NYSE:DCOM",
      companyName: "Dime Community Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dcomp",
      code: "NYSE:DCOMP",
      companyName:
        "Dime Community Bancshares Inc. Fixed-Rate Non-Cumulative Perpetual Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nyse-dcp",
      code: "NYSE:DCP",
      companyName: "DCP Midstream LP",
      popularity: 0,
    },
    {
      slug: "nyse-dcp-b",
      code: "NYSE:DCP-B",
      companyName:
        "DCP Midstream LP 7.875% Series B Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred U",
      popularity: 0,
    },
    {
      slug: "nyse-dcp-c",
      code: "NYSE:DCP-C",
      companyName:
        "DCP Midstream LP 7.95% Series C Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Un",
      popularity: 0,
    },
    {
      slug: "nyse-dcph",
      code: "NYSE:DCPH",
      companyName: "Deciphera Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dcrd",
      code: "NYSE:DCRD",
      companyName:
        "Decarbonization Plus Acquisition Corporation IV Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-dcrdu",
      code: "NYSE:DCRDU",
      companyName: "Decarbonization Plus Acquisition Corporation IV Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dcth",
      code: "NYSE:DCTH",
      companyName: "Delcath Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ddd",
      code: "NYSE:DDD",
      companyName: "3D Systems Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ddec",
      code: "NYSE:DDEC",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - December",
      popularity: 0,
    },
    {
      slug: "nyse-ddf",
      code: "NYSE:DDF",
      companyName: "Delaware Investments Dividend & Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ddi",
      code: "NYSE:DDI",
      companyName: "DoubleDown Interactive Co. Ltd. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ddiv",
      code: "NYSE:DDIV",
      companyName:
        "First Trust Exchange-Traded Fund VI First Trust Dorsey Wright Momentum & Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ddl",
      code: "NYSE:DDL",
      companyName:
        "Dingdong (Cayman) Limited American Depositary Shares (each two representing three Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-ddls",
      code: "NYSE:DDLS",
      companyName:
        "WisdomTree Dynamic Currency Hedged International SmallCap Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ddm",
      code: "NYSE:DDM",
      companyName: "ProShares Ultra Dow30",
      popularity: 0,
    },
    {
      slug: "nyse-dds",
      code: "NYSE:DDS",
      companyName: "Dillards Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ddt",
      code: "NYSE:DDT",
      companyName: "Dillard's Capital Trust I 7.50% Capital Securities",
      popularity: 0,
    },
    {
      slug: "nyse-ddwm",
      code: "NYSE:DDWM",
      companyName:
        "WisdomTree Dynamic Currency Hedged International Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dea",
      code: "NYSE:DEA",
      companyName: "Easterly Government Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-deca",
      code: "NYSE:DECA",
      companyName: "Denali Capital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-decau",
      code: "NYSE:DECAU",
      companyName: "Denali Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-decaw",
      code: "NYSE:DECAW",
      companyName: "Denali Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-decz",
      code: "NYSE:DECZ",
      companyName: "TrueShares Structured Outcome (December) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-deed",
      code: "NYSE:DEED",
      companyName: "First Trust TCW Securitized Plus ETF",
      popularity: 0,
    },
    {
      slug: "nyse-deef",
      code: "NYSE:DEEF",
      companyName: "Xtrackers FTSE Developed ex US Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-deep",
      code: "NYSE:DEEP",
      companyName: "Roundhill Acquirers Deep Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-def",
      code: "NYSE:DEF",
      companyName: "Invesco Defensive Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dehp",
      code: "NYSE:DEHP",
      companyName: "Dimensional Emerging Markets High Profitability ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dei",
      code: "NYSE:DEI",
      companyName: "Douglas Emmett Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-deif",
      code: "NYSE:DEIF",
      companyName: "Sterling Capital Diverse Multi-Manager Active ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dem",
      code: "NYSE:DEM",
      companyName: "WisdomTree Emerging Markets High Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-demz",
      code: "NYSE:DEMZ",
      companyName:
        "The Advisors' Inner Circle Fund III Democratic Large Cap Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-den",
      code: "NYSE:DEN",
      companyName: "Denbury Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-denn",
      code: "NYSE:DENN",
      companyName: "DENNY'S CORP",
      popularity: 0,
    },
    {
      slug: "nyse-derm",
      code: "NYSE:DERM",
      companyName: "Journey Medical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-des",
      code: "NYSE:DES",
      companyName: "WisdomTree U.S. SmallCap Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-desp",
      code: "NYSE:DESP",
      companyName: "Despegar.com Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-deus",
      code: "NYSE:DEUS",
      companyName: "Xtrackers Russell US Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dew",
      code: "NYSE:DEW",
      companyName: "WisdomTree Global High Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dex",
      code: "NYSE:DEX",
      companyName: "DELAWARE ENHANCED GLOBAL DIVIDEND & INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-dfac",
      code: "NYSE:DFAC",
      companyName: "Dimensional U.S. Core Equity 2 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfae",
      code: "NYSE:DFAE",
      companyName: "Dimensional Emerging Core Equity Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfai",
      code: "NYSE:DFAI",
      companyName: "Dimensional International Core Equity Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfar",
      code: "NYSE:DFAR",
      companyName: "Dimensional US Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfas",
      code: "NYSE:DFAS",
      companyName: "Dimensional U.S. Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfat",
      code: "NYSE:DFAT",
      companyName: "Dimensional U.S. Targeted Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfau",
      code: "NYSE:DFAU",
      companyName: "Dimensional US Core Equity Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfax",
      code: "NYSE:DFAX",
      companyName: "Dimensional World ex U.S. Core Equity 2 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfcf",
      code: "NYSE:DFCF",
      companyName: "Dimensional Core Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfe",
      code: "NYSE:DFE",
      companyName: "WisdomTree Europe SmallCap Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dfeb",
      code: "NYSE:DFEB",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - February",
      popularity: 0,
    },
    {
      slug: "nyse-dfem",
      code: "NYSE:DFEM",
      companyName: "Dimensional Emerging Markets Core Equity 2 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfen",
      code: "NYSE:DFEN",
      companyName: "Direxion Daily Aerospace & Defense Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dfev",
      code: "NYSE:DFEV",
      companyName: "Dimensional Emerging Markets Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dffn",
      code: "NYSE:DFFN",
      companyName: "DIFFUSION PHARMACEUTICALS INC",
      popularity: 0,
    },
    {
      slug: "nyse-dfh",
      code: "NYSE:DFH",
      companyName: "Dream Finders Homes Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dfhy",
      code: "NYSE:DFHY",
      companyName: "Donoghue Forlines Tactical High Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfic",
      code: "NYSE:DFIC",
      companyName: "Dimensional International Core Equity 2 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfin",
      code: "NYSE:DFIN",
      companyName: "Donnelley Financial Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-deo",
      code: "NYSE:DEO",
      companyName: "Diageo plc",
      popularity: 0,
    },
    {
      slug: "nyse-deck",
      code: "NYSE:DECK",
      companyName: "Deckers Outdoor Corp",
      popularity: 0,
    },
    {
      slug: "nyse-dfip",
      code: "NYSE:DFIP",
      companyName: "Dimensional Inflation-Protected Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfis",
      code: "NYSE:DFIS",
      companyName: "Dimensional International Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfnd",
      code: "NYSE:DFND",
      companyName: "Siren DIVCON Dividend Defender ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfnl",
      code: "NYSE:DFNL",
      companyName: "Davis Select Financial ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfnm",
      code: "NYSE:DFNM",
      companyName: "Dimensional National Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfnv",
      code: "NYSE:DFNV",
      companyName: "Donoghue Forlines Risk Managed Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfp",
      code: "NYSE:DFP",
      companyName:
        "FLAHERTY & CRUMRINE DYNAMIC PREFERRED AND INCOME FUND INCORPORATED",
      popularity: 0,
    },
    {
      slug: "nyse-dfra",
      code: "NYSE:DFRA",
      companyName: "Donoghue Forlines Yield Enhanced Real Asset ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfs",
      code: "NYSE:DFS",
      companyName: "Discover Financial Services",
      popularity: 0,
    },
    {
      slug: "nyse-dfsd",
      code: "NYSE:DFSD",
      companyName: "Dimensional Short-Duration Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfsv",
      code: "NYSE:DFSV",
      companyName: "Dimensional US Small Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfus",
      code: "NYSE:DFUS",
      companyName: "Dimensional U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfuv",
      code: "NYSE:DFUV",
      companyName: "Dimensional US Marketwide Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dghi",
      code: "NYSE:DGHI",
      companyName: "Digihost Technology Inc. Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dgica",
      code: "NYSE:DGICA",
      companyName: "Donegal Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-dgicb",
      code: "NYSE:DGICB",
      companyName: "Donegal Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-dgii",
      code: "NYSE:DGII",
      companyName: "Digi International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-dgin",
      code: "NYSE:DGIN",
      companyName: "VanEck Digital India ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dgl",
      code: "NYSE:DGL",
      companyName: "Invesco DB Gold Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dgly",
      code: "NYSE:DGLY",
      companyName: "Digital Ally Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dgnu",
      code: "NYSE:DGNU",
      companyName:
        "Dragoneer Growth Opportunities Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dgp",
      code: "NYSE:DGP",
      companyName: "DB Gold Double Long ETN due February 15 2038",
      popularity: 0,
    },
    {
      slug: "nyse-dgre",
      code: "NYSE:DGRE",
      companyName:
        "WisdomTree Trust WisdomTree Emerging Markets Quality Dividend Growth Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dgro",
      code: "NYSE:DGRO",
      companyName: "iShares Core Dividend Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dgrs",
      code: "NYSE:DGRS",
      companyName:
        "WisdomTree Trust WisdomTree U.S. SmallCap Quality Dividend Growth Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dgrw",
      code: "NYSE:DGRW",
      companyName:
        "WisdomTree Trust WisdomTree U.S. Quality Dividend Growth Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dgs",
      code: "NYSE:DGS",
      companyName: "WisdomTree Emerging Markets SmallCap Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dgt",
      code: "NYSE:DGT",
      companyName: "SPDR Global Dow ETF (based on The Global Dow)",
      popularity: 0,
    },
    {
      slug: "nyse-dgx",
      code: "NYSE:DGX",
      companyName: "Quest Diagnostics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dgz",
      code: "NYSE:DGZ",
      companyName: "DB Gold Short ETN due February 15 2038",
      popularity: 0,
    },
    {
      slug: "nyse-dh",
      code: "NYSE:DH",
      companyName: "Definitive Healthcare Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dhac",
      code: "NYSE:DHAC",
      companyName: "Digital Health Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dhacu",
      code: "NYSE:DHACU",
      companyName: "Digital Health Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dhacw",
      code: "NYSE:DHACW",
      companyName: "Digital Health Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dhbc",
      code: "NYSE:DHBC",
      companyName: "DHB Capital Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-dhbcu",
      code: "NYSE:DHBCU",
      companyName: "DHB Capital Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dhbcw",
      code: "NYSE:DHBCW",
      companyName: "DHB Capital Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dhc",
      code: "NYSE:DHC",
      companyName:
        "Diversified Healthcare Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-dhca",
      code: "NYSE:DHCA",
      companyName: "DHC Acquisition Corp. Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nyse-dhcau",
      code: "NYSE:DHCAU",
      companyName: "DHC Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dhcaw",
      code: "NYSE:DHCAW",
      companyName: "DHC Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dhcni",
      code: "NYSE:DHCNI",
      companyName: "Diversified Healthcare Trust 5.625% Senior Notes due 2042",
      popularity: 0,
    },
    {
      slug: "nyse-dhcnl",
      code: "NYSE:DHCNL",
      companyName: "Diversified Healthcare Trust 6.25% Senior Notes Due 2046",
      popularity: 0,
    },
    {
      slug: "nyse-dhf",
      code: "NYSE:DHF",
      companyName: "BNY Mellon High Yield Strategies Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dhhc",
      code: "NYSE:DHHC",
      companyName: "DiamondHead Holdings Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dhhcu",
      code: "NYSE:DHHCU",
      companyName: "DiamondHead Holdings Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dhhcw",
      code: "NYSE:DHHCW",
      companyName: "DiamondHead Holdings Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dhil",
      code: "NYSE:DHIL",
      companyName: "Diamond Hill Investment Group",
      popularity: 0,
    },
    {
      slug: "nyse-dhr-b",
      code: "NYSE:DHR-B",
      companyName:
        "Danaher Corporation 5.00% Mandatory Convertible Preferred Stock Series B",
      popularity: 0,
    },
    {
      slug: "nyse-dht",
      code: "NYSE:DHT",
      companyName: "DHT HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-dhx",
      code: "NYSE:DHX",
      companyName: "DHI Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dhy",
      code: "NYSE:DHY",
      companyName: "Credit Suisse High Yield Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dia",
      code: "NYSE:DIA",
      companyName: "SPDR Dow Jones Industrial Average ETF Trust",
      popularity: 0,
    },
    {
      slug: "nyse-dial",
      code: "NYSE:DIAL",
      companyName: "Columbia Diversified Fixed Income Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-diax",
      code: "NYSE:DIAX",
      companyName: "NUVEEN DOW 30SM DYNAMIC OVERWRITE FUND",
      popularity: 0,
    },
    {
      slug: "nyse-dibs",
      code: "NYSE:DIBS",
      companyName: "1stdibs.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dice",
      code: "NYSE:DICE",
      companyName: "DICE Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-diem",
      code: "NYSE:DIEM",
      companyName: "Franklin Emerging Market Core Dividend Tilt Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dig",
      code: "NYSE:DIG",
      companyName: "ProShares Ultra Oil & Gas",
      popularity: 0,
    },
    {
      slug: "nyse-dila",
      code: "NYSE:DILA",
      companyName: "DILA Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dhs",
      code: "NYSE:DHS",
      companyName: "WisdomTree U.S. High Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dilaw",
      code: "NYSE:DILAW",
      companyName: "DILA Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dim",
      code: "NYSE:DIM",
      companyName: "WisdomTree International MidCap Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-din",
      code: "NYSE:DIN",
      companyName: "Dine Brands Global Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dino",
      code: "NYSE:DINO",
      companyName: "HF Sinclair Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-dint",
      code: "NYSE:DINT",
      companyName: "Davis Select International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-diod",
      code: "NYSE:DIOD",
      companyName: "Diodes Inc",
      popularity: 0,
    },
    {
      slug: "nyse-dks",
      code: "NYSE:DKS",
      companyName: "Dick's Sporting Goods Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-disa",
      code: "NYSE:DISA",
      companyName:
        "Disruptive Acquisition Corporation I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-disau",
      code: "NYSE:DISAU",
      companyName: "Disruptive Acquisition Corporation I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-disaw",
      code: "NYSE:DISAW",
      companyName: "Disruptive Acquisition Corporation I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dish",
      code: "NYSE:DISH",
      companyName: "DISH Network Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-disv",
      code: "NYSE:DISV",
      companyName: "Dimensional International Small Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dit",
      code: "NYSE:DIT",
      companyName: "AMCON Distributing Co.",
      popularity: 0,
    },
    {
      slug: "nyse-div",
      code: "NYSE:DIV",
      companyName: "Global X SuperDividend U.S. ETF",
      popularity: 0,
    },
    {
      slug: "nyse-divb",
      code: "NYSE:DIVB",
      companyName: "iShares U.S. Dividend and Buyback ETF",
      popularity: 0,
    },
    {
      slug: "nyse-divi",
      code: "NYSE:DIVI",
      companyName: "Franklin International Core Dividend Tilt Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-divo",
      code: "NYSE:DIVO",
      companyName: "Amplify CWP Enhanced Dividend Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-divs",
      code: "NYSE:DIVS",
      companyName: "SmartETFs Dividend Builder ETF",
      popularity: 0,
    },
    {
      slug: "nyse-divz",
      code: "NYSE:DIVZ",
      companyName: "TrueShares Low Volatility Equity Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-djan",
      code: "NYSE:DJAN",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-djcb",
      code: "NYSE:DJCB",
      companyName:
        "ETRACS Bloomberg Commodity Index Total Return ETN Series B due October 31 2039",
      popularity: 0,
    },
    {
      slug: "nyse-djco",
      code: "NYSE:DJCO",
      companyName: "Daily Journal Corp",
      popularity: 0,
    },
    {
      slug: "nyse-djd",
      code: "NYSE:DJD",
      companyName: "Invesco Dow Jones Industrial Average Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-djp",
      code: "NYSE:DJP",
      companyName:
        "iPath Bloomberg Commodity Index Total Return ETN due June 12 2036",
      popularity: 0,
    },
    {
      slug: "nyse-djul",
      code: "NYSE:DJUL",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-djun",
      code: "NYSE:DJUN",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - June",
      popularity: 0,
    },
    {
      slug: "nyse-dk",
      code: "NYSE:DK",
      companyName: "Delek US Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dkdca",
      code: "NYSE:DKDCA",
      companyName: "Data Knights Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dkdcu",
      code: "NYSE:DKDCU",
      companyName: "Data Knights Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dkdcw",
      code: "NYSE:DKDCW",
      companyName: "Data Knights Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dkl",
      code: "NYSE:DKL",
      companyName: "DELEK LOGISTICS PARTNERS LP",
      popularity: 0,
    },
    {
      slug: "nyse-dkng",
      code: "NYSE:DKNG",
      companyName: "DraftKings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dla",
      code: "NYSE:DLA",
      companyName: "Delta Apparel Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dlb",
      code: "NYSE:DLB",
      companyName: "Dolby Laboratories Inc.Class A",
      popularity: 0,
    },
    {
      slug: "nyse-dlca",
      code: "NYSE:DLCA",
      companyName:
        "Deep Lake Capital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dlcau",
      code: "NYSE:DLCAU",
      companyName: "Deep Lake Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dlcaw",
      code: "NYSE:DLCAW",
      companyName: "Deep Lake Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dlhc",
      code: "NYSE:DLHC",
      companyName: "DLH Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-dln",
      code: "NYSE:DLN",
      companyName: "WisdomTree U.S. LargeCap Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dlng",
      code: "NYSE:DLNG",
      companyName: "DYNAGAS LNG PARNERS LP",
      popularity: 0,
    },
    {
      slug: "nyse-dlng-a",
      code: "NYSE:DLNG-A",
      companyName:
        "Dynagas LNG Partners LP 9.00% Series A Cumulative Redeemable Preferred Units liquidation preference",
      popularity: 0,
    },
    {
      slug: "nyse-dlng-b",
      code: "NYSE:DLNG-B",
      companyName:
        "Dynagas LNG Partners LP 8.75% Series B Fixed to Floating Rate Cumulative Redeemable Perpetual Prefer",
      popularity: 0,
    },
    {
      slug: "nyse-dlo",
      code: "NYSE:DLO",
      companyName: "DLocal Limited Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dlpn",
      code: "NYSE:DLPN",
      companyName: "Dolphin Entertainment Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dlr",
      code: "NYSE:DLR",
      companyName: "Digital Realty Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dlr-j",
      code: "NYSE:DLR-J",
      companyName:
        "Digital Realty Trust Inc. 5.250% Series J Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dlr-k",
      code: "NYSE:DLR-K",
      companyName:
        "Digital Realty Trust Inc. 5.850% Series K Cumulative Redeemable Preferred Stock par value $0.01 pe",
      popularity: 0,
    },
    {
      slug: "nyse-dlr-l",
      code: "NYSE:DLR-L",
      companyName:
        "Digital Realty Trust Inc. 5.200% Series L Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dls",
      code: "NYSE:DLS",
      companyName: "WisdomTree International SmallCap Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dlth",
      code: "NYSE:DLTH",
      companyName: "Duluth Holdings Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dltr",
      code: "NYSE:DLTR",
      companyName: "Dollar Tree Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dlx",
      code: "NYSE:DLX",
      companyName: "Deluxe Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-dly",
      code: "NYSE:DLY",
      companyName: "DoubleLine Yield Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dm",
      code: "NYSE:DM",
      companyName: "Desktop Metal Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dma",
      code: "NYSE:DMA",
      companyName: "Destra Multi-Alternative Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dmac",
      code: "NYSE:DMAC",
      companyName: "DiaMedica Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dmaq",
      code: "NYSE:DMAQ",
      companyName: "Deep Medicine Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dmaqr",
      code: "NYSE:DMAQR",
      companyName: "Deep Medicine Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-dmar",
      code: "NYSE:DMAR",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - March",
      popularity: 0,
    },
    {
      slug: "nyse-dmat",
      code: "NYSE:DMAT",
      companyName: "Global X Disruptive Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-djia",
      code: "NYSE:DJIA",
      companyName: "Global X Dow 30 Covered Call ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dmay",
      code: "NYSE:DMAY",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - May",
      popularity: 0,
    },
    {
      slug: "nyse-dmb",
      code: "NYSE:DMB",
      companyName: "BNY Mellon Municipal Bond Infrastructure Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dmcy",
      code: "NYSE:DMCY",
      companyName: "Democracy International Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dmdv",
      code: "NYSE:DMDV",
      companyName: "AAM S& P Developed Markets High Dividend Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dmf",
      code: "NYSE:DMF",
      companyName: "BNY Mellon Municipal Income Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dmlp",
      code: "NYSE:DMLP",
      companyName: "Dorchester Minerals LP",
      popularity: 0,
    },
    {
      slug: "nyse-dmo",
      code: "NYSE:DMO",
      companyName: "Western Asset Mortgage Opportunity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dmrc",
      code: "NYSE:DMRC",
      companyName: "Digimarc Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-dms",
      code: "NYSE:DMS",
      companyName: "Digital Media Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dmtk",
      code: "NYSE:DMTK",
      companyName: "DermTech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dmxf",
      code: "NYSE:DMXF",
      companyName: "iShares ESG Advanced MSCI EAFE ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dmys",
      code: "NYSE:DMYS",
      companyName: "dMY Technology Group Inc. VI",
      popularity: 0,
    },
    {
      slug: "nyse-docu",
      code: "NYSE:DOCU",
      companyName: "DocuSign Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dnab",
      code: "NYSE:DNAB",
      companyName:
        "Social Capital Suvretta Holdings Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dnad",
      code: "NYSE:DNAD",
      companyName:
        "Social Capital Suvretta Holdings Corp. IV Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dnay",
      code: "NYSE:DNAY",
      companyName: "Codex DNA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dnb",
      code: "NYSE:DNB",
      companyName: "Dun & Bradstreet Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dnl",
      code: "NYSE:DNL",
      companyName: "WisdomTree Global ex-US Quality Dividend Growth Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dnli",
      code: "NYSE:DNLI",
      companyName: "Denali Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dnmr",
      code: "NYSE:DNMR",
      companyName: "Danimer Scientific Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dnn",
      code: "NYSE:DNN",
      companyName: "Denison Mines Corp",
      popularity: 0,
    },
    {
      slug: "nyse-dnov",
      code: "NYSE:DNOV",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - November",
      popularity: 0,
    },
    {
      slug: "nyse-dnow",
      code: "NYSE:DNOW",
      companyName: "NOW INC.",
      popularity: 0,
    },
    {
      slug: "nyse-dnp",
      code: "NYSE:DNP",
      companyName: "DNP Select Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dnut",
      code: "NYSE:DNUT",
      companyName: "Krispy Kreme Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dnz",
      code: "NYSE:DNZ",
      companyName: "D and Z Media Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-do",
      code: "NYSE:DO",
      companyName: "Diamond Offshore Drilling Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-doc",
      code: "NYSE:DOC",
      companyName: "PHYSICIANS REALTY TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-docn",
      code: "NYSE:DOCN",
      companyName: "DigitalOcean Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-docs",
      code: "NYSE:DOCS",
      companyName: "Doximity Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-doct",
      code: "NYSE:DOCT",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-dog",
      code: "NYSE:DOG",
      companyName: "ProShares Short Dow30",
      popularity: 0,
    },
    {
      slug: "nyse-dogz",
      code: "NYSE:DOGZ",
      companyName: "Dogness (International) Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dol",
      code: "NYSE:DOL",
      companyName: "WisdomTree International LargeCap Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dole",
      code: "NYSE:DOLE",
      companyName: "Dole plc",
      popularity: 0,
    },
    {
      slug: "nyse-doma",
      code: "NYSE:DOMA",
      companyName: "Doma Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-domo",
      code: "NYSE:DOMO",
      companyName: "Domo Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-don",
      code: "NYSE:DON",
      companyName: "WisdomTree U.S. MidCap Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dooo",
      code: "NYSE:DOOO",
      companyName: "BRP Inc. Common Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-door",
      code: "NYSE:DOOR",
      companyName: "MASONITE INTERNATIONAL CORP",
      popularity: 0,
    },
    {
      slug: "nyse-dorm",
      code: "NYSE:DORM",
      companyName: "Dorman Products Inc. New",
      popularity: 0,
    },
    {
      slug: "nyse-doug",
      code: "NYSE:DOUG",
      companyName: "Douglas Elliman Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dov",
      code: "NYSE:DOV",
      companyName: "Dover Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-dow",
      code: "NYSE:DOW",
      companyName: "Dow Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dox",
      code: "NYSE:DOX",
      companyName: "Amdocs Limited",
      popularity: 0,
    },
    {
      slug: "nyse-doyu",
      code: "NYSE:DOYU",
      companyName: "DouYu International Holdings Limited ADS",
      popularity: 0,
    },
    {
      slug: "nyse-dozr",
      code: "NYSE:DOZR",
      companyName: "Direxion Daily US Infrastructure Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dpcs",
      code: "NYSE:DPCS",
      companyName: "DP Cap Acquisition Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dpcsu",
      code: "NYSE:DPCSU",
      companyName: "DP Cap Acquisition Corp I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dpcsw",
      code: "NYSE:DPCSW",
      companyName: "DP Cap Acquisition Corp I Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-dpg",
      code: "NYSE:DPG",
      companyName: "Duff & Phelps Utility and Infrastructure Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dpro",
      code: "NYSE:DPRO",
      companyName: "Draganfly Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dpsi",
      code: "NYSE:DPSI",
      companyName: "DecisionPoint Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dpz",
      code: "NYSE:DPZ",
      companyName: "Domino's Pizza Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dq",
      code: "NYSE:DQ",
      companyName:
        "Daqo New Energy Corp. American Depositary Shares (each representing 5 Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-dray",
      code: "NYSE:DRAY",
      companyName:
        "Macondray Capital Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-drayu",
      code: "NYSE:DRAYU",
      companyName: "Macondray Capital Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-drayw",
      code: "NYSE:DRAYW",
      companyName: "Macondray Capital Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-drct",
      code: "NYSE:DRCT",
      companyName: "Direct Digital Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-drctw",
      code: "NYSE:DRCTW",
      companyName: "Direct Digital Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-drd",
      code: "NYSE:DRD",
      companyName: "DRDGOLD Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-dre",
      code: "NYSE:DRE",
      companyName: "Duke Realty Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-drh-a",
      code: "NYSE:DRH-A",
      companyName:
        "DiamondRock Hospitality Company 8.250% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dri",
      code: "NYSE:DRI",
      companyName: "Darden Restaurants Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-drio",
      code: "NYSE:DRIO",
      companyName: "DarioHealth Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-drip",
      code: "NYSE:DRIP",
      companyName: "Direxion Daily S&P Oil & Gas Exp. & Prod. Bear 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-driv",
      code: "NYSE:DRIV",
      companyName: "Global X Autonomous & Electric Vehicles ETF",
      popularity: 0,
    },
    {
      slug: "nyse-drll",
      code: "NYSE:DRLL",
      companyName: "Strive U.S. Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-drma",
      code: "NYSE:DRMA",
      companyName: "Dermata Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-drmaw",
      code: "NYSE:DRMAW",
      companyName: "Dermata Therapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-drn",
      code: "NYSE:DRN",
      companyName: "Direxion Daily Real Estate Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-drrx",
      code: "NYSE:DRRX",
      companyName: "Durect Corp",
      popularity: 0,
    },
    {
      slug: "nyse-drsk",
      code: "NYSE:DRSK",
      companyName: "Aptus Defined Risk ETF",
      popularity: 0,
    },
    {
      slug: "nyse-drts",
      code: "NYSE:DRTS",
      companyName: "Alpha Tau Medical Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-drtsw",
      code: "NYSE:DRTSW",
      companyName: "Alpha Tau Medical Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-drtt",
      code: "NYSE:DRTT",
      companyName: "DIRTT Environmental Solutions Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-drug",
      code: "NYSE:DRUG",
      companyName: "Bright Minds Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-drv",
      code: "NYSE:DRV",
      companyName: "Direxion Daily Real Estate Bear 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-drvn",
      code: "NYSE:DRVN",
      companyName: "Driven Brands Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ds",
      code: "NYSE:DS",
      companyName: "Drive Shack Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ds-b",
      code: "NYSE:DS-B",
      companyName:
        "Drive Shack Inc. Series B 9.75% Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ds-c",
      code: "NYSE:DS-C",
      companyName:
        "Drive Shack Inc. 8.05% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ds-d",
      code: "NYSE:DS-D",
      companyName:
        "Drive Shack Inc. 8.375% Series D Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dsaq",
      code: "NYSE:DSAQ",
      companyName: "Direct Selling Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-dscf",
      code: "NYSE:DSCF",
      companyName: "Discipline Fund ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dsep",
      code: "NYSE:DSEP",
      companyName: "FT Cboe Vest U.S. Equity Deep Buffer ETF - September",
      popularity: 0,
    },
    {
      slug: "nyse-dsey",
      code: "NYSE:DSEY",
      companyName: "Diversey Holdings Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dsgn",
      code: "NYSE:DSGN",
      companyName: "Design Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dsgr",
      code: "NYSE:DSGR",
      companyName: "Distribution Solutions Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dsgx",
      code: "NYSE:DSGX",
      companyName: "Descartes Systems Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-dsi",
      code: "NYSE:DSI",
      companyName: "iShares MSCI KLD 400 Social ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dsja",
      code: "NYSE:DSJA",
      companyName: "Innovator Double Stacker ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-dske",
      code: "NYSE:DSKE",
      companyName: "Daseke Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dsl",
      code: "NYSE:DSL",
      companyName: "DOUBLELINE INCOME SOLUTIONS FUND",
      popularity: 0,
    },
    {
      slug: "nyse-dsm",
      code: "NYSE:DSM",
      companyName: "BNY Mellon Strategic Municipal Bond Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dsoc",
      code: "NYSE:DSOC",
      companyName: "Innovator Double Stacker ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-dsp",
      code: "NYSE:DSP",
      companyName: "Viant Technology Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dspc",
      code: "NYSE:DSPC",
      companyName: "AXS De-SPAC ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dss",
      code: "NYSE:DSS",
      companyName: "DSS Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dstl",
      code: "NYSE:DSTL",
      companyName: "Distillate U.S. Fundamental Stability & Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dstx",
      code: "NYSE:DSTX",
      companyName: "Distillate International Fundamental Stability & Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dsu",
      code: "NYSE:DSU",
      companyName: "Blackrock Debt Strategies Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dswl",
      code: "NYSE:DSWL",
      companyName: "Deswell Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-dsx",
      code: "NYSE:DSX",
      companyName: "Diana Shipping Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dsx-b",
      code: "NYSE:DSX-B",
      companyName:
        "DIANA SHIPPING INC 8.875% Series B Cumulative Redeemable Perpetual Preferred Shares $0.01 par value",
      popularity: 0,
    },
    {
      slug: "nyse-dt",
      code: "NYSE:DT",
      companyName: "Dynatrace Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dtb",
      code: "NYSE:DTB",
      companyName:
        "DTE Energy Company 2020 Series G 4.375% Junior Subordinated Debentures due 2080",
      popularity: 0,
    },
    {
      slug: "nyse-dtc",
      code: "NYSE:DTC",
      companyName: "Solo Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dtd",
      code: "NYSE:DTD",
      companyName: "WisdomTree U.S. Total Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dte",
      code: "NYSE:DTE",
      companyName: "DTE Energy Company",
      popularity: 0,
    },
    {
      slug: "nyse-dtea",
      code: "NYSE:DTEA",
      companyName: "DAVIDsTEA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dtec",
      code: "NYSE:DTEC",
      companyName: "ALPS Disruptive Technologies ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dtf",
      code: "NYSE:DTF",
      companyName: "DTF Tax-Free Income 2028 Term Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dtg",
      code: "NYSE:DTG",
      companyName:
        "DTE Energy Company 2021 Series E 4.375% Junior Subordinated Debentures",
      popularity: 0,
    },
    {
      slug: "nyse-dth",
      code: "NYSE:DTH",
      companyName: "WisdomTree International High Dividend  Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dtil",
      code: "NYSE:DTIL",
      companyName: "Precision BioSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dtla-",
      code: "NYSE:DTLA-",
      companyName: "BROOKFIELD DTLA FUND OFFICE TRUST INVESTOR INC.",
      popularity: 0,
    },
    {
      slug: "nyse-dtm",
      code: "NYSE:DTM",
      companyName: "DT Midstream Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dtoc",
      code: "NYSE:DTOC",
      companyName:
        "Digital Transformation Opportunities Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dtocu",
      code: "NYSE:DTOCU",
      companyName: "Digital Transformation Opportunities Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-dtocw",
      code: "NYSE:DTOCW",
      companyName: "Digital Transformation Opportunities Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dtox",
      code: "NYSE:DTOX",
      companyName: "Amplify Cleaner Living ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dtp",
      code: "NYSE:DTP",
      companyName: "DTE Energy Company 2019 Corporate Units",
      popularity: 0,
    },
    {
      slug: "nyse-dtrt",
      code: "NYSE:DTRT",
      companyName: "DTRT Health Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dtrtu",
      code: "NYSE:DTRTU",
      companyName: "DTRT Health Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dtrtw",
      code: "NYSE:DTRTW",
      companyName: "DTRT Health Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dtss",
      code: "NYSE:DTSS",
      companyName: "Datasea Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ecvt",
      code: "NYSE:ECVT",
      companyName: "Ecovyst Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dtst",
      code: "NYSE:DTST",
      companyName: "Data Storage Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dtstw",
      code: "NYSE:DTSTW",
      companyName: "Data Storage Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dtw",
      code: "NYSE:DTW",
      companyName:
        "DTE Energy Company 2017 Series E 5.25% Junior Subordinated Debentures due 2077",
      popularity: 0,
    },
    {
      slug: "nyse-dude",
      code: "NYSE:DUDE",
      companyName: "Merlyn.AI SectorSurfer Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-duet",
      code: "NYSE:DUET",
      companyName: "DUET Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-duetu",
      code: "NYSE:DUETU",
      companyName: "DUET Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-duetw",
      code: "NYSE:DUETW",
      companyName: "DUET Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dug",
      code: "NYSE:DUG",
      companyName: "ProShares UltraShort Oil & Gas",
      popularity: 0,
    },
    {
      slug: "nyse-duhp",
      code: "NYSE:DUHP",
      companyName: "Dimensional US High Profitability ETF",
      popularity: 0,
    },
    {
      slug: "nyse-duk",
      code: "NYSE:DUK",
      companyName: "Duke Energy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-duk-a",
      code: "NYSE:DUK-A",
      companyName:
        "Duke Energy Corporation Depositary Shares each representing a 1/1000th interest in a share of 5.75",
      popularity: 0,
    },
    {
      slug: "nyse-dukb",
      code: "NYSE:DUKB",
      companyName:
        "Duke Energy Corporation 5.625% Junior Subordinated Debentures due 2078",
      popularity: 0,
    },
    {
      slug: "nyse-dune",
      code: "NYSE:DUNE",
      companyName: "Dune Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-duneu",
      code: "NYSE:DUNEU",
      companyName: "Dune Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-dunew",
      code: "NYSE:DUNEW",
      companyName: "Dune Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-duo",
      code: "NYSE:DUO",
      companyName: "Fangdd Network Group Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-duol",
      code: "NYSE:DUOL",
      companyName: "Duolingo Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-duot",
      code: "NYSE:DUOT",
      companyName: "Duos Technologies Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dura",
      code: "NYSE:DURA",
      companyName: "VanEck Morningstar Durable Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dusa",
      code: "NYSE:DUSA",
      companyName: "Davis Select U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dusl",
      code: "NYSE:DUSL",
      companyName: "Direxion Daily Industrials Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dust",
      code: "NYSE:DUST",
      companyName: "Direxion Daily Gold Miners Index Bear 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-dv",
      code: "NYSE:DV",
      companyName: "DoubleVerify Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dva",
      code: "NYSE:DVA",
      companyName: "DaVita Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dvax",
      code: "NYSE:DVAX",
      companyName: "Dynavax Technologies Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-dvlu",
      code: "NYSE:DVLU",
      companyName: "First Trust Dorsey Wright Momentum & Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dvn",
      code: "NYSE:DVN",
      companyName: "Devon Energy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-dvnd",
      code: "NYSE:DVND",
      companyName: "Touchstone Dividend Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dvol",
      code: "NYSE:DVOL",
      companyName: "First Trust Dorsey Wright Momentum & Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dvy",
      code: "NYSE:DVY",
      companyName: "iShares Select Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dvya",
      code: "NYSE:DVYA",
      companyName: "iShares Asia/Pacific Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dvye",
      code: "NYSE:DVYE",
      companyName: "iShares Emerging Markets Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwac",
      code: "NYSE:DWAC",
      companyName: "Digital World Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dwacu",
      code: "NYSE:DWACU",
      companyName: "Digital World Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-dwacw",
      code: "NYSE:DWACW",
      companyName: "Digital World Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-dwas",
      code: "NYSE:DWAS",
      companyName: "Invesco DWA SmallCap Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwat",
      code: "NYSE:DWAT",
      companyName: "Arrow Investments Trust Arrow DWA Tactical ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwaw",
      code: "NYSE:DWAW",
      companyName: "AdvisorShares Dorsey Wright FSM All Cap World ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwcr",
      code: "NYSE:DWCR",
      companyName: "Arrow DWA Country Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dweq",
      code: "NYSE:DWEQ",
      companyName: "AdvisorShares Dorsey Wright Alpha Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwin",
      code: "NYSE:DWIN",
      companyName: "Delwinds Insurance Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-dwld",
      code: "NYSE:DWLD",
      companyName: "Davis Select Worldwide ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwm",
      code: "NYSE:DWM",
      companyName: "WisdomTree International Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dwmc",
      code: "NYSE:DWMC",
      companyName: "AdvisorShares Dorsey Wright Micro-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwmf",
      code: "NYSE:DWMF",
      companyName: "WisdomTree International Multifactor Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dwpp",
      code: "NYSE:DWPP",
      companyName: "First Trust Dorsey Wright People's Portfolio ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwsh",
      code: "NYSE:DWSH",
      companyName: "AdvisorShares Dorsey Wright Short ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwsn",
      code: "NYSE:DWSN",
      companyName: "Dawson Geophysical Company New Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dwus",
      code: "NYSE:DWUS",
      companyName: "AdvisorShares Dorsey Wright FSM US Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dwx",
      code: "NYSE:DWX",
      companyName: "SPDR S&P International Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dx",
      code: "NYSE:DX",
      companyName: "Dynex Capital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dx-c",
      code: "NYSE:DX-C",
      companyName:
        "Dynex Capital Inc. 6.900% Series C Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dxc",
      code: "NYSE:DXC",
      companyName: "DXC Technology Company",
      popularity: 0,
    },
    {
      slug: "nyse-dxd",
      code: "NYSE:DXD",
      companyName: "ProShares UltraShort Dow 30",
      popularity: 0,
    },
    {
      slug: "nyse-dxf",
      code: "NYSE:DXF",
      companyName: "Dunxin Financial Holdings Limited",
      popularity: 0,
    },
    {
      slug: "nyse-dxge",
      code: "NYSE:DXGE",
      companyName: "WisdomTree Germany Hedged Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dxj",
      code: "NYSE:DXJ",
      companyName: "WisdomTree Japan Hedged Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dxjs",
      code: "NYSE:DXJS",
      companyName: "WisdomTree Japan Hedged SmallCap Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dxlg",
      code: "NYSE:DXLG",
      companyName: "Destination XL Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dxr",
      code: "NYSE:DXR",
      companyName: "Daxor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dy",
      code: "NYSE:DY",
      companyName: "Dycom Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dyai",
      code: "NYSE:DYAI",
      companyName: "Dyadic International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dyld",
      code: "NYSE:DYLD",
      companyName: "LeaderShares Dynamic Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dyn",
      code: "NYSE:DYN",
      companyName: "Dyne Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dynf",
      code: "NYSE:DYNF",
      companyName: "BlackRock U.S. Equity Factor Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dynt",
      code: "NYSE:DYNT",
      companyName: "Dynatronics Corp",
      popularity: 0,
    },
    {
      slug: "nyse-dzsi",
      code: "NYSE:DZSI",
      companyName: "DZS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dzz",
      code: "NYSE:DZZ",
      companyName: "DB Gold Double Short ETN due February 15 2038",
      popularity: 0,
    },
    {
      slug: "nyse-e",
      code: "NYSE:E",
      companyName: "ENI S.p.A.",
      popularity: 0,
    },
    {
      slug: "nyse-ea",
      code: "NYSE:EA",
      companyName: "Electronic Arts Inc",
      popularity: 0,
    },
    {
      slug: "nyse-eac",
      code: "NYSE:EAC",
      companyName: "Edify Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eacpu",
      code: "NYSE:EACPU",
      companyName: "Edify Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-eacpw",
      code: "NYSE:EACPW",
      companyName: "Edify Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ead",
      code: "NYSE:EAD",
      companyName: "Allspring Income Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-eaf",
      code: "NYSE:EAF",
      companyName: "GrafTech International Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-eafd",
      code: "NYSE:EAFD",
      companyName: "Simplify Developed Ex-US PLUS Downside Convexity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eagg",
      code: "NYSE:EAGG",
      companyName: "iShares ESG Aware U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eai",
      code: "NYSE:EAI",
      companyName:
        "Entergy Arkansas LLC First Mortgage Bonds 4.875% Series due September 1 2066",
      popularity: 0,
    },
    {
      slug: "nyse-eaoa",
      code: "NYSE:EAOA",
      companyName: "iShares ESG Aware Aggressive Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eaok",
      code: "NYSE:EAOK",
      companyName: "iShares ESG Aware Conservative Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eaom",
      code: "NYSE:EAOM",
      companyName: "iShares ESG Aware Moderate Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eaor",
      code: "NYSE:EAOR",
      companyName: "iShares ESG Aware Growth Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eapr",
      code: "NYSE:EAPR",
      companyName: "Innovator Emerging Markets Power Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-ear",
      code: "NYSE:EAR",
      companyName: "Eargo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-earn",
      code: "NYSE:EARN",
      companyName: "ELLINGTON RESIDENTIAL MORTGAGE REIT",
      popularity: 0,
    },
    {
      slug: "nyse-easg",
      code: "NYSE:EASG",
      companyName: "Xtrackers MSCI EAFE ESG Leaders Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-east",
      code: "NYSE:EAST",
      companyName: "EASTSIDE DISTILLING  INC.",
      popularity: 0,
    },
    {
      slug: "nyse-eat",
      code: "NYSE:EAT",
      companyName: "Brinker International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eatv",
      code: "NYSE:EATV",
      companyName: "VegTech Plant-based Innovation & Climate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eatz",
      code: "NYSE:EATZ",
      companyName: "AdvisorShares Restaurant ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eb",
      code: "NYSE:EB",
      companyName: "Eventbrite Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ebac",
      code: "NYSE:EBAC",
      companyName: "European Biotech Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ebacu",
      code: "NYSE:EBACU",
      companyName: "European Biotech Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-ebacw",
      code: "NYSE:EBACW",
      companyName: "European Biotech Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ebay",
      code: "NYSE:EBAY",
      companyName: "eBay Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ebc",
      code: "NYSE:EBC",
      companyName: "Eastern Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ebet",
      code: "NYSE:EBET",
      companyName: "EBET INC. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ebf",
      code: "NYSE:EBF",
      companyName: "Ennis Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ebix",
      code: "NYSE:EBIX",
      companyName: "Ebix Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ebiz",
      code: "NYSE:EBIZ",
      companyName: "Global X E-commerce ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eblu",
      code: "NYSE:EBLU",
      companyName: "Ecofin Global Water ESG Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ebmt",
      code: "NYSE:EBMT",
      companyName: "Eagle Bancorp Montana Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ebnd",
      code: "NYSE:EBND",
      companyName: "SPDR Bloomberg Emerging Markets Local Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ebon",
      code: "NYSE:EBON",
      companyName: "Ebang International Holdings Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ebr",
      code: "NYSE:EBR",
      companyName:
        "Centrais El‚tricas Brasileiras S.A.- Eletrobr s American Depositary Shares (Each representing one Co",
      popularity: 0,
    },
    {
      slug: "nyse-ebs",
      code: "NYSE:EBS",
      companyName: "Emergent Biosolutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ebtc",
      code: "NYSE:EBTC",
      companyName: "Enterprise Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ec",
      code: "NYSE:EC",
      companyName: "Ecopetrol S.A",
      popularity: 0,
    },
    {
      slug: "nyse-ecat",
      code: "NYSE:ECAT",
      companyName: "BlackRock ESG Capital Allocation Trust",
      popularity: 0,
    },
    {
      slug: "nyse-ecbk",
      code: "NYSE:ECBK",
      companyName: "ECB Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ecc",
      code: "NYSE:ECC",
      companyName: "EAGLE POINT CREDIT COMPANY INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ecc-d",
      code: "NYSE:ECC-D",
      companyName:
        "Eagle Point Credit Company Inc. 6.75% Series D Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eccc",
      code: "NYSE:ECCC",
      companyName:
        "Eagle Point Credit Company Inc. 6.50% Series C Term Preferred Stock due 2031",
      popularity: 0,
    },
    {
      slug: "nyse-eccv",
      code: "NYSE:ECCV",
      companyName: "Eagle Point Credit Company Inc. 5.375% Notes due 2029",
      popularity: 0,
    },
    {
      slug: "nyse-eccw",
      code: "NYSE:ECCW",
      companyName: "Eagle Point Credit Company Inc .6.75% Notes due 2031",
      popularity: 0,
    },
    {
      slug: "nyse-eccx",
      code: "NYSE:ECCX",
      companyName: "Eagle Point Credit Company Inc. 6.6875% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-ecf",
      code: "NYSE:ECF",
      companyName: "Ellsworth Growth and Income Fund Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ecf-a",
      code: "NYSE:ECF-A",
      companyName:
        "Ellsworth Growth and Income Fund Ltd. 5.25 percent Series A Cumulative Preferred Shares (Liquidation",
      popularity: 0,
    },
    {
      slug: "nyse-ech",
      code: "NYSE:ECH",
      companyName: "iShares MSCI Chile ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ecln",
      code: "NYSE:ECLN",
      companyName: "First Trust EIP Carbon Impact ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ecns",
      code: "NYSE:ECNS",
      companyName: "iShares MSCI China Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ecom",
      code: "NYSE:ECOM",
      companyName: "CHANNELADVISOR CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-econ",
      code: "NYSE:ECON",
      companyName: "Columbia Emerging Markets Consumer ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ecor",
      code: "NYSE:ECOR",
      companyName: "electroCore Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ecow",
      code: "NYSE:ECOW",
      companyName: "Pacer Emerging Markets Cash Cows 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ecoz",
      code: "NYSE:ECOZ",
      companyName: "TrueShares ESG Active Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ecpg",
      code: "NYSE:ECPG",
      companyName: "Encore Capital Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ed",
      code: "NYSE:ED",
      companyName: "Consolidated Edison Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-edap",
      code: "NYSE:EDAP",
      companyName: "EDAP TMS SA",
      popularity: 0,
    },
    {
      slug: "nyse-edbl",
      code: "NYSE:EDBL",
      companyName: "Edible Garden AG Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-edblw",
      code: "NYSE:EDBLW",
      companyName: "Edible Garden AG Incorporated Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-edc",
      code: "NYSE:EDC",
      companyName:
        "Direxion Daily Emerging Markets Bull 3X Shares Shares of beneficial interest no par value",
      popularity: 0,
    },
    {
      slug: "nyse-edd",
      code: "NYSE:EDD",
      companyName: "Morgan Stanley Emerging Markets Domestic Debt Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eden",
      code: "NYSE:EDEN",
      companyName: "iShares MSCI Denmark ETF",
      popularity: 0,
    },
    {
      slug: "nyse-edf",
      code: "NYSE:EDF",
      companyName: "Virtus Stone Harbor Emerging Markets Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-edi",
      code: "NYSE:EDI",
      companyName: "Virtus Stone Harbor Emerging Markets Total Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-edit",
      code: "NYSE:EDIT",
      companyName: "Editas Medicine Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ediv",
      code: "NYSE:EDIV",
      companyName: "SPDR S&P Emerging Markets Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-edn",
      code: "NYSE:EDN",
      companyName:
        "Empresa Distribuidora Y Comercializadora Norte S.A. (Edenor)",
      popularity: 0,
    },
    {
      slug: "nyse-ednc",
      code: "NYSE:EDNC",
      companyName: "Endurance Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-edncu",
      code: "NYSE:EDNCU",
      companyName: "Endurance Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-edncw",
      code: "NYSE:EDNCW",
      companyName: "Endurance Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-edoc",
      code: "NYSE:EDOC",
      companyName: "Global X Telemedicine & Digital Health ETF",
      popularity: 0,
    },
    {
      slug: "nyse-edog",
      code: "NYSE:EDOG",
      companyName: "ALPS Emerging Sector Dividend Dogs ETF",
      popularity: 0,
    },
    {
      slug: "nyse-edow",
      code: "NYSE:EDOW",
      companyName: "First Trust Dow 30 Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-edr",
      code: "NYSE:EDR",
      companyName: "Endeavor Group Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-edry",
      code: "NYSE:EDRY",
      companyName: "EuroDry Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-edsa",
      code: "NYSE:EDSA",
      companyName: "Edesa Biotech Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-edtk",
      code: "NYSE:EDTK",
      companyName:
        "Skillful Craftsman Education Technology Limited Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-edtx",
      code: "NYSE:EDTX",
      companyName: "EdtechX Holdings Acquisition Corp. II Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-edtxu",
      code: "NYSE:EDTXU",
      companyName: "EdtechX Holdings Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-edtxw",
      code: "NYSE:EDTXW",
      companyName: "EdtechX Holdings Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-edu",
      code: "NYSE:EDU",
      companyName:
        "New Oriental Education and Technology Group Inc. American Depositary Shares (each representing ten ",
      popularity: 0,
    },
    {
      slug: "nyse-educ",
      code: "NYSE:EDUC",
      companyName: "Educational Development Corp",
      popularity: 0,
    },
    {
      slug: "nyse-edut",
      code: "NYSE:EDUT",
      companyName: "Global X Education ETF",
      popularity: 0,
    },
    {
      slug: "nyse-edz",
      code: "NYSE:EDZ",
      companyName: "Direxion Daily Emerging Markets Bear 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ee",
      code: "NYSE:EE",
      companyName: "Excelerate Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eea",
      code: "NYSE:EEA",
      companyName: "The European Equity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eeft",
      code: "NYSE:EEFT",
      companyName: "Euronet Worldwide Inc",
      popularity: 0,
    },
    {
      slug: "nyse-eeiq",
      code: "NYSE:EEIQ",
      companyName: "Elite Education Group International Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eelv",
      code: "NYSE:EELV",
      companyName: "Invesco S&P Emerging Markets Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eem",
      code: "NYSE:EEM",
      companyName: "iShares MSCI Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eema",
      code: "NYSE:EEMA",
      companyName: "iShares MSCI Emerging Markets Asia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eemd",
      code: "NYSE:EEMD",
      companyName: "AAM S&P Emerging Markets High Dividend Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eemo",
      code: "NYSE:EEMO",
      companyName: "Invesco S&P Emerging Markets Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eems",
      code: "NYSE:EEMS",
      companyName: "iShares MSCI Emerging Markets Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eemv",
      code: "NYSE:EEMV",
      companyName: "iShares MSCI Emerging Markets Min Vol Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eemx",
      code: "NYSE:EEMX",
      companyName: "SPDR MSCI Emerging Markets Fossil Fuel Reserves Free ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eern",
      code: "NYSE:EERN",
      companyName: "DriveWealth Power Saver ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ees",
      code: "NYSE:EES",
      companyName: "WisdomTree U.S. SmallCap Fund",
      popularity: 0,
    },
    {
      slug: "nyse-eet",
      code: "NYSE:EET",
      companyName: "ProShares Ultra MSCI Emerging Markets",
      popularity: 0,
    },
    {
      slug: "nyse-eev",
      code: "NYSE:EEV",
      companyName: "ProShares Trust UltraShort MSCI Emerging Markets",
      popularity: 0,
    },
    {
      slug: "nyse-eex",
      code: "NYSE:EEX",
      companyName: "Emerald Holding Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-efa",
      code: "NYSE:EFA",
      companyName: "iShares MSCI EAFE ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efad",
      code: "NYSE:EFAD",
      companyName: "ProShares MSCI EAFE Dividend Growers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efas",
      code: "NYSE:EFAS",
      companyName: "Global X MSCI SuperDividend EAFE ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efav",
      code: "NYSE:EFAV",
      companyName: "iShares MSCI EAFE Min Vol Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efax",
      code: "NYSE:EFAX",
      companyName: "SPDR MSCI EAFE Fossil Fuel Reserves Free ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efc",
      code: "NYSE:EFC",
      companyName: "Ellington Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-efc-a",
      code: "NYSE:EFC-A",
      companyName:
        "Ellington Financial Inc. 6.750% Series A Fixed-to-Floating Rate Cumulative Redeemable Preferred Stoc",
      popularity: 0,
    },
    {
      slug: "nyse-efc-b",
      code: "NYSE:EFC-B",
      companyName:
        "Ellington Financial Inc. 6.250% Series B Fixed-Rate Reset Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-efg",
      code: "NYSE:EFG",
      companyName: "iShares MSCI EAFE Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efiv",
      code: "NYSE:EFIV",
      companyName: "SPDR S&P 500 ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efnl",
      code: "NYSE:EFNL",
      companyName: "iShares MSCI Finland ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efoi",
      code: "NYSE:EFOI",
      companyName: "Energy Focus Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-efr",
      code: "NYSE:EFR",
      companyName: "Eaton Vance Senior Floating-Rate Fund",
      popularity: 0,
    },
    {
      slug: "nyse-efsc",
      code: "NYSE:EFSC",
      companyName: "Enterprise Financial Services Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-efscp",
      code: "NYSE:EFSCP",
      companyName:
        "Enterprise Financial Services Corporation Depositary Shares Each Representing a 1/40th Interest in a",
      popularity: 0,
    },
    {
      slug: "nyse-efsh",
      code: "NYSE:EFSH",
      companyName: "1847 Holdings LLC",
      popularity: 0,
    },
    {
      slug: "nyse-el",
      code: "NYSE:EL",
      companyName: "The Estee Lauder Companies Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-eft",
      code: "NYSE:EFT",
      companyName: "Eaton Vance Floating-Rate Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-eftr",
      code: "NYSE:EFTR",
      companyName: "eFFECTOR Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eftrw",
      code: "NYSE:EFTRW",
      companyName: "eFFECTOR Therapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-efu",
      code: "NYSE:EFU",
      companyName: "ProShares Trust UltraShort MSCI EAFE",
      popularity: 0,
    },
    {
      slug: "nyse-efv",
      code: "NYSE:EFV",
      companyName: "iShares MSCI EAFE Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efz",
      code: "NYSE:EFZ",
      companyName: "ProShares Trust Short MSCI EAFE",
      popularity: 0,
    },
    {
      slug: "nyse-egan",
      code: "NYSE:EGAN",
      companyName: "eGain Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-egbn",
      code: "NYSE:EGBN",
      companyName: "Eagle Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-egf",
      code: "NYSE:EGF",
      companyName: "Blackrock Enhanced Government Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eggf",
      code: "NYSE:EGGF",
      companyName: "EG Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-eght",
      code: "NYSE:EGHT",
      companyName: "8x8 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-egio",
      code: "NYSE:EGIO",
      companyName: "Edgio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-egis",
      code: "NYSE:EGIS",
      companyName: "2ndVote Society Defended ETF",
      popularity: 0,
    },
    {
      slug: "nyse-egle",
      code: "NYSE:EGLE",
      companyName: "Eagle Bulk Shipping Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eglx",
      code: "NYSE:EGLX",
      companyName: "Enthusiast Gaming Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ego",
      code: "NYSE:EGO",
      companyName: "Eldorado Gold Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-egp",
      code: "NYSE:EGP",
      companyName: "EastGroup Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-egpt",
      code: "NYSE:EGPT",
      companyName: "VanEck Egypt Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-egrx",
      code: "NYSE:EGRX",
      companyName: "Eagle Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-egy",
      code: "NYSE:EGY",
      companyName: "Vaalco Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eh",
      code: "NYSE:EH",
      companyName: "EHang Holdings Limited ADS",
      popularity: 0,
    },
    {
      slug: "nyse-ehab",
      code: "NYSE:EHAB",
      companyName: "Enhabit Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ehc",
      code: "NYSE:EHC",
      companyName: "Encompass Health Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ehi",
      code: "NYSE:EHI",
      companyName: "Western Asset Global High Income Fund Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ehth",
      code: "NYSE:EHTH",
      companyName: "eHealth Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eic",
      code: "NYSE:EIC",
      companyName: "Eagle Point Income Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eica",
      code: "NYSE:EICA",
      companyName:
        "Eagle Point Income Company Inc. 5.00% Series A Term Preferred Stock due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-eido",
      code: "NYSE:EIDO",
      companyName: "iShares MSCI Indonesia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eig",
      code: "NYSE:EIG",
      companyName: "Employers Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eigr",
      code: "NYSE:EIGR",
      companyName: "Eiger BioPharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eim",
      code: "NYSE:EIM",
      companyName: "Eaton Vance Municipal Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-einc",
      code: "NYSE:EINC",
      companyName: "VanEck Energy Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eirl",
      code: "NYSE:EIRL",
      companyName: "iShares MSCI Ireland ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eis",
      code: "NYSE:EIS",
      companyName: "iShares MSCI Israel ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ejan",
      code: "NYSE:EJAN",
      companyName: "Innovator Emerging Markets Power Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-ejh",
      code: "NYSE:EJH",
      companyName: "E-Home Household Service Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ejul",
      code: "NYSE:EJUL",
      companyName: "Innovator Emerging Markets Power Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-ekar",
      code: "NYSE:EKAR",
      companyName:
        "Capital Link Global Green Energy Transport and Technology Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ekg",
      code: "NYSE:EKG",
      companyName: "First Trust Nasdaq Lux Digital Health Solutions ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ekso",
      code: "NYSE:EKSO",
      companyName: "Ekso Bionics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ela",
      code: "NYSE:ELA",
      companyName: "Envela Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-elan",
      code: "NYSE:ELAN",
      companyName: "Elanco Animal Health Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-elat",
      code: "NYSE:ELAT",
      companyName:
        "Elanco Animal Health Incorporated 5.00% Tangible Equity Units",
      popularity: 0,
    },
    {
      slug: "nyse-elbm",
      code: "NYSE:ELBM",
      companyName: "Electra Battery Materials Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-elc",
      code: "NYSE:ELC",
      companyName:
        "Entergy Louisiana LLC Collateral Trust Mortgage Bonds 4.875 % Series due September 1 2066",
      popularity: 0,
    },
    {
      slug: "nyse-eld",
      code: "NYSE:ELD",
      companyName: "WisdomTree Emerging Markets Local Debt Fund",
      popularity: 0,
    },
    {
      slug: "nyse-eldn",
      code: "NYSE:ELDN",
      companyName: "Eledon Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-elev",
      code: "NYSE:ELEV",
      companyName: "Elevation Oncology Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-elf",
      code: "NYSE:ELF",
      companyName: "e.l.f. Beauty Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ello",
      code: "NYSE:ELLO",
      companyName: "Ellomay Capital LTD",
      popularity: 0,
    },
    {
      slug: "nyse-elmd",
      code: "NYSE:ELMD",
      companyName: "Electromed Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-elox",
      code: "NYSE:ELOX",
      companyName: "Eloxx Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-elp",
      code: "NYSE:ELP",
      companyName:
        "Companhia Paranaense de Energia  American Depositary Shares (each representing one Unit consisting o",
      popularity: 0,
    },
    {
      slug: "nyse-elqd",
      code: "NYSE:ELQD",
      companyName: "iShares ESG Advanced Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-els",
      code: "NYSE:ELS",
      companyName: "Equity Lifestyle Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-else",
      code: "NYSE:ELSE",
      companyName: "Electro-Sensors Inc",
      popularity: 0,
    },
    {
      slug: "nyse-eltk",
      code: "NYSE:ELTK",
      companyName: "Eltek Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-elv",
      code: "NYSE:ELV",
      companyName: "Elevance Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-elvt",
      code: "NYSE:ELVT",
      companyName: "Elevate Credit Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ely",
      code: "NYSE:ELY",
      companyName: "Callaway Golf Company",
      popularity: 0,
    },
    {
      slug: "nyse-elym",
      code: "NYSE:ELYM",
      companyName: "Eliem Therapeutics Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-efx",
      code: "NYSE:EFX",
      companyName: "Equifax Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-elys",
      code: "NYSE:ELYS",
      companyName: "Elys Game Technology Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-em",
      code: "NYSE:EM",
      companyName: "Smart Share Global Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-eman",
      code: "NYSE:EMAN",
      companyName: "eMagin Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-emb",
      code: "NYSE:EMB",
      companyName: "iShares J.P. Morgan USD Emerging Markets Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-embc",
      code: "NYSE:EMBC",
      companyName: "Embecta Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-embd",
      code: "NYSE:EMBD",
      companyName: "Global X Emerging Markets Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-embh",
      code: "NYSE:EMBH",
      companyName: "iShares Interest Rate Hedged Emerging Markets Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-embk",
      code: "NYSE:EMBK",
      companyName: "Embark Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-embkw",
      code: "NYSE:EMBKW",
      companyName: "Embark Technology Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-emcb",
      code: "NYSE:EMCB",
      companyName: "WisdomTree Emerging Markets Corporate Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-emcf",
      code: "NYSE:EMCF",
      companyName: "Emclaire Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-emcgu",
      code: "NYSE:EMCGU",
      companyName: "Embrace Change Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-emcr",
      code: "NYSE:EMCR",
      companyName:
        "Xtrackers Emerging Markets Carbon Reduction and Climate Improvers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emd",
      code: "NYSE:EMD",
      companyName: "Western Asset Emerging Markets Debt Fund Inc",
      popularity: 0,
    },
    {
      slug: "nyse-emdv",
      code: "NYSE:EMDV",
      companyName: "ProShares MSCI Emerging Markets Dividend Growers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eme",
      code: "NYSE:EME",
      companyName: "EMCOR Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-emf",
      code: "NYSE:EMF",
      companyName: "Templeton Emerging Markets Fund",
      popularity: 0,
    },
    {
      slug: "nyse-emfm",
      code: "NYSE:EMFM",
      companyName: "Global X MSCI Next Emerging & Frontier ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emfq",
      code: "NYSE:EMFQ",
      companyName: "Amplify Emerging Markets FinTech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emgd",
      code: "NYSE:EMGD",
      companyName:
        "Simplify Emerging Markets Equity PLUS Downside Convexity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emgf",
      code: "NYSE:EMGF",
      companyName: "iShares MSCI Emerging Markets Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emhc",
      code: "NYSE:EMHC",
      companyName: "SPDR Bloomberg Emerging Markets USD Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emif",
      code: "NYSE:EMIF",
      companyName: "iShares Emerging Markets Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emkr",
      code: "NYSE:EMKR",
      companyName: "Emcore Corp",
      popularity: 0,
    },
    {
      slug: "nyse-eml",
      code: "NYSE:EML",
      companyName: "Eastern Company",
      popularity: 0,
    },
    {
      slug: "nyse-emlc",
      code: "NYSE:EMLC",
      companyName: "VanEck J. P. Morgan EM Local Currency Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emld",
      code: "NYSE:EMLD",
      companyName: "FTAC Emerald Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-emldu",
      code: "NYSE:EMLDU",
      companyName: "FTAC Emerald Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-emldw",
      code: "NYSE:EMLDW",
      companyName: "FTAC Emerald Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-emlp",
      code: "NYSE:EMLP",
      companyName: "First Trust North American Energy Infrastructure Fund",
      popularity: 0,
    },
    {
      slug: "nyse-emmf",
      code: "NYSE:EMMF",
      companyName: "WisdomTree Emerging Markets Multifactor Fund",
      popularity: 0,
    },
    {
      slug: "nyse-emn",
      code: "NYSE:EMN",
      companyName: "Eastman Chemical Company",
      popularity: 0,
    },
    {
      slug: "nyse-emnt",
      code: "NYSE:EMNT",
      companyName: "PIMCO Enhanced Short Maturity Active ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emo",
      code: "NYSE:EMO",
      companyName: "ClearBridge Energy Midstream Opportunity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-emp",
      code: "NYSE:EMP",
      companyName:
        "Entergy Mississippi LLC First Mortgage Bonds 4.90% Series due October 1 2066",
      popularity: 0,
    },
    {
      slug: "nyse-emqq",
      code: "NYSE:EMQQ",
      companyName: "EMQQ The Emerging Markets Internet & Ecommerce ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emr",
      code: "NYSE:EMR",
      companyName: "Emerson Electric Co.",
      popularity: 0,
    },
    {
      slug: "nyse-emsg",
      code: "NYSE:EMSG",
      companyName: "Xtrackers MSCI Emerging Markets ESG Leaders Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emtl",
      code: "NYSE:EMTL",
      companyName: "SPDR DoubleLine Emerging Markets Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emty",
      code: "NYSE:EMTY",
      companyName: "ProShares Decline of the Retail Store ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emx",
      code: "NYSE:EMX",
      companyName: "EMX Royalty Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-emxc",
      code: "NYSE:EMXC",
      companyName: "iShares MSCI Emerging Markets ex China ETF",
      popularity: 0,
    },
    {
      slug: "nyse-emxf",
      code: "NYSE:EMXF",
      companyName: "iShares ESG Advanced MSCI EM ETF",
      popularity: 0,
    },
    {
      slug: "nyse-enb",
      code: "NYSE:ENB",
      companyName: "Enbridge Inc",
      popularity: 0,
    },
    {
      slug: "nyse-enba",
      code: "NYSE:ENBA",
      companyName:
        "Enbridge Inc. 6.375% Fixed-to-Floating Rate Subordinated Notes Series 2018-B due 2078",
      popularity: 0,
    },
    {
      slug: "nyse-encp",
      code: "NYSE:ENCP",
      companyName: "Energem Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-encpu",
      code: "NYSE:ENCPU",
      companyName: "Energem Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-encpw",
      code: "NYSE:ENCPW",
      companyName: "Energem Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-endp",
      code: "NYSE:ENDP",
      companyName: "Endo International plc",
      popularity: 0,
    },
    {
      slug: "nyse-ener",
      code: "NYSE:ENER",
      companyName: "Accretion Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-enerr",
      code: "NYSE:ENERR",
      companyName: "Accretion Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-eneru",
      code: "NYSE:ENERU",
      companyName: "Accretion Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-enerw",
      code: "NYSE:ENERW",
      companyName: "Accretion Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-enfn",
      code: "NYSE:ENFN",
      companyName: "Enfusion Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-enfr",
      code: "NYSE:ENFR",
      companyName: "Alerian Energy Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eng",
      code: "NYSE:ENG",
      companyName: "ENGlobal Corp",
      popularity: 0,
    },
    {
      slug: "nyse-enic",
      code: "NYSE:ENIC",
      companyName:
        "Enel Chile S.A. American Depositary Shares Representing Common Stock (Each representing 50 shares of",
      popularity: 0,
    },
    {
      slug: "nyse-enj",
      code: "NYSE:ENJ",
      companyName:
        "Entergy New Orleans LLC First Mortgage Bonds 5.0% Series due December 1 2052",
      popularity: 0,
    },
    {
      slug: "nyse-enlc",
      code: "NYSE:ENLC",
      companyName: "ENLINK MIDSTREAM LLC",
      popularity: 0,
    },
    {
      slug: "nyse-enlv",
      code: "NYSE:ENLV",
      companyName: "Enlivex Therapeutics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-eno",
      code: "NYSE:ENO",
      companyName:
        "Entergy New Orleans LLC First Mortgage Bonds 5.50% Series due April 1 2066",
      popularity: 0,
    },
    {
      slug: "nyse-enob",
      code: "NYSE:ENOB",
      companyName: "Enochian Biosciences Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-enor",
      code: "NYSE:ENOR",
      companyName: "iShares MSCI Norway ETF",
      popularity: 0,
    },
    {
      slug: "nyse-enov",
      code: "NYSE:ENOV",
      companyName: "Enovis Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-enpc",
      code: "NYSE:ENPC",
      companyName: "Executive Network Partnering Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-enr",
      code: "NYSE:ENR",
      companyName: "Energizer Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-enrg",
      code: "NYSE:ENRG",
      companyName: "SoFi Smart Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ens",
      code: "NYSE:ENS",
      companyName: "EnerSys Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ensc",
      code: "NYSE:ENSC",
      companyName: "Ensysce Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ensg",
      code: "NYSE:ENSG",
      companyName: "The Ensign Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ensv",
      code: "NYSE:ENSV",
      companyName: "Enservco Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-enta",
      code: "NYSE:ENTA",
      companyName: "Enanta Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-entf",
      code: "NYSE:ENTF",
      companyName:
        "Enterprise 4.0 Technology Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-entfu",
      code: "NYSE:ENTFU",
      companyName: "Enterprise 4.0 Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-entfw",
      code: "NYSE:ENTFW",
      companyName: "Enterprise 4.0 Technology Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-entg",
      code: "NYSE:ENTG",
      companyName: "Entegris Inc",
      popularity: 0,
    },
    {
      slug: "nyse-entr",
      code: "NYSE:ENTR",
      companyName: "ERShares Entrepreneurs ETF",
      popularity: 0,
    },
    {
      slug: "nyse-entx",
      code: "NYSE:ENTX",
      companyName: "Entera Bio Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-entxw",
      code: "NYSE:ENTXW",
      companyName: "Entera Bio Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-env",
      code: "NYSE:ENV",
      companyName: "ENVESTNET INC.",
      popularity: 0,
    },
    {
      slug: "nyse-enva",
      code: "NYSE:ENVA",
      companyName: "Enova International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-envb",
      code: "NYSE:ENVB",
      companyName: "Enveric Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-envx",
      code: "NYSE:ENVX",
      companyName: "Enovix Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-enx",
      code: "NYSE:ENX",
      companyName: "Eaton Vance New York Municipal Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-enz",
      code: "NYSE:ENZ",
      companyName: "Enzo Biochem Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-enzl",
      code: "NYSE:ENZL",
      companyName: "iShares Trust iShares MSCI New Zealand ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eoct",
      code: "NYSE:EOCT",
      companyName: "Innovator Emerging Markets Power Buffer ETF-October",
      popularity: 0,
    },
    {
      slug: "nyse-eocw",
      code: "NYSE:EOCW",
      companyName: "Elliott Opportunity II Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-eod",
      code: "NYSE:EOD",
      companyName: "Allspring Global Dividend Opportunity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-enph",
      code: "NYSE:ENPH",
      companyName: "Enphase Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eoi",
      code: "NYSE:EOI",
      companyName: "Eaton Vance Enhanced Equity Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-eols",
      code: "NYSE:EOLS",
      companyName: "Evolus Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eops",
      code: "NYSE:EOPS",
      companyName: "Emles Alpha Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eos",
      code: "NYSE:EOS",
      companyName: "Eaton Vance Enhance Equity Income Fund II",
      popularity: 0,
    },
    {
      slug: "nyse-eose",
      code: "NYSE:EOSE",
      companyName: "Eos Energy Enterprises Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eosew",
      code: "NYSE:EOSEW",
      companyName: "Eos Energy Enterprises Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-eot",
      code: "NYSE:EOT",
      companyName: "EATON VANCE NATIONAL MUNICIPAL OPPORTUNITIES TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-ep",
      code: "NYSE:EP",
      companyName: "Empire Petroleum Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ep-c",
      code: "NYSE:EP-C",
      companyName: "El Paso Energy Capital Trust I",
      popularity: 0,
    },
    {
      slug: "nyse-epac",
      code: "NYSE:EPAC",
      companyName: "Enerpac Tool Group Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-epam",
      code: "NYSE:EPAM",
      companyName: "EPAM SYSTEMS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-epc",
      code: "NYSE:EPC",
      companyName: "Edgewell Personal Care Company",
      popularity: 0,
    },
    {
      slug: "nyse-epd",
      code: "NYSE:EPD",
      companyName: "Enterprise Products Partners L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-ephe",
      code: "NYSE:EPHE",
      companyName: "iShares MSCI Philippines ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ephy",
      code: "NYSE:EPHY",
      companyName: "Epiphany Technology Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ephyu",
      code: "NYSE:EPHYU",
      companyName: "Epiphany Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ephyw",
      code: "NYSE:EPHYW",
      companyName: "Epiphany Technology Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-epi",
      code: "NYSE:EPI",
      companyName: "WisdomTree India Earnings Fund ETF",
      popularity: 0,
    },
    {
      slug: "nyse-epix",
      code: "NYSE:EPIX",
      companyName: "ESSA Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-epm",
      code: "NYSE:EPM",
      companyName: "Evolution Petroleum Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-epol",
      code: "NYSE:EPOL",
      companyName: "iShares MSCI Poland ETF",
      popularity: 0,
    },
    {
      slug: "nyse-epow",
      code: "NYSE:EPOW",
      companyName: "Sunrise New Energy Co. Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-epp",
      code: "NYSE:EPP",
      companyName: "iShares MSCI Pacific ex Japan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-epr-c",
      code: "NYSE:EPR-C",
      companyName:
        "EPR Properties 5.75% Series C Cumulative Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-epr-e",
      code: "NYSE:EPR-E",
      companyName:
        "EPR Properties 9.00% Series E Cumulative Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-epr-g",
      code: "NYSE:EPR-G",
      companyName:
        "EPR Properties 5.750% Series G Cumulative Redeemable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-epre",
      code: "NYSE:EPRE",
      companyName: "First Trust TCW ESG Premier Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eprf",
      code: "NYSE:EPRF",
      companyName: "Innovator S&P Investment Grade Preferred ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eprt",
      code: "NYSE:EPRT",
      companyName: "Essential Properties Realty Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eps",
      code: "NYSE:EPS",
      companyName: "WisdomTree U.S. LargeCap Fund",
      popularity: 0,
    },
    {
      slug: "nyse-epsn",
      code: "NYSE:EPSN",
      companyName: "Epsilon Energy Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-epu",
      code: "NYSE:EPU",
      companyName: "iShares MSCI Peru ETF",
      popularity: 0,
    },
    {
      slug: "nyse-epv",
      code: "NYSE:EPV",
      companyName: "ProShares UltraShort FTSE Europe",
      popularity: 0,
    },
    {
      slug: "nyse-epwr",
      code: "NYSE:EPWR",
      companyName: "Empowerment & Inclusion Capital I Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-eq",
      code: "NYSE:EQ",
      companyName: "Equillium Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eqal",
      code: "NYSE:EQAL",
      companyName: "Invesco Russell 1000 Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eqbk",
      code: "NYSE:EQBK",
      companyName: "Equity Bancshares Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eqc",
      code: "NYSE:EQC",
      companyName: "Equity Commonwealth",
      popularity: 0,
    },
    {
      slug: "nyse-eqc-d",
      code: "NYSE:EQC-D",
      companyName:
        "Equity Commonwealth 6 1/2% Series D Cumulative Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-eqd",
      code: "NYSE:EQD",
      companyName: "Equity Distribution Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-eqh",
      code: "NYSE:EQH",
      companyName: "Equitable Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eqh-a",
      code: "NYSE:EQH-A",
      companyName:
        "Equitable Holdings Inc. Depositary Shares each representing a 1/1000th interest in a share of Fixe",
      popularity: 0,
    },
    {
      slug: "nyse-eqh-c",
      code: "NYSE:EQH-C",
      companyName:
        "Equitable Holdings Inc. Depositary Shares each representing a 1/1 000th interest in a share of Fi",
      popularity: 0,
    },
    {
      slug: "nyse-eqha",
      code: "NYSE:EQHA",
      companyName: "EQ Health Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-eqix",
      code: "NYSE:EQIX",
      companyName: "Equinix Inc. Common Stock REIT",
      popularity: 0,
    },
    {
      slug: "nyse-eql",
      code: "NYSE:EQL",
      companyName: "ALPS Equal Sector Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eqnr",
      code: "NYSE:EQNR",
      companyName:
        "Equinor ASA American Depositary Shares (Each Representing One Ordinary Share nominal value NOK 2.50",
      popularity: 0,
    },
    {
      slug: "nyse-eqop",
      code: "NYSE:EQOP",
      companyName: "Natixis U.S. Equity Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eqos",
      code: "NYSE:EQOS",
      companyName: "EQONEX LIMITED Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-eqr",
      code: "NYSE:EQR",
      companyName: "Equity Residential",
      popularity: 0,
    },
    {
      slug: "nyse-eqrr",
      code: "NYSE:EQRR",
      companyName: "ProShares Equities for Rising Rates ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eqrx",
      code: "NYSE:EQRX",
      companyName: "EQRx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eqrxw",
      code: "NYSE:EQRXW",
      companyName: "EQRx Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-eqs",
      code: "NYSE:EQS",
      companyName: "Equus Total Return Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-eqt",
      code: "NYSE:EQT",
      companyName: "EQT CORP",
      popularity: 0,
    },
    {
      slug: "nyse-equl",
      code: "NYSE:EQUL",
      companyName: "IQ Engender Equality ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eqwl",
      code: "NYSE:EQWL",
      companyName: "Invesco S&P 100 Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eqx",
      code: "NYSE:EQX",
      companyName: "Equinox Gold Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-eras",
      code: "NYSE:ERAS",
      companyName: "Erasca Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-erc",
      code: "NYSE:ERC",
      companyName: "Allspring Multi-Sector Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-eres",
      code: "NYSE:ERES",
      companyName: "East Resources Acquisition Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eresu",
      code: "NYSE:ERESU",
      companyName: "East Resources Acquisition Company Unit",
      popularity: 0,
    },
    {
      slug: "nyse-eresw",
      code: "NYSE:ERESW",
      companyName: "East Resources Acquisition Company Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-erf",
      code: "NYSE:ERF",
      companyName: "Enerplus Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-erh",
      code: "NYSE:ERH",
      companyName: "Allspring Utilities and High Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-eric",
      code: "NYSE:ERIC",
      companyName: "Ericsson American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-erie",
      code: "NYSE:ERIE",
      companyName: "Erie Indemnity Co",
      popularity: 0,
    },
    {
      slug: "nyse-erii",
      code: "NYSE:ERII",
      companyName: "Energy Recovery Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-erj",
      code: "NYSE:ERJ",
      companyName: "Embraer S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-erm",
      code: "NYSE:ERM",
      companyName: "EquityCompass Risk Manager ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ero",
      code: "NYSE:ERO",
      companyName: "Ero Copper Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ersx",
      code: "NYSE:ERSX",
      companyName: "ERShares NextGen Entrepreneurs ETF",
      popularity: 0,
    },
    {
      slug: "nyse-erth",
      code: "NYSE:ERTH",
      companyName: "Invesco MSCI Sustainable Future ETF",
      popularity: 0,
    },
    {
      slug: "nyse-erx",
      code: "NYSE:ERX",
      companyName: "Direxion Daily Energy Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ery",
      code: "NYSE:ERY",
      companyName: "Direxion Daily Energy Bear 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-eryp",
      code: "NYSE:ERYP",
      companyName: "Erytech Pharma S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-es",
      code: "NYSE:ES",
      companyName: "Eversource Energy",
      popularity: 0,
    },
    {
      slug: "nyse-esab",
      code: "NYSE:ESAB",
      companyName: "ESAB Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-esac",
      code: "NYSE:ESAC",
      companyName: "ESGEN Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-esacu",
      code: "NYSE:ESACU",
      companyName: "ESGEN Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-esacw",
      code: "NYSE:ESACW",
      companyName: "ESGEN Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-esba",
      code: "NYSE:ESBA",
      companyName: "EMPIRE STATE REALTY OP L.P.  SERIES ES",
      popularity: 0,
    },
    {
      slug: "nyse-esca",
      code: "NYSE:ESCA",
      companyName: "Escalade Inc",
      popularity: 0,
    },
    {
      slug: "nyse-escr",
      code: "NYSE:ESCR",
      companyName: "Xtrackers Bloomberg US Investment Grade Corporate ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ese",
      code: "NYSE:ESE",
      companyName: "ESCO Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-esea",
      code: "NYSE:ESEA",
      companyName: "Euroseas Ltd.(Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nyse-eseb",
      code: "NYSE:ESEB",
      companyName: "Xtrackers J.P. Morgan ESG Emerging Markets Sovereign ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esg",
      code: "NYSE:ESG",
      companyName: "FlexShares STOXX US ESG Select Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-esga",
      code: "NYSE:ESGA",
      companyName: "American Century Sustainable Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esgb",
      code: "NYSE:ESGB",
      companyName: "IQ MacKay ESG Core Plus Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esgd",
      code: "NYSE:ESGD",
      companyName: "iShares Trust iShares ESG Aware MSCI EAFE ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esge",
      code: "NYSE:ESGE",
      companyName: "iShares Inc. iShares ESG Aware MSCI EM ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esgg",
      code: "NYSE:ESGG",
      companyName: "FlexShares STOXX Global ESG Select Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-esgn",
      code: "NYSE:ESGN",
      companyName: "Columbia Sustainable International Equity Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esgr",
      code: "NYSE:ESGR",
      companyName: "Enstar Group",
      popularity: 0,
    },
    {
      slug: "nyse-esgro",
      code: "NYSE:ESGRO",
      companyName:
        "Enstar Group Limited Depository Shares 7.00% Perpetual Non-Cumulative Preference Shares Series E",
      popularity: 0,
    },
    {
      slug: "nyse-esgrp",
      code: "NYSE:ESGRP",
      companyName:
        "Enstar Group Limited Depositary Shares Each Representing 1/1000th of an interest in Preference Share",
      popularity: 0,
    },
    {
      slug: "nyse-esgu",
      code: "NYSE:ESGU",
      companyName: "iShares Trust iShares ESG Aware MSCI USA ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esgv",
      code: "NYSE:ESGV",
      companyName: "Vanguard ESG U.S. Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esgy",
      code: "NYSE:ESGY",
      companyName: "American Century Sustainable Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eshy",
      code: "NYSE:ESHY",
      companyName:
        "Xtrackers J.P. Morgan ESG USD High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esi",
      code: "NYSE:ESI",
      companyName: "Element Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-esix",
      code: "NYSE:ESIX",
      companyName: "SPDR S&P SmallCap 600 ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eslt",
      code: "NYSE:ESLT",
      companyName: "Elbit Systems Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-esm",
      code: "NYSE:ESM",
      companyName: "ESM Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-esml",
      code: "NYSE:ESML",
      companyName: "iShares ESG Aware MSCI USA Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esmt",
      code: "NYSE:ESMT",
      companyName: "EngageSmart Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-esmv",
      code: "NYSE:ESMV",
      companyName: "iShares ESG MSCI USA Min Vol Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-esnt",
      code: "NYSE:ESNT",
      companyName: "Essent Group LTD",
      popularity: 0,
    },
    {
      slug: "nyse-esoa",
      code: "NYSE:ESOA",
      companyName: "Energy Services of America Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-esp",
      code: "NYSE:ESP",
      companyName: "Espey Mfg. & Electronics Corp",
      popularity: 0,
    },
    {
      slug: "nyse-espo",
      code: "NYSE:ESPO",
      companyName: "VanEck Video Gaming and eSports ETF",
      popularity: 0,
    },
    {
      slug: "nyse-espr",
      code: "NYSE:ESPR",
      companyName: "Esperion Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-esq",
      code: "NYSE:ESQ",
      companyName: "Esquire Financial Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-esrt",
      code: "NYSE:ESRT",
      companyName: "EMPIRE STATE REALTY TRUST INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ess",
      code: "NYSE:ESS",
      companyName: "Essex Property Trust Inc",
      popularity: 0,
    },
    {
      slug: "nyse-essa",
      code: "NYSE:ESSA",
      companyName: "ESSA Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-essc",
      code: "NYSE:ESSC",
      companyName: "East Stone Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-esscr",
      code: "NYSE:ESSCR",
      companyName: "East Stone Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nyse-esscu",
      code: "NYSE:ESSCU",
      companyName: "East Stone Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-esscw",
      code: "NYSE:ESSCW",
      companyName: "East Stone Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-esta",
      code: "NYSE:ESTA",
      companyName: "Establishment Labs Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-estc",
      code: "NYSE:ESTC",
      companyName: "Elastic N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-este",
      code: "NYSE:ESTE",
      companyName: "Earthstone Energy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-esus",
      code: "NYSE:ESUS",
      companyName: "ETRACS 2x Leveraged MSCI USA ESG Focus TR ETN",
      popularity: 0,
    },
    {
      slug: "nyse-et",
      code: "NYSE:ET",
      companyName:
        "Energy Transfer LP Common Units representing limited partner interests",
      popularity: 0,
    },
    {
      slug: "nyse-et-c",
      code: "NYSE:ET-C",
      companyName:
        "Energy Transfer LP 7.375% Series C Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-et-d",
      code: "NYSE:ET-D",
      companyName:
        "Energy Transfer LP 7.625% Series D Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-et-e",
      code: "NYSE:ET-E",
      companyName:
        "Energy Transfer LP 7.600% Series E Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-etac",
      code: "NYSE:ETAC",
      companyName: "E.Merge Technology Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-etacu",
      code: "NYSE:ETACU",
      companyName: "E.Merge Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-etacw",
      code: "NYSE:ETACW",
      companyName: "E.Merge Technology Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-etb",
      code: "NYSE:ETB",
      companyName: "Eaton Vance Tax-Managed Buy-Write Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-etd",
      code: "NYSE:ETD",
      companyName: "Ethan Allen Interiors Inc",
      popularity: 0,
    },
    {
      slug: "nyse-etg",
      code: "NYSE:ETG",
      companyName: "Eaton Vance Tax-Advantaged Global Dividend Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-etho",
      code: "NYSE:ETHO",
      companyName: "ETF Managers Trust New Issue",
      popularity: 0,
    },
    {
      slug: "nyse-eti-",
      code: "NYSE:ETI-",
      companyName: "Entergy Texas Inc. 5.375% Series A Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-etj",
      code: "NYSE:ETJ",
      companyName: "Eaton Vance Risk - Managed Diversified Equity Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-etn",
      code: "NYSE:ETN",
      companyName: "Eaton Corporation plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-etnb",
      code: "NYSE:ETNB",
      companyName: "89bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eto",
      code: "NYSE:ETO",
      companyName: "Eaton Vance Tax-Advantaged Global Div Oppor. Fund",
      popularity: 0,
    },
    {
      slug: "nyse-eton",
      code: "NYSE:ETON",
      companyName: "Eton Pharmaceutcials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-etpa",
      code: "NYSE:ETPA",
      companyName: "Ecofin Digital Payments Infrastructure Fund",
      popularity: 0,
    },
    {
      slug: "nyse-etr",
      code: "NYSE:ETR",
      companyName: "Entergy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-etrn",
      code: "NYSE:ETRN",
      companyName: "Equitrans Midstream Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-etsy",
      code: "NYSE:ETSY",
      companyName: "Etsy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-etv",
      code: "NYSE:ETV",
      companyName: "Eaton Vance Tax-Managed Buy-Write Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-etw",
      code: "NYSE:ETW",
      companyName:
        "Eaton Vance Tax-Managed Global Buy-Write Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-etwo",
      code: "NYSE:ETWO",
      companyName: "E2open Parent Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-etx",
      code: "NYSE:ETX",
      companyName: "EATON VANCE MUNICIPAL INCOME 2028 TERM TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-ety",
      code: "NYSE:ETY",
      companyName: "Eaton Vance Tax-Managed Diversified Equity Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-eucr",
      code: "NYSE:EUCR",
      companyName: "Eucrates Biomedical Acquisition Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-eucru",
      code: "NYSE:EUCRU",
      companyName: "Eucrates Biomedical Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-eucrw",
      code: "NYSE:EUCRW",
      companyName: "Eucrates Biomedical Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-eudg",
      code: "NYSE:EUDG",
      companyName: "WisdomTree Europe Quality Dividend Growth Fund",
      popularity: 0,
    },
    {
      slug: "nyse-eudv",
      code: "NYSE:EUDV",
      companyName: "ProShares MSCI Europe Dividend Growers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eufn",
      code: "NYSE:EUFN",
      companyName: "iShares MSCI Europe Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eum",
      code: "NYSE:EUM",
      companyName: "ProShares Trust Short MSCI Emerging Markets",
      popularity: 0,
    },
    {
      slug: "nyse-euo",
      code: "NYSE:EUO",
      companyName: "ProShares UltraShort Euro",
      popularity: 0,
    },
    {
      slug: "nyse-eurl",
      code: "NYSE:EURL",
      companyName: "Direxion Daily FTSE Europe Bull 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-eurn",
      code: "NYSE:EURN",
      companyName: "EURONAV NV",
      popularity: 0,
    },
    {
      slug: "nyse-eusa",
      code: "NYSE:EUSA",
      companyName: "iShares MSCI USA Equal Weighted ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eusb",
      code: "NYSE:EUSB",
      companyName: "iShares ESG Advanced Total USD Bond Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eusc",
      code: "NYSE:EUSC",
      companyName: "WisdomTree Europe Hedged SmallCap Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ewbc",
      code: "NYSE:EWBC",
      companyName: "East-West Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ew",
      code: "NYSE:EW",
      companyName: "Edwards Lifesciences Corp",
      popularity: 0,
    },
    {
      slug: "nyse-eva",
      code: "NYSE:EVA",
      companyName: "Enviva Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-evav",
      code: "NYSE:EVAV",
      companyName:
        "Direxion Daily Electric and Autonomous Vehicles Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-evax",
      code: "NYSE:EVAX",
      companyName: "Evaxion Biotech A/S American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-evbg",
      code: "NYSE:EVBG",
      companyName: "Everbridge Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-evbn",
      code: "NYSE:EVBN",
      companyName: "Evans Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-evc",
      code: "NYSE:EVC",
      companyName: "Entravision Communication",
      popularity: 0,
    },
    {
      slug: "nyse-evcm",
      code: "NYSE:EVCM",
      companyName: "EverCommerce Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eve",
      code: "NYSE:EVE",
      companyName: "EVe Mobility Acquisition Corp",
      popularity: 0,
    },
    {
      slug: "nyse-even",
      code: "NYSE:EVEN",
      companyName: "Direxion Daily S&P 500 Equal Weight Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ever",
      code: "NYSE:EVER",
      companyName: "EverQuote Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-evex",
      code: "NYSE:EVEX",
      companyName: "Eve Holding Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-evf",
      code: "NYSE:EVF",
      companyName: "Eaton Vance Senior Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-evg",
      code: "NYSE:EVG",
      companyName: "Eaton Vance Short Duration Diversified Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-evgn",
      code: "NYSE:EVGN",
      companyName: "EVOGENE LTD.",
      popularity: 0,
    },
    {
      slug: "nyse-evgo",
      code: "NYSE:EVGO",
      companyName: "EVgo Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-evgow",
      code: "NYSE:EVGOW",
      companyName: "EVgo Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-evgr",
      code: "NYSE:EVGR",
      companyName: "Evergreen Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-evgru",
      code: "NYSE:EVGRU",
      companyName: "Evergreen Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-evgrw",
      code: "NYSE:EVGRW",
      companyName: "Evergreen Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-evh",
      code: "NYSE:EVH",
      companyName: "Evolent Health Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-evi",
      code: "NYSE:EVI",
      companyName: "EVI Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-evk",
      code: "NYSE:EVK",
      companyName: "Ever-Glory International Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-evlo",
      code: "NYSE:EVLO",
      companyName: "Evelo Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-evlv",
      code: "NYSE:EVLV",
      companyName: "Evolv Technologies Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-evlvw",
      code: "NYSE:EVLVW",
      companyName: "Evolv Technologies Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-evm",
      code: "NYSE:EVM",
      companyName: "Eaton Vance California Municipal Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-evmt",
      code: "NYSE:EVMT",
      companyName:
        "Invesco Electric Vehicle Metals Commodity Strategy No K-1 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-evt",
      code: "NYSE:EVT",
      companyName: "Eaton Vance Tax-Advantaged Dividend Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-evnt",
      code: "NYSE:EVNT",
      companyName: "AltShares Event-Driven ETF",
      popularity: 0,
    },
    {
      slug: "nyse-evo",
      code: "NYSE:EVO",
      companyName: "Evotec SE American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-evoj",
      code: "NYSE:EVOJ",
      companyName: "Evo Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-evoju",
      code: "NYSE:EVOJU",
      companyName: "Evo Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-evojw",
      code: "NYSE:EVOJW",
      companyName: "Evo Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-evok",
      code: "NYSE:EVOK",
      companyName: "Evoke Pharma Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-evop",
      code: "NYSE:EVOP",
      companyName: "EVO Payments Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-evr",
      code: "NYSE:EVR",
      companyName: "Evercore Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-evrg",
      code: "NYSE:EVRG",
      companyName: "Evergy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-evri",
      code: "NYSE:EVRI",
      companyName: "Everi Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-evtc",
      code: "NYSE:EVTC",
      companyName: "EVERTEC INC.",
      popularity: 0,
    },
    {
      slug: "nyse-evtl",
      code: "NYSE:EVTL",
      companyName: "Vertical Aerospace Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-evtv",
      code: "NYSE:EVTV",
      companyName: "Envirotech Vehicles Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-evv",
      code: "NYSE:EVV",
      companyName: "Eaton Vance Limited Duration Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-evx",
      code: "NYSE:EVX",
      companyName: "VanEck Environmental Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewa",
      code: "NYSE:EWA",
      companyName: "iShares MSCI Australia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewc",
      code: "NYSE:EWC",
      companyName: "iShares MSCI Canada ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewco",
      code: "NYSE:EWCO",
      companyName:
        "Invesco Exchange-Traded Fund Trust Invesco S&P 500 Equal Weight Communication Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewcz",
      code: "NYSE:EWCZ",
      companyName: "European Wax Center Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ewd",
      code: "NYSE:EWD",
      companyName: "iShares MSCI Sweden ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eweb",
      code: "NYSE:EWEB",
      companyName: "Global X Emerging Markets Internet & E-commerce ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewg",
      code: "NYSE:EWG",
      companyName: "iShares MSCI Germany ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewgs",
      code: "NYSE:EWGS",
      companyName: "iShares MSCI Germany Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewh",
      code: "NYSE:EWH",
      companyName: "iShares MSCI Hong Kong ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewi",
      code: "NYSE:EWI",
      companyName: "iShares MSCI Italy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewj",
      code: "NYSE:EWJ",
      companyName: "iShares MSCI Japan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewje",
      code: "NYSE:EWJE",
      companyName: "iShares MSCI Japan Equal Weighted ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewjv",
      code: "NYSE:EWJV",
      companyName: "iShares MSCI Japan Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewk",
      code: "NYSE:EWK",
      companyName: "iShares MSCI Belgium ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewm",
      code: "NYSE:EWM",
      companyName: "iShares MSCI Malaysia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewmc",
      code: "NYSE:EWMC",
      companyName: "Invesco S&P MidCap 400 Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewn",
      code: "NYSE:EWN",
      companyName: "iShares MSCI Netherlands ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewo",
      code: "NYSE:EWO",
      companyName: "iShares MSCI Austria ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewp",
      code: "NYSE:EWP",
      companyName: "iShares MSCI Spain ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewq",
      code: "NYSE:EWQ",
      companyName: "iShares MSCI France ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewre",
      code: "NYSE:EWRE",
      companyName: "Invesco S&P 500 Equal Weight Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ews",
      code: "NYSE:EWS",
      companyName: "iShares MSCI Singapore ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewsc",
      code: "NYSE:EWSC",
      companyName: "Invesco S&P SmallCap 600 Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewt",
      code: "NYSE:EWT",
      companyName: "iShares MSCI Taiwan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewtx",
      code: "NYSE:EWTX",
      companyName: "Edgewise Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ewu",
      code: "NYSE:EWU",
      companyName: "iShares MSCI United Kingdom ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewus",
      code: "NYSE:EWUS",
      companyName: "iShares MSCI United Kingdom Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewv",
      code: "NYSE:EWV",
      companyName: "ProShares Trust UltraShort MSCI Japan",
      popularity: 0,
    },
    {
      slug: "nyse-eww",
      code: "NYSE:EWW",
      companyName: "iShares MSCI Mexico ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewx",
      code: "NYSE:EWX",
      companyName: "SPDR S&P Emerging Markets Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewy",
      code: "NYSE:EWY",
      companyName: "iShares MSCI South Korea ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewz",
      code: "NYSE:EWZ",
      companyName: "iShares MSCI Brazil ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewzs",
      code: "NYSE:EWZS",
      companyName: "iShares MSCI Brazil Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-exai",
      code: "NYSE:EXAI",
      companyName: "Exscientia Plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-exas",
      code: "NYSE:EXAS",
      companyName: "Exact Sciences Corp",
      popularity: 0,
    },
    {
      slug: "nyse-exc",
      code: "NYSE:EXC",
      companyName: "Exelon Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-exd",
      code: "NYSE:EXD",
      companyName: "Eaton Vance TaxManaged Buy-Write Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-exel",
      code: "NYSE:EXEL",
      companyName: "Exelixis Inc",
      popularity: 0,
    },
    {
      slug: "nyse-exfy",
      code: "NYSE:EXFY",
      companyName: "Expensify Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-exg",
      code: "NYSE:EXG",
      companyName:
        "Eaton Vance Tax-Managed Global Diversified Equity Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-exk",
      code: "NYSE:EXK",
      companyName: "Endeavour Silver Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-exls",
      code: "NYSE:EXLS",
      companyName: "ExlService Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-exn",
      code: "NYSE:EXN",
      companyName: "Excellon Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-expd",
      code: "NYSE:EXPD",
      companyName: "Expeditors International of Washington Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-expi",
      code: "NYSE:EXPI",
      companyName: "eXp World Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-expo",
      code: "NYSE:EXPO",
      companyName: "Exponent Inc",
      popularity: 0,
    },
    {
      slug: "nyse-expr",
      code: "NYSE:EXPR",
      companyName: "Express Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-exr",
      code: "NYSE:EXR",
      companyName: "Extra Space Storage Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-extn",
      code: "NYSE:EXTN",
      companyName: "Exterran Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-extr",
      code: "NYSE:EXTR",
      companyName: "Extreme Networks",
      popularity: 0,
    },
    {
      slug: "nyse-eye",
      code: "NYSE:EYE",
      companyName: "National Vision Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eyen",
      code: "NYSE:EYEN",
      companyName: "Eyenovia Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eyes",
      code: "NYSE:EYES",
      companyName: "Second Sight Medical Products Inc",
      popularity: 0,
    },
    {
      slug: "nyse-eyesw",
      code: "NYSE:EYESW",
      companyName:
        "Second Sight Medical Products Inc. Warrants expiring 03/14/2024",
      popularity: 0,
    },
    {
      slug: "nyse-eyld",
      code: "NYSE:EYLD",
      companyName: "Cambria Emerging Shareholder Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-eypt",
      code: "NYSE:EYPT",
      companyName: "EyePoint Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-eza",
      code: "NYSE:EZA",
      companyName: "iShares MSCI South Africa ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ezfl",
      code: "NYSE:EZFL",
      companyName: "EzFill Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ezgo",
      code: "NYSE:EZGO",
      companyName: "EZGO Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ezj",
      code: "NYSE:EZJ",
      companyName: "ProShares Ultra MSCI Japan",
      popularity: 0,
    },
    {
      slug: "nyse-ezm",
      code: "NYSE:EZM",
      companyName: "WisdomTree U.S. MidCap Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ezpw",
      code: "NYSE:EZPW",
      companyName: "Ezcorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ezu",
      code: "NYSE:EZU",
      companyName: "iShare MSCI Eurozone ETF of ISHARES INC.",
      popularity: 0,
    },
    {
      slug: "nyse-exi",
      code: "NYSE:EXI",
      companyName: "iShares Global Industrials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-f-b",
      code: "NYSE:F-B",
      companyName: "Ford Motor Company 6.20% Notes due June 1 2059",
      popularity: 0,
    },
    {
      slug: "nyse-f-c",
      code: "NYSE:F-C",
      companyName: "Ford Motor Company 6.000% Notes due December 1 2059",
      popularity: 0,
    },
    {
      slug: "nyse-fa",
      code: "NYSE:FA",
      companyName: "First Advantage Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-faar",
      code: "NYSE:FAAR",
      companyName: "First Trust Alternative Absolute Return Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fab",
      code: "NYSE:FAB",
      companyName: "First Trust Multi Cap Value AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-faca",
      code: "NYSE:FACA",
      companyName: "Figure Acquisition Corp. I",
      popularity: 0,
    },
    {
      slug: "nyse-fact",
      code: "NYSE:FACT",
      companyName: "Freedom Acquisition I Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-fad",
      code: "NYSE:FAD",
      companyName: "First Trust Multi Cap Growth AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-faf",
      code: "NYSE:FAF",
      companyName: "First American Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-fail",
      code: "NYSE:FAIL",
      companyName: "Cambria Global Tail Risk ETF",
      popularity: 0,
    },
    {
      slug: "nyse-faln",
      code: "NYSE:FALN",
      companyName: "iShares Fallen Angels USD Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fam",
      code: "NYSE:FAM",
      companyName: "First Trust/abrdn Global Opportunity Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fami",
      code: "NYSE:FAMI",
      companyName: "Farmmi Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fan",
      code: "NYSE:FAN",
      companyName: "First Trust Global Wind Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fang",
      code: "NYSE:FANG",
      companyName: "Diamondback Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fanh",
      code: "NYSE:FANH",
      companyName: "Fanhua Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fapr",
      code: "NYSE:FAPR",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-faro",
      code: "NYSE:FARO",
      companyName: "Faro Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fas",
      code: "NYSE:FAS",
      companyName: "Direxion Daily Financial Bull 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fat",
      code: "NYSE:FAT",
      companyName: "FAT Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fatbb",
      code: "NYSE:FATBB",
      companyName: "FAT Brands Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fatbp",
      code: "NYSE:FATBP",
      companyName: "FAT Brands Inc. 8.25% Series B Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fatbw",
      code: "NYSE:FATBW",
      companyName: "FAT Brands Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fate",
      code: "NYSE:FATE",
      companyName: "Fate Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fath",
      code: "NYSE:FATH",
      companyName: "Fathom Digital Manufacturing Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-fatp",
      code: "NYSE:FATP",
      companyName: "Fat Projects Acquisition Corp Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-fatpu",
      code: "NYSE:FATPU",
      companyName: "Fat Projects Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-fatpw",
      code: "NYSE:FATPW",
      companyName: "Fat Projects Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-faug",
      code: "NYSE:FAUG",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - August",
      popularity: 0,
    },
    {
      slug: "nyse-fax",
      code: "NYSE:FAX",
      companyName: "abrdn Asia-Pacific Income Fund Inc",
      popularity: 0,
    },
    {
      slug: "nyse-faz",
      code: "NYSE:FAZ",
      companyName: "Direxion Daily Financial Bear 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-faze",
      code: "NYSE:FAZE",
      companyName: "FaZe Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fazew",
      code: "NYSE:FAZEW",
      companyName: "FaZe Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fbc",
      code: "NYSE:FBC",
      companyName: "Flagstar Bancorp Inc. New",
      popularity: 0,
    },
    {
      slug: "nyse-fbcg",
      code: "NYSE:FBCG",
      companyName: "Fidelity Blue Chip Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fbcv",
      code: "NYSE:FBCV",
      companyName: "Fidelity Blue Chip Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fbgx",
      code: "NYSE:FBGX",
      companyName: "UBS AG FI Enhanced Large Cap Growth ETN",
      popularity: 0,
    },
    {
      slug: "nyse-fbhs",
      code: "NYSE:FBHS",
      companyName: "FORTUNE BRANDS HOME & SECURITY INC.",
      popularity: 0,
    },
    {
      slug: "nyse-fbio",
      code: "NYSE:FBIO",
      companyName: "Fortress Biotech Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fbiop",
      code: "NYSE:FBIOP",
      companyName:
        "Fortress Biotech Inc. 9.375% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fbiz",
      code: "NYSE:FBIZ",
      companyName: "First Business Financial Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fbk",
      code: "NYSE:FBK",
      companyName: "FB Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-fbms",
      code: "NYSE:FBMS",
      companyName: "First Bancshares Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fbnc",
      code: "NYSE:FBNC",
      companyName: "First Bancorp/NC",
      popularity: 0,
    },
    {
      slug: "nyse-fbnd",
      code: "NYSE:FBND",
      companyName: "Fidelity Total Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fbp",
      code: "NYSE:FBP",
      companyName: "First BanCorp.",
      popularity: 0,
    },
    {
      slug: "nyse-fbrt",
      code: "NYSE:FBRT",
      companyName: "Franklin BSP Realty Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fbrt-e",
      code: "NYSE:FBRT-E",
      companyName:
        "Franklin BSP Realty Trust Inc. 7.50% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fbrx",
      code: "NYSE:FBRX",
      companyName: "Forte Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fbt",
      code: "NYSE:FBT",
      companyName: "First Trust NYSE Arca Biotechnology Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fbz",
      code: "NYSE:FBZ",
      companyName: "First Trust Brazil AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fc",
      code: "NYSE:FC",
      companyName: "Franklin Covey Company",
      popularity: 0,
    },
    {
      slug: "nyse-fca",
      code: "NYSE:FCA",
      companyName: "First Trust China AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fcal",
      code: "NYSE:FCAL",
      companyName: "First Trust California Municipal High income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fcap",
      code: "NYSE:FCAP",
      companyName: "First Capital Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fcax",
      code: "NYSE:FCAX",
      companyName: "Fortress Capital Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-fcbc",
      code: "NYSE:FCBC",
      companyName: "First Community Bankshares Inc. (VA)",
      popularity: 0,
    },
    {
      slug: "nyse-fcco",
      code: "NYSE:FCCO",
      companyName: "First Community Corp",
      popularity: 0,
    },
    {
      slug: "nyse-fcef",
      code: "NYSE:FCEF",
      companyName:
        "First Trust Exchange-Traded Fund VIII First Trust Income Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fcel",
      code: "NYSE:FCEL",
      companyName: "FuelCell Energy Inc  NEW (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-fcf",
      code: "NYSE:FCF",
      companyName: "First Commonwealth Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-fcfs",
      code: "NYSE:FCFS",
      companyName: "FirstCash Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fcg",
      code: "NYSE:FCG",
      companyName: "First Trust Natural Gas ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fcld",
      code: "NYSE:FCLD",
      companyName: "Fidelity Cloud Computing ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fcn",
      code: "NYSE:FCN",
      companyName: "FTI Consulting Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fcnca",
      code: "NYSE:FCNCA",
      companyName: "First Citizens BancShares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fcnco",
      code: "NYSE:FCNCO",
      companyName:
        "First Citizens BancShares Inc. 5.625% Non-Cumulative Perpetual Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nyse-fcncp",
      code: "NYSE:FCNCP",
      companyName:
        "First Citizens BancShares Inc. Depositary Shares Each Representing a 1/40th Interest in a Share of",
      popularity: 0,
    },
    {
      slug: "nyse-fco",
      code: "NYSE:FCO",
      companyName: "abrdn Global Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fcom",
      code: "NYSE:FCOM",
      companyName: "Fidelity MSCI Communication Services Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fcor",
      code: "NYSE:FCOR",
      companyName: "Fidelity Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fcpi",
      code: "NYSE:FCPI",
      companyName: "Fidelity Stocks for Inflation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fcpt",
      code: "NYSE:FCPT",
      companyName: "Four Corners Property Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fcrd",
      code: "NYSE:FCRD",
      companyName: "First Eagle Alternative Capital BDC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fcrx",
      code: "NYSE:FCRX",
      companyName:
        "First Eagle Alternative Capital BDC Inc. 5.00% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-fcsh",
      code: "NYSE:FCSH",
      companyName: "Federated Hermes Short Duration Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fcuv",
      code: "NYSE:FCUV",
      companyName: "Focus Universal Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fcvt",
      code: "NYSE:FCVT",
      companyName: "First Trust SSI Strategic Convertible Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdbc",
      code: "NYSE:FDBC",
      companyName: "Fidelity D & D Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fdd",
      code: "NYSE:FDD",
      companyName: "First Trust STOXX European Select Dividend Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fdec",
      code: "NYSE:FDEC",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - December",
      popularity: 0,
    },
    {
      slug: "nyse-fdem",
      code: "NYSE:FDEM",
      companyName: "Fidelity Emerging Markets Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdeu",
      code: "NYSE:FDEU",
      companyName: "First Trust Dynamic Europe Equity Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fdev",
      code: "NYSE:FDEV",
      companyName: "Fidelity International Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdg",
      code: "NYSE:FDG",
      companyName: "American Century Focused Dynamic Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdht",
      code: "NYSE:FDHT",
      companyName: "Fidelity Digital Health ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdhy",
      code: "NYSE:FDHY",
      companyName: "Fidelity High Yield Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdig",
      code: "NYSE:FDIG",
      companyName: "Fidelity Crypto Industry and Digital Payments ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdis",
      code: "NYSE:FDIS",
      companyName: "Fidelity MSCI Consumer Discretionary Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdl",
      code: "NYSE:FDL",
      companyName: "First Trust Morningstar Dividend Leaders Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fdlo",
      code: "NYSE:FDLO",
      companyName: "Fidelity Low Volatility Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdm",
      code: "NYSE:FDM",
      companyName: "First Trust Dow Jones Select MicroCap Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fdmo",
      code: "NYSE:FDMO",
      companyName: "Fidelity Momentum Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdmt",
      code: "NYSE:FDMT",
      companyName: "4D Molecular Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fdn",
      code: "NYSE:FDN",
      companyName: "First Trust Dow Jones Internet Index Fund ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdni",
      code: "NYSE:FDNI",
      companyName: "First Trust Dow Jones International Internet ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdp",
      code: "NYSE:FDP",
      companyName: "Fresh Del Monte Produce Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fdrr",
      code: "NYSE:FDRR",
      companyName: "Fidelity Dividend ETF for Rising Rates",
      popularity: 0,
    },
    {
      slug: "nyse-fdrv",
      code: "NYSE:FDRV",
      companyName: "Fidelity Electric Vehicles and Future Transportation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fds",
      code: "NYSE:FDS",
      companyName: "Factset Research Systems",
      popularity: 0,
    },
    {
      slug: "nyse-fdt",
      code: "NYSE:FDT",
      companyName: "First Trust Developed Markets ex-US AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fdts",
      code: "NYSE:FDTS",
      companyName:
        "First Trust Developed Markets ex-US Small Cap AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fdus",
      code: "NYSE:FDUS",
      companyName: "Fidus Investment Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-fdvv",
      code: "NYSE:FDVV",
      companyName: "Fidelity High Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fdwm",
      code: "NYSE:FDWM",
      companyName: "Fidelity Women's Leadership ETF",
      popularity: 0,
    },
    {
      slug: "nyse-feam",
      code: "NYSE:FEAM",
      companyName: "5E Advanced Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-febz",
      code: "NYSE:FEBZ",
      companyName: "TrueShares Structured Outcome (February) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fedl",
      code: "NYSE:FEDL",
      companyName: "ETRACS 2x Leveraged IFED Invest with the Fed TR Index ETN",
      popularity: 0,
    },
    {
      slug: "nyse-fedm",
      code: "NYSE:FEDM",
      companyName:
        "FlexShares ESG & Climate Developed Markets ex-US Core Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fedu",
      code: "NYSE:FEDU",
      companyName:
        "Four Seasons Education (Cayman) Inc. American depositary shares each representing ten (10) Ordinary",
      popularity: 0,
    },
    {
      slug: "nyse-fedx",
      code: "NYSE:FEDX",
      companyName: "Emles Federal Contractors ETF",
      popularity: 0,
    },
    {
      slug: "nyse-feem",
      code: "NYSE:FEEM",
      companyName: "FlexShares ESG & Climate Emerging Markets Core Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fehy",
      code: "NYSE:FEHY",
      companyName:
        "FlexShares ESG & Climate High Yield Corporate Core Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fei",
      code: "NYSE:FEI",
      companyName: "FIRST TRUST MLP AND ENERGY INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-feig",
      code: "NYSE:FEIG",
      companyName:
        "FlexShares ESG & Climate Investment Grade Corporate Core Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-feim",
      code: "NYSE:FEIM",
      companyName: "Frequency Electronics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fele",
      code: "NYSE:FELE",
      companyName: "Franklin Electric Co Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fem",
      code: "NYSE:FEM",
      companyName: "First Trust Emerging Markets AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fema",
      code: "NYSE:FEMA",
      companyName: "Procure Disaster Recovery Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-femb",
      code: "NYSE:FEMB",
      companyName: "First Trust Emerging Markets Local Currency Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fems",
      code: "NYSE:FEMS",
      companyName: "First Trust Emerging Markets Small Cap AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-femy",
      code: "NYSE:FEMY",
      companyName: "Femasys Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fen",
      code: "NYSE:FEN",
      companyName: "First Trust Energy Income and Growth Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fenc",
      code: "NYSE:FENC",
      companyName: "Fennec Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-feng",
      code: "NYSE:FENG",
      companyName:
        "Phoenix New Media Limited American Depositary Shares (each representing forty-eight (48) Class A Ord",
      popularity: 0,
    },
    {
      slug: "nyse-feny",
      code: "NYSE:FENY",
      companyName: "Fidelity MSCI Energy Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-feo",
      code: "NYSE:FEO",
      companyName: "First Trust/abrdn Emerging Opportunity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fep",
      code: "NYSE:FEP",
      companyName: "First Trust Europe AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fet",
      code: "NYSE:FET",
      companyName: "Forum Energy Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-feus",
      code: "NYSE:FEUS",
      companyName: "FlexShares ESG & Climate US Large Cap Core Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-feuz",
      code: "NYSE:FEUZ",
      companyName: "First Trust Eurozone AlphaDEX",
      popularity: 0,
    },
    {
      slug: "nyse-fevr",
      code: "NYSE:FEVR",
      companyName: "Inspire Faithward Large Cap Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fex",
      code: "NYSE:FEX",
      companyName: "First Trust Large Cap Core AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fexd",
      code: "NYSE:FEXD",
      companyName: "Fintech Ecosystem Development Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fexdr",
      code: "NYSE:FEXDR",
      companyName: "Fintech Ecosystem Development Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-fexdu",
      code: "NYSE:FEXDU",
      companyName: "Fintech Ecosystem Development Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-fexdw",
      code: "NYSE:FEXDW",
      companyName: "Fintech Ecosystem Development Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fez",
      code: "NYSE:FEZ",
      companyName: "SPDR EURO STOXX 50 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ff",
      code: "NYSE:FF",
      companyName: "Future Fuel Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ffa",
      code: "NYSE:FFA",
      companyName: "First Trust Enhanced Equity Income Fund.",
      popularity: 0,
    },
    {
      slug: "nyse-ffbc",
      code: "NYSE:FFBC",
      companyName: "First Financial Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-ffbw",
      code: "NYSE:FFBW",
      companyName: "FFBW Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ffc",
      code: "NYSE:FFC",
      companyName:
        "Flaherty & Crumrine Preferred and Income Securities Fund Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-ffeb",
      code: "NYSE:FFEB",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - February",
      popularity: 0,
    },
    {
      slug: "nyse-ffhg",
      code: "NYSE:FFHG",
      companyName: "Formula Folios Hedged Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ffhl",
      code: "NYSE:FFHL",
      companyName: "Fuwei Films (Holdings) Co. Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-ffic",
      code: "NYSE:FFIC",
      companyName: "Flushing Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ffie",
      code: "NYSE:FFIE",
      companyName: "Faraday Future Intelligent Electric Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ffiew",
      code: "NYSE:FFIEW",
      companyName: "Faraday Future Intelligent Electric Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ffin",
      code: "NYSE:FFIN",
      companyName: "First Financial Bankshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ffiu",
      code: "NYSE:FFIU",
      companyName: "UVA Unconstrained Medium-Term Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ffiv",
      code: "NYSE:FFIV",
      companyName: "F5 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ffnd",
      code: "NYSE:FFND",
      companyName: "The Future Fund Active ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ffnw",
      code: "NYSE:FFNW",
      companyName: "First Financial Northwest Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ffr",
      code: "NYSE:FFR",
      companyName: "First Trust FTSE EPRA/NAREIT Global Real Estate Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ffsg",
      code: "NYSE:FFSG",
      companyName: "FormulaFolios Smart Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fftg",
      code: "NYSE:FFTG",
      companyName: "FormulaFolios Tactical Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ffti",
      code: "NYSE:FFTI",
      companyName: "FormulaFolios Tactical Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ffty",
      code: "NYSE:FFTY",
      companyName: "Innovator IBD 50 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ffwm",
      code: "NYSE:FFWM",
      companyName: "First Foundation Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fgb",
      code: "NYSE:FGB",
      companyName:
        "First Trust Specialty Finance and Financial Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fgbi",
      code: "NYSE:FGBI",
      companyName: "FIRST GUARANTY BANCSHARES INC",
      popularity: 0,
    },
    {
      slug: "nyse-fgbip",
      code: "NYSE:FGBIP",
      companyName:
        "First Guaranty Bancshares Inc. 6.75% Series A Fixed-Rate Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fgd",
      code: "NYSE:FGD",
      companyName: "First Trust Dow Jones Global Select Dividend Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fgen",
      code: "NYSE:FGEN",
      companyName: "FibroGen Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fgf",
      code: "NYSE:FGF",
      companyName: "FG Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fgfpp",
      code: "NYSE:FGFPP",
      companyName: "FG Financial Group Inc. 8.00% Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fgi",
      code: "NYSE:FGI",
      companyName: "FGI Industries Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fgiww",
      code: "NYSE:FGIWW",
      companyName: "FGI Industries Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fgld",
      code: "NYSE:FGLD",
      companyName: "Franklin Responsibly Sourced Gold ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fgm",
      code: "NYSE:FGM",
      companyName: "First Trust Germany AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fgmc",
      code: "NYSE:FGMC",
      companyName: "FG Merger Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fgmcu",
      code: "NYSE:FGMCU",
      companyName: "FG Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-fgmcw",
      code: "NYSE:FGMCW",
      companyName: "FG Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fgro",
      code: "NYSE:FGRO",
      companyName: "Fidelity Growth Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fhb",
      code: "NYSE:FHB",
      companyName: "First Hawaiian Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fhi",
      code: "NYSE:FHI",
      companyName: "Federated Hermes Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fhlc",
      code: "NYSE:FHLC",
      companyName: "Fidelity MSCI Health Care Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fhlt",
      code: "NYSE:FHLT",
      companyName: "Future Health ESG Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-fhltu",
      code: "NYSE:FHLTU",
      companyName: "Future Health ESG Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-fhltw",
      code: "NYSE:FHLTW",
      companyName: "Future Health ESG Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fhn",
      code: "NYSE:FHN",
      companyName: "First Horizon Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-fhn-b",
      code: "NYSE:FHN-B",
      companyName:
        "First Horizon Corporation Depositary Shares each representing a 1/400th interest in a share of Non-",
      popularity: 0,
    },
    {
      slug: "nyse-fhn-c",
      code: "NYSE:FHN-C",
      companyName:
        "First Horizon Corporation Depositary Shares each representing a 1/400th interest in a share of Non-",
      popularity: 0,
    },
    {
      slug: "nyse-fhn-d",
      code: "NYSE:FHN-D",
      companyName:
        "First Horizon Corporation Depositary Shares each representing a 1/400th interest in a share of Non-",
      popularity: 0,
    },
    {
      slug: "nyse-fhn-e",
      code: "NYSE:FHN-E",
      companyName:
        "First Horizon Corporation Depositary Shares Each Representing a 1/ 4000th Interest in a Share of No",
      popularity: 0,
    },
    {
      slug: "nyse-fhn-f",
      code: "NYSE:FHN-F",
      companyName:
        "First Horizon Corporation Depositary Shares each representing 1/4000th Interest in a Share of Non-C",
      popularity: 0,
    },
    {
      slug: "nyse-fhs",
      code: "NYSE:FHS",
      companyName:
        "First High-School Education Group Co. Ltd. American Depositary Shares (each representing three (3)",
      popularity: 0,
    },
    {
      slug: "nyse-fhtx",
      code: "NYSE:FHTX",
      companyName: "Foghorn Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fhys",
      code: "NYSE:FHYS",
      companyName: "Federated Hermes Short Duration High Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fiac",
      code: "NYSE:FIAC",
      companyName: "Focus Impact Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fiacu",
      code: "NYSE:FIACU",
      companyName: "Focus Impact Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-fiacw",
      code: "NYSE:FIACW",
      companyName: "Focus Impact Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fibk",
      code: "NYSE:FIBK",
      companyName: "First Interstate BancSystem Inc. - Class A",
      popularity: 0,
    },
    {
      slug: "nyse-fico",
      code: "NYSE:FICO",
      companyName: "Fair Isaac Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-fics",
      code: "NYSE:FICS",
      companyName: "First Trust International Developed Capital Strength ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ficv",
      code: "NYSE:FICV",
      companyName: "Frontier Investment Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ficvu",
      code: "NYSE:FICVU",
      companyName: "Frontier Investment Corp Units",
      popularity: 0,
    },
    {
      slug: "nyse-ficvw",
      code: "NYSE:FICVW",
      companyName: "Frontier Investment Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-fid",
      code: "NYSE:FID",
      companyName:
        "First Trust Exchange-Traded Fund VI First Trust S&P International Dividend Aristocrats ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fidi",
      code: "NYSE:FIDI",
      companyName: "Fidelity International High Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fidu",
      code: "NYSE:FIDU",
      companyName: "Fidelity MSCI Industrials Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fiee",
      code: "NYSE:FIEE",
      companyName: "FI Enhanced Europe 50 ETN",
      popularity: 0,
    },
    {
      slug: "nyse-fif",
      code: "NYSE:FIF",
      companyName: "FIRST TRUST ENERGY INFRASTRUCTURE FUND",
      popularity: 0,
    },
    {
      slug: "nyse-fig",
      code: "NYSE:FIG",
      companyName: "Simplify Macro Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-figb",
      code: "NYSE:FIGB",
      companyName: "Fidelity Investment Grade Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-figs",
      code: "NYSE:FIGS",
      companyName: "FIGS Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fihd",
      code: "NYSE:FIHD",
      companyName: "UBS AG FI Enhanced Global High Yield ETN",
      popularity: 0,
    },
    {
      slug: "nyse-fill",
      code: "NYSE:FILL",
      companyName: "iShares MSCI Global Energy Producers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-finm",
      code: "NYSE:FINM",
      companyName: "Marlin Technology Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-finmu",
      code: "NYSE:FINMU",
      companyName: "Marlin Technology Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-finmw",
      code: "NYSE:FINMW",
      companyName: "Marlin Technology Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fins",
      code: "NYSE:FINS",
      companyName: "Angel Oak Financial Strategies Income Term Trust",
      popularity: 0,
    },
    {
      slug: "nyse-finv",
      code: "NYSE:FINV",
      companyName:
        "FinVolution Group American depositary shares each representing five Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-finw",
      code: "NYSE:FINW",
      companyName: "FinWise Bancorp Common",
      popularity: 0,
    },
    {
      slug: "nyse-finx",
      code: "NYSE:FINX",
      companyName: "Global X Funds Global X FinTech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fip",
      code: "NYSE:FIP",
      companyName: "FTAI Infrastructure Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fis",
      code: "NYSE:FIS",
      companyName: "Fidelity National Information Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fisi",
      code: "NYSE:FISI",
      companyName: "Financial Institutions Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fisk",
      code: "NYSE:FISK",
      companyName: "Empire State Realty OP L.P. Series 250",
      popularity: 0,
    },
    {
      slug: "nyse-fisr",
      code: "NYSE:FISR",
      companyName: "SPDR SSGA Fixed Income Sector Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fisv",
      code: "NYSE:FISV",
      companyName: "Fiserv Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fitb",
      code: "NYSE:FITB",
      companyName: "Fifth Third Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-fitbi",
      code: "NYSE:FITBI",
      companyName: "Fifth Third Bancorp Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fitbo",
      code: "NYSE:FITBO",
      companyName:
        "Fifth Third Bancorp Depositary Shares each representing a 1/1000th ownership interest in a share of",
      popularity: 0,
    },
    {
      slug: "nyse-fitbp",
      code: "NYSE:FITBP",
      companyName:
        "Fifth Third Bancorp Depositary Shares each representing 1/40th share of Fifth Third 6.00% Non-Cumula",
      popularity: 0,
    },
    {
      slug: "nyse-fite",
      code: "NYSE:FITE",
      companyName: "SPDR S&P Kensho Future Security ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fiva",
      code: "NYSE:FIVA",
      companyName: "Fidelity International Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-five",
      code: "NYSE:FIVE",
      companyName: "Five Below Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fivg",
      code: "NYSE:FIVG",
      companyName: "Defiance Next Gen Connectivity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fivn",
      code: "NYSE:FIVN",
      companyName: "FIVE9 INC.",
      popularity: 0,
    },
    {
      slug: "nyse-fivr",
      code: "NYSE:FIVR",
      companyName: "Strategy Shares Nasdaq 5HANDL Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fiw",
      code: "NYSE:FIW",
      companyName: "First Trust Water ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fix",
      code: "NYSE:FIX",
      companyName: "Comfort Systems USA Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fixx",
      code: "NYSE:FIXX",
      companyName: "Homology Medicines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fizz",
      code: "NYSE:FIZZ",
      companyName: "National Beverage Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-fjan",
      code: "NYSE:FJAN",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-fjp",
      code: "NYSE:FJP",
      companyName: "First Trust Japan AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fjul",
      code: "NYSE:FJUL",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-fjun",
      code: "NYSE:FJUN",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - June",
      popularity: 0,
    },
    {
      slug: "nyse-fku",
      code: "NYSE:FKU",
      companyName: "First Trust United Kingdom AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fkwl",
      code: "NYSE:FKWL",
      companyName: "Franklin Wireless Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fl",
      code: "NYSE:FL",
      companyName: "Foot Locker Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-flac",
      code: "NYSE:FLAC",
      companyName:
        "Frazier Lifesciences Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-flacu",
      code: "NYSE:FLACU",
      companyName: "Frazier Lifesciences Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-flacw",
      code: "NYSE:FLACW",
      companyName: "Frazier Lifesciences Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-flag",
      code: "NYSE:FLAG",
      companyName: "First Light Acquisition Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-flau",
      code: "NYSE:FLAU",
      companyName: "Franklin FTSE Australia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flax",
      code: "NYSE:FLAX",
      companyName: "Franklin FTSE Asia ex Japan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flbl",
      code: "NYSE:FLBL",
      companyName: "Franklin Senior Loan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flbr",
      code: "NYSE:FLBR",
      companyName: "Franklin FTSE Brazil ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flc",
      code: "NYSE:FLC",
      companyName: "Flaherty & Crumrine Total Return Fund Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-flca",
      code: "NYSE:FLCA",
      companyName: "Franklin FTSE Canada ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flcb",
      code: "NYSE:FLCB",
      companyName: "Franklin U.S. Core Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flch",
      code: "NYSE:FLCH",
      companyName: "Franklin FTSE China ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flco",
      code: "NYSE:FLCO",
      companyName: "Franklin Investment Grade Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fleh",
      code: "NYSE:FLEH",
      companyName: "Franklin FTSE Europe Hedged ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flex",
      code: "NYSE:FLEX",
      companyName: "Flex Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-flfr",
      code: "NYSE:FLFR",
      companyName: "Franklin FTSE France ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flfv",
      code: "NYSE:FLFV",
      companyName: "Feutune Light Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-flfvr",
      code: "NYSE:FLFVR",
      companyName: "Feutune Light Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nyse-flfvu",
      code: "NYSE:FLFVU",
      companyName: "Feutune Light Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-flfvw",
      code: "NYSE:FLFVW",
      companyName: "Feutune Light Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-flgb",
      code: "NYSE:FLGB",
      companyName: "Franklin FTSE United Kingdom ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flgc",
      code: "NYSE:FLGC",
      companyName: "Flora Growth Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-flgr",
      code: "NYSE:FLGR",
      companyName: "Franklin FTSE Germany ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flgt",
      code: "NYSE:FLGT",
      companyName: "Fulgent Genetics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-flgv",
      code: "NYSE:FLGV",
      companyName: "Franklin U.S. Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flhk",
      code: "NYSE:FLHK",
      companyName: "Franklin FTSE Hong Kong ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flhy",
      code: "NYSE:FLHY",
      companyName: "Franklin High Yield Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flia",
      code: "NYSE:FLIA",
      companyName: "Franklin International Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flic",
      code: "NYSE:FLIC",
      companyName: "First of Long Island Corp/The",
      popularity: 0,
    },
    {
      slug: "nyse-flin",
      code: "NYSE:FLIN",
      companyName: "Franklin FTSE India ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fliy",
      code: "NYSE:FLIY",
      companyName: "Franklin FTSE Italy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fljh",
      code: "NYSE:FLJH",
      companyName: "Franklin FTSE Japan Hedged ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fljp",
      code: "NYSE:FLJP",
      companyName: "Franklin FTSE Japan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flkr",
      code: "NYSE:FLKR",
      companyName: "Franklin FTSE South Korea ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fll",
      code: "NYSE:FLL",
      companyName: "Full House Resorts Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-flla",
      code: "NYSE:FLLA",
      companyName: "Franklin FTSE Latin America",
      popularity: 0,
    },
    {
      slug: "nyse-fllv",
      code: "NYSE:FLLV",
      companyName: "Franklin U.S. Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flmb",
      code: "NYSE:FLMB",
      companyName: "Franklin Municipal Green Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flme",
      code: "NYSE:FLME",
      companyName: "Flame Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-flmi",
      code: "NYSE:FLMI",
      companyName: "Franklin Dynamic Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flmx",
      code: "NYSE:FLMX",
      companyName: "Franklin FTSE Mexico ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fln",
      code: "NYSE:FLN",
      companyName: "First Trust Latin America AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-flnc",
      code: "NYSE:FLNC",
      companyName: "Fluence Energy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-flng",
      code: "NYSE:FLNG",
      companyName: "FLEX LNG Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-flnt",
      code: "NYSE:FLNT",
      companyName: "Fluent Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-flo",
      code: "NYSE:FLO",
      companyName: "Flowers Foods Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-flql",
      code: "NYSE:FLQL",
      companyName: "Franklin U.S. Large Cap Multifactor Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flqm",
      code: "NYSE:FLQM",
      companyName: "Franklin U.S. Mid Cap Multifactor Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flqs",
      code: "NYSE:FLQS",
      companyName: "Franklin U.S. Small Cap Multifactor Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flr",
      code: "NYSE:FLR",
      companyName: "Fluor Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-flrg",
      code: "NYSE:FLRG",
      companyName: "Fidelity U.S. Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flrn",
      code: "NYSE:FLRN",
      companyName: "SPDR Bloomberg Investment Grade Floating Rate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flrt",
      code: "NYSE:FLRT",
      companyName: "Pacer Pacific Asset Floating Rate High Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flru",
      code: "NYSE:FLRU",
      companyName: "Franklin FTSE Russia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fls",
      code: "NYSE:FLS",
      companyName: "Flowserve Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-flsa",
      code: "NYSE:FLSA",
      companyName: "Franklin FTSE Saudi Arabia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flsp",
      code: "NYSE:FLSP",
      companyName: "Franklin Systematic Style Premia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flsw",
      code: "NYSE:FLSW",
      companyName: "Franklin FTSE Switzerland ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flt",
      code: "NYSE:FLT",
      companyName: "FleetCor Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fltb",
      code: "NYSE:FLTB",
      companyName: "Fidelity Limited Term Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fltn",
      code: "NYSE:FLTN",
      companyName: "Rareview Inflation/Deflation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fltw",
      code: "NYSE:FLTW",
      companyName: "Franklin FTSE Taiwan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flud",
      code: "NYSE:FLUD",
      companyName: "Franklin Ultra Short Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flux",
      code: "NYSE:FLUX",
      companyName: "Flux Power Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-flv",
      code: "NYSE:FLV",
      companyName: "American Century Focused Large Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flws",
      code: "NYSE:FLWS",
      companyName: "1-800-FLOWERS.COM Inc",
      popularity: 0,
    },
    {
      slug: "nyse-flxs",
      code: "NYSE:FLXS",
      companyName: "Flexsteel Industries",
      popularity: 0,
    },
    {
      slug: "nyse-flya",
      code: "NYSE:FLYA",
      companyName: "SOAR Technology Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-flyd",
      code: "NYSE:FLYD",
      companyName: "MicroSectors Travel -3x Inverse Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-flyu",
      code: "NYSE:FLYU",
      companyName: "MicroSectors Travel 3x Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-flyw",
      code: "NYSE:FLYW",
      companyName: "Flywire Corporation Voting Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-flza",
      code: "NYSE:FLZA",
      companyName: "Franklin FTSE South Africa",
      popularity: 0,
    },
    {
      slug: "nyse-fm",
      code: "NYSE:FM",
      companyName: "iShares MSCI Frontier and Select EM ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmag",
      code: "NYSE:FMAG",
      companyName: "Fidelity Magellan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmao",
      code: "NYSE:FMAO",
      companyName: "Farmers & Merchants Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fmat",
      code: "NYSE:FMAT",
      companyName: "Fidelity MSCI Materials Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmay",
      code: "NYSE:FMAY",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - May",
      popularity: 0,
    },
    {
      slug: "nyse-fmb",
      code: "NYSE:FMB",
      companyName: "First Trust Managed Municipal ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmbh",
      code: "NYSE:FMBH",
      companyName: "First Mid Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fmcx",
      code: "NYSE:FMCX",
      companyName: "FMC Excelsior Focus Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmet",
      code: "NYSE:FMET",
      companyName: "Fidelity Metaverse ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmf",
      code: "NYSE:FMF",
      companyName: "First Trust Managed Futures Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fmhi",
      code: "NYSE:FMHI",
      companyName: "First Trust Municipal High Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmil",
      code: "NYSE:FMIL",
      companyName: "Fidelity New Millennium ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmiv",
      code: "NYSE:FMIV",
      companyName: "Forum Merger IV Corporation Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-fmivu",
      code: "NYSE:FMIVU",
      companyName: "Forum Merger IV Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-fmivw",
      code: "NYSE:FMIVW",
      companyName: "Forum Merger IV Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fmn",
      code: "NYSE:FMN",
      companyName: "Federated Hermes Premier Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fmnb",
      code: "NYSE:FMNB",
      companyName: "Farmers National Banc Corp",
      popularity: 0,
    },
    {
      slug: "nyse-fmny",
      code: "NYSE:FMNY",
      companyName: "First Trust New York Municipal High Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmqq",
      code: "NYSE:FMQQ",
      companyName: "FMQQ The Next Frontier Internet & Ecommerce ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fms",
      code: "NYSE:FMS",
      companyName: "Fresenius Medical Care AG & Co. KGaA",
      popularity: 0,
    },
    {
      slug: "nyse-flot",
      code: "NYSE:FLOT",
      companyName: "iShares Floating Rate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmtx",
      code: "NYSE:FMTX",
      companyName: "Forma Therapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fmx",
      code: "NYSE:FMX",
      companyName: "FOMENTO ECONOMICO MEXICANO S.A.B. DE C.V.",
      popularity: 0,
    },
    {
      slug: "nyse-fmy",
      code: "NYSE:FMY",
      companyName: "FIRST TRUST MORTGAGE INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-fn",
      code: "NYSE:FN",
      companyName: "Fabrinet",
      popularity: 0,
    },
    {
      slug: "nyse-fna",
      code: "NYSE:FNA",
      companyName: "Paragon 28 Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fnb",
      code: "NYSE:FNB",
      companyName: "F.N.B. Corp",
      popularity: 0,
    },
    {
      slug: "nyse-fnb-e",
      code: "NYSE:FNB-E",
      companyName:
        "F.N.B. CORPORATION Representing a 1/40th Interest in a Share of Fixed-to-Floating Rate Non-Cumulativ",
      popularity: 0,
    },
    {
      slug: "nyse-fncb",
      code: "NYSE:FNCB",
      companyName: "FNCB Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fnch",
      code: "NYSE:FNCH",
      companyName: "Finch Therapeutics Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fncl",
      code: "NYSE:FNCL",
      companyName: "Fidelity MSCI Financials Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fnda",
      code: "NYSE:FNDA",
      companyName: "Schwab Fundamental U.S. Small Company Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fndb",
      code: "NYSE:FNDB",
      companyName: "Schwab Fundamental U.S. Broad Market Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fndc",
      code: "NYSE:FNDC",
      companyName: "Schwab Fundamental International Small Company Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fnde",
      code: "NYSE:FNDE",
      companyName:
        "Schwab Fundamental Emerging Markets Large Company Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fndf",
      code: "NYSE:FNDF",
      companyName: "Schwab Fundamental International Large Company Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fndx",
      code: "NYSE:FNDX",
      companyName: "Schwab Fundamental U.S. Large Company Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fnf",
      code: "NYSE:FNF",
      companyName: "Fidelity National Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fngd",
      code: "NYSE:FNGD",
      companyName:
        "MicroSectors FANG+ Index -3X Inverse Leveraged ETNs due January 8 2038",
      popularity: 0,
    },
    {
      slug: "nyse-fngg",
      code: "NYSE:FNGG",
      companyName: "Direxion Daily Select Large Caps & FANGs Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fngo",
      code: "NYSE:FNGO",
      companyName:
        "MicroSectors FANG+ Index 2X Leveraged ETNs due January 8 2038",
      popularity: 0,
    },
    {
      slug: "nyse-fngr",
      code: "NYSE:FNGR",
      companyName: "FingerMotion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fngs",
      code: "NYSE:FNGS",
      companyName: "MicroSectors FANG+ ETNs due January 8 2038",
      popularity: 0,
    },
    {
      slug: "nyse-fngu",
      code: "NYSE:FNGU",
      companyName:
        "MicroSectors FANG+ Index 3X Leveraged ETNs due January 8 2038",
      popularity: 0,
    },
    {
      slug: "nyse-fnhc",
      code: "NYSE:FNHC",
      companyName: "FedNat Holding Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fni",
      code: "NYSE:FNI",
      companyName: "First Trust Chindia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fnk",
      code: "NYSE:FNK",
      companyName: "First Trust Mid Cap Value AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fnko",
      code: "NYSE:FNKO",
      companyName: "Funko Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fnlc",
      code: "NYSE:FNLC",
      companyName: "First Bancorp Inc. (ME)",
      popularity: 0,
    },
    {
      slug: "nyse-fnov",
      code: "NYSE:FNOV",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - November",
      popularity: 0,
    },
    {
      slug: "nyse-fntc",
      code: "NYSE:FNTC",
      companyName: "Direxion Daily FinTech Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fnv",
      code: "NYSE:FNV",
      companyName: "Franco-Nevada Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-fnvt",
      code: "NYSE:FNVT",
      companyName: "Finnovate Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fnvtu",
      code: "NYSE:FNVTU",
      companyName: "Finnovate Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-fnvtw",
      code: "NYSE:FNVTW",
      companyName: "Finnovate Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-fnwb",
      code: "NYSE:FNWB",
      companyName: "First Northwest Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fnwd",
      code: "NYSE:FNWD",
      companyName: "Finward Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fnx",
      code: "NYSE:FNX",
      companyName: "First Trust Mid Cap Core AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fny",
      code: "NYSE:FNY",
      companyName: "First Trust Mid Cap Growth AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-foa",
      code: "NYSE:FOA",
      companyName: "Finance of America Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-focs",
      code: "NYSE:FOCS",
      companyName: "Focus Financial Partners Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-foct",
      code: "NYSE:FOCT",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-fof",
      code: "NYSE:FOF",
      companyName: "Cohen & Steers Closed End Opportunity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fold",
      code: "NYSE:FOLD",
      companyName: "Amicus Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fomo",
      code: "NYSE:FOMO",
      companyName: "AXS FOMO ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fonr",
      code: "NYSE:FONR",
      companyName: "Fonar Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-for",
      code: "NYSE:FOR",
      companyName: "Forestar Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fora",
      code: "NYSE:FORA",
      companyName: "Forian Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-forg",
      code: "NYSE:FORG",
      companyName: "ForgeRock Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-forh",
      code: "NYSE:FORH",
      companyName: "Formidable ETF",
      popularity: 0,
    },
    {
      slug: "nyse-form",
      code: "NYSE:FORM",
      companyName: "FormFactor Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-forr",
      code: "NYSE:FORR",
      companyName: "Forrester Research Inc",
      popularity: 0,
    },
    {
      slug: "nyse-forty",
      code: "NYSE:FORTY",
      companyName: "Formula Systems 1985 Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-fosl",
      code: "NYSE:FOSL",
      companyName: "Fossil Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fosll",
      code: "NYSE:FOSLL",
      companyName: "Fossil Group Inc. 7% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-four",
      code: "NYSE:FOUR",
      companyName: "Shift4 Payments Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fovl",
      code: "NYSE:FOVL",
      companyName: "iShares Focused Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fox",
      code: "NYSE:FOX",
      companyName: "Fox Corporation Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-foxa",
      code: "NYSE:FOXA",
      companyName: "Fox Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-foxf",
      code: "NYSE:FOXF",
      companyName: "Fox Factory Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-foxw",
      code: "NYSE:FOXW",
      companyName:
        "FoxWayne Enterprises Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-foxwu",
      code: "NYSE:FOXWU",
      companyName: "FoxWayne Enterprises Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-foxww",
      code: "NYSE:FOXWW",
      companyName: "FoxWayne Enterprises Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fpa",
      code: "NYSE:FPA",
      companyName: "First Trust Asia Pacific ex-Japan AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fpac",
      code: "NYSE:FPAC",
      companyName: "Far Peak Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-fpag",
      code: "NYSE:FPAG",
      companyName: "FPA Global Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fpay",
      code: "NYSE:FPAY",
      companyName: "FlexShopper Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fpe",
      code: "NYSE:FPE",
      companyName: "First Trust Preferred Securities and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fpei",
      code: "NYSE:FPEI",
      companyName:
        "First Trust Institutional Preferred Securities and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fpf",
      code: "NYSE:FPF",
      companyName: "FIRST TRUST INTERMEDIATE DURATION PREFERRED & INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-fpfd",
      code: "NYSE:FPFD",
      companyName: "Fidelity Preferred Securities & Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fph",
      code: "NYSE:FPH",
      companyName: "Five Point Holdings LLC Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fpl",
      code: "NYSE:FPL",
      companyName: "FIRST TRUST NEW OPPORTUNITIES MLP & ENERGY FUND",
      popularity: 0,
    },
    {
      slug: "nyse-fpro",
      code: "NYSE:FPRO",
      companyName: "Fidelity Real Estate Investment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fpx",
      code: "NYSE:FPX",
      companyName: "First Trust US Equity Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fpxe",
      code: "NYSE:FPXE",
      companyName: "First Trust IPOX Europe Equity Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fpxi",
      code: "NYSE:FPXI",
      companyName:
        "First Trust Exchange-Traded Fund II First Trust International Equity Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fqal",
      code: "NYSE:FQAL",
      companyName: "Fidelity Quality Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fr",
      code: "NYSE:FR",
      companyName: "First Industrial Realty Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fra",
      code: "NYSE:FRA",
      companyName: "Blackrock Floating Rate Income Strategies Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fraf",
      code: "NYSE:FRAF",
      companyName: "Franklin Financial Services Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-frba",
      code: "NYSE:FRBA",
      companyName: "First Bank",
      popularity: 0,
    },
    {
      slug: "nyse-frbk",
      code: "NYSE:FRBK",
      companyName: "Republic First Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-frbn",
      code: "NYSE:FRBN",
      companyName: "Forbion European Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-frbnu",
      code: "NYSE:FRBNU",
      companyName: "Forbion European Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-frbnw",
      code: "NYSE:FRBNW",
      companyName: "Forbion European Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-frc",
      code: "NYSE:FRC",
      companyName: "First Republic Bank",
      popularity: 0,
    },
    {
      slug: "nyse-frc-h",
      code: "NYSE:FRC-H",
      companyName: "First Republic Bank",
      popularity: 0,
    },
    {
      slug: "nyse-frc-i",
      code: "NYSE:FRC-I",
      companyName:
        "First Republic Bank  Depositary Shares each representing a 1/40th interest in a share of 5.50% Nonc",
      popularity: 0,
    },
    {
      slug: "nyse-frc-j",
      code: "NYSE:FRC-J",
      companyName:
        "First Republic Bank Depositary Shares Each Representing a 1/40th Interest in a Share of 4.70% Noncu",
      popularity: 0,
    },
    {
      slug: "nyse-frc-k",
      code: "NYSE:FRC-K",
      companyName:
        "First Republic Bank Depositary Shares Each Representing a 1/40th Interest in a Share of 4.125% Nonc",
      popularity: 0,
    },
    {
      slug: "nyse-frc-l",
      code: "NYSE:FRC-L",
      companyName:
        "First Republic Bank Depositary Shares Each Representing a 1/40th Interest in a Share of 4.250% Nonc",
      popularity: 0,
    },
    {
      slug: "nyse-frc-m",
      code: "NYSE:FRC-M",
      companyName:
        "First Republic Bank Depositary Shares each representing a 1/40th interest in a share of 4.000% Nonc",
      popularity: 0,
    },
    {
      slug: "nyse-frc-n",
      code: "NYSE:FRC-N",
      companyName:
        "First Republic Bank Depositary Shares Each Representing a 1/40th Interest in a Share of 4.500% Nonc",
      popularity: 0,
    },
    {
      slug: "nyse-frd",
      code: "NYSE:FRD",
      companyName: "Friedman Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-frdm",
      code: "NYSE:FRDM",
      companyName: "Freedom 100 Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-free",
      code: "NYSE:FREE",
      companyName: "Whole Earth Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-freew",
      code: "NYSE:FREEW",
      companyName: "Whole Earth Brands Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-frel",
      code: "NYSE:FREL",
      companyName: "Fidelity MSCI Real Estate Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-freq",
      code: "NYSE:FREQ",
      companyName: "Frequency Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-frey",
      code: "NYSE:FREY",
      companyName: "FREYR Battery",
      popularity: 0,
    },
    {
      slug: "nyse-frg",
      code: "NYSE:FRG",
      companyName: "Franchise Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-frgap",
      code: "NYSE:FRGAP",
      companyName:
        "Franchise Group Inc. 7.50% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-frge",
      code: "NYSE:FRGE",
      companyName: "Forge Global Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-frgi",
      code: "NYSE:FRGI",
      companyName: "Fiesta Restaurant Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-frgt",
      code: "NYSE:FRGT",
      companyName: "Freight Technologies Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-frhc",
      code: "NYSE:FRHC",
      companyName: "Freedom Holding Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-fri",
      code: "NYSE:FRI",
      companyName: "First Trust S&P REIT Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-frla",
      code: "NYSE:FRLA",
      companyName: "Fortune Rise Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-frlau",
      code: "NYSE:FRLAU",
      companyName: "Fortune Rise Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nyse-frlaw",
      code: "NYSE:FRLAW",
      companyName: "Fortune Rise Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-frln",
      code: "NYSE:FRLN",
      companyName:
        "Freeline Therapeutics Holdings plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-frme",
      code: "NYSE:FRME",
      companyName: "First Merchants Corp",
      popularity: 0,
    },
    {
      slug: "nyse-frmep",
      code: "NYSE:FRMEP",
      companyName: "First Merchants Corporation Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-frnw",
      code: "NYSE:FRNW",
      companyName: "Fidelity Clean Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fro",
      code: "NYSE:FRO",
      companyName: "Frontline Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-frog",
      code: "NYSE:FROG",
      companyName: "JFrog Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fron",
      code: "NYSE:FRON",
      companyName: "Frontier Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fronu",
      code: "NYSE:FRONU",
      companyName: "Frontier Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-fronw",
      code: "NYSE:FRONW",
      companyName: "Frontier Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-frph",
      code: "NYSE:FRPH",
      companyName: "FRP Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-frpt",
      code: "NYSE:FRPT",
      companyName: "Freshpet Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-frsg",
      code: "NYSE:FRSG",
      companyName:
        "First Reserve Sustainable Growth Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-frsgu",
      code: "NYSE:FRSGU",
      companyName: "First Reserve Sustainable Growth Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-frsgw",
      code: "NYSE:FRSGW",
      companyName: "First Reserve Sustainable Growth Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fpi",
      code: "NYSE:FPI",
      companyName: "Farmland Partners Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-frsh",
      code: "NYSE:FRSH",
      companyName: "Freshworks Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-frst",
      code: "NYSE:FRST",
      companyName: "Primis Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-frsx",
      code: "NYSE:FRSX",
      companyName:
        "Foresight Autonomous Holdings Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-frt",
      code: "NYSE:FRT",
      companyName: "Federal Realty Investment Trust",
      popularity: 0,
    },
    {
      slug: "nyse-frt-c",
      code: "NYSE:FRT-C",
      companyName:
        "Federal Realty Investment Trust Depositary Shares each representing a 1/1000th interest in a 5.000",
      popularity: 0,
    },
    {
      slug: "nyse-frty",
      code: "NYSE:FRTY",
      companyName: "Alger Mid Cap 40 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-frw",
      code: "NYSE:FRW",
      companyName: "PWP Forward Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-frwau",
      code: "NYSE:FRWAU",
      companyName: "PWP Forward Acquisition Corp. I Units",
      popularity: 0,
    },
    {
      slug: "nyse-frwaw",
      code: "NYSE:FRWAW",
      companyName: "PWP Forward Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-frxb",
      code: "NYSE:FRXB",
      companyName: "Forest Road Acquisition Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-frza",
      code: "NYSE:FRZA",
      companyName: "Forza X1 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fsbc",
      code: "NYSE:FSBC",
      companyName: "Five Star Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fsbd",
      code: "NYSE:FSBD",
      companyName: "Fidelity Sustainable Core Plus Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fsbw",
      code: "NYSE:FSBW",
      companyName: "FS Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fsd",
      code: "NYSE:FSD",
      companyName: "FIRST TRUST HIGH INCOME LONG/SHORT FUND",
      popularity: 0,
    },
    {
      slug: "nyse-fsea",
      code: "NYSE:FSEA",
      companyName: "First Seacoast Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fsec",
      code: "NYSE:FSEC",
      companyName: "Fidelity Investment Grade Securitized ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fsep",
      code: "NYSE:FSEP",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - September",
      popularity: 0,
    },
    {
      slug: "nyse-fsfg",
      code: "NYSE:FSFG",
      companyName: "First Savings Financial Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-fsi",
      code: "NYSE:FSI",
      companyName: "Flexible Solutions International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fsig",
      code: "NYSE:FSIG",
      companyName:
        "First Trust Limited Duration Investment Grade Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fsld",
      code: "NYSE:FSLD",
      companyName: "Fidelity Sustainable Low Duration Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fsly",
      code: "NYSE:FSLY",
      companyName: "Fastly Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fsm",
      code: "NYSE:FSM",
      companyName: "FORTUNA Silver Mines Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fsmb",
      code: "NYSE:FSMB",
      companyName: "First Trust Short Duration Managed Municipal ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fsmd",
      code: "NYSE:FSMD",
      companyName: "Fidelity Small-Mid Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fsmo",
      code: "NYSE:FSMO",
      companyName: "Fidelity Small-Mid Cap Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fsnb",
      code: "NYSE:FSNB",
      companyName: "Fusion Acquisition Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-fsp",
      code: "NYSE:FSP",
      companyName: "Franklin Street Properties Corp",
      popularity: 0,
    },
    {
      slug: "nyse-fsr",
      code: "NYSE:FSR",
      companyName: "Fisker Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fsrd",
      code: "NYSE:FSRD",
      companyName: "Fast Radius Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fsrdw",
      code: "NYSE:FSRDW",
      companyName: "Fast Radius Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-fsrx",
      code: "NYSE:FSRX",
      companyName: "FinServ Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fsrxu",
      code: "NYSE:FSRXU",
      companyName: "FinServ Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-fsrxw",
      code: "NYSE:FSRXW",
      companyName: "FinServ Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fss",
      code: "NYSE:FSS",
      companyName: "Federal Signal Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-fssi",
      code: "NYSE:FSSI",
      companyName: "Fortistar Sustainable Solutions Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fssiu",
      code: "NYSE:FSSIU",
      companyName: "Fortistar Sustainable Solutions Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-fssiw",
      code: "NYSE:FSSIW",
      companyName: "Fortistar Sustainable Solutions Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-fsst",
      code: "NYSE:FSST",
      companyName: "Fidelity Sustainable U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fst",
      code: "NYSE:FST",
      companyName: "FAST Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-fsta",
      code: "NYSE:FSTA",
      companyName: "Fidelity MSCI Consumer Staples Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fstr",
      code: "NYSE:FSTR",
      companyName: "Foster (Lb) Co",
      popularity: 0,
    },
    {
      slug: "nyse-fstx",
      code: "NYSE:FSTX",
      companyName: "F-star Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fsv",
      code: "NYSE:FSV",
      companyName: "FirstService Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fsyd",
      code: "NYSE:FSYD",
      companyName: "Fidelity Sustainable High Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fsz",
      code: "NYSE:FSZ",
      companyName: "First Trust Switzerland AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ft",
      code: "NYSE:FT",
      companyName: "Franklin Universal Trust Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-fta",
      code: "NYSE:FTA",
      companyName:
        "First Trust Large Cap Value AlphaDEX Fund (based on the Defined Large Cap Value Index--symbol DEFILV",
      popularity: 0,
    },
    {
      slug: "nyse-ftaa",
      code: "NYSE:FTAA",
      companyName: "FTAC Athena Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ftaau",
      code: "NYSE:FTAAU",
      companyName: "FTAC Athena Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ftaaw",
      code: "NYSE:FTAAW",
      companyName: "FTAC Athena Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ftag",
      code: "NYSE:FTAG",
      companyName:
        "First Trust Exchange-Traded Fund II First Trust Indxx Global Agriculture ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftai",
      code: "NYSE:FTAI",
      companyName:
        "Fortress Transportation and Infrastructure Investors LLC Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ftain",
      code: "NYSE:FTAIN",
      companyName:
        "Fortress Transportation and Infrastructure Investors LLC 8.25% Fixed - Rate Reset Series C Cumulativ",
      popularity: 0,
    },
    {
      slug: "nyse-ftaio",
      code: "NYSE:FTAIO",
      companyName:
        "Fortress Transportation and Infrastructure Investors LLC 8.00% Fixed-to-Floating Rate Series B Cumul",
      popularity: 0,
    },
    {
      slug: "nyse-ftaip",
      code: "NYSE:FTAIP",
      companyName:
        "Fortress Transportation and Infrastructure Investors LLC 8.25% Fixed-to-Floating Rate Series A Cumul",
      popularity: 0,
    },
    {
      slug: "nyse-ftc",
      code: "NYSE:FTC",
      companyName:
        "First Trust Large Cap Growth AlphaDEX Fund (based on the Defined Large Cap Growth Index--symbol DEFI",
      popularity: 0,
    },
    {
      slug: "nyse-ftch",
      code: "NYSE:FTCH",
      companyName: "Farfetch Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ftci",
      code: "NYSE:FTCI",
      companyName: "FTC Solar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ftcs",
      code: "NYSE:FTCS",
      companyName: "First Trust Capital Strength ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftcv",
      code: "NYSE:FTCV",
      companyName: "FinTech Acquisition Corp. V Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ftcvu",
      code: "NYSE:FTCVU",
      companyName: "FinTech Acquisition Corp. V Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ftcvw",
      code: "NYSE:FTCVW",
      companyName: "FinTech Acquisition Corp. V Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ftdr",
      code: "NYSE:FTDR",
      companyName: "Frontdoor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ftds",
      code: "NYSE:FTDS",
      companyName: "First Trust Dividend Strength ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftec",
      code: "NYSE:FTEC",
      companyName: "Fidelity MSCI Information Technology Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftek",
      code: "NYSE:FTEK",
      companyName: "Fuel Tech Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ftev",
      code: "NYSE:FTEV",
      companyName: "FinTech Evolution Acquisition Group",
      popularity: 0,
    },
    {
      slug: "nyse-ftf",
      code: "NYSE:FTF",
      companyName:
        "Franklin Limited Duration Income Trust Common Shrs. of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-ftft",
      code: "NYSE:FTFT",
      companyName: "Future FinTech Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ftgc",
      code: "NYSE:FTGC",
      companyName: "First Trust Global Tactical Commodity Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fthi",
      code: "NYSE:FTHI",
      companyName:
        "First Trust Exchange-Traded Fund VI First Trust BuyWrite Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fthm",
      code: "NYSE:FTHM",
      companyName: "Fathom Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fthy",
      code: "NYSE:FTHY",
      companyName: "First Trust High Yield Opportunities 2027 Term Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fti",
      code: "NYSE:FTI",
      companyName: "TechnipFMC plc Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ftii",
      code: "NYSE:FTII",
      companyName: "FutureTech II Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ftiiu",
      code: "NYSE:FTIIU",
      companyName: "FutureTech II Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ftiiw",
      code: "NYSE:FTIIW",
      companyName: "FutureTech II Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ftk",
      code: "NYSE:FTK",
      companyName: "Flotek Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ftls",
      code: "NYSE:FTLS",
      companyName: "First Trust Long/Short Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftpa",
      code: "NYSE:FTPA",
      companyName: "FTAC Parnassus Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ftpau",
      code: "NYSE:FTPAU",
      companyName: "FTAC Parnassus Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ftpaw",
      code: "NYSE:FTPAW",
      companyName: "FTAC Parnassus Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ftqi",
      code: "NYSE:FTQI",
      companyName:
        "First Trust Exchange-Traded Fund VI First Trust Hedged BuyWrite Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftri",
      code: "NYSE:FTRI",
      companyName:
        "First Trust Exchange-Traded Fund II First Trust Indxx Global Natural Resources Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fts",
      code: "NYSE:FTS",
      companyName: "Fortis Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ftsd",
      code: "NYSE:FTSD",
      companyName: "Franklin Short Duration U.S. Government ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftsl",
      code: "NYSE:FTSL",
      companyName: "First Trust Senior Loan Fund ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftsm",
      code: "NYSE:FTSM",
      companyName: "First Trust Enhanced Short Maturity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftv",
      code: "NYSE:FTV",
      companyName: "Fortive Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ftvi",
      code: "NYSE:FTVI",
      companyName: "FinTech Acquisition Corp. VI Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ftviu",
      code: "NYSE:FTVIU",
      companyName: "FinTech Acquisition Corp. VI Units",
      popularity: 0,
    },
    {
      slug: "nyse-ftviw",
      code: "NYSE:FTVIW",
      companyName: "FinTech Acquisition Corp. VI Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-ftxg",
      code: "NYSE:FTXG",
      companyName: "First Trust Nasdaq Food & Beverage ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftxh",
      code: "NYSE:FTXH",
      companyName: "First Trust Nasdaq Pharmaceuticals ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftxl",
      code: "NYSE:FTXL",
      companyName: "First Trust Nasdaq Semiconductor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftxn",
      code: "NYSE:FTXN",
      companyName: "First Trust Nasdaq Oil & Gas ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftxo",
      code: "NYSE:FTXO",
      companyName: "First Trust Nasdaq Bank ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ftxr",
      code: "NYSE:FTXR",
      companyName: "First Trust Nasdaq Transportation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fubo",
      code: "NYSE:FUBO",
      companyName: "fuboTV Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fue",
      code: "NYSE:FUE",
      companyName:
        "ELEMENTS Linked to the ICE BofAML Commodity Index eXtra Biofuels Total Return",
      popularity: 0,
    },
    {
      slug: "nyse-ful",
      code: "NYSE:FUL",
      companyName: "H.B. Fuller Company",
      popularity: 0,
    },
    {
      slug: "nyse-fulc",
      code: "NYSE:FULC",
      companyName: "Fulcrum Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fult",
      code: "NYSE:FULT",
      companyName: "Fulton Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-fultp",
      code: "NYSE:FULTP",
      companyName:
        "Fulton Financial Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of Fi",
      popularity: 0,
    },
    {
      slug: "nyse-fumb",
      code: "NYSE:FUMB",
      companyName: "First Trust Ultra Short Duration Municipal ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fun",
      code: "NYSE:FUN",
      companyName: "Cedar Fair L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-func",
      code: "NYSE:FUNC",
      companyName: "First United Corp",
      popularity: 0,
    },
    {
      slug: "nyse-fund",
      code: "NYSE:FUND",
      companyName: "Sprott Focus Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-funl",
      code: "NYSE:FUNL",
      companyName: "CornerCap Fundametrics Large-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fury",
      code: "NYSE:FURY",
      companyName: "Fury Gold Mines Limited",
      popularity: 0,
    },
    {
      slug: "nyse-fusb",
      code: "NYSE:FUSB",
      companyName: "First US Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fusn",
      code: "NYSE:FUSN",
      companyName: "Fusion Pharmaceuticals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-futu",
      code: "NYSE:FUTU",
      companyName: "Futu Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-futy",
      code: "NYSE:FUTY",
      companyName: "Fidelity MSCI Utilities Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fuv",
      code: "NYSE:FUV",
      companyName: "Arcimoto Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fv",
      code: "NYSE:FV",
      companyName: "First Trust Dorsey Wright Focus 5 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fval",
      code: "NYSE:FVAL",
      companyName: "Fidelity Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fvam",
      code: "NYSE:FVAM",
      companyName: "5:01 Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fvc",
      code: "NYSE:FVC",
      companyName: "First Trust Dorsey Wright Dynamic Focus 5 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fvcb",
      code: "NYSE:FVCB",
      companyName: "FVCBankcorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fvd",
      code: "NYSE:FVD",
      companyName: "First Trust Value Line Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fviv",
      code: "NYSE:FVIV",
      companyName: "Fortress Value Acquisition Corp. IV",
      popularity: 0,
    },
    {
      slug: "nyse-fvrr",
      code: "NYSE:FVRR",
      companyName: "Fiverr International Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-fvt",
      code: "NYSE:FVT",
      companyName: "Fortress Value Acquisition Corp. III",
      popularity: 0,
    },
    {
      slug: "nyse-fwac",
      code: "NYSE:FWAC",
      companyName: "Fifth Wall Acquisition Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fwbi",
      code: "NYSE:FWBI",
      companyName: "First Wave BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fwonk",
      code: "NYSE:FWONK",
      companyName:
        "Liberty Media Corporation Series C Liberty Formula One Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fwp",
      code: "NYSE:FWP",
      companyName: "Forward Pharma A/S American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-fwrd",
      code: "NYSE:FWRD",
      companyName: "Forward Air Corp",
      popularity: 0,
    },
    {
      slug: "nyse-fwrg",
      code: "NYSE:FWRG",
      companyName: "First Watch Restaurant Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fxa",
      code: "NYSE:FXA",
      companyName: "Invesco CurrencyShares Australian Dollar Trust",
      popularity: 0,
    },
    {
      slug: "nyse-fxb",
      code: "NYSE:FXB",
      companyName: "Invesco CurrencyShares British Pound Sterling Trust",
      popularity: 0,
    },
    {
      slug: "nyse-fxc",
      code: "NYSE:FXC",
      companyName: "Invesco CurrencyShares Canadian Dollar Trust",
      popularity: 0,
    },
    {
      slug: "nyse-fxco",
      code: "NYSE:FXCO",
      companyName:
        "Financial Strategies Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fxcor",
      code: "NYSE:FXCOR",
      companyName: "Financial Strategies Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-fxcow",
      code: "NYSE:FXCOW",
      companyName: "Financial Strategies Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-fxd",
      code: "NYSE:FXD",
      companyName: "First Trust Consumer Discretionary AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fxe",
      code: "NYSE:FXE",
      companyName: "Invesco CurrencyShares Euro Currency Trust",
      popularity: 0,
    },
    {
      slug: "nyse-fxf",
      code: "NYSE:FXF",
      companyName: "Invesco CurrencyShares Swiss Franc Trust",
      popularity: 0,
    },
    {
      slug: "nyse-fxg",
      code: "NYSE:FXG",
      companyName: "First Trust Consumer Staples AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fxh",
      code: "NYSE:FXH",
      companyName: "First Trust Health Care AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fxi",
      code: "NYSE:FXI",
      companyName: "iShares China Large-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fxl",
      code: "NYSE:FXL",
      companyName: "First Trust Technology AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fxlv",
      code: "NYSE:FXLV",
      companyName: "F45 Training Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-fxn",
      code: "NYSE:FXN",
      companyName: "First Trust Energy AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fxnc",
      code: "NYSE:FXNC",
      companyName: "FIRST NATL CORP STRASBURG VA",
      popularity: 0,
    },
    {
      slug: "nyse-fxo",
      code: "NYSE:FXO",
      companyName: "First Trust Financials AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fxp",
      code: "NYSE:FXP",
      companyName: "ProShares UltraShort FTSE China 50 of ProShares Trust",
      popularity: 0,
    },
    {
      slug: "nyse-fxr",
      code: "NYSE:FXR",
      companyName: "First Trust Industrials/Producer Durables AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fxu",
      code: "NYSE:FXU",
      companyName: "First Trust Utilities AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fxy",
      code: "NYSE:FXY",
      companyName: "Invesco CurrencyShares Japanese Yen Trust",
      popularity: 0,
    },
    {
      slug: "nyse-fxz",
      code: "NYSE:FXZ",
      companyName: "First Trust Materials AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fybr",
      code: "NYSE:FYBR",
      companyName: "Frontier Communications Parent Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fyc",
      code: "NYSE:FYC",
      companyName: "First Trust Small Cap Growth AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fyld",
      code: "NYSE:FYLD",
      companyName: "Cambria Foreign Shareholder Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fyt",
      code: "NYSE:FYT",
      companyName: "First Trust Small Cap Value AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fyx",
      code: "NYSE:FYX",
      companyName: "First Trust Small Cap Core AlphaDEX Fund",
      popularity: 0,
    },
    {
      slug: "nyse-fzt",
      code: "NYSE:FZT",
      companyName: "FAST Acquisition Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-g",
      code: "NYSE:G",
      companyName: "GENPACT LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-gaa",
      code: "NYSE:GAA",
      companyName: "Cambria Global Asset Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gab",
      code: "NYSE:GAB",
      companyName: "The Gabelli Equity Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gab-g",
      code: "NYSE:GAB-G",
      companyName:
        "The Gabelli Equity Trust Inc. Series G Cumulative Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-gab-h",
      code: "NYSE:GAB-H",
      companyName:
        "THE GABELLI EQUITY TRUST INC. 5.00% Series H Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gab-k",
      code: "NYSE:GAB-K",
      companyName:
        "The Gabelli Equity Trust Inc. 5.00% Series K Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gabc",
      code: "NYSE:GABC",
      companyName: "German American Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gabf",
      code: "NYSE:GABF",
      companyName: "Gabelli Financial Services Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gacq",
      code: "NYSE:GACQ",
      companyName: "Global Consumer Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gacqu",
      code: "NYSE:GACQU",
      companyName: "Global Consumer Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gacqw",
      code: "NYSE:GACQW",
      companyName: "Global Consumer Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gaia",
      code: "NYSE:GAIA",
      companyName: "Gaia Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gain",
      code: "NYSE:GAIN",
      companyName: "Gladstone Investment Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gainn",
      code: "NYSE:GAINN",
      companyName: "Gladstone Investment Corporation 5.00% Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-gainz",
      code: "NYSE:GAINZ",
      companyName: "Gladstone Investment Corporation 4.875% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-gal",
      code: "NYSE:GAL",
      companyName: "SPDR SSgA Global Allocation ETF of SSgA Active Trust",
      popularity: 0,
    },
    {
      slug: "nyse-galt",
      code: "NYSE:GALT",
      companyName: "Galectin Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gam",
      code: "NYSE:GAM",
      companyName: "General American Investors Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gam-b",
      code: "NYSE:GAM-B",
      companyName:
        "General American Investors Company Inc  5.95% Cumul Pfd Stock Ser B",
      popularity: 0,
    },
    {
      slug: "nyse-gamb",
      code: "NYSE:GAMB",
      companyName: "Gambling.com Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gamc",
      code: "NYSE:GAMC",
      companyName: "Golden Arrow Merger Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gamcu",
      code: "NYSE:GAMCU",
      companyName: "Golden Arrow Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gamcw",
      code: "NYSE:GAMCW",
      companyName: "Golden Arrow Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-game",
      code: "NYSE:GAME",
      companyName: "Engine Gaming and Media Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gbf",
      code: "NYSE:GBF",
      companyName: "iShares Government/Credit Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gamr",
      code: "NYSE:GAMR",
      companyName: "Wedbush ETFMG Video Game Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gan",
      code: "NYSE:GAN",
      companyName: "GAN Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ganx",
      code: "NYSE:GANX",
      companyName: "Gain Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gapa",
      code: "NYSE:GAPA",
      companyName: "G&P Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-gaq",
      code: "NYSE:GAQ",
      companyName: "Generation Asia I Acquisition Limited",
      popularity: 0,
    },
    {
      slug: "nyse-gass",
      code: "NYSE:GASS",
      companyName: "StealthGas Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gast",
      code: "NYSE:GAST",
      companyName: "Gabelli Automation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gate",
      code: "NYSE:GATE",
      companyName: "Marblegate Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gateu",
      code: "NYSE:GATEU",
      companyName: "Marblegate Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gatew",
      code: "NYSE:GATEW",
      companyName: "Marblegate Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gato",
      code: "NYSE:GATO",
      companyName: "Gatos Silver Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gatx",
      code: "NYSE:GATX",
      companyName: "GATX Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gau",
      code: "NYSE:GAU",
      companyName: "Galiano Gold Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gaz",
      code: "NYSE:GAZ",
      companyName:
        "iPath Series B Bloomberg Natural Gas Total Return Sub-Index ETN",
      popularity: 0,
    },
    {
      slug: "nyse-gb",
      code: "NYSE:GB",
      companyName: "Global Blue Group Holding AG",
      popularity: 0,
    },
    {
      slug: "nyse-gbab",
      code: "NYSE:GBAB",
      companyName:
        "Guggenheim Taxable Municipal Bond & Investment Grade Debt Trust",
      popularity: 0,
    },
    {
      slug: "nyse-gbbk",
      code: "NYSE:GBBK",
      companyName: "Global Blockchain Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gbbkr",
      code: "NYSE:GBBKR",
      companyName: "Global Blockchain Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-gbbkw",
      code: "NYSE:GBBKW",
      companyName: "Global Blockchain Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gbci",
      code: "NYSE:GBCI",
      companyName: "Glacier Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-gbdc",
      code: "NYSE:GBDC",
      companyName: "Golub Capital BDC Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gbdv",
      code: "NYSE:GBDV",
      companyName: "Global Beta Smart Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gbgr",
      code: "NYSE:GBGR",
      companyName: "Global Beta Rising Stars ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gbil",
      code: "NYSE:GBIL",
      companyName: "Goldman Sachs Access Treasury 0-1 Year ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gbio",
      code: "NYSE:GBIO",
      companyName: "Generation Bio Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gbl",
      code: "NYSE:GBL",
      companyName: "GAMCO Investors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gbld",
      code: "NYSE:GBLD",
      companyName: "Invesco MSCI Green Building ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gbli",
      code: "NYSE:GBLI",
      companyName: "Global Indemnity Group LLC",
      popularity: 0,
    },
    {
      slug: "nyse-gblo",
      code: "NYSE:GBLO",
      companyName: "Global Beta Low Beta ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gbnh",
      code: "NYSE:GBNH",
      companyName: "Greenbrook TMS Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gbny",
      code: "NYSE:GBNY",
      companyName: "Generations Bancorp NY Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gbox",
      code: "NYSE:GBOX",
      companyName: "GreenBox POS Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gbr",
      code: "NYSE:GBR",
      companyName: "New Concept Energy Inc",
      popularity: 0,
    },
    {
      slug: "nyse-gbrg",
      code: "NYSE:GBRG",
      companyName: "Goldenbridge Acquisition Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gbrgr",
      code: "NYSE:GBRGR",
      companyName: "Goldenbridge Acquisition Limited Right",
      popularity: 0,
    },
    {
      slug: "nyse-gbrgu",
      code: "NYSE:GBRGU",
      companyName: "Goldenbridge Acquisition Limited Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gbrgw",
      code: "NYSE:GBRGW",
      companyName: "Goldenbridge Acquisition Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gbs",
      code: "NYSE:GBS",
      companyName: "GBS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gbt",
      code: "NYSE:GBT",
      companyName: "Global Blood Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gbtg",
      code: "NYSE:GBTG",
      companyName: "Global Business Travel Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gbug",
      code: "NYSE:GBUG",
      companyName: "Pacer iPath Gold ETNs",
      popularity: 0,
    },
    {
      slug: "nyse-gbuy",
      code: "NYSE:GBUY",
      companyName: "Goldman Sachs Future Consumer Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gbx",
      code: "NYSE:GBX",
      companyName: "The Greenbrier Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gcbc",
      code: "NYSE:GCBC",
      companyName: "Greene County Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-gcc",
      code: "NYSE:GCC",
      companyName: "WisdomTree Enhanced Commodity Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-gci",
      code: "NYSE:GCI",
      companyName: "Gannett Co. Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gcig",
      code: "NYSE:GCIG",
      companyName: "Genuine Investors ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gcln",
      code: "NYSE:GCLN",
      companyName: "Goldman Sachs Bloomberg Clean Energy Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gcmg",
      code: "NYSE:GCMG",
      companyName: "GCM Grosvenor Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gcmgw",
      code: "NYSE:GCMGW",
      companyName: "GCM Grosvenor Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gco",
      code: "NYSE:GCO",
      companyName: "Genesco Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gcor",
      code: "NYSE:GCOR",
      companyName: "Goldman Sachs Access U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gcow",
      code: "NYSE:GCOW",
      companyName: "Pacer Global Cash Cows Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gcp",
      code: "NYSE:GCP",
      companyName: "GCP Applied Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gct",
      code: "NYSE:GCT",
      companyName: "GigaCloud Technology Inc Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gctk",
      code: "NYSE:GCTK",
      companyName: "GlucoTrack Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gcv",
      code: "NYSE:GCV",
      companyName: "The Gabelli Convertible and Income Securities Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gd",
      code: "NYSE:GD",
      companyName: "General Dynamics Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gddy",
      code: "NYSE:GDDY",
      companyName: "GoDaddy Inc",
      popularity: 0,
    },
    {
      slug: "nyse-gde",
      code: "NYSE:GDE",
      companyName: "WisdomTree Efficient Gold Plus Equity Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-gden",
      code: "NYSE:GDEN",
      companyName: "Golden Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gdev",
      code: "NYSE:GDEV",
      companyName: "Nexters Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gdevw",
      code: "NYSE:GDEVW",
      companyName: "Nexters Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gdiv",
      code: "NYSE:GDIV",
      companyName: "Harbor Dividend Growth Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gdl",
      code: "NYSE:GDL",
      companyName: "The GDL Fund",
      popularity: 0,
    },
    {
      slug: "nyse-gdl-c",
      code: "NYSE:GDL-C",
      companyName:
        "GDL Fund The Series C Cumulative Puttable and Callable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gdma",
      code: "NYSE:GDMA",
      companyName: "Gadsden Dynamic Multi-Asset ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gdmn",
      code: "NYSE:GDMN",
      companyName: "WisdomTree Efficient Gold Plus Gold Miners Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-gdnr",
      code: "NYSE:GDNR",
      companyName: "Gardiner Healthcare Acquisitions Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gdnru",
      code: "NYSE:GDNRU",
      companyName: "Gardiner Healthcare Acquisitions Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gdnrw",
      code: "NYSE:GDNRW",
      companyName: "Gardiner Healthcare Acquisitions Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gdo",
      code: "NYSE:GDO",
      companyName:
        "Western Asset Global Corporate Defined Opportunity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gdoc",
      code: "NYSE:GDOC",
      companyName: "Goldman Sachs Future Health Care Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gdot",
      code: "NYSE:GDOT",
      companyName: "Green Dot Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gdrx",
      code: "NYSE:GDRX",
      companyName: "GoodRx Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gds",
      code: "NYSE:GDS",
      companyName: "GDS Holdings Limited ADS",
      popularity: 0,
    },
    {
      slug: "nyse-gdst",
      code: "NYSE:GDST",
      companyName: "Goldenstone Acquisition Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gdstr",
      code: "NYSE:GDSTR",
      companyName: "Goldenstone Acquisition Limited Rights",
      popularity: 0,
    },
    {
      slug: "nyse-gdstu",
      code: "NYSE:GDSTU",
      companyName: "Goldenstone Acquisition Limited Units",
      popularity: 0,
    },
    {
      slug: "nyse-gdstw",
      code: "NYSE:GDSTW",
      companyName: "Goldenstone Acquisition Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-gdv",
      code: "NYSE:GDV",
      companyName: "The Gabelli Dividend & Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-gdv-h",
      code: "NYSE:GDV-H",
      companyName:
        "The Gabelli Dividend & Income Trust 5.375% Series H Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gdv-k",
      code: "NYSE:GDV-K",
      companyName:
        "The Gabelli Dividend & Income Trust 4.250% Series K Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gdvd",
      code: "NYSE:GDVD",
      companyName: "R3 Global Dividend Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gdxd",
      code: "NYSE:GDXD",
      companyName: "MicroSectors Gold Miners -3x Inverse Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-gdxu",
      code: "NYSE:GDXU",
      companyName: "MicroSectors Gold Miners 3x Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-gdyn",
      code: "NYSE:GDYN",
      companyName: "Grid Dynamics Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gecc",
      code: "NYSE:GECC",
      companyName: "Great Elm Capital. Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-geccm",
      code: "NYSE:GECCM",
      companyName: "Great Elm Capital Corp. 6.75% Notes Due 2025",
      popularity: 0,
    },
    {
      slug: "nyse-geccn",
      code: "NYSE:GECCN",
      companyName: "Great Elm Capital Corp. 6.5% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nyse-gecco",
      code: "NYSE:GECCO",
      companyName: "Great Elm Capital Corp. 5.875% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-geex",
      code: "NYSE:GEEX",
      companyName:
        "Games & Esports Experience Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-geexu",
      code: "NYSE:GEEXU",
      companyName: "Games & Esports Experience Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-geexw",
      code: "NYSE:GEEXW",
      companyName: "Games & Esports Experience Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-gef",
      code: "NYSE:GEF",
      companyName: "Greif Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-geg",
      code: "NYSE:GEG",
      companyName: "Great Elm Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-geggl",
      code: "NYSE:GEGGL",
      companyName: "Great Elm Group Inc. 7.25% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nyse-gehi",
      code: "NYSE:GEHI",
      companyName: "Gravitas Education Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gel",
      code: "NYSE:GEL",
      companyName: "Genesis Energy L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-gem",
      code: "NYSE:GEM",
      companyName: "Goldman Sachs ActiveBeta Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gemd",
      code: "NYSE:GEMD",
      companyName: "Goldman Sachs Access Emerging Markets USD Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-genc",
      code: "NYSE:GENC",
      companyName: "Gencor Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gene",
      code: "NYSE:GENE",
      companyName: "Genetic Technologies Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-geni",
      code: "NYSE:GENI",
      companyName: "Genius Sports Limited",
      popularity: 0,
    },
    {
      slug: "nyse-genq",
      code: "NYSE:GENQ",
      companyName: "Genesis Unicorn Capital Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-genqu",
      code: "NYSE:GENQU",
      companyName: "Genesis Unicorn Capital Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-genqw",
      code: "NYSE:GENQW",
      companyName: "Genesis Unicorn Capital Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-geny",
      code: "NYSE:GENY",
      companyName:
        "Principal Exchange-Traded Funds Principal Millennial Global Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-geo",
      code: "NYSE:GEO",
      companyName: "The GEO Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-geos",
      code: "NYSE:GEOS",
      companyName: "Geospace Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ger",
      code: "NYSE:GER",
      companyName: "Goldman Sachs MLP Energy Renaissance Fund",
      popularity: 0,
    },
    {
      slug: "nyse-germ",
      code: "NYSE:GERM",
      companyName: "ETFMG Treatments Testing and Advancements ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ges",
      code: "NYSE:GES",
      companyName: "Guess? Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-get",
      code: "NYSE:GET",
      companyName:
        "Getnet Adquirencia e Servicos para Meios de Pagamento S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gety",
      code: "NYSE:GETY",
      companyName: "Getty Images Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gevo",
      code: "NYSE:GEVO",
      companyName: "Gevo Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gf",
      code: "NYSE:GF",
      companyName: "NEW GERMANY FUND Inc",
      popularity: 0,
    },
    {
      slug: "nyse-gfai",
      code: "NYSE:GFAI",
      companyName: "Guardforce AI Co. Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gfaiw",
      code: "NYSE:GFAIW",
      companyName: "Guardforce AI Co. Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gff",
      code: "NYSE:GFF",
      companyName: "Griffon Corp",
      popularity: 0,
    },
    {
      slug: "nyse-gfgd",
      code: "NYSE:GFGD",
      companyName:
        "The Growth for Good Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gfgdr",
      code: "NYSE:GFGDR",
      companyName: "The Growth for Good Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nyse-gfgdu",
      code: "NYSE:GFGDU",
      companyName: "The Growth for Good Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gfgdw",
      code: "NYSE:GFGDW",
      companyName: "The Growth for Good Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gfgf",
      code: "NYSE:GFGF",
      companyName: "Guru Favorite Stocks ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gfi",
      code: "NYSE:GFI",
      companyName: "Gold Fields Ltd ADR",
      popularity: 0,
    },
    {
      slug: "nyse-gflu",
      code: "NYSE:GFLU",
      companyName: "GFL Environmental Inc. Tangible Equity Units",
      popularity: 0,
    },
    {
      slug: "nyse-gfof",
      code: "NYSE:GFOF",
      companyName: "Grayscale Future of Finance ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gfor",
      code: "NYSE:GFOR",
      companyName: "Graf Acquisition Corp. IV",
      popularity: 0,
    },
    {
      slug: "nyse-gfs",
      code: "NYSE:GFS",
      companyName: "GlobalFoundries Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gfx",
      code: "NYSE:GFX",
      companyName: "Golden Falcon Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ggaa",
      code: "NYSE:GGAA",
      companyName:
        "Genesis Growth Tech Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ggaau",
      code: "NYSE:GGAAU",
      companyName: "Genesis Growth Tech Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ggaaw",
      code: "NYSE:GGAAW",
      companyName: "Genesis Growth Tech Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ggal",
      code: "NYSE:GGAL",
      companyName: "Grupo Financiero Galicia SA",
      popularity: 0,
    },
    {
      slug: "nyse-ggb",
      code: "NYSE:GGB",
      companyName: "Gerdau S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-gge",
      code: "NYSE:GGE",
      companyName: "Green Giant Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ggmc",
      code: "NYSE:GGMC",
      companyName: "Glenfarne Merger Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ggmcu",
      code: "NYSE:GGMCU",
      companyName: "Glenfarne Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ggmcw",
      code: "NYSE:GGMCW",
      companyName: "Glenfarne Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ggn",
      code: "NYSE:GGN",
      companyName: "GAMCO Global Gold Natural Resources & Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-ggn-b",
      code: "NYSE:GGN-B",
      companyName:
        "GAMCO Global Gold Natural Resources & Income Trust 5.00% Series B",
      popularity: 0,
    },
    {
      slug: "nyse-ggr",
      code: "NYSE:GGR",
      companyName: "Gogoro Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ggrow",
      code: "NYSE:GGROW",
      companyName: "Gogoro Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ggrw",
      code: "NYSE:GGRW",
      companyName: "Gabelli Growth Innovators ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ggt",
      code: "NYSE:GGT",
      companyName: "THE GABELLI MULTIMEDIA TRUST INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ggt-e",
      code: "NYSE:GGT-E",
      companyName:
        "The Gabelli Multimedia Trust Inc. 5.125 Percent Series E Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ggt-g",
      code: "NYSE:GGT-G",
      companyName:
        "The Gabelli Multimedia Trust Inc. 5.125% Series G Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ggz",
      code: "NYSE:GGZ",
      companyName: "The Gabelli Global Small and Mid Cap Value Trust",
      popularity: 0,
    },
    {
      slug: "nyse-gh",
      code: "NYSE:GH",
      companyName: "Guardant Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ghac",
      code: "NYSE:GHAC",
      companyName:
        "Gaming & Hospitality Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ghacu",
      code: "NYSE:GHACU",
      companyName: "Gaming & Hospitality Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ghacw",
      code: "NYSE:GHACW",
      companyName: "Gaming & Hospitality Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-ghc",
      code: "NYSE:GHC",
      companyName: "GRAHAM HOLDINGS COMPANY",
      popularity: 0,
    },
    {
      slug: "nyse-ghg",
      code: "NYSE:GHG",
      companyName:
        "GreenTree Hospitality Group Ltd. American depositary shares each representing one Class A ordinary ",
      popularity: 0,
    },
    {
      slug: "nyse-ghix",
      code: "NYSE:GHIX",
      companyName: "Gores Holdings IX Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ghixu",
      code: "NYSE:GHIXU",
      companyName: "Gores Holdings IX Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ghixw",
      code: "NYSE:GHIXW",
      companyName: "Gores Holdings IX Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ghl",
      code: "NYSE:GHL",
      companyName: "Greenhill & Co. Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ghld",
      code: "NYSE:GHLD",
      companyName: "Guild Holdings Company",
      popularity: 0,
    },
    {
      slug: "nyse-ghm",
      code: "NYSE:GHM",
      companyName: "Graham Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ghrs",
      code: "NYSE:GHRS",
      companyName: "GH Research PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ghsi",
      code: "NYSE:GHSI",
      companyName: "Guardion Health Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ghta",
      code: "NYSE:GHTA",
      companyName: "Goose Hollow Tactical Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ghy",
      code: "NYSE:GHY",
      companyName: "PGIM Global High Yield Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gia",
      code: "NYSE:GIA",
      companyName: "GigCapital 5 Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-giac",
      code: "NYSE:GIAC",
      companyName: "Gesher I Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-giacu",
      code: "NYSE:GIACU",
      companyName: "Gesher I Acquisition Corp.Unit",
      popularity: 0,
    },
    {
      slug: "nyse-giacw",
      code: "NYSE:GIACW",
      companyName: "Gesher I Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-gib",
      code: "NYSE:GIB",
      companyName: "CGI Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gic",
      code: "NYSE:GIC",
      companyName: "Global Industrial Company",
      popularity: 0,
    },
    {
      slug: "nyse-gifi",
      code: "NYSE:GIFI",
      companyName: "Gulf Island Fabrication Inc",
      popularity: 0,
    },
    {
      slug: "nyse-gigm",
      code: "NYSE:GIGM",
      companyName: "GigaMedia Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-gii",
      code: "NYSE:GII",
      companyName: "SPDR S&P Global Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-giii",
      code: "NYSE:GIII",
      companyName: "G-Iii Apparel Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-giix",
      code: "NYSE:GIIX",
      companyName: "Gores Holdings VIII Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-giixu",
      code: "NYSE:GIIXU",
      companyName: "Gores Holdings VIII Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-giixw",
      code: "NYSE:GIIXW",
      companyName: "Gores Holdings VIII Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gil",
      code: "NYSE:GIL",
      companyName: "Gildan Activewear Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gilt",
      code: "NYSE:GILT",
      companyName: "Gilat Satellite Networks Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-gim",
      code: "NYSE:GIM",
      companyName: "Templeton Global Income Fund (Delaware)",
      popularity: 0,
    },
    {
      slug: "nyse-ginn",
      code: "NYSE:GINN",
      companyName: "Goldman Sachs Innovate Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gipr",
      code: "NYSE:GIPR",
      companyName: "Generation Income Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ghyb",
      code: "NYSE:GHYB",
      companyName: "Goldman Sachs Access High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ghyg",
      code: "NYSE:GHYG",
      companyName: "iShares US & Intl High Yield Corp Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gigb",
      code: "NYSE:GIGB",
      companyName: "Goldman Sachs Access Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-giprw",
      code: "NYSE:GIPRW",
      companyName: "Generation Income Properties Inc Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gis",
      code: "NYSE:GIS",
      companyName: "General Mills Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-giw",
      code: "NYSE:GIW",
      companyName: "GigInternational1 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-giwwu",
      code: "NYSE:GIWWU",
      companyName: "GigInternational1 Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-giwww",
      code: "NYSE:GIWWW",
      companyName: "GigInternational1 Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gjh",
      code: "NYSE:GJH",
      companyName:
        "Synthetic Fixed-Income Sec STRATS 2004-06 6.375% US Cellular Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-gjo",
      code: "NYSE:GJO",
      companyName:
        "Synthetic Fixed-Income Securities Inc. 4.65% Floating Rate STRATS Certificates Series 2005-4",
      popularity: 0,
    },
    {
      slug: "nyse-gjp",
      code: "NYSE:GJP",
      companyName:
        "Synthetic Fixed Income Securities on the behalf of STRATS for Dominion Resources  Series 2005-6",
      popularity: 0,
    },
    {
      slug: "nyse-gjr",
      code: "NYSE:GJR",
      companyName:
        "Synthetic Fixed Income Securities Inc. Floating Rate Structured Repackaged Asset-Backed Trust Secur",
      popularity: 0,
    },
    {
      slug: "nyse-gjs",
      code: "NYSE:GJS",
      companyName:
        "Synthetic Fixed-Income Securities STRATS 2006-2 Goldman Sachs Group",
      popularity: 0,
    },
    {
      slug: "nyse-gjt",
      code: "NYSE:GJT",
      companyName:
        "Synthetic Fixed-Income Securities STRATS 2006-3 AllState Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gk",
      code: "NYSE:GK",
      companyName: "AdvisorShares Gerber Kawasaki ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gkos",
      code: "NYSE:GKOS",
      companyName: "Glaukos Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gl",
      code: "NYSE:GL",
      companyName: "Globe Life Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gl-d",
      code: "NYSE:GL-D",
      companyName:
        "Globe Life Inc. 4.25% Junior Subordinated Debentures due 2061",
      popularity: 0,
    },
    {
      slug: "nyse-glad",
      code: "NYSE:GLAD",
      companyName: "Gladstone Capital Corp",
      popularity: 0,
    },
    {
      slug: "nyse-glbe",
      code: "NYSE:GLBE",
      companyName: "Global-E Online Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-glbl",
      code: "NYSE:GLBL",
      companyName: "Cartesian Growth Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-glblu",
      code: "NYSE:GLBLU",
      companyName: "Cartesian Growth Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-glblw",
      code: "NYSE:GLBLW",
      companyName: "Cartesian Growth Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-glbs",
      code: "NYSE:GLBS",
      companyName: "Globus Maritime Limited",
      popularity: 0,
    },
    {
      slug: "nyse-glbz",
      code: "NYSE:GLBZ",
      companyName: "Glen Burnie Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-glcn",
      code: "NYSE:GLCN",
      companyName: "VanEck China Growth Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gldb",
      code: "NYSE:GLDB",
      companyName: "Strategy Shares Gold-Hedged Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gldd",
      code: "NYSE:GLDD",
      companyName: "Great Lakes Dredge & Dock Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gldg",
      code: "NYSE:GLDG",
      companyName: "GoldMining Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gldi",
      code: "NYSE:GLDI",
      companyName:
        "Credit Suisse X-Links Gold Shares Covered Call ETNs due February 2 2033",
      popularity: 0,
    },
    {
      slug: "nyse-gldm",
      code: "NYSE:GLDM",
      companyName: "SPDR Gold MiniShares",
      popularity: 0,
    },
    {
      slug: "nyse-gldx",
      code: "NYSE:GLDX",
      companyName: "USCF GOLD STRATEGY PLUS INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-glee",
      code: "NYSE:GLEE",
      companyName: "Gladstone Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gleeu",
      code: "NYSE:GLEEU",
      companyName: "Gladstone Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gleew",
      code: "NYSE:GLEEW",
      companyName: "Gladstone Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-glg",
      code: "NYSE:GLG",
      companyName: "TD Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-glha",
      code: "NYSE:GLHA",
      companyName: "Glass Houses Acquisition Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-glhau",
      code: "NYSE:GLHAU",
      companyName: "Glass Houses Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-glhaw",
      code: "NYSE:GLHAW",
      companyName: "Glass Houses Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-glif",
      code: "NYSE:GLIF",
      companyName: "AGFiQ Global Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-glin",
      code: "NYSE:GLIN",
      companyName: "VanEck India Growth Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gll",
      code: "NYSE:GLL",
      companyName: "ProShares UltraShort Gold",
      popularity: 0,
    },
    {
      slug: "nyse-glli",
      code: "NYSE:GLLI",
      companyName: "Globalink Investment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gllir",
      code: "NYSE:GLLIR",
      companyName: "Globalink Investment Inc. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-glliu",
      code: "NYSE:GLLIU",
      companyName: "Globalink Investment Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-glliw",
      code: "NYSE:GLLIW",
      companyName: "Globalink Investment Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-glmd",
      code: "NYSE:GLMD",
      companyName: "Galmed Pharmaceuticals Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-glng",
      code: "NYSE:GLNG",
      companyName: "Golar LNG Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-glo",
      code: "NYSE:GLO",
      companyName: "Clough Global Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-glob",
      code: "NYSE:GLOB",
      companyName: "GLOBANT S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-glop",
      code: "NYSE:GLOP",
      companyName: "GASLOG PARTNERS LP",
      popularity: 0,
    },
    {
      slug: "nyse-glop-a",
      code: "NYSE:GLOP-A",
      companyName:
        "GasLog Partners LP 8.625% Series A Cumulative Redeemable Perpetual Fixed to Floating Rate Preference",
      popularity: 0,
    },
    {
      slug: "nyse-glop-b",
      code: "NYSE:GLOP-B",
      companyName:
        "GasLog Partners LP 8.200% Series B Cumulative Redeemable Perpetual Fixed to Floating Rate Preference",
      popularity: 0,
    },
    {
      slug: "nyse-glop-c",
      code: "NYSE:GLOP-C",
      companyName:
        "GasLog Partners LP 8.500% Series C Cumulative Redeemable Perpetual Fixed to Floating Rate Preference",
      popularity: 0,
    },
    {
      slug: "nyse-glov",
      code: "NYSE:GLOV",
      companyName: "Goldman Sachs ActiveBeta World Low Vol Plus Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-glp",
      code: "NYSE:GLP",
      companyName: "Global Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-glp-a",
      code: "NYSE:GLP-A",
      companyName:
        "Global Partners LP 9.75% Series A Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred U",
      popularity: 0,
    },
    {
      slug: "nyse-glp-b",
      code: "NYSE:GLP-B",
      companyName:
        "Global Partners LP 9.50% Series B Fixed Rate Cumulative Redeemable Perpetual Preferred Units represe",
      popularity: 0,
    },
    {
      slug: "nyse-glpg",
      code: "NYSE:GLPG",
      companyName: "Galapagos NV",
      popularity: 0,
    },
    {
      slug: "nyse-glpi",
      code: "NYSE:GLPI",
      companyName: "Gaming and Leisure Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-glq",
      code: "NYSE:GLQ",
      companyName: "Clough Global Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-glre",
      code: "NYSE:GLRE",
      companyName: "Greenlight Captial RE LTD. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-glry",
      code: "NYSE:GLRY",
      companyName: "Inspire Faithward Mid Cap Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gls",
      code: "NYSE:GLS",
      companyName: "Gelesis Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-glsi",
      code: "NYSE:GLSI",
      companyName: "Greenwich LifeSciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-glt",
      code: "NYSE:GLT",
      companyName: "Glatfelter Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-glta",
      code: "NYSE:GLTA",
      companyName: "Galata Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-glto",
      code: "NYSE:GLTO",
      companyName: "Galecto Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gltr",
      code: "NYSE:GLTR",
      companyName: "abrdn Physical Precious Metals Basket Shares ETF",
      popularity: 0,
    },
    {
      slug: "nyse-glu",
      code: "NYSE:GLU",
      companyName: "The Gabelli Utility & Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-glu-a",
      code: "NYSE:GLU-A",
      companyName: "The Gabelli Global Utility & Income Trust Series A",
      popularity: 0,
    },
    {
      slug: "nyse-glu-b",
      code: "NYSE:GLU-B",
      companyName:
        "The Gabelli Global Utility & Income Trust Series B Cumulative Puttable and Callable Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-glue",
      code: "NYSE:GLUE",
      companyName: "Monte Rosa Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-glv",
      code: "NYSE:GLV",
      companyName: "Clough Global Dividend and Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-glw",
      code: "NYSE:GLW",
      companyName: "Corning Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-glyc",
      code: "NYSE:GLYC",
      companyName: "GlycoMimetics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gmab",
      code: "NYSE:GMAB",
      companyName: "Genmab A/S ADS",
      popularity: 0,
    },
    {
      slug: "nyse-gmbl",
      code: "NYSE:GMBL",
      companyName: "Esports Entertainment Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gmblp",
      code: "NYSE:GMBLP",
      companyName:
        "Esports Entertainment Group Inc. 10.0% Series A Cumulative Redeemable Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gmblw",
      code: "NYSE:GMBLW",
      companyName: "Esports Entertainment Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gmblz",
      code: "NYSE:GMBLZ",
      companyName: "Esports Entertainment Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gmda",
      code: "NYSE:GMDA",
      companyName: "Gamida Cell Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gme",
      code: "NYSE:GME",
      companyName: "GameStop Corp. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-gmed",
      code: "NYSE:GMED",
      companyName: "GLOBUS MEDICAL INC",
      popularity: 0,
    },
    {
      slug: "nyse-gmf",
      code: "NYSE:GMF",
      companyName: "SPDR S&P Emerging Asia Pacific ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gmfi",
      code: "NYSE:GMFI",
      companyName: "Aetherium Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gmfiu",
      code: "NYSE:GMFIU",
      companyName: "Aetherium Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gmfiw",
      code: "NYSE:GMFIW",
      companyName: "Aetherium Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gmgi",
      code: "NYSE:GMGI",
      companyName: "Golden Matrix Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gmom",
      code: "NYSE:GMOM",
      companyName: "Cambria Global Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gmre-a",
      code: "NYSE:GMRE-A",
      companyName:
        "Global Medical REIT Inc. Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gms",
      code: "NYSE:GMS",
      companyName: "GMS Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gmtx",
      code: "NYSE:GMTX",
      companyName: "Gemini Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gmvd",
      code: "NYSE:GMVD",
      companyName: "G Medical Innovations Holdings Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gmvdw",
      code: "NYSE:GMVDW",
      companyName: "G Medical Innovations Holdings Ltd. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-gnac",
      code: "NYSE:GNAC",
      companyName: "Group Nine Acquisition Corp. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-gnacu",
      code: "NYSE:GNACU",
      companyName: "Group Nine Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gnacw",
      code: "NYSE:GNACW",
      companyName: "Group Nine Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gne",
      code: "NYSE:GNE",
      companyName: "GENIE ENERGY LTD",
      popularity: 0,
    },
    {
      slug: "nyse-gne-a",
      code: "NYSE:GNE-A",
      companyName:
        "GENIE ENERGY LTD. Series 2012-A Preferred Stock $0.01 par value",
      popularity: 0,
    },
    {
      slug: "nyse-gnft",
      code: "NYSE:GNFT",
      companyName: "GENFIT S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gnk",
      code: "NYSE:GNK",
      companyName: "GENCO SHIPPING & TRADING LTD",
      popularity: 0,
    },
    {
      slug: "nyse-gnl",
      code: "NYSE:GNL",
      companyName: "Global Net Lease Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gnl-a",
      code: "NYSE:GNL-A",
      companyName:
        "Global Net Lease Inc. 7.25% Series A Cumulative Redeemable Preferred Stock $0.01 par value per sha",
      popularity: 0,
    },
    {
      slug: "nyse-gnl-b",
      code: "NYSE:GNL-B",
      companyName:
        "Global Net Lease Inc. 6.875% Series B Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gnln",
      code: "NYSE:GNLN",
      companyName: "Greenlane Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gnma",
      code: "NYSE:GNMA",
      companyName: "iShares GNMA Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gnom",
      code: "NYSE:GNOM",
      companyName: "Global X Genomics & Biotechnology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gnr",
      code: "NYSE:GNR",
      companyName: "SPDR S&P Global Natural Resources ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gns",
      code: "NYSE:GNS",
      companyName: "Genius Group Limited",
      popularity: 0,
    },
    {
      slug: "nyse-gnss",
      code: "NYSE:GNSS",
      companyName: "Genasys Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gnt",
      code: "NYSE:GNT",
      companyName: "GAMCO Natural Resources Gold & Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-gnt-a",
      code: "NYSE:GNT-A",
      companyName:
        "GAMCO Natural Resources Gold & Income Trust 5.2 Percent Series A Cumulative Preferred Shares (Liqui",
      popularity: 0,
    },
    {
      slug: "nyse-gnta",
      code: "NYSE:GNTA",
      companyName: "Genenta Science S.p.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gntx",
      code: "NYSE:GNTX",
      companyName: "Gentex Corp",
      popularity: 0,
    },
    {
      slug: "nyse-gnty",
      code: "NYSE:GNTY",
      companyName: "Guaranty Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gnus",
      code: "NYSE:GNUS",
      companyName: "Genius Brands International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gnw",
      code: "NYSE:GNW",
      companyName: "Genworth Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-go",
      code: "NYSE:GO",
      companyName: "Grocery Outlet Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-goau",
      code: "NYSE:GOAU",
      companyName: "US Global GO Gold and Precious Metal Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-goco",
      code: "NYSE:GOCO",
      companyName: "GoHealth Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-goev",
      code: "NYSE:GOEV",
      companyName: "Canoo Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-goevw",
      code: "NYSE:GOEVW",
      companyName: "Canoo Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gof",
      code: "NYSE:GOF",
      companyName: "Guggenheim Strategic Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-goex",
      code: "NYSE:GOEX",
      companyName: "Global X Gold Explorers ETF (NEW)",
      popularity: 0,
    },
    {
      slug: "nyse-gmet",
      code: "NYSE:GMET",
      companyName: "VanEck Green Metals ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gogl",
      code: "NYSE:GOGL",
      companyName: "Golden Ocean Group Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gogn",
      code: "NYSE:GOGN",
      companyName: "GoGreen Investments Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gogo",
      code: "NYSE:GOGO",
      companyName: "Gogo Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gol",
      code: "NYSE:GOL",
      companyName:
        "Gol Linhas A‚reas Inteligentes S.A. American Depositary Shares (Each representing Ten Preferred Shar",
      popularity: 0,
    },
    {
      slug: "nyse-golf",
      code: "NYSE:GOLF",
      companyName: "Acushnet Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-good",
      code: "NYSE:GOOD",
      companyName: "Gladstone Commercial Corporation - REIT",
      popularity: 0,
    },
    {
      slug: "nyse-goodn",
      code: "NYSE:GOODN",
      companyName:
        "Gladstone Commercial Corporation 6.625% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-goodo",
      code: "NYSE:GOODO",
      companyName:
        "Gladstone Commercial Corporation 6.00% Series G Cumulative Redeemable Preferred Stock par value $0.",
      popularity: 0,
    },
    {
      slug: "nyse-goos",
      code: "NYSE:GOOS",
      companyName: "Canada Goose Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-goro",
      code: "NYSE:GORO",
      companyName: "Gold Resource Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-goss",
      code: "NYSE:GOSS",
      companyName: "Gossamer Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gotu",
      code: "NYSE:GOTU",
      companyName:
        "Gaotu Techedu Inc. American Depositary Shares three of which representing two Class A Ordinary Shar",
      popularity: 0,
    },
    {
      slug: "nyse-govt",
      code: "NYSE:GOVT",
      companyName: "iShares U.S. Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-govx",
      code: "NYSE:GOVX",
      companyName: "GeoVax Labs Inc. New",
      popularity: 0,
    },
    {
      slug: "nyse-govxw",
      code: "NYSE:GOVXW",
      companyName: "GeoVax Labs Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-govz",
      code: "NYSE:GOVZ",
      companyName: "iShares 25+ Year Treasury STRIPS Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gp",
      code: "NYSE:GP",
      companyName: "GreenPower Motor Company Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gpac",
      code: "NYSE:GPAC",
      companyName: "Global Partner Acquisition Corp II Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-gpacu",
      code: "NYSE:GPACU",
      companyName: "Global Partner Acquisition Corp II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gpacw",
      code: "NYSE:GPACW",
      companyName: "Global Partner Acquisition Corp II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gpal",
      code: "NYSE:GPAL",
      companyName:
        "Goldman Sachs ActiveBeta Paris-Aligned Climate U.S. Large Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gpc",
      code: "NYSE:GPC",
      companyName: "Genuine Parts Company",
      popularity: 0,
    },
    {
      slug: "nyse-gpco",
      code: "NYSE:GPCO",
      companyName: "Golden Path Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gpcor",
      code: "NYSE:GPCOR",
      companyName: "Golden Path Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nyse-gpcou",
      code: "NYSE:GPCOU",
      companyName: "Golden Path Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nyse-gpcow",
      code: "NYSE:GPCOW",
      companyName: "Golden Path Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gpi",
      code: "NYSE:GPI",
      companyName: "Group 1 Automotive Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gpja",
      code: "NYSE:GPJA",
      companyName:
        "Georgia Power Company Series 2017A 5.00 Percent Junior Subordinated Notes due October 1 2077",
      popularity: 0,
    },
    {
      slug: "nyse-gpl",
      code: "NYSE:GPL",
      companyName: "Great Panther Mining Limited",
      popularity: 0,
    },
    {
      slug: "nyse-gpmt",
      code: "NYSE:GPMT",
      companyName: "Granite Point Mortgage Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gpmt-a",
      code: "NYSE:GPMT-A",
      companyName:
        "Granite Point Mortgage Trust Inc. 7.00% Series A Fixed-to-Floating Rate Cumulative Redeemable Prefer",
      popularity: 0,
    },
    {
      slug: "nyse-gpn",
      code: "NYSE:GPN",
      companyName: "Global Payments Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gpor",
      code: "NYSE:GPOR",
      companyName: "Gulfport Energy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gpp",
      code: "NYSE:GPP",
      companyName: "Green Plains Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-gpre",
      code: "NYSE:GPRE",
      companyName: "Green Plains Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gprk",
      code: "NYSE:GPRK",
      companyName: "GEOPARK LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-gpro",
      code: "NYSE:GPRO",
      companyName: "GoPro Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gps",
      code: "NYSE:GPS",
      companyName: "The Gap Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gqre",
      code: "NYSE:GQRE",
      companyName: "FlexShares Global Quality Real Estate Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-grab",
      code: "NYSE:GRAB",
      companyName: "Grab Holdings Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-grbk",
      code: "NYSE:GRBK",
      companyName: "Green Brick Partners Inc",
      popularity: 0,
    },
    {
      slug: "nyse-grbk-a",
      code: "NYSE:GRBK-A",
      companyName:
        "Green Brick Partners Inc. Depositary Shares (each representing a 1/1000th fractional interest in a",
      popularity: 0,
    },
    {
      slug: "nyse-grc",
      code: "NYSE:GRC",
      companyName: "The Gorman-Rupp Company Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-grcl",
      code: "NYSE:GRCL",
      companyName: "Gracell Biotechnologies Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-grcy",
      code: "NYSE:GRCY",
      companyName: "Greencity Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-grcyu",
      code: "NYSE:GRCYU",
      companyName: "Greencity Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-grcyw",
      code: "NYSE:GRCYW",
      companyName: "Greencity Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-gree",
      code: "NYSE:GREE",
      companyName: "Greenidge Generation Holdings Inc. Class A Common",
      popularity: 0,
    },
    {
      slug: "nyse-greel",
      code: "NYSE:GREEL",
      companyName:
        "Greenidge Generation Holdings Inc. 8.50% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-grei",
      code: "NYSE:GREI",
      companyName:
        "Goldman Sachs Future Real Estate and Infrastructure Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gres",
      code: "NYSE:GRES",
      companyName: "IQ ARB Global Resources",
      popularity: 0,
    },
    {
      slug: "nyse-grf",
      code: "NYSE:GRF",
      companyName: "Eagle Capital Growth Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-grfs",
      code: "NYSE:GRFS",
      companyName: "Grifois S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-grfx",
      code: "NYSE:GRFX",
      companyName: "Graphex Group Limited",
      popularity: 0,
    },
    {
      slug: "nyse-grid",
      code: "NYSE:GRID",
      companyName:
        "First Trust NASDAQ Clean Edge Smart Grid Infrastructure Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-gril",
      code: "NYSE:GRIL",
      companyName: "Muscle Maker Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-grin",
      code: "NYSE:GRIN",
      companyName: "Grindrod Shipping Holdings Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-grmn",
      code: "NYSE:GRMN",
      companyName: "Garmin Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-grek",
      code: "NYSE:GREK",
      companyName: "Global X MSCI Greece ETF",
      popularity: 0,
    },
    {
      slug: "nyse-grn",
      code: "NYSE:GRN",
      companyName: "iPath Series B Carbon Exchange-Traded Notes",
      popularity: 0,
    },
    {
      slug: "nyse-grna",
      code: "NYSE:GRNA",
      companyName: "GreenLight Biosciences Holdings PBC Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-grnaw",
      code: "NYSE:GRNAW",
      companyName: "GreenLight Biosciences Holdings PBC Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-grnb",
      code: "NYSE:GRNB",
      companyName: "VanEck Green Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-grnq",
      code: "NYSE:GRNQ",
      companyName: "Greenpro Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-grom",
      code: "NYSE:GROM",
      companyName: "Grom Social Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gromw",
      code: "NYSE:GROMW",
      companyName: "Grom Social Enterprises Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-grov",
      code: "NYSE:GROV",
      companyName: "Grove Collaborative Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-grow",
      code: "NYSE:GROW",
      companyName: "US Global Investors Inc",
      popularity: 0,
    },
    {
      slug: "nyse-groy",
      code: "NYSE:GROY",
      companyName: "Gold Royalty Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-grph",
      code: "NYSE:GRPH",
      companyName: "Graphite Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-grpn",
      code: "NYSE:GRPN",
      companyName: "Groupon Inc.Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-grrr",
      code: "NYSE:GRRR",
      companyName: "Gorilla Technology Group Inc. Ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-grrrw",
      code: "NYSE:GRRRW",
      companyName: "Gorilla Technology Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-grts",
      code: "NYSE:GRTS",
      companyName: "Gritstone bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-grtx",
      code: "NYSE:GRTX",
      companyName: "Galera Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gru",
      code: "NYSE:GRU",
      companyName:
        "ELEMENTS Linked to the ICE BofAML Commodity Index eXtra Grains Total Return",
      popularity: 0,
    },
    {
      slug: "nyse-grvy",
      code: "NYSE:GRVY",
      companyName: "GRAVITY Co. Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-grwg",
      code: "NYSE:GRWG",
      companyName: "GROW GENERATION CORP",
      popularity: 0,
    },
    {
      slug: "nyse-grx",
      code: "NYSE:GRX",
      companyName: "The Gabelli Healthcare & Wellness Trust",
      popularity: 0,
    },
    {
      slug: "nyse-grzz",
      code: "NYSE:GRZZ",
      companyName: "Grizzle Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-grnr",
      code: "NYSE:GRNR",
      companyName: "Global X Green Building ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gs-a",
      code: "NYSE:GS-A",
      companyName: "Goldman Sachs Group Inc. (The) Depositary shares",
      popularity: 0,
    },
    {
      slug: "nyse-gs-c",
      code: "NYSE:GS-C",
      companyName:
        "Goldman Sachs Group Dep. Shares (1/1000 Int. of Floating Rate Non-Cum. Prfrd. Stk. Ser. C)",
      popularity: 0,
    },
    {
      slug: "nyse-gs-d",
      code: "NYSE:GS-D",
      companyName:
        "Goldman Sachs Group Inc. (Each representing 1/1000th Interest in a Share of Floating Rate Non-cumul",
      popularity: 0,
    },
    {
      slug: "nyse-gs-j",
      code: "NYSE:GS-J",
      companyName: "GOLDMAN SACHS GROUP INC. 5.50%  SER J",
      popularity: 0,
    },
    {
      slug: "nyse-gs-k",
      code: "NYSE:GS-K",
      companyName: "GOLDMAN SACHS GROUP INC. THE 6.375%",
      popularity: 0,
    },
    {
      slug: "nyse-gsat",
      code: "NYSE:GSAT",
      companyName: "Globalstar Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gsbc",
      code: "NYSE:GSBC",
      companyName: "Great Southern Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-gsee",
      code: "NYSE:GSEE",
      companyName: "Goldman Sachs MarketBeta Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gseu",
      code: "NYSE:GSEU",
      companyName: "Goldman Sachs ActiveBeta Europe Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsev",
      code: "NYSE:GSEV",
      companyName: "Gores Holdings VII Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gsevu",
      code: "NYSE:GSEVU",
      companyName: "Gores Holdings VII Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-gsevw",
      code: "NYSE:GSEVW",
      companyName: "Gores Holdings VII Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gsew",
      code: "NYSE:GSEW",
      companyName: "Goldman Sachs Equal Weight U.S. Large Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsfp",
      code: "NYSE:GSFP",
      companyName: "Goldman Sachs Future Planet Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gshd",
      code: "NYSE:GSHD",
      companyName: "Goosehead Insurance Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gsid",
      code: "NYSE:GSID",
      companyName: "Goldman Sachs MarketBeta International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsie",
      code: "NYSE:GSIE",
      companyName: "Goldman Sachs ActiveBeta International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsit",
      code: "NYSE:GSIT",
      companyName: "GSI Technology",
      popularity: 0,
    },
    {
      slug: "nyse-gsjy",
      code: "NYSE:GSJY",
      companyName: "Goldman Sachs ActiveBeta Japan Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsg",
      code: "NYSE:GSG",
      companyName: "iShares S&P  GSCI Commodity-Indexed Trust",
      popularity: 0,
    },
    {
      slug: "nyse-gsl-b",
      code: "NYSE:GSL-B",
      companyName: "GLOBAL SHIP LEASE INC. 8.75%  SER B",
      popularity: 0,
    },
    {
      slug: "nyse-gslc",
      code: "NYSE:GSLC",
      companyName: "Goldman Sachs ActiveBeta U.S. Large Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsm",
      code: "NYSE:GSM",
      companyName: "Ferroglobe PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gsmg",
      code: "NYSE:GSMG",
      companyName: "Glory Star New Media Group Holdings Limited Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-gsmgw",
      code: "NYSE:GSMGW",
      companyName:
        "Glory Star New Media Group Holdings Limited Warrant expiring 2/13/2025",
      popularity: 0,
    },
    {
      slug: "nyse-gsp",
      code: "NYSE:GSP",
      companyName:
        "Barclays Bank PLC iPath Exchange Traded Notes due 2036 Linked to GSCI Total Return Index",
      popularity: 0,
    },
    {
      slug: "nyse-gspy",
      code: "NYSE:GSPY",
      companyName: "Gotham Enhanced 500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsqb",
      code: "NYSE:GSQB",
      companyName: "G Squared Ascend II Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gsqd",
      code: "NYSE:GSQD",
      companyName: "G Squared Ascend I Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gsrm",
      code: "NYSE:GSRM",
      companyName: "GSR II Meteora Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gsrmr",
      code: "NYSE:GSRMR",
      companyName: "GSR II Meteora Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-gsrmu",
      code: "NYSE:GSRMU",
      companyName: "GSR II Meteora Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gsrmw",
      code: "NYSE:GSRMW",
      companyName: "GSR II Meteora Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gssc",
      code: "NYSE:GSSC",
      companyName: "GS ActiveBeta U.S. Small Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsst",
      code: "NYSE:GSST",
      companyName: "Goldman Sachs Access Ultra Short Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsun",
      code: "NYSE:GSUN",
      companyName: "Golden Sun Education Group Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gsl",
      code: "NYSE:GSL",
      companyName: "Global Ship Lease Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gsbd",
      code: "NYSE:GSBD",
      companyName: "Goldman Sachs BDC Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gsus",
      code: "NYSE:GSUS",
      companyName: "Goldman Sachs MarketBeta U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gsy",
      code: "NYSE:GSY",
      companyName: "Invesco Ultra Short Duration ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gt",
      code: "NYSE:GT",
      companyName: "Goodyear Tire & Rubber",
      popularity: 0,
    },
    {
      slug: "nyse-gtac",
      code: "NYSE:GTAC",
      companyName:
        "Global Technology Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gtacu",
      code: "NYSE:GTACU",
      companyName: "Global Technology Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gtacw",
      code: "NYSE:GTACW",
      companyName: "Global Technology Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gtbp",
      code: "NYSE:GTBP",
      companyName: "GT Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gte",
      code: "NYSE:GTE",
      companyName: "Gran Tierra Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gtec",
      code: "NYSE:GTEC",
      companyName: "Greenland Technologies Holding Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gtes",
      code: "NYSE:GTES",
      companyName: "Gates Industrial Corporation plc",
      popularity: 0,
    },
    {
      slug: "nyse-gth",
      code: "NYSE:GTH",
      companyName: "Genetron Holdings Limited ADS",
      popularity: 0,
    },
    {
      slug: "nyse-gthx",
      code: "NYSE:GTHX",
      companyName: "G1 Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gtim",
      code: "NYSE:GTIM",
      companyName: "Good Times Restaurants Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gtip",
      code: "NYSE:GTIP",
      companyName: "Goldman Sachs Access Inflation Protected USD Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gtlb",
      code: "NYSE:GTLB",
      companyName: "GitLab Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gtn",
      code: "NYSE:GTN",
      companyName: "Gray Television Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gto",
      code: "NYSE:GTO",
      companyName: "Invesco Total Return Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gtpa",
      code: "NYSE:GTPA",
      companyName: "Gores Technology Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gtpau",
      code: "NYSE:GTPAU",
      companyName: "Gores Technology Partners Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-gtpaw",
      code: "NYSE:GTPAW",
      companyName: "Gores Technology Partners Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gtpb",
      code: "NYSE:GTPB",
      companyName: "Gores Technology Partners II Inc. Class A Common",
      popularity: 0,
    },
    {
      slug: "nyse-gtpbu",
      code: "NYSE:GTPBU",
      companyName: "Gores Technology Partners II Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-gtpbw",
      code: "NYSE:GTPBW",
      companyName: "Gores Technology Partners II Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gtr",
      code: "NYSE:GTR",
      companyName: "WisdomTree Target Range Fund",
      popularity: 0,
    },
    {
      slug: "nyse-gtx",
      code: "NYSE:GTX",
      companyName: "Garrett Motion Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gtxap",
      code: "NYSE:GTXAP",
      companyName:
        "Garrett Motion Inc. Series A Cumulative Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gty",
      code: "NYSE:GTY",
      companyName: "Getty Realty Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-gug",
      code: "NYSE:GUG",
      companyName: "Guggenheim Active Allocation Fund",
      popularity: 0,
    },
    {
      slug: "nyse-gunr",
      code: "NYSE:GUNR",
      companyName: "FlexShares Global Upstream Natural Resources Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-gure",
      code: "NYSE:GURE",
      companyName: "Gulf Resources Inc. (NV) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gusa",
      code: "NYSE:GUSA",
      companyName: "Goldman Sachs MarketBeta U.S. 1000 Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gut",
      code: "NYSE:GUT",
      companyName: "GABELLI UTILITY TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-gut-c",
      code: "NYSE:GUT-C",
      companyName:
        "Gabelli Utility Trust   5.375% Series C Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gva",
      code: "NYSE:GVA",
      companyName: "Granite Construction Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gval",
      code: "NYSE:GVAL",
      companyName: "Cambria Global Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gvci",
      code: "NYSE:GVCI",
      companyName:
        "Green Visor Financial Technology Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gvciu",
      code: "NYSE:GVCIU",
      companyName: "Green Visor Financial Technology Acquisition Corp. I Units",
      popularity: 0,
    },
    {
      slug: "nyse-gvciw",
      code: "NYSE:GVCIW",
      companyName:
        "Green Visor Financial Technology Acquisition Corp. I Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-gvi",
      code: "NYSE:GVI",
      companyName: "iShares Intermediate Government/Credit Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gvlu",
      code: "NYSE:GVLU",
      companyName: "Gotham 1000 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gvp",
      code: "NYSE:GVP",
      companyName: "GSE Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gwav",
      code: "NYSE:GWAV",
      companyName: "Greenwave Technology Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gwh",
      code: "NYSE:GWH",
      companyName: "ESS Tech Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gwii",
      code: "NYSE:GWII",
      companyName: "Good Works II Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gwiiw",
      code: "NYSE:GWIIW",
      companyName: "Good Works II Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gwre",
      code: "NYSE:GWRE",
      companyName: "GUIDEWIRE SOFTWARE INC.",
      popularity: 0,
    },
    {
      slug: "nyse-gwrs",
      code: "NYSE:GWRS",
      companyName: "Global Water Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gtek",
      code: "NYSE:GTEK",
      companyName: "Goldman Sachs Future Tech Leaders Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gwx",
      code: "NYSE:GWX",
      companyName: "SPDR S&P International Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gxc",
      code: "NYSE:GXC",
      companyName: "SPDR S&P China ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gxii",
      code: "NYSE:GXII",
      companyName: "GX Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gxiiu",
      code: "NYSE:GXIIU",
      companyName: "GX Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-gxiiw",
      code: "NYSE:GXIIW",
      companyName: "GX Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gxo",
      code: "NYSE:GXO",
      companyName: "GXO Logistics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gyld",
      code: "NYSE:GYLD",
      companyName: "Arrow Dow Jones Global Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gyro",
      code: "NYSE:GYRO",
      companyName: "Gyrodyne LLC Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-h",
      code: "NYSE:H",
      companyName: "Hyatt Hotels Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ha",
      code: "NYSE:HA",
      companyName: "Hawaiian Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-haac",
      code: "NYSE:HAAC",
      companyName: "Health Assurance Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-gush",
      code: "NYSE:GUSH",
      companyName: "Direxion Daily S&P Oil & Gas Exp. & Prod. Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gxtg",
      code: "NYSE:GXTG",
      companyName: "Global X Thematic Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gxg",
      code: "NYSE:GXG",
      companyName: "Global X MSCI Colombia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-guru",
      code: "NYSE:GURU",
      companyName: "Global X Guru Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-haacu",
      code: "NYSE:HAACU",
      companyName: "Health Assurance Acquisition Corp. SAIL Securities",
      popularity: 0,
    },
    {
      slug: "nyse-haacw",
      code: "NYSE:HAACW",
      companyName: "Health Assurance Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-hae",
      code: "NYSE:HAE",
      companyName: "Haemonetics Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hafc",
      code: "NYSE:HAFC",
      companyName: "Hanmi Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-haia",
      code: "NYSE:HAIA",
      companyName: "Healthcare AI Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-haiau",
      code: "NYSE:HAIAU",
      companyName: "Healthcare AI Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-haiaw",
      code: "NYSE:HAIAW",
      companyName: "Healthcare AI Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-hail",
      code: "NYSE:HAIL",
      companyName: "SPDR S&P Kensho Smart Mobility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hain",
      code: "NYSE:HAIN",
      companyName: "Hain Celestial Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hall",
      code: "NYSE:HALL",
      companyName: "Hallmark Financial Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-halo",
      code: "NYSE:HALO",
      companyName: "Halozyme Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hap",
      code: "NYSE:HAP",
      companyName: "VanEck Natural Resources ETF",
      popularity: 0,
    },
    {
      slug: "nyse-happ",
      code: "NYSE:HAPP",
      companyName:
        "Happiness Development Group Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hapy",
      code: "NYSE:HAPY",
      companyName: "Harbor Corporate Culture Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-harp",
      code: "NYSE:HARP",
      companyName: "Harpoon Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hart",
      code: "NYSE:HART",
      companyName: "IQ Healthy Hearts ETF",
      popularity: 0,
    },
    {
      slug: "nyse-has",
      code: "NYSE:HAS",
      companyName: "Hasbro Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hasi",
      code: "NYSE:HASI",
      companyName: "HANNON ARMSTRONG SUSTAINABLE INFRASTRUCTURE CAPITAL INC",
      popularity: 0,
    },
    {
      slug: "nyse-haus",
      code: "NYSE:HAUS",
      companyName: "Home Appreciation U.S. REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hauz",
      code: "NYSE:HAUZ",
      companyName: "Xtrackers International Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hawx",
      code: "NYSE:HAWX",
      companyName: "iShares Currency Hedged MSCI ACWI ex U.S. ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hayn",
      code: "NYSE:HAYN",
      companyName: "Haynes International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hayw",
      code: "NYSE:HAYW",
      companyName: "Hayward Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hban",
      code: "NYSE:HBAN",
      companyName: "Huntington Bancshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hbanm",
      code: "NYSE:HBANM",
      companyName:
        "Huntington Bancshares Incorporated Depositary Shares each representing a 1/1000th interest in a shar",
      popularity: 0,
    },
    {
      slug: "nyse-hbanp",
      code: "NYSE:HBANP",
      companyName:
        "Huntington Bancshares Incorporated Depositary Shares 4.500% Series H Non-Cumulative Perpetual Prefer",
      popularity: 0,
    },
    {
      slug: "nyse-hbb",
      code: "NYSE:HBB",
      companyName: "Hamilton Beach Brands Holding Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hbcp",
      code: "NYSE:HBCP",
      companyName: "Home Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hbi",
      code: "NYSE:HBI",
      companyName: "Hanesbrands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hbio",
      code: "NYSE:HBIO",
      companyName: "Harvard Bioscience Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hbm",
      code: "NYSE:HBM",
      companyName: "Hudbay Minerals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hbnc",
      code: "NYSE:HBNC",
      companyName: "Horizon Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hbt",
      code: "NYSE:HBT",
      companyName: "HBT Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcar",
      code: "NYSE:HCAR",
      companyName:
        "Healthcare Services Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcaru",
      code: "NYSE:HCARU",
      companyName: "Healthcare Services Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hcarw",
      code: "NYSE:HCARW",
      companyName: "Healthcare Services Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hcat",
      code: "NYSE:HCAT",
      companyName: "Health Catalyst Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcci",
      code: "NYSE:HCCI",
      companyName: "Heritage-Crystal Clean Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hcdi",
      code: "NYSE:HCDI",
      companyName: "Harbor Custom Development Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcdip",
      code: "NYSE:HCDIP",
      companyName:
        "Harbor Custom Development Inc. 8.0% Series A Cumulative Convertible Preferred Stock no par value",
      popularity: 0,
    },
    {
      slug: "nyse-hcdiw",
      code: "NYSE:HCDIW",
      companyName: "Harbor Custom Development Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hcdiz",
      code: "NYSE:HCDIZ",
      companyName: "Harbor Custom Development Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hci",
      code: "NYSE:HCI",
      companyName: "HCI Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hcic",
      code: "NYSE:HCIC",
      companyName: "Hennessy Capital Investment Corp. V Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcicu",
      code: "NYSE:HCICU",
      companyName: "Hennessy Capital Investment Corp. V Units",
      popularity: 0,
    },
    {
      slug: "nyse-hcicw",
      code: "NYSE:HCICW",
      companyName: "Hennessy Capital Investment Corp. V Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hcii",
      code: "NYSE:HCII",
      companyName: "Hudson Executive Investment Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hciiu",
      code: "NYSE:HCIIU",
      companyName: "Hudson Executive Investment Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hciiw",
      code: "NYSE:HCIIW",
      companyName: "Hudson Executive Investment Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hckt",
      code: "NYSE:HCKT",
      companyName: "Hackett Group Inc (The).",
      popularity: 0,
    },
    {
      slug: "nyse-hcm",
      code: "NYSE:HCM",
      companyName: "HUTCHMED (China) Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hcma",
      code: "NYSE:HCMA",
      companyName: "HCM Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hcmau",
      code: "NYSE:HCMAU",
      companyName: "HCM Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hcmaw",
      code: "NYSE:HCMAW",
      companyName: "HCM Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hcne",
      code: "NYSE:HCNE",
      companyName: "Jaws Hurricane Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcneu",
      code: "NYSE:HCNEU",
      companyName: "Jaws Hurricane Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hcnew",
      code: "NYSE:HCNEW",
      companyName: "Jaws Hurricane Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hcom",
      code: "NYSE:HCOM",
      companyName: "Hartford Schroders Commodity Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hcp",
      code: "NYSE:HCP",
      companyName: "HashiCorp Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcrb",
      code: "NYSE:HCRB",
      companyName: "Hartford Core Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hcsg",
      code: "NYSE:HCSG",
      companyName: "Healthcare Services Group",
      popularity: 0,
    },
    {
      slug: "nyse-hcti",
      code: "NYSE:HCTI",
      companyName: "Healthcare Triangle Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcvi",
      code: "NYSE:HCVI",
      companyName: "Hennessy Capital Investment Corp. VI Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcviu",
      code: "NYSE:HCVIU",
      companyName: "Hennessy Capital Investment Corp. VI Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hcviw",
      code: "NYSE:HCVIW",
      companyName: "Hennessy Capital Investment Corp. VI Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hcwb",
      code: "NYSE:HCWB",
      companyName: "HCW Biologics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hcxy",
      code: "NYSE:HCXY",
      companyName: "Hercules Capital Inc. 6.25% Notes due 2033",
      popularity: 0,
    },
    {
      slug: "nyse-hdaw",
      code: "NYSE:HDAW",
      companyName:
        "Xtrackers MSCI All World ex US High Dividend Yield Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hdef",
      code: "NYSE:HDEF",
      companyName: "Xtrackers MSCI EAFE High Dividend Yield Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hdg",
      code: "NYSE:HDG",
      companyName: "ProShares Hedge Replication ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hdge",
      code: "NYSE:HDGE",
      companyName: "AdvisorShares Ranger Equity Bear ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hdiv",
      code: "NYSE:HDIV",
      companyName: "Qraft AI-Enhanced US High Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hdlb",
      code: "NYSE:HDLB",
      companyName:
        "ETRACS Monthly Pay 2xLeveraged US High Dividend Low Volatility ETN Series B due October 21 2049",
      popularity: 0,
    },
    {
      slug: "nyse-hdmv",
      code: "NYSE:HDMV",
      companyName:
        "First Trust Horizon Managed Volatility Developed International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hdro",
      code: "NYSE:HDRO",
      companyName: "Defiance Next Gen H2 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hdsn",
      code: "NYSE:HDSN",
      companyName: "Hudson Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hdv",
      code: "NYSE:HDV",
      companyName: "iShares Core High Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-he",
      code: "NYSE:HE",
      companyName: "Hawaiian Electric Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hear",
      code: "NYSE:HEAR",
      companyName: "Turtle Beach Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hedj",
      code: "NYSE:HEDJ",
      companyName: "WisdomTree Europe Hedged Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-heem",
      code: "NYSE:HEEM",
      companyName: "iShares Currency Hedged MSCI Emerging Markets",
      popularity: 0,
    },
    {
      slug: "nyse-hees",
      code: "NYSE:HEES",
      companyName: "H&E Equipment Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-heet",
      code: "NYSE:HEET",
      companyName: "Hartford Schroders ESG US Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hefa",
      code: "NYSE:HEFA",
      companyName: "iShares Currency Hedged MSCI EAFE ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hegd",
      code: "NYSE:HEGD",
      companyName: "Swan Hedged Equity US Large Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hei",
      code: "NYSE:HEI",
      companyName: "HEICO Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hele",
      code: "NYSE:HELE",
      companyName: "Helen Of Troy Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-helx",
      code: "NYSE:HELX",
      companyName: "Franklin Genomic Advancements ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hep",
      code: "NYSE:HEP",
      companyName: "Holly Energy Partners L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-hepa",
      code: "NYSE:HEPA",
      companyName: "Hepion Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-heps",
      code: "NYSE:HEPS",
      companyName:
        "D-Market Electronic Services & Trading American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-heq",
      code: "NYSE:HEQ",
      companyName: "JOHN HANCOCK HEDGED EQUITY & INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-heqt",
      code: "NYSE:HEQT",
      companyName: "Simplify Hedged Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hera",
      code: "NYSE:HERA",
      companyName: "FTAC Hera Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-herau",
      code: "NYSE:HERAU",
      companyName: "FTAC Hera Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-heraw",
      code: "NYSE:HERAW",
      companyName: "FTAC Hera Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-herd",
      code: "NYSE:HERD",
      companyName: "Pacer Cash Cows Fund of Funds ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hewc",
      code: "NYSE:HEWC",
      companyName: "iShares Currency Hedged MSCI Canada ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hewg",
      code: "NYSE:HEWG",
      companyName: "iShares Currency Hedged MSCI Germany ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hewj",
      code: "NYSE:HEWJ",
      companyName: "iShares Currency Hedged MSCI Japan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hewu",
      code: "NYSE:HEWU",
      companyName: "iShares Currency Hedged MSCI United Kingdom ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hexo",
      code: "NYSE:HEXO",
      companyName: "HEXO Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hezu",
      code: "NYSE:HEZU",
      companyName: "iShares Currency Hedged MSCI Eurozone ETF of ISHARES TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-hfbl",
      code: "NYSE:HFBL",
      companyName: "Home Federal Bancorp Inc. of Louisiana",
      popularity: 0,
    },
    {
      slug: "nyse-hffg",
      code: "NYSE:HFFG",
      companyName: "HF Foods Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hfgo",
      code: "NYSE:HFGO",
      companyName: "Hartford Large Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hfro",
      code: "NYSE:HFRO",
      companyName: "Highland Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-hfro-a",
      code: "NYSE:HFRO-A",
      companyName:
        "Highland Income Fund 5.375% Series A Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hfwa",
      code: "NYSE:HFWA",
      companyName: "Heritage Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-hfxi",
      code: "NYSE:HFXI",
      companyName: "IQ 50 Percent Hedged FTSE International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hgbl",
      code: "NYSE:HGBL",
      companyName: "HERITAGE GLOBAL INC",
      popularity: 0,
    },
    {
      slug: "nyse-hgen",
      code: "NYSE:HGEN",
      companyName: "HUMANIGEN INC.",
      popularity: 0,
    },
    {
      slug: "nyse-hger",
      code: "NYSE:HGER",
      companyName: "Harbor All-Weather Inflation Focus ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hglb",
      code: "NYSE:HGLB",
      companyName: "Highland Global Allocation Fund",
      popularity: 0,
    },
    {
      slug: "nyse-hgty",
      code: "NYSE:HGTY",
      companyName: "Hagerty Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hgv",
      code: "NYSE:HGV",
      companyName: "Hilton Grand Vacations Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hhc",
      code: "NYSE:HHC",
      companyName: "The Howard Hughes Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hhgc",
      code: "NYSE:HHGC",
      companyName: "HHG Capital Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hhgcr",
      code: "NYSE:HHGCR",
      companyName: "HHG Capital Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nyse-hhgcu",
      code: "NYSE:HHGCU",
      companyName: "HHG Capital Corporation Units",
      popularity: 0,
    },
    {
      slug: "nyse-hhgcw",
      code: "NYSE:HHGCW",
      companyName: "HHG Capital Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hhla",
      code: "NYSE:HHLA",
      companyName: "HH&L Acquisition Co.",
      popularity: 0,
    },
    {
      slug: "nyse-hhr",
      code: "NYSE:HHR",
      companyName: "HeadHunter Group PLC American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hhs",
      code: "NYSE:HHS",
      companyName: "Harte-Hanks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hi",
      code: "NYSE:HI",
      companyName: "Hillenbrand Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hibb",
      code: "NYSE:HIBB",
      companyName: "Hibbett Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hibl",
      code: "NYSE:HIBL",
      companyName: "Direxion Daily S&P 500 High Beta Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hibs",
      code: "NYSE:HIBS",
      companyName: "Direxion Daily S&P 500 High Beta Bear 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hie",
      code: "NYSE:HIE",
      companyName: "Miller/Howard High Income Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-hifs",
      code: "NYSE:HIFS",
      companyName: "Hingham Institution for Saving",
      popularity: 0,
    },
    {
      slug: "nyse-hig",
      code: "NYSE:HIG",
      companyName: "The Hartford Financial Services Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hig-g",
      code: "NYSE:HIG-G",
      companyName:
        "The Hartford Financial Services Group Inc. Depositary Shares each representing a 1/1000th interest",
      popularity: 0,
    },
    {
      slug: "nyse-higa",
      code: "NYSE:HIGA",
      companyName: "H.I.G. Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-hiho",
      code: "NYSE:HIHO",
      companyName: "Highway Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-hii",
      code: "NYSE:HII",
      companyName: "Huntington Ingalls Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hiii",
      code: "NYSE:HIII",
      companyName: "Hudson Executive Investment Corp. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hiiiu",
      code: "NYSE:HIIIU",
      companyName: "Hudson Executive Investment Corp. III Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hiiiw",
      code: "NYSE:HIIIW",
      companyName: "Hudson Executive Investment Corp. III Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hil",
      code: "NYSE:HIL",
      companyName: "Hill International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hils",
      code: "NYSE:HILS",
      companyName: "Hillstream BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hims",
      code: "NYSE:HIMS",
      companyName: "Hims & Hers Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-himx",
      code: "NYSE:HIMX",
      companyName: "Himax Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hio",
      code: "NYSE:HIO",
      companyName: "Western Asset High Income Opportunity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hipo",
      code: "NYSE:HIPO",
      companyName: "Hippo Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hips",
      code: "NYSE:HIPS",
      companyName: "GraniteShares HIPS US High Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hisf",
      code: "NYSE:HISF",
      companyName:
        "First Trust Exchange-Traded Fund IV First Trust High Income Strategic Focus ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hiti",
      code: "NYSE:HITI",
      companyName: "High Tide Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hive",
      code: "NYSE:HIVE",
      companyName: "Hive Blockchain Technologies Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hiw",
      code: "NYSE:HIW",
      companyName: "Highwoods Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hix",
      code: "NYSE:HIX",
      companyName: "Western Asset High Income Fund II Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hjen",
      code: "NYSE:HJEN",
      companyName: "Direxion Hydrogen ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hjpx",
      code: "NYSE:HJPX",
      companyName: "iShares Currency Hedged JPX-Nikkei 400 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hkd",
      code: "NYSE:HKD",
      companyName:
        "AMTD Digital Inc. American Depositary Shares (every five of which represent two Class A Ordinary Sha",
      popularity: 0,
    },
    {
      slug: "nyse-hknd",
      code: "NYSE:HKND",
      companyName: "Humankind US Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hl",
      code: "NYSE:HL",
      companyName: "Hecla Mining Company",
      popularity: 0,
    },
    {
      slug: "nyse-hl-b",
      code: "NYSE:HL-B",
      companyName:
        "Hecla Mining Company Series B Cumulative Convertible Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-hlah",
      code: "NYSE:HLAH",
      companyName:
        "Hamilton Lane Alliance Holdings I Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hlahu",
      code: "NYSE:HLAHU",
      companyName: "Hamilton Lane Alliance Holdings I Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hlahw",
      code: "NYSE:HLAHW",
      companyName: "Hamilton Lane Alliance Holdings I Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hlal",
      code: "NYSE:HLAL",
      companyName: "Wahed FTSE USA Shariah ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hlbz",
      code: "NYSE:HLBZ",
      companyName: "Helbiz Inc. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-hlbzw",
      code: "NYSE:HLBZW",
      companyName: "Helbiz Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hlf",
      code: "NYSE:HLF",
      companyName: "Herbalife Nutrition Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-hlg",
      code: "NYSE:HLG",
      companyName: "Hailiang Education Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hlge",
      code: "NYSE:HLGE",
      companyName: "Hartford Longevity Economy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hlgn",
      code: "NYSE:HLGN",
      companyName: "Heliogen Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hli",
      code: "NYSE:HLI",
      companyName: "Houlihan Lokey Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hlio",
      code: "NYSE:HLIO",
      companyName: "Helios Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hlit",
      code: "NYSE:HLIT",
      companyName: "Harmonic Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hlly",
      code: "NYSE:HLLY",
      companyName: "Holley Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hlmn",
      code: "NYSE:HLMN",
      companyName: "Hillman Solutions Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hln",
      code: "NYSE:HLN",
      companyName:
        "Haleon plc American Depositary Shares (Each representing two Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-hlne",
      code: "NYSE:HLNE",
      companyName: "Hamilton Lane Incorporated Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hlth",
      code: "NYSE:HLTH",
      companyName: "Cue Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hlvx",
      code: "NYSE:HLVX",
      companyName: "HilleVax Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hlx",
      code: "NYSE:HLX",
      companyName: "Helix Energy Solutions Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hma",
      code: "NYSE:HMA",
      companyName: "Heartland Media Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-hmacu",
      code: "NYSE:HMACU",
      companyName: "Hainan Manaslu Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hmc",
      code: "NYSE:HMC",
      companyName: "Honda Motor Co. Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-hmco",
      code: "NYSE:HMCO",
      companyName: "HumanCo Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hmcou",
      code: "NYSE:HMCOU",
      companyName: "HumanCo Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hmcow",
      code: "NYSE:HMCOW",
      companyName: "HumanCo Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hmlp",
      code: "NYSE:HMLP",
      companyName: "HOEGH LNG PARTNERS LP",
      popularity: 0,
    },
    {
      slug: "nyse-hmlp-a",
      code: "NYSE:HMLP-A",
      companyName:
        "Hoegh LNG Partners LP 8.75 Percent Series A Cumulative Redeemable Preferred Units  representing li",
      popularity: 0,
    },
    {
      slug: "nyse-hmn",
      code: "NYSE:HMN",
      companyName: "Horace Mann Educators Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hmnf",
      code: "NYSE:HMNF",
      companyName: "HMN Financial Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hmop",
      code: "NYSE:HMOP",
      companyName: "Hartford Municipal Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hmpt",
      code: "NYSE:HMPT",
      companyName: "Home Point Capital Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hmst",
      code: "NYSE:HMST",
      companyName: "HomeStreet Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hmtv",
      code: "NYSE:HMTV",
      companyName: "Hemisphere Media Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hmy",
      code: "NYSE:HMY",
      companyName: "Harmony Gold Mining Company Limited",
      popularity: 0,
    },
    {
      slug: "nyse-hndl",
      code: "NYSE:HNDL",
      companyName: "Strategy Shares Nasdaq 7HANDL Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hngr",
      code: "NYSE:HNGR",
      companyName: "Hanger Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hni",
      code: "NYSE:HNI",
      companyName: "HNI Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hnna",
      code: "NYSE:HNNA",
      companyName: "Hennessy Advisors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hnnaz",
      code: "NYSE:HNNAZ",
      companyName: "Hennessy Advisors Inc. 4.875% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-hnra",
      code: "NYSE:HNRA",
      companyName: "HNR Acquisition Corp",
      popularity: 0,
    },
    {
      slug: "nyse-hnrg",
      code: "NYSE:HNRG",
      companyName: "Hallador Energy Company",
      popularity: 0,
    },
    {
      slug: "nyse-hnst",
      code: "NYSE:HNST",
      companyName: "The Honest Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hnvr",
      code: "NYSE:HNVR",
      companyName: "Hanover Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hnw",
      code: "NYSE:HNW",
      companyName: "Pioneer Diversified High Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hoft",
      code: "NYSE:HOFT",
      companyName: "Hooker Furnishings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hofv",
      code: "NYSE:HOFV",
      companyName: "Hall of Fame Resort & Entertainment Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hofvw",
      code: "NYSE:HOFVW",
      companyName: "Hall of Fame Resort & Entertainment Company Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hog",
      code: "NYSE:HOG",
      companyName: "Harley-Davidson Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hold",
      code: "NYSE:HOLD",
      companyName: "AdvisorShares North Square McKee Core Reserves ETF",
      popularity: 0,
    },
    {
      slug: "nyse-holi",
      code: "NYSE:HOLI",
      companyName:
        "Hollsys Automation Technologies INTERNATIONAL LTD. COMMON (British Virgin Island)",
      popularity: 0,
    },
    {
      slug: "nyse-holx",
      code: "NYSE:HOLX",
      companyName: "Hologic Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hom",
      code: "NYSE:HOM",
      companyName: "LifeGoal Home Down Payment Investment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-homb",
      code: "NYSE:HOMB",
      companyName: "Home BancShares Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-homz",
      code: "NYSE:HOMZ",
      companyName: "Hoya Capital Housing ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hone",
      code: "NYSE:HONE",
      companyName: "HarborOne Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hood",
      code: "NYSE:HOOD",
      companyName: "Robinhood Markets Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hook",
      code: "NYSE:HOOK",
      companyName: "HOOKIPA Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hope",
      code: "NYSE:HOPE",
      companyName: "Hope Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hori",
      code: "NYSE:HORI",
      companyName: "Emerging Markets Horizon Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-horiu",
      code: "NYSE:HORIU",
      companyName: "Emerging Markets Horizon Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-horiw",
      code: "NYSE:HORIW",
      companyName: "Emerging Markets Horizon Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-hoth",
      code: "NYSE:HOTH",
      companyName: "Hoth Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hotl",
      code: "NYSE:HOTL",
      companyName: "Kelly Hotel & Lodging Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hour",
      code: "NYSE:HOUR",
      companyName: "Hour Loop Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hous",
      code: "NYSE:HOUS",
      companyName: "Anywhere Real Estate Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hov",
      code: "NYSE:HOV",
      companyName: "Hovnanian Enterprises Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-hovnp",
      code: "NYSE:HOVNP",
      companyName: "Hovnanian Enterprises Inc. Dep Shr Srs A Pfd",
      popularity: 0,
    },
    {
      slug: "nyse-howl",
      code: "NYSE:HOWL",
      companyName: "Werewolf Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hp",
      code: "NYSE:HP",
      companyName: "Helmerich & Payne Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hpe",
      code: "NYSE:HPE",
      companyName: "Hewlett Packard Enterprise Company",
      popularity: 0,
    },
    {
      slug: "nyse-hpf",
      code: "NYSE:HPF",
      companyName: "John Hancock Preferred Income Fund II",
      popularity: 0,
    },
    {
      slug: "nyse-hpi",
      code: "NYSE:HPI",
      companyName: "John Hancock Preferred Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-hpk",
      code: "NYSE:HPK",
      companyName: "HighPeak Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hpkew",
      code: "NYSE:HPKEW",
      companyName: "HighPeak Energy Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hplt",
      code: "NYSE:HPLT",
      companyName: "Home Plate Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hpltu",
      code: "NYSE:HPLTU",
      companyName: "Home Plate Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hpltw",
      code: "NYSE:HPLTW",
      companyName: "Home Plate Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hpp-c",
      code: "NYSE:HPP-C",
      companyName:
        "Hudson Pacific Properties Inc. 4.750% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hps",
      code: "NYSE:HPS",
      companyName: "John Hancock Preferred Income Fund III",
      popularity: 0,
    },
    {
      slug: "nyse-hpx",
      code: "NYSE:HPX",
      companyName: "HPX Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-hqh",
      code: "NYSE:HQH",
      companyName: "Tekla Healthcare Investors",
      popularity: 0,
    },
    {
      slug: "nyse-hqi",
      code: "NYSE:HQI",
      companyName: "HireQuest Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-hql",
      code: "NYSE:HQL",
      companyName: "Tekla Life Sciences Investors",
      popularity: 0,
    },
    {
      slug: "nyse-hqy",
      code: "NYSE:HQY",
      companyName: "HealthEquity Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hr",
      code: "NYSE:HR",
      companyName: "Healthcare Realty Trust Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-hri",
      code: "NYSE:HRI",
      companyName: "Herc Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hrl",
      code: "NYSE:HRL",
      companyName: "Hormel Foods Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hrmy",
      code: "NYSE:HRMY",
      companyName: "Harmony Biosciences Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hrow",
      code: "NYSE:HROW",
      companyName: "Harrow Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hrowl",
      code: "NYSE:HROWL",
      companyName: "Harrow Health Inc. 8.625% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-hrt",
      code: "NYSE:HRT",
      companyName: "HireRight Holdings Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hrtg",
      code: "NYSE:HRTG",
      companyName: "HERITAGE INSURANCE HOLDINGS INC",
      popularity: 0,
    },
    {
      slug: "nyse-hrtx",
      code: "NYSE:HRTX",
      companyName: "Heron Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hrzn",
      code: "NYSE:HRZN",
      companyName: "Horizon Technology Finance Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hsaq",
      code: "NYSE:HSAQ",
      companyName: "Health Sciences Acquisitions Corporation 2 Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hsbc",
      code: "NYSE:HSBC",
      companyName: "HSBC Holdings PLC",
      popularity: 0,
    },
    {
      slug: "nyse-hsc",
      code: "NYSE:HSC",
      companyName: "Harsco Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hscs",
      code: "NYSE:HSCS",
      companyName: "Heart Test Laboratories Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hscsw",
      code: "NYSE:HSCSW",
      companyName: "Heart Test Laboratories Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hscz",
      code: "NYSE:HSCZ",
      companyName: "iShares Currency Hedged MSCI EAFE Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hsdt",
      code: "NYSE:HSDT",
      companyName: "Helius Medical Technologies Inc. Class A Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-hsic",
      code: "NYSE:HSIC",
      companyName: "Henry Schein Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hsii",
      code: "NYSE:HSII",
      companyName: "Heidrick & Struggles Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hska",
      code: "NYSE:HSKA",
      companyName: "Heska Corp",
      popularity: 0,
    },
    {
      slug: "nyse-hsmv",
      code: "NYSE:HSMV",
      companyName: "First Trust Horizon Managed Volatility Small/Mid ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hson",
      code: "NYSE:HSON",
      companyName: "Hudson Global Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hsrt",
      code: "NYSE:HSRT",
      companyName: "Hartford Short Duration ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hst",
      code: "NYSE:HST",
      companyName: "Host Hotels & Resorts Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hstm",
      code: "NYSE:HSTM",
      companyName: "HealthStream Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hsto",
      code: "NYSE:HSTO",
      companyName: "Histogen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hsun",
      code: "NYSE:HSUN",
      companyName: "Hartford Sustainable Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hsy",
      code: "NYSE:HSY",
      companyName: "The Hershey Company",
      popularity: 0,
    },
    {
      slug: "nyse-ht",
      code: "NYSE:HT",
      companyName:
        "Hersha Hospitality Trust  Priority Class A Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-ht-c",
      code: "NYSE:HT-C",
      companyName:
        "HERSHA HOSPITALITY TRUST  6.875% Series C Cumulative Redeemable Preferred Shares of Beneficial Inter",
      popularity: 0,
    },
    {
      slug: "nyse-ht-d",
      code: "NYSE:HT-D",
      companyName:
        "Hersha Hospitality Trust    6.50% Series D Cumulative Redeemable Preferred Shares of Beneficial Inte",
      popularity: 0,
    },
    {
      slug: "nyse-ht-e",
      code: "NYSE:HT-E",
      companyName:
        "Hersha Hospitality Trust 6.50% Series E Cumulative Redeemable Preferred Shares of Beneficial Interes",
      popularity: 0,
    },
    {
      slug: "nyse-htab",
      code: "NYSE:HTAB",
      companyName: "Hartford Schroders Tax-Aware Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-htaq",
      code: "NYSE:HTAQ",
      companyName: "Hunt Companies Acquisition Corp. I",
      popularity: 0,
    },
    {
      slug: "nyse-htbi",
      code: "NYSE:HTBI",
      companyName: "HomeTrust Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-htbk",
      code: "NYSE:HTBK",
      companyName: "Heritage Commerce Corp",
      popularity: 0,
    },
    {
      slug: "nyse-htcr",
      code: "NYSE:HTCR",
      companyName: "Heartcore Enterprises Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-htd",
      code: "NYSE:HTD",
      companyName: "John Hancock Tax-Advantaged Dividend Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-htec",
      code: "NYSE:HTEC",
      companyName: "ROBO Global Healthcare Technology and Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-htfb",
      code: "NYSE:HTFB",
      companyName:
        "Horizon Technology Finance Corporation 4.875% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-htfc",
      code: "NYSE:HTFC",
      companyName:
        "Horizon Technology Finance Corporation 6.25% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nyse-htgc",
      code: "NYSE:HTGC",
      companyName: "Hercules Capital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-htgm",
      code: "NYSE:HTGM",
      companyName: "HTG Molecular Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hth",
      code: "NYSE:HTH",
      companyName: "HILLTOP HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-htia",
      code: "NYSE:HTIA",
      companyName:
        "Healthcare Trust Inc. 7.375% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-htibp",
      code: "NYSE:HTIBP",
      companyName:
        "Healthcare Trust Inc. 7.125% Series B Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-htld",
      code: "NYSE:HTLD",
      companyName: "Heartland Express Inc",
      popularity: 0,
    },
    {
      slug: "nyse-htlf",
      code: "NYSE:HTLF",
      companyName: "Heartland Financial USA Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-htlfp",
      code: "NYSE:HTLFP",
      companyName:
        "Heartland Financial USA Inc. Depositary Shares each representing a 1/400th ownership interest in a",
      popularity: 0,
    },
    {
      slug: "nyse-htoo",
      code: "NYSE:HTOO",
      companyName: "Fusion Fuel Green PLC Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-htoow",
      code: "NYSE:HTOOW",
      companyName: "Fusion Fuel Green PLC Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-htpa",
      code: "NYSE:HTPA",
      companyName: "Highland Transcend Partners I Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-htrb",
      code: "NYSE:HTRB",
      companyName: "Hartford Total Return Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-htus",
      code: "NYSE:HTUS",
      companyName: "Hull Tactical US ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hty",
      code: "NYSE:HTY",
      companyName: "JOHN HANCOCK TAX-ADVANTAGED GLOBAL SHAREHOLDER YIELD FUND",
      popularity: 0,
    },
    {
      slug: "nyse-htz",
      code: "NYSE:HTZ",
      companyName: "Hertz Global Holdings Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-htzww",
      code: "NYSE:HTZWW",
      companyName: "Hertz Global Holdings Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-hubg",
      code: "NYSE:HUBG",
      companyName: "HUB Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hudi",
      code: "NYSE:HUDI",
      companyName: "Huadi International Group Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-huge",
      code: "NYSE:HUGE",
      companyName: "FSD Pharma Inc. Class B Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hugs",
      code: "NYSE:HUGS",
      companyName: "USHG Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-huiz",
      code: "NYSE:HUIZ",
      companyName: "Huize Holding Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-huma",
      code: "NYSE:HUMA",
      companyName: "Humacyte Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-humaw",
      code: "NYSE:HUMAW",
      companyName: "Humacyte Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hun",
      code: "NYSE:HUN",
      companyName: "Huntsman Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hurc",
      code: "NYSE:HURC",
      companyName: "Hurco Cos Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hurn",
      code: "NYSE:HURN",
      companyName: "Huron Consulting Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-husa",
      code: "NYSE:HUSA",
      companyName: "Houston American Energy Corp",
      popularity: 0,
    },
    {
      slug: "nyse-hubb",
      code: "NYSE:HUBB",
      companyName: "Hubbell Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-hum",
      code: "NYSE:HUM",
      companyName: "Humana Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-husv",
      code: "NYSE:HUSV",
      companyName: "First Trust Horizon Managed Volatility Domestic ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hut",
      code: "NYSE:HUT",
      companyName: "Hut 8 Mining Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-huya",
      code: "NYSE:HUYA",
      companyName: "HUYA Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hval",
      code: "NYSE:HVAL",
      companyName: "ALPS Hillman Active Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hvbc",
      code: "NYSE:HVBC",
      companyName: "HV Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hvt",
      code: "NYSE:HVT",
      companyName: "Haverty Furniture Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hwbk",
      code: "NYSE:HWBK",
      companyName: "Hawthorn Bancshars Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hwc",
      code: "NYSE:HWC",
      companyName: "Hancock Whitney Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hwcpz",
      code: "NYSE:HWCPZ",
      companyName:
        "Hancock Whitney Corporation 6.25% Subordinated Notes due 2060",
      popularity: 0,
    },
    {
      slug: "nyse-hwel",
      code: "NYSE:HWEL",
      companyName: "Healthwell Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hwelu",
      code: "NYSE:HWELU",
      companyName: "Healthwell Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-hwelw",
      code: "NYSE:HWELW",
      companyName: "Healthwell Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hwkn",
      code: "NYSE:HWKN",
      companyName: "Hawkins Inc",
      popularity: 0,
    },
    {
      slug: "nyse-hwkz",
      code: "NYSE:HWKZ",
      companyName: "Hawks Acquisition Corp",
      popularity: 0,
    },
    {
      slug: "nyse-hwm",
      code: "NYSE:HWM",
      companyName: "Howmet Aerospace Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hwm-",
      code: "NYSE:HWM-",
      companyName: "Howmet Aerospace Inc. $3.75 Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hxl",
      code: "NYSE:HXL",
      companyName: "Hexcel Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hy",
      code: "NYSE:HY",
      companyName: "HYSTER-YALE MATERIALS HANDLING INC",
      popularity: 0,
    },
    {
      slug: "nyse-hyb",
      code: "NYSE:HYB",
      companyName: "New America High Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hybb",
      code: "NYSE:HYBB",
      companyName: "iShares BB Rated Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hybl",
      code: "NYSE:HYBL",
      companyName: "SPDR Blackstone High Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyd",
      code: "NYSE:HYD",
      companyName: "VanEck High Yield Muni ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hydb",
      code: "NYSE:HYDB",
      companyName: "iShares High Yield Bond Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hydw",
      code: "NYSE:HYDW",
      companyName: "Xtrackers Low Beta High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyem",
      code: "NYSE:HYEM",
      companyName: "VanEck Emerging Markets High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyfm",
      code: "NYSE:HYFM",
      companyName: "Hydrofarm Holdings Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hyg",
      code: "NYSE:HYG",
      companyName: "iShares iBoxx $ High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hygh",
      code: "NYSE:HYGH",
      companyName: "iShares Interest Rate Hedged High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hygi",
      code: "NYSE:HYGI",
      companyName: "iShares Inflation Hedged High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hygv",
      code: "NYSE:HYGV",
      companyName: "FlexShares High Yield Value-Scored Bond Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-hygw",
      code: "NYSE:HYGW",
      companyName: "iShares High Yield Corporate Bond BuyWrite Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyhg",
      code: "NYSE:HYHG",
      companyName: "ProShares High Yield-Interest Rate Hedged ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyi",
      code: "NYSE:HYI",
      companyName: "Western Asset High Yield Defined Opportunity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hyin",
      code: "NYSE:HYIN",
      companyName: "WisdomTree Alternative Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-hylb",
      code: "NYSE:HYLB",
      companyName: "Xtrackers USD High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyld",
      code: "NYSE:HYLD",
      companyName: "High Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyln",
      code: "NYSE:HYLN",
      companyName: "Hyliion Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-hyls",
      code: "NYSE:HYLS",
      companyName:
        "First Trust Exchange-Traded Fund IV First Trust Tactical High Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hylv",
      code: "NYSE:HYLV",
      companyName: "IQ S&P High Yield Low Volatility Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hymb",
      code: "NYSE:HYMB",
      companyName: "SPDR Nuveen Bloomberg High Yield Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hymc",
      code: "NYSE:HYMC",
      companyName: "Hycroft Mining Holding Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hymcl",
      code: "NYSE:HYMCL",
      companyName: "Hycroft Mining Holding Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-hymcw",
      code: "NYSE:HYMCW",
      companyName: "Hycroft Mining Holding Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hymcz",
      code: "NYSE:HYMCZ",
      companyName: "Hycroft Mining Holding Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-hymu",
      code: "NYSE:HYMU",
      companyName: "BlackRock High Yield Muni Income Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hypr",
      code: "NYSE:HYPR",
      companyName: "Hyperfine Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hyre",
      code: "NYSE:HYRE",
      companyName: "HyreCar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hyrm",
      code: "NYSE:HYRM",
      companyName: "Xtrackers Risk Managed USD High Yield Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hys",
      code: "NYSE:HYS",
      companyName:
        "PIMCO 0-5 Year High Yield Corporate Bond Index Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-hyt",
      code: "NYSE:HYT",
      companyName: "BLACKROCK CORPORATE HIGH YIELD FUND INC.",
      popularity: 0,
    },
    {
      slug: "nyse-hytr",
      code: "NYSE:HYTR",
      companyName: "CP High Yield Trend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyup",
      code: "NYSE:HYUP",
      companyName: "Xtrackers High Beta High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyw",
      code: "NYSE:HYW",
      companyName: "Hywin Holdings Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hyxf",
      code: "NYSE:HYXF",
      companyName:
        "iShares Trust iShares ESG Advanced High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyxu",
      code: "NYSE:HYXU",
      companyName: "iShares Global ex USD High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hyzd",
      code: "NYSE:HYZD",
      companyName:
        "WisdomTree Trust WisdomTree Interest Rate Hedged High Yield Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-hyzn",
      code: "NYSE:HYZN",
      companyName: "Hyzon Motors Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hyznw",
      code: "NYSE:HYZNW",
      companyName: "Hyzon Motors Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-hzn",
      code: "NYSE:HZN",
      companyName: "Horizon Global Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-hznp",
      code: "NYSE:HZNP",
      companyName:
        "Horizon Therapeutics Public Limited Company Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-hzo",
      code: "NYSE:HZO",
      companyName: "MarineMax Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hzon",
      code: "NYSE:HZON",
      companyName: "Horizon Acquisition Corporation II",
      popularity: 0,
    },
    {
      slug: "nyse-hydr",
      code: "NYSE:HYDR",
      companyName: "Global X Hydrogen ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iau",
      code: "NYSE:IAU",
      companyName: "iShares Gold Trust",
      popularity: 0,
    },
    {
      slug: "nyse-iac",
      code: "NYSE:IAC",
      companyName: "IAC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iacc",
      code: "NYSE:IACC",
      companyName: "ION Acquisition Corp 3 Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-iae",
      code: "NYSE:IAE",
      companyName: "VOYA ASIA PACIFIC HIGH DIVIDEND EQUITY INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-iaf",
      code: "NYSE:IAF",
      companyName: "abrdn Australia Equity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iag",
      code: "NYSE:IAG",
      companyName: "IAMGold Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-iagg",
      code: "NYSE:IAGG",
      companyName: "iShares Core International Aggregate Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-iai",
      code: "NYSE:IAI",
      companyName: "iShares U.S. Broker-Dealers & Securities Exchanges ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iak",
      code: "NYSE:IAK",
      companyName: "iShares U.S. Insurance ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iapr",
      code: "NYSE:IAPR",
      companyName: "Innovator International Developed Power Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-iart",
      code: "NYSE:IART",
      companyName: "Integra LifeSciences Holdings",
      popularity: 0,
    },
    {
      slug: "nyse-ias",
      code: "NYSE:IAS",
      companyName: "Integral Ad Science Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iat",
      code: "NYSE:IAT",
      companyName: "iShares U.S. Regional Banks ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iauf",
      code: "NYSE:IAUF",
      companyName: "iShares Gold Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iaum",
      code: "NYSE:IAUM",
      companyName: "iShares Gold Trust Micro",
      popularity: 0,
    },
    {
      slug: "nyse-iaux",
      code: "NYSE:IAUX",
      companyName: "i-80 Gold Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-iba",
      code: "NYSE:IBA",
      companyName: "Industrias Bachoco SAB De C.V.",
      popularity: 0,
    },
    {
      slug: "nyse-ibb",
      code: "NYSE:IBB",
      companyName: "iShares Biotechnology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibbq",
      code: "NYSE:IBBQ",
      companyName: "Invesco Nasdaq Biotechnology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibce",
      code: "NYSE:IBCE",
      companyName: "iShares iBonds Mar 2023 Term Corporate ex-Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibcp",
      code: "NYSE:IBCP",
      companyName: "Independent Bank Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ibd",
      code: "NYSE:IBD",
      companyName: "Inspire Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdd",
      code: "NYSE:IBDD",
      companyName: "iShares iBonds Mar 2023 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdn",
      code: "NYSE:IBDN",
      companyName: "iShares iBonds Dec 2022 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdo",
      code: "NYSE:IBDO",
      companyName: "iShares iBonds Dec 2023 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdp",
      code: "NYSE:IBDP",
      companyName: "iShares iBonds Dec 2024 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdq",
      code: "NYSE:IBDQ",
      companyName: "iShares iBonds Dec 2025 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdr",
      code: "NYSE:IBDR",
      companyName: "iShares iBonds Dec 2026 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibds",
      code: "NYSE:IBDS",
      companyName: "iShares iBonds Dec 2027 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdt",
      code: "NYSE:IBDT",
      companyName: "iShares iBonds Dec 2028 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdu",
      code: "NYSE:IBDU",
      companyName: "iShares iBonds Dec 2029 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdv",
      code: "NYSE:IBDV",
      companyName: "iShares iBonds Dec 2030 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdw",
      code: "NYSE:IBDW",
      companyName: "iShares iBonds Dec 2031 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibdx",
      code: "NYSE:IBDX",
      companyName: "iShares iBonds Dec 2032 Term Corporate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iber",
      code: "NYSE:IBER",
      companyName: "Ibere Pharmaceuticals",
      popularity: 0,
    },
    {
      slug: "nyse-ibet",
      code: "NYSE:IBET",
      companyName: "iBET Sports Betting and Gaming ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibex",
      code: "NYSE:IBEX",
      companyName: "IBEX Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ibhd",
      code: "NYSE:IBHD",
      companyName: "iShares iBonds 2024 Term High Yield and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibhe",
      code: "NYSE:IBHE",
      companyName: "iShares iBonds 2025 Term High Yield and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibhf",
      code: "NYSE:IBHF",
      companyName: "iShares iBonds 2026 Term High Yield and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibhg",
      code: "NYSE:IBHG",
      companyName: "iShares iBonds 2027 Term High Yield and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibhh",
      code: "NYSE:IBHH",
      companyName: "iShares iBonds 2028 Term High Yield and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibhi",
      code: "NYSE:IBHI",
      companyName: "iShares iBonds 2029 Term High Yield and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibio",
      code: "NYSE:IBIO",
      companyName: "iBio Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ibkr",
      code: "NYSE:IBKR",
      companyName: "Interactive Brokers Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iblc",
      code: "NYSE:IBLC",
      companyName: "iShares Blockchain and Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibmk",
      code: "NYSE:IBMK",
      companyName: "iShares iBonds Dec 2022 Term Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibml",
      code: "NYSE:IBML",
      companyName: "iShares iBonds Dec 2023 Term Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibmm",
      code: "NYSE:IBMM",
      companyName: "iShares iBonds Dec 2024 Term Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibmn",
      code: "NYSE:IBMN",
      companyName: "iShares iBonds Dec 2025 Term Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibmo",
      code: "NYSE:IBMO",
      companyName: "iShares iBonds Dec 2026 Term Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibmp",
      code: "NYSE:IBMP",
      companyName: "iShares iBonds Dec 2027 Term Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibmq",
      code: "NYSE:IBMQ",
      companyName: "iShares iBonds Dec 2028 Term Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibn",
      code: "NYSE:IBN",
      companyName: "ICICI Bank Limited",
      popularity: 0,
    },
    {
      slug: "nyse-ibnd",
      code: "NYSE:IBND",
      companyName: "SPDR Bloomberg International Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iboc",
      code: "NYSE:IBOC",
      companyName: "International Bancshares Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ibrx",
      code: "NYSE:IBRX",
      companyName: "ImmunityBio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ibtb",
      code: "NYSE:IBTB",
      companyName: "iShares iBonds Dec 2022 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibtd",
      code: "NYSE:IBTD",
      companyName: "iShares iBonds Dec 2023 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibte",
      code: "NYSE:IBTE",
      companyName: "iShares iBonds Dec 2024 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iaa",
      code: "NYSE:IAA",
      companyName: "IAA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ibtf",
      code: "NYSE:IBTF",
      companyName: "iShares iBonds Dec 2025 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibtg",
      code: "NYSE:IBTG",
      companyName: "iShares iBonds Dec 2026 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibth",
      code: "NYSE:IBTH",
      companyName: "iShares iBonds Dec 2027 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibti",
      code: "NYSE:IBTI",
      companyName: "iShares iBonds Dec 2028 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibtj",
      code: "NYSE:IBTJ",
      companyName: "iShares iBonds Dec 2029 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibtk",
      code: "NYSE:IBTK",
      companyName: "iShares iBonds Dec 2030 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibtl",
      code: "NYSE:IBTL",
      companyName: "iShares iBonds Dec 2031 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibtm",
      code: "NYSE:IBTM",
      companyName: "iShares iBonds Dec 2032 Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibtx",
      code: "NYSE:IBTX",
      companyName: "Independent Bank Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ibuy",
      code: "NYSE:IBUY",
      companyName: "Amplify Online Retail ETF",
      popularity: 0,
    },
    {
      slug: "nyse-icad",
      code: "NYSE:ICAD",
      companyName: "Icad Inc",
      popularity: 0,
    },
    {
      slug: "nyse-icap",
      code: "NYSE:ICAP",
      companyName: "InfraCap Equity Income Fund ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iccc",
      code: "NYSE:ICCC",
      companyName: "Immucell Corp",
      popularity: 0,
    },
    {
      slug: "nyse-icch",
      code: "NYSE:ICCH",
      companyName: "ICC Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iccm",
      code: "NYSE:ICCM",
      companyName: "IceCure Medical Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-icd",
      code: "NYSE:ICD",
      companyName: "Independence Contract Drilling Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-icf",
      code: "NYSE:ICF",
      companyName: "iShares Cohen & Steers REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-icfi",
      code: "NYSE:ICFI",
      companyName: "ICF International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ichr",
      code: "NYSE:ICHR",
      companyName: "Ichor Holdings",
      popularity: 0,
    },
    {
      slug: "nyse-icl",
      code: "NYSE:ICL",
      companyName: "ICL Group Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-iclk",
      code: "NYSE:ICLK",
      companyName: "iClick Interactive Asia Group Limited",
      popularity: 0,
    },
    {
      slug: "nyse-icln",
      code: "NYSE:ICLN",
      companyName: "iShares Global Clean Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iclr",
      code: "NYSE:ICLR",
      companyName: "Icon Plc",
      popularity: 0,
    },
    {
      slug: "nyse-icmb",
      code: "NYSE:ICMB",
      companyName: "Investcorp Credit Management BDC Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-icnc",
      code: "NYSE:ICNC",
      companyName: "Iconic Sports Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-icol",
      code: "NYSE:ICOL",
      companyName: "iShares MSCI Colombia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-icow",
      code: "NYSE:ICOW",
      companyName: "Pacer Developed Markets International Cash Cows 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-icpt",
      code: "NYSE:ICPT",
      companyName: "Intercept Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-icr-a",
      code: "NYSE:ICR-A",
      companyName:
        "InPoint Commercial Real Estate Income Inc. 6.75% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-icsh",
      code: "NYSE:ICSH",
      companyName: "BlackRock Ultra Short-Term Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-icui",
      code: "NYSE:ICUI",
      companyName: "ICU Medical Inc",
      popularity: 0,
    },
    {
      slug: "nyse-icvt",
      code: "NYSE:ICVT",
      companyName: "iShares Convertible Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-icvx",
      code: "NYSE:ICVX",
      companyName: "Icosavax Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-id",
      code: "NYSE:ID",
      companyName: "PARTS iD Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ida",
      code: "NYSE:IDA",
      companyName: "IDACORP Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-idat",
      code: "NYSE:IDAT",
      companyName: "iShares Cloud 5G and Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idba",
      code: "NYSE:IDBA",
      companyName: "IDEX Biometrics ASA American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-idcc",
      code: "NYSE:IDCC",
      companyName: "InterDigital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ide",
      code: "NYSE:IDE",
      companyName: "VOYA INFRASTRUCTURE INDUSTRIALS AND MATERIALS FUND",
      popularity: 0,
    },
    {
      slug: "nyse-idev",
      code: "NYSE:IDEV",
      companyName: "iShares Core MSCI International Developed Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idex",
      code: "NYSE:IDEX",
      companyName: "Ideanomics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-idhd",
      code: "NYSE:IDHD",
      companyName:
        "Invesco S&P International Developed High Dividend Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idhq",
      code: "NYSE:IDHQ",
      companyName: "Invesco S&P International Developed Quality ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idiv",
      code: "NYSE:IDIV",
      companyName: "U.S. Equity Cumulative Dividends Fund - Series 2027",
      popularity: 0,
    },
    {
      slug: "nyse-idlb",
      code: "NYSE:IDLB",
      companyName: "Invesco FTSE International Low Beta Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idlv",
      code: "NYSE:IDLV",
      companyName: "Invesco S&P International Developed Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idme",
      code: "NYSE:IDME",
      companyName: "International Drawdown Managed Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idmo",
      code: "NYSE:IDMO",
      companyName: "Invesco S&P International Developed Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idn",
      code: "NYSE:IDN",
      companyName: "Intellicheck Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-idna",
      code: "NYSE:IDNA",
      companyName: "iShares Genomics Immunology and Healthcare ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idog",
      code: "NYSE:IDOG",
      companyName: "ALPS International Sector Dividend Dogs ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idr",
      code: "NYSE:IDR",
      companyName: "Idaho Strategic Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-idra",
      code: "NYSE:IDRA",
      companyName: "Idera Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-idrv",
      code: "NYSE:IDRV",
      companyName: "iShares Self-Driving EV and Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idt",
      code: "NYSE:IDT",
      companyName: "IDT Corporation Class B",
      popularity: 0,
    },
    {
      slug: "nyse-idu",
      code: "NYSE:IDU",
      companyName: "iShares U.S. Utilities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idv",
      code: "NYSE:IDV",
      companyName: "iShares International Select Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idw",
      code: "NYSE:IDW",
      companyName: "IDW Media Holdings",
      popularity: 0,
    },
    {
      slug: "nyse-idx",
      code: "NYSE:IDX",
      companyName: "VanEck Indonesia Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idxx",
      code: "NYSE:IDXX",
      companyName: "Idexx Laboratories Inc",
      popularity: 0,
    },
    {
      slug: "nyse-idya",
      code: "NYSE:IDYA",
      companyName: "IDEAYA Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ie",
      code: "NYSE:IE",
      companyName: "Ivanhoe Electric Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iea",
      code: "NYSE:IEA",
      companyName: "Infrastructure and Energy Alternatives Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ieaww",
      code: "NYSE:IEAWW",
      companyName: "Infrastructure and Energy Alternatives Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-iecs",
      code: "NYSE:IECS",
      companyName: "iShares Evolved U.S. Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iedi",
      code: "NYSE:IEDI",
      companyName: "iShares Evolved U.S. Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ief",
      code: "NYSE:IEF",
      companyName: "iShares 7-10 Year Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iefa",
      code: "NYSE:IEFA",
      companyName: "iShares Core MSCI EAFE ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iefn",
      code: "NYSE:IEFN",
      companyName: "iShares Evolved U.S. Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iehs",
      code: "NYSE:IEHS",
      companyName: "iShares Evolved U.S. Healthcare Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iei",
      code: "NYSE:IEI",
      companyName: "iShares 3-7 Year Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ieih",
      code: "NYSE:IEIH",
      companyName: "iShares Evolved U.S. Innovative Healthcare ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ieme",
      code: "NYSE:IEME",
      companyName: "iShares Evolved U.S. Media and Entertainment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ifra",
      code: "NYSE:IFRA",
      companyName: "iShares U.S. Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iep",
      code: "NYSE:IEP",
      companyName: "Icahn Enterprises L.P",
      popularity: 0,
    },
    {
      slug: "nyse-iesc",
      code: "NYSE:IESC",
      companyName: "IES Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ietc",
      code: "NYSE:IETC",
      companyName: "iShares Evolved U.S. Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ieur",
      code: "NYSE:IEUR",
      companyName: "iShares Core MSCI Europe ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ieus",
      code: "NYSE:IEUS",
      companyName: "iShares MSCI Europe Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iev",
      code: "NYSE:IEV",
      companyName: "iShares Europe ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iex",
      code: "NYSE:IEX",
      companyName: "IDEX Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-iez",
      code: "NYSE:IEZ",
      companyName: "iShares U.S. Oil Equipment & Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ifbd",
      code: "NYSE:IFBD",
      companyName: "Infobird Co. Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ifed",
      code: "NYSE:IFED",
      companyName: "ETRACS IFED Invest with the Fed TR Index ETN",
      popularity: 0,
    },
    {
      slug: "nyse-iff",
      code: "NYSE:IFF",
      companyName: "International Flavors & Fragrances Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ifgl",
      code: "NYSE:IFGL",
      companyName: "iShares International Developed Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ifin",
      code: "NYSE:IFIN",
      companyName: "InFinT Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ifn",
      code: "NYSE:IFN",
      companyName: "The India Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ifrx",
      code: "NYSE:IFRX",
      companyName: "InflaRx N.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ifs",
      code: "NYSE:IFS",
      companyName: "Intercorp Financial Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ifv",
      code: "NYSE:IFV",
      companyName: "First Trust Dorsey Wright International Focus 5 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ig",
      code: "NYSE:IG",
      companyName: "Principal Investment Grade Corporate Active ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iga",
      code: "NYSE:IGA",
      companyName: "VOYA GLOBAL ADVANTAGE AND PREMIUM OPPORTUNITY FUND",
      popularity: 0,
    },
    {
      slug: "nyse-igac",
      code: "NYSE:IGAC",
      companyName: "IG Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-igacu",
      code: "NYSE:IGACU",
      companyName: "IG Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-igacw",
      code: "NYSE:IGACW",
      companyName: "IG Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-igbh",
      code: "NYSE:IGBH",
      companyName: "iShares Interest Rate Hedged Long-Term Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igc",
      code: "NYSE:IGC",
      companyName: "India Globalization Capital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-igd",
      code: "NYSE:IGD",
      companyName: "VOYA GLOBAL EQUITY DIVIDEND AND PREMIUM OPPORTUNITY FUND",
      popularity: 0,
    },
    {
      slug: "nyse-ige",
      code: "NYSE:IGE",
      companyName: "iShares North American Natural Resources ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igeb",
      code: "NYSE:IGEB",
      companyName: "iShares Investment Grade Bond Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igf",
      code: "NYSE:IGF",
      companyName: "iShares Global Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ighg",
      code: "NYSE:IGHG",
      companyName: "ProShares Investment Grade-Interest Rate Hedged",
      popularity: 0,
    },
    {
      slug: "nyse-igi",
      code: "NYSE:IGI",
      companyName:
        "Western Asset Investment Grade Defined Opportunity Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-igib",
      code: "NYSE:IGIB",
      companyName:
        "iShares Trust iShares 5-10 Year Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igic",
      code: "NYSE:IGIC",
      companyName:
        "International General Insurance Holdings Ltd. Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-igicw",
      code: "NYSE:IGICW",
      companyName:
        "International General Insurance Holdings Ltd. Warrants expiring 03/17/2025",
      popularity: 0,
    },
    {
      slug: "nyse-iglb",
      code: "NYSE:IGLB",
      companyName: "iShares 10+ Year Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igld",
      code: "NYSE:IGLD",
      companyName: "FT Cboe Vest Gold Strategy Target Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igm",
      code: "NYSE:IGM",
      companyName: "iShares Expanded Tech Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igms",
      code: "NYSE:IGMS",
      companyName: "IGM Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ign",
      code: "NYSE:IGN",
      companyName: "iShares North American Tech-Multimedia Networking ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igny",
      code: "NYSE:IGNY",
      companyName: "Ignyte Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ignyu",
      code: "NYSE:IGNYU",
      companyName: "Ignyte Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ignyw",
      code: "NYSE:IGNYW",
      companyName: "Ignyte Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-igov",
      code: "NYSE:IGOV",
      companyName: "iShares 1-3 Year International Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igr",
      code: "NYSE:IGR",
      companyName: "CBRE Global Real Estate Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-igro",
      code: "NYSE:IGRO",
      companyName: "iShares International Dividend Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igsb",
      code: "NYSE:IGSB",
      companyName:
        "iShares Trust iShares 1-5 Year Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-igta",
      code: "NYSE:IGTA",
      companyName: "Inception Growth Acquisition Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-igtar",
      code: "NYSE:IGTAR",
      companyName: "Inception Growth Acquisition Limited Rights",
      popularity: 0,
    },
    {
      slug: "nyse-igtau",
      code: "NYSE:IGTAU",
      companyName: "Inception Growth Acquisition Limited Unit",
      popularity: 0,
    },
    {
      slug: "nyse-igtaw",
      code: "NYSE:IGTAW",
      companyName: "Inception Growth Acquisition Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-igv",
      code: "NYSE:IGV",
      companyName: "iShares Expanded Tech-Software Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ih",
      code: "NYSE:IH",
      companyName:
        "iHuman Inc. American depositary shares each representing five Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-ihak",
      code: "NYSE:IHAK",
      companyName: "iShares Cybersecurity and Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ihd",
      code: "NYSE:IHD",
      companyName: "VOYA EMERGING MARKETS HIGH INCOME DIVIDEND EQUITY FUND",
      popularity: 0,
    },
    {
      slug: "nyse-ihdg",
      code: "NYSE:IHDG",
      companyName:
        "WisdomTree International Hedged Quality Dividend Growth Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ihe",
      code: "NYSE:IHE",
      companyName: "iShares U.S. Pharmaceuticals ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ihf",
      code: "NYSE:IHF",
      companyName: "iShares U.S. Healthcare Providers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ihg",
      code: "NYSE:IHG",
      companyName: "InterContinental Hotels Group Plc",
      popularity: 0,
    },
    {
      slug: "nyse-ihi",
      code: "NYSE:IHI",
      companyName: "iShares U.S. Medical Devices ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ihit",
      code: "NYSE:IHIT",
      companyName:
        "Invesco High Income 2023 Target Term Fund Common Shares of Beneficial Interest No par value per sha",
      popularity: 0,
    },
    {
      slug: "nyse-ihrt",
      code: "NYSE:IHRT",
      companyName: "iHeartMedia Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ihs",
      code: "NYSE:IHS",
      companyName: "IHS Holding Limited",
      popularity: 0,
    },
    {
      slug: "nyse-iht",
      code: "NYSE:IHT",
      companyName: "InnSuites Hospitality Trust",
      popularity: 0,
    },
    {
      slug: "nyse-ihta",
      code: "NYSE:IHTA",
      companyName: "Invesco High Income 2024 Target Term Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ihy",
      code: "NYSE:IHY",
      companyName: "VanEck International High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ihyf",
      code: "NYSE:IHYF",
      companyName: "Invesco High Yield Bond Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iif",
      code: "NYSE:IIF",
      companyName: "Morgan Stanley India Investment Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iigd",
      code: "NYSE:IIGD",
      companyName: "Invesco Investment Grade Defensive ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iigv",
      code: "NYSE:IIGV",
      companyName: "Invesco Investment Grade Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iii",
      code: "NYSE:III",
      companyName: "Information Services Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iiii",
      code: "NYSE:IIII",
      companyName: "INSU Acquisition Corp. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iiiiu",
      code: "NYSE:IIIIU",
      companyName: "INSU Acquisition Corp. III Unit",
      popularity: 0,
    },
    {
      slug: "nyse-iiiiw",
      code: "NYSE:IIIIW",
      companyName: "INSU Acquisition Corp. III Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-iiin",
      code: "NYSE:IIIN",
      companyName: "Insteel Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iiiv",
      code: "NYSE:IIIV",
      companyName: "i3 Verticals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iim",
      code: "NYSE:IIM",
      companyName: "INVESCO VALUE MUNICIPAL INCOME TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-iinn",
      code: "NYSE:IINN",
      companyName: "Inspira Technologies Oxy B.H.N. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-iinnw",
      code: "NYSE:IINNW",
      companyName: "Inspira Technologies Oxy B.H.N. Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-iipr",
      code: "NYSE:IIPR",
      companyName: "Innovative Industrial Properties Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-iipr-a",
      code: "NYSE:IIPR-A",
      companyName:
        "Innovative Industrial Properties Inc.9.00 Percent Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iivi",
      code: "NYSE:IIVI",
      companyName: "Ii-Vi Inc",
      popularity: 0,
    },
    {
      slug: "nyse-iivip",
      code: "NYSE:IIVIP",
      companyName:
        "II-VI Incorporated 6.00% Series A Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ijan",
      code: "NYSE:IJAN",
      companyName:
        "Innovator International Developed Power Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-ijh",
      code: "NYSE:IJH",
      companyName: "iShares Core S&P Mid-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ijj",
      code: "NYSE:IJJ",
      companyName: "iShares S&P Mid-Cap 400 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ijk",
      code: "NYSE:IJK",
      companyName: "iShares S&P Mid-Cap 400 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ijr",
      code: "NYSE:IJR",
      companyName: "iShares Core S&P Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ijs",
      code: "NYSE:IJS",
      companyName: "iShares S&P Small-Cap 600 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ijt",
      code: "NYSE:IJT",
      companyName: "iShares S&P Small-Cap 600 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ijul",
      code: "NYSE:IJUL",
      companyName: "Innovator International Developed Power Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-ikna",
      code: "NYSE:IKNA",
      companyName: "Ikena Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ikt",
      code: "NYSE:IKT",
      companyName: "Inhibikase Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ilag",
      code: "NYSE:ILAG",
      companyName: "Intelligent Living Application Group Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ilcb",
      code: "NYSE:ILCB",
      companyName: "iShares Morningstar U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ilcg",
      code: "NYSE:ILCG",
      companyName: "iShares Morningstar Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ilcv",
      code: "NYSE:ILCV",
      companyName: "iShares Morningstar Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ildr",
      code: "NYSE:ILDR",
      companyName: "First Trust Innovation Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ilf",
      code: "NYSE:ILF",
      companyName: "iShares Latin America 40 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ilmn",
      code: "NYSE:ILMN",
      companyName: "Illumina Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ilpt",
      code: "NYSE:ILPT",
      companyName:
        "Industrial Logistics Properties Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-iltb",
      code: "NYSE:ILTB",
      companyName: "iShares Core 10+ Year USD Bond ETFof iShares Trust",
      popularity: 0,
    },
    {
      slug: "nyse-imab",
      code: "NYSE:IMAB",
      companyName: "I-MAB American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-imacw",
      code: "NYSE:IMACW",
      companyName: "IMAC Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-imaq",
      code: "NYSE:IMAQ",
      companyName: "International Media Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-imaqr",
      code: "NYSE:IMAQR",
      companyName: "International Media Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-imaqu",
      code: "NYSE:IMAQU",
      companyName: "International Media Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-imaqw",
      code: "NYSE:IMAQW",
      companyName: "International Media Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-imax",
      code: "NYSE:IMAX",
      companyName: "Imax Corp",
      popularity: 0,
    },
    {
      slug: "nyse-imbi",
      code: "NYSE:IMBI",
      companyName: "iMedia Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-imbil",
      code: "NYSE:IMBIL",
      companyName: "iMedia Brands Inc. 8.5% Senior Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-imcb",
      code: "NYSE:IMCB",
      companyName: "iShares Morningstar Mid-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-imcc",
      code: "NYSE:IMCC",
      companyName: "IM Cannabis Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-imcg",
      code: "NYSE:IMCG",
      companyName: "iShares Morningstar Mid-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-imcr",
      code: "NYSE:IMCR",
      companyName: "Immunocore Holdings plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-imcv",
      code: "NYSE:IMCV",
      companyName: "iShares Morningstar Mid-Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-imfl",
      code: "NYSE:IMFL",
      companyName: "Invesco International Developed Dynamic Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-imgn",
      code: "NYSE:IMGN",
      companyName: "Immunogen Inc",
      popularity: 0,
    },
    {
      slug: "nyse-imgo",
      code: "NYSE:IMGO",
      companyName: "Imago BioSciences Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-imh",
      code: "NYSE:IMH",
      companyName: "Impac Mortgage Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-imkta",
      code: "NYSE:IMKTA",
      companyName: "Ingles Markets Inc",
      popularity: 0,
    },
    {
      slug: "nyse-imlp",
      code: "NYSE:IMLP",
      companyName: "iPath S&P MLP ETN",
      popularity: 0,
    },
    {
      slug: "nyse-immp",
      code: "NYSE:IMMP",
      companyName: "Immutep Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-immr",
      code: "NYSE:IMMR",
      companyName: "Immersion Corp",
      popularity: 0,
    },
    {
      slug: "nyse-immx",
      code: "NYSE:IMMX",
      companyName: "Immix Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-imnm",
      code: "NYSE:IMNM",
      companyName: "Immunome Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-imo",
      code: "NYSE:IMO",
      companyName: "Imperial Oil Limited",
      popularity: 0,
    },
    {
      slug: "nyse-imom",
      code: "NYSE:IMOM",
      companyName: "Alpha Architect International Quantitative Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-imos",
      code: "NYSE:IMOS",
      companyName: "ChipMOS TECHNOLOGIES INC",
      popularity: 0,
    },
    {
      slug: "nyse-impl",
      code: "NYSE:IMPL",
      companyName: "Impel Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-impp",
      code: "NYSE:IMPP",
      companyName: "Imperial Petroleum Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-imppp",
      code: "NYSE:IMPPP",
      companyName:
        "Imperial Petroleum Inc. 8.75% Series A Cumulative Redeemable Perpetual Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-impx",
      code: "NYSE:IMPX",
      companyName: "AEA-Bridges Impact Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-imra",
      code: "NYSE:IMRA",
      companyName: "IMARA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-imrn",
      code: "NYSE:IMRN",
      companyName: "Immuron Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-imrx",
      code: "NYSE:IMRX",
      companyName: "Immuneering Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-imtb",
      code: "NYSE:IMTB",
      companyName: "iShares Core 5-10 Year USD Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-imte",
      code: "NYSE:IMTE",
      companyName: "Integrated Media Technology Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-imtm",
      code: "NYSE:IMTM",
      companyName: "iShares MSCI Intl Momentum Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-imtx",
      code: "NYSE:IMTX",
      companyName: "Immatics N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-imtxw",
      code: "NYSE:IMTXW",
      companyName: "Immatics N.V. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-imux",
      code: "NYSE:IMUX",
      companyName: "Immunic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-imv",
      code: "NYSE:IMV",
      companyName: "IMV Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-imvt",
      code: "NYSE:IMVT",
      companyName: "Immunovant Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-imxi",
      code: "NYSE:IMXI",
      companyName: "International Money Express Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-inab",
      code: "NYSE:INAB",
      companyName: "IN8bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inaq",
      code: "NYSE:INAQ",
      companyName: "Insight Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-inbk",
      code: "NYSE:INBK",
      companyName: "First Internet Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-inbkz",
      code: "NYSE:INBKZ",
      companyName:
        "First Internet Bancorp 6.0% Fixed-to-Floating Rate Subordinated Notes Due 2029",
      popularity: 0,
    },
    {
      slug: "nyse-inbx",
      code: "NYSE:INBX",
      companyName: "Inhibrx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inco",
      code: "NYSE:INCO",
      companyName: "Columbia India Consumer ETF",
      popularity: 0,
    },
    {
      slug: "nyse-incr",
      code: "NYSE:INCR",
      companyName: "Intercure Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-incy",
      code: "NYSE:INCY",
      companyName: "Incyte Genomics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-inda",
      code: "NYSE:INDA",
      companyName: "iShares MSCI India ETF",
      popularity: 0,
    },
    {
      slug: "nyse-indi",
      code: "NYSE:INDI",
      companyName: "indie Semiconductor Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-indiw",
      code: "NYSE:INDIW",
      companyName: "indie Semiconductor Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-indl",
      code: "NYSE:INDL",
      companyName: "Direxion Daily MSCI India Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-indo",
      code: "NYSE:INDO",
      companyName: "Indonesia Energy Corporation Limited",
      popularity: 0,
    },
    {
      slug: "nyse-indp",
      code: "NYSE:INDP",
      companyName: "Indaptus Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inds",
      code: "NYSE:INDS",
      companyName: "Pacer Benchmark Industrial Real Estate SCTR ETF",
      popularity: 0,
    },
    {
      slug: "nyse-indt",
      code: "NYSE:INDT",
      companyName: "INDUS Realty Trust Inc. (MD) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-indy",
      code: "NYSE:INDY",
      companyName: "iShares S&P India Nifty 50 Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-infa",
      code: "NYSE:INFA",
      companyName: "Informatica Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-infi",
      code: "NYSE:INFI",
      companyName: "Infinity Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-infl",
      code: "NYSE:INFL",
      companyName: "Horizon Kinetics Inflation Beneficiaries ETF",
      popularity: 0,
    },
    {
      slug: "nyse-infn",
      code: "NYSE:INFN",
      companyName: "Infinera Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-infu",
      code: "NYSE:INFU",
      companyName: "InfuSystem Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-infy",
      code: "NYSE:INFY",
      companyName: "Infosys Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ingn",
      code: "NYSE:INGN",
      companyName: "Inogen Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ingr",
      code: "NYSE:INGR",
      companyName: "Ingredion Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-inka",
      code: "NYSE:INKA",
      companyName: "KludeIn I Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inkau",
      code: "NYSE:INKAU",
      companyName: "KludeIn I Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-inkaw",
      code: "NYSE:INKAW",
      companyName: "KludeIn I Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-inkm",
      code: "NYSE:INKM",
      companyName: "SPDR SSgA Income Allocation ETF of SSgA Active Trust",
      popularity: 0,
    },
    {
      slug: "nyse-inkt",
      code: "NYSE:INKT",
      companyName: "MiNK Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inm",
      code: "NYSE:INM",
      companyName: "InMed Pharmaceuticals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-inmb",
      code: "NYSE:INMB",
      companyName: "INmune Bio Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-inmd",
      code: "NYSE:INMD",
      companyName: "InMode Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-inmu",
      code: "NYSE:INMU",
      companyName: "BlackRock Intermediate Muni Income Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-inn",
      code: "NYSE:INN",
      companyName: "Summit Hotel Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-inn-e",
      code: "NYSE:INN-E",
      companyName:
        "Summit Hotel Properties Inc. 6.250% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inn-f",
      code: "NYSE:INN-F",
      companyName:
        "Summit Hotel Properties Inc. 5.875% Series F Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inno",
      code: "NYSE:INNO",
      companyName: "Harbor Disruptive Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-innv",
      code: "NYSE:INNV",
      companyName: "InnovAge Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ino",
      code: "NYSE:INO",
      companyName: "Inovio Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-inod",
      code: "NYSE:INOD",
      companyName: "Innodata Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-inpx",
      code: "NYSE:INPX",
      companyName: "Inpixon Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inqq",
      code: "NYSE:INQQ",
      companyName: "India Internet & Ecommerce ETF",
      popularity: 0,
    },
    {
      slug: "nyse-inse",
      code: "NYSE:INSE",
      companyName: "Inspired Entertainment Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-insg",
      code: "NYSE:INSG",
      companyName: "Inseego Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-insi",
      code: "NYSE:INSI",
      companyName: "Insight Select Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-insm",
      code: "NYSE:INSM",
      companyName: "Insmed Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-insp",
      code: "NYSE:INSP",
      companyName: "Inspire Medical Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-inst",
      code: "NYSE:INST",
      companyName: "Instructure Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-insw",
      code: "NYSE:INSW",
      companyName: "International Seaways Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-int",
      code: "NYSE:INT",
      companyName: "World Fuel Services Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-inta",
      code: "NYSE:INTA",
      companyName: "Intapp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inte",
      code: "NYSE:INTE",
      companyName: "Integral Acquisition Corporation 1 Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inteu",
      code: "NYSE:INTEU",
      companyName: "Integral Acquisition Corporation 1 Unit",
      popularity: 0,
    },
    {
      slug: "nyse-intew",
      code: "NYSE:INTEW",
      companyName: "Integral Acquisition Corporation 1 Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-intf",
      code: "NYSE:INTF",
      companyName: "iShares International Equity Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-intg",
      code: "NYSE:INTG",
      companyName: "Intergroup Corporation (The)",
      popularity: 0,
    },
    {
      slug: "nyse-intr",
      code: "NYSE:INTR",
      companyName: "Inter & Co. Inc. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-intt",
      code: "NYSE:INTT",
      companyName: "inTEST Corporation",
      popularity: 0,
    },
    {
      slug: "asx-ai1",
      code: "ASX:AI1",
      companyName: "Adisyn Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-intz",
      code: "NYSE:INTZ",
      companyName: "Intrusion Inc New",
      popularity: 0,
    },
    {
      slug: "nyse-inuv",
      code: "NYSE:INUV",
      companyName: "Inuvo Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-inva",
      code: "NYSE:INVA",
      companyName: "Innoviva Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-inve",
      code: "NYSE:INVE",
      companyName: "Identive Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-invo",
      code: "NYSE:INVO",
      companyName: "INVO BioScienceINC Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-invz",
      code: "NYSE:INVZ",
      companyName: "Innoviz Technologies Ltd. Ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-invzw",
      code: "NYSE:INVZW",
      companyName: "Innoviz Technologies Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-inzy",
      code: "NYSE:INZY",
      companyName: "Inozyme Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ioac",
      code: "NYSE:IOAC",
      companyName:
        "Innovative International Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ioacw",
      code: "NYSE:IOACW",
      companyName: "Innovative International Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-ioct",
      code: "NYSE:IOCT",
      companyName: "Innovator International Developed Power Buffer ETF-October",
      popularity: 0,
    },
    {
      slug: "nyse-ionm",
      code: "NYSE:IONM",
      companyName: "Assure Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ioo",
      code: "NYSE:IOO",
      companyName: "iShares Global 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ionr",
      code: "NYSE:IONR",
      companyName: "ioneer Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ions",
      code: "NYSE:IONS",
      companyName: "Ionis Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ior",
      code: "NYSE:IOR",
      companyName: "Income Opportunity Realty Investors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iosp",
      code: "NYSE:IOSP",
      companyName: "Innospec Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iova",
      code: "NYSE:IOVA",
      companyName: "Iovance Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ip",
      code: "NYSE:IP",
      companyName: "International Paper Co.",
      popularity: 0,
    },
    {
      slug: "nyse-ipa",
      code: "NYSE:IPA",
      companyName: "IMMUNOPRECISE ANTIBODIES LTD",
      popularity: 0,
    },
    {
      slug: "nyse-ipac",
      code: "NYSE:IPAC",
      companyName: "iShares Core MSCI Pacific ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ipar",
      code: "NYSE:IPAR",
      companyName: "Inter Parfums Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ipax",
      code: "NYSE:IPAX",
      companyName: "Inflection Point Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ipaxu",
      code: "NYSE:IPAXU",
      companyName: "Inflection Point Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-ipaxw",
      code: "NYSE:IPAXW",
      companyName: "Inflection Point Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-ipay",
      code: "NYSE:IPAY",
      companyName: "ETFMG Prime Mobile Payments ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ipb",
      code: "NYSE:IPB",
      companyName:
        "Merrill Lynch 6.0518% Index Plus Trust Certificates Series 2003-1",
      popularity: 0,
    },
    {
      slug: "nyse-ipdn",
      code: "NYSE:IPDN",
      companyName: "Professional Diversity Network Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ipdp",
      code: "NYSE:IPDP",
      companyName: "Dividend Performers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ipg",
      code: "NYSE:IPG",
      companyName: "The Interpublic Group of Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ipgp",
      code: "NYSE:IPGP",
      companyName: "IPG Photonics Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ipha",
      code: "NYSE:IPHA",
      companyName: "Innate Pharma S.A. ADS",
      popularity: 0,
    },
    {
      slug: "nyse-ipi",
      code: "NYSE:IPI",
      companyName: "Intrepid Potash Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ipkw",
      code: "NYSE:IPKW",
      companyName: "Invesco International BuyBack Achievers  ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ipo",
      code: "NYSE:IPO",
      companyName: "Renaissance IPO ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ipod",
      code: "NYSE:IPOD",
      companyName: "Social Capital Hedosophia Holdings Corp. IV",
      popularity: 0,
    },
    {
      slug: "nyse-ipof",
      code: "NYSE:IPOF",
      companyName: "Social Capital Hedosophia Holdings Corp. VI",
      popularity: 0,
    },
    {
      slug: "nyse-ipos",
      code: "NYSE:IPOS",
      companyName: "Renaissance International IPO ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ippp",
      code: "NYSE:IPPP",
      companyName: "Preferred-Plus ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ipsc",
      code: "NYSE:IPSC",
      companyName: "Century Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ipva",
      code: "NYSE:IPVA",
      companyName: "InterPrivate II Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ipvf",
      code: "NYSE:IPVF",
      companyName: "InterPrivate III Financial Partners Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ipvi",
      code: "NYSE:IPVI",
      companyName:
        "InterPrivate IV InfraTech Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ipviu",
      code: "NYSE:IPVIU",
      companyName: "InterPrivate IV InfraTech Partners Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-ipviw",
      code: "NYSE:IPVIW",
      companyName: "InterPrivate IV InfraTech Partners Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ipw",
      code: "NYSE:IPW",
      companyName: "iPower Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ipwr",
      code: "NYSE:IPWR",
      companyName: "Ideal Power Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ipx",
      code: "NYSE:IPX",
      companyName: "IperionX Limited American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-iq",
      code: "NYSE:IQ",
      companyName: "iQIYI Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-iqde",
      code: "NYSE:IQDE",
      companyName:
        "FlexShares International Quality Dividend Defensive Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-iqdf",
      code: "NYSE:IQDF",
      companyName: "FlexShares International Quality Dividend Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-iqdg",
      code: "NYSE:IQDG",
      companyName: "WisdomTree International Quality Dividend Growth Fund",
      popularity: 0,
    },
    {
      slug: "nyse-iqdy",
      code: "NYSE:IQDY",
      companyName:
        "FlexShares International Quality Dividend Dynamic Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-iqi",
      code: "NYSE:IQI",
      companyName: "INVESCO QUALITY MUNICIPAL SECURITIES",
      popularity: 0,
    },
    {
      slug: "nyse-iqin",
      code: "NYSE:IQIN",
      companyName: "IQ 500 International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iqlt",
      code: "NYSE:IQLT",
      companyName: "iShares MSCI Intl Quality Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iqm",
      code: "NYSE:IQM",
      companyName: "Franklin Intelligent Machines ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iqmd",
      code: "NYSE:IQMD",
      companyName:
        "Intelligent Medicine Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iqmdu",
      code: "NYSE:IQMDU",
      companyName: "Intelligent Medicine Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-iqmdw",
      code: "NYSE:IQMDW",
      companyName: "Intelligent Medicine Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-iqsi",
      code: "NYSE:IQSI",
      companyName: "IQ Candriam ESG International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iqsu",
      code: "NYSE:IQSU",
      companyName: "IQ Candriam ESG US Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ir",
      code: "NYSE:IR",
      companyName: "Ingersoll Rand Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iraa",
      code: "NYSE:IRAA",
      companyName: "Iris Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iraau",
      code: "NYSE:IRAAU",
      companyName: "Iris Acquisition Corp Units",
      popularity: 0,
    },
    {
      slug: "nyse-iraaw",
      code: "NYSE:IRAAW",
      companyName: "Iris Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-irba",
      code: "NYSE:IRBA",
      companyName: "iMGP RBA Responsible Global Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-irbo",
      code: "NYSE:IRBO",
      companyName:
        "iShares Robotics and Artificial Intelligence Multisector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-irbt",
      code: "NYSE:IRBT",
      companyName: "iRobot Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-irdm",
      code: "NYSE:IRDM",
      companyName: "Iridium Communications Inc.",
      popularity: 0,
    },
    {
      slug: "asx-tridb",
      code: "ASX:TRIDB",
      companyName: "Trivarx Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-irix",
      code: "NYSE:IRIX",
      companyName: "Iridex Corp",
      popularity: 0,
    },
    {
      slug: "nyse-irl",
      code: "NYSE:IRL",
      companyName: "NEW IRELAND FUND INC",
      popularity: 0,
    },
    {
      slug: "asx-jayn",
      code: "ASX:JAYN",
      companyName: "Jayride Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-irmd",
      code: "NYSE:IRMD",
      companyName: "iRadimed Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-irnt",
      code: "NYSE:IRNT",
      companyName: "IronNet Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iroq",
      code: "NYSE:IROQ",
      companyName: "IF Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-irrx",
      code: "NYSE:IRRX",
      companyName: "Integrated Rail and Resources Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-irs",
      code: "NYSE:IRS",
      companyName:
        "IRSA Inversiones y Representaciones S.A. Global Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-irt",
      code: "NYSE:IRT",
      companyName: "Independence Realty Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-irtc",
      code: "NYSE:IRTC",
      companyName: "iRhythm Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-irwd",
      code: "NYSE:IRWD",
      companyName: "Ironwood Pharmaceuticals Inc. - Class A",
      popularity: 0,
    },
    {
      slug: "nyse-is",
      code: "NYSE:IS",
      companyName: "ironSource Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-isaa",
      code: "NYSE:ISAA",
      companyName: "Iron Spark I Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iscb",
      code: "NYSE:ISCB",
      companyName: "iShares Morningstar Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iscf",
      code: "NYSE:ISCF",
      companyName: "iShares MSCI Intl Small-Cap Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iscg",
      code: "NYSE:ISCG",
      companyName: "iShares Morningstar Small-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iscv",
      code: "NYSE:ISCV",
      companyName: "iShares Morningstar Small-Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-isd",
      code: "NYSE:ISD",
      companyName: "PGIM High Yield Bond Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-isdr",
      code: "NYSE:ISDR",
      companyName: "Issuer Direct Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-isdx",
      code: "NYSE:ISDX",
      companyName:
        "Invesco Exchange-Traded Self-Indexed Fund Trust Invesco RAFI Strategic Developed ex-US ETF",
      popularity: 0,
    },
    {
      slug: "nyse-isee",
      code: "NYSE:ISEE",
      companyName: "IVERIC bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-isem",
      code: "NYSE:ISEM",
      companyName:
        "Invesco Exchange-Traded Self-Indexed Fund Trust Invesco RAFI Strategic Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ishg",
      code: "NYSE:ISHG",
      companyName: "iShares International Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ishp",
      code: "NYSE:ISHP",
      companyName:
        "First Trust Exchange-Traded Fund VI First Trust S-Network E-Commerce ETF",
      popularity: 0,
    },
    {
      slug: "nyse-isig",
      code: "NYSE:ISIG",
      companyName: "Insignia Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-isle",
      code: "NYSE:ISLE",
      companyName: "Isleworth Healthcare Acquisition Corporation Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-islew",
      code: "NYSE:ISLEW",
      companyName: "Isleworth Healthcare Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ismd",
      code: "NYSE:ISMD",
      companyName: "Inspire Small/Mid Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iso",
      code: "NYSE:ISO",
      companyName: "IsoPlexis Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-irvh",
      code: "NYSE:IRVH",
      companyName: "Global X Interest Rate Volatility & Inflation Hedge ETF",
      popularity: 0,
    },
    {
      slug: "nyse-irhg",
      code: "NYSE:IRHG",
      companyName: "Global X Interest Rate Hedge ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iqv",
      code: "NYSE:IQV",
      companyName: "IQVIA Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ispc",
      code: "NYSE:ISPC",
      companyName: "iSpecimen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ispo",
      code: "NYSE:ISPO",
      companyName: "Inspirato Incorporated Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ispow",
      code: "NYSE:ISPOW",
      companyName: "Inspirato Incorporated Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-isr",
      code: "NYSE:ISR",
      companyName: "IsoRay Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-isra",
      code: "NYSE:ISRA",
      companyName: "VanEck Israel ETF",
      popularity: 0,
    },
    {
      slug: "nyse-issc",
      code: "NYSE:ISSC",
      companyName: "Innovative Solutions & Support",
      popularity: 0,
    },
    {
      slug: "nyse-istb",
      code: "NYSE:ISTB",
      companyName: "iShares Core 1-5 Year USD Bond ETF of iShares Trust",
      popularity: 0,
    },
    {
      slug: "nyse-istr",
      code: "NYSE:ISTR",
      companyName: "Investar Holding Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-isun",
      code: "NYSE:ISUN",
      companyName: "iSun Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-isvl",
      code: "NYSE:ISVL",
      companyName: "iShares International Developed Small Cap Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iswn",
      code: "NYSE:ISWN",
      companyName: "Amplify BlackSwan ISWN ETF",
      popularity: 0,
    },
    {
      slug: "nyse-isze",
      code: "NYSE:ISZE",
      companyName: "iShares MSCI Intl Size Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-it",
      code: "NYSE:IT",
      companyName: "Gartner Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ita",
      code: "NYSE:ITA",
      companyName: "iShares U.S. Aerospace & Defense ETF",
      popularity: 0,
    },
    {
      slug: "nyse-itan",
      code: "NYSE:ITAN",
      companyName: "Sparkline Intangible Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-itaq",
      code: "NYSE:ITAQ",
      companyName: "Industrial Tech Acquisitions II Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-itaqu",
      code: "NYSE:ITAQU",
      companyName: "Industrial Tech Acquisitions II Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-itaqw",
      code: "NYSE:ITAQW",
      companyName: "Industrial Tech Acquisitions II Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-itb",
      code: "NYSE:ITB",
      companyName: "iShares U.S. Home Construction ETF",
      popularity: 0,
    },
    {
      slug: "nyse-itcb",
      code: "NYSE:ITCB",
      companyName: "Itau CorpBanca",
      popularity: 0,
    },
    {
      slug: "nyse-itci",
      code: "NYSE:ITCI",
      companyName: "Intra-Cellular Therapies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-iteq",
      code: "NYSE:ITEQ",
      companyName: "BlueStar Israel Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-itgr",
      code: "NYSE:ITGR",
      companyName: "Integer Holdings Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-iti",
      code: "NYSE:ITI",
      companyName: "Iteris Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-itic",
      code: "NYSE:ITIC",
      companyName: "Investors Title Co",
      popularity: 0,
    },
    {
      slug: "nyse-itm",
      code: "NYSE:ITM",
      companyName: "VanEck Intermediate Muni ETF",
      popularity: 0,
    },
    {
      slug: "nyse-itos",
      code: "NYSE:ITOS",
      companyName: "iTeos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-itot",
      code: "NYSE:ITOT",
      companyName: "iShares Core S&P Total U.S. Stock Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-itp",
      code: "NYSE:ITP",
      companyName: "IT Tech Packaging Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-itq",
      code: "NYSE:ITQ",
      companyName: "Itiquira Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-itqru",
      code: "NYSE:ITQRU",
      companyName: "Itiquira Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-itqrw",
      code: "NYSE:ITQRW",
      companyName: "Itiquira Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-itrg",
      code: "NYSE:ITRG",
      companyName: "Integra Resources Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-itri",
      code: "NYSE:ITRI",
      companyName: "Itron Inc",
      popularity: 0,
    },
    {
      slug: "nyse-itrm",
      code: "NYSE:ITRM",
      companyName: "Iterum Therapeutics plc Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-itrn",
      code: "NYSE:ITRN",
      companyName: "Ituran Location and Control Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-itt",
      code: "NYSE:ITT",
      companyName: "ITT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-itub",
      code: "NYSE:ITUB",
      companyName: "Itau Unibanco Holding S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-itw",
      code: "NYSE:ITW",
      companyName: "Illinois Tool Works Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ius",
      code: "NYSE:IUS",
      companyName:
        "Invesco Exchange-Traded Self-Indexed Fund Trust Invesco RAFI Strategic US ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iusa",
      code: "NYSE:IUSA",
      companyName: "Amberwave Invest USA JSG Fund",
      popularity: 0,
    },
    {
      slug: "nyse-iusb",
      code: "NYSE:IUSB",
      companyName: "iShares Core Total USD Bond Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iusg",
      code: "NYSE:IUSG",
      companyName: "iShares Core S&P U.S. Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iuss",
      code: "NYSE:IUSS",
      companyName:
        "Invesco Exchange-Traded Self-Indexed Fund Trust Invesco RAFI Strategic US Small Company ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iusv",
      code: "NYSE:IUSV",
      companyName: "iShares Core S&P U.S. Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iva",
      code: "NYSE:IVA",
      companyName: "Inventiva S.A. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ivac",
      code: "NYSE:IVAC",
      companyName: "Intevac Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ival",
      code: "NYSE:IVAL",
      companyName: "Alpha Architect International Quantitative Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivc",
      code: "NYSE:IVC",
      companyName: "Invacare Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ivca",
      code: "NYSE:IVCA",
      companyName: "Investcorp India Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ivcau",
      code: "NYSE:IVCAU",
      companyName: "Investcorp India Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ivcaw",
      code: "NYSE:IVCAW",
      companyName: "Investcorp India Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ivcb",
      code: "NYSE:IVCB",
      companyName:
        "Investcorp Europe Acquisition Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ivcbu",
      code: "NYSE:IVCBU",
      companyName: "Investcorp Europe Acquisition Corp I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ivcbw",
      code: "NYSE:IVCBW",
      companyName: "Investcorp Europe Acquisition Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ivcp",
      code: "NYSE:IVCP",
      companyName: "Swiftmerge Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ivcpu",
      code: "NYSE:IVCPU",
      companyName: "Swiftmerge Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ivcpw",
      code: "NYSE:IVCPW",
      companyName: "Swiftmerge Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-ivda",
      code: "NYSE:IVDA",
      companyName: "Iveda Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ivdaw",
      code: "NYSE:IVDAW",
      companyName: "Iveda Solutions Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ivdg",
      code: "NYSE:IVDG",
      companyName: "Invesco Focused Discovery Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ive",
      code: "NYSE:IVE",
      companyName: "iShares S&P 500 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iveg",
      code: "NYSE:IVEG",
      companyName: "iShares Emergent Food and AgTech Multisector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ives",
      code: "NYSE:IVES",
      companyName: "Wedbush ETFMG Global Cloud Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivh",
      code: "NYSE:IVH",
      companyName: "Delaware Ivy High Income Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ivlc",
      code: "NYSE:IVLC",
      companyName: "Invesco US Large Cap Core ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivlu",
      code: "NYSE:IVLU",
      companyName: "iShares MSCI Intl Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivog",
      code: "NYSE:IVOG",
      companyName: "Vanguard S&P Mid-Cap 400 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivol",
      code: "NYSE:IVOL",
      companyName: "Quadratic Interest Rate Volatility and Inflation Hedge ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivoo",
      code: "NYSE:IVOO",
      companyName: "Vanguard S&P Mid-Cap 400 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivov",
      code: "NYSE:IVOV",
      companyName: "Vanguard S&P Mid-Cap 400 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivr",
      code: "NYSE:IVR",
      companyName: "Invesco Mortgage Capital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ivr-b",
      code: "NYSE:IVR-B",
      companyName:
        "INVESCO MORTGAGE CAPITAL INC. 7.75% Fixed-To-Floating Series B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ivr-c",
      code: "NYSE:IVR-C",
      companyName:
        "Invesco Mortgage Capital Inc. 7.5% Fixed-to-Floating Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ivra",
      code: "NYSE:IVRA",
      companyName: "Invesco Real Assets ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivsg",
      code: "NYSE:IVSG",
      companyName: "Invesco Select Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ivt",
      code: "NYSE:IVT",
      companyName: "InvenTrust Properties Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ivw",
      code: "NYSE:IVW",
      companyName: "iShares S&P 500 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwb",
      code: "NYSE:IWB",
      companyName: "iShares Russell 1000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwc",
      code: "NYSE:IWC",
      companyName: "iShares Micro-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwd",
      code: "NYSE:IWD",
      companyName: "iShares Russell 1000 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwdl",
      code: "NYSE:IWDL",
      companyName: "ETRACS 2x Leveraged US Value Factor TR ETN",
      popularity: 0,
    },
    {
      slug: "nyse-iwf",
      code: "NYSE:IWF",
      companyName: "iShares Russell 1000 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwfg",
      code: "NYSE:IWFG",
      companyName: "IQ Winslow Focused Large Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwfh",
      code: "NYSE:IWFH",
      companyName: "iShares Virtual Work and Life Multisector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwfl",
      code: "NYSE:IWFL",
      companyName: "ETRACS 2x Leveraged US Growth Factor TR ETN",
      popularity: 0,
    },
    {
      slug: "nyse-iwin",
      code: "NYSE:IWIN",
      companyName: "Amplify Inflation Fighter ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwl",
      code: "NYSE:IWL",
      companyName: "iShares Russell Top 200 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwlg",
      code: "NYSE:IWLG",
      companyName: "IQ Winslow Large Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwm",
      code: "NYSE:IWM",
      companyName: "iShares Russell 2000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwml",
      code: "NYSE:IWML",
      companyName: "ETRACS 2x Leveraged US Size Factor TR ETN",
      popularity: 0,
    },
    {
      slug: "nyse-iwn",
      code: "NYSE:IWN",
      companyName: "iShares Russell 2000 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwo",
      code: "NYSE:IWO",
      companyName: "iShares Russell 2000 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwp",
      code: "NYSE:IWP",
      companyName: "iShares Russell Mid-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iws",
      code: "NYSE:IWS",
      companyName: "iShares Russell Mid-Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwv",
      code: "NYSE:IWV",
      companyName: "iShares Russell 3000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwx",
      code: "NYSE:IWX",
      companyName: "iShares Russell Top 200 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iwy",
      code: "NYSE:IWY",
      companyName: "iShares Russell Top 200 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ix",
      code: "NYSE:IX",
      companyName: "ORIX Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ixaq",
      code: "NYSE:IXAQ",
      companyName: "IX Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ixaqu",
      code: "NYSE:IXAQU",
      companyName: "IX Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ixaqw",
      code: "NYSE:IXAQW",
      companyName: "IX Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ixc",
      code: "NYSE:IXC",
      companyName: "iShares Global Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ixg",
      code: "NYSE:IXG",
      companyName: "iShares Global Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ixhl",
      code: "NYSE:IXHL",
      companyName: "Incannex Healthcare Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ixn",
      code: "NYSE:IXN",
      companyName: "iShares Global Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ixp",
      code: "NYSE:IXP",
      companyName: "iShares Global Comm Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ixse",
      code: "NYSE:IXSE",
      companyName: "WisdomTree India Ex-State-Owned Enterprises Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ixus",
      code: "NYSE:IXUS",
      companyName: "iShares Core MSCI Total International Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyc",
      code: "NYSE:IYC",
      companyName: "iShares U.S. Consumer Discretionary ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iye",
      code: "NYSE:IYE",
      companyName: "iShares U.S. Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyf",
      code: "NYSE:IYF",
      companyName: "iShares U.S. Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyg",
      code: "NYSE:IYG",
      companyName: "iShares U.S. Financial Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyh",
      code: "NYSE:IYH",
      companyName: "iShares U.S. Healthcare ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyj",
      code: "NYSE:IYJ",
      companyName: "iShares U.S. Industrials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyk",
      code: "NYSE:IYK",
      companyName: "iShares U.S. Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyld",
      code: "NYSE:IYLD",
      companyName: "iShares Morningstar Multi-Asset Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iym",
      code: "NYSE:IYM",
      companyName: "iShares U.S. Basic Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyr",
      code: "NYSE:IYR",
      companyName: "iShares U.S. Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyt",
      code: "NYSE:IYT",
      companyName: "iShares U.S. Transportation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyw",
      code: "NYSE:IYW",
      companyName: "iShares U.S. Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyy",
      code: "NYSE:IYY",
      companyName: "iShares Dow Jones U.S. ETF",
      popularity: 0,
    },
    {
      slug: "nyse-iyz",
      code: "NYSE:IYZ",
      companyName: "iShares U.S. Telecommunications ETF",
      popularity: 0,
    },
    {
      slug: "nyse-izea",
      code: "NYSE:IZEA",
      companyName: "IZEA Worldwide Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-izrl",
      code: "NYSE:IZRL",
      companyName: "ARK Israel Innovative Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-j",
      code: "NYSE:J",
      companyName: "Jacobs Engineering Group",
      popularity: 0,
    },
    {
      slug: "nyse-jaaa",
      code: "NYSE:JAAA",
      companyName: "Janus Henderson AAA CLO ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jack",
      code: "NYSE:JACK",
      companyName: "Jack in the Box Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jagg",
      code: "NYSE:JAGG",
      companyName: "JPMorgan U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jagx",
      code: "NYSE:JAGX",
      companyName: "Jaguar Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jakk",
      code: "NYSE:JAKK",
      companyName: "Jakks Pacific Inc",
      popularity: 0,
    },
    {
      slug: "nyse-jepq",
      code: "NYSE:JEPQ",
      companyName: "J.P. Morgan Nasdaq Equity Premium Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jamf",
      code: "NYSE:JAMF",
      companyName: "Jamf Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jan",
      code: "NYSE:JAN",
      companyName: "JanOne Inc. Common Stock (NV)",
      popularity: 0,
    },
    {
      slug: "nyse-janx",
      code: "NYSE:JANX",
      companyName: "Janux Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-janz",
      code: "NYSE:JANZ",
      companyName: "TrueShares Structured Outcome (January) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jaqc",
      code: "NYSE:JAQC",
      companyName: "Jupiter Acquisition Corporation Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-jaqcu",
      code: "NYSE:JAQCU",
      companyName: "Jupiter Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nyse-jaqcw",
      code: "NYSE:JAQCW",
      companyName: "Jupiter Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-jatt",
      code: "NYSE:JATT",
      companyName: "JATT Acquisition Corp",
      popularity: 0,
    },
    {
      slug: "nyse-java",
      code: "NYSE:JAVA",
      companyName: "JPMorgan Active Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jazz",
      code: "NYSE:JAZZ",
      companyName: "Jazz Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jbbb",
      code: "NYSE:JBBB",
      companyName: "Janus Henderson B-BBB CLO ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jbgs",
      code: "NYSE:JBGS",
      companyName: "JBG SMITH Properties Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jbht",
      code: "NYSE:JBHT",
      companyName: "JB Hunt Transport Services Inc",
      popularity: 0,
    },
    {
      slug: "nyse-jbk",
      code: "NYSE:JBK",
      companyName: "Lehman ABS Corp 3.50 Adj Corp Backed Tr Cert Goldman Cap I",
      popularity: 0,
    },
    {
      slug: "nyse-jbl",
      code: "NYSE:JBL",
      companyName: "Jabil Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jblu",
      code: "NYSE:JBLU",
      companyName: "JetBlue Airways Corp",
      popularity: 0,
    },
    {
      slug: "nyse-jbss",
      code: "NYSE:JBSS",
      companyName: "John B. Sanfilippo & SON",
      popularity: 0,
    },
    {
      slug: "nyse-jbt",
      code: "NYSE:JBT",
      companyName: "John Bean Technologies Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-jce",
      code: "NYSE:JCE",
      companyName: "Nuveen Core Equity Alpha Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jci",
      code: "NYSE:JCI",
      companyName: "Johnson Controls International plc",
      popularity: 0,
    },
    {
      slug: "nyse-jcic",
      code: "NYSE:JCIC",
      companyName: "Jack Creek Investment Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jcicu",
      code: "NYSE:JCICU",
      companyName: "Jack Creek Investment Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-jcicw",
      code: "NYSE:JCICW",
      companyName: "Jack Creek Investment Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-jcpb",
      code: "NYSE:JCPB",
      companyName: "JPMorgan Core Plus Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jcpi",
      code: "NYSE:JCPI",
      companyName: "JPMorgan Inflation Managed Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jcse",
      code: "NYSE:JCSE",
      companyName: "JE Cleantech Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jctcf",
      code: "NYSE:JCTCF",
      companyName: "Jewett-Cameron Trading",
      popularity: 0,
    },
    {
      slug: "nyse-jdiv",
      code: "NYSE:JDIV",
      companyName: "JPMorgan U.S. Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jdst",
      code: "NYSE:JDST",
      companyName: "Direxion Daily Junior Gold Miners Index Bear 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jef",
      code: "NYSE:JEF",
      companyName: "Jefferies Financial Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jeld",
      code: "NYSE:JELD",
      companyName: "JELD-WEN Holding Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jema",
      code: "NYSE:JEMA",
      companyName: "JPMorgan ActiveBuilders Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jemd",
      code: "NYSE:JEMD",
      companyName:
        "Nuveen Emerging Markets Debt 2022 Target Term Fund Common Shares of Beneficial Interest $0.01 par",
      popularity: 0,
    },
    {
      slug: "nyse-jepi",
      code: "NYSE:JEPI",
      companyName: "JPMorgan Equity Premium Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jeq",
      code: "NYSE:JEQ",
      companyName: "abrdn Japan Equity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jets",
      code: "NYSE:JETS",
      companyName: "U.S. Global Jets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jfin",
      code: "NYSE:JFIN",
      companyName: "Jiayin Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jfr",
      code: "NYSE:JFR",
      companyName: "Nuveen Floating Rate Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jfu",
      code: "NYSE:JFU",
      companyName: "9F Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jfwd",
      code: "NYSE:JFWD",
      companyName: "Jacob Forward ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jg",
      code: "NYSE:JG",
      companyName: "Aurora Mobile Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jggc",
      code: "NYSE:JGGC",
      companyName: "Jaguar Global Growth Corporation I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jggcr",
      code: "NYSE:JGGCR",
      companyName: "Jaguar Global Growth Corporation I Right",
      popularity: 0,
    },
    {
      slug: "nyse-jggcu",
      code: "NYSE:JGGCU",
      companyName: "Jaguar Global Growth Corporation I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-jggcw",
      code: "NYSE:JGGCW",
      companyName: "Jaguar Global Growth Corporation I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-jgh",
      code: "NYSE:JGH",
      companyName: "NUVEEN GLOBAL HIGH INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-jgld",
      code: "NYSE:JGLD",
      companyName: "Amplify Pure Junior Gold Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jgro",
      code: "NYSE:JGRO",
      companyName: "JPMorgan Active Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhaa",
      code: "NYSE:JHAA",
      companyName: "Nuveen Corporate Income 2023 Target Term Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jhcb",
      code: "NYSE:JHCB",
      companyName: "John Hancock Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhcs",
      code: "NYSE:JHCS",
      companyName: "John Hancock Multifactor Media and Communications ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhem",
      code: "NYSE:JHEM",
      companyName: "John Hancock Multifactor Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhg",
      code: "NYSE:JHG",
      companyName: "Janus Henderson Group plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jhi",
      code: "NYSE:JHI",
      companyName: "John Hancock Investors Trust Capital Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jhma",
      code: "NYSE:JHMA",
      companyName: "John Hancock Multifactor Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhmb",
      code: "NYSE:JHMB",
      companyName: "John Hancock Mortgage-Backed Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhmc",
      code: "NYSE:JHMC",
      companyName: "John Hancock Multifactor Consumer Discretionary ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhmd",
      code: "NYSE:JHMD",
      companyName: "John Hancock Multifactor Developed International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhme",
      code: "NYSE:JHME",
      companyName: "John Hancock Multifactor Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhmf",
      code: "NYSE:JHMF",
      companyName: "John Hancock Multifactor Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhmh",
      code: "NYSE:JHMH",
      companyName: "John Hancock Multifactor Healthcare ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhmi",
      code: "NYSE:JHMI",
      companyName: "John Hancock Multifactor Industrials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhml",
      code: "NYSE:JHML",
      companyName: "John Hancock Multifactor Large Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhmm",
      code: "NYSE:JHMM",
      companyName: "John Hancock Multifactor Mid Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhms",
      code: "NYSE:JHMS",
      companyName: "John Hancock Multifactor Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhmt",
      code: "NYSE:JHMT",
      companyName: "John Hancock Multifactor Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhmu",
      code: "NYSE:JHMU",
      companyName: "John Hancock Multifactor Utilities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhpi",
      code: "NYSE:JHPI",
      companyName: "John Hancock Preferred Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jhs",
      code: "NYSE:JHS",
      companyName: "John Hancock Income Securities Trust Capital Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jhsc",
      code: "NYSE:JHSC",
      companyName: "John Hancock Multifactor Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jib",
      code: "NYSE:JIB",
      companyName: "Janus Henderson Sustainable & Impact Core Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jida",
      code: "NYSE:JIDA",
      companyName: "JPMorgan ActiveBuilders International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jig",
      code: "NYSE:JIG",
      companyName: "JPMorgan International Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jigb",
      code: "NYSE:JIGB",
      companyName: "JPMorgan Corporate Bond Research Enhanced ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jill",
      code: "NYSE:JILL",
      companyName: "J.Jill Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jire",
      code: "NYSE:JIRE",
      companyName: "JPMorgan International Research Enhanced Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jja",
      code: "NYSE:JJA",
      companyName:
        "iPath Series B Bloomberg Agriculture Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jjc",
      code: "NYSE:JJC",
      companyName:
        "iPath Series B Bloomberg Copper Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jje",
      code: "NYSE:JJE",
      companyName:
        "iPath Series B Bloomberg Energy Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jjg",
      code: "NYSE:JJG",
      companyName:
        "iPath Series B Bloomberg Grains Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jjm",
      code: "NYSE:JJM",
      companyName:
        "iPath Series B Bloomberg Industrial Metals Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jjn",
      code: "NYSE:JJN",
      companyName:
        "iPath Series B Bloomberg Nickel Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jjp",
      code: "NYSE:JJP",
      companyName:
        "iPath Series B Bloomberg Precious Metals Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jjs",
      code: "NYSE:JJS",
      companyName: "iPath Series B Bloomberg Softs Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jjsf",
      code: "NYSE:JJSF",
      companyName: "J&J Snack Foods Corp",
      popularity: 0,
    },
    {
      slug: "nyse-jkhy",
      code: "NYSE:JKHY",
      companyName: "Henry (Jack) & Associates",
      popularity: 0,
    },
    {
      slug: "nyse-jks",
      code: "NYSE:JKS",
      companyName: "JINKOSOLAR HOLDINGS CO",
      popularity: 0,
    },
    {
      slug: "nyse-jll",
      code: "NYSE:JLL",
      companyName: "Jones Lang LaSalle Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jls",
      code: "NYSE:JLS",
      companyName: "Nuveen Mortgage and Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jmac",
      code: "NYSE:JMAC",
      companyName: "Maxpro Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jmacu",
      code: "NYSE:JMACU",
      companyName: "Maxpro Capital Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-jmacw",
      code: "NYSE:JMACW",
      companyName: "Maxpro Capital Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-jmbs",
      code: "NYSE:JMBS",
      companyName: "Janus Henderson Mortgage-Backed Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jmee",
      code: "NYSE:JMEE",
      companyName: "JPMorgan Market Expansion Enhanced Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jmia",
      code: "NYSE:JMIA",
      companyName: "Jumia Technologies AG",
      popularity: 0,
    },
    {
      slug: "nyse-jmin",
      code: "NYSE:JMIN",
      companyName: "JPMorgan U.S. Minimum Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jmm",
      code: "NYSE:JMM",
      companyName: "NUVEEN MULTI-MARKET INCOME FUND INC",
      popularity: 0,
    },
    {
      slug: "nyse-jmom",
      code: "NYSE:JMOM",
      companyName: "JPMorgan U.S. Momentum Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jmsb",
      code: "NYSE:JMSB",
      companyName: "John Marshall Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jmst",
      code: "NYSE:JMST",
      companyName: "JPMorgan Ultra-Short Municipal Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jmub",
      code: "NYSE:JMUB",
      companyName: "JPMorgan Municipal ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jnce",
      code: "NYSE:JNCE",
      companyName: "Jounce Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jnk",
      code: "NYSE:JNK",
      companyName: "SPDR Bloomberg High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jnpr",
      code: "NYSE:JNPR",
      companyName: "Juniper Networks Inc",
      popularity: 0,
    },
    {
      slug: "nyse-jnug",
      code: "NYSE:JNUG",
      companyName: "Direxion Daily Junior Gold Miners Index Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jo",
      code: "NYSE:JO",
      companyName:
        "iPath Series B Bloomberg Coffee Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-joan",
      code: "NYSE:JOAN",
      companyName: "JOANN Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-job",
      code: "NYSE:JOB",
      companyName: "GEE Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-joby",
      code: "NYSE:JOBY",
      companyName: "Joby Aviation Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-joe",
      code: "NYSE:JOE",
      companyName: "St. Joe Company",
      popularity: 0,
    },
    {
      slug: "nyse-joet",
      code: "NYSE:JOET",
      companyName: "Virtus Terranova U.S. Quality Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jof",
      code: "NYSE:JOF",
      companyName: "JAPAN SMALLER CAPITALIZATION FUND",
      popularity: 0,
    },
    {
      slug: "nyse-joff",
      code: "NYSE:JOFF",
      companyName: "JOFF Fintech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-joffu",
      code: "NYSE:JOFFU",
      companyName: "JOFF Fintech Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-joffw",
      code: "NYSE:JOFFW",
      companyName: "JOFF Fintech Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-jojo",
      code: "NYSE:JOJO",
      companyName: "ATAC Credit Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jout",
      code: "NYSE:JOUT",
      companyName: "Johnson Outdoors Inc",
      popularity: 0,
    },
    {
      slug: "nyse-jpc",
      code: "NYSE:JPC",
      companyName: "Nuveen Preferred & Income Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jpem",
      code: "NYSE:JPEM",
      companyName: "JPMorgan Diversified Return Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jphy",
      code: "NYSE:JPHY",
      companyName: "JPMorgan Research Enhanced High Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jpi",
      code: "NYSE:JPI",
      companyName: "NUVEEN PREFERRED AND INCOME TERM FUND",
      popularity: 0,
    },
    {
      slug: "nyse-jpib",
      code: "NYSE:JPIB",
      companyName: "JPMorgan International Bond Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jpie",
      code: "NYSE:JPIE",
      companyName: "JPMorgan Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jpin",
      code: "NYSE:JPIN",
      companyName: "JPMorgan Diversified Return International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jpm-c",
      code: "NYSE:JPM-C",
      companyName:
        "JPMorgan Chase & Co. Depositary Shares each representing a 1/400th interest in a share of 6.00% Non",
      popularity: 0,
    },
    {
      slug: "nyse-jpm-d",
      code: "NYSE:JPM-D",
      companyName:
        "JPMorgan Chase & Co. Depositary Shares each representing a 1/400th  interest in a share of 5.75% No",
      popularity: 0,
    },
    {
      slug: "nyse-jpm-j",
      code: "NYSE:JPM-J",
      companyName:
        "JPMorgan Chase & Co. Depositary Shares each representing a 1/400th interest in a share of JPMorgan",
      popularity: 0,
    },
    {
      slug: "nyse-jpm-k",
      code: "NYSE:JPM-K",
      companyName:
        "JPMorgan Chase & Co. Depositary Shares each representing a 1/400th interest in a share of 4.55% Non",
      popularity: 0,
    },
    {
      slug: "nyse-jpm-l",
      code: "NYSE:JPM-L",
      companyName:
        "JPMorgan Chase & Co. Depositary Shares each representing a 1/400th interest in a share of 4.625% No",
      popularity: 0,
    },
    {
      slug: "nyse-jpm-m",
      code: "NYSE:JPM-M",
      companyName:
        "JPMorgan Chase & Co. Depositary Shares each representing a 1/400th interest in a share of 4.20% Non",
      popularity: 0,
    },
    {
      slug: "nyse-jpmb",
      code: "NYSE:JPMB",
      companyName: "JPMorgan USD Emerging Markets Sovereign Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jpme",
      code: "NYSE:JPME",
      companyName: "JPMorgan Diversified Return US Mid Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jpre",
      code: "NYSE:JPRE",
      companyName: "JPMorgan Realty Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jps",
      code: "NYSE:JPS",
      companyName: "Nuveen Preferred & Income Securities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jpse",
      code: "NYSE:JPSE",
      companyName: "JPMorgan Diversified Return US Small Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jpt",
      code: "NYSE:JPT",
      companyName: "Nuveen Preferred and Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jpus",
      code: "NYSE:JPUS",
      companyName: "JPMorgan Diversified Return US Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jpxn",
      code: "NYSE:JPXN",
      companyName: "iShares JPX-Nikkei 400 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jqc",
      code: "NYSE:JQC",
      companyName: "Nuveen Credit Strategies Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jqua",
      code: "NYSE:JQUA",
      companyName: "JPMorgan U.S. Quality Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jre",
      code: "NYSE:JRE",
      companyName: "Janus Henderson U.S. Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jrny",
      code: "NYSE:JRNY",
      companyName: "ALPS Global Travel Beneficiaries ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jro",
      code: "NYSE:JRO",
      companyName: "Nuveen Floating Rate Income Opportunty Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jrs",
      code: "NYSE:JRS",
      companyName: "Nuveen Real Estate Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-jrsh",
      code: "NYSE:JRSH",
      companyName: "Jerash Holdings (US) Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jrvr",
      code: "NYSE:JRVR",
      companyName: "James River Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-jscp",
      code: "NYSE:JSCP",
      companyName: "JPMorgan Short Duration Core Plus ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jsd",
      code: "NYSE:JSD",
      companyName: "NUVEEN SHORT DURATION CREDIT OPPORTUNITIES FUND",
      popularity: 0,
    },
    {
      slug: "nyse-jsm",
      code: "NYSE:JSM",
      companyName: "Navient Corporation 6% Senior Notes due December 15 2043",
      popularity: 0,
    },
    {
      slug: "nyse-jsmd",
      code: "NYSE:JSMD",
      companyName:
        "Janus Detroit Street Trust Janus Henderson Small/Mid Cap Growth Alpha ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jsml",
      code: "NYSE:JSML",
      companyName:
        "Janus Detroit Street Trust Janus Henderson Small Cap Growth Alpha ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jspr",
      code: "NYSE:JSPR",
      companyName: "Jasper Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jsprw",
      code: "NYSE:JSPRW",
      companyName: "Japer Therapeutics Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-jstc",
      code: "NYSE:JSTC",
      companyName: "Adasina Social Justice All Cap Global ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jt",
      code: "NYSE:JT",
      companyName:
        "Jianpu Technology Inc. American Depositary Shares each representing twenty Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jugg",
      code: "NYSE:JUGG",
      companyName:
        "Jaws Juggernaut Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-juggu",
      code: "NYSE:JUGGU",
      companyName: "Jaws Juggernaut Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-juggw",
      code: "NYSE:JUGGW",
      companyName: "Jaws Juggernaut Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-julz",
      code: "NYSE:JULZ",
      companyName: "TrueShares Structured Outcome (July) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jun",
      code: "NYSE:JUN",
      companyName: "Juniper II Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-junz",
      code: "NYSE:JUNZ",
      companyName: "TrueShares Structured Outcome (June) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jupw",
      code: "NYSE:JUPW",
      companyName: "Jupiter Wellness Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jupww",
      code: "NYSE:JUPWW",
      companyName: "Jupiter Wellness Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-jusa",
      code: "NYSE:JUSA",
      companyName: "JPMorgan ActiveBuilders U.S. Large Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-just",
      code: "NYSE:JUST",
      companyName: "Goldman Sachs JUST U.S. Large Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jva",
      code: "NYSE:JVA",
      companyName: "Coffee Holding Co. Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jval",
      code: "NYSE:JVAL",
      companyName: "JPMorgan U.S. Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jwac",
      code: "NYSE:JWAC",
      companyName: "Jupiter Wellness Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jwacr",
      code: "NYSE:JWACR",
      companyName: "Jupiter Wellness Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-jwel",
      code: "NYSE:JWEL",
      companyName: "Jowell Global Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jwn",
      code: "NYSE:JWN",
      companyName: "Nordstrom Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jwsm",
      code: "NYSE:JWSM",
      companyName: "Jaws Mustang Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-jxi",
      code: "NYSE:JXI",
      companyName: "iShares Global Utilities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jxn",
      code: "NYSE:JXN",
      companyName: "Jackson Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jyac",
      code: "NYSE:JYAC",
      companyName: "Jiya Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-jynt",
      code: "NYSE:JYNT",
      companyName: "The Joint Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-jzro",
      code: "NYSE:JZRO",
      companyName: "Janus Henderson Net Zero Transition Resources ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jzxn",
      code: "NYSE:JZXN",
      companyName: "Jiuzi Holdings Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kacl",
      code: "NYSE:KACL",
      companyName: "Kairous Acquisition Corp. Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-jpst",
      code: "NYSE:JPST",
      companyName: "JPMorgan Ultra-Short Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kaclr",
      code: "NYSE:KACLR",
      companyName: "Kairous Acquisition Corp. Limited Rights",
      popularity: 0,
    },
    {
      slug: "nyse-kaclu",
      code: "NYSE:KACLU",
      companyName: "Kairous Acquisition Corp. Limited Unit",
      popularity: 0,
    },
    {
      slug: "nyse-kaclw",
      code: "NYSE:KACLW",
      companyName: "Kairous Acquisition Corp. Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-kahc",
      code: "NYSE:KAHC",
      companyName: "KKR Acquisition Holdings I Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-kai",
      code: "NYSE:KAI",
      companyName: "Kadant Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kaii",
      code: "NYSE:KAII",
      companyName: "Kismet Acquisition Two Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kaiiu",
      code: "NYSE:KAIIU",
      companyName: "Kismet Acquisition Two Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-kaiiw",
      code: "NYSE:KAIIW",
      companyName: "Kismet Acquisition Two Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kair",
      code: "NYSE:KAIR",
      companyName: "Kairos Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kairu",
      code: "NYSE:KAIRU",
      companyName: "Kairos Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-kairw",
      code: "NYSE:KAIRW",
      companyName: "Kairos Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kal",
      code: "NYSE:KAL",
      companyName: "Kalera Public Limited Company Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kala",
      code: "NYSE:KALA",
      companyName: "Kala Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kall",
      code: "NYSE:KALL",
      companyName: "KraneShares MSCI All China Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kalu",
      code: "NYSE:KALU",
      companyName: "Kaiser Aluminum Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-kalv",
      code: "NYSE:KALV",
      companyName: "KalVista Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kalww",
      code: "NYSE:KALWW",
      companyName: "Kalera Public Limited Company Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kamn",
      code: "NYSE:KAMN",
      companyName: "Kaman Corp",
      popularity: 0,
    },
    {
      slug: "nyse-kapr",
      code: "NYSE:KAPR",
      companyName: "Innovator U.S. Small Cap Power Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-kar",
      code: "NYSE:KAR",
      companyName: "KAR AUCTION SERVICES INC.",
      popularity: 0,
    },
    {
      slug: "nyse-karo",
      code: "NYSE:KARO",
      companyName: "Karooooo Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kars",
      code: "NYSE:KARS",
      companyName:
        "KraneShares Electric Vehicles and Future Mobility Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kavl",
      code: "NYSE:KAVL",
      companyName: "Kaival Brands Innovations Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-kb",
      code: "NYSE:KB",
      companyName: "KB Financial Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-kbe",
      code: "NYSE:KBE",
      companyName: "SPDR S&P Bank ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kbh",
      code: "NYSE:KBH",
      companyName: "KB Home",
      popularity: 0,
    },
    {
      slug: "nyse-kbnd",
      code: "NYSE:KBND",
      companyName: "KraneShares Bloomberg China Bond Inclusion Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kbnt",
      code: "NYSE:KBNT",
      companyName: "Kubient Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kbntw",
      code: "NYSE:KBNTW",
      companyName: "Kubient Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kbuy",
      code: "NYSE:KBUY",
      companyName: "KraneShares CICC China Consumer Leaders Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kbwb",
      code: "NYSE:KBWB",
      companyName: "Invesco KBW Bank ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kbwd",
      code: "NYSE:KBWD",
      companyName: "Invesco KBW High Dividend Yield Financial ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kbwp",
      code: "NYSE:KBWP",
      companyName: "Invesco KBW Property & Casualty Insurance ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kbwr",
      code: "NYSE:KBWR",
      companyName: "Invesco KBW Regional Banking ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kbwy",
      code: "NYSE:KBWY",
      companyName: "Invesco KBW Premium Yield Equity REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kc",
      code: "NYSE:KC",
      companyName: "Kingsoft Cloud Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kcca",
      code: "NYSE:KCCA",
      companyName: "KraneShares California Carbon Allowance Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kce",
      code: "NYSE:KCE",
      companyName: "SPDR S&P Capital Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kcgi",
      code: "NYSE:KCGI",
      companyName: "Kensington Capital Acquisition Corp. V",
      popularity: 0,
    },
    {
      slug: "nyse-kd",
      code: "NYSE:KD",
      companyName: "Kyndryl Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kdny",
      code: "NYSE:KDNY",
      companyName: "Chinook Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kdp",
      code: "NYSE:KDP",
      companyName: "Keurig Dr Pepper Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kdrn",
      code: "NYSE:KDRN",
      companyName: "Kingsbarn Tactical Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ke",
      code: "NYSE:KE",
      companyName: "Kimball Electronics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kelya",
      code: "NYSE:KELYA",
      companyName: "Kelly Services Inc",
      popularity: 0,
    },
    {
      slug: "nyse-kelyb",
      code: "NYSE:KELYB",
      companyName: "Kelly Services Inc",
      popularity: 0,
    },
    {
      slug: "nyse-kemq",
      code: "NYSE:KEMQ",
      companyName: "KraneShares Emerging Markets Consumer Technology Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kemx",
      code: "NYSE:KEMX",
      companyName: "KraneShares MSCI Emerging Markets Ex China Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ken",
      code: "NYSE:KEN",
      companyName: "KENON HOLDINGS LTD.",
      popularity: 0,
    },
    {
      slug: "nyse-kep",
      code: "NYSE:KEP",
      companyName: "Korea Electric Power Corp",
      popularity: 0,
    },
    {
      slug: "nyse-kequ",
      code: "NYSE:KEQU",
      companyName: "Kewaunee Scientific Corp",
      popularity: 0,
    },
    {
      slug: "nyse-kern",
      code: "NYSE:KERN",
      companyName: "Akerna Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kernw",
      code: "NYSE:KERNW",
      companyName: "Akerna Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kesg",
      code: "NYSE:KESG",
      companyName: "KraneShares MSCI China ESG Leaders Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-keua",
      code: "NYSE:KEUA",
      companyName: "KraneShares European Carbon Allowance Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kex",
      code: "NYSE:KEX",
      companyName: "Kirby Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-key",
      code: "NYSE:KEY",
      companyName: "KeyCorp",
      popularity: 0,
    },
    {
      slug: "nyse-key-i",
      code: "NYSE:KEY-I",
      companyName:
        "KeyCorp Depositary Shares each representing a 1/40th ownership interest in a share of Fixed-to-Float",
      popularity: 0,
    },
    {
      slug: "nyse-key-j",
      code: "NYSE:KEY-J",
      companyName:
        "KeyCorp Depositary Shares each representing a 1/40th ownership interest in a share of Fixed Rate Per",
      popularity: 0,
    },
    {
      slug: "nyse-key-k",
      code: "NYSE:KEY-K",
      companyName:
        "KeyCorp Depositary Shares each representing a 1/40th ownership interest in a share of Fixed Rate Pe",
      popularity: 0,
    },
    {
      slug: "nyse-kf",
      code: "NYSE:KF",
      companyName: "KOREA FUND INC",
      popularity: 0,
    },
    {
      slug: "nyse-kffb",
      code: "NYSE:KFFB",
      companyName: "Kentucky First Federal Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-kfrc",
      code: "NYSE:KFRC",
      companyName: "kforce Inc",
      popularity: 0,
    },
    {
      slug: "nyse-kfs",
      code: "NYSE:KFS",
      companyName: "Kingsway Financial Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kfvg",
      code: "NYSE:KFVG",
      companyName: "KraneShares CICC China 5G and Semiconductor Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kfy",
      code: "NYSE:KFY",
      companyName: "Korn Ferry",
      popularity: 0,
    },
    {
      slug: "nyse-kfyp",
      code: "NYSE:KFYP",
      companyName: "KraneShares CICC China Leaders 100 Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kgc",
      code: "NYSE:KGC",
      companyName: "Kinross Gold Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-kghg",
      code: "NYSE:KGHG",
      companyName: "KraneShares Global Carbon Transformation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kgrn",
      code: "NYSE:KGRN",
      companyName: "KraneShares MSCI China Clean Technology Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kgro",
      code: "NYSE:KGRO",
      companyName: "KraneShares China Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-khc",
      code: "NYSE:KHC",
      companyName: "The Kraft Heinz Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-khyb",
      code: "NYSE:KHYB",
      companyName: "KraneShares Asia Pacific High Income Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kids",
      code: "NYSE:KIDS",
      companyName: "OrthoPediatrics Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kie",
      code: "NYSE:KIE",
      companyName: "SPDR S&P Insurance ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kiii",
      code: "NYSE:KIII",
      companyName: "Kismet Acquisition Three Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kiiiu",
      code: "NYSE:KIIIU",
      companyName: "Kismet Acquisition Three Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-kiiiw",
      code: "NYSE:KIIIW",
      companyName: "Kismet Acquisition Three Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kim",
      code: "NYSE:KIM",
      companyName: "Kimco Realty Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-kim-l",
      code: "NYSE:KIM-L",
      companyName:
        "Kimco Realty Corporation Class L Depositary Shares each of which represents a one-one thousandth fr",
      popularity: 0,
    },
    {
      slug: "nyse-kim-m",
      code: "NYSE:KIM-M",
      companyName:
        "Kimco Realty Corporation Class M Depositary Shares each of which represents a one-one thousandth fr",
      popularity: 0,
    },
    {
      slug: "nyse-kind",
      code: "NYSE:KIND",
      companyName: "Nextdoor Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kins",
      code: "NYSE:KINS",
      companyName: "Kingstone Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kinz",
      code: "NYSE:KINZ",
      companyName: "KINS Technology Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kinzw",
      code: "NYSE:KINZW",
      companyName: "KINS Technology Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kio",
      code: "NYSE:KIO",
      companyName: "KKR INCOME OPPORTUNITIES FUND",
      popularity: 0,
    },
    {
      slug: "nyse-kiq",
      code: "NYSE:KIQ",
      companyName: "Kelso Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kjan",
      code: "NYSE:KJAN",
      companyName: "Innovator U.S. Small Cap Power Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-kjul",
      code: "NYSE:KJUL",
      companyName: "Innovator U.S. Small Cap Power Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-kkr",
      code: "NYSE:KKR",
      companyName: "KKR & Co. Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kkr-c",
      code: "NYSE:KKR-C",
      companyName:
        "KKR & Co. Inc. 6.00% Series C Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kkrs",
      code: "NYSE:KKRS",
      companyName:
        "KKR Group Finance Co. IX LLC 4.625% Subordinated Notes due 2061",
      popularity: 0,
    },
    {
      slug: "nyse-klac",
      code: "NYSE:KLAC",
      companyName: "KLA Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-klaq",
      code: "NYSE:KLAQ",
      companyName: "KL Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-klaqu",
      code: "NYSE:KLAQU",
      companyName: "KL Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-klaqw",
      code: "NYSE:KLAQW",
      companyName: "KL Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-klcd",
      code: "NYSE:KLCD",
      companyName: "KFA Large Cap Quality Dividend Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kldw",
      code: "NYSE:KLDW",
      companyName: "Knowledge Leaders Developed World ETF",
      popularity: 0,
    },
    {
      slug: "nyse-klic",
      code: "NYSE:KLIC",
      companyName: "Kulicke & Soffa Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-klne",
      code: "NYSE:KLNE",
      companyName: "Direxion Daily Global Clean Energy Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-klr",
      code: "NYSE:KLR",
      companyName: "Kaleyra Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kltr",
      code: "NYSE:KLTR",
      companyName: "Kaltura Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-klxe",
      code: "NYSE:KLXE",
      companyName: "KLX Energy Services Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kmb",
      code: "NYSE:KMB",
      companyName: "Kimberly-Clark Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-kmda",
      code: "NYSE:KMDA",
      companyName: "Kamada Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-kmed",
      code: "NYSE:KMED",
      companyName: "KraneShares Emerging Markets Healthcare Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kmf",
      code: "NYSE:KMF",
      companyName: "Kayne Anderson NextGen Energy & Infrastructure Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kmi",
      code: "NYSE:KMI",
      companyName: "Kinder Morgan Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kmlm",
      code: "NYSE:KMLM",
      companyName: "KFA Mount Lucas Index Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kmpb",
      code: "NYSE:KMPB",
      companyName:
        "Kemper Corporation 5.875% Fixed-Rate Reset Junior Subordinated Debentures due 2062",
      popularity: 0,
    },
    {
      slug: "nyse-kmph",
      code: "NYSE:KMPH",
      companyName: "KemPharm Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kmpr",
      code: "NYSE:KMPR",
      companyName: "Kemper Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-kmt",
      code: "NYSE:KMT",
      companyName: "Kennametal Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kmx",
      code: "NYSE:KMX",
      companyName: "CarMax Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kn",
      code: "NYSE:KN",
      companyName: "KNOWLES CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-knbe",
      code: "NYSE:KNBE",
      companyName: "KnowBe4 Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kndi",
      code: "NYSE:KNDI",
      companyName: "Kandi Technologies Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kng",
      code: "NYSE:KNG",
      companyName:
        "FT Cboe Vest S&P 500 Dividend Aristocrats Target Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kngs",
      code: "NYSE:KNGS",
      companyName: "UPHOLDINGS Compound Kings ETF",
      popularity: 0,
    },
    {
      slug: "nyse-knop",
      code: "NYSE:KNOP",
      companyName: "KNOT OFFSHORE PARTNERS LP",
      popularity: 0,
    },
    {
      slug: "nyse-knsa",
      code: "NYSE:KNSA",
      companyName: "Kiniksa Pharmaceuticals Ltd. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-knsl",
      code: "NYSE:KNSL",
      companyName: "Kinsale Capital Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-knsw",
      code: "NYSE:KNSW",
      companyName: "KnightSwan Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-knte",
      code: "NYSE:KNTE",
      companyName: "Kinnate Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kntk",
      code: "NYSE:KNTK",
      companyName: "Kinetik Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-knx",
      code: "NYSE:KNX",
      companyName:
        "Knight-Swift Transportation Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kocg",
      code: "NYSE:KOCG",
      companyName: "FIS Knights of Columbus Global Belief ETF",
      popularity: 0,
    },
    {
      slug: "nyse-latgw",
      code: "NYSE:LATGW",
      companyName: "LatAmGrowth SPAC Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-koct",
      code: "NYSE:KOCT",
      companyName: "Innovator U.S. Small Cap Power Buffer ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-kod",
      code: "NYSE:KOD",
      companyName: "Kodiak Sciences Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kodk",
      code: "NYSE:KODK",
      companyName: "EASTMAN KODAK COMPANY",
      popularity: 0,
    },
    {
      slug: "nyse-kof",
      code: "NYSE:KOF",
      companyName: "Coca-Cola FEMSA S.A.B DE C.V",
      popularity: 0,
    },
    {
      slug: "nyse-koin",
      code: "NYSE:KOIN",
      companyName: "Capital Link Global Fintech Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-koku",
      code: "NYSE:KOKU",
      companyName: "Xtrackers MSCI Kokusai Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kold",
      code: "NYSE:KOLD",
      companyName: "ProShares UltraShort Bloomberg Natural Gas",
      popularity: 0,
    },
    {
      slug: "nyse-komp",
      code: "NYSE:KOMP",
      companyName: "SPDR S&P Kensho New Economies Composite ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kong",
      code: "NYSE:KONG",
      companyName: "Formidable Fortress ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kop",
      code: "NYSE:KOP",
      companyName: "Koppers Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kopn",
      code: "NYSE:KOPN",
      companyName: "Kopin Corp",
      popularity: 0,
    },
    {
      slug: "nyse-kore",
      code: "NYSE:KORE",
      companyName: "KORE Group Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-korp",
      code: "NYSE:KORP",
      companyName: "American Century Diversified Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-koru",
      code: "NYSE:KORU",
      companyName: "Direxion Daily South Korea Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kos",
      code: "NYSE:KOS",
      companyName: "Kosmos Energy Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-koss",
      code: "NYSE:KOSS",
      companyName: "Koss Corp",
      popularity: 0,
    },
    {
      slug: "nyse-kplt",
      code: "NYSE:KPLT",
      companyName: "Katapult Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kpltw",
      code: "NYSE:KPLTW",
      companyName: "Katapult Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kprx",
      code: "NYSE:KPRX",
      companyName: "Kiora Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kpti",
      code: "NYSE:KPTI",
      companyName: "Karyopharm Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kr",
      code: "NYSE:KR",
      companyName: "The Kroger Co.",
      popularity: 0,
    },
    {
      slug: "nyse-krbn",
      code: "NYSE:KRBN",
      companyName: "KraneShares Global Carbon Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-krbp",
      code: "NYSE:KRBP",
      companyName: "Kiromic BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-krc",
      code: "NYSE:KRC",
      companyName: "Kilroy Realty Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-kre",
      code: "NYSE:KRE",
      companyName: "SPDR S&P Regional Banking ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kref",
      code: "NYSE:KREF",
      companyName: "KKR Real Estate Finance Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kref-a",
      code: "NYSE:KREF-A",
      companyName:
        "KKR Real Estate Finance Trust Inc. 6.50% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-krg",
      code: "NYSE:KRG",
      companyName: "Kite Realty Group Trust",
      popularity: 0,
    },
    {
      slug: "nyse-krkr",
      code: "NYSE:KRKR",
      companyName: "36Kr Holdings Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-krmd",
      code: "NYSE:KRMD",
      companyName: "KORU Medical Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-krnl",
      code: "NYSE:KRNL",
      companyName: "Kernel Group Holdings Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-krnlu",
      code: "NYSE:KRNLU",
      companyName: "Kernel Group Holdings Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-krnlw",
      code: "NYSE:KRNLW",
      companyName: "Kernel Group Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-krnt",
      code: "NYSE:KRNT",
      companyName: "Kornit Digital Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-krny",
      code: "NYSE:KRNY",
      companyName: "Kearny Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-kro",
      code: "NYSE:KRO",
      companyName: "Kronos Worldwide Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kron",
      code: "NYSE:KRON",
      companyName: "Kronos Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-krop",
      code: "NYSE:KROP",
      companyName: "Global X AgTech & Food Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kros",
      code: "NYSE:KROS",
      companyName: "Keros Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-krp",
      code: "NYSE:KRP",
      companyName:
        "Kimbell Royalty Partners LP Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nyse-krt",
      code: "NYSE:KRT",
      companyName: "Karat Packaging Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-krtx",
      code: "NYSE:KRTX",
      companyName: "Karuna Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-krus",
      code: "NYSE:KRUS",
      companyName: "Kura Sushi USA Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-krys",
      code: "NYSE:KRYS",
      companyName: "Krystal Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ksa",
      code: "NYSE:KSA",
      companyName: "iShares MSCI Saudi Arabia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kscd",
      code: "NYSE:KSCD",
      companyName: "KFA Small Cap Quality Dividend Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kscp",
      code: "NYSE:KSCP",
      companyName: "Knightscope Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kset",
      code: "NYSE:KSET",
      companyName: "KraneShares Global Carbon Offset Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ksi",
      code: "NYSE:KSI",
      companyName: "Kadem Sustainable Impact Corporation Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-ksicu",
      code: "NYSE:KSICU",
      companyName: "Kadem Sustainable Impact Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ksicw",
      code: "NYSE:KSICW",
      companyName: "Kadem Sustainable Impact Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ksm",
      code: "NYSE:KSM",
      companyName: "DWS Strategic Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-kspn",
      code: "NYSE:KSPN",
      companyName: "Kaspien Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kstr",
      code: "NYSE:KSTR",
      companyName: "KraneShares SSE STAR Market 50 Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kt",
      code: "NYSE:KT",
      companyName: "KT Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ktb",
      code: "NYSE:KTB",
      companyName: "Kontoor Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ktcc",
      code: "NYSE:KTCC",
      companyName: "KEY Tronic Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ktec",
      code: "NYSE:KTEC",
      companyName: "KraneShares Hang Seng TECH Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ktf",
      code: "NYSE:KTF",
      companyName: "DWS Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-kth",
      code: "NYSE:KTH",
      companyName:
        "Structured Products CorTS PECO Energy Cap Trust III 8% Cert.",
      popularity: 0,
    },
    {
      slug: "nyse-ktn",
      code: "NYSE:KTN",
      companyName: "Structured Products CorTS Aon Capital A 8.205% Cert.",
      popularity: 0,
    },
    {
      slug: "nyse-ktos",
      code: "NYSE:KTOS",
      companyName: "Kratos Defense & Security Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ktra",
      code: "NYSE:KTRA",
      companyName: "Kintara Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ktta",
      code: "NYSE:KTTA",
      companyName: "Pasithea Therapeutics Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kttaw",
      code: "NYSE:KTTAW",
      companyName: "Pasithea Therapeutics Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-kuke",
      code: "NYSE:KUKE",
      companyName:
        "Kuke Music Holding Limited American Depositary Shares each representing one Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-kulr",
      code: "NYSE:KULR",
      companyName: "KULR Technology Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kura",
      code: "NYSE:KURA",
      companyName: "Kura Oncology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kure",
      code: "NYSE:KURE",
      companyName: "KraneShares MSCI All China Health Care Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kvhi",
      code: "NYSE:KVHI",
      companyName: "KVH Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-kvle",
      code: "NYSE:KVLE",
      companyName: "KFA Value Line Dynamic Core Equity Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kvsa",
      code: "NYSE:KVSA",
      companyName: "Khosla Ventures Acquisition Co. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kvsc",
      code: "NYSE:KVSC",
      companyName: "Khosla Ventures Acquisition Co. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kw",
      code: "NYSE:KW",
      companyName: "KENNEDY-WILSON HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-kwr",
      code: "NYSE:KWR",
      companyName: "Quaker Houghton",
      popularity: 0,
    },
    {
      slug: "nyse-kwt",
      code: "NYSE:KWT",
      companyName: "iShares MSCI Kuwait ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kxi",
      code: "NYSE:KXI",
      companyName: "iShares Global Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kxin",
      code: "NYSE:KXIN",
      companyName: "Kaixin Auto Holdings Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-kych",
      code: "NYSE:KYCH",
      companyName: "Keyarch Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kychr",
      code: "NYSE:KYCHR",
      companyName: "Keyarch Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nyse-kychu",
      code: "NYSE:KYCHU",
      companyName: "Keyarch Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-kychw",
      code: "NYSE:KYCHW",
      companyName: "Keyarch Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-kymr",
      code: "NYSE:KYMR",
      companyName: "Kymera Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-kyn",
      code: "NYSE:KYN",
      companyName: "Kayne Anderson Energy Infrastructure Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-kzia",
      code: "NYSE:KZIA",
      companyName: "Kazia Therapeutics Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kzr",
      code: "NYSE:KZR",
      companyName: "Kezar Life Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-l",
      code: "NYSE:L",
      companyName: "Loews Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-laaa",
      code: "NYSE:LAAA",
      companyName: "Lakeshore Acquisition I Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-laaau",
      code: "NYSE:LAAAU",
      companyName: "Lakeshore Acquisition I Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-laaaw",
      code: "NYSE:LAAAW",
      companyName: "Lakeshore Acquisition I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lab",
      code: "NYSE:LAB",
      companyName: "Standard BioTools Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-labd",
      code: "NYSE:LABD",
      companyName: "Direxion Daily S&P Biotech Bear 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-labp",
      code: "NYSE:LABP",
      companyName: "Landos Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-labu",
      code: "NYSE:LABU",
      companyName: "Direxion Daily S&P Biotech Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-kweb",
      code: "NYSE:KWEB",
      companyName: "KraneShares CSI China Internet ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lad",
      code: "NYSE:LAD",
      companyName: "Lithia Motors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ladr",
      code: "NYSE:LADR",
      companyName: "LADDER CAPITAL CORP",
      popularity: 0,
    },
    {
      slug: "nyse-lake",
      code: "NYSE:LAKE",
      companyName: "Lakeland Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lamr",
      code: "NYSE:LAMR",
      companyName: "Lamar Advertising Co",
      popularity: 0,
    },
    {
      slug: "nyse-lanc",
      code: "NYSE:LANC",
      companyName: "Lancaster Colony Corp",
      popularity: 0,
    },
    {
      slug: "nyse-land",
      code: "NYSE:LAND",
      companyName: "Gladstone Land Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-landm",
      code: "NYSE:LANDM",
      companyName:
        "Gladstone Land Corporation 5.00% Series D Cumulative Term Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lando",
      code: "NYSE:LANDO",
      companyName:
        "Gladstone Land Corporation 6.00% Series B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lark",
      code: "NYSE:LARK",
      companyName: "Landmark Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lasr",
      code: "NYSE:LASR",
      companyName: "nLIGHT Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-latg",
      code: "NYSE:LATG",
      companyName: "LatAmGrowth SPAC Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-latgu",
      code: "NYSE:LATGU",
      companyName: "LatAmGrowth SPAC Unit",
      popularity: 0,
    },
    {
      slug: "nyse-laur",
      code: "NYSE:LAUR",
      companyName: "Laureate Education Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-law",
      code: "NYSE:LAW",
      companyName: "CS Disco Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lax",
      code: "NYSE:LAX",
      companyName: "8i Acquisition 2 Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-laxxr",
      code: "NYSE:LAXXR",
      companyName: "8i Acquisition 2 Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-laxxu",
      code: "NYSE:LAXXU",
      companyName: "8i Acquisition 2 Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-laxxw",
      code: "NYSE:LAXXW",
      companyName: "8i Acquisition 2 Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-laz",
      code: "NYSE:LAZ",
      companyName: "Lazard Ltd. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-lazr",
      code: "NYSE:LAZR",
      companyName: "Luminar Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lazy",
      code: "NYSE:LAZY",
      companyName: "Lazydays Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lbai",
      code: "NYSE:LBAI",
      companyName: "Lakeland Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lbay",
      code: "NYSE:LBAY",
      companyName: "Leatherback Long/Short Alternative Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lbbb",
      code: "NYSE:LBBB",
      companyName: "Lakeshore Acquisition II Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lbbbr",
      code: "NYSE:LBBBR",
      companyName: "Lakeshore Acquisition II Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-lbbbu",
      code: "NYSE:LBBBU",
      companyName: "Lakeshore Acquisition II Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lbbbw",
      code: "NYSE:LBBBW",
      companyName: "Lakeshore Acquisition II Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lbc",
      code: "NYSE:LBC",
      companyName: "Luther Burbank Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lbph",
      code: "NYSE:LBPH",
      companyName: "Longboard Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lbrda",
      code: "NYSE:LBRDA",
      companyName: "Liberty Broadband Corporation Class A",
      popularity: 0,
    },
    {
      slug: "nyse-lbrdk",
      code: "NYSE:LBRDK",
      companyName: "Liberty Broadband Corporation Class C",
      popularity: 0,
    },
    {
      slug: "nyse-lbrdp",
      code: "NYSE:LBRDP",
      companyName:
        "Liberty Broadband Corporation Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lbrt",
      code: "NYSE:LBRT",
      companyName: "Liberty Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lbtya",
      code: "NYSE:LBTYA",
      companyName: "Liberty Global plc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-lbtyb",
      code: "NYSE:LBTYB",
      companyName: "Liberty Global plc Class B",
      popularity: 0,
    },
    {
      slug: "nyse-lbtyk",
      code: "NYSE:LBTYK",
      companyName: "Liberty Global plc. Class C",
      popularity: 0,
    },
    {
      slug: "nyse-lc",
      code: "NYSE:LC",
      companyName: "LendingClub Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-lca",
      code: "NYSE:LCA",
      companyName: "Landcadia Holdings IV Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lcaa",
      code: "NYSE:LCAA",
      companyName: "L Catterton Asia Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lcaau",
      code: "NYSE:LCAAU",
      companyName: "L Catterton Asia Acquisition Corp Units",
      popularity: 0,
    },
    {
      slug: "nyse-lcaaw",
      code: "NYSE:LCAAW",
      companyName: "L Catterton Asia Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lcahu",
      code: "NYSE:LCAHU",
      companyName: "Landcadia Holdings IV Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-lcahw",
      code: "NYSE:LCAHW",
      companyName: "Landcadia Holdings IV Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lcf",
      code: "NYSE:LCF",
      companyName: "Touchstone US Large Cap Focused ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lcfy",
      code: "NYSE:LCFY",
      companyName: "Locafy Limited Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-lcfyw",
      code: "NYSE:LCFYW",
      companyName: "Locafy Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lcg",
      code: "NYSE:LCG",
      companyName: "Sterling Capital Focus Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lci",
      code: "NYSE:LCI",
      companyName: "Lannett Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lcii",
      code: "NYSE:LCII",
      companyName: "LCI Industries",
      popularity: 0,
    },
    {
      slug: "nyse-lclg",
      code: "NYSE:LCLG",
      companyName: "Logan Capital Broad Innovative Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lcnb",
      code: "NYSE:LCNB",
      companyName: "LCNB Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-lcr",
      code: "NYSE:LCR",
      companyName: "Leuthold Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lctd",
      code: "NYSE:LCTD",
      companyName: "BlackRock World ex U.S. Carbon Transition Readiness ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lctu",
      code: "NYSE:LCTU",
      companyName: "BlackRock U.S. Carbon Transition Readiness ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lctx",
      code: "NYSE:LCTX",
      companyName: "Lineage Cell Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lcut",
      code: "NYSE:LCUT",
      companyName: "Lifetime Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lcw",
      code: "NYSE:LCW",
      companyName: "Learn CW Investment Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ld",
      code: "NYSE:LD",
      companyName:
        "iPath Bloomberg Lead Subindex Total Return ETN due June 24 2038",
      popularity: 0,
    },
    {
      slug: "nyse-ldem",
      code: "NYSE:LDEM",
      companyName: "iShares ESG MSCI EM Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ldha",
      code: "NYSE:LDHA",
      companyName: "LDH Growth Corp I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ldhau",
      code: "NYSE:LDHAU",
      companyName: "LDH Growth Corp I Units",
      popularity: 0,
    },
    {
      slug: "nyse-ldhaw",
      code: "NYSE:LDHAW",
      companyName: "LDH Growth Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ldi",
      code: "NYSE:LDI",
      companyName: "loanDepot Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ldos",
      code: "NYSE:LDOS",
      companyName: "Leidos Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ldp",
      code: "NYSE:LDP",
      companyName:
        "COHEN & STEERS LIMITED DURATION PREFERRED AND INCOME FUND INC",
      popularity: 0,
    },
    {
      slug: "nyse-ldsf",
      code: "NYSE:LDSF",
      companyName: "First Trust Low Duration Strategic Focus ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ldur",
      code: "NYSE:LDUR",
      companyName: "PIMCO Enhanced Low Duration Active Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-le",
      code: "NYSE:LE",
      companyName: "Lands' End Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lea",
      code: "NYSE:LEA",
      companyName: "Lear Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-lead",
      code: "NYSE:LEAD",
      companyName: "Siren DIVCON Leaders Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-leco",
      code: "NYSE:LECO",
      companyName: "Lincoln Electric Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-leds",
      code: "NYSE:LEDS",
      companyName: "SemiLEDS Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-lee",
      code: "NYSE:LEE",
      companyName: "Lee Enterprises Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-leg",
      code: "NYSE:LEG",
      companyName: "Leggett & Platt Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lega",
      code: "NYSE:LEGA",
      companyName: "Lead Edge Growth Opportunities Ltd Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-legau",
      code: "NYSE:LEGAU",
      companyName: "Lead Edge Growth Opportunities Ltd Units",
      popularity: 0,
    },
    {
      slug: "nyse-legaw",
      code: "NYSE:LEGAW",
      companyName: "Lead Edge Growth Opportunities Ltd Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-legh",
      code: "NYSE:LEGH",
      companyName: "Legacy Housing Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-legn",
      code: "NYSE:LEGN",
      companyName: "Legend Biotech Corporation American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-legr",
      code: "NYSE:LEGR",
      companyName: "First Trust Indxx Innovative Transaction & Process ETF",
      popularity: 0,
    },
    {
      slug: "nyse-leju",
      code: "NYSE:LEJU",
      companyName:
        "Leju Holdings Limited American Depositary Shares each representing ten (10) Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lemb",
      code: "NYSE:LEMB",
      companyName: "iShares J.P. Morgan EM Local Currency Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-len",
      code: "NYSE:LEN",
      companyName: "Lennar Corporation Class A",
      popularity: 0,
    },
    {
      slug: "nyse-leo",
      code: "NYSE:LEO",
      companyName: "BNY Mellon Strategic Municipals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lesl",
      code: "NYSE:LESL",
      companyName: "Leslie's Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-letb",
      code: "NYSE:LETB",
      companyName: "AdvisorShares Let Bob AI Powered Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-leu",
      code: "NYSE:LEU",
      companyName: "Centrus Energy Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-lev",
      code: "NYSE:LEV",
      companyName: "The Lion Electric Company",
      popularity: 0,
    },
    {
      slug: "nyse-levi",
      code: "NYSE:LEVI",
      companyName: "Levi Strauss & Co. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lexi",
      code: "NYSE:LEXI",
      companyName: "Alexis Practical Tactical ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lexx",
      code: "NYSE:LEXX",
      companyName: "Lexaria Bioscience Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lexxw",
      code: "NYSE:LEXXW",
      companyName: "Lexaria Bioscience Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lfac",
      code: "NYSE:LFAC",
      companyName: "LF Capital Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lfacu",
      code: "NYSE:LFACU",
      companyName: "LF Capital Acquisition Corp. II Units",
      popularity: 0,
    },
    {
      slug: "nyse-lfacw",
      code: "NYSE:LFACW",
      companyName: "LF Capital Acquisition Corp. II Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lfc",
      code: "NYSE:LFC",
      companyName: "China Life Insurance Company Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-lfeq",
      code: "NYSE:LFEQ",
      companyName: "VanEck Long/Flat Trend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lfg",
      code: "NYSE:LFG",
      companyName: "Archaea Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lfly",
      code: "NYSE:LFLY",
      companyName: "Leafly Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lflyw",
      code: "NYSE:LFLYW",
      companyName: "Leafly Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lfmd",
      code: "NYSE:LFMD",
      companyName: "LifeMD Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lfmdp",
      code: "NYSE:LFMDP",
      companyName:
        "LifeMD Inc. 8.875% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lfst",
      code: "NYSE:LFST",
      companyName: "LifeStance Health Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lft",
      code: "NYSE:LFT",
      companyName: "Lument Finance Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lft-a",
      code: "NYSE:LFT-A",
      companyName:
        "Lument Finance Trust Inc. 7.875% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lftr",
      code: "NYSE:LFTR",
      companyName: "Lefteris Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lftru",
      code: "NYSE:LFTRU",
      companyName: "Lefteris Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lftrw",
      code: "NYSE:LFTRW",
      companyName: "Lefteris Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lfus",
      code: "NYSE:LFUS",
      companyName: "Littelfuse Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lfvn",
      code: "NYSE:LFVN",
      companyName: "Lifevantage Corporation Common Stock (Delaware)",
      popularity: 0,
    },
    {
      slug: "nyse-lgac",
      code: "NYSE:LGAC",
      companyName: "Lazard Growth Acquisition Corp. I Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lgacu",
      code: "NYSE:LGACU",
      companyName: "Lazard Growth Acquisition Corp. I Units",
      popularity: 0,
    },
    {
      slug: "nyse-lgacw",
      code: "NYSE:LGACW",
      companyName: "Lazard Growth Acquisition Corp. I Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lgh",
      code: "NYSE:LGH",
      companyName: "HCM Defender 500 Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lghl",
      code: "NYSE:LGHL",
      companyName: "Lion Group Holding Ltd. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-lghlw",
      code: "NYSE:LGHLW",
      companyName: "Lion Group Holding Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lgi",
      code: "NYSE:LGI",
      companyName: "Lazard Global Total Return & Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-lgih",
      code: "NYSE:LGIH",
      companyName: "LGI Homes Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lglv",
      code: "NYSE:LGLV",
      companyName: "SPDR SSGA US Large Cap Low Volatility Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lgnd",
      code: "NYSE:LGND",
      companyName: "Ligand Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lgo",
      code: "NYSE:LGO",
      companyName: "Largo Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lgov",
      code: "NYSE:LGOV",
      companyName: "First Trust Long Duration Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lgst",
      code: "NYSE:LGST",
      companyName:
        "Semper Paratus Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lgstu",
      code: "NYSE:LGSTU",
      companyName: "Semper Paratus Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lgstw",
      code: "NYSE:LGSTW",
      companyName: "Semper Paratus Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lgto",
      code: "NYSE:LGTO",
      companyName: "Legato Merger Corp. II Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lgtou",
      code: "NYSE:LGTOU",
      companyName: "Legato Merger Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lgtow",
      code: "NYSE:LGTOW",
      companyName: "Legato Merger Corp. II Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lgv",
      code: "NYSE:LGV",
      companyName: "Longview Acquisition Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-lgvc",
      code: "NYSE:LGVC",
      companyName: "LAMF Global Ventures Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lgvcu",
      code: "NYSE:LGVCU",
      companyName: "LAMF Global Ventures Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lgvcw",
      code: "NYSE:LGVCW",
      companyName: "LAMF Global Ventures Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lgvn",
      code: "NYSE:LGVN",
      companyName: "Longeveron Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lh",
      code: "NYSE:LH",
      companyName: "Laboratory Corporation of America Holdings",
      popularity: 0,
    },
    {
      slug: "nyse-lhaa",
      code: "NYSE:LHAA",
      companyName: "Lerer Hippeau Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lhc",
      code: "NYSE:LHC",
      companyName: "Leo Holdings Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-lhcg",
      code: "NYSE:LHCG",
      companyName: "LHC Group LLC",
      popularity: 0,
    },
    {
      slug: "nyse-lhdx",
      code: "NYSE:LHDX",
      companyName: "Lucira Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lhx",
      code: "NYSE:LHX",
      companyName: "L3Harris Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lian",
      code: "NYSE:LIAN",
      companyName: "LianBio American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-liby",
      code: "NYSE:LIBY",
      companyName: "Liberty Resources Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-libyu",
      code: "NYSE:LIBYU",
      companyName: "Liberty Resources Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-libyw",
      code: "NYSE:LIBYW",
      companyName: "Liberty Resources Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-licy",
      code: "NYSE:LICY",
      companyName: "Li-Cycle Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-lidr",
      code: "NYSE:LIDR",
      companyName: "AEye Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lidrw",
      code: "NYSE:LIDRW",
      companyName: "AEye Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-life",
      code: "NYSE:LIFE",
      companyName: "aTyr Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lii",
      code: "NYSE:LII",
      companyName: "Lennox International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lila",
      code: "NYSE:LILA",
      companyName: "Liberty Latin America Ltd. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lilak",
      code: "NYSE:LILAK",
      companyName: "Liberty Latin America Ltd. Class C Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lilm",
      code: "NYSE:LILM",
      companyName: "Lilium N.V. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lilmw",
      code: "NYSE:LILMW",
      companyName: "Lilium N.V. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lit",
      code: "NYSE:LIT",
      companyName: "Global X Lithium & Battery Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-linc",
      code: "NYSE:LINC",
      companyName: "Lincoln Educational Services",
      popularity: 0,
    },
    {
      slug: "nyse-lind",
      code: "NYSE:LIND",
      companyName: "Lindblad Expeditions Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-link",
      code: "NYSE:LINK",
      companyName: "Interlink Electronics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lion",
      code: "NYSE:LION",
      companyName: "Lionheart III Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lionu",
      code: "NYSE:LIONU",
      companyName: "Lionheart III Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lionw",
      code: "NYSE:LIONW",
      companyName: "Lionheart III Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-liqt",
      code: "NYSE:LIQT",
      companyName: "LiqTech International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-li",
      code: "NYSE:LI",
      companyName: "Li Auto Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-litb",
      code: "NYSE:LITB",
      companyName: "LIGHTINTHEBOX HOLDING CO. LTD.",
      popularity: 0,
    },
    {
      slug: "nyse-lite",
      code: "NYSE:LITE",
      companyName: "Lumentum Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-litm",
      code: "NYSE:LITM",
      companyName: "Snow Lake Resources Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-litt",
      code: "NYSE:LITT",
      companyName:
        "Logistics Innovation Technologies Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-littu",
      code: "NYSE:LITTU",
      companyName: "Logistics Innovation Technologies Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-littw",
      code: "NYSE:LITTW",
      companyName: "Logistics Innovation Technologies Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-liv",
      code: "NYSE:LIV",
      companyName: "Emles @Home ETF",
      popularity: 0,
    },
    {
      slug: "nyse-livb",
      code: "NYSE:LIVB",
      companyName: "LIV Capital Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-livbu",
      code: "NYSE:LIVBU",
      companyName: "LIV Capital Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-livbw",
      code: "NYSE:LIVBW",
      companyName: "LIV Capital Acquisition Corp. II Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-live",
      code: "NYSE:LIVE",
      companyName: "Live Ventures Inc",
      popularity: 0,
    },
    {
      slug: "nyse-livn",
      code: "NYSE:LIVN",
      companyName: "LivaNova PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lixt",
      code: "NYSE:LIXT",
      companyName: "Lixte Biotechnology Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lixtw",
      code: "NYSE:LIXTW",
      companyName: "Lixte Biotechnology Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lizi",
      code: "NYSE:LIZI",
      companyName: "LIZHI INC. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ljaq",
      code: "NYSE:LJAQ",
      companyName: "LightJump Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ljaqu",
      code: "NYSE:LJAQU",
      companyName: "LightJump Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ljaqw",
      code: "NYSE:LJAQW",
      companyName: "LightJump Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lkco",
      code: "NYSE:LKCO",
      companyName: "Luokung Technology Corp Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lkor",
      code: "NYSE:LKOR",
      companyName: "FlexShares Credit-Scored US Long Corporate Bond Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-lkq",
      code: "NYSE:LKQ",
      companyName: "LKQ Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ll",
      code: "NYSE:LL",
      companyName: "LL Flooring Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-llap",
      code: "NYSE:LLAP",
      companyName: "Terran Orbital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-lll",
      code: "NYSE:LLL",
      companyName: "JX Luxventure Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lmt",
      code: "NYSE:LMT",
      companyName: "Lockheed Martin Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-lmaca",
      code: "NYSE:LMACA",
      companyName:
        "Liberty Media Acquisition Corporation Series A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lmacu",
      code: "NYSE:LMACU",
      companyName: "Liberty Media Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lmacw",
      code: "NYSE:LMACW",
      companyName: "Liberty Media Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lmao",
      code: "NYSE:LMAO",
      companyName: "LMF Acquisition Opportunities Inc. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-lmaou",
      code: "NYSE:LMAOU",
      companyName: "LMF Acquisition Opportunities Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lmaow",
      code: "NYSE:LMAOW",
      companyName: "LMF Acquisition Opportunities Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lmat",
      code: "NYSE:LMAT",
      companyName: "LeMaitre Vascular Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lmb",
      code: "NYSE:LMB",
      companyName: "Limbach Holdings Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lmbs",
      code: "NYSE:LMBS",
      companyName:
        "First Trust Exchange-Traded Fund IV First Trust Low Duration Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lmdx",
      code: "NYSE:LMDX",
      companyName: "LumiraDx Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lmdxw",
      code: "NYSE:LMDXW",
      companyName: "LumiraDx Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lmfa",
      code: "NYSE:LMFA",
      companyName: "LM Funding America Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lmnd",
      code: "NYSE:LMND",
      companyName: "Lemonade Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lmnl",
      code: "NYSE:LMNL",
      companyName: "Liminal BioSciences Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lmnr",
      code: "NYSE:LMNR",
      companyName: "Limoneira Co",
      popularity: 0,
    },
    {
      slug: "nyse-lmpx",
      code: "NYSE:LMPX",
      companyName: "LMP Automotive Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lmst",
      code: "NYSE:LMST",
      companyName: "Limestone Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lnc",
      code: "NYSE:LNC",
      companyName: "Lincoln National Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-lnd",
      code: "NYSE:LND",
      companyName:
        "BrasilAgro - Companhia Brasileira de Propriedades Agra-colas",
      popularity: 0,
    },
    {
      slug: "nyse-lndc",
      code: "NYSE:LNDC",
      companyName: "Landec Corp",
      popularity: 0,
    },
    {
      slug: "nyse-lnn",
      code: "NYSE:LNN",
      companyName: "Lindsay Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-lnsr",
      code: "NYSE:LNSR",
      companyName: "LENSAR Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lnt",
      code: "NYSE:LNT",
      companyName: "Alliant Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lnth",
      code: "NYSE:LNTH",
      companyName: "Lantheus Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lnw",
      code: "NYSE:LNW",
      companyName: "Light & Wonder Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-loan",
      code: "NYSE:LOAN",
      companyName: "Manhattan Bridge Capital Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lob",
      code: "NYSE:LOB",
      companyName: "Live Oak Bancshares Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-locc",
      code: "NYSE:LOCC",
      companyName: "Live Oak Crestview Climate Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-locl",
      code: "NYSE:LOCL",
      companyName: "Local Bounti Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-loco",
      code: "NYSE:LOCO",
      companyName: "El Pollo Loco Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lode",
      code: "NYSE:LODE",
      companyName: "Comstock Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-logc",
      code: "NYSE:LOGC",
      companyName: "LogicBio Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-logi",
      code: "NYSE:LOGI",
      companyName: "Logitech International SA",
      popularity: 0,
    },
    {
      slug: "nyse-lokm",
      code: "NYSE:LOKM",
      companyName: "Live Oak Mobility Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-loma",
      code: "NYSE:LOMA",
      companyName:
        "Loma Negra Compa¤¡a Industrial Argentina Sociedad An¢nima American Depositary Shares (ADSs) each re",
      popularity: 0,
    },
    {
      slug: "nyse-lonz",
      code: "NYSE:LONZ",
      companyName: "PIMCO Senior Loan Active Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-loop",
      code: "NYSE:LOOP",
      companyName: "Loop Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lope",
      code: "NYSE:LOPE",
      companyName: "Grand Canyon Education Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lopp",
      code: "NYSE:LOPP",
      companyName: "Gabelli Love Our Planet & People ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lopx",
      code: "NYSE:LOPX",
      companyName: "Direxion Low Priced Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lotz",
      code: "NYSE:LOTZ",
      companyName: "CarLotz Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lotzw",
      code: "NYSE:LOTZW",
      companyName: "CarLotz Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-loup",
      code: "NYSE:LOUP",
      companyName: "Innovator Loup Frontier Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lov",
      code: "NYSE:LOV",
      companyName: "Spark Networks SE American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-love",
      code: "NYSE:LOVE",
      companyName: "The Lovesac Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lpcn",
      code: "NYSE:LPCN",
      companyName: "Lipocine Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lpg",
      code: "NYSE:LPG",
      companyName: "DORIAN LPG LTD",
      popularity: 0,
    },
    {
      slug: "nyse-lpi",
      code: "NYSE:LPI",
      companyName: "Laredo Petroleum Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lpl",
      code: "NYSE:LPL",
      companyName: "LG Display Co. Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-lpla",
      code: "NYSE:LPLA",
      companyName: "LPL Financial Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lpro",
      code: "NYSE:LPRO",
      companyName: "Open Lending Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lpsn",
      code: "NYSE:LPSN",
      companyName: "LivePerson Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lpth",
      code: "NYSE:LPTH",
      companyName: "Lightpath Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lptx",
      code: "NYSE:LPTX",
      companyName: "Leap Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lqda",
      code: "NYSE:LQDA",
      companyName: "Liquidia Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lqdb",
      code: "NYSE:LQDB",
      companyName: "iShares BBB Rated Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lqdh",
      code: "NYSE:LQDH",
      companyName: "iShares Interest Rate Hedged Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lqdi",
      code: "NYSE:LQDI",
      companyName: "iShares Inflation Hedged Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lqdt",
      code: "NYSE:LQDT",
      companyName: "Liquidity Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lqdw",
      code: "NYSE:LQDW",
      companyName:
        "iShares Investment Grade Corporate Bond BuyWrite Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lqig",
      code: "NYSE:LQIG",
      companyName: "SPDR MarketAxess Investment Grade 400 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lrfc",
      code: "NYSE:LRFC",
      companyName: "Logan Ridge Finance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lrge",
      code: "NYSE:LRGE",
      companyName: "ClearBridge Large Cap Growth ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lrgf",
      code: "NYSE:LRGF",
      companyName: "iShares U.S. Equity Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lrmr",
      code: "NYSE:LRMR",
      companyName: "Larimar Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lrn",
      code: "NYSE:LRN",
      companyName: "Stride Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lrnd",
      code: "NYSE:LRND",
      companyName: "IQ U.S. Large Cap R&D Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lrnz",
      code: "NYSE:LRNZ",
      companyName: "TrueShares Technology AI & Deep Learning ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lsaf",
      code: "NYSE:LSAF",
      companyName: "LeaderShares AlphaFactor US Core Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lsak",
      code: "NYSE:LSAK",
      companyName: "Lesaka Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lsat",
      code: "NYSE:LSAT",
      companyName: "LeaderShares AlphaFactor Tactical Focused ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lsbk",
      code: "NYSE:LSBK",
      companyName: "Lake Shore Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lscc",
      code: "NYSE:LSCC",
      companyName: "Lattice Semiconductor Corp",
      popularity: 0,
    },
    {
      slug: "nyse-lsea",
      code: "NYSE:LSEA",
      companyName: "Landsea Homes Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lseaw",
      code: "NYSE:LSEAW",
      companyName: "Landsea Homes Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lsf",
      code: "NYSE:LSF",
      companyName: "Laird Superfood Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lspd",
      code: "NYSE:LSPD",
      companyName: "Lightspeed Commerce Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lspr",
      code: "NYSE:LSPR",
      companyName: "Larkspur Health Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lspru",
      code: "NYSE:LSPRU",
      companyName: "Larkspur Health Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lsprw",
      code: "NYSE:LSPRW",
      companyName: "Larkspur Health Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lsst",
      code: "NYSE:LSST",
      companyName: "Natixis Loomis Sayles Short Duration Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lstr",
      code: "NYSE:LSTR",
      companyName: "Landstar System Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lsxma",
      code: "NYSE:LSXMA",
      companyName:
        "Liberty Media Corporation Series A Liberty SiriusXM Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lsxmb",
      code: "NYSE:LSXMB",
      companyName:
        "Liberty Media Corporation Series B Liberty SiriusXM Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lsxmk",
      code: "NYSE:LSXMK",
      companyName:
        "Liberty Media Corporation Series C Liberty SiriusXM Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ltbr",
      code: "NYSE:LTBR",
      companyName: "Lightbridge Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ltc",
      code: "NYSE:LTC",
      companyName: "LTC Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ltch",
      code: "NYSE:LTCH",
      companyName: "Latch Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ltchw",
      code: "NYSE:LTCHW",
      companyName: "Latch Inc. Warrant expiring 6/4/2026",
      popularity: 0,
    },
    {
      slug: "nyse-lth",
      code: "NYSE:LTH",
      companyName: "Life Time Group Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ltl",
      code: "NYSE:LTL",
      companyName: "ProShares Ultra Telecommunications",
      popularity: 0,
    },
    {
      slug: "nyse-ltpz",
      code: "NYSE:LTPZ",
      companyName: "PIMCO 15+ Year U.S. TIPS Index Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ltrn",
      code: "NYSE:LTRN",
      companyName: "Lantern Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ltrpa",
      code: "NYSE:LTRPA",
      companyName: "Liberty TripAdvisor Holdings Inc. Series A",
      popularity: 0,
    },
    {
      slug: "nyse-ltrpb",
      code: "NYSE:LTRPB",
      companyName: "Liberty TripAdvisor Holdings Inc. Series B",
      popularity: 0,
    },
    {
      slug: "nyse-ltrx",
      code: "NYSE:LTRX",
      companyName: "Lantronix Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ltry",
      code: "NYSE:LTRY",
      companyName: "Lottery.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ltryw",
      code: "NYSE:LTRYW",
      companyName: "Lottery.com Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lu",
      code: "NYSE:LU",
      companyName:
        "Lufax Holding Ltd. American Depositary Shares two of which representing one Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-lrcx",
      code: "NYSE:LRCX",
      companyName: "Lam Research Corp",
      popularity: 0,
    },
    {
      slug: "nyse-lucd",
      code: "NYSE:LUCD",
      companyName: "Lucid Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lucy",
      code: "NYSE:LUCY",
      companyName: "Innovative Eyewear Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lucyw",
      code: "NYSE:LUCYW",
      companyName: "Innovative Eyewear Inc. Series A Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lumo",
      code: "NYSE:LUMO",
      companyName: "Lumos Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-luna",
      code: "NYSE:LUNA",
      companyName: "Luna Innovations Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-lung",
      code: "NYSE:LUNG",
      companyName: "Pulmonx Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-luv",
      code: "NYSE:LUV",
      companyName: "Southwest Airlines Co.",
      popularity: 0,
    },
    {
      slug: "nyse-luxa",
      code: "NYSE:LUXA",
      companyName: "Lux Health Tech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-luxau",
      code: "NYSE:LUXAU",
      companyName: "Lux Health Tech Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-luxaw",
      code: "NYSE:LUXAW",
      companyName: "Lux Health Tech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-luxe",
      code: "NYSE:LUXE",
      companyName: "Emles Luxury Goods ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lvac",
      code: "NYSE:LVAC",
      companyName: "LAVA Medtech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lvacu",
      code: "NYSE:LVACU",
      companyName: "LAVA Medtech Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lvlu",
      code: "NYSE:LVLU",
      companyName: "Lulu's Fashion Lounge Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lvol",
      code: "NYSE:LVOL",
      companyName: "American Century Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lvox",
      code: "NYSE:LVOX",
      companyName: "LiveVox Holding Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lvoxu",
      code: "NYSE:LVOXU",
      companyName: "LiveVox Holding Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lvoxw",
      code: "NYSE:LVOXW",
      companyName: "LiveVox Holding Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lvra",
      code: "NYSE:LVRA",
      companyName: "Levere Holdings Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lvrau",
      code: "NYSE:LVRAU",
      companyName: "Levere Holdings Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-lvraw",
      code: "NYSE:LVRAW",
      companyName: "Levere Holdings Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-lvs",
      code: "NYSE:LVS",
      companyName: "Las Vegas Sands Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-lvtx",
      code: "NYSE:LVTX",
      companyName: "LAVA Therapeutics N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lw",
      code: "NYSE:LW",
      companyName: "Lamb Weston Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lway",
      code: "NYSE:LWAY",
      companyName: "Lifeway Foods Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lwlg",
      code: "NYSE:LWLG",
      companyName: "Lightwave Logic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lx",
      code: "NYSE:LX",
      companyName: "LexinFintech Holdings Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lxeh",
      code: "NYSE:LXEH",
      companyName:
        "Lixiang Education Holding Co. Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lxfr",
      code: "NYSE:LXFR",
      companyName: "Luxfer Holdings PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lxp",
      code: "NYSE:LXP",
      companyName: "LXP Industrial Trust",
      popularity: 0,
    },
    {
      slug: "nyse-lxp-c",
      code: "NYSE:LXP-C",
      companyName:
        "LXP Industrial Trust 6.5% Series C Cumulative Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lxrx",
      code: "NYSE:LXRX",
      companyName: "Lexicon Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lyb",
      code: "NYSE:LYB",
      companyName: "LyondellBasell Industries N.V. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-lyel",
      code: "NYSE:LYEL",
      companyName: "Lyell Immunopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lyfe",
      code: "NYSE:LYFE",
      companyName: "2ndVote Life Neutral Plus ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lyft",
      code: "NYSE:LYFT",
      companyName: "Lyft Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lyg",
      code: "NYSE:LYG",
      companyName: "Lloyds Banking Group PLC",
      popularity: 0,
    },
    {
      slug: "nyse-lyl",
      code: "NYSE:LYL",
      companyName: "Dragon Victory International Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lylt",
      code: "NYSE:LYLT",
      companyName: "Loyalty Ventures Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lyra",
      code: "NYSE:LYRA",
      companyName: "Lyra Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lyt",
      code: "NYSE:LYT",
      companyName: "Lytus Technologies Holdings PTV. Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-lyts",
      code: "NYSE:LYTS",
      companyName: "LSI Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lyv",
      code: "NYSE:LYV",
      companyName: "Live Nation Entertainment Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lz",
      code: "NYSE:LZ",
      companyName: "LegalZoom.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-lzb",
      code: "NYSE:LZB",
      companyName: "La-Z-Boy Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-m",
      code: "NYSE:M",
      companyName: "Macy's Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-maa",
      code: "NYSE:MAA",
      companyName: "Mid-America Apartment Communities Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-maa-i",
      code: "NYSE:MAA-I",
      companyName:
        "Mid-America Apartment Communities Inc. 8.50% Series I Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-maaq",
      code: "NYSE:MAAQ",
      companyName: "Mana Capital Acquisition Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-maaqr",
      code: "NYSE:MAAQR",
      companyName: "Mana Capital Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-maaqu",
      code: "NYSE:MAAQU",
      companyName: "Mana Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-maaqw",
      code: "NYSE:MAAQW",
      companyName: "Mana Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-maax",
      code: "NYSE:MAAX",
      companyName: "VanEck Muni Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-maca",
      code: "NYSE:MACA",
      companyName: "Moringa Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-macau",
      code: "NYSE:MACAU",
      companyName: "Moringa Acquisition Corp Units",
      popularity: 0,
    },
    {
      slug: "nyse-macaw",
      code: "NYSE:MACAW",
      companyName: "Moringa Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-macc",
      code: "NYSE:MACC",
      companyName: "Mission Advancement Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mack",
      code: "NYSE:MACK",
      companyName: "Merrimack Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mag",
      code: "NYSE:MAG",
      companyName: "MAG Silver Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-maga",
      code: "NYSE:MAGA",
      companyName: "Point Bridge America First ETF",
      popularity: 0,
    },
    {
      slug: "nyse-maia",
      code: "NYSE:MAIA",
      companyName: "MAIA Biotechnology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-main",
      code: "NYSE:MAIN",
      companyName: "Main Street Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mac",
      code: "NYSE:MAC",
      companyName: "The Macerich Company",
      popularity: 0,
    },
    {
      slug: "nyse-lxu",
      code: "NYSE:LXU",
      companyName: "LSB INDUSTRIES INC",
      popularity: 0,
    },
    {
      slug: "nyse-makx",
      code: "NYSE:MAKX",
      companyName: "ProShares S&P Kensho Smart Factories ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mamb",
      code: "NYSE:MAMB",
      companyName: "Monarch Ambassador Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-man",
      code: "NYSE:MAN",
      companyName: "ManpowerGroup",
      popularity: 0,
    },
    {
      slug: "nyse-manh",
      code: "NYSE:MANH",
      companyName: "Manhattan Associates Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mant",
      code: "NYSE:MANT",
      companyName: "Mantech International Corp",
      popularity: 0,
    },
    {
      slug: "nyse-manu",
      code: "NYSE:MANU",
      companyName: "MANCHESTER UNITED PLC",
      popularity: 0,
    },
    {
      slug: "nyse-maps",
      code: "NYSE:MAPS",
      companyName: "WM Technology Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mapsw",
      code: "NYSE:MAPSW",
      companyName: "WM Technology Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-maqc",
      code: "NYSE:MAQC",
      companyName:
        "Maquia Capital Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-maqcu",
      code: "NYSE:MAQCU",
      companyName: "Maquia Capital Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-maqcw",
      code: "NYSE:MAQCW",
      companyName: "Maquia Capital Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mar",
      code: "NYSE:MAR",
      companyName: "Marriot International Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mara",
      code: "NYSE:MARA",
      companyName: "Marathon Digital Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-marb",
      code: "NYSE:MARB",
      companyName: "First Trust Merger Arbitrage ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mark",
      code: "NYSE:MARK",
      companyName: "Remark Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-marps",
      code: "NYSE:MARPS",
      companyName: "Marine Petroleum Trust",
      popularity: 0,
    },
    {
      slug: "nyse-marz",
      code: "NYSE:MARZ",
      companyName: "TrueShares Structured Outcome (March) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mas",
      code: "NYSE:MAS",
      companyName: "Masco Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-masi",
      code: "NYSE:MASI",
      companyName: "Masimo Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mass",
      code: "NYSE:MASS",
      companyName: "908 Devices Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mat",
      code: "NYSE:MAT",
      companyName: "Mattel Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-matv",
      code: "NYSE:MATV",
      companyName: "Mativ Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-matw",
      code: "NYSE:MATW",
      companyName: "Matthews International Corp",
      popularity: 0,
    },
    {
      slug: "nyse-matx",
      code: "NYSE:MATX",
      companyName: "Matsons Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mav",
      code: "NYSE:MAV",
      companyName: "Pioneer Municipal High Income Advantage Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-max",
      code: "NYSE:MAX",
      companyName: "MediaAlpha Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-maxn",
      code: "NYSE:MAXN",
      companyName: "Maxeon Solar Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-maxr",
      code: "NYSE:MAXR",
      companyName: "Maxar Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mays",
      code: "NYSE:MAYS",
      companyName: "Mays (J.W.) Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mayz",
      code: "NYSE:MAYZ",
      companyName: "TrueShares Structured Outcome (May) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mbac",
      code: "NYSE:MBAC",
      companyName: "M3-Brigade Acquisition II Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mbb",
      code: "NYSE:MBB",
      companyName: "iShares MBS ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mbbb",
      code: "NYSE:MBBB",
      companyName: "VanEck Moody's Analytics BBB Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mbcc",
      code: "NYSE:MBCC",
      companyName: "Monarch Blue Chips Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mbcn",
      code: "NYSE:MBCN",
      companyName: "Middlefield Banc Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mbin",
      code: "NYSE:MBIN",
      companyName: "Merchants Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mbinn",
      code: "NYSE:MBINN",
      companyName: "Merchants Bancorp Depositary Shares Preferred Series C",
      popularity: 0,
    },
    {
      slug: "nyse-mbino",
      code: "NYSE:MBINO",
      companyName:
        "Merchants Bancorp Depositary Shares Each Representing a 1/40th Interest in a Share of Series B Fixed",
      popularity: 0,
    },
    {
      slug: "nyse-mbinp",
      code: "NYSE:MBINP",
      companyName:
        "Merchants Bancorp 7.00% Fixed-to-Floating Rate Series A Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mbio",
      code: "NYSE:MBIO",
      companyName: "Mustang Bio Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mbnd",
      code: "NYSE:MBND",
      companyName: "SPDR Nuveen Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mbne",
      code: "NYSE:MBNE",
      companyName: "SPDR Nuveen Municipal Bond ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mbnkp",
      code: "NYSE:MBNKP",
      companyName:
        "Medallion Bank Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series F",
      popularity: 0,
    },
    {
      slug: "nyse-mbot",
      code: "NYSE:MBOT",
      companyName: "Microbot Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mbox",
      code: "NYSE:MBOX",
      companyName: "Freedom Day Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mbrx",
      code: "NYSE:MBRX",
      companyName: "Moleculin Biotech Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mbsc",
      code: "NYSE:MBSC",
      companyName: "M3-Brigade Acquisition III Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mbsd",
      code: "NYSE:MBSD",
      companyName: "FlexShares Disciplined Duration MBS Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-mbtc",
      code: "NYSE:MBTC",
      companyName: "Nocturne Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mbtcr",
      code: "NYSE:MBTCR",
      companyName: "Nocturne Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nyse-mbtcu",
      code: "NYSE:MBTCU",
      companyName: "Nocturne Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mbuu",
      code: "NYSE:MBUU",
      companyName: "Malibu Boats Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-mbwm",
      code: "NYSE:MBWM",
      companyName: "Mercantile Bank Corp",
      popularity: 0,
    },
    {
      slug: "nyse-mc",
      code: "NYSE:MC",
      companyName: "MOELIS & COMPANY",
      popularity: 0,
    },
    {
      slug: "nyse-mcaa",
      code: "NYSE:MCAA",
      companyName: "Mountain & Co. I Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mcaau",
      code: "NYSE:MCAAU",
      companyName: "Mountain & Co. I Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mcaaw",
      code: "NYSE:MCAAW",
      companyName: "Mountain & Co. I Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mcac",
      code: "NYSE:MCAC",
      companyName:
        "Monterey Capital Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mcacr",
      code: "NYSE:MCACR",
      companyName: "Monterey Capital Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nyse-mcacu",
      code: "NYSE:MCACU",
      companyName: "Monterey Capital Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mcacw",
      code: "NYSE:MCACW",
      companyName: "Monterey Capital Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-mcae",
      code: "NYSE:MCAE",
      companyName: "Mountain Crest Acquisition Corp. III Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mcaer",
      code: "NYSE:MCAER",
      companyName: "Mountain Crest Acquisition Corp. III Right",
      popularity: 0,
    },
    {
      slug: "nyse-mcaeu",
      code: "NYSE:MCAEU",
      companyName: "Mountain Crest Acquisition Corp. III Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mcaf",
      code: "NYSE:MCAF",
      companyName: "Mountain Crest Acquisition Corp. IV Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mcafr",
      code: "NYSE:MCAFR",
      companyName: "Mountain Crest Acquisition Corp. IV Rights",
      popularity: 0,
    },
    {
      slug: "nyse-mcafu",
      code: "NYSE:MCAFU",
      companyName: "Mountain Crest Acquisition Corp. IV Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mcag",
      code: "NYSE:MCAG",
      companyName: "Mountain Crest Acquisition Corp. V Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mcagr",
      code: "NYSE:MCAGR",
      companyName: "Mountain Crest Acquisition Corp. V Right",
      popularity: 0,
    },
    {
      slug: "nyse-mcagu",
      code: "NYSE:MCAGU",
      companyName: "Mountain Crest Acquisition Corp. V Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mcb",
      code: "NYSE:MCB",
      companyName:
        "Metropolitan Bank Holding Corp. Common Stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nyse-mcbc",
      code: "NYSE:MCBC",
      companyName: "Macatawa Bank Corp",
      popularity: 0,
    },
    {
      slug: "nyse-mcft",
      code: "NYSE:MCFT",
      companyName: "MasterCraft Boat Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mcg",
      code: "NYSE:MCG",
      companyName: "Membership Collective Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mchi",
      code: "NYSE:MCHI",
      companyName: "iShares MSCI China ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mchp",
      code: "NYSE:MCHP",
      companyName: "Microchip Technology Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mchx",
      code: "NYSE:MCHX",
      companyName: "Marchex Inc. Class B",
      popularity: 0,
    },
    {
      slug: "nyse-mci",
      code: "NYSE:MCI",
      companyName: "Barings Corporate Investors",
      popularity: 0,
    },
    {
      slug: "nyse-mcld",
      code: "NYSE:MCLD",
      companyName: "mCloud Technologies Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mcldw",
      code: "NYSE:MCLDW",
      companyName: "mCloud Technologies Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-mcn",
      code: "NYSE:MCN",
      companyName: "Madison Covered Call & Equity Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-mcr",
      code: "NYSE:MCR",
      companyName: "MFS Charter Income Trust Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-mcrb",
      code: "NYSE:MCRB",
      companyName: "Seres Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mcri",
      code: "NYSE:MCRI",
      companyName: "Monarch Casino & Resort Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mcro",
      code: "NYSE:MCRO",
      companyName: "IQ Hedge Macro Tracker",
      popularity: 0,
    },
    {
      slug: "nyse-mcs",
      code: "NYSE:MCS",
      companyName: "The Marcus Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mcvt",
      code: "NYSE:MCVT",
      companyName: "Mill City Ventures III Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mcw",
      code: "NYSE:MCW",
      companyName: "Mister Car Wash Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mcy",
      code: "NYSE:MCY",
      companyName: "Mercury General Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-md",
      code: "NYSE:MD",
      companyName: "Pediatrix Medical Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mdb",
      code: "NYSE:MDB",
      companyName: "MongoDB Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-mdc",
      code: "NYSE:MDC",
      companyName: "M.D.C. Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mdcp",
      code: "NYSE:MDCP",
      companyName: "VictoryShares THB Mid Cap ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mdev",
      code: "NYSE:MDEV",
      companyName: "First Trust Indxx Medical Devices ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mdgl",
      code: "NYSE:MDGL",
      companyName: "Madrigal Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mdgs",
      code: "NYSE:MDGS",
      companyName: "Medigus Ltd. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-mdgsw",
      code: "NYSE:MDGSW",
      companyName: "Medigus Ltd. Series C Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mdh",
      code: "NYSE:MDH",
      companyName: "MDH Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mdia",
      code: "NYSE:MDIA",
      companyName: "Mediaco Holding Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mdiv",
      code: "NYSE:MDIV",
      companyName:
        "First Trust Exchange-Traded Fund VI Multi-Asset Diversified Income Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-mdjh",
      code: "NYSE:MDJH",
      companyName: "MDJM LTD Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-mdlz",
      code: "NYSE:MDLZ",
      companyName: "Mondelez International Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-mdna",
      code: "NYSE:MDNA",
      companyName: "Medicenna Therapeutics Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mdrr",
      code: "NYSE:MDRR",
      companyName: "Medalist Diversified REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mdrrp",
      code: "NYSE:MDRRP",
      companyName:
        "Medalist Diversified REIT Inc. Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mdrx",
      code: "NYSE:MDRX",
      companyName: "Allscripts-Misys Healthcare Solution",
      popularity: 0,
    },
    {
      slug: "nyse-mdu",
      code: "NYSE:MDU",
      companyName: "MDU Resources Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mdv",
      code: "NYSE:MDV",
      companyName: "Modiv Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mdv-a",
      code: "NYSE:MDV-A",
      companyName:
        "Modiv Inc. 7.375% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mdvl",
      code: "NYSE:MDVL",
      companyName: "MedAvail Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mdwd",
      code: "NYSE:MDWD",
      companyName: "MediWound Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-mdwt",
      code: "NYSE:MDWT",
      companyName: "Midwest Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mdxg",
      code: "NYSE:MDXG",
      companyName: "MiMedx Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mdxh",
      code: "NYSE:MDXH",
      companyName: "MDxHealth SA American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mdy",
      code: "NYSE:MDY",
      companyName: "SPDR S&P MidCap 400 ETF Trust",
      popularity: 0,
    },
    {
      slug: "nyse-mdyg",
      code: "NYSE:MDYG",
      companyName:
        "SPDR S&P 400 Mid Cap Growth ETF (Based on S&P MidCap 400 Growth Index--symbol MUV)",
      popularity: 0,
    },
    {
      slug: "nyse-mdyv",
      code: "NYSE:MDYV",
      companyName:
        "SPDR S&P 400 Mid Cap Value ETF (based on S&P MidCap 400 Value Index--symbol: MGD)",
      popularity: 0,
    },
    {
      slug: "nyse-me",
      code: "NYSE:ME",
      companyName: "23andMe Holding Co. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-meac",
      code: "NYSE:MEAC",
      companyName: "Mercury Ecommerce Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-meacu",
      code: "NYSE:MEACU",
      companyName: "Mercury Ecommerce Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-meacw",
      code: "NYSE:MEACW",
      companyName: "Mercury Ecommerce Acquisition Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-mear",
      code: "NYSE:MEAR",
      companyName: "BlackRock Short Maturity Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mec",
      code: "NYSE:MEC",
      companyName: "Mayville Engineering Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-medp",
      code: "NYSE:MEDP",
      companyName: "Medpace Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mco",
      code: "NYSE:MCO",
      companyName: "Moody's Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-meds",
      code: "NYSE:MEDS",
      companyName: "TRxADE HEALTH Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-meg",
      code: "NYSE:MEG",
      companyName: "Montrose Environmental Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-megi",
      code: "NYSE:MEGI",
      companyName: "MainStay CBRE Global Infrastructure Megatrends Fund",
      popularity: 0,
    },
    {
      slug: "nyse-megl",
      code: "NYSE:MEGL",
      companyName: "Magic Empire Global Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mei",
      code: "NYSE:MEI",
      companyName: "Methode Electronics",
      popularity: 0,
    },
    {
      slug: "nyse-meip",
      code: "NYSE:MEIP",
      companyName: "MEI Pharma Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-meka",
      code: "NYSE:MEKA",
      companyName: "MELI Kaszek Pioneer Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-meoa",
      code: "NYSE:MEOA",
      companyName:
        "Minority Equality Opportunities Acquisition Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-meoau",
      code: "NYSE:MEOAU",
      companyName: "Minority Equality Opportunities Acquisition Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-meoaw",
      code: "NYSE:MEOAW",
      companyName: "Minority Equality Opportunities Acquisition Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-meoh",
      code: "NYSE:MEOH",
      companyName: "Methanex Corp",
      popularity: 0,
    },
    {
      slug: "nyse-mer-k",
      code: "NYSE:MER-K",
      companyName:
        "Bank of America Corporation Income Capital Obligation Notes initially due December 15 2066",
      popularity: 0,
    },
    {
      slug: "nyse-merc",
      code: "NYSE:MERC",
      companyName: "Mercer International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mesa",
      code: "NYSE:MESA",
      companyName: "Mesa Air Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-meso",
      code: "NYSE:MESO",
      companyName: "Mesoblast Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-met-a",
      code: "NYSE:MET-A",
      companyName: "Metlife Inc. Floating Rate Non Cuml Series A",
      popularity: 0,
    },
    {
      slug: "nyse-met-e",
      code: "NYSE:MET-E",
      companyName:
        "MetLife Inc. Depositary Shares each representing a 1/1000th interest in a share of 5.625% Non-Cum",
      popularity: 0,
    },
    {
      slug: "nyse-met-f",
      code: "NYSE:MET-F",
      companyName:
        "MetLife Inc. Depositary Shares each representing a 1/1000th interest in a share of 4.75% Non-Cumu",
      popularity: 0,
    },
    {
      slug: "nyse-metc",
      code: "NYSE:METC",
      companyName: "Ramaco Resources Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-metcl",
      code: "NYSE:METCL",
      companyName: "Ramaco Resources Inc. 9.00% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-metv",
      code: "NYSE:METV",
      companyName: "Roundhill Ball Metaverse ETF",
      popularity: 0,
    },
    {
      slug: "nyse-metx",
      code: "NYSE:METX",
      companyName: "Meten Holding Group Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-metxw",
      code: "NYSE:METXW",
      companyName: "Meten Holding Group Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mexx",
      code: "NYSE:MEXX",
      companyName: "Direxion Daily MSCI Mexico Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mf",
      code: "NYSE:MF",
      companyName: "Missfresh Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mfa",
      code: "NYSE:MFA",
      companyName: "MFA Financial Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mfa-b",
      code: "NYSE:MFA-B",
      companyName:
        "MFA Financial Inc. 7.50% Series B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mfa-c",
      code: "NYSE:MFA-C",
      companyName:
        "MFA Financial Inc. 6.50% Series C Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mfc",
      code: "NYSE:MFC",
      companyName: "Manulife Financial Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mfdx",
      code: "NYSE:MFDX",
      companyName: "PIMCO RAFI Multi-Factor International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mfem",
      code: "NYSE:MFEM",
      companyName:
        "PIMCO RAFI Dynamic Multi-Factor Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mfg",
      code: "NYSE:MFG",
      companyName:
        "Mizuho Financial Group Inc. American Depositary Shares (Each representing one-fifth of an Ordinary ",
      popularity: 0,
    },
    {
      slug: "nyse-mfgp",
      code: "NYSE:MFGP",
      companyName:
        "Micro Focus International plc. American Depositary Shares each representing One Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-mfh",
      code: "NYSE:MFH",
      companyName: "Mercurity Fintech Holding Inc. ADS",
      popularity: 0,
    },
    {
      slug: "nyse-mfic",
      code: "NYSE:MFIC",
      companyName: "MidCap Financial Investment Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mfin",
      code: "NYSE:MFIN",
      companyName: "Medallion Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-mflx",
      code: "NYSE:MFLX",
      companyName:
        "First Trust Exchange-Traded Fund VIII First Trust Flexible Municipal High Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mfm",
      code: "NYSE:MFM",
      companyName: "MFS Municipal Income Trust Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-mful",
      code: "NYSE:MFUL",
      companyName: "Mindful Conservative ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mfus",
      code: "NYSE:MFUS",
      companyName: "PIMCO RAFI Dynamic Multi-Factor U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mfv",
      code: "NYSE:MFV",
      companyName: "MFS SPECIAL VALUE TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-mg",
      code: "NYSE:MG",
      companyName: "Mistras Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mga",
      code: "NYSE:MGA",
      companyName: "Magna International",
      popularity: 0,
    },
    {
      slug: "nyse-mgam",
      code: "NYSE:MGAM",
      companyName: "Mobile Global Esports Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mgc",
      code: "NYSE:MGC",
      companyName: "Vanguard Mega Cap 300 Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mgee",
      code: "NYSE:MGEE",
      companyName: "MGE Energy Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mgf",
      code: "NYSE:MGF",
      companyName:
        "MFS Government Markets Income Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-mgi",
      code: "NYSE:MGI",
      companyName: "MoneyGram International Inc. New",
      popularity: 0,
    },
    {
      slug: "nyse-mgic",
      code: "NYSE:MGIC",
      companyName: "Magic Software Enterprises Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-mgk",
      code: "NYSE:MGK",
      companyName: "Vanguard Mega Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mgld",
      code: "NYSE:MGLD",
      companyName: "The Marygold Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mgm",
      code: "NYSE:MGM",
      companyName: "MGM RESORTS INTERNATIONAL",
      popularity: 0,
    },
    {
      slug: "nyse-mgmt",
      code: "NYSE:MGMT",
      companyName: "Ballast Small/Mid Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mgni",
      code: "NYSE:MGNI",
      companyName: "Magnite Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mgnx",
      code: "NYSE:MGNX",
      companyName: "MacroGenics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mgpi",
      code: "NYSE:MGPI",
      companyName: "MGP Ingredients Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mgr",
      code: "NYSE:MGR",
      companyName:
        "Affiliated Managers Group Inc. 5.875% Junior Subordinated Notes due 2059",
      popularity: 0,
    },
    {
      slug: "nyse-met",
      code: "NYSE:MET",
      companyName: "MetLife Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mfd",
      code: "NYSE:MFD",
      companyName:
        "Macquarie/First Trust Global Infrastructure/Utilities Dividend & Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-mgrb",
      code: "NYSE:MGRB",
      companyName:
        "Affiliated Managers Group Inc. 4.750% Junior Subordinated Notes due 2060",
      popularity: 0,
    },
    {
      slug: "nyse-mgrc",
      code: "NYSE:MGRC",
      companyName: "Mcgrath Rentcorp",
      popularity: 0,
    },
    {
      slug: "nyse-mgrd",
      code: "NYSE:MGRD",
      companyName:
        "Affiliated Managers Group Inc. 4.200% Junior Subordinated Notes due 2061",
      popularity: 0,
    },
    {
      slug: "nyse-mgta",
      code: "NYSE:MGTA",
      companyName: "Magenta Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mgtx",
      code: "NYSE:MGTX",
      companyName: "MeiraGTx Holdings plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mgv",
      code: "NYSE:MGV",
      companyName: "Vanguard Mega Cap  Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mgy",
      code: "NYSE:MGY",
      companyName: "Magnolia Oil & Gas Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mgyr",
      code: "NYSE:MGYR",
      companyName: "Magyar Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mh-a",
      code: "NYSE:MH-A",
      companyName:
        "MAIDEN HOLDINGS LTD. 8.25% Non-Cumulative Preference Shares Series A",
      popularity: 0,
    },
    {
      slug: "nyse-mh-c",
      code: "NYSE:MH-C",
      companyName:
        "Maiden Holdings North America Ltd. 7.125% Non-Cumulative Preference Shares Series C",
      popularity: 0,
    },
    {
      slug: "nyse-mh-d",
      code: "NYSE:MH-D",
      companyName:
        "Maiden Holdings North America Ltd. 6.700% Non-Cumulative Preference Shares Series D",
      popularity: 0,
    },
    {
      slug: "nyse-mhd",
      code: "NYSE:MHD",
      companyName: "Blackrock Muniholdings Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mhf",
      code: "NYSE:MHF",
      companyName: "Western Asset Municipal High Income Fund Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mhh",
      code: "NYSE:MHH",
      companyName: "Mastech Digital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mhi",
      code: "NYSE:MHI",
      companyName: "Pioneer Municipal High Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mhk",
      code: "NYSE:MHK",
      companyName: "Mohawk Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mhla",
      code: "NYSE:MHLA",
      companyName: "Maiden Holdings Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-mhld",
      code: "NYSE:MHLD",
      companyName: "Maiden Hldgs Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-mhn",
      code: "NYSE:MHN",
      companyName: "BLACKROCK MUNIHOLDINGS NEW YORK QUALITY FUND INC",
      popularity: 0,
    },
    {
      slug: "nyse-mhnc",
      code: "NYSE:MHNC",
      companyName: "MAIDEN HOLDINGS NORTH AMERICA LTD",
      popularity: 0,
    },
    {
      slug: "nyse-mho",
      code: "NYSE:MHO",
      companyName: "M/I Homes Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mhua",
      code: "NYSE:MHUA",
      companyName:
        "Meihua International Medical Technologies Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mics",
      code: "NYSE:MICS",
      companyName: "The Singing Machine Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mict",
      code: "NYSE:MICT",
      companyName: "MICT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mid",
      code: "NYSE:MID",
      companyName: "American Century Mid Cap Growth Impact ETF",
      popularity: 0,
    },
    {
      slug: "nyse-midd",
      code: "NYSE:MIDD",
      companyName: "Middleby Corp",
      popularity: 0,
    },
    {
      slug: "nyse-mide",
      code: "NYSE:MIDE",
      companyName: "Xtrackers S&P MidCap 400 ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-midf",
      code: "NYSE:MIDF",
      companyName: "iShares MSCI USA Mid-Cap Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-midu",
      code: "NYSE:MIDU",
      companyName: "Direxion Daily Mid Cap Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mig",
      code: "NYSE:MIG",
      companyName: "VanEck Moody's Analytics IG Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-migi",
      code: "NYSE:MIGI",
      companyName: "Mawson Infrastructure Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mimo",
      code: "NYSE:MIMO",
      companyName: "Airspan Networks Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-min",
      code: "NYSE:MIN",
      companyName: "MFS Intermediate Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-minc",
      code: "NYSE:MINC",
      companyName: "AdvisorShares Newfleet Multi-Sector Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mind",
      code: "NYSE:MIND",
      companyName: "MIND Technology Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-mindp",
      code: "NYSE:MINDP",
      companyName:
        "MIND Technology Inc. Series A 9.00% Series A Cumulative Preferred Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-minm",
      code: "NYSE:MINM",
      companyName: "Minim Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-minn",
      code: "NYSE:MINN",
      companyName: "Mairs & Power Minnesota Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mino",
      code: "NYSE:MINO",
      companyName: "PIMCO Municipal Income Opportunities Active ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mint",
      code: "NYSE:MINT",
      companyName: "PIMCO Enhanced Short Maturity Active Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-minv",
      code: "NYSE:MINV",
      companyName: "Matthews Asia Innovators Active ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mio",
      code: "NYSE:MIO",
      companyName: "Pioneer Municipal High Income Opportunities Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mir",
      code: "NYSE:MIR",
      companyName: "Mirion Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mirm",
      code: "NYSE:MIRM",
      companyName: "Mirum Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-miro",
      code: "NYSE:MIRO",
      companyName: "Miromatrix Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mist",
      code: "NYSE:MIST",
      companyName: "Milestone Pharmaceuticals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mit",
      code: "NYSE:MIT",
      companyName: "Mason Industrial Technology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mita",
      code: "NYSE:MITA",
      companyName: "Coliseum Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-mitau",
      code: "NYSE:MITAU",
      companyName: "Coliseum Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mitaw",
      code: "NYSE:MITAW",
      companyName: "Coliseum Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mitk",
      code: "NYSE:MITK",
      companyName: "Mitek Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mito",
      code: "NYSE:MITO",
      companyName: "Stealth BioTherapeutics Corp. ADS",
      popularity: 0,
    },
    {
      slug: "nyse-mitq",
      code: "NYSE:MITQ",
      companyName: "Moving iMage Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mitt",
      code: "NYSE:MITT",
      companyName: "AG MORTGAGE INVESTMENT TRUST INC.",
      popularity: 0,
    },
    {
      slug: "nyse-mitt-a",
      code: "NYSE:MITT-A",
      companyName: "AG MORTGAGE INVESTMENT TRUST INC.",
      popularity: 0,
    },
    {
      slug: "nyse-mitt-b",
      code: "NYSE:MITT-B",
      companyName: "AG MORTGAGE INVESTMENT TRUST INC",
      popularity: 0,
    },
    {
      slug: "nyse-mitt-c",
      code: "NYSE:MITT-C",
      companyName:
        "AG Mortgage Investment Trust Inc. 8.00% Series C Fixed-to-Floating Rate Cumulative Redeemable Prefe",
      popularity: 0,
    },
    {
      slug: "nyse-mixt",
      code: "NYSE:MIXT",
      companyName: "MIX TELEMATICS LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-miy",
      code: "NYSE:MIY",
      companyName: "BLACKROCK MUNIYIELD MICHIGAN QUALITY FUND INC. i",
      popularity: 0,
    },
    {
      slug: "nyse-mj",
      code: "NYSE:MJ",
      companyName: "ETFMG Alternative Harvest ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mjin",
      code: "NYSE:MJIN",
      companyName: "ETFMG 2X Daily Inverse Alternative Harvest ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mgu",
      code: "NYSE:MGU",
      companyName: "Macquarie Global Infrastructure Total Return Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mjus",
      code: "NYSE:MJUS",
      companyName: "ETFMG U.S. Alternative Harvest ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mjxl",
      code: "NYSE:MJXL",
      companyName: "ETFMG 2X Daily Alternative Harvest ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mkc",
      code: "NYSE:MKC",
      companyName: "McCormick & Company Incorporated Non-VTG CS",
      popularity: 0,
    },
    {
      slug: "nyse-mkd",
      code: "NYSE:MKD",
      companyName: "Molecular Data Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mkfg",
      code: "NYSE:MKFG",
      companyName: "Markforged Holding Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mksi",
      code: "NYSE:MKSI",
      companyName: "MKS Instruments Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mktw",
      code: "NYSE:MKTW",
      companyName: "MarketWise Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mktww",
      code: "NYSE:MKTWW",
      companyName: "MarketWise Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mktx",
      code: "NYSE:MKTX",
      companyName: "MarketAxess Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ml",
      code: "NYSE:ML",
      companyName: "MoneyLion Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mlab",
      code: "NYSE:MLAB",
      companyName: "Mesa Laboratories Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mlac",
      code: "NYSE:MLAC",
      companyName:
        "Malacca Straits Acquisition Company Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mlacu",
      code: "NYSE:MLACU",
      companyName: "Malacca Straits Acquisition Company Limited Units",
      popularity: 0,
    },
    {
      slug: "nyse-mlacw",
      code: "NYSE:MLACW",
      companyName: "Malacca Straits Acquisition Company Limited Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-mlai",
      code: "NYSE:MLAI",
      companyName: "McLaren Technology Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mlaiu",
      code: "NYSE:MLAIU",
      companyName: "McLaren Technology Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mlaiw",
      code: "NYSE:MLAIW",
      companyName: "McLaren Technology Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mlco",
      code: "NYSE:MLCO",
      companyName:
        "Melco Resorts & Entertainment Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mli",
      code: "NYSE:MLI",
      companyName: "Mueller Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mlkn",
      code: "NYSE:MLKN",
      companyName: "MillerKnoll Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mln",
      code: "NYSE:MLN",
      companyName: "VanEck Long Muni ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mlnk",
      code: "NYSE:MLNK",
      companyName: "MeridianLink Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mlp",
      code: "NYSE:MLP",
      companyName: "Maui Land & Pineapple Co.",
      popularity: 0,
    },
    {
      slug: "nyse-mlpb",
      code: "NYSE:MLPB",
      companyName:
        "ETRACS Alerian MLP Infrastructure Index ETN Series B due April 2 2040",
      popularity: 0,
    },
    {
      slug: "nyse-mlpo",
      code: "NYSE:MLPO",
      companyName: "Credit Suisse S&P MLP Index ETN",
      popularity: 0,
    },
    {
      slug: "nyse-mlpr",
      code: "NYSE:MLPR",
      companyName: "ETRACS Quarterly Pay 1.5X Leveraged Alerian MLP Index ETN",
      popularity: 0,
    },
    {
      slug: "nyse-mlpa",
      code: "NYSE:MLPA",
      companyName: "Global X MLP ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mlr",
      code: "NYSE:MLR",
      companyName: "Miller Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mlss",
      code: "NYSE:MLSS",
      companyName: "Milestone Scientific Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mltx",
      code: "NYSE:MLTX",
      companyName: "MoonLake Immunotherapeutics Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mlvf",
      code: "NYSE:MLVF",
      companyName: "Malvern Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mmat",
      code: "NYSE:MMAT",
      companyName: "Meta Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mmc",
      code: "NYSE:MMC",
      companyName: "Marsh & McLennan Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mmca",
      code: "NYSE:MMCA",
      companyName: "IQ MacKay California Municipal Intermediate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mmd",
      code: "NYSE:MMD",
      companyName: "MainStay MacKay DefinedTerm Municipal Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-mmi",
      code: "NYSE:MMI",
      companyName: "MARCUS & MILLICHAP",
      popularity: 0,
    },
    {
      slug: "nyse-mmin",
      code: "NYSE:MMIN",
      companyName: "IQ MacKay Municipal Insured ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mmit",
      code: "NYSE:MMIT",
      companyName: "IQ MacKay Municipal Intermediate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mmlg",
      code: "NYSE:MMLG",
      companyName: "First Trust Multi-Manager Large Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mmlp",
      code: "NYSE:MMLP",
      companyName: "Martin Midstream Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-mmm",
      code: "NYSE:MMM",
      companyName: "3M Company",
      popularity: 0,
    },
    {
      slug: "nyse-mmmb",
      code: "NYSE:MMMB",
      companyName: "MamaMancini's Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mms",
      code: "NYSE:MMS",
      companyName: "MAXIMUS Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mmsb",
      code: "NYSE:MMSB",
      companyName: "IQ MacKay Multi-Sector Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mmsc",
      code: "NYSE:MMSC",
      companyName: "First Trust Multi-Manager Small Cap Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mmsi",
      code: "NYSE:MMSI",
      companyName: "Merit Medical Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mmt",
      code: "NYSE:MMT",
      companyName: "MFS Multimarket Income Trust Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-mmtm",
      code: "NYSE:MMTM",
      companyName: "SPDR S&P 1500 Momentum Tilt ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mmu",
      code: "NYSE:MMU",
      companyName: "Western Asset Managed Municipals Fund Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mmx",
      code: "NYSE:MMX",
      companyName: "Maverix Metals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mmyt",
      code: "NYSE:MMYT",
      companyName: "MakeMyTrip Limited",
      popularity: 0,
    },
    {
      slug: "nyse-mn",
      code: "NYSE:MN",
      companyName: "MANNING & NAPIER INC.",
      popularity: 0,
    },
    {
      slug: "nyse-mna",
      code: "NYSE:MNA",
      companyName: "IQ ARB Merger Arbitrage ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mnbd",
      code: "NYSE:MNBD",
      companyName: "ALPS Intermediate Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mndo",
      code: "NYSE:MNDO",
      companyName: "Mind CTI Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-mndt",
      code: "NYSE:MNDT",
      companyName: "Mandiant Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mndy",
      code: "NYSE:MNDY",
      companyName: "monday.com Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mnkd",
      code: "NYSE:MNKD",
      companyName: "Mannkind Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mnm",
      code: "NYSE:MNM",
      companyName: "Direxion Daily Metal Miners Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mnmd",
      code: "NYSE:MNMD",
      companyName: "Mind Medicine (MindMed) Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mnov",
      code: "NYSE:MNOV",
      companyName: "Medicinova Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mnp",
      code: "NYSE:MNP",
      companyName: "Western Asset Municipal Partners Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mnpr",
      code: "NYSE:MNPR",
      companyName: "Monopar Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mnrl",
      code: "NYSE:MNRL",
      companyName: "Brigham Minerals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mnro",
      code: "NYSE:MNRO",
      companyName: "Monro Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mnsb",
      code: "NYSE:MNSB",
      companyName: "MainStreet Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mnsbp",
      code: "NYSE:MNSBP",
      companyName: "MainStreet Bancshares Inc. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mntk",
      code: "NYSE:MNTK",
      companyName: "Montauk Renewables Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mntn",
      code: "NYSE:MNTN",
      companyName: "Everest Consolidator Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mpw",
      code: "NYSE:MPW",
      companyName: "Medical Properties Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mnts",
      code: "NYSE:MNTS",
      companyName: "Momentus Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mntv",
      code: "NYSE:MNTV",
      companyName: "Momentive Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mntx",
      code: "NYSE:MNTX",
      companyName: "Manitex International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mobq",
      code: "NYSE:MOBQ",
      companyName: "Mobiquity Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mobqw",
      code: "NYSE:MOBQW",
      companyName: "Mobiquity Technologies Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mobvu",
      code: "NYSE:MOBVU",
      companyName: "Mobiv Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mod",
      code: "NYSE:MOD",
      companyName: "Modine Manufacturing Co",
      popularity: 0,
    },
    {
      slug: "nyse-modd",
      code: "NYSE:MODD",
      companyName: "Modular Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-modn",
      code: "NYSE:MODN",
      companyName: "MODEL N INC.",
      popularity: 0,
    },
    {
      slug: "nyse-modv",
      code: "NYSE:MODV",
      companyName: "ModivCare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mofg",
      code: "NYSE:MOFG",
      companyName: "MidWestOne Financial Group",
      popularity: 0,
    },
    {
      slug: "nyse-mogo",
      code: "NYSE:MOGO",
      companyName: "Mogo Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mogu",
      code: "NYSE:MOGU",
      companyName:
        "MOGU Inc. American Depositary Shares each representing three-hundred (300) Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-moh",
      code: "NYSE:MOH",
      companyName: "Molina Healthcare Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-moho",
      code: "NYSE:MOHO",
      companyName: "ECMOHO Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mohr",
      code: "NYSE:MOHR",
      companyName: "Mohr Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-moln",
      code: "NYSE:MOLN",
      companyName: "Molecular Partners AG American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-momo",
      code: "NYSE:MOMO",
      companyName: "Hello Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mon",
      code: "NYSE:MON",
      companyName: "Monument Circle Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-moncu",
      code: "NYSE:MONCU",
      companyName: "Monument Circle Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-moncw",
      code: "NYSE:MONCW",
      companyName: "Monument Circle Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mond",
      code: "NYSE:MOND",
      companyName: "Mondee Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mondw",
      code: "NYSE:MONDW",
      companyName: "Mondee Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-moo",
      code: "NYSE:MOO",
      companyName: "VanEck Agribusiness ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mood",
      code: "NYSE:MOOD",
      companyName: "Relative Sentiment Tactical Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-moon",
      code: "NYSE:MOON",
      companyName: "Direxion Moonshot Innovators ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mor",
      code: "NYSE:MOR",
      companyName: "MorphoSys AG American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-morf",
      code: "NYSE:MORF",
      companyName: "Morphic Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-morn",
      code: "NYSE:MORN",
      companyName: "Morningstar Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mort",
      code: "NYSE:MORT",
      companyName: "VanEck Mortgage REIT Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mote",
      code: "NYSE:MOTE",
      companyName: "VanEck Morningstar ESG Moat ETF",
      popularity: 0,
    },
    {
      slug: "nyse-motg",
      code: "NYSE:MOTG",
      companyName: "VanEck Morningstar Global Wide Moat ETF",
      popularity: 0,
    },
    {
      slug: "nyse-moti",
      code: "NYSE:MOTI",
      companyName: "VanEck Morningstar International Moat ETF",
      popularity: 0,
    },
    {
      slug: "nyse-moto",
      code: "NYSE:MOTO",
      companyName: "SmartETFs Smart Transportation & Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mots",
      code: "NYSE:MOTS",
      companyName: "Motus GI Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mov",
      code: "NYSE:MOV",
      companyName: "Movado Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-move",
      code: "NYSE:MOVE",
      companyName: "Movano Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-moxc",
      code: "NYSE:MOXC",
      companyName: "Moxian (BVI) Inc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mpa",
      code: "NYSE:MPA",
      companyName: "BLACKROCK MUNIYIELD PENNSYLVANIA QUALITY FUND",
      popularity: 0,
    },
    {
      slug: "nyse-mpaa",
      code: "NYSE:MPAA",
      companyName: "Motorcar Parts of America Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mpac",
      code: "NYSE:MPAC",
      companyName: "Model Performance Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-mpacr",
      code: "NYSE:MPACR",
      companyName: "Model Performance Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-mpacu",
      code: "NYSE:MPACU",
      companyName: "Model Performance Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-mpacw",
      code: "NYSE:MPACW",
      companyName: "Model Performance Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mpay",
      code: "NYSE:MPAY",
      companyName: "Akros Monthly Payout ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mpb",
      code: "NYSE:MPB",
      companyName: "Mid Penn Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mpc",
      code: "NYSE:MPC",
      companyName: "MARATHON PETROLEUM CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-mpln",
      code: "NYSE:MPLN",
      companyName: "MultiPlan Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mplx",
      code: "NYSE:MPLX",
      companyName: "MPLX LP",
      popularity: 0,
    },
    {
      slug: "nyse-mpra",
      code: "NYSE:MPRA",
      companyName:
        "Mercato Partners Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mprau",
      code: "NYSE:MPRAU",
      companyName: "Mercato Partners Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mpraw",
      code: "NYSE:MPRAW",
      companyName: "Mercato Partners Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mpro",
      code: "NYSE:MPRO",
      companyName: "Monarch ProCap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mpv",
      code: "NYSE:MPV",
      companyName: "Barings Participation Investors",
      popularity: 0,
    },
    {
      slug: "nyse-mpwr",
      code: "NYSE:MPWR",
      companyName: "Monolithic Power Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mpx",
      code: "NYSE:MPX",
      companyName: "Marine Products Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mos",
      code: "NYSE:MOS",
      companyName: "The Mosaic Company",
      popularity: 0,
    },
    {
      slug: "nyse-mo",
      code: "NYSE:MO",
      companyName: "Altria Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mrai",
      code: "NYSE:MRAI",
      companyName: "Marpai Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mram",
      code: "NYSE:MRAM",
      companyName: "Everspin Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mrbk",
      code: "NYSE:MRBK",
      companyName: "Meridian Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mrc",
      code: "NYSE:MRC",
      companyName: "MRC GLOBAL INC.",
      popularity: 0,
    },
    {
      slug: "nyse-mrcc",
      code: "NYSE:MRCC",
      companyName: "Monroe Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mrcy",
      code: "NYSE:MRCY",
      companyName: "Mercury Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mreo",
      code: "NYSE:MREO",
      companyName: "Mereo BioPharma Group plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mrgr",
      code: "NYSE:MRGR",
      companyName: "ProShares Merger ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mrin",
      code: "NYSE:MRIN",
      companyName: "MARIN SOFTWARE INCORPORATED",
      popularity: 0,
    },
    {
      slug: "nyse-mrkr",
      code: "NYSE:MRKR",
      companyName: "Marker Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mrm",
      code: "NYSE:MRM",
      companyName:
        "MEDIROM Healthcare Technologies Inc. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-mrna",
      code: "NYSE:MRNA",
      companyName: "Moderna Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mrnd",
      code: "NYSE:MRND",
      companyName: "IQ U.S. Mid Cap R&D Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mrns",
      code: "NYSE:MRNS",
      companyName: "Marinus Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mro",
      code: "NYSE:MRO",
      companyName: "Marathon Oil Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mrsn",
      code: "NYSE:MRSN",
      companyName: "Mersana Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mrtn",
      code: "NYSE:MRTN",
      companyName: "Marten Transport Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-mrtx",
      code: "NYSE:MRTX",
      companyName: "Mirati Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mrus",
      code: "NYSE:MRUS",
      companyName: "Merus N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mrvi",
      code: "NYSE:MRVI",
      companyName: "Maravai LifeSciences Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mrvl",
      code: "NYSE:MRVL",
      companyName: "Marvell Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mrsk",
      code: "NYSE:MRSK",
      companyName: "Toews Agility Shares Managed Risk ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ms-a",
      code: "NYSE:MS-A",
      companyName:
        "Morgan Stanley Floating Rate non-cumulative Preferred Series A",
      popularity: 0,
    },
    {
      slug: "nyse-ms-e",
      code: "NYSE:MS-E",
      companyName:
        "MORGAN STANLEY DEP SHARES EACH REPRESENTING 1/1000TH OF SHARE OF FIXED TO FLOATING RATE SER E",
      popularity: 0,
    },
    {
      slug: "nyse-ms-f",
      code: "NYSE:MS-F",
      companyName: "MORGAN STANLEY SERIES F",
      popularity: 0,
    },
    {
      slug: "nyse-ms-i",
      code: "NYSE:MS-I",
      companyName:
        "MORGAN STANLEY  Depositary Shares each representing 1/1000th of a share of Fixed-to-Floating Rate",
      popularity: 0,
    },
    {
      slug: "nyse-ms-k",
      code: "NYSE:MS-K",
      companyName:
        "Morgan Stanley Depositary Shares each representing 1/1000th of a share of Fixed-to-Floating Rate N",
      popularity: 0,
    },
    {
      slug: "nyse-ms-l",
      code: "NYSE:MS-L",
      companyName:
        "Morgan Stanley Depositary Shares each representing 1/1000th of a share of 4.875% Non-Cumulative Pr",
      popularity: 0,
    },
    {
      slug: "nyse-ms-o",
      code: "NYSE:MS-O",
      companyName:
        "Morgan Stanley Depositary Shares each representing 1/1000th of a share of 4.250% Non-Cumulative Pr",
      popularity: 0,
    },
    {
      slug: "nyse-ms-p",
      code: "NYSE:MS-P",
      companyName:
        "Morgan Stanley Depositary Shares each representing 1/1000th of a share of 6.500% Non-Cumulative Pr",
      popularity: 0,
    },
    {
      slug: "nyse-msa",
      code: "NYSE:MSA",
      companyName: "Mine Safety Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-msac",
      code: "NYSE:MSAC",
      companyName: "Medicus Sciences Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-msacw",
      code: "NYSE:MSACW",
      companyName: "Medicus Sciences Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-msb",
      code: "NYSE:MSB",
      companyName: "Mesabi Trust",
      popularity: 0,
    },
    {
      slug: "nyse-msbi",
      code: "NYSE:MSBI",
      companyName: "Midland States Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-msc",
      code: "NYSE:MSC",
      companyName:
        "Studio City International Holdings Limited American depositary shares each representing four Class ",
      popularity: 0,
    },
    {
      slug: "nyse-msci",
      code: "NYSE:MSCI",
      companyName: "MSCI Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-msd",
      code: "NYSE:MSD",
      companyName: "Morgan Stanley Emerging Markets Debt Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-msda",
      code: "NYSE:MSDA",
      companyName: "MSD Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-msdau",
      code: "NYSE:MSDAU",
      companyName: "MSD Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-msdaw",
      code: "NYSE:MSDAW",
      companyName: "MSD Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-msex",
      code: "NYSE:MSEX",
      companyName: "Middlesex Water Co",
      popularity: 0,
    },
    {
      slug: "nyse-msge",
      code: "NYSE:MSGE",
      companyName: "Madison Square Garden Entertainment Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-msgm",
      code: "NYSE:MSGM",
      companyName: "Motorsport Games Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-msgr",
      code: "NYSE:MSGR",
      companyName: "Direxion mRNA ETF",
      popularity: 0,
    },
    {
      slug: "nyse-msgs",
      code: "NYSE:MSGS",
      companyName: "Madison Square Garden Sports Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-msi",
      code: "NYSE:MSI",
      companyName: "Motorola Solutions Inc. New",
      popularity: 0,
    },
    {
      slug: "nyse-msm",
      code: "NYSE:MSM",
      companyName: "MSC Industrial Direct Co. Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-msmr",
      code: "NYSE:MSMR",
      companyName: "McElhenny Sheffield Managed Risk ETF",
      popularity: 0,
    },
    {
      slug: "nyse-msn",
      code: "NYSE:MSN",
      companyName: "Emerson Radio Corp. ",
      popularity: 0,
    },
    {
      slug: "nyse-msos",
      code: "NYSE:MSOS",
      companyName: "AdvisorShares Pure US Cannabis ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mspr",
      code: "NYSE:MSPR",
      companyName: "MSP Recovery Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-msprw",
      code: "NYSE:MSPRW",
      companyName: "MSP Recovery Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mssa",
      code: "NYSE:MSSA",
      companyName: "Metal Sky Star Acquisition Corporation Ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-mssar",
      code: "NYSE:MSSAR",
      companyName: "Metal Sky Star Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nyse-mssau",
      code: "NYSE:MSSAU",
      companyName: "Metal Sky Star Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mssaw",
      code: "NYSE:MSSAW",
      companyName: "Metal Sky Star Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mstq",
      code: "NYSE:MSTQ",
      companyName: "LHA Market State Tactical Q ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mstr",
      code: "NYSE:MSTR",
      companyName: "MicroStrategy Inc",
      popularity: 0,
    },
    {
      slug: "nyse-msvb",
      code: "NYSE:MSVB",
      companyName: "Mid-Southern Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-msvx",
      code: "NYSE:MSVX",
      companyName: "LHA Market State Alpha Seeker ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mt",
      code: "NYSE:MT",
      companyName: "ArcelorMittal",
      popularity: 0,
    },
    {
      slug: "nyse-mta",
      code: "NYSE:MTA",
      companyName: "Metalla Royalty & Streaming Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-mtac",
      code: "NYSE:MTAC",
      companyName: "MedTech Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mtacu",
      code: "NYSE:MTACU",
      companyName: "MedTech Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mtacw",
      code: "NYSE:MTACW",
      companyName: "MedTech Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mufg",
      code: "NYSE:MUFG",
      companyName: "Mitsubishi UFJ Financial Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mtb",
      code: "NYSE:MTB",
      companyName: "M&T Bank Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mtb-h",
      code: "NYSE:MTB-H",
      companyName:
        "M&T Bank Corporation Perpetual Fixed-to-Floating Rate Non- Cumulative Preferred Stock Series H",
      popularity: 0,
    },
    {
      slug: "nyse-mtbc",
      code: "NYSE:MTBC",
      companyName: "CareCloud Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mtbco",
      code: "NYSE:MTBCO",
      companyName:
        "CareCloud Inc. 8.75% Series B Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mtbcp",
      code: "NYSE:MTBCP",
      companyName:
        "CareCloud Inc. 11% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mtc",
      code: "NYSE:MTC",
      companyName: "MMTec Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mtch",
      code: "NYSE:MTCH",
      companyName: "Match Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mtcn",
      code: "NYSE:MTCN",
      companyName:
        "ArcelorMittal 5.50% Mandatorily Convertible Subordinated Notes due 2023",
      popularity: 0,
    },
    {
      slug: "nyse-mtcr",
      code: "NYSE:MTCR",
      companyName: "Metacrine Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mtd",
      code: "NYSE:MTD",
      companyName: "Mettler-Toledo International",
      popularity: 0,
    },
    {
      slug: "nyse-mtdr",
      code: "NYSE:MTDR",
      companyName: "MATADOR RESOURCES COMPANY",
      popularity: 0,
    },
    {
      slug: "nyse-mtek",
      code: "NYSE:MTEK",
      companyName: "Maris-Tech Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mtekw",
      code: "NYSE:MTEKW",
      companyName: "Maris-Tech Ltd. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-mtem",
      code: "NYSE:MTEM",
      companyName: "Molecular Templates Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mtex",
      code: "NYSE:MTEX",
      companyName: "Mannatech Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mtg",
      code: "NYSE:MTG",
      companyName: "MGIC Investment Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mtgp",
      code: "NYSE:MTGP",
      companyName: "WisdomTree Mortgage Plus Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-mth",
      code: "NYSE:MTH",
      companyName: "Meritage Homes Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mtl",
      code: "NYSE:MTL",
      companyName:
        "Mechel PAO American Depository Shares each representing two ordinary shares (ADSs)",
      popularity: 0,
    },
    {
      slug: "nyse-mtl-",
      code: "NYSE:MTL-",
      companyName:
        "Mechel PAO American Depositary Shares (each representing one-half of a Preferred Share)",
      popularity: 0,
    },
    {
      slug: "nyse-mtls",
      code: "NYSE:MTLS",
      companyName: "Materialise NV",
      popularity: 0,
    },
    {
      slug: "nyse-mtmt",
      code: "NYSE:MTMT",
      companyName: "Mega Matrix Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mtn",
      code: "NYSE:MTN",
      companyName: "Vail Resorts Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mtnb",
      code: "NYSE:MTNB",
      companyName: "Matinas BioPharma Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mtp",
      code: "NYSE:MTP",
      companyName: "Midatech Pharma PLC",
      popularity: 0,
    },
    {
      slug: "nyse-mtr",
      code: "NYSE:MTR",
      companyName: "Mesa Royalty Trust  ",
      popularity: 0,
    },
    {
      slug: "nyse-mtrn",
      code: "NYSE:MTRN",
      companyName: "Materion Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mtrx",
      code: "NYSE:MTRX",
      companyName: "Matrix Service Co",
      popularity: 0,
    },
    {
      slug: "nyse-mtry",
      code: "NYSE:MTRY",
      companyName: "Monterey Bio Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mtryu",
      code: "NYSE:MTRYU",
      companyName: "Monterey Bio Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mtryw",
      code: "NYSE:MTRYW",
      companyName: "Monterey Bio Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mtsi",
      code: "NYSE:MTSI",
      companyName: "MACOM Technology Solutions Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mttr",
      code: "NYSE:MTTR",
      companyName: "Matterport Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mtul",
      code: "NYSE:MTUL",
      companyName: "ETRACS 2x Leveraged MSCI US Momentum Factor TR ETN",
      popularity: 0,
    },
    {
      slug: "nyse-mtum",
      code: "NYSE:MTUM",
      companyName: "iShares MSCI USA Momentum Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mtvc",
      code: "NYSE:MTVC",
      companyName: "Motive Capital Corp II",
      popularity: 0,
    },
    {
      slug: "nyse-mtvr",
      code: "NYSE:MTVR",
      companyName: "Fount Metaverse ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mtw",
      code: "NYSE:MTW",
      companyName: "The Manitowoc Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mtx",
      code: "NYSE:MTX",
      companyName: "Minerals Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mtz",
      code: "NYSE:MTZ",
      companyName: "MasTec Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mu",
      code: "NYSE:MU",
      companyName: "Micron Technology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mua",
      code: "NYSE:MUA",
      companyName: "Blackrock Muni Assets Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mub",
      code: "NYSE:MUB",
      companyName: "iShares National Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-muc",
      code: "NYSE:MUC",
      companyName: "BLACKROCK MUNIHOLDINGS CALIFORNIA QUALITY FUND INC",
      popularity: 0,
    },
    {
      slug: "nyse-muds",
      code: "NYSE:MUDS",
      companyName:
        "Mudrick Capital Acquisition Corporation II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mudsu",
      code: "NYSE:MUDSU",
      companyName: "Mudrick Capital Acquisition Corporation II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-mudsw",
      code: "NYSE:MUDSW",
      companyName: "Mudrick Capital Acquisition Corporation II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mue",
      code: "NYSE:MUE",
      companyName: "BLACKROCK MUNIHOLDINGS QUALITY FUND II INC",
      popularity: 0,
    },
    {
      slug: "nyse-mui",
      code: "NYSE:MUI",
      companyName: "BlackRock Municipal Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-muj",
      code: "NYSE:MUJ",
      companyName: "BLACKROCK MUNIHOLDINGS NEW JERSEY QUALITY FUND INC.",
      popularity: 0,
    },
    {
      slug: "nyse-muln",
      code: "NYSE:MULN",
      companyName: "Mullen Automotive Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-muni",
      code: "NYSE:MUNI",
      companyName:
        "PIMCO Intermediate Municipal Bond Active Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-mur",
      code: "NYSE:MUR",
      companyName: "Murphy Oil Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-murf",
      code: "NYSE:MURF",
      companyName: "Murphy Canyon Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-murfu",
      code: "NYSE:MURFU",
      companyName: "Murphy Canyon Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-murfw",
      code: "NYSE:MURFW",
      companyName: "Murphy Canyon Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-musa",
      code: "NYSE:MUSA",
      companyName: "MURPHY USA INC.",
      popularity: 0,
    },
    {
      slug: "nyse-musi",
      code: "NYSE:MUSI",
      companyName: "American Century Multisector Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-must",
      code: "NYSE:MUST",
      companyName: "Columbia Multi-Sector Municipal Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mux",
      code: "NYSE:MUX",
      companyName: "McEwen Mining Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mvbf",
      code: "NYSE:MVBF",
      companyName: "MVB Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mvf",
      code: "NYSE:MVF",
      companyName: "BlackRock MuniVest Fund Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mvis",
      code: "NYSE:MVIS",
      companyName: "Microvision Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mvo",
      code: "NYSE:MVO",
      companyName: "MV Oil Trust",
      popularity: 0,
    },
    {
      slug: "nyse-mvps",
      code: "NYSE:MVPS",
      companyName: "Amplify Thematic All-Stars ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mvrl",
      code: "NYSE:MVRL",
      companyName: "ETRACS Monthly Pay 1.5X Leveraged Mortgage REIT ETN",
      popularity: 0,
    },
    {
      slug: "nyse-mvst",
      code: "NYSE:MVST",
      companyName: "Microvast Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mvstw",
      code: "NYSE:MVSTW",
      companyName: "Microvast Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-mvt",
      code: "NYSE:MVT",
      companyName: "Blackrock Munivest Fund II",
      popularity: 0,
    },
    {
      slug: "nyse-mvv",
      code: "NYSE:MVV",
      companyName: "ProShares Ultra MidCap400",
      popularity: 0,
    },
    {
      slug: "nyse-mwa",
      code: "NYSE:MWA",
      companyName: "Mueller Water Products Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mx",
      code: "NYSE:MX",
      companyName: "Magnachip Semiconductor Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-mxc",
      code: "NYSE:MXC",
      companyName: "Mexco Energy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mxct",
      code: "NYSE:MXCT",
      companyName: "MaxCyte Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mxe",
      code: "NYSE:MXE",
      companyName: "The Mexico Equity and Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mxf",
      code: "NYSE:MXF",
      companyName: "MEXICO FUND",
      popularity: 0,
    },
    {
      slug: "nyse-mxi",
      code: "NYSE:MXI",
      companyName: "iShares Global Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mxl",
      code: "NYSE:MXL",
      companyName: "MaxLinear Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-myd",
      code: "NYSE:MYD",
      companyName: "Blackrock Muniyield Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mye",
      code: "NYSE:MYE",
      companyName: "Myers Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-myfw",
      code: "NYSE:MYFW",
      companyName: "First Western Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mygn",
      code: "NYSE:MYGN",
      companyName: "Myriad Genetics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-myi",
      code: "NYSE:MYI",
      companyName: "BLACKROCK MUNIYIELD QUALITY FUND III INC.",
      popularity: 0,
    },
    {
      slug: "nyse-mymd",
      code: "NYSE:MYMD",
      companyName: "MyMD Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-myn",
      code: "NYSE:MYN",
      companyName: "BLACKROCK MUNIYIELD NEW YORK QUALITY FUND INC.",
      popularity: 0,
    },
    {
      slug: "nyse-myna",
      code: "NYSE:MYNA",
      companyName: "Mynaric AG American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mynz",
      code: "NYSE:MYNZ",
      companyName: "Mainz Biomed B.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-myo",
      code: "NYSE:MYO",
      companyName: "Myomo Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-myov",
      code: "NYSE:MYOV",
      companyName: "Myovant Sciences Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-myps",
      code: "NYSE:MYPS",
      companyName: "PLAYSTUDIOS Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mypsw",
      code: "NYSE:MYPSW",
      companyName: "PLAYSTUDIOS Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-myrg",
      code: "NYSE:MYRG",
      companyName: "MYR Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mysz",
      code: "NYSE:MYSZ",
      companyName: "My Size Inc",
      popularity: 0,
    },
    {
      slug: "nyse-myte",
      code: "NYSE:MYTE",
      companyName:
        "MYT Netherlands Parent B.V. American Depositary Shares each representing one Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-myy",
      code: "NYSE:MYY",
      companyName: "ProShares Short MidCap400",
      popularity: 0,
    },
    {
      slug: "nyse-mzz",
      code: "NYSE:MZZ",
      companyName: "ProShares UltraShort MidCap400",
      popularity: 0,
    },
    {
      slug: "nyse-na",
      code: "NYSE:NA",
      companyName: "Nano Labs Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-naac",
      code: "NYSE:NAAC",
      companyName:
        "North Atlantic Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-naacu",
      code: "NYSE:NAACU",
      companyName: "North Atlantic Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-naacw",
      code: "NYSE:NAACW",
      companyName: "North Atlantic Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-naas",
      code: "NYSE:NAAS",
      companyName: "NaaS Technology Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nabl",
      code: "NYSE:NABL",
      companyName: "N-able Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nac",
      code: "NYSE:NAC",
      companyName: "Nuveen California Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nacp",
      code: "NYSE:NACP",
      companyName: "Impact Shares NAACP Minority Empowerment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nad",
      code: "NYSE:NAD",
      companyName: "Nuveen Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-naii",
      code: "NYSE:NAII",
      companyName: "Natural Alternatives International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nak",
      code: "NYSE:NAK",
      companyName: "Northern Dynasty Minerals Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-nan",
      code: "NYSE:NAN",
      companyName: "Nuveen New York Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nanr",
      code: "NYSE:NANR",
      companyName: "SPDR S&P North American Natural Resources ETF",
      popularity: 0,
    },
    {
      slug: "nyse-naov",
      code: "NYSE:NAOV",
      companyName: "NanoVibronix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-napa",
      code: "NYSE:NAPA",
      companyName: "The Duckhorn Portfolio Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-napr",
      code: "NYSE:NAPR",
      companyName: "Innovator Growth-100 Power Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-nari",
      code: "NYSE:NARI",
      companyName: "Inari Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nat",
      code: "NYSE:NAT",
      companyName: "Nordic American Tanker",
      popularity: 0,
    },
    {
      slug: "nyse-nath",
      code: "NYSE:NATH",
      companyName: "Nathan's Famous Inc",
      popularity: 0,
    },
    {
      slug: "nyse-naut",
      code: "NYSE:NAUT",
      companyName: "Nautilus Biotechnolgy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-navb",
      code: "NYSE:NAVB",
      companyName: "Navidea Biopharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-navi",
      code: "NYSE:NAVI",
      companyName: "Navient Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-naz",
      code: "NYSE:NAZ",
      companyName: "Nuveen Arizona Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nbb",
      code: "NYSE:NBB",
      companyName: "Nuveen Taxable Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nbcc",
      code: "NYSE:NBCC",
      companyName: "Neuberger Berman Next Generation Connected Consumer ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nbct",
      code: "NYSE:NBCT",
      companyName: "Neuberger Berman Carbon Transition & Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nbds",
      code: "NYSE:NBDS",
      companyName: "Neuberger Berman Disrupters ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nflx",
      code: "NYSE:NFLX",
      companyName: "NetFlix Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nbev",
      code: "NYSE:NBEV",
      companyName: "NewAge Inc. Common Stock (Delaware)",
      popularity: 0,
    },
    {
      slug: "nyse-nbh",
      code: "NYSE:NBH",
      companyName: "Neuberger Berman Municipal Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nbhc",
      code: "NYSE:NBHC",
      companyName: "NATIONAL BANK HOLDINGS CORP.",
      popularity: 0,
    },
    {
      slug: "nyse-nbix",
      code: "NYSE:NBIX",
      companyName: "Neurocrine Biosciences Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nbn",
      code: "NYSE:NBN",
      companyName: "Northeast Bank Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nbo",
      code: "NYSE:NBO",
      companyName: "Neuberger Berman New York Municipal Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nbr",
      code: "NYSE:NBR",
      companyName: "Nabors Industries Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-nbrv",
      code: "NYSE:NBRV",
      companyName: "Nabriva Therapeutics plc Ordinary Shares Ireland",
      popularity: 0,
    },
    {
      slug: "nyse-nbse",
      code: "NYSE:NBSE",
      companyName: "NeuBase Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nbst",
      code: "NYSE:NBST",
      companyName: "Newbury Street Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nbstu",
      code: "NYSE:NBSTU",
      companyName: "Newbury Street Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nyse-nbstw",
      code: "NYSE:NBSTW",
      companyName: "Newbury Street Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-nbtb",
      code: "NYSE:NBTB",
      companyName: "NBT Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nbtx",
      code: "NYSE:NBTX",
      companyName: "Nanobiotix S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nbw",
      code: "NYSE:NBW",
      companyName: "Neuberger Berman California Municipal Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nbxg",
      code: "NYSE:NBXG",
      companyName: "Neuberger Berman Next Generation Connectivity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nby",
      code: "NYSE:NBY",
      companyName: "NovaBay Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nc",
      code: "NYSE:NC",
      companyName: "NACCO Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nca",
      code: "NYSE:NCA",
      companyName: "Nuveen California Municipal Value Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ncac",
      code: "NYSE:NCAC",
      companyName: "Newcourt Acquisition Corp Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ncacu",
      code: "NYSE:NCACU",
      companyName: "Newcourt Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ncacw",
      code: "NYSE:NCACW",
      companyName: "Newcourt Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ncmi",
      code: "NYSE:NCMI",
      companyName: "National CineMedia Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ncna",
      code: "NYSE:NCNA",
      companyName: "NuCana plc American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ncno",
      code: "NYSE:NCNO",
      companyName: "nCino Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ncpl",
      code: "NYSE:NCPL",
      companyName: "Netcapital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ncplw",
      code: "NYSE:NCPLW",
      companyName: "Netcapital Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-ncr",
      code: "NYSE:NCR",
      companyName: "NCR Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ncra",
      code: "NYSE:NCRA",
      companyName: "Nocera Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ncsm",
      code: "NYSE:NCSM",
      companyName: "NCS Multistage Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ncty",
      code: "NYSE:NCTY",
      companyName:
        "The9 Limited American Depository Shares representing three class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-ncv",
      code: "NYSE:NCV",
      companyName: "Virtus Convertible & Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ncv-a",
      code: "NYSE:NCV-A",
      companyName:
        "Virtus Convertible & Income Fund 5.625% Series A Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ncz",
      code: "NYSE:NCZ",
      companyName: "Virtus Convertible & Income Fund II",
      popularity: 0,
    },
    {
      slug: "nyse-ncz-a",
      code: "NYSE:NCZ-A",
      companyName:
        "Virtus Convertible & Income Fund II 5.50% Series A Cumulative Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ndac",
      code: "NYSE:NDAC",
      companyName: "NightDragon Acquisition Corp. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-ndacu",
      code: "NYSE:NDACU",
      companyName: "NightDragon Acquisition Corp. SCALE Units",
      popularity: 0,
    },
    {
      slug: "nyse-ndacw",
      code: "NYSE:NDACW",
      companyName:
        "NightDragon Acquisition Corp. Warrants to purchase Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-ndaq",
      code: "NYSE:NDAQ",
      companyName: "Nasdaq Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ndji",
      code: "NYSE:NDJI",
      companyName: "Nationwide Dow Jones Risk Managed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ndls",
      code: "NYSE:NDLS",
      companyName: "Noodles & Company Class A",
      popularity: 0,
    },
    {
      slug: "nyse-ndmo",
      code: "NYSE:NDMO",
      companyName:
        "Nuveen Dynamic Municipal Opportunities Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-ndp",
      code: "NYSE:NDP",
      companyName: "TORTOISE ENERGY INDEPENDENCE FUND INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ndra",
      code: "NYSE:NDRA",
      companyName: "ENDRA Life Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ndsn",
      code: "NYSE:NDSN",
      companyName: "Nordson Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ndvg",
      code: "NYSE:NDVG",
      companyName: "Nuveen Dividend Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nea",
      code: "NYSE:NEA",
      companyName: "Nuveen AMT-Free Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-near",
      code: "NYSE:NEAR",
      companyName: "BlackRock Short Maturity Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-necb",
      code: "NYSE:NECB",
      companyName: "Northeast Community Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nee-n",
      code: "NYSE:NEE-N",
      companyName:
        "NextEra Energy Capital Holdings Inc. Series N Junior Subordinated Debentures due March 1 2079",
      popularity: 0,
    },
    {
      slug: "nyse-nee-o",
      code: "NYSE:NEE-O",
      companyName: "NextEra Energy Inc. 4.872% Corporate Units",
      popularity: 0,
    },
    {
      slug: "nyse-nee-p",
      code: "NYSE:NEE-P",
      companyName: "NextEra Energy Inc. 5.279% Corporate Units",
      popularity: 0,
    },
    {
      slug: "nyse-nee-q",
      code: "NYSE:NEE-Q",
      companyName: "NextEra Energy Inc. 6.219% Corporate Units",
      popularity: 0,
    },
    {
      slug: "nyse-negg",
      code: "NYSE:NEGG",
      companyName: "Newegg Commerce Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nen",
      code: "NYSE:NEN",
      companyName: "New England Realty Associates Limited Partnership",
      popularity: 0,
    },
    {
      slug: "nyse-neo",
      code: "NYSE:NEO",
      companyName: "NeoGenomics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-neog",
      code: "NYSE:NEOG",
      companyName: "Neogen Corp",
      popularity: 0,
    },
    {
      slug: "nyse-neon",
      code: "NYSE:NEON",
      companyName: "Neonode Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-neov",
      code: "NYSE:NEOV",
      companyName: "NeoVolta Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-neovw",
      code: "NYSE:NEOVW",
      companyName: "NeoVolta Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nep",
      code: "NYSE:NEP",
      companyName: "NextEra Energy Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-neph",
      code: "NYSE:NEPH",
      companyName: "Nephros Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nept",
      code: "NYSE:NEPT",
      companyName: "Neptune Wellness Solutions Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nerd",
      code: "NYSE:NERD",
      companyName: "Roundhill BITKRAFT Esports & Digital Entertainment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nerv",
      code: "NYSE:NERV",
      companyName: "Minerva Neurosciences Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nesr",
      code: "NYSE:NESR",
      companyName: "National Energy Services Reunited Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nesrw",
      code: "NYSE:NESRW",
      companyName: "National Energy Services Reunited Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-net",
      code: "NYSE:NET",
      companyName:
        "Cloudflare Inc. Class A common stock par value $0.001 per share",
      popularity: 0,
    },
    {
      slug: "nyse-netc",
      code: "NYSE:NETC",
      companyName: "Nabors Energy Transition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-neti",
      code: "NYSE:NETI",
      companyName: "Eneti Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-netl",
      code: "NYSE:NETL",
      companyName: "NETLease Corporate Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-netz",
      code: "NYSE:NETZ",
      companyName: "Engine No. 1 Transform Climate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-neu",
      code: "NYSE:NEU",
      companyName: "NewMarket Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-newp",
      code: "NYSE:NEWP",
      companyName: "New Pacific Metals Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-newr",
      code: "NYSE:NEWR",
      companyName: "New Relic Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-newt",
      code: "NYSE:NEWT",
      companyName: "Newtek Business Services Corp",
      popularity: 0,
    },
    {
      slug: "nyse-newtl",
      code: "NYSE:NEWTL",
      companyName: "Newtek Business Services Corp. 5.75% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nyse-newtz",
      code: "NYSE:NEWTZ",
      companyName: "Newtek Business Services Corp. 5.50% Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-nex",
      code: "NYSE:NEX",
      companyName: "NexTier Oilfield Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nexa",
      code: "NYSE:NEXA",
      companyName: "Nexa Resources S.A. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nexi",
      code: "NYSE:NEXI",
      companyName: "NexImmune Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-next",
      code: "NYSE:NEXT",
      companyName: "NextDecade Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nfbk",
      code: "NYSE:NFBK",
      companyName: "Northfield Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nfe",
      code: "NYSE:NFE",
      companyName: "New Fortress Energy Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nfg",
      code: "NYSE:NFG",
      companyName: "National Fuel Gas Co.",
      popularity: 0,
    },
    {
      slug: "nyse-nfgc",
      code: "NYSE:NFGC",
      companyName: "New Found Gold Corp",
      popularity: 0,
    },
    {
      slug: "nyse-nfj",
      code: "NYSE:NFJ",
      companyName: "Virtus Dividend Interest & Premium Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nflt",
      code: "NYSE:NFLT",
      companyName: "Virtus Newfleet Multi-Sector Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nfnt",
      code: "NYSE:NFNT",
      companyName: "Infinite Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-nfra",
      code: "NYSE:NFRA",
      companyName: "FlexShares STOXX Global Broad Infrastructure Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nfty",
      code: "NYSE:NFTY",
      companyName: "First Trust India Nifty 50 Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nftz",
      code: "NYSE:NFTZ",
      companyName: "Defiance Digital Revolution ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nfys",
      code: "NYSE:NFYS",
      companyName: "Enphys Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ng",
      code: "NYSE:NG",
      companyName: "NovaGold Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ngc",
      code: "NYSE:NGC",
      companyName: "Northern Genesis Acquisition Corp. III",
      popularity: 0,
    },
    {
      slug: "nyse-ngd",
      code: "NYSE:NGD",
      companyName: "New Gold Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ngg",
      code: "NYSE:NGG",
      companyName: "National Grid PLC",
      popularity: 0,
    },
    {
      slug: "nyse-ngl",
      code: "NYSE:NGL",
      companyName: "NGL ENERGY PARTNERS LP",
      popularity: 0,
    },
    {
      slug: "nyse-ngl-b",
      code: "NYSE:NGL-B",
      companyName:
        "NGL Energy Partners LP 9.00% Class B Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferre",
      popularity: 0,
    },
    {
      slug: "nyse-ngl-c",
      code: "NYSE:NGL-C",
      companyName:
        "NGL Energy Partners LP 9.625% Class C Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferr",
      popularity: 0,
    },
    {
      slug: "nyse-ngm",
      code: "NYSE:NGM",
      companyName: "NGM Biopharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ngms",
      code: "NYSE:NGMS",
      companyName: "NeoGames S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ngs",
      code: "NYSE:NGS",
      companyName: "Natural Gas Services Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ngvc",
      code: "NYSE:NGVC",
      companyName: "NATURAL GROCERS BY VITAMIN COTTAGE INC",
      popularity: 0,
    },
    {
      slug: "nyse-ngvt",
      code: "NYSE:NGVT",
      companyName: "Ingevity Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-nh",
      code: "NYSE:NH",
      companyName: "NantHealth Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nhc",
      code: "NYSE:NHC",
      companyName: "National Healthcare Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-nhi",
      code: "NYSE:NHI",
      companyName: "National Health Investors",
      popularity: 0,
    },
    {
      slug: "nyse-nhic",
      code: "NYSE:NHIC",
      companyName: "NewHold Investment Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nhicu",
      code: "NYSE:NHICU",
      companyName: "NewHold Investment Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-nhicw",
      code: "NYSE:NHICW",
      companyName: "NewHold Investment Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nhs",
      code: "NYSE:NHS",
      companyName: "Neuberger Berman High Yield Strategies Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nhtc",
      code: "NYSE:NHTC",
      companyName: "Natural Health Trends Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-nhwk",
      code: "NYSE:NHWK",
      companyName: "NightHawk Biosciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ni",
      code: "NYSE:NI",
      companyName: "NiSource Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nib",
      code: "NYSE:NIB",
      companyName:
        "iPath Bloomberg Cocoa Subindex Total Return ETN due June 24 2038",
      popularity: 0,
    },
    {
      slug: "nyse-nic",
      code: "NYSE:NIC",
      companyName: "Nicolet BanksharesInc.",
      popularity: 0,
    },
    {
      slug: "nyse-nice",
      code: "NYSE:NICE",
      companyName: "NICE Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-nick",
      code: "NYSE:NICK",
      companyName: "Nicholas Financial Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nid",
      code: "NYSE:NID",
      companyName: "NUVEEN INTERMEDIATE DURATION MUNICIPAL TERM FUND",
      popularity: 0,
    },
    {
      slug: "nyse-nie",
      code: "NYSE:NIE",
      companyName: "Virtus Equity & Convertible Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nife",
      code: "NYSE:NIFE",
      companyName: "Direxion Fallen Knives ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nile",
      code: "NYSE:NILE",
      companyName: "BitNile Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nile-d",
      code: "NYSE:NILE-D",
      companyName:
        "BitNile Holdings Inc. 13.00% Series D Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nim",
      code: "NYSE:NIM",
      companyName: "Nuveen Select Maturities Municipal Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nimc",
      code: "NYSE:NIMC",
      companyName: "NiSource Inc. Series A Corporate Units",
      popularity: 0,
    },
    {
      slug: "nyse-nine",
      code: "NYSE:NINE",
      companyName: "Nine Energy Service Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-niq",
      code: "NYSE:NIQ",
      companyName: "NUVEEN INTERMEDIATE DURATION QUALITY MUNICIPAL TERM FUND",
      popularity: 0,
    },
    {
      slug: "nyse-nisn",
      code: "NYSE:NISN",
      companyName:
        "NiSun International Enterprise Development Group Co. Ltd. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-niu",
      code: "NYSE:NIU",
      companyName: "Niu Technologies American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-niwm",
      code: "NYSE:NIWM",
      companyName: "NightShares 2000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-njan",
      code: "NYSE:NJAN",
      companyName: "Innovator Growth-100 Power Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-njr",
      code: "NYSE:NJR",
      companyName: "New Jersey Resources Corp",
      popularity: 0,
    },
    {
      slug: "nyse-njul",
      code: "NYSE:NJUL",
      companyName: "Innovator Growth-100 Power Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-nkel",
      code: "NYSE:NKEL",
      companyName: "AXS 2X NKE Bull Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nkeq",
      code: "NYSE:NKEQ",
      companyName: "AXS 2X NKE Bear Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nkg",
      code: "NYSE:NKG",
      companyName: "Nuveen Georgia Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nkla",
      code: "NYSE:NKLA",
      companyName: "Nikola Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nksh",
      code: "NYSE:NKSH",
      companyName: "National Bankshares Inc/VA",
      popularity: 0,
    },
    {
      slug: "nyse-nktr",
      code: "NYSE:NKTR",
      companyName: "Nektar Therapeutics",
      popularity: 0,
    },
    {
      slug: "nyse-nktx",
      code: "NYSE:NKTX",
      companyName: "Nkarta Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nkx",
      code: "NYSE:NKX",
      companyName: "Nuveen California AMT-Free Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nl",
      code: "NYSE:NL",
      companyName: "NL Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nlit",
      code: "NYSE:NLIT",
      companyName: "Northern Lights Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nlitu",
      code: "NYSE:NLITU",
      companyName: "Northern Lights Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-nlitw",
      code: "NYSE:NLITW",
      companyName: "Northern Lights Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-nlok",
      code: "NYSE:NLOK",
      companyName: "NortonLifeLock Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nlr",
      code: "NYSE:NLR",
      companyName: "VanEck Uranium + Nuclear Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nls",
      code: "NYSE:NLS",
      companyName: "Nautilus Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nlsn",
      code: "NYSE:NLSN",
      companyName: "Nielsen Holdings plc",
      popularity: 0,
    },
    {
      slug: "nyse-nlsp",
      code: "NYSE:NLSP",
      companyName: "NLS Pharmaceutics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nlspw",
      code: "NYSE:NLSPW",
      companyName: "NLS Pharmaceutics Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nltx",
      code: "NYSE:NLTX",
      companyName: "Neoleukin Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nly",
      code: "NYSE:NLY",
      companyName: "Annaly Capital Management. Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nly-f",
      code: "NYSE:NLY-F",
      companyName:
        "Annaly Capital Management Inc. 6.95% Series F Fixed-to-Floating Rate Cumulative Redeemable Preferre",
      popularity: 0,
    },
    {
      slug: "nyse-nly-g",
      code: "NYSE:NLY-G",
      companyName:
        "Annaly Capital Management Inc. 6.50% Series G Fixed-to-Floating Rate Cumulative Redeemable Preferre",
      popularity: 0,
    },
    {
      slug: "nyse-nly-i",
      code: "NYSE:NLY-I",
      companyName:
        "Annaly Capital Management Inc. 6.750% Series I Fixed-to-Floating Rate Cumulative Redeemable Preferr",
      popularity: 0,
    },
    {
      slug: "nyse-nm",
      code: "NYSE:NM",
      companyName: "Navios Maritime Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nm-g",
      code: "NYSE:NM-G",
      companyName:
        "NAVIOS MARITIME HOLDINGS INC. American Depositary Shares each representing 1/100th of a 8.75% Serie",
      popularity: 0,
    },
    {
      slug: "nyse-nm-h",
      code: "NYSE:NM-H",
      companyName: "NAVIOS MARITIME HOLDNGS INC. 8.625% SER H",
      popularity: 0,
    },
    {
      slug: "nyse-nmai",
      code: "NYSE:NMAI",
      companyName: "Nuveen Multi-Asset Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nmco",
      code: "NYSE:NMCO",
      companyName: "Nuveen Municipal Credit Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nmfc",
      code: "NYSE:NMFC",
      companyName: "NEW MOUNTAIN FINANCE CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-nmg",
      code: "NYSE:NMG",
      companyName: "Nouveau Monde Graphite Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nmi",
      code: "NYSE:NMI",
      companyName: "Nuveen Municipal Income",
      popularity: 0,
    },
    {
      slug: "nyse-nmih",
      code: "NYSE:NMIH",
      companyName: "NMI Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nmk-b",
      code: "NYSE:NMK-B",
      companyName:
        "Niagara Mohawk Power Corporation Preferred Stock 3.60% Series",
      popularity: 0,
    },
    {
      slug: "nyse-nmk-c",
      code: "NYSE:NMK-C",
      companyName:
        "Niagara Mohawk Power Corporation Preferred Stock 3.90% Series",
      popularity: 0,
    },
    {
      slug: "nyse-nml",
      code: "NYSE:NML",
      companyName: "Neuberger Berman MLP and Energy Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nmm",
      code: "NYSE:NMM",
      companyName: "Navios Maritime Partners L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-nmmc",
      code: "NYSE:NMMC",
      companyName: "North Mountain Merger Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nmmcu",
      code: "NYSE:NMMCU",
      companyName: "North Mountain Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-nmmcw",
      code: "NYSE:NMMCW",
      companyName: "North Mountain Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nmr",
      code: "NYSE:NMR",
      companyName: "Nomura Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nms",
      code: "NYSE:NMS",
      companyName: "Nuveen Minnesota Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nmt",
      code: "NYSE:NMT",
      companyName: "Nuveen Massachusetts Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nmtc",
      code: "NYSE:NMTC",
      companyName: "NeuroOne Medical Technologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nmtr",
      code: "NYSE:NMTR",
      companyName: "9 Meters Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nmz",
      code: "NYSE:NMZ",
      companyName: "Nuveen Municipal High Income Opportunity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nn",
      code: "NYSE:NN",
      companyName: "NextNav Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nnavw",
      code: "NYSE:NNAVW",
      companyName: "NextNav Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nnbr",
      code: "NYSE:NNBR",
      companyName: "NN Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nndm",
      code: "NYSE:NNDM",
      companyName: "Nano Dimension Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nni",
      code: "NYSE:NNI",
      companyName: "Nelnet Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-nnn",
      code: "NYSE:NNN",
      companyName: "National Retail Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nnox",
      code: "NYSE:NNOX",
      companyName: "NANO-X IMAGING LTD Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nnvc",
      code: "NYSE:NNVC",
      companyName: "NanoViricides Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nny",
      code: "NYSE:NNY",
      companyName: "Nuveen New York Municipal Value Fund",
      popularity: 0,
    },
    {
      slug: "nyse-noa",
      code: "NYSE:NOA",
      companyName: "North American Construction Group Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-noac",
      code: "NYSE:NOAC",
      companyName: "Natural Order Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-noacu",
      code: "NYSE:NOACU",
      companyName: "Natural Order Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-noacw",
      code: "NYSE:NOACW",
      companyName: "Natural Order Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-noah",
      code: "NYSE:NOAH",
      companyName: "Noah Holdings Limited",
      popularity: 0,
    },
    {
      slug: "nyse-nobl",
      code: "NYSE:NOBL",
      companyName: "ProShares S&P 500 Dividend Aristocrats ETF",
      popularity: 0,
    },
    {
      slug: "nyse-noc",
      code: "NYSE:NOC",
      companyName: "Northrop Grumman Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-noct",
      code: "NYSE:NOCT",
      companyName: "Innovator Growth-100 Power Buffer ETF- October",
      popularity: 0,
    },
    {
      slug: "nyse-nodk",
      code: "NYSE:NODK",
      companyName: "NI Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nog",
      code: "NYSE:NOG",
      companyName: "Northern Oil and Gas Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nom",
      code: "NYSE:NOM",
      companyName: "Nuveen Missouri Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nomd",
      code: "NYSE:NOMD",
      companyName: "Nomad Foods Limited",
      popularity: 0,
    },
    {
      slug: "nyse-note",
      code: "NYSE:NOTE",
      companyName: "FiscalNote Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-notv",
      code: "NYSE:NOTV",
      companyName: "Inotiv Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nov",
      code: "NYSE:NOV",
      companyName: "NOV Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nova",
      code: "NYSE:NOVA",
      companyName: "Sunnova Energy International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-novn",
      code: "NYSE:NOVN",
      companyName: "Novan Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-novt",
      code: "NYSE:NOVT",
      companyName: "Novanta Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-novv",
      code: "NYSE:NOVV",
      companyName: "Nova Vision Acquisition Corp. Ordinary share",
      popularity: 0,
    },
    {
      slug: "nyse-novvr",
      code: "NYSE:NOVVR",
      companyName: "Nova Vision Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-novvu",
      code: "NYSE:NOVVU",
      companyName: "Nova Vision Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-novvw",
      code: "NYSE:NOVVW",
      companyName: "Nova Vision Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-novz",
      code: "NYSE:NOVZ",
      companyName: "TrueShares Structured Outcome (November) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-npab",
      code: "NYSE:NPAB",
      companyName: "New Providence Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-npabu",
      code: "NYSE:NPABU",
      companyName: "New Providence Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-npabw",
      code: "NYSE:NPABW",
      companyName: "New Providence Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-npce",
      code: "NYSE:NPCE",
      companyName: "Neuropace Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-npct",
      code: "NYSE:NPCT",
      companyName: "Nuveen Core Plus Impact Fund",
      popularity: 0,
    },
    {
      slug: "nyse-npfd",
      code: "NYSE:NPFD",
      companyName: "Nuveen Variable Rate Preferred & Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-npk",
      code: "NYSE:NPK",
      companyName: "National Presto Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-npo",
      code: "NYSE:NPO",
      companyName: "ENPRO INDUSTRIES",
      popularity: 0,
    },
    {
      slug: "nyse-npv",
      code: "NYSE:NPV",
      companyName: "Nuveen Virginia Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nqp",
      code: "NYSE:NQP",
      companyName: "Nuveen Pennsylvania Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nr",
      code: "NYSE:NR",
      companyName: "Newpark Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nrac",
      code: "NYSE:NRAC",
      companyName: "Noble Rock Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-nracu",
      code: "NYSE:NRACU",
      companyName: "Noble Rock Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-nracw",
      code: "NYSE:NRACW",
      companyName: "Noble Rock Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nrbo",
      code: "NYSE:NRBO",
      companyName: "NeuroBo Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nrc",
      code: "NYSE:NRC",
      companyName: "National Research Corporation Common Stock (Delaware)",
      popularity: 0,
    },
    {
      slug: "nyse-nrds",
      code: "NYSE:NRDS",
      companyName: "NerdWallet Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nrdy",
      code: "NYSE:NRDY",
      companyName: "Nerdy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nref",
      code: "NYSE:NREF",
      companyName: "NexPoint Real Estate Finance Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nref-a",
      code: "NYSE:NREF-A",
      companyName:
        "NexPoint Real Estate Finance Inc. 8.50% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nrg",
      code: "NYSE:NRG",
      companyName: "NRG Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nrgd",
      code: "NYSE:NRGD",
      companyName: "MicroSectors US Big Oil -3x Inverse Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-nrgv",
      code: "NYSE:NRGV",
      companyName: "Energy Vault Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nrgx",
      code: "NYSE:NRGX",
      companyName: "PIMCO Energy and Tactical Credit Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nrk",
      code: "NYSE:NRK",
      companyName: "Nuveen New York AMT-Free Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nro",
      code: "NYSE:NRO",
      companyName: "Neuberger Berman Real Estate Sec. Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nrp",
      code: "NYSE:NRP",
      companyName: "Natural Resource Partners L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-nrsn",
      code: "NYSE:NRSN",
      companyName: "NeuroSense Therapeutics Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nrsnw",
      code: "NYSE:NRSNW",
      companyName: "NeuroSense Therapeutics Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nrt",
      code: "NYSE:NRT",
      companyName: "North European Oil Royalty Trust",
      popularity: 0,
    },
    {
      slug: "nyse-nruc",
      code: "NYSE:NRUC",
      companyName:
        "National Rural Utilities Cooperative Finance Corporation 5.500% Subordinated Notes due 2064 (Subordi",
      popularity: 0,
    },
    {
      slug: "nyse-nrxp",
      code: "NYSE:NRXP",
      companyName: "NRX Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nrxpw",
      code: "NYSE:NRXPW",
      companyName: "NRX Pharmaceuticals Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ns-a",
      code: "NYSE:NS-A",
      companyName:
        "NuStar Energy L.P. 8.50% Series A Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred U",
      popularity: 0,
    },
    {
      slug: "nyse-ns-b",
      code: "NYSE:NS-B",
      companyName:
        "NuStar Energy L.P. 7.625% Series B Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-ns-c",
      code: "NYSE:NS-C",
      companyName:
        "NuStar Energy L.P. 9.00% Series C Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred U",
      popularity: 0,
    },
    {
      slug: "nyse-nsa",
      code: "NYSE:NSA",
      companyName: "National Storage Affiliates Trust",
      popularity: 0,
    },
    {
      slug: "nyse-nsa-a",
      code: "NYSE:NSA-A",
      companyName:
        "National Storage Affiliates Trust 6.000 Percent Series A Cumulative Redeemable Preferred Shares of B",
      popularity: 0,
    },
    {
      slug: "nyse-nsc",
      code: "NYSE:NSC",
      companyName: "Norfolk Southern Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-nscs",
      code: "NYSE:NSCS",
      companyName: "Nuveen Small Cap Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nsit",
      code: "NYSE:NSIT",
      companyName: "Insight Enterprises Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nsl",
      code: "NYSE:NSL",
      companyName: "NUVEEN SENIOR INCM FD",
      popularity: 0,
    },
    {
      slug: "nyse-nsp",
      code: "NYSE:NSP",
      companyName: "Insperity Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nspi",
      code: "NYSE:NSPI",
      companyName: "Nationwide S&P 500 Risk Managed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nspr",
      code: "NYSE:NSPR",
      companyName: "InspireMD Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nspy",
      code: "NYSE:NSPY",
      companyName: "NightShares 500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nss",
      code: "NYSE:NSS",
      companyName:
        "NUSTAR LOGISTICS L.P. 7.625% Fixed-to-Floating Rate Subordinated Notes due 2043",
      popularity: 0,
    },
    {
      slug: "nyse-nssc",
      code: "NYSE:NSSC",
      companyName: "Napco Security Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nstb",
      code: "NYSE:NSTB",
      companyName: "Northern Star Investment Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-nstc",
      code: "NYSE:NSTC",
      companyName: "Northern Star Investment Corp. III",
      popularity: 0,
    },
    {
      slug: "nyse-nstd",
      code: "NYSE:NSTD",
      companyName: "Northern Star Investment Corp. IV",
      popularity: 0,
    },
    {
      slug: "nyse-nstg",
      code: "NYSE:NSTG",
      companyName: "NanoString Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nsts",
      code: "NYSE:NSTS",
      companyName: "NSTS Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nsys",
      code: "NYSE:NSYS",
      companyName: "Nortech Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ntap",
      code: "NYSE:NTAP",
      companyName: "NetApp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ntb",
      code: "NYSE:NTB",
      companyName: "The Bank of N.T. Butterfield & Son Limited",
      popularity: 0,
    },
    {
      slug: "nyse-ntco",
      code: "NYSE:NTCO",
      companyName:
        "Natura &Co Holding S.A. American Depositary Shares (each representing two Common Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-ntct",
      code: "NYSE:NTCT",
      companyName: "Netscout Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ntes",
      code: "NYSE:NTES",
      companyName: "NetEase inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ntg",
      code: "NYSE:NTG",
      companyName: "Tortoise Midstream Energy Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ntgr",
      code: "NYSE:NTGR",
      companyName: "NETGEAR Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ntic",
      code: "NYSE:NTIC",
      companyName: "Northern Technologies International Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ntip",
      code: "NYSE:NTIP",
      companyName: "Network-1 Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ntki",
      code: "NYSE:NTKI",
      companyName: "Nationwide Russell 2000 Risk Managed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ntla",
      code: "NYSE:NTLA",
      companyName: "Intellia Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ntnx",
      code: "NYSE:NTNX",
      companyName: "Nutanix Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ntp",
      code: "NYSE:NTP",
      companyName: "Nam Tai Property Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ntra",
      code: "NYSE:NTRA",
      companyName: "Natera Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ntrb",
      code: "NYSE:NTRB",
      companyName: "Nutriband Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ntrbw",
      code: "NYSE:NTRBW",
      companyName: "Nutriband Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ntrs",
      code: "NYSE:NTRS",
      companyName: "Northern Trust Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ntrso",
      code: "NYSE:NTRSO",
      companyName:
        "Northern Trust Corporation Depositary Shares Each Representing a 1/1000th Interest in a Share of Se",
      popularity: 0,
    },
    {
      slug: "nyse-ntse",
      code: "NYSE:NTSE",
      companyName: "WisdomTree Emerging Markets Efficient Core Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ntsi",
      code: "NYSE:NTSI",
      companyName: "WisdomTree International Efficient Core Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ntst",
      code: "NYSE:NTST",
      companyName: "NetSTREIT Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ntsx",
      code: "NYSE:NTSX",
      companyName: "WisdomTree U.S. Efficient Core Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ntwk",
      code: "NYSE:NTWK",
      companyName: "NetSol Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ntz",
      code: "NYSE:NTZ",
      companyName: "Natuzzi S.p.A",
      popularity: 0,
    },
    {
      slug: "nyse-ntzg",
      code: "NYSE:NTZG",
      companyName: "Nuveen Global Net Zero Transition ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nu",
      code: "NYSE:NU",
      companyName: "Nu Holdings Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-nuag",
      code: "NYSE:NUAG",
      companyName: "Nuveen Enhanced Yield U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nubd",
      code: "NYSE:NUBD",
      companyName: "Nuveen ESG U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nubiu",
      code: "NYSE:NUBIU",
      companyName: "Nubia Brand International Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-nubiw",
      code: "NYSE:NUBIW",
      companyName: "Nubia Brand International Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nudm",
      code: "NYSE:NUDM",
      companyName: "Nuveen ESG International Developed Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nue",
      code: "NYSE:NUE",
      companyName: "Nucor Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-nuem",
      code: "NYSE:NUEM",
      companyName: "Nuveen ESG Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nugo",
      code: "NYSE:NUGO",
      companyName: "Nuveen Growth Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nugt",
      code: "NYSE:NUGT",
      companyName: "Direxion Daily Gold Miners Index Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nuhy",
      code: "NYSE:NUHY",
      companyName: "Nuveen ESG High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nulc",
      code: "NYSE:NULC",
      companyName: "Nuveen ESG Large-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nulg",
      code: "NYSE:NULG",
      companyName: "Nuveen ESG Large-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nulv",
      code: "NYSE:NULV",
      companyName: "Nuveen ESG Large-Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-numg",
      code: "NYSE:NUMG",
      companyName: "Nuveen ESG Mid-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-numv",
      code: "NYSE:NUMV",
      companyName: "Nuveen ESG Mid-Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nuo",
      code: "NYSE:NUO",
      companyName: "Nuveen Ohio Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nure",
      code: "NYSE:NURE",
      companyName: "Nuveen Short-Term REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nuro",
      code: "NYSE:NURO",
      companyName: "NeuroMetrix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nus",
      code: "NYSE:NUS",
      companyName: "NuSkin Enterprises Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nusa",
      code: "NYSE:NUSA",
      companyName: "Nuveen Enhanced Yield 1-5 Year U.S. Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nusc",
      code: "NYSE:NUSC",
      companyName: "Nuveen ESG Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nusi",
      code: "NYSE:NUSI",
      companyName: "Nationwide Nasdaq-100 Risk-Managed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nutx",
      code: "NYSE:NUTX",
      companyName: "Nutex Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nxe",
      code: "NYSE:NXE",
      companyName: "NexGen Energy Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-nuv",
      code: "NYSE:NUV",
      companyName: "Nuveen Municipal Value Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nuva",
      code: "NYSE:NUVA",
      companyName: "NuVasive Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nuvb",
      code: "NYSE:NUVB",
      companyName: "Nuvation Bio Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nuvl",
      code: "NYSE:NUVL",
      companyName: "Nuvalent Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nuw",
      code: "NYSE:NUW",
      companyName: "Nuveen AMT-Free Municipal Value Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nuwe",
      code: "NYSE:NUWE",
      companyName: "Nuwellis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nuze",
      code: "NYSE:NUZE",
      companyName: "NuZee Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nvac",
      code: "NYSE:NVAC",
      companyName: "NorthView Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nvacr",
      code: "NYSE:NVACR",
      companyName: "NorthView Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nyse-nvacw",
      code: "NYSE:NVACW",
      companyName: "NorthView Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nvax",
      code: "NYSE:NVAX",
      companyName: "Novavax Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nvcn",
      code: "NYSE:NVCN",
      companyName: "Neovasc Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nvcr",
      code: "NYSE:NVCR",
      companyName: "NovoCure Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nvct",
      code: "NYSE:NVCT",
      companyName: "Nuvectis Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nvds",
      code: "NYSE:NVDS",
      companyName: "AXS 1.25X NVDA Bear Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nvec",
      code: "NYSE:NVEC",
      companyName: "NVE Corp",
      popularity: 0,
    },
    {
      slug: "nyse-nvee",
      code: "NYSE:NVEE",
      companyName: "NV5 Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nvei",
      code: "NYSE:NVEI",
      companyName: "Nuvei Corporation Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nvfy",
      code: "NYSE:NVFY",
      companyName: "Nova Lifestyle Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nvg",
      code: "NYSE:NVG",
      companyName: "Nuveen AMT-Free Municipal Credit Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nvgs",
      code: "NYSE:NVGS",
      companyName: "NAVIGATOR HOLDINGS LTD.",
      popularity: 0,
    },
    {
      slug: "nyse-nviv",
      code: "NYSE:NVIV",
      companyName: "InVivo Therapeutics Holdings Corp",
      popularity: 0,
    },
    {
      slug: "nyse-nvmi",
      code: "NYSE:NVMI",
      companyName: "Nova Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nvno",
      code: "NYSE:NVNO",
      companyName: "enVVeno Medical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nvnow",
      code: "NYSE:NVNOW",
      companyName: "enVVeno Medical Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-nvos",
      code: "NYSE:NVOS",
      companyName: "Novo Integrated Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nvq",
      code: "NYSE:NVQ",
      companyName: "Qraft AI-Enhanced US Next Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nvr",
      code: "NYSE:NVR",
      companyName: "NVR Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nvro",
      code: "NYSE:NVRO",
      companyName: "NEVRO CORP.",
      popularity: 0,
    },
    {
      slug: "nyse-nvsa",
      code: "NYSE:NVSA",
      companyName: "New Vista Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nvsau",
      code: "NYSE:NVSAU",
      companyName: "New Vista Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-nvsaw",
      code: "NYSE:NVSAW",
      companyName: "New Vista Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nvst",
      code: "NYSE:NVST",
      companyName:
        "Envista Holdings Corporation Common stock $0.01 par value per share",
      popularity: 0,
    },
    {
      slug: "nyse-nvt",
      code: "NYSE:NVT",
      companyName: "nVent Electric plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nvta",
      code: "NYSE:NVTA",
      companyName: "Invitae Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-nvts",
      code: "NYSE:NVTS",
      companyName: "Navitas Semiconductor Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nvve",
      code: "NYSE:NVVE",
      companyName: "Nuvve Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nvvew",
      code: "NYSE:NVVEW",
      companyName: "Newborn Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nvx",
      code: "NYSE:NVX",
      companyName: "NOVONIX Limited American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nwbi",
      code: "NYSE:NWBI",
      companyName: "Northwest Bancshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nwe",
      code: "NYSE:NWE",
      companyName: "NorthWestern Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-nwfl",
      code: "NYSE:NWFL",
      companyName: "Norwood Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-nwg",
      code: "NYSE:NWG",
      companyName:
        "NatWest Group plc American Depositary Shares (Each representing 2 ordinary shares)",
      popularity: 0,
    },
    {
      slug: "nyse-nwlg",
      code: "NYSE:NWLG",
      companyName: "Nuveen Winslow Large-Cap Growth ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nwli",
      code: "NYSE:NWLI",
      companyName: "National Western Life Group Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-nwn",
      code: "NYSE:NWN",
      companyName: "Northwest Natural Holding Company",
      popularity: 0,
    },
    {
      slug: "nyse-nwpx",
      code: "NYSE:NWPX",
      companyName: "Northwest Pipe Co",
      popularity: 0,
    },
    {
      slug: "nyse-nws",
      code: "NYSE:NWS",
      companyName: "News Corporation Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nwsa",
      code: "NYSE:NWSA",
      companyName: "News Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nx",
      code: "NYSE:NX",
      companyName: "Quanex Building Products Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-nxc",
      code: "NYSE:NXC",
      companyName: "NUVEEN CA SEL TAX-FREE INC",
      popularity: 0,
    },
    {
      slug: "nyse-nxdt",
      code: "NYSE:NXDT",
      companyName: "NexPoint Diversified Real Estate Trust",
      popularity: 0,
    },
    {
      slug: "nyse-nxdt-a",
      code: "NYSE:NXDT-A",
      companyName:
        "NexPoint Diversified Real Estate Trust 5.50% Series A Cumulative Preferred Shares ($25.00 liquidatio",
      popularity: 0,
    },
    {
      slug: "nyse-nxgl",
      code: "NYSE:NXGL",
      companyName: "NexGel Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nxglw",
      code: "NYSE:NXGLW",
      companyName: "NexGel Inc Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-nxgn",
      code: "NYSE:NXGN",
      companyName: "NextGen Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nxj",
      code: "NYSE:NXJ",
      companyName: "Nuveen New Jersey Quality Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nxn",
      code: "NYSE:NXN",
      companyName: "NUVEEN NY SEL TAX-FREE INC",
      popularity: 0,
    },
    {
      slug: "nyse-nxp",
      code: "NYSE:NXP",
      companyName: "NUVEEN SELECT TAX-FREE INC",
      popularity: 0,
    },
    {
      slug: "nyse-nxpi",
      code: "NYSE:NXPI",
      companyName: "NXP Semiconductors N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-nxpl",
      code: "NYSE:NXPL",
      companyName: "NextPlat Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nxplw",
      code: "NYSE:NXPLW",
      companyName: "NextPlat Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-nxrt",
      code: "NYSE:NXRT",
      companyName: "NexPoint Residential Trust Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nxst",
      code: "NYSE:NXST",
      companyName: "Nexstar Media Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nxtc",
      code: "NYSE:NXTC",
      companyName: "NextCure Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nxtg",
      code: "NYSE:NXTG",
      companyName: "First Trust Indxx NextG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nxtp",
      code: "NYSE:NXTP",
      companyName: "NextPlay Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nyc",
      code: "NYSE:NYC",
      companyName: "New York City REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nycb-a",
      code: "NYSE:NYCB-A",
      companyName: "New York Community Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nycb-u",
      code: "NYSE:NYCB-U",
      companyName: "New York Community Capital Trust V (BONUSES)",
      popularity: 0,
    },
    {
      slug: "nyse-nyf",
      code: "NYSE:NYF",
      companyName: "iShares New York Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nymt",
      code: "NYSE:NYMT",
      companyName: "New York Mortgage Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-nymtl",
      code: "NYSE:NYMTL",
      companyName:
        "New York Mortgage Trust Inc. 6.875% Series F Fixed-to-Floating Rate Cumulative Redeemable Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-nymtm",
      code: "NYSE:NYMTM",
      companyName:
        "New York Mortgage Trust Inc. 7.875% Series E Fixed-to-Floating Rate Cumulative Redeemable Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-nymtn",
      code: "NYSE:NYMTN",
      companyName:
        "New York Mortgage Trust Inc. 8.00 Percent Series D Fixed-to-Floating Rate Cumulative Redeemable Pre",
      popularity: 0,
    },
    {
      slug: "nyse-nymtz",
      code: "NYSE:NYMTZ",
      companyName:
        "New York Mortgage Trust Inc. 7.000% Series G Cumulative Redeemable Preferred Stock $0.01 par value",
      popularity: 0,
    },
    {
      slug: "nyse-nymx",
      code: "NYSE:NYMX",
      companyName: "Nymox Pharmaceutical Corp",
      popularity: 0,
    },
    {
      slug: "nyse-nyt",
      code: "NYSE:NYT",
      companyName: "New York Times Co.",
      popularity: 0,
    },
    {
      slug: "nyse-nyxh",
      code: "NYSE:NYXH",
      companyName: "Nyxoah SA Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-nzac",
      code: "NYSE:NZAC",
      companyName: "SPDR MSCI ACWI Climate Paris Aligned ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nzf",
      code: "NYSE:NZF",
      companyName: "Nuveen Municipal Credit Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-nzro",
      code: "NYSE:NZRO",
      companyName: "Strategy Shares Halt Climate Change ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nzus",
      code: "NYSE:NZUS",
      companyName: "SPDR MSCI USA Climate Paris Aligned ETF",
      popularity: 0,
    },
    {
      slug: "nyse-o",
      code: "NYSE:O",
      companyName: "Realty Income Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-oacp",
      code: "NYSE:OACP",
      companyName: "OneAscent Core Plus Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-oaie",
      code: "NYSE:OAIE",
      companyName: "Optimize AI Smart Sentiment Event-Driven ETF",
      popularity: 0,
    },
    {
      slug: "nyse-oak-a",
      code: "NYSE:OAK-A",
      companyName: "Oaktree Capital Group LLC 6.625% Series A Preferred units",
      popularity: 0,
    },
    {
      slug: "nyse-oak-b",
      code: "NYSE:OAK-B",
      companyName: "Oaktree Capital Group LLC 6.550% Series B Preferred Units",
      popularity: 0,
    },
    {
      slug: "nyse-oalc",
      code: "NYSE:OALC",
      companyName: "OneAscent Large Cap Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ob",
      code: "NYSE:OB",
      companyName: "Outbrain Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-obe",
      code: "NYSE:OBE",
      companyName: "Obsidian Energy Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-oblg",
      code: "NYSE:OBLG",
      companyName: "Oblong Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-obnd",
      code: "NYSE:OBND",
      companyName: "SPDR Loomis Sayles Opportunistic Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-obnk",
      code: "NYSE:OBNK",
      companyName: "Origin Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-obor",
      code: "NYSE:OBOR",
      companyName: "Kraneshares MSCI One Belt One Road Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-obsv",
      code: "NYSE:OBSV",
      companyName: "ObsEva SA Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-obt",
      code: "NYSE:OBT",
      companyName: "Orange County Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oc",
      code: "NYSE:OC",
      companyName: "Owens Corning",
      popularity: 0,
    },
    {
      slug: "nyse-ocax",
      code: "NYSE:OCAX",
      companyName: "OCA Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ocaxu",
      code: "NYSE:OCAXU",
      companyName: "OCA Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ocaxw",
      code: "NYSE:OCAXW",
      companyName: "OCA Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-occ",
      code: "NYSE:OCC",
      companyName: "Optical Cable Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-occi",
      code: "NYSE:OCCI",
      companyName: "OFS Credit Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-occin",
      code: "NYSE:OCCIN",
      companyName:
        "OFS Credit Company Inc. 5.25% Series E Term Preferred Stock Due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-occio",
      code: "NYSE:OCCIO",
      companyName:
        "OFS Credit Company Inc. 6.125% Series C Term Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ocen",
      code: "NYSE:OCEN",
      companyName: "IQ Clean Oceans ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ocfc",
      code: "NYSE:OCFC",
      companyName: "OceanFirst Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ocfcp",
      code: "NYSE:OCFCP",
      companyName: "OceanFirst Financial Corp. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ocft",
      code: "NYSE:OCFT",
      companyName:
        "OneConnect Financial Technology Co. Ltd. American Depositary Shares each representing three ordina",
      popularity: 0,
    },
    {
      slug: "nyse-ocg",
      code: "NYSE:OCG",
      companyName: "Oriental Culture Holding LTD Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ocgn",
      code: "NYSE:OCGN",
      companyName: "Ocugen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ocio",
      code: "NYSE:OCIO",
      companyName: "ClearShares OCIO ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ocn",
      code: "NYSE:OCN",
      companyName: "Ocwen Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ocsl",
      code: "NYSE:OCSL",
      companyName: "Oaktree Specialty Lending Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-octz",
      code: "NYSE:OCTZ",
      companyName: "TrueShares Structured Outcome (October) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ocul",
      code: "NYSE:OCUL",
      companyName: "Ocular Therapeutix Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ocup",
      code: "NYSE:OCUP",
      companyName: "Ocuphire Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ocx",
      code: "NYSE:OCX",
      companyName: "Oncocyte Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-odc",
      code: "NYSE:ODC",
      companyName: "Oil-Dri Corporation of America",
      popularity: 0,
    },
    {
      slug: "nyse-odds",
      code: "NYSE:ODDS",
      companyName: "Pacer BlueStar Digital Entertainment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-odfl",
      code: "NYSE:ODFL",
      companyName: "Old Dominion Freight Line",
      popularity: 0,
    },
    {
      slug: "nyse-odp",
      code: "NYSE:ODP",
      companyName: "The ODP Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-odv",
      code: "NYSE:ODV",
      companyName: "Osisko Development Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-oec",
      code: "NYSE:OEC",
      companyName: "ORION ENGINEERED CARBONS S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-oef",
      code: "NYSE:OEF",
      companyName: "iShares S&P 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-oepw",
      code: "NYSE:OEPW",
      companyName:
        "One Equity Partners Open Water I Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oepwu",
      code: "NYSE:OEPWU",
      companyName: "One Equity Partners Open Water I Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-oepww",
      code: "NYSE:OEPWW",
      companyName: "One Equity Partners Open Water I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-oesx",
      code: "NYSE:OESX",
      companyName: "Orion Energy Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-oeur",
      code: "NYSE:OEUR",
      companyName: "ALPS O'Shares Europe Quality Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ofc",
      code: "NYSE:OFC",
      companyName: "Corporate Office Properties Trust",
      popularity: 0,
    },
    {
      slug: "nyse-ofed",
      code: "NYSE:OFED",
      companyName: "Oconee Federal Financial Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ofg",
      code: "NYSE:OFG",
      companyName: "OFG BANCORP",
      popularity: 0,
    },
    {
      slug: "nyse-ofix",
      code: "NYSE:OFIX",
      companyName: "Orthofix Medical Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-oflx",
      code: "NYSE:OFLX",
      companyName: "Omega Flex Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ofs",
      code: "NYSE:OFS",
      companyName: "OFS Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ofssh",
      code: "NYSE:OFSSH",
      companyName: "OFS Capital Corporation 4.95% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-og",
      code: "NYSE:OG",
      companyName:
        "Onion Global Limited American Depositary Shares (each ten (10) ADSs representing one (1) Class A Ord",
      popularity: 0,
    },
    {
      slug: "nyse-ogcp",
      code: "NYSE:OGCP",
      companyName: "Empire State Realty OP L.P. Series 60",
      popularity: 0,
    },
    {
      slug: "nyse-oge",
      code: "NYSE:OGE",
      companyName: "OGE Energy Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ogen",
      code: "NYSE:OGEN",
      companyName: "Oragenics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ogi",
      code: "NYSE:OGI",
      companyName: "Organigram Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ogig",
      code: "NYSE:OGIG",
      companyName: "ALPS  O'Shares Global Internet Giants ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ogn",
      code: "NYSE:OGN",
      companyName: "Organon & Co.",
      popularity: 0,
    },
    {
      slug: "nyse-ogs",
      code: "NYSE:OGS",
      companyName: "ONE GAS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ohaa",
      code: "NYSE:OHAA",
      companyName: "OPY Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ohaau",
      code: "NYSE:OHAAU",
      companyName: "OPY Acquisition Corp. I Units",
      popularity: 0,
    },
    {
      slug: "nyse-ohaaw",
      code: "NYSE:OHAAW",
      companyName: "OPY Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ohi",
      code: "NYSE:OHI",
      companyName: "Omega Healthcare Investors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ohpa",
      code: "NYSE:OHPA",
      companyName: "Orion Acquisition Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-ohpau",
      code: "NYSE:OHPAU",
      companyName: "Orion Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ohpaw",
      code: "NYSE:OHPAW",
      companyName: "Orion Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-oi",
      code: "NYSE:OI",
      companyName: "O-I Glass Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-oia",
      code: "NYSE:OIA",
      companyName: "INVESCO MUNICIPAL INCOME OPPORTUNITIES TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-oig",
      code: "NYSE:OIG",
      companyName: "Orbital Infrastructure Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oii",
      code: "NYSE:OII",
      companyName: "Oceaneering International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-oiim",
      code: "NYSE:OIIM",
      companyName: "02Micro International Limited",
      popularity: 0,
    },
    {
      slug: "nyse-oil",
      code: "NYSE:OIL",
      companyName: "iPath Pure Beta Crude Oil ETN",
      popularity: 0,
    },
    {
      slug: "nyse-oild",
      code: "NYSE:OILD",
      companyName:
        "MicroSectors Oil & Gas Exp. & Prod. -3x Inverse Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-oilk",
      code: "NYSE:OILK",
      companyName: "ProShares K-1 Free Crude Oil Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-oilu",
      code: "NYSE:OILU",
      companyName: "MicroSectors Oil & Gas Exp. & Prod. 3x Leveraged ETN",
      popularity: 0,
    },
    {
      slug: "nyse-ois",
      code: "NYSE:OIS",
      companyName: "OIL STATES INTERNATIONAL INC.",
      popularity: 0,
    },
    {
      slug: "nyse-oke",
      code: "NYSE:OKE",
      companyName: "Oneok Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-okyo",
      code: "NYSE:OKYO",
      companyName: "OKYO Pharma Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-olb",
      code: "NYSE:OLB",
      companyName: "The OLB Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oled",
      code: "NYSE:OLED",
      companyName: "Universal Display Corp",
      popularity: 0,
    },
    {
      slug: "nyse-olit",
      code: "NYSE:OLIT",
      companyName: "OmniLit Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-olitu",
      code: "NYSE:OLITU",
      companyName: "OmniLit Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-olitw",
      code: "NYSE:OLITW",
      companyName: "OmniLit Acquisition Corp. Warrants.",
      popularity: 0,
    },
    {
      slug: "nyse-olk",
      code: "NYSE:OLK",
      companyName: "Olink Holding AB (publ) American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-olli",
      code: "NYSE:OLLI",
      companyName: "Ollie's Bargain Outlet Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-olma",
      code: "NYSE:OLMA",
      companyName: "Olema Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oln",
      code: "NYSE:OLN",
      companyName: "Olin Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-olo",
      code: "NYSE:OLO",
      companyName: "Olo Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-olp",
      code: "NYSE:OLP",
      companyName: "One Liberty Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-olpx",
      code: "NYSE:OLPX",
      companyName: "Olaplex Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-om",
      code: "NYSE:OM",
      companyName: "Outset Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-omab",
      code: "NYSE:OMAB",
      companyName: "Grupo Aeroportuario del Centro Norte S.A.B. de C.V",
      popularity: 0,
    },
    {
      slug: "nyse-omc",
      code: "NYSE:OMC",
      companyName: "Omnicom Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-omcl",
      code: "NYSE:OMCL",
      companyName: "Omnicell Inc",
      popularity: 0,
    },
    {
      slug: "nyse-omeg",
      code: "NYSE:OMEG",
      companyName: "Omega Alpha SPAC Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-omer",
      code: "NYSE:OMER",
      companyName: "Omeros Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-omex",
      code: "NYSE:OMEX",
      companyName: "Odyssey Marine Exploration Inc",
      popularity: 0,
    },
    {
      slug: "nyse-omf",
      code: "NYSE:OMF",
      companyName: "OneMain Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-omfl",
      code: "NYSE:OMFL",
      companyName: "Invesco Russell 1000 Dynamic Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-omfs",
      code: "NYSE:OMFS",
      companyName: "Invesco Russell 2000 Dynamic Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-omga",
      code: "NYSE:OMGA",
      companyName: "Omega Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-omi",
      code: "NYSE:OMI",
      companyName: "Owens & Minor Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-omic",
      code: "NYSE:OMIC",
      companyName: "Singular Genomics Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-omqs",
      code: "NYSE:OMQS",
      companyName: "OMNIQ Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-on",
      code: "NYSE:ON",
      companyName: "ON Semiconductor Corp",
      popularity: 0,
    },
    {
      slug: "nyse-onb",
      code: "NYSE:ONB",
      companyName: "Old National Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-onbpo",
      code: "NYSE:ONBPO",
      companyName:
        "Old National Bancorp Depositary Shares Each Representing a 1/40th Interest in a Share of Series C P",
      popularity: 0,
    },
    {
      slug: "nyse-onbpp",
      code: "NYSE:ONBPP",
      companyName:
        "Old National Bancorp Depositary Shares Each Representing a 1/40th Interest in a Share of Series A P",
      popularity: 0,
    },
    {
      slug: "nyse-oncr",
      code: "NYSE:ONCR",
      companyName: "Oncorus Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-oncs",
      code: "NYSE:ONCS",
      companyName: "OncoSec Medical Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-onct",
      code: "NYSE:ONCT",
      companyName: "Oncternal Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oncy",
      code: "NYSE:ONCY",
      companyName: "Oncolytics Biotech Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ond",
      code: "NYSE:OND",
      companyName: "ProShares On-Demand ETF",
      popularity: 0,
    },
    {
      slug: "nyse-onds",
      code: "NYSE:ONDS",
      companyName: "Ondas Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-onem",
      code: "NYSE:ONEM",
      companyName: "1Life Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oneo",
      code: "NYSE:ONEO",
      companyName: "SPDR Russell 1000 Momentum Focus ETF",
      popularity: 0,
    },
    {
      slug: "nyse-oneq",
      code: "NYSE:ONEQ",
      companyName: "Fidelity Nasdaq Composite Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-onev",
      code: "NYSE:ONEV",
      companyName: "SPDR Russell 1000 Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-onew",
      code: "NYSE:ONEW",
      companyName: "OneWater Marine Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oney",
      code: "NYSE:ONEY",
      companyName: "SPDR Russell 1000 Yield Focus ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ong",
      code: "NYSE:ONG",
      companyName: "Direxion Daily Oil Services Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-onl",
      code: "NYSE:ONL",
      companyName: "Orion Office REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-onln",
      code: "NYSE:ONLN",
      companyName: "ProShares Online Retail ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ontf",
      code: "NYSE:ONTF",
      companyName: "ON24 Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-onto",
      code: "NYSE:ONTO",
      companyName: "Onto Innovation Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ontx",
      code: "NYSE:ONTX",
      companyName: "Onconova Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-onvo",
      code: "NYSE:ONVO",
      companyName: "Organovo Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-onyx",
      code: "NYSE:ONYX",
      companyName: "Onyx Acquisition Co. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-onyxu",
      code: "NYSE:ONYXU",
      companyName: "Onyx Acquisition Co. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-onyxw",
      code: "NYSE:ONYXW",
      companyName: "Onyx Acquisition Co. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ooma",
      code: "NYSE:OOMA",
      companyName: "Ooma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ooto",
      code: "NYSE:OOTO",
      companyName: "Direxion Daily Travel & Vacation Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-op",
      code: "NYSE:OP",
      companyName: "OceanPal Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-opa",
      code: "NYSE:OPA",
      companyName: "Magnum Opus Acquisition Limited",
      popularity: 0,
    },
    {
      slug: "nyse-opad",
      code: "NYSE:OPAD",
      companyName: "Offerpad Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-opal",
      code: "NYSE:OPAL",
      companyName: "OPAL Fuels Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-opalw",
      code: "NYSE:OPALW",
      companyName: "OPAL Fuels Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-opbk",
      code: "NYSE:OPBK",
      companyName: "OP Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-opch",
      code: "NYSE:OPCH",
      companyName: "Option Care Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-open",
      code: "NYSE:OPEN",
      companyName: "Opendoor Technologies Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oper",
      code: "NYSE:OPER",
      companyName: "ClearShares Ultra-Short Maturity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-opfi",
      code: "NYSE:OPFI",
      companyName: "OppFi Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-opgn",
      code: "NYSE:OPGN",
      companyName: "OpGen Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ophc",
      code: "NYSE:OPHC",
      companyName: "OptimumBank Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-opi",
      code: "NYSE:OPI",
      companyName:
        "Office Properties Income Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-opinl",
      code: "NYSE:OPINL",
      companyName:
        "Office Properties Income Trust 6.375% Senior Notes due 2050",
      popularity: 0,
    },
    {
      slug: "nyse-opk",
      code: "NYSE:OPK",
      companyName: "Opko Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-opnt",
      code: "NYSE:OPNT",
      companyName: "Opiant Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-opof",
      code: "NYSE:OPOF",
      companyName: "Old Point Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-opp",
      code: "NYSE:OPP",
      companyName: "RiverNorth/DoubleLine Strategic Opportunity Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-opp-a",
      code: "NYSE:OPP-A",
      companyName:
        "RiverNorth/DoubleLine Strategic Opportunity Fund Inc. 4.375% Series A Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-opp-b",
      code: "NYSE:OPP-B",
      companyName:
        "RiverNorth/DoubleLine Strategic Opportunity Fund Inc.4.75% Series B Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oppx",
      code: "NYSE:OPPX",
      companyName: "Corbett Road Tactical Opportunity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-opra",
      code: "NYSE:OPRA",
      companyName: "Opera Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-oprt",
      code: "NYSE:OPRT",
      companyName: "Oportun Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oprx",
      code: "NYSE:OPRX",
      companyName: "OptimizeRx Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-opt",
      code: "NYSE:OPT",
      companyName: "Opthea Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-optn",
      code: "NYSE:OPTN",
      companyName: "OptiNose Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-optt",
      code: "NYSE:OPTT",
      companyName: "Ocean Power Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-opy",
      code: "NYSE:OPY",
      companyName: "Oppenheimer Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-or",
      code: "NYSE:OR",
      companyName: "Osisko Gold Royalties Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ora",
      code: "NYSE:ORA",
      companyName: "Ormat Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-oran",
      code: "NYSE:ORAN",
      companyName: "Orange",
      popularity: 0,
    },
    {
      slug: "nyse-orc",
      code: "NYSE:ORC",
      companyName: "Orchid Island Capital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-orcc",
      code: "NYSE:ORCC",
      companyName: "Owl Rock Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-onof",
      code: "NYSE:ONOF",
      companyName: "Global X Adaptive U.S. Risk Management ETF",
      popularity: 0,
    },
    {
      slug: "nyse-orfn",
      code: "NYSE:ORFN",
      companyName: "Constrained Capital ESG Orphans ETF",
      popularity: 0,
    },
    {
      slug: "nyse-orgn",
      code: "NYSE:ORGN",
      companyName: "Origin Materials Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-orgnw",
      code: "NYSE:ORGNW",
      companyName: "Origin Materials Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-orgo",
      code: "NYSE:ORGO",
      companyName: "Organogenesis Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-orgs",
      code: "NYSE:ORGS",
      companyName: "Orgenesis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ori",
      code: "NYSE:ORI",
      companyName: "Old Republic International Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-oria",
      code: "NYSE:ORIA",
      companyName: "Orion Biotech Opportunities Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-oriau",
      code: "NYSE:ORIAU",
      companyName: "Orion Biotech Opportunities Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-oriaw",
      code: "NYSE:ORIAW",
      companyName: "Orion Biotech Opportunities Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-oric",
      code: "NYSE:ORIC",
      companyName: "Oric Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-orla",
      code: "NYSE:ORLA",
      companyName: "Orla Mining Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-orly",
      code: "NYSE:ORLY",
      companyName: "O'Reilly Automotive Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ormp",
      code: "NYSE:ORMP",
      companyName: "Oramed Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-orn",
      code: "NYSE:ORN",
      companyName: "Orion Group Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-orrf",
      code: "NYSE:ORRF",
      companyName: "Orrstown Financial Services Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ortx",
      code: "NYSE:ORTX",
      companyName: "Orchard Therapeutics plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-osbc",
      code: "NYSE:OSBC",
      companyName: "Old Second Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-oscr",
      code: "NYSE:OSCR",
      companyName: "Oscar Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-oscv",
      code: "NYSE:OSCV",
      companyName: "Opus Small Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-osg",
      code: "NYSE:OSG",
      companyName: "Overseas Shipholding Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-osh",
      code: "NYSE:OSH",
      companyName: "Oak Street Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-osi",
      code: "NYSE:OSI",
      companyName: "Osiris Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-osis",
      code: "NYSE:OSIS",
      companyName: "OSI Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-osk",
      code: "NYSE:OSK",
      companyName: "Oshkosh Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ospn",
      code: "NYSE:OSPN",
      companyName: "OneSpan Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oss",
      code: "NYSE:OSS",
      companyName: "One Stop Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ost",
      code: "NYSE:OST",
      companyName: "Ostin Technology Group Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ostk",
      code: "NYSE:OSTK",
      companyName: "Overstock.com Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ostr",
      code: "NYSE:OSTR",
      companyName: "Oyster Enterprises Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ostru",
      code: "NYSE:OSTRU",
      companyName: "Oyster Enterprises Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ostrw",
      code: "NYSE:OSTRW",
      companyName: "Oyster Enterprises Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-osur",
      code: "NYSE:OSUR",
      companyName: "OraSure Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-osw",
      code: "NYSE:OSW",
      companyName: "OneSpaWorld Holdings Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-otec",
      code: "NYSE:OTEC",
      companyName: "OceanTech Acquisitions I Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-otecu",
      code: "NYSE:OTECU",
      companyName: "OceanTech Acquisitions I Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-otecw",
      code: "NYSE:OTECW",
      companyName: "OceanTech Acquisitions I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-otex",
      code: "NYSE:OTEX",
      companyName: "Open Text Corp",
      popularity: 0,
    },
    {
      slug: "nyse-otic",
      code: "NYSE:OTIC",
      companyName: "Otonomy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-otlk",
      code: "NYSE:OTLK",
      companyName: "Outlook Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-otly",
      code: "NYSE:OTLY",
      companyName: "Oatly Group AB American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-otmo",
      code: "NYSE:OTMO",
      companyName: "Otonomo Technologies Ltd. Ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-otmow",
      code: "NYSE:OTMOW",
      companyName: "Otonomo Technologies Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-otrk",
      code: "NYSE:OTRK",
      companyName: "Ontrak Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-otrkp",
      code: "NYSE:OTRKP",
      companyName:
        "Ontrak Inc. 9.50% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ottr",
      code: "NYSE:OTTR",
      companyName: "Otter Tail Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ounz",
      code: "NYSE:OUNZ",
      companyName: "VanEck Merk Gold Trust",
      popularity: 0,
    },
    {
      slug: "nyse-ousa",
      code: "NYSE:OUSA",
      companyName: "ALPS  O'Shares U.S. Quality Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ousm",
      code: "NYSE:OUSM",
      companyName: "ALPS  O'Shares U.S. Small-Cap Quality Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-out",
      code: "NYSE:OUT",
      companyName: "OUTFRONT Media Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ovb",
      code: "NYSE:OVB",
      companyName: "Overlay Shares Core Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ovbc",
      code: "NYSE:OVBC",
      companyName: "Ohio Valley Banc Corp",
      popularity: 0,
    },
    {
      slug: "nyse-ovf",
      code: "NYSE:OVF",
      companyName: "Overlay Shares Foreign Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ovid",
      code: "NYSE:OVID",
      companyName: "Ovid Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ovl",
      code: "NYSE:OVL",
      companyName: "Overlay Shares Large Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ovlh",
      code: "NYSE:OVLH",
      companyName: "Overlay Shares Hedged Large Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ovly",
      code: "NYSE:OVLY",
      companyName: "Oak Valley Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-ovm",
      code: "NYSE:OVM",
      companyName: "Overlay Shares Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ovs",
      code: "NYSE:OVS",
      companyName: "Overlay Shares Small Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ovt",
      code: "NYSE:OVT",
      companyName: "Overlay Shares Short Term Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ovv",
      code: "NYSE:OVV",
      companyName: "Ovintiv Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-owl",
      code: "NYSE:OWL",
      companyName: "Blue Owl Capital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-owlt",
      code: "NYSE:OWLT",
      companyName: "Owlet Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-owns",
      code: "NYSE:OWNS",
      companyName: "Impact Shares Affordable Housing MBS ETF",
      popularity: 0,
    },
    {
      slug: "nyse-oxac",
      code: "NYSE:OXAC",
      companyName: "Oxbridge Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-oxacu",
      code: "NYSE:OXACU",
      companyName: "Oxbridge Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-oxacw",
      code: "NYSE:OXACW",
      companyName: "Oxbridge Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-oxbr",
      code: "NYSE:OXBR",
      companyName: "Oxbridge Re Holdings Limited",
      popularity: 0,
    },
    {
      slug: "nyse-oxbrw",
      code: "NYSE:OXBRW",
      companyName: "Oxbridge Re Holdings Limited Warrant expiring 3/26/2024",
      popularity: 0,
    },
    {
      slug: "nyse-oxlc",
      code: "NYSE:OXLC",
      companyName: "Oxford Lane Capital Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-oxlcl",
      code: "NYSE:OXLCL",
      companyName: "Oxford Lane Capital Corp. 6.75% Notes due 2031",
      popularity: 0,
    },
    {
      slug: "nyse-oxlcm",
      code: "NYSE:OXLCM",
      companyName:
        "Oxford Lane Capital Corp. 6.75% Series 2024 Term Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oxlcn",
      code: "NYSE:OXLCN",
      companyName:
        "Oxford Lane Capital Corp. 7.125% Series 2029 Term Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oxlco",
      code: "NYSE:OXLCO",
      companyName:
        "Oxford Lane Capital Corp. Preferred Stock Shares 6.00% Series 2029",
      popularity: 0,
    },
    {
      slug: "nyse-oxlcp",
      code: "NYSE:OXLCP",
      companyName:
        "Oxford Lane Capital Corp. 6.25% Series 2027 Term Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-oxlcz",
      code: "NYSE:OXLCZ",
      companyName: "Oxford Lane Capital Corp. 5.00% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nyse-oxm",
      code: "NYSE:OXM",
      companyName: "Oxford Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-oxsq",
      code: "NYSE:OXSQ",
      companyName: "Oxford Square Capital Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-oxsqg",
      code: "NYSE:OXSQG",
      companyName: "Oxford Square Capital Corp. 5.50% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-oxsql",
      code: "NYSE:OXSQL",
      companyName: "Oxford Square Capital Corp. 6.50% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nyse-oxsqz",
      code: "NYSE:OXSQZ",
      companyName: "Oxford Square Capital Corp. 6.25% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-oxus",
      code: "NYSE:OXUS",
      companyName: "Oxus Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-oxusu",
      code: "NYSE:OXUSU",
      companyName: "Oxus Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-oxusw",
      code: "NYSE:OXUSW",
      companyName: "Oxus Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-oyst",
      code: "NYSE:OYST",
      companyName: "Oyster Point Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-oz",
      code: "NYSE:OZ",
      companyName: "Belpointe PREP LLC Class A Units",
      popularity: 0,
    },
    {
      slug: "nyse-ozk",
      code: "NYSE:OZK",
      companyName: "Bank OZK",
      popularity: 0,
    },
    {
      slug: "nyse-ozkap",
      code: "NYSE:OZKAP",
      companyName:
        "Bank OZK 4.625% Series A Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ozon",
      code: "NYSE:OZON",
      companyName:
        "Ozon Holdings PLC American Depositary Shares each ADS representing one ordinary share",
      popularity: 0,
    },
    {
      slug: "nyse-paa",
      code: "NYSE:PAA",
      companyName:
        "Plains All American Pipeline L.P. Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nyse-paas",
      code: "NYSE:PAAS",
      companyName: "PAN American Silver Corp",
      popularity: 0,
    },
    {
      slug: "nyse-pab",
      code: "NYSE:PAB",
      companyName: "PGIM Active Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pabu",
      code: "NYSE:PABU",
      companyName: "iShares Paris-Aligned Climate MSCI USA ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pac",
      code: "NYSE:PAC",
      companyName:
        "Grupo Aeroportuario del Pacifico S.A.B. de C.V. Amer. Dep. Shares (each rep. 10 Ser. B shares)",
      popularity: 0,
    },
    {
      slug: "nyse-pacb",
      code: "NYSE:PACB",
      companyName: "Pacific Biosciences of California Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-paci",
      code: "NYSE:PACI",
      companyName: "PROOF Acquisition Corp I",
      popularity: 0,
    },
    {
      slug: "nyse-pack",
      code: "NYSE:PACK",
      companyName: "Ranpak Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-pacw",
      code: "NYSE:PACW",
      companyName: "PacWest Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-pacwp",
      code: "NYSE:PACWP",
      companyName:
        "PacWest Bancorp Depositary Shares Each Representing a 1/40th Interest in a Share of % Fixed Rate Non",
      popularity: 0,
    },
    {
      slug: "nyse-pacx",
      code: "NYSE:PACX",
      companyName: "Pioneer Merger Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-pacxu",
      code: "NYSE:PACXU",
      companyName: "Pioneer Merger Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pacxw",
      code: "NYSE:PACXW",
      companyName: "Pioneer Merger Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pafo",
      code: "NYSE:PAFO",
      companyName: "Pacifico Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pafor",
      code: "NYSE:PAFOR",
      companyName: "Pacifico Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-pafou",
      code: "NYSE:PAFOU",
      companyName: "Pacifico Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-pag",
      code: "NYSE:PAG",
      companyName: "Penske Automotive Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pagp",
      code: "NYSE:PAGP",
      companyName:
        "Plains GP Holdings L.P. Class A Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nyse-pags",
      code: "NYSE:PAGS",
      companyName: "PagSeguro Digital Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-pahc",
      code: "NYSE:PAHC",
      companyName: "Phibro Animal Health Corporation Class A",
      popularity: 0,
    },
    {
      slug: "nyse-pai",
      code: "NYSE:PAI",
      companyName: "Western Asset Investment Grade Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-palc",
      code: "NYSE:PALC",
      companyName: "Pacer Lunt Large Cap Multi-Factor Alternator ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pali",
      code: "NYSE:PALI",
      companyName: "Palisade Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pall",
      code: "NYSE:PALL",
      companyName: "abrdn Physical Palladium Shares ETF",
      popularity: 0,
    },
    {
      slug: "nyse-palt",
      code: "NYSE:PALT",
      companyName: "Paltalk Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pam",
      code: "NYSE:PAM",
      companyName: "PAMPA ENERGIA S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-pamc",
      code: "NYSE:PAMC",
      companyName: "Pacer Lunt MidCap Multi-Factor Alternator ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pana",
      code: "NYSE:PANA",
      companyName: "Panacea Acquisition Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-panl",
      code: "NYSE:PANL",
      companyName: "Pangaea Logistics Solutions Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-papr",
      code: "NYSE:PAPR",
      companyName: "Innovator U.S. Equity Power Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-paqc",
      code: "NYSE:PAQC",
      companyName: "Provident Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-paqcu",
      code: "NYSE:PAQCU",
      companyName: "Provident Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-paqcw",
      code: "NYSE:PAQCW",
      companyName: "Provident Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-par",
      code: "NYSE:PAR",
      companyName: "PAR Technology Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-para",
      code: "NYSE:PARA",
      companyName: "Paramount Global Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-paraa",
      code: "NYSE:PARAA",
      companyName: "Paramount Global Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-parap",
      code: "NYSE:PARAP",
      companyName:
        "Paramount Global 5.75% Series A Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-parr",
      code: "NYSE:PARR",
      companyName: "Par Pacific Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pasg",
      code: "NYSE:PASG",
      companyName: "Passage Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pati",
      code: "NYSE:PATI",
      companyName: "Patriot Transportation Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-patk",
      code: "NYSE:PATK",
      companyName: "Patrick Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-paug",
      code: "NYSE:PAUG",
      companyName: "Innovator U.S. Equity Power Buffer ETF - August",
      popularity: 0,
    },
    {
      slug: "nyse-pave",
      code: "NYSE:PAVE",
      companyName: "Global X U.S. Infrastructure Development ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pavm",
      code: "NYSE:PAVM",
      companyName: "PAVmed Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pavmz",
      code: "NYSE:PAVMZ",
      companyName: "PAVmed Inc. Series Z Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pawz",
      code: "NYSE:PAWZ",
      companyName: "ProShares Pet Care ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pax",
      code: "NYSE:PAX",
      companyName: "Patria Investments Limited Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-paxs",
      code: "NYSE:PAXS",
      companyName: "PIMCO Access Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-pay",
      code: "NYSE:PAY",
      companyName: "Paymentus Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-paya",
      code: "NYSE:PAYA",
      companyName: "Paya Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-payc",
      code: "NYSE:PAYC",
      companyName: "PAYCOM SOFTWARE INC.",
      popularity: 0,
    },
    {
      slug: "nyse-payo",
      code: "NYSE:PAYO",
      companyName: "Payoneer Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-payow",
      code: "NYSE:PAYOW",
      companyName: "Payoneer Global Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pays",
      code: "NYSE:PAYS",
      companyName: "Paysign Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-payx",
      code: "NYSE:PAYX",
      companyName: "Paychex Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pb",
      code: "NYSE:PB",
      companyName: "Prosperity Bancshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pba",
      code: "NYSE:PBA",
      companyName: "PEMBINA PIPELINE CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-pbax",
      code: "NYSE:PBAX",
      companyName: "Phoenix Biotech Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pbaxu",
      code: "NYSE:PBAXU",
      companyName: "Phoenix Biotech Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pbaxw",
      code: "NYSE:PBAXW",
      companyName: "Phoenix Biotech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-pbbk",
      code: "NYSE:PBBK",
      companyName: "PB Bankshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pbd",
      code: "NYSE:PBD",
      companyName: "Invesco Global Clean Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbdm",
      code: "NYSE:PBDM",
      companyName: "Invesco PureBeta FTSE Developed ex-North America ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbe",
      code: "NYSE:PBE",
      companyName: "Invesco Dynamic Biotechnology & Genome ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbee",
      code: "NYSE:PBEE",
      companyName: "Invesco PureBeta FTSE Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbf",
      code: "NYSE:PBF",
      companyName: "PBF ENERGY INC.",
      popularity: 0,
    },
    {
      slug: "nyse-pbfs",
      code: "NYSE:PBFS",
      companyName: "Pioneer Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pbfx",
      code: "NYSE:PBFX",
      companyName: "PBF LOGISTICS LP",
      popularity: 0,
    },
    {
      slug: "nyse-pbhc",
      code: "NYSE:PBHC",
      companyName: "Pathfinder Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pbi",
      code: "NYSE:PBI",
      companyName: "Pitney Bowes Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pbi-b",
      code: "NYSE:PBI-B",
      companyName: "PITNEY BOWES INC .6.70% Notes Due 2043",
      popularity: 0,
    },
    {
      slug: "nyse-pbj",
      code: "NYSE:PBJ",
      companyName: "Invesco Dynamic Food & Beverage ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbla",
      code: "NYSE:PBLA",
      companyName: "Panbela Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pbnd",
      code: "NYSE:PBND",
      companyName: "Invesco PureBeta US Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbp",
      code: "NYSE:PBP",
      companyName: "Invesco S&P 500 BuyWrite ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbpb",
      code: "NYSE:PBPB",
      companyName: "Potbelly Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pbr",
      code: "NYSE:PBR",
      companyName:
        "PETROLEO BRASILEIRO S.A.-PETROBRAS ADS (REP 1 COMMON SHARE)",
      popularity: 0,
    },
    {
      slug: "nyse-pbs",
      code: "NYSE:PBS",
      companyName: "Invesco Dynamic Media ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbsm",
      code: "NYSE:PBSM",
      companyName: "Invesco PureBeta MSCI USA Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbt",
      code: "NYSE:PBT",
      companyName: "Permian Basin Royalty Trust",
      popularity: 0,
    },
    {
      slug: "nyse-pbtp",
      code: "NYSE:PBTP",
      companyName: "Invesco PureBeta 0-5 Yr US TIPS ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbts",
      code: "NYSE:PBTS",
      companyName: "Powerbridge Technologies Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pbug",
      code: "NYSE:PBUG",
      companyName: "Pacer iPath Gold Trendpilot Exchange-Traded Notes",
      popularity: 0,
    },
    {
      slug: "nyse-pbus",
      code: "NYSE:PBUS",
      companyName: "Invesco PureBeta MSCI USA ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbw",
      code: "NYSE:PBW",
      companyName: "Invesco WilderHill Clean Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pbyi",
      code: "NYSE:PBYI",
      companyName: "PUMA BIOTECHNOLOGY INC",
      popularity: 0,
    },
    {
      slug: "nyse-pcar",
      code: "NYSE:PCAR",
      companyName: "Paccar Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pcb",
      code: "NYSE:PCB",
      companyName: "PCB Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pcct",
      code: "NYSE:PCCT",
      companyName: "Perception Capital Corp. II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pcctu",
      code: "NYSE:PCCTU",
      companyName: "Perception Capital Corp. II Units",
      popularity: 0,
    },
    {
      slug: "nyse-pcctw",
      code: "NYSE:PCCTW",
      companyName: "Perception Capital Corp. II Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-pcef",
      code: "NYSE:PCEF",
      companyName: "Invesco CEF Income Composite ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pcf",
      code: "NYSE:PCF",
      companyName: "High Income Securities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-pcg-a",
      code: "NYSE:PCG-A",
      companyName: "Pacific Gas and Electric Company 6% 1st Pfd.",
      popularity: 0,
    },
    {
      slug: "nyse-pcg-b",
      code: "NYSE:PCG-B",
      companyName: "Pacific Gas and Electric Company 5 1/2% 1st Pfd.",
      popularity: 0,
    },
    {
      slug: "nyse-pcg-c",
      code: "NYSE:PCG-C",
      companyName: "Pacific Gas and Electric Company 5% 1st Pfd.",
      popularity: 0,
    },
    {
      slug: "nyse-pcg-d",
      code: "NYSE:PCG-D",
      companyName: "Pacific Gas and Electric Company 5% Red. 1st Pfd.",
      popularity: 0,
    },
    {
      slug: "nyse-pcg-e",
      code: "NYSE:PCG-E",
      companyName: "Pacific Gas and Electric Company 5% Red. 1st Pfd.A",
      popularity: 0,
    },
    {
      slug: "nyse-pcg-g",
      code: "NYSE:PCG-G",
      companyName: "Pacific Gas and Electric Company 4.80% Red. 1st Pfd.",
      popularity: 0,
    },
    {
      slug: "nyse-pcg-h",
      code: "NYSE:PCG-H",
      companyName: "Pacific Gas and Electric Company 4.50% Red. 1st Pfd.",
      popularity: 0,
    },
    {
      slug: "nyse-pcg-i",
      code: "NYSE:PCG-I",
      companyName: "Pacific Gas & Electric Company 4.36% Red 1st Pfd",
      popularity: 0,
    },
    {
      slug: "nyse-pcgu",
      code: "NYSE:PCGU",
      companyName: "PG&E Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pch",
      code: "NYSE:PCH",
      companyName: "PotlatchDeltic Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pck",
      code: "NYSE:PCK",
      companyName:
        "PIMCO CALIFORNIA MUNICIPAL INCOME FUND II COMMON SHARES OF BENEFICIAL INT.",
      popularity: 0,
    },
    {
      slug: "nyse-pcm",
      code: "NYSE:PCM",
      companyName: "PCM Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pcn",
      code: "NYSE:PCN",
      companyName: "PIMCO Corporate & Income Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-pcor",
      code: "NYSE:PCOR",
      companyName: "Procore Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pcpc",
      code: "NYSE:PCPC",
      companyName: "Periphas Capital Partnering Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pcq",
      code: "NYSE:PCQ",
      companyName: "Pimco California Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-pcrx",
      code: "NYSE:PCRX",
      companyName: "Pacira BioSciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pcsa",
      code: "NYSE:PCSA",
      companyName: "Processa Pharmaceuticals Inc. Common",
      popularity: 0,
    },
    {
      slug: "nyse-pcsb",
      code: "NYSE:PCSB",
      companyName: "PCSB Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pct",
      code: "NYSE:PCT",
      companyName: "PureCycle Technologies Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-pcti",
      code: "NYSE:PCTI",
      companyName: "PCTEL Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pcttu",
      code: "NYSE:PCTTU",
      companyName: "PureCycle Technologies Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pcttw",
      code: "NYSE:PCTTW",
      companyName: "PureCycle Technologies Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pcty",
      code: "NYSE:PCTY",
      companyName: "Paylocity Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pcvx",
      code: "NYSE:PCVX",
      companyName: "Vaxcyte Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pcx",
      code: "NYSE:PCX",
      companyName: "Parsec Capital Acquisitions Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pcxcu",
      code: "NYSE:PCXCU",
      companyName: "Parsec Capital Acquisitions Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pcxcw",
      code: "NYSE:PCXCW",
      companyName: "Parsec Capital Acquisitions Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pcy",
      code: "NYSE:PCY",
      companyName: "Invesco Emerging Markets Sovereign Debt ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pcyg",
      code: "NYSE:PCYG",
      companyName: "Park City Group Inc. new",
      popularity: 0,
    },
    {
      slug: "nyse-pcyo",
      code: "NYSE:PCYO",
      companyName: "Pure Cycle Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pd",
      code: "NYSE:PD",
      companyName: "PagerDuty Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pdbc",
      code: "NYSE:PDBC",
      companyName:
        "Invesco Actively Managed Exch-Traded Commodity Fd Tr Invesco Optimum Yield Diversified Commodity Str",
      popularity: 0,
    },
    {
      slug: "nyse-pdce",
      code: "NYSE:PDCE",
      companyName: "PDC Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pdco",
      code: "NYSE:PDCO",
      companyName: "Patterson Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pdd",
      code: "NYSE:PDD",
      companyName: "Pinduoduo Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pdec",
      code: "NYSE:PDEC",
      companyName: "Innovator U.S. Equity Power Buffer ETF - December",
      popularity: 0,
    },
    {
      slug: "nyse-pdex",
      code: "NYSE:PDEX",
      companyName: "Pro-Dex Inc New",
      popularity: 0,
    },
    {
      slug: "nyse-pdfs",
      code: "NYSE:PDFS",
      companyName: "PDF Solutions Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pdlb",
      code: "NYSE:PDLB",
      companyName: "Ponce Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pdm",
      code: "NYSE:PDM",
      companyName: "Piedmont Office Realty Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pdn",
      code: "NYSE:PDN",
      companyName: "Invesco FTSE RAFI Developed Markets ex-U.S. Small-Mid ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pdo",
      code: "NYSE:PDO",
      companyName: "PIMCO Dynamic Income Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-pdot",
      code: "NYSE:PDOT",
      companyName: "Peridot Acquisition Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-pdp",
      code: "NYSE:PDP",
      companyName: "Invesco DWA Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pds",
      code: "NYSE:PDS",
      companyName: "Precision Drilling Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pdsb",
      code: "NYSE:PDSB",
      companyName: "PDS Biotechnology Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pdt",
      code: "NYSE:PDT",
      companyName: "John Hancock Premium Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-peak",
      code: "NYSE:PEAK",
      companyName: "Healthpeak Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pear",
      code: "NYSE:PEAR",
      companyName: "Pear Therapeutics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pearw",
      code: "NYSE:PEARW",
      companyName: "Pear Therapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-peb",
      code: "NYSE:PEB",
      companyName: "Pebblebrook Hotel Trust",
      popularity: 0,
    },
    {
      slug: "nyse-peb-f",
      code: "NYSE:PEB-F",
      companyName:
        "Pebblebrook Hotel Trust 6.3% Series F Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-peb-g",
      code: "NYSE:PEB-G",
      companyName:
        "Pebblebrook Hotel Trust 6.375% Series G Cumulative Redeemable Preferred Shares of Beneficial Interes",
      popularity: 0,
    },
    {
      slug: "nyse-peb-h",
      code: "NYSE:PEB-H",
      companyName:
        "Pebblebrook Hotel Trust 5.700% Series H Cumulative Redeemable Preferred Shares of Beneficial Interes",
      popularity: 0,
    },
    {
      slug: "nyse-pebk",
      code: "NYSE:PEBK",
      companyName: "Peoples Bancorp of North Carol",
      popularity: 0,
    },
    {
      slug: "nyse-pebo",
      code: "NYSE:PEBO",
      companyName: "Peoples Bancorp Inc/OH",
      popularity: 0,
    },
    {
      slug: "nyse-peco",
      code: "NYSE:PECO",
      companyName: "Phillips Edison & Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ped",
      code: "NYSE:PED",
      companyName: "PEDEVCO Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-peg",
      code: "NYSE:PEG",
      companyName: "Public Service Enterprise Group Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-pega",
      code: "NYSE:PEGA",
      companyName: "Pegasystems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pegr",
      code: "NYSE:PEGR",
      companyName:
        "Project Energy Reimagined Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-pegru",
      code: "NYSE:PEGRU",
      companyName: "Project Energy Reimagined Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pegrw",
      code: "NYSE:PEGRW",
      companyName: "Project Energy Reimagined Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pegy",
      code: "NYSE:PEGY",
      companyName: "Pineapple Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pei",
      code: "NYSE:PEI",
      companyName: "Pennsylvania Real Estate Investment Trust",
      popularity: 0,
    },
    {
      slug: "nyse-pei-b",
      code: "NYSE:PEI-B",
      companyName:
        "PENNSYLVANIA REAL ESTATE INVESTMENT TRUST 7.375% Series B Cumulative Redeemable Perpetual Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-pei-c",
      code: "NYSE:PEI-C",
      companyName:
        "Pennsylvania Real Estate Investment Trust 7.20% Series C Cumulative Redeemable Perpetual Preferred S",
      popularity: 0,
    },
    {
      slug: "nyse-pei-d",
      code: "NYSE:PEI-D",
      companyName:
        "Pennsylvania Real Estate Investment Trust 6.875% Series D Cumulative Redeemable Perpetual Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-pej",
      code: "NYSE:PEJ",
      companyName: "Invesco Dynamic Leisure and Entertainment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pen",
      code: "NYSE:PEN",
      companyName: "Penumbra Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-penn",
      code: "NYSE:PENN",
      companyName: "PENN Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-peo",
      code: "NYSE:PEO",
      companyName: "Adams Natural Resources Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pfix",
      code: "NYSE:PFIX",
      companyName: "Simplify Interest Rate Hedge ETF",
      popularity: 0,
    },
    {
      slug: "nyse-peri",
      code: "NYSE:PERI",
      companyName: "Perion Network Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-pepg",
      code: "NYSE:PEPG",
      companyName: "PepGen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pepl",
      code: "NYSE:PEPL",
      companyName:
        "PepperLime Health Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-peplu",
      code: "NYSE:PEPLU",
      companyName: "PepperLime Health Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-peplw",
      code: "NYSE:PEPLW",
      companyName: "PepperLime Health Acquisition Corporation Warrrant",
      popularity: 0,
    },
    {
      slug: "nyse-pesi",
      code: "NYSE:PESI",
      companyName: "Perma-Fix Environmental Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pet",
      code: "NYSE:PET",
      companyName: "Wag! Group Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-petq",
      code: "NYSE:PETQ",
      companyName: "PetIQ Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pets",
      code: "NYSE:PETS",
      companyName: "PetMed Express Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-petv",
      code: "NYSE:PETV",
      companyName: "PetVivo Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-petvw",
      code: "NYSE:PETVW",
      companyName: "PetVivo Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-petww",
      code: "NYSE:PETWW",
      companyName: "Wag! Group Co Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-petz",
      code: "NYSE:PETZ",
      companyName: "TDH Holdings Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pev",
      code: "NYSE:PEV",
      companyName: "Phoenix Motor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pex",
      code: "NYSE:PEX",
      companyName: "ProShares Global Listed Private Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pexl",
      code: "NYSE:PEXL",
      companyName: "Pacer US Export Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pey",
      code: "NYSE:PEY",
      companyName: "Invesco High Yield Equity Dividend Achievers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pez",
      code: "NYSE:PEZ",
      companyName: "Invesco DWA Consumer Cyclicals Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pfbc",
      code: "NYSE:PFBC",
      companyName: "Preferred Bank",
      popularity: 0,
    },
    {
      slug: "nyse-pfc",
      code: "NYSE:PFC",
      companyName: "Premier Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pfd",
      code: "NYSE:PFD",
      companyName: "Flaherty & Crumrine Preferred and Income Fund Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-pfdr",
      code: "NYSE:PFDR",
      companyName: "Pathfinder Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pfdru",
      code: "NYSE:PFDRU",
      companyName: "Pathfinder Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pfdrw",
      code: "NYSE:PFDRW",
      companyName: "Pathfinder Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pfeb",
      code: "NYSE:PFEB",
      companyName: "Innovator U.S. Equity Power Buffer ETF - February",
      popularity: 0,
    },
    {
      slug: "nyse-pfel",
      code: "NYSE:PFEL",
      companyName: "AXS 2X PFE Bull Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pfes",
      code: "NYSE:PFES",
      companyName: "AXS 2X PFE Bear Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pff",
      code: "NYSE:PFF",
      companyName: "iShares Trust iShares Preferred and Income Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pffa",
      code: "NYSE:PFFA",
      companyName: "Virtus InfraCap U.S. Preferred Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pffl",
      code: "NYSE:PFFL",
      companyName: "ETRACS Monthly Pay 2xLeveraged Preferred Stock ETN",
      popularity: 0,
    },
    {
      slug: "nyse-pffr",
      code: "NYSE:PFFR",
      companyName: "InfraCap REIT Preferred ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pfg",
      code: "NYSE:PFG",
      companyName: "Principal Financial Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pfgc",
      code: "NYSE:PFGC",
      companyName: "Performance Food Group Company",
      popularity: 0,
    },
    {
      slug: "nyse-pfh",
      code: "NYSE:PFH",
      companyName:
        "Prudential Financial Inc. 4.125% Junior Subordinated Notes due 2060",
      popularity: 0,
    },
    {
      slug: "nyse-pfhc",
      code: "NYSE:PFHC",
      companyName: "ProFrac Holding Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pfhd",
      code: "NYSE:PFHD",
      companyName: "Professional Holding Corp. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-pfig",
      code: "NYSE:PFIG",
      companyName: "Invesco Fundamental Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pfin",
      code: "NYSE:PFIN",
      companyName: "P&F Industries",
      popularity: 0,
    },
    {
      slug: "nyse-pfis",
      code: "NYSE:PFIS",
      companyName: "Peoples Financial Services Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-pfl",
      code: "NYSE:PFL",
      companyName: "PIMCO Income Strategy  Fund",
      popularity: 0,
    },
    {
      slug: "nyse-pfld",
      code: "NYSE:PFLD",
      companyName: "AAM Low Duration Preferred and Income Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pflt",
      code: "NYSE:PFLT",
      companyName: "PennantPark Floating Rate Capital Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-pfm",
      code: "NYSE:PFM",
      companyName: "Invesco Dividend Achievers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pfmt",
      code: "NYSE:PFMT",
      companyName: "Performant Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pfn",
      code: "NYSE:PFN",
      companyName: "PIMCO Income Strategy Fund II",
      popularity: 0,
    },
    {
      slug: "nyse-pfo",
      code: "NYSE:PFO",
      companyName:
        "Flaherty & Crumrine Preferred and Income Opportunity Fund Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-pfrl",
      code: "NYSE:PFRL",
      companyName: "PGIM Floating Rate Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pfs",
      code: "NYSE:PFS",
      companyName: "Provident Financial Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pfsi",
      code: "NYSE:PFSI",
      companyName: "PennyMac Financial Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pfsw",
      code: "NYSE:PFSW",
      companyName: "PFSweb Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pfta",
      code: "NYSE:PFTA",
      companyName:
        "Portage Fintech Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-pftau",
      code: "NYSE:PFTAU",
      companyName: "Portage Fintech Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pftaw",
      code: "NYSE:PFTAW",
      companyName: "Portage Fintech Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pfut",
      code: "NYSE:PFUT",
      companyName: "Putnam Sustainable Future ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pfx",
      code: "NYSE:PFX",
      companyName: "PhenixFIN Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pfxf",
      code: "NYSE:PFXF",
      companyName: "VanEck Preferred Securities ex Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pfxnl",
      code: "NYSE:PFXNL",
      companyName: "PhenixFIN Corporation 6.125% Senior Notes due 2023",
      popularity: 0,
    },
    {
      slug: "nyse-pfxnz",
      code: "NYSE:PFXNZ",
      companyName: "PhenixFIN Corporation 5.25% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-pgal",
      code: "NYSE:PGAL",
      companyName: "Global X MSCI Portugal ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pffv",
      code: "NYSE:PFFV",
      companyName: "Global X Variable Rate Preferred ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pffd",
      code: "NYSE:PFFD",
      companyName: "Global X U.S. Preferred ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pgc",
      code: "NYSE:PGC",
      companyName: "Peapack-Gladstone Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-pgen",
      code: "NYSE:PGEN",
      companyName: "Precigen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pgf",
      code: "NYSE:PGF",
      companyName: "Invesco Financial Preferred ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pghy",
      code: "NYSE:PGHY",
      companyName: "Invesco Global Short Term High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pgj",
      code: "NYSE:PGJ",
      companyName: "Invesco Golden Dragon China ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pgm",
      code: "NYSE:PGM",
      companyName:
        "iPath Series B Bloomberg Platinum Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-pgny",
      code: "NYSE:PGNY",
      companyName: "Progyny Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pgp",
      code: "NYSE:PGP",
      companyName: "PIMCO Global StockPLUS & Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-pgre",
      code: "NYSE:PGRE",
      companyName: "PARAMOUNT GROUP INC.",
      popularity: 0,
    },
    {
      slug: "nyse-pgro",
      code: "NYSE:PGRO",
      companyName: "Putnam Focused Large Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pgru",
      code: "NYSE:PGRU",
      companyName: "PropertyGuru Group Limited",
      popularity: 0,
    },
    {
      slug: "nyse-pgrw",
      code: "NYSE:PGRW",
      companyName: "Progress Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pgrwu",
      code: "NYSE:PGRWU",
      companyName: "Progress Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-pgrww",
      code: "NYSE:PGRWW",
      companyName: "Progress Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pgss",
      code: "NYSE:PGSS",
      companyName: "Pegasus Digital Mobility Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-pgti",
      code: "NYSE:PGTI",
      companyName: "PGT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pgx",
      code: "NYSE:PGX",
      companyName: "Invesco Preferred ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pgy",
      code: "NYSE:PGY",
      companyName: "Pagaya Technologies Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pgyww",
      code: "NYSE:PGYWW",
      companyName: "Pagaya Technologies Ltd. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-pgz",
      code: "NYSE:PGZ",
      companyName: "PRINCIPAL REAL ESTATE INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-ph",
      code: "NYSE:PH",
      companyName: "Parker-Hannifin Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-phar",
      code: "NYSE:PHAR",
      companyName:
        "Pharming Group N.V. ADS each representing 10 ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-phas",
      code: "NYSE:PHAS",
      companyName: "PhaseBio Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-phb",
      code: "NYSE:PHB",
      companyName: "Invesco Fundamental High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-phcf",
      code: "NYSE:PHCF",
      companyName: "Puhui Wealth Investment Management Co. Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-phd",
      code: "NYSE:PHD",
      companyName: "Pioneer Floating Rate Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-phdg",
      code: "NYSE:PHDG",
      companyName: "Invesco S&P 500 Downside Hedged ETF",
      popularity: 0,
    },
    {
      slug: "nyse-phge",
      code: "NYSE:PHGE",
      companyName: "BiomX Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-phi",
      code: "NYSE:PHI",
      companyName: "PLDT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-phic",
      code: "NYSE:PHIC",
      companyName:
        "Population Health Investment Co. Inc. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-phicu",
      code: "NYSE:PHICU",
      companyName: "Population Health Investment Co. Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-phicw",
      code: "NYSE:PHICW",
      companyName: "Population Health Investment Co. Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-phio",
      code: "NYSE:PHIO",
      companyName: "Phio Pharmaceuticals Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-phk",
      code: "NYSE:PHK",
      companyName: "PIMCO High Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-phm",
      code: "NYSE:PHM",
      companyName: "Pultegroup Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pho",
      code: "NYSE:PHO",
      companyName: "Invesco Water Resources ETF",
      popularity: 0,
    },
    {
      slug: "nyse-phun",
      code: "NYSE:PHUN",
      companyName: "Phunware Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-phunw",
      code: "NYSE:PHUNW",
      companyName: "Phunware Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-phvs",
      code: "NYSE:PHVS",
      companyName: "Pharvaris N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-phyl",
      code: "NYSE:PHYL",
      companyName: "PGIM Active High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-phys",
      code: "NYSE:PHYS",
      companyName: "Sprott Physical Gold Trust",
      popularity: 0,
    },
    {
      slug: "nyse-phyt",
      code: "NYSE:PHYT",
      companyName: "Pyrophyte Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-pi",
      code: "NYSE:PI",
      companyName: "Impinj Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-piai",
      code: "NYSE:PIAI",
      companyName: "Prime Impact Acquisition I",
      popularity: 0,
    },
    {
      slug: "nyse-picb",
      code: "NYSE:PICB",
      companyName: "Invesco International Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-picc",
      code: "NYSE:PICC",
      companyName: "Pivotal Investment Corporation III",
      popularity: 0,
    },
    {
      slug: "nyse-pick",
      code: "NYSE:PICK",
      companyName: "iShares MSCI Global Metals & Mining Producers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pid",
      code: "NYSE:PID",
      companyName: "Invesco International Dividend Achievers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pie",
      code: "NYSE:PIE",
      companyName: "Invesco DWA Emerging Markets Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pifi",
      code: "NYSE:PIFI",
      companyName: "ClearShares Piton Intermediate Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-piii",
      code: "NYSE:PIII",
      companyName: "P3 Health Partners Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-piiiw",
      code: "NYSE:PIIIW",
      companyName: "P3 Health Partners Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pik",
      code: "NYSE:PIK",
      companyName: "Kidpik Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pill",
      code: "NYSE:PILL",
      companyName: "Direxion Daily Pharmaceutical & Medical Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pim",
      code: "NYSE:PIM",
      companyName: "Putnam Master Intermediate Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-pin",
      code: "NYSE:PIN",
      companyName: "Invesco India ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pinc",
      code: "NYSE:PINC",
      companyName: "Premier Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-pine",
      code: "NYSE:PINE",
      companyName: "Alpine Income Property Trust Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ping",
      code: "NYSE:PING",
      companyName: "Ping Identity Holding Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-pink",
      code: "NYSE:PINK",
      companyName: "Simplify Health Care ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pins",
      code: "NYSE:PINS",
      companyName: "Pinterest Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pio",
      code: "NYSE:PIO",
      companyName: "Invesco Global Water ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pipp",
      code: "NYSE:PIPP",
      companyName: "Pine Island Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-pipr",
      code: "NYSE:PIPR",
      companyName: "Piper Sandler Companies",
      popularity: 0,
    },
    {
      slug: "nyse-pirs",
      code: "NYSE:PIRS",
      companyName: "PIERIS PHARMACEUTICALS INC",
      popularity: 0,
    },
    {
      slug: "nyse-pixy",
      code: "NYSE:PIXY",
      companyName: "ShiftPixy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-plym",
      code: "NYSE:PLYM",
      companyName: "Plymouth Industrial REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-piz",
      code: "NYSE:PIZ",
      companyName: "Invesco DWA Developed Markets Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pjan",
      code: "NYSE:PJAN",
      companyName: "Innovator U.S. Equity Power Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-pjp",
      code: "NYSE:PJP",
      companyName: "Invesco Dynamic Pharmaceuticals ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pjt",
      code: "NYSE:PJT",
      companyName: "PJT Partners Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pjul",
      code: "NYSE:PJUL",
      companyName: "Innovator U.S. Equity Power Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-pjun",
      code: "NYSE:PJUN",
      companyName: "Innovator U.S. Equity Power Buffer ETF - June",
      popularity: 0,
    },
    {
      slug: "nyse-pk",
      code: "NYSE:PK",
      companyName: "Park Hotels & Resorts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pkb",
      code: "NYSE:PKB",
      companyName: "Invesco Dynamic Building & Construction ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pkbk",
      code: "NYSE:PKBK",
      companyName: "Parke Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pke",
      code: "NYSE:PKE",
      companyName: "Park Aerospace Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pkg",
      code: "NYSE:PKG",
      companyName: "Packaging Corp of America",
      popularity: 0,
    },
    {
      slug: "nyse-pki",
      code: "NYSE:PKI",
      companyName: "PerkinElmer Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pkoh",
      code: "NYSE:PKOH",
      companyName: "Park-Ohio Holdings Corp",
      popularity: 0,
    },
    {
      slug: "nyse-pkw",
      code: "NYSE:PKW",
      companyName: "Invesco BuyBack Achievers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pkx",
      code: "NYSE:PKX",
      companyName:
        "POSCO Holdings Inc. American Depositary Shares (Each representing 1/4th of a share of Common Stock)",
      popularity: 0,
    },
    {
      slug: "nyse-pl",
      code: "NYSE:PL",
      companyName: "Planet Labs PBC",
      popularity: 0,
    },
    {
      slug: "nyse-plab",
      code: "NYSE:PLAB",
      companyName: "Photronics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-plag",
      code: "NYSE:PLAG",
      companyName: "Planet Green Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-plao",
      code: "NYSE:PLAO",
      companyName:
        "Patria Latin American Opportunity Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-plaou",
      code: "NYSE:PLAOU",
      companyName: "Patria Latin American Opportunity Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-plaow",
      code: "NYSE:PLAOW",
      companyName:
        "Patria Latin American Opportunity Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-plat",
      code: "NYSE:PLAT",
      companyName: "WisdomTree Growth Leaders Fund",
      popularity: 0,
    },
    {
      slug: "nyse-play",
      code: "NYSE:PLAY",
      companyName: "Dave & Buster's Entertainment Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-plbc",
      code: "NYSE:PLBC",
      companyName: "Plumas Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-plby",
      code: "NYSE:PLBY",
      companyName: "PLBY Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-plce",
      code: "NYSE:PLCE",
      companyName: "Children's Place Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pldr",
      code: "NYSE:PLDR",
      companyName: "Putnam Sustainable Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-plg",
      code: "NYSE:PLG",
      companyName: "Platinum Group Metals LTD.",
      popularity: 0,
    },
    {
      slug: "nyse-plm",
      code: "NYSE:PLM",
      companyName: "PolyMet Mining Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-plmi",
      code: "NYSE:PLMI",
      companyName: "Plum Acquisition Corp. I Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-plmiu",
      code: "NYSE:PLMIU",
      companyName: "Plum Acquisition Corp. I Units",
      popularity: 0,
    },
    {
      slug: "nyse-plmiw",
      code: "NYSE:PLMIW",
      companyName: "Plum Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-plmr",
      code: "NYSE:PLMR",
      companyName: "Palomar Holdings Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-plnt",
      code: "NYSE:PLNT",
      companyName: "Planet Fitness Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-plrg",
      code: "NYSE:PLRG",
      companyName: "Principal U.S. Large-Cap Adaptive Multi-Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pltk",
      code: "NYSE:PLTK",
      companyName: "Playtika Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pltl",
      code: "NYSE:PLTL",
      companyName: "Principal U.S. Small-Cap Adaptive Multi-Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pltm",
      code: "NYSE:PLTM",
      companyName: "GraniteShares Platinum Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pmd",
      code: "NYSE:PMD",
      companyName: "Psychemedics Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-plug",
      code: "NYSE:PLUG",
      companyName: "Plug Power Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-plur",
      code: "NYSE:PLUR",
      companyName: "Pluri Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-plus",
      code: "NYSE:PLUS",
      companyName: "ePlus Inc",
      popularity: 0,
    },
    {
      slug: "nyse-plw",
      code: "NYSE:PLW",
      companyName: "Invesco 1-30 Laddered Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-plx",
      code: "NYSE:PLX",
      companyName: "Protalix BioTherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-plxp",
      code: "NYSE:PLXP",
      companyName: "PLx Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-plxs",
      code: "NYSE:PLXS",
      companyName: "Plexus Corp",
      popularity: 0,
    },
    {
      slug: "nyse-plya",
      code: "NYSE:PLYA",
      companyName: "Playa Hotels & Resorts N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-plym-a",
      code: "NYSE:PLYM-A",
      companyName:
        "Plymouth Industrial REIT Inc. 7.50 percent Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-plse",
      code: "NYSE:PLSE",
      companyName: "Pulse Biosciences Inc Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-pmar",
      code: "NYSE:PMAR",
      companyName: "Innovator U.S. Equity Power Buffer ETF - March",
      popularity: 0,
    },
    {
      slug: "nyse-pmay",
      code: "NYSE:PMAY",
      companyName: "Innovator U.S. Equity Power Buffer ETF - May",
      popularity: 0,
    },
    {
      slug: "nyse-pmcb",
      code: "NYSE:PMCB",
      companyName: "PharmaCyte Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pme",
      code: "NYSE:PME",
      companyName: "Pingtan Marine Enterprise Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-pmf",
      code: "NYSE:PMF",
      companyName:
        "PIMCO MUNICIPAL INCOME FUND COMMON SHARES OF BENEFICIAL INTERST",
      popularity: 0,
    },
    {
      slug: "nyse-pmgm",
      code: "NYSE:PMGM",
      companyName: "Priveterra Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pmgmu",
      code: "NYSE:PMGMU",
      companyName: "Priveterra Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-pmgmw",
      code: "NYSE:PMGMW",
      companyName: "Priveterra Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pml",
      code: "NYSE:PML",
      companyName:
        "PIMCO MUNICIPAL INCOME FUND II COMMON SHARES OF BENEFICIAL INT.",
      popularity: 0,
    },
    {
      slug: "nyse-pmm",
      code: "NYSE:PMM",
      companyName: "Putnam Managed Municipal Income",
      popularity: 0,
    },
    {
      slug: "nyse-pmn",
      code: "NYSE:PMN",
      companyName: "ProMIS Neurosciences Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pmo",
      code: "NYSE:PMO",
      companyName: "Putnam Municipal Opportunities Trust",
      popularity: 0,
    },
    {
      slug: "nyse-pmt",
      code: "NYSE:PMT",
      companyName: "PennyMac Mortgage Investment Trust",
      popularity: 0,
    },
    {
      slug: "nyse-potx",
      code: "NYSE:POTX",
      companyName: "Global X Cannabis ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pmt-a",
      code: "NYSE:PMT-A",
      companyName:
        "PennyMac Mortgage Investment Trust 8.125% Series A Fixed-to-Floating Rate Cumulative Redeemable Pref",
      popularity: 0,
    },
    {
      slug: "nyse-pmt-b",
      code: "NYSE:PMT-B",
      companyName:
        "PennyMac Mortgage Investment Trust 8.00% Series B Fixed-to-Floating Rate Cumulative Redeemable Prefe",
      popularity: 0,
    },
    {
      slug: "nyse-pmt-c",
      code: "NYSE:PMT-C",
      companyName:
        "PennyMac Mortgage Investment Trust 6.75% Series C Cumulative Redeemable Preferred Shares of Benefici",
      popularity: 0,
    },
    {
      slug: "nyse-pmts",
      code: "NYSE:PMTS",
      companyName: "CPI Card Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pmvc",
      code: "NYSE:PMVC",
      companyName: "PMV Consumer Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-pmvp",
      code: "NYSE:PMVP",
      companyName: "PMV Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pmx",
      code: "NYSE:PMX",
      companyName: "PIMCO Municipal Income Fund III",
      popularity: 0,
    },
    {
      slug: "nyse-pnac",
      code: "NYSE:PNAC",
      companyName: "Prime Number Acquisition I Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pnacr",
      code: "NYSE:PNACR",
      companyName: "Prime Number Acquisition I Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-pnacu",
      code: "NYSE:PNACU",
      companyName: "Prime Number Acquisition I Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pnacw",
      code: "NYSE:PNACW",
      companyName: "Prime Number Acquisition I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pnbk",
      code: "NYSE:PNBK",
      companyName: "Patriot National Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pnc",
      code: "NYSE:PNC",
      companyName: "PNC Financial Services Group",
      popularity: 0,
    },
    {
      slug: "nyse-pnc-p",
      code: "NYSE:PNC-P",
      companyName: "THE PNC FINANCIAL SERVICES GROUP INC.",
      popularity: 0,
    },
    {
      slug: "nyse-pnf",
      code: "NYSE:PNF",
      companyName:
        "PIMCO NEW YORK MUNICIPAL INCOME FUND COMMON SHARES OF BENEFICIAL INTEREST",
      popularity: 0,
    },
    {
      slug: "nyse-pnfp",
      code: "NYSE:PNFP",
      companyName: "Pinnacle Financial Partners In",
      popularity: 0,
    },
    {
      slug: "nyse-pnfpp",
      code: "NYSE:PNFPP",
      companyName:
        "Pinnacle Financial Partners Inc. Depositary shares of Pinnacle Financial Partners Inc. each repre",
      popularity: 0,
    },
    {
      slug: "nyse-pnm",
      code: "NYSE:PNM",
      companyName: "PNM Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pnnt",
      code: "NYSE:PNNT",
      companyName: "Pennant Investment Corp",
      popularity: 0,
    },
    {
      slug: "nyse-pnov",
      code: "NYSE:PNOV",
      companyName: "Innovator U.S. Equity Power Buffer ETF - November",
      popularity: 0,
    },
    {
      slug: "nyse-pnqi",
      code: "NYSE:PNQI",
      companyName: "Invesco NASDAQ Internet ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pnr",
      code: "NYSE:PNR",
      companyName: "Pentair plc",
      popularity: 0,
    },
    {
      slug: "nyse-pnrg",
      code: "NYSE:PNRG",
      companyName: "PrimeEnergy Resources Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pnt",
      code: "NYSE:PNT",
      companyName: "POINT Biopharma Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pntg",
      code: "NYSE:PNTG",
      companyName: "The Pennant Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pntm",
      code: "NYSE:PNTM",
      companyName: "Pontem Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pnw",
      code: "NYSE:PNW",
      companyName: "Pinnacle West Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-poai",
      code: "NYSE:POAI",
      companyName: "Predictive Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-poct",
      code: "NYSE:POCT",
      companyName: "Innovator U.S. Equity Power Buffer ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-podd",
      code: "NYSE:PODD",
      companyName: "Insulet Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-poet",
      code: "NYSE:POET",
      companyName: "POET Technologies Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pol",
      code: "NYSE:POL",
      companyName: "Polished.com Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pola",
      code: "NYSE:POLA",
      companyName: "Polar Power Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-poly",
      code: "NYSE:POLY",
      companyName: "Plantronics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pond",
      code: "NYSE:POND",
      companyName: "Angel Pond Holdings Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pono",
      code: "NYSE:PONO",
      companyName: "Pono Capital Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ponou",
      code: "NYSE:PONOU",
      companyName: "Pono Capital Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ponow",
      code: "NYSE:PONOW",
      companyName: "Pono Capital Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pool",
      code: "NYSE:POOL",
      companyName: "Pool Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-por",
      code: "NYSE:POR",
      companyName: "Portland General Electric Company",
      popularity: 0,
    },
    {
      slug: "nyse-port",
      code: "NYSE:PORT",
      companyName: "Southport Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-posh",
      code: "NYSE:POSH",
      companyName: "Poshmark Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-post",
      code: "NYSE:POST",
      companyName: "POST HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-pow",
      code: "NYSE:POW",
      companyName: "Powered Brands Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-powi",
      code: "NYSE:POWI",
      companyName: "Power Integrations Inc",
      popularity: 0,
    },
    {
      slug: "nyse-powl",
      code: "NYSE:POWL",
      companyName: "Powell Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-powru",
      code: "NYSE:POWRU",
      companyName: "Powered Brands Units",
      popularity: 0,
    },
    {
      slug: "nyse-powrw",
      code: "NYSE:POWRW",
      companyName: "Powered Brands Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-poww",
      code: "NYSE:POWW",
      companyName: "AMMO Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-powwp",
      code: "NYSE:POWWP",
      companyName:
        "AMMO Inc. 8.75% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ppa",
      code: "NYSE:PPA",
      companyName: "Invesco Aerospace & Defense ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ppbi",
      code: "NYSE:PPBI",
      companyName: "Pacific Premier Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pni",
      code: "NYSE:PNI",
      companyName:
        "PIMCO NEW YORK MUNICIPAL INCOME FUND II COMMON SHARES OF BENEFICIAL INT.",
      popularity: 0,
    },
    {
      slug: "nyse-ppbt",
      code: "NYSE:PPBT",
      companyName: "Purple Biotech Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ppc",
      code: "NYSE:PPC",
      companyName: "Pilgrims Pride Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ppg",
      code: "NYSE:PPG",
      companyName: "PPG Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pph",
      code: "NYSE:PPH",
      companyName: "VanEck Pharmaceutical ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pphp",
      code: "NYSE:PPHP",
      companyName: "PHP Ventures Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pphpr",
      code: "NYSE:PPHPR",
      companyName: "PHP Ventures Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-pphpu",
      code: "NYSE:PPHPU",
      companyName: "PHP Ventures Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-pphpw",
      code: "NYSE:PPHPW",
      companyName: "PHP Ventures Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-ppi",
      code: "NYSE:PPI",
      companyName: "AXS Astoria Inflation Sensitive ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ppih",
      code: "NYSE:PPIH",
      companyName: "Perma-Pipe International Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ppl",
      code: "NYSE:PPL",
      companyName: "PPL Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pplt",
      code: "NYSE:PPLT",
      companyName: "abrdn Physical Platinum Shares ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ppsi",
      code: "NYSE:PPSI",
      companyName: "Pioneer Power Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ppt",
      code: "NYSE:PPT",
      companyName: "Putnam Premier Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-ppta",
      code: "NYSE:PPTA",
      companyName: "Perpetua Resources Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ppty",
      code: "NYSE:PPTY",
      companyName: "U.S. Diversified Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ppya",
      code: "NYSE:PPYA",
      companyName: "Papaya Growth Opportunity Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ppyau",
      code: "NYSE:PPYAU",
      companyName: "Papaya Growth Opportunity Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ppyaw",
      code: "NYSE:PPYAW",
      companyName: "Papaya Growth Opportunity Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pqdi",
      code: "NYSE:PQDI",
      companyName: "Principal Spectrum Tax-Advantaged Dividend Active ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pqin",
      code: "NYSE:PQIN",
      companyName:
        "PGIM Quant Solutions Strategic Alpha International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pra",
      code: "NYSE:PRA",
      companyName: "ProAssurance Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-praa",
      code: "NYSE:PRAA",
      companyName: "PRA Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-prax",
      code: "NYSE:PRAX",
      companyName: "Praxis Precision Medicines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pray",
      code: "NYSE:PRAY",
      companyName: "FIS Biblically Responsible Risk Managed ETF",
      popularity: 0,
    },
    {
      slug: "nyse-prbm",
      code: "NYSE:PRBM",
      companyName: "Parabellum Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-prch",
      code: "NYSE:PRCH",
      companyName: "Porch Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prct",
      code: "NYSE:PRCT",
      companyName: "PROCEPT BioRobotics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prdo",
      code: "NYSE:PRDO",
      companyName: "Perdoceo Education Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-prds",
      code: "NYSE:PRDS",
      companyName: "Pardes Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pre",
      code: "NYSE:PRE",
      companyName: "Prenetics Global Limited Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-pre-j",
      code: "NYSE:PRE-J",
      companyName:
        "PartnerRe Ltd. 4.875% Fixed Rate Non-Cumulative Redeemable Preferred Shares Series J",
      popularity: 0,
    },
    {
      slug: "nyse-pref",
      code: "NYSE:PREF",
      companyName: "Principal Spectrum Preferred Securities Active ETF",
      popularity: 0,
    },
    {
      slug: "nyse-prenw",
      code: "NYSE:PRENW",
      companyName: "Prenetics Global Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-prf",
      code: "NYSE:PRF",
      companyName: "Invesco FTSE RAFI US 1000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-prft",
      code: "NYSE:PRFT",
      companyName: "Perficient Inc",
      popularity: 0,
    },
    {
      slug: "nyse-prfx",
      code: "NYSE:PRFX",
      companyName: "PainReform Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-prfz",
      code: "NYSE:PRFZ",
      companyName: "Invesco FTSE RAFI US 1500 Small-Mid ETF",
      popularity: 0,
    },
    {
      slug: "nyse-prg",
      code: "NYSE:PRG",
      companyName: "PROG Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-prgo",
      code: "NYSE:PRGO",
      companyName: "PERRIGO COMPANY PLC",
      popularity: 0,
    },
    {
      slug: "nyse-prgs",
      code: "NYSE:PRGS",
      companyName: "Progress Software Corp (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-prh",
      code: "NYSE:PRH",
      companyName:
        "Prudential Financial Inc. 5.950% Junior Subordinated Notes due 2062",
      popularity: 0,
    },
    {
      slug: "nyse-pri",
      code: "NYSE:PRI",
      companyName: "PRIMERICA INC.",
      popularity: 0,
    },
    {
      slug: "nyse-prif-d",
      code: "NYSE:PRIF-D",
      companyName:
        "Priority Income Fund Inc. 7.00% Series D Term Preferred Stock due 2029",
      popularity: 0,
    },
    {
      slug: "nyse-prif-f",
      code: "NYSE:PRIF-F",
      companyName:
        "Priority Income Fund Inc. 6.625% Series F Term Preferred Stock due 2027",
      popularity: 0,
    },
    {
      slug: "nyse-prif-g",
      code: "NYSE:PRIF-G",
      companyName:
        "Priority Income Fund Inc. 6.25% Series G Preferred Stock Due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-prif-h",
      code: "NYSE:PRIF-H",
      companyName:
        "Priority Income Fund Inc. 6.00% Series H Term Preferred Stock due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-prif-i",
      code: "NYSE:PRIF-I",
      companyName:
        "Priority Income Fund Inc. 6.125% Series I Term Preferred Stock due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-prif-j",
      code: "NYSE:PRIF-J",
      companyName:
        "Priority Income Fund Inc. 6.000% Series J Term Preferred Stock due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-prif-k",
      code: "NYSE:PRIF-K",
      companyName:
        "Priority Income Fund Inc. 7.000% Series K Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prif-l",
      code: "NYSE:PRIF-L",
      companyName:
        "Priority Income Fund Inc. 6.375% Series L Term Preferred Stock Due 2029",
      popularity: 0,
    },
    {
      slug: "nyse-prk",
      code: "NYSE:PRK",
      companyName: "Park National Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-prlb",
      code: "NYSE:PRLB",
      companyName: "PROTO LABS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-prld",
      code: "NYSE:PRLD",
      companyName: "Prelude Therapeutics Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-prlh",
      code: "NYSE:PRLH",
      companyName: "Pearl Holdings Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-prlhu",
      code: "NYSE:PRLHU",
      companyName: "Pearl Holdings Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-prlhw",
      code: "NYSE:PRLHW",
      companyName: "Pearl Holdings Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-prm",
      code: "NYSE:PRM",
      companyName: "Perimeter Solutions SA",
      popularity: 0,
    },
    {
      slug: "nyse-prmw",
      code: "NYSE:PRMW",
      companyName: "Primo Water Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-prn",
      code: "NYSE:PRN",
      companyName: "Invesco DWA Industrials Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-prnt",
      code: "NYSE:PRNT",
      companyName: "The 3D Printing ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pro",
      code: "NYSE:PRO",
      companyName: "Pros Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-proc",
      code: "NYSE:PROC",
      companyName: "Procaps Group S.A. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-procw",
      code: "NYSE:PROCW",
      companyName: "Procaps Group S.A. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-prof",
      code: "NYSE:PROF",
      companyName: "Profound Medical Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prok",
      code: "NYSE:PROK",
      companyName: "ProKidney Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-prov",
      code: "NYSE:PROV",
      companyName: "Provident Financial Hldgs",
      popularity: 0,
    },
    {
      slug: "nyse-prpc",
      code: "NYSE:PRPC",
      companyName: "CC Neuberger Principal Holdings III",
      popularity: 0,
    },
    {
      slug: "nyse-prph",
      code: "NYSE:PRPH",
      companyName: "ProPhase Labs Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-prpl",
      code: "NYSE:PRPL",
      companyName: "Purple Innovation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prpo",
      code: "NYSE:PRPO",
      companyName: "Precipio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prqr",
      code: "NYSE:PRQR",
      companyName: "ProQR Therapeutics N.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-prs",
      code: "NYSE:PRS",
      companyName:
        "Prudential Financial Inc. 5.625% Junior Subordinated Notes due 2058",
      popularity: 0,
    },
    {
      slug: "nyse-prso",
      code: "NYSE:PRSO",
      companyName: "Peraso Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prsr",
      code: "NYSE:PRSR",
      companyName: "Prospector Capital Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-prsru",
      code: "NYSE:PRSRU",
      companyName: "Prospector Capital Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-prsrw",
      code: "NYSE:PRSRW",
      companyName: "Prospector Capital Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-prt",
      code: "NYSE:PRT",
      companyName: "PermRock Royalty Trust Trust Unit",
      popularity: 0,
    },
    {
      slug: "nyse-prta",
      code: "NYSE:PRTA",
      companyName: "Prothena Corporation plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-prtc",
      code: "NYSE:PRTC",
      companyName: "PureTech Health plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-prtg",
      code: "NYSE:PRTG",
      companyName: "Portage Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prth",
      code: "NYSE:PRTH",
      companyName: "Priority Technology Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-prtk",
      code: "NYSE:PRTK",
      companyName: "Paratek Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-prts",
      code: "NYSE:PRTS",
      companyName: "CarParts.com Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prty",
      code: "NYSE:PRTY",
      companyName: "Party City Holdco Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pru",
      code: "NYSE:PRU",
      companyName: "Prudential Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-prva",
      code: "NYSE:PRVA",
      companyName: "Privia Health Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prvb",
      code: "NYSE:PRVB",
      companyName: "Provention Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-psa-f",
      code: "NYSE:PSA-F",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 5.15% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-g",
      code: "NYSE:PSA-G",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 5.05% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-h",
      code: "NYSE:PSA-H",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 5.60% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-i",
      code: "NYSE:PSA-I",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.875% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-j",
      code: "NYSE:PSA-J",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.700% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-k",
      code: "NYSE:PSA-K",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.75% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-l",
      code: "NYSE:PSA-L",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.625% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-m",
      code: "NYSE:PSA-M",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.125% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-n",
      code: "NYSE:PSA-N",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 3.875% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-o",
      code: "NYSE:PSA-O",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 3.900% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-p",
      code: "NYSE:PSA-P",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.000% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-q",
      code: "NYSE:PSA-Q",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 3.950% Cumulative Preferred  Share o",
      popularity: 0,
    },
    {
      slug: "nyse-psa-r",
      code: "NYSE:PSA-R",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.00% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psa-s",
      code: "NYSE:PSA-S",
      companyName:
        "Public Storage Depositary Shares Each Representing 1/1000 of a 4.100% Cumulative Preferred Share of",
      popularity: 0,
    },
    {
      slug: "nyse-psag",
      code: "NYSE:PSAG",
      companyName:
        "Property Solutions Acquisition Corporation II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-psagu",
      code: "NYSE:PSAGU",
      companyName: "Property Solutions Acquisition Corporation II Units",
      popularity: 0,
    },
    {
      slug: "nyse-psagw",
      code: "NYSE:PSAGW",
      companyName: "Property Solutions Acquisition Corporation II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-psb-x",
      code: "NYSE:PSB-X",
      companyName:
        "PS Business Parks Inc. Depositary Shares Each Representing 1/1000 of a Share of 5.25 Percent Cumul",
      popularity: 0,
    },
    {
      slug: "nyse-psb-y",
      code: "NYSE:PSB-Y",
      companyName:
        "PS Business Parks Inc. 5.20% Cumulative Preferred Stock Series Y",
      popularity: 0,
    },
    {
      slug: "nyse-psb-z",
      code: "NYSE:PSB-Z",
      companyName:
        "PS Business Parks Inc. Depositary Shares Each Representing 1/1000 of a Share of 4.875% Cumulative P",
      popularity: 0,
    },
    {
      slug: "nyse-psc",
      code: "NYSE:PSC",
      companyName:
        "Principal Exchange-Traded Funds Principal U.S. Small-Cap Multi-Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pscc",
      code: "NYSE:PSCC",
      companyName: "Invesco S&P SmallCap Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pscd",
      code: "NYSE:PSCD",
      companyName: "Invesco S&P SmallCap Consumer Discretionary ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psce",
      code: "NYSE:PSCE",
      companyName: "Invesco S&P SmallCap Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pscf",
      code: "NYSE:PSCF",
      companyName: "Invesco S&P SmallCap Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psch",
      code: "NYSE:PSCH",
      companyName: "Invesco S&P SmallCap Health Care ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psci",
      code: "NYSE:PSCI",
      companyName: "Invesco S&P SmallCap Industrials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pscj",
      code: "NYSE:PSCJ",
      companyName: "Pacer Swan SOS Conservative (July) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pscm",
      code: "NYSE:PSCM",
      companyName: "Invesco S&P SmallCap Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pscq",
      code: "NYSE:PSCQ",
      companyName: "Pacer Swan SOS Conservative (October) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psct",
      code: "NYSE:PSCT",
      companyName: "Invesco S&P SmallCap Information Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pscu",
      code: "NYSE:PSCU",
      companyName:
        "Invesco Exchange-Traded Fund Trust II Invesco S&P SmallCap Utilities & Communication Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pscw",
      code: "NYSE:PSCW",
      companyName: "Pacer Swan SOS Conservative (April) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pscx",
      code: "NYSE:PSCX",
      companyName: "Pacer Swan SOS Conservative (January) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psdn",
      code: "NYSE:PSDN",
      companyName: "AdvisorShares Poseidon Dynamic Cannabis ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psec",
      code: "NYSE:PSEC",
      companyName: "Prospect Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-psec-a",
      code: "NYSE:PSEC-A",
      companyName:
        "Prospect Capital Corporation 5.35% Series A Fixed Rate Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-psep",
      code: "NYSE:PSEP",
      companyName: "Innovator U.S. Equity Power Buffer ETF - September",
      popularity: 0,
    },
    {
      slug: "nyse-pset",
      code: "NYSE:PSET",
      companyName: "Principal Exchange-Traded Funds Principal Quality ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psf",
      code: "NYSE:PSF",
      companyName: "COHEN & STEERS SELECT PREFERRED AND INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-psfd",
      code: "NYSE:PSFD",
      companyName: "Pacer Swan SOS Flex (January) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psff",
      code: "NYSE:PSFF",
      companyName: "Pacer Swan SOS Fund of Funds ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psfj",
      code: "NYSE:PSFJ",
      companyName: "Pacer Swan SOS Flex (July) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psfm",
      code: "NYSE:PSFM",
      companyName: "Pacer Swan SOS Flex (April) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psfo",
      code: "NYSE:PSFO",
      companyName: "Pacer Swan SOS Flex (October) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pshg",
      code: "NYSE:PSHG",
      companyName: "Performance Shipping Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-psi",
      code: "NYSE:PSI",
      companyName: "Invesco Dynamic Semiconductors ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psj",
      code: "NYSE:PSJ",
      companyName: "Invesco Dynamic Software ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psk",
      code: "NYSE:PSK",
      companyName: "SPDR ICE Preferred Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psl",
      code: "NYSE:PSL",
      companyName: "Invesco DWA Consumer Staples Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pslv",
      code: "NYSE:PSLV",
      companyName: "Sprott Physical Silver Trust",
      popularity: 0,
    },
    {
      slug: "nyse-psmb",
      code: "NYSE:PSMB",
      companyName: "Invesco Balanced Multi-Asset Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psmc",
      code: "NYSE:PSMC",
      companyName: "Invesco Conservative Multi-Asset Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psmd",
      code: "NYSE:PSMD",
      companyName: "Pacer Swan SOS Moderate (January) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psmg",
      code: "NYSE:PSMG",
      companyName: "Invesco Growth Multi-Asset Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psmj",
      code: "NYSE:PSMJ",
      companyName: "Pacer Swan SOS Moderate (July) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psmm",
      code: "NYSE:PSMM",
      companyName: "Invesco Moderately Conservative Multi-Asset Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psmo",
      code: "NYSE:PSMO",
      companyName: "Pacer Swan SOS Moderate (October) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psmr",
      code: "NYSE:PSMR",
      companyName: "Pacer Swan SOS Moderate (April) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psmt",
      code: "NYSE:PSMT",
      companyName: "Pricesmart Inc",
      popularity: 0,
    },
    {
      slug: "nyse-psn",
      code: "NYSE:PSN",
      companyName: "Parsons Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-psnl",
      code: "NYSE:PSNL",
      companyName: "Personalis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-psny",
      code: "NYSE:PSNY",
      companyName: "Gores Guggenheim Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-psnyw",
      code: "NYSE:PSNYW",
      companyName: "Polestar Automotive Holding UK PLC Class C-1 ADS (ADW)",
      popularity: 0,
    },
    {
      slug: "nyse-pso",
      code: "NYSE:PSO",
      companyName: "Pearson plc ",
      popularity: 0,
    },
    {
      slug: "nyse-psp",
      code: "NYSE:PSP",
      companyName: "Invesco Global Listed Private Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pspc",
      code: "NYSE:PSPC",
      companyName: "Post Holdings Partnering Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-psq",
      code: "NYSE:PSQ",
      companyName: "ProShares Short QQQ",
      popularity: 0,
    },
    {
      slug: "nyse-psr",
      code: "NYSE:PSR",
      companyName: "Invesco Active U.S. Real Estate Fund",
      popularity: 0,
    },
    {
      slug: "nyse-pst",
      code: "NYSE:PST",
      companyName: "ProShares Trust UltraShort Lehman 7-10 Year Treasury",
      popularity: 0,
    },
    {
      slug: "nyse-pstg",
      code: "NYSE:PSTG",
      companyName: "Pure Storage Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-pstl",
      code: "NYSE:PSTL",
      companyName: "Postal Realty Trust Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pstp",
      code: "NYSE:PSTP",
      companyName: "Innovator Power Buffer Step-Up Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pstv",
      code: "NYSE:PSTV",
      companyName: "PLUS THERAPEUTICS Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pstx",
      code: "NYSE:PSTX",
      companyName: "Poseida Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-psx",
      code: "NYSE:PSX",
      companyName: "PHILLIPS 66",
      popularity: 0,
    },
    {
      slug: "nyse-psy",
      code: "NYSE:PSY",
      companyName: "Defiance Next Gen Altered Experience ETF",
      popularity: 0,
    },
    {
      slug: "nyse-psyk",
      code: "NYSE:PSYK",
      companyName: "PSYK ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pt",
      code: "NYSE:PT",
      companyName:
        "Pintec Technology Holdings Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pta",
      code: "NYSE:PTA",
      companyName:
        "Cohen & Steers Tax-Advantaged Preferred Securities and Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ptbd",
      code: "NYSE:PTBD",
      companyName: "Pacer Trendpilot US Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ptc",
      code: "NYSE:PTC",
      companyName: "PTC INC",
      popularity: 0,
    },
    {
      slug: "nyse-ptct",
      code: "NYSE:PTCT",
      companyName: "PTC Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pte",
      code: "NYSE:PTE",
      companyName: "PolarityTE Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pten",
      code: "NYSE:PTEN",
      companyName: "Patterson-UTI Energy Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pteu",
      code: "NYSE:PTEU",
      companyName: "Pacer TrendpilotTM European Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ptf",
      code: "NYSE:PTF",
      companyName: "Invesco DWA Technology Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ptgx",
      code: "NYSE:PTGX",
      companyName: "Protagonist Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pth",
      code: "NYSE:PTH",
      companyName: "Invesco DWA Healthcare Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ptic",
      code: "NYSE:PTIC",
      companyName: "PropTech Investment Corporation II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pticu",
      code: "NYSE:PTICU",
      companyName: "PropTech Investment Corporation II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pticw",
      code: "NYSE:PTICW",
      companyName: "PropTech Investment Corporation II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ptin",
      code: "NYSE:PTIN",
      companyName: "Pacer Trendpilot International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ptix",
      code: "NYSE:PTIX",
      companyName: "Performance Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ptixw",
      code: "NYSE:PTIXW",
      companyName: "Protagenic Therapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ptlc",
      code: "NYSE:PTLC",
      companyName: "Pacer Trendpilot US Large Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ptlo",
      code: "NYSE:PTLO",
      companyName: "Portillo's Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ptmc",
      code: "NYSE:PTMC",
      companyName: "Pacer Trendpilot US Mid Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ptmn",
      code: "NYSE:PTMN",
      companyName: "Portman Ridge Finance Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ptn",
      code: "NYSE:PTN",
      companyName: "Palatin Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ptnq",
      code: "NYSE:PTNQ",
      companyName: "Pacer Trendpilot 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ptnr",
      code: "NYSE:PTNR",
      companyName: "Partner Communications",
      popularity: 0,
    },
    {
      slug: "nyse-ptoc",
      code: "NYSE:PTOC",
      companyName: "Pine Technology Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ptocu",
      code: "NYSE:PTOCU",
      companyName: "Pine TechnologYES Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ptocw",
      code: "NYSE:PTOCW",
      companyName: "Pine Technology Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pton",
      code: "NYSE:PTON",
      companyName: "Peloton Interactive Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ptpi",
      code: "NYSE:PTPI",
      companyName: "Petros Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ptr",
      code: "NYSE:PTR",
      companyName: "PETROCHINA COMPANY LIMITED ADS (REP 100 H SHARES)",
      popularity: 0,
    },
    {
      slug: "nyse-ptra",
      code: "NYSE:PTRA",
      companyName: "Proterra Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ptrb",
      code: "NYSE:PTRB",
      companyName: "PGIM Total Return Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ptrs",
      code: "NYSE:PTRS",
      companyName: "Partners Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ptsi",
      code: "NYSE:PTSI",
      companyName: "PAM Transportation Services",
      popularity: 0,
    },
    {
      slug: "nyse-ptve",
      code: "NYSE:PTVE",
      companyName: "Pactiv Evergreen Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-ptwou",
      code: "NYSE:PTWOU",
      companyName: "Pono Capital Two Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pty",
      code: "NYSE:PTY",
      companyName: "PIMCO Corporate & Income Opportunity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-pubm",
      code: "NYSE:PUBM",
      companyName: "PubMatic Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-puck",
      code: "NYSE:PUCK",
      companyName: "Goal Acquisitions Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pucku",
      code: "NYSE:PUCKU",
      companyName: "Goal Acquisitions Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-puckw",
      code: "NYSE:PUCKW",
      companyName: "Goal Acquisitions Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pui",
      code: "NYSE:PUI",
      companyName: "Invesco DWA Utilities Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-puk",
      code: "NYSE:PUK",
      companyName: "PRUDENTIAL PLC ADS (REP 2 ORD SHARES)",
      popularity: 0,
    },
    {
      slug: "nyse-pulm",
      code: "NYSE:PULM",
      companyName: "Pulmatrix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-puls",
      code: "NYSE:PULS",
      companyName: "PGIM Ultra Short Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pump",
      code: "NYSE:PUMP",
      companyName: "ProPetro Holding Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-punk",
      code: "NYSE:PUNK",
      companyName: "Subversive Metaverse ETF",
      popularity: 0,
    },
    {
      slug: "nyse-putw",
      code: "NYSE:PUTW",
      companyName: "WisdomTree CBOE S&P 500 PutWrite Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-puyi",
      code: "NYSE:PUYI",
      companyName: "Puyi Inc. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pv",
      code: "NYSE:PV",
      companyName: "Primavera Capital Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-pval",
      code: "NYSE:PVAL",
      companyName: "Putnam Focused Large Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pvbc",
      code: "NYSE:PVBC",
      companyName: "Provident Bancorp Inc. (MD) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pvi",
      code: "NYSE:PVI",
      companyName: "Invesco VRDO Tax-Free ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pvl",
      code: "NYSE:PVL",
      companyName: "Permianville Royalty Trust",
      popularity: 0,
    },
    {
      slug: "nyse-pw",
      code: "NYSE:PW",
      companyName: "Power REIT",
      popularity: 0,
    },
    {
      slug: "nyse-pw-a",
      code: "NYSE:PW-A",
      companyName:
        "Power REIT  7.75% Series A Cumulative Redeemable Perpetual Preferred Stock Liquidation Preference $",
      popularity: 0,
    },
    {
      slug: "nyse-pwb",
      code: "NYSE:PWB",
      companyName: "Invesco Dynamic Large Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pwc",
      code: "NYSE:PWC",
      companyName: "Invesco Dynamic Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pwfl",
      code: "NYSE:PWFL",
      companyName: "PowerFleet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pwp",
      code: "NYSE:PWP",
      companyName: "Perella Weinberg Partners Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pwppw",
      code: "NYSE:PWPPW",
      companyName: "Perella Weinberg Partners Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pwr",
      code: "NYSE:PWR",
      companyName: "Quanta Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pws",
      code: "NYSE:PWS",
      companyName: "Pacer WealthShield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pwsc",
      code: "NYSE:PWSC",
      companyName: "PowerSchool Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pwup",
      code: "NYSE:PWUP",
      companyName: "PowerUp Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pwupu",
      code: "NYSE:PWUPU",
      companyName: "PowerUp Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-pwupw",
      code: "NYSE:PWUPW",
      companyName: "PowerUp Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pwv",
      code: "NYSE:PWV",
      companyName: "Invesco Dynamic Large Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pwz",
      code: "NYSE:PWZ",
      companyName: "Invesco California AMT-Free Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-px",
      code: "NYSE:PX",
      companyName: "P10 Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-pxd",
      code: "NYSE:PXD",
      companyName: "Pioneer Natural Resource Co.",
      popularity: 0,
    },
    {
      slug: "nyse-pxe",
      code: "NYSE:PXE",
      companyName: "Invesco Dynamic Energy Exploration & Production ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pxf",
      code: "NYSE:PXF",
      companyName: "Invesco FTSE RAFI Developed Markets ex-U.S. ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pxh",
      code: "NYSE:PXH",
      companyName: "Invesco FTSE RAFI Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pxi",
      code: "NYSE:PXI",
      companyName: "Invesco DWA Energy Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pxj",
      code: "NYSE:PXJ",
      companyName: "Invesco Dynamic Oil & Gas Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pxlw",
      code: "NYSE:PXLW",
      companyName: "Pixelworks Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pxmd",
      code: "NYSE:PXMD",
      companyName: "PaxMedica Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pxq",
      code: "NYSE:PXQ",
      companyName: "Invesco Dynamic Networking ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pxs",
      code: "NYSE:PXS",
      companyName: "Pyxis Tankers Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pxsap",
      code: "NYSE:PXSAP",
      companyName:
        "Pyxis Tankers Inc. 7.75% Series A Cumulative Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pxsaw",
      code: "NYSE:PXSAW",
      companyName: "Pyxis Tankers Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-pxus",
      code: "NYSE:PXUS",
      companyName: "Principal International Adaptive Multi-Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-py",
      code: "NYSE:PY",
      companyName: "Principal Exchange-Traded Funds Principal Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pycr",
      code: "NYSE:PYCR",
      companyName: "Paycor HCM Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pyn",
      code: "NYSE:PYN",
      companyName: "PIMCO New York Municipal Income Fund III",
      popularity: 0,
    },
    {
      slug: "nyse-pypd",
      code: "NYSE:PYPD",
      companyName: "PolyPid Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pype",
      code: "NYSE:PYPE",
      companyName:
        "ETRACS NYSE Pickens Core Midstream Index ETN due August 20 2048",
      popularity: 0,
    },
    {
      slug: "nyse-pyps",
      code: "NYSE:PYPS",
      companyName: "AXS 1.5X PYPL Bear Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pypt",
      code: "NYSE:PYPT",
      companyName: "AXS 1.5X PYPL Bull Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pyr",
      code: "NYSE:PYR",
      companyName: "PyroGenesis Canada Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-pys",
      code: "NYSE:PYS",
      companyName:
        "Merrill Lynch Depositor Inc. PPLUS Class A 6.30% Callable Trust Certificates Series RRD-1 (Issued b",
      popularity: 0,
    },
    {
      slug: "nyse-pyt",
      code: "NYSE:PYT",
      companyName:
        "Merrill Lynch Depositor PPLUS  Floating Rate Call TR Cert. Ser GSC-2(Goldman Sachs)",
      popularity: 0,
    },
    {
      slug: "nyse-pyxs",
      code: "NYSE:PYXS",
      companyName: "Pyxis Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-pyz",
      code: "NYSE:PYZ",
      companyName: "Invesco DWA Basic Materials Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pza",
      code: "NYSE:PZA",
      companyName: "Invesco National AMT-Free Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pzc",
      code: "NYSE:PZC",
      companyName: "PIMCO California Municipal Income Fund III",
      popularity: 0,
    },
    {
      slug: "nyse-pzg",
      code: "NYSE:PZG",
      companyName: "Paramount Gold Nevada Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-pzn",
      code: "NYSE:PZN",
      companyName: "Pzena Investment Management Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-pzt",
      code: "NYSE:PZT",
      companyName: "Invesco New York AMT-Free Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pzza",
      code: "NYSE:PZZA",
      companyName: "Papa John's International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-qaba",
      code: "NYSE:QABA",
      companyName: "First Trust NASDAQ ABA Community Bank Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qai",
      code: "NYSE:QAI",
      companyName: "IQ Hedge Multi-Strategy Tracker ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qarp",
      code: "NYSE:QARP",
      companyName:
        "Xtrackers Russell 1000 US Quality at a Reasonable Price ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qat",
      code: "NYSE:QAT",
      companyName: "iShares Trust iShares MSCI Qatar ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qcln",
      code: "NYSE:QCLN",
      companyName: "First Trust NASDAQ Clean Edge Green Energy Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qcon",
      code: "NYSE:QCON",
      companyName: "American Century Quality Convertible Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qcrh",
      code: "NYSE:QCRH",
      companyName: "QCR Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-qd",
      code: "NYSE:QD",
      companyName:
        "Qudian Inc. American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-qdec",
      code: "NYSE:QDEC",
      companyName: "FT Cboe Vest Growth-100 Buffer ETF - December",
      popularity: 0,
    },
    {
      slug: "nyse-qdef",
      code: "NYSE:QDEF",
      companyName: "FlexShares Quality Dividend Defensive Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qdel",
      code: "NYSE:QDEL",
      companyName: "QuidelOrtho Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qdf",
      code: "NYSE:QDF",
      companyName: "FlexShares Quality Dividend Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qcom",
      code: "NYSE:QCOM",
      companyName: "Qualcomm Inc",
      popularity: 0,
    },
    {
      slug: "nyse-qdpl",
      code: "NYSE:QDPL",
      companyName: "Pacer Metaurus US Large Cap Dividend Multiplier 400 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qdyn",
      code: "NYSE:QDYN",
      companyName: "FlexShares Quality Dividend Dynamic Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qed",
      code: "NYSE:QED",
      companyName: "IQ Hedge Event-Driven Tracker ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qefa",
      code: "NYSE:QEFA",
      companyName: "SPDR MSCI EAFE StrategicFactors ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qemm",
      code: "NYSE:QEMM",
      companyName: "SPDR MSCI Emerging Markets StrategicFactors ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qfin",
      code: "NYSE:QFIN",
      companyName: "360 DigiTech Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-qfta",
      code: "NYSE:QFTA",
      companyName: "Quantum FinTech Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-qgro",
      code: "NYSE:QGRO",
      companyName: "American Century STOXX U.S. Quality Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qh",
      code: "NYSE:QH",
      companyName: "Quhuo Limited American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-qid",
      code: "NYSE:QID",
      companyName: "ProShares UltraShort QQQ",
      popularity: 0,
    },
    {
      slug: "nyse-qint",
      code: "NYSE:QINT",
      companyName: "American Century Quality Diversified International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qipt",
      code: "NYSE:QIPT",
      companyName: "Quipt Home Medical Corp. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-qiwi",
      code: "NYSE:QIWI",
      companyName: "QIWI PLC",
      popularity: 0,
    },
    {
      slug: "nyse-qjun",
      code: "NYSE:QJUN",
      companyName: "FT Cboe Vest Growth-100 Buffer ETF - June",
      popularity: 0,
    },
    {
      slug: "nyse-qk",
      code: "NYSE:QK",
      companyName: "Q&K International Group Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-qlc",
      code: "NYSE:QLC",
      companyName: "FlexShares US Quality Large Cap Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qld",
      code: "NYSE:QLD",
      companyName: "ProShares Ultra QQQ",
      popularity: 0,
    },
    {
      slug: "nyse-qlgn",
      code: "NYSE:QLGN",
      companyName: "Qualigen Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qli",
      code: "NYSE:QLI",
      companyName: "Qilian International Holding Group Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-qls",
      code: "NYSE:QLS",
      companyName: "IQ Hedge Long/Short Tracker ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qlta",
      code: "NYSE:QLTA",
      companyName: "iShares Aaa - A Rated Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qlv",
      code: "NYSE:QLV",
      companyName: "FlexShares US Quality Low Volatility Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qlvd",
      code: "NYSE:QLVD",
      companyName:
        "FlexShares Developed Markets ex-US Quality Low Volatility Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qlve",
      code: "NYSE:QLVE",
      companyName:
        "FlexShares Emerging Markets Quality Low Volatility Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qlys",
      code: "NYSE:QLYS",
      companyName: "Qualys Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qmar",
      code: "NYSE:QMAR",
      companyName: "FT Cboe Vest Growth-100 Buffer ETF - March",
      popularity: 0,
    },
    {
      slug: "nyse-qmco",
      code: "NYSE:QMCO",
      companyName: "Quantum Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-qmn",
      code: "NYSE:QMN",
      companyName: "IQ Hedge Market Neutral Tracker ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qmom",
      code: "NYSE:QMOM",
      companyName: "Alpha Architect U.S. Quantitative Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qncx",
      code: "NYSE:QNCX",
      companyName: "Quince Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qngy",
      code: "NYSE:QNGY",
      companyName: "Quanergy Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-qnrx",
      code: "NYSE:QNRX",
      companyName: "Quoin Pharmaceuticals Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-qnst",
      code: "NYSE:QNST",
      companyName: "QuinStreet Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-qpff",
      code: "NYSE:QPFF",
      companyName: "American Century Quality Preferred ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qpt",
      code: "NYSE:QPT",
      companyName: "AdvisorShares Q Portfolio Blended Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qpx",
      code: "NYSE:QPX",
      companyName: "AdvisorShares Q Dynamic Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qclr",
      code: "NYSE:QCLR",
      companyName: "Global X NASDAQ 100 Collar 95-110 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqc",
      code: "NYSE:QQC",
      companyName:
        "Simplify Exchange Traded Funds Simplify Nasdaq 100 PLUS Convexity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqd",
      code: "NYSE:QQD",
      companyName:
        "Simplify Exchange Traded Funds Simplify Nasdaq 100 PLUS Downside Convexity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqew",
      code: "NYSE:QQEW",
      companyName: "First Trust NASDAQ-100 Equal Weighted Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qqh",
      code: "NYSE:QQH",
      companyName: "HCM Defender 100 Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqjg",
      code: "NYSE:QQJG",
      companyName: "Invesco ESG NASDAQ Next Gen 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqmg",
      code: "NYSE:QQMG",
      companyName: "Invesco ESG NASDAQ 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqqa",
      code: "NYSE:QQQA",
      companyName: "ProShares Nasdaq-100 Dorsey Wright Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqqe",
      code: "NYSE:QQQE",
      companyName: "Direxion NASDAQ-100 Equal Weighted Index Shares",
      popularity: 0,
    },
    {
      slug: "nyse-qqqj",
      code: "NYSE:QQQJ",
      companyName: "Invesco NASDAQ Next Gen 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqqm",
      code: "NYSE:QQQM",
      companyName: "Invesco NASDAQ 100 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqqn",
      code: "NYSE:QQQN",
      companyName: "VictoryShares Nasdaq Next 50 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qqqx",
      code: "NYSE:QQQX",
      companyName:
        "Nuveen NASDAQ 100 Dynamic Overwrite Fund - Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-qqxt",
      code: "NYSE:QQXT",
      companyName: "First Trust NASDAQ - 100 Ex-Technology Sector Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qrft",
      code: "NYSE:QRFT",
      companyName: "Qraft AI-Enhanced US Large Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qrhc",
      code: "NYSE:QRHC",
      companyName: "Quest Resource Holding Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-qrtea",
      code: "NYSE:QRTEA",
      companyName: "Qurate Retail Inc. Series A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qrteb",
      code: "NYSE:QRTEB",
      companyName: "Qurate Retail Inc. Series B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qrtep",
      code: "NYSE:QRTEP",
      companyName:
        "Qurate Retail Inc. 8.0% Fixed Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qrvo",
      code: "NYSE:QRVO",
      companyName: "Qorvo Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-qs",
      code: "NYSE:QS",
      companyName: "QuantumScape Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-qsi",
      code: "NYSE:QSI",
      companyName: "Quantum-Si Incorporated Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qsiaw",
      code: "NYSE:QSIAW",
      companyName: "Quantum-Si Incorporated Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-qspt",
      code: "NYSE:QSPT",
      companyName: "FT Cboe Vest Nasdaq-100 Buffer ETF - September",
      popularity: 0,
    },
    {
      slug: "nyse-qsr",
      code: "NYSE:QSR",
      companyName: "Restaurant Brands International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-qswn",
      code: "NYSE:QSWN",
      companyName: "Amplify BlackSwan Tech & Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qtap",
      code: "NYSE:QTAP",
      companyName: "Innovator Growth Accelerated Plus ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-qtec",
      code: "NYSE:QTEC",
      companyName: "First Trust NASDAQ-100 Technology  Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-qtekw",
      code: "NYSE:QTEKW",
      companyName: "QualTek Services Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-qtja",
      code: "NYSE:QTJA",
      companyName: "Innovator Growth Accelerated Plus ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-qtjl",
      code: "NYSE:QTJL",
      companyName: "Innovator Growth Accelerated Plus ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-qtnt",
      code: "NYSE:QTNT",
      companyName: "Quotient Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-qtoc",
      code: "NYSE:QTOC",
      companyName: "Innovator Growth Accelerated Plus ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-qtrx",
      code: "NYSE:QTRX",
      companyName: "Quanterix Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qtt",
      code: "NYSE:QTT",
      companyName: "Qutoutiao Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-qtum",
      code: "NYSE:QTUM",
      companyName: "Defiance Quantum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qtwo",
      code: "NYSE:QTWO",
      companyName: "Q2 Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-quad",
      code: "NYSE:QUAD",
      companyName: "QUAD/GRAPHICS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-qual",
      code: "NYSE:QUAL",
      companyName: "iShares MSCI USA Quality Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-quik",
      code: "NYSE:QUIK",
      companyName: "QuickLogic Corp",
      popularity: 0,
    },
    {
      slug: "nyse-qull",
      code: "NYSE:QULL",
      companyName: "ETRACS 2x Leveraged MSCI US Quality Factor TR ETN",
      popularity: 0,
    },
    {
      slug: "nyse-qumu",
      code: "NYSE:QUMU",
      companyName: "Qumu Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-quot",
      code: "NYSE:QUOT",
      companyName: "Quotient Technology Inc",
      popularity: 0,
    },
    {
      slug: "nyse-qure",
      code: "NYSE:QURE",
      companyName: "uniQure N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-qus",
      code: "NYSE:QUS",
      companyName: "SPDR MSCI USA StrategicFactors ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qval",
      code: "NYSE:QVAL",
      companyName: "Alpha Architect U.S. Quantitative Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qvcc",
      code: "NYSE:QVCC",
      companyName: "QVC Inc. 6.250% Senior Secured Notes due 2068",
      popularity: 0,
    },
    {
      slug: "nyse-qvcd",
      code: "NYSE:QVCD",
      companyName: "QVC Inc. 6.375% Senior Secured Notes due 2067",
      popularity: 0,
    },
    {
      slug: "nyse-qvml",
      code: "NYSE:QVML",
      companyName: "Invesco S&P 500 QVM Multi-factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qvmm",
      code: "NYSE:QVMM",
      companyName: "Invesco S&P MidCap 400 QVM Multi-factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qvms",
      code: "NYSE:QVMS",
      companyName: "Invesco S&P SmallCap 600 QVM Multi-factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qwld",
      code: "NYSE:QWLD",
      companyName: "SPDR MSCI World StrategicFactors ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qylg",
      code: "NYSE:QYLG",
      companyName: "Global X Nasdaq 100 Covered Call & Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-r",
      code: "NYSE:R",
      companyName: "Ryder System Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ra",
      code: "NYSE:RA",
      companyName: "Brookfield Real Assets Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-raas",
      code: "NYSE:RAAS",
      companyName:
        "Cloopen Group Holding Limited American Depositary Shares each representing two Class A Ordinary Sha",
      popularity: 0,
    },
    {
      slug: "nyse-raax",
      code: "NYSE:RAAX",
      companyName: "VanEck Inflation Allocation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-racb",
      code: "NYSE:RACB",
      companyName: "Research Alliance Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-racy",
      code: "NYSE:RACY",
      companyName: "Relativity Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-qrmi",
      code: "NYSE:QRMI",
      companyName: "Global X NASDAQ 100 Risk Managed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-qtr",
      code: "NYSE:QTR",
      companyName: "Global X NASDAQ 100 Tail Risk ETF",
      popularity: 0,
    },
    {
      slug: "nyse-racyu",
      code: "NYSE:RACYU",
      companyName: "Relativity Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-racyw",
      code: "NYSE:RACYW",
      companyName: "Relativity Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rad",
      code: "NYSE:RAD",
      companyName: "Rite Aid Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-rada",
      code: "NYSE:RADA",
      companyName: "Rada Electronic Industries Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-radi",
      code: "NYSE:RADI",
      companyName: "Radius Global Infrastructure Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rafe",
      code: "NYSE:RAFE",
      companyName: "PIMCO RAFI ESG U.S. ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rail",
      code: "NYSE:RAIL",
      companyName: "FreightCar America Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rain",
      code: "NYSE:RAIN",
      companyName: "Rain Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ram",
      code: "NYSE:RAM",
      companyName: "Aries I Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-rammu",
      code: "NYSE:RAMMU",
      companyName: "Aries I Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rammw",
      code: "NYSE:RAMMW",
      companyName: "Aries I Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ramp",
      code: "NYSE:RAMP",
      companyName: "LiveRamp Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rand",
      code: "NYSE:RAND",
      companyName: "Rand Capital Corp",
      popularity: 0,
    },
    {
      slug: "nyse-rani",
      code: "NYSE:RANI",
      companyName: "Rani Therapeutics Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rapt",
      code: "NYSE:RAPT",
      companyName: "RAPT Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rare",
      code: "NYSE:RARE",
      companyName: "Ultragenyx Pharmaceutical Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rave",
      code: "NYSE:RAVE",
      companyName: "Rave Restaurant Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ravi",
      code: "NYSE:RAVI",
      companyName: "FlexShares Ready Access Variable Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-rayc",
      code: "NYSE:RAYC",
      companyName: "Rayliant Quantamental China Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rayd",
      code: "NYSE:RAYD",
      companyName: "Rayliant Quantitative Developed Market Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-raye",
      code: "NYSE:RAYE",
      companyName: "Rayliant Quantamental Emerging Market Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rba",
      code: "NYSE:RBA",
      companyName: "Ritchie Bros. Auctioneers Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-rbb",
      code: "NYSE:RBB",
      companyName: "RBB Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rbbn",
      code: "NYSE:RBBN",
      companyName: "Ribbon Communications Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rbcaa",
      code: "NYSE:RBCAA",
      companyName: "Republic Bancorp Inc/KY",
      popularity: 0,
    },
    {
      slug: "nyse-rbcn",
      code: "NYSE:RBCN",
      companyName: "Rubicon Technology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rbkb",
      code: "NYSE:RBKB",
      companyName: "Rhinebeck Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rbld",
      code: "NYSE:RBLD",
      companyName: "First Trust Alerian US NextGen Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rcl",
      code: "NYSE:RCL",
      companyName: "Royal Caribbean Group",
      popularity: 0,
    },
    {
      slug: "nyse-rbnd",
      code: "NYSE:RBND",
      companyName: "SPDR Bloomberg SASB Corporate Bond ESG Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rbot",
      code: "NYSE:RBOT",
      companyName: "Vicarious Surgical Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rbt",
      code: "NYSE:RBT",
      companyName: "Rubicon Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rc",
      code: "NYSE:RC",
      companyName: "Ready Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-rc-c",
      code: "NYSE:RC-C",
      companyName:
        "Ready Capital Corporation 6.25% Series C Cumulative Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rc-e",
      code: "NYSE:RC-E",
      companyName:
        "Ready Capital Corporation 6.50% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rca",
      code: "NYSE:RCA",
      companyName:
        "Ready Capital Corporation 7.00% Convertible Senior Notes due 2023",
      popularity: 0,
    },
    {
      slug: "nyse-rcac",
      code: "NYSE:RCAC",
      companyName: "Revelstone Capital Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rcacu",
      code: "NYSE:RCACU",
      companyName: "Revelstone Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rcacw",
      code: "NYSE:RCACW",
      companyName: "Revelstone Capital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rcat",
      code: "NYSE:RCAT",
      companyName: "Red Cat Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rcb",
      code: "NYSE:RCB",
      companyName: "Ready Capital Corporation 6.20% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-rcc",
      code: "NYSE:RCC",
      companyName: "Ready Capital Corporation 5.75% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-rcd",
      code: "NYSE:RCD",
      companyName: "Invesco S&P 500 Equal Weight Consumer Discretionary ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rcel",
      code: "NYSE:RCEL",
      companyName: "Avita Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rcfa",
      code: "NYSE:RCFA",
      companyName: "RCF Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-rcg",
      code: "NYSE:RCG",
      companyName: "RENN Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rchg",
      code: "NYSE:RCHG",
      companyName: "Recharge Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rchgu",
      code: "NYSE:RCHGU",
      companyName: "Recharge Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rchgw",
      code: "NYSE:RCHGW",
      companyName: "Recharge Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rci",
      code: "NYSE:RCI",
      companyName: "Rogers Communications Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rcii",
      code: "NYSE:RCII",
      companyName: "Rent-A-Center Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rckt",
      code: "NYSE:RCKT",
      companyName: "Rocket Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rcky",
      code: "NYSE:RCKY",
      companyName: "Rocky Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rclf",
      code: "NYSE:RCLF",
      companyName: "Rosecliff Acquisition Corp I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rclfu",
      code: "NYSE:RCLFU",
      companyName: "Rosecliff Acquisition Corp I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rclfw",
      code: "NYSE:RCLFW",
      companyName: "Rosecliff Acquisition Corp I Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-rcm",
      code: "NYSE:RCM",
      companyName: "R1 RCM Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rcmt",
      code: "NYSE:RCMT",
      companyName: "RCM Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rcon",
      code: "NYSE:RCON",
      companyName: "Recon Technology Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rcor",
      code: "NYSE:RCOR",
      companyName: "Renovacor Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rcrt",
      code: "NYSE:RCRT",
      companyName: "Recruiter.com Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rcrtw",
      code: "NYSE:RCRTW",
      companyName: "Recruiter.com Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rcs",
      code: "NYSE:RCS",
      companyName: "PIMCO STRATEGIC INCOME FUND INC.",
      popularity: 0,
    },
    {
      slug: "nyse-rcus",
      code: "NYSE:RCUS",
      companyName: "Arcus Biosciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rdcm",
      code: "NYSE:RDCM",
      companyName: "Radcom Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-rdfi",
      code: "NYSE:RDFI",
      companyName: "Rareview Dynamic Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rdfn",
      code: "NYSE:RDFN",
      companyName: "Redfin Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rdhl",
      code: "NYSE:RDHL",
      companyName: "Redhill Biopharma Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-rdi",
      code: "NYSE:RDI",
      companyName: "Reading International Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rdib",
      code: "NYSE:RDIB",
      companyName: "Reading International Inc (Class B",
      popularity: 0,
    },
    {
      slug: "nyse-rdiv",
      code: "NYSE:RDIV",
      companyName: "Invesco S&P Ultra Dividend Revenue ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rdmx",
      code: "NYSE:RDMX",
      companyName: "SPDR Bloomberg SASB Developed Markets Ex US ESG Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rdn",
      code: "NYSE:RDN",
      companyName: "Radian Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rdnt",
      code: "NYSE:RDNT",
      companyName: "RadNet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rdog",
      code: "NYSE:RDOG",
      companyName: "ALPS REIT Dividend Dogs ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rdvt",
      code: "NYSE:RDVT",
      companyName: "Red Violet Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rdvy",
      code: "NYSE:RDVY",
      companyName: "First Trust Rising Dividend Achievers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rdw",
      code: "NYSE:RDW",
      companyName: "Redwire Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-rdwr",
      code: "NYSE:RDWR",
      companyName: "Radware Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-rdy",
      code: "NYSE:RDY",
      companyName:
        "Dr. Reddy's Laboratories Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-re",
      code: "NYSE:RE",
      companyName: "Everest Re Group Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-real",
      code: "NYSE:REAL",
      companyName: "The RealReal Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-reax",
      code: "NYSE:REAX",
      companyName: "REAL BROKERAGE INC",
      popularity: 0,
    },
    {
      slug: "nyse-rebn",
      code: "NYSE:REBN",
      companyName: "Reborn Coffee Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rec",
      code: "NYSE:REC",
      companyName: "Emles Real Estate Credit ETF",
      popularity: 0,
    },
    {
      slug: "nyse-recs",
      code: "NYSE:RECS",
      companyName: "Columbia Research Enhanced Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ree",
      code: "NYSE:REE",
      companyName: "REE Automotive Ltd. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-reeaw",
      code: "NYSE:REEAW",
      companyName: "REE Automotive Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-reed",
      code: "NYSE:REED",
      companyName: "Reeds Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-reet",
      code: "NYSE:REET",
      companyName: "iShares Global REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-refi",
      code: "NYSE:REFI",
      companyName: "Chicago Atlantic Real Estate Finance Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-refr",
      code: "NYSE:REFR",
      companyName: "Research Frontiers Inc",
      popularity: 0,
    },
    {
      slug: "nyse-reg",
      code: "NYSE:REG",
      companyName: "Regency Centers Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-regl",
      code: "NYSE:REGL",
      companyName: "ProShares S&P MidCap 400 Dividend Aristocrats ETF",
      popularity: 0,
    },
    {
      slug: "nyse-regn",
      code: "NYSE:REGN",
      companyName: "Regeneron Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rei",
      code: "NYSE:REI",
      companyName: "Ring Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rek",
      code: "NYSE:REK",
      companyName: "ProShares Short Real Estate",
      popularity: 0,
    },
    {
      slug: "nyse-rekr",
      code: "NYSE:REKR",
      companyName: "Rekor Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-reli",
      code: "NYSE:RELI",
      companyName: "Reliance Global Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-reliw",
      code: "NYSE:RELIW",
      companyName: "Reliance Global Group Inc. Series A Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-rell",
      code: "NYSE:RELL",
      companyName: "Richardson Electronics Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-rely",
      code: "NYSE:RELY",
      companyName: "Remitly Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rem",
      code: "NYSE:REM",
      companyName: "iShares Mortgage Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-remg",
      code: "NYSE:REMG",
      companyName: "SPDR Bloomberg SASB Emerging Markets ESG Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-remx",
      code: "NYSE:REMX",
      companyName: "VanEck Rare Earth/Strategic Metals ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rene",
      code: "NYSE:RENE",
      companyName: "Cartesian Growth Corporation II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-reneu",
      code: "NYSE:RENEU",
      companyName: "Cartesian Growth Corporation II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-renew",
      code: "NYSE:RENEW",
      companyName: "Cartesian Growth Corporation II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-renn",
      code: "NYSE:RENN",
      companyName:
        "Renren Inc. American Depositary Share (each representing forty-five (45) Class A Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-rent",
      code: "NYSE:RENT",
      companyName: "Rent the Runway Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-renw",
      code: "NYSE:RENW",
      companyName: "Harbor Energy Transition Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-repl",
      code: "NYSE:REPL",
      companyName: "Replimune Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-repx",
      code: "NYSE:REPX",
      companyName: "Riley Exploration Permian Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rere",
      code: "NYSE:RERE",
      companyName:
        "ATRenew Inc. American Depositary Shares (every three of which representing two Class A ordinary shar",
      popularity: 0,
    },
    {
      slug: "nyse-res",
      code: "NYSE:RES",
      companyName: "RPC Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-resd",
      code: "NYSE:RESD",
      companyName: "WisdomTree International ESG Fund",
      popularity: 0,
    },
    {
      slug: "nyse-rese",
      code: "NYSE:RESE",
      companyName: "WisdomTree Emerging Markets ESG Fund",
      popularity: 0,
    },
    {
      slug: "nyse-resi",
      code: "NYSE:RESI",
      companyName: "Kelly Residential & Apartment Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-resp",
      code: "NYSE:RESP",
      companyName: "WisdomTree U.S. ESG Fund",
      popularity: 0,
    },
    {
      slug: "nyse-reta",
      code: "NYSE:RETA",
      companyName: "Reata Pharmaceuticals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-retl",
      code: "NYSE:RETL",
      companyName: "Direxion Daily Retail Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-reto",
      code: "NYSE:RETO",
      companyName: "ReTo Eco-Solutions Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-reun",
      code: "NYSE:REUN",
      companyName: "Reunion Neuroscience Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rev",
      code: "NYSE:REV",
      companyName: "Revlon Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-revb",
      code: "NYSE:REVB",
      companyName: "Revelation Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-revbu",
      code: "NYSE:REVBU",
      companyName: "Revelation Biosciences Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-revbw",
      code: "NYSE:REVBW",
      companyName: "Revelation Biosciences Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-reve",
      code: "NYSE:REVE",
      companyName: "Alpine Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-reveu",
      code: "NYSE:REVEU",
      companyName: "Alpine Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-revew",
      code: "NYSE:REVEW",
      companyName: "Alpine Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-revg",
      code: "NYSE:REVG",
      companyName: "REV Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-revh",
      code: "NYSE:REVH",
      companyName:
        "Revolution Healthcare Acquisition Corp. SAIL Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-revhu",
      code: "NYSE:REVHU",
      companyName: "Revolution Healthcare Acquisition Corp. SAIL Units",
      popularity: 0,
    },
    {
      slug: "nyse-revhw",
      code: "NYSE:REVHW",
      companyName: "Revolution Healthcare Acquisition Corp. SAIL Warrant.",
      popularity: 0,
    },
    {
      slug: "nyse-revs",
      code: "NYSE:REVS",
      companyName: "Columbia Research Enhanced Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rew",
      code: "NYSE:REW",
      companyName: "Proshares UltraShort Technology",
      popularity: 0,
    },
    {
      slug: "nyse-rex",
      code: "NYSE:REX",
      companyName: "REX American Resources Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-rexr-b",
      code: "NYSE:REXR-B",
      companyName:
        "Rexford Industrial Realty Inc. 5.875% Series B Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rexr-c",
      code: "NYSE:REXR-C",
      companyName:
        "Rexford Industrial Realty Inc. 5.625% Series C Cumulative Redeemable Preferred Stock par value $0.",
      popularity: 0,
    },
    {
      slug: "nyse-reyn",
      code: "NYSE:REYN",
      companyName: "Reynolds Consumer Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rez",
      code: "NYSE:REZ",
      companyName: "iShares Residential and Multisector Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rezi",
      code: "NYSE:REZI",
      companyName: "Resideo Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rf",
      code: "NYSE:RF",
      companyName: "Regions Financial Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-rf-b",
      code: "NYSE:RF-B",
      companyName: "REGIONS FINANCIAL CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-rf-c",
      code: "NYSE:RF-C",
      companyName:
        "Regions Financial Corporation Depositary Shares each Representing a 1/40th Interest in a Share of 5",
      popularity: 0,
    },
    {
      slug: "nyse-rf-e",
      code: "NYSE:RF-E",
      companyName:
        "Regions Financial Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of 4",
      popularity: 0,
    },
    {
      slug: "nyse-rfac",
      code: "NYSE:RFAC",
      companyName: "RF Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rfacr",
      code: "NYSE:RFACR",
      companyName: "RF Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-rfacu",
      code: "NYSE:RFACU",
      companyName: "RF Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rfacw",
      code: "NYSE:RFACW",
      companyName: "RF Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-rfci",
      code: "NYSE:RFCI",
      companyName: "RiverFront Dynamic Core Income",
      popularity: 0,
    },
    {
      slug: "nyse-rfda",
      code: "NYSE:RFDA",
      companyName: "RiverFront Dynamic US Dividend Advantage ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rfdi",
      code: "NYSE:RFDI",
      companyName: "First Trust RiverFront Dynamic Developed International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rfem",
      code: "NYSE:RFEM",
      companyName: "First Trust RiverFront Dynamic Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rfeu",
      code: "NYSE:RFEU",
      companyName: "First Trust RiverFront Dynamic Europe ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rffc",
      code: "NYSE:RFFC",
      companyName: "RiverFront Dynamic US Flex-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rfg",
      code: "NYSE:RFG",
      companyName: "Invesco S&P MidCap 400 Pure Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rfi",
      code: "NYSE:RFI",
      companyName: "Cohen and Steers Total Return Realty Fund",
      popularity: 0,
    },
    {
      slug: "nyse-rfl",
      code: "NYSE:RFL",
      companyName: "Rafael Holdings Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rfm",
      code: "NYSE:RFM",
      companyName: "RiverNorth Flexible Municipal Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rfmz",
      code: "NYSE:RFMZ",
      companyName: "RiverNorth Flexible Municipal Income Fund II Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rfp",
      code: "NYSE:RFP",
      companyName: "Resolute Forest Products Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rfv",
      code: "NYSE:RFV",
      companyName: "Invesco S&P MidCap 400 Pure Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rga",
      code: "NYSE:RGA",
      companyName: "Reinsurance Group of America Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-rgc",
      code: "NYSE:RGC",
      companyName: "Regencell Bioscience Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rgco",
      code: "NYSE:RGCO",
      companyName: "RGC Resources Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rgen",
      code: "NYSE:RGEN",
      companyName: "Repligen Corp",
      popularity: 0,
    },
    {
      slug: "nyse-rgf",
      code: "NYSE:RGF",
      companyName: "The Real Good Food Company Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rgi",
      code: "NYSE:RGI",
      companyName: "Invesco S&P 500 Equal Weight Industrials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rgld",
      code: "NYSE:RGLD",
      companyName: "Royal Gold Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rgls",
      code: "NYSE:RGLS",
      companyName: "Regulus Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rgnx",
      code: "NYSE:RGNX",
      companyName: "REGENXBIO Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rgp",
      code: "NYSE:RGP",
      companyName: "Resources Connection",
      popularity: 0,
    },
    {
      slug: "nyse-rgr",
      code: "NYSE:RGR",
      companyName: "Sturm Ruger & Company Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rgs",
      code: "NYSE:RGS",
      companyName: "Regis Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-rgt",
      code: "NYSE:RGT",
      companyName: "Royce Global Value Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rig",
      code: "NYSE:RIG",
      companyName: "Transocean LTD.",
      popularity: 0,
    },
    {
      slug: "nyse-rgtiw",
      code: "NYSE:RGTIW",
      companyName: "Rigetti Computing Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-rh",
      code: "NYSE:RH",
      companyName: "RH",
      popularity: 0,
    },
    {
      slug: "nyse-rhcb",
      code: "NYSE:RHCB",
      companyName: "BNY Mellon Responsible Horizons Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rhe",
      code: "NYSE:RHE",
      companyName: "Regional Health Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rhe-a",
      code: "NYSE:RHE-A",
      companyName:
        "Regional Health Properties Inc. Regional Health Properties Inc. 10.875 percent Series A Cumulative",
      popularity: 0,
    },
    {
      slug: "nyse-rhi",
      code: "NYSE:RHI",
      companyName: "Robert Half International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rhp",
      code: "NYSE:RHP",
      companyName: "Ryman Hospitality Properties Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rhrx",
      code: "NYSE:RHRX",
      companyName: "RH Tactical Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rhs",
      code: "NYSE:RHS",
      companyName: "Invesco S&P 500 Equal Weight Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rhtx",
      code: "NYSE:RHTX",
      companyName: "RH Tactical Outlook ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ribt",
      code: "NYSE:RIBT",
      companyName: "RiceBran Technologies",
      popularity: 0,
    },
    {
      slug: "nyse-rick",
      code: "NYSE:RICK",
      companyName: "RCI Hospitality Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ride",
      code: "NYSE:RIDE",
      companyName: "Lordstown Motors Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-riet",
      code: "NYSE:RIET",
      companyName: "Hoya Capital High Dividend Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rigl",
      code: "NYSE:RIGL",
      companyName: "Rigel Pharmaceuticals Inc. (New)",
      popularity: 0,
    },
    {
      slug: "nyse-rigs",
      code: "NYSE:RIGS",
      companyName: "RiverFront Strategic Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-rigz",
      code: "NYSE:RIGZ",
      companyName: "Viridi Bitcoin Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rily",
      code: "NYSE:RILY",
      companyName: "B. RILEY FINANCIAL INC.",
      popularity: 0,
    },
    {
      slug: "nyse-rilyg",
      code: "NYSE:RILYG",
      companyName: "B. Riley Financial Inc. 5.00% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-rilyk",
      code: "NYSE:RILYK",
      companyName: "B. Riley Financial Inc. 5.50% Senior Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-rilyl",
      code: "NYSE:RILYL",
      companyName:
        "B. Riley Financial Inc. Depositary Shares each representing 1/1000th in a share of 7.375% Series B",
      popularity: 0,
    },
    {
      slug: "nyse-rilym",
      code: "NYSE:RILYM",
      companyName: "B. Riley Financial Inc. 6.375% Senior Notes due 2025",
      popularity: 0,
    },
    {
      slug: "nyse-rilyn",
      code: "NYSE:RILYN",
      companyName: "B. Riley Financial Inc. 6.50% Senior Notes Due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-rilyo",
      code: "NYSE:RILYO",
      companyName: "B. Riley Financial Inc. 6.75% Senior Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nyse-rilyp",
      code: "NYSE:RILYP",
      companyName:
        "B. Riley Financial Inc. Depositary Shares each representing a 1/1000th fractional interest in a sh",
      popularity: 0,
    },
    {
      slug: "nyse-rilyt",
      code: "NYSE:RILYT",
      companyName: "B. Riley Financial Inc. 6.00% Senior Notes Due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-rilyz",
      code: "NYSE:RILYZ",
      companyName: "B. Riley Financial Inc. 5.25% Senior Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-rinf",
      code: "NYSE:RINF",
      companyName: "ProShares Inflation Expectations ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ring",
      code: "NYSE:RING",
      companyName: "iShares MSCI Global Gold Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-risn",
      code: "NYSE:RISN",
      companyName: "Inspire Tactical Balanced ETF",
      popularity: 0,
    },
    {
      slug: "nyse-risr",
      code: "NYSE:RISR",
      companyName: "FolioBeyond Rising Rate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rita",
      code: "NYSE:RITA",
      companyName: "ETFB Green SRI REITs ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ritm",
      code: "NYSE:RITM",
      companyName: "Rithm Capital Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ritm-a",
      code: "NYSE:RITM-A",
      companyName:
        "Rithm Capital Corp.7.50% Series A Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ritm-b",
      code: "NYSE:RITM-B",
      companyName:
        "Rithm Capital Corp. 7.125% Series B Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ritm-c",
      code: "NYSE:RITM-C",
      companyName:
        "Rithm Capital Corp. 6.375% Series C Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ritm-d",
      code: "NYSE:RITM-D",
      companyName:
        "Rithm Capital Corp. 7.00% Fixed-Rate Reset Series D Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-riv",
      code: "NYSE:RIV",
      companyName: "RiverNorth Opportunities Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-riv-a",
      code: "NYSE:RIV-A",
      companyName:
        "RiverNorth Opportunities Fund Inc. 6.00% Series A Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rivn",
      code: "NYSE:RIVN",
      companyName: "Rivian Automotive Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rja",
      code: "NYSE:RJA",
      companyName:
        "AB Svensk Ekportkredit ELEMENTS Linked to the Rogers International Commodity Index-Agriculture Total",
      popularity: 0,
    },
    {
      slug: "nyse-rjac",
      code: "NYSE:RJAC",
      companyName: "Jackson Acquisition Company",
      popularity: 0,
    },
    {
      slug: "nyse-rjf",
      code: "NYSE:RJF",
      companyName: "Raymond James Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rjf-a",
      code: "NYSE:RJF-A",
      companyName:
        "Raymond James Financial Inc. Depositary Shares each representing a 1/40th interest in a share of 6",
      popularity: 0,
    },
    {
      slug: "nyse-rjf-b",
      code: "NYSE:RJF-B",
      companyName:
        "Raymond James Financial Inc. Depositary Shares each representing a 1/40th interest in a share of 6",
      popularity: 0,
    },
    {
      slug: "nyse-rji",
      code: "NYSE:RJI",
      companyName:
        "AB Svensk Ekportkredit ELEMENTS Linked to the Rogers International Commodity Index-Total Return",
      popularity: 0,
    },
    {
      slug: "nyse-rjn",
      code: "NYSE:RJN",
      companyName:
        "AB Svensk Ekportkredit ELEMENTS Linked to the Rogers International Commodity Index-Energy Total Retu",
      popularity: 0,
    },
    {
      slug: "nyse-rjz",
      code: "NYSE:RJZ",
      companyName:
        "AB Svensk Ekportkredit ELEMENTS Linked to the Rogers International Commodity Index-Metals Total Retu",
      popularity: 0,
    },
    {
      slug: "nyse-rkda",
      code: "NYSE:RKDA",
      companyName: "Arcadia Biosciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rklb",
      code: "NYSE:RKLB",
      companyName: "Rocket Lab USA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rkly",
      code: "NYSE:RKLY",
      companyName: "Rockley Photonics Holdings Limited",
      popularity: 0,
    },
    {
      slug: "nyse-rkt",
      code: "NYSE:RKT",
      companyName: "Rocket Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rkta",
      code: "NYSE:RKTA",
      companyName: "Rocket Internet Growth Opportunities Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-rl",
      code: "NYSE:RL",
      companyName: "Ralph Lauren Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-rlay",
      code: "NYSE:RLAY",
      companyName: "Relay Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rlgt",
      code: "NYSE:RLGT",
      companyName: "Radiant Logistics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rli",
      code: "NYSE:RLI",
      companyName: "RLI Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-rlj",
      code: "NYSE:RLJ",
      companyName: "RLJ Lodging Trust",
      popularity: 0,
    },
    {
      slug: "nyse-rlj-a",
      code: "NYSE:RLJ-A",
      companyName:
        "RLJ Lodging Trust $1.95 Series A Cumulative Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rlmd",
      code: "NYSE:RLMD",
      companyName: "Relmada Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rlty",
      code: "NYSE:RLTY",
      companyName: "Cohen & Steers Real Estate Opportunities and Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-rlx",
      code: "NYSE:RLX",
      companyName:
        "RLX Technology Inc. American Depositary Shares each representing the right to receive one (1) Class",
      popularity: 0,
    },
    {
      slug: "nyse-rly",
      code: "NYSE:RLY",
      companyName: "SPDR SSgA Multi-Asset Real Return ETF of SSgA Active Trust",
      popularity: 0,
    },
    {
      slug: "nyse-rlyb",
      code: "NYSE:RLYB",
      companyName: "Rallybio Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rm",
      code: "NYSE:RM",
      companyName: "REGIONAL MANAGEMENT CORP",
      popularity: 0,
    },
    {
      slug: "nyse-rmax",
      code: "NYSE:RMAX",
      companyName: "RE/MAX HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-rmbi",
      code: "NYSE:RMBI",
      companyName: "Richmond Mutual Bancorporation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rmbl",
      code: "NYSE:RMBL",
      companyName: "RumbleOn Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rmbs",
      code: "NYSE:RMBS",
      companyName: "Rambus Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rmcf",
      code: "NYSE:RMCF",
      companyName: "Rocky Mountain Chocolate Factory Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rnrg",
      code: "NYSE:RNRG",
      companyName: "Global X Funds Global X Renewable Energy Producers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-robo",
      code: "NYSE:ROBO",
      companyName: "ROBO Global Robotics & Automation Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rmed",
      code: "NYSE:RMED",
      companyName: "Ra Medical Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rmgc",
      code: "NYSE:RMGC",
      companyName: "RMG Acquisition Corp. III Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rmgcu",
      code: "NYSE:RMGCU",
      companyName: "RMG Acquisition Corp. III Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rmgcw",
      code: "NYSE:RMGCW",
      companyName: "RMG Acquisition Corp. III Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rmi",
      code: "NYSE:RMI",
      companyName:
        "RiverNorth Opportunistic Municipal Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rmm",
      code: "NYSE:RMM",
      companyName: "RiverNorth Managed Duration Municipal Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rmmz",
      code: "NYSE:RMMZ",
      companyName: "RiverNorth Managed Duration Municipal Income Fund II Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rmni",
      code: "NYSE:RMNI",
      companyName: "Rimini Street Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rmo",
      code: "NYSE:RMO",
      companyName: "Romeo Power Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rmpl-",
      code: "NYSE:RMPL-",
      companyName:
        "RiverNorth Specialty Finance Corporation 5.875%% Series A Term Preferred Stock $0.0001 par value per",
      popularity: 0,
    },
    {
      slug: "nyse-rmr",
      code: "NYSE:RMR",
      companyName: "The RMR Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rmt",
      code: "NYSE:RMT",
      companyName: "Royce Micro-Cap Trust Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rmti",
      code: "NYSE:RMTI",
      companyName: "Rockwell Medical Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rna",
      code: "NYSE:RNA",
      companyName: "Avidity Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rnaz",
      code: "NYSE:RNAZ",
      companyName: "TransCode Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rndb",
      code: "NYSE:RNDB",
      companyName: "Randolph Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rndm",
      code: "NYSE:RNDM",
      companyName: "First Trust Developed International Equity Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rndv",
      code: "NYSE:RNDV",
      companyName: "First Trust US Equity Dividend Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rnem",
      code: "NYSE:RNEM",
      companyName: "First Trust Emerging Markets Equity Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rner",
      code: "NYSE:RNER",
      companyName: "Mount Rainier Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rneru",
      code: "NYSE:RNERU",
      companyName: "Mount Rainier Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rnerw",
      code: "NYSE:RNERW",
      companyName: "Mount Rainier Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rng",
      code: "NYSE:RNG",
      companyName: "RINGCENTRAL INC.",
      popularity: 0,
    },
    {
      slug: "nyse-rngr",
      code: "NYSE:RNGR",
      companyName: "Ranger Energy Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rnlc",
      code: "NYSE:RNLC",
      companyName: "First Trust Large Cap US Equity Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rnlx",
      code: "NYSE:RNLX",
      companyName: "Renalytix plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rnmc",
      code: "NYSE:RNMC",
      companyName: "First Trust Mid Cap US Equity Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rnp",
      code: "NYSE:RNP",
      companyName: "Cohen & Steers REIT and Preferred and Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rnr-f",
      code: "NYSE:RNR-F",
      companyName:
        "RenaissanceRe Holdings Ltd. Depositary Shares each Representing a 1/1000th Interest in a 5.750% Se",
      popularity: 0,
    },
    {
      slug: "nyse-rnr-g",
      code: "NYSE:RNR-G",
      companyName:
        "RenaissanceRe Holdings Ltd. Depositary Shares each representing a 1/1 000th interest in a share of",
      popularity: 0,
    },
    {
      slug: "nyse-rnst",
      code: "NYSE:RNST",
      companyName: "Renasant Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-rnw",
      code: "NYSE:RNW",
      companyName: "ReNew Energy Global plc Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rnwk",
      code: "NYSE:RNWK",
      companyName: "RealNetworks Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rnwww",
      code: "NYSE:RNWWW",
      companyName: "ReNew Energy Global plc Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rnxt",
      code: "NYSE:RNXT",
      companyName: "RenovoRx Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-road",
      code: "NYSE:ROAD",
      companyName: "Construction Partners Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-roam",
      code: "NYSE:ROAM",
      companyName: "Hartford Multifactor Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-robt",
      code: "NYSE:ROBT",
      companyName:
        "First Trust Nasdaq Artificial Intelligence and Robotics ETF",
      popularity: 0,
    },
    {
      slug: "nyse-roc",
      code: "NYSE:ROC",
      companyName: "ROC Energy Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rocar",
      code: "NYSE:ROCAR",
      companyName: "ROC Energy Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-rocau",
      code: "NYSE:ROCAU",
      companyName: "ROC Energy Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rocc",
      code: "NYSE:ROCC",
      companyName: "Ranger Oil Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rocg",
      code: "NYSE:ROCG",
      companyName: "Roth CH Acquisition IV Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rocgu",
      code: "NYSE:ROCGU",
      companyName: "Roth CH Acquisition IV Co. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rocgw",
      code: "NYSE:ROCGW",
      companyName: "Roth CH Acquisition IV Co. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-roci",
      code: "NYSE:ROCI",
      companyName: "ROC ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rock",
      code: "NYSE:ROCK",
      companyName: "Gibraltar Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rocl",
      code: "NYSE:ROCL",
      companyName: "Roth CH Acquisition V Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-roclu",
      code: "NYSE:ROCLU",
      companyName: "Roth CH Acquisition V Co. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-roclw",
      code: "NYSE:ROCLW",
      companyName: "Roth CH Acquisition V Co. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rode",
      code: "NYSE:RODE",
      companyName: "Hartford Multifactor Diversified International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rodi",
      code: "NYSE:RODI",
      companyName: "iPath Return on Disability ETN",
      popularity: 0,
    },
    {
      slug: "nyse-rodm",
      code: "NYSE:RODM",
      companyName: "Hartford Multifactor Developed Markets (ex-US) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rog",
      code: "NYSE:ROG",
      companyName: "Rogers Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-roic",
      code: "NYSE:ROIC",
      companyName: "Retail Opportunity Investments Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-roiv",
      code: "NYSE:ROIV",
      companyName: "Roivant Sciences Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-roivw",
      code: "NYSE:ROIVW",
      companyName: "Roivant Sciences Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rokt",
      code: "NYSE:ROKT",
      companyName: "SPDR S&P Kensho Final Frontiers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-roku",
      code: "NYSE:ROKU",
      companyName: "Roku Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rol",
      code: "NYSE:ROL",
      companyName: "Rollins Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-roll",
      code: "NYSE:ROLL",
      companyName: "RBC Bearings Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-rollp",
      code: "NYSE:ROLLP",
      companyName:
        "RBC Bearings Incorporated 5.00% Series A Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rom",
      code: "NYSE:ROM",
      companyName: "ProShares Ultra Technology",
      popularity: 0,
    },
    {
      slug: "nyse-romo",
      code: "NYSE:ROMO",
      companyName: "Strategy Shares Newfound/ReSolve Robust Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-roni",
      code: "NYSE:RONI",
      companyName: "Rice Acquisition Corp. II",
      popularity: 0,
    },
    {
      slug: "nyse-roof",
      code: "NYSE:ROOF",
      companyName: "IQ US REAL ESTATE SMALL CAP ETF",
      popularity: 0,
    },
    {
      slug: "nyse-root",
      code: "NYSE:ROOT",
      companyName: "Root Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rop",
      code: "NYSE:ROP",
      companyName: "Roper Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-roro",
      code: "NYSE:RORO",
      companyName: "ATAC US Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rosc",
      code: "NYSE:ROSC",
      companyName: "Hartford Multifactor Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rose",
      code: "NYSE:ROSE",
      companyName: "Rose Hill Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-roseu",
      code: "NYSE:ROSEU",
      companyName: "Rose Hill Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rosew",
      code: "NYSE:ROSEW",
      companyName: "Rose Hill Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ross",
      code: "NYSE:ROSS",
      companyName: "Ross Acquisition Corp II",
      popularity: 0,
    },
    {
      slug: "nyse-rous",
      code: "NYSE:ROUS",
      companyName: "Hartford Multifactor US Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rovr",
      code: "NYSE:ROVR",
      companyName: "Rover Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rpar",
      code: "NYSE:RPAR",
      companyName: "RPAR Risk Parity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rpay",
      code: "NYSE:RPAY",
      companyName: "Repay Holdings Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rpd",
      code: "NYSE:RPD",
      companyName: "Rapid7 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rpg",
      code: "NYSE:RPG",
      companyName: "Invesco S&P 500 Pure Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rphm",
      code: "NYSE:RPHM",
      companyName: "Reneo Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rphs",
      code: "NYSE:RPHS",
      companyName: "Regents Park Hedged Market Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rpid",
      code: "NYSE:RPID",
      companyName: "Rapid Micro Biosystems Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rpm",
      code: "NYSE:RPM",
      companyName: "RPM International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rprx",
      code: "NYSE:RPRX",
      companyName: "Royalty Pharma plc Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rtx",
      code: "NYSE:RTX",
      companyName: "Raytheon Technologies Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-rptx",
      code: "NYSE:RPTX",
      companyName: "Repare Therapeutics Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rpv",
      code: "NYSE:RPV",
      companyName: "Invesco S&P 500 Pure Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rqi",
      code: "NYSE:RQI",
      companyName:
        "COHEN & STEERS QUALITY INCOME REALTY FUND INC. COMMON SHARES",
      popularity: 0,
    },
    {
      slug: "nyse-rrac",
      code: "NYSE:RRAC",
      companyName: "Rigel Resource Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-rrbi",
      code: "NYSE:RRBI",
      companyName: "Red River Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rrc",
      code: "NYSE:RRC",
      companyName: "Range Resources Corp",
      popularity: 0,
    },
    {
      slug: "nyse-rrgb",
      code: "NYSE:RRGB",
      companyName: "Red Robin Gourmet Burgers Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rrr",
      code: "NYSE:RRR",
      companyName: "Red Rock Resorts Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rrx",
      code: "NYSE:RRX",
      companyName: "Regal Rexnord Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-rsee",
      code: "NYSE:RSEE",
      companyName: "Rareview Systematic Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rsf",
      code: "NYSE:RSF",
      companyName: "RiverNorth Specialty Finance Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-rsg",
      code: "NYSE:RSG",
      companyName: "Republic Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rsi",
      code: "NYSE:RSI",
      companyName: "Rush Street Interactive Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rskd",
      code: "NYSE:RSKD",
      companyName: "Riskified Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-rsls",
      code: "NYSE:RSLS",
      companyName: "ReShape Lifesciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rsp",
      code: "NYSE:RSP",
      companyName: "Invesco S&P 500 Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rspe",
      code: "NYSE:RSPE",
      companyName: "Invesco ESG S&P 500 Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rspy",
      code: "NYSE:RSPY",
      companyName: "Revere Sector Opportunity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rsss",
      code: "NYSE:RSSS",
      companyName: "RESEARCH SOLUTIONS INC",
      popularity: 0,
    },
    {
      slug: "nyse-rsvr",
      code: "NYSE:RSVR",
      companyName: "Reservoir Media Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rsvrw",
      code: "NYSE:RSVRW",
      companyName: "Reservoir Media Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rsx",
      code: "NYSE:RSX",
      companyName: "VanEck Russia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rsxj",
      code: "NYSE:RSXJ",
      companyName: "VanEck Russia Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rtai",
      code: "NYSE:RTAI",
      companyName: "Rareview Tax Advantaged Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rth",
      code: "NYSE:RTH",
      companyName: "VanEck Retail ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rtl",
      code: "NYSE:RTL",
      companyName: "The Necessity Retail REIT Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rtlpo",
      code: "NYSE:RTLPO",
      companyName:
        "The Necessity Retail REIT Inc. 7.375% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rtlpp",
      code: "NYSE:RTLPP",
      companyName:
        "The Necessity Retail REIT Inc. 7.50% Series A Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rtlr",
      code: "NYSE:RTLR",
      companyName: "Rattler Midstream LP Common Units",
      popularity: 0,
    },
    {
      slug: "nyse-rtm",
      code: "NYSE:RTM",
      companyName: "Invesco S&P 500 Equal Weight Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rtyd",
      code: "NYSE:RTYD",
      companyName: "Simplify US Small Cap PLUS Downside Convexity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ruby",
      code: "NYSE:RUBY",
      companyName: "Rubius Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ruff",
      code: "NYSE:RUFF",
      companyName: "Alpha Dog ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rule",
      code: "NYSE:RULE",
      companyName: "Adaptive Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-run",
      code: "NYSE:RUN",
      companyName: "Sunrun Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rusha",
      code: "NYSE:RUSHA",
      companyName: "Rush Enterprises Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rrh",
      code: "NYSE:RRH",
      companyName: "Advocate Rising Rate Hedge ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rs",
      code: "NYSE:RS",
      companyName: "Reliance Steel & Aluminium Co.",
      popularity: 0,
    },
    {
      slug: "nyse-rushb",
      code: "NYSE:RUSHB",
      companyName: "Rush Enterprises Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ruth",
      code: "NYSE:RUTH",
      companyName: "Ruth's Hospitality Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rvac",
      code: "NYSE:RVAC",
      companyName: "Riverview Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rvacu",
      code: "NYSE:RVACU",
      companyName: "Riverview Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rvacw",
      code: "NYSE:RVACW",
      companyName: "Riverview Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rvlp",
      code: "NYSE:RVLP",
      companyName: "RVL Pharmaceuticals plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-rvlv",
      code: "NYSE:RVLV",
      companyName: "Revolve Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rvmd",
      code: "NYSE:RVMD",
      companyName: "Revolution Medicines Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rvnc",
      code: "NYSE:RVNC",
      companyName: "Revance Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rvnu",
      code: "NYSE:RVNU",
      companyName: "Xtrackers Municipal Infrastructure Revenue Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rvp",
      code: "NYSE:RVP",
      companyName: "Retractable Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rvph",
      code: "NYSE:RVPH",
      companyName: "Reviva Pharmaceuticals Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rvphw",
      code: "NYSE:RVPHW",
      companyName: "Reviva Pharmaceuticals Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-rvsb",
      code: "NYSE:RVSB",
      companyName: "Riverview Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-rvsn",
      code: "NYSE:RVSN",
      companyName: "Rail Vision Ltd. Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-rvsnw",
      code: "NYSE:RVSNW",
      companyName: "Rail Vision Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-rvt",
      code: "NYSE:RVT",
      companyName: "Royce Value Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rway",
      code: "NYSE:RWAY",
      companyName: "Runway Growth Finance Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rwayl",
      code: "NYSE:RWAYL",
      companyName: "Runway Growth Finance Corp. 7.50% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nyse-rwgv",
      code: "NYSE:RWGV",
      companyName: "Direxion Russell 1000 Growth Over Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rwj",
      code: "NYSE:RWJ",
      companyName: "Invesco S&P SmallCap 600 Revenue ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rwk",
      code: "NYSE:RWK",
      companyName: "Invesco S&P MidCap 400 Revenue ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rwl",
      code: "NYSE:RWL",
      companyName: "Invesco S&P 500 Revenue ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rwlk",
      code: "NYSE:RWLK",
      companyName: "ReWalk Robotics Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-rwm",
      code: "NYSE:RWM",
      companyName: "ProShares Short Russell2000",
      popularity: 0,
    },
    {
      slug: "nyse-rwo",
      code: "NYSE:RWO",
      companyName: "SPDR  Dow Jones  Global Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rwod",
      code: "NYSE:RWOD",
      companyName: "Redwoods Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rwodr",
      code: "NYSE:RWODR",
      companyName: "Redwoods Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-rwodu",
      code: "NYSE:RWODU",
      companyName: "Redwoods Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-rwodw",
      code: "NYSE:RWODW",
      companyName: "Redwoods Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-rwt",
      code: "NYSE:RWT",
      companyName: "Redwood Trust Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rwvg",
      code: "NYSE:RWVG",
      companyName: "Direxion Russell 1000 Value Over Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rwx",
      code: "NYSE:RWX",
      companyName: "SPDR Dow Jones  International Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rxd",
      code: "NYSE:RXD",
      companyName: "ProShares UltraShort Health Care",
      popularity: 0,
    },
    {
      slug: "nyse-rxdx",
      code: "NYSE:RXDX",
      companyName: "Prometheus Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rxi",
      code: "NYSE:RXI",
      companyName: "iShares Global Consumer Discretionary ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rxl",
      code: "NYSE:RXL",
      companyName: "ProShares Ultra Health Care",
      popularity: 0,
    },
    {
      slug: "nyse-rxra",
      code: "NYSE:RXRA",
      companyName: "RXR Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rxrau",
      code: "NYSE:RXRAU",
      companyName: "RXR Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-rxraw",
      code: "NYSE:RXRAW",
      companyName:
        "RXR Acquisition Corp. Warrants to purchase Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-rxrx",
      code: "NYSE:RXRX",
      companyName: "Recursion Pharmaceuticals Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rxst",
      code: "NYSE:RXST",
      companyName: "RxSight Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-rxt",
      code: "NYSE:RXT",
      companyName: "Rackspace Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ry",
      code: "NYSE:RY",
      companyName: "Royal Bank of Canada",
      popularity: 0,
    },
    {
      slug: "nyse-ry-t",
      code: "NYSE:RY-T",
      companyName:
        "Royal Bank of Canada Depositary Shares each representing a 1/40th interest in a share of 6.750% Fix",
      popularity: 0,
    },
    {
      slug: "nyse-ryaay",
      code: "NYSE:RYAAY",
      companyName: "Ryanair Holdings plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ryam",
      code: "NYSE:RYAM",
      companyName: "Rayonier Advanced Materials Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ryan",
      code: "NYSE:RYAN",
      companyName: "Ryan Specialty Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-rye",
      code: "NYSE:RYE",
      companyName: "Invesco S&P 500 Equal Weight Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ryf",
      code: "NYSE:RYF",
      companyName: "Invesco S&P 500 Equal Weight Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ryh",
      code: "NYSE:RYH",
      companyName: "Invesco S&P 500 Equal Weight Health Care ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ryi",
      code: "NYSE:RYI",
      companyName: "RYERSON HOLDING CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-ryj",
      code: "NYSE:RYJ",
      companyName: "Invesco Raymond James SB-1 Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ryn",
      code: "NYSE:RYN",
      companyName: "Rayonier Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ryt",
      code: "NYSE:RYT",
      companyName: "Invesco S&P 500 Equal Weight Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rytm",
      code: "NYSE:RYTM",
      companyName: "Rhythm Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ryu",
      code: "NYSE:RYU",
      companyName: "Invesco S&P 500 Equal Weight Utilities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rza",
      code: "NYSE:RZA",
      companyName:
        "REINSURANCE GROUP OF AMERICA INCORPORATED 6.20% Fixed-To-Floating Rate Subordinated Debentures due",
      popularity: 0,
    },
    {
      slug: "nyse-rzb",
      code: "NYSE:RZB",
      companyName:
        "Reinsurance Group of America Incorporated 5.75% Fixed-To-Floating Rate Subordinated Debentures due",
      popularity: 0,
    },
    {
      slug: "nyse-rzg",
      code: "NYSE:RZG",
      companyName: "Invesco S&P SmallCap 600 Pure Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rzlt",
      code: "NYSE:RZLT",
      companyName: "Rezolute Inc. Common Stock (NV)",
      popularity: 0,
    },
    {
      slug: "nyse-rzv",
      code: "NYSE:RZV",
      companyName: "Invesco S&P SmallCap 600 Pure Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-s",
      code: "NYSE:S",
      companyName: "SentinelOne Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sa",
      code: "NYSE:SA",
      companyName: "Seabridge Gold Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-saa",
      code: "NYSE:SAA",
      companyName: "ProShares Ulta SmallCap600",
      popularity: 0,
    },
    {
      slug: "nyse-sabr",
      code: "NYSE:SABR",
      companyName: "Sabre Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-sabrp",
      code: "NYSE:SABRP",
      companyName:
        "Sabre Corporation 6.50% Series A Mandatory Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sabs",
      code: "NYSE:SABS",
      companyName: "SAB Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sabsw",
      code: "NYSE:SABSW",
      companyName: "SAB Biotherapeutics Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sacc",
      code: "NYSE:SACC",
      companyName: "Sachem Capital Corp. 6.875% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nyse-sach",
      code: "NYSE:SACH",
      companyName: "Sachem Capital Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sach-a",
      code: "NYSE:SACH-A",
      companyName:
        "Sachem Capital Corp. 7.75% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-saef",
      code: "NYSE:SAEF",
      companyName: "Schwab Ariel ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-saft",
      code: "NYSE:SAFT",
      companyName: "Safety Insurance Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-saga",
      code: "NYSE:SAGA",
      companyName: "Sagaliam Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sagar",
      code: "NYSE:SAGAR",
      companyName: "Sagaliam Acquisition Corp. Rights",
      popularity: 0,
    },
    {
      slug: "nyse-sagau",
      code: "NYSE:SAGAU",
      companyName: "Sagaliam Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-sage",
      code: "NYSE:SAGE",
      companyName: "Sage Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sagp",
      code: "NYSE:SAGP",
      companyName: "Strategas Global Policy Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sah",
      code: "NYSE:SAH",
      companyName: "Sonic Automotive Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sai",
      code: "NYSE:SAI",
      companyName: "SAI.TECH Global Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-saia",
      code: "NYSE:SAIA",
      companyName: "Saia Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-saic",
      code: "NYSE:SAIC",
      companyName: "SCIENCE APPLICATIONS INTERNATIONAL CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-saitw",
      code: "NYSE:SAITW",
      companyName: "SAI.TECH Global Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sal",
      code: "NYSE:SAL",
      companyName: "Salisbury Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-salm",
      code: "NYSE:SALM",
      companyName: "Salem Media Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sam",
      code: "NYSE:SAM",
      companyName: "Boston Beer Company",
      popularity: 0,
    },
    {
      slug: "nyse-samau",
      code: "NYSE:SAMAU",
      companyName: "Schultze Special Purpose Acquisition Corp. II Units",
      popularity: 0,
    },
    {
      slug: "nyse-samaw",
      code: "NYSE:SAMAW",
      companyName: "Schultze Special Purpose Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-samg",
      code: "NYSE:SAMG",
      companyName: "Silvercrest Asset Management Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-samt",
      code: "NYSE:SAMT",
      companyName: "Strategas Macro Thematic Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-san",
      code: "NYSE:SAN",
      companyName: "Banco Santander S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-sana",
      code: "NYSE:SANA",
      companyName: "Sana Biotechnology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sanb",
      code: "NYSE:SANB",
      companyName: "Sanaby Health Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sanbu",
      code: "NYSE:SANBU",
      companyName: "Sanaby Health Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-sanbw",
      code: "NYSE:SANBW",
      companyName: "Sanaby Health Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sand",
      code: "NYSE:SAND",
      companyName: "Sandstorm Gold Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-sang",
      code: "NYSE:SANG",
      companyName: "Sangoma Technologies Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sanm",
      code: "NYSE:SANM",
      companyName: "Sanmina  Corp",
      popularity: 0,
    },
    {
      slug: "nyse-sanw",
      code: "NYSE:SANW",
      companyName: "S&W Seed Company",
      popularity: 0,
    },
    {
      slug: "nyse-sap",
      code: "NYSE:SAP",
      companyName: "SAP SE",
      popularity: 0,
    },
    {
      slug: "nyse-sar",
      code: "NYSE:SAR",
      companyName: "SARATOGA INVESTMENT CORP. NEW",
      popularity: 0,
    },
    {
      slug: "nyse-sark",
      code: "NYSE:SARK",
      companyName:
        "Investment Managers Series Trust II AXS Short Innovation Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sasi",
      code: "NYSE:SASI",
      companyName: "Sigma Additive Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sasr",
      code: "NYSE:SASR",
      companyName: "Sandy Spring Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sat",
      code: "NYSE:SAT",
      companyName: "Saratoga Investment Corp. 6.00% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nyse-satl",
      code: "NYSE:SATL",
      companyName: "Satellogic Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-satlw",
      code: "NYSE:SATLW",
      companyName: "Satellogic Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sato",
      code: "NYSE:SATO",
      companyName: "Invesco Alerian Galaxy Crypto Economy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sats",
      code: "NYSE:SATS",
      companyName: "EchoStar Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-sava",
      code: "NYSE:SAVA",
      companyName: "Cassava Sciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-save",
      code: "NYSE:SAVE",
      companyName: "Spirit Airlines Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-savn",
      code: "NYSE:SAVN",
      companyName: "LifeGoal Conservative Wealth Builder ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sb",
      code: "NYSE:SB",
      companyName: "Safe Bulkers Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sb-c",
      code: "NYSE:SB-C",
      companyName: "SAFE BULKERS INC. 8.00%  SER C",
      popularity: 0,
    },
    {
      slug: "nyse-sb-d",
      code: "NYSE:SB-D",
      companyName: "Safe Bulkers Inc. 8.00% Series D",
      popularity: 0,
    },
    {
      slug: "nyse-sbac",
      code: "NYSE:SBAC",
      companyName: "SBA Communications Corp",
      popularity: 0,
    },
    {
      slug: "nyse-sbb",
      code: "NYSE:SBB",
      companyName: "ProShares Short SmallCap600",
      popularity: 0,
    },
    {
      slug: "nyse-sbba",
      code: "NYSE:SBBA",
      companyName: "Scorpio Tankers Inc. 7.00% Senior Notes due 2025",
      popularity: 0,
    },
    {
      slug: "nyse-sbcf",
      code: "NYSE:SBCF",
      companyName: "Seacoast Banking Corp of Florida",
      popularity: 0,
    },
    {
      slug: "nyse-sbet",
      code: "NYSE:SBET",
      companyName: "SharpLink Gaming Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sbev",
      code: "NYSE:SBEV",
      companyName: "Splash Beverage Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sbfg",
      code: "NYSE:SBFG",
      companyName: "SB Financial Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sbfm",
      code: "NYSE:SBFM",
      companyName: "Sunshine Biopharma Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sbfmw",
      code: "NYSE:SBFMW",
      companyName: "Sunshine Biopharma Inc. warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sbgi",
      code: "NYSE:SBGI",
      companyName: "Sinclair Broadcast Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sbh",
      code: "NYSE:SBH",
      companyName: "Sally Beauty Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sbi",
      code: "NYSE:SBI",
      companyName: "Western Asset Intermediate Muni Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sbig",
      code: "NYSE:SBIG",
      companyName: "SpringBig Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sbigw",
      code: "NYSE:SBIGW",
      companyName: "SpringBig Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sbii",
      code: "NYSE:SBII",
      companyName: "Sandbridge X2 Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-sbio",
      code: "NYSE:SBIO",
      companyName: "ALPS Medical Breakthroughs ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sblk",
      code: "NYSE:SBLK",
      companyName: "Star Bulk Carriers Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-sbnd",
      code: "NYSE:SBND",
      companyName: "Columbia Short Duration Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sbny",
      code: "NYSE:SBNY",
      companyName: "Signature Bank",
      popularity: 0,
    },
    {
      slug: "nyse-sbnyp",
      code: "NYSE:SBNYP",
      companyName:
        "Signature Bank Depositary shares each representing a 1/40th ownership interest in a share of 5.000%",
      popularity: 0,
    },
    {
      slug: "nyse-sbow",
      code: "NYSE:SBOW",
      companyName: "SilverBow Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sbr",
      code: "NYSE:SBR",
      companyName: "Sabine Royalty Trust",
      popularity: 0,
    },
    {
      slug: "nyse-sbra",
      code: "NYSE:SBRA",
      companyName: "Sabra Healthcare REIT Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sbs",
      code: "NYSE:SBS",
      companyName:
        "COMPANHIA DE SANEAMENTO B SICO DO ESTADO DE SAO PAULO-SABESP ADS'S",
      popularity: 0,
    },
    {
      slug: "nyse-sbsi",
      code: "NYSE:SBSI",
      companyName: "Southside Bancshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sbsw",
      code: "NYSE:SBSW",
      companyName:
        "Sibanye-Stillwater American Depositary Shares each representing four ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-sbt",
      code: "NYSE:SBT",
      companyName: "Sterling Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sbtx",
      code: "NYSE:SBTX",
      companyName: "Silverback Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sbug",
      code: "NYSE:SBUG",
      companyName: "iPath Silver ETN",
      popularity: 0,
    },
    {
      slug: "nyse-scaq",
      code: "NYSE:SCAQ",
      companyName: "Stratim Cloud Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scaqu",
      code: "NYSE:SCAQU",
      companyName: "Stratim Cloud Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-scaqw",
      code: "NYSE:SCAQW",
      companyName: "Stratim Cloud Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-scc",
      code: "NYSE:SCC",
      companyName: "ProShares UltraShort Consumer Services",
      popularity: 0,
    },
    {
      slug: "nyse-sccb",
      code: "NYSE:SCCB",
      companyName: "Sachem Capital Corp. 7.125% Notes due 2024",
      popularity: 0,
    },
    {
      slug: "nyse-sccd",
      code: "NYSE:SCCD",
      companyName: "Sachem Capital Corp. 6.00% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-scce",
      code: "NYSE:SCCE",
      companyName: "Sachem Capital Corp. 6.00% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nyse-sccf",
      code: "NYSE:SCCF",
      companyName: "Sachem Capital Corp. 7.125% Notes due 2027",
      popularity: 0,
    },
    {
      slug: "nyse-scd",
      code: "NYSE:SCD",
      companyName: "LMP Capital and Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-scdl",
      code: "NYSE:SCDL",
      companyName: "ETRACS 2x Leveraged US Dividend Factor TR ETN",
      popularity: 0,
    },
    {
      slug: "nyse-sce-g",
      code: "NYSE:SCE-G",
      companyName: "SCE TRUST II 5.10% Trust Preference Securities",
      popularity: 0,
    },
    {
      slug: "nyse-sce-h",
      code: "NYSE:SCE-H",
      companyName:
        "SCE TRUST III 5.75% Fixed-to-Floating Rate Trust Preference Securities of SCE Trust III",
      popularity: 0,
    },
    {
      slug: "nyse-sce-j",
      code: "NYSE:SCE-J",
      companyName:
        "SCE TRUST IV 5.375% Fixed-to-Floating Rate Trust Preference Securities",
      popularity: 0,
    },
    {
      slug: "nyse-sce-k",
      code: "NYSE:SCE-K",
      companyName: "SCE TRUST V",
      popularity: 0,
    },
    {
      slug: "nyse-sce-l",
      code: "NYSE:SCE-L",
      companyName: "SCE TRUST VI 5.00% Trust Preference Securities",
      popularity: 0,
    },
    {
      slug: "nyse-scha",
      code: "NYSE:SCHA",
      companyName: "Schwab U.S Small- Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schb",
      code: "NYSE:SCHB",
      companyName: "Schwab U.S. Broad Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schc",
      code: "NYSE:SCHC",
      companyName: "Schwab International Small-Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schd",
      code: "NYSE:SCHD",
      companyName: "Schwab US Dividend Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sche",
      code: "NYSE:SCHE",
      companyName: "Schwab Emerging Markets Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schf",
      code: "NYSE:SCHF",
      companyName: "Schwab International Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schg",
      code: "NYSE:SCHG",
      companyName: "Schwab U.S. Large-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schh",
      code: "NYSE:SCHH",
      companyName: "Schwab U.S. REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schi",
      code: "NYSE:SCHI",
      companyName: "Schwab 5-10 Year Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schj",
      code: "NYSE:SCHJ",
      companyName: "Schwab 1-5 Year Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schk",
      code: "NYSE:SCHK",
      companyName: "Schwab 1000 Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schl",
      code: "NYSE:SCHL",
      companyName: "Scholastic Corp",
      popularity: 0,
    },
    {
      slug: "nyse-schm",
      code: "NYSE:SCHM",
      companyName: "Schwab U.S. Mid-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schn",
      code: "NYSE:SCHN",
      companyName: "Schnitzer Steel Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-scho",
      code: "NYSE:SCHO",
      companyName: "Schwab Short-Term U.S. Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schp",
      code: "NYSE:SCHP",
      companyName: "Schwab U.S. TIPS ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schq",
      code: "NYSE:SCHQ",
      companyName: "Schwab Long-Term U.S. Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schr",
      code: "NYSE:SCHR",
      companyName: "Schwab Intermediately-Term U.S. Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schv",
      code: "NYSE:SCHV",
      companyName: "Schwab U.S. Large-Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schw-d",
      code: "NYSE:SCHW-D",
      companyName:
        "Charles Schwab Corporation Depositary Shares each representing 1/40th interest in a share of 5.95% N",
      popularity: 0,
    },
    {
      slug: "nyse-schw-j",
      code: "NYSE:SCHW-J",
      companyName:
        "The Charles Schwab Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of",
      popularity: 0,
    },
    {
      slug: "nyse-schx",
      code: "NYSE:SCHX",
      companyName: "Schwab U.S. Large- Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schy",
      code: "NYSE:SCHY",
      companyName: "Schwab International Dividend Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-schz",
      code: "NYSE:SCHZ",
      companyName: "Schwab US Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sci",
      code: "NYSE:SCI",
      companyName: "Service Corporation International",
      popularity: 0,
    },
    {
      slug: "nyse-scj",
      code: "NYSE:SCJ",
      companyName: "iShares MSCI Japan Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sckt",
      code: "NYSE:SCKT",
      companyName: "Socket Mobile Inc. New",
      popularity: 0,
    },
    {
      slug: "nyse-scl",
      code: "NYSE:SCL",
      companyName: "Stepan Co.",
      popularity: 0,
    },
    {
      slug: "nyse-scle",
      code: "NYSE:SCLE",
      companyName: "Broadscale Acquisition Corp. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-scleu",
      code: "NYSE:SCLEU",
      companyName: "Broadscale Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-sclew",
      code: "NYSE:SCLEW",
      companyName: "Broadscale Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-scm",
      code: "NYSE:SCM",
      companyName: "STELLUS CAPITAL INVESTMENT CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-scma",
      code: "NYSE:SCMA",
      companyName:
        "Seaport Calibre Materials Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scmau",
      code: "NYSE:SCMAU",
      companyName: "Seaport Calibre Materials Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-scmaw",
      code: "NYSE:SCMAW",
      companyName: "Seaport Calibre Materials Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sco",
      code: "NYSE:SCO",
      companyName: "ProShares UltraShort Bloomberg Crude Oil",
      popularity: 0,
    },
    {
      slug: "nyse-scoa",
      code: "NYSE:SCOA",
      companyName: "ScION Tech Growth I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-scoau",
      code: "NYSE:SCOAU",
      companyName: "ScION Tech Growth I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-scoaw",
      code: "NYSE:SCOAW",
      companyName: "ScION Tech Growth I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-scob",
      code: "NYSE:SCOB",
      companyName: "ScION Tech Growth II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-scobu",
      code: "NYSE:SCOBU",
      companyName: "ScION Tech Growth II Units",
      popularity: 0,
    },
    {
      slug: "nyse-scobw",
      code: "NYSE:SCOBW",
      companyName: "ScION Tech Growth II Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-scor",
      code: "NYSE:SCOR",
      companyName: "comScore Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scph",
      code: "NYSE:SCPH",
      companyName: "scPharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scpl",
      code: "NYSE:SCPL",
      companyName: "SciPlay Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scps",
      code: "NYSE:SCPS",
      companyName: "Scopus BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scrd",
      code: "NYSE:SCRD",
      companyName: "Janus Henderson Sustainable Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-scrm",
      code: "NYSE:SCRM",
      companyName: "Screaming Eagle Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-scrmu",
      code: "NYSE:SCRMU",
      companyName: "Screaming Eagle Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-scrmw",
      code: "NYSE:SCRMW",
      companyName: "Screaming Eagle Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-scs",
      code: "NYSE:SCS",
      companyName: "Steelcase Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-scsc",
      code: "NYSE:SCSC",
      companyName: "Scansource Inc",
      popularity: 0,
    },
    {
      slug: "nyse-scu",
      code: "NYSE:SCU",
      companyName: "Sculptor Capital Management Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scua",
      code: "NYSE:SCUA",
      companyName: "Sculptor Acquisition Corp I",
      popularity: 0,
    },
    {
      slug: "nyse-scvl",
      code: "NYSE:SCVL",
      companyName: "Shoe Carnival Inc",
      popularity: 0,
    },
    {
      slug: "nyse-scwo",
      code: "NYSE:SCWO",
      companyName: "374Water Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scwx",
      code: "NYSE:SCWX",
      companyName: "SecureWorks Corp  Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-scx",
      code: "NYSE:SCX",
      companyName: "The L.S. Starrett Company",
      popularity: 0,
    },
    {
      slug: "nyse-scyx",
      code: "NYSE:SCYX",
      companyName: "SCYNEXIS Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-scz",
      code: "NYSE:SCZ",
      companyName: "iShares MSCI EAFE Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sd",
      code: "NYSE:SD",
      companyName: "SandRidge Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sdac",
      code: "NYSE:SDAC",
      companyName:
        "Sustainable Development Acquisition I Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sdacu",
      code: "NYSE:SDACU",
      companyName: "Sustainable Development Acquisition I Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-sdacw",
      code: "NYSE:SDACW",
      companyName: "Sustainable Development Acquisition I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sdc",
      code: "NYSE:SDC",
      companyName: "SmileDirectClub Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sdci",
      code: "NYSE:SDCI",
      companyName: "USCF SummerHaven Dynamic Commodity Strategy No K-1 Fund",
      popularity: 0,
    },
    {
      slug: "nyse-sdd",
      code: "NYSE:SDD",
      companyName: "ProShares UltraShort SmallCap600",
      popularity: 0,
    },
    {
      slug: "nyse-sdef",
      code: "NYSE:SDEF",
      companyName: "Sound Enhanced Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sdei",
      code: "NYSE:SDEI",
      companyName: "Sound Equity Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sdg",
      code: "NYSE:SDG",
      companyName:
        "iShares Trust iShares MSCI Global Sustainable Development Goals ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sdga",
      code: "NYSE:SDGA",
      companyName:
        "Impact Shares Sustainable Development Goals Global Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sdgr",
      code: "NYSE:SDGR",
      companyName: "Schrodinger Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sdhy",
      code: "NYSE:SDHY",
      companyName: "PGIM Short Duration High Yield Opportunities Fund",
      popularity: 0,
    },
    {
      slug: "nyse-sdig",
      code: "NYSE:SDIG",
      companyName: "Stronghold Digital Mining Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sdog",
      code: "NYSE:SDOG",
      companyName: "ALPS Sector Dividend Dogs ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sdow",
      code: "NYSE:SDOW",
      companyName: "ProShares UltraPro Short Dow 30",
      popularity: 0,
    },
    {
      slug: "nyse-sdp",
      code: "NYSE:SDP",
      companyName: "ProShares UltraShort Utilities",
      popularity: 0,
    },
    {
      slug: "nyse-sdpi",
      code: "NYSE:SDPI",
      companyName: "Superior Drilling Products Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sds",
      code: "NYSE:SDS",
      companyName: "ProShares UltraShort S&P500",
      popularity: 0,
    },
    {
      slug: "nyse-sdvy",
      code: "NYSE:SDVY",
      companyName: "First Trust SMID Cap Rising Dividend Achievers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sdy",
      code: "NYSE:SDY",
      companyName: "SPDR S&P Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sea",
      code: "NYSE:SEA",
      companyName: "U.S. Global Sea to Sky Cargo ETF",
      popularity: 0,
    },
    {
      slug: "nyse-seac",
      code: "NYSE:SEAC",
      companyName: "Seachange International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-seal-a",
      code: "NYSE:SEAL-A",
      companyName:
        "Seapeak LLC 9.00% Series A Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nyse-seal-b",
      code: "NYSE:SEAL-B",
      companyName:
        "Seapeak LLC 8.50% Series B Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred Units",
      popularity: 0,
    },
    {
      slug: "nyse-seas",
      code: "NYSE:SEAS",
      companyName: "SEAWORLD ENTERTAINMENT INC",
      popularity: 0,
    },
    {
      slug: "nyse-seat",
      code: "NYSE:SEAT",
      companyName: "Vivid Seats Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-seatw",
      code: "NYSE:SEATW",
      companyName: "Vivid Seats Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-seb",
      code: "NYSE:SEB",
      companyName: "Seaboard Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-seco",
      code: "NYSE:SECO",
      companyName: "Secoo Holding Limited ADR",
      popularity: 0,
    },
    {
      slug: "nyse-sect",
      code: "NYSE:SECT",
      companyName: "Main Sector Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-seda",
      code: "NYSE:SEDA",
      companyName: "SDCL EDGE Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-sdem",
      code: "NYSE:SDEM",
      companyName: "Global X MSCI SuperDividend Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sedg",
      code: "NYSE:SEDG",
      companyName: "SolarEdge Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-see",
      code: "NYSE:SEE",
      companyName: "Sealed Air Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-seed",
      code: "NYSE:SEED",
      companyName: "Origin Agritech Limited",
      popularity: 0,
    },
    {
      slug: "nyse-seel",
      code: "NYSE:SEEL",
      companyName: "Seelos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-seer",
      code: "NYSE:SEER",
      companyName: "Seer Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sef",
      code: "NYSE:SEF",
      companyName: "ProShares Short Financials",
      popularity: 0,
    },
    {
      slug: "nyse-seic",
      code: "NYSE:SEIC",
      companyName: "SEI Investments Co",
      popularity: 0,
    },
    {
      slug: "nyse-seim",
      code: "NYSE:SEIM",
      companyName: "SEI Enhanced U.S. Large Cap Momentum Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-seiq",
      code: "NYSE:SEIQ",
      companyName: "SEI Enhanced U.S. Large Cap Quality Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-seiv",
      code: "NYSE:SEIV",
      companyName: "SEI Enhanced U.S. Large Cap Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-seix",
      code: "NYSE:SEIX",
      companyName: "Virtus SEIX Senior Loan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-selb",
      code: "NYSE:SELB",
      companyName: "Selecta Biosciences Inc",
      popularity: 0,
    },
    {
      slug: "nyse-self",
      code: "NYSE:SELF",
      companyName: "Global Self Storage Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-selv",
      code: "NYSE:SELV",
      companyName: "SEI Enhanced Low Volatility U.S. Large Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sem",
      code: "NYSE:SEM",
      companyName: "SELECT MEDICAL HOLDINGS CORP",
      popularity: 0,
    },
    {
      slug: "nyse-semi",
      code: "NYSE:SEMI",
      companyName: "Columbia Seligman Semiconductor and Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-semr",
      code: "NYSE:SEMR",
      companyName: "SEMrush Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-senea",
      code: "NYSE:SENEA",
      companyName: "Seneca Foods Corp",
      popularity: 0,
    },
    {
      slug: "nyse-seneb",
      code: "NYSE:SENEB",
      companyName: "Seneca Foods Corp",
      popularity: 0,
    },
    {
      slug: "nyse-sens",
      code: "NYSE:SENS",
      companyName: "Senseonics Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sent",
      code: "NYSE:SENT",
      companyName: "AdvisorShares Alpha DNA Equity Sentiment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sepz",
      code: "NYSE:SEPZ",
      companyName: "TrueShares Structured Outcome (September) ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sera",
      code: "NYSE:SERA",
      companyName: "Sera Prognostics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ses",
      code: "NYSE:SES",
      companyName: "SES AI Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-sesg",
      code: "NYSE:SESG",
      companyName: "Sprott ESG Gold ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sesn",
      code: "NYSE:SESN",
      companyName: "Sesen Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sev",
      code: "NYSE:SEV",
      companyName: "Sono Group N.V. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sevn",
      code: "NYSE:SEVN",
      companyName: "Seven Hills Realty Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sf",
      code: "NYSE:SF",
      companyName: "Stifel Financial Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-sf-b",
      code: "NYSE:SF-B",
      companyName:
        "Stifel Financial Corp. Depositary Shares Each Representing 1/1000th Interest in a Share of 6.25% N",
      popularity: 0,
    },
    {
      slug: "nyse-sf-c",
      code: "NYSE:SF-C",
      companyName:
        "Stifel Financial Corp. Depositary Shares Each Representing 1/1 000th Interest in a Share of 6.125%",
      popularity: 0,
    },
    {
      slug: "nyse-sf-d",
      code: "NYSE:SF-D",
      companyName:
        "Stifel Financial Corp. Depositary Shares Each Representing 1/1000th Interest in a Share of 4.50% N",
      popularity: 0,
    },
    {
      slug: "nyse-sfb",
      code: "NYSE:SFB",
      companyName: "Stifel Financial Corp.5.20 percent Senior Notes due 2047",
      popularity: 0,
    },
    {
      slug: "nyse-sfbc",
      code: "NYSE:SFBC",
      companyName: "Sound Financial Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sfbs",
      code: "NYSE:SFBS",
      companyName: "ServisFirst Bancshares Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sfe",
      code: "NYSE:SFE",
      companyName: "Safeguard Scientifics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sfet",
      code: "NYSE:SFET",
      companyName: "Safe-T Group Ltd. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-sfig",
      code: "NYSE:SFIG",
      companyName: "WisdomTree U.S. Short Term Corporate Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-sfix",
      code: "NYSE:SFIX",
      companyName: "Stitch Fix Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sfl",
      code: "NYSE:SFL",
      companyName: "SFL Corporation Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-sfm",
      code: "NYSE:SFM",
      companyName: "Sprouts Farmers Market Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sfnc",
      code: "NYSE:SFNC",
      companyName: "Simmons First National Corp",
      popularity: 0,
    },
    {
      slug: "nyse-sfst",
      code: "NYSE:SFST",
      companyName: "Southern First Bancshares Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sft",
      code: "NYSE:SFT",
      companyName: "Shift Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sfy",
      code: "NYSE:SFY",
      companyName: "SoFi Select 500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sfyf",
      code: "NYSE:SFYF",
      companyName: "SoFi Social 50 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sfyx",
      code: "NYSE:SFYX",
      companyName: "SoFi Next 500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sg",
      code: "NYSE:SG",
      companyName: "Sweetgreen Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sga",
      code: "NYSE:SGA",
      companyName: "Saga Communications Inc. Class A Common Stock (FL)",
      popularity: 0,
    },
    {
      slug: "nyse-sgbx",
      code: "NYSE:SGBX",
      companyName: "SG Blocks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sgc",
      code: "NYSE:SGC",
      companyName: "Superior Group of Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sgdj",
      code: "NYSE:SGDJ",
      companyName: "Sprott Junior Gold Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sgdm",
      code: "NYSE:SGDM",
      companyName: "Sprott Gold Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sgfy",
      code: "NYSE:SGFY",
      companyName: "Signify Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sgg",
      code: "NYSE:SGG",
      companyName: "iPath Series B Bloomberg Sugar Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-sgh",
      code: "NYSE:SGH",
      companyName: "SMART Global Holdings Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sghc",
      code: "NYSE:SGHC",
      companyName: "Super Group (SGHC) Limited",
      popularity: 0,
    },
    {
      slug: "nyse-sghl",
      code: "NYSE:SGHL",
      companyName: "Signal Hill Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sghlu",
      code: "NYSE:SGHLU",
      companyName: "Signal Hill Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-sghlw",
      code: "NYSE:SGHLW",
      companyName: "Signal Hill Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sght",
      code: "NYSE:SGHT",
      companyName: "Sight Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sgii",
      code: "NYSE:SGII",
      companyName: "Seaport Global Acquisition II Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sgiiu",
      code: "NYSE:SGIIU",
      companyName: "Seaport Global Acquisition II Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-sgiiw",
      code: "NYSE:SGIIW",
      companyName: "Seaport Global Acquisition II Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-sgly",
      code: "NYSE:SGLY",
      companyName: "Singularity Future Technology Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sgma",
      code: "NYSE:SGMA",
      companyName: "Sigmatron International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sgml",
      code: "NYSE:SGML",
      companyName: "Sigma Lithium Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sgmo",
      code: "NYSE:SGMO",
      companyName: "Sangamo Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sgol",
      code: "NYSE:SGOL",
      companyName: "abrdn Physical Gold Shares ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sgov",
      code: "NYSE:SGOV",
      companyName: "iShares 0-3 Month Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sgrp",
      code: "NYSE:SGRP",
      companyName: "SPAR Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sgry",
      code: "NYSE:SGRY",
      companyName: "Surgery Partners Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sgtx",
      code: "NYSE:SGTX",
      companyName: "Sigilon Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sgu",
      code: "NYSE:SGU",
      companyName:
        "Star Group L.P. Common Units Representing Limited Partner Interest",
      popularity: 0,
    },
    {
      slug: "nyse-sh",
      code: "NYSE:SH",
      companyName: "ProShares Short S&P500",
      popularity: 0,
    },
    {
      slug: "nyse-shac",
      code: "NYSE:SHAC",
      companyName:
        "SCP & CO Healthcare Acquisition Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shacu",
      code: "NYSE:SHACU",
      companyName: "SCP & CO Healthcare Acquisition Company Unit",
      popularity: 0,
    },
    {
      slug: "nyse-shacw",
      code: "NYSE:SHACW",
      companyName: "SCP & CO Healthcare Acquisition Company Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-shag",
      code: "NYSE:SHAG",
      companyName:
        "WisdomTree Yield Enhanced U.S. Short-Term Aggregate Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-shak",
      code: "NYSE:SHAK",
      companyName: "Shake Shack Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-shap",
      code: "NYSE:SHAP",
      companyName: "Spree Acquisition Corp. 1 Limited",
      popularity: 0,
    },
    {
      slug: "nyse-shbi",
      code: "NYSE:SHBI",
      companyName: "Shore Bancshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-shc",
      code: "NYSE:SHC",
      companyName: "Sotera Health Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shca",
      code: "NYSE:SHCA",
      companyName: "Spindletop Health Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shcau",
      code: "NYSE:SHCAU",
      companyName: "Spindletop Health Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-she",
      code: "NYSE:SHE",
      companyName: "SPDR SSGA Gender Diversity Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-shel",
      code: "NYSE:SHEL",
      companyName:
        "Shell plc American Depositary Shares (Each represents two Ordinary shares)",
      popularity: 0,
    },
    {
      slug: "nyse-shen",
      code: "NYSE:SHEN",
      companyName: "Shenandoah Telecom Co",
      popularity: 0,
    },
    {
      slug: "nyse-shg",
      code: "NYSE:SHG",
      companyName: "Shinhan Financial Group Co Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-shi",
      code: "NYSE:SHI",
      companyName: "Sinopec Shanghai Petrochemical Co. Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-ship",
      code: "NYSE:SHIP",
      companyName: "Seanergy Maritime Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-shls",
      code: "NYSE:SHLS",
      companyName: "Shoals Technologies Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shlx",
      code: "NYSE:SHLX",
      companyName: "Shell Midstream Partners L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-shm",
      code: "NYSE:SHM",
      companyName: "SPDR Nuveen Bloomberg Short Term Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sho",
      code: "NYSE:SHO",
      companyName: "Sunstone Hotel Investors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sho-h",
      code: "NYSE:SHO-H",
      companyName:
        "Sunstone Hotel Investors Inc. 6.125% Series H Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sho-i",
      code: "NYSE:SHO-I",
      companyName:
        "Sunstone Hotel Investors Inc. 5.70% Series I Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shoo",
      code: "NYSE:SHOO",
      companyName: "Steven Madden Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-shpp",
      code: "NYSE:SHPP",
      companyName: "Pacer Industrials and Logistics ETF",
      popularity: 0,
    },
    {
      slug: "nyse-shpw",
      code: "NYSE:SHPW",
      companyName: "Shapeways Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-shqa",
      code: "NYSE:SHQA",
      companyName: "Shelter Acquisition Corporation I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shqau",
      code: "NYSE:SHQAU",
      companyName: "Shelter Acquisition Corporation I Units",
      popularity: 0,
    },
    {
      slug: "nyse-shqaw",
      code: "NYSE:SHQAW",
      companyName: "Shelter Acquisition Corporation I Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-shua",
      code: "NYSE:SHUA",
      companyName: "SHUAA Partners Acquisition Corp I Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-shuau",
      code: "NYSE:SHUAU",
      companyName: "SHUAA Partners Acquisition Corp I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-shuaw",
      code: "NYSE:SHUAW",
      companyName: "SHUAA Partners Acquisition Corp I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-shus",
      code: "NYSE:SHUS",
      companyName: "Syntax Stratified U.S. Total Market Hedged ETF",
      popularity: 0,
    },
    {
      slug: "nyse-shw",
      code: "NYSE:SHW",
      companyName: "The Sherwin-Williams Company",
      popularity: 0,
    },
    {
      slug: "nyse-shy",
      code: "NYSE:SHY",
      companyName: "iShares 1-3 Year Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-shyd",
      code: "NYSE:SHYD",
      companyName: "VanEck Short High Yield Muni ETF",
      popularity: 0,
    },
    {
      slug: "nyse-shyf",
      code: "NYSE:SHYF",
      companyName: "The Shyft Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shyg",
      code: "NYSE:SHYG",
      companyName: "iShares 0-5 Year High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-shyl",
      code: "NYSE:SHYL",
      companyName: "Xtrackers Short Duration High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-si",
      code: "NYSE:SI",
      companyName: "Silvergate Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-si-a",
      code: "NYSE:SI-A",
      companyName:
        "Silvergate Capital Corporation Depositary Shares Each Representing a 1/40th Interest in a Share of",
      popularity: 0,
    },
    {
      slug: "nyse-sibn",
      code: "NYSE:SIBN",
      companyName: "SI-BONE Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sid",
      code: "NYSE:SID",
      companyName: "Companhia Siderurgica Nacional S.A. (CSN)",
      popularity: 0,
    },
    {
      slug: "nyse-sidu",
      code: "NYSE:SIDU",
      companyName: "Sidus Space Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sieb",
      code: "NYSE:SIEB",
      companyName: "Siebert Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-sien",
      code: "NYSE:SIEN",
      companyName: "Sientra Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sier",
      code: "NYSE:SIER",
      companyName: "Sierra Lake Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sieru",
      code: "NYSE:SIERU",
      companyName: "Sierra Lake Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-sierw",
      code: "NYSE:SIERW",
      companyName: "Sierra Lake Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sif",
      code: "NYSE:SIF",
      companyName: "SIFCO Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sifi",
      code: "NYSE:SIFI",
      companyName: "Harbor Scientific Alpha Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sify",
      code: "NYSE:SIFY",
      companyName: "Sify Technologies Limited",
      popularity: 0,
    },
    {
      slug: "nyse-sig",
      code: "NYSE:SIG",
      companyName: "Signet Jewelers Limited",
      popularity: 0,
    },
    {
      slug: "nyse-siga",
      code: "NYSE:SIGA",
      companyName: "SIGA Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sigi",
      code: "NYSE:SIGI",
      companyName: "Selective Insurance Group",
      popularity: 0,
    },
    {
      slug: "nyse-sigip",
      code: "NYSE:SIGIP",
      companyName:
        "Selective Insurance Group Inc. Depositary Shares each representing a 1/1000th interest in a share",
      popularity: 0,
    },
    {
      slug: "nyse-sihy",
      code: "NYSE:SIHY",
      companyName: "Harbor Scientific Alpha High-Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sii",
      code: "NYSE:SII",
      companyName: "Sprott Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sij",
      code: "NYSE:SIJ",
      companyName: "ProShares UltraShort Industrials",
      popularity: 0,
    },
    {
      slug: "nyse-silc",
      code: "NYSE:SILC",
      companyName: "Silicom Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-silj",
      code: "NYSE:SILJ",
      companyName: "ETFMG Prime Junior Silver Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-silk",
      code: "NYSE:SILK",
      companyName: "Silk Road Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-silv",
      code: "NYSE:SILV",
      companyName: "SilverCrest Metals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-silx",
      code: "NYSE:SILX",
      companyName: "ETFMG Prime 2x Daily Junior Silver Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sim",
      code: "NYSE:SIM",
      companyName: "Groupo Simec S.A.B de C.V.",
      popularity: 0,
    },
    {
      slug: "nyse-simo",
      code: "NYSE:SIMO",
      companyName: "Silicon Motion Technology Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-sims",
      code: "NYSE:SIMS",
      companyName: "SPDR S&P Kensho Intelligent Structures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sint",
      code: "NYSE:SINT",
      companyName: "SiNtx Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-siox",
      code: "NYSE:SIOX",
      companyName: "Sio Gene Therapies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sire",
      code: "NYSE:SIRE",
      companyName: "Sisecam Resources LP",
      popularity: 0,
    },
    {
      slug: "nyse-siri",
      code: "NYSE:SIRI",
      companyName: "Sirius XM Holdings  Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sisi",
      code: "NYSE:SISI",
      companyName: "Shineco Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sitc",
      code: "NYSE:SITC",
      companyName: "SITE Centers Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sitc-a",
      code: "NYSE:SITC-A",
      companyName:
        "SITE Centers Corp. Depositary Shares each representing a 1/20th interest in a share of 6.375% Class",
      popularity: 0,
    },
    {
      slug: "nyse-site",
      code: "NYSE:SITE",
      companyName: "SiteOne Landscape Supply Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sitm",
      code: "NYSE:SITM",
      companyName: "SiTime Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sivbp",
      code: "NYSE:SIVBP",
      companyName:
        "SVB Financial Group Depositary Shs 5.25% Preferred Stock Series A",
      popularity: 0,
    },
    {
      slug: "nyse-sivr",
      code: "NYSE:SIVR",
      companyName: "abrdn Physical Silver Shares ETF",
      popularity: 0,
    },
    {
      slug: "nyse-six",
      code: "NYSE:SIX",
      companyName: "Six Flags Entertainment Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-sixa",
      code: "NYSE:SIXA",
      companyName: "ETC 6 Meridian Mega Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sixh",
      code: "NYSE:SIXH",
      companyName: "ETC 6 Meridian Hedged Equity Index Option ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sixj",
      code: "NYSE:SIXJ",
      companyName: "AllianzIM U.S. Large Cap 6 Month Buffer10 Jan/Jul ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sixl",
      code: "NYSE:SIXL",
      companyName: "ETC 6 Meridian Low Beta Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sixo",
      code: "NYSE:SIXO",
      companyName: "AllianzIM U.S. Large Cap 6 Month Buffer10 Apr/Oct ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sixs",
      code: "NYSE:SIXS",
      companyName: "ETC 6 Meridian Small Cap Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-size",
      code: "NYSE:SIZE",
      companyName: "iShares MSCI USA Size Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sj",
      code: "NYSE:SJ",
      companyName: "Scienjoy Holding Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sjb",
      code: "NYSE:SJB",
      companyName: "ProShares Short High Yield",
      popularity: 0,
    },
    {
      slug: "nyse-sji",
      code: "NYSE:SJI",
      companyName: "South Jersey Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sjij",
      code: "NYSE:SJIJ",
      companyName:
        "South Jersey Industries Inc. 5.625% Junior Subordinated Notes due 2079",
      popularity: 0,
    },
    {
      slug: "nyse-sjiv",
      code: "NYSE:SJIV",
      companyName: "South Jersey Industries Inc. Corporate Units",
      popularity: 0,
    },
    {
      slug: "nyse-sjm",
      code: "NYSE:SJM",
      companyName: "The J.M. Smucker Company",
      popularity: 0,
    },
    {
      slug: "nyse-sjnk",
      code: "NYSE:SJNK",
      companyName: "SPDR Bloomberg Short Term High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sjr",
      code: "NYSE:SJR",
      companyName: "Shaw Communications Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sjt",
      code: "NYSE:SJT",
      companyName: "San Juan Basin Royalty Trust UBI",
      popularity: 0,
    },
    {
      slug: "nyse-sjw",
      code: "NYSE:SJW",
      companyName: "SJW Group Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ske",
      code: "NYSE:SKE",
      companyName: "Skeena Resources Limited",
      popularity: 0,
    },
    {
      slug: "nyse-skf",
      code: "NYSE:SKF",
      companyName: "ProShares UltraShort Financials",
      popularity: 0,
    },
    {
      slug: "nyse-skgr",
      code: "NYSE:SKGR",
      companyName: "SK Growth Opportunities Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-skgru",
      code: "NYSE:SKGRU",
      companyName: "SK Growth Opportunities Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-skgrw",
      code: "NYSE:SKGRW",
      companyName: "SK Growth Opportunities Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-skil",
      code: "NYSE:SKIL",
      companyName: "Skillsoft Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-skin",
      code: "NYSE:SKIN",
      companyName: "The Beauty Health Company Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sklz",
      code: "NYSE:SKLZ",
      companyName: "Skillz Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-skm",
      code: "NYSE:SKM",
      companyName:
        "SK Telecom Co. Ltd.  American Depositary Shares (Each representing 5/9th of a Ordinary Share of SK",
      popularity: 0,
    },
    {
      slug: "nyse-skor",
      code: "NYSE:SKOR",
      companyName: "FlexShares Credit-Scored US Corporate Bond Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-skt",
      code: "NYSE:SKT",
      companyName: "TANGER FACTORY OUTLET CENTERS",
      popularity: 0,
    },
    {
      slug: "nyse-skx",
      code: "NYSE:SKX",
      companyName: "Skechers U.S.A. Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sky",
      code: "NYSE:SKY",
      companyName: "Skyline Champion Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-skya",
      code: "NYSE:SKYA",
      companyName: "Skydeck Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-skyau",
      code: "NYSE:SKYAU",
      companyName: "Skydeck Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-skyaw",
      code: "NYSE:SKYAW",
      companyName: "Skydeck Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-skyh",
      code: "NYSE:SKYH",
      companyName: "Sky Harbour Group Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-skyt",
      code: "NYSE:SKYT",
      companyName: "SkyWater Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-skyu",
      code: "NYSE:SKYU",
      companyName: "ProShares Ultra Nasdaq Cloud Computing ETF",
      popularity: 0,
    },
    {
      slug: "nyse-skyw",
      code: "NYSE:SKYW",
      companyName: "Skywest Inc",
      popularity: 0,
    },
    {
      slug: "nyse-skyx",
      code: "NYSE:SKYX",
      companyName: "SKYX Platforms Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-skyy",
      code: "NYSE:SKYY",
      companyName: "First Trust Cloud Computing ETF",
      popularity: 0,
    },
    {
      slug: "nyse-slab",
      code: "NYSE:SLAB",
      companyName: "Silicon Laboratories Inc",
      popularity: 0,
    },
    {
      slug: "nyse-slac",
      code: "NYSE:SLAC",
      companyName: "Social Leverage Acquisition Corp I",
      popularity: 0,
    },
    {
      slug: "nyse-slam",
      code: "NYSE:SLAM",
      companyName: "Slam Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-slamu",
      code: "NYSE:SLAMU",
      companyName: "Slam Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-slamw",
      code: "NYSE:SLAMW",
      companyName: "Slam Corp. warrant",
      popularity: 0,
    },
    {
      slug: "nyse-slca",
      code: "NYSE:SLCA",
      companyName: "U.S. SILICA HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-slcr",
      code: "NYSE:SLCR",
      companyName:
        "Silver Crest Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-slcru",
      code: "NYSE:SLCRU",
      companyName: "Silver Crest Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-slcrw",
      code: "NYSE:SLCRW",
      companyName: "Silver Crest Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sldb",
      code: "NYSE:SLDB",
      companyName: "Solid Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sldp",
      code: "NYSE:SLDP",
      companyName: "Solid Power Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sldpw",
      code: "NYSE:SLDPW",
      companyName: "Solid Power Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-slf",
      code: "NYSE:SLF",
      companyName: "Sun Life Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-slg",
      code: "NYSE:SLG",
      companyName: "SL Green Realty Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-slg-i",
      code: "NYSE:SLG-I",
      companyName:
        "SL GREEN REALTY CORP 6.50% Series I Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-slgc",
      code: "NYSE:SLGC",
      companyName: "SomaLogic Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-slgcw",
      code: "NYSE:SLGCW",
      companyName: "SomaLogic Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-slgg",
      code: "NYSE:SLGG",
      companyName: "Super League Gaming Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-slgl",
      code: "NYSE:SLGL",
      companyName: "Sol-Gel Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-slgn",
      code: "NYSE:SLGN",
      companyName: "Silgan Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-slhg",
      code: "NYSE:SLHG",
      companyName: "Skylight Health Group Inc Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-slhgp",
      code: "NYSE:SLHGP",
      companyName:
        "Skylight Health Group Inc. Skylight Health Group Inc. 9.25% Series A Cumulative Redeemable Perpetual",
      popularity: 0,
    },
    {
      slug: "nyse-slm",
      code: "NYSE:SLM",
      companyName: "SLM Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-slmbp",
      code: "NYSE:SLMBP",
      companyName: "SLM Corporation Floating-Rate Non-Cumulative Series B",
      popularity: 0,
    },
    {
      slug: "nyse-sln",
      code: "NYSE:SLN",
      companyName: "Silence Therapeutics Plc American Depository Share",
      popularity: 0,
    },
    {
      slug: "nyse-slng",
      code: "NYSE:SLNG",
      companyName: "Stabilis Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-slnh",
      code: "NYSE:SLNH",
      companyName: "Soluna Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-slnhp",
      code: "NYSE:SLNHP",
      companyName:
        "Soluna Holdings Inc 9.0% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-slno",
      code: "NYSE:SLNO",
      companyName: "Soleno Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-slp",
      code: "NYSE:SLP",
      companyName: "Simulations Plus Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-slqd",
      code: "NYSE:SLQD",
      companyName: "iShares 0-5 Year Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-slqt",
      code: "NYSE:SLQT",
      companyName: "SelectQuote Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-slrc",
      code: "NYSE:SLRC",
      companyName: "SLR Investment Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-slrx",
      code: "NYSE:SLRX",
      companyName: "Salarius Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sls",
      code: "NYSE:SLS",
      companyName: "SELLAS Life Sciences Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-slv",
      code: "NYSE:SLV",
      companyName: "iShares Silver Trust",
      popularity: 0,
    },
    {
      slug: "nyse-slvm",
      code: "NYSE:SLVM",
      companyName: "Sylvamo Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-slvo",
      code: "NYSE:SLVO",
      companyName:
        "Credit Suisse X-Links Silver Shares Covered Call ETNs due April 21 2033",
      popularity: 0,
    },
    {
      slug: "nyse-slvp",
      code: "NYSE:SLVP",
      companyName: "iShares MSCI Global Silver and Metals Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-slvr",
      code: "NYSE:SLVR",
      companyName: "SilverSPAC Inc. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-slvru",
      code: "NYSE:SLVRU",
      companyName: "SilverSPAC Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-slvrw",
      code: "NYSE:SLVRW",
      companyName: "SilverSPAC Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-slx",
      code: "NYSE:SLX",
      companyName: "VanEck Steel ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sly",
      code: "NYSE:SLY",
      companyName:
        "SPDR S&P 600 Small Cap ETF (based on S&P SmallCap 600 Index--symbol SML)",
      popularity: 0,
    },
    {
      slug: "nyse-slyg",
      code: "NYSE:SLYG",
      companyName:
        "SPDR S&P 600 Small Cap Growth ETF (based on S&P SmallCap 600 Growth Index--symbol: CKG)",
      popularity: 0,
    },
    {
      slug: "nyse-slyv",
      code: "NYSE:SLYV",
      companyName:
        "SPDR S&P 600 Small Cap Value ETF (based on S&P SmallCap 600 Value Index symbol--CVK)",
      popularity: 0,
    },
    {
      slug: "nyse-sm",
      code: "NYSE:SM",
      companyName: "SM Energy Company",
      popularity: 0,
    },
    {
      slug: "nyse-smap",
      code: "NYSE:SMAP",
      companyName: "SportsMap Tech Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smapu",
      code: "NYSE:SMAPU",
      companyName: "SportsMap Tech Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-smapw",
      code: "NYSE:SMAPW",
      companyName: "SportsMap Tech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-smar",
      code: "NYSE:SMAR",
      companyName: "Smartsheet Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-smb",
      code: "NYSE:SMB",
      companyName: "VanEck Short Muni ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smbc",
      code: "NYSE:SMBC",
      companyName: "Southern Missouri Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-smbk",
      code: "NYSE:SMBK",
      companyName: "SmartFinancial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-smci",
      code: "NYSE:SMCI",
      companyName: "Super Micro Computer Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smcp",
      code: "NYSE:SMCP",
      companyName: "AlphaMark Actively Managed Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smdd",
      code: "NYSE:SMDD",
      companyName: "ProShares UltraPro Short MidCap400",
      popularity: 0,
    },
    {
      slug: "nyse-smdv",
      code: "NYSE:SMDV",
      companyName: "ProShares Russell 2000 Dividend Growers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smdy",
      code: "NYSE:SMDY",
      companyName: "Syntax Stratified MidCap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smed",
      code: "NYSE:SMED",
      companyName: "Sharps Compliance Corp",
      popularity: 0,
    },
    {
      slug: "nyse-smfg",
      code: "NYSE:SMFG",
      companyName: "Sumitomo Mitsui Financial Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-smfl",
      code: "NYSE:SMFL",
      companyName: "Smart for Life Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smfr",
      code: "NYSE:SMFR",
      companyName: "Sema4 Holdings Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smfrw",
      code: "NYSE:SMFRW",
      companyName: "Sema4 Holdings Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-smg",
      code: "NYSE:SMG",
      companyName: "The Scotts Miracle-Gro Company",
      popularity: 0,
    },
    {
      slug: "nyse-smhb",
      code: "NYSE:SMHB",
      companyName:
        "ETRACS 2xMonthly Pay Leveraged US Small Cap High Dividend ETN Series B",
      popularity: 0,
    },
    {
      slug: "nyse-smhi",
      code: "NYSE:SMHI",
      companyName: "SEACOR Marine Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smi",
      code: "NYSE:SMI",
      companyName: "VanEck HIP Sustainable Muni ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smid",
      code: "NYSE:SMID",
      companyName: "Smith-Midland Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smig",
      code: "NYSE:SMIG",
      companyName: "AAM Bahl & Gaynor Small/Mid Cap Income Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smih",
      code: "NYSE:SMIH",
      companyName: "Summit Healthcare Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-smihu",
      code: "NYSE:SMIHU",
      companyName: "Summit Healthcare Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-smihw",
      code: "NYSE:SMIHW",
      companyName: "Summit Healthcare Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-smin",
      code: "NYSE:SMIN",
      companyName: "iShares MSCI India Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smlf",
      code: "NYSE:SMLF",
      companyName: "iShares MSCI USA Small-Cap Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smlp",
      code: "NYSE:SMLP",
      companyName: "Summit Midstream Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-smlv",
      code: "NYSE:SMLV",
      companyName: "SPDR SSGA US Small Cap Low Volatility Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smm",
      code: "NYSE:SMM",
      companyName: "Salient Midstream & MLP Fund",
      popularity: 0,
    },
    {
      slug: "nyse-smmd",
      code: "NYSE:SMMD",
      companyName: "iShares Russell 2500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smmf",
      code: "NYSE:SMMF",
      companyName: "Summit Financial Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-smmt",
      code: "NYSE:SMMT",
      companyName: "Summit Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smmu",
      code: "NYSE:SMMU",
      companyName:
        "PIMCO Short Term Municipal Bond Active Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-smmv",
      code: "NYSE:SMMV",
      companyName: "iShares MSCI USA Small-Cap Min Vol Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smn",
      code: "NYSE:SMN",
      companyName: "ProShares UltraShort Basic Materials",
      popularity: 0,
    },
    {
      slug: "nyse-smog",
      code: "NYSE:SMOG",
      companyName: "VanEck Low Carbon Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smp",
      code: "NYSE:SMP",
      companyName: "Standard Motor Products",
      popularity: 0,
    },
    {
      slug: "nyse-smpl",
      code: "NYSE:SMPL",
      companyName: "The Simply Good Foods Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smr",
      code: "NYSE:SMR",
      companyName: "NuScale Power Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-smrt",
      code: "NYSE:SMRT",
      companyName: "SmartRent Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-smsi",
      code: "NYSE:SMSI",
      companyName: "Smith Micro Software Inc",
      popularity: 0,
    },
    {
      slug: "nyse-smtc",
      code: "NYSE:SMTC",
      companyName: "Semtech Corp",
      popularity: 0,
    },
    {
      slug: "nyse-smti",
      code: "NYSE:SMTI",
      companyName: "Sanara MedTech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smts",
      code: "NYSE:SMTS",
      companyName: "Sierra Metals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-smwb",
      code: "NYSE:SMWB",
      companyName: "Similarweb Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-sna",
      code: "NYSE:SNA",
      companyName: "Snap-on Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-smh",
      code: "NYSE:SMH",
      companyName: "VanEck Semiconductor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-snax",
      code: "NYSE:SNAX",
      companyName: "Stryve Foods Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snaxw",
      code: "NYSE:SNAXW",
      companyName: "Stryve Foods Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-snbr",
      code: "NYSE:SNBR",
      companyName: "Sleep Number Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snce",
      code: "NYSE:SNCE",
      companyName: "Science 37 Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sncr",
      code: "NYSE:SNCR",
      companyName: "Synchronoss Technologies Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sncrl",
      code: "NYSE:SNCRL",
      companyName: "Synchronoss Technologies Inc. 8.375% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-sncy",
      code: "NYSE:SNCY",
      companyName: "Sun Country Airlines Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snd",
      code: "NYSE:SND",
      companyName: "Smart Sand Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snda",
      code: "NYSE:SNDA",
      companyName: "Sonida Senior Living Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sndl",
      code: "NYSE:SNDL",
      companyName: "Sundial Growers Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sndx",
      code: "NYSE:SNDX",
      companyName: "Syndax Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-snes",
      code: "NYSE:SNES",
      companyName: "SenesTech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snex",
      code: "NYSE:SNEX",
      companyName: "StoneX Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snfca",
      code: "NYSE:SNFCA",
      companyName: "Security National Financial Co",
      popularity: 0,
    },
    {
      slug: "nyse-sngx",
      code: "NYSE:SNGX",
      companyName: "Soligenix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snln",
      code: "NYSE:SNLN",
      companyName: "Highland/iBoxx Senior Loan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-snmp",
      code: "NYSE:SNMP",
      companyName: "Evolve Transition Infrastructure LP",
      popularity: 0,
    },
    {
      slug: "nyse-snn",
      code: "NYSE:SNN",
      companyName: "Smith & Nephew plc",
      popularity: 0,
    },
    {
      slug: "nyse-snoa",
      code: "NYSE:SNOA",
      companyName: "Sonoma Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snsr",
      code: "NYSE:SNSR",
      companyName: "Global X Funds Global X Internet of Things ETF",
      popularity: 0,
    },
    {
      slug: "nyse-snp",
      code: "NYSE:SNP",
      companyName:
        "CHINA PETROLEUM & CHEMICAL CORPORATION ADS (REP 100 ORDINARY H SHARES)",
      popularity: 0,
    },
    {
      slug: "nyse-snpe",
      code: "NYSE:SNPE",
      companyName: "Xtrackers S&P 500 ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-snpo",
      code: "NYSE:SNPO",
      companyName: "Snap One Holdings Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snpx",
      code: "NYSE:SNPX",
      companyName: "Synaptogenix Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snrh",
      code: "NYSE:SNRH",
      companyName: "Senior Connect Acquisition Corp. I Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snrhu",
      code: "NYSE:SNRHU",
      companyName: "Senior Connect Acquisition Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-snrhw",
      code: "NYSE:SNRHW",
      companyName: "Senior Connect Acquisition Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-snse",
      code: "NYSE:SNSE",
      companyName: "Sensei Biotherapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snt",
      code: "NYSE:SNT",
      companyName: "Senstar Technologies Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sntg",
      code: "NYSE:SNTG",
      companyName: "Sentage Holdings Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-snti",
      code: "NYSE:SNTI",
      companyName: "Senti Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-snug",
      code: "NYSE:SNUG",
      companyName: "Merlyn.AI Tactical Growth & Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-snv",
      code: "NYSE:SNV",
      companyName: "Synovus Financial Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-snv-d",
      code: "NYSE:SNV-D",
      companyName:
        "Synovus Financial Corp. Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Series D Li",
      popularity: 0,
    },
    {
      slug: "nyse-snv-e",
      code: "NYSE:SNV-E",
      companyName:
        "Synovus Financial Corp. 5.875% Fixed-Rate Reset Non-Cumulative Perpetual Preferred Stock Series E",
      popularity: 0,
    },
    {
      slug: "nyse-soxx",
      code: "NYSE:SOXX",
      companyName: "iShares Semiconductor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-so",
      code: "NYSE:SO",
      companyName: "The Southern Company",
      popularity: 0,
    },
    {
      slug: "nyse-sobr",
      code: "NYSE:SOBR",
      companyName: "SOBR Safe Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sofi",
      code: "NYSE:SOFI",
      companyName: "SoFi Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sofo",
      code: "NYSE:SOFO",
      companyName: "Sonic Foundry Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sogu",
      code: "NYSE:SOGU",
      companyName: "AXS Short De-SPAC Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-soho",
      code: "NYSE:SOHO",
      companyName: "Sotherly Hotels Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sohob",
      code: "NYSE:SOHOB",
      companyName:
        "Sotherly Hotels Inc. 8.0% Series B Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sohon",
      code: "NYSE:SOHON",
      companyName:
        "Sotherly Hotels Inc. 8.25% Series D Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sohoo",
      code: "NYSE:SOHOO",
      companyName:
        "Sotherly Hotels Inc. 7.875 Percent Series C Cumulative Redeemable Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sohu",
      code: "NYSE:SOHU",
      companyName: "Sohu.com Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-soi",
      code: "NYSE:SOI",
      companyName: "Solaris Oilfield Infrastructure Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sojc",
      code: "NYSE:SOJC",
      companyName:
        "The Southern Company Series 2017B 5.25% Junior Subordinated Notes due December 1 2077",
      popularity: 0,
    },
    {
      slug: "nyse-sojd",
      code: "NYSE:SOJD",
      companyName:
        "The Southern Company Series 2020A 4.95% Junior Subordinated Notes due January 30 2080",
      popularity: 0,
    },
    {
      slug: "nyse-soje",
      code: "NYSE:SOJE",
      companyName:
        "The Southern Company Series 2020C 4.20% Junior Subordinated Notes due October 15 2060",
      popularity: 0,
    },
    {
      slug: "nyse-sol",
      code: "NYSE:SOL",
      companyName:
        "ReneSola Ltd American Depositary (Each representing ten shares)",
      popularity: 0,
    },
    {
      slug: "nyse-solo",
      code: "NYSE:SOLO",
      companyName: "Electrameccanica Vehicles Corp. Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-solow",
      code: "NYSE:SOLOW",
      companyName: "Electrameccanica Vehicles Corp. Ltd. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-solr",
      code: "NYSE:SOLR",
      companyName: "SmartETFs Sustainable Energy II ETF",
      popularity: 0,
    },
    {
      slug: "nyse-son",
      code: "NYSE:SON",
      companyName: "Sonoco Products Company",
      popularity: 0,
    },
    {
      slug: "nyse-sond",
      code: "NYSE:SOND",
      companyName: "Sonder Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sondw",
      code: "NYSE:SONDW",
      companyName: "Sonder Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-sonm",
      code: "NYSE:SONM",
      companyName: "Sonim Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sonn",
      code: "NYSE:SONN",
      companyName: "Sonnet BioTherapeutics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sono",
      code: "NYSE:SONO",
      companyName: "Sonos Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sonx",
      code: "NYSE:SONX",
      companyName: "Sonendo Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sony",
      code: "NYSE:SONY",
      companyName:
        "Sony Group Corporation American Depositary Shares (Each Representing One Share of Dollar Validated C",
      popularity: 0,
    },
    {
      slug: "nyse-sopa",
      code: "NYSE:SOPA",
      companyName: "Society Pass Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-soph",
      code: "NYSE:SOPH",
      companyName: "SOPHiA GENETICS SA Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sor",
      code: "NYSE:SOR",
      companyName: "Source Capital Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sos",
      code: "NYSE:SOS",
      companyName:
        "SOS Limited American Depositary Shares each representing five hundred (500) Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sotk",
      code: "NYSE:SOTK",
      companyName: "Sono-Tek Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-soun",
      code: "NYSE:SOUN",
      companyName: "SoundHound AI Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sounw",
      code: "NYSE:SOUNW",
      companyName: "SoundHound AI Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sovo",
      code: "NYSE:SOVO",
      companyName: "Sovos Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-soxl",
      code: "NYSE:SOXL",
      companyName: "Direxion Daily Semiconductor Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-soxq",
      code: "NYSE:SOXQ",
      companyName: "Invesco PHLX Semiconductor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-soxs",
      code: "NYSE:SOXS",
      companyName: "Direxion Daily Semiconductor Bear 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-soyb",
      code: "NYSE:SOYB",
      companyName: "Teucrium Soybean Fund",
      popularity: 0,
    },
    {
      slug: "nyse-sp",
      code: "NYSE:SP",
      companyName: "SP Plus Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-spab",
      code: "NYSE:SPAB",
      companyName: "SPDR Portfolio Aggregate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spak",
      code: "NYSE:SPAK",
      companyName: "Defiance Next Gen SPAC Derived ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spax",
      code: "NYSE:SPAX",
      companyName: "Robinson Alternative Yield Pre-merger SPAC ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spb",
      code: "NYSE:SPB",
      companyName: "Spectrum Brands Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-spbc",
      code: "NYSE:SPBC",
      companyName: "Simplify U.S. Equity PLUS GBTC ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spbo",
      code: "NYSE:SPBO",
      companyName: "SPDR Portfolio Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spc",
      code: "NYSE:SPC",
      companyName: "CrossingBridge Pre-Merger SPAC ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spcb",
      code: "NYSE:SPCB",
      companyName: "SuperCom Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-spcm",
      code: "NYSE:SPCM",
      companyName: "Sound Point Acquisition Corp I Ltd Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-spcmu",
      code: "NYSE:SPCMU",
      companyName: "Sound Point Acquisition Corp I Ltd Unit",
      popularity: 0,
    },
    {
      slug: "nyse-spcmw",
      code: "NYSE:SPCMW",
      companyName: "Sound Point Acquisition Corp I Ltd Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-spcx",
      code: "NYSE:SPCX",
      companyName: "The SPAC and New Issue ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spff",
      code: "NYSE:SPFF",
      companyName: "Global X SuperIncome Preferred ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spcz",
      code: "NYSE:SPCZ",
      companyName: "RiverNorth Enhanced Pre-Merger SPAC ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spd",
      code: "NYSE:SPD",
      companyName: "Simplify US Equity PLUS Downside Convexity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spdn",
      code: "NYSE:SPDN",
      companyName: "Direxion Daily S&P 500 Bear 1X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-spdv",
      code: "NYSE:SPDV",
      companyName: "AAM S&P 500 High Dividend Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spdw",
      code: "NYSE:SPDW",
      companyName: "SPDR Portfolio Developed World ex-US ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spe",
      code: "NYSE:SPE",
      companyName: "Special Opportunities Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-spe-c",
      code: "NYSE:SPE-C",
      companyName:
        "Special Opportunities Fund Inc. 2.75% Convertible Preferred Stock Series C",
      popularity: 0,
    },
    {
      slug: "nyse-spem",
      code: "NYSE:SPEM",
      companyName: "SPDR Portfolio Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-speu",
      code: "NYSE:SPEU",
      companyName: "SPDR Portfolio Europe ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spfi",
      code: "NYSE:SPFI",
      companyName: "South Plains Financial Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-spg-j",
      code: "NYSE:SPG-J",
      companyName: "Simon Property Group Inc. 8 3/8% Series J",
      popularity: 0,
    },
    {
      slug: "nyse-spgi",
      code: "NYSE:SPGI",
      companyName: "S&P Global Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-spgm",
      code: "NYSE:SPGM",
      companyName: "SPDR Portfolio MSCI Global Stock Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spgp",
      code: "NYSE:SPGP",
      companyName: "Invesco S&P 500 GARP ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spgs",
      code: "NYSE:SPGS",
      companyName: "Simon Property Group Acquisition Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sph",
      code: "NYSE:SPH",
      companyName: "Suburban Propane Partners L P",
      popularity: 0,
    },
    {
      slug: "nyse-sphb",
      code: "NYSE:SPHB",
      companyName: "Invesco S&P 500 High Beta ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sphd",
      code: "NYSE:SPHD",
      companyName: "Invesco S&P 500 High Dividend Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sphq",
      code: "NYSE:SPHQ",
      companyName: "Invesco S&P 500 Quality ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spi",
      code: "NYSE:SPI",
      companyName: "SPI Energy Co. Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-spib",
      code: "NYSE:SPIB",
      companyName: "SPDR Portfolio Intermediate Term Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spip",
      code: "NYSE:SPIP",
      companyName: "SPDR Portfolio TIPS ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spir",
      code: "NYSE:SPIR",
      companyName: "Spire Global Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-spk",
      code: "NYSE:SPK",
      companyName: "SPK Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-spkar",
      code: "NYSE:SPKAR",
      companyName: "SPK Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-spkau",
      code: "NYSE:SPKAU",
      companyName: "SPK Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-spkb",
      code: "NYSE:SPKB",
      companyName: "Silver Spike Acquisition Corp II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-spkbu",
      code: "NYSE:SPKBU",
      companyName: "Silver Spike Acquisition Corp II Units",
      popularity: 0,
    },
    {
      slug: "nyse-spkbw",
      code: "NYSE:SPKBW",
      companyName: "Silver Spike Acquisition Corp II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-spkx",
      code: "NYSE:SPKX",
      companyName: "ConvexityShares 1X SPIKES Futures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spky",
      code: "NYSE:SPKY",
      companyName: "ConvexityShares Daily 1.5X SPIKES Futures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-splb",
      code: "NYSE:SPLB",
      companyName: "SPDR Portfolio Long Term Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-splg",
      code: "NYSE:SPLG",
      companyName: "SPDR Portfolio S&P 500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-splk",
      code: "NYSE:SPLK",
      companyName: "Splunk Inc",
      popularity: 0,
    },
    {
      slug: "nyse-splp",
      code: "NYSE:SPLP",
      companyName: "STEEL PARTNERS HOLDINGS L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-splp-a",
      code: "NYSE:SPLP-A",
      companyName:
        "Steel Partners Holdings L.P. 6.0% Series A Preferred Units no par value",
      popularity: 0,
    },
    {
      slug: "nyse-splv",
      code: "NYSE:SPLV",
      companyName: "Invesco S&P 500 Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spmb",
      code: "NYSE:SPMB",
      companyName: "SPDR Portfolio Mortgage Backed Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spmd",
      code: "NYSE:SPMD",
      companyName: "SPDR Portfolio S&P 400 Mid Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spmo",
      code: "NYSE:SPMO",
      companyName: "Invesco S&P 500 Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spmv",
      code: "NYSE:SPMV",
      companyName: "Invesco S&P 500 Minimum Variance ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spne",
      code: "NYSE:SPNE",
      companyName: "SeaSpine Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-spns",
      code: "NYSE:SPNS",
      companyName:
        "Sapiens International Corporation N.V. Common Shares (Cayman Islands)",
      popularity: 0,
    },
    {
      slug: "nyse-spnt",
      code: "NYSE:SPNT",
      companyName: "SiriusPoint Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-spnt-b",
      code: "NYSE:SPNT-B",
      companyName:
        "SiriusPoint Ltd. 8.00% Resettable Fixed Rate Preference Shares Series B $25.00 liquidation prefere",
      popularity: 0,
    },
    {
      slug: "nyse-spok",
      code: "NYSE:SPOK",
      companyName: "Spok Holdings Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sppi",
      code: "NYSE:SPPI",
      companyName: "Spectrum Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sppp",
      code: "NYSE:SPPP",
      companyName: "Sprott Physical Platinum and Palladium Trust",
      popularity: 0,
    },
    {
      slug: "nyse-spr",
      code: "NYSE:SPR",
      companyName: "Spirit Aerosystems Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sprb",
      code: "NYSE:SPRB",
      companyName: "Spruce Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sprc",
      code: "NYSE:SPRC",
      companyName: "SciSparc Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-spre",
      code: "NYSE:SPRE",
      companyName: "SP Funds S&P Global REIT Sharia ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spro",
      code: "NYSE:SPRO",
      companyName: "Spero Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sprx",
      code: "NYSE:SPRX",
      companyName: "Spear Alpha ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spsb",
      code: "NYSE:SPSB",
      companyName: "SPDR Portfolio Short Term Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spsc",
      code: "NYSE:SPSC",
      companyName: "SPS Commerce Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-spsk",
      code: "NYSE:SPSK",
      companyName: "SP Funds Dow Jones Global Sukuk ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spsm",
      code: "NYSE:SPSM",
      companyName: "SPDR Portfolio S&P 600 Small Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spt",
      code: "NYSE:SPT",
      companyName: "Sprout Social Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-spti",
      code: "NYSE:SPTI",
      companyName: "SPDR Portfolio Intermediate Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sptk",
      code: "NYSE:SPTK",
      companyName: "SportsTek Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sphy",
      code: "NYSE:SPHY",
      companyName: "SPDR Portfolio High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sptku",
      code: "NYSE:SPTKU",
      companyName: "SportsTek Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-sptkw",
      code: "NYSE:SPTKW",
      companyName: "SportsTek Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sptl",
      code: "NYSE:SPTL",
      companyName: "SPDR Portfolio Long Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sptm",
      code: "NYSE:SPTM",
      companyName: "SPDR Portfolio S&P 1500 Composite Stock Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sptn",
      code: "NYSE:SPTN",
      companyName: "SpartanNash Company",
      popularity: 0,
    },
    {
      slug: "nyse-spts",
      code: "NYSE:SPTS",
      companyName: "SPDR Portfolio Short Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spuc",
      code: "NYSE:SPUC",
      companyName: "Simplify US Equity PLUS Upside Convexity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spus",
      code: "NYSE:SPUS",
      companyName: "SP Funds S&P 500 Sharia  ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spuu",
      code: "NYSE:SPUU",
      companyName: "Direxion Daily S&P 500 Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-spvm",
      code: "NYSE:SPVM",
      companyName: "Invesco S&P 500 Value with Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spvu",
      code: "NYSE:SPVU",
      companyName: "Invesco S&P 500 Enhanced Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spwh",
      code: "NYSE:SPWH",
      companyName: "Sportsman's Warehouse Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-spwr",
      code: "NYSE:SPWR",
      companyName: "SunPower Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-spxb",
      code: "NYSE:SPXB",
      companyName: "ProShares S&P 500 Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spxc",
      code: "NYSE:SPXC",
      companyName: "SPX Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-spxe",
      code: "NYSE:SPXE",
      companyName: "ProShares S&P 500 Ex-Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spxl",
      code: "NYSE:SPXL",
      companyName: "Direxion Daily S&P 500  Bull 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-spxn",
      code: "NYSE:SPXN",
      companyName: "ProShares S&P 500 Ex-Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spxs",
      code: "NYSE:SPXS",
      companyName: "Direxion Daily S&P 500 Bear 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-spxt",
      code: "NYSE:SPXT",
      companyName: "ProShares S&P 500 Ex-Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spxu",
      code: "NYSE:SPXU",
      companyName: "ProShares UltraPro Short S&P 500",
      popularity: 0,
    },
    {
      slug: "nyse-spxv",
      code: "NYSE:SPXV",
      companyName: "ProShares S&P 500 Ex-Health Care ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spxx",
      code: "NYSE:SPXX",
      companyName: "NUVEEN S&P 500 DYNAMIC OVERWRITE FUND",
      popularity: 0,
    },
    {
      slug: "nyse-spyc",
      code: "NYSE:SPYC",
      companyName: "Simplify US Equity PLUS Convexity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spyd",
      code: "NYSE:SPYD",
      companyName: "SPDR Portfolio S&P 500 High Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spyg",
      code: "NYSE:SPYG",
      companyName: "SPDR Portfolio S&P 500 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spyv",
      code: "NYSE:SPYV",
      companyName: "SPDR Portfolio S&P 500 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spyx",
      code: "NYSE:SPYX",
      companyName: "SPDR S&P 500 Fossil Fuel Free ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sret",
      code: "NYSE:SRET",
      companyName: "Global X SuperDividend REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sqew",
      code: "NYSE:SQEW",
      companyName: "LeaderShares Equity Skew ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sqft",
      code: "NYSE:SQFT",
      companyName: "Presidio Property Trust Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sqftp",
      code: "NYSE:SQFTP",
      companyName:
        "Presidio Property Trust Inc. 9.375% Series D Cumulative Redeemable Perpetual Preferred Stock $0.01",
      popularity: 0,
    },
    {
      slug: "nyse-sqftw",
      code: "NYSE:SQFTW",
      companyName:
        "Presidio Property Trust Inc. Series A Common Stock Purchase Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-sql",
      code: "NYSE:SQL",
      companyName: "SeqLL Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-sqllw",
      code: "NYSE:SQLLW",
      companyName: "SeqLL Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sqlv",
      code: "NYSE:SQLV",
      companyName: "Royce Quant Small-Cap Quality Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-spy",
      code: "NYSE:SPY",
      companyName: "SPDR S&P 500 ETF Trust",
      popularity: 0,
    },
    {
      slug: "nyse-sqns",
      code: "NYSE:SQNS",
      companyName:
        "Sequans Communications S.A. American Depositary Shares each representing four Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sqqq",
      code: "NYSE:SQQQ",
      companyName: "ProShares UltraPro Short QQQ",
      popularity: 0,
    },
    {
      slug: "nyse-sqsp",
      code: "NYSE:SQSP",
      companyName: "Squarespace Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sqz",
      code: "NYSE:SQZ",
      companyName: "SQZ Biotechnologies Company",
      popularity: 0,
    },
    {
      slug: "nyse-sr",
      code: "NYSE:SR",
      companyName: "Spire Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sr-a",
      code: "NYSE:SR-A",
      companyName:
        "Spire Inc. Depositary Shares each representing a 1/1000th interest in a share of 5.90% Series A Cu",
      popularity: 0,
    },
    {
      slug: "nyse-srad",
      code: "NYSE:SRAD",
      companyName: "Sportradar Group AG Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-srax",
      code: "NYSE:SRAX",
      companyName: "SRAX Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-src",
      code: "NYSE:SRC",
      companyName: "SPIRIT REALTY CAPITAL INC.",
      popularity: 0,
    },
    {
      slug: "nyse-src-a",
      code: "NYSE:SRC-A",
      companyName:
        "Spirit Realty Capital Inc. 6.000 Percent Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-srce",
      code: "NYSE:SRCE",
      companyName: "1st Source Corp",
      popularity: 0,
    },
    {
      slug: "nyse-srcl",
      code: "NYSE:SRCL",
      companyName: "Stericycle Inc",
      popularity: 0,
    },
    {
      slug: "nyse-srdx",
      code: "NYSE:SRDX",
      companyName: "Surmodics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sre",
      code: "NYSE:SRE",
      companyName: "Sempra",
      popularity: 0,
    },
    {
      slug: "nyse-srea",
      code: "NYSE:SREA",
      companyName: "Sempra 5.750% Junior Subordinated Notes due 2079",
      popularity: 0,
    },
    {
      slug: "nyse-srg",
      code: "NYSE:SRG",
      companyName:
        "Seritage Growth Properties Class A common shares of beneficial interest par value $0.01",
      popularity: 0,
    },
    {
      slug: "nyse-srg-a",
      code: "NYSE:SRG-A",
      companyName:
        "Seritage Growth Properties 7.00% Series A Cumulative Redeemable Preferred Shares of Beneficial Inter",
      popularity: 0,
    },
    {
      slug: "nyse-srga",
      code: "NYSE:SRGA",
      companyName: "Surgalign Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sri",
      code: "NYSE:SRI",
      companyName: "Stoneridge Inc",
      popularity: 0,
    },
    {
      slug: "nyse-srl",
      code: "NYSE:SRL",
      companyName: "Scully Royalty Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-srln",
      code: "NYSE:SRLN",
      companyName: "SPDR Blackstone Senior Loan ETF",
      popularity: 0,
    },
    {
      slug: "nyse-srlp",
      code: "NYSE:SRLP",
      companyName: "SPRAGUE RESOURCES LP",
      popularity: 0,
    },
    {
      slug: "nyse-srne",
      code: "NYSE:SRNE",
      companyName: "Sorrento Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-srpt",
      code: "NYSE:SRPT",
      companyName: "Sarepta Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-srrk",
      code: "NYSE:SRRK",
      companyName: "Scholar Rock Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-srs",
      code: "NYSE:SRS",
      companyName: "ProShares UltraShort Real Estate",
      popularity: 0,
    },
    {
      slug: "nyse-srsa",
      code: "NYSE:SRSA",
      companyName: "Sarissa Capital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-srsau",
      code: "NYSE:SRSAU",
      companyName: "Sarissa Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-srsaw",
      code: "NYSE:SRSAW",
      companyName: "Sarissa Capital Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-srt",
      code: "NYSE:SRT",
      companyName: "Startek Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-srts",
      code: "NYSE:SRTS",
      companyName: "Sensus Healthcare Inc",
      popularity: 0,
    },
    {
      slug: "nyse-srty",
      code: "NYSE:SRTY",
      companyName: "ProShares UltraPro Short Russell2000",
      popularity: 0,
    },
    {
      slug: "nyse-srv",
      code: "NYSE:SRV",
      companyName: "The Cushing MLP & Infrastructure Total Return Fund",
      popularity: 0,
    },
    {
      slug: "nyse-srvr",
      code: "NYSE:SRVR",
      companyName: "Pacer Benchmark Data & Infrastructure Real Estate SCTR ETF",
      popularity: 0,
    },
    {
      slug: "nyse-srznw",
      code: "NYSE:SRZNW",
      companyName: "Surrozen Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ssaa",
      code: "NYSE:SSAA",
      companyName:
        "Science Strategic Acquisition Corp. Alpha Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ssaau",
      code: "NYSE:SSAAU",
      companyName: "Science Strategic Acquisition Corp. Alpha Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ssaaw",
      code: "NYSE:SSAAW",
      companyName: "Science Strategic Acquisition Corp. Alpha Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ssb",
      code: "NYSE:SSB",
      companyName: "SouthState Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ssbi",
      code: "NYSE:SSBI",
      companyName: "Summit State Bank",
      popularity: 0,
    },
    {
      slug: "nyse-ssbk",
      code: "NYSE:SSBK",
      companyName: "Southern States Bancshares Inc. Common",
      popularity: 0,
    },
    {
      slug: "nyse-ssd",
      code: "NYSE:SSD",
      companyName: "Simpson Manufacturing Co. Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ssfi",
      code: "NYSE:SSFI",
      companyName: "Day Hagan/Ned Davis Research Smart Sector Fixed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ssg",
      code: "NYSE:SSG",
      companyName: "ProShares UltraShort Semiconductors",
      popularity: 0,
    },
    {
      slug: "nyse-ssic",
      code: "NYSE:SSIC",
      companyName: "Silver Spike Investment Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sskn",
      code: "NYSE:SSKN",
      companyName: "Strata Skin Sciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ssl",
      code: "NYSE:SSL",
      companyName: "Sasol Limited",
      popularity: 0,
    },
    {
      slug: "nyse-ssly",
      code: "NYSE:SSLY",
      companyName: "Syntax Stratified SmallCap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ssnc",
      code: "NYSE:SSNC",
      companyName: "SS&C Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ssnt",
      code: "NYSE:SSNT",
      companyName: "SilverSun Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sso",
      code: "NYSE:SSO",
      companyName: "ProShares Ultra S&P500",
      popularity: 0,
    },
    {
      slug: "nyse-ssp",
      code: "NYSE:SSP",
      companyName: "The E.W. Scripps Company",
      popularity: 0,
    },
    {
      slug: "nyse-sspx",
      code: "NYSE:SSPX",
      companyName: "Janus Henderson US Sustainable EquityETF",
      popularity: 0,
    },
    {
      slug: "nyse-sspy",
      code: "NYSE:SSPY",
      companyName: "Syntax Stratified LargeCap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ssrm",
      code: "NYSE:SSRM",
      companyName: "SSR Mining Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ssss",
      code: "NYSE:SSSS",
      companyName: "SuRo Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ssssl",
      code: "NYSE:SSSSL",
      companyName: "SuRo Capital Corp. 6.00% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-sst",
      code: "NYSE:SST",
      companyName: "System1 Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ssti",
      code: "NYSE:SSTI",
      companyName: "ShotSpotter Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sstk",
      code: "NYSE:SSTK",
      companyName: "SHUTTERSTOCK INC.",
      popularity: 0,
    },
    {
      slug: "nyse-ssu",
      code: "NYSE:SSU",
      companyName: "SIGNA Sports United N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-ssus",
      code: "NYSE:SSUS",
      companyName: "Day Hagan Ned Davis Research Smart Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ssxu",
      code: "NYSE:SSXU",
      companyName:
        "Day Hagan/Ned Davis Research Smart Sector International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ssy",
      code: "NYSE:SSY",
      companyName: "SunLink Health Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ssys",
      code: "NYSE:SSYS",
      companyName: "Stratasys Inc (ISRAEL)",
      popularity: 0,
    },
    {
      slug: "nyse-st",
      code: "NYSE:ST",
      companyName: "Sensata Technologies Holding plc",
      popularity: 0,
    },
    {
      slug: "nyse-staa",
      code: "NYSE:STAA",
      companyName: "Staar Surgical Co",
      popularity: 0,
    },
    {
      slug: "nyse-stab",
      code: "NYSE:STAB",
      companyName: "Statera Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-staf",
      code: "NYSE:STAF",
      companyName: "Staffing 360 Solutions Inc. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-stag",
      code: "NYSE:STAG",
      companyName: "STAG INDUSTRIAL INC.",
      popularity: 0,
    },
    {
      slug: "nyse-star",
      code: "NYSE:STAR",
      companyName: "ISTAR INC",
      popularity: 0,
    },
    {
      slug: "nyse-star-d",
      code: "NYSE:STAR-D",
      companyName: "ISTAR INC. Series D Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-star-g",
      code: "NYSE:STAR-G",
      companyName:
        "ISTAR INC. 7.65% Series G Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-star-i",
      code: "NYSE:STAR-I",
      companyName:
        "ISTAR INC. 7.50% Series I Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stba",
      code: "NYSE:STBA",
      companyName: "S&T Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-stbl",
      code: "NYSE:STBL",
      companyName: "DriveWealth Steady Saver ETF",
      popularity: 0,
    },
    {
      slug: "nyse-stc",
      code: "NYSE:STC",
      companyName: "Stewart Information Services Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-stce",
      code: "NYSE:STCE",
      companyName: "Schwab Crypto Thematic ETF",
      popularity: 0,
    },
    {
      slug: "nyse-stcn",
      code: "NYSE:STCN",
      companyName: "Steel Connect Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stem",
      code: "NYSE:STEM",
      companyName: "Stem Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-step",
      code: "NYSE:STEP",
      companyName: "StepStone Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ster",
      code: "NYSE:STER",
      companyName: "Sterling Check Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stet",
      code: "NYSE:STET",
      companyName: "ST Energy Transition I Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-stew",
      code: "NYSE:STEW",
      companyName: "SRH Total Return Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-stg",
      code: "NYSE:STG",
      companyName:
        "Sunlands Technology Group American Depositary Shares  American Depositary Shares every two (2) AD",
      popularity: 0,
    },
    {
      slug: "nyse-stgf",
      code: "NYSE:STGF",
      companyName: "Merk Stagflation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-stgw",
      code: "NYSE:STGW",
      companyName: "Stagwell Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stim",
      code: "NYSE:STIM",
      companyName: "Neuronetics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stip",
      code: "NYSE:STIP",
      companyName: "iShares 0-5 Year TIPS Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-stix",
      code: "NYSE:STIX",
      companyName: "Semantix Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-stixw",
      code: "NYSE:STIXW",
      companyName: "Semantix Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-stk",
      code: "NYSE:STK",
      companyName: "Columbia Seligman Premium Technology Growth Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-stkh",
      code: "NYSE:STKH",
      companyName: "Steakholder Foods Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-stkl",
      code: "NYSE:STKL",
      companyName: "SunOpta Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-stks",
      code: "NYSE:STKS",
      companyName: "The ONE Group Hospitality Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stla",
      code: "NYSE:STLA",
      companyName: "Stellantis N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-stld",
      code: "NYSE:STLD",
      companyName: "Steel Dynamics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-stlg",
      code: "NYSE:STLG",
      companyName: "iShares Factors US Growth Style ETF",
      popularity: 0,
    },
    {
      slug: "nyse-stlv",
      code: "NYSE:STLV",
      companyName: "iShares Factors US Value Style ETF",
      popularity: 0,
    },
    {
      slug: "nyse-stm",
      code: "NYSE:STM",
      companyName: "STMicroelectronics N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-stnc",
      code: "NYSE:STNC",
      companyName: "Stance Equity ESG Large Cap Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-stne",
      code: "NYSE:STNE",
      companyName: "StoneCo Ltd. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-stng",
      code: "NYSE:STNG",
      companyName: "Scorpio Tankers Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-stok",
      code: "NYSE:STOK",
      companyName: "Stoke Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ston",
      code: "NYSE:STON",
      companyName: "StoneMor Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-stor",
      code: "NYSE:STOR",
      companyName: "STORE Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-stot",
      code: "NYSE:STOT",
      companyName: "SPDR DoubleLine Short Duration Total Return Tactical ETF",
      popularity: 0,
    },
    {
      slug: "nyse-stpz",
      code: "NYSE:STPZ",
      companyName: "PIMCO 1-5 Year U.S. TIPS Index Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-str",
      code: "NYSE:STR",
      companyName: "Sitio Royalties Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-stra",
      code: "NYSE:STRA",
      companyName: "Strategic Education Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-strc",
      code: "NYSE:STRC",
      companyName: "Sarcos Technology and Robotics Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-strcw",
      code: "NYSE:STRCW",
      companyName: "Sarcos Technology and Robotics Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-stre",
      code: "NYSE:STRE",
      companyName: "Supernova Partners Acquisition Company III Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-strl",
      code: "NYSE:STRL",
      companyName: "Sterling Infrastructure Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-strm",
      code: "NYSE:STRM",
      companyName: "Streamline Health Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-strn",
      code: "NYSE:STRN",
      companyName: "86260J102 NASDAQ PILLAR Stran & Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-strnw",
      code: "NYSE:STRNW",
      companyName: "Stran & Company Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-stro",
      code: "NYSE:STRO",
      companyName: "Sutro Biopharma Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-strr",
      code: "NYSE:STRR",
      companyName: "Star Equity Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-strrp",
      code: "NYSE:STRRP",
      companyName:
        "Star Equity Holdings Inc. Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-strs",
      code: "NYSE:STRS",
      companyName: "Stratus Properties Inc",
      popularity: 0,
    },
    {
      slug: "nyse-strt",
      code: "NYSE:STRT",
      companyName: "Strattec Security Corp",
      popularity: 0,
    },
    {
      slug: "nyse-stry",
      code: "NYSE:STRY",
      companyName: "Starry Group Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-stsa",
      code: "NYSE:STSA",
      companyName: "Satsuma Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stss",
      code: "NYSE:STSS",
      companyName: "Sharps Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stssw",
      code: "NYSE:STSSW",
      companyName: "Sharps Technology Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-stt",
      code: "NYSE:STT",
      companyName: "State Street Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-stt-d",
      code: "NYSE:STT-D",
      companyName:
        "State Street Corporation Depository Shares each representing a 1/4000th ownership interest in a sha",
      popularity: 0,
    },
    {
      slug: "nyse-stt-g",
      code: "NYSE:STT-G",
      companyName:
        "State Street Corporation Depositary shares each representing a 1/4000th ownership interest in a sh",
      popularity: 0,
    },
    {
      slug: "nyse-sttk",
      code: "NYSE:STTK",
      companyName: "Shattuck Labs Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stvn",
      code: "NYSE:STVN",
      companyName: "Stevanato Group S.p.A.",
      popularity: 0,
    },
    {
      slug: "nyse-stwd",
      code: "NYSE:STWD",
      companyName: "STARWOOD PROPERTY TRUST INC.",
      popularity: 0,
    },
    {
      slug: "nyse-stx",
      code: "NYSE:STX",
      companyName: "Seagate Technology Holdings PLC Ordinary Shares (Ireland)",
      popularity: 0,
    },
    {
      slug: "nyse-stxs",
      code: "NYSE:STXS",
      companyName: "Stereotaxis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-stz",
      code: "NYSE:STZ",
      companyName: "Constellation Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-su",
      code: "NYSE:SU",
      companyName: "Suncor Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-suac",
      code: "NYSE:SUAC",
      companyName: "ShoulderUp Technology Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-sub",
      code: "NYSE:SUB",
      companyName: "iShares Short-Term National Muni Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-subs",
      code: "NYSE:SUBS",
      companyName: "Fount Subscription Economy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sui",
      code: "NYSE:SUI",
      companyName: "Sun Communities Inc",
      popularity: 0,
    },
    {
      slug: "nyse-sum",
      code: "NYSE:SUM",
      companyName: "Summit Materials Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sumo",
      code: "NYSE:SUMO",
      companyName: "Sumo Logic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sun",
      code: "NYSE:SUN",
      companyName: "SUNOCO L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-sunl",
      code: "NYSE:SUNL",
      companyName: "Sunlight Financial Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sunw",
      code: "NYSE:SUNW",
      companyName: "Sunworks Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sup",
      code: "NYSE:SUP",
      companyName: "Superior Industries International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-supl",
      code: "NYSE:SUPL",
      companyName: "ProShares Supply Chain Logistics ETF",
      popularity: 0,
    },
    {
      slug: "nyse-supn",
      code: "NYSE:SUPN",
      companyName: "Supernus Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-supv",
      code: "NYSE:SUPV",
      companyName: "Grupo Supervielle S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-surf",
      code: "NYSE:SURF",
      companyName: "Surface Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-surg",
      code: "NYSE:SURG",
      companyName: "SurgePays Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-surgw",
      code: "NYSE:SURGW",
      companyName: "SurgePays Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-susa",
      code: "NYSE:SUSA",
      companyName: "iShares MSCI USA ESG Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-susb",
      code: "NYSE:SUSB",
      companyName:
        "iShares Trust iShares ESG Aware 1-5 Year USD Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-susc",
      code: "NYSE:SUSC",
      companyName: "iShares Trust iShares ESG Aware USD Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-susl",
      code: "NYSE:SUSL",
      companyName: "iShares ESG MSCI USA Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-suz",
      code: "NYSE:SUZ",
      companyName:
        "Suzano S.A. American Depositary Shares (each representing one Ordinary Share ) representing one Ordi",
      popularity: 0,
    },
    {
      slug: "nyse-sva",
      code: "NYSE:SVA",
      companyName: "Sinovac Biotech Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-sval",
      code: "NYSE:SVAL",
      companyName: "iShares US Small Cap Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-svc",
      code: "NYSE:SVC",
      companyName: "Service Properties Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-svfa",
      code: "NYSE:SVFA",
      companyName: "SVF Investment Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-svfau",
      code: "NYSE:SVFAU",
      companyName: "SVF Investment Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-svfaw",
      code: "NYSE:SVFAW",
      companyName: "SVF Investment Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-svfb",
      code: "NYSE:SVFB",
      companyName: "SVF Investment Corp. 2 Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-svfd",
      code: "NYSE:SVFD",
      companyName: "Save Foods Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-svix",
      code: "NYSE:SVIX",
      companyName: "-1x Short VIX Futures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-svm",
      code: "NYSE:SVM",
      companyName: "Silvercorp Metals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-svna",
      code: "NYSE:SVNA",
      companyName: "7 Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-svnau",
      code: "NYSE:SVNAU",
      companyName: "7 Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-svnaw",
      code: "NYSE:SVNAW",
      companyName: "7 Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-svol",
      code: "NYSE:SVOL",
      companyName: "Simplify Volatility Premium ETF",
      popularity: 0,
    },
    {
      slug: "nyse-svra",
      code: "NYSE:SVRA",
      companyName: "Savara Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-svre",
      code: "NYSE:SVRE",
      companyName: "SaverOne 2014 Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-svrew",
      code: "NYSE:SVREW",
      companyName: "SaverOne 2014 Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-svt",
      code: "NYSE:SVT",
      companyName: "Servotronics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-svvc",
      code: "NYSE:SVVC",
      companyName: "Firsthand Technology Value Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-svxy",
      code: "NYSE:SVXY",
      companyName: "ProShares Short VIX Short-Term Futures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-swag",
      code: "NYSE:SWAG",
      companyName: "Software Acquisition Group Inc. III Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-swagu",
      code: "NYSE:SWAGU",
      companyName: "Software Acquisition Group Inc. III Unit",
      popularity: 0,
    },
    {
      slug: "nyse-swagw",
      code: "NYSE:SWAGW",
      companyName: "Software Acquisition Group Inc. III Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-swan",
      code: "NYSE:SWAN",
      companyName: "Amplify BlackSwan Growth & Treasure Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-swar",
      code: "NYSE:SWAR",
      companyName: "Direxion Daily Software Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-swav",
      code: "NYSE:SWAV",
      companyName: "ShockWave Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-swbi",
      code: "NYSE:SWBI",
      companyName: "Smith & Wesson Brands Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-swch",
      code: "NYSE:SWCH",
      companyName: "Switch Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sweb",
      code: "NYSE:SWEB",
      companyName: "AXS Short China Internet ETF",
      popularity: 0,
    },
    {
      slug: "nyse-swet",
      code: "NYSE:SWET",
      companyName: "Athlon Acquisition Corp. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-swetu",
      code: "NYSE:SWETU",
      companyName: "Athlon Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-swetw",
      code: "NYSE:SWETW",
      companyName: "Athlon Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-swi",
      code: "NYSE:SWI",
      companyName: "SolarWinds Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-swim",
      code: "NYSE:SWIM",
      companyName: "Latham Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-swir",
      code: "NYSE:SWIR",
      companyName: "Sierra Wireless",
      popularity: 0,
    },
    {
      slug: "nyse-swk",
      code: "NYSE:SWK",
      companyName: "Stanley Black & Decker Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-swkh",
      code: "NYSE:SWKH",
      companyName: "SWK Holdings Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-swks",
      code: "NYSE:SWKS",
      companyName: "Skyworks Solutions Inc",
      popularity: 0,
    },
    {
      slug: "nyse-swn",
      code: "NYSE:SWN",
      companyName: "Southwestern Energy Company",
      popularity: 0,
    },
    {
      slug: "nyse-swss",
      code: "NYSE:SWSS",
      companyName: "Springwater Special Situations Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-swssu",
      code: "NYSE:SWSSU",
      companyName: "Springwater Special Situations Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-swssw",
      code: "NYSE:SWSSW",
      companyName: "Springwater Special Situations Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-swt",
      code: "NYSE:SWT",
      companyName: "Stanley Black & Decker Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-swtx",
      code: "NYSE:SWTX",
      companyName: "SpringWorks Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-swvl",
      code: "NYSE:SWVL",
      companyName: "Swvl Holdings Corp Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-swvlw",
      code: "NYSE:SWVLW",
      companyName: "Swvl Holdings Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-swx",
      code: "NYSE:SWX",
      companyName: "Southwest Gas Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-swz",
      code: "NYSE:SWZ",
      companyName: "Swiss Helvetia Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sxc",
      code: "NYSE:SXC",
      companyName: "SUNCOKE ENERGY INC",
      popularity: 0,
    },
    {
      slug: "nyse-sxi",
      code: "NYSE:SXI",
      companyName: "Standex International Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-sxqg",
      code: "NYSE:SXQG",
      companyName: "ETC 6 Meridian Quality Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sxt",
      code: "NYSE:SXT",
      companyName: "Sensient Technology Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-sxtc",
      code: "NYSE:SXTC",
      companyName: "China SXT Pharmaceuticals Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sxus",
      code: "NYSE:SXUS",
      companyName: "Janus Henderson International Sustainable Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sy",
      code: "NYSE:SY",
      companyName: "So-Young International Inc. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-sybt",
      code: "NYSE:SYBT",
      companyName: "Stock Yards Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sybx",
      code: "NYSE:SYBX",
      companyName: "Synlogic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-syf",
      code: "NYSE:SYF",
      companyName: "SYNCHRONY FINANCIAL",
      popularity: 0,
    },
    {
      slug: "nyse-syf-a",
      code: "NYSE:SYF-A",
      companyName:
        "Synchrony Financial Depositary Shares each Representing a 1/40th Interest in a Share of 5.625% Fixe",
      popularity: 0,
    },
    {
      slug: "nyse-syii",
      code: "NYSE:SYII",
      companyName: "Syntax Stratified Total Market II ETF",
      popularity: 0,
    },
    {
      slug: "nyse-syld",
      code: "NYSE:SYLD",
      companyName: "Cambria Shareholder Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sym",
      code: "NYSE:SYM",
      companyName: "Symbotic Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-syn",
      code: "NYSE:SYN",
      companyName: "Synthetic Biologics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-syna",
      code: "NYSE:SYNA",
      companyName: "Synaptics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-synh",
      code: "NYSE:SYNH",
      companyName: "Syneos Health Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sypr",
      code: "NYSE:SYPR",
      companyName: "Sypris Solutions Inc",
      popularity: 0,
    },
    {
      slug: "nyse-syrs",
      code: "NYSE:SYRS",
      companyName: "Syros Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-syta",
      code: "NYSE:SYTA",
      companyName: "Siyata Mobile Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sytaw",
      code: "NYSE:SYTAW",
      companyName: "Siyata Mobile Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-syus",
      code: "NYSE:SYUS",
      companyName: "Syntax Stratified U.S. Total Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-syy",
      code: "NYSE:SYY",
      companyName: "Sysco Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-szc",
      code: "NYSE:SZC",
      companyName: "The Cushing NextGen Infrastructure Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-szk",
      code: "NYSE:SZK",
      companyName: "ProShares UltraShort Consumer Goods",
      popularity: 0,
    },
    {
      slug: "nyse-szne",
      code: "NYSE:SZNE",
      companyName: "Pacer CFRA- Stoval Equal Weight Seasonal Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-szzl",
      code: "NYSE:SZZL",
      companyName: "Sizzle Acquisition Corp. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-szzlu",
      code: "NYSE:SZZLU",
      companyName: "Sizzle Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-szzlw",
      code: "NYSE:SZZLW",
      companyName: "Sizzle Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-t-a",
      code: "NYSE:T-A",
      companyName:
        "AT&T Inc. Depositary Shares each representing a 1/1000th interest in a share of 5.000% Perpetual P",
      popularity: 0,
    },
    {
      slug: "nyse-t-c",
      code: "NYSE:T-C",
      companyName:
        "AT&T Inc. Depositary Shares each representing a 1/1000th interest in a share of 4.750% Perpetual P",
      popularity: 0,
    },
    {
      slug: "nyse-ta",
      code: "NYSE:TA",
      companyName: "TravelCenters of America LLC",
      popularity: 0,
    },
    {
      slug: "nyse-tac",
      code: "NYSE:TAC",
      companyName: "TransAlta Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tack",
      code: "NYSE:TACK",
      companyName: "Fairlead Tactical Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tact",
      code: "NYSE:TACT",
      companyName: "Transact Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tagg",
      code: "NYSE:TAGG",
      companyName: "T. Rowe Price QM U.S. Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tags",
      code: "NYSE:TAGS",
      companyName: "Teucrium Agricultural Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tail",
      code: "NYSE:TAIL",
      companyName: "Cambria Tail Risk ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tait",
      code: "NYSE:TAIT",
      companyName: "Taitron Components Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tak",
      code: "NYSE:TAK",
      companyName:
        "Takeda Pharmaceutical Company Limited American Depositary Shares (each representing 1/2 of a share o",
      popularity: 0,
    },
    {
      slug: "nyse-tal",
      code: "NYSE:TAL",
      companyName: "TAL Education Group",
      popularity: 0,
    },
    {
      slug: "nyse-talk",
      code: "NYSE:TALK",
      companyName: "Talkspace Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-talkw",
      code: "NYSE:TALKW",
      companyName: "Talkspace Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-talo",
      code: "NYSE:TALO",
      companyName: "Talos Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tals",
      code: "NYSE:TALS",
      companyName: "Talaris Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tan",
      code: "NYSE:TAN",
      companyName: "Invesco Solar ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tanh",
      code: "NYSE:TANH",
      companyName: "Tantech Holdings Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tanni",
      code: "NYSE:TANNI",
      companyName: "TravelCenters of America LLC 8.25% Senior Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-tannl",
      code: "NYSE:TANNL",
      companyName: "TRAVEL CENTERS OF AMERICA LLC 8.00%  SENIOR NOTES DUE 2029",
      popularity: 0,
    },
    {
      slug: "nyse-tannz",
      code: "NYSE:TANNZ",
      companyName: "TravelCenters of America LLC",
      popularity: 0,
    },
    {
      slug: "nyse-taop",
      code: "NYSE:TAOP",
      companyName: "Taoping Inc. BVI Ordinary Shares (0 par)",
      popularity: 0,
    },
    {
      slug: "nyse-tap",
      code: "NYSE:TAP",
      companyName: "Molson Coors Beverage Company Class B",
      popularity: 0,
    },
    {
      slug: "nyse-tara",
      code: "NYSE:TARA",
      companyName: "Protara Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tark",
      code: "NYSE:TARK",
      companyName: "AXS 2X Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-taro",
      code: "NYSE:TARO",
      companyName: "Taro Pharmaceutical Industries Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-tars",
      code: "NYSE:TARS",
      companyName: "Tarsus Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-task",
      code: "NYSE:TASK",
      companyName: "TaskUs Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tast",
      code: "NYSE:TAST",
      companyName: "Carrols Restaurant Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tatt",
      code: "NYSE:TATT",
      companyName: "TAT Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-taxf",
      code: "NYSE:TAXF",
      companyName: "American Century Diversified Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tayd",
      code: "NYSE:TAYD",
      companyName: "Taylor Devices Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tbb",
      code: "NYSE:TBB",
      companyName: "AT&T Inc. 5.350 Percent Global Notes due 2066",
      popularity: 0,
    },
    {
      slug: "nyse-tbbk",
      code: "NYSE:TBBK",
      companyName: "The Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tbc",
      code: "NYSE:TBC",
      companyName: "AT&T Inc. 5.625% Global Notes due 2067",
      popularity: 0,
    },
    {
      slug: "nyse-tbcp",
      code: "NYSE:TBCP",
      companyName:
        "Thunder Bridge Capital Partners III Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tbcpu",
      code: "NYSE:TBCPU",
      companyName: "Thunder Bridge Capital Partners III Inc. Units",
      popularity: 0,
    },
    {
      slug: "nyse-tbcpw",
      code: "NYSE:TBCPW",
      companyName: "Thunder Bridge Capital Partners III Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tbf",
      code: "NYSE:TBF",
      companyName: "ProShares Short 20+ Year Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tbi",
      code: "NYSE:TBI",
      companyName: "Trueblue Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tbjl",
      code: "NYSE:TBJL",
      companyName: "Innovator 20+ Year Treasury Bond 9 Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-tbk",
      code: "NYSE:TBK",
      companyName: "Triumph Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tbkcp",
      code: "NYSE:TBKCP",
      companyName:
        "Triumph Bancorp Inc. Depositary Shares Each Representing a 1/40th Interest in a Share of 7.125% Se",
      popularity: 0,
    },
    {
      slug: "nyse-tbla",
      code: "NYSE:TBLA",
      companyName: "Taboola.com Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tblaw",
      code: "NYSE:TBLAW",
      companyName: "Taboola.com Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tbld",
      code: "NYSE:TBLD",
      companyName: "Thornburg Income Builder Opportunities Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tblt",
      code: "NYSE:TBLT",
      companyName: "ToughBuilt Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tbltw",
      code: "NYSE:TBLTW",
      companyName: "ToughBuilt Industries Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tbnk",
      code: "NYSE:TBNK",
      companyName: "Territorial Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tbph",
      code: "NYSE:TBPH",
      companyName: "Theravance Biopharma Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tbsa",
      code: "NYSE:TBSA",
      companyName: "TB SA Acquisition Corp Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-tbsau",
      code: "NYSE:TBSAU",
      companyName: "TB SA Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tbsaw",
      code: "NYSE:TBSAW",
      companyName: "TB SA Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tbt",
      code: "NYSE:TBT",
      companyName: "ProShares Trust UltraShort Lehman 20+ Year Treasury",
      popularity: 0,
    },
    {
      slug: "nyse-tbux",
      code: "NYSE:TBUX",
      companyName: "T. Rowe Price Ultra Short-Term Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tbx",
      code: "NYSE:TBX",
      companyName: "ProShares Short 7-10 Year Treasury",
      popularity: 0,
    },
    {
      slug: "nyse-tcbc",
      code: "NYSE:TCBC",
      companyName: "TC Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tcbi",
      code: "NYSE:TCBI",
      companyName: "Texas Capital Bancshares Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tcbio",
      code: "NYSE:TCBIO",
      companyName:
        "Texas Capital Bancshares Inc. Depositary Shares 5.75% Fixed Rate Non-Cumulative Perpetual Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-tcbk",
      code: "NYSE:TCBK",
      companyName: "Trico Bancshares",
      popularity: 0,
    },
    {
      slug: "nyse-tcbp",
      code: "NYSE:TCBP",
      companyName: "TC BioPharm (Holdings) plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tcbpw",
      code: "NYSE:TCBPW",
      companyName: "TC BioPharm (Holdings) plc Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-tcbs",
      code: "NYSE:TCBS",
      companyName: "Texas Community Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tcbx",
      code: "NYSE:TCBX",
      companyName: "Third Coast Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tcda",
      code: "NYSE:TCDA",
      companyName: "Tricida Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tcfc",
      code: "NYSE:TCFC",
      companyName: "The Community Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tchi",
      code: "NYSE:TCHI",
      companyName: "iShares MSCI China Multisector Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tchp",
      code: "NYSE:TCHP",
      companyName: "T. Rowe Price Blue Chip Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tci",
      code: "NYSE:TCI",
      companyName: "Transcontinental Realty Investors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tcmd",
      code: "NYSE:TCMD",
      companyName: "Tactile Systems Technology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tcoa",
      code: "NYSE:TCOA",
      companyName: "Trajectory Alpha Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-tcon",
      code: "NYSE:TCON",
      companyName: "TRACON Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tcpc",
      code: "NYSE:TCPC",
      companyName: "BlackRock TCP Capital Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tcrr",
      code: "NYSE:TCRR",
      companyName: "TCR2 Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tcrt",
      code: "NYSE:TCRT",
      companyName: "Alaunos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tcrx",
      code: "NYSE:TCRX",
      companyName: "TScan Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tcs",
      code: "NYSE:TCS",
      companyName: "THE CONTAINER STORE GROUP INC.",
      popularity: 0,
    },
    {
      slug: "nyse-tctl",
      code: "NYSE:TCTL",
      companyName: "Premise Capital Diversified Tactical ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tcva",
      code: "NYSE:TCVA",
      companyName: "TCV Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tcx",
      code: "NYSE:TCX",
      companyName: "Tucows Inc",
      popularity: 0,
    },
    {
      slug: "nyse-td",
      code: "NYSE:TD",
      companyName: "Toronto Dominion Bank",
      popularity: 0,
    },
    {
      slug: "nyse-tdc",
      code: "NYSE:TDC",
      companyName: "TERADATA CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-tdcx",
      code: "NYSE:TDCX",
      companyName:
        "TDCX Inc. American Depositary Shares each representing one Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nyse-tdf",
      code: "NYSE:TDF",
      companyName: "Templeton Dragon Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tdg",
      code: "NYSE:TDG",
      companyName: "TransDigm Group Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-tdiv",
      code: "NYSE:TDIV",
      companyName:
        "First Trust Exchange-Traded Fund VI First Trust NASDAQ Technology Dividend Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tdoc",
      code: "NYSE:TDOC",
      companyName: "Teladoc Health Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tds",
      code: "NYSE:TDS",
      companyName: "Telephone and Data Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tds-u",
      code: "NYSE:TDS-U",
      companyName:
        "Telephone and Data Systems Inc. Depositary Shares Each Representing a 1/1000th Interest in a 6.62",
      popularity: 0,
    },
    {
      slug: "nyse-tds-v",
      code: "NYSE:TDS-V",
      companyName:
        "Telephone and Data Systems Inc. Depositary Shares Each Representing a 1/1000th Interest in a 6.00",
      popularity: 0,
    },
    {
      slug: "nyse-tdsa",
      code: "NYSE:TDSA",
      companyName: "Cabana Target Drawdown 5 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tdsb",
      code: "NYSE:TDSB",
      companyName: "Cabana Target Drawdown 7 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tdsc",
      code: "NYSE:TDSC",
      companyName: "Cabana Target Drawdown 10 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tdsd",
      code: "NYSE:TDSD",
      companyName: "Cabana Target Drawdown 13 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tdse",
      code: "NYSE:TDSE",
      companyName: "Cabana Target Drawdown 16 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tdtf",
      code: "NYSE:TDTF",
      companyName: "FlexShares iBoxx 5-Year Target Duration TIPS Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tdtt",
      code: "NYSE:TDTT",
      companyName: "FlexShares iBoxx 3-Year Target Duration TIPS Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tdup",
      code: "NYSE:TDUP",
      companyName: "ThredUp Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tdv",
      code: "NYSE:TDV",
      companyName: "ProShares S&P Technology Dividend Aristocrats ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tdvg",
      code: "NYSE:TDVG",
      companyName: "T. Rowe Price Dividend Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tdy",
      code: "NYSE:TDY",
      companyName: "Teledyne Technologies Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-teaf",
      code: "NYSE:TEAF",
      companyName: "Ecofin Sustainable and Social Impact Term Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tecb",
      code: "NYSE:TECB",
      companyName: "iShares U.S. Tech Breakthrough Multisector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tech",
      code: "NYSE:TECH",
      companyName: "Bio-Techne Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-team",
      code: "NYSE:TEAM",
      companyName: "Atlassian Corporation Plc Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tecl",
      code: "NYSE:TECL",
      companyName: "Direxion Daily Technology Bull 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tecs",
      code: "NYSE:TECS",
      companyName: "Direxion Daily Technology Bear 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tectp",
      code: "NYSE:TECTP",
      companyName:
        "Tectonic Financial Inc. 9.00% Fixed-to-Floating Rate Series B Non-Cumulative Perpetual Preferred St",
      popularity: 0,
    },
    {
      slug: "nyse-tedu",
      code: "NYSE:TEDU",
      companyName: "Tarena International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tef",
      code: "NYSE:TEF",
      companyName: "Telefonica S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-tcn",
      code: "NYSE:TCN",
      companyName: "Tricon Residential Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tdw",
      code: "NYSE:TDW",
      companyName: "Tidewater Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tei",
      code: "NYSE:TEI",
      companyName: "Templeton Emerging Markets Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tekk",
      code: "NYSE:TEKK",
      companyName: "Tekkorp Digital Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tekku",
      code: "NYSE:TEKKU",
      companyName: "Tekkorp Digital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tekkw",
      code: "NYSE:TEKKW",
      companyName: "Tekkorp Digital Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tell",
      code: "NYSE:TELL",
      companyName: "Tellurian Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-telz",
      code: "NYSE:TELZ",
      companyName: "Tellurian Inc. 8.25% Senior Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nyse-temp",
      code: "NYSE:TEMP",
      companyName: "JPMorgan Climate Change Solutions ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ten",
      code: "NYSE:TEN",
      companyName: "Tenneco Inc. Class A Voting Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tenb",
      code: "NYSE:TENB",
      companyName: "Tenable Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-teng",
      code: "NYSE:TENG",
      companyName: "Direxion Daily 5G Communications Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tenx",
      code: "NYSE:TENX",
      companyName: "Tenax Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-teo",
      code: "NYSE:TEO",
      companyName: "Telecom Argentina S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-teqi",
      code: "NYSE:TEQI",
      companyName: "T. Rowe Price Equity Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ter",
      code: "NYSE:TER",
      companyName: "Teradyne Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tern",
      code: "NYSE:TERN",
      companyName: "Terns Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tess",
      code: "NYSE:TESS",
      companyName: "Tessco Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tetc",
      code: "NYSE:TETC",
      companyName:
        "Tech and Energy Transition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tetcu",
      code: "NYSE:TETCU",
      companyName: "Tech and Energy Transition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tetcw",
      code: "NYSE:TETCW",
      companyName: "Tech and Energy Transition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tete",
      code: "NYSE:TETE",
      companyName:
        "Technology & Telecommunication Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-teteu",
      code: "NYSE:TETEU",
      companyName:
        "Technology & Telecommunication Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tetew",
      code: "NYSE:TETEW",
      companyName:
        "Technology & Telecommunication Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-teva",
      code: "NYSE:TEVA",
      companyName:
        "Teva Pharmaceutical Industries Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tex",
      code: "NYSE:TEX",
      companyName: "Terex Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tfc",
      code: "NYSE:TFC",
      companyName: "Truist Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tfc-i",
      code: "NYSE:TFC-I",
      companyName:
        "Truist Financial Corporation Depositary Shares each representing 1/4000th interest in a share of S",
      popularity: 0,
    },
    {
      slug: "nyse-tfc-o",
      code: "NYSE:TFC-O",
      companyName:
        "Truist Financial Corporation Depositary Shares Each Representing a 1/1000th Interest in a  Share o",
      popularity: 0,
    },
    {
      slug: "nyse-tfc-r",
      code: "NYSE:TFC-R",
      companyName:
        "Truist Financial Corporation Depositary Shares each representing 1/1000th interest in a share of S",
      popularity: 0,
    },
    {
      slug: "nyse-tffp",
      code: "NYSE:TFFP",
      companyName: "TFF Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tfi",
      code: "NYSE:TFI",
      companyName: "SPDR Nuveen Bloomberg Municipal Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tfii",
      code: "NYSE:TFII",
      companyName: "TFI International Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tfjl",
      code: "NYSE:TFJL",
      companyName: "Innovator 20+ Year Treasury Bond 5 Floor ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-tgt",
      code: "NYSE:TGT",
      companyName: "Target Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tfsa",
      code: "NYSE:TFSA",
      companyName: "Terra Income Fund 6 Inc.  7.00% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-tfsl",
      code: "NYSE:TFSL",
      companyName: "TFS Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tg",
      code: "NYSE:TG",
      companyName: "Tredegar Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tga",
      code: "NYSE:TGA",
      companyName: "Transglobe Energy Corp",
      popularity: 0,
    },
    {
      slug: "nyse-tgaa",
      code: "NYSE:TGAA",
      companyName: "Target Global Acquisition I Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-tgaau",
      code: "NYSE:TGAAU",
      companyName: "Target Global Acquisition I Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tgaaw",
      code: "NYSE:TGAAW",
      companyName: "Target Global Acquisition I Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tgan",
      code: "NYSE:TGAN",
      companyName: "Transphorm Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tgb",
      code: "NYSE:TGB",
      companyName: "Taseko Mines Limited",
      popularity: 0,
    },
    {
      slug: "nyse-tgh",
      code: "NYSE:TGH",
      companyName: "Textainer Group Holdings limited",
      popularity: 0,
    },
    {
      slug: "nyse-tgh-a",
      code: "NYSE:TGH-A",
      companyName:
        "Textainer Group Holdings Limited Depositary Shares each representing a 1/1000th interest in a share",
      popularity: 0,
    },
    {
      slug: "nyse-tgh-b",
      code: "NYSE:TGH-B",
      companyName:
        "Textainer Group Holdings Limited Depositary Shares each representing a 1/1 000th interest in a sha",
      popularity: 0,
    },
    {
      slug: "nyse-tgi",
      code: "NYSE:TGI",
      companyName: "Triumph Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tgif",
      code: "NYSE:TGIF",
      companyName: "SoFi Weekly Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tgl",
      code: "NYSE:TGL",
      companyName: "Treasure Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tgls",
      code: "NYSE:TGLS",
      companyName: "Tecnoglass Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tgna",
      code: "NYSE:TGNA",
      companyName: "TEGNA Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tgr",
      code: "NYSE:TGR",
      companyName: "Kimbell Tiger Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tgrw",
      code: "NYSE:TGRW",
      companyName: "T. Rowe Price Growth Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tgs",
      code: "NYSE:TGS",
      companyName: "Transportadora de Gas del Sur S.A. ADS",
      popularity: 0,
    },
    {
      slug: "nyse-tgtx",
      code: "NYSE:TGTX",
      companyName: "TG Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tgvc",
      code: "NYSE:TGVC",
      companyName: "TG Venture Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tgvcu",
      code: "NYSE:TGVCU",
      companyName: "TG Venture Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-tgvcw",
      code: "NYSE:TGVCW",
      companyName: "TG Venture Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-th",
      code: "NYSE:TH",
      companyName: "Target Hospitality Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-thac",
      code: "NYSE:THAC",
      companyName: "Thrive Acquisition Corporation Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-thacu",
      code: "NYSE:THACU",
      companyName: "Thrive Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-thacw",
      code: "NYSE:THACW",
      companyName: "Thrive Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tfx",
      code: "NYSE:TFX",
      companyName: "Teleflex Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-thnq",
      code: "NYSE:THNQ",
      companyName: "ROBO Global Artificial Intelligence ETF",
      popularity: 0,
    },
    {
      slug: "nyse-thca",
      code: "NYSE:THCA",
      companyName: "Tuscan Holdings Corp. II Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-thcaw",
      code: "NYSE:THCAW",
      companyName: "Tuscan Holdings Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-thcp",
      code: "NYSE:THCP",
      companyName:
        "Thunder Bridge Capital Partners IV Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-thcpu",
      code: "NYSE:THCPU",
      companyName: "Thunder Bridge Capital Partners IV Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-thcpw",
      code: "NYSE:THCPW",
      companyName: "Thunder Bridge Capital Partners IV Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-thd",
      code: "NYSE:THD",
      companyName: "iShares MSCI Thailand ETF",
      popularity: 0,
    },
    {
      slug: "nyse-thff",
      code: "NYSE:THFF",
      companyName: "First Financial Corp/Indiana",
      popularity: 0,
    },
    {
      slug: "nyse-thg",
      code: "NYSE:THG",
      companyName: "The Hanover Insurance Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-thm",
      code: "NYSE:THM",
      companyName: "International Tower Hill Mines Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-thmo",
      code: "NYSE:THMO",
      companyName: "ThermoGenesis Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tho",
      code: "NYSE:THO",
      companyName: "Thor Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-thq",
      code: "NYSE:THQ",
      companyName: "TEKLA HEALTHCARE OPPORTUNITIES FUND",
      popularity: 0,
    },
    {
      slug: "nyse-thr",
      code: "NYSE:THR",
      companyName: "THERMON GROUP HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-thrm",
      code: "NYSE:THRM",
      companyName: "Gentherm Inc",
      popularity: 0,
    },
    {
      slug: "nyse-thrn",
      code: "NYSE:THRN",
      companyName: "Thorne Healthtech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-thrx",
      code: "NYSE:THRX",
      companyName: "Theseus Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-thry",
      code: "NYSE:THRY",
      companyName: "Thryv Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ths",
      code: "NYSE:THS",
      companyName: "Treehouse Foods Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-thtx",
      code: "NYSE:THTX",
      companyName: "Theratechnologies Inc. Common",
      popularity: 0,
    },
    {
      slug: "nyse-thw",
      code: "NYSE:THW",
      companyName: "Tekla World Healthcare Fund",
      popularity: 0,
    },
    {
      slug: "nyse-thwww",
      code: "NYSE:THWWW",
      companyName: "Target Hospitality Corp. Warrant expiring 3/15/2024",
      popularity: 0,
    },
    {
      slug: "nyse-thy",
      code: "NYSE:THY",
      companyName: "Toews Agility Shares Dynamic Tactical Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tig",
      code: "NYSE:TIG",
      companyName: "Trean Insurance Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tigo",
      code: "NYSE:TIGO",
      companyName: "Millicom International Cellular S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tigr",
      code: "NYSE:TIGR",
      companyName:
        "UP Fintech Holding Ltd American Depositary Share representing fifteen Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-til",
      code: "NYSE:TIL",
      companyName: "Instil Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tile",
      code: "NYSE:TILE",
      companyName: "Interface Inc",
      popularity: 0,
    },
    {
      slug: "nyse-till",
      code: "NYSE:TILL",
      companyName: "Teucrium Agricultural Strategy No K-1 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tilt",
      code: "NYSE:TILT",
      companyName: "FlexShares Morningstar US Market Factors Tilt Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-timb",
      code: "NYSE:TIMB",
      companyName:
        "TIM S.A. American Depositary Shares (Each representing 5 Common Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-time",
      code: "NYSE:TIME",
      companyName: "Clockwise Capital Innovation ET",
      popularity: 0,
    },
    {
      slug: "nyse-tint",
      code: "NYSE:TINT",
      companyName: "ProShares Smart Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tinv",
      code: "NYSE:TINV",
      companyName: "Tiga Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-tiny",
      code: "NYSE:TINY",
      companyName: "ProShares Nanotechnology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tioa",
      code: "NYSE:TIOA",
      companyName: "Tio Tech A Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-tioau",
      code: "NYSE:TIOAU",
      companyName: "Tio Tech A Units",
      popularity: 0,
    },
    {
      slug: "nyse-tioaw",
      code: "NYSE:TIOAW",
      companyName: "Tio Tech A Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-tip",
      code: "NYSE:TIP",
      companyName: "iShares TIPS Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tipd",
      code: "NYSE:TIPD",
      companyName: "Direxion Daily TIPS Bear 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tipl",
      code: "NYSE:TIPL",
      companyName: "Direxion Daily TIPS Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tipt",
      code: "NYSE:TIPT",
      companyName: "Tiptree Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tipx",
      code: "NYSE:TIPX",
      companyName: "SPDR Bloomberg 1-10 Year TIPS ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tipz",
      code: "NYSE:TIPZ",
      companyName: "PIMCO Broad U.S. TIPS Index Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tirx",
      code: "NYSE:TIRX",
      companyName: "TIAN RUIXIANG Holdings Ltd Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tisi",
      code: "NYSE:TISI",
      companyName: "Team Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-titn",
      code: "NYSE:TITN",
      companyName: "Titan Machinery Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tivc",
      code: "NYSE:TIVC",
      companyName: "Tivic Health Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tixt",
      code: "NYSE:TIXT",
      companyName: "TELUS International (Cda) Inc. Subordinate Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tjx",
      code: "NYSE:TJX",
      companyName: "TJX Companies Inc. (The)",
      popularity: 0,
    },
    {
      slug: "nyse-tk",
      code: "NYSE:TK",
      companyName: "Teekay Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tkat",
      code: "NYSE:TKAT",
      companyName: "Takung Art Co. Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-tkc",
      code: "NYSE:TKC",
      companyName: "TURKCELL ILETISIM HIZMETLERI A.S. ADS",
      popularity: 0,
    },
    {
      slug: "nyse-tklf",
      code: "NYSE:TKLF",
      companyName: "Yoshitsu Co. Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tkno",
      code: "NYSE:TKNO",
      companyName: "Alpha Teknova Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tkr",
      code: "NYSE:TKR",
      companyName: "The Timken Company",
      popularity: 0,
    },
    {
      slug: "nyse-tlga",
      code: "NYSE:TLGA",
      companyName: "TLG Acquisition One Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-tlgy",
      code: "NYSE:TLGY",
      companyName: "TLGY Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-tlgyu",
      code: "NYSE:TLGYU",
      companyName: "TLGY Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tlgyw",
      code: "NYSE:TLGYW",
      companyName: "TLGY Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tlh",
      code: "NYSE:TLH",
      companyName: "iShares 10-20 Year Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tlis",
      code: "NYSE:TLIS",
      companyName: "Talis Biomedical Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tlk",
      code: "NYSE:TLK",
      companyName: "PT Telekomunikasi Indonesia",
      popularity: 0,
    },
    {
      slug: "nyse-tlry",
      code: "NYSE:TLRY",
      companyName: "Tilray Brands Inc. Class 2 Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tlsa",
      code: "NYSE:TLSA",
      companyName: "Tiziana Life Sciences Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tltd",
      code: "NYSE:TLTD",
      companyName:
        "FlexShares Morningstar Developed Markets ex-US Factor Tilt Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tlte",
      code: "NYSE:TLTE",
      companyName:
        "FlexShares Morningstar Emerging Markets Factor Tilt Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-tltw",
      code: "NYSE:TLTW",
      companyName: "iShares 20+ Year Treasury Bond BuyWrite Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tlys",
      code: "NYSE:TLYS",
      companyName: "Tilly's Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tm",
      code: "NYSE:TM",
      companyName:
        "Toyota Motor Corporation American Depositary Shares (Each representing ten Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nyse-tmac",
      code: "NYSE:TMAC",
      companyName: "The Music Acquisition Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tmat",
      code: "NYSE:TMAT",
      companyName: "Main Thematic Innovation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tmbr",
      code: "NYSE:TMBR",
      companyName: "Timber Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tmc",
      code: "NYSE:TMC",
      companyName: "TMC the metals company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tmci",
      code: "NYSE:TMCI",
      companyName: "Treace Medical Concepts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tmcww",
      code: "NYSE:TMCWW",
      companyName: "TMC the metals company Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-tmdi",
      code: "NYSE:TMDI",
      companyName: "Titan Medical Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tmdv",
      code: "NYSE:TMDV",
      companyName: "ProShares Russell US Dividend Growers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tmdx",
      code: "NYSE:TMDX",
      companyName: "TransMedics Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tmf",
      code: "NYSE:TMF",
      companyName:
        "Direxion Daily 20+ Year Treasury Bull 3X Shares (based on the NYSE 20 Year Plus Treasury Bond Index;",
      popularity: 0,
    },
    {
      slug: "nyse-tmfc",
      code: "NYSE:TMFC",
      companyName: "Motley Fool 100 Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tmfe",
      code: "NYSE:TMFE",
      companyName: "Motley Fool Capital Efficiency 100 Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tmfg",
      code: "NYSE:TMFG",
      companyName: "Motley Fool Global Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tmfm",
      code: "NYSE:TMFM",
      companyName: "Motley Fool Mid-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tmfs",
      code: "NYSE:TMFS",
      companyName: "Motley Fool Small-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tmfx",
      code: "NYSE:TMFX",
      companyName: "Motley Fool Next Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tmhc",
      code: "NYSE:TMHC",
      companyName: "Taylor Morrison Home Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tmkr",
      code: "NYSE:TMKR",
      companyName: "Tastemaker Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tmkru",
      code: "NYSE:TMKRU",
      companyName: "Tastemaker Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tmkrw",
      code: "NYSE:TMKRW",
      companyName:
        "Tastemaker Acquisition Corp. Warrant to purchase Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-tmp",
      code: "NYSE:TMP",
      companyName: "Tompkins Financial Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tmpm",
      code: "NYSE:TMPM",
      companyName: "Turmeric Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tmpmu",
      code: "NYSE:TMPMU",
      companyName: "Turmeric Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tmpmw",
      code: "NYSE:TMPMW",
      companyName: "Turmeric Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tmq",
      code: "NYSE:TMQ",
      companyName: "Trilogy Metals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tmst",
      code: "NYSE:TMST",
      companyName: "TIMKENSTEEL CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-tmus",
      code: "NYSE:TMUS",
      companyName: "T-Mobile US Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tmv",
      code: "NYSE:TMV",
      companyName:
        "Direxion Daily 20+ Year Treasury Bear 3X Shares (based on the NYSE 20 Year Plus Treasury Bond Index;",
      popularity: 0,
    },
    {
      slug: "nyse-tmx",
      code: "NYSE:TMX",
      companyName: "Terminix Global Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tna",
      code: "NYSE:TNA",
      companyName: "Direxion Daily Small Cap Bull 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tnc",
      code: "NYSE:TNC",
      companyName: "TENNANT COMPANY",
      popularity: 0,
    },
    {
      slug: "nyse-tndm",
      code: "NYSE:TNDM",
      companyName: "Tandem Diabetes Care Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tnet",
      code: "NYSE:TNET",
      companyName: "TRINET GROUP INC.",
      popularity: 0,
    },
    {
      slug: "nyse-tngx",
      code: "NYSE:TNGX",
      companyName: "Tango Therapeutics Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tnk",
      code: "NYSE:TNK",
      companyName: "Teekay Tankers Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-tnl",
      code: "NYSE:TNL",
      companyName: "Travel + Leisure Co.",
      popularity: 0,
    },
    {
      slug: "nyse-tnon",
      code: "NYSE:TNON",
      companyName: "Tenon Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tnp",
      code: "NYSE:TNP",
      companyName: "Tsakos Energy Navigation Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-tnp-d",
      code: "NYSE:TNP-D",
      companyName:
        "Tsakos Energy Navigation Limited  8.75% Series D Cumulative Redeemable Perpetual Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tnp-e",
      code: "NYSE:TNP-E",
      companyName:
        "Tsakos Energy Navigation Limited Series E Fixed-to-Floating Rate Cumulative Redeemable Perpetual Pre",
      popularity: 0,
    },
    {
      slug: "nyse-tnp-f",
      code: "NYSE:TNP-F",
      companyName:
        "Tsakos Energy Navigation Limited Series F Fixed-to-Floating Rate Cumulative Redeemable Perpetual Pre",
      popularity: 0,
    },
    {
      slug: "nyse-tnxp",
      code: "NYSE:TNXP",
      companyName: "Tonix Pharmaceuticals Holding Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-tnya",
      code: "NYSE:TNYA",
      companyName: "Tenaya Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-toac",
      code: "NYSE:TOAC",
      companyName: "Talon 1 Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-toacu",
      code: "NYSE:TOACU",
      companyName: "Talon 1 Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-toacw",
      code: "NYSE:TOACW",
      companyName: "Talon 1 Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-toi",
      code: "NYSE:TOI",
      companyName: "The Oncology Institute Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-toiiw",
      code: "NYSE:TOIIW",
      companyName: "The Oncology Institute Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tok",
      code: "NYSE:TOK",
      companyName: "iShares MSCI Kokusai Fund",
      popularity: 0,
    },
    {
      slug: "nyse-toke",
      code: "NYSE:TOKE",
      companyName: "Cambria Cannabis ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tol",
      code: "NYSE:TOL",
      companyName: "Toll Brothers Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tolz",
      code: "NYSE:TOLZ",
      companyName: "ProShares DJ Brookfield Global Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tomz",
      code: "NYSE:TOMZ",
      companyName: "TOMI Environmental Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tops",
      code: "NYSE:TOPS",
      companyName: "TOP Ships Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tost",
      code: "NYSE:TOST",
      companyName: "Toast Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-totl",
      code: "NYSE:TOTL",
      companyName:
        "SSgA Active ETF Trust SPDR DoubleLine Total Return Tactical ETF",
      popularity: 0,
    },
    {
      slug: "nyse-totr",
      code: "NYSE:TOTR",
      companyName: "T. Rowe Price Total Return ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tour",
      code: "NYSE:TOUR",
      companyName: "Tuniu Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-town",
      code: "NYSE:TOWN",
      companyName: "Towne Bank",
      popularity: 0,
    },
    {
      slug: "nyse-tpb",
      code: "NYSE:TPB",
      companyName: "Turning Point Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tpba",
      code: "NYSE:TPBA",
      companyName: "TPB Acquisition Corporation I Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-tpbau",
      code: "NYSE:TPBAU",
      companyName: "TPB Acquisition Corporation I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tpbaw",
      code: "NYSE:TPBAW",
      companyName: "TPB Acquisition Corporation I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tpc",
      code: "NYSE:TPC",
      companyName: "Tutor Perini Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tpgy",
      code: "NYSE:TPGY",
      companyName: "TPG Pace Beneficial Finance Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-tph",
      code: "NYSE:TPH",
      companyName: "Tri Pointe Homes Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tphd",
      code: "NYSE:TPHD",
      companyName: "Timothy Plan High Dividend Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tphe",
      code: "NYSE:TPHE",
      companyName: "TIMOTHY PLAN HIGH DIVIDEND STOCK ENHANCED ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tphs",
      code: "NYSE:TPHS",
      companyName: "Trinity Place Holdings Inc.com",
      popularity: 0,
    },
    {
      slug: "nyse-tpic",
      code: "NYSE:TPIC",
      companyName: "TPI Composites Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tpif",
      code: "NYSE:TPIF",
      companyName: "Timothy Plan International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tpl",
      code: "NYSE:TPL",
      companyName: "Texas Pacific Land Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tplc",
      code: "NYSE:TPLC",
      companyName: "Timothy Plan US Large/Mid Cap Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tple",
      code: "NYSE:TPLE",
      companyName: "TIMOTHY PLAN US LARGE/MID CAP CORE ENHANCED ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tpor",
      code: "NYSE:TPOR",
      companyName: "Direxion Daily Transportation Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tpsc",
      code: "NYSE:TPSC",
      companyName: "Timothy Plan US Small Cap Core ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tpst",
      code: "NYSE:TPST",
      companyName: "Tempest Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tpta",
      code: "NYSE:TPTA",
      companyName: "Terra Property Trust Inc. 6.00% Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-tpvg",
      code: "NYSE:TPVG",
      companyName: "TRIPLEPOINT VENTURE GROWTH BDC CORP.",
      popularity: 0,
    },
    {
      slug: "nyse-tpx",
      code: "NYSE:TPX",
      companyName: "TEMPUR SEALY INTERNATIONAL INC.",
      popularity: 0,
    },
    {
      slug: "nyse-tpyp",
      code: "NYSE:TPYP",
      companyName: "Tortoise North American Pipeline ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tpz",
      code: "NYSE:TPZ",
      companyName: "Tortoise Power and Energy Infrastructure Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tqqq",
      code: "NYSE:TQQQ",
      companyName: "ProShares  UltraPro QQQ",
      popularity: 0,
    },
    {
      slug: "nyse-tr",
      code: "NYSE:TR",
      companyName: "Tootsie Roll Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-traq",
      code: "NYSE:TRAQ",
      companyName: "Trine II Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-trc",
      code: "NYSE:TRC",
      companyName: "Tejon Ranch Co.",
      popularity: 0,
    },
    {
      slug: "nyse-trca",
      code: "NYSE:TRCA",
      companyName: "Twin Ridge Capital Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-trda",
      code: "NYSE:TRDA",
      companyName: "Entrada Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tree",
      code: "NYSE:TREE",
      companyName: "LendingTree Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tpg",
      code: "NYSE:TPG",
      companyName: "TPG Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-trfk",
      code: "NYSE:TRFK",
      companyName: "Pacer Data and Digital Revolution ETF",
      popularity: 0,
    },
    {
      slug: "nyse-trfm",
      code: "NYSE:TRFM",
      companyName: "AAM Transformers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-trgp",
      code: "NYSE:TRGP",
      companyName: "Targa Resources Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-trhc",
      code: "NYSE:TRHC",
      companyName: "Tabula Rasa HealthCare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tri",
      code: "NYSE:TRI",
      companyName: "Thomson Reuters Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-trib",
      code: "NYSE:TRIB",
      companyName: "Trinity Biotech plc",
      popularity: 0,
    },
    {
      slug: "nyse-trin",
      code: "NYSE:TRIN",
      companyName: "Trinity Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-trinl",
      code: "NYSE:TRINL",
      companyName: "Trinity Capital Inc. 7.00% Notes Due 2025",
      popularity: 0,
    },
    {
      slug: "nyse-trip",
      code: "NYSE:TRIP",
      companyName: "TripAdvisor Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tris",
      code: "NYSE:TRIS",
      companyName: "Tristar Acquisition I Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-trka",
      code: "NYSE:TRKA",
      companyName: "Troika Media Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-trkaw",
      code: "NYSE:TRKAW",
      companyName: "Troika Media Group Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-trmb",
      code: "NYSE:TRMB",
      companyName: "Trimble Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-trmd",
      code: "NYSE:TRMD",
      companyName: "TORM plc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-trmk",
      code: "NYSE:TRMK",
      companyName: "Trustmark Corp",
      popularity: 0,
    },
    {
      slug: "nyse-trmr",
      code: "NYSE:TRMR",
      companyName: "Tremor International Ltd. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-trn",
      code: "NYSE:TRN",
      companyName: "Trinity Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-trnd",
      code: "NYSE:TRND",
      companyName: "Pacer Trendpilot Fund of Funds ETF",
      popularity: 0,
    },
    {
      slug: "nyse-trno",
      code: "NYSE:TRNO",
      companyName: "Terreno Realty Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-trns",
      code: "NYSE:TRNS",
      companyName: "Transcat Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tron",
      code: "NYSE:TRON",
      companyName: "Corner Growth Acquisition Corp. 2 Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-tronu",
      code: "NYSE:TRONU",
      companyName: "Corner Growth Acquisition Corp. 2 Units",
      popularity: 0,
    },
    {
      slug: "nyse-tronw",
      code: "NYSE:TRONW",
      companyName: "Corner Growth Acquisition Corp. 2 Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-troo",
      code: "NYSE:TROO",
      companyName: "TROOPS Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-trow",
      code: "NYSE:TROW",
      companyName: "T Rowe Price Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-trox",
      code: "NYSE:TROX",
      companyName: "TRONOX LIMITED CL A ORDINARY SHARES",
      popularity: 0,
    },
    {
      slug: "nyse-trp",
      code: "NYSE:TRP",
      companyName: "TC Energy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-trpl",
      code: "NYSE:TRPL",
      companyName: "Pacer Metaurus US Large Cap Dividend Multiplier 300 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-trst",
      code: "NYSE:TRST",
      companyName: "Trustco Bank Corp NY",
      popularity: 0,
    },
    {
      slug: "nyse-trt",
      code: "NYSE:TRT",
      companyName: "Trio-Tech International ",
      popularity: 0,
    },
    {
      slug: "nyse-trtl",
      code: "NYSE:TRTL",
      companyName: "TortoiseEcofin Acquisition Corp. III",
      popularity: 0,
    },
    {
      slug: "nyse-trtn",
      code: "NYSE:TRTN",
      companyName: "Triton International Limited",
      popularity: 0,
    },
    {
      slug: "nyse-trtn-a",
      code: "NYSE:TRTN-A",
      companyName:
        "Triton International Limited 8.50% Series A Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nyse-trtn-b",
      code: "NYSE:TRTN-B",
      companyName:
        "Triton International Limited 8.00% Series B Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nyse-trtn-c",
      code: "NYSE:TRTN-C",
      companyName:
        "Triton International Limited 7.375% Series C Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nyse-trtn-d",
      code: "NYSE:TRTN-D",
      companyName:
        "Triton International Limited 6.875% Series D Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nyse-trtn-e",
      code: "NYSE:TRTN-E",
      companyName:
        "Triton International Limited 5.75% Series E Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nyse-trtx",
      code: "NYSE:TRTX",
      companyName: "TPG RE Finance Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-trtx-c",
      code: "NYSE:TRTX-C",
      companyName:
        "TPG RE Finance Trust Inc. 6.25% Series C Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-trty",
      code: "NYSE:TRTY",
      companyName: "Cambria Trinity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tsl",
      code: "NYSE:TSL",
      companyName: "GraniteShares 1.25x Long Tesla Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-true",
      code: "NYSE:TRUE",
      companyName: "TrueCar Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-trup",
      code: "NYSE:TRUP",
      companyName: "Trupanion Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-trv",
      code: "NYSE:TRV",
      companyName: "The Travelers Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-trvg",
      code: "NYSE:TRVG",
      companyName: "trivago N.V. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-trvi",
      code: "NYSE:TRVI",
      companyName: "Trevi Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-trvn",
      code: "NYSE:TRVN",
      companyName: "Trevena Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-trx",
      code: "NYSE:TRX",
      companyName: "TRX Gold Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ts",
      code: "NYSE:TS",
      companyName: "Tenaris S. A.",
      popularity: 0,
    },
    {
      slug: "nyse-tsat",
      code: "NYSE:TSAT",
      companyName:
        "Telesat Corporation Class A Common Shares and Class B Variable Voting Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tsbk",
      code: "NYSE:TSBK",
      companyName: "Timberland Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tsn",
      code: "NYSE:TSN",
      companyName: "Tyson Foods Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tse",
      code: "NYSE:TSE",
      companyName: "Trinseo PLC",
      popularity: 0,
    },
    {
      slug: "nyse-tsem",
      code: "NYSE:TSEM",
      companyName: "Tower Semiconductor Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-tsha",
      code: "NYSE:TSHA",
      companyName: "Taysha Gene Therapies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tsi",
      code: "NYSE:TSI",
      companyName: "TCW Strategic Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tsib",
      code: "NYSE:TSIB",
      companyName: "Tishman Speyer Innovation Corp. II Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-tsibu",
      code: "NYSE:TSIBU",
      companyName: "Tishman Speyer Innovation Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tsibw",
      code: "NYSE:TSIBW",
      companyName: "Tishman Speyer Innovation Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tsja",
      code: "NYSE:TSJA",
      companyName: "Innovator Triple Stacker ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-tslh",
      code: "NYSE:TSLH",
      companyName: "Innovator Hedged TSLA Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tsli",
      code: "NYSE:TSLI",
      companyName: "GraniteShares 1x Short TSLA Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tsll",
      code: "NYSE:TSLL",
      companyName: "Direxion Daily TSLA Bull 1.5X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tslq",
      code: "NYSE:TSLQ",
      companyName: "AXS TSLA Bear Daily ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tsls",
      code: "NYSE:TSLS",
      companyName: "Direxion Daily TSLA Bear 1X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tslx",
      code: "NYSE:TSLX",
      companyName: "Sixth Street Specialty Lending Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tt",
      code: "NYSE:TT",
      companyName: "Trane Technologies plc",
      popularity: 0,
    },
    {
      slug: "nyse-tsoc",
      code: "NYSE:TSOC",
      companyName: "Innovator Triple Stacker ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-tsp",
      code: "NYSE:TSP",
      companyName: "TuSimple Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tspa",
      code: "NYSE:TSPA",
      companyName: "T. Rowe Price U.S. Equity Research ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tspq",
      code: "NYSE:TSPQ",
      companyName: "TCW Special Purpose Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-tsq",
      code: "NYSE:TSQ",
      companyName: "TOWNSQUARE MEDIA INC.",
      popularity: 0,
    },
    {
      slug: "nyse-tsri",
      code: "NYSE:TSRI",
      companyName: "TSR Inc. New",
      popularity: 0,
    },
    {
      slug: "nyse-tsvt",
      code: "NYSE:TSVT",
      companyName: "2seventy bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ttac",
      code: "NYSE:TTAC",
      companyName: "FCF US Quality ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ttai",
      code: "NYSE:TTAI",
      companyName: "FCF International Quality ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ttcf",
      code: "NYSE:TTCF",
      companyName: "Tattooed Chef Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ttec",
      code: "NYSE:TTEC",
      companyName: "TTEC Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ttek",
      code: "NYSE:TTEK",
      companyName: "Tetra Tech Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ttgt",
      code: "NYSE:TTGT",
      companyName: "TechTarget Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tti",
      code: "NYSE:TTI",
      companyName: "TETRA Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ttm",
      code: "NYSE:TTM",
      companyName: "Tata Motors Limited",
      popularity: 0,
    },
    {
      slug: "nyse-ttmi",
      code: "NYSE:TTMI",
      companyName: "TTM Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ttnp",
      code: "NYSE:TTNP",
      companyName: "TITAN PHARMACEUTICAL INC",
      popularity: 0,
    },
    {
      slug: "nyse-ttoo",
      code: "NYSE:TTOO",
      companyName: "T2 Biosystems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ttp",
      code: "NYSE:TTP",
      companyName: "TORTOISE PIPELINE & ENERGY FUND INC.",
      popularity: 0,
    },
    {
      slug: "nyse-tuem",
      code: "NYSE:TUEM",
      companyName: "Tuesday Morning Corp",
      popularity: 0,
    },
    {
      slug: "nyse-tufn",
      code: "NYSE:TUFN",
      companyName: "Tufin Software Technologies Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-ttc",
      code: "NYSE:TTC",
      companyName: "Toro Company (The)",
      popularity: 0,
    },
    {
      slug: "nyse-tug",
      code: "NYSE:TUG",
      companyName: "STF Tactical Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tugn",
      code: "NYSE:TUGN",
      companyName: "STF Tactical Growth & Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tup",
      code: "NYSE:TUP",
      companyName: "Tupperware Brands Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tur",
      code: "NYSE:TUR",
      companyName: "iShares MSCI Turkey ETF",
      popularity: 0,
    },
    {
      slug: "nyse-turn",
      code: "NYSE:TURN",
      companyName: "180 Degree Capital Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-tusi",
      code: "NYSE:TUSI",
      companyName: "Touchstone Ultra Short Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tusk",
      code: "NYSE:TUSK",
      companyName: "Mammoth Energy Services Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tuya",
      code: "NYSE:TUYA",
      companyName:
        "Tuya Inc. American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-tv",
      code: "NYSE:TV",
      companyName: "Grupo Televisa S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-tvc",
      code: "NYSE:TVC",
      companyName:
        "Tennessee Valley Authority Power Bonds 1998 Series D due June 1 2028",
      popularity: 0,
    },
    {
      slug: "nyse-tve",
      code: "NYSE:TVE",
      companyName:
        "Tennessee Valley Authority Power Bonds 1999 Series A due May 1 2029",
      popularity: 0,
    },
    {
      slug: "nyse-tvtx",
      code: "NYSE:TVTX",
      companyName: "Travere Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tw",
      code: "NYSE:TW",
      companyName: "Tradeweb Markets Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-twcb",
      code: "NYSE:TWCB",
      companyName: "Bilander Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-twcbu",
      code: "NYSE:TWCBU",
      companyName: "Bilander Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-twcbw",
      code: "NYSE:TWCBW",
      companyName: "Bilander Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-tweb",
      code: "NYSE:TWEB",
      companyName: "SoFi Web 3 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-twi",
      code: "NYSE:TWI",
      companyName: "Titan International Inc.(Delaware)",
      popularity: 0,
    },
    {
      slug: "nyse-twin",
      code: "NYSE:TWIN",
      companyName: "Twin Disc Incorporated",
      popularity: 0,
    },
    {
      slug: "nyse-twio",
      code: "NYSE:TWIO",
      companyName: "Trajan Wealth Income Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-twks",
      code: "NYSE:TWKS",
      companyName: "Thoughtworks Holding Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-twlo",
      code: "NYSE:TWLO",
      companyName: "Twilio Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-twlv",
      code: "NYSE:TWLV",
      companyName: "Twelve Seas Investment Company II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-twlvu",
      code: "NYSE:TWLVU",
      companyName: "Twelve Seas Investment Company II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-twlvw",
      code: "NYSE:TWLVW",
      companyName: "Twelve Seas Investment Company II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-twm",
      code: "NYSE:TWM",
      companyName: "ProShares UltraShort Russell2000",
      popularity: 0,
    },
    {
      slug: "nyse-twn",
      code: "NYSE:TWN",
      companyName: "Taiwan Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-twnd",
      code: "NYSE:TWND",
      companyName: "Tailwind Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-twni",
      code: "NYSE:TWNI",
      companyName: "Tailwind International Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-twnk",
      code: "NYSE:TWNK",
      companyName: "Hostess Brands Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-two",
      code: "NYSE:TWO",
      companyName: "Two Harbors Investment Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-two-a",
      code: "NYSE:TWO-A",
      companyName:
        "Two Harbors Investment Corp 8.125% Series A Fixed-to-Floating Rate Cumulative Redeemable Preferred S",
      popularity: 0,
    },
    {
      slug: "nyse-two-b",
      code: "NYSE:TWO-B",
      companyName:
        "Two Harbors Investment Corp 7.625% Series B Fixed-to-Floating Rate Cumulative Redeemable Preferred S",
      popularity: 0,
    },
    {
      slug: "nyse-two-c",
      code: "NYSE:TWO-C",
      companyName:
        "Two Harbors Investment Corp 7.25% Series C Fixed-to-Floating Rate Cumulative Redeemable Preferred St",
      popularity: 0,
    },
    {
      slug: "nyse-twoa",
      code: "NYSE:TWOA",
      companyName: "two",
      popularity: 0,
    },
    {
      slug: "nyse-twou",
      code: "NYSE:TWOU",
      companyName: "2U Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-twst",
      code: "NYSE:TWST",
      companyName: "Twist Bioscience Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-twtr",
      code: "NYSE:TWTR",
      companyName: "Twitter Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tx",
      code: "NYSE:TX",
      companyName: "Ternium S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-txg",
      code: "NYSE:TXG",
      companyName: "10x Genomics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-txmd",
      code: "NYSE:TXMD",
      companyName: "TherapeuticsMD Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-txrh",
      code: "NYSE:TXRH",
      companyName: "Texas Roadhouse Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-txt",
      code: "NYSE:TXT",
      companyName: "Textron Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ty",
      code: "NYSE:TY",
      companyName: "TRI-Continental Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ty-",
      code: "NYSE:TY-",
      companyName: "Tri-Continental Corporation $2.50 Cumulative Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-tya",
      code: "NYSE:TYA",
      companyName: "Simplify Risk Parity Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tyd",
      code: "NYSE:TYD",
      companyName:
        "Direxion Daily 7-10 Year Treasury Bull 3X Shares (based on the NYSE 7-10 Year Treasury Bond Index; s",
      popularity: 0,
    },
    {
      slug: "nyse-tyde",
      code: "NYSE:TYDE",
      companyName: "Cryptyde Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tyg",
      code: "NYSE:TYG",
      companyName: "Tortoise Energy Infrastructure Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-tyme",
      code: "NYSE:TYME",
      companyName: "Tyme Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tyne",
      code: "NYSE:TYNE",
      companyName: "Direxion Nanotechnology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-tyo",
      code: "NYSE:TYO",
      companyName:
        "Direxion Daily 7-10 Year Treasury Bear 3X Shares (based on the NYSE 7-10 Year Treasury Bond Index; s",
      popularity: 0,
    },
    {
      slug: "nyse-tyra",
      code: "NYSE:TYRA",
      companyName: "Tyra Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-tza",
      code: "NYSE:TZA",
      companyName: "Direxion Daily Small Cap Bear 3x Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tzps",
      code: "NYSE:TZPS",
      companyName: "TZP Strategies Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-tzpsu",
      code: "NYSE:TZPSU",
      companyName: "TZP Strategies Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tzpsw",
      code: "NYSE:TZPSW",
      companyName: "TZP Strategies Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-ua",
      code: "NYSE:UA",
      companyName:
        "Under Armour Inc. Class C Common Stock $0.0003 1/3 par value",
      popularity: 0,
    },
    {
      slug: "nyse-uaa",
      code: "NYSE:UAA",
      companyName: "Under Armour Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-uae",
      code: "NYSE:UAE",
      companyName: "iShares Trust iShares MSCI UAE ETF",
      popularity: 0,
    },
    {
      slug: "nyse-u",
      code: "NYSE:U",
      companyName: "Unity Software Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-uamy",
      code: "NYSE:UAMY",
      companyName: "United States Antimony Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-uan",
      code: "NYSE:UAN",
      companyName: "CVR Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-uapr",
      code: "NYSE:UAPR",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-uaug",
      code: "NYSE:UAUG",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - August",
      popularity: 0,
    },
    {
      slug: "nyse-uav",
      code: "NYSE:UAV",
      companyName: "AdvisorShares Drone Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-uavs",
      code: "NYSE:UAVS",
      companyName: "AgEagle Aerial Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-uba",
      code: "NYSE:UBA",
      companyName: "Urstadt Biddle Properties Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-ubcb",
      code: "NYSE:UBCB",
      companyName: "UBC Algorithmic Fundamentals ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ubcp",
      code: "NYSE:UBCP",
      companyName: "United Bancorp Inc/OH",
      popularity: 0,
    },
    {
      slug: "nyse-ubfo",
      code: "NYSE:UBFO",
      companyName: "United Security Bancshares",
      popularity: 0,
    },
    {
      slug: "nyse-ubnd",
      code: "NYSE:UBND",
      companyName: "VictoryShares ESG Core Plus Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-uboh",
      code: "NYSE:UBOH",
      companyName: "United Bancshares Inc/OH",
      popularity: 0,
    },
    {
      slug: "nyse-ubot",
      code: "NYSE:UBOT",
      companyName:
        "Direxion Daily Robotics Artificial Intelligence & Automation Index Bull 2X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ubp",
      code: "NYSE:UBP",
      companyName: "Urstadt Biddle Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ubp-h",
      code: "NYSE:UBP-H",
      companyName:
        "Urstadt Biddle Properties Inc. 6.250 Percent Series H Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ubp-k",
      code: "NYSE:UBP-K",
      companyName:
        "Urstadt Biddle Properties Inc. 5.875% Series K Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ubr",
      code: "NYSE:UBR",
      companyName: "ProShares Ultra MSCI Brazil Capped",
      popularity: 0,
    },
    {
      slug: "nyse-uec",
      code: "NYSE:UEC",
      companyName: "Uranium Energy Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ubsi",
      code: "NYSE:UBSI",
      companyName: "United Bankshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ubt",
      code: "NYSE:UBT",
      companyName: "ProShares Ultra 20+ Year Treasury",
      popularity: 0,
    },
    {
      slug: "nyse-ubx",
      code: "NYSE:UBX",
      companyName: "Unity Biotechnology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ucbi",
      code: "NYSE:UCBI",
      companyName: "United Community Banks Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ucbio",
      code: "NYSE:UCBIO",
      companyName:
        "United Community Banks Inc. Depositary Shares each representing 1/1000th interest in a share of Se",
      popularity: 0,
    },
    {
      slug: "nyse-ucc",
      code: "NYSE:UCC",
      companyName: "ProShares Ultra Consumer Services",
      popularity: 0,
    },
    {
      slug: "nyse-ucib",
      code: "NYSE:UCIB",
      companyName:
        "ETRACS UBS Bloomberg Constant Maturity Commodity Index (CMCI) Total Return ETN Series B due April 5",
      popularity: 0,
    },
    {
      slug: "nyse-ucl",
      code: "NYSE:UCL",
      companyName: "uCloudlink Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-uco",
      code: "NYSE:UCO",
      companyName: "ProShares Ultra Bloomberg Crude Oil",
      popularity: 0,
    },
    {
      slug: "nyse-ucon",
      code: "NYSE:UCON",
      companyName: "First Trust TCW Unconstrained Plus Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ucrd",
      code: "NYSE:UCRD",
      companyName: "VictoryShares ESG Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-uctt",
      code: "NYSE:UCTT",
      companyName: "Ultra Clean Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ucyb",
      code: "NYSE:UCYB",
      companyName: "ProShares Ultra Nasdaq Cybersecurity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-udec",
      code: "NYSE:UDEC",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - December",
      popularity: 0,
    },
    {
      slug: "nyse-udi",
      code: "NYSE:UDI",
      companyName: "USCF Dividend Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-udiv",
      code: "NYSE:UDIV",
      companyName: "Franklin U.S. Core Dividend Tilt Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-udmy",
      code: "NYSE:UDMY",
      companyName: "Udemy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-udn",
      code: "NYSE:UDN",
      companyName: "Invesco DB US Dollar Index Bearish Fund",
      popularity: 0,
    },
    {
      slug: "nyse-udow",
      code: "NYSE:UDOW",
      companyName: "ProShares UltraPro Dow 30",
      popularity: 0,
    },
    {
      slug: "nyse-udr",
      code: "NYSE:UDR",
      companyName: "UDR Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ue",
      code: "NYSE:UE",
      companyName: "UBRAN EDGE PROPERTIES",
      popularity: 0,
    },
    {
      slug: "nyse-ueic",
      code: "NYSE:UEIC",
      companyName: "Universal Electronics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-uevm",
      code: "NYSE:UEVM",
      companyName:
        "VictoryShares USAA MSCI Emerging Markets Value Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ufab",
      code: "NYSE:UFAB",
      companyName: "Unique Fabricating Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ufcs",
      code: "NYSE:UFCS",
      companyName: "United Fire Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ufeb",
      code: "NYSE:UFEB",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - February",
      popularity: 0,
    },
    {
      slug: "nyse-ufi",
      code: "NYSE:UFI",
      companyName: "UNIFI Inc. New",
      popularity: 0,
    },
    {
      slug: "nyse-ufo",
      code: "NYSE:UFO",
      companyName: "Procure Space ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ufpi",
      code: "NYSE:UFPI",
      companyName: "UFP Industries Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ufpt",
      code: "NYSE:UFPT",
      companyName: "UFP Technologies Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ug",
      code: "NYSE:UG",
      companyName: "United-Guardian Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-uga",
      code: "NYSE:UGA",
      companyName: "United States Gasoline Fund LP",
      popularity: 0,
    },
    {
      slug: "nyse-uge",
      code: "NYSE:UGE",
      companyName: "ProShares Ultra Consumer Good",
      popularity: 0,
    },
    {
      slug: "nyse-ugi",
      code: "NYSE:UGI",
      companyName: "UGI Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ugic",
      code: "NYSE:UGIC",
      companyName: "UGI Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ugl",
      code: "NYSE:UGL",
      companyName: "ProShares Ultra Gold",
      popularity: 0,
    },
    {
      slug: "nyse-ugp",
      code: "NYSE:UGP",
      companyName: "Ultrapar Participacoes S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-uht",
      code: "NYSE:UHT",
      companyName: "Universal Health Realty Income Trust ",
      popularity: 0,
    },
    {
      slug: "nyse-ui",
      code: "NYSE:UI",
      companyName: "Ubiquiti Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-uihc",
      code: "NYSE:UIHC",
      companyName: "United Insurance Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-uis",
      code: "NYSE:UIS",
      companyName: "Unisys Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-uitb",
      code: "NYSE:UITB",
      companyName: "VictoryShares USAA Core Intermediate-Term Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-uivm",
      code: "NYSE:UIVM",
      companyName: "VictoryShares USAA MSCI International Value Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ujan",
      code: "NYSE:UJAN",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-ujb",
      code: "NYSE:UJB",
      companyName: "ProShares Ultra High Yield",
      popularity: 0,
    },
    {
      slug: "nyse-ujul",
      code: "NYSE:UJUL",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-ujun",
      code: "NYSE:UJUN",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - June",
      popularity: 0,
    },
    {
      slug: "nyse-uk",
      code: "NYSE:UK",
      companyName: "Ucommune International Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ukomw",
      code: "NYSE:UKOMW",
      companyName: "Ucommune International Ltd Warrant expiring 11/17/2025",
      popularity: 0,
    },
    {
      slug: "nyse-ulbi",
      code: "NYSE:ULBI",
      companyName: "Ultralife Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ulcc",
      code: "NYSE:ULCC",
      companyName: "Frontier Group Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ule",
      code: "NYSE:ULE",
      companyName: "ProShares Ultra Euro",
      popularity: 0,
    },
    {
      slug: "nyse-ulh",
      code: "NYSE:ULH",
      companyName: "Universal Logistics Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ulst",
      code: "NYSE:ULST",
      companyName: "SPDR SSgA Ultra Short Term Bond ETF of SSgA Active Trust",
      popularity: 0,
    },
    {
      slug: "nyse-ulta",
      code: "NYSE:ULTA",
      companyName: "Ulta Beauty Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ultr",
      code: "NYSE:ULTR",
      companyName: "IQ Ultra Short Duration ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ulvm",
      code: "NYSE:ULVM",
      companyName: "VictoryShares USAA MSCI USA Value Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-umar",
      code: "NYSE:UMAR",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - March",
      popularity: 0,
    },
    {
      slug: "nyse-umay",
      code: "NYSE:UMAY",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - May",
      popularity: 0,
    },
    {
      slug: "nyse-umbf",
      code: "NYSE:UMBF",
      companyName: "UMB Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-umc",
      code: "NYSE:UMC",
      companyName: "United Microelectronic Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-umdd",
      code: "NYSE:UMDD",
      companyName: "ProShares UltraPro MidCap400",
      popularity: 0,
    },
    {
      slug: "nyse-umh-d",
      code: "NYSE:UMH-D",
      companyName:
        "UMH Properties Inc. 6.375% Series D Cumulative Redeemable Preferred Stock Liquidation Preference $",
      popularity: 0,
    },
    {
      slug: "nyse-umi",
      code: "NYSE:UMI",
      companyName: "USCF Midstream Energy Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-umma",
      code: "NYSE:UMMA",
      companyName: "Wahed Dow Jones Islamic World ETF",
      popularity: 0,
    },
    {
      slug: "nyse-umpq",
      code: "NYSE:UMPQ",
      companyName: "Umpqua Holdings Corp",
      popularity: 0,
    },
    {
      slug: "nyse-unam",
      code: "NYSE:UNAM",
      companyName: "Unico American Corp",
      popularity: 0,
    },
    {
      slug: "nyse-unb",
      code: "NYSE:UNB",
      companyName: "Union Bankshares Inc",
      popularity: 0,
    },
    {
      slug: "nyse-uncy",
      code: "NYSE:UNCY",
      companyName: "Unicycive Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-unfi",
      code: "NYSE:UNFI",
      companyName: "United Natural Foods Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ung",
      code: "NYSE:UNG",
      companyName: "United States Natural Gas Fund LP Unit",
      popularity: 0,
    },
    {
      slug: "nyse-ura",
      code: "NYSE:URA",
      companyName: "Global X Uranium ETF",
      popularity: 0,
    },
    {
      slug: "nyse-unf",
      code: "NYSE:UNF",
      companyName: "Unifirst Corp",
      popularity: 0,
    },
    {
      slug: "nyse-unit",
      code: "NYSE:UNIT",
      companyName: "Uniti Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-unl",
      code: "NYSE:UNL",
      companyName: "United States 12 Month Natural Gas Fund LP",
      popularity: 0,
    },
    {
      slug: "nyse-unm",
      code: "NYSE:UNM",
      companyName: "Unum Group",
      popularity: 0,
    },
    {
      slug: "nyse-unma",
      code: "NYSE:UNMA",
      companyName: "Unum Group 6.250% Junior Subordinated Notes due 2058",
      popularity: 0,
    },
    {
      slug: "nyse-unov",
      code: "NYSE:UNOV",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - November",
      popularity: 0,
    },
    {
      slug: "nyse-unp",
      code: "NYSE:UNP",
      companyName: "Union Pacific Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-unty",
      code: "NYSE:UNTY",
      companyName: "Unity Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-unvr",
      code: "NYSE:UNVR",
      companyName: "Univar Solutions Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-uoct",
      code: "NYSE:UOCT",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-uone",
      code: "NYSE:UONE",
      companyName: "Urban One Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-uonek",
      code: "NYSE:UONEK",
      companyName: "Urban One Inc. Class D Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-up",
      code: "NYSE:UP",
      companyName: "Wheels Up Experience Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-upar",
      code: "NYSE:UPAR",
      companyName: "UPAR Ultra Risk Parity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-upc",
      code: "NYSE:UPC",
      companyName: "Universe Pharmaceuticals Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-uph",
      code: "NYSE:UPH",
      companyName: "UpHealth Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-upld",
      code: "NYSE:UPLD",
      companyName: "Upland Software Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-upro",
      code: "NYSE:UPRO",
      companyName: "ProShares UltraPro S&P 500",
      popularity: 0,
    },
    {
      slug: "nyse-ups",
      code: "NYSE:UPS",
      companyName: "United Parcel Service Inc. Class B",
      popularity: 0,
    },
    {
      slug: "nyse-upst",
      code: "NYSE:UPST",
      companyName: "Upstart Holdings Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-uptd",
      code: "NYSE:UPTD",
      companyName: "TradeUP Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-uptdu",
      code: "NYSE:UPTDU",
      companyName: "TradeUP Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-uptdw",
      code: "NYSE:UPTDW",
      companyName: "TradeUP Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-upv",
      code: "NYSE:UPV",
      companyName: "ProShares Ultra FTSE Europe",
      popularity: 0,
    },
    {
      slug: "nyse-upw",
      code: "NYSE:UPW",
      companyName: "ProShares Ultra Utilities",
      popularity: 0,
    },
    {
      slug: "nyse-urbn",
      code: "NYSE:URBN",
      companyName: "Urban Outfitters Inc",
      popularity: 0,
    },
    {
      slug: "nyse-ure",
      code: "NYSE:URE",
      companyName: "ProShares Ultra Real Estate",
      popularity: 0,
    },
    {
      slug: "nyse-urg",
      code: "NYSE:URG",
      companyName: "Ur-Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-urgn",
      code: "NYSE:URGN",
      companyName: "UroGen Pharma Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-uroy",
      code: "NYSE:UROY",
      companyName: "Uranium Royalty Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-urth",
      code: "NYSE:URTH",
      companyName: "iShares MSCI World ETF",
      popularity: 0,
    },
    {
      slug: "nyse-urty",
      code: "NYSE:URTY",
      companyName: "ProShares UltraPro Russell2000",
      popularity: 0,
    },
    {
      slug: "nyse-usa",
      code: "NYSE:USA",
      companyName: "Liberty All-Star Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-usac",
      code: "NYSE:USAC",
      companyName: "USA COMPRESSION PARTNERS LP",
      popularity: 0,
    },
    {
      slug: "nyse-umh",
      code: "NYSE:UMH",
      companyName: "UMH Properties Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-urnm",
      code: "NYSE:URNM",
      companyName: "Sprott Uranium Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ul",
      code: "NYSE:UL",
      companyName: "Unilever plc",
      popularity: 0,
    },
    {
      slug: "nyse-usai",
      code: "NYSE:USAI",
      companyName: "Pacer American Energy Independence ETF",
      popularity: 0,
    },
    {
      slug: "nyse-usak",
      code: "NYSE:USAK",
      companyName: "USA Truck Inc",
      popularity: 0,
    },
    {
      slug: "nyse-usap",
      code: "NYSE:USAP",
      companyName: "Universal Stainless & Alloy",
      popularity: 0,
    },
    {
      slug: "nyse-usau",
      code: "NYSE:USAU",
      companyName: "U.S. Gold Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-usb-a",
      code: "NYSE:USB-A",
      companyName:
        "U.S. Bancorp Depositary Shares (each representing a 1/100th interest in a share of Series A Non-Cumu",
      popularity: 0,
    },
    {
      slug: "nyse-usb-h",
      code: "NYSE:USB-H",
      companyName:
        "US Bancorp Depositary Shares (1/1000 Interest in Ser. B Non-Cum. Prptl. Prfrd. Stock)",
      popularity: 0,
    },
    {
      slug: "nyse-usb-p",
      code: "NYSE:USB-P",
      companyName:
        "U.S. Bancorp Depositary Shares each representing a 1/1000th interest in a share of Series K Non-Cum",
      popularity: 0,
    },
    {
      slug: "nyse-usb-q",
      code: "NYSE:USB-Q",
      companyName:
        "U.S. Bancorp Depositary Shares Each Representing a 1/1 000th Interest in a Share of Series L Non-",
      popularity: 0,
    },
    {
      slug: "nyse-usb-r",
      code: "NYSE:USB-R",
      companyName:
        "U.S. Bancorp Depositary Shares Each Representing a 1/1 000th Interest in a Share of Series M Non-",
      popularity: 0,
    },
    {
      slug: "nyse-usb-s",
      code: "NYSE:USB-S",
      companyName:
        "U.S. Bancorp Depositary Shares each representing a 1/1 000th interest in a share of Series O Non-",
      popularity: 0,
    },
    {
      slug: "nyse-usbf",
      code: "NYSE:USBF",
      companyName: "iShares USD Bond Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-uscb",
      code: "NYSE:USCB",
      companyName: "USCB Financial Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-usci",
      code: "NYSE:USCI",
      companyName: "US Commodity Index",
      popularity: 0,
    },
    {
      slug: "nyse-usct",
      code: "NYSE:USCT",
      companyName: "TKB Critical Technologies 1 Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-usctu",
      code: "NYSE:USCTU",
      companyName: "TKB Critical Technologies 1 Unit",
      popularity: 0,
    },
    {
      slug: "nyse-usctw",
      code: "NYSE:USCTW",
      companyName: "TKB Critical Technologies 1 Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-usd",
      code: "NYSE:USD",
      companyName: "ProShares Ultra Semiconductors",
      popularity: 0,
    },
    {
      slug: "nyse-usdp",
      code: "NYSE:USDP",
      companyName: "USD PARTNERS LP",
      popularity: 0,
    },
    {
      slug: "nyse-usdu",
      code: "NYSE:USDU",
      companyName: "WisdomTree Bloomberg U.S. Dollar Bullish Fund",
      popularity: 0,
    },
    {
      slug: "nyse-usea",
      code: "NYSE:USEA",
      companyName: "United Maritime Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-useg",
      code: "NYSE:USEG",
      companyName: "U.S. Energy Corp. Common Stock (DE)",
      popularity: 0,
    },
    {
      slug: "nyse-usep",
      code: "NYSE:USEP",
      companyName: "Innovator U.S. Equity Ultra Buffer ETF - September",
      popularity: 0,
    },
    {
      slug: "nyse-useq",
      code: "NYSE:USEQ",
      companyName: "Invesco Russell 1000 Enhanced Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-user",
      code: "NYSE:USER",
      companyName: "UserTesting Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-usfd",
      code: "NYSE:USFD",
      companyName: "US Foods Holding Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-usfr",
      code: "NYSE:USFR",
      companyName: "WisdomTree Floating Rate Treasury Fund",
      popularity: 0,
    },
    {
      slug: "nyse-ushy",
      code: "NYSE:USHY",
      companyName: "iShares Broad USD High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-usi",
      code: "NYSE:USI",
      companyName: "Principal Ultra-Short Active Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-usig",
      code: "NYSE:USIG",
      companyName: "iShares Broad USD Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-usio",
      code: "NYSE:USIO",
      companyName: "Usio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-usl",
      code: "NYSE:USL",
      companyName: "United States 12 Month Oil Fund LP",
      popularity: 0,
    },
    {
      slug: "nyse-uslb",
      code: "NYSE:USLB",
      companyName: "Invesco Russell 1000 Low Beta Equal Weight ETF",
      popularity: 0,
    },
    {
      slug: "nyse-uslm",
      code: "NYSE:USLM",
      companyName: "United States Lime & Minerals",
      popularity: 0,
    },
    {
      slug: "nyse-usm",
      code: "NYSE:USM",
      companyName: "United States Cellular Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-usmc",
      code: "NYSE:USMC",
      companyName:
        "Principal Exchange-Traded Funds Principal U.S. Mega-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-usmf",
      code: "NYSE:USMF",
      companyName: "WisdomTree U.S. Multifactor Fund",
      popularity: 0,
    },
    {
      slug: "nyse-usml",
      code: "NYSE:USML",
      companyName:
        "ETRACS 2x Leveraged MSCI US Minimum Volatility Factor TR ETN",
      popularity: 0,
    },
    {
      slug: "nyse-usmv",
      code: "NYSE:USMV",
      companyName: "iShares MSCI USA Min Vol Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-usna",
      code: "NYSE:USNA",
      companyName: "USANA Health Sciences Inc",
      popularity: 0,
    },
    {
      slug: "nyse-usnz",
      code: "NYSE:USNZ",
      companyName: "Xtrackers Net Zero Pathway Paris Aligned US Equity ETF",
      popularity: 0,
    },
    {
      slug: "asx-aren",
      code: "ASX:AREN",
      companyName: "Argonaut Resources NL",
      popularity: 0,
    },
    {
      slug: "nyse-usoi",
      code: "NYSE:USOI",
      companyName:
        "Credit Suisse AG Credit Suisse X-Links Crude Oil Shares Covered Call ETN",
      popularity: 0,
    },
    {
      slug: "nyse-usph",
      code: "NYSE:USPH",
      companyName: "US Physical Therapy Inc",
      popularity: 0,
    },
    {
      slug: "nyse-uspx",
      code: "NYSE:USPX",
      companyName: "Franklin U.S. Equity Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-usrt",
      code: "NYSE:USRT",
      companyName: "iShares Core U.S. REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ussg",
      code: "NYSE:USSG",
      companyName: "Xtrackers MSCI USA ESG Leaders Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ust",
      code: "NYSE:UST",
      companyName: "ProShares Ultra 7-10 Year Treasury",
      popularity: 0,
    },
    {
      slug: "nyse-ustb",
      code: "NYSE:USTB",
      companyName: "VictoryShares USAA Core Short-Term Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-usws",
      code: "NYSE:USWS",
      companyName: "U.S. Well Services Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-uswsw",
      code: "NYSE:USWSW",
      companyName: "U.S. Well Services Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-usx",
      code: "NYSE:USX",
      companyName: "U.S. Xpress Enterprises Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-usxf",
      code: "NYSE:USXF",
      companyName: "iShares ESG Advanced MSCI USA ETF",
      popularity: 0,
    },
    {
      slug: "nyse-utaa",
      code: "NYSE:UTAA",
      companyName: "UTA Acquisition Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-utaau",
      code: "NYSE:UTAAU",
      companyName: "UTA Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nyse-utaaw",
      code: "NYSE:UTAAW",
      companyName: "UTA Acquisition Corporation Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-uten",
      code: "NYSE:UTEN",
      companyName: "US Treasury 10 Year Note ETF",
      popularity: 0,
    },
    {
      slug: "nyse-utes",
      code: "NYSE:UTES",
      companyName: "Virtus Reaves Utilities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-utf",
      code: "NYSE:UTF",
      companyName: "Cohen & Steers  Infrastructure Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-utg",
      code: "NYSE:UTG",
      companyName: "Reaves Utility Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-usas",
      code: "NYSE:USAS",
      companyName: "Americas Gold and Silver Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-uthr",
      code: "NYSE:UTHR",
      companyName: "United Therapeutics Corp",
      popularity: 0,
    },
    {
      slug: "nyse-uti",
      code: "NYSE:UTI",
      companyName: "Universal Technical Institute Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-utl",
      code: "NYSE:UTL",
      companyName: "Unitil Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-utmd",
      code: "NYSE:UTMD",
      companyName: "Utah Medical Products Inc",
      popularity: 0,
    },
    {
      slug: "nyse-utme",
      code: "NYSE:UTME",
      companyName: "UTime Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-utrn",
      code: "NYSE:UTRN",
      companyName: "Vesper US Large Cap Short-Term Reversal Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-utrs",
      code: "NYSE:UTRS",
      companyName: "Minerva Surgical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-utsi",
      code: "NYSE:UTSI",
      companyName: "UTStarcom Holdings Corp Ordinary Shares (Cayman Islands)",
      popularity: 0,
    },
    {
      slug: "nyse-utsl",
      code: "NYSE:UTSL",
      companyName: "Direxion Daily Utilities Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-utwo",
      code: "NYSE:UTWO",
      companyName: "US Treasury 2 Year Note ETF",
      popularity: 0,
    },
    {
      slug: "nyse-utz",
      code: "NYSE:UTZ",
      companyName: "Utz Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-uup",
      code: "NYSE:UUP",
      companyName: "Invesco DB US Dollar Index Bullish Fund",
      popularity: 0,
    },
    {
      slug: "nyse-uuu",
      code: "NYSE:UUU",
      companyName: "Universal Security Instruments Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-uuuu",
      code: "NYSE:UUUU",
      companyName: "Energy Fuels Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-uvdv",
      code: "NYSE:UVDV",
      companyName: "UVA Dividend Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-uve",
      code: "NYSE:UVE",
      companyName: "UNIVERSAL INSURANCE HLDG INC.",
      popularity: 0,
    },
    {
      slug: "nyse-uvix",
      code: "NYSE:UVIX",
      companyName: "2x Long VIX Futures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-uvsp",
      code: "NYSE:UVSP",
      companyName: "Univest Financial Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-uvv",
      code: "NYSE:UVV",
      companyName: "Universal Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-uvxy",
      code: "NYSE:UVXY",
      companyName: "ProShares Ultra VIX Short-Term Futures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-uwm",
      code: "NYSE:UWM",
      companyName: "ProShares Ultra Russell2000",
      popularity: 0,
    },
    {
      slug: "nyse-uwmc",
      code: "NYSE:UWMC",
      companyName: "UWM Holdings Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-uxi",
      code: "NYSE:UXI",
      companyName: "ProShares Ultra Industrials",
      popularity: 0,
    },
    {
      slug: "nyse-uxin",
      code: "NYSE:UXIN",
      companyName: "Uxin Limited ADS",
      popularity: 0,
    },
    {
      slug: "nyse-uyg",
      code: "NYSE:UYG",
      companyName: "ProShares Ultra Financials",
      popularity: 0,
    },
    {
      slug: "nyse-uym",
      code: "NYSE:UYM",
      companyName: "ProShares Ultra Basic Materials",
      popularity: 0,
    },
    {
      slug: "nyse-uzd",
      code: "NYSE:UZD",
      companyName:
        "United States Cellular Corporation 6.250% Senior Notes due 2069",
      popularity: 0,
    },
    {
      slug: "nyse-uze",
      code: "NYSE:UZE",
      companyName:
        "United States Cellular Corporation 5.500% Senior Notes due 2070",
      popularity: 0,
    },
    {
      slug: "nyse-uzf",
      code: "NYSE:UZF",
      companyName:
        "United States Cellular Corporation 5.500% Senior Notes due 2070",
      popularity: 0,
    },
    {
      slug: "nyse-vabk",
      code: "NYSE:VABK",
      companyName: "Virginia National Bankshares Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vabs",
      code: "NYSE:VABS",
      companyName: "Virtus Newfleet ABS/MBS ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vac",
      code: "NYSE:VAC",
      companyName: "MARRIOTT VACATIONS WORLDWIDE CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-vacc",
      code: "NYSE:VACC",
      companyName: "Vaccitech plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vale",
      code: "NYSE:VALE",
      companyName: "VALE S.A.",
      popularity: 0,
    },
    {
      slug: "nyse-valn",
      code: "NYSE:VALN",
      companyName: "Valneva SE American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-valq",
      code: "NYSE:VALQ",
      companyName: "American Century STOXX U.S. Quality Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-valt",
      code: "NYSE:VALT",
      companyName: "ETFMG Sit Ultra Short ETF",
      popularity: 0,
    },
    {
      slug: "nyse-valu",
      code: "NYSE:VALU",
      companyName: "Value Line Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vamo",
      code: "NYSE:VAMO",
      companyName: "Cambria Value and Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vapo",
      code: "NYSE:VAPO",
      companyName: "Vapotherm Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vaqc",
      code: "NYSE:VAQC",
      companyName: "Vector Acquisition Corporation II Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vate",
      code: "NYSE:VATE",
      companyName: "INNOVATE Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-vaw",
      code: "NYSE:VAW",
      companyName: "Vanguard Materials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vaxx",
      code: "NYSE:VAXX",
      companyName: "Vaxxinity Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vb",
      code: "NYSE:VB",
      companyName: "Vanguard Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vbb",
      code: "NYSE:VBB",
      companyName: "Valkyrie Balance Sheet Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vbf",
      code: "NYSE:VBF",
      companyName: "INVESCO  BOND FUND",
      popularity: 0,
    },
    {
      slug: "nyse-vbfc",
      code: "NYSE:VBFC",
      companyName: "Village Bank and Trust Financial Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-vbiv",
      code: "NYSE:VBIV",
      companyName: "VBI Vaccines Inc. New Common Stock (Canada)",
      popularity: 0,
    },
    {
      slug: "nyse-vbk",
      code: "NYSE:VBK",
      companyName: "Vanguard Small-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vblt",
      code: "NYSE:VBLT",
      companyName: "Vascular Biogenics Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-vbnk",
      code: "NYSE:VBNK",
      companyName: "VersaBank Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vboc",
      code: "NYSE:VBOC",
      companyName: "Viscogliosi Brothers Acquisition Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vbocu",
      code: "NYSE:VBOCU",
      companyName: "Viscogliosi Brothers Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vbocw",
      code: "NYSE:VBOCW",
      companyName: "Viscogliosi Brothers Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vbr",
      code: "NYSE:VBR",
      companyName: "Vanguard Small-Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vbtx",
      code: "NYSE:VBTX",
      companyName: "Veritex Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vc",
      code: "NYSE:VC",
      companyName: "VISTEON CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-vcar",
      code: "NYSE:VCAR",
      companyName: "Simplify Volt RoboCar Disruption and Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vceb",
      code: "NYSE:VCEB",
      companyName: "Vanguard ESG U.S. Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vcel",
      code: "NYSE:VCEL",
      companyName: "Vericel Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-vcif",
      code: "NYSE:VCIF",
      companyName: "Vertical Capital Income Fund Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-vcit",
      code: "NYSE:VCIT",
      companyName: "Vanguard Intermediate-Term Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vcka",
      code: "NYSE:VCKA",
      companyName: "Vickers Vantage Corp. I Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vckau",
      code: "NYSE:VCKAU",
      companyName: "Vickers Vantage Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vckaw",
      code: "NYSE:VCKAW",
      companyName: "Vickers Vantage Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vcln",
      code: "NYSE:VCLN",
      companyName: "Virtus Duff & Phelps Clean Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vclo",
      code: "NYSE:VCLO",
      companyName: "Simplify Volt Cloud and Cybersecurity Disruption ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vclt",
      code: "NYSE:VCLT",
      companyName: "Vanguard Long-Term Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vcnx",
      code: "NYSE:VCNX",
      companyName: "Vaccinex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vcr",
      code: "NYSE:VCR",
      companyName: "Vanguard Consumer Discretionary ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vcsa",
      code: "NYSE:VCSA",
      companyName: "Vacasa Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vcsh",
      code: "NYSE:VCSH",
      companyName: "Vanguard Short-Term Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vctr",
      code: "NYSE:VCTR",
      companyName: "Victory Capital Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vcv",
      code: "NYSE:VCV",
      companyName: "INVESCO  CALIFORNIA VALUE MUNI INCOME TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-vcxa",
      code: "NYSE:VCXA",
      companyName:
        "10X Capital Venture Acquisition Corp. II Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-vcxau",
      code: "NYSE:VCXAU",
      companyName: "10X Capital Venture Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vcxaw",
      code: "NYSE:VCXAW",
      companyName: "10X Capital Venture Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vcxb",
      code: "NYSE:VCXB",
      companyName: "10X Capital Venture Acquisition Corp. III",
      popularity: 0,
    },
    {
      slug: "nyse-vcyt",
      code: "NYSE:VCYT",
      companyName: "Veracyte Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vdc",
      code: "NYSE:VDC",
      companyName: "Vanguard Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vde",
      code: "NYSE:VDE",
      companyName: "Vanguard Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vdni",
      code: "NYSE:VDNI",
      companyName: "V-Shares US Leadership Diversity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vea",
      code: "NYSE:VEA",
      companyName: "Vanguard FTSE Developed Markets ETF",
      popularity: 0,
    },
    {
      slug: "nyse-veco",
      code: "NYSE:VECO",
      companyName: "Veeco Instruments Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vect",
      code: "NYSE:VECT",
      companyName: "VectivBio Holding AG Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vedu",
      code: "NYSE:VEDU",
      companyName:
        "Visionary Education Technology Holdings Group Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-veee",
      code: "NYSE:VEEE",
      companyName: "Twin Vee PowerCats Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-veev",
      code: "NYSE:VEEV",
      companyName: "Veeva Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vega",
      code: "NYSE:VEGA",
      companyName: "AdvisorShares STAR Global Buy-Write ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vegi",
      code: "NYSE:VEGI",
      companyName: "iShares MSCI Global Agriculture Producers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vegn",
      code: "NYSE:VEGN",
      companyName: "US Vegan Climate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vel",
      code: "NYSE:VEL",
      companyName: "Velocity Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-velo",
      code: "NYSE:VELO",
      companyName: "Velocity Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-velou",
      code: "NYSE:VELOU",
      companyName: "Velocity Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-velow",
      code: "NYSE:VELOW",
      companyName: "Velocity Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vena",
      code: "NYSE:VENA",
      companyName: "Venus Acquisition Corporation Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-venar",
      code: "NYSE:VENAR",
      companyName: "Venus Acquisition Corporation Rights",
      popularity: 0,
    },
    {
      slug: "nyse-venau",
      code: "NYSE:VENAU",
      companyName: "Venus Acquisition Corporation Units",
      popularity: 0,
    },
    {
      slug: "nyse-venaw",
      code: "NYSE:VENAW",
      companyName: "Venus Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-veon",
      code: "NYSE:VEON",
      companyName: "VEON Ltd. ADS",
      popularity: 0,
    },
    {
      slug: "nyse-vera",
      code: "NYSE:VERA",
      companyName: "Vera Therapeutics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-verb",
      code: "NYSE:VERB",
      companyName: "Verb Technology Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-verbw",
      code: "NYSE:VERBW",
      companyName: "Verb Technology Company Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-veri",
      code: "NYSE:VERI",
      companyName: "Veritone Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vero",
      code: "NYSE:VERO",
      companyName: "Venus Concept Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vers",
      code: "NYSE:VERS",
      companyName: "ProShares Metaverse ETF",
      popularity: 0,
    },
    {
      slug: "nyse-veru",
      code: "NYSE:VERU",
      companyName: "Veru Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-verv",
      code: "NYSE:VERV",
      companyName: "Verve Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-verx",
      code: "NYSE:VERX",
      companyName: "Vertex Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-very",
      code: "NYSE:VERY",
      companyName: "Vericity Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vet",
      code: "NYSE:VET",
      companyName: "VERMILION ENERGY INC.",
      popularity: 0,
    },
    {
      slug: "nyse-vev",
      code: "NYSE:VEV",
      companyName: "Vicinity Motor Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vfc",
      code: "NYSE:VFC",
      companyName: "V.F. Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-vff",
      code: "NYSE:VFF",
      companyName: "Village Farms International Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vfl",
      code: "NYSE:VFL",
      companyName: "Delaware Investments National Municipal Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-vflq",
      code: "NYSE:VFLQ",
      companyName: "Vanguard U.S. Liquidity Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vfmf",
      code: "NYSE:VFMF",
      companyName: "Vanguard U.S. Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vfmo",
      code: "NYSE:VFMO",
      companyName: "Vanguard U.S. Momentum Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vfmv",
      code: "NYSE:VFMV",
      companyName: "Vanguard U.S. Minimum Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vfqy",
      code: "NYSE:VFQY",
      companyName: "Vanguard U.S. Quality Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vfva",
      code: "NYSE:VFVA",
      companyName: "Vanguard U.S. Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vgfc",
      code: "NYSE:VGFC",
      companyName: "The Very Good Food Company",
      popularity: 0,
    },
    {
      slug: "nyse-vgi",
      code: "NYSE:VGI",
      companyName: "VIRTUS GLOBAL MULTI-SECTOR INCOME FUND",
      popularity: 0,
    },
    {
      slug: "nyse-vgit",
      code: "NYSE:VGIT",
      companyName: "Vanguard Intermediate-Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vglt",
      code: "NYSE:VGLT",
      companyName: "Vanguard Long-Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vgm",
      code: "NYSE:VGM",
      companyName: "Invesco  Trust Investment Grade Municipals",
      popularity: 0,
    },
    {
      slug: "nyse-vgr",
      code: "NYSE:VGR",
      companyName: "Vector Group Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-vgt",
      code: "NYSE:VGT",
      companyName: "Vanguard Information Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vgz",
      code: "NYSE:VGZ",
      companyName: "Vista Gold Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-vhaq",
      code: "NYSE:VHAQ",
      companyName: "Viveon Health Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-vgsh",
      code: "NYSE:VGSH",
      companyName: "Vanguard Short-Term Treasury ETF",
      popularity: 0,
    },
    {
      slug: "nyse-veu",
      code: "NYSE:VEU",
      companyName: "Vanguard FTSE All-World Ex-US ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vhaq^",
      code: "NYSE:VHAQ^",
      companyName:
        "Viveon Health Acquisition Corp. Rights each exchangeable into one-twentieth of a share of Common St",
      popularity: 0,
    },
    {
      slug: "nyse-vhc",
      code: "NYSE:VHC",
      companyName: "VirnetX Holding Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-vhi",
      code: "NYSE:VHI",
      companyName: "Valhi Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vhna",
      code: "NYSE:VHNA",
      companyName:
        "Vahanna Tech Edge Acquisition I Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vhnau",
      code: "NYSE:VHNAU",
      companyName: "Vahanna Tech Edge Acquisition I Corp. Units",
      popularity: 0,
    },
    {
      slug: "nyse-vhnaw",
      code: "NYSE:VHNAW",
      companyName: "Vahanna Tech Edge Acquisition I Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-vht",
      code: "NYSE:VHT",
      companyName: "Vanguard Health Care ETF",
      popularity: 0,
    },
    {
      slug: "nyse-via",
      code: "NYSE:VIA",
      companyName: "Via Renewables Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-viao",
      code: "NYSE:VIAO",
      companyName:
        "VIA optronics AG American Depositary Shares each representing one-fifth of an Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-viasp",
      code: "NYSE:VIASP",
      companyName:
        "Via Renewables Inc. 8.75% Series A Fixed-to-Floating Rate Cumulative Redeemable Perpetual Preferred",
      popularity: 0,
    },
    {
      slug: "nyse-viav",
      code: "NYSE:VIAV",
      companyName: "Viavi Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vice",
      code: "NYSE:VICE",
      companyName: "AdvisorShares Vice ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vici",
      code: "NYSE:VICI",
      companyName: "VICI Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vicr",
      code: "NYSE:VICR",
      companyName: "Vicor Corp",
      popularity: 0,
    },
    {
      slug: "nyse-vidi",
      code: "NYSE:VIDI",
      companyName: "Vident International Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-view",
      code: "NYSE:VIEW",
      companyName: "View Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vieww",
      code: "NYSE:VIEWW",
      companyName: "View Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vig",
      code: "NYSE:VIG",
      companyName: "Vanguard Dividend Appreciation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vigi",
      code: "NYSE:VIGI",
      companyName: "Vanguard International Dividend Appreciation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vigl",
      code: "NYSE:VIGL",
      companyName: "Vigil Neuroscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vii",
      code: "NYSE:VII",
      companyName: "7GC & Co. Holdings Inc. Class A common stock",
      popularity: 0,
    },
    {
      slug: "nyse-viiau",
      code: "NYSE:VIIAU",
      companyName: "7GC & Co. Holdings Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-viiaw",
      code: "NYSE:VIIAW",
      companyName: "7GC & Co. Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vinc",
      code: "NYSE:VINC",
      companyName: "Vincerx Pharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vine",
      code: "NYSE:VINE",
      companyName: "Fresh Vine Wine Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vino",
      code: "NYSE:VINO",
      companyName: "Gaucho Group Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vioo",
      code: "NYSE:VIOO",
      companyName: "Vanguard S&P Small-Cap 600 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-viog",
      code: "NYSE:VIOG",
      companyName: "Vanguard S&P Small-Cap 600 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-viot",
      code: "NYSE:VIOT",
      companyName: "Viomi Technology Co. Ltd American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-viov",
      code: "NYSE:VIOV",
      companyName: "Vanguard S&P Small-Cap 600 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vips",
      code: "NYSE:VIPS",
      companyName: "Vipshop Holdings Limited",
      popularity: 0,
    },
    {
      slug: "nyse-vir",
      code: "NYSE:VIR",
      companyName: "Vir Biotechnology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-virc",
      code: "NYSE:VIRC",
      companyName: "Virco Mfg. Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-viri",
      code: "NYSE:VIRI",
      companyName: "Virios Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-virs",
      code: "NYSE:VIRS",
      companyName: "Pacer BioThreat Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-virt",
      code: "NYSE:VIRT",
      companyName: "Virtu Financial Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-virx",
      code: "NYSE:VIRX",
      companyName: "Viracta Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vis",
      code: "NYSE:VIS",
      companyName: "Vanguard Industrials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-visl",
      code: "NYSE:VISL",
      companyName: "Vislink Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vist",
      code: "NYSE:VIST",
      companyName: "Vista Energy S.A.B. de C.V.",
      popularity: 0,
    },
    {
      slug: "nyse-vitl",
      code: "NYSE:VITL",
      companyName: "Vital Farms Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-viv",
      code: "NYSE:VIV",
      companyName:
        "Telefonica Brasil S.A. American Depositary Shares (Each representing One Common Share)",
      popularity: 0,
    },
    {
      slug: "nyse-vive",
      code: "NYSE:VIVE",
      companyName: "VIVEVE MED INC",
      popularity: 0,
    },
    {
      slug: "nyse-vivk",
      code: "NYSE:VIVK",
      companyName: "Vivakor Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vivo",
      code: "NYSE:VIVO",
      companyName: "Meridian Bioscience Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vixm",
      code: "NYSE:VIXM",
      companyName: "ProShares VIX Mid-Term Futures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vixy",
      code: "NYSE:VIXY",
      companyName: "ProShares VIX Short-Term Futures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vjet",
      code: "NYSE:VJET",
      companyName:
        "VOXELJET AG American Depositary Shares (each representing one Ordinary Share)",
      popularity: 0,
    },
    {
      slug: "nyse-vki",
      code: "NYSE:VKI",
      companyName: "Invesco Advantage Municipal Income Trust II",
      popularity: 0,
    },
    {
      slug: "nyse-vkq",
      code: "NYSE:VKQ",
      companyName: "Invesco Municipal Trust",
      popularity: 0,
    },
    {
      slug: "nyse-vktx",
      code: "NYSE:VKTX",
      companyName: "Viking Therapeutics Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vlat",
      code: "NYSE:VLAT",
      companyName: "Valor Latitude Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vlatu",
      code: "NYSE:VLATU",
      companyName: "Valor Latitude Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vlatw",
      code: "NYSE:VLATW",
      companyName: "Valor Latitude Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vlcn",
      code: "NYSE:VLCN",
      companyName: "Volcon Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-vld",
      code: "NYSE:VLD",
      companyName: "Velo3D Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vldr",
      code: "NYSE:VLDR",
      companyName: "Velodyne Lidar Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vldrw",
      code: "NYSE:VLDRW",
      companyName: "Velodyne Lidar Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-vlgea",
      code: "NYSE:VLGEA",
      companyName: "Village Super Market",
      popularity: 0,
    },
    {
      slug: "nyse-vln",
      code: "NYSE:VLN",
      companyName: "Valens Semiconductor Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-vlns",
      code: "NYSE:VLNS",
      companyName: "The Valens Company Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vlon",
      code: "NYSE:VLON",
      companyName: "Vallon Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vlrs",
      code: "NYSE:VLRS",
      companyName: "CONTROLADORA VUELA COMPA¥IA DE AVIACION S.A.B. DE C.V.",
      popularity: 0,
    },
    {
      slug: "asx-h100",
      code: "ASX:H100",
      companyName: "Betashares Ftse 100 Currency Hedged ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vlt",
      code: "NYSE:VLT",
      companyName: "Invesco  High Income Trust II",
      popularity: 0,
    },
    {
      slug: "nyse-vlta",
      code: "NYSE:VLTA",
      companyName: "Volta Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vlu",
      code: "NYSE:VLU",
      companyName: "SPDR S&P 1500 Value Tilt ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vlue",
      code: "NYSE:VLUE",
      companyName: "iShares MSCI USA Value Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vly",
      code: "NYSE:VLY",
      companyName: "Valley National Bancorp",
      popularity: 0,
    },
    {
      slug: "nyse-vlypo",
      code: "NYSE:VLYPO",
      companyName:
        "Valley National Bancorp 5.50% Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Serie",
      popularity: 0,
    },
    {
      slug: "nyse-vlypp",
      code: "NYSE:VLYPP",
      companyName:
        "Valley National Bancorp 6.25% Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Serie",
      popularity: 0,
    },
    {
      slug: "nyse-vmar",
      code: "NYSE:VMAR",
      companyName: "Vision Marine Technologies Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vmat",
      code: "NYSE:VMAT",
      companyName:
        "V-Shares MSCI World ESG Materiality and Carbon Transition ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vmbs",
      code: "NYSE:VMBS",
      companyName: "Vanguard Mortgage-Backed Securities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vmc",
      code: "NYSE:VMC",
      companyName: "Vulcan Materials Company(Holding Company)",
      popularity: 0,
    },
    {
      slug: "nyse-vmca",
      code: "NYSE:VMCA",
      companyName: "Valuence Merger Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vmcau",
      code: "NYSE:VMCAU",
      companyName: "Valuence Merger Corp. I Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vmcaw",
      code: "NYSE:VMCAW",
      companyName: "Valuence Merger Corp. I Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vmd",
      code: "NYSE:VMD",
      companyName: "Viemed Healthcare Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vmeo",
      code: "NYSE:VMEO",
      companyName: "Vimeo Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vmga",
      code: "NYSE:VMGA",
      companyName: "VMG Consumer Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vmgau",
      code: "NYSE:VMGAU",
      companyName: "VMG Consumer Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vmgaw",
      code: "NYSE:VMGAW",
      companyName: "VMG Consumer Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vmi",
      code: "NYSE:VMI",
      companyName: "Valmont Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vmo",
      code: "NYSE:VMO",
      companyName: "Invesco Municipal Opportunity Trust",
      popularity: 0,
    },
    {
      slug: "nyse-vmot",
      code: "NYSE:VMOT",
      companyName: "Alpha Architect Value Momentum Trend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vmw",
      code: "NYSE:VMW",
      companyName: "VMware Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vnce",
      code: "NYSE:VNCE",
      companyName: "VINCE HOLDING CORP.",
      popularity: 0,
    },
    {
      slug: "nyse-vnda",
      code: "NYSE:VNDA",
      companyName: "Vanda Pharmaceuticals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vnet",
      code: "NYSE:VNET",
      companyName: "VNET Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vnla",
      code: "NYSE:VNLA",
      companyName: "Janus Henderson Short Duration Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vnm",
      code: "NYSE:VNM",
      companyName: "VanEck Vietnam ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vnmc",
      code: "NYSE:VNMC",
      companyName: "Natixis Vaughan Nelson Mid Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vno",
      code: "NYSE:VNO",
      companyName: "Vornado Realty Trust",
      popularity: 0,
    },
    {
      slug: "nyse-vno-l",
      code: "NYSE:VNO-L",
      companyName:
        "VORNADO REALTY TRUST 5.40% Series L Cumulative Redeemable Preferred Shares of Beneficial Interest l",
      popularity: 0,
    },
    {
      slug: "nyse-vno-m",
      code: "NYSE:VNO-M",
      companyName:
        "Vornado Realty Trust 5.25% Series M Cumulative Redeemable Preferred Shares of Beneficial Interest l",
      popularity: 0,
    },
    {
      slug: "nyse-vno-n",
      code: "NYSE:VNO-N",
      companyName:
        "Vornado Realty Trust 5.25% Series N Cumulative Redeemable Preferred Shares of Beneficial Interest l",
      popularity: 0,
    },
    {
      slug: "nyse-vno-o",
      code: "NYSE:VNO-O",
      companyName:
        "Vornado Realty Trust 4.45% Series O Cumulative Redeemable Preferred Shares Liquidation Preference $",
      popularity: 0,
    },
    {
      slug: "nyse-vnom",
      code: "NYSE:VNOM",
      companyName: "Viper Energy Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-vnq",
      code: "NYSE:VNQ",
      companyName: "Vanguard Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vnqi",
      code: "NYSE:VNQI",
      companyName: "Vanguard Global ex-U.S. Real Estate ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vnrx",
      code: "NYSE:VNRX",
      companyName: "VolitionRX Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vnse",
      code: "NYSE:VNSE",
      companyName: "Natixis Vaughan Nelson Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vnt",
      code: "NYSE:VNT",
      companyName: "Vontier Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-vntr",
      code: "NYSE:VNTR",
      companyName: "Venator Materials PLC",
      popularity: 0,
    },
    {
      slug: "nyse-vo",
      code: "NYSE:VO",
      companyName: "Vanguard Mid-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-voc",
      code: "NYSE:VOC",
      companyName: "VOC ENERGY TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-vone",
      code: "NYSE:VONE",
      companyName: "Vanguard Russell 1000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vong",
      code: "NYSE:VONG",
      companyName: "Vanguard Russell 1000 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vonv",
      code: "NYSE:VONV",
      companyName: "Vanguard Russell 1000 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vnam",
      code: "NYSE:VNAM",
      companyName: "Global X MSCI Vietnam ETF",
      popularity: 0,
    },
    {
      slug: "nyse-voog",
      code: "NYSE:VOOG",
      companyName: "Vanguard S&P 500 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vor",
      code: "NYSE:VOR",
      companyName: "Vor Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vorb",
      code: "NYSE:VORB",
      companyName: "Virgin Orbit Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vorbw",
      code: "NYSE:VORBW",
      companyName: "Virgin Orbit Holdings Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vot",
      code: "NYSE:VOT",
      companyName: "Vanguard Mid-Cap Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vote",
      code: "NYSE:VOTE",
      companyName: "Engine No. 1 Transform 500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vox",
      code: "NYSE:VOX",
      companyName: "Vanguard Communication Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-voxx",
      code: "NYSE:VOXX",
      companyName: "VOXX International Corporation Class A",
      popularity: 0,
    },
    {
      slug: "nyse-voya",
      code: "NYSE:VOYA",
      companyName: "VOYA FINANCIAL INC.",
      popularity: 0,
    },
    {
      slug: "nyse-voya-b",
      code: "NYSE:VOYA-B",
      companyName:
        "Voya Financial Inc. Depositary Shares each representing a 1/40th interest in a share of 5.35% Fixe",
      popularity: 0,
    },
    {
      slug: "nyse-vpc",
      code: "NYSE:VPC",
      companyName: "Virtus Private Credit Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vpcb",
      code: "NYSE:VPCB",
      companyName: "VPC Impact Acquisition Holdings II Class A ordinary shre",
      popularity: 0,
    },
    {
      slug: "nyse-vpcbu",
      code: "NYSE:VPCBU",
      companyName: "VPC Impact Acquisition Holdings II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vpcbw",
      code: "NYSE:VPCBW",
      companyName: "VPC Impact Acquisition Holdings II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vpg",
      code: "NYSE:VPG",
      companyName: "Vishay Precision Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vpl",
      code: "NYSE:VPL",
      companyName: "Vanguard FTSE Pacific ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vpu",
      code: "NYSE:VPU",
      companyName: "Vanguard Utilities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vpv",
      code: "NYSE:VPV",
      companyName: "Invesco  Pennsylvania Value Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-vqs",
      code: "NYSE:VQS",
      companyName: "VIQ SOLUTIONS INC",
      popularity: 0,
    },
    {
      slug: "nyse-vra",
      code: "NYSE:VRA",
      companyName: "Vera Bradley Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vrai",
      code: "NYSE:VRAI",
      companyName: "Virtus Real Asset Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vrar",
      code: "NYSE:VRAR",
      companyName: "The Glimpse Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vrax",
      code: "NYSE:VRAX",
      companyName: "Virax Biolabs Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vray",
      code: "NYSE:VRAY",
      companyName: "ViewRay Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vrca",
      code: "NYSE:VRCA",
      companyName: "Verrica Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vrdn",
      code: "NYSE:VRDN",
      companyName: "Viridian Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vre",
      code: "NYSE:VRE",
      companyName: "Veris Residential Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vrex",
      code: "NYSE:VREX",
      companyName: "Varex Imaging Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vrig",
      code: "NYSE:VRIG",
      companyName: "Invesco Variable Rate Investment Grade ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vrm",
      code: "NYSE:VRM",
      companyName: "Vroom Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vrme",
      code: "NYSE:VRME",
      companyName: "VerifyMe Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vrmew",
      code: "NYSE:VRMEW",
      companyName: "VerifyMe Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vrna",
      code: "NYSE:VRNA",
      companyName: "Verona Pharma plc",
      popularity: 0,
    },
    {
      slug: "nyse-vrns",
      code: "NYSE:VRNS",
      companyName: "Varonis Systems Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vrnt",
      code: "NYSE:VRNT",
      companyName: "Verint Systems Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vrp",
      code: "NYSE:VRP",
      companyName: "Invesco Variable Rate Preferred ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vrpx",
      code: "NYSE:VRPX",
      companyName: "Virpax Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vrrm",
      code: "NYSE:VRRM",
      companyName: "Verra Mobility Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vrsk",
      code: "NYSE:VRSK",
      companyName: "Verisk Analytics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vrsn",
      code: "NYSE:VRSN",
      companyName: "VeriSign Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vrts",
      code: "NYSE:VRTS",
      companyName: "Virtus Investment Partners Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vrtv",
      code: "NYSE:VRTV",
      companyName: "VERITIV CORPORATION",
      popularity: 0,
    },
    {
      slug: "nyse-vrtx",
      code: "NYSE:VRTX",
      companyName: "Vertex Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vs",
      code: "NYSE:VS",
      companyName: "Versus Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vsac",
      code: "NYSE:VSAC",
      companyName: "Vision Sensing Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vsacu",
      code: "NYSE:VSACU",
      companyName: "Vision Sensing Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vsacw",
      code: "NYSE:VSACW",
      companyName: "Vision Sensing Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-vsat",
      code: "NYSE:VSAT",
      companyName: "Viasat Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vsco",
      code: "NYSE:VSCO",
      companyName: "Victoria's Secret & Co.",
      popularity: 0,
    },
    {
      slug: "nyse-vsda",
      code: "NYSE:VSDA",
      companyName: "VictoryShares Dividend Accelerator ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vsec",
      code: "NYSE:VSEC",
      companyName: "VSE Corp",
      popularity: 0,
    },
    {
      slug: "nyse-vsgx",
      code: "NYSE:VSGX",
      companyName: "Vanguard ESG International Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vsh",
      code: "NYSE:VSH",
      companyName: "Vishay Intertechnology Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vslu",
      code: "NYSE:VSLU",
      companyName: "Applied Finance Valuation Large Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vsmv",
      code: "NYSE:VSMV",
      companyName: "VictoryShares US Multi-Factor Minimum Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vspy",
      code: "NYSE:VSPY",
      companyName: "VectorShares Min Vol ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vss",
      code: "NYSE:VSS",
      companyName: "Vanguard FTSE All-World EX-US Small-Cap Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-vssyw",
      code: "NYSE:VSSYW",
      companyName: "Versus Systems Inc. Class A Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-vst",
      code: "NYSE:VST",
      companyName: "Vistra Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-vstm",
      code: "NYSE:VSTM",
      companyName: "Verastem Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vsto",
      code: "NYSE:VSTO",
      companyName: "Vista Outdoor Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vt",
      code: "NYSE:VT",
      companyName: "Vanguard Total World Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vtaq",
      code: "NYSE:VTAQ",
      companyName: "Ventoux CCM Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vtaqr",
      code: "NYSE:VTAQR",
      companyName: "Ventoux CCM Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-vtaqu",
      code: "NYSE:VTAQU",
      companyName: "Ventoux CCM Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vtaqw",
      code: "NYSE:VTAQW",
      companyName: "Ventoux CCM Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vtc",
      code: "NYSE:VTC",
      companyName: "Vanguard Total Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vteb",
      code: "NYSE:VTEB",
      companyName: "Vanguard Tax-Exempt Bond Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-vtex",
      code: "NYSE:VTEX",
      companyName: "VTEX",
      popularity: 0,
    },
    {
      slug: "nyse-vtgn",
      code: "NYSE:VTGN",
      companyName: "VistaGen Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vthr",
      code: "NYSE:VTHR",
      companyName: "Vanguard Russell 3000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vr",
      code: "NYSE:VR",
      companyName: "Global X Metaverse ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vtip",
      code: "NYSE:VTIP",
      companyName:
        "Vanguard Short-Term Inflation-Protected Securities Index Fund",
      popularity: 0,
    },
    {
      slug: "nyse-vtiq",
      code: "NYSE:VTIQ",
      companyName: "VectoIQ Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vtiqu",
      code: "NYSE:VTIQU",
      companyName: "VectoIQ Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-vtiqw",
      code: "NYSE:VTIQW",
      companyName: "VectoIQ Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-vtn",
      code: "NYSE:VTN",
      companyName: "Invesco  Trust for Investment Grade New York Municipals",
      popularity: 0,
    },
    {
      slug: "nyse-vtnr",
      code: "NYSE:VTNR",
      companyName: "Vertex Energy Inc",
      popularity: 0,
    },
    {
      slug: "nyse-vtol",
      code: "NYSE:VTOL",
      companyName: "Bristow Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vtr",
      code: "NYSE:VTR",
      companyName: "Ventas Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vpn",
      code: "NYSE:VPN",
      companyName: "Global X Data Center REITs & Digital Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vtrs",
      code: "NYSE:VTRS",
      companyName: "Viatris Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vtru",
      code: "NYSE:VTRU",
      companyName: "Vitru Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-vtsi",
      code: "NYSE:VTSI",
      companyName: "VirTra Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vtv",
      code: "NYSE:VTV",
      companyName: "Vanguard Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vtvt",
      code: "NYSE:VTVT",
      companyName: "vTv Therapeutics Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vtwg",
      code: "NYSE:VTWG",
      companyName: "Vanguard Russell 2000 Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vtwo",
      code: "NYSE:VTWO",
      companyName: "Vanguard Russell 2000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vtwv",
      code: "NYSE:VTWV",
      companyName: "Vanguard Russell 2000 Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vtyx",
      code: "NYSE:VTYX",
      companyName: "Ventyx Biosciences Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vug",
      code: "NYSE:VUG",
      companyName: "Vanguard Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vusb",
      code: "NYSE:VUSB",
      companyName: "Vanguard Ultra-Short Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vuse",
      code: "NYSE:VUSE",
      companyName: "Vident Core U.S. Equity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-vuzi",
      code: "NYSE:VUZI",
      companyName: "Vuzix Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-vv",
      code: "NYSE:VV",
      companyName: "Vanguard Large-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vvi",
      code: "NYSE:VVI",
      companyName: "Viad Corp",
      popularity: 0,
    },
    {
      slug: "nyse-vvnt",
      code: "NYSE:VVNT",
      companyName: "Vivint Smart Home Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vvos",
      code: "NYSE:VVOS",
      companyName: "Vivos Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vvpr",
      code: "NYSE:VVPR",
      companyName: "VivoPower International PLC",
      popularity: 0,
    },
    {
      slug: "nyse-vvr",
      code: "NYSE:VVR",
      companyName: "Invesco  Senior Income Trust",
      popularity: 0,
    },
    {
      slug: "nyse-vvv",
      code: "NYSE:VVV",
      companyName: "Valvoline Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vvx",
      code: "NYSE:VVX",
      companyName: "V2X Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-vwe",
      code: "NYSE:VWE",
      companyName: "Vintage Wine Estates Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vweww",
      code: "NYSE:VWEWW",
      companyName: "Vintage Wine Estates Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-vwid",
      code: "NYSE:VWID",
      companyName: "Virtus WMC International Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vwob",
      code: "NYSE:VWOB",
      companyName: "Vanguard Emerging Markets Government Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vxf",
      code: "NYSE:VXF",
      companyName: "Vanguard Extended Market ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vxrt",
      code: "NYSE:VXRT",
      companyName: "Vaxart Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vxus",
      code: "NYSE:VXUS",
      companyName: "Vanguard Total International Stock ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vxx",
      code: "NYSE:VXX",
      companyName: "iPath Series B S&P 500 VIX Short-Term Futures ETN",
      popularity: 0,
    },
    {
      slug: "nyse-vxz",
      code: "NYSE:VXZ",
      companyName: "iPath Series B S&P 500 VIX Mid-Term Futures ETN",
      popularity: 0,
    },
    {
      slug: "nyse-vygg",
      code: "NYSE:VYGG",
      companyName: "Vy Global Growth",
      popularity: 0,
    },
    {
      slug: "nyse-vygr",
      code: "NYSE:VYGR",
      companyName: "Voyager Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vym",
      code: "NYSE:VYM",
      companyName: "Vanguard High Dividend Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vyne",
      code: "NYSE:VYNE",
      companyName: "VYNE Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vynt",
      code: "NYSE:VYNT",
      companyName: "Vyant Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vz",
      code: "NYSE:VZ",
      companyName: "Verizon Communications",
      popularity: 0,
    },
    {
      slug: "nyse-vzio",
      code: "NYSE:VZIO",
      companyName: "VIZIO Holding Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-vzla",
      code: "NYSE:VZLA",
      companyName: "Vizsla Silver Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-w",
      code: "NYSE:W",
      companyName: "Wayfair Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wab",
      code: "NYSE:WAB",
      companyName: "Wabtec Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wabc",
      code: "NYSE:WABC",
      companyName: "Westamerica Bancorporation",
      popularity: 0,
    },
    {
      slug: "nyse-wafd",
      code: "NYSE:WAFD",
      companyName: "Washington Federal Inc",
      popularity: 0,
    },
    {
      slug: "nyse-wafdp",
      code: "NYSE:WAFDP",
      companyName: "Washington Federal Inc. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wafu",
      code: "NYSE:WAFU",
      companyName: "Wah Fu Education Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wald",
      code: "NYSE:WALD",
      companyName: "Waldencast plc Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-want",
      code: "NYSE:WANT",
      companyName: "Direxion Daily Consumer Discretionary Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-warr",
      code: "NYSE:WARR",
      companyName: "Warrior Technologies Acquisition Company",
      popularity: 0,
    },
    {
      slug: "nyse-wash",
      code: "NYSE:WASH",
      companyName: "Washington Trust Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-wat",
      code: "NYSE:WAT",
      companyName: "Waters Corp",
      popularity: 0,
    },
    {
      slug: "nyse-watt",
      code: "NYSE:WATT",
      companyName: "Energous Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-wavc",
      code: "NYSE:WAVC",
      companyName: "Waverley Capital Acquisition Corp. 1",
      popularity: 0,
    },
    {
      slug: "nyse-wavd",
      code: "NYSE:WAVD",
      companyName: "WaveDancer Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wave",
      code: "NYSE:WAVE",
      companyName: "Eco Wave Power Global AB (publ) American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wavs",
      code: "NYSE:WAVS",
      companyName: "Western Acquisition Ventures Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wavsu",
      code: "NYSE:WAVSU",
      companyName: "Western Acquisition Ventures Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-wavsw",
      code: "NYSE:WAVSW",
      companyName: "Western Acquisition Ventures Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-wb",
      code: "NYSE:WB",
      companyName: "Weibo Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-wba",
      code: "NYSE:WBA",
      companyName: "Walgreens Boots Alliance Inc",
      popularity: 0,
    },
    {
      slug: "nyse-wbat",
      code: "NYSE:WBAT",
      companyName: "WisdomTree Battery Value Chain and Innovation Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wbev",
      code: "NYSE:WBEV",
      companyName: "Winc Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wbif",
      code: "NYSE:WBIF",
      companyName: "WBI BullBear Value 3000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wbig",
      code: "NYSE:WBIG",
      companyName: "WBI BullBear Yield 3000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wbii",
      code: "NYSE:WBII",
      companyName: "WBI BullBear Global Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wbil",
      code: "NYSE:WBIL",
      companyName: "WBI BullBear Quality 3000 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wbit",
      code: "NYSE:WBIT",
      companyName: "WBI BullBear Trend Switch US 3000 Total Return ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wbd",
      code: "NYSE:WBD",
      companyName: "Warner Bros. Discovery Inc. Series A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wbiy",
      code: "NYSE:WBIY",
      companyName: "WBI Power FactorTM High Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wbnd",
      code: "NYSE:WBND",
      companyName: "Western Asset Total Return ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wbs",
      code: "NYSE:WBS",
      companyName: "Webster Financial Corporation Waterbury",
      popularity: 0,
    },
    {
      slug: "nyse-wbs-f",
      code: "NYSE:WBS-F",
      companyName:
        "Webster Financial Corporation Depositary Shares Each Representing 1/1000th Interest in a Share of",
      popularity: 0,
    },
    {
      slug: "nyse-wbs-g",
      code: "NYSE:WBS-G",
      companyName:
        "Webster Financial Corporation Depositary Shares each representing a 1/40th interest in a share of 6",
      popularity: 0,
    },
    {
      slug: "nyse-wbx",
      code: "NYSE:WBX",
      companyName: "Wallbox N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-wcbr",
      code: "NYSE:WCBR",
      companyName: "WisdomTree Cybersecurity Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wcc-a",
      code: "NYSE:WCC-A",
      companyName:
        "WESCO International Inc. Depositary Shares each representing 1/1000th interest in a share of Serie",
      popularity: 0,
    },
    {
      slug: "nyse-wcld",
      code: "NYSE:WCLD",
      companyName: "WisdomTree Cloud Computing Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wfc-y",
      code: "NYSE:WFC-Y",
      companyName: "Wells Fargo & Company",
      popularity: 0,
    },
    {
      slug: "nyse-wd",
      code: "NYSE:WD",
      companyName: "Walker & Dunlop Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wdc",
      code: "NYSE:WDC",
      companyName: "Western Digital Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-wdfc",
      code: "NYSE:WDFC",
      companyName: "Wd-40 Co",
      popularity: 0,
    },
    {
      slug: "nyse-wdh",
      code: "NYSE:WDH",
      companyName:
        "Waterdrop Inc. American Depositary Shares (each representing the right to receive 10 Class A Ordinar",
      popularity: 0,
    },
    {
      slug: "nyse-wdi",
      code: "NYSE:WDI",
      companyName: "Western Asset Diversified Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wdiv",
      code: "NYSE:WDIV",
      companyName: "SPDR S&P Global Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wdna",
      code: "NYSE:WDNA",
      companyName: "WisdomTree BioRevolution Fund",
      popularity: 0,
    },
    {
      slug: "nyse-we",
      code: "NYSE:WE",
      companyName: "WeWork Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wea",
      code: "NYSE:WEA",
      companyName: "Western Asset Premier Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-weat",
      code: "NYSE:WEAT",
      companyName: "Teucrium Wheat Fund",
      popularity: 0,
    },
    {
      slug: "nyse-weav",
      code: "NYSE:WEAV",
      companyName: "Weave Communications Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-webl",
      code: "NYSE:WEBL",
      companyName: "Direxion Daily Dow Jones Internet Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-webr",
      code: "NYSE:WEBR",
      companyName: "Weber Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-webs",
      code: "NYSE:WEBS",
      companyName: "Direxion Daily Dow Jones Internet Bear 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wec",
      code: "NYSE:WEC",
      companyName: "WEC Energy Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-weed",
      code: "NYSE:WEED",
      companyName: "Roundhill Cannabis ETF",
      popularity: 0,
    },
    {
      slug: "nyse-weix",
      code: "NYSE:WEIX",
      companyName: "Dynamic Short Short-Term Volatility Futures ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wejo",
      code: "NYSE:WEJO",
      companyName: "Wejo Group Limited Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wejow",
      code: "NYSE:WEJOW",
      companyName: "Wejo Group Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-wel",
      code: "NYSE:WEL",
      companyName: "Integrated Wellness Acquisition Corp",
      popularity: 0,
    },
    {
      slug: "nyse-well",
      code: "NYSE:WELL",
      companyName: "Welltower Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wen",
      code: "NYSE:WEN",
      companyName: "The Wendy's Company",
      popularity: 0,
    },
    {
      slug: "nyse-wern",
      code: "NYSE:WERN",
      companyName: "Werner Enterprises Inc",
      popularity: 0,
    },
    {
      slug: "nyse-wes",
      code: "NYSE:WES",
      companyName: "Western Midstream Partners LP",
      popularity: 0,
    },
    {
      slug: "nyse-wetf",
      code: "NYSE:WETF",
      companyName: "WisdomTree Investments Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wex",
      code: "NYSE:WEX",
      companyName: "WEX Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-weys",
      code: "NYSE:WEYS",
      companyName: "Weyco Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-wf",
      code: "NYSE:WF",
      companyName:
        "Woori Financial Group Inc. American Depositary Shares (each representing three (3) shares of Common",
      popularity: 0,
    },
    {
      slug: "nyse-wfc-a",
      code: "NYSE:WFC-A",
      companyName:
        "Wells Fargo & Company Depositary Shares each representing a 1/1 000th interest in a share of Non-C",
      popularity: 0,
    },
    {
      slug: "nyse-wfc-c",
      code: "NYSE:WFC-C",
      companyName:
        "Wells Fargo & Company Depositary Shares each representing a 1/1 000th interest in a share of Non-C",
      popularity: 0,
    },
    {
      slug: "nyse-wfc-d",
      code: "NYSE:WFC-D",
      companyName:
        "Wells Fargo & Company Depositary Shares each representing a 1/1 000th interest in a share of Non-C",
      popularity: 0,
    },
    {
      slug: "nyse-wfc-l",
      code: "NYSE:WFC-L",
      companyName: "WELLS FARGO 7.5% NON CUMV PERP CONV",
      popularity: 0,
    },
    {
      slug: "nyse-wfc-q",
      code: "NYSE:WFC-Q",
      companyName: "Wells Fargo & Co.",
      popularity: 0,
    },
    {
      slug: "nyse-wfc-r",
      code: "NYSE:WFC-R",
      companyName:
        "WELLS FARGO & COMPANY Depositary Shares each representing a 1/1000th interest in a share of 6.625%",
      popularity: 0,
    },
    {
      slug: "nyse-wfc-z",
      code: "NYSE:WFC-Z",
      companyName:
        "Wells Fargo & Company Depositary Shares each representing a 1/1000th interest in a share of Non-Cu",
      popularity: 0,
    },
    {
      slug: "nyse-wfcf",
      code: "NYSE:WFCF",
      companyName: "Where Food Comes From Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wfh",
      code: "NYSE:WFH",
      companyName: "Direxion Work From Home ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wfhy",
      code: "NYSE:WFHY",
      companyName: "WisdomTree U.S. High Yield Corporate Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wfig",
      code: "NYSE:WFIG",
      companyName: "WisdomTree U.S. Corporate Bond Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wfrd",
      code: "NYSE:WFRD",
      companyName: "Weatherford International plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wgld",
      code: "NYSE:WGLD",
      companyName: "wShares Enhanced Gold ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wgmi",
      code: "NYSE:WGMI",
      companyName: "Valkyrie Bitcoin Miners ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wgo",
      code: "NYSE:WGO",
      companyName: "Winnebago Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wgro",
      code: "NYSE:WGRO",
      companyName: "WisdomTree U.S. Growth & Momentum Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wh",
      code: "NYSE:WH",
      companyName: "Wyndham Hotels & Resorts Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-whd",
      code: "NYSE:WHD",
      companyName: "Cactus Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-whf",
      code: "NYSE:WHF",
      companyName: "WhiteHorse Finance Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wfc",
      code: "NYSE:WFC",
      companyName: "Wells Fargo & Co.",
      popularity: 0,
    },
    {
      slug: "nyse-wcn",
      code: "NYSE:WCN",
      companyName: "Waste Connections Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-whg",
      code: "NYSE:WHG",
      companyName: "WESTWOOD HOLDINGS GROUP INC.",
      popularity: 0,
    },
    {
      slug: "nyse-whlm",
      code: "NYSE:WHLM",
      companyName: "Wilhelmina International Inc",
      popularity: 0,
    },
    {
      slug: "nyse-whlr",
      code: "NYSE:WHLR",
      companyName: "Wheeler Real Estate Investment Trust Inc",
      popularity: 0,
    },
    {
      slug: "nyse-whlrd",
      code: "NYSE:WHLRD",
      companyName:
        "Wheeler Real Estate Investment Trust Inc. Series D Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-whlrl",
      code: "NYSE:WHLRL",
      companyName:
        "Wheeler Real Estate Investment Trust Inc. 7.00% Senior Subordinated Convertible Notes Due 2031",
      popularity: 0,
    },
    {
      slug: "nyse-whlrp",
      code: "NYSE:WHLRP",
      companyName: "Wheeler Real Estate Investment Trust Inc. Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-whr",
      code: "NYSE:WHR",
      companyName: "Whirlpool Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-wia",
      code: "NYSE:WIA",
      companyName: "Western Asset Inflation-Linked Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wil",
      code: "NYSE:WIL",
      companyName: "iPath Women in Leadership ETN",
      popularity: 0,
    },
    {
      slug: "nyse-wilc",
      code: "NYSE:WILC",
      companyName: "G Willi-Food International Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-wimi",
      code: "NYSE:WIMI",
      companyName: "WiMi Hologram Cloud Inc. American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nyse-wina",
      code: "NYSE:WINA",
      companyName: "Winmark Corp",
      popularity: 0,
    },
    {
      slug: "nyse-winc",
      code: "NYSE:WINC",
      companyName: "Western Asset Short Duration Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wing",
      code: "NYSE:WING",
      companyName: "Wingstop Inc",
      popularity: 0,
    },
    {
      slug: "nyse-winn",
      code: "NYSE:WINN",
      companyName: "Harbor Long-Term Growers ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wint",
      code: "NYSE:WINT",
      companyName: "Windtree Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-winv",
      code: "NYSE:WINV",
      companyName: "WinVest Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-winvr",
      code: "NYSE:WINVR",
      companyName: "WinVest Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nyse-winvu",
      code: "NYSE:WINVU",
      companyName: "WinVest Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-winvw",
      code: "NYSE:WINVW",
      companyName: "WinVest Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-wip",
      code: "NYSE:WIP",
      companyName:
        "SPDR FTSE International Government Inflation-Protected Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wire",
      code: "NYSE:WIRE",
      companyName: "Encore Wire Corp",
      popularity: 0,
    },
    {
      slug: "nyse-wisa",
      code: "NYSE:WISA",
      companyName: "WiSA Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wish",
      code: "NYSE:WISH",
      companyName: "ContextLogic Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wit",
      code: "NYSE:WIT",
      companyName: "Wipro Limited",
      popularity: 0,
    },
    {
      slug: "nyse-wiw",
      code: "NYSE:WIW",
      companyName: "Western Asset Inflation-Linked Opportunities & Income Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wix",
      code: "NYSE:WIX",
      companyName: "WIX.com Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-wiz",
      code: "NYSE:WIZ",
      companyName: "Alpha Architect Merlyn.AI Bull-Rider Bear-Fighter ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wk",
      code: "NYSE:WK",
      companyName: "Workiva Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wkey",
      code: "NYSE:WKEY",
      companyName:
        "WISeKey International Holding AG American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wkhs",
      code: "NYSE:WKHS",
      companyName: "Workhorse Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-wkly",
      code: "NYSE:WKLY",
      companyName: "SoFi Weekly Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wkme",
      code: "NYSE:WKME",
      companyName: "WalkMe Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wksp",
      code: "NYSE:WKSP",
      companyName: "Worksport Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wkspw",
      code: "NYSE:WKSPW",
      companyName: "Worksport Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-wldn",
      code: "NYSE:WLDN",
      companyName: "Willdan Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wldr",
      code: "NYSE:WLDR",
      companyName: "Affinity World Leaders Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wlms",
      code: "NYSE:WLMS",
      companyName: "Williams Industrial Services Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wltg",
      code: "NYSE:WLTG",
      companyName: "WealthTrust DBS Long Term Growth ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wlth",
      code: "NYSE:WLTH",
      companyName: "LifeGoal Wealth Builder ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wly",
      code: "NYSE:WLY",
      companyName: "John Wiley & Sons Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-wlyb",
      code: "NYSE:WLYB",
      companyName: "John Wiley & Sons Inc. Class B",
      popularity: 0,
    },
    {
      slug: "nyse-wm",
      code: "NYSE:WM",
      companyName: "Waste Management Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wmb",
      code: "NYSE:WMB",
      companyName: "Williams Companies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wmc",
      code: "NYSE:WMC",
      companyName: "Western Asset Mortgage Capital Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-wmg",
      code: "NYSE:WMG",
      companyName: "Warner Music Group Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wmk",
      code: "NYSE:WMK",
      companyName: "Weis Markets Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wmpn",
      code: "NYSE:WMPN",
      companyName: "William Penn Bancorporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wms",
      code: "NYSE:WMS",
      companyName: "ADVANCED DRAINAGE SYSTEMS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-wndy",
      code: "NYSE:WNDY",
      companyName: "Global X Wind Energy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wnc",
      code: "NYSE:WNC",
      companyName: "Wabash National Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-wneb",
      code: "NYSE:WNEB",
      companyName: "Western New England Bancorp Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wnnr",
      code: "NYSE:WNNR",
      companyName: "Andretti Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-wns",
      code: "NYSE:WNS",
      companyName: "WNS Holdings Limited",
      popularity: 0,
    },
    {
      slug: "nyse-wnw",
      code: "NYSE:WNW",
      companyName: "Meiwu Technology Company Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wolf",
      code: "NYSE:WOLF",
      companyName: "Wolfspeed Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-womn",
      code: "NYSE:WOMN",
      companyName: "Impact Shares YWCA Women's Empowerment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wood",
      code: "NYSE:WOOD",
      companyName: "iShares Global Timber & Forestry ETF",
      popularity: 0,
    },
    {
      slug: "nyse-woof",
      code: "NYSE:WOOF",
      companyName:
        "Petco Health and Wellness Company Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wor",
      code: "NYSE:WOR",
      companyName: "WORTHINGTON INDUSTRIES INC. COMMON SHARES",
      popularity: 0,
    },
    {
      slug: "nyse-worx",
      code: "NYSE:WORX",
      companyName: "SC WORX Corp",
      popularity: 0,
    },
    {
      slug: "nyse-wpc",
      code: "NYSE:WPC",
      companyName: "W.P. Carey Inc. (REIT)",
      popularity: 0,
    },
    {
      slug: "nyse-wpca",
      code: "NYSE:WPCA",
      companyName: "Warburg Pincus Capital Corporation I-A",
      popularity: 0,
    },
    {
      slug: "nyse-wpcb",
      code: "NYSE:WPCB",
      companyName: "Warburg Pincus Capital Corporation I-B",
      popularity: 0,
    },
    {
      slug: "nyse-wow",
      code: "NYSE:WOW",
      companyName: "WideOpenWest Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wpp",
      code: "NYSE:WPP",
      companyName: "WPP PLC",
      popularity: 0,
    },
    {
      slug: "nyse-wprt",
      code: "NYSE:WPRT",
      companyName: "Westport Fuel Systems Inc Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wps",
      code: "NYSE:WPS",
      companyName: "iShares International Developed Property ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wqga",
      code: "NYSE:WQGA",
      companyName: "World Quantum Growth Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-wrac",
      code: "NYSE:WRAC",
      companyName: "Williams Rowland Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-wrap",
      code: "NYSE:WRAP",
      companyName: "Wrap Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wrb",
      code: "NYSE:WRB",
      companyName: "W.R. Berkley Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-wrb-e",
      code: "NYSE:WRB-E",
      companyName:
        "W.R. Berkley Corporation 5.70% Subordinated Debentures due 2058",
      popularity: 0,
    },
    {
      slug: "nyse-wrb-f",
      code: "NYSE:WRB-F",
      companyName:
        "W.R. Berkley Corporation 5.10% Subordinated Debentures due 2059",
      popularity: 0,
    },
    {
      slug: "nyse-wrb-g",
      code: "NYSE:WRB-G",
      companyName:
        "W.R. Berkley Corporation 4.25% Subordinated Debentures due 2060",
      popularity: 0,
    },
    {
      slug: "nyse-wrb-h",
      code: "NYSE:WRB-H",
      companyName:
        "W.R. Berkley Corporation 4.125% Subordinated Debentures due 2061",
      popularity: 0,
    },
    {
      slug: "nyse-wrby",
      code: "NYSE:WRBY",
      companyName: "Warby Parker Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wre",
      code: "NYSE:WRE",
      companyName: "Washington Real Estate Investment Trust",
      popularity: 0,
    },
    {
      slug: "nyse-wrk",
      code: "NYSE:WRK",
      companyName: "WestRock Company",
      popularity: 0,
    },
    {
      slug: "nyse-wrld",
      code: "NYSE:WRLD",
      companyName: "World Acceptance Corp",
      popularity: 0,
    },
    {
      slug: "nyse-wrn",
      code: "NYSE:WRN",
      companyName: "Western Copper and Gold Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-wrnd",
      code: "NYSE:WRND",
      companyName: "IQ Global Equity R&D Leaders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wsbc",
      code: "NYSE:WSBC",
      companyName: "WesBanco Inc",
      popularity: 0,
    },
    {
      slug: "nyse-wsbcp",
      code: "NYSE:WSBCP",
      companyName:
        "WesBanco Inc. Depositary Shares Each Representing a 1/40th Interest in a Share of 6.75% Fixed-Rate",
      popularity: 0,
    },
    {
      slug: "nyse-wsbf",
      code: "NYSE:WSBF",
      companyName: "Waterstone Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wsc",
      code: "NYSE:WSC",
      companyName: "WillScot Mobile Mini Holdings Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wsfs",
      code: "NYSE:WSFS",
      companyName: "WSFS Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-wsm",
      code: "NYSE:WSM",
      companyName: "Williams-Sonoma Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wso",
      code: "NYSE:WSO",
      companyName: "Watsco Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wsr",
      code: "NYSE:WSR",
      companyName: "Whitestone REIT",
      popularity: 0,
    },
    {
      slug: "nyse-wst",
      code: "NYSE:WST",
      companyName: "West Pharmaceutical Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wstg",
      code: "NYSE:WSTG",
      companyName: "Wayside Technology Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wtai",
      code: "NYSE:WTAI",
      companyName: "WisdomTree Artificial Intelligence and Innovation Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wtba",
      code: "NYSE:WTBA",
      companyName: "West Bancorporation",
      popularity: 0,
    },
    {
      slug: "nyse-wter",
      code: "NYSE:WTER",
      companyName: "The Alkaline Water Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wtfc",
      code: "NYSE:WTFC",
      companyName: "Wintrust Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-wtfcm",
      code: "NYSE:WTFCM",
      companyName:
        "Wintrust Financial Corporation Fixed-to-Floating Rate Non-Cumulative Perpetual Preferred Stock Seri",
      popularity: 0,
    },
    {
      slug: "nyse-wtfcp",
      code: "NYSE:WTFCP",
      companyName:
        "Wintrust Financial Corporation Depositary Shares Each Representing a 1/1000th Interest in a Share",
      popularity: 0,
    },
    {
      slug: "nyse-wtm",
      code: "NYSE:WTM",
      companyName: "White Mountains Insurance Group Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-wtma",
      code: "NYSE:WTMA",
      companyName: "Welsbach Technology Metals Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wtmar",
      code: "NYSE:WTMAR",
      companyName:
        "Welsbach Technology Metals Acquisition Corp. one right to receive 1/10th of a share of common stock",
      popularity: 0,
    },
    {
      slug: "nyse-wtmau",
      code: "NYSE:WTMAU",
      companyName: "Welsbach Technology Metals Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-wtmf",
      code: "NYSE:WTMF",
      companyName: "WisdomTree Managed Futures Strategy Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wtre",
      code: "NYSE:WTRE",
      companyName: "WisdomTree New Economy Real Estate Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wtrg",
      code: "NYSE:WTRG",
      companyName: "Essential Utilities Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wtrh",
      code: "NYSE:WTRH",
      companyName: "Waitr Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wts",
      code: "NYSE:WTS",
      companyName: "Watts Water Technologies Inc. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-wtt",
      code: "NYSE:WTT",
      companyName: "Wireless Telecom Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wttr",
      code: "NYSE:WTTR",
      companyName: "Select Energy Services Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wtv",
      code: "NYSE:WTV",
      companyName: "WisdomTree U.S. Value Fund",
      popularity: 0,
    },
    {
      slug: "nyse-wtw",
      code: "NYSE:WTW",
      companyName:
        "Willis Towers Watson Public Limited Company Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wu",
      code: "NYSE:WU",
      companyName: "The Western Union Company",
      popularity: 0,
    },
    {
      slug: "nyse-wugi",
      code: "NYSE:WUGI",
      companyName: "Esoterica NextG Economy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wulf",
      code: "NYSE:WULF",
      companyName: "TeraWulf Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wve",
      code: "NYSE:WVE",
      companyName: "Wave Life Sciences Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wvvi",
      code: "NYSE:WVVI",
      companyName: "Willamette Valley Vineyards",
      popularity: 0,
    },
    {
      slug: "nyse-wvvip",
      code: "NYSE:WVVIP",
      companyName:
        "Willamette Valley Vineyards Inc. Series A Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wwac",
      code: "NYSE:WWAC",
      companyName: "Worldwide Webb Acquisition Corp. Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-wwacu",
      code: "NYSE:WWACU",
      companyName: "Worldwide Webb Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-wwacw",
      code: "NYSE:WWACW",
      companyName: "Worldwide Webb Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-wwd",
      code: "NYSE:WWD",
      companyName: "Woodward Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wwe",
      code: "NYSE:WWE",
      companyName: "World Wrestling Entertainment",
      popularity: 0,
    },
    {
      slug: "nyse-wwjd",
      code: "NYSE:WWJD",
      companyName: "Inspire International ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wwow",
      code: "NYSE:WWOW",
      companyName: "Direxion World Without Waste ETF",
      popularity: 0,
    },
    {
      slug: "nyse-wwr",
      code: "NYSE:WWR",
      companyName: "Westwater Resources Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-www",
      code: "NYSE:WWW",
      companyName: "Wolverine World Wide Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-wynn",
      code: "NYSE:WYNN",
      companyName: "Wynn Resorts Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-wyy",
      code: "NYSE:WYY",
      companyName: "WidePoint Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-x",
      code: "NYSE:X",
      companyName: "United States Steel Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-xair",
      code: "NYSE:XAIR",
      companyName: "Beyond Air Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xar",
      code: "NYSE:XAR",
      companyName: "SPDR S&P Aerospace & Defense ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xb",
      code: "NYSE:XB",
      companyName: "BondBloxx B-Rated USD High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xbap",
      code: "NYSE:XBAP",
      companyName: "Innovator U.S. Equity Accelerated 9 Buffer ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-xbb",
      code: "NYSE:XBB",
      companyName: "BondBloxx BB-Rated USD High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xbi",
      code: "NYSE:XBI",
      companyName: "SPDR S&P Biotech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xbio",
      code: "NYSE:XBIO",
      companyName: "Xenetic Biosciences Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-xbiow",
      code: "NYSE:XBIOW",
      companyName: "Xenetic Biosciences Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-xbit",
      code: "NYSE:XBIT",
      companyName: "XBiotech Inc",
      popularity: 0,
    },
    {
      slug: "nyse-xbja",
      code: "NYSE:XBJA",
      companyName: "Innovator U.S. Equity Accelerated 9 Buffer ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-xbjl",
      code: "NYSE:XBJL",
      companyName: "Innovator U.S. Equity Accelerated 9 Buffer ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-xboc",
      code: "NYSE:XBOC",
      companyName: "Innovator U.S. Equity Accelerated 9 Buffer ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-xbtf",
      code: "NYSE:XBTF",
      companyName: "VanEck Bitcoin Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xccc",
      code: "NYSE:XCCC",
      companyName: "BondBloxx CCC-Rated USD High Yield Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xcem",
      code: "NYSE:XCEM",
      companyName: "Columbia EM Core ex-China ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xcur",
      code: "NYSE:XCUR",
      companyName: "Exicure Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xdap",
      code: "NYSE:XDAP",
      companyName: "Innovator U.S. Equity Accelerated ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-xdat",
      code: "NYSE:XDAT",
      companyName: "Franklin Exponential Data ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xdec",
      code: "NYSE:XDEC",
      companyName:
        "FT Cboe Vest U.S. Equity Enhance & Moderate Buffer ETF - December",
      popularity: 0,
    },
    {
      slug: "nyse-xdja",
      code: "NYSE:XDJA",
      companyName: "Innovator U.S. Equity Accelerated ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-xdjl",
      code: "NYSE:XDJL",
      companyName: "Innovator U.S. Equity Accelerated ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-xdna",
      code: "NYSE:XDNA",
      companyName: "Strategic CRISPR & Gene Editing Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xdoc",
      code: "NYSE:XDOC",
      companyName: "Innovator U.S. Equity Accelerated ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-xdqq",
      code: "NYSE:XDQQ",
      companyName: "Innovator Growth Accelerated ETF - Quarterly",
      popularity: 0,
    },
    {
      slug: "nyse-xdsq",
      code: "NYSE:XDSQ",
      companyName: "Innovator U.S. Equity Accelerated ETF - Quarterly",
      popularity: 0,
    },
    {
      slug: "nyse-xel",
      code: "NYSE:XEL",
      companyName: "Xcel Energy Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-xelap",
      code: "NYSE:XELAP",
      companyName:
        "Exela Technologies Inc. 6.00% Series B Cumulative Convertible Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xemd",
      code: "NYSE:XEMD",
      companyName:
        "BondBloxx JP Morgan USD Emerging Markets 1-10 Year Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xene",
      code: "NYSE:XENE",
      companyName: "Xenon Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-xers",
      code: "NYSE:XERS",
      companyName: "Xeris Biopharma Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xes",
      code: "NYSE:XES",
      companyName: "SPDR S&P Oil & Gas  Equipment & Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xfin",
      code: "NYSE:XFIN",
      companyName: "ExcelFin Acquisition Corp Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xfinu",
      code: "NYSE:XFINU",
      companyName: "ExcelFin Acquisition Corp Unit",
      popularity: 0,
    },
    {
      slug: "nyse-xfinw",
      code: "NYSE:XFINW",
      companyName: "ExcelFin Acquisition Corp Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-xflt",
      code: "NYSE:XFLT",
      companyName:
        "XAI Octagon Floating Rate & Alternative Income Term Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-xflt-a",
      code: "NYSE:XFLT-A",
      companyName:
        "XAI Octagon Floating Rate & Alternative Income Term Trust 6.50% Series 2026 Term Preferred Shares (",
      popularity: 0,
    },
    {
      slug: "nyse-xfor",
      code: "NYSE:XFOR",
      companyName: "X4 Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xgn",
      code: "NYSE:XGN",
      companyName: "Exagen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xhb",
      code: "NYSE:XHB",
      companyName: "SPDR S&P Homebuilders ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xhe",
      code: "NYSE:XHE",
      companyName: "SPDR S&P Health Care Equipment ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xhr",
      code: "NYSE:XHR",
      companyName: "Xenia Hotels & Resorts Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-xhs",
      code: "NYSE:XHS",
      companyName: "SPDR S&P Health Care Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xhyc",
      code: "NYSE:XHYC",
      companyName:
        "BondBloxx USD High Yield Bond Consumer Cyclicals Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xhyd",
      code: "NYSE:XHYD",
      companyName:
        "BondBloxx USD High Yield Bond Consumer Non-Cyclicals Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xhye",
      code: "NYSE:XHYE",
      companyName: "BondBloxx USD High Yield Bond Energy Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xhyf",
      code: "NYSE:XHYF",
      companyName: "BondBloxx USD High Yield Bond Financial & REIT Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xhyh",
      code: "NYSE:XHYH",
      companyName: "BondBloxx USD High Yield Bond Healthcare Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xhyi",
      code: "NYSE:XHYI",
      companyName: "BondBloxx USD High Yield Bond Industrial Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xhyt",
      code: "NYSE:XHYT",
      companyName:
        "BondBloxx USD High Yield Bond Telecom Media & Technology Sector ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xin",
      code: "NYSE:XIN",
      companyName: "Xinyuan Real Estate Co. LTD",
      popularity: 0,
    },
    {
      slug: "nyse-xitk",
      code: "NYSE:XITK",
      companyName: "SPDR FactSet Innovative Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xjh",
      code: "NYSE:XJH",
      companyName: "iShares ESG Screened S&P Mid-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xjr",
      code: "NYSE:XJR",
      companyName: "iShares ESG Screened S&P Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xjun",
      code: "NYSE:XJUN",
      companyName:
        "FT Cboe Vest U.S. Equity Enhance & Moderate Buffer ETF - June",
      popularity: 0,
    },
    {
      slug: "nyse-xl",
      code: "NYSE:XL",
      companyName: "XL Fleet Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-xlb",
      code: "NYSE:XLB",
      companyName: "Materials Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xlc",
      code: "NYSE:XLC",
      companyName: "The Communication Services Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xle",
      code: "NYSE:XLE",
      companyName: "Energy Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xlf",
      code: "NYSE:XLF",
      companyName: "Financial Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xlg",
      code: "NYSE:XLG",
      companyName: "Invesco S&P 500 Top 50 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xli",
      code: "NYSE:XLI",
      companyName: "Industrial Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xlk",
      code: "NYSE:XLK",
      companyName: "Technology Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xlo",
      code: "NYSE:XLO",
      companyName: "Xilio Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xlp",
      code: "NYSE:XLP",
      companyName: "Consumers Staples Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xlre",
      code: "NYSE:XLRE",
      companyName: "Real Estate Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xlsr",
      code: "NYSE:XLSR",
      companyName: "SPDR SSGA US Sector Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xlu",
      code: "NYSE:XLU",
      companyName: "Utilities Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xlv",
      code: "NYSE:XLV",
      companyName: "Health Care Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xly",
      code: "NYSE:XLY",
      companyName: "Consumer Discretionary Select Sector SPDR Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xm",
      code: "NYSE:XM",
      companyName: "Qualtrics International Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xme",
      code: "NYSE:XME",
      companyName: "SPDR S&P Metals & Mining ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xmhq",
      code: "NYSE:XMHQ",
      companyName: "Invesco S&P MidCap Quality ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xmlv",
      code: "NYSE:XMLV",
      companyName: "Invesco S&P MidCap Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xmmo",
      code: "NYSE:XMMO",
      companyName: "Invesco S&P MidCap Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xmpt",
      code: "NYSE:XMPT",
      companyName: "VanEck CEF Muni Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xmtr",
      code: "NYSE:XMTR",
      companyName: "Xometry Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xmvm",
      code: "NYSE:XMVM",
      companyName: "Invesco S&P MidCap Value with Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xncr",
      code: "NYSE:XNCR",
      companyName: "Xencor Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-xnet",
      code: "NYSE:XNET",
      companyName: "Xunlei Limited",
      popularity: 0,
    },
    {
      slug: "nyse-xntk",
      code: "NYSE:XNTK",
      companyName: "SPDR NYSE Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xoma",
      code: "NYSE:XOMA",
      companyName: "XOMA Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-xomao",
      code: "NYSE:XOMAO",
      companyName:
        "XOMA Corporation Depositary Shares Rep Series B 8.375% Cumulative Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xomap",
      code: "NYSE:XOMAP",
      companyName:
        "XOMA Corporation 8.625% Series A Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xos",
      code: "NYSE:XOS",
      companyName: "Xos Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xosww",
      code: "NYSE:XOSWW",
      companyName: "Xos Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-xp",
      code: "NYSE:XP",
      companyName: "XP Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xpax",
      code: "NYSE:XPAX",
      companyName: "XPAC Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-xpaxu",
      code: "NYSE:XPAXU",
      companyName: "XPAC Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-xpaxw",
      code: "NYSE:XPAXW",
      companyName: "XPAC Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-xpdb",
      code: "NYSE:XPDB",
      companyName:
        "Power & Digital Infrastructure Acquisition II Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xpdbu",
      code: "NYSE:XPDBU",
      companyName: "Power & Digital Infrastructure Acquisition II Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-xpdbw",
      code: "NYSE:XPDBW",
      companyName:
        "Power & Digital Infrastructure Acquisition II Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-xpel",
      code: "NYSE:XPEL",
      companyName: "XPEL Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xper",
      code: "NYSE:XPER",
      companyName: "Xperi Holding Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xph",
      code: "NYSE:XPH",
      companyName: "SPDR S&P Pharmaceuticals ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xpl",
      code: "NYSE:XPL",
      companyName: "Solitario Zinc Corp",
      popularity: 0,
    },
    {
      slug: "nyse-xpnd",
      code: "NYSE:XPND",
      companyName: "First Trust Expanded Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xpo",
      code: "NYSE:XPO",
      companyName: "XPO LOGISTICS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-xpof",
      code: "NYSE:XPOF",
      companyName: "Xponential Fitness Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-xpon",
      code: "NYSE:XPON",
      companyName: "Expion360 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xpp",
      code: "NYSE:XPP",
      companyName: "ProShares Ultra FTSE China 50 of PROSHARES TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-xpro",
      code: "NYSE:XPRO",
      companyName: "Expro Group Holdings N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-xray",
      code: "NYSE:XRAY",
      companyName: "DENTSPLY SIRONA Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-xrlv",
      code: "NYSE:XRLV",
      companyName: "Invesco S&P 500 ex-Rate Sensitive Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xrt",
      code: "NYSE:XRT",
      companyName: "SPDR S&P Retail ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xrtx",
      code: "NYSE:XRTX",
      companyName: "XORTX Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xrx",
      code: "NYSE:XRX",
      companyName: "Xerox Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xop",
      code: "NYSE:XOP",
      companyName: "SPDR S&P Oil & Gas Exploration & Production ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xshd",
      code: "NYSE:XSHD",
      companyName: "Invesco S&P SmallCap High Dividend Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xshq",
      code: "NYSE:XSHQ",
      companyName: "Invesco S&P SmallCap Quality ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xslv",
      code: "NYSE:XSLV",
      companyName: "Invesco S&P SmallCap Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xsmo",
      code: "NYSE:XSMO",
      companyName: "Invesco S&P SmallCap Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xsoe",
      code: "NYSE:XSOE",
      companyName:
        "WisdomTree Emerging Markets ex-State-Owned Enterprises Fund",
      popularity: 0,
    },
    {
      slug: "nyse-xspa",
      code: "NYSE:XSPA",
      companyName: "XpresSpa Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xsvm",
      code: "NYSE:XSVM",
      companyName: "Invesco S&P SmallCap Value with Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xsw",
      code: "NYSE:XSW",
      companyName: "SPDR S&P Software & Services ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xt",
      code: "NYSE:XT",
      companyName: "iShares Exponential Technologies ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xtap",
      code: "NYSE:XTAP",
      companyName: "Innovator U.S. Equity Accelerated Plus ETF - April",
      popularity: 0,
    },
    {
      slug: "nyse-xtja",
      code: "NYSE:XTJA",
      companyName: "Innovator U.S. Equity Accelerated Plus ETF - January",
      popularity: 0,
    },
    {
      slug: "nyse-xtjl",
      code: "NYSE:XTJL",
      companyName: "Innovator U.S. Equity Accelerated Plus ETF - July",
      popularity: 0,
    },
    {
      slug: "nyse-xtl",
      code: "NYSE:XTL",
      companyName: "SPDR S&P Telecom ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xtlb",
      code: "NYSE:XTLB",
      companyName: "XTL Biopharmaceuticals Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-xrmi",
      code: "NYSE:XRMI",
      companyName: "Global X S&P 500 Risk Managed Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xtn",
      code: "NYSE:XTN",
      companyName: "SPDR S&P Transportation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xtnt",
      code: "NYSE:XTNT",
      companyName: "Xtant Medical Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-xtoc",
      code: "NYSE:XTOC",
      companyName: "Innovator U.S. Equity Accelerated Plus ETF - October",
      popularity: 0,
    },
    {
      slug: "nyse-xusp",
      code: "NYSE:XUSP",
      companyName: "Innovator Uncapped Accelerated U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xvol",
      code: "NYSE:XVOL",
      companyName: "Acruence Active Hedge U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xvv",
      code: "NYSE:XVV",
      companyName: "iShares ESG Screened S&P 500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xweb",
      code: "NYSE:XWEB",
      companyName: "SPDR S&P Internet ETF",
      popularity: 0,
    },
    {
      slug: "nyse-xxii",
      code: "NYSE:XXII",
      companyName: "22nd Century Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-xyf",
      code: "NYSE:XYF",
      companyName:
        "X Financial American Depositary Shares each representing six Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-xyl",
      code: "NYSE:XYL",
      companyName: "Xylem Inc",
      popularity: 0,
    },
    {
      slug: "nyse-xtr",
      code: "NYSE:XTR",
      companyName: "Global X S&P 500 Tail Risk ETF",
      popularity: 0,
    },
    {
      slug: "nyse-y",
      code: "NYSE:Y",
      companyName: "Alleghany Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-yala",
      code: "NYSE:YALA",
      companyName:
        "Yalla Group Limited American Depositary Shares each representing one Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-yang",
      code: "NYSE:YANG",
      companyName: "Direxion Daily FTSE  China Bear 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ycbd",
      code: "NYSE:YCBD",
      companyName: "cbdMD Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ycbd-a",
      code: "NYSE:YCBD-A",
      companyName:
        "cbdMD Inc. 8.0% Series A Cumulative Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ycl",
      code: "NYSE:YCL",
      companyName: "ProShares Ultra Yen",
      popularity: 0,
    },
    {
      slug: "nyse-ycs",
      code: "NYSE:YCS",
      companyName: "ProShares UltraShort Yen",
      popularity: 0,
    },
    {
      slug: "nyse-ydec",
      code: "NYSE:YDEC",
      companyName: "FT Cboe Vest International Equity Buffer ETF - December",
      popularity: 0,
    },
    {
      slug: "nyse-yell",
      code: "NYSE:YELL",
      companyName: "Yellow Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-yelp",
      code: "NYSE:YELP",
      companyName: "YELP INC.",
      popularity: 0,
    },
    {
      slug: "nyse-yext",
      code: "NYSE:YEXT",
      companyName: "Yext Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ygmz",
      code: "NYSE:YGMZ",
      companyName: "MingZhu Logistics Holdings Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-yi",
      code: "NYSE:YI",
      companyName: "111 Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-yinn",
      code: "NYSE:YINN",
      companyName: "Direxion Daily FTSE  China Bull 3X Shares",
      popularity: 0,
    },
    {
      slug: "nyse-yj",
      code: "NYSE:YJ",
      companyName: "Yunji Inc. American Depository Shares",
      popularity: 0,
    },
    {
      slug: "nyse-yjun",
      code: "NYSE:YJUN",
      companyName: "FT Cboe Vest International Equity Buffer ETF - June",
      popularity: 0,
    },
    {
      slug: "nyse-yld",
      code: "NYSE:YLD",
      companyName: "Principal Active High Yield ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ylde",
      code: "NYSE:YLDE",
      companyName: "ClearBridge Dividend Strategy ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ymab",
      code: "NYSE:YMAB",
      companyName: "Y-mAbs Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ymar",
      code: "NYSE:YMAR",
      companyName: "FT Cboe Vest International Equity Buffer ETF - March",
      popularity: 0,
    },
    {
      slug: "nyse-ymm",
      code: "NYSE:YMM",
      companyName:
        "Full Truck Alliance Co. Ltd. American Depositary Shares (each representing 20 Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-ymtx",
      code: "NYSE:YMTX",
      companyName: "Yumanity Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-yndx",
      code: "NYSE:YNDX",
      companyName: "Yandex N.V. Class A",
      popularity: 0,
    },
    {
      slug: "nyse-yolo",
      code: "NYSE:YOLO",
      companyName: "AdvisorShares Pure Cannabis ETF",
      popularity: 0,
    },
    {
      slug: "nyse-yorw",
      code: "NYSE:YORW",
      companyName: "York Water Co",
      popularity: 0,
    },
    {
      slug: "nyse-yota",
      code: "NYSE:YOTA",
      companyName: "Yotta Acquisition Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-yotar",
      code: "NYSE:YOTAR",
      companyName: "Yotta Acquisition Corporation Right",
      popularity: 0,
    },
    {
      slug: "nyse-yotau",
      code: "NYSE:YOTAU",
      companyName: "Yotta Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nyse-yotaw",
      code: "NYSE:YOTAW",
      companyName: "Yotta Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-you",
      code: "NYSE:YOU",
      companyName: "Clear Secure Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ypf",
      code: "NYSE:YPF",
      companyName: "YPF Sociedad Anonima",
      popularity: 0,
    },
    {
      slug: "nyse-yps",
      code: "NYSE:YPS",
      companyName: "Arrow Reverse Cap 500 ETF",
      popularity: 0,
    },
    {
      slug: "nyse-yq",
      code: "NYSE:YQ",
      companyName:
        "17 Education & Technology Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-yrd",
      code: "NYSE:YRD",
      companyName: "Yiren Digital Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-ysep",
      code: "NYSE:YSEP",
      companyName: "FT Cboe Vest International Equity Buffer ETF - September",
      popularity: 0,
    },
    {
      slug: "nyse-ysg",
      code: "NYSE:YSG",
      companyName:
        "Yatsen Holding Limited American Depositary Shares each representing four Class A ordinary shares",
      popularity: 0,
    },
    {
      slug: "nyse-yten",
      code: "NYSE:YTEN",
      companyName: "Yield10 Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ytpg",
      code: "NYSE:YTPG",
      companyName: "TPG Pace Beneficial II Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ytra",
      code: "NYSE:YTRA",
      companyName: "Yatra Online Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-yum",
      code: "NYSE:YUM",
      companyName: "Yum! Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-yumc",
      code: "NYSE:YUMC",
      companyName: "Yum China Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-yumy",
      code: "NYSE:YUMY",
      companyName: "VanEck Future of Food ETF",
      popularity: 0,
    },
    {
      slug: "nyse-yvr",
      code: "NYSE:YVR",
      companyName: "Liquid Media Group Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nyse-yxi",
      code: "NYSE:YXI",
      companyName: "ProShares Short FTSE China 50 of PROSHARES TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-yy",
      code: "NYSE:YY",
      companyName: "JOYY Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-yyy",
      code: "NYSE:YYY",
      companyName: "Amplify High Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-z",
      code: "NYSE:Z",
      companyName: "Zillow Group Inc. Class C Capital Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zbh",
      code: "NYSE:ZBH",
      companyName: "Zimmer Biomet Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-zcmd",
      code: "NYSE:ZCMD",
      companyName: "Zhongchao Inc. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-zd",
      code: "NYSE:ZD",
      companyName: "Ziff Davis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zdge",
      code: "NYSE:ZDGE",
      companyName: "Zedge Inc.",
      popularity: 0,
    },
    {
      slug: "asx-ddd",
      code: "ASX:DDD",
      companyName: "3D RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ari",
      code: "ASX:ARI",
      companyName: "A.C.N. 004 410 833 LIMITED",
      popularity: 16000,
    },
    {
      slug: "nasdaq-abt",
      code: "NASDAQ:ABT",
      companyName: "Abbott Laboratories Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ajc",
      code: "ASX:AJC",
      companyName: "ACACIA COAL LIMITED",
      popularity: 29000,
    },
    {
      slug: "asx-5gn",
      code: "ASX:5GN",
      companyName: "5G NETWORKS LIMITED",
      popularity: 702000,
    },
    {
      slug: "asx-14d",
      code: "ASX:14D",
      companyName: "1414 Degrees Ltd",
      popularity: 85000,
    },
    {
      slug: "asx-abt",
      code: "ASX:ABT",
      companyName: "ABUNDANT PRODUCE LIMITED",
      popularity: 18000,
    },
    {
      slug: "asx-1st",
      code: "ASX:1ST",
      companyName: "1ST Group Ltd",
      popularity: 29000,
    },
    {
      slug: "asx-4ds",
      code: "ASX:4DS",
      companyName: "4DS Memory Ltd",
      popularity: 183000,
    },
    {
      slug: "asx-nnw",
      code: "ASX:NNW",
      companyName: "99 WUXIAN LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-akg",
      code: "ASX:AKG",
      companyName: "Academies Australasia Group Ltd",
      popularity: 20000,
    },
    {
      slug: "asx-8ih",
      code: "ASX:8IH",
      companyName: "8I Holdings Ltd",
      popularity: 18000,
    },
    {
      slug: "asx-8vi",
      code: "ASX:8VI",
      companyName: "8VI Holdings Ltd",
      popularity: 21000,
    },
    {
      slug: "asx-acb",
      code: "ASX:ACB",
      companyName: "A-Cap Energy Ltd",
      popularity: 44000,
    },
    {
      slug: "asx-t3d",
      code: "ASX:T3D",
      companyName: "333D Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-oxy",
      code: "NYSE:OXY",
      companyName: "Occidental Petroleum Corporation",
      popularity: 0,
    },
    {
      slug: "asx-tgp",
      code: "ASX:TGP",
      companyName: "360 Capital Group",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpwr",
      code: "NASDAQ:MPWR",
      companyName: "Monolithic Power Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ayi",
      code: "ASX:AYI",
      companyName: "A1 Investments & Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tdo",
      code: "ASX:TDO",
      companyName: "3D Energi Ltd",
      popularity: 0,
    },
    {
      slug: "asx-abl",
      code: "ASX:ABL",
      companyName: "ABILENE OIL AND GAS LIMITED",
      popularity: 22000,
    },
    {
      slug: "asx-tot",
      code: "ASX:TOT",
      companyName: "360 Capital REIT",
      popularity: 0,
    },
    {
      slug: "nyse-hubs",
      code: "NYSE:HUBS",
      companyName: "HUBSPOT INC.",
      popularity: 0,
    },
    {
      slug: "asx-moq",
      code: "ASX:MOQ",
      companyName: "MOQ LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-aeg",
      code: "ASX:AEG",
      companyName: "ABSOLUTE EQUITY PERFORMANCE FUND LIMITED",
      popularity: 25000,
    },
    {
      slug: "asx-pat",
      code: "ASX:PAT",
      companyName: "Patriot Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-dhr",
      code: "NYSE:DHR",
      companyName: "Danaher Corporation",
      popularity: 0,
    },
    {
      slug: "asx-9sp",
      code: "ASX:9SP",
      companyName: "9 SPOKES INTERNATIONAL LIMITED",
      popularity: 57000,
    },
    {
      slug: "nyse-zeal",
      code: "NYSE:ZEAL",
      companyName: "Zealand Pharma A/S American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "asx-ont",
      code: "ASX:ONT",
      companyName: "1300 SMILES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-8co",
      code: "ASX:8CO",
      companyName: "8COMMON Ltd",
      popularity: 26000,
    },
    {
      slug: "asx-abp",
      code: "ASX:ABP",
      companyName: "Abacus Property Group",
      popularity: 183000,
    },
    {
      slug: "nyse-zecp",
      code: "NYSE:ZECP",
      companyName: "Zacks Earnings Consistent Portfolio ETF",
      popularity: 0,
    },
    {
      slug: "nyse-zen",
      code: "NYSE:ZEN",
      companyName: "ZENDESK INC",
      popularity: 0,
    },
    {
      slug: "nasdaq-masi",
      code: "NASDAQ:MASI",
      companyName: "Masimo Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-8ec",
      code: "ASX:8EC",
      companyName: "8IP EMERGING COMPANIES LIMITED",
      popularity: 33000,
    },
    {
      slug: "nyse-zenv",
      code: "NYSE:ZENV",
      companyName: "Zenvia Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bbwi",
      code: "NYSE:BBWI",
      companyName: "Bath & Body Works Inc.",
      popularity: 0,
    },
    {
      slug: "asx-88e",
      code: "ASX:88E",
      companyName: "88 Energy Ltd",
      popularity: 351000,
    },
    {
      slug: "nyse-zepp",
      code: "NYSE:ZEPP",
      companyName: "Zepp Health Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-zest",
      code: "NYSE:ZEST",
      companyName: "Ecoark Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zeta",
      code: "NYSE:ZETA",
      companyName: "Zeta Global Holdings Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-zeus",
      code: "NYSE:ZEUS",
      companyName: "Olympic Steel Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-zev",
      code: "NYSE:ZEV",
      companyName: "Lightning eMotors Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-zfox",
      code: "NYSE:ZFOX",
      companyName: "ZeroFox Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zfoxw",
      code: "NYSE:ZFOXW",
      companyName: "ZeroFox Holdings Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "asx-3pl",
      code: "ASX:3PL",
      companyName: "3P Learning Ltd",
      popularity: 53000,
    },
    {
      slug: "nasdaq-khc",
      code: "NASDAQ:KHC",
      companyName: "The Kraft Heinz Company Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-agj",
      code: "ASX:AGJ",
      companyName: "AGRICULTURAL LAND TRUST",
      popularity: 65000,
    },
    {
      slug: "asx-acr",
      code: "ASX:ACR",
      companyName: "ACRUX Ltd",
      popularity: 52000,
    },
    {
      slug: "asx-abc",
      code: "ASX:ABC",
      companyName: "Adbri Ltd",
      popularity: 282000,
    },
    {
      slug: "asx-adj",
      code: "ASX:ADJ",
      companyName: "ADSLOT LTD",
      popularity: 31000,
    },
    {
      slug: "asx-srg",
      code: "ASX:SRG",
      companyName: "SRG Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ada",
      code: "ASX:ADA",
      companyName: "Adacel Technologies Ltd",
      popularity: 61000,
    },
    {
      slug: "asx-aeb",
      code: "ASX:AEB",
      companyName: "AFFINITY ENERGY AND HEALTH LIMITED",
      popularity: 25000,
    },
    {
      slug: "asx-ahz",
      code: "ASX:AHZ",
      companyName: "ADMEDUS LTD",
      popularity: 52000,
    },
    {
      slug: "nyse-anf",
      code: "NYSE:ANF",
      companyName: "Abercrombie & Fitch Co.",
      popularity: 0,
    },
    {
      slug: "asx-a1c",
      code: "ASX:A1C",
      companyName: "AIC RESOURCES LIMITED",
      popularity: 25000,
    },
    {
      slug: "asx-ady",
      code: "ASX:ADY",
      companyName: "Admiralty Resources NL",
      popularity: 33000,
    },
    {
      slug: "nyse-lin",
      code: "NYSE:LIN",
      companyName: "Linde plc Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-zg",
      code: "NYSE:ZG",
      companyName: "ZILLOW GROUP INC CLASS A",
      popularity: 0,
    },
    {
      slug: "asx-aft",
      code: "ASX:AFT",
      companyName: "AFT CORPORATION LIMITED",
      popularity: 20000,
    },
    {
      slug: "asx-acw",
      code: "ASX:ACW",
      companyName: "Actinogen Medical Ltd",
      popularity: 71000,
    },
    {
      slug: "nyse-zgen",
      code: "NYSE:ZGEN",
      companyName: "The Generation Z ETF",
      popularity: 0,
    },
    {
      slug: "asx-aqg",
      code: "ASX:AQG",
      companyName: "ALACER GOLD CORP.",
      popularity: 111000,
    },
    {
      slug: "asx-aau",
      code: "ASX:AAU",
      companyName: "Antilles Gold Ltd",
      popularity: 39000,
    },
    {
      slug: "nyse-zgn",
      code: "NYSE:ZGN",
      companyName: "Ermenegildo Zegna N.V.",
      popularity: 0,
    },
    {
      slug: "nyse-zh",
      code: "NYSE:ZH",
      companyName:
        "Zhihu Inc. American Depositary Shares (every two of each representing one Class A ordinary share)",
      popularity: 0,
    },
    {
      slug: "nyse-zhdg",
      code: "NYSE:ZHDG",
      companyName: "Zega Buy & Hedge ETF",
      popularity: 0,
    },
    {
      slug: "nyse-zi",
      code: "NYSE:ZI",
      companyName: "ZoomInfo Technologies Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zig",
      code: "NYSE:ZIG",
      companyName: "The Acquirers Fund",
      popularity: 0,
    },
    {
      slug: "nyse-zts",
      code: "NYSE:ZTS",
      companyName: "ZOETIS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-zim",
      code: "NYSE:ZIM",
      companyName: "ZIM Integrated Shipping Services Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-zimv",
      code: "NYSE:ZIMV",
      companyName: "ZimVie Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-acf",
      code: "ASX:ACF",
      companyName: "Acrow Ltd",
      popularity: 74000,
    },
    {
      slug: "nyse-zing",
      code: "NYSE:ZING",
      companyName: "FTAC Zeus Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zingu",
      code: "NYSE:ZINGU",
      companyName: "FTAC Zeus Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "asx-adr",
      code: "ASX:ADR",
      companyName: "Adherium Ltd",
      popularity: 23000,
    },
    {
      slug: "nyse-zingw",
      code: "NYSE:ZINGW",
      companyName: "FTAC Zeus Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-zion",
      code: "NYSE:ZION",
      companyName: "Zions Bancorporation N.A.",
      popularity: 0,
    },
    {
      slug: "nyse-zionl",
      code: "NYSE:ZIONL",
      companyName:
        "Zions Bancorporation N.A. 6.95% Fixed-to-Floating Rate Subordinated Notes due September 15 2028",
      popularity: 0,
    },
    {
      slug: "asx-aiv",
      code: "ASX:AIV",
      companyName: "Activex Ltd",
      popularity: 19000,
    },
    {
      slug: "asx-add",
      code: "ASX:ADD",
      companyName: "Adavale Resources Ltd",
      popularity: 22000,
    },
    {
      slug: "asx-adt",
      code: "ASX:ADT",
      companyName: "Adriatic Metals Plc",
      popularity: 106000,
    },
    {
      slug: "nyse-ztaqw",
      code: "NYSE:ZTAQW",
      companyName: "Zimmer Energy Transition Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-ztek",
      code: "NYSE:ZTEK",
      companyName: "Zentek Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zto",
      code: "NYSE:ZTO",
      companyName:
        "ZTO Express (Cayman) Inc. American Depositary Shares each representing one Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "asx-1ad",
      code: "ASX:1AD",
      companyName: "Adalta Ltd",
      popularity: 31000,
    },
    {
      slug: "asx-afr",
      code: "ASX:AFR",
      companyName: "AFRICAN ENERGY RESOURCES LIMITED",
      popularity: 27000,
    },
    {
      slug: "nyse-ztr",
      code: "NYSE:ZTR",
      companyName: "Virtus Total Return Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-zumz",
      code: "NYSE:ZUMZ",
      companyName: "Zumiez Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-zuo",
      code: "NYSE:ZUO",
      companyName: "Zuora Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-zvia",
      code: "NYSE:ZVIA",
      companyName: "Zevia PBC",
      popularity: 0,
    },
    {
      slug: "nyse-zvo",
      code: "NYSE:ZVO",
      companyName: "Zovio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-apt",
      code: "ASX:APT",
      companyName: "AFTERPAY LIMITED",
      popularity: 3259000,
    },
    {
      slug: "asx-ama",
      code: "ASX:AMA",
      companyName: "AMA Group Ltd",
      popularity: 117000,
    },
    {
      slug: "asx-atx",
      code: "ASX:ATX",
      companyName: "Amplia Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aqx",
      code: "ASX:AQX",
      companyName: "Alice QUEEN Ltd",
      popularity: 66000,
    },
    {
      slug: "asx-dug",
      code: "ASX:DUG",
      companyName: "DUG Technology Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ahq",
      code: "ASX:AHQ",
      companyName: "Allegiance Coal Ltd",
      popularity: 25000,
    },
    {
      slug: "asx-ajm",
      code: "ASX:AJM",
      companyName: "ALTURA MINING LIMITED",
      popularity: 171000,
    },
    {
      slug: "asx-aqi",
      code: "ASX:AQI",
      companyName: "Alicanto Minerals Ltd",
      popularity: 33000,
    },
    {
      slug: "asx-aqz",
      code: "ASX:AQZ",
      companyName: "Alliance Aviation Services Ltd",
      popularity: 139000,
    },
    {
      slug: "asx-ame",
      code: "ASX:AME",
      companyName: "Alto Metals Ltd",
      popularity: 37000,
    },
    {
      slug: "asx-ato",
      code: "ASX:ATO",
      companyName: "ALTOSTRATOS HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-amh",
      code: "ASX:AMH",
      companyName: "Amcil Ltd",
      popularity: 69000,
    },
    {
      slug: "asx-amo",
      code: "ASX:AMO",
      companyName: "Ambertech Ltd",
      popularity: 33000,
    },
    {
      slug: "asx-a40",
      code: "ASX:A40",
      companyName: "ALITA RESOURCES LIMITED",
      popularity: 20000,
    },
    {
      slug: "asx-amb",
      code: "ASX:AMB",
      companyName: "AMBITION GROUP LIMITED",
      popularity: 19000,
    },
    {
      slug: "asx-abr",
      code: "ASX:ABR",
      companyName: "AMERICAN PACIFIC BORATES LIMITED",
      popularity: 67000,
    },
    {
      slug: "asx-ayr",
      code: "ASX:AYR",
      companyName: "ALLOY RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-arn",
      code: "ASX:ARN",
      companyName: "Aldoro Resources Ltd",
      popularity: 37000,
    },
    {
      slug: "asx-alk",
      code: "ASX:ALK",
      companyName: "Alkane Resources Ltd",
      popularity: 422000,
    },
    {
      slug: "asx-ars",
      code: "ASX:ARS",
      companyName: "ALT RESOURCES LIMITED",
      popularity: 18000,
    },
    {
      slug: "asx-amt",
      code: "ASX:AMT",
      companyName: "Allegra Medical Technologies Ltd",
      popularity: 26000,
    },
    {
      slug: "asx-ays",
      code: "ASX:AYS",
      companyName: "AMAYSIM AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-mcd",
      code: "NYSE:MCD",
      companyName: "McDonald's Corporation",
      popularity: 0,
    },
    {
      slug: "asx-aly",
      code: "ASX:ALY",
      companyName: "Alchemy Resources Ltd",
      popularity: 46000,
    },
    {
      slug: "nyse-ko",
      code: "NYSE:KO",
      companyName: "Coca-Cola Company",
      popularity: 0,
    },
    {
      slug: "asx-anl",
      code: "ASX:ANL",
      companyName: "Amani Gold Ltd",
      popularity: 91000,
    },
    {
      slug: "asx-lep",
      code: "ASX:LEP",
      companyName: "ALE PROPERTY GROUP",
      popularity: 0,
    },
    {
      slug: "asx-ajx",
      code: "ASX:AJX",
      companyName: "Alexium International Group Ltd",
      popularity: 65000,
    },
    {
      slug: "asx-ags",
      code: "ASX:AGS",
      companyName: "ALLIANCE RESOURCES LIMITED",
      popularity: 23000,
    },
    {
      slug: "asx-aow",
      code: "ASX:AOW",
      companyName: "AMERICAN PATRIOT OIL & GAS LIMITED",
      popularity: 34000,
    },
    {
      slug: "asx-alc",
      code: "ASX:ALC",
      companyName: "Alcidion Group Ltd",
      popularity: 284000,
    },
    {
      slug: "nyse-zwrk",
      code: "NYSE:ZWRK",
      companyName: "Z-Work Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zwrku",
      code: "NYSE:ZWRKU",
      companyName: "Z-Work Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-hpe",
      code: "NASDAQ:HPE",
      companyName: "Hewlett Packard Enterprise Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zwrkw",
      code: "NYSE:ZWRKW",
      companyName: "Z-Work Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "asx-al8",
      code: "ASX:AL8",
      companyName: "Alderan Resources Ltd",
      popularity: 24000,
    },
    {
      slug: "nyse-dg",
      code: "NYSE:DG",
      companyName: "Dollar General Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-zws",
      code: "NYSE:ZWS",
      companyName: "Zurn Elkay Water Solutions Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-zy",
      code: "NYSE:ZY",
      companyName: "Zymergen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zyme",
      code: "NYSE:ZYME",
      companyName: "Zymeworks Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-zyne",
      code: "NYSE:ZYNE",
      companyName: "Zynerba Pharmaceuticals Inc",
      popularity: 0,
    },
    {
      slug: "nyse-zyxi",
      code: "NYSE:ZYXI",
      companyName: "ZYNEX INC",
      popularity: 0,
    },
    {
      slug: "asx-anq",
      code: "ASX:ANQ",
      companyName: "ANAECO LIMITED",
      popularity: 21000,
    },
    {
      slug: "asx-alt",
      code: "ASX:ALT",
      companyName: "Analytica Ltd",
      popularity: 24000,
    },
    {
      slug: "asx-anr",
      code: "ASX:ANR",
      companyName: "Anatara Lifesciences Ltd",
      popularity: 18000,
    },
    {
      slug: "nasdaq-jpm",
      code: "NASDAQ:JPM",
      companyName: "JP Morgan Chase & Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ter",
      code: "NASDAQ:TER",
      companyName: "Teradyne Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zbra",
      code: "NASDAQ:ZBRA",
      companyName: "Zebra Technologies Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-jatdd",
      code: "ASX:JATDD",
      companyName: "Jatcorp Ltd",
      popularity: 0,
    },
    {
      slug: "asx-apd",
      code: "ASX:APD",
      companyName: "APN PROPERTY GROUP",
      popularity: 91000,
    },
    {
      slug: "asx-nxmn",
      code: "ASX:NXMN",
      companyName: "Nexus Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-atm",
      code: "ASX:ATM",
      companyName: "Aneka Tambang (Persero) TBK (PT)",
      popularity: 0,
    },
    {
      slug: "asx-anp",
      code: "ASX:ANP",
      companyName: "Antisense Therapeutics Ltd",
      popularity: 80000,
    },
    {
      slug: "nyse-asml",
      code: "NYSE:ASML",
      companyName: "ASML Holding NV",
      popularity: 0,
    },
    {
      slug: "asx-ab1",
      code: "ASX:AB1",
      companyName: "ABARTA RESOURCES LIMITED",
      popularity: 21000,
    },
    {
      slug: "asx-adn",
      code: "ASX:ADN",
      companyName: "Andromeda Metals Ltd",
      popularity: 232000,
    },
    {
      slug: "asx-aar",
      code: "ASX:AAR",
      companyName: "Astral Resources NL",
      popularity: 74000,
    },
    {
      slug: "nasdaq-vbf",
      code: "NASDAQ:VBF",
      companyName: "Invesco Bond Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-as1",
      code: "ASX:AS1",
      companyName: "ANGEL SEAFOOD HOLDINGS LTD",
      popularity: 50000,
    },
    {
      slug: "nasdaq-mmm",
      code: "NASDAQ:MMM",
      companyName: "3M Company Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-bap",
      code: "ASX:BAP",
      companyName: "Bapcor Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aoj",
      code: "ASX:AOJ",
      companyName: "APOLLO SERIES 2010-1 TRUST",
      popularity: 18000,
    },
    {
      slug: "asx-ahr",
      code: "ASX:AHR",
      companyName: "ANCHOR RESOURCES LIMITED",
      popularity: 19000,
    },
    {
      slug: "asx-ado",
      code: "ASX:ADO",
      companyName: "Anteotech Ltd",
      popularity: 116000,
    },
    {
      slug: "asx-asn",
      code: "ASX:ASN",
      companyName: "Anson Resources Ltd",
      popularity: 85000,
    },
    {
      slug: "asx-vmt",
      code: "ASX:VMT",
      companyName: "Vmoto Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iusg",
      code: "ASX:IUSG",
      companyName: "Ishares U.S. Treasury Bond (Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "nasdaq-dxcm",
      code: "NASDAQ:DXCM",
      companyName: "DexCom Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ahx",
      code: "ASX:AHX",
      companyName: "Apiam Animal Health Ltd",
      popularity: 25000,
    },
    {
      slug: "asx-adi",
      code: "ASX:ADI",
      companyName: "DEXUS INDUSTRIA REIT",
      popularity: 194000,
    },
    {
      slug: "nyse-fnd",
      code: "NYSE:FND",
      companyName: "Floor & Decor Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "asx-aop",
      code: "ASX:AOP",
      companyName: "APOLLO CONSOLIDATED LIMITED",
      popularity: 42000,
    },
    {
      slug: "asx-rmc",
      code: "ASX:RMC",
      companyName: "Resimac Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pvh",
      code: "NYSE:PVH",
      companyName: "PVH Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-vlo",
      code: "NYSE:VLO",
      companyName: "Valero Energy Corporation",
      popularity: 0,
    },
    {
      slug: "asx-azy",
      code: "ASX:AZY",
      companyName: "Antipa Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-med",
      code: "NYSE:MED",
      companyName: "Medifast Inc.",
      popularity: 0,
    },
    {
      slug: "asx-aqr",
      code: "ASX:AQR",
      companyName: "APN CONVENIENCE RETAIL REIT",
      popularity: 64000,
    },
    {
      slug: "asx-apl",
      code: "ASX:APL",
      companyName: "Associate Global Partners Ltd",
      popularity: 98000,
    },
    {
      slug: "nyse-adbe",
      code: "NYSE:ADBE",
      companyName: "Adobe Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-onon",
      code: "NYSE:ONON",
      companyName: "On Holding AG",
      popularity: 0,
    },
    {
      slug: "asx-aon",
      code: "ASX:AON",
      companyName: "Apollo Minerals Ltd",
      popularity: 47000,
    },
    {
      slug: "nyse-hd",
      code: "NYSE:HD",
      companyName: "Home Depot Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-lulu",
      code: "NASDAQ:LULU",
      companyName: "lululemon athletica inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-awv",
      code: "ASX:AWV",
      companyName: "ANOVA METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-agg",
      code: "ASX:AGG",
      companyName: "ANGLOGOLD ASHANTI LIMITED",
      popularity: 145000,
    },
    {
      slug: "asx-areda",
      code: "ASX:AREDA",
      companyName: "Argonaut Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-aqm",
      code: "ASX:AQM",
      companyName: "ANGLO AMERICAN CAPITAL PLC",
      popularity: 37000,
    },
    {
      slug: "asx-asp",
      code: "ASX:ASP",
      companyName: "Aspermont Ltd",
      popularity: 19000,
    },
    {
      slug: "asx-avc",
      code: "ASX:AVC",
      companyName: "Auctus Investment Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ajy",
      code: "ASX:AJY",
      companyName: "Asaplus Resources Ltd",
      popularity: 16000,
    },
    {
      slug: "nyse-aemb",
      code: "NYSE:AEMB",
      companyName: "American Century Emerging Markets Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-ahk",
      code: "ASX:AHK",
      companyName: "Ark Mines Ltd",
      popularity: 33000,
    },
    {
      slug: "asx-agy",
      code: "ASX:AGY",
      companyName: "Argosy Minerals Ltd",
      popularity: 202000,
    },
    {
      slug: "asx-amd",
      code: "ASX:AMD",
      companyName: "Arrow Minerals Ltd",
      popularity: 53000,
    },
    {
      slug: "asx-arq",
      code: "ASX:ARQ",
      companyName: "ARQ GROUP LIMITED",
      popularity: 19000,
    },
    {
      slug: "asx-atb",
      code: "ASX:ATB",
      companyName: "ASIAN DEVELOPMENT BANK",
      popularity: 0,
    },
    {
      slug: "asx-axt",
      code: "ASX:AXT",
      companyName: "ARGO EXPLORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-snap",
      code: "NYSE:SNAP",
      companyName: "Snap Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-urbn",
      code: "NASDAQ:URBN",
      companyName: "Urban Outfitters Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-acp",
      code: "ASX:ACP",
      companyName: "Audalia Resources Ltd",
      popularity: 19000,
    },
    {
      slug: "nyse-syk",
      code: "NYSE:SYK",
      companyName: "Stryker Corporation",
      popularity: 0,
    },
    {
      slug: "asx-ali",
      code: "ASX:ALI",
      companyName: "Argo Global Listed Infrastructure Ltd",
      popularity: 360000,
    },
    {
      slug: "asx-ajq",
      code: "ASX:AJQ",
      companyName: "Armour Energy Ltd",
      popularity: 37000,
    },
    {
      slug: "asx-air",
      code: "ASX:AIR",
      companyName: "ASTIVITA LIMITED",
      popularity: 18000,
    },
    {
      slug: "asx-aia",
      code: "ASX:AIA",
      companyName: "Auckland International Airport Ltd",
      popularity: 678000,
    },
    {
      slug: "asx-awn",
      code: "ASX:AWN",
      companyName: "AWN HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ard",
      code: "ASX:ARD",
      companyName: "Argent Minerals Ltd",
      popularity: 52000,
    },
    {
      slug: "asx-ao1",
      code: "ASX:AO1",
      companyName: "Assetowl Ltd",
      popularity: 19000,
    },
    {
      slug: "asx-ash",
      code: "ASX:ASH",
      companyName: "Ashley Services Group Ltd",
      popularity: 34000,
    },
    {
      slug: "asx-tpg",
      code: "ASX:TPG",
      companyName: "TPG Telecom Ltd",
      popularity: 0,
    },
    {
      slug: "asx-afa",
      code: "ASX:AFA",
      companyName: "Asf Group Ltd",
      popularity: 19000,
    },
    {
      slug: "asx-ajj",
      code: "ASX:AJJ",
      companyName: "Asian American Medical Group Ltd",
      popularity: 30000,
    },
    {
      slug: "asx-are",
      code: "ASX:ARE",
      companyName: "Argonaut Resources NL",
      popularity: 49000,
    },
    {
      slug: "asx-aro",
      code: "ASX:ARO",
      companyName: "ASTRO RESOURCES NL",
      popularity: 43000,
    },
    {
      slug: "asx-lfs",
      code: "ASX:LFS",
      companyName: "Latitude Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lfg",
      code: "ASX:LFG",
      companyName: "Liberty Financial Group",
      popularity: 0,
    },
    {
      slug: "asx-ahy",
      code: "ASX:AHY",
      companyName: "ASALEO CARE LIMITED",
      popularity: 38000,
    },
    {
      slug: "asx-akm",
      code: "ASX:AKM",
      companyName: "Aspire Mining Ltd",
      popularity: 36000,
    },
    {
      slug: "asx-ppm",
      code: "ASX:PPM",
      companyName: "Pepper Money Ltd",
      popularity: 0,
    },
    {
      slug: "asx-azs",
      code: "ASX:AZS",
      companyName: "AZURE Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aaj",
      code: "ASX:AAJ",
      companyName: "Aruma Resources Ltd",
      popularity: 31000,
    },
    {
      slug: "nasdaq-mp",
      code: "NASDAQ:MP",
      companyName: "MP Materials Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-akp",
      code: "ASX:AKP",
      companyName: "Audio Pixels Holdings Ltd",
      popularity: 37000,
    },
    {
      slug: "asx-ara",
      code: "ASX:ARA",
      companyName: "Ariadne Australia Ltd",
      popularity: 38000,
    },
    {
      slug: "asx-apz",
      code: "ASX:APZ",
      companyName: "Aspen Group",
      popularity: 175000,
    },
    {
      slug: "asx-arv",
      code: "ASX:ARV",
      companyName: "Artemis Resources Ltd",
      popularity: 102000,
    },
    {
      slug: "asx-aac",
      code: "ASX:AAC",
      companyName: "Australian Agricultural Company Ltd",
      popularity: 338000,
    },
    {
      slug: "nyse-intu",
      code: "NYSE:INTU",
      companyName: "Intuit Inc",
      popularity: 0,
    },
    {
      slug: "asx-a3d",
      code: "ASX:A3D",
      companyName: "Aurora Labs Ltd",
      popularity: 58000,
    },
    {
      slug: "asx-aok",
      code: "ASX:AOK",
      companyName: "AUSTEX OIL LIMITED",
      popularity: 22000,
    },
    {
      slug: "asx-apg",
      code: "ASX:APG",
      companyName: "AUSTPAC RESOURCES NL",
      popularity: 26000,
    },
    {
      slug: "asx-aap",
      code: "ASX:AAP",
      companyName: "Australian Agricultural Projects Ltd",
      popularity: 82000,
    },
    {
      slug: "asx-aqd",
      code: "ASX:AQD",
      companyName: "Ausquest Ltd",
      popularity: 22000,
    },
    {
      slug: "asx-abx",
      code: "ASX:ABX",
      companyName: "ABX Group Ltd",
      popularity: 41000,
    },
    {
      slug: "asx-gud",
      code: "ASX:GUD",
      companyName: "G.U.D. Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xcl",
      code: "ASX:XCL",
      companyName: "AUSTRALIAN COMMONWEALTH GOVERNMENT LOANS",
      popularity: 0,
    },
    {
      slug: "asx-aoa",
      code: "ASX:AOA",
      companyName: "Ausmon Resources Ltd",
      popularity: 26000,
    },
    {
      slug: "asx-amg",
      code: "ASX:AMG",
      companyName: "ASHBY MINING LIMITED",
      popularity: 48000,
    },
    {
      slug: "asx-aup",
      code: "ASX:AUP",
      companyName: "AURORA PROPERTY BUY-WRITE INCOME TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ast",
      code: "ASX:AST",
      companyName: "AUSNET SERVICES LIMITED",
      popularity: 262000,
    },
    {
      slug: "asx-aib",
      code: "ASX:AIB",
      companyName: "Aurora Global Income Trust",
      popularity: 29000,
    },
    {
      slug: "asx-auh",
      code: "ASX:AUH",
      companyName: "Austchina Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ac8",
      code: "ASX:AC8",
      companyName: "Auscann Group Holdings Ltd",
      popularity: 164000,
    },
    {
      slug: "asx-aym",
      code: "ASX:AYM",
      companyName: "Australia United Mining Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-emhy",
      code: "NYSE:EMHY",
      companyName: "iShares J.P. Morgan EM High Yield Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-agd",
      code: "ASX:AGD",
      companyName: "Austral Gold Ltd",
      popularity: 133000,
    },
    {
      slug: "asx-anw",
      code: "ASX:ANW",
      companyName: "AUS TIN MINING LTD",
      popularity: 66000,
    },
    {
      slug: "asx-aou",
      code: "ASX:AOU",
      companyName: "AUROCH MINERALS LTD",
      popularity: 67000,
    },
    {
      slug: "asx-svw",
      code: "ASX:SVW",
      companyName: "Seven Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-agm",
      code: "ASX:AGM",
      companyName: "AUSTRALIAN GOVERNANCE & ETHICAL INDEX FUND",
      popularity: 87000,
    },
    {
      slug: "asx-arm",
      code: "ASX:ARM",
      companyName: "AURORA MINERALS LIMITED",
      popularity: 123000,
    },
    {
      slug: "asx-14dn",
      code: "ASX:14DN",
      companyName: "1414 Degrees Ltd",
      popularity: 0,
    },
    {
      slug: "asx-suhn",
      code: "ASX:SUHN",
      companyName: "Southern Hemisphere Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-asl",
      code: "ASX:ASL",
      companyName: "AUSDRILL LIMITED",
      popularity: 107000,
    },
    {
      slug: "nasdaq-nvt",
      code: "NASDAQ:NVT",
      companyName: "nVent Electric plc Ordinary Shares ",
      popularity: 0,
    },
    {
      slug: "asx-anv",
      code: "ASX:ANV",
      companyName: "AUSNET SERVICES HOLDINGS PTY LTD",
      popularity: 73000,
    },
    {
      slug: "nasdaq-sgml",
      code: "NASDAQ:SGML",
      companyName: "Sigma Lithium Corporation Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-apo",
      code: "NASDAQ:APO",
      companyName: "Apollo Global Management Inc. (New) Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-asb",
      code: "ASX:ASB",
      companyName: "Austal Ltd",
      popularity: 369000,
    },
    {
      slug: "asx-auc",
      code: "ASX:AUC",
      companyName: "Ausgold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-abw",
      code: "ASX:ABW",
      companyName: "AURORA ABSOLUTE RETURN FUND",
      popularity: 22000,
    },
    {
      slug: "asx-fl1",
      code: "ASX:FL1",
      companyName: "First Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-span",
      code: "ASX:SPAN",
      companyName: "Spacetalk Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aul",
      code: "ASX:AUL",
      companyName: "AUSTAR GOLD LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-teck",
      code: "NYSE:TECK",
      companyName: "Teck Resources Limited",
      popularity: 0,
    },
    {
      slug: "asx-ahf",
      code: "ASX:AHF",
      companyName: "Australian Dairy Nutritionals Ltd",
      popularity: 72000,
    },
    {
      slug: "asx-ayf",
      code: "ASX:AYF",
      companyName: "AUSTRALIAN ENHANCED INCOME FUND",
      popularity: 0,
    },
    {
      slug: "asx-avh",
      code: "ASX:AVH",
      companyName: "Avita Medical Inc",
      popularity: 0,
    },
    {
      slug: "asx-axl",
      code: "ASX:AXL",
      companyName: "A.C.N. 603 323 182 LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-aut",
      code: "ASX:AUT",
      companyName: "Auteco Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-awy",
      code: "ASX:AWY",
      companyName: "AUSTRALIAN WHISKY HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ava",
      code: "ASX:AVA",
      companyName: "AVA Risk Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-avl",
      code: "ASX:AVL",
      companyName: "Australian Vanadium Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-beam",
      code: "NYSE:BEAM",
      companyName: "Beam Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-avj",
      code: "ASX:AVJ",
      companyName: "Avjennings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ayu",
      code: "ASX:AYU",
      companyName: "AUSTRALIAN UNITY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-aog",
      code: "ASX:AOG",
      companyName: "AVEO GROUP",
      popularity: 38000,
    },
    {
      slug: "asx-aui",
      code: "ASX:AUI",
      companyName: "Australian United Investment Company Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-wms",
      code: "NASDAQ:WMS",
      companyName: "Advanced Drainage Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ans",
      code: "ASX:ANS",
      companyName: "AUSTSINO RESOURCES GROUP LIMITED",
      popularity: 22000,
    },
    {
      slug: "asx-avg",
      code: "ASX:AVG",
      companyName: "Australian Vintage Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ats",
      code: "ASX:ATS",
      companyName: "Australis Oil & Gas Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-fwona",
      code: "NYSE:FWONA",
      companyName:
        "Liberty Media Corporation Series A Liberty Formula One Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-asg",
      code: "ASX:ASG",
      companyName: "Autosports Group Ltd",
      popularity: 47000,
    },
    {
      slug: "asx-aev",
      code: "ASX:AEV",
      companyName: "Avenira Ltd",
      popularity: 28000,
    },
    {
      slug: "nyse-aph",
      code: "NYSE:APH",
      companyName: "Amphenol Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-chx",
      code: "NYSE:CHX",
      companyName: "ChampionX Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-slb",
      code: "NYSE:SLB",
      companyName: "Schlumberger Limited",
      popularity: 0,
    },
    {
      slug: "nyse-wcc",
      code: "NYSE:WCC",
      companyName: "Wesco International Inc.",
      popularity: 0,
    },
    {
      slug: "asx-aiy",
      code: "ASX:AIY",
      companyName: "AUTHORISED INVESTMENT FUND LIMITED",
      popularity: 21000,
    },
    {
      slug: "asx-avw",
      code: "ASX:AVW",
      companyName: "Avira Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aof",
      code: "ASX:AOF",
      companyName: "Australian Unity Office Fund",
      popularity: 51000,
    },
    {
      slug: "asx-arc",
      code: "ASX:ARC",
      companyName: "ARC Funds Ltd",
      popularity: 61000,
    },
    {
      slug: "nyse-ford",
      code: "NYSE:FORD",
      companyName: "Forward Industries Inc-N Y",
      popularity: 0,
    },
    {
      slug: "asx-ahg",
      code: "ASX:AHG",
      companyName: "AUTOMOTIVE HOLDINGS GROUP LIMITED.",
      popularity: 53000,
    },
    {
      slug: "asx-axi",
      code: "ASX:AXI",
      companyName: "Axiom Properties Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-sndr",
      code: "NYSE:SNDR",
      companyName: "Schneider National Inc.",
      popularity: 0,
    },
    {
      slug: "asx-avn",
      code: "ASX:AVN",
      companyName: "AVENTUS GROUP",
      popularity: 0,
    },
    {
      slug: "asx-avq",
      code: "ASX:AVQ",
      companyName: "AXIOM MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-axs",
      code: "ASX:AXS",
      companyName: "AXS GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ayg",
      code: "ASX:AYG",
      companyName: "AXXIS TECHNOLOGY GROUP LTD",
      popularity: 0,
    },
    {
      slug: "asx-azm",
      code: "ASX:AZM",
      companyName: "AZUMAH RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-azt",
      code: "ASX:AZT",
      companyName: "AZURE HEALTH TECHNOLOGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bal",
      code: "ASX:BAL",
      companyName: "BELLAMY'S AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-intc",
      code: "NYSE:INTC",
      companyName: "Intel Corp",
      popularity: 0,
    },
    {
      slug: "asx-sek",
      code: "ASX:SEK",
      companyName: "Seek Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bgl",
      code: "ASX:BGL",
      companyName: "Bellevue Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bth",
      code: "ASX:BTH",
      companyName: "Bigtincan Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bst",
      code: "ASX:BST",
      companyName: "BEST & LESS GROUP HOLDINGS LTD",
      popularity: 0,
    },
    {
      slug: "asx-bcn",
      code: "ASX:BCN",
      companyName: "Beacon Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bcc",
      code: "ASX:BCC",
      companyName: "Beam Communications Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bas",
      code: "ASX:BAS",
      companyName: "Bass Oil Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bat",
      code: "ASX:BAT",
      companyName: "Battery Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bci",
      code: "ASX:BCI",
      companyName: "BCI Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-blx",
      code: "ASX:BLX",
      companyName: "Beacon Lighting Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bnl",
      code: "ASX:BNL",
      companyName: "Blue Star Helium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bar",
      code: "ASX:BAR",
      companyName: "BARRA RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bid",
      code: "ASX:BID",
      companyName: "BILL IDENTITY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bfg",
      code: "ASX:BFG",
      companyName: "Bell Financial Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bmh",
      code: "ASX:BMH",
      companyName: "Baumart Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bbx",
      code: "ASX:BBX",
      companyName: "BBX Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hygg",
      code: "ASX:HYGG",
      companyName: "Hyperion GBL Growth Companies Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-brl",
      code: "ASX:BRL",
      companyName: "Bathurst Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bse",
      code: "ASX:BSE",
      companyName: "Base Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bsm",
      code: "ASX:BSM",
      companyName: "BASS METALS LTD",
      popularity: 0,
    },
    {
      slug: "asx-bsr",
      code: "ASX:BSR",
      companyName: "BASSARI RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bri",
      code: "ASX:BRI",
      companyName: "Big River Industries Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bau",
      code: "ASX:BAU",
      companyName: "BAUXITE RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ben",
      code: "ASX:BEN",
      companyName: "Bendigo and Adelaide Bank Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bga",
      code: "ASX:BGA",
      companyName: "Bega Cheese Ltd",
      popularity: 0,
    },
    {
      slug: "asx-blt",
      code: "ASX:BLT",
      companyName: "BENITEC BIOPHARMA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-byi",
      code: "ASX:BYI",
      companyName: "BEYOND INTERNATIONAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bwf",
      code: "ASX:BWF",
      companyName: "Blackwall Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bbc",
      code: "ASX:BBC",
      companyName: "BNK Banking Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bah",
      code: "ASX:BAH",
      companyName: "BOJUN AGRICULTURE HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bct",
      code: "ASX:BCT",
      companyName: "Bluechiip Ltd",
      popularity: 0,
    },
    {
      slug: "asx-boe",
      code: "ASX:BOE",
      companyName: "Boss Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bkm",
      code: "ASX:BKM",
      companyName: "BKM MANAGEMENT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bkt",
      code: "ASX:BKT",
      companyName: "Black Rock Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bsx",
      code: "ASX:BSX",
      companyName: "Blackstone Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bsp",
      code: "ASX:BSP",
      companyName: "BLACK STAR PETROLEUM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bem",
      code: "ASX:BEM",
      companyName: "BLACKEARTH MINERALS NL",
      popularity: 0,
    },
    {
      slug: "asx-blk",
      code: "ASX:BLK",
      companyName: "BLACKHAM RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-aba",
      code: "ASX:ABA",
      companyName: "Auswide Bank Ltd",
      popularity: 106000,
    },
    {
      slug: "asx-baf",
      code: "ASX:BAF",
      companyName: "BLUE SKY ALTERNATIVES ACCESS FUND LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bdg",
      code: "ASX:BDG",
      companyName: "Black Dragon Gold Corp",
      popularity: 0,
    },
    {
      slug: "asx-bkl",
      code: "ASX:BKL",
      companyName: "Blackmores Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bc8",
      code: "ASX:BC8",
      companyName: "Black Cat Syndicate Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bly",
      code: "ASX:BLY",
      companyName: "Boart Longyear Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bgh",
      code: "ASX:BGH",
      companyName: "BLIGH RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bdi",
      code: "ASX:BDI",
      companyName: "BLINA MINERALS NL",
      popularity: 0,
    },
    {
      slug: "asx-bul",
      code: "ASX:BUL",
      companyName: "BLUE ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-blz",
      code: "ASX:BLZ",
      companyName: "BLAZE Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bmg",
      code: "ASX:BMG",
      companyName: "BMG Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bwr",
      code: "ASX:BWR",
      companyName: "WOTSO PROP",
      popularity: 0,
    },
    {
      slug: "nasdaq-open",
      code: "NASDAQ:OPEN",
      companyName: "Opendoor Technologies Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-boa",
      code: "ASX:BOA",
      companyName: "Boadicea Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bla",
      code: "ASX:BLA",
      companyName: "BLUE SKY ALTERNATIVE INVESTMENTS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bda",
      code: "ASX:BDA",
      companyName: "BOD AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bol",
      code: "ASX:BOL",
      companyName: "Boom Logistics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-buy",
      code: "ASX:BUY",
      companyName: "Bounty Oil & Gas NL",
      popularity: 0,
    },
    {
      slug: "asx-bbr",
      code: "ASX:BBR",
      companyName: "BORA BORA RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-blg",
      code: "ASX:BLG",
      companyName: "Bluglass Ltd",
      popularity: 0,
    },
    {
      slug: "asx-b2y",
      code: "ASX:B2Y",
      companyName: "BOUNTY MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bhl",
      code: "ASX:BHL",
      companyName: "BOYUAN HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-now",
      code: "NASDAQ:NOW",
      companyName: "ServiceNow Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-apa",
      code: "ASX:APA",
      companyName: "APA Group",
      popularity: 830000,
    },
    {
      slug: "asx-bck",
      code: "ASX:BCK",
      companyName: "Brockman Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bkw",
      code: "ASX:BKW",
      companyName: "Brickworks Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cad",
      code: "ASX:CAD",
      companyName: "CAENEUS MINERALS LTD",
      popularity: 0,
    },
    {
      slug: "asx-bee",
      code: "ASX:BEE",
      companyName: "Broo Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bgp",
      code: "ASX:BGP",
      companyName: "Briscoe Group Australasia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ctx",
      code: "ASX:CTX",
      companyName: "CALTEX AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-brk",
      code: "ASX:BRK",
      companyName: "Brookside Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shl",
      code: "ASX:SHL",
      companyName: "Sonic Healthcare Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bsa",
      code: "ASX:BSA",
      companyName: "BSA Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bub",
      code: "ASX:BUB",
      companyName: "Bubs Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bru",
      code: "ASX:BRU",
      companyName: "Buru Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aub",
      code: "ASX:AUB",
      companyName: "AUB Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-caj",
      code: "ASX:CAJ",
      companyName: "Capitol Health Ltd",
      popularity: 0,
    },
    {
      slug: "asx-btc",
      code: "ASX:BTC",
      companyName: "BTC Health Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bud",
      code: "ASX:BUD",
      companyName: "Buddy Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cpu",
      code: "ASX:CPU",
      companyName: "Computershare Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bpl",
      code: "ASX:BPL",
      companyName: "BROKEN HILL PROSPECTING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bgr",
      code: "ASX:BGR",
      companyName: "BRONSON GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cae",
      code: "ASX:CAE",
      companyName: "Cannindah Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cag",
      code: "ASX:CAG",
      companyName: "Cape Range Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dxa",
      code: "ASX:DXA",
      companyName: "CAISSE FRANCAISE DE FINANCEMENT LOCAL",
      popularity: 0,
    },
    {
      slug: "asx-bnr",
      code: "ASX:BNR",
      companyName: "Bulletin Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cay",
      code: "ASX:CAY",
      companyName: "Canyon Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cby",
      code: "ASX:CBY",
      companyName: "Canterbury Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cgb",
      code: "ASX:CGB",
      companyName: "Cann Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-clb",
      code: "ASX:CLB",
      companyName: "Candy Club Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-byh",
      code: "ASX:BYH",
      companyName: "Bryah Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-can",
      code: "ASX:CAN",
      companyName: "Cann Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bug",
      code: "ASX:BUG",
      companyName: "BUDERIM GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-biq",
      code: "ASX:BIQ",
      companyName: "BUILDINGIQ INC",
      popularity: 0,
    },
    {
      slug: "asx-bcl",
      code: "ASX:BCL",
      companyName: "BUNJI CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bmp",
      code: "ASX:BMP",
      companyName: "BUYMYPLACE.COM.AU LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bpg",
      code: "ASX:BPG",
      companyName: "BYTE POWER GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cp1",
      code: "ASX:CP1",
      companyName: "CANNPAL ANIMAL THERAPEUTICS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cfe",
      code: "ASX:CFE",
      companyName: "CAPE LAMBERT RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cmd",
      code: "ASX:CMD",
      companyName: "Cassius Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-crm",
      code: "ASX:CRM",
      companyName: "Carbon Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cvn",
      code: "ASX:CVN",
      companyName: "Carnarvon Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-des",
      code: "ASX:DES",
      companyName: "Desoto Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cav",
      code: "ASX:CAV",
      companyName: "Carnavale Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-wday",
      code: "NYSE:WDAY",
      companyName: "Workday Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-cdv",
      code: "ASX:CDV",
      companyName: "CARDINAL RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-brg",
      code: "ASX:BRG",
      companyName: "Breville Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ccv",
      code: "ASX:CCV",
      companyName: "Cash Converters International",
      popularity: 0,
    },
    {
      slug: "asx-ccz",
      code: "ASX:CCZ",
      companyName: "Castillo Copper Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cdd",
      code: "ASX:CDD",
      companyName: "Cardno Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mom",
      code: "ASX:MOM",
      companyName: "Moab Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cap",
      code: "ASX:CAP",
      companyName: "CARPENTARIA RESOURCES LTD",
      popularity: 0,
    },
    {
      slug: "asx-cdx",
      code: "ASX:CDX",
      companyName: "Cardiex Ltd",
      popularity: 0,
    },
    {
      slug: "asx-czi",
      code: "ASX:CZI",
      companyName: "CASSINI RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-oma",
      code: "ASX:OMA",
      companyName: "Omega Oil & Gas Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cbc",
      code: "ASX:CBC",
      companyName: "CBG CAPITAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cnl",
      code: "ASX:CNL",
      companyName: "CELAMIN HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cdy",
      code: "ASX:CDY",
      companyName: "CELLMID LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-orp",
      code: "ASX:ORP",
      companyName: "ORPHEUS MINERALS LTD",
      popularity: 0,
    },
    {
      slug: "asx-ctl",
      code: "ASX:CTL",
      companyName: "CENTENNIAL MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kyp",
      code: "ASX:KYP",
      companyName: "Kinatico Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cpl",
      code: "ASX:CPL",
      companyName: "CSL FINANCE PLC",
      popularity: 0,
    },
    {
      slug: "asx-cdt",
      code: "ASX:CDT",
      companyName: "Castle Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cdp",
      code: "ASX:CDP",
      companyName: "Carindale Property Trust",
      popularity: 0,
    },
    {
      slug: "asx-l1m",
      code: "ASX:L1M",
      companyName: "Lightning Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cma",
      code: "ASX:CMA",
      companyName: "CENTURIA METROPOLITAN REIT",
      popularity: 0,
    },
    {
      slug: "asx-cce",
      code: "ASX:CCE",
      companyName: "Carnegie Clean Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lli",
      code: "ASX:LLI",
      companyName: "Loyal Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-adg",
      code: "ASX:ADG",
      companyName: "Adelong Gold Ltd",
      popularity: 12000,
    },
    {
      slug: "asx-cvs",
      code: "ASX:CVS",
      companyName: "CERVANTES CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sc1",
      code: "ASX:SC1",
      companyName: "SOURCE CERTAIN INTERNATIONAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hro",
      code: "ASX:HRO",
      companyName: "HIRO BRANDS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bus",
      code: "ASX:BUS",
      companyName: "Bubalus Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-t1g",
      code: "ASX:T1G",
      companyName: "TIGER TASMAN MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cg1",
      code: "ASX:CG1",
      companyName: "Carbonxt Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gtm",
      code: "ASX:GTM",
      companyName: "GREENTECH MINERALS LTD",
      popularity: 0,
    },
    {
      slug: "asx-cin",
      code: "ASX:CIN",
      companyName: "Carlton Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nrl",
      code: "ASX:NRL",
      companyName: "NORTHAM RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nrp",
      code: "ASX:NRP",
      companyName: "NATIONAL RMBS TRUST 2022-1 IN RESPECT OF SERIES 2022-1",
      popularity: 0,
    },
    {
      slug: "asx-cnw",
      code: "ASX:CNW",
      companyName: "Cirrus Networks Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cqe",
      code: "ASX:CQE",
      companyName: "Charter Hall Social Infrastructure REIT",
      popularity: 0,
    },
    {
      slug: "asx-cgf",
      code: "ASX:CGF",
      companyName: "Challenger Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cel",
      code: "ASX:CEL",
      companyName: "Challenger Gold Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-aph",
      code: "NASDAQ:APH",
      companyName: "Amphenol Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ncm",
      code: "ASX:NCM",
      companyName: "Newcrest Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cto",
      code: "ASX:CTO",
      companyName: "Citigold Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-clz",
      code: "ASX:CLZ",
      companyName: "Classic Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mms",
      code: "ASX:MMS",
      companyName: "Mcmillan Shakespeare Ltd",
      popularity: 0,
    },
    {
      slug: "asx-chr",
      code: "ASX:CHR",
      companyName: "Charger Metals NL",
      popularity: 0,
    },
    {
      slug: "asx-cvl",
      code: "ASX:CVL",
      companyName: "Civmec Ltd",
      popularity: 0,
    },
    {
      slug: "asx-csx",
      code: "ASX:CSX",
      companyName: "Cleanspace Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cnu",
      code: "ASX:CNU",
      companyName: "Chorus Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cim",
      code: "ASX:CIM",
      companyName: "CIMIC GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cii",
      code: "ASX:CII",
      companyName: "Ci Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-chp",
      code: "ASX:CHP",
      companyName: "CHAPMANS LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-ual",
      code: "NYSE:UAL",
      companyName: "United Airlines Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-cml",
      code: "ASX:CML",
      companyName: "CHASE MINING CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-chj",
      code: "ASX:CHJ",
      companyName: "CHALLENGER MILLENNIUM SERIES 2007-1E TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ccb",
      code: "ASX:CCB",
      companyName: "CHINA CONSTRUCTION BANK CORPORATION",
      popularity: 0,
    },
    {
      slug: "asx-chu",
      code: "ASX:CHU",
      companyName: "CHALLENGER MILLENNIUM SERIES 2007-2L TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-uri",
      code: "NYSE:URI",
      companyName: "United Rentals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hdb",
      code: "NYSE:HDB",
      companyName: "HDFC Bank Limited",
      popularity: 0,
    },
    {
      slug: "asx-chz",
      code: "ASX:CHZ",
      companyName: "Chesser Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cmc",
      code: "ASX:CMC",
      companyName: "CHINA MAGNESIUM CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lnas",
      code: "ASX:LNAS",
      companyName: "Global X Ultra Long Nasdaq 100 Hedge Fund",
      popularity: 0,
    },
    {
      slug: "nyse-riot",
      code: "NYSE:RIOT",
      companyName: "Riot Blockchain Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-cca",
      code: "ASX:CCA",
      companyName: "Change Financial Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cdh",
      code: "ASX:CDH",
      companyName: "CHONGHERR INVESTMENTS LTD",
      popularity: 0,
    },
    {
      slug: "asx-amp",
      code: "ASX:AMP",
      companyName: "AMP Ltd",
      popularity: 1182000,
    },
    {
      slug: "asx-nuf",
      code: "ASX:NUF",
      companyName: "Nufarm Ltd",
      popularity: 0,
    },
    {
      slug: "asx-web",
      code: "ASX:WEB",
      companyName: "Webjet Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cro",
      code: "ASX:CRO",
      companyName: "CIRRALTO LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cwl",
      code: "ASX:CWL",
      companyName: "CONSOLIDATED FINANCIAL HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cly",
      code: "ASX:CLY",
      companyName: "CLANCY EXPLORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cl1",
      code: "ASX:CL1",
      companyName: "CLASS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-clq",
      code: "ASX:CLQ",
      companyName: "CLEAN TEQ HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cse",
      code: "ASX:CSE",
      companyName: "Copper Strike Ltd",
      popularity: 0,
    },
    {
      slug: "asx-czn",
      code: "ASX:CZN",
      companyName: "Corazon Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-etm",
      code: "ASX:ETM",
      companyName: "Energy Transition Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cl8",
      code: "ASX:CL8",
      companyName: "Carly Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-cprt",
      code: "NYSE:CPRT",
      companyName: "Copart Inc",
      popularity: 0,
    },
    {
      slug: "asx-c7a",
      code: "ASX:C7A",
      companyName: "Clara Resources Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cen",
      code: "ASX:CEN",
      companyName: "Contact Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-c6c",
      code: "ASX:C6C",
      companyName: "COPPER MOUNTAIN MINING CORPORATION",
      popularity: 0,
    },
    {
      slug: "asx-cgs",
      code: "ASX:CGS",
      companyName: "Cogstate Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ccg",
      code: "ASX:CCG",
      companyName: "Comms Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-czl",
      code: "ASX:CZL",
      companyName: "CONSOLIDATED ZINC LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pp1",
      code: "ASX:PP1",
      companyName: "PEPPER PRIME 2022-2 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-clf",
      code: "ASX:CLF",
      companyName: "CONCENTRATED LEADERS FUND LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-clh",
      code: "ASX:CLH",
      companyName: "COLLECTION HOUSE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-coi",
      code: "ASX:COI",
      companyName: "Comet Ridge Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cio",
      code: "ASX:CIO",
      companyName: "Connected Io Ltd",
      popularity: 0,
    },
    {
      slug: "asx-coe",
      code: "ASX:COE",
      companyName: "Cooper Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cka",
      code: "ASX:CKA",
      companyName: "Cokal Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cmp",
      code: "ASX:CMP",
      companyName: "Compumedics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-chk",
      code: "ASX:CHK",
      companyName: "Cohiba Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-csd",
      code: "ASX:CSD",
      companyName: "CONSOLIDATED TIN MINES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cnj",
      code: "ASX:CNJ",
      companyName: "Conico Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nws",
      code: "ASX:NWS",
      companyName: "News Corporation",
      popularity: 0,
    },
    {
      slug: "asx-bsl",
      code: "ASX:BSL",
      companyName: "Bluescope Steel Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cga",
      code: "ASX:CGA",
      companyName: "CONTANGO ASSET MANAGEMENT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-awc",
      code: "ASX:AWC",
      companyName: "Alumina Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cie",
      code: "ASX:CIE",
      companyName: "CONTANGO INCOME GENERATOR  LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cvf",
      code: "ASX:CVF",
      companyName: "CONTRARIAN VALUE FUND LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cm1",
      code: "ASX:CM1",
      companyName: "COOLGARDIE MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cog",
      code: "ASX:COG",
      companyName: "COG Financial Services Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ccl",
      code: "ASX:CCL",
      companyName: "COCA-COLA AMATIL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-coy",
      code: "ASX:COY",
      companyName: "Coppermoly Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tah",
      code: "ASX:TAH",
      companyName: "Tabcorp Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cr1",
      code: "ASX:CR1",
      companyName: "Constellation Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-crl",
      code: "ASX:CRL",
      companyName: "Comet Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-alk",
      code: "NYSE:ALK",
      companyName: "Alaska Air Group Inc.",
      popularity: 0,
    },
    {
      slug: "asx-cxz",
      code: "ASX:CXZ",
      companyName: "Connexion Mobility Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rem",
      code: "ASX:REM",
      companyName: "Remsense Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ciz",
      code: "ASX:CIZ",
      companyName: "CORIZON LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mkm",
      code: "ASX:MKM",
      companyName: "MACKEREL METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-sqm",
      code: "NASDAQ:SQM",
      companyName: "Sociedad Quimica y Minera S.A. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-cwn",
      code: "ASX:CWN",
      companyName: "CROWN RESORTS LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-alb",
      code: "NYSE:ALB",
      companyName: "Albemarle Corporation",
      popularity: 0,
    },
    {
      slug: "asx-nbs",
      code: "ASX:NBS",
      companyName: "NATIONWIDE BUILDING SOCIETY.",
      popularity: 0,
    },
    {
      slug: "nyse-ggg",
      code: "NYSE:GGG",
      companyName: "Graco Inc",
      popularity: 0,
    },
    {
      slug: "asx-cyg",
      code: "ASX:CYG",
      companyName: "Coventry Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-alk",
      code: "NASDAQ:ALK",
      companyName: "Alaska Air Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-cmw",
      code: "ASX:CMW",
      companyName: "Cromwell Property Group",
      popularity: 0,
    },
    {
      slug: "asx-cup",
      code: "ASX:CUP",
      companyName: "Count Ltd",
      popularity: 0,
    },
    {
      slug: "asx-clx",
      code: "ASX:CLX",
      companyName: "Cti Logistics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cgn",
      code: "ASX:CGN",
      companyName: "CRATER GOLD MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-czr",
      code: "ASX:CZR",
      companyName: "CZR Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cgo",
      code: "ASX:CGO",
      companyName: "CPT Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ci1",
      code: "ASX:CI1",
      companyName: "Credit Intelligence Ltd",
      popularity: 0,
    },
    {
      slug: "asx-coo",
      code: "ASX:COO",
      companyName: "Corum Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-csr",
      code: "ASX:CSR",
      companyName: "CSR Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cli",
      code: "ASX:CLI",
      companyName: "CROPLOGIC LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-crd",
      code: "ASX:CRD",
      companyName: "Conrad Asia Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cux",
      code: "ASX:CUX",
      companyName: "CROSSLAND STRATEGIC METALS LTD",
      popularity: 0,
    },
    {
      slug: "asx-cm8",
      code: "ASX:CM8",
      companyName: "CROWD MEDIA HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cte",
      code: "ASX:CTE",
      companyName: "Cryosite Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cxx",
      code: "ASX:CXX",
      companyName: "Cradle Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-csk",
      code: "ASX:CSK",
      companyName: "CROWDSPARK LTD",
      popularity: 0,
    },
    {
      slug: "asx-cph",
      code: "ASX:CPH",
      companyName: "CRESO PHARMA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cuh",
      code: "ASX:CUH",
      companyName: "CRUSADE ABS SERIES 2015-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-cu1",
      code: "ASX:CU1",
      companyName: "CRUSADE ABS SERIES 2016-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-cu2",
      code: "ASX:CU2",
      companyName: "CRUSADE ABS SERIES 2017-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-cgm",
      code: "ASX:CGM",
      companyName: "COUGAR METALS NL",
      popularity: 0,
    },
    {
      slug: "asx-ccj",
      code: "ASX:CCJ",
      companyName: "COUNTY INTERNATIONAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cas",
      code: "ASX:CAS",
      companyName: "CRUSADER RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cvt",
      code: "ASX:CVT",
      companyName: "COVATA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-csv",
      code: "ASX:CSV",
      companyName: "CSG LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dgr",
      code: "ASX:DGR",
      companyName: "DGR Global Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-mlm",
      code: "NYSE:MLM",
      companyName: "Martin Marietta Materials",
      popularity: 0,
    },
    {
      slug: "asx-vnt",
      code: "ASX:VNT",
      companyName: "Ventia Services Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dtl",
      code: "ASX:DTL",
      companyName: "Data#3 Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dna",
      code: "ASX:DNA",
      companyName: "Donaco International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dcg",
      code: "ASX:DCG",
      companyName: "Decmil Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dmg",
      code: "ASX:DMG",
      companyName: "Dragon Mountain Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dor",
      code: "ASX:DOR",
      companyName: "Doriemus Plc",
      popularity: 0,
    },
    {
      slug: "asx-drx",
      code: "ASX:DRX",
      companyName: "Diatreme Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-fast",
      code: "NYSE:FAST",
      companyName: "Fastenal Co",
      popularity: 0,
    },
    {
      slug: "asx-dxs",
      code: "ASX:DXS",
      companyName: "Dexus",
      popularity: 0,
    },
    {
      slug: "asx-dtr",
      code: "ASX:DTR",
      companyName: "Dateline Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dw8",
      code: "ASX:DW8",
      companyName: "DW8 LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dav",
      code: "ASX:DAV",
      companyName: "DAVENPORT RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dev",
      code: "ASX:DEV",
      companyName: "DEVEX Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dme",
      code: "ASX:DME",
      companyName: "Dome Gold Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-idea",
      code: "ASX:IDEA",
      companyName: "Perpetual Global Innovation Share (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-dtz",
      code: "ASX:DTZ",
      companyName: "DOTZ Nano Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ddt",
      code: "ASX:DDT",
      companyName: "Datadot Technology Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dvl",
      code: "ASX:DVL",
      companyName: "Dorsavi Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dlc",
      code: "ASX:DLC",
      companyName: "DELECTA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-d13",
      code: "ASX:D13",
      companyName: "DELAWARE THIRTEEN LTD",
      popularity: 0,
    },
    {
      slug: "asx-dem",
      code: "ASX:DEM",
      companyName: "De.Mem Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dvn",
      code: "ASX:DVN",
      companyName: "DEVINE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dgo",
      code: "ASX:DGO",
      companyName: "DGO GOLD LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dfm",
      code: "ASX:DFM",
      companyName: "DONGFANG MODERN AGRICULTURE HOLDING GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dgh",
      code: "ASX:DGH",
      companyName: "Desane Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-drm",
      code: "ASX:DRM",
      companyName: "DEMETALLICA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dgf",
      code: "ASX:DGF",
      companyName: "DOWNER GROUP FINANCE PTY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dts",
      code: "ASX:DTS",
      companyName: "DRAGONTAIL SYSTEMS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-enn",
      code: "ASX:ENN",
      companyName: "Elanor Investors Group",
      popularity: 0,
    },
    {
      slug: "asx-epm",
      code: "ASX:EPM",
      companyName: "Eclipse Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-erf",
      code: "ASX:ERF",
      companyName: "ELANOR RETAIL PROPERTY FUND",
      popularity: 0,
    },
    {
      slug: "nyse-ferg",
      code: "NYSE:FERG",
      companyName: "Ferguson plc",
      popularity: 0,
    },
    {
      slug: "asx-edc",
      code: "ASX:EDC",
      companyName: "Eildon Capital Group",
      popularity: 0,
    },
    {
      slug: "asx-efe",
      code: "ASX:EFE",
      companyName: "Eastern Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-htm",
      code: "ASX:HTM",
      companyName: "High-Tech Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-smr",
      code: "ASX:SMR",
      companyName: "Stanmore Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-d2o",
      code: "ASX:D2O",
      companyName: "Duxton Water Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ebo",
      code: "ASX:EBO",
      companyName: "Ebos Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sya",
      code: "ASX:SYA",
      companyName: "Sayona Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sxl",
      code: "ASX:SXL",
      companyName: "Southern Cross Media Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-em2",
      code: "ASX:EM2",
      companyName: "Eagle Mountain Mining Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-hpq",
      code: "NYSE:HPQ",
      companyName: "HP Inc.",
      popularity: 0,
    },
    {
      slug: "asx-dlx",
      code: "ASX:DLX",
      companyName: "DULUXGROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-cat",
      code: "NYSE:CAT",
      companyName: "Caterpillar Inc.",
      popularity: 0,
    },
    {
      slug: "asx-ear",
      code: "ASX:EAR",
      companyName: "ECHO RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pac",
      code: "ASX:PAC",
      companyName: "Pacific Current Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dws",
      code: "ASX:DWS",
      companyName: "DWS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dma",
      code: "ASX:DMA",
      companyName: "DYNASTY RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-e2m",
      code: "ASX:E2M",
      companyName: "E2 METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-e3s",
      code: "ASX:E3S",
      companyName: "E3SIXTY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ecg",
      code: "ASX:ECG",
      companyName: "Ecargo Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ehh",
      code: "ASX:EHH",
      companyName: "EAGLE HEALTH HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-e25",
      code: "ASX:E25",
      companyName: "Element 25 Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eld",
      code: "ASX:ELD",
      companyName: "Elders Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eer",
      code: "ASX:EER",
      companyName: "EAST ENERGY RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-egs",
      code: "ASX:EGS",
      companyName: "EASTERN GOLDFIELDS LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-lthm",
      code: "NASDAQ:LTHM",
      companyName: "Livent Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-elt",
      code: "ASX:ELT",
      companyName: "Elementos Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eas",
      code: "ASX:EAS",
      companyName: "EASTON INVESTMENTS LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-jbi",
      code: "NYSE:JBI",
      companyName: "Janus International Group Inc.",
      popularity: 0,
    },
    {
      slug: "asx-ecx",
      code: "ASX:ECX",
      companyName: "ECLIPX GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dbf",
      code: "ASX:DBF",
      companyName: "Duxton Farms Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ega",
      code: "ASX:EGA",
      companyName: "EGAN STREET RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dkm",
      code: "ASX:DKM",
      companyName: "Duketon Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ehx",
      code: "ASX:EHX",
      companyName: "EHR RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dti",
      code: "ASX:DTI",
      companyName: "DTI Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-all",
      code: "ASX:ALL",
      companyName: "Aristocrat Leisure Ltd",
      popularity: 1685000,
    },
    {
      slug: "asx-dse",
      code: "ASX:DSE",
      companyName: "Dropsuite Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ede",
      code: "ASX:EDE",
      companyName: "Eden Innovations Ltd",
      popularity: 0,
    },
    {
      slug: "asx-elk",
      code: "ASX:ELK",
      companyName: "ELK PETROLEUM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-eos",
      code: "ASX:EOS",
      companyName: "Electro Optic Systems Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-emi",
      code: "ASX:EMI",
      companyName: "EMIRATES NBD PJSC",
      popularity: 0,
    },
    {
      slug: "asx-ewc",
      code: "ASX:EWC",
      companyName: "Energy World Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-enr",
      code: "ASX:ENR",
      companyName: "Encounter Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-tsco",
      code: "NYSE:TSCO",
      companyName: "Tractor Supply Co",
      popularity: 0,
    },
    {
      slug: "asx-egg",
      code: "ASX:EGG",
      companyName: "Enero Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-emr",
      code: "ASX:EMR",
      companyName: "Emerald Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-eax",
      code: "ASX:EAX",
      companyName: "Energy Action Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pci",
      code: "ASX:PCI",
      companyName: "Perpetual Credit Income Trust",
      popularity: 0,
    },
    {
      slug: "asx-ctd",
      code: "ASX:CTD",
      companyName: "Corporate Travel Management Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-adbe",
      code: "NASDAQ:ADBE",
      companyName: "Adobe Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-emu",
      code: "ASX:EMU",
      companyName: "EMU NL",
      popularity: 0,
    },
    {
      slug: "asx-eeg",
      code: "ASX:EEG",
      companyName: "Empire Energy Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-egy",
      code: "ASX:EGY",
      companyName: "Energy Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ehl",
      code: "ASX:EHL",
      companyName: "Emeco Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-els",
      code: "ASX:ELS",
      companyName: "Elsight Ltd",
      popularity: 0,
    },
    {
      slug: "asx-emb",
      code: "ASX:EMB",
      companyName: "Embelton Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eme",
      code: "ASX:EME",
      companyName: "Energy Metals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-fbhs",
      code: "NASDAQ:FBHS",
      companyName: "Fortune Brands Home & Security Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-eol",
      code: "ASX:EOL",
      companyName: "Energy One Ltd",
      popularity: 0,
    },
    {
      slug: "asx-era",
      code: "ASX:ERA",
      companyName: "Energy Resources of Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ego",
      code: "ASX:EGO",
      companyName: "EMPIRE OIL & GAS NL",
      popularity: 0,
    },
    {
      slug: "asx-emp",
      code: "ASX:EMP",
      companyName: "Emperor Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-enx",
      code: "ASX:ENX",
      companyName: "Enegex Ltd",
      popularity: 0,
    },
    {
      slug: "asx-em1",
      code: "ASX:EM1",
      companyName: "EMERGE GAMING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-epd",
      code: "ASX:EPD",
      companyName: "EMPIRED LTD",
      popularity: 0,
    },
    {
      slug: "asx-erl",
      code: "ASX:ERL",
      companyName: "Empire Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-erm",
      code: "ASX:ERM",
      companyName: "Emmerson Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-enb",
      code: "ASX:ENB",
      companyName: "ENEABBA GAS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-emv",
      code: "ASX:EMV",
      companyName: "Emvision Medical Devices Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ctas",
      code: "NYSE:CTAS",
      companyName: "Cintas Corp",
      popularity: 0,
    },
    {
      slug: "asx-erg",
      code: "ASX:ERG",
      companyName: "Eneco Refresh Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ene",
      code: "ASX:ENE",
      companyName: "ENEVIS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-en1",
      code: "ASX:EN1",
      companyName: "ENGAGE:BDR LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-eor",
      code: "ASX:EOR",
      companyName: "EOR GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-exo",
      code: "ASX:EXO",
      companyName: "ENNOX GROUP LTD",
      popularity: 0,
    },
    {
      slug: "asx-e88",
      code: "ASX:E88",
      companyName: "ENSOGO LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ete",
      code: "ASX:ETE",
      companyName: "ENTEK ENERGY LTD",
      popularity: 0,
    },
    {
      slug: "asx-far",
      code: "ASX:FAR",
      companyName: "FAR Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eve",
      code: "ASX:EVE",
      companyName: "EVE Health Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-evz",
      code: "ASX:EVZ",
      companyName: "EVZ Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ezl",
      code: "ASX:EZL",
      companyName: "EUROZ Hartleys Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-frm",
      code: "ASX:FRM",
      companyName: "Farm Pride Foods Ltd",
      popularity: 0,
    },
    {
      slug: "asx-esk",
      code: "ASX:ESK",
      companyName: "Etherstack Plc",
      popularity: 0,
    },
    {
      slug: "asx-emn",
      code: "ASX:EMN",
      companyName: "Euro Manganese Inc",
      popularity: 0,
    },
    {
      slug: "asx-erx",
      code: "ASX:ERX",
      companyName: "EXORE RESOURCES LTD",
      popularity: 0,
    },
    {
      slug: "asx-euc",
      code: "ASX:EUC",
      companyName: "EUROPEAN COBALT LTD",
      popularity: 0,
    },
    {
      slug: "asx-esh",
      code: "ASX:ESH",
      companyName: "ESPORTS MOGUL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-esv",
      code: "ASX:ESV",
      companyName: "ESERVGLOBAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-evo",
      code: "ASX:EVO",
      companyName: "Embark Early Education Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-bc-a",
      code: "NASDAQ:BC-A",
      companyName: "Brunswick Corporation 6.500% Senior Notes due 2048",
      popularity: 0,
    },
    {
      slug: "asx-egd",
      code: "ASX:EGD",
      companyName: "EVANS & PARTNERS GLOBAL DISRUPTION FUND",
      popularity: 0,
    },
    {
      slug: "nasdaq-cmg",
      code: "NASDAQ:CMG",
      companyName: "Chipotle Mexican Grill Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-rea",
      code: "ASX:REA",
      companyName: "REA Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ex1",
      code: "ASX:EX1",
      companyName: "Exopharm Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fzo",
      code: "ASX:FZO",
      companyName: "FAMILY ZONE CYBER SAFETY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-eur",
      code: "ASX:EUR",
      companyName: "European Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-esr",
      code: "ASX:ESR",
      companyName: "Estrella Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-chx",
      code: "NASDAQ:CHX",
      companyName: "ChampionX Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-btu",
      code: "NASDAQ:BTU",
      companyName: "Peabody Energy Corporation Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-bkng",
      code: "NASDAQ:BKNG",
      companyName: "Booking Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ebg",
      code: "ASX:EBG",
      companyName: "Eumundi Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ecl",
      code: "ASX:ECL",
      companyName: "Excelsior Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-egh",
      code: "ASX:EGH",
      companyName: "Eureka Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-emh",
      code: "ASX:EMH",
      companyName: "European Metals Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eaf",
      code: "ASX:EAF",
      companyName: "EVANS & PARTNERS ASIA FUND",
      popularity: 0,
    },
    {
      slug: "asx-eff",
      code: "ASX:EFF",
      companyName: "EVANS & PARTNERS AUSTRALIAN FLAGSHIP FUND",
      popularity: 0,
    },
    {
      slug: "asx-egf",
      code: "ASX:EGF",
      companyName: "EVANS & PARTNERS GLOBAL FLAGSHIP FUND",
      popularity: 0,
    },
    {
      slug: "asx-ed1",
      code: "ASX:ED1",
      companyName: "EVANS DIXON LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ftt",
      code: "ASX:FTT",
      companyName: "FACTOR THERAPEUTICS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fam",
      code: "ASX:FAM",
      companyName: "FAMILY INSIGHTS GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ffc",
      code: "ASX:FFC",
      companyName: "FARMAFORCE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fe8",
      code: "ASX:FE8",
      companyName: "FASTER ENTERPRISES LTD",
      popularity: 0,
    },
    {
      slug: "nasdaq-pltr",
      code: "NASDAQ:PLTR",
      companyName: "Palantir Technologies Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-asnnc",
      code: "ASX:ASNNC",
      companyName: "Anson Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mhcn",
      code: "ASX:MHCN",
      companyName: "Manhattan Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-4ce",
      code: "ASX:4CE",
      companyName: "FORCE COMMODITIES LIMITED",
      popularity: 26000,
    },
    {
      slug: "asx-fln",
      code: "ASX:FLN",
      companyName: "Freelancer Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fml",
      code: "ASX:FML",
      companyName: "Focus Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrna",
      code: "NASDAQ:MRNA",
      companyName: "Moderna Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-fin",
      code: "ASX:FIN",
      companyName: "FIN Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fdv",
      code: "ASX:FDV",
      companyName: "Frontier Digital Ventures Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cbln",
      code: "ASX:CBLN",
      companyName: "Control Bionics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fri",
      code: "ASX:FRI",
      companyName: "Finbar Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fhs",
      code: "ASX:FHS",
      companyName: "Freehill Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cann",
      code: "ASX:CANN",
      companyName: "Cann Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fsg",
      code: "ASX:FSG",
      companyName: "Field Solutions Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fya",
      code: "ASX:FYA",
      companyName: "FORTUNE ASIA GROUP LTD",
      popularity: 0,
    },
    {
      slug: "asx-ccona",
      code: "ASX:CCONA",
      companyName: "The Calmer Co International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xtcr",
      code: "ASX:XTCR",
      companyName: "Xantippe Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-adpt",
      code: "NASDAQ:ADPT",
      companyName: "Adaptive Biotechnologies Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ftc",
      code: "ASX:FTC",
      companyName: "Fintech Chain Ltd",
      popularity: 0,
    },
    {
      slug: "asx-frn",
      code: "ASX:FRN",
      companyName: "FRASER RANGE METALS GROUP LTD",
      popularity: 0,
    },
    {
      slug: "asx-frx",
      code: "ASX:FRX",
      companyName: "Flexiroam Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-fcx",
      code: "NASDAQ:FCX",
      companyName: "Freeport-McMoRan Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-fms",
      code: "ASX:FMS",
      companyName: "Flinders Mines Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-gold",
      code: "NYSE:GOLD",
      companyName: "Barrick Gold Corp.",
      popularity: 0,
    },
    {
      slug: "asx-fsf",
      code: "ASX:FSF",
      companyName: "Fonterra Shareholders' Fund",
      popularity: 0,
    },
    {
      slug: "asx-fij",
      code: "ASX:FIJ",
      companyName: "FIJI KAVA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-acedb",
      code: "ASX:ACEDB",
      companyName: "Acusensus Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fau",
      code: "ASX:FAU",
      companyName: "First Au Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fct",
      code: "ASX:FCT",
      companyName: "Firstwave Cloud Technology Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dxi",
      code: "ASX:DXI",
      companyName: "Dexus Industria REIT",
      popularity: 0,
    },
    {
      slug: "asx-ffi",
      code: "ASX:FFI",
      companyName: "FFI Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fgr",
      code: "ASX:FGR",
      companyName: "First Graphene Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dcgpa",
      code: "ASX:DCGPA",
      companyName: "Decmil Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fnp",
      code: "ASX:FNP",
      companyName: "FREEDOM FOODS GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-orcl",
      code: "NASDAQ:ORCL",
      companyName: "Oracle Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-fid",
      code: "ASX:FID",
      companyName: "Fiducian Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fcc",
      code: "ASX:FCC",
      companyName: "FIRST COBALT CORP.",
      popularity: 0,
    },
    {
      slug: "asx-fgf",
      code: "ASX:FGF",
      companyName: "FIRST GROWTH FUNDS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fgo",
      code: "ASX:FGO",
      companyName: "FARGO ENTERPRISES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fxl",
      code: "ASX:FXL",
      companyName: "FLEXIGROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fcg",
      code: "ASX:FCG",
      companyName: "Freedom Care Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fig",
      code: "ASX:FIG",
      companyName: "FREEDOM INSURANCE GROUP LTD",
      popularity: 0,
    },
    {
      slug: "asx-fnd",
      code: "ASX:FND",
      companyName: "Findi Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ge",
      code: "NYSE:GE",
      companyName: "General Electric Company",
      popularity: 0,
    },
    {
      slug: "nasdaq-beam",
      code: "NASDAQ:BEAM",
      companyName: "Beam Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-fdm",
      code: "ASX:FDM",
      companyName: "FREEDOM OIL AND GAS LTD",
      popularity: 0,
    },
    {
      slug: "nasdaq-mu",
      code: "NASDAQ:MU",
      companyName: "Micron Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bldr",
      code: "NYSE:BLDR",
      companyName: "Builders FirstSource Inc.",
      popularity: 0,
    },
    {
      slug: "asx-fpl",
      code: "ASX:FPL",
      companyName: "FREMONT PETROLEUM CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-fdx",
      code: "ASX:FDX",
      companyName: "FRONTIER DIAMONDS LTD",
      popularity: 0,
    },
    {
      slug: "nasdaq-bntx",
      code: "NASDAQ:BNTX",
      companyName: "BioNTech SE American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-ntla",
      code: "NASDAQ:NTLA",
      companyName: "Intellia Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dna",
      code: "NYSE:DNA",
      companyName: "Ginkgo Bioworks Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "asx-flc",
      code: "ASX:FLC",
      companyName: "Fluence Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gbz",
      code: "ASX:GBZ",
      companyName: "GBM Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gap",
      code: "ASX:GAP",
      companyName: "Gale Pacific Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrtx",
      code: "NASDAQ:VRTX",
      companyName: "Vertex Pharmaceuticals Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gal",
      code: "ASX:GAL",
      companyName: "Galileo Mining Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-bynd",
      code: "NASDAQ:BYND",
      companyName: "Beyond Meat Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gxy",
      code: "ASX:GXY",
      companyName: "GALAXY RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-ntr",
      code: "NYSE:NTR",
      companyName: "Nutrien Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmc",
      code: "NASDAQ:MMC",
      companyName: "Marsh & McLennan Companies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-orly",
      code: "NASDAQ:ORLY",
      companyName: "O'Reilly Automotive Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-celh",
      code: "NASDAQ:CELH",
      companyName: "Celsius Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-wpm",
      code: "NYSE:WPM",
      companyName: "Wheaton Precious Metals Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gs",
      code: "NASDAQ:GS",
      companyName: "Goldman Sachs Group Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-fdx",
      code: "NYSE:FDX",
      companyName: "FedEx Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-gsk",
      code: "NYSE:GSK",
      companyName:
        "GSK plc American Depositary Shares (Each representing two Ordinary Shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-mrk",
      code: "NASDAQ:MRK",
      companyName: "Merck & Company Inc. Common Stock (new)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfe",
      code: "NASDAQ:PFE",
      companyName: "Pfizer Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-fyi",
      code: "ASX:FYI",
      companyName: "FYI Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gdf",
      code: "ASX:GDF",
      companyName: "Garda Property Group",
      popularity: 0,
    },
    {
      slug: "nyse-fmc",
      code: "NYSE:FMC",
      companyName: "FMC Corporation",
      popularity: 0,
    },
    {
      slug: "asx-fgg",
      code: "ASX:FGG",
      companyName: "Future Generation Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gll",
      code: "ASX:GLL",
      companyName: "Galilee Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-g1a",
      code: "ASX:G1A",
      companyName: "Galena Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gcm",
      code: "ASX:GCM",
      companyName: "Green Critical Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-chtr",
      code: "NASDAQ:CHTR",
      companyName: "Charter Communications Inc. Class A Common Stock New",
      popularity: 0,
    },
    {
      slug: "asx-gdi",
      code: "ASX:GDI",
      companyName: "GDI Property Group",
      popularity: 0,
    },
    {
      slug: "nasdaq-schw",
      code: "NASDAQ:SCHW",
      companyName: "Charles Schwab Corporation (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbny",
      code: "NASDAQ:SBNY",
      companyName: "Signature Bank Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-hes",
      code: "NYSE:HES",
      companyName: "Hess Corporation",
      popularity: 0,
    },
    {
      slug: "nasdaq-dg",
      code: "NASDAQ:DG",
      companyName: "Dollar General Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-vinp",
      code: "NYSE:VINP",
      companyName: "Vinci Partners Investments Ltd. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-gln",
      code: "ASX:GLN",
      companyName: "Galan Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-fcx",
      code: "NYSE:FCX",
      companyName: "Freeport-McMoran Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-enph",
      code: "NASDAQ:ENPH",
      companyName: "Enphase Energy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-ggx",
      code: "ASX:GGX",
      companyName: "GAS2GRID Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-ggg",
      code: "NASDAQ:GGG",
      companyName: "Graco Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ewbc",
      code: "NASDAQ:EWBC",
      companyName: "East West Bancorp Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ste",
      code: "NYSE:STE",
      companyName: "STERIS plc",
      popularity: 0,
    },
    {
      slug: "asx-gfs",
      code: "ASX:GFS",
      companyName: "GASFIELDS LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-mck",
      code: "NASDAQ:MCK",
      companyName: "McKesson Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wpm",
      code: "NASDAQ:WPM",
      companyName: "Wheaton Precious Metals Corp Common Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nyse-ice",
      code: "NYSE:ICE",
      companyName: "Intercontinental Exchange  Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-hban",
      code: "NASDAQ:HBAN",
      companyName: "Huntington Bancshares Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gml",
      code: "ASX:GML",
      companyName: "Gateway Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gmv",
      code: "ASX:GMV",
      companyName: "G MEDICAL INNOVATIONS HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-grb",
      code: "ASX:GRB",
      companyName: "GAGE ROADS BREWING CO LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gzl",
      code: "ASX:GZL",
      companyName: "GAZAL CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gbm",
      code: "ASX:GBM",
      companyName: "GBM GOLD LTD",
      popularity: 0,
    },
    {
      slug: "asx-gbt",
      code: "ASX:GBT",
      companyName: "GBST HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gbi",
      code: "ASX:GBI",
      companyName: "GENERA BIOSYSTEMS LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-tak",
      code: "NASDAQ:TAK",
      companyName:
        "Takeda Pharmaceutical Company Limited American Depositary Shares (each representing 1/2 of a share of Common Stock)",
      popularity: 0,
    },
    {
      slug: "asx-glv",
      code: "ASX:GLV",
      companyName: "Global Oil & Gas Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-tela",
      code: "NASDAQ:TELA",
      companyName: "TELA Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gsm",
      code: "ASX:GSM",
      companyName: "Golden State Mining Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bkng",
      code: "NYSE:BKNG",
      companyName: "Booking Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gmn",
      code: "ASX:GMN",
      companyName: "Gold Mountain Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gmr",
      code: "ASX:GMR",
      companyName: "Golden Rim Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gvf",
      code: "ASX:GVF",
      companyName: "Staude Capital Global Value Fund Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-kbr",
      code: "NYSE:KBR",
      companyName: "KBR Inc.",
      popularity: 0,
    },
    {
      slug: "asx-gcn",
      code: "ASX:GCN",
      companyName: "GOCONNECT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ged",
      code: "ASX:GED",
      companyName: "Golden Deeps Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gow",
      code: "ASX:GOW",
      companyName: "Gowing Bros Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gps",
      code: "ASX:GPS",
      companyName: "GPS Alliance Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gor",
      code: "ASX:GOR",
      companyName: "Gold Road Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-abt",
      code: "NYSE:ABT",
      companyName: "Abbott Laboratories",
      popularity: 0,
    },
    {
      slug: "asx-g88",
      code: "ASX:G88",
      companyName: "Golden Mile Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-tyl",
      code: "NYSE:TYL",
      companyName: "Tyler Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-sbux",
      code: "NASDAQ:SBUX",
      companyName: "Starbucks Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snps",
      code: "NASDAQ:SNPS",
      companyName: "Synopsys Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gfl",
      code: "ASX:GFL",
      companyName: "Global Masters Fund Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gbe",
      code: "ASX:GBE",
      companyName: "Globe Metals & Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gc1",
      code: "ASX:GC1",
      companyName: "Glennon Small Companies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gcr",
      code: "ASX:GCR",
      companyName: "Golden Cross Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-vtr",
      code: "NASDAQ:VTR",
      companyName: "Ventas Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sivb",
      code: "NYSE:SIVB",
      companyName: "SVB Financial Group",
      popularity: 0,
    },
    {
      slug: "asx-gra",
      code: "ASX:GRA",
      companyName: "GOLD TIGER RESOURCES (AUSTRALIA) LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-thc",
      code: "NYSE:THC",
      companyName: "Tenet Healthcare Corporation New",
      popularity: 0,
    },
    {
      slug: "asx-gev",
      code: "ASX:GEV",
      companyName: "GLOBAL ENERGY VENTURES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gfi",
      code: "ASX:GFI",
      companyName: "GLOBAL FORTUNE INVESTMENT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-glb",
      code: "ASX:GLB",
      companyName: "Globe International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gle",
      code: "ASX:GLE",
      companyName: "GLG Corp Ltd",
      popularity: 0,
    },
    {
      slug: "asx-glh",
      code: "ASX:GLH",
      companyName: "Global Health Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-imvt",
      code: "NASDAQ:IMVT",
      companyName: "Immunovant Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-gbp",
      code: "ASX:GBP",
      companyName: "GLOBAL PETROLEUM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gng",
      code: "ASX:GNG",
      companyName: "GR Engineering Services Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gme",
      code: "ASX:GME",
      companyName: "GME RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-goo",
      code: "ASX:GOO",
      companyName: "GOOROO VENTURES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-har",
      code: "ASX:HAR",
      companyName: "Haranga Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hli",
      code: "ASX:HLI",
      companyName: "Helia Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-eg1",
      code: "ASX:EG1",
      companyName: "Evergreen Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gul",
      code: "ASX:GUL",
      companyName: "Gullewa Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hls",
      code: "ASX:HLS",
      companyName: "Healius Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gwr",
      code: "ASX:GWR",
      companyName: "GWR Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-h2g",
      code: "ASX:H2G",
      companyName: "GREENHY2 Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ht8",
      code: "ASX:HT8",
      companyName: "Harris Technology Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hdy",
      code: "ASX:HDY",
      companyName: "HARDEY RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wa8",
      code: "ASX:WA8",
      companyName: "Warriedar Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hav",
      code: "ASX:HAV",
      companyName: "Havilah Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hmx",
      code: "ASX:HMX",
      companyName: "Hammer Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-haw",
      code: "ASX:HAW",
      companyName: "Hawthorn Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hog",
      code: "ASX:HOG",
      companyName: "HAWKLEY OIL AND GAS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hwk",
      code: "ASX:HWK",
      companyName: "HAWKSTONE MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hgh",
      code: "ASX:HGH",
      companyName: "Heartland Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-now",
      code: "NYSE:NOW",
      companyName: "SERVICENOW INC.",
      popularity: 0,
    },
    {
      slug: "asx-hso",
      code: "ASX:HSO",
      companyName: "HEALTHSCOPE LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-hmo",
      code: "ASX:HMO",
      companyName: "HEARMEOUT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hsn",
      code: "ASX:HSN",
      companyName: "Hansen Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hm1",
      code: "ASX:HM1",
      companyName: "Hearts and Minds Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-adc",
      code: "ASX:ADC",
      companyName: "Acdc Metals Ltd",
      popularity: 21000,
    },
    {
      slug: "asx-hml",
      code: "ASX:HML",
      companyName: "HENRY MORGAN LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hrr",
      code: "ASX:HRR",
      companyName: "HERON RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hnr",
      code: "ASX:HNR",
      companyName: "Hannans Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hhy",
      code: "ASX:HHY",
      companyName: "HHY FUND",
      popularity: 0,
    },
    {
      slug: "asx-hgm",
      code: "ASX:HGM",
      companyName: "HIGH GRADE METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hig",
      code: "ASX:HIG",
      companyName: "HIGHLANDS PACIFIC LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-has",
      code: "ASX:HAS",
      companyName: "Hastings Technology Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hip",
      code: "ASX:HIP",
      companyName: "HIPO RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gwa",
      code: "ASX:GWA",
      companyName: "GWA Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tvn",
      code: "ASX:TVN",
      companyName: "Tivan Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hla",
      code: "ASX:HLA",
      companyName: "Healthia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gmc",
      code: "ASX:GMC",
      companyName: "GULF MANGANESE CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hzr",
      code: "ASX:HZR",
      companyName: "HAZER Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-axn",
      code: "ASX:AXN",
      companyName: "Alliance Nickel Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hhm",
      code: "ASX:HHM",
      companyName: "HAMPTON HILL MINING NL",
      popularity: 0,
    },
    {
      slug: "asx-nth",
      code: "ASX:NTH",
      companyName: "NORTHSTAR ENERGY LTD",
      popularity: 0,
    },
    {
      slug: "asx-sul",
      code: "ASX:SUL",
      companyName: "Super Retail Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hgl",
      code: "ASX:HGL",
      companyName: "Hudson Investment Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hsc",
      code: "ASX:HSC",
      companyName: "HSC TECHNOLOGY GROUP LTD",
      popularity: 0,
    },
    {
      slug: "asx-hor",
      code: "ASX:HOR",
      companyName: "Horseshoe Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hrn",
      code: "ASX:HRN",
      companyName: "Horizon Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hrl",
      code: "ASX:HRL",
      companyName: "HRL HOLDINGS LTD",
      popularity: 0,
    },
    {
      slug: "asx-hta",
      code: "ASX:HTA",
      companyName: "Hutchison Telecommunications (Australia) Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hch",
      code: "ASX:HCH",
      companyName: "Hot Chili Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ht1",
      code: "ASX:HT1",
      companyName: "HT&E LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hyd",
      code: "ASX:HYD",
      companyName: "HYDRIX Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hcs",
      code: "ASX:HCS",
      companyName: "HYUNDAI CAPITAL SERVICES INC.",
      popularity: 0,
    },
    {
      slug: "asx-hpi",
      code: "ASX:HPI",
      companyName: "Hotel Property Investments",
      popularity: 0,
    },
    {
      slug: "asx-ics",
      code: "ASX:ICS",
      companyName: "ICSGLOBAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hzn",
      code: "ASX:HZN",
      companyName: "Horizon Oil Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hdx",
      code: "ASX:HDX",
      companyName: "HUGHES DRILLING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-id8",
      code: "ASX:ID8",
      companyName: "Identitii Ltd",
      popularity: 0,
    },
    {
      slug: "asx-huo",
      code: "ASX:HUO",
      companyName: "HUON AQUACULTURE GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-is3",
      code: "ASX:IS3",
      companyName: "I Synergy Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-icn",
      code: "ASX:ICN",
      companyName: "Icon Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nxt",
      code: "ASX:NXT",
      companyName: "NEXTDC Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ici",
      code: "ASX:ICI",
      companyName: "Icandy Interactive Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nwh",
      code: "ASX:NWH",
      companyName: "NRW Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hco",
      code: "ASX:HCO",
      companyName: "HYLEA METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-iab",
      code: "ASX:IAB",
      companyName: "IAB HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ian",
      code: "ASX:IAN",
      companyName: "IAG FINANCE (NEW ZEALAND) LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ib8",
      code: "ASX:IB8",
      companyName: "IBOSSES CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hot",
      code: "ASX:HOT",
      companyName: "HOTCOPPER HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ibn",
      code: "ASX:IBN",
      companyName: "IBUYNEW GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-icq",
      code: "ASX:ICQ",
      companyName: "ICAR ASIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ict",
      code: "ASX:ICT",
      companyName: "ICOLLEGE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-idf",
      code: "ASX:IDF",
      companyName: "IDOL 2010-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-idh",
      code: "ASX:IDH",
      companyName: "IDOL 2011-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ifm",
      code: "ASX:IFM",
      companyName: "Infomedia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ing",
      code: "ASX:ING",
      companyName: "Inghams Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-dash",
      code: "NASDAQ:DASH",
      companyName: "DoorDash Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-imu",
      code: "ASX:IMU",
      companyName: "Imugene Ltd",
      popularity: 0,
    },
    {
      slug: "asx-brn",
      code: "ASX:BRN",
      companyName: "Brainchip Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-icg",
      code: "ASX:ICG",
      companyName: "Inca Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tne",
      code: "ASX:TNE",
      companyName: "Technology One Ltd",
      popularity: 0,
    },
    {
      slug: "asx-idx",
      code: "ASX:IDX",
      companyName: "Integral Diagnostics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-inf",
      code: "ASX:INF",
      companyName: "Infinity Lithium Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cda",
      code: "ASX:CDA",
      companyName: "Codan Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ipd",
      code: "ASX:IPD",
      companyName: "Impedimed Ltd",
      popularity: 0,
    },
    {
      slug: "asx-inp",
      code: "ASX:INP",
      companyName: "Incentiapay Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ipc",
      code: "ASX:IPC",
      companyName: "Imperial Pacific Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ida",
      code: "ASX:IDA",
      companyName: "Indiana Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ifn",
      code: "ASX:IFN",
      companyName: "INFIGEN ENERGY",
      popularity: 0,
    },
    {
      slug: "asx-ihl",
      code: "ASX:IHL",
      companyName: "Incannex Healthcare Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ind",
      code: "ASX:IND",
      companyName: "Industrial Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ims",
      code: "ASX:IMS",
      companyName: "IMPELUS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ift",
      code: "ASX:IFT",
      companyName: "Infratil Ltd",
      popularity: 0,
    },
    {
      slug: "asx-deg",
      code: "ASX:DEG",
      companyName: "De Grey Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ink",
      code: "ASX:INK",
      companyName: "INDAGO ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-irl",
      code: "ASX:IRL",
      companyName: "INDIA RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ior",
      code: "ASX:IOR",
      companyName: "INDIORE LTD",
      popularity: 0,
    },
    {
      slug: "asx-idz",
      code: "ASX:IDZ",
      companyName: "INDOOR SKYDIVE AUSTRALIA GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-icb",
      code: "ASX:ICB",
      companyName: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ige",
      code: "ASX:IGE",
      companyName: "INTEGRATED GREEN ENERGY SOLUTIONS LTD",
      popularity: 0,
    },
    {
      slug: "asx-ip1",
      code: "ASX:IP1",
      companyName: "INTEGRATED PAYMENT TECHNOLOGIES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ivz",
      code: "ASX:IVZ",
      companyName: "Invictus Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-inr",
      code: "ASX:INR",
      companyName: "Ioneer Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ixu",
      code: "ASX:IXU",
      companyName: "Ixup Ltd",
      popularity: 0,
    },
    {
      slug: "asx-skc",
      code: "ASX:SKC",
      companyName: "Skycity Entertainment Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vea",
      code: "ASX:VEA",
      companyName: "Viva Energy Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jan",
      code: "ASX:JAN",
      companyName: "Janison Education Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-isx",
      code: "ASX:ISX",
      companyName: "ISIGNTHIS LTD",
      popularity: 0,
    },
    {
      slug: "asx-ivq",
      code: "ASX:IVQ",
      companyName: "INVITROCUE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ibc",
      code: "ASX:IBC",
      companyName: "Ironbark Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iod",
      code: "ASX:IOD",
      companyName: "Iodm Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ipb",
      code: "ASX:IPB",
      companyName: "IPB Petroleum Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-anet",
      code: "NASDAQ:ANET",
      companyName: "Arista Networks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-iot",
      code: "ASX:IOT",
      companyName: "IOT GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ird",
      code: "ASX:IRD",
      companyName: "Iron Road Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ibg",
      code: "ASX:IBG",
      companyName: "Ironbark ZINC Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ire",
      code: "ASX:IRE",
      companyName: "Iress Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ivx",
      code: "ASX:IVX",
      companyName: "Invion Ltd",
      popularity: 0,
    },
    {
      slug: "asx-icu",
      code: "ASX:ICU",
      companyName: "Investor Centre Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jat",
      code: "ASX:JAT",
      companyName: "Jatcorp Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iq3",
      code: "ASX:IQ3",
      companyName: "IQ3CORP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ivc",
      code: "ASX:IVC",
      companyName: "Invocare Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mrm",
      code: "ASX:MRM",
      companyName: "Mma Offshore Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ivo",
      code: "ASX:IVO",
      companyName: "Invigor Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bbn",
      code: "NYSE:BBN",
      companyName: "BlackRock Taxable Municipal Bond Trust",
      popularity: 0,
    },
    {
      slug: "asx-jal",
      code: "ASX:JAL",
      companyName: "Jameson Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-isu",
      code: "ASX:ISU",
      companyName: "ISELECT LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-isd",
      code: "ASX:ISD",
      companyName: "ISENTIA GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-jip",
      code: "ASX:JIP",
      companyName: "JACK-IN GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-jka",
      code: "ASX:JKA",
      companyName: "JACKA RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-jdr",
      code: "ASX:JDR",
      companyName: "JADAR RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-jpr",
      code: "ASX:JPR",
      companyName: "Jupiter Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dvpn",
      code: "ASX:DVPN",
      companyName: "Develop Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kas",
      code: "ASX:KAS",
      companyName: "KASBAH RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kai",
      code: "ASX:KAI",
      companyName: "Kairos Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kam",
      code: "ASX:KAM",
      companyName: "K2 Asset Management Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hrnn",
      code: "ASX:HRNN",
      companyName: "Horizon Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aqlt",
      code: "ASX:AQLT",
      companyName: "Betashares Australian Quality ETF",
      popularity: 21000,
    },
    {
      slug: "asx-keb",
      code: "ASX:KEB",
      companyName: "KEB HANA BANK",
      popularity: 0,
    },
    {
      slug: "asx-ktd",
      code: "ASX:KTD",
      companyName: "KEYTONE DAIRY CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kat",
      code: "ASX:KAT",
      companyName: "Katana Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kmd",
      code: "ASX:KMD",
      companyName: "KMD Brands Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aasf",
      code: "ASX:AASF",
      companyName: "Airlie Australian Share Fund (Managed Fund)",
      popularity: 14000,
    },
    {
      slug: "asx-k2f",
      code: "ASX:K2F",
      companyName: "K2FLY Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gcy",
      code: "ASX:GCY",
      companyName: "Gascoyne Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-klr",
      code: "ASX:KLR",
      companyName: "Kaili Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kzr",
      code: "ASX:KZR",
      companyName: "Kalamazoo Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kll",
      code: "ASX:KLL",
      companyName: "Kalium Lakes Ltd",
      popularity: 0,
    },
    {
      slug: "asx-knl",
      code: "ASX:KNL",
      companyName: "KIBARAN RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kdr",
      code: "ASX:KDR",
      companyName: "KIDMAN RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kpe",
      code: "ASX:KPE",
      companyName: "KINA PETROLEUM CORPORATION",
      popularity: 0,
    },
    {
      slug: "asx-kpl",
      code: "ASX:KPL",
      companyName: "KINA PETROLEUM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kpc",
      code: "ASX:KPC",
      companyName: "KAZAKHSTAN POTASH CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kis",
      code: "ASX:KIS",
      companyName: "KING ISLAND SCHEELITE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lke",
      code: "ASX:LKE",
      companyName: "Lake Resources N.L.",
      popularity: 0,
    },
    {
      slug: "asx-ksc",
      code: "ASX:KSC",
      companyName: "K & S Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kla",
      code: "ASX:KLA",
      companyName: "KIRKLAND LAKE GOLD LTD",
      popularity: 0,
    },
    {
      slug: "nyse-evn",
      code: "NYSE:EVN",
      companyName: "Eaton Vance Municipal Income Trust",
      popularity: 0,
    },
    {
      slug: "asx-wer",
      code: "ASX:WER",
      companyName: "WESTERN AUSTRALIA ENERGY RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kfw",
      code: "ASX:KFW",
      companyName: "KFW",
      popularity: 0,
    },
    {
      slug: "asx-jvg",
      code: "ASX:JVG",
      companyName: "JV GLOBAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kig",
      code: "ASX:KIG",
      companyName: "KINGFISHER TRUST 2016-1",
      popularity: 0,
    },
    {
      slug: "asx-dtrn",
      code: "ASX:DTRN",
      companyName: "Dateline Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kte",
      code: "ASX:KTE",
      companyName: "K2 ENERGY LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-rdmnb",
      code: "ASX:RDMNB",
      companyName: "Red Metal Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sq2",
      code: "ASX:SQ2",
      companyName: "Block Inc",
      popularity: 0,
    },
    {
      slug: "asx-kik",
      code: "ASX:KIK",
      companyName: "KAIRIKI ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lm1",
      code: "ASX:LM1",
      companyName: "Leeuwin Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-klh",
      code: "ASX:KLH",
      companyName: "KALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cc9",
      code: "ASX:CC9",
      companyName: "Chariot Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-adef",
      code: "ASX:ADEF",
      companyName: "Apostle Dundas Global Equity Classd (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-aesg",
      code: "ASX:AESG",
      companyName: "Ishares Global Aggregate Bond Esg (Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-kgm",
      code: "ASX:KGM",
      companyName: "KALNORTH GOLD MINES LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-ceva",
      code: "NASDAQ:CEVA",
      companyName: "CEVA Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-kpt",
      code: "ASX:KPT",
      companyName: "KANGAROO ISLAND PLANTATION TIMBERS LTD",
      popularity: 0,
    },
    {
      slug: "asx-jms",
      code: "ASX:JMS",
      companyName: "Jupiter Mines Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsfg",
      code: "NASDAQ:FSFG",
      companyName: "First Savings Financial Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-tmxna",
      code: "ASX:TMXNA",
      companyName: "Terrain Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mxcda",
      code: "ASX:MXCDA",
      companyName: "MGC Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cwxr",
      code: "ASX:CWXR",
      companyName: "Carawine Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kpo",
      code: "ASX:KPO",
      companyName: "Kalina Power Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lotn",
      code: "ASX:LOTN",
      companyName: "Lotus Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mgtr",
      code: "ASX:MGTR",
      companyName: "Magnetite Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lsf",
      code: "ASX:LSF",
      companyName: "L1 Long Short Fund Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kmt",
      code: "ASX:KMT",
      companyName: "KOPORE METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rio",
      code: "ASX:RIO",
      companyName: "RIO Tinto Ltd",
      popularity: 0,
    },
    {
      slug: "asx-krx",
      code: "ASX:KRX",
      companyName: "KOPPAR RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rms",
      code: "ASX:RMS",
      companyName: "Ramelius Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dyl",
      code: "ASX:DYL",
      companyName: "Deep Yellow Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pdn",
      code: "ASX:PDN",
      companyName: "Paladin Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kgd",
      code: "ASX:KGD",
      companyName: "Kula Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-knm",
      code: "ASX:KNM",
      companyName: "Kneomedia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ltf",
      code: "ASX:LTF",
      companyName: "LA TROBE FINANCIAL CAPITAL MARKETS TRUST 2018-1",
      popularity: 0,
    },
    {
      slug: "asx-lt1",
      code: "ASX:LT1",
      companyName: "LA TROBE FINANCIAL CAPITAL MARKETS TRUST 2018-2",
      popularity: 0,
    },
    {
      slug: "asx-kno",
      code: "ASX:KNO",
      companyName: "Knosys Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kor",
      code: "ASX:KOR",
      companyName: "Korab Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-edv",
      code: "ASX:EDV",
      companyName: "Endeavour Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kss",
      code: "ASX:KSS",
      companyName: "Kleos Space S.A",
      popularity: 0,
    },
    {
      slug: "asx-lhm",
      code: "ASX:LHM",
      companyName: "Land & Homes Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lsa",
      code: "ASX:LSA",
      companyName: "Lachlan Star Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kop",
      code: "ASX:KOP",
      companyName: "KOREA SOUTH-EAST POWER CO LTD",
      popularity: 0,
    },
    {
      slug: "asx-lko",
      code: "ASX:LKO",
      companyName: "Lakes Blue Energy NL",
      popularity: 0,
    },
    {
      slug: "asx-kov",
      code: "ASX:KOV",
      companyName: "Korvest Ltd",
      popularity: 0,
    },
    {
      slug: "asx-krs",
      code: "ASX:KRS",
      companyName: "KRESTA HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bcom",
      code: "ASX:BCOM",
      companyName: "Global X Bloomberg Commodity ETF (Synthetic)",
      popularity: 0,
    },
    {
      slug: "asx-kyk",
      code: "ASX:KYK",
      companyName: "KYCKR LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ddr",
      code: "ASX:DDR",
      companyName: "Dicker Data Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mgr",
      code: "ASX:MGR",
      companyName: "Mirvac Group",
      popularity: 0,
    },
    {
      slug: "asx-nugg",
      code: "ASX:NUGG",
      companyName: "Vaneck Gold Bullion ETF",
      popularity: 0,
    },
    {
      slug: "asx-kp2",
      code: "ASX:KP2",
      companyName: "Kore Potash Plc",
      popularity: 0,
    },
    {
      slug: "asx-kta",
      code: "ASX:KTA",
      companyName: "Krakatoa Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kfe",
      code: "ASX:KFE",
      companyName: "KOGI IRON LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kgn",
      code: "ASX:KGN",
      companyName: "Kogan.com Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kol",
      code: "ASX:KOL",
      companyName: "KOLIGO THERAPEUTICS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kkl",
      code: "ASX:KKL",
      companyName: "KOLLAKORN CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-kkt",
      code: "ASX:KKT",
      companyName: "KONEKT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-knh",
      code: "ASX:KNH",
      companyName: "KOON HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-yal",
      code: "ASX:YAL",
      companyName: "Yancoal Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lmw",
      code: "ASX:LMW",
      companyName: "LANDMARK WHITE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lny",
      code: "ASX:LNY",
      companyName: "LANEWAY RESOURCES LTD",
      popularity: 0,
    },
    {
      slug: "asx-lgr",
      code: "ASX:LGR",
      companyName: "LANKA GRAPHITE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ltn",
      code: "ASX:LTN",
      companyName: "LANTERN HOTEL GROUP",
      popularity: 0,
    },
    {
      slug: "asx-lnu",
      code: "ASX:LNU",
      companyName: "Linius Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kar",
      code: "ASX:KAR",
      companyName: "Karoon Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lml",
      code: "ASX:LML",
      companyName: "Lincoln Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-atec",
      code: "ASX:ATEC",
      companyName: "Betashares S&P/ASX Australian Technology ETF",
      popularity: 0,
    },
    {
      slug: "asx-lio",
      code: "ASX:LIO",
      companyName: "Lion Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lct",
      code: "ASX:LCT",
      companyName: "Living Cell Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lbtn",
      code: "ASX:LBTN",
      companyName: "LBT Innovations Ltd",
      popularity: 0,
    },
    {
      slug: "asx-llo",
      code: "ASX:LLO",
      companyName: "Lion One Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lic",
      code: "ASX:LIC",
      companyName: "Lifestyle Communities Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lsh",
      code: "ASX:LSH",
      companyName: "LIFESPOT HEALTH LTD",
      popularity: 0,
    },
    {
      slug: "asx-lnk",
      code: "ASX:LNK",
      companyName: "Link Administration Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lvt",
      code: "ASX:LVT",
      companyName: "Livetiles Ltd",
      popularity: 0,
    },
    {
      slug: "asx-devn",
      code: "ASX:DEVN",
      companyName: "DEVEX Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lpi",
      code: "ASX:LPI",
      companyName: "Lithium Power International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mdir",
      code: "ASX:MDIR",
      companyName: "Middle Island Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nge",
      code: "ASX:NGE",
      companyName: "NGE Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mrn",
      code: "ASX:MRN",
      companyName: "MACQUARIE MEDIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-frsn",
      code: "ASX:FRSN",
      companyName: "Forrestania Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-li2",
      code: "ASX:LI2",
      companyName:
        "LIBERTY FUNDING PTY LTD IN RESPECT OF LIBERTY SERIES 2018-1",
      popularity: 0,
    },
    {
      slug: "asx-mld",
      code: "ASX:MLD",
      companyName: "MACA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-li5",
      code: "ASX:LI5",
      companyName:
        "LIBERTY FUNDING PTY LTD IN RESPECT OF LIBERTY SERIES 2018-3",
      popularity: 0,
    },
    {
      slug: "asx-lau",
      code: "ASX:LAU",
      companyName: "Lindsay Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-frsr",
      code: "ASX:FRSR",
      companyName: "Forrestania Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-qcom",
      code: "NASDAQ:QCOM",
      companyName: "QUALCOMM Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-mbl",
      code: "ASX:MBL",
      companyName: "MACQUARIE BANK LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lsx",
      code: "ASX:LSX",
      companyName: "Lion Selection Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsm",
      code: "NASDAQ:TSM",
      companyName: "Taiwan Semiconductor Manufacturing Company Ltd.",
      popularity: 0,
    },
    {
      slug: "asx-lo1",
      code: "ASX:LO1",
      companyName: "LLOYDS BANKING GROUP PLC",
      popularity: 0,
    },
    {
      slug: "asx-nrzr",
      code: "ASX:NRZR",
      companyName: "Neurizer Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lng",
      code: "ASX:LNG",
      companyName: "LIQUEFIED NATURAL GAS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lhb",
      code: "ASX:LHB",
      companyName: "LIONHUB GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-asv",
      code: "ASX:ASV",
      companyName: "Asset Vision Co Ltd",
      popularity: 0,
    },
    {
      slug: "asx-skuk",
      code: "ASX:SKUK",
      companyName: "HEJAZ Sukuk Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-gldn",
      code: "ASX:GLDN",
      companyName: "Ishares Physical Gold ETF",
      popularity: 0,
    },
    {
      slug: "asx-li3",
      code: "ASX:LI3",
      companyName: "LITHIUM CONSOLIDATED LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tipda",
      code: "ASX:TIPDA",
      companyName: "Teaminvest Private Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lit",
      code: "ASX:LIT",
      companyName: "Lithium Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-twer",
      code: "ASX:TWER",
      companyName: "Treasury Wine Estates Ltd",
      popularity: 0,
    },
    {
      slug: "asx-atg",
      code: "ASX:ATG",
      companyName: "Articore Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lcm",
      code: "ASX:LCM",
      companyName: "LOGICAMMS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lgo",
      code: "ASX:LGO",
      companyName: "LONGREACH OIL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lvh",
      code: "ASX:LVH",
      companyName: "Livehire Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vfx",
      code: "ASX:VFX",
      companyName: "Visionflex Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-vrt",
      code: "NYSE:VRT",
      companyName: "Vertiv Holdings Co Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-li4",
      code: "ASX:LI4",
      companyName:
        "LIBERTY FUNDING PTY LTD IN RESPECT OF LIBERTY SERIES 2017-3",
      popularity: 0,
    },
    {
      slug: "asx-li1",
      code: "ASX:LI1",
      companyName:
        "LIBERTY FUNDING PTY LTD IN RESPECT OF LIBERTY SERIES 2017-4",
      popularity: 0,
    },
    {
      slug: "asx-vtin",
      code: "ASX:VTIN",
      companyName: "Visioneering Technologies Inc",
      popularity: 0,
    },
    {
      slug: "asx-lon",
      code: "ASX:LON",
      companyName: "LONGTABLE GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lrm",
      code: "ASX:LRM",
      companyName: "LUSTRUM MINERALS LTD",
      popularity: 0,
    },
    {
      slug: "asx-mrp",
      code: "ASX:MRP",
      companyName: "MACPHERSONS RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecf-a",
      code: "NASDAQ:ECF-A",
      companyName:
        "Ellsworth Growth and Income Fund Ltd. 5.25% Series A Cumulative Preferred Shares (Liquidation Preference $25.00 per share)",
      popularity: 0,
    },
    {
      slug: "nyse-expe",
      code: "NYSE:EXPE",
      companyName: "Expedia Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-jnon",
      code: "ASX:JNON",
      companyName: "Juno Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-anxn",
      code: "ASX:ANXN",
      companyName: "ANAX Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cwxn",
      code: "ASX:CWXN",
      companyName: "Carawine Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-meu",
      code: "ASX:MEU",
      companyName: "Marmota Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mtl",
      code: "ASX:MTL",
      companyName: "Mantle Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mai",
      code: "ASX:MAI",
      companyName: "MAINSTREAM GROUP HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mqr",
      code: "ASX:MQR",
      companyName: "Marquee Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mye",
      code: "ASX:MYE",
      companyName: "Metarock Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mcp",
      code: "ASX:MCP",
      companyName: "Mcpherson's Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mxr",
      code: "ASX:MXR",
      companyName: "Maximus Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mag",
      code: "ASX:MAG",
      companyName: "Magmatic Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mgg",
      code: "ASX:MGG",
      companyName: "Mogul Games Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mrl",
      code: "ASX:MRL",
      companyName: "Mayur Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-for",
      code: "ASX:FOR",
      companyName: "Forager Australian Shares Fund",
      popularity: 0,
    },
    {
      slug: "asx-mar",
      code: "ASX:MAR",
      companyName: "MALACHITE RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mgp",
      code: "ASX:MGP",
      companyName: "MANAGED ACCOUNTS HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mcm",
      code: "ASX:MCM",
      companyName: "MC Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mey",
      code: "ASX:MEY",
      companyName: "MARENICA ENERGY LTD",
      popularity: 0,
    },
    {
      slug: "nyse-cve",
      code: "NYSE:CVE",
      companyName: "Cenovus Energy Inc.",
      popularity: 0,
    },
    {
      slug: "asx-mzn",
      code: "ASX:MZN",
      companyName: "MARINDI METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mcx",
      code: "ASX:MCX",
      companyName: "Mariner Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mfd",
      code: "ASX:MFD",
      companyName: "Mayfield Childcare Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mns",
      code: "ASX:MNS",
      companyName: "Magnis Energy Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mau",
      code: "ASX:MAU",
      companyName: "Magnetic Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-mgl",
      code: "ASX:MGL",
      companyName: "Magontec Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mgt",
      code: "ASX:MGT",
      companyName: "Magnetite Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mkg",
      code: "ASX:MKG",
      companyName: "Mako Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fex",
      code: "ASX:FEX",
      companyName: "FENIX Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mtm",
      code: "ASX:MTM",
      companyName: "MTM Critical Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mce",
      code: "ASX:MCE",
      companyName: "Matrix Composites & Engineering Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mhc",
      code: "ASX:MHC",
      companyName: "Manhattan Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-myx",
      code: "ASX:MYX",
      companyName: "Mayne Pharma Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mat",
      code: "ASX:MAT",
      companyName: "Matsa Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-afgb",
      code: "NASDAQ:AFGB",
      companyName:
        "American Financial Group Inc. 5.875% Subordinated Debentures due 2059",
      popularity: 0,
    },
    {
      slug: "asx-mea",
      code: "ASX:MEA",
      companyName: "Mcgrath Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mzz",
      code: "ASX:MZZ",
      companyName: "Matador Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mmm",
      code: "ASX:MMM",
      companyName: "Marley Spoon Se",
      popularity: 0,
    },
    {
      slug: "asx-nbi",
      code: "ASX:NBI",
      companyName: "NB Global Corporate Income Trust",
      popularity: 0,
    },
    {
      slug: "asx-fgx",
      code: "ASX:FGX",
      companyName: "Future Generation Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mgu",
      code: "ASX:MGU",
      companyName: "Magnum Mining and Exploration Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mxi",
      code: "ASX:MXI",
      companyName: "Maxiparts Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mpz",
      code: "ASX:MPZ",
      companyName: "MEDALLION TRUST SERIES 2014-1P",
      popularity: 0,
    },
    {
      slug: "asx-mzf",
      code: "ASX:MZF",
      companyName: "MEDALLION TRUST SERIES 2016-1",
      popularity: 0,
    },
    {
      slug: "asx-mzt",
      code: "ASX:MZT",
      companyName: "MEDALLION TRUST SERIES 2016-2",
      popularity: 0,
    },
    {
      slug: "asx-may",
      code: "ASX:MAY",
      companyName: "Melbana Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mz1",
      code: "ASX:MZ1",
      companyName: "MEDALLION TRUST SERIES 2017-1",
      popularity: 0,
    },
    {
      slug: "asx-mz2",
      code: "ASX:MZ2",
      companyName: "MEDALLION TRUST SERIES 2017-2",
      popularity: 0,
    },
    {
      slug: "asx-mp1",
      code: "ASX:MP1",
      companyName: "Megaport Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mbj",
      code: "ASX:MBJ",
      companyName: "MEDALLION TRUST SERIES 2013-2",
      popularity: 0,
    },
    {
      slug: "asx-mdz",
      code: "ASX:MDZ",
      companyName: "MEDALLION TRUST SERIES 2014-1",
      popularity: 0,
    },
    {
      slug: "asx-mvt",
      code: "ASX:MVT",
      companyName: "MERCANTILE INVESTMENT COMPANY LTD",
      popularity: 0,
    },
    {
      slug: "asx-mcy",
      code: "ASX:MCY",
      companyName: "Mercury NZ Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nem",
      code: "ASX:NEM",
      companyName: "Newmont Corporation",
      popularity: 0,
    },
    {
      slug: "asx-mdc",
      code: "ASX:MDC",
      companyName: "Medlab Clinical Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mhi",
      code: "ASX:MHI",
      companyName: "Merchant House International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mlm",
      code: "ASX:MLM",
      companyName: "Metallica Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-msb",
      code: "ASX:MSB",
      companyName: "Mesoblast Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mzb",
      code: "ASX:MZB",
      companyName: "MEDALLION TRUST SERIES 2014-2",
      popularity: 0,
    },
    {
      slug: "asx-cd1",
      code: "ASX:CD1",
      companyName: "CD Private Equity Fund I",
      popularity: 0,
    },
    {
      slug: "asx-cd2",
      code: "ASX:CD2",
      companyName: "CD Private Equity Fund Ii",
      popularity: 0,
    },
    {
      slug: "asx-mza",
      code: "ASX:MZA",
      companyName: "MEDALLION TRUST SERIES 2015-1",
      popularity: 0,
    },
    {
      slug: "asx-mzc",
      code: "ASX:MZC",
      companyName: "MEDALLION TRUST SERIES 2015-2",
      popularity: 0,
    },
    {
      slug: "asx-vdhg",
      code: "ASX:VDHG",
      companyName: "Vanguard Diversified High Growth INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-vgs",
      code: "ASX:VGS",
      companyName: "Vanguard MSCI INDEX International Shares ETF",
      popularity: 0,
    },
    {
      slug: "asx-dhhf",
      code: "ASX:DHHF",
      companyName: "Betashares Diversified All Growth ETF",
      popularity: 0,
    },
    {
      slug: "asx-mem",
      code: "ASX:MEM",
      companyName: "Memphasys Ltd",
      popularity: 0,
    },
    {
      slug: "asx-meb",
      code: "ASX:MEB",
      companyName: "Medibio Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mvp",
      code: "ASX:MVP",
      companyName: "Medical Developments International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mct",
      code: "ASX:MCT",
      companyName: "Metalicity Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mgz",
      code: "ASX:MGZ",
      companyName: "MEDIGARD LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mph",
      code: "ASX:MPH",
      companyName: "MEDILAND PHARM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mbk",
      code: "ASX:MBK",
      companyName: "Metal Bank Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mml",
      code: "ASX:MML",
      companyName: "MEDUSA MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mjc",
      code: "ASX:MJC",
      companyName: "MEJORITY CAPITAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-med",
      code: "ASX:MED",
      companyName: "MERLIN DIAMONDS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mas",
      code: "ASX:MAS",
      companyName: "MESA MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mdi",
      code: "ASX:MDI",
      companyName: "Middle Island Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mdx",
      code: "ASX:MDX",
      companyName: "Mindax Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gr8",
      code: "ASX:GR8",
      companyName: "Great Dirt Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mhd",
      code: "ASX:MHD",
      companyName: "MILLENNIUM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mlt",
      code: "ASX:MLT",
      companyName: "MILTON CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tok",
      code: "ASX:TOK",
      companyName: "Tolu Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mil",
      code: "ASX:MIL",
      companyName: "Millennium Services Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-moy",
      code: "ASX:MOY",
      companyName: "MILLENNIUM MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mhj",
      code: "ASX:MHJ",
      companyName: "Michael Hill International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mny",
      code: "ASX:MNY",
      companyName: "MONEY3 CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-max",
      code: "ASX:MAX",
      companyName: "MILLINIUM'S ALTERNATIVES FUND.",
      popularity: 0,
    },
    {
      slug: "asx-hvlu",
      code: "ASX:HVLU",
      companyName: "Vaneck MSCI International Value (Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-mx1",
      code: "ASX:MX1",
      companyName: "Micro-X Ltd",
      popularity: 0,
    },
    {
      slug: "asx-moc",
      code: "ASX:MOC",
      companyName: "MORTGAGE CHOICE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mnb",
      code: "ASX:MNB",
      companyName: "Minbos Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mohnb",
      code: "ASX:MOHNB",
      companyName: "Moho Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-atom",
      code: "ASX:ATOM",
      companyName: "Global X Uranium ETF",
      popularity: 0,
    },
    {
      slug: "nyse-borr",
      code: "NYSE:BORR",
      companyName: "Borr Drilling Limited",
      popularity: 0,
    },
    {
      slug: "asx-mep",
      code: "ASX:MEP",
      companyName: "MINOTAUR EXPLORATION LTD",
      popularity: 0,
    },
    {
      slug: "asx-mnw",
      code: "ASX:MNW",
      companyName: "MINT PAYMENTS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mbt",
      code: "ASX:MBT",
      companyName: "MISSION NEWENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mmg",
      code: "ASX:MMG",
      companyName: "MONGER GOLD LTD",
      popularity: 0,
    },
    {
      slug: "asx-mmj",
      code: "ASX:MMJ",
      companyName: "MMJ GROUP HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mnf",
      code: "ASX:MNF",
      companyName: "MNF GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mbm",
      code: "ASX:MBM",
      companyName: "MOBECOM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mrz",
      code: "ASX:MRZ",
      companyName: "Mont Royal Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mod",
      code: "ASX:MOD",
      companyName: "MOD RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-ne",
      code: "NYSE:NE",
      companyName: "Noble Corporation",
      popularity: 0,
    },
    {
      slug: "asx-moe",
      code: "ASX:MOE",
      companyName: "MOELIS AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mwy",
      code: "ASX:MWY",
      companyName: "Midway Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mpo",
      code: "ASX:MPO",
      companyName: "MOLOPO ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cxuna",
      code: "ASX:CXUNA",
      companyName: "Cauldron Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ma1",
      code: "ASX:MA1",
      companyName: "MONASH ABSOLUTE INVESTMENT COMPANY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-psin",
      code: "ASX:PSIN",
      companyName: "PSC Insurance Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mcr",
      code: "ASX:MCR",
      companyName: "Mincor Resources NL",
      popularity: 0,
    },
    {
      slug: "asx-mrc",
      code: "ASX:MRC",
      companyName: "Mineral Commodities Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qhsm",
      code: "ASX:QHSM",
      companyName: "Vaneck MSCI Intl SML Comp Quality (Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-ayld",
      code: "ASX:AYLD",
      companyName: "Global X S&P/ASX 200 Covered Call ETF",
      popularity: 0,
    },
    {
      slug: "asx-mec",
      code: "ASX:MEC",
      companyName: "Morphic Ethical Equities Fund Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-crh",
      code: "NYSE:CRH",
      companyName: "CRH Public Limited Company",
      popularity: 0,
    },
    {
      slug: "asx-bhyb",
      code: "ASX:BHYB",
      companyName: "Betashares Australian Major Bank Hybrids INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-mam",
      code: "ASX:MAM",
      companyName: "Microequities Asset Management Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mhot",
      code: "ASX:MHOT",
      companyName: "Vaneck Morningstar Wide Moat (Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-mgtn",
      code: "ASX:MGTN",
      companyName: "Magnetite Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cldd",
      code: "ASX:CLDD",
      companyName: "Betashares Cloud Computing ETF",
      popularity: 0,
    },
    {
      slug: "asx-mrv",
      code: "ASX:MRV",
      companyName: "MORETON RESOURCES LTD",
      popularity: 0,
    },
    {
      slug: "asx-mig",
      code: "ASX:MIG",
      companyName: "A.C.N. 059 457 279 LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pxa",
      code: "ASX:PXA",
      companyName: "Pexa Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mvf",
      code: "ASX:MVF",
      companyName: "Monash Ivf Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nag",
      code: "ASX:NAG",
      companyName: "Nagambie Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-myo",
      code: "ASX:MYO",
      companyName: "MYOB GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mtb",
      code: "ASX:MTB",
      companyName: "Mount Burgess Mining NL",
      popularity: 0,
    },
    {
      slug: "asx-mpr",
      code: "ASX:MPR",
      companyName: "Mpower Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mrd",
      code: "ASX:MRD",
      companyName: "Mount Ridley Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mgv",
      code: "ASX:MGV",
      companyName: "Musgrave Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-val",
      code: "NYSE:VAL",
      companyName: "Valaris Limited",
      popularity: 0,
    },
    {
      slug: "nyse-amh",
      code: "NYSE:AMH",
      companyName: "AMERICAN HOMES 4 RENT",
      popularity: 0,
    },
    {
      slug: "asx-mca",
      code: "ASX:MCA",
      companyName: "Murray Cod Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mrq",
      code: "ASX:MRQ",
      companyName: "MRG Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mys",
      code: "ASX:MYS",
      companyName: "Mystate Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mpx",
      code: "ASX:MPX",
      companyName: "Mustera Property Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-msi",
      code: "ASX:MSI",
      companyName: "Multistack International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nam",
      code: "ASX:NAM",
      companyName: "Namoi Cotton Ltd",
      popularity: 0,
    },
    {
      slug: "asx-myr",
      code: "ASX:MYR",
      companyName: "Myer Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-n1h",
      code: "ASX:N1H",
      companyName: "N1 Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nc6",
      code: "ASX:NC6",
      companyName: "Nanollose Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mto",
      code: "ASX:MTO",
      companyName: "Motorcycle Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mpw",
      code: "ASX:MPW",
      companyName: "MSL SOLUTIONS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-msm",
      code: "ASX:MSM",
      companyName: "MSM CORPORATION INTERNATIONAL LTD",
      popularity: 0,
    },
    {
      slug: "asx-mxu",
      code: "ASX:MXU",
      companyName: "MULTIPLEX SITES TRUST",
      popularity: 0,
    },
    {
      slug: "asx-mch",
      code: "ASX:MCH",
      companyName: "MURCHISON HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mrg",
      code: "ASX:MRG",
      companyName: "MURRAY RIVER ORGANICS GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mgx",
      code: "ASX:MGX",
      companyName: "Mount Gibson Iron Ltd",
      popularity: 0,
    },
    {
      slug: "asx-myl",
      code: "ASX:MYL",
      companyName: "MALLEE RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-myq",
      code: "ASX:MYQ",
      companyName: "MYFIZIQ LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mzi",
      code: "ASX:MZI",
      companyName: "MZI RESOURCES LTD",
      popularity: 0,
    },
    {
      slug: "asx-nxm",
      code: "ASX:NXM",
      companyName: "Nexus Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ncl",
      code: "ASX:NCL",
      companyName: "NETCCENTRIC LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nms",
      code: "ASX:NMS",
      companyName: "NEPTUNE MARINE SERVICES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nxs",
      code: "ASX:NXS",
      companyName: "Next Science Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nzk",
      code: "ASX:NZK",
      companyName: "New Zealand King Salmon Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nmt",
      code: "ASX:NMT",
      companyName: "Neometals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ntc",
      code: "ASX:NTC",
      companyName: "NETCOMM WIRELESS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nwf",
      code: "ASX:NWF",
      companyName: "Newfield Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nwl",
      code: "ASX:NWL",
      companyName: "Netwealth Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nwc",
      code: "ASX:NWC",
      companyName: "New World Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-agx1",
      code: "ASX:AGX1",
      companyName: "Antipodes Global Shares (Quoted Managed Fund)",
      popularity: 73000,
    },
    {
      slug: "asx-neu",
      code: "ASX:NEU",
      companyName: "Neuren Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nic",
      code: "ASX:NIC",
      companyName: "Nickel Industries Ltd",
      popularity: 0,
    },
    {
      slug: "asx-adh",
      code: "ASX:ADH",
      companyName: "Adairs Ltd",
      popularity: 647000,
    },
    {
      slug: "asx-nea",
      code: "ASX:NEA",
      companyName: "NEARMAP LTD",
      popularity: 0,
    },
    {
      slug: "asx-nxe",
      code: "ASX:NXE",
      companyName: "NEW ENERGY MINERALS LTD",
      popularity: 0,
    },
    {
      slug: "asx-nae",
      code: "ASX:NAE",
      companyName: "New Age Exploration Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nti",
      code: "ASX:NTI",
      companyName: "Neurotech International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ntl",
      code: "ASX:NTL",
      companyName: "New Talisman Gold Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nes",
      code: "ASX:NES",
      companyName: "Nelson Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-net",
      code: "ASX:NET",
      companyName: "Netlinkz Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nme",
      code: "ASX:NME",
      companyName: "NEX Metals Exploration Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ncz",
      code: "ASX:NCZ",
      companyName: "NEW CENTURY RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-new",
      code: "ASX:NEW",
      companyName: "NEW Energy Solar Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nse",
      code: "ASX:NSE",
      companyName: "NEW STANDARD ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nio",
      code: "ASX:NIO",
      companyName: "NICKELORE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nov",
      code: "ASX:NOV",
      companyName: "Novatti Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cryp",
      code: "ASX:CRYP",
      companyName: "Betashares CRYPTO Innovators ETF",
      popularity: 0,
    },
    {
      slug: "asx-oar",
      code: "ASX:OAR",
      companyName: "OAR Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nva",
      code: "ASX:NVA",
      companyName: "Nova Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nfn",
      code: "ASX:NFN",
      companyName: "NUFARM FINANCE (NZ) LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ntm",
      code: "ASX:NTM",
      companyName: "NT Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ocl",
      code: "ASX:OCL",
      companyName: "Objective Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-clne",
      code: "ASX:CLNE",
      companyName: "Vaneck Global Clean Energy ETF",
      popularity: 0,
    },
    {
      slug: "asx-oex",
      code: "ASX:OEX",
      companyName: "OILEX LTD",
      popularity: 0,
    },
    {
      slug: "asx-oxx",
      code: "ASX:OXX",
      companyName: "OCTANEX LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nox",
      code: "ASX:NOX",
      companyName: "Noxopharm Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nvx",
      code: "ASX:NVX",
      companyName: "Novonix Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dbbf",
      code: "ASX:DBBF",
      companyName: "Betashares Ethical Diversified Balanced ETF",
      popularity: 0,
    },
    {
      slug: "asx-oku",
      code: "ASX:OKU",
      companyName: "OKLO RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nhl",
      code: "ASX:NHL",
      companyName: "NOVITA HEALTHCARE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ncr",
      code: "ASX:NCR",
      companyName: "Nucoal Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ngy",
      code: "ASX:NGY",
      companyName: "Nuenergy Gas Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nsx",
      code: "ASX:NSX",
      companyName: "NSX Ltd",
      popularity: 0,
    },
    {
      slug: "asx-1al",
      code: "ASX:1AL",
      companyName: "ONEALL INTERNATIONAL LIMITED",
      popularity: 19000,
    },
    {
      slug: "asx-nvo",
      code: "ASX:NVO",
      companyName: "Novo Resources Corp",
      popularity: 0,
    },
    {
      slug: "asx-nus",
      code: "ASX:NUS",
      companyName: "NUSANTARA RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nzm",
      code: "ASX:NZM",
      companyName: "NZME Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oca",
      code: "ASX:OCA",
      companyName: "Oceania Healthcare Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ogc",
      code: "ASX:OGC",
      companyName: "OCEANAGOLD CORPORATION",
      popularity: 0,
    },
    {
      slug: "asx-osh",
      code: "ASX:OSH",
      companyName: "OIL SEARCH LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nzc",
      code: "ASX:NZC",
      companyName: "NZURI COPPER LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-odm",
      code: "ASX:ODM",
      companyName: "Odin Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-okj",
      code: "ASX:OKJ",
      companyName: "Oakajee Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-obj",
      code: "ASX:OBJ",
      companyName: "OBJ LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nuh",
      code: "ASX:NUH",
      companyName: "Nuheara Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oga",
      code: "ASX:OGA",
      companyName: "OCEAN GROWN ABALONE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ocp",
      code: "ASX:OCP",
      companyName: "OCEANIA CAPITAL PARTNERS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-odn",
      code: "ASX:ODN",
      companyName: "ODIN ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-omn",
      code: "ASX:OMN",
      companyName: "ONEMARKET LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ovh",
      code: "ASX:OVH",
      companyName: "ONEVUE HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-otr",
      code: "ASX:OTR",
      companyName: "ONTERRAN LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ore",
      code: "ASX:ORE",
      companyName: "OROCOBRE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ndq",
      code: "ASX:NDQ",
      companyName: "Betashares Nasdaq 100 ETF",
      popularity: 0,
    },
    {
      slug: "asx-spy",
      code: "ASX:SPY",
      companyName: "SPDR S&P 500 ETF Trust",
      popularity: 0,
    },
    {
      slug: "asx-zor",
      code: "ASX:ZOR",
      companyName: "ORDINARY (UNLISTED/LISTED - COSACS)",
      popularity: 0,
    },
    {
      slug: "asx-jhx",
      code: "ASX:JHX",
      companyName: "James Hardie Industries Plc",
      popularity: 0,
    },
    {
      slug: "asx-tg6",
      code: "ASX:TG6",
      companyName: "TG Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-otw",
      code: "ASX:OTW",
      companyName: "OVER THE WIRE HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-tsla",
      code: "NYSE:TSLA",
      companyName: "Tesla Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-voo",
      code: "NYSE:VOO",
      companyName: "Vanguard S&P 500 ETF",
      popularity: 0,
    },
    {
      slug: "asx-occ",
      code: "ASX:OCC",
      companyName: "Orthocell Ltd",
      popularity: 0,
    },
    {
      slug: "asx-onx",
      code: "ASX:ONX",
      companyName: "ORMINEX LTD",
      popularity: 0,
    },
    {
      slug: "asx-ovl",
      code: "ASX:OVL",
      companyName: "ORO VERDE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-oda",
      code: "ASX:ODA",
      companyName: "Orcoda Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vas",
      code: "ASX:VAS",
      companyName: "Vanguard Australian Shares INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-ora",
      code: "ASX:ORA",
      companyName: "Orora Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oel",
      code: "ASX:OEL",
      companyName: "Otto Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wes",
      code: "ASX:WES",
      companyName: "Wesfarmers Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pea",
      code: "ASX:PEA",
      companyName: "PEPPER RESIDENTIAL SECURITIES TRUST NO. 30",
      popularity: 0,
    },
    {
      slug: "asx-rwc",
      code: "ASX:RWC",
      companyName: "Reliance Worldwide Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oeq",
      code: "ASX:OEQ",
      companyName: "Orion Equities Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oil",
      code: "ASX:OIL",
      companyName: "Optiscan Imaging Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ozg",
      code: "ASX:OZG",
      companyName: "OZGROWTH LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-osp",
      code: "ASX:OSP",
      companyName: "OSPREY MEDICAL INC",
      popularity: 0,
    },
    {
      slug: "asx-olv",
      code: "ASX:OLV",
      companyName: "OTHERLEVELS HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-orm",
      code: "ASX:ORM",
      companyName: "Orion Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-orn",
      code: "ASX:ORN",
      companyName: "Orion Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-orr",
      code: "ASX:ORR",
      companyName: "Orecorp Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ovn",
      code: "ASX:OVN",
      companyName: "Oventus Medical Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ovt",
      code: "ASX:OVT",
      companyName: "OVATO LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-oau",
      code: "ASX:OAU",
      companyName: "Ora Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-a200",
      code: "ASX:A200",
      companyName: "Betashares Australia 200 ETF",
      popularity: 2061000,
    },
    {
      slug: "asx-ffm",
      code: "ASX:FFM",
      companyName: "Firefly Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gmrn",
      code: "ASX:GMRN",
      companyName: "Golden Rim Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oec",
      code: "ASX:OEC",
      companyName: "Orbital Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gtgda",
      code: "ASX:GTGDA",
      companyName: "Genetic Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ogx",
      code: "ASX:OGX",
      companyName: "ORINOCO GOLD LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mqg",
      code: "ASX:MQG",
      companyName: "Macquarie Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-p2p",
      code: "ASX:P2P",
      companyName: "P2P TRANSPORT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pak",
      code: "ASX:PAK",
      companyName: "PACIFIC AMERICAN HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pbx",
      code: "ASX:PBX",
      companyName: "PACIFIC BAUXITE NL",
      popularity: 0,
    },
    {
      slug: "asx-pdf",
      code: "ASX:PDF",
      companyName: "PACIFIC DAIRIES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pnw",
      code: "ASX:PNW",
      companyName: "PACIFIC STAR NETWORK LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pmy",
      code: "ASX:PMY",
      companyName: "PACIFICO MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-espo",
      code: "ASX:ESPO",
      companyName: "Vaneck Video Gaming and Esports ETF",
      popularity: 0,
    },
    {
      slug: "asx-par",
      code: "ASX:PAR",
      companyName: "Paradigm Biopharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fatp",
      code: "ASX:FATP",
      companyName: "FAT Prophets Global High Conviction Hedge Fund",
      popularity: 0,
    },
    {
      slug: "asx-pex",
      code: "ASX:PEX",
      companyName: "Peel Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fdem",
      code: "ASX:FDEM",
      companyName: "Fidelity Global Demographics Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-gco2",
      code: "ASX:GCO2",
      companyName: "Global X Global Carbon ETF (Synthetic)",
      popularity: 0,
    },
    {
      slug: "asx-pdl",
      code: "ASX:PDL",
      companyName: "PENDAL GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pgc",
      code: "ASX:PGC",
      companyName: "Paragon Care Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gbnd",
      code: "ASX:GBND",
      companyName:
        "Betashares Sustainability Leaders DVRSFD Bond ETF - Cur HDG",
      popularity: 0,
    },
    {
      slug: "asx-game",
      code: "ASX:GAME",
      companyName: "Betashares Video Games and Esports ETF",
      popularity: 0,
    },
    {
      slug: "asx-pek",
      code: "ASX:PEK",
      companyName: "Peak Rare EARTHS Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pkd",
      code: "ASX:PKD",
      companyName: "Parkd Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pko",
      code: "ASX:PKO",
      companyName: "Peako Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gcap",
      code: "ASX:GCAP",
      companyName: "Vaneck Bentham GL Cap Se Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-prz",
      code: "ASX:PRZ",
      companyName: "PARAZERO LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pwn",
      code: "ASX:PWN",
      companyName: "Parkway Corporate Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pnl",
      code: "ASX:PNL",
      companyName: "PARINGA RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dggf",
      code: "ASX:DGGF",
      companyName: "Betashares Ethical Diversified Growth ETF",
      popularity: 0,
    },
    {
      slug: "asx-fang",
      code: "ASX:FANG",
      companyName: "Global X Fang+ ETF",
      popularity: 0,
    },
    {
      slug: "asx-pyg",
      code: "ASX:PYG",
      companyName: "PAYGROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ggov",
      code: "ASX:GGOV",
      companyName: "Betashares US Treasury Bond 20+YR ETF - CCY Hedged",
      popularity: 0,
    },
    {
      slug: "asx-dhof",
      code: "ASX:DHOF",
      companyName: "Daintree HYBRID Opportunities Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-pg1",
      code: "ASX:PG1",
      companyName: "PEARL GLOBAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pel",
      code: "ASX:PEL",
      companyName: "PELICAN RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-peu",
      code: "ASX:PEU",
      companyName: "PEPPER RESIDENTIAL SECURITIES TRUST NO 22",
      popularity: 0,
    },
    {
      slug: "asx-pes",
      code: "ASX:PES",
      companyName: "PEPPER RESIDENTIAL SECURITIES TRUST NO. 21",
      popularity: 0,
    },
    {
      slug: "asx-dvdy",
      code: "ASX:DVDY",
      companyName: "Vaneck Morningstar Australian Moat Income ETF",
      popularity: 0,
    },
    {
      slug: "asx-psm",
      code: "ASX:PSM",
      companyName: "PENINSULA MINES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pm8",
      code: "ASX:PM8",
      companyName: "PENSANA PLC",
      popularity: 0,
    },
    {
      slug: "asx-pep",
      code: "ASX:PEP",
      companyName: "PEPPER I-PRIME 2017-3 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-per",
      code: "ASX:PER",
      companyName: "PEPPER RESIDENTIAL SECURITIES TRUST NO. 20",
      popularity: 0,
    },
    {
      slug: "asx-psa",
      code: "ASX:PSA",
      companyName: "PETSEC ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-poh",
      code: "ASX:POH",
      companyName: "PHOSPHAGENICS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-dzzf",
      code: "ASX:DZZF",
      companyName: "Betashares Ethical Diversified High Growth ETF",
      popularity: 0,
    },
    {
      slug: "asx-e200",
      code: "ASX:E200",
      companyName: "SPDR S&P/ASX 200 Esg Fund",
      popularity: 0,
    },
    {
      slug: "asx-ebnd",
      code: "ASX:EBND",
      companyName:
        "Vaneck Emerging Inc Opportunities Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ecpga",
      code: "ASX:ECPGA",
      companyName: "ECP Emerging Growth Ltd",
      popularity: 0,
    },
    {
      slug: "asx-edoc",
      code: "ASX:EDOC",
      companyName: "Betashares Digital Health and Telemedicine ETF",
      popularity: 0,
    },
    {
      slug: "asx-pab",
      code: "ASX:PAB",
      companyName: "PATRYS Ltd",
      popularity: 0,
    },
    {
      slug: "asx-futr",
      code: "ASX:FUTR",
      companyName: "Janus Henderson GLB Sust Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-sgp",
      code: "ASX:SGP",
      companyName: "Stockland",
      popularity: 0,
    },
    {
      slug: "asx-pgm",
      code: "ASX:PGM",
      companyName: "Platina Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cba",
      code: "ASX:CBA",
      companyName: "Commonwealth Bank of Australia",
      popularity: 0,
    },
    {
      slug: "asx-3dp",
      code: "ASX:3DP",
      companyName: "Pointerra Ltd",
      popularity: 297000,
    },
    {
      slug: "asx-ptm",
      code: "ASX:PTM",
      companyName: "Platinum Asset Management Ltd",
      popularity: 0,
    },
    {
      slug: "asx-csl",
      code: "ASX:CSL",
      companyName: "CSL Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pvs",
      code: "ASX:PVS",
      companyName: "Pivotal Systems Corporation",
      popularity: 0,
    },
    {
      slug: "asx-plc",
      code: "ASX:PLC",
      companyName: "PLC FINANCIAL SOLUTIONS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pka",
      code: "ASX:PKA",
      companyName: "PLUKKA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pc1",
      code: "ASX:PC1",
      companyName: "PLUS CONNECT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pod",
      code: "ASX:POD",
      companyName: "Podium Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ori",
      code: "ASX:ORI",
      companyName: "Orica Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pnc",
      code: "ASX:PNC",
      companyName: "Pioneer Credit Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pai",
      code: "ASX:PAI",
      companyName: "Platinum Asia Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pgf",
      code: "ASX:PGF",
      companyName: "PM Capital Global Opportunities Fund Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pgy",
      code: "ASX:PGY",
      companyName: "Pilot Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bhp",
      code: "ASX:BHP",
      companyName: "BHP Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pnx",
      code: "ASX:PNX",
      companyName: "PNX Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pos",
      code: "ASX:POS",
      companyName: "Poseidon Nickel Ltd",
      popularity: 0,
    },
    {
      slug: "asx-paf",
      code: "ASX:PAF",
      companyName: "PM CAPITAL ASIAN OPPORTUNITIES FUND LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-meta",
      code: "NYSE:META",
      companyName: "Meta Platforms Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-msft",
      code: "NYSE:MSFT",
      companyName: "Microsoft Corp",
      popularity: 0,
    },
    {
      slug: "asx-pgs",
      code: "ASX:PGS",
      companyName: "PLANET GAS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ppk",
      code: "ASX:PPK",
      companyName: "PPK Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pxx",
      code: "ASX:PXX",
      companyName: "Polarx Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pve",
      code: "ASX:PVE",
      companyName: "Po Valley Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pl8",
      code: "ASX:PL8",
      companyName: "Plato Income Maximiser Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pvl",
      code: "ASX:PVL",
      companyName: "Powerhouse Ventures Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pin",
      code: "ASX:PIN",
      companyName: "PINCHME.COM INC.",
      popularity: 0,
    },
    {
      slug: "asx-pio",
      code: "ASX:PIO",
      companyName: "PIONEER RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ppz",
      code: "ASX:PPZ",
      companyName: "PLACES FOR PEOPLE TREASURY PLC",
      popularity: 0,
    },
    {
      slug: "asx-pmc",
      code: "ASX:PMC",
      companyName: "Platinum Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pll",
      code: "ASX:PLL",
      companyName: "Piedmont Lithium Inc",
      popularity: 0,
    },
    {
      slug: "asx-pdz",
      code: "ASX:PDZ",
      companyName: "PRAIRIE MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pbt",
      code: "ASX:PBT",
      companyName: "PRANA BIOTECHNOLOGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pot",
      code: "ASX:POT",
      companyName: "PROGRESS 2017-2 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-pov",
      code: "ASX:POV",
      companyName: "PROGRESS 2018-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-pob",
      code: "ASX:POB",
      companyName: "PROGRESS 2021-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-me1",
      code: "ASX:ME1",
      companyName: "Melodiol Global Health Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pro",
      code: "ASX:PRO",
      companyName: "Prophecy International Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-puk",
      code: "ASX:PUK",
      companyName: "PUMA SERIES 2014-1",
      popularity: 0,
    },
    {
      slug: "asx-puo",
      code: "ASX:PUO",
      companyName: "PUMA SERIES 2014-2",
      popularity: 0,
    },
    {
      slug: "nyse-aon",
      code: "NYSE:AON",
      companyName: "Aon plc Class A",
      popularity: 0,
    },
    {
      slug: "asx-bp8",
      code: "ASX:BP8",
      companyName: "BPH Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ctm",
      code: "ASX:CTM",
      companyName: "Centaurus Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pfp",
      code: "ASX:PFP",
      companyName: "Propel Funeral Partners Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pan",
      code: "ASX:PAN",
      companyName: "Panoramic Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ccp",
      code: "ASX:CCP",
      companyName: "Credit Corp Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-piq",
      code: "ASX:PIQ",
      companyName: "Proteomics International Laboratories Ltd",
      popularity: 0,
    },
    {
      slug: "asx-psi",
      code: "ASX:PSI",
      companyName: "PSC Insurance Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pbp",
      code: "ASX:PBP",
      companyName: "Probiotec Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gdm",
      code: "ASX:GDM",
      companyName: "Great Divide Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-plg",
      code: "ASX:PLG",
      companyName: "Pearl Gull Iron Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pow",
      code: "ASX:POW",
      companyName: "Protean Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ppg",
      code: "ASX:PPG",
      companyName: "Pro-Pac Packaging Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-lrcx",
      code: "NASDAQ:LRCX",
      companyName: "Lam Research Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-amc",
      code: "ASX:AMC",
      companyName: "Amcor Plc",
      popularity: 981000,
    },
    {
      slug: "asx-prx",
      code: "ASX:PRX",
      companyName: "Prodigy Gold NL",
      popularity: 0,
    },
    {
      slug: "asx-psc",
      code: "ASX:PSC",
      companyName: "Prospect Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-anz",
      code: "ASX:ANZ",
      companyName: "ANZ Group Holdings Ltd",
      popularity: 5932000,
    },
    {
      slug: "asx-rkt",
      code: "ASX:RKT",
      companyName: "Rocketdna Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-mstr",
      code: "NASDAQ:MSTR",
      companyName: "MicroStrategy Incorporated Common Stock Class A",
      popularity: 0,
    },
    {
      slug: "asx-col",
      code: "ASX:COL",
      companyName: "Coles Group Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-nvs",
      code: "NYSE:NVS",
      companyName: "Novartis AG",
      popularity: 0,
    },
    {
      slug: "asx-crn",
      code: "ASX:CRN",
      companyName: "Coronado Global Resources Inc",
      popularity: 0,
    },
    {
      slug: "asx-psz",
      code: "ASX:PSZ",
      companyName: "PS&C LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pch",
      code: "ASX:PCH",
      companyName: "PROPERTY CONNECT HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ptb",
      code: "ASX:PTB",
      companyName: "PTB GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pub",
      code: "ASX:PUB",
      companyName: "PUMA MASTERFUND P-16",
      popularity: 0,
    },
    {
      slug: "asx-puj",
      code: "ASX:PUJ",
      companyName: "PUMA SERIES 2013-1",
      popularity: 0,
    },
    {
      slug: "asx-nab",
      code: "ASX:NAB",
      companyName: "National Australia Bank Ltd",
      popularity: 0,
    },
    {
      slug: "asx-glob",
      code: "ASX:GLOB",
      companyName: "Barrow Hanley Global Share Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-red",
      code: "ASX:RED",
      companyName: "RED 5 Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rbr",
      code: "ASX:RBR",
      companyName: "RBR Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-give",
      code: "ASX:GIVE",
      companyName: "Perpetual Esg Australian Share Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-rdn",
      code: "ASX:RDN",
      companyName: "Raiden Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rac",
      code: "ASX:RAC",
      companyName: "Race Oncology Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rnd",
      code: "ASX:RND",
      companyName: "Rand Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rkn",
      code: "ASX:RKN",
      companyName: "Reckon Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rpg",
      code: "ASX:RPG",
      companyName: "Raptis Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rmm",
      code: "ASX:RMM",
      companyName: "RAMS MORTGAGE SECURITIES TRUST SERIES 2006-1",
      popularity: 0,
    },
    {
      slug: "asx-rft",
      code: "ASX:RFT",
      companyName: "Rectifier Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-r3d",
      code: "ASX:R3D",
      companyName: "R3D Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wbc",
      code: "ASX:WBC",
      companyName: "Westpac Banking Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ieo",
      code: "NYSE:IEO",
      companyName: "iShares U.S. Oil & Gas Exploration & Production ETF",
      popularity: 0,
    },
    {
      slug: "nyse-oih",
      code: "NYSE:OIH",
      companyName: "VanEck Oil Services ETF",
      popularity: 0,
    },
    {
      slug: "asx-ivv",
      code: "ASX:IVV",
      companyName: "Ishares S&P 500 ETF",
      popularity: 0,
    },
    {
      slug: "asx-rag",
      code: "ASX:RAG",
      companyName: "Ragnar Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hcrd",
      code: "ASX:HCRD",
      companyName: "Betashares Interest Rate Hedged Aus Corp Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-rrs",
      code: "ASX:RRS",
      companyName: "RANGE RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rzi",
      code: "ASX:RZI",
      companyName: "RAIZ Invest Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rce",
      code: "ASX:RCE",
      companyName: "Recce Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qhl",
      code: "ASX:QHL",
      companyName: "Quickstep Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-hlt",
      code: "NYSE:HLT",
      companyName: "Hilton Worldwide Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "asx-rle",
      code: "ASX:RLE",
      companyName: "REAL ENERGY CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rev",
      code: "ASX:REV",
      companyName: "REAL ESTATE INVESTAR GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rcr",
      code: "ASX:RCR",
      companyName: "Rincon Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-car",
      code: "ASX:CAR",
      companyName: "CAR Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tpw",
      code: "ASX:TPW",
      companyName: "Temple & Webster Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rmp",
      code: "ASX:RMP",
      companyName: "RED EMPEROR RESOURCES NL",
      popularity: 0,
    },
    {
      slug: "asx-rcp",
      code: "ASX:RCP",
      companyName: "REDBANK COPPER LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gpeq",
      code: "ASX:GPEQ",
      companyName: "Vaneck Global Listed Private Equity ETF",
      popularity: 0,
    },
    {
      slug: "asx-rdc",
      code: "ASX:RDC",
      companyName: "REDCAPE HOTEL GROUP",
      popularity: 0,
    },
    {
      slug: "asx-rdf",
      code: "ASX:RDF",
      companyName: "REDFLEX HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-goat",
      code: "ASX:GOAT",
      companyName: "Vaneck Morningstar International Wide Moat ETF",
      popularity: 0,
    },
    {
      slug: "asx-rdh",
      code: "ASX:RDH",
      companyName: "REDHILL EDUCATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-qve",
      code: "ASX:QVE",
      companyName: "QV Equities Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ran",
      code: "ASX:RAN",
      companyName: "Range International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rcl",
      code: "ASX:RCL",
      companyName: "Readcloud Ltd",
      popularity: 0,
    },
    {
      slug: "asx-qin",
      code: "ASX:QIN",
      companyName: "QUINTIS LTD",
      popularity: 0,
    },
    {
      slug: "asx-a2m",
      code: "ASX:A2M",
      companyName: "The a2 Milk Company Ltd",
      popularity: 3423000,
    },
    {
      slug: "asx-rfr",
      code: "ASX:RFR",
      companyName: "RAFAELLA RESOURCES LTD.",
      popularity: 0,
    },
    {
      slug: "asx-rbd",
      code: "ASX:RBD",
      companyName: "Restaurant Brands New Zealand Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rmi",
      code: "ASX:RMI",
      companyName: "Resource Mining Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rbx",
      code: "ASX:RBX",
      companyName: "Resource Base Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rct",
      code: "ASX:RCT",
      companyName: "Reef Casino Trust",
      popularity: 0,
    },
    {
      slug: "asx-rsh",
      code: "ASX:RSH",
      companyName: "Respiri Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rht",
      code: "ASX:RHT",
      companyName: "Resonance Health Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rtd",
      code: "ASX:RTD",
      companyName:
        "RESIMAC BASTILLE TRUST IN RESPECT OF RESIMAC SERIES 2018-1NC",
      popularity: 0,
    },
    {
      slug: "asx-rdg",
      code: "ASX:RDG",
      companyName: "Resource Development Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rfn",
      code: "ASX:RFN",
      companyName: "REFFIND LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rez",
      code: "ASX:REZ",
      companyName: "Resources & Energy Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rnu",
      code: "ASX:RNU",
      companyName: "Renascor Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-amd",
      code: "NYSE:AMD",
      companyName: "Advanced Micro Devices",
      popularity: 0,
    },
    {
      slug: "nyse-googl",
      code: "NYSE:GOOGL",
      companyName: "Alphabet Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-rex",
      code: "ASX:REX",
      companyName: "Regional Express Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wow",
      code: "ASX:WOW",
      companyName: "Woolworths Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ake",
      code: "ASX:AKE",
      companyName: "Allkem Ltd",
      popularity: 558000,
    },
    {
      slug: "asx-rgs",
      code: "ASX:RGS",
      companyName: "Regeneus Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rnt",
      code: "ASX:RNT",
      companyName: "Rent.com.Au Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rne",
      code: "ASX:RNE",
      companyName: "Renu Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-bkr",
      code: "NYSE:BKR",
      companyName: "Baker Hughes Company",
      popularity: 0,
    },
    {
      slug: "nyse-hal",
      code: "NYSE:HAL",
      companyName: "Halliburton Company",
      popularity: 0,
    },
    {
      slug: "asx-rnx",
      code: "ASX:RNX",
      companyName: "Renegade Exploration Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rsg",
      code: "ASX:RSG",
      companyName: "Resolute Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rd1",
      code: "ASX:RD1",
      companyName: "REGISTRY DIRECT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rrl",
      code: "ASX:RRL",
      companyName: "Regis Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rt9",
      code: "ASX:RT9",
      companyName: "RESIMAC BASTILLE TRUST SERIES 2017-1NC",
      popularity: 0,
    },
    {
      slug: "asx-rap",
      code: "ASX:RAP",
      companyName: "RESAPP HEALTH LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rtc",
      code: "ASX:RTC",
      companyName: "RESIMAC TRIOMPHE TRUST PREMIER 2017-2",
      popularity: 0,
    },
    {
      slug: "asx-rt1",
      code: "ASX:RT1",
      companyName: "RESIMAC TRIOMPHE TRUST RESIMAC PREMIER SERIES 2018-1",
      popularity: 0,
    },
    {
      slug: "asx-res",
      code: "ASX:RES",
      companyName: "RESOURCE GENERATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rco",
      code: "ASX:RCO",
      companyName: "ROYALCO RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-driv",
      code: "ASX:DRIV",
      companyName: "Betashares Electric Vehicles and FTR Mobility ETF",
      popularity: 0,
    },
    {
      slug: "asx-rub",
      code: "ASX:RUB",
      companyName: "RUBICOR GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rgi",
      code: "ASX:RGI",
      companyName: "Roto-Gro International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rmy",
      code: "ASX:RMY",
      companyName: "Rma Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rhl",
      code: "ASX:RHL",
      companyName: "RURALCO HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rxp",
      code: "ASX:RXP",
      companyName: "RXP SERVICES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ann",
      code: "ASX:ANN",
      companyName: "Ansell Ltd",
      popularity: 778000,
    },
    {
      slug: "asx-rtg",
      code: "ASX:RTG",
      companyName: "RTG Mining Inc",
      popularity: 0,
    },
    {
      slug: "asx-rxl",
      code: "ASX:RXL",
      companyName: "ROX Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-s2r",
      code: "ASX:S2R",
      companyName: "S2 Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sfv",
      code: "ASX:SFV",
      companyName: "SANTOS FINANCE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-roo",
      code: "ASX:ROO",
      companyName: "Roots Sustainable Agricultural Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sgc",
      code: "ASX:SGC",
      companyName: "Sacgasco Ltd",
      popularity: 0,
    },
    {
      slug: "asx-snc",
      code: "ASX:SNC",
      companyName: "Sandon Capital Investments Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-aapl",
      code: "NYSE:AAPL",
      companyName: "Apple Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-amzn",
      code: "NYSE:AMZN",
      companyName: "Amazon.Com Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nvda",
      code: "NYSE:NVDA",
      companyName: "Nvidia Corp",
      popularity: 0,
    },
    {
      slug: "asx-rff",
      code: "ASX:RFF",
      companyName: "Rural Funds Group",
      popularity: 0,
    },
    {
      slug: "asx-sbr",
      code: "ASX:SBR",
      companyName: "Sabre Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sfm",
      code: "ASX:SFM",
      companyName: "Santa Fe Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-so4",
      code: "ASX:SO4",
      companyName: "Salt Lake Potash Ltd",
      popularity: 0,
    },
    {
      slug: "asx-smi",
      code: "ASX:SMI",
      companyName: "Santana Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-slm",
      code: "ASX:SLM",
      companyName: "Solis Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-acdc",
      code: "ASX:ACDC",
      companyName: "Global X Battery Tech & Lithium ETF",
      popularity: 1785000,
    },
    {
      slug: "asx-org",
      code: "ASX:ORG",
      companyName: "Origin Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-srh",
      code: "ASX:SRH",
      companyName: "Saferoads Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-san",
      code: "ASX:SAN",
      companyName: "Sagalio Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ryd",
      code: "ASX:RYD",
      companyName: "Ryder Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rgl",
      code: "ASX:RGL",
      companyName: "Riversgold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wds",
      code: "ASX:WDS",
      companyName: "Woodside Energy Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rtr",
      code: "ASX:RTR",
      companyName: "Rumble Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rnl",
      code: "ASX:RNL",
      companyName: "RISION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rmt",
      code: "ASX:RMT",
      companyName: "RMA ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rmg",
      code: "ASX:RMG",
      companyName: "RMG LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-rny",
      code: "ASX:RNY",
      companyName: "RNY PROPERTY TRUST",
      popularity: 0,
    },
    {
      slug: "asx-rlk",
      code: "ASX:RLK",
      companyName: "ROLEK RESOURCES LTD",
      popularity: 0,
    },
    {
      slug: "asx-ssn",
      code: "ASX:SSN",
      companyName: "SAMSON OIL & GAS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sen",
      code: "ASX:SEN",
      companyName: "Senetas Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pbh",
      code: "ASX:PBH",
      companyName: "Pointsbet Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sct",
      code: "ASX:SCT",
      companyName: "Scout Security Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sdi",
      code: "ASX:SDI",
      companyName: "SDI Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-ionq",
      code: "NYSE:IONQ",
      companyName: "IonQ Inc.",
      popularity: 0,
    },
    {
      slug: "asx-se1",
      code: "ASX:SE1",
      companyName: "Sensera Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sns",
      code: "ASX:SNS",
      companyName: "Sensen Networks Ltd",
      popularity: 0,
    },
    {
      slug: "asx-seq",
      code: "ASX:SEQ",
      companyName: "Sequoia Financial Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wsz",
      code: "ASX:WSZ",
      companyName: "SERIES 2014-1 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-wek",
      code: "ASX:WEK",
      companyName: "SERIES 2014-2 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-wej",
      code: "ASX:WEJ",
      companyName: "SERIES 2015-1 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ses",
      code: "ASX:SES",
      companyName: "Secos Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sfg",
      code: "ASX:SFG",
      companyName: "Seafarms Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-slk",
      code: "ASX:SLK",
      companyName: "SEALINK TRAVEL GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sdv",
      code: "ASX:SDV",
      companyName: "Scidev Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sac",
      code: "ASX:SAC",
      companyName: "SECURITISED AUSTRALIAN MORTGAGE TRUST 2011-1",
      popularity: 0,
    },
    {
      slug: "asx-smx",
      code: "ASX:SMX",
      companyName: "SECURITY MATTERS LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnt",
      code: "NASDAQ:PNT",
      companyName: "POINT Biopharma Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-swf",
      code: "ASX:SWF",
      companyName: "Selfwealth Ltd",
      popularity: 0,
    },
    {
      slug: "asx-scn",
      code: "ASX:SCN",
      companyName: "Scorpion Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shv",
      code: "ASX:SHV",
      companyName: "Select Harvests Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sxy",
      code: "ASX:SXY",
      companyName: "SENEX ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wsc",
      code: "ASX:WSC",
      companyName: "SERIES 2009-1 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-rek",
      code: "ASX:REK",
      companyName: "SERIES 2010-1 REDS TRUST",
      popularity: 0,
    },
    {
      slug: "asx-rda",
      code: "ASX:RDA",
      companyName: "SERIES 2010-2 REDS TRUST",
      popularity: 0,
    },
    {
      slug: "asx-wsh",
      code: "ASX:WSH",
      companyName: "SERIES 2011-1 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-wsj",
      code: "ASX:WSJ",
      companyName: "SERIES 2011-2 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-wsn",
      code: "ASX:WSN",
      companyName: "SERIES 2011-3 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-wso",
      code: "ASX:WSO",
      companyName: "SERIES 2012-1 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-rfb",
      code: "ASX:RFB",
      companyName: "SERIES 2012-1E REDS TRUST",
      popularity: 0,
    },
    {
      slug: "asx-htb",
      code: "ASX:HTB",
      companyName: "SERIES 2013-1 HARVEY TRUST",
      popularity: 0,
    },
    {
      slug: "asx-wsq",
      code: "ASX:WSQ",
      companyName: "SERIES 2013-1 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-wsd",
      code: "ASX:WSD",
      companyName: "SERIES 2013-2 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-slx",
      code: "ASX:SLX",
      companyName: "SILEX Systems Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shm",
      code: "ASX:SHM",
      companyName: "Shriro Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shz",
      code: "ASX:SHZ",
      companyName: "SHINHAN BANK.",
      popularity: 0,
    },
    {
      slug: "asx-sih",
      code: "ASX:SIH",
      companyName: "Sihayo Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sio",
      code: "ASX:SIO",
      companyName: "Simonds Group Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-fusn",
      code: "NASDAQ:FUSN",
      companyName: "Fusion Pharmaceuticals Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "asx-sci",
      code: "ASX:SCI",
      companyName: "SILVER CITY MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sis",
      code: "ASX:SIS",
      companyName: "Simble Solutions Ltd",
      popularity: 0,
    },
    {
      slug: "asx-siv",
      code: "ASX:SIV",
      companyName: "SIV Capital Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sri",
      code: "ASX:SRI",
      companyName: "Sipa Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ssl",
      code: "ASX:SSL",
      companyName: "Sietel Ltd",
      popularity: 0,
    },
    {
      slug: "asx-scp",
      code: "ASX:SCP",
      companyName: "SHOPPING CENTRES AUSTRALASIA PROPERTY GROUP",
      popularity: 0,
    },
    {
      slug: "asx-svh",
      code: "ASX:SVH",
      companyName: "SILVER HERITAGE GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-svl",
      code: "ASX:SVL",
      companyName: "Silver Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sig",
      code: "ASX:SIG",
      companyName: "Sigma Healthcare Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cu6",
      code: "ASX:CU6",
      companyName: "Clarity Pharmaceuticals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-slr",
      code: "ASX:SLR",
      companyName: "Silver Lake Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-pm",
      code: "NYSE:PM",
      companyName: "Philip Morris International Inc.",
      popularity: 0,
    },
    {
      slug: "asx-sgm",
      code: "ASX:SGM",
      companyName: "Sims Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shh",
      code: "ASX:SHH",
      companyName: "SHREE MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sbu",
      code: "ASX:SBU",
      companyName: "SIBURAN RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sdx",
      code: "ASX:SDX",
      companyName: "SIENNA CANCER DIAGNOSTICS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sva",
      code: "ASX:SVA",
      companyName: "SIMAVITA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-stc",
      code: "ASX:STC",
      companyName: "SINETECH LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ieat",
      code: "ASX:IEAT",
      companyName: "Betashares Future of Food ETF",
      popularity: 0,
    },
    {
      slug: "asx-iesg",
      code: "ASX:IESG",
      companyName: "Ishares Core MSCI Australia Esg ETF",
      popularity: 0,
    },
    {
      slug: "asx-igro",
      code: "ASX:IGRO",
      companyName: "Ishares High Growth Esg ETF",
      popularity: 0,
    },
    {
      slug: "asx-lsge",
      code: "ASX:LSGE",
      companyName: "Loomis Sayles GBL EQ Fund (Quoted Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-s32",
      code: "ASX:S32",
      companyName: "SOUTH32 Ltd",
      popularity: 0,
    },
    {
      slug: "asx-heth",
      code: "ASX:HETH",
      companyName: "Betashares Global Sustainability Leaders ETF - CH",
      popularity: 0,
    },
    {
      slug: "asx-jzro",
      code: "ASX:JZRO",
      companyName: "Janus HDRSN ZR Trans Res Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-hndq",
      code: "ASX:HNDQ",
      companyName: "Betashares Nasdaq 100 ETF - Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-spb",
      code: "ASX:SPB",
      companyName: "SOUTH PACIFIC RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-maat",
      code: "ASX:MAAT",
      companyName: "Monash Investors SML Companies Trust (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-svm",
      code: "ASX:SVM",
      companyName: "Sovereign Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sau",
      code: "ASX:SAU",
      companyName: "Southern Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sxx",
      code: "ASX:SXX",
      companyName: "SOUTHERN CROSS EXPLORATION N.L.",
      popularity: 0,
    },
    {
      slug: "asx-ipay",
      code: "ASX:IPAY",
      companyName: "Betashares Future of Payments ETF",
      popularity: 0,
    },
    {
      slug: "asx-hgen",
      code: "ASX:HGEN",
      companyName: "Global X Hydrogen ETF",
      popularity: 0,
    },
    {
      slug: "asx-sxe",
      code: "ASX:SXE",
      companyName: "Southern Cross Electrical Engineering Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jepi",
      code: "ASX:JEPI",
      companyName: "Jpmorgan EQ Prem Income Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-islm",
      code: "ASX:ISLM",
      companyName: "HEJAZ Equities Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-suh",
      code: "ASX:SUH",
      companyName: "Southern Hemisphere Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hjzp",
      code: "ASX:HJZP",
      companyName: "HEJAZ Property Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-itek",
      code: "ASX:ITEK",
      companyName: "Ishares Future Tech Innovators ETF",
      popularity: 0,
    },
    {
      slug: "asx-sei",
      code: "ASX:SEI",
      companyName: "SPECIALITY METALS INTERNATIONAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sda",
      code: "ASX:SDA",
      companyName: "SPEEDCAST INTERNATIONAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-srs",
      code: "ASX:SRS",
      companyName: "SPICERS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-spo",
      code: "ASX:SPO",
      companyName: "SPOTLESS GROUP HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sfl",
      code: "ASX:SFL",
      companyName: "SPRING FG LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-stl",
      code: "ASX:STL",
      companyName: "STARGROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sf1",
      code: "ASX:SF1",
      companyName: "STEMIFY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sbi",
      code: "ASX:SBI",
      companyName: "STERLING PLANTATIONS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-hlth",
      code: "ASX:HLTH",
      companyName: "Vaneck Global Healthcare Leaders ETF",
      popularity: 0,
    },
    {
      slug: "asx-ibal",
      code: "ASX:IBAL",
      companyName: "Ishares Balanced Esg ETF",
      popularity: 0,
    },
    {
      slug: "asx-ski",
      code: "ASX:SKI",
      companyName: "SPARK INFRASTRUCTURE GROUP",
      popularity: 0,
    },
    {
      slug: "asx-ibuy",
      code: "ASX:IBUY",
      companyName: "Betashares Online Retail and E-Commerce ETF",
      popularity: 0,
    },
    {
      slug: "asx-icor",
      code: "ASX:ICOR",
      companyName: "Ishares Core Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-iyld",
      code: "ASX:IYLD",
      companyName: "Ishares Yield Plus ETF",
      popularity: 0,
    },
    {
      slug: "asx-jpsi",
      code: "ASX:JPSI",
      companyName: "Jpmorgan Sustain Infra Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-hqlt",
      code: "ASX:HQLT",
      companyName: "Betashares Global Quality Leaders ETF Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-mccl",
      code: "ASX:MCCL",
      companyName: "Munro Climate Change Leaders Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-lpgd",
      code: "ASX:LPGD",
      companyName: "Loftus Peak Global Disruption Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-jreg",
      code: "ASX:JREG",
      companyName: "Jpmorgan Asset Management (Australia) Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iigf",
      code: "ASX:IIGF",
      companyName: "Intelligent Investor Aus Equity Growth Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-sbk",
      code: "ASX:SBK",
      companyName: "SUNCORP-METWAY LIMITED .",
      popularity: 0,
    },
    {
      slug: "asx-sry",
      code: "ASX:SRY",
      companyName: "Story-I Ltd",
      popularity: 0,
    },
    {
      slug: "asx-smn",
      code: "ASX:SMN",
      companyName: "Structural Monitoring Systems Plc",
      popularity: 0,
    },
    {
      slug: "asx-sea",
      code: "ASX:SEA",
      companyName: "SUNDANCE ENERGY AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sta",
      code: "ASX:STA",
      companyName: "Strandline Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-smc",
      code: "ASX:SMC",
      companyName: "STRATEGIC MINERALS CORPORATION NL",
      popularity: 0,
    },
    {
      slug: "asx-sgo",
      code: "ASX:SGO",
      companyName: "STREAM GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ser",
      code: "ASX:SER",
      companyName: "Strategic Energy Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-slz",
      code: "ASX:SLZ",
      companyName: "Sultan Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sgu",
      code: "ASX:SGU",
      companyName: "SUCCESS GLOBAL MEDIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sud",
      code: "ASX:SUD",
      companyName: "SUDA PHARMACEUTICALS LTD",
      popularity: 0,
    },
    {
      slug: "asx-snz",
      code: "ASX:SNZ",
      companyName: "Summerset Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sor",
      code: "ASX:SOR",
      companyName: "Strategic Elements Ltd",
      popularity: 0,
    },
    {
      slug: "asx-srk",
      code: "ASX:SRK",
      companyName: "Strike Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sur",
      code: "ASX:SUR",
      companyName: "SUN RESOURCES NL",
      popularity: 0,
    },
    {
      slug: "asx-stx",
      code: "ASX:STX",
      companyName: "Strike Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-spq",
      code: "ASX:SPQ",
      companyName: "Superior Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sbb",
      code: "ASX:SBB",
      companyName: "SUNBRIDGE GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-stm",
      code: "ASX:STM",
      companyName: "Sunstone Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sum",
      code: "ASX:SUM",
      companyName: "Summit Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-stg",
      code: "ASX:STG",
      companyName: "Straker Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sdg",
      code: "ASX:SDG",
      companyName: "Sunland Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sdl",
      code: "ASX:SDL",
      companyName: "SUNDANCE RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-shk",
      code: "ASX:SHK",
      companyName: "STONE RESOURCES AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sxa",
      code: "ASX:SXA",
      companyName: "STRATA-X ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-svs",
      code: "ASX:SVS",
      companyName: "SUNVEST CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sup",
      code: "ASX:SUP",
      companyName: "SUPERIOR LAKE RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ter",
      code: "ASX:TER",
      companyName: "Terracom Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tts",
      code: "ASX:TTS",
      companyName: "TATTS GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tdl",
      code: "ASX:TDL",
      companyName: "TBG DIAGNOSTICS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-au1",
      code: "ASX:AU1",
      companyName: "The Agency Group Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tgr",
      code: "ASX:TGR",
      companyName: "TASSAL GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tcn",
      code: "ASX:TCN",
      companyName: "TECHNICHE LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-tam",
      code: "ASX:TAM",
      companyName: "Tanami Gold NL",
      popularity: 0,
    },
    {
      slug: "asx-tpp",
      code: "ASX:TPP",
      companyName: "TEMPO AUSTRALIA LTD",
      popularity: 0,
    },
    {
      slug: "asx-tmk",
      code: "ASX:TMK",
      companyName: "TMK Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tas",
      code: "ASX:TAS",
      companyName: "Tasman Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tar",
      code: "ASX:TAR",
      companyName: "Taruga Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tfl",
      code: "ASX:TFL",
      companyName: "Tasfoods Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tnt",
      code: "ASX:TNT",
      companyName: "Tesserent Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tlm",
      code: "ASX:TLM",
      companyName: "Talisman Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tes",
      code: "ASX:TES",
      companyName: "TEST SECURITY",
      popularity: 0,
    },
    {
      slug: "asx-tgg",
      code: "ASX:TGG",
      companyName: "TEMPLETON GLOBAL GROWTH FUND LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tip",
      code: "ASX:TIP",
      companyName: "Teaminvest Private Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tmr",
      code: "ASX:TMR",
      companyName: "Tempus Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-twd",
      code: "ASX:TWD",
      companyName: "Tamawood Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tzn",
      code: "ASX:TZN",
      companyName: "Terramin Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tpd",
      code: "ASX:TPD",
      companyName: "Talon Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wor",
      code: "ASX:WOR",
      companyName: "Worley Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tbl",
      code: "ASX:TBL",
      companyName: "TAMBLA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tno",
      code: "ASX:TNO",
      companyName: "TANDO RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tmx",
      code: "ASX:TMX",
      companyName: "Terrain Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-trl",
      code: "ASX:TRL",
      companyName: "TANGA RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tao",
      code: "ASX:TAO",
      companyName: "TAO COMMODITIES LTD",
      popularity: 0,
    },
    {
      slug: "asx-tap",
      code: "ASX:TAP",
      companyName: "TAP OIL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tex",
      code: "ASX:TEX",
      companyName: "TARGET ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-thc",
      code: "ASX:THC",
      companyName: "THC GLOBAL GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tlt",
      code: "ASX:TLT",
      companyName: "TILT RENEWABLES LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-tpm",
      code: "ASX:TPM",
      companyName: "TPG TELECOM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tih",
      code: "ASX:TIH",
      companyName: "TILLEGRAH LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mcgg",
      code: "ASX:MCGG",
      companyName: "Munro Concentrated Global Growth (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-tek",
      code: "ASX:TEK",
      companyName: "Thorney Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tie",
      code: "ASX:TIE",
      companyName: "Tietto Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tng",
      code: "ASX:TNG",
      companyName: "TNG LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tin",
      code: "ASX:TIN",
      companyName: "TNT MINES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tom",
      code: "ASX:TOM",
      companyName: "TOMIZONE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tnr",
      code: "ASX:TNR",
      companyName: "TORIAN RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tnb",
      code: "ASX:TNB",
      companyName: "TORRENS SERIES 2013-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-tnf",
      code: "ASX:TNF",
      companyName: "TORRENS SERIES 2013-2 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-tnh",
      code: "ASX:TNH",
      companyName: "TORRENS SERIES 2014-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-mfoa",
      code: "ASX:MFOA",
      companyName: "Milford Australian Absolute Growth (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-mgoc",
      code: "ASX:MGOC",
      companyName: "Magellan Global Fund (Open Class) (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-tnk",
      code: "ASX:TNK",
      companyName: "THINK CHILDCARE GROUP",
      popularity: 0,
    },
    {
      slug: "asx-top",
      code: "ASX:TOP",
      companyName: "Thorney Opportunities Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tgm",
      code: "ASX:TGM",
      companyName: "Theta Gold Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-toz",
      code: "ASX:TOZ",
      companyName: "TORRENS SERIES 2014-2 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-tnj",
      code: "ASX:TNJ",
      companyName: "TORRENS SERIES 2015-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ttz",
      code: "ASX:TTZ",
      companyName: "TORRENS SERIES 2016-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-xvg",
      code: "ASX:XVG",
      companyName: "TREASURY CORPORATION OF VICTORIA",
      popularity: 0,
    },
    {
      slug: "asx-thr",
      code: "ASX:THR",
      companyName: "Thor Energy Plc",
      popularity: 0,
    },
    {
      slug: "asx-tia",
      code: "ASX:TIA",
      companyName: "Tian An Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tml",
      code: "ASX:TML",
      companyName: "Timah Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tmz",
      code: "ASX:TMZ",
      companyName: "Thomson Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nsr",
      code: "ASX:NSR",
      companyName: "National Storage REIT",
      popularity: 0,
    },
    {
      slug: "asx-tpo",
      code: "ASX:TPO",
      companyName: "Tian Poh Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tps",
      code: "ASX:TPS",
      companyName: "THREAT PROTECT AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-thd",
      code: "ASX:THD",
      companyName: "THRED LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tig",
      code: "ASX:TIG",
      companyName: "Tigers Realm Coal Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tb8",
      code: "ASX:TB8",
      companyName: "TIANMEI BEVERAGE GROUP CORPORATION LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tga",
      code: "ASX:TGA",
      companyName: "Thorn Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tgs",
      code: "ASX:TGS",
      companyName: "TIGER RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tkf",
      code: "ASX:TKF",
      companyName: "TIKFORCE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tpe",
      code: "ASX:TPE",
      companyName: "TPI ENTERPRISES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tme",
      code: "ASX:TME",
      companyName: "TRADE ME GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ttl",
      code: "ASX:TTL",
      companyName: "TRANSCENDENCE TECHNOLOGIES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tkm",
      code: "ASX:TKM",
      companyName: "Trek Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-trm",
      code: "ASX:TRM",
      companyName: "Truscott Mining Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-uwl",
      code: "ASX:UWL",
      companyName: "UNITI GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tt9",
      code: "ASX:TT9",
      companyName: "TRITON TRUST NO. 8 IN RESPECT OF BOND SERIES 2018-1",
      popularity: 0,
    },
    {
      slug: "asx-tbr",
      code: "ASX:TBR",
      companyName: "Tribune Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-teg",
      code: "ASX:TEG",
      companyName: "Triangle Energy (Global) Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tgn",
      code: "ASX:TGN",
      companyName: "Tungsten Mining NL",
      popularity: 0,
    },
    {
      slug: "asx-ton",
      code: "ASX:TON",
      companyName: "Triton Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tra",
      code: "ASX:TRA",
      companyName: "Turners Automotive Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-try",
      code: "ASX:TRY",
      companyName: "Troy Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tta",
      code: "ASX:TTA",
      companyName: "TTA Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tym",
      code: "ASX:TYM",
      companyName: "TYMLEZ Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tzl",
      code: "ASX:TZL",
      companyName: "TZ Ltd",
      popularity: 0,
    },
    {
      slug: "asx-uul",
      code: "ASX:UUL",
      companyName: "Ultima United Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tgf",
      code: "ASX:TGF",
      companyName: "Tribeca Global Natural Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tyx",
      code: "ASX:TYX",
      companyName: "Tyranna Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-panw",
      code: "NYSE:PANW",
      companyName: "Palo Alto Networks Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-tv2",
      code: "ASX:TV2",
      companyName: "TV2U INTERNATIONAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tgo",
      code: "ASX:TGO",
      companyName: "GROWTHOPS LTD",
      popularity: 0,
    },
    {
      slug: "asx-tnp",
      code: "ASX:TNP",
      companyName: "TRIPLE ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tt7",
      code: "ASX:TT7",
      companyName: "TRITON TRUST NO.7 IN RESPECT OF THE BOND SERIES 2017-2",
      popularity: 0,
    },
    {
      slug: "asx-tau",
      code: "ASX:TAU",
      companyName: "TRUSTEES AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tsc",
      code: "ASX:TSC",
      companyName: "TWENTY SEVEN CO. LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ucw",
      code: "ASX:UCW",
      companyName: "UCW LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-utr",
      code: "ASX:UTR",
      companyName: "ULTRACHARGE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-unl",
      code: "ASX:UNL",
      companyName: "UNITED NETWORKS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ven",
      code: "ASX:VEN",
      companyName: "Vintage Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vic",
      code: "ASX:VIC",
      companyName: "VICTORY MINES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vah",
      code: "ASX:VAH",
      companyName: "VIRGIN AUSTRALIA HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vml",
      code: "ASX:VML",
      companyName: "Vital Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vg1",
      code: "ASX:VG1",
      companyName: "Vgi Partners Global Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vcd",
      code: "ASX:VCD",
      companyName: "VICINITY CENTRES TRUST",
      popularity: 0,
    },
    {
      slug: "asx-vti",
      code: "ASX:VTI",
      companyName: "Visioneering Technologies Inc",
      popularity: 0,
    },
    {
      slug: "asx-via",
      code: "ASX:VIA",
      companyName: "Viagold Rare Earth Resources Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vtg",
      code: "ASX:VTG",
      companyName: "VITA GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vii",
      code: "ASX:VII",
      companyName: "VIETNAM INDUSTRIAL INVESTMENTS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vig",
      code: "ASX:VIG",
      companyName: "Victor Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vip",
      code: "ASX:VIP",
      companyName: "VIP Gloves Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vlw",
      code: "ASX:VLW",
      companyName: "VILLA WORLD LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-vka",
      code: "ASX:VKA",
      companyName: "Viking Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vrt",
      code: "ASX:VRT",
      companyName: "VIRTUS HEALTH LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vrl",
      code: "ASX:VRL",
      companyName: "VILLAGE ROADSHOW LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vls",
      code: "ASX:VLS",
      companyName: "Vita Life Sciences Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vmc",
      code: "ASX:VMC",
      companyName: "Venus Metals Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vrs",
      code: "ASX:VRS",
      companyName: "Veris Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vmy",
      code: "ASX:VMY",
      companyName: "VIMY RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vcx",
      code: "ASX:VCX",
      companyName: "Vicinity Centres",
      popularity: 0,
    },
    {
      slug: "asx-vgl",
      code: "ASX:VGL",
      companyName: "Vista Group International Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-s",
      code: "NASDAQ:S",
      companyName: "SentinelOne Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-vrm",
      code: "ASX:VRM",
      companyName: "VERDANT MINERALS LTD",
      popularity: 0,
    },
    {
      slug: "asx-vri",
      code: "ASX:VRI",
      companyName: "VERILUMA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vth",
      code: "ASX:VTH",
      companyName: "VITALHARVEST FREEHOLD TRUST",
      popularity: 0,
    },
    {
      slug: "asx-wat",
      code: "ASX:WAT",
      companyName: "Waterco Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sol",
      code: "ASX:SOL",
      companyName: "Washington H Soul Pattinson & Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-waf",
      code: "ASX:WAF",
      companyName: "West African Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wgo",
      code: "ASX:WGO",
      companyName: "WARREGO ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wef",
      code: "ASX:WEF",
      companyName: "WEA FINANCE LLC AND WESTFIELD UK & EUROPE FINANCE PLC",
      popularity: 0,
    },
    {
      slug: "asx-wld",
      code: "ASX:WLD",
      companyName: "Wellard Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wqg",
      code: "ASX:WQG",
      companyName: "WCM Global Growth Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wgf",
      code: "ASX:WGF",
      companyName: "WATERMARK GLOBAL LEADERS FUND LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wmk",
      code: "ASX:WMK",
      companyName: "WATERMARK MARKET NEUTRAL FUND LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wha",
      code: "ASX:WHA",
      companyName: "WATTLE HEALTH AUSTRALIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wic",
      code: "ASX:WIC",
      companyName: "WESTOZ INVESTMENT COMPANY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wle",
      code: "ASX:WLE",
      companyName: "Wam Leaders Ltd",
      popularity: 0,
    },
    {
      slug: "asx-weh",
      code: "ASX:WEH",
      companyName: "WEA FINANCE LLC",
      popularity: 0,
    },
    {
      slug: "asx-wwi",
      code: "ASX:WWI",
      companyName: "West Wits Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wgb",
      code: "ASX:WGB",
      companyName: "Wam Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wax",
      code: "ASX:WAX",
      companyName: "Wam Research Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wba",
      code: "ASX:WBA",
      companyName: "WEBSTER LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wbt",
      code: "ASX:WBT",
      companyName: "Weebit Nano Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wll",
      code: "ASX:WLL",
      companyName: "WELLCOM GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wgx",
      code: "ASX:WGX",
      companyName: "Westgold Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wsa",
      code: "ASX:WSA",
      companyName: "WESTERN AREAS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wnb",
      code: "ASX:WNB",
      companyName: "WELLNESS AND BEAUTY SOLUTIONS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-xrf",
      code: "ASX:XRF",
      companyName: "XRF Scientific Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xam",
      code: "ASX:XAM",
      companyName: "Xanadu Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wml",
      code: "ASX:WML",
      companyName: "Woomera Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mtav",
      code: "ASX:MTAV",
      companyName: "Betashares Metaverse ETF",
      popularity: 0,
    },
    {
      slug: "asx-nacga",
      code: "ASX:NACGA",
      companyName: "Naos Ex-50 Opportunities Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nccga",
      code: "ASX:NCCGA",
      companyName: "Naos Emerging Opportunities Company Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nfng",
      code: "ASX:NFNG",
      companyName: "Nufarm Finance (NZ) Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mkax",
      code: "ASX:MKAX",
      companyName: "Montaka Global Extension Fund (Quoted Managed Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-zam",
      code: "ASX:ZAM",
      companyName: "ZAMANCO MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-zen",
      code: "ASX:ZEN",
      companyName: "ZENITH ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wpl",
      code: "ASX:WPL",
      companyName: "WOODSIDE PETROLEUM LTD",
      popularity: 0,
    },
    {
      slug: "asx-zta",
      code: "ASX:ZTA",
      companyName: "ZETA PETROLEUM PLC",
      popularity: 0,
    },
    {
      slug: "asx-nnuk",
      code: "ASX:NNUK",
      companyName: "Nanuk New World Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-wmc",
      code: "ASX:WMC",
      companyName: "Wiluna Mining Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wwg",
      code: "ASX:WWG",
      companyName: "Wiseway Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wlf",
      code: "ASX:WLF",
      companyName: "WOLF MINERALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-wlc",
      code: "ASX:WLC",
      companyName: "WOLLONGONG COAL LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-xf1",
      code: "ASX:XF1",
      companyName: "Xref Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mhht",
      code: "ASX:MHHT",
      companyName: "Magellan High Conviction Trust (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-wns",
      code: "ASX:WNS",
      companyName: "WORLD.NET SERVICES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-xst",
      code: "ASX:XST",
      companyName: "Xstate Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wpg",
      code: "ASX:WPG",
      companyName: "WPG RESOURCES LTD",
      popularity: 0,
    },
    {
      slug: "asx-wpp",
      code: "ASX:WPP",
      companyName: "WPP AUNZ LTD",
      popularity: 0,
    },
    {
      slug: "asx-xte",
      code: "ASX:XTE",
      companyName: "Xtek Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xip",
      code: "ASX:XIP",
      companyName: "XENITH IP GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-xpd",
      code: "ASX:XPD",
      companyName: "XPD SOCCER GEAR GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-xpe",
      code: "ASX:XPE",
      companyName: "XPED LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pgtx",
      code: "ASX:PGTX",
      companyName: "Platinum Transition (Quoted Managed Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-mstr",
      code: "ASX:MSTR",
      companyName: "Morningstar International Shares Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ozbd",
      code: "ASX:OZBD",
      companyName: "Betashares Australian Composite Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-xs1",
      code: "ASX:XS1",
      companyName: "XS RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-xtd",
      code: "ASX:XTD",
      companyName: "XTD LTD",
      popularity: 0,
    },
    {
      slug: "asx-zel",
      code: "ASX:ZEL",
      companyName: "Z ENERGY LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-xtv",
      code: "ASX:XTV",
      companyName: "XTV NETWORKS LTD",
      popularity: 0,
    },
    {
      slug: "asx-pwl",
      code: "ASX:PWL",
      companyName: "POWERWRAP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tmg",
      code: "ASX:TMG",
      companyName: "Trigg Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vva",
      code: "ASX:VVA",
      companyName: "Viva Leisure Ltd",
      popularity: 0,
    },
    {
      slug: "asx-z1p",
      code: "ASX:Z1P",
      companyName: "ZIP CO LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-rlt",
      code: "ASX:RLT",
      companyName: "Renergen Ltd",
      popularity: 0,
    },
    {
      slug: "asx-we1",
      code: "ASX:WE1",
      companyName: "SERIES 2019-1 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-rdy",
      code: "ASX:RDY",
      companyName: "Readytech Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wen",
      code: "ASX:WEN",
      companyName: "WESTFIELD UK & EUROPE FINANCE PLC",
      popularity: 0,
    },
    {
      slug: "asx-vol",
      code: "ASX:VOL",
      companyName: "Victory Offices Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xpl",
      code: "ASX:XPL",
      companyName: "XPLORE WEALTH LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-zno",
      code: "ASX:ZNO",
      companyName: "ZOONO Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-2be",
      code: "ASX:2BE",
      companyName: "TUBI LIMITED",
      popularity: 20000,
    },
    {
      slug: "asx-ath",
      code: "ASX:ATH",
      companyName: "Alterity Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pgl",
      code: "ASX:PGL",
      companyName: "Prospa Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-iap",
      code: "ASX:IAP",
      companyName: "IRONGATE GROUP",
      popularity: 0,
    },
    {
      slug: "asx-360",
      code: "ASX:360",
      companyName: "LIFE360 Inc",
      popularity: 464000,
    },
    {
      slug: "asx-qmax",
      code: "ASX:QMAX",
      companyName: "Betashares Nasdaq 100 Yield MAX (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ave",
      code: "ASX:AVE",
      companyName: "Avecho Biotechnology Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vgi",
      code: "ASX:VGI",
      companyName: "VGI PARTNERS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-cwz",
      code: "ASX:CWZ",
      companyName: "CASHWERKZ LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-apv",
      code: "ASX:APV",
      companyName: "APPSVILLAGE AUSTRALIA LIMITED",
      popularity: 21000,
    },
    {
      slug: "asx-blu",
      code: "ASX:BLU",
      companyName: "Blue Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-zip",
      code: "ASX:ZIP",
      companyName: "ZIP Co Ltd",
      popularity: 0,
    },
    {
      slug: "asx-zyb",
      code: "ASX:ZYB",
      companyName: "ZYBER HOLDINGS LTD",
      popularity: 0,
    },
    {
      slug: "asx-nxr",
      code: "ASX:NXR",
      companyName: "NEMEX RESOURCES LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-cnb",
      code: "ASX:CNB",
      companyName: "Carnaby Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pks",
      code: "ASX:PKS",
      companyName: "PKS HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pal",
      code: "ASX:PAL",
      companyName: "PALLA PHARMA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sm9",
      code: "ASX:SM9",
      companyName: "SMART ABS SERIES 2019-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-mll",
      code: "ASX:MLL",
      companyName: "MALI LITHIUM LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tna",
      code: "ASX:TNA",
      companyName: "TARTANA RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-btk",
      code: "ASX:BTK",
      companyName: "BOTAI TECHNOLOGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pgg",
      code: "ASX:PGG",
      companyName: "Partners Group Global Income Fund",
      popularity: 0,
    },
    {
      slug: "asx-fcl",
      code: "ASX:FCL",
      companyName: "Fineos Corporation Holdings Plc",
      popularity: 0,
    },
    {
      slug: "asx-nzs",
      code: "ASX:NZS",
      companyName: "New Zealand Coastal Seafoods Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mhh",
      code: "ASX:MHH",
      companyName: "MAGELLAN HIGH CONVICTION TRUST",
      popularity: 0,
    },
    {
      slug: "asx-rpm",
      code: "ASX:RPM",
      companyName: "RPM Automotive Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ki1",
      code: "ASX:KI1",
      companyName: "KINGFISHER TRUST 2019-1",
      popularity: 0,
    },
    {
      slug: "asx-lt3",
      code: "ASX:LT3",
      companyName: "LA TROBE FINANCIAL CAPITAL MARKETS TRUST 2019-1",
      popularity: 0,
    },
    {
      slug: "asx-li6",
      code: "ASX:LI6",
      companyName:
        "LIBERTY FUNDING PTY LTD IN RESPECT OF LIBERTY SERIES 2019-2",
      popularity: 0,
    },
    {
      slug: "asx-hrz",
      code: "ASX:HRZ",
      companyName: "Horizon Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ele",
      code: "ASX:ELE",
      companyName: "Elmore Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pu1",
      code: "ASX:PU1",
      companyName: "PEPPER RESIDENTIAL SECURITIES TRUST NO. 23",
      popularity: 0,
    },
    {
      slug: "asx-pox",
      code: "ASX:POX",
      companyName: "PROGRESS 2019-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-brv",
      code: "ASX:BRV",
      companyName: "BIG RIVER GOLD LTD",
      popularity: 0,
    },
    {
      slug: "asx-spw",
      code: "ASX:SPW",
      companyName: "SAPPHIRE XXI SERIES 2019-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-osx",
      code: "ASX:OSX",
      companyName: "Osteopore Ltd",
      popularity: 0,
    },
    {
      slug: "asx-man",
      code: "ASX:MAN",
      companyName: "Mandrake Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-she",
      code: "ASX:SHE",
      companyName: "Stonehorse Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vr8",
      code: "ASX:VR8",
      companyName: "Vanadium Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-imr",
      code: "ASX:IMR",
      companyName: "Imricor Medical Systems Inc",
      popularity: 0,
    },
    {
      slug: "asx-opc",
      code: "ASX:OPC",
      companyName: "OPTICOMM LTD",
      popularity: 0,
    },
    {
      slug: "asx-mad",
      code: "ASX:MAD",
      companyName: "Mader Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wja",
      code: "ASX:WJA",
      companyName: "WAMEJA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ecs",
      code: "ASX:ECS",
      companyName: "ECS Botanics Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xcd",
      code: "ASX:XCD",
      companyName: "XCD ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-sg1",
      code: "ASX:SG1",
      companyName: "SAGON RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-vg8",
      code: "ASX:VG8",
      companyName: "VGI PARTNERS ASIAN INVESTMENTS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-13s",
      code: "ASX:13S",
      companyName: "13 SEEDS LTD",
      popularity: 8000,
    },
    {
      slug: "asx-ice",
      code: "ASX:ICE",
      companyName: "Icetana Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vlue",
      code: "ASX:VLUE",
      companyName: "Vaneck MSCI International Value ETF",
      popularity: 0,
    },
    {
      slug: "asx-m8s",
      code: "ASX:M8S",
      companyName: "M8 Sustainable Ltd",
      popularity: 0,
    },
    {
      slug: "asx-asq",
      code: "ASX:ASQ",
      companyName: "Australian Silica Quartz Group Ltd",
      popularity: 22000,
    },
    {
      slug: "asx-3da",
      code: "ASX:3DA",
      companyName: "Amaero International Ltd",
      popularity: 34000,
    },
    {
      slug: "asx-subd",
      code: "ASX:SUBD",
      companyName: "Vaneck Australian Subordinated Debt ETF",
      popularity: 0,
    },
    {
      slug: "asx-urnm",
      code: "ASX:URNM",
      companyName: "Betashares Global Uranium ETF",
      popularity: 0,
    },
    {
      slug: "asx-veth",
      code: "ASX:VETH",
      companyName: "Vanguard Ethically Conscious Australian Shares ETF",
      popularity: 0,
    },
    {
      slug: "asx-wtl",
      code: "ASX:WTL",
      companyName: "WT Financial Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-blv",
      code: "ASX:BLV",
      companyName: "BLOSSOMVALE HOLDINGS LTD",
      popularity: 0,
    },
    {
      slug: "asx-vngs",
      code: "ASX:VNGS",
      companyName: "Vaughan Nelson Global Smid Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-nfi",
      code: "ASX:NFI",
      companyName: "NATIONAL HOUSING FINANCE AND INVESTMENT CORPORATION",
      popularity: 0,
    },
    {
      slug: "asx-ushy",
      code: "ASX:USHY",
      companyName: "Global X Usd High Yield Bond ETF(Currency Hedged)",
      popularity: 0,
    },
    {
      slug: "asx-nto",
      code: "ASX:NTO",
      companyName: "NITRO SOFTWARE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-nuc",
      code: "ASX:NUC",
      companyName: "Nuchev Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oll",
      code: "ASX:OLL",
      companyName: "Openlearning Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xalg",
      code: "ASX:XALG",
      companyName: "Alphinity Global Equity Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-qyld",
      code: "ASX:QYLD",
      companyName: "Global X Nasdaq 100 Covered Call ETF",
      popularity: 0,
    },
    {
      slug: "asx-amx",
      code: "ASX:AMX",
      companyName: "Aerometrex Ltd",
      popularity: 48000,
    },
    {
      slug: "asx-mme",
      code: "ASX:MME",
      companyName: "Moneyme Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gnm",
      code: "ASX:GNM",
      companyName: "Great Northern Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-royl",
      code: "ASX:ROYL",
      companyName: "Betashares Global Royalties ETF",
      popularity: 0,
    },
    {
      slug: "asx-moz",
      code: "ASX:MOZ",
      companyName: "Mosaic Brands Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sgllv",
      code: "ASX:SGLLV",
      companyName: "Ricegrowers Ltd",
      popularity: 0,
    },
    {
      slug: "asx-semi",
      code: "ASX:SEMI",
      companyName: "Global X Semiconductor ETF",
      popularity: 0,
    },
    {
      slug: "asx-uyld",
      code: "ASX:UYLD",
      companyName: "Global X S&P 500 Covered Call ETF",
      popularity: 0,
    },
    {
      slug: "asx-ffl",
      code: "ASX:FFL",
      companyName: "FOUNDERS FIRST LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-t3mp",
      code: "ASX:T3MP",
      companyName: "Jpmorgan Climate CHG Sol Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ustb",
      code: "ASX:USTB",
      companyName: "Global X US Treasury Bond ETF (Currency Hedged)",
      popularity: 0,
    },
    {
      slug: "asx-esl",
      code: "ASX:ESL",
      companyName: "ECO SYSTEMS LTD",
      popularity: 0,
    },
    {
      slug: "asx-tann",
      code: "ASX:TANN",
      companyName: "Betashares Solar ETF",
      popularity: 0,
    },
    {
      slug: "asx-tyr",
      code: "ASX:TYR",
      companyName: "Tyro Payments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-s3go",
      code: "ASX:S3GO",
      companyName: "Firetrail S3 Global Opps Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-das",
      code: "ASX:DAS",
      companyName: "DRIVER AUSTRALIA SIX TRUST",
      popularity: 0,
    },
    {
      slug: "asx-ffr",
      code: "ASX:FFR",
      companyName: "FIREFLY RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-tdy",
      code: "ASX:TDY",
      companyName: "THEDOCYARD LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ecp",
      code: "ASX:ECP",
      companyName: "ECP Emerging Growth Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hwh",
      code: "ASX:HWH",
      companyName: "HOUSTON WE HAVE LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-grl",
      code: "ASX:GRL",
      companyName: "Godolphin Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bond",
      code: "ASX:BOND",
      companyName: "SPDR S&P/ASX Australian Bond Fund",
      popularity: 0,
    },
    {
      slug: "asx-re1",
      code: "ASX:RE1",
      companyName: "RESA GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-eeu",
      code: "ASX:EEU",
      companyName: "Betashares Euro ETF",
      popularity: 0,
    },
    {
      slug: "asx-bbus",
      code: "ASX:BBUS",
      companyName: "Betashares US EQY Strong Bear - CH (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-bboz",
      code: "ASX:BBOZ",
      companyName: "Betashares Australian Strong Bear (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-cred",
      code: "ASX:CRED",
      companyName: "Betashares Australian Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-emt",
      code: "ASX:EMT",
      companyName: "Emetals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-drug",
      code: "ASX:DRUG",
      companyName: "Betashares Global Healthcare ETF - Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-lt4",
      code: "ASX:LT4",
      companyName: "LA TROBE FINANCIAL CAPITAL MARKETS TRUST 2019-2",
      popularity: 0,
    },
    {
      slug: "asx-aaa",
      code: "ASX:AAA",
      companyName: "Betashares Australian High Interest Cash ETF",
      popularity: 422000,
    },
    {
      slug: "asx-eiga",
      code: "ASX:EIGA",
      companyName: "Perennial Income Generator Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-auds",
      code: "ASX:AUDS",
      companyName: "Betashares Strong Australian Dollar Fund (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-asia",
      code: "ASX:ASIA",
      companyName: "Betashares Asia Technology Tigers ETF",
      popularity: 1370000,
    },
    {
      slug: "asx-cnew",
      code: "ASX:CNEW",
      companyName: "Vaneck China New Economy ETF",
      popularity: 0,
    },
    {
      slug: "asx-bnds",
      code: "ASX:BNDS",
      companyName: "Betashares Westn Asset Aus Bond Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-bnks",
      code: "ASX:BNKS",
      companyName: "Betashares Global Banks ETF - Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-lcl",
      code: "ASX:LCL",
      companyName: "LCL Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dmkt",
      code: "ASX:DMKT",
      companyName: "AMP Capital Dynamic Markets Fund (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-aumf",
      code: "ASX:AUMF",
      companyName: "Ishares Edge MSCI Australia Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "asx-aust",
      code: "ASX:AUST",
      companyName: "Betashares Managed Risk AUS SH Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-core",
      code: "ASX:CORE",
      companyName: "ETFs Global Core Infrastructure ETF",
      popularity: 0,
    },
    {
      slug: "asx-div",
      code: "ASX:DIV",
      companyName: "Ubs IQ Morningstar Australia Dividend Yield ETF",
      popularity: 0,
    },
    {
      slug: "asx-food",
      code: "ASX:FOOD",
      companyName: "Betashares Global Agriculture ETF - Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-iaa",
      code: "ASX:IAA",
      companyName: "Ishares Asia 50 ETF",
      popularity: 0,
    },
    {
      slug: "asx-gear",
      code: "ASX:GEAR",
      companyName: "Betashares Geared Australian Equity Fund (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ggus",
      code: "ASX:GGUS",
      companyName:
        "Betashares Geared US Equity Fund Currency Hedged (Hedgefund)",
      popularity: 0,
    },
    {
      slug: "asx-fuel",
      code: "ASX:FUEL",
      companyName: "Betashares Global Energy Companies ETF - Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-glin",
      code: "ASX:GLIN",
      companyName: "Ishares Ftse GBL Infrastructure (Aud Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-ex20",
      code: "ASX:EX20",
      companyName: "Betashares Australian Ex-20 Portfolio Diversifier ETF",
      popularity: 0,
    },
    {
      slug: "asx-govt",
      code: "ASX:GOVT",
      companyName: "SPDR S&P/ASX Australian Government Bond Fund",
      popularity: 0,
    },
    {
      slug: "asx-grnv",
      code: "ASX:GRNV",
      companyName: "Vaneck MSCI Australian Sustainable Equity ETF",
      popularity: 0,
    },
    {
      slug: "asx-femx",
      code: "ASX:FEMX",
      companyName: "Fidelity Global Emerging Markets Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-grow",
      code: "ASX:GROW",
      companyName: "Schroder Real Return (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-iem",
      code: "ASX:IEM",
      companyName: "Ishares MSCI Emerging Markets ETF",
      popularity: 0,
    },
    {
      slug: "asx-heur",
      code: "ASX:HEUR",
      companyName: "Betashares Europe ETF-Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-ieu",
      code: "ASX:IEU",
      companyName: "Ishares Europe ETF",
      popularity: 0,
    },
    {
      slug: "asx-fair",
      code: "ASX:FAIR",
      companyName: "Betashares Australian Sustainability Leaders ETF",
      popularity: 0,
    },
    {
      slug: "asx-hjpn",
      code: "ASX:HJPN",
      companyName: "Betashares Japan ETF-Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-etpmpm",
      code: "ASX:ETPMPM",
      companyName: "Global X Metal Securities Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-etpmpt",
      code: "ASX:ETPMPT",
      companyName: "Global X Metal Securities Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-f100",
      code: "ASX:F100",
      companyName: "Betashares Ftse 100 ETF",
      popularity: 0,
    },
    {
      slug: "asx-flot",
      code: "ASX:FLOT",
      companyName: "Vaneck Australian Floating Rate ETF",
      popularity: 0,
    },
    {
      slug: "asx-gdx",
      code: "ASX:GDX",
      companyName: "Vaneck Gold Miners ETF",
      popularity: 0,
    },
    {
      slug: "asx-mhg",
      code: "ASX:MHG",
      companyName:
        "Magellan Global Equities Fund Currency Hedged (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-mnrs",
      code: "ASX:MNRS",
      companyName: "Betashares Global Gold Miners ETF - Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-izz",
      code: "ASX:IZZ",
      companyName: "Ishares China Large-Cap ETF",
      popularity: 0,
    },
    {
      slug: "asx-incm",
      code: "ASX:INCM",
      companyName: "Betashares Global Income Leaders ETF",
      popularity: 0,
    },
    {
      slug: "asx-mogl",
      code: "ASX:MOGL",
      companyName: "Montaka GBL Long Only Equities Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ioz",
      code: "ASX:IOZ",
      companyName: "Ishares Core S&P/ASX 200 ETF",
      popularity: 0,
    },
    {
      slug: "asx-impq",
      code: "ASX:IMPQ",
      companyName: "Perennial Better Future Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ijr",
      code: "ASX:IJR",
      companyName: "Ishares S&P Small-Cap ETF",
      popularity: 0,
    },
    {
      slug: "asx-iko",
      code: "ASX:IKO",
      companyName: "Ishares MSCI South Korea ETF",
      popularity: 0,
    },
    {
      slug: "asx-ilb",
      code: "ASX:ILB",
      companyName: "Ishares Government Inflation ETF",
      popularity: 0,
    },
    {
      slug: "asx-ilc",
      code: "ASX:ILC",
      companyName: "Ishares S&P/ASX 20 ETF",
      popularity: 0,
    },
    {
      slug: "asx-ixj",
      code: "ASX:IXJ",
      companyName: "Ishares Global Healthcare ETF",
      popularity: 0,
    },
    {
      slug: "asx-moat",
      code: "ASX:MOAT",
      companyName: "Vaneck Morningstar Wide Moat ETF",
      popularity: 0,
    },
    {
      slug: "asx-inif",
      code: "ASX:INIF",
      companyName: "Intelligent Investor Aus Equity Income Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-ixi",
      code: "ASX:IXI",
      companyName: "Ishares Global Consumer Staples ETF",
      popularity: 0,
    },
    {
      slug: "asx-ive",
      code: "ASX:IVE",
      companyName: "Ishares MSCI Eafe ETF",
      popularity: 0,
    },
    {
      slug: "asx-ksm",
      code: "ASX:KSM",
      companyName: "K2 Australian Small Cap Fund (Hedge Fund)",
      popularity: 0,
    },
    {
      slug: "asx-itw",
      code: "ASX:ITW",
      companyName: "Ishares MSCI TW ETF",
      popularity: 0,
    },
    {
      slug: "asx-ines",
      code: "ASX:INES",
      companyName: "Intelligent Investor Ethical Share Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-iwld",
      code: "ASX:IWLD",
      companyName: "Ishares Core MSCI World Ex Australia Esg ETF",
      popularity: 0,
    },
    {
      slug: "asx-mva",
      code: "ASX:MVA",
      companyName: "Vaneck Australian Property ETF",
      popularity: 0,
    },
    {
      slug: "asx-mge",
      code: "ASX:MGE",
      companyName: "Magellan Global Equities Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-mich",
      code: "ASX:MICH",
      companyName:
        "Magellan Infrastructure Fund (Currency Hedged)(Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-isec",
      code: "ASX:ISEC",
      companyName: "Ishares Enhanced Cash ETF",
      popularity: 0,
    },
    {
      slug: "asx-iso",
      code: "ASX:ISO",
      companyName: "Ishares S&P/ASX Small Ordinaries ETF",
      popularity: 0,
    },
    {
      slug: "asx-mony",
      code: "ASX:MONY",
      companyName: "Ubs IQ Cash ETF",
      popularity: 0,
    },
    {
      slug: "asx-plus",
      code: "ASX:PLUS",
      companyName: "Vaneck Australian Corporate Bond Plus ETF",
      popularity: 0,
    },
    {
      slug: "asx-qmix",
      code: "ASX:QMIX",
      companyName: "SPDR MSCI World Quality MIX Fund",
      popularity: 0,
    },
    {
      slug: "asx-rent",
      code: "ASX:RENT",
      companyName: "AMP Capital Global Prop Sec Fund (Unhedged) (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-pmgold",
      code: "ASX:PMGOLD",
      companyName: "Gold Corporation",
      popularity: 0,
    },
    {
      slug: "asx-qlty",
      code: "ASX:QLTY",
      companyName: "Betashares Global Quality Leaders ETF",
      popularity: 0,
    },
    {
      slug: "asx-qhal",
      code: "ASX:QHAL",
      companyName: "Vaneck MSCI International Quality (Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-rcb",
      code: "ASX:RCB",
      companyName: "Russell Investments Australian Select Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-rgb",
      code: "ASX:RGB",
      companyName: "Russell Investments Australian Government Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-robo",
      code: "ASX:ROBO",
      companyName: "Global X Robo Global Robotics & Automation ETF",
      popularity: 0,
    },
    {
      slug: "asx-rsm",
      code: "ASX:RSM",
      companyName: "Russell Investments Australian Semi-Government Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-rbtz",
      code: "ASX:RBTZ",
      companyName: "Betashares Global Robotics and Artificial Intelligence ETF",
      popularity: 0,
    },
    {
      slug: "asx-qus",
      code: "ASX:QUS",
      companyName: "Betashares S&P 500 EQUAL Weight ETF",
      popularity: 0,
    },
    {
      slug: "asx-pou",
      code: "ASX:POU",
      companyName: "Betashares British Pound ETF",
      popularity: 0,
    },
    {
      slug: "asx-qpon",
      code: "ASX:QPON",
      companyName: "Betashares Australian Bank Senior Floating Rate Bond ETF",
      popularity: 0,
    },
    {
      slug: "asx-qau",
      code: "ASX:QAU",
      companyName: "Betashares Gold Bullion ETF - Currency Hedged",
      popularity: 0,
    },
    {
      slug: "asx-qag",
      code: "ASX:QAG",
      companyName: "Betashares Agriculture ETF-Currency Hedged (Synthetic)",
      popularity: 0,
    },
    {
      slug: "asx-sso",
      code: "ASX:SSO",
      companyName: "SPDR S&P/ASX Small Ordinaries Fund",
      popularity: 0,
    },
    {
      slug: "asx-qcb",
      code: "ASX:QCB",
      companyName:
        "Betashares Commodities Basket ETF-Currency Hedged(Synthetic)",
      popularity: 0,
    },
    {
      slug: "asx-vap",
      code: "ASX:VAP",
      companyName: "Vanguard Australian Property Securities INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-xco2",
      code: "ASX:XCO2",
      companyName: "Vaneck Global Carbon Credits ETF (Synthetic)",
      popularity: 0,
    },
    {
      slug: "asx-vvlu",
      code: "ASX:VVLU",
      companyName: "Vanguard Global Value Equity Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-vcf",
      code: "ASX:VCF",
      companyName:
        "Vanguard International Credit Securities INDEX (Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-vlc",
      code: "ASX:VLC",
      companyName: "Vanguard MSCI Australian Large Companies INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-vgmf",
      code: "ASX:VGMF",
      companyName: "Vanguard Global Multi-Factor Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-vdco",
      code: "ASX:VDCO",
      companyName: "Vanguard Diversified Conservative INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-xmet",
      code: "ASX:XMET",
      companyName: "Betashares Energy Transition Metals ETF",
      popularity: 0,
    },
    {
      slug: "asx-vefi",
      code: "ASX:VEFI",
      companyName:
        "Vanguard Ethically Conscious GLB Agg Bond INDEX (Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-vmin",
      code: "ASX:VMIN",
      companyName:
        "Vanguard Global Minimum Volatility Active ETF (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-wcmq",
      code: "ASX:WCMQ",
      companyName: "WCM Quality Global Growth Fund (Quoted Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-wdmf",
      code: "ASX:WDMF",
      companyName: "Ishares Edge MSCI World Multifactor ETF",
      popularity: 0,
    },
    {
      slug: "asx-wemg",
      code: "ASX:WEMG",
      companyName: "SPDR S&P Emerging Markets Carbon Control Fund",
      popularity: 0,
    },
    {
      slug: "asx-wrld",
      code: "ASX:WRLD",
      companyName: "Betashares Managed Risk Global Share Fund (Managed Fund)",
      popularity: 0,
    },
    {
      slug: "asx-wvol",
      code: "ASX:WVOL",
      companyName: "Ishares Edge MSCI World Minimum Volatility ETF",
      popularity: 0,
    },
    {
      slug: "asx-wxoz",
      code: "ASX:WXOZ",
      companyName: "SPDR S&P World Ex Australia Carbon Control Fund",
      popularity: 0,
    },
    {
      slug: "asx-vbld",
      code: "ASX:VBLD",
      companyName: "Vanguard Global Infrastructure INDEX ETF",
      popularity: 0,
    },
    {
      slug: "asx-vbnd",
      code: "ASX:VBND",
      companyName: "Vanguard Global Aggregate Bond INDEX (Hedged) ETF",
      popularity: 0,
    },
    {
      slug: "asx-zyau",
      code: "ASX:ZYAU",
      companyName: "Global X S&P/ASX 200 High Dividend ETF",
      popularity: 0,
    },
    {
      slug: "asx-tso",
      code: "ASX:TSO",
      companyName: "Tesoro Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mcb",
      code: "ASX:MCB",
      companyName: "MCB RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-al3",
      code: "ASX:AL3",
      companyName: "AML3D Ltd",
      popularity: 47000,
    },
    {
      slug: "asx-af1",
      code: "ASX:AF1",
      companyName: "AFG 2019-2 TRUST IN RESPECT OF SERIES 2019-2",
      popularity: 6000,
    },
    {
      slug: "asx-msl",
      code: "ASX:MSL",
      companyName: "MSL SOLUTIONS LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-ads",
      code: "ASX:ADS",
      companyName: "Adslot Ltd",
      popularity: 19000,
    },
    {
      slug: "asx-acu",
      code: "ASX:ACU",
      companyName: "Acumentis Group Ltd",
      popularity: 18000,
    },
    {
      slug: "asx-pft",
      code: "ASX:PFT",
      companyName: "Pure Foods Tasmania Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fa2",
      code: "ASX:FA2",
      companyName: "FIRST ABU DHABI BANK PJSC",
      popularity: 0,
    },
    {
      slug: "asx-fm4",
      code: "ASX:FM4",
      companyName: "FIRSTMAC MORTGAGE FUNDING TRUST NO.4 SERIES 3PP-2019",
      popularity: 0,
    },
    {
      slug: "asx-env",
      code: "ASX:ENV",
      companyName: "Enova Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dcx",
      code: "ASX:DCX",
      companyName: "Discovex Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fa1",
      code: "ASX:FA1",
      companyName: "FLEXI ABS TRUST 2019-2",
      popularity: 0,
    },
    {
      slug: "asx-icr",
      code: "ASX:ICR",
      companyName: "Intelicare Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-htg",
      code: "ASX:HTG",
      companyName: "Harvest Technology Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nnt",
      code: "ASX:NNT",
      companyName: "99 LOYALTY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-mkr",
      code: "ASX:MKR",
      companyName: "Manuka Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-at1",
      code: "ASX:AT1",
      companyName: "Atomo Diagnostics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pu3",
      code: "ASX:PU3",
      companyName: "PEPPER SPARKZ TRUST NO. 2",
      popularity: 0,
    },
    {
      slug: "asx-pu2",
      code: "ASX:PU2",
      companyName: "PUMA SERIES 2019-1",
      popularity: 0,
    },
    {
      slug: "asx-wb1",
      code: "ASX:WB1",
      companyName: "SERIES 2020-1 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-tt3",
      code: "ASX:TT3",
      companyName: "TRITON TRUST NO.8 IN RESPECT OF THE BOND SERIES 2019-3",
      popularity: 0,
    },
    {
      slug: "asx-arr",
      code: "ASX:ARR",
      companyName: "American Rare EARTHS Ltd",
      popularity: 239000,
    },
    {
      slug: "asx-wpr",
      code: "ASX:WPR",
      companyName: "Waypoint REIT",
      popularity: 0,
    },
    {
      slug: "asx-zyus",
      code: "ASX:ZYUS",
      companyName: "Global X S&P 500 High Yield Low Volatility ETF",
      popularity: 0,
    },
    {
      slug: "asx-zusd",
      code: "ASX:ZUSD",
      companyName: "ETFs Enhanced Usd Cash ETF",
      popularity: 0,
    },
    {
      slug: "asx-asm",
      code: "ASX:ASM",
      companyName: "Australian Strategic Materials Ltd",
      popularity: 257000,
    },
    {
      slug: "asx-erd",
      code: "ASX:ERD",
      companyName: "Eroad Ltd",
      popularity: 0,
    },
    {
      slug: "asx-xnc",
      code: "ASX:XNC",
      companyName: "NEW SOUTH WALES TREASURY CORPORATION",
      popularity: 0,
    },
    {
      slug: "asx-stk",
      code: "ASX:STK",
      companyName: "Strickland Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aim",
      code: "ASX:AIM",
      companyName: "Ai-Media Technologies Ltd",
      popularity: 48000,
    },
    {
      slug: "asx-sng",
      code: "ASX:SNG",
      companyName: "Siren Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-drr",
      code: "ASX:DRR",
      companyName: "Deterra Royalties Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wc8",
      code: "ASX:WC8",
      companyName: "Wildcat Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ba2",
      code: "ASX:BA2",
      companyName: "SERIES 2019-1 REDS TRUST",
      popularity: 0,
    },
    {
      slug: "asx-srj",
      code: "ASX:SRJ",
      companyName: "SRJ Technologies Group Plc",
      popularity: 0,
    },
    {
      slug: "asx-ddb",
      code: "ASX:DDB",
      companyName: "Dynamic Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pf1",
      code: "ASX:PF1",
      companyName: "PATHFINDER RESOURCES LTD",
      popularity: 0,
    },
    {
      slug: "asx-mbh",
      code: "ASX:MBH",
      companyName: "Maggie Beer Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mvl",
      code: "ASX:MVL",
      companyName: "Marvel Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nsm",
      code: "ASX:NSM",
      companyName: "North Stawell Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fm1",
      code: "ASX:FM1",
      companyName: "FIRSTMAC MORTGAGE FUNDING TRUST NO.4 SERIES 4-2019",
      popularity: 0,
    },
    {
      slug: "asx-npm",
      code: "ASX:NPM",
      companyName: "Newpeak Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fff",
      code: "ASX:FFF",
      companyName: "Forbidden Foods Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ta1",
      code: "ASX:TA1",
      companyName: "TRANSURBAN FINANCE COMPANY PTY LTD",
      popularity: 0,
    },
    {
      slug: "asx-nzo",
      code: "ASX:NZO",
      companyName: "New Zealand Oil & Gas Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ras",
      code: "ASX:RAS",
      companyName: "Ragusa Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vt1",
      code: "ASX:VT1",
      companyName: "VERMILION TRUST NO.1 BOND SERIES 2019-1",
      popularity: 0,
    },
    {
      slug: "asx-suv",
      code: "ASX:SUV",
      companyName: "Suvo Strategic Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pam",
      code: "ASX:PAM",
      companyName: "Pan Asia Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lby",
      code: "ASX:LBY",
      companyName: "LAYBUY GROUP HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-4dx",
      code: "ASX:4DX",
      companyName: "4DMEDICAL Ltd",
      popularity: 263000,
    },
    {
      slug: "asx-hxl",
      code: "ASX:HXL",
      companyName: "Hexima Ltd",
      popularity: 0,
    },
    {
      slug: "asx-prs",
      code: "ASX:PRS",
      companyName: "Prospech Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hpg",
      code: "ASX:HPG",
      companyName: "Hipages Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cha",
      code: "ASX:CHA",
      companyName: "CHAUCER ENERGY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-aun",
      code: "ASX:AUN",
      companyName: "Aurumin Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cle",
      code: "ASX:CLE",
      companyName: "Cyclone Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wma",
      code: "ASX:WMA",
      companyName: "Wam Alternative Assets Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wak",
      code: "ASX:WAK",
      companyName: "Wa Kaolin Ltd",
      popularity: 0,
    },
    {
      slug: "asx-yfz",
      code: "ASX:YFZ",
      companyName: "YOUFOODZ HOLDINGS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-crw",
      code: "ASX:CRW",
      companyName: "CASHREWARDS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ptg",
      code: "ASX:PTG",
      companyName: "PROPTECH GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-px1",
      code: "ASX:PX1",
      companyName: "PLEXURE GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-anx",
      code: "ASX:ANX",
      companyName: "ANAX Metals Ltd",
      popularity: 34000,
    },
    {
      slug: "asx-hdn",
      code: "ASX:HDN",
      companyName: "Homeco Daily Needs REIT",
      popularity: 0,
    },
    {
      slug: "asx-dsk",
      code: "ASX:DSK",
      companyName: "Dusk Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aby",
      code: "ASX:ABY",
      companyName: "Adore Beauty Group Ltd",
      popularity: 271000,
    },
    {
      slug: "asx-clu",
      code: "ASX:CLU",
      companyName: "Cluey Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cpn",
      code: "ASX:CPN",
      companyName: "Caspin Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-e33",
      code: "ASX:E33",
      companyName: "East 33 Ltd",
      popularity: 0,
    },
    {
      slug: "asx-zbt",
      code: "ASX:ZBT",
      companyName: "ZEBIT INC.",
      popularity: 0,
    },
    {
      slug: "asx-epy",
      code: "ASX:EPY",
      companyName: "Earlypay Ltd",
      popularity: 0,
    },
    {
      slug: "asx-li8",
      code: "ASX:LI8",
      companyName: "LION SERIES 2020-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-awj",
      code: "ASX:AWJ",
      companyName: "Auric Mining Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bdm",
      code: "ASX:BDM",
      companyName: "Burgundy Diamond Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bnz",
      code: "ASX:BNZ",
      companyName: "BENZ Mining Corp",
      popularity: 0,
    },
    {
      slug: "asx-mm8",
      code: "ASX:MM8",
      companyName: "Medallion Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tt4",
      code: "ASX:TT4",
      companyName: "TRITON BOND TRUST 2020 IN RESPECT OF SERIES 1",
      popularity: 0,
    },
    {
      slug: "asx-erw",
      code: "ASX:ERW",
      companyName: "Errawarra Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bpm",
      code: "ASX:BPM",
      companyName: "BPM Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gda",
      code: "ASX:GDA",
      companyName: "Good Drinks Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sla",
      code: "ASX:SLA",
      companyName: "Silk Laser Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hum",
      code: "ASX:HUM",
      companyName: "Humm Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ply",
      code: "ASX:PLY",
      companyName: "Playside Studios Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ahc",
      code: "ASX:AHC",
      companyName: "Austco Healthcare Ltd",
      popularity: 27000,
    },
    {
      slug: "asx-myg",
      code: "ASX:MYG",
      companyName: "Mayfield Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tru",
      code: "ASX:TRU",
      companyName: "Truscreen Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tsi",
      code: "ASX:TSI",
      companyName: "Top Shelf International Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mgh",
      code: "ASX:MGH",
      companyName: "Maas Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-chm",
      code: "ASX:CHM",
      companyName: "Chimeric Therapeutics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dbi",
      code: "ASX:DBI",
      companyName: "Dalrymple Bay Infrastructure Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ace",
      code: "ASX:ACE",
      companyName: "Acusensus Ltd",
      popularity: 16000,
    },
    {
      slug: "asx-trn",
      code: "ASX:TRN",
      companyName: "TORRENS MINING LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lt5",
      code: "ASX:LT5",
      companyName: "LA TROBE FINANCIAL CAPITAL MARKETS TRUST 2020-1",
      popularity: 0,
    },
    {
      slug: "asx-li7",
      code: "ASX:LI7",
      companyName: "LIBERTY SERIES 2020-2",
      popularity: 0,
    },
    {
      slug: "asx-ddh",
      code: "ASX:DDH",
      companyName: "DDH1 Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gdc",
      code: "ASX:GDC",
      companyName: "Global Data Centre Group",
      popularity: 0,
    },
    {
      slug: "asx-det",
      code: "ASX:DET",
      companyName: "DEALT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-bmo",
      code: "ASX:BMO",
      companyName: "Bastion Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mfb",
      code: "ASX:MFB",
      companyName: "MY FOOD BAG GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pvw",
      code: "ASX:PVW",
      companyName: "PVW Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-af2",
      code: "ASX:AF2",
      companyName: "AFG 2020-1NC TRUST IN RESPECT OF SERIES 2020-1NC",
      popularity: 7000,
    },
    {
      slug: "asx-ap2",
      code: "ASX:AP2",
      companyName: "APA INFRASTRUCTURE LIMITED",
      popularity: 36000,
    },
    {
      slug: "asx-epn",
      code: "ASX:EPN",
      companyName: "Epsilon Healthcare Ltd",
      popularity: 0,
    },
    {
      slug: "asx-frb",
      code: "ASX:FRB",
      companyName: "Firebird Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wot",
      code: "ASX:WOT",
      companyName: "Wotso Property",
      popularity: 0,
    },
    {
      slug: "asx-tg1",
      code: "ASX:TG1",
      companyName: "Techgen Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-art",
      code: "ASX:ART",
      companyName: "Airtasker Ltd",
      popularity: 344000,
    },
    {
      slug: "asx-bml",
      code: "ASX:BML",
      companyName: "Boab Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-c2f",
      code: "ASX:C2F",
      companyName: "CENTURIA FUNDS MANAGEMENT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-gen",
      code: "ASX:GEN",
      companyName: "Genmin Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fm5",
      code: "ASX:FM5",
      companyName: "FIRSTMAC MORTGAGE FUNDING TRUST NO.4 SERIES 2-2020",
      popularity: 0,
    },
    {
      slug: "asx-ka1",
      code: "ASX:KA1",
      companyName: "KOREA EXPRESSWAY CORPORATION",
      popularity: 0,
    },
    {
      slug: "asx-ra2",
      code: "ASX:RA2",
      companyName: "RESIMAC PREMIER SERIES 2020-1",
      popularity: 0,
    },
    {
      slug: "asx-ezz",
      code: "ASX:EZZ",
      companyName: "EZZ Life Science Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-woo",
      code: "ASX:WOO",
      companyName: "WOOBOARD TECHNOLOGIES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-jno",
      code: "ASX:JNO",
      companyName: "Juno Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ra1",
      code: "ASX:RA1",
      companyName: "RESIMAC PREMIER SERIES 2020-2",
      popularity: 0,
    },
    {
      slug: "asx-mpa",
      code: "ASX:MPA",
      companyName: "Mad Paws Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rb1",
      code: "ASX:RB1",
      companyName: "RUBY BOND TRUST 2020-1",
      popularity: 0,
    },
    {
      slug: "asx-tul",
      code: "ASX:TUL",
      companyName: "TULLA RESOURCES PLC",
      popularity: 0,
    },
    {
      slug: "asx-pgd",
      code: "ASX:PGD",
      companyName: "Peregrine Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bex",
      code: "ASX:BEX",
      companyName: "Bikeexchange Ltd",
      popularity: 0,
    },
    {
      slug: "asx-zag",
      code: "ASX:ZAG",
      companyName: "Zuleika Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-3mf",
      code: "ASX:3MF",
      companyName: "3D Metalforge Ltd",
      popularity: 33000,
    },
    {
      slug: "asx-csm",
      code: "ASX:CSM",
      companyName: "COSMO GOLD LIMITED",
      popularity: 0,
    },
    {
      slug: "nyse-phr",
      code: "NYSE:PHR",
      companyName: "Phreesia Inc.",
      popularity: 0,
    },
    {
      slug: "asx-am7",
      code: "ASX:AM7",
      companyName: "Arcadia Minerals Ltd",
      popularity: 10000,
    },
    {
      slug: "asx-mlg",
      code: "ASX:MLG",
      companyName: "MLG OZ Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cdr",
      code: "ASX:CDR",
      companyName: "Codrus Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fg1",
      code: "ASX:FG1",
      companyName: "FLYNN Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bfl",
      code: "ASX:BFL",
      companyName: "BSP Financial Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aua",
      code: "ASX:AUA",
      companyName: "Audeara Ltd",
      popularity: 0,
    },
    {
      slug: "asx-shp",
      code: "ASX:SHP",
      companyName: "South HARZ Potash Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bez",
      code: "ASX:BEZ",
      companyName: "Besra Gold Inc",
      popularity: 0,
    },
    {
      slug: "asx-agn",
      code: "ASX:AGN",
      companyName: "Argenica Therapeutics Ltd",
      popularity: 20000,
    },
    {
      slug: "asx-wmg",
      code: "ASX:WMG",
      companyName: "Western Mines Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hym",
      code: "ASX:HYM",
      companyName: "HYPERION METALS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pev",
      code: "ASX:PEV",
      companyName: "PEPPER RESIDENTIAL SECURITIES TRUST NO.28",
      popularity: 0,
    },
    {
      slug: "asx-pu4",
      code: "ASX:PU4",
      companyName: "PEPPER SPARKZ TRUST NO.3",
      popularity: 0,
    },
    {
      slug: "asx-tor",
      code: "ASX:TOR",
      companyName: "Torque Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-gti",
      code: "ASX:GTI",
      companyName: "Gratifii Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hmi",
      code: "ASX:HMI",
      companyName: "Hiremii Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ked",
      code: "ASX:KED",
      companyName: "Keypath Education International Inc",
      popularity: 0,
    },
    {
      slug: "asx-vt2",
      code: "ASX:VT2",
      companyName: "VERMILION BOND TRUST 2020 IN RESPECT OF SERIES 1",
      popularity: 0,
    },
    {
      slug: "asx-wb2",
      code: "ASX:WB2",
      companyName: "WOORI BANK",
      popularity: 0,
    },
    {
      slug: "asx-ldr",
      code: "ASX:LDR",
      companyName: "Lode Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lel",
      code: "ASX:LEL",
      companyName: "Lithium Energy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-oak",
      code: "ASX:OAK",
      companyName: "Oakridge International Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ozz",
      code: "ASX:OZZ",
      companyName: "OZZ Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-srl",
      code: "ASX:SRL",
      companyName: "Sunrise Energy Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-trj",
      code: "ASX:TRJ",
      companyName: "Trajan Group Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sb2",
      code: "ASX:SB2",
      companyName: "Salter Brothers Emerging Companies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pwr",
      code: "ASX:PWR",
      companyName: "Peter Warren Automotive Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-1vg",
      code: "ASX:1VG",
      companyName: "VICTORY GOLDFIELDS LIMITED",
      popularity: 21000,
    },
    {
      slug: "asx-maf",
      code: "ASX:MAF",
      companyName: "Ma Financial Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bur",
      code: "ASX:BUR",
      companyName: "Burley Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bmr",
      code: "ASX:BMR",
      companyName: "Ballymore Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-el8",
      code: "ASX:EL8",
      companyName: "Elevate Uranium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wls",
      code: "ASX:WLS",
      companyName: "WCM GLOBAL LONG SHORT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lt6",
      code: "ASX:LT6",
      companyName: "LA TROBE FINANCIAL CAPITAL MARKETS TRUST 2020-S1",
      popularity: 0,
    },
    {
      slug: "asx-cnr",
      code: "ASX:CNR",
      companyName: "CANNON RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-li9",
      code: "ASX:LI9",
      companyName: "LIBERTY SERIES 2020-3",
      popularity: 0,
    },
    {
      slug: "asx-poa",
      code: "ASX:POA",
      companyName: "PROGRESS 2020-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-99l",
      code: "ASX:99L",
      companyName: "99 LOYALTY LIMITED.",
      popularity: 17000,
    },
    {
      slug: "asx-crr",
      code: "ASX:CRR",
      companyName: "Critical Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-btn",
      code: "ASX:BTN",
      companyName: "Butn Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dra",
      code: "ASX:DRA",
      companyName: "DRA Global Ltd",
      popularity: 0,
    },
    {
      slug: "asx-war",
      code: "ASX:WAR",
      companyName: "Wam Strategic Value Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ett",
      code: "ASX:ETT",
      companyName: "EAST 33 LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-g50",
      code: "ASX:G50",
      companyName: "Gold 50 Ltd",
      popularity: 0,
    },
    {
      slug: "asx-jtl",
      code: "ASX:JTL",
      companyName: "JAYEX Technology Ltd",
      popularity: 0,
    },
    {
      slug: "asx-drf",
      code: "ASX:DRF",
      companyName: "DRAGONFLY BIOSCIENCES LIMITED.",
      popularity: 0,
    },
    {
      slug: "asx-atv",
      code: "ASX:ATV",
      companyName: "Activeport Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-aue",
      code: "ASX:AUE",
      companyName: "Aurum Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mmc",
      code: "ASX:MMC",
      companyName: "Mitre Mining Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-e79",
      code: "ASX:E79",
      companyName: "E79 Gold Mines Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rm1",
      code: "ASX:RM1",
      companyName: "RESILIENCE MINING MONGOLIA LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-ems",
      code: "ASX:EMS",
      companyName: "Eastern Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dbo",
      code: "ASX:DBO",
      companyName: "Diablo Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rec",
      code: "ASX:REC",
      companyName: "Recharge Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rwl",
      code: "ASX:RWL",
      companyName: "Rubicon Water Ltd",
      popularity: 0,
    },
    {
      slug: "asx-b01",
      code: "ASX:B01",
      companyName: "BANCO SANTANDER S.A.",
      popularity: 0,
    },
    {
      slug: "asx-iny",
      code: "ASX:INY",
      companyName: "INCOME ASSET MANAGEMENT GROUP LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-win",
      code: "ASX:WIN",
      companyName: "Widgie Nickel Ltd",
      popularity: 0,
    },
    {
      slug: "asx-z2u",
      code: "ASX:Z2U",
      companyName: "ZOOM2U Technologies Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hio",
      code: "ASX:HIO",
      companyName: "Hawsons Iron Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tt2",
      code: "ASX:TT2",
      companyName: "TRITON BOND TRUST 2020 IN RESPECT OF SERIES 2",
      popularity: 0,
    },
    {
      slug: "asx-g79",
      code: "ASX:G79",
      companyName: "GOLDOZ LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lkn",
      code: "ASX:LKN",
      companyName: "LUKIN RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lan",
      code: "ASX:LAN",
      companyName: "LANYON INVESTMENT COMPANY LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-lt2",
      code: "ASX:LT2",
      companyName: "LA TROBE FINANCIAL CAPITAL MARKETS TRUST 2021-1",
      popularity: 0,
    },
    {
      slug: "asx-lt7",
      code: "ASX:LT7",
      companyName: "LA TROBE FINANCIAL CAPITAL MARKETS TRUST 2021-2",
      popularity: 0,
    },
    {
      slug: "asx-lp1",
      code: "ASX:LP1",
      companyName: "LIBERTY PRIME SERIES 2021-1",
      popularity: 0,
    },
    {
      slug: "asx-mf1",
      code: "ASX:MF1",
      companyName: "METRO FINANCE 2021-1 TRUST SERIES 1",
      popularity: 0,
    },
    {
      slug: "asx-dal",
      code: "ASX:DAL",
      companyName: "Dalaroo Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-tt6",
      code: "ASX:TT6",
      companyName: "TRITON BOND TRUST 2021-1 IN RESPECT OF SERIES 1",
      popularity: 0,
    },
    {
      slug: "asx-tt5",
      code: "ASX:TT5",
      companyName: "TRITON SMSF BOND TRUST 2020 IN RESPECT OF SERIES 1",
      popularity: 0,
    },
    {
      slug: "asx-frs",
      code: "ASX:FRS",
      companyName: "Forrestania Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wc1",
      code: "ASX:WC1",
      companyName: "West Cobar Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dlm",
      code: "ASX:DLM",
      companyName: "Dominion Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sdr",
      code: "ASX:SDR",
      companyName: "Siteminder Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rad",
      code: "ASX:RAD",
      companyName: "Radiopharm Theranostics Ltd",
      popularity: 0,
    },
    {
      slug: "asx-wse",
      code: "ASX:WSE",
      companyName: "SERIES 2021-1 WST TRUST",
      popularity: 0,
    },
    {
      slug: "asx-abe",
      code: "ASX:ABE",
      companyName: "Australian Bond Exchange Holdings Ltd",
      popularity: 13000,
    },
    {
      slug: "asx-ala",
      code: "ASX:ALA",
      companyName: "Arovella Therapeutics Ltd",
      popularity: 19000,
    },
    {
      slug: "asx-wr1",
      code: "ASX:WR1",
      companyName: "Winsome Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bio",
      code: "ASX:BIO",
      companyName: "Biome Australia Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kil",
      code: "ASX:KIL",
      companyName: "Kiland Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lrv",
      code: "ASX:LRV",
      companyName: "Larvotto Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fal",
      code: "ASX:FAL",
      companyName: "Falcon Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-apm",
      code: "ASX:APM",
      companyName: "APM Human Services International Ltd",
      popularity: 20000,
    },
    {
      slug: "asx-8au",
      code: "ASX:8AU",
      companyName: "8 AU LIMITED",
      popularity: 6000,
    },
    {
      slug: "asx-adm",
      code: "ASX:ADM",
      companyName: "ANDEAN MINING LIMITED",
      popularity: 10000,
    },
    {
      slug: "asx-alo",
      code: "ASX:ALO",
      companyName: "Alloggio Group Ltd",
      popularity: 13000,
    },
    {
      slug: "asx-jdo",
      code: "ASX:JDO",
      companyName: "Judo Capital Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-roc",
      code: "ASX:ROC",
      companyName: "Rocketboots Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ebr",
      code: "ASX:EBR",
      companyName: "EBR Systems Inc",
      popularity: 0,
    },
    {
      slug: "asx-aya",
      code: "ASX:AYA",
      companyName: "ARTRYA Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nim",
      code: "ASX:NIM",
      companyName: "Nimy Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vsl",
      code: "ASX:VSL",
      companyName: "Vulcan Steel Ltd",
      popularity: 0,
    },
    {
      slug: "asx-msa",
      code: "ASX:MSA",
      companyName: "MYSALE GROUP PLC",
      popularity: 0,
    },
    {
      slug: "asx-b4p",
      code: "ASX:B4P",
      companyName: "Beforepay Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bdt",
      code: "ASX:BDT",
      companyName: "Birddog Technology Ltd",
      popularity: 0,
    },
    {
      slug: "asx-feg",
      code: "ASX:FEG",
      companyName: "Far East Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fxg",
      code: "ASX:FXG",
      companyName: "FELIX Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rab",
      code: "ASX:RAB",
      companyName: "ADRABBIT LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pth",
      code: "ASX:PTH",
      companyName: "PATHIFY HOLDINGS INC.",
      popularity: 0,
    },
    {
      slug: "asx-hkx",
      code: "ASX:HKX",
      companyName: "HAEMOKINESIS LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-pe4",
      code: "ASX:PE4",
      companyName: "PEPPER SPARKZ TRUST NO.4",
      popularity: 0,
    },
    {
      slug: "asx-cmx",
      code: "ASX:CMX",
      companyName: "CHEMX Materials Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kli",
      code: "ASX:KLI",
      companyName: "Killi Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dat",
      code: "ASX:DAT",
      companyName: "DRIVER AUSTRALIA SEVEN TRUST",
      popularity: 0,
    },
    {
      slug: "asx-vmm",
      code: "ASX:VMM",
      companyName: "Viridis Mining and Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ayt",
      code: "ASX:AYT",
      companyName: "Austin Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dvr",
      code: "ASX:DVR",
      companyName: "Diverger Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sym",
      code: "ASX:SYM",
      companyName: "SYMBIO Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-1ae",
      code: "ASX:1AE",
      companyName: "Aurora Energy Metals Ltd",
      popularity: 22000,
    },
    {
      slug: "asx-c79",
      code: "ASX:C79",
      companyName: "Chrysos Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-hal",
      code: "ASX:HAL",
      companyName: "Halo Technologies Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sxg",
      code: "ASX:SXG",
      companyName: "Southern Cross Gold Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kng",
      code: "ASX:KNG",
      companyName: "Kingsland Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nrz",
      code: "ASX:NRZ",
      companyName: "Neurizer Ltd",
      popularity: 0,
    },
    {
      slug: "asx-srr",
      code: "ASX:SRR",
      companyName: "Sarama Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mf2",
      code: "ASX:MF2",
      companyName: "METRO FINANCE 2022-1 TRUST - SERIES 1",
      popularity: 0,
    },
    {
      slug: "asx-lpm",
      code: "ASX:LPM",
      companyName: "Lithium Plus Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bim",
      code: "ASX:BIM",
      companyName: "Bindi Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-cvr",
      code: "ASX:CVR",
      companyName: "Cavalier Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-fdr",
      code: "ASX:FDR",
      companyName: "Finder Energy Holdings Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ftl",
      code: "ASX:FTL",
      companyName: "Firetail Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kob",
      code: "ASX:KOB",
      companyName: "Koba Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-mma",
      code: "ASX:MMA",
      companyName: "Maronan Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-nym",
      code: "ASX:NYM",
      companyName: "Narryer Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ocn",
      code: "ASX:OCN",
      companyName: "Oceana Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sls",
      code: "ASX:SLS",
      companyName: "Solstice Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-snx",
      code: "ASX:SNX",
      companyName: "Sierra Nevada Gold Inc",
      popularity: 0,
    },
    {
      slug: "asx-pmx",
      code: "ASX:PMX",
      companyName: "PIMCO GLOBAL INCOME OPPORTUNITIES TRUST",
      popularity: 0,
    },
    {
      slug: "asx-sh2",
      code: "ASX:SH2",
      companyName: "SYNERGEN MET LIMITED",
      popularity: 0,
    },
    {
      slug: "nasdaq-abb",
      code: "NASDAQ:ABB",
      companyName: "ABB Ltd Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aaww",
      code: "NASDAQ:AAWW",
      companyName: "Atlas Air Worldwide Holdings NEW Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ab",
      code: "NASDAQ:AB",
      companyName: "AllianceBernstein Holding L.P.  Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-abev",
      code: "NASDAQ:ABEV",
      companyName:
        "Ambev S.A. American Depositary Shares (Each representing 1 Common Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-abgi",
      code: "NASDAQ:ABGI",
      companyName: "ABG Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-abio",
      code: "NASDAQ:ABIO",
      companyName: "ARCA biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abmd",
      code: "NASDAQ:ABMD",
      companyName: "ABIOMED Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abtx",
      code: "NASDAQ:ABTX",
      companyName: "Allegiance Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abus",
      code: "NASDAQ:ABUS",
      companyName: "Arbutus Biopharma Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-abvc",
      code: "NASDAQ:ABVC",
      companyName: "ABVC BioPharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ac",
      code: "NASDAQ:AC",
      companyName: "Associated Capital Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aca",
      code: "NASDAQ:ACA",
      companyName: "Arcosa Inc. Common Stock ",
      popularity: 0,
    },
    {
      slug: "nasdaq-acab",
      code: "NASDAQ:ACAB",
      companyName: "Atlantic Coastal Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acabu",
      code: "NASDAQ:ACABU",
      companyName: "Atlantic Coastal Acquisition Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-acad",
      code: "NASDAQ:ACAD",
      companyName: "ACADIA Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acah",
      code: "NASDAQ:ACAH",
      companyName: "Atlantic Coastal Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acahw",
      code: "NASDAQ:ACAHW",
      companyName: "Atlantic Coastal Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-acaq",
      code: "NASDAQ:ACAQ",
      companyName: "Athena Consumer Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-acaxr",
      code: "NASDAQ:ACAXR",
      companyName: "Alset Capital Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-achl",
      code: "NASDAQ:ACHL",
      companyName: "Achilles Therapeutics plc American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-achr",
      code: "NASDAQ:ACHR",
      companyName: "Archer Aviation Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-achv",
      code: "NASDAQ:ACHV",
      companyName: "Achieve Life Sciences Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-aciu",
      code: "NASDAQ:ACIU",
      companyName: "AC Immune SA Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-adilw",
      code: "NASDAQ:ADILW",
      companyName: "Adial Pharmaceuticals Inc Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-adm",
      code: "NASDAQ:ADM",
      companyName: "Archer-Daniels-Midland Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aese",
      code: "NASDAQ:AESE",
      companyName: "Allied Esports Entertainment Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aeva",
      code: "NASDAQ:AEVA",
      companyName: "Aeva Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-agncp",
      code: "NASDAQ:AGNCP",
      companyName:
        "AGNC Investment Corp. Depositary Shares Each Representing a 1/1000th Interest in a Share of 6.125% Series F Fixed-to-Floating Rate Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-airt",
      code: "NASDAQ:AIRT",
      companyName: "Air T Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-airtp",
      code: "NASDAQ:AIRTP",
      companyName:
        "Air T Inc. Air T Funding Alpha Income Trust Preferred Securities",
      popularity: 0,
    },
    {
      slug: "nasdaq-ait",
      code: "NASDAQ:AIT",
      companyName: "Applied Industrial Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-all-h",
      code: "NASDAQ:ALL-H",
      companyName:
        "Allstate Corporation (The) Depositary Shares each representing a 1/1000th interest in a share of Fixed Rate Noncumulative Perpetual Preferred Stock Series H",
      popularity: 0,
    },
    {
      slug: "nasdaq-all-i",
      code: "NASDAQ:ALL-I",
      companyName:
        "Allstate Corporation (The) Depositary Shares each representing a 1/1000th interest in a share of Fixed Rate Noncumulative Perpetual Preferred Stock Series I",
      popularity: 0,
    },
    {
      slug: "nasdaq-amci",
      code: "NASDAQ:AMCI",
      companyName: "AMCI Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-amciu",
      code: "NASDAQ:AMCIU",
      companyName: "AMCI Acquisition Corp. II Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-amciw",
      code: "NASDAQ:AMCIW",
      companyName: "AMCI Acquisition Corp. II Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-amcr",
      code: "NASDAQ:AMCR",
      companyName: "Amcor plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-angh",
      code: "NASDAQ:ANGH",
      companyName: "Anghami Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-anghw",
      code: "NASDAQ:ANGHW",
      companyName: "Anghami Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-angi",
      code: "NASDAQ:ANGI",
      companyName: "Angi Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-aptv",
      code: "NASDAQ:APTV",
      companyName: "Aptiv PLC Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-arhs",
      code: "NASDAQ:ARHS",
      companyName: "Arhaus Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ari",
      code: "NASDAQ:ARI",
      companyName: "Apollo Commercial Real Estate Finance Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-aris",
      code: "NASDAQ:ARIS",
      companyName: "Aris Water Solutions Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-asgi",
      code: "NASDAQ:ASGI",
      companyName:
        "Aberdeen Standard Global Infrastructure Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-asgn",
      code: "NASDAQ:ASGN",
      companyName: "ASGN Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ash",
      code: "NASDAQ:ASH",
      companyName: "Ashland Global Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ath-b",
      code: "NASDAQ:ATH-B",
      companyName:
        "Athene Holding Ltd. Depositary Shares Each Representing a 1/1000th Interest in a 5.625% Fixed Rate Perpetual Non- Cumulative Preference Share Series B par value $1.00 per share",
      popularity: 0,
    },
    {
      slug: "nasdaq-aust",
      code: "NASDAQ:AUST",
      companyName: "Austin Gold Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-autl",
      code: "NASDAQ:AUTL",
      companyName: "Autolus Therapeutics plc American Depositary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-auto",
      code: "NASDAQ:AUTO",
      companyName: "AutoWeb Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axdx",
      code: "NASDAQ:AXDX",
      companyName: "Accelerate Diagnostics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axgn",
      code: "NASDAQ:AXGN",
      companyName: "Axogen Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-axh",
      code: "NASDAQ:AXH",
      companyName: "Industrial Human Capital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bamh",
      code: "NASDAQ:BAMH",
      companyName:
        "Brookfield Finance Inc. 4.625% Subordinated Notes due October 16 2080",
      popularity: 0,
    },
    {
      slug: "nasdaq-bcor",
      code: "NASDAQ:BCOR",
      companyName: "Blucora Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfriw",
      code: "NASDAQ:BFRIW",
      companyName: "Biofrontera Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfs",
      code: "NASDAQ:BFS",
      companyName: "Saul Centers Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bfst",
      code: "NASDAQ:BFST",
      companyName: "Business First Bancshares Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bio/b",
      code: "NASDAQ:BIO/B",
      companyName: "Bio-Rad Laboratories Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-blfy",
      code: "NASDAQ:BLFY",
      companyName: "Blue Foundry Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bli",
      code: "NASDAQ:BLI",
      companyName: "Berkeley Lights Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-blin",
      code: "NASDAQ:BLIN",
      companyName: "Bridgeline Digital Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnnr",
      code: "NASDAQ:BNNR",
      companyName: "Banner Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bnnru",
      code: "NASDAQ:BNNRU",
      companyName: "Banner Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-bp",
      code: "NASDAQ:BP",
      companyName: "BP p.l.c. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bsrr",
      code: "NASDAQ:BSRR",
      companyName: "Sierra Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwmn",
      code: "NASDAQ:BWMN",
      companyName: "Bowman Consulting Group Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwmx",
      code: "NASDAQ:BWMX",
      companyName: "Betterware de Mexico S.A.B. de C.V. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-bwnb",
      code: "NASDAQ:BWNB",
      companyName:
        "Babcock & Wilcox Enterprises Inc. 6.50% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nasdaq-can",
      code: "NASDAQ:CAN",
      companyName: "Canaan Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-canf",
      code: "NASDAQ:CANF",
      companyName: "Can-Fite Biopharma Ltd Sponsored ADR (Israel)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccl",
      code: "NASDAQ:CCL",
      companyName: "Carnival Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cclp",
      code: "NASDAQ:CCLP",
      companyName: "CSI Compressco LP Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-ccm",
      code: "NASDAQ:CCM",
      companyName:
        "Concord Medical Services Holdings Limited ADS (Each represents three ordinary shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-cdk",
      code: "NASDAQ:CDK",
      companyName: "CDK Global Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-celuw",
      code: "NASDAQ:CELUW",
      companyName: "Celularity Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-celz",
      code: "NASDAQ:CELZ",
      companyName: "Creative Medical Technology Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgen",
      code: "NASDAQ:CGEN",
      companyName: "Compugen Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cgnt",
      code: "NASDAQ:CGNT",
      companyName: "Cognyte Software Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-clgn",
      code: "NASDAQ:CLGN",
      companyName: "CollPlant Biotechnologies Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-clh",
      code: "NASDAQ:CLH",
      companyName: "Clean Harbors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-clim",
      code: "NASDAQ:CLIM",
      companyName:
        "Climate Real Impact Solutions II Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cohr",
      code: "NASDAQ:COHR",
      companyName: "Coherent Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cntqw",
      code: "NASDAQ:CNTQW",
      companyName: "Chardan NexTech Acquisition 2 Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-cntx",
      code: "NASDAQ:CNTX",
      companyName: "Context Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-corr",
      code: "NASDAQ:CORR",
      companyName: "CorEnergy Infrastructure Trust Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-corr-a",
      code: "NASDAQ:CORR-A",
      companyName:
        "CorEnergy Infrastructure Trust Inc. Depositary Shares each representing a 1/100th fractional interest of a share of 7.375% Series A Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cors",
      code: "NASDAQ:CORS",
      companyName: "Corsair Partnering Corporation Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-crc",
      code: "NASDAQ:CRC",
      companyName: "California Resources Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crct",
      code: "NASDAQ:CRCT",
      companyName: "Cricut Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crd/a",
      code: "NASDAQ:CRD/A",
      companyName: "Crawford & Company",
      popularity: 0,
    },
    {
      slug: "nasdaq-crd/b",
      code: "NASDAQ:CRD/B",
      companyName: "Crawford & Company",
      popularity: 0,
    },
    {
      slug: "nasdaq-crdf",
      code: "NASDAQ:CRDF",
      companyName: "Cardiff Oncology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-crdl",
      code: "NASDAQ:CRDL",
      companyName: "Cardiol Therapeutics Inc. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-crdo",
      code: "NASDAQ:CRDO",
      companyName: "Credo Technology Group Holding Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-crec",
      code: "NASDAQ:CREC",
      companyName: "Crescera Capital Acquisition Corp Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cri",
      code: "NASDAQ:CRI",
      companyName: "Carter's Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-csii",
      code: "NASDAQ:CSII",
      companyName: "Cardiovascular Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-csiq",
      code: "NASDAQ:CSIQ",
      companyName: "Canadian Solar Inc. Common Shares (BC)",
      popularity: 0,
    },
    {
      slug: "nasdaq-ctxs",
      code: "NASDAQ:CTXS",
      companyName: "Citrix Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cuba",
      code: "NASDAQ:CUBA",
      companyName: "Herzfeld Caribbean Basin Fund Inc. (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyan",
      code: "NASDAQ:CYAN",
      companyName: "Cyanotech Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cybe",
      code: "NASDAQ:CYBE",
      companyName: "CyberOptics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-cybn",
      code: "NASDAQ:CYBN",
      companyName: "Cybin Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-cyn",
      code: "NASDAQ:CYN",
      companyName: "Cyngn Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcf",
      code: "NASDAQ:DCF",
      companyName:
        "BNY Mellon Alcentra Global Credit Income 2024 Target Term Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dcfc",
      code: "NASDAQ:DCFC",
      companyName: "Tritium DCFC Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhbcw",
      code: "NASDAQ:DHBCW",
      companyName: "DHB Capital Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhc",
      code: "NASDAQ:DHC",
      companyName:
        "Diversified Healthcare Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhca",
      code: "NASDAQ:DHCA",
      companyName: "DHC Acquisition Corp. Class A ordinary share",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhcau",
      code: "NASDAQ:DHCAU",
      companyName: "DHC Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhcni",
      code: "NASDAQ:DHCNI",
      companyName: "Diversified Healthcare Trust 5.625% Senior Notes due 2042",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhcnl",
      code: "NASDAQ:DHCNL",
      companyName: "Diversified Healthcare Trust 6.25% Senior Notes Due 2046",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhf",
      code: "NASDAQ:DHF",
      companyName: "BNY Mellon High Yield Strategies Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dhhc",
      code: "NASDAQ:DHHC",
      companyName: "DiamondHead Holdings Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlr-l",
      code: "NASDAQ:DLR-L",
      companyName:
        "Digital Realty Trust Inc. 5.200% Series L Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dlth",
      code: "NASDAQ:DLTH",
      companyName: "Duluth Holdings Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-drct",
      code: "NASDAQ:DRCT",
      companyName: "Direct Digital Holdings Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-dukb",
      code: "NASDAQ:DUKB",
      companyName:
        "Duke Energy Corporation 5.625% Junior Subordinated Debentures due 2078",
      popularity: 0,
    },
    {
      slug: "nasdaq-ecf",
      code: "NASDAQ:ECF",
      companyName: "Ellsworth Growth and Income Fund Ltd.",
      popularity: 0,
    },
    {
      slug: "nasdaq-egy",
      code: "NASDAQ:EGY",
      companyName: "VAALCO Energy Inc.  Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enb",
      code: "NASDAQ:ENB",
      companyName: "Enbridge Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-enba",
      code: "NASDAQ:ENBA",
      companyName:
        "Enbridge Inc 6.375% Fixed-to-Floating Rate Subordinated Notes Series 2018-B due 2078",
      popularity: 0,
    },
    {
      slug: "nasdaq-enerr",
      code: "NASDAQ:ENERR",
      companyName: "Accretion Acquisition Corp. Right",
      popularity: 0,
    },
    {
      slug: "nasdaq-esnt",
      code: "NASDAQ:ESNT",
      companyName: "Essent Group Ltd. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-evgn",
      code: "NASDAQ:EVGN",
      companyName: "Evogene Ltd Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-evgo",
      code: "NASDAQ:EVGO",
      companyName: "EVgo Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-evgow",
      code: "NASDAQ:EVGOW",
      companyName: "EVgo Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-evgr",
      code: "NASDAQ:EVGR",
      companyName: "Evergreen Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-evgru",
      code: "NASDAQ:EVGRU",
      companyName: "Evergreen Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-f",
      code: "NASDAQ:F",
      companyName: "Ford Motor Company Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ezpw",
      code: "NASDAQ:EZPW",
      companyName: "EZCORP Inc. Class A Non Voting Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-f-b",
      code: "NASDAQ:F-B",
      companyName: "Ford Motor Company 6.20% Notes due June 1 2059",
      popularity: 0,
    },
    {
      slug: "nasdaq-fdeu",
      code: "NASDAQ:FDEU",
      companyName:
        "First Trust Dynamic Europe Equity Income Fund Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-fhs",
      code: "NASDAQ:FHS",
      companyName:
        "First High-School Education Group Co. Ltd. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-fmivu",
      code: "NASDAQ:FMIVU",
      companyName: "Forum Merger IV Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-frba",
      code: "NASDAQ:FRBA",
      companyName: "First Bank Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsm",
      code: "NASDAQ:FSM",
      companyName: "Fortuna Silver Mines Inc Ordinary Shares (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-fsnb",
      code: "NASDAQ:FSNB",
      companyName: "Fusion Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-fuv",
      code: "NASDAQ:FUV",
      companyName: "Arcimoto Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbio",
      code: "NASDAQ:GBIO",
      companyName: "Generation Bio Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gbl",
      code: "NASDAQ:GBL",
      companyName: "Gamco Investors Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ger",
      code: "NASDAQ:GER",
      companyName: "Goldman Sachs MLP Energy Renaissance Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-gifi",
      code: "NASDAQ:GIFI",
      companyName: "Gulf Island Fabrication Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-glpg",
      code: "NASDAQ:GLPG",
      companyName: "Galapagos NV American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-glpi",
      code: "NASDAQ:GLPI",
      companyName: "Gaming and Leisure Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnus",
      code: "NASDAQ:GNUS",
      companyName: "Genius Brands International Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gnw",
      code: "NASDAQ:GNW",
      companyName: "Genworth Financial Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-go",
      code: "NASDAQ:GO",
      companyName: "Grocery Outlet Holding Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-goac",
      code: "NASDAQ:GOAC",
      companyName: "GO Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-gobi",
      code: "NASDAQ:GOBI",
      companyName: "Gobi Acquisition Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-grcl",
      code: "NASDAQ:GRCL",
      companyName: "Gracell Biotechnologies Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtac",
      code: "NASDAQ:GTAC",
      companyName:
        "Global Technology Acquisition Corp. I Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-gtbp",
      code: "NASDAQ:GTBP",
      companyName: "GT Biopharma Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hbanp",
      code: "NASDAQ:HBANP",
      companyName:
        "Huntington Bancshares Incorporated Depositary Shares 4.500% Series H Non-Cumulative Perpetual Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hexo",
      code: "NASDAQ:HEXO",
      companyName: "HEXO Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmc",
      code: "NASDAQ:HMC",
      companyName: "Honda Motor Company Ltd. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hmco",
      code: "NASDAQ:HMCO",
      companyName: "HumanCo Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hrl",
      code: "NASDAQ:HRL",
      companyName: "Hormel Foods Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hrow",
      code: "NASDAQ:HROW",
      companyName: "Harrow Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-hurn",
      code: "NASDAQ:HURN",
      companyName: "Huron Consulting Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-icad",
      code: "NASDAQ:ICAD",
      companyName: "iCAD Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iccc",
      code: "NASDAQ:ICCC",
      companyName: "ImmuCell Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-icch",
      code: "NASDAQ:ICCH",
      companyName: "ICC Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-iccm",
      code: "NASDAQ:ICCM",
      companyName: "IceCure Medical Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-icvx",
      code: "NASDAQ:ICVX",
      companyName: "Icosavax Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imtxw",
      code: "NASDAQ:IMTXW",
      companyName: "Immatics N.V. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-imux",
      code: "NASDAQ:IMUX",
      companyName: "Immunic Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-imv",
      code: "NASDAQ:IMV",
      companyName: "IMV Inc. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-imxi",
      code: "NASDAQ:IMXI",
      companyName: "International Money Express Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-inab",
      code: "NASDAQ:INAB",
      companyName: "IN8bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-invz",
      code: "NASDAQ:INVZ",
      companyName: "Innoviz Technologies Ltd. Ordinary shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-invzw",
      code: "NASDAQ:INVZW",
      companyName: "Innoviz Technologies Ltd. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-isdr",
      code: "NASDAQ:ISDR",
      companyName: "Issuer Direct Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jan",
      code: "NASDAQ:JAN",
      companyName: "JanOne Inc. Common Stock (NV)",
      popularity: 0,
    },
    {
      slug: "nasdaq-janx",
      code: "NASDAQ:JANX",
      companyName: "Janux Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jaqc",
      code: "NASDAQ:JAQC",
      companyName: "Jupiter Acquisition Corporation Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-job",
      code: "NASDAQ:JOB",
      companyName: "GEE Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-jobs",
      code: "NASDAQ:JOBS",
      companyName: "51job Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-joby",
      code: "NASDAQ:JOBY",
      companyName: "Joby Aviation Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kaii",
      code: "NASDAQ:KAII",
      companyName: "Kismet Acquisition Two Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-kaiiu",
      code: "NASDAQ:KAIIU",
      companyName: "Kismet Acquisition Two Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-kaiiw",
      code: "NASDAQ:KAIIW",
      companyName: "Kismet Acquisition Two Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-kinzu",
      code: "NASDAQ:KINZU",
      companyName: "KINS Technology Group Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-kro",
      code: "NASDAQ:KRO",
      companyName: "Kronos Worldwide Inc Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-kt",
      code: "NASDAQ:KT",
      companyName: "KT Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-laws",
      code: "NASDAQ:LAWS",
      companyName: "Lawson Products Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lesl",
      code: "NASDAQ:LESL",
      companyName: "Leslie's Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lilak",
      code: "NASDAQ:LILAK",
      companyName: "Liberty Latin America Ltd. Class C Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lilm",
      code: "NASDAQ:LILM",
      companyName: "Lilium N.V. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-lilmw",
      code: "NASDAQ:LILMW",
      companyName: "Lilium N.V. Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-lnth",
      code: "NASDAQ:LNTH",
      companyName: "Lantheus Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-lnw",
      code: "NASDAQ:LNW",
      companyName: "Light & Wonder Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-loan",
      code: "NASDAQ:LOAN",
      companyName: "Manhattan Bridge Capital Inc",
      popularity: 0,
    },
    {
      slug: "nasdaq-lu",
      code: "NASDAQ:LU",
      companyName:
        "Lufax Holding Ltd American Depositary Shares two of which representing one Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-lub",
      code: "NASDAQ:LUB",
      companyName: "Luby's Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-main",
      code: "NASDAQ:MAIN",
      companyName: "Main Street Capital Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-man",
      code: "NASDAQ:MAN",
      companyName: "ManpowerGroup Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mchp",
      code: "NASDAQ:MCHP",
      companyName: "Microchip Technology Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mchx",
      code: "NASDAQ:MCHX",
      companyName: "Marchex Inc. Class B Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mci",
      code: "NASDAQ:MCI",
      companyName: "Barings Corporate Investors Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mcld",
      code: "NASDAQ:MCLD",
      companyName: "mCloud Technologies Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-met",
      code: "NASDAQ:MET",
      companyName: "MetLife Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-met-a",
      code: "NASDAQ:MET-A",
      companyName: "MetLife Inc. Preferred Series A Floating Rate",
      popularity: 0,
    },
    {
      slug: "nasdaq-mfa",
      code: "NASDAQ:MFA",
      companyName: "MFA Financial Inc.",
      popularity: 0,
    },
    {
      slug: "nasdaq-midd",
      code: "NASDAQ:MIDD",
      companyName: "Middleby Corporation (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mile",
      code: "NASDAQ:MILE",
      companyName: "Metromile Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mmmb",
      code: "NASDAQ:MMMB",
      companyName: "MamaMancini's Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpln",
      code: "NASDAQ:MPLN",
      companyName: "MultiPlan Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mplx",
      code: "NASDAQ:MPLX",
      companyName:
        "MPLX LP Common Units Representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpra",
      code: "NASDAQ:MPRA",
      companyName:
        "Mercato Partners Acquisition Corporation Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-mprau",
      code: "NASDAQ:MPRAU",
      companyName: "Mercato Partners Acquisition Corporation Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpraw",
      code: "NASDAQ:MPRAW",
      companyName: "Mercato Partners Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-mpv",
      code: "NASDAQ:MPV",
      companyName: "Barings Participation Investors Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msi",
      code: "NASDAQ:MSI",
      companyName: "Motorola Solutions Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-msm",
      code: "NASDAQ:MSM",
      companyName: "MSC Industrial Direct Company Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbr",
      code: "NASDAQ:NBR",
      companyName: "Nabors Industries Ltd.",
      popularity: 0,
    },
    {
      slug: "nasdaq-nbrv",
      code: "NASDAQ:NBRV",
      companyName: "Nabriva Therapeutics plc Ordinary Shares Ireland",
      popularity: 0,
    },
    {
      slug: "nasdaq-netc",
      code: "NASDAQ:NETC",
      companyName: "Nabors Energy Transition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-neti",
      code: "NASDAQ:NETI",
      companyName: "Eneti Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-neu",
      code: "NASDAQ:NEU",
      companyName: "NewMarket Corp Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-newp",
      code: "NASDAQ:NEWP",
      companyName: "New Pacific Metals Corp. Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-nisn",
      code: "NASDAQ:NISN",
      companyName:
        "NiSun International Enterprise Development Group Co. Ltd. Class A Common Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-niu",
      code: "NASDAQ:NIU",
      companyName: "Niu Technologies American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-noac",
      code: "NASDAQ:NOAC",
      companyName: "Natural Order Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ns",
      code: "NASDAQ:NS",
      companyName: "Nustar Energy L.P.  Common Units",
      popularity: 0,
    },
    {
      slug: "nasdaq-nvax",
      code: "NASDAQ:NVAX",
      companyName: "Novavax Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nuvl",
      code: "NASDAQ:NUVL",
      companyName: "Nuvalent Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nuw",
      code: "NASDAQ:NUW",
      companyName: "Nuveen AMT-Free Municipal Value Fund",
      popularity: 0,
    },
    {
      slug: "nasdaq-nuwe",
      code: "NASDAQ:NUWE",
      companyName: "Nuwellis Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nuze",
      code: "NASDAQ:NUZE",
      companyName: "NuZee Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-nxplw",
      code: "NASDAQ:NXPLW",
      companyName: "NextPlat Corp Warrants",
      popularity: 0,
    },
    {
      slug: "nasdaq-oesx",
      code: "NASDAQ:OESX",
      companyName: "Orion Energy Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ofc",
      code: "NASDAQ:OFC",
      companyName: "Corporate Office Properties Trust Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onem",
      code: "NASDAQ:ONEM",
      companyName: "1Life Healthcare Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-onew",
      code: "NASDAQ:ONEW",
      companyName: "OneWater Marine Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-osh",
      code: "NASDAQ:OSH",
      companyName: "Oak Street Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pac",
      code: "NASDAQ:PAC",
      companyName:
        "Grupo Aeroportuario Del Pacifico S.A. B. de C.V. Grupo Aeroportuario Del Pacifico S.A. de C.V. (each representing 10 Series B shares)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pacb",
      code: "NASDAQ:PACB",
      companyName: "Pacific Biosciences of California Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-pbr",
      code: "NASDAQ:PBR",
      companyName: "Petroleo Brasileiro S.A.- Petrobras Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-peb-f",
      code: "NASDAQ:PEB-F",
      companyName:
        "Pebblebrook Hotel Trust 6.3% Series F Cumulative Redeemable Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfxnl",
      code: "NASDAQ:PFXNL",
      companyName: "PhenixFIN Corporation 6.125% Senior Notes due 2023",
      popularity: 0,
    },
    {
      slug: "nasdaq-pfxnz",
      code: "NASDAQ:PFXNZ",
      companyName: "PhenixFIN Corporation  5.25% Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-pkx",
      code: "NASDAQ:PKX",
      companyName:
        "POSCO Holdings Inc. American Depositary Shares (Each representing 1/4th of a share of Common Stock)",
      popularity: 0,
    },
    {
      slug: "nasdaq-pnf",
      code: "NASDAQ:PNF",
      companyName: "PIMCO New York Municipal Income Fund Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-prgo",
      code: "NASDAQ:PRGO",
      companyName: "Perrigo Company plc Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-psag",
      code: "NASDAQ:PSAG",
      companyName:
        "Property Solutions Acquisition Corporation II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptpi",
      code: "NASDAQ:PTPI",
      companyName: "Petros Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ptr",
      code: "NASDAQ:PTR",
      companyName: "PetroChina Company Limited Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rc-c",
      code: "NASDAQ:RC-C",
      companyName:
        "Ready Capital Corporation 6.25% Series C Cumulative Convertible Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rc-e",
      code: "NASDAQ:RC-E",
      companyName:
        "Ready Capital Corporation 6.50% Series E Cumulative Redeemable Preferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-relx",
      code: "NASDAQ:RELX",
      companyName:
        "RELX PLC PLC American Depositary Shares (Each representing One Ordinary Share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-rhe",
      code: "NASDAQ:RHE",
      companyName: "Regional Health Properties Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmm",
      code: "NASDAQ:RMM",
      companyName:
        "RiverNorth Managed Duration Municipal Income Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rmni",
      code: "NASDAQ:RMNI",
      companyName: "Rimini Street Inc. (DE) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-rpid",
      code: "NASDAQ:RPID",
      companyName: "Rapid Micro Biosystems Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ry",
      code: "NASDAQ:RY",
      companyName: "Royal Bank Of Canada Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ry-t",
      code: "NASDAQ:RY-T",
      companyName:
        "Royal Bank Of Canada 6.750% Fixed Rate/Floating Rate Noncumulative First Preferred Shares Series C-2",
      popularity: 0,
    },
    {
      slug: "nasdaq-sb",
      code: "NASDAQ:SB",
      companyName: "Safe Bulkers Inc Common Stock ($0.001 par value)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sb-c",
      code: "NASDAQ:SB-C",
      companyName:
        "Safe Bulkers Inc Cumulative Redeemable Perpetual Preferred Series C (Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sb-d",
      code: "NASDAQ:SB-D",
      companyName:
        "Safe Bulkers Inc Perpetual Preferred Series D (Marshall Islands)",
      popularity: 0,
    },
    {
      slug: "nasdaq-sfl",
      code: "NASDAQ:SFL",
      companyName: "SFL Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-shlx",
      code: "NASDAQ:SHLX",
      companyName:
        "Shell Midstream Partners L.P. Common Units representing Limited Partner Interests",
      popularity: 0,
    },
    {
      slug: "nasdaq-sibn",
      code: "NASDAQ:SIBN",
      companyName: "SI-BONE Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smed",
      code: "NASDAQ:SMED",
      companyName: "Sharps Compliance Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-smfg",
      code: "NASDAQ:SMFG",
      companyName:
        "Sumitomo Mitsui Financial Group Inc Unsponsored American Depositary Shares (Japan)",
      popularity: 0,
    },
    {
      slug: "nasdaq-smfl",
      code: "NASDAQ:SMFL",
      companyName: "Smart for Life Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snv",
      code: "NASDAQ:SNV",
      companyName: "Synovus Financial Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-snx",
      code: "NASDAQ:SNX",
      companyName: "TD SYNNEX Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-splp",
      code: "NASDAQ:SPLP",
      companyName: "Steel Partners Holdings LP LTD PARTNERSHIP UNIT",
      popularity: 0,
    },
    {
      slug: "nasdaq-splp-a",
      code: "NASDAQ:SPLP-A",
      companyName:
        "Steel Partners Holdings LP 6.0% Series A Preferred Units no par value",
      popularity: 0,
    },
    {
      slug: "nasdaq-spne",
      code: "NASDAQ:SPNE",
      companyName: "SeaSpine Holdings Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-strc",
      code: "NASDAQ:STRC",
      companyName: "Sarcos Technology and Robotics Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swch",
      code: "NASDAQ:SWCH",
      companyName: "Switch Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swet",
      code: "NASDAQ:SWET",
      companyName: "Athlon Acquisition Corp. Class A Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-swetu",
      code: "NASDAQ:SWETU",
      companyName: "Athlon Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-tanni",
      code: "NASDAQ:TANNI",
      companyName: "TravelCenters of America Inc. 8.25% Senior Notes due 2028",
      popularity: 0,
    },
    {
      slug: "nasdaq-tdoc",
      code: "NASDAQ:TDOC",
      companyName: "Teladoc Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tdf",
      code: "NASDAQ:TDF",
      companyName: "Templeton Dragon Fund Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tdg",
      code: "NASDAQ:TDG",
      companyName: "Transdigm Group Incorporated Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tgi",
      code: "NASDAQ:TGI",
      companyName: "Triumph Group Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tlga",
      code: "NASDAQ:TLGA",
      companyName: "TLG Acquisition One Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-tlgy",
      code: "NASDAQ:TLGY",
      companyName: "TLGY Acquisition Corporation Class A Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nasdaq-tlgyw",
      code: "NASDAQ:TLGYW",
      companyName: "TLGY Acquisition Corporation Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-tpgy",
      code: "NASDAQ:TPGY",
      companyName: "TPG Pace Beneficial Finance Corp. Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trvg",
      code: "NASDAQ:TRVG",
      companyName: "trivago N.V. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-trvi",
      code: "NASDAQ:TRVI",
      companyName: "Trevi Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trvn",
      code: "NASDAQ:TRVN",
      companyName: "Trevena Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-trx",
      code: "NASDAQ:TRX",
      companyName: "Tanzanian Gold Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ts",
      code: "NASDAQ:TS",
      companyName: "Tenaris S.A. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-tsat",
      code: "NASDAQ:TSAT",
      companyName:
        "Telesat Corporation Class A Common Shares and Class B Variable Voting Shares ",
      popularity: 0,
    },
    {
      slug: "nasdaq-twcb",
      code: "NASDAQ:TWCB",
      companyName: "Bilander Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-twcbu",
      code: "NASDAQ:TWCBU",
      companyName: "Bilander Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nasdaq-twcbw",
      code: "NASDAQ:TWCBW",
      companyName: "Bilander Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nasdaq-ucbio",
      code: "NASDAQ:UCBIO",
      companyName:
        "United Community Banks Inc. Depositary Shares each representing 1/1000th interest in a share of Series I Non-CumulativePreferred Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-ucl",
      code: "NASDAQ:UCL",
      companyName: "uCloudlink Group Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-uctt",
      code: "NASDAQ:UCTT",
      companyName: "Ultra Clean Holdings Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-udmy",
      code: "NASDAQ:UDMY",
      companyName: "Udemy Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uec",
      code: "NASDAQ:UEC",
      companyName: "Uranium Energy Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-upst",
      code: "NASDAQ:UPST",
      companyName: "Upstart Holdings Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uptd",
      code: "NASDAQ:UPTD",
      companyName: "TradeUP Acquisition Corp. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-uxin",
      code: "NASDAQ:UXIN",
      companyName: "Uxin Limited ADS",
      popularity: 0,
    },
    {
      slug: "nasdaq-uzd",
      code: "NASDAQ:UZD",
      companyName:
        "United States Cellular Corporation 6.250% Senior Notes due 2069",
      popularity: 0,
    },
    {
      slug: "nasdaq-vet",
      code: "NASDAQ:VET",
      companyName: "Vermilion Energy Inc. Common (Canada)",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlo",
      code: "NASDAQ:VLO",
      companyName: "Valero Energy Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vlon",
      code: "NASDAQ:VLON",
      companyName: "Vallon Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrns",
      code: "NASDAQ:VRNS",
      companyName: "Varonis Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrnt",
      code: "NASDAQ:VRNT",
      companyName: "Verint Systems Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-vrpx",
      code: "NASDAQ:VRPX",
      companyName: "Virpax Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wafd",
      code: "NASDAQ:WAFD",
      companyName: "Washington Federal Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wafdp",
      code: "NASDAQ:WAFDP",
      companyName: "Washington Federal Inc. Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-wmt",
      code: "NASDAQ:WMT",
      companyName: "Walmart Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wnc",
      code: "NASDAQ:WNC",
      companyName: "Wabash National Corporation Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-wu",
      code: "NASDAQ:WU",
      companyName: "Western Union Company (The) Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpoa",
      code: "NASDAQ:XPOA",
      companyName: "DPCM Capital Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpof",
      code: "NASDAQ:XPOF",
      companyName: "Xponential Fitness Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpon",
      code: "NASDAQ:XPON",
      companyName: "Expion360 Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-xpro",
      code: "NASDAQ:XPRO",
      companyName: "Expro Group Holdings N.V. Common Stock",
      popularity: 0,
    },
    {
      slug: "asx-pv1",
      code: "ASX:PV1",
      companyName: "Provaris Energy Ltd",
      popularity: 0,
    },
    {
      slug: "nasdaq-zh",
      code: "NASDAQ:ZH",
      companyName:
        "Zhihu Inc. American Depositary Shares (every two of each representing one Class A ordinary share)",
      popularity: 0,
    },
    {
      slug: "nasdaq-zi",
      code: "NASDAQ:ZI",
      companyName: "ZoomInfo Technologies Inc Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zim",
      code: "NASDAQ:ZIM",
      companyName: "ZIM Integrated Shipping Services Ltd. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nasdaq-zimv",
      code: "NASDAQ:ZIMV",
      companyName: "ZimVie Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zing",
      code: "NASDAQ:ZING",
      companyName: "FTAC Zeus Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nasdaq-zingu",
      code: "NASDAQ:ZINGU",
      companyName: "FTAC Zeus Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "asx-avm",
      code: "ASX:AVM",
      companyName: "Advance Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ln1",
      code: "ASX:LN1",
      companyName: "LION SERIES 2022-1 TRUST",
      popularity: 0,
    },
    {
      slug: "asx-cmg",
      code: "ASX:CMG",
      companyName: "Critical Minerals Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bay",
      code: "ASX:BAY",
      companyName: "BAYROCK RESOURCES LIMITED",
      popularity: 0,
    },
    {
      slug: "asx-syn",
      code: "ASX:SYN",
      companyName: "SYNERGIA ENERGY LTD",
      popularity: 0,
    },
    {
      slug: "asx-pe5",
      code: "ASX:PE5",
      companyName: "PEPPER SPARKZ TRUST NO.5",
      popularity: 0,
    },
    {
      slug: "asx-oct",
      code: "ASX:OCT",
      companyName: "Octava Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ilt",
      code: "ASX:ILT",
      companyName: "Iltani Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-a",
      code: "NYSE:A",
      companyName: "Agilent Technologies Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aa",
      code: "NYSE:AA",
      companyName: "Alcoa Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-aaa",
      code: "NYSE:AAA",
      companyName: "AAF First Priority CLO Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-aaau",
      code: "NYSE:AAAU",
      companyName: "Goldman Sachs Physical Gold ETF Shares",
      popularity: 0,
    },
    {
      slug: "nyse-abos",
      code: "NYSE:ABOS",
      companyName: "Acumen Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-acn",
      code: "NYSE:ACN",
      companyName: "Accenture PLC",
      popularity: 0,
    },
    {
      slug: "nyse-acnb",
      code: "NYSE:ACNB",
      companyName: "ACNB Corp",
      popularity: 0,
    },
    {
      slug: "nyse-acnt",
      code: "NYSE:ACNT",
      companyName: "Ascent Industries Co. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-adra",
      code: "NYSE:ADRA",
      companyName: "Adara Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-ago",
      code: "NYSE:AGO",
      companyName: "Assured Guaranty LTD",
      popularity: 0,
    },
    {
      slug: "nyse-aimc",
      code: "NYSE:AIMC",
      companyName: "Altra Industrial Motion Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-aimd",
      code: "NYSE:AIMD",
      companyName: "Ainos Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-aimdw",
      code: "NYSE:AIMDW",
      companyName: "Ainos Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-alkt",
      code: "NYSE:ALKT",
      companyName: "Alkami Technology Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ambo",
      code: "NYSE:AMBO",
      companyName:
        "Ambow Education Holding Ltd. American Depository Shares each representing two Class A ordinary shar",
      popularity: 0,
    },
    {
      slug: "nyse-anet",
      code: "NYSE:ANET",
      companyName: "Arista Networks",
      popularity: 0,
    },
    {
      slug: "nyse-aneb",
      code: "NYSE:ANEB",
      companyName: "Anebulo Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-anss",
      code: "NYSE:ANSS",
      companyName: "Ansys Inc",
      popularity: 0,
    },
    {
      slug: "nyse-anew",
      code: "NYSE:ANEW",
      companyName: "ProShares MSCI Transformational Changes ETF",
      popularity: 0,
    },
    {
      slug: "nyse-asaxw",
      code: "NYSE:ASAXW",
      companyName: "Astrea Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-asb",
      code: "NYSE:ASB",
      companyName: "Associated Banc-Corp",
      popularity: 0,
    },
    {
      slug: "nyse-atec",
      code: "NYSE:ATEC",
      companyName: "Alphatec Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-aus",
      code: "NYSE:AUS",
      companyName: "Austerlitz Acquisition Corporation I",
      popularity: 0,
    },
    {
      slug: "nyse-away",
      code: "NYSE:AWAY",
      companyName: "ETFMG Travel Tech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-awf",
      code: "NYSE:AWF",
      companyName: "ALLIANCEBERSTEIN GLOBAL HIGH INCOME FUND INC.",
      popularity: 0,
    },
    {
      slug: "nyse-awh",
      code: "NYSE:AWH",
      companyName: "Aspira Women's Health Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-awi",
      code: "NYSE:AWI",
      companyName: "Armstrong World Industries Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-awk",
      code: "NYSE:AWK",
      companyName: "American Water Works Company Inc",
      popularity: 0,
    },
    {
      slug: "nyse-axti",
      code: "NYSE:AXTI",
      companyName: "AXT Inc",
      popularity: 0,
    },
    {
      slug: "nyse-banf",
      code: "NYSE:BANF",
      companyName: "Bancfirst Corp",
      popularity: 0,
    },
    {
      slug: "nyse-be",
      code: "NYSE:BE",
      companyName: "Bloom Energy Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-bit",
      code: "NYSE:BIT",
      companyName: "BLACKROCK MULTI-SECTOR INCOME TRUST",
      popularity: 0,
    },
    {
      slug: "nyse-bite",
      code: "NYSE:BITE",
      companyName: "Bite Acquisition Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-blfy",
      code: "NYSE:BLFY",
      companyName: "Blue Foundry Bancorp Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-bnixw",
      code: "NYSE:BNIXW",
      companyName: "Bannix Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-bscq",
      code: "NYSE:BSCQ",
      companyName: "Invesco BulletShares 2026 Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-btf",
      code: "NYSE:BTF",
      companyName: "Valkyrie Bitcoin Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-btg",
      code: "NYSE:BTG",
      companyName: "B2Gold Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-btn",
      code: "NYSE:BTN",
      companyName: "Ballantyne Strong Inc",
      popularity: 0,
    },
    {
      slug: "nyse-bwsn",
      code: "NYSE:BWSN",
      companyName:
        "Babcock & Wilcox Enterprises Inc. 8.125% Senior Notes due 2026",
      popularity: 0,
    },
    {
      slug: "nyse-cae",
      code: "NYSE:CAE",
      companyName: "CAE INC",
      popularity: 0,
    },
    {
      slug: "nyse-can",
      code: "NYSE:CAN",
      companyName: "Canaan Inc. American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cane",
      code: "NYSE:CANE",
      companyName: "Teucrium Sugar Fund",
      popularity: 0,
    },
    {
      slug: "nyse-cclp",
      code: "NYSE:CCLP",
      companyName: "CSI Compressco LP",
      popularity: 0,
    },
    {
      slug: "nyse-cggo",
      code: "NYSE:CGGO",
      companyName: "Capital Group Global Growth Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-clvt-a",
      code: "NYSE:CLVT-A",
      companyName:
        "Clarivate Plc 5.25% Series A Mandatory Convertible Preferred Shares",
      popularity: 0,
    },
    {
      slug: "nyse-cphc",
      code: "NYSE:CPHC",
      companyName: "Canterbury Park Holding Corporation 'New' Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ctex",
      code: "NYSE:CTEX",
      companyName: "ProShares S&P Kensho Cleantech ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dare",
      code: "NYSE:DARE",
      companyName: "Dare Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dash",
      code: "NYSE:DASH",
      companyName: "DoorDash Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dcrdw",
      code: "NYSE:DCRDW",
      companyName: "Decarbonization Plus Acquisition Corporation IV Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-dct",
      code: "NYSE:DCT",
      companyName: "Duck Creek Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-dfiv",
      code: "NYSE:DFIV",
      companyName: "Dimensional International Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dfj",
      code: "NYSE:DFJ",
      companyName: "WisdomTree Japan SmallCap Dividend Fund",
      popularity: 0,
    },
    {
      slug: "nyse-dihp",
      code: "NYSE:DIHP",
      companyName: "Dimensional International High Profitability ETF",
      popularity: 0,
    },
    {
      slug: "nyse-dilau",
      code: "NYSE:DILAU",
      companyName: "DILA Capital Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-drh",
      code: "NYSE:DRH",
      companyName: "DiamondRock Hospitality Company",
      popularity: 0,
    },
    {
      slug: "nyse-drq",
      code: "NYSE:DRQ",
      companyName: "Dril-Quip Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-dxpe",
      code: "NYSE:DXPE",
      companyName: "DXP Enterprises Inc",
      popularity: 0,
    },
    {
      slug: "nyse-dxyn",
      code: "NYSE:DXYN",
      companyName: "Dixie Group Inc",
      popularity: 0,
    },
    {
      slug: "nyse-efix",
      code: "NYSE:EFIX",
      companyName: "First Trust TCW Emerging Markets Debt ETF",
      popularity: 0,
    },
    {
      slug: "nyse-efl",
      code: "NYSE:EFL",
      companyName:
        "Eaton Vance Floating-Rate 2022 Target Term Trust Common Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-efo",
      code: "NYSE:EFO",
      companyName: "ProShares Ultra MSCI EAFE",
      popularity: 0,
    },
    {
      slug: "nyse-esgs",
      code: "NYSE:ESGS",
      companyName: "Columbia Sustainable U.S. Equity Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ewl",
      code: "NYSE:EWL",
      companyName: "iShares MSCI Switzerland ETF",
      popularity: 0,
    },
    {
      slug: "nyse-farm",
      code: "NYSE:FARM",
      companyName: "Farmer Bros Co",
      popularity: 0,
    },
    {
      slug: "nyse-fct",
      code: "NYSE:FCT",
      companyName: "First Trust Senior Floating Rate Income Fund II",
      popularity: 0,
    },
    {
      slug: "nyse-fctr",
      code: "NYSE:FCTR",
      companyName: "First Trust Lunt U.S. Factor Rotation ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fe",
      code: "NYSE:FE",
      companyName: "FirstEnergy Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-fibr",
      code: "NYSE:FIBR",
      companyName: "iShares U.S. Fixed Income Balanced Risk Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fldr",
      code: "NYSE:FLDR",
      companyName: "Fidelity Low Duration Bond Factor ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fldz",
      code: "NYSE:FLDZ",
      companyName: "RiverNorth Patriot ETF",
      popularity: 0,
    },
    {
      slug: "nyse-flee",
      code: "NYSE:FLEE",
      companyName: "Franklin FTSE Europe ETF",
      popularity: 0,
    },
    {
      slug: "nyse-fmar",
      code: "NYSE:FMAR",
      companyName: "FT Cboe Vest U.S. Equity Buffer ETF - March",
      popularity: 0,
    },
    {
      slug: "nyse-gern",
      code: "NYSE:GERN",
      companyName: "Geron Corp",
      popularity: 0,
    },
    {
      slug: "nyse-glog-a",
      code: "NYSE:GLOG-A",
      companyName:
        "GasLog Ltd. 8.75% Series A Cumulative Redeemable Perpetual Preference Shares",
      popularity: 0,
    },
    {
      slug: "nyse-gnrc",
      code: "NYSE:GNRC",
      companyName: "GENERAC HOLDINGS INC",
      popularity: 0,
    },
    {
      slug: "nyse-gnpx",
      code: "NYSE:GNPX",
      companyName: "Genprex Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-grabw",
      code: "NYSE:GRABW",
      companyName: "Grab Holdings Limited Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-gray",
      code: "NYSE:GRAY",
      companyName: "Graybug Vision Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-gsig",
      code: "NYSE:GSIG",
      companyName:
        "Goldman Sachs Access Investment Grade Corporate 1-5 Year Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-gvip",
      code: "NYSE:GVIP",
      companyName: "Goldman Sachs Hedge Industry VIP ETF",
      popularity: 0,
    },
    {
      slug: "nyse-hcc",
      code: "NYSE:HCC",
      companyName: "Warrior Met Coal Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-hero",
      code: "NYSE:HERO",
      companyName: "Global X Video Games & Esports ETF",
      popularity: 0,
    },
    {
      slug: "nyse-htht",
      code: "NYSE:HTHT",
      companyName: "H World Group Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-ibhb",
      code: "NYSE:IBHB",
      companyName: "iShares iBonds 2022 Term High Yield and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ibhc",
      code: "NYSE:IBHC",
      companyName: "iShares iBonds 2023 Term High Yield and Income ETF",
      popularity: 0,
    },
    {
      slug: "nyse-idai",
      code: "NYSE:IDAI",
      companyName: "T Stamp Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-indb",
      code: "NYSE:INDB",
      companyName: "Independent Bank Corp/MA",
      popularity: 0,
    },
    {
      slug: "nyse-indf",
      code: "NYSE:INDF",
      companyName: "Nifty India Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-ioacu",
      code: "NYSE:IOACU",
      companyName: "Innovative International Acquisition Corp. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-iobt",
      code: "NYSE:IOBT",
      companyName: "IO Biotech Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-iwr",
      code: "NYSE:IWR",
      companyName: "iShares Russell Mid-Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jd",
      code: "NYSE:JD",
      companyName: "JD.com Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-jctr",
      code: "NYSE:JCTR",
      companyName: "JPMorgan Carbon Transition U.S. Equity ETF",
      popularity: 0,
    },
    {
      slug: "nyse-jjt",
      code: "NYSE:JJT",
      companyName: "iPath Series B Bloomberg Tin Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jju",
      code: "NYSE:JJU",
      companyName:
        "iPath Series B Bloomberg Aluminum Subindex Total ReturnSM ETN",
      popularity: 0,
    },
    {
      slug: "nyse-jri",
      code: "NYSE:JRI",
      companyName: "NUVEEN REAL ASSET INCOME AND GROWTH FUND",
      popularity: 0,
    },
    {
      slug: "nyse-kba",
      code: "NYSE:KBA",
      companyName: "KraneShares Bosera MSCI China A 50 Connect Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-kbal",
      code: "NYSE:KBAL",
      companyName: "Kimball International",
      popularity: 0,
    },
    {
      slug: "nyse-kinzu",
      code: "NYSE:KINZU",
      companyName: "KINS Technology Group Inc. Unit",
      popularity: 0,
    },
    {
      slug: "nyse-kirk",
      code: "NYSE:KIRK",
      companyName: "Kirkland's Inc",
      popularity: 0,
    },
    {
      slug: "nyse-lgl",
      code: "NYSE:LGL",
      companyName: "The LGL Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-lgmk",
      code: "NYSE:LGMK",
      companyName: "LogicMark Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ljpc",
      code: "NYSE:LJPC",
      companyName: "La Jolla Pharmaceutical Company",
      popularity: 0,
    },
    {
      slug: "nyse-lkfn",
      code: "NYSE:LKFN",
      companyName: "Lakeland Financial Corp",
      popularity: 0,
    },
    {
      slug: "nyse-lqd",
      code: "NYSE:LQD",
      companyName: "iShares iBoxx $ Investment Grade Corporate Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lvacw",
      code: "NYSE:LVACW",
      companyName: "LAVA Medtech Acquisition Corp. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-lvhd",
      code: "NYSE:LVHD",
      companyName: "Franklin U.S. Low Volatility High Dividend Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lvhi",
      code: "NYSE:LVHI",
      companyName:
        "Franklin International Low Volatility High Dividend Index ETF",
      popularity: 0,
    },
    {
      slug: "nyse-lvo",
      code: "NYSE:LVO",
      companyName: "LiveOne Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mbi",
      code: "NYSE:MBI",
      companyName: "MBIA Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mcbs",
      code: "NYSE:MCBS",
      companyName: "METROCITY BANKSHARES INC",
      popularity: 0,
    },
    {
      slug: "nyse-mch",
      code: "NYSE:MCH",
      companyName: "Matthews China Active ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mem",
      code: "NYSE:MEM",
      companyName: "Matthews Emerging Markets Equity Active ETF",
      popularity: 0,
    },
    {
      slug: "nyse-meme",
      code: "NYSE:MEME",
      companyName: "Roundhill MEME ETF",
      popularity: 0,
    },
    {
      slug: "nyse-menv",
      code: "NYSE:MENV",
      companyName: "AdvisorShares North Square McKee ESG Core Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-mkl",
      code: "NYSE:MKL",
      companyName: "Markel Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mnst",
      code: "NYSE:MNST",
      companyName: "Monster Beverage Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-mnso",
      code: "NYSE:MNSO",
      companyName:
        "MINISO Group Holding Limited American Depositary Shares each representing four Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-mntsw",
      code: "NYSE:MNTSW",
      companyName: "Momentus Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mq",
      code: "NYSE:MQ",
      companyName: "Marqeta Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-mqt",
      code: "NYSE:MQT",
      companyName: "Blackrock Muni Yield Quality Fund II Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-mqy",
      code: "NYSE:MQY",
      companyName: "Blackrock Muni Yield Quality Fund Inc",
      popularity: 0,
    },
    {
      slug: "nyse-mrad",
      code: "NYSE:MRAD",
      companyName: "SmartETFs Advertising & Marketing Technology ETF",
      popularity: 0,
    },
    {
      slug: "nyse-msprz",
      code: "NYSE:MSPRZ",
      companyName: "MSP Recovery Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-mstb",
      code: "NYSE:MSTB",
      companyName: "LHA Market State Tactical Beta ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nati",
      code: "NYSE:NATI",
      companyName: "National Instruments Corp",
      popularity: 0,
    },
    {
      slug: "nyse-natr",
      code: "NYSE:NATR",
      companyName: "Nature's Sunshine Products Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ni-b",
      code: "NYSE:NI-B",
      companyName:
        "NiSource Inc. Depositary Shares representing 1/1000th ownership interest in a share of 6.50% Series",
      popularity: 0,
    },
    {
      slug: "nyse-nmrd",
      code: "NYSE:NMRD",
      companyName: "Nemaura Medical Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nmrk",
      code: "NYSE:NMRK",
      companyName: "Newmark Group Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nrim",
      code: "NYSE:NRIM",
      companyName: "Northrim BanCorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-nrix",
      code: "NYSE:NRIX",
      companyName: "Nurix Therapeutics Inc. Common stock",
      popularity: 0,
    },
    {
      slug: "nyse-ns",
      code: "NYSE:NS",
      companyName: "NuStar Energy L.P.",
      popularity: 0,
    },
    {
      slug: "nyse-nubi",
      code: "NYSE:NUBI",
      companyName: "Nubia Brand International Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-nudv",
      code: "NYSE:NUDV",
      companyName: "Nuveen ESG Dividend ETF",
      popularity: 0,
    },
    {
      slug: "nyse-nwl",
      code: "NYSE:NWL",
      companyName: "Newell Brands Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-oust",
      code: "NYSE:OUST",
      companyName: "Ouster Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-path",
      code: "NYSE:PATH",
      companyName: "UiPath Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-peb-e",
      code: "NYSE:PEB-E",
      companyName:
        "Pebblebrook Hotel Trust 6.375% Series E Cumulative Redeemable Preferred Shares of Beneficial Interes",
      popularity: 0,
    },
    {
      slug: "nyse-pfi",
      code: "NYSE:PFI",
      companyName: "Invesco DWA Financial Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-pfie",
      code: "NYSE:PFIE",
      companyName: "Profire Energy Inc",
      popularity: 0,
    },
    {
      slug: "nyse-pht",
      code: "NYSE:PHT",
      companyName: "Pioneer High Income Fund Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-phx",
      code: "NYSE:PHX",
      companyName: "PHX Minerals Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-plow",
      code: "NYSE:PLOW",
      companyName: "DOUGLAS DYNAMICS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-plpc",
      code: "NYSE:PLPC",
      companyName: "Preformed Line Products Co",
      popularity: 0,
    },
    {
      slug: "nyse-plrx",
      code: "NYSE:PLRX",
      companyName: "Pliant Therapeutics Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-prim",
      code: "NYSE:PRIM",
      companyName: "Primoris Services Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-psfe",
      code: "NYSE:PSFE",
      companyName: "Paysafe Limited",
      popularity: 0,
    },
    {
      slug: "nyse-pwod",
      code: "NYSE:PWOD",
      companyName: "Penns Woods Bancorp Inc",
      popularity: 0,
    },
    {
      slug: "nyse-qgen",
      code: "NYSE:QGEN",
      companyName: "Qiagen NV",
      popularity: 0,
    },
    {
      slug: "nyse-qtek",
      code: "NYSE:QTEK",
      companyName: "QualTek Services Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-reit",
      code: "NYSE:REIT",
      companyName: "ALPS Active REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rfil",
      code: "NYSE:RFIL",
      companyName: "RF Industries Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-rnr",
      code: "NYSE:RNR",
      companyName: "RenaissanceRe Holdings Ltd.",
      popularity: 0,
    },
    {
      slug: "nyse-rnsc",
      code: "NYSE:RNSC",
      companyName: "First Trust Small Cap US Equity Select ETF",
      popularity: 0,
    },
    {
      slug: "nyse-rpt-d",
      code: "NYSE:RPT-D",
      companyName:
        "RPT Realty 7.25% Series D Cumulative Convertible Perpetual Preferred Shares of Beneficial Interest",
      popularity: 0,
    },
    {
      slug: "nyse-rwr",
      code: "NYSE:RWR",
      companyName: "SPDR Dow Jones REIT ETF",
      popularity: 0,
    },
    {
      slug: "nyse-sama",
      code: "NYSE:SAMA",
      companyName:
        "Schultze Special Purpose Acquisition Corp. II Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-sccc",
      code: "NYSE:SCCC",
      companyName: "Sachem Capital Corp. 7.75% Notes due 2025",
      popularity: 0,
    },
    {
      slug: "nyse-sctl",
      code: "NYSE:SCTL",
      companyName: "Societal CDMO Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shcaw",
      code: "NYSE:SHCAW",
      companyName: "Spindletop Health Acquisition Corp. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-shcr",
      code: "NYSE:SHCR",
      companyName: "Sharecare Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-shcrw",
      code: "NYSE:SHCRW",
      companyName: "Sharecare Inc. Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-sio",
      code: "NYSE:SIO",
      companyName: "Touchstone Strategic Income Opportunities ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smit",
      code: "NYSE:SMIT",
      companyName: "Schmitt Industries Inc",
      popularity: 0,
    },
    {
      slug: "nyse-smle",
      code: "NYSE:SMLE",
      companyName: "Xtrackers S&P SmallCap 600 ESG ETF",
      popularity: 0,
    },
    {
      slug: "nyse-smlr",
      code: "NYSE:SMLR",
      companyName: "Semler Scientific Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-sny",
      code: "NYSE:SNY",
      companyName:
        "Sanofi American Depositary Shares (Each representing one-half of one ordinary share)",
      popularity: 0,
    },
    {
      slug: "nyse-spg",
      code: "NYSE:SPG",
      companyName: "Simon Property Group Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-srzn",
      code: "NYSE:SRZN",
      companyName: "Surrozen Inc. Common",
      popularity: 0,
    },
    {
      slug: "nyse-stn",
      code: "NYSE:STN",
      companyName: "Stantec Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-t",
      code: "NYSE:T",
      companyName: "AT&T Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-tc",
      code: "NYSE:TC",
      companyName: "TuanChe Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-tel",
      code: "NYSE:TEL",
      companyName: "TE CONNECTIVITY LTD",
      popularity: 0,
    },
    {
      slug: "nyse-tela",
      code: "NYSE:TELA",
      companyName: "TELA Bio Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-thcau",
      code: "NYSE:THCAU",
      companyName: "Tuscan Holdings Corp. II Unit",
      popularity: 0,
    },
    {
      slug: "nyse-tlt",
      code: "NYSE:TLT",
      companyName: "iShares 20+ Year Treasury Bond ETF",
      popularity: 0,
    },
    {
      slug: "nyse-top",
      code: "NYSE:TOP",
      companyName: "TOP Financial Group Limited Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-trq",
      code: "NYSE:TRQ",
      companyName: "Turquoise Hill Resources Ltd",
      popularity: 0,
    },
    {
      slug: "nyse-trs",
      code: "NYSE:TRS",
      companyName: "Trimas Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-ttsh",
      code: "NYSE:TTSH",
      companyName: "Tile Shop Holdings Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-ttt",
      code: "NYSE:TTT",
      companyName: "ProShares UltraPro Short 20+ Year Treasury",
      popularity: 0,
    },
    {
      slug: "nyse-ttwo",
      code: "NYSE:TTWO",
      companyName: "Take-Two Interactive Software Inc",
      popularity: 0,
    },
    {
      slug: "nyse-tu",
      code: "NYSE:TU",
      companyName: "Telus Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-tzoo",
      code: "NYSE:TZOO",
      companyName: "Travelzoo Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ugro",
      code: "NYSE:UGRO",
      companyName: "urban-gro Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-uhal",
      code: "NYSE:UHAL",
      companyName: "Amerco Inc",
      popularity: 0,
    },
    {
      slug: "nyse-uhs",
      code: "NYSE:UHS",
      companyName: "Universal Health Services Inc. Class B",
      popularity: 0,
    },
    {
      slug: "nyse-upwk",
      code: "NYSE:UPWK",
      companyName: "Upwork Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-upxi",
      code: "NYSE:UPXI",
      companyName: "Upexi Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-usvm",
      code: "NYSE:USVM",
      companyName: "VictoryShares USAA MSCI USA Small Cap Value Momentum ETF",
      popularity: 0,
    },
    {
      slug: "nyse-usvt",
      code: "NYSE:USVT",
      companyName: "US Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vbnd",
      code: "NYSE:VBND",
      companyName: "Vident Core US Bond Strategy ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vfh",
      code: "NYSE:VFH",
      companyName: "Vanguard Financials ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vgk",
      code: "NYSE:VGK",
      companyName: "Vanguard FTSE Europe ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vod",
      code: "NYSE:VOD",
      companyName: "Vodafone Group PLC",
      popularity: 0,
    },
    {
      slug: "nyse-voe",
      code: "NYSE:VOE",
      companyName: "Vanguard Mid-Cap Value ETF",
      popularity: 0,
    },
    {
      slug: "nyse-vsta",
      code: "NYSE:VSTA",
      companyName: "Vasta Platform Limited Class A Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wal",
      code: "NYSE:WAL",
      companyName: "Western Alliance Bancorporation",
      popularity: 0,
    },
    {
      slug: "nyse-wal-a",
      code: "NYSE:WAL-A",
      companyName:
        "Western Alliance Bancorporation Depositary Shares Each Representing a 1/ 400th Interest in a Share",
      popularity: 0,
    },
    {
      slug: "nyse-waldw",
      code: "NYSE:WALDW",
      companyName: "Waldencast plc Warrant",
      popularity: 0,
    },
    {
      slug: "nyse-wetg",
      code: "NYSE:WETG",
      companyName: "WeTrade Group Inc. Ordinary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-wlfc",
      code: "NYSE:WLFC",
      companyName: "Willis Lease Finance Corp",
      popularity: 0,
    },
    {
      slug: "nyse-wlk",
      code: "NYSE:WLK",
      companyName: "Westlake Corporation",
      popularity: 0,
    },
    {
      slug: "nyse-wlkp",
      code: "NYSE:WLKP",
      companyName: "WESTLAKE CHEMICAL PARTNERS LP",
      popularity: 0,
    },
    {
      slug: "nyse-wti",
      code: "NYSE:WTI",
      companyName: "W&T Offshore Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-xela",
      code: "NYSE:XELA",
      companyName: "Exela Technologies Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-xelb",
      code: "NYSE:XELB",
      companyName: "XCEL BRANDS INC.",
      popularity: 0,
    },
    {
      slug: "nyse-xout",
      code: "NYSE:XOUT",
      companyName: "GraniteShares XOUT U.S. Large Cap ETF",
      popularity: 0,
    },
    {
      slug: "nyse-znh",
      code: "NYSE:ZNH",
      companyName: "China Southern Airlines Company Limited",
      popularity: 0,
    },
    {
      slug: "nyse-ziono",
      code: "NYSE:ZIONO",
      companyName:
        "Zions Bancorporation N.A. Depositary Shares Each Representing 1/40th Interest in a Share of Series",
      popularity: 0,
    },
    {
      slug: "nyse-zionp",
      code: "NYSE:ZIONP",
      companyName:
        "Zions Bancorporation N.A. Depositary Shares (Each Representing 1/40th Interest in a Share of Series",
      popularity: 0,
    },
    {
      slug: "nyse-zip",
      code: "NYSE:ZIP",
      companyName: "ZipRecruiter Inc.",
      popularity: 0,
    },
    {
      slug: "nyse-zivo",
      code: "NYSE:ZIVO",
      companyName: "Zivo Bioscience Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zivow",
      code: "NYSE:ZIVOW",
      companyName: "Zivo Bioscience Inc. Warrants",
      popularity: 0,
    },
    {
      slug: "nyse-zkin",
      code: "NYSE:ZKIN",
      companyName: "ZK International Group Co. Ltd Ordinary Share",
      popularity: 0,
    },
    {
      slug: "nyse-zlab",
      code: "NYSE:ZLAB",
      companyName: "Zai Lab Limited American Depositary Shares",
      popularity: 0,
    },
    {
      slug: "nyse-zm",
      code: "NYSE:ZM",
      companyName: "Zoom Video Communications Inc. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zntl",
      code: "NYSE:ZNTL",
      companyName: "Zentalis Pharmaceuticals Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zom",
      code: "NYSE:ZOM",
      companyName: "Zomedica Corp.",
      popularity: 0,
    },
    {
      slug: "nyse-zroz",
      code: "NYSE:ZROZ",
      companyName:
        "PIMCO 25+ Year Zero Coupon U.S. Treasury Index Exchange-Traded Fund",
      popularity: 0,
    },
    {
      slug: "nyse-zs",
      code: "NYSE:ZS",
      companyName: "Zscaler Inc. Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-zsl",
      code: "NYSE:ZSL",
      companyName: "ProShares UltraShort Silver",
      popularity: 0,
    },
    {
      slug: "nyse-zt",
      code: "NYSE:ZT",
      companyName:
        "Zimmer Energy Transition Acquisition Corp. Class A Common Stock",
      popularity: 0,
    },
    {
      slug: "nyse-ztaqu",
      code: "NYSE:ZTAQU",
      companyName: "Zimmer Energy Transition Acquisition Corp. Units",
      popularity: 0,
    },
    {
      slug: "asx-m4m",
      code: "ASX:M4M",
      companyName: "Macro Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-bm8",
      code: "ASX:BM8",
      companyName: "Battery Age Minerals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pvt",
      code: "ASX:PVT",
      companyName: "Pivotal Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ctn",
      code: "ASX:CTN",
      companyName: "Catalina Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-rgn",
      code: "ASX:RGN",
      companyName: "Region Group",
      popularity: 0,
    },
    {
      slug: "asx-af3",
      code: "ASX:AF3",
      companyName: "AFG 2022-2 TRUST IN RESPECT OF SERIES 2022-2",
      popularity: 0,
    },
    {
      slug: "asx-rg8",
      code: "ASX:RG8",
      companyName: "Regal Asian Investments Ltd",
      popularity: 0,
    },
    {
      slug: "asx-ghy",
      code: "ASX:GHY",
      companyName: "Gold Hydrogen Ltd",
      popularity: 0,
    },
    {
      slug: "asx-svr",
      code: "ASX:SVR",
      companyName: "Solvar Ltd",
      popularity: 0,
    },
    {
      slug: "asx-an3",
      code: "ASX:AN3",
      companyName: "AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED.",
      popularity: 30000,
    },
    {
      slug: "asx-nxd",
      code: "ASX:NXD",
      companyName: "Nexted Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vtm",
      code: "ASX:VTM",
      companyName: "Victory Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-lt8",
      code: "ASX:LT8",
      companyName: "LA TROBE FINANCIAL CAPITAL MARKETS TRUST 2022-1",
      popularity: 0,
    },
    {
      slug: "asx-emc",
      code: "ASX:EMC",
      companyName: "Everest Metals Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-dym",
      code: "ASX:DYM",
      companyName: "Dynamic Metals Ltd",
      popularity: 0,
    },
    {
      slug: "asx-evg",
      code: "ASX:EVG",
      companyName: "Evion Group NL",
      popularity: 0,
    },
    {
      slug: "asx-etr",
      code: "ASX:ETR",
      companyName: "ENTYR Ltd",
      popularity: 0,
    },
    {
      slug: "asx-kdy",
      code: "ASX:KDY",
      companyName: "Kaddy Ltd",
      popularity: 0,
    },
    {
      slug: "asx-opa",
      code: "ASX:OPA",
      companyName: "Optima Technology Group Ltd",
      popularity: 0,
    },
    {
      slug: "asx-pl3",
      code: "ASX:PL3",
      companyName: "Patagonia Lithium Ltd",
      popularity: 0,
    },
    {
      slug: "asx-soc",
      code: "ASX:SOC",
      companyName: "Soco Corporation Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sp8",
      code: "ASX:SP8",
      companyName: "Streamplay Studio Ltd",
      popularity: 0,
    },
    {
      slug: "asx-sqx",
      code: "ASX:SQX",
      companyName: "SQX Resources Ltd",
      popularity: 0,
    },
    {
      slug: "asx-unt",
      code: "ASX:UNT",
      companyName: "Unith Ltd",
      popularity: 0,
    },
    {
      slug: "asx-vhm",
      code: "ASX:VHM",
      companyName: "VHM Ltd",
      popularity: 0,
    },
  ],
};

export async function get() {
  const response = await axios.get(`${ENDPOINT}`)
  const apiData = response.data;

  const data = {...onboardingData, ...apiData}

  return new Promise((resolve, reject) => {
    resolve({ data: data });
  });
}

export function getStepsToComplete() {
  return axios.get(`${ENDPOINT}/_get_steps_to_complete`);
}

export function setInvestorType(typeId) {
  return axios.post(`${ENDPOINT}/_set_investor_type`, {
    investor_type_id: typeId,
  });
}

export function setInvestmentThemes(assetClassIds) {
  return axios.post(`${ENDPOINT}/_set_investment_themes`, {
    asset_class_ids: assetClassIds,
  });
}

export function setHoldingsOptOut(value) {
  return axios.post(`${ENDPOINT}/_set_holdings_opt_out`, {
    holdings_opt_out: value,
  });
}

export function setPersonalDetails(password, firstName, lastName) {
  return axios.post(`${ENDPOINT}/_set_personal_details`, {
    password,
    first_name: firstName,
    last_name: lastName,
  });
}
